function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("zU4ax", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$901be321e686b435$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $jD5no;
    var $7nKe3;
    var $4nnGr;
    var $evDrO;
    var $x8FYU;
    var $1kpI8;
    var $6s1PB;
    var $dAmbh;
    var $l2N2a;
    var $9dbF6;
    var $9NiTW;
    var $l8ruj;
    const $901be321e686b435$var$JiraBusinessListApp = (props)=>{
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const isSubtasksEnabled = (0, (0, parcelRequire("dAmbh")).useIsSubtasksEnabled)();
        const isSimplifiedProject = Boolean(project?.isSimplified);
        const canCreateIssues = Boolean(project?.permissions.createIssues);
        const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-list-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "business"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nKe3")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nnGr")).ListFeaturesProvider), {
            hasCreateSubtask: canCreateSubtask,
            canCreateIssues: canCreateIssues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kpI8")).ViewPreferencesProvider), {
            view: "list",
            preferences: (0, (0, parcelRequire("x8FYU")).LIST_VIEW_PREFERENCES)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("evDrO")).default), {
            formattingRulesQuery: (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? props.queries.formattingRulesQuery : null
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "core"
        }))));
    };
    var $901be321e686b435$export$2e2bcd8739ae039 = $901be321e686b435$var$JiraBusinessListApp;
});
parcelRegister("7nKe3", function(module, exports) {
    $parcel$export(module.exports, "RelayProjectContextProvider", ()=>$b120e66bf4d03608$export$b29ebc220106a807);
    $parcel$export(module.exports, "default", ()=>$b120e66bf4d03608$export$2e2bcd8739ae039);
    var $1Mt6f;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $12jwF;
    var $54qG5;
    var $5YBrl;
    var $1Zr0i;
    var $daQYX;
    var $cm8b5;
    var $gxGcZ;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $koeKL;
    var $lVJAU;
    var $k7McJ;
    var $8OqLl;
    const $b120e66bf4d03608$export$b29ebc220106a807 = ({ children: children, projectFragment: projectFragment = null })=>{
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const projectData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1Mt6f")).default), projectFragment);
        const project = (0, $5uXOq.useMemo)(()=>projectData ? {
                id: Number(projectData.projectId),
                key: projectData.key,
                avatarUrl: projectData.avatar.large,
                name: projectData.name,
                type: projectData.projectType.toLowerCase(),
                isSimplified: projectData.projectStyle === 'TEAM_MANAGED_PROJECT',
                isFavorite: projectData.isFavourite,
                status: projectData.status,
                permissions: {
                    assignIssues: projectData.assignIssues.canPerform,
                    administerProject: projectData.administerProject.canPerform,
                    createIssues: projectData.createIssues.canPerform,
                    deleteIssues: projectData.deleteIssues.canPerform,
                    editIssues: projectData.editIssues.canPerform,
                    linkIssues: projectData.linkIssues.canPerform,
                    scheduleIssues: projectData.scheduleIssues.canPerform,
                    transitionIssues: projectData.transitionIssues.canPerform,
                    viewIssues: projectData.viewIssues.canPerform
                }
            } : null, [
            projectData
        ]);
        const jqlContext = projectData ? `project = '${projectData.key}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: Number(projectData?.projectId),
                isTeamManaged: projectData?.projectStyle === 'TEAM_MANAGED_PROJECT',
                projectType: projectData?.projectType.toLowerCase()
            }), [
            projectData
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>projectData?.viewIssues.canPerform ? {
                name: projectData.name,
                id: String(projectData.projectId)
            } : null, [
            projectData
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectData ? [
                Number(projectData.projectId)
            ] : undefined, [
            projectData
        ]);
        if (projectData?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (projectData == null || project == null || entityData == null) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null);
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectData.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: projectData?.projectId,
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: projectData?.projectId
        }, content);
    };
    const $b120e66bf4d03608$var$ProjectContextProvider = ({ children: children })=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = project?.id;
        const projectKey = project?.key;
        const projectType = project?.type;
        const isTeamManaged = Boolean(project?.isSimplified);
        const jqlContext = projectKey ? `project = '${projectKey}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isTeamManaged: isTeamManaged,
                projectType: projectType
            }), [
            projectId,
            isTeamManaged,
            projectType
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>project?.permissions?.viewIssues ? {
                name: project.name,
                id: String(project.id)
            } : null, [
            project
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectId ? [
                projectId
            ] : undefined, [
            projectId
        ]);
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        if (project?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        else if (project == null || entityData == null || error) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE),
            error: error
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectAri
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: String(project?.id),
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: String(project?.id)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        }), content);
    };
    var $b120e66bf4d03608$export$2e2bcd8739ae039 = $b120e66bf4d03608$var$ProjectContextProvider;
});
parcelRegister("1Mt6f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86f6b5f51dcbf821$export$2e2bcd8739ae039);
    const $86f6b5f51dcbf821$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "canPerform"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "projectContext_businessEntityProjectProvider_RelayProjectContextProvider",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    "action": "THROW",
                    "path": "key"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectId"
                    },
                    "action": "THROW",
                    "path": "projectId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "large"
                                },
                                "action": "THROW",
                                "path": "avatar.large"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "avatar"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    "action": "THROW",
                    "path": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectType"
                    },
                    "action": "THROW",
                    "path": "projectType"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    "action": "THROW",
                    "path": "status"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                    },
                    "action": "THROW",
                    "path": "projectStyle"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    },
                    "action": "THROW",
                    "path": "isFavourite"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "assignIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "ASSIGN_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "assignIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "assignIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "administerProject",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "administerProject.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    "action": "THROW",
                    "path": "administerProject"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "createIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "createIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"CREATE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "createIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "deleteIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "DELETE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "deleteIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"DELETE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "deleteIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "editIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "editIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "linkIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "LINK_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "linkIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"LINK_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "linkIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "scheduleIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "SCHEDULE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "scheduleIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "scheduleIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "transitionIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "TRANSITION_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "transitionIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "transitionIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "viewIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "viewIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "viewIssues"
                }
            ],
            "type": "JiraProject"
        };
    }();
    $86f6b5f51dcbf821$var$node.hash = "98150a5607016a9ea425926244f44d6a";
    var $86f6b5f51dcbf821$export$2e2bcd8739ae039 = $86f6b5f51dcbf821$var$node;
});
parcelRegister("12jwF", function(module, exports) {
    $parcel$export(module.exports, "AriProvider", ()=>$d9a27a44a6301e03$export$c806f8ac05dc61fa);
    $parcel$export(module.exports, "useEntityAri", ()=>$d9a27a44a6301e03$export$badcacdc306567b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d9a27a44a6301e03$var$AriContext = (0, $5uXOq.createContext)('');
    const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
            value: ari
        }, children);
    const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);
});
parcelRegister("54qG5", function(module, exports) {
    $parcel$export(module.exports, "BusinessEntityProvider", ()=>$a71d927d8f07dfcc$export$c800e064c3c327ef);
    $parcel$export(module.exports, "useBusinessEntity", ()=>$a71d927d8f07dfcc$export$ff2574b00bc1c100);
    var $5uXOq = parcelRequire("5uXOq");
    const $a71d927d8f07dfcc$var$BusinessEntityContext = (0, $5uXOq.createContext)(null);
    const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
            value: data
        }, children);
    const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
        const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
        return {
            data: entity
        };
    };
});
parcelRegister("5YBrl", function(module, exports) {
    $parcel$export(module.exports, "JqlProvider", ()=>$81e54c5b62a4ab4d$export$fdc879e2ba0da048);
    $parcel$export(module.exports, "useJqlContext", ()=>$81e54c5b62a4ab4d$export$f32e2f688fc08561);
    var $5uXOq = parcelRequire("5uXOq");
    const $81e54c5b62a4ab4d$var$JqlContext = (0, $5uXOq.createContext)('');
    const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
            value: jqlContext
        }, children);
    const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);
});
parcelRegister("1Zr0i", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$6a65786548fb921c$export$64d242981d970821);
    $parcel$export(module.exports, "useRealtimeContext", ()=>$6a65786548fb921c$export$f39c07717ad8c35b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6a65786548fb921c$var$RealtimeContext = (0, $5uXOq.createContext)([]);
    const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
        const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
            ids
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
            value: projectsIds
        }, children);
    };
    const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);
});
parcelRegister("daQYX", function(module, exports) {
    $parcel$export(module.exports, "ProjectHookProvider", ()=>$cf7f84dff81db95f$export$f1938a4916a14d9f);
    $parcel$export(module.exports, "useProject", ()=>$cf7f84dff81db95f$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    const $cf7f84dff81db95f$var$Context = (0, $5uXOq.createContext)(null);
    const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
            value: project
        }, children);
    const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
        const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
        if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
        return project;
    };
});
parcelRegister("gxGcZ", function(module, exports) {
    $parcel$export(module.exports, "FiltersProvider", ()=>$5ac2d1f4676106ae$export$905df3588d1d8c75);
    $parcel$export(module.exports, "useAssigneesFilterQuery", ()=>$5ac2d1f4676106ae$export$f39bce8705b01ff5);
    $parcel$export(module.exports, "useProjectFilter", ()=>$5ac2d1f4676106ae$export$b71768ffb8163578);
    $parcel$export(module.exports, "useAllowedFieldTypes", ()=>$5ac2d1f4676106ae$export$9dc8a291956c2fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
        assigneeQuery: '',
        projectFilter: {
            totalCount: 0,
            options: []
        }
    };
    const $5ac2d1f4676106ae$var$FiltersContext = (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
    const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
            const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
            const projectFilter = {
                totalCount: projects.length,
                options: projects.map((project)=>({
                        label: project.name,
                        value: String(project.id),
                        avatar: project.avatarUrl,
                        square: true
                    }))
            };
            return {
                assigneeQuery: assigneeQuery,
                projectFilter: projectFilter
            };
        }, [
            projects
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
            value: value
        }, children);
    };
    const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
    const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
    const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
        const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
        return (0, $5uXOq.useMemo)(()=>{
            const result = new Set(inputAllowedFieldTypes ?? (0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES));
            if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, (0, parcelRequire("5fc53")).PROJECT_TYPE));
            return result;
        }, [
            filtersContext,
            inputAllowedFieldTypes
        ]);
    };
});
parcelRegister("gzkAf", function(module, exports) {
    $parcel$export(module.exports, "POPUP_WIDTH", ()=>$92b04c6ea9a59b67$export$b6d617db656efcca);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$92b04c6ea9a59b67$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$92b04c6ea9a59b67$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$92b04c6ea9a59b67$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$92b04c6ea9a59b67$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$92b04c6ea9a59b67$export$fb22dccd99438559);
    $parcel$export(module.exports, "POPUP_OFFSET_TOP", ()=>$92b04c6ea9a59b67$export$15839778e99d81e7);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$92b04c6ea9a59b67$export$39aa3a14ebf850c7);
    $parcel$export(module.exports, "DATE_RANGE_TYPE", ()=>$92b04c6ea9a59b67$export$1178808c606e043b);
    $parcel$export(module.exports, "BUSINESS_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$c269ba5d631cb115);
    $parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$232814e45256d5dc);
    $parcel$export(module.exports, "IMPLEMENTED_TYPES", ()=>$92b04c6ea9a59b67$export$9615a3d79408a88a);
    $parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$a21166a4b76932b5);
    $parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", ()=>$92b04c6ea9a59b67$export$1989c7236a398e8a);
    var $gwIPs;
    var $5fc53;
    const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
    const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
    const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
    const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, (0, parcelRequire("gwIPs")).gridSize) / 2;
    const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $92b04c6ea9a59b67$export$fb22dccd99438559 = 14;
    const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
    const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
    const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
    const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
    const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        $92b04c6ea9a59b67$export$1178808c606e043b,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
    ];
    const $92b04c6ea9a59b67$export$232814e45256d5dc = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)
    ];
    const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
        ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
        ...$92b04c6ea9a59b67$export$232814e45256d5dc
    ]);
    const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ]);
    const $92b04c6ea9a59b67$export$90ca377eb0b24ff1 = {
        assignee: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        component: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        created: (0, (0, parcelRequire("5fc53")).CREATED),
        issuetype: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        labels: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        priority: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        project: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        reporter: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        status: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        updated: (0, (0, parcelRequire("5fc53")).UPDATED)
    };
    const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3.5;
    const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
    const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
    const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("k7McJ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", ()=>$47951bf9c4bef1f5$export$cb40bbf7ea51db63);
    const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
        experience: 'fetch-project',
        packageName: 'jiraBusinessEntityProjectProvider',
        teamName: 'wanjel'
    };
});
parcelRegister("8OqLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5cc2e237e9a9763$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a5cc2e237e9a9763$var$NotFoundComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("imwWS")), {
        moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
    });
    const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "not-found-component",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
    var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;
});
parcelRegister("imwWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("azGse")
    ]).then(()=>parcelRequire('4zX1V'));
});
parcelRegister("4nnGr", function(module, exports) {
    $parcel$export(module.exports, "useJWMListFeatures", ()=>$a4964e0e2b381387$export$1253737febad5ca9);
    $parcel$export(module.exports, "ListFeaturesProvider", ()=>$a4964e0e2b381387$export$9b33d4a1cd64aa2c);
    var $5uXOq = parcelRequire("5uXOq");
    const $a4964e0e2b381387$var$defaultFeaturesContext = {
        isShareButtonEnabled: true,
        isPresenceEnabled: true,
        issueViewInteraction: 'default',
        isOnboardingEnabled: true,
        featureView: 'list',
        inviteButtonInteraction: 'default',
        typeSelectInteraction: 'default',
        hasFilterCustomFields: true,
        hasCreateSubtask: true,
        canCreateIssues: true,
        isSoftwareFieldsEnabled: false,
        isBusinessFieldsEnabled: true,
        isScrumProject: false
    };
    const $a4964e0e2b381387$var$ListFeaturesContext = (0, $5uXOq.createContext)($a4964e0e2b381387$var$defaultFeaturesContext);
    const $a4964e0e2b381387$export$1253737febad5ca9 = ()=>(0, $5uXOq.useContext)($a4964e0e2b381387$var$ListFeaturesContext);
    const $a4964e0e2b381387$export$9b33d4a1cd64aa2c = ({ children: children, ...props })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                ...$a4964e0e2b381387$var$defaultFeaturesContext,
                ...props
            }), [
            props
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a4964e0e2b381387$var$ListFeaturesContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("evDrO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37be016d73635480$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dO33;
    var $aXhsp;
    var $AeWM3;
    var $eiOkd;
    var $54aDJ;
    var $imVeH;
    var $daQYX;
    var $adJfs;
    var $388MD;
    var $cm8b5;
    var $cLGgz;
    var $l9KLJ;
    var $lL5b5;
    var $9oIax;
    var $39xOx;
    var $6s1PB;
    var $4R6GH;
    var $5fc53;
    var $iXVV6;
    var $5oFIy;
    var $eTDjN;
    var $cpqMw;
    var $4nnGr;
    var $5cP2Q;
    var $8e3Yw;
    var $g4BWd;
    var $lz9hZ;
    var $aoiYi;
    const $37be016d73635480$var$analyticsSourceName = 'listView';
    const $37be016d73635480$var$ListViewWithWorkflow = (0, $5uXOq.memo)(({ formattingRulesQuery: formattingRulesQuery })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectId = String(projectData.id);
        const projectKey = projectData.key;
        const projectName = projectData.name;
        const isTeamManaged = projectData.isSimplified;
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGroupingByStatus = groupByFieldId === (0, (0, parcelRequire("5fc53")).STATUS_TYPE);
        const services = (0, (0, parcelRequire("g4BWd")).useCreateIssue)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "list",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: $37be016d73635480$var$analyticsSourceName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aoiYi")).default), {
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            formattingRulesQuery: formattingRulesQuery
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                projectKey: projectKey
            }
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l9KLJ")).WorkflowsProvider), {
            enabled: isGroupingByStatus
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLGgz")).IssueCreateProvider), {
            onCreateIssue: services.createIssue,
            onRefetchIssue: services.refetchIssue
        }, content));
    });
    const $37be016d73635480$export$4b527a365d42af03 = (0, $5uXOq.memo)(({ header: header, formattingRulesQuery: formattingRulesQuery })=>{
        const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const [formsIssueViewExpConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jwm_business_forms_issue_view');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiOkd")).default), {
            header: header,
            sidebarTheme: isSoftwareFieldsEnabled ? 'software' : 'business',
            withSidebar: true,
            withOverflow: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adJfs")).IssueTypesAndFieldsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement($37be016d73635480$var$ListViewWithWorkflow, {
            formattingRulesQuery: formattingRulesQuery
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("388MD")).RefetchFieldsController), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "forms-label-flag",
            packageName: "jiraBusinessList",
            teamName: "jira-werewolves"
        }, formsIssueViewExpConfig.get('isFormsIssueViewEnabled', false) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5cP2Q")).FormsLabelFlag), null)));
    });
    const $37be016d73635480$var$ListViewRootWithConfluenceProvider = ({ children: children })=>{
        const hasConfluence = (0, (0, parcelRequire("imVeH")).useTenantHasConfluence)();
        return hasConfluence ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54aDJ")).ConfluenceModalProvider), null, children) : children;
    };
    const $37be016d73635480$export$d63bf888f7c02a67 = (props)=>{
        const hasConfluence = (0, (0, parcelRequire("imVeH")).useTenantHasConfluence)();
        if (hasConfluence || (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($37be016d73635480$var$ListViewRootWithConfluenceProvider, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$4b527a365d42af03, props))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$4b527a365d42af03, props));
    };
    const $37be016d73635480$var$List = (props)=>{
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9oIax")).AuthenticationErrorBoundary), {
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lL5b5")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($37be016d73635480$export$d63bf888f7c02a67, props));
        if ((0, (0, parcelRequire("4R6GH")).fg)('list-handle-field-missing-handler-server-error')) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cpqMw")).InvalidJQLErrorBoundary), {
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lz9hZ")).EmptyState), {
                    reason: "INVALID_JQL"
                })
        }, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("eTDjN")).VIEW_EXPERIENCE),
            shouldStartExperience: true
        }, content);
    };
    var $37be016d73635480$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($37be016d73635480$var$List);
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $dxpxC;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("clSzL")).Observable)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("dxpxC")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("clSzL")).Observable).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("clSzL")).Observable).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("dxpxC", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$4350c2bcf1320fcf$export$fb326ed954631f3f);
    var $clSzL;
    var $bFU4G;
    const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("eiOkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98d0f47ed36cd9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $6cG4N;
    var $bUSNl;
    var $lLfAu;
    const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
        const [{ content: sidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const isSidebarOpen = withSidebar && sidebarContent != null;
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, children);
        if (withSidebar) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLfAu")).SidebarLayout), {
            theme: sidebarTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $b98d0f47ed36cd9a$var$contentWrapperStyles,
                isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
            ]
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b98d0f47ed36cd9a$var$ThemedContainer, {
            shouldAddPadding: shouldAddPadding,
            isSidebarOpen: isSidebarOpen,
            withSidebar: withSidebar,
            withDynamicHeight: withDynamicHeight,
            withOverflow: withOverflow,
            id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
            className: className
        }, content);
    };
    const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto'
    });
    const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingRight: 'space.300',
        paddingBottom: 'space.300'
    });
    var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
    const $b98d0f47ed36cd9a$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
                !__cmplp.withSidebar && "_syazfrbu",
                __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
                __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
                __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
                __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';
parcelRegister("bUSNl", function(module, exports) {
    $parcel$export(module.exports, "getSidebarQueryParams", ()=>$39fc2da09b28cabf$export$ddc11e4d41e7cf62);
    $parcel$export(module.exports, "useSidebar", ()=>$39fc2da09b28cabf$export$54c70f22f548bff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $3hGWp;
    var $dCm1o;
    var $3sQ5x;
    var $iXqE5;
    var $jnA4H;
    const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
    const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
            (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
            (0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM)
        ];
    const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
    const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                content: content
            });
        };
    const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
            if (newWidth === state.sidebarWidth) return;
            setState({
                ...state,
                sidebarWidth: newWidth
            });
            (0, (0, parcelRequire("jnA4H")).localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
        };
    const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                onSidebarClose: onSidebarClose
            });
        };
    const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            state.onSidebarClose();
            setState({
                ...state,
                content: null,
                onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
            });
        };
    const $39fc2da09b28cabf$var$actions = {
        setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
        setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
        setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
        closeSidebar: $39fc2da09b28cabf$var$closeSidebar
    };
    const $39fc2da09b28cabf$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            content: null,
            sidebarWidth: (0, (0, parcelRequire("jnA4H")).localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
            onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $39fc2da09b28cabf$var$actions,
        name: 'JWMSidebarStore'
    });
    const $39fc2da09b28cabf$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($39fc2da09b28cabf$var$Store);
    const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
        const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
        const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
        const [, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
            const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                    [param]: undefined
                }), {});
            setQueryParams(newQueryParams);
        }, [
            setQueryParams,
            sidebarQueryParams
        ]);
        return [
            state,
            {
                ...hookActions,
                resetSidebarQueryParams: resetSidebarQueryParams
            }
        ];
    };
});
parcelRegister("hE5wF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", ()=>$bfd6cbe4770149b5$export$8386e51ba415e85d);
    $parcel$export(module.exports, "DEFAULT_AVATAR_RES", ()=>$bfd6cbe4770149b5$export$159fe44438c210e9);
    $parcel$export(module.exports, "FILTER_PARAM", ()=>$bfd6cbe4770149b5$export$d8301e0b33832d94);
    $parcel$export(module.exports, "INLINE_CREATE_PARAM", ()=>$bfd6cbe4770149b5$export$599c163c1570a353);
    $parcel$export(module.exports, "INVITE_OPEN_PARAM", ()=>$bfd6cbe4770149b5$export$3a74d1a195d2f007);
    $parcel$export(module.exports, "SELECTED_ISSUE_PARAM", ()=>$bfd6cbe4770149b5$export$c070acdc9b0f1be5);
    $parcel$export(module.exports, "SELECTED_COMMENT_PARAM", ()=>$bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
    $parcel$export(module.exports, "GROUP_BY_ASSIGNEE", ()=>$bfd6cbe4770149b5$export$dba794af6c0f2afc);
    $parcel$export(module.exports, "GROUP_BY_PRIORITY", ()=>$bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
    $parcel$export(module.exports, "GROUP_BY_CATEGORY", ()=>$bfd6cbe4770149b5$export$22ef551f315f2786);
    $parcel$export(module.exports, "GROUP_BY_STATUS", ()=>$bfd6cbe4770149b5$export$6d69efb296b78a);
    $parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e23e1d1ea45171c2);
    $parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e35c6e217c75dc4b);
    $parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", ()=>$bfd6cbe4770149b5$export$e5eab344feb92af9);
    $parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", ()=>$bfd6cbe4770149b5$export$a311e1b78816c048);
    $parcel$export(module.exports, "CARD_COVERS_TYPE", ()=>$bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$bfd6cbe4770149b5$export$5716e8bcb003888d);
    $parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$1f9fb9f15184100f);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$c72ea455b368cdd9);
    const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
    const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
    const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
    const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
    const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
    const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
    const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
    const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
    const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
    const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
    const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
    const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
    const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
    const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
    const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
    const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
    const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
    const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
    const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
    const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
    const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("jnA4H", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$301038d04a64b539$export$c2ed3351cac403d1);
    var $bSSG7;
    const $301038d04a64b539$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_common');
});
parcelRegister("lLfAu", function(module, exports) {
    $parcel$export(module.exports, "SidebarLayout", ()=>$1dbab6fa0f2d1b51$export$8295a33ab8a36876);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $getxR;
    var $He4jn;
    var $bUSNl;
    var $eHSp3;
    const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $1dbab6fa0f2d1b51$var$sidebarStyles,
                theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
            ],
            style: {
                width: sidebarWidth
            }
        }, children);
    const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
        (0, (0, parcelRequire("getxR")).useSidebarQueryParams)();
        const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, (0, parcelRequire("He4jn")).useResizer)();
        (0, $5uXOq.useEffect)(()=>()=>{
                setSidebarContent(null);
            }, [
            setSidebarContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).Wrapper), {
            isResizing: isResizing,
            "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
        }, children, content && (0, ($parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
            sidebarWidth: sidebarWidth,
            theme: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).ResizeHandle), {
            onMouseDown: onMouseDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).SidebarContent), null, content)));
    };
    const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface',
        flexGrow: 0,
        flexShrink: 0,
        position: 'relative',
        zIndex: 'card',
        maxWidth: '75%'
    });
    const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'border.radius.200',
        borderTopRightRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        marginRight: 'space.300',
        marginTop: 'space.300'
    });
});
parcelRegister("getxR", function(module, exports) {
    $parcel$export(module.exports, "useSidebarQueryParams", ()=>$7ddee5a34b903b90$export$34adbeffbeceba68);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $3hGWp;
    var $bUSNl;
    const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const sidebarQueryParams = (0, (0, parcelRequire("bUSNl")).getSidebarQueryParams)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const prevQueryParams = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(queryParams);
        const closeSidebar = (0, $5uXOq.useCallback)(()=>{
            resetSidebarQueryParams();
            setSidebarContent(null);
        }, [
            resetSidebarQueryParams,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarQueryParams.forEach((queryParam)=>{
                if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                    const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                            [param]: undefined
                        }), {});
                    setQueryParams(newQueryParams);
                }
            });
        }, [
            prevQueryParams,
            queryParams,
            setQueryParams,
            sidebarQueryParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleKeydown = (event)=>{
                if (!queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
                if (queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') return;
                if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                    closeSidebar();
                }
            };
            typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            closeSidebar,
            content?.key,
            createAnalyticsEvent,
            queryParams
        ]);
    };
});
parcelRegister("He4jn", function(module, exports) {
    $parcel$export(module.exports, "useResizer", ()=>$80d7a99fb39f1e91$export$faede3f1542958fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $bUSNl;
    const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
    const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
        const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const startRef = (0, $5uXOq.useRef)(0);
        const width = (0, $5uXOq.useRef)(0);
        const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
        const resize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((clientX)=>{
            const proposedWidth = width.current + startRef.current - clientX;
            setSidebarWidth(proposedWidth);
        }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
            setSidebarWidth
        ]);
        const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            resize(event.clientX);
        }, [
            resize
        ]);
        const onMouseUp = (0, $5uXOq.useCallback)(()=>{
            startRef.current = 0;
            width.current = 0;
            setIsResizing(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }, [
            onMouseMove,
            onMouseUp
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
            startRef.current = event.clientX;
            width.current = sidebarWidth;
            setIsResizing(true);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove,
            onMouseUp,
            sidebarWidth
        ]);
        return {
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            isResizing: isResizing
        };
    };
});
parcelRegister("eHSp3", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$71d20039839e60ab$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SidebarContent", ()=>$71d20039839e60ab$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "ResizeHandle", ()=>$71d20039839e60ab$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $71d20039839e60ab$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isResizing: isResizing, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
                __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$49e8f7b58a4df4ea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$33f2411a0ad35be7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("54aDJ", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceModalProvider", ()=>$80aa91d8ae783d16$export$465701d340b2a0fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $bKinl;
    var $3kWBc;
    var $hInrt;
    var $7X77D;
    const $80aa91d8ae783d16$export$465701d340b2a0fb = ({ children: children })=>{
        const viewModalControlNew = (0, (0, parcelRequire("hInrt")).useConfluenceViewModalNew)();
        const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, (0, parcelRequire("hInrt")).useConfluenceCreatePageModal)();
        const confluenceContext = (0, $5uXOq.useMemo)(()=>({
                showConfluencePage: viewModalControlNew.showConfluencePage,
                showCreatePage: showCreatePage
            }), [
            viewModalControlNew.showConfluencePage,
            showCreatePage
        ]);
        const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKinl")).confluencePagesContext).Provider, {
            value: confluenceContext
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, confluencePageUrl != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7X77D")).default), {
            onClose: viewModalControlNew.hideConfluencePage,
            confluenceUrl: confluencePageUrl || '',
            mode: viewMode,
            onCloseComplete: onCloseCompleteCallback,
            isOpen: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kWBc")).default), {
            onClose: hideCreatePage,
            ...createModalProps
        }));
    };
});
parcelRegister("bKinl", function(module, exports) {
    $parcel$export(module.exports, "confluencePagesContext", ()=>$2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
    $parcel$export(module.exports, "useConfluencePagesModals", ()=>$2f6ddafdd32c5a4c$export$750ed67ce7764287);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $2f6ddafdd32c5a4c$export$4cb8e522e2ecb030 = (0, $5uXOq.createContext)({
        showConfluencePage: (0, ($parcel$interopDefault($8Rkzz))),
        showCreatePage: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $2f6ddafdd32c5a4c$export$750ed67ce7764287 = ()=>{
        const context = (0, $5uXOq.useContext)($2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
        const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
        return {
            showConfluencePage: showConfluencePage,
            showCreatePage: showCreatePage
        };
    };
});
parcelRegister("3kWBc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0652eb4cfa0c28f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $d0652eb4cfa0c28f$var$LazyCreatePage = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("dF7lh")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
    });
    var $d0652eb4cfa0c28f$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-page-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d0652eb4cfa0c28f$var$LazyCreatePage, props));
});
parcelRegister("dF7lh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8pEjw")
    ]).then(()=>parcelRequire('5mDXx'));
});
parcelRegister("hInrt", function(module, exports) {
    $parcel$export(module.exports, "useConfluenceCreatePageModal", ()=>$ee59ca0344a0436e$export$81799af04beb008f);
    $parcel$export(module.exports, "useConfluenceViewModalNew", ()=>$ee59ca0344a0436e$export$3cac20211c8788d8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gVnoy;
    var $2NMNM;
    var $8zOmE;
    const $ee59ca0344a0436e$export$81799af04beb008f = ()=>{
        const [createModalProps, setCreateModalProps] = (0, $5uXOq.useState)({
            showCreateModal: false,
            onCreate: undefined
        });
        const showCreatePage = (0, $5uXOq.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
                showCreateModal: true,
                onCreate: onCreate,
                onCloseComplete: onCloseComplete,
                onCancel: onCancel
            }), []);
        const hideCreatePage = (0, $5uXOq.useCallback)(()=>setCreateModalProps({
                showCreateModal: false,
                onCreate: undefined
            }), []);
        return {
            createModalProps: createModalProps,
            showCreatePage: showCreatePage,
            hideCreatePage: hideCreatePage
        };
    };
    const $ee59ca0344a0436e$export$3cac20211c8788d8 = ()=>{
        const [viewModalProps, setViewModalProps] = (0, $5uXOq.useState)({
            confluencePageUrl: null,
            viewMode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const showConfluencePage = (0, $5uXOq.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
            setViewModalProps({
                confluencePageUrl: confluenceUrl,
                viewMode: mode || (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
                onCloseCompleteCallback: onCloseComplete
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
        }, [
            createAnalyticsEvent
        ]);
        const hideConfluencePage = (0, $5uXOq.useCallback)(()=>{
            setViewModalProps({
                confluencePageUrl: null,
                viewMode: (0, (0, parcelRequire("gVnoy")).EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
                onCloseCompleteCallback: undefined
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
        }, [
            createAnalyticsEvent
        ]);
        return {
            viewModalProps: viewModalProps,
            showConfluencePage: showConfluencePage,
            hideConfluencePage: hideConfluencePage
        };
    };
});
parcelRegister("7X77D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e7a84b08712e0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a3e7a84b08712e0f$var$LazyConfluenceViewModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("2lJSy")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
    });
    var $a3e7a84b08712e0f$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "view-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3e7a84b08712e0f$var$LazyConfluenceViewModal, props));
});
parcelRegister("2lJSy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9vLmH")
    ]).then(()=>parcelRequire('17Ef1'));
});
parcelRegister("imVeH", function(module, exports) {
    $parcel$export(module.exports, "useTenantHasConfluence", ()=>$734552c5f3b177b5$export$964fe2dd9242a588);
    var $4Pf62;
    var $hqBSi;
    const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        return Boolean(licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).CONFLUENCE]);
    };
});
parcelRegister("adJfs", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesAndFieldsContext", ()=>$1c25c33c14b14fda$export$31eaf35dc72d0fa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $8zOmE;
    var $2NMNM;
    var $1T2vX;
    const $1c25c33c14b14fda$var$noop = ()=>{};
    const $1c25c33c14b14fda$var$TRACKING_TIMEOUT = 1000;
    const $1c25c33c14b14fda$export$31eaf35dc72d0fa0 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const IssueTypesAndFieldsViewContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'VIEW'
        });
        const IssueTypesAndFieldsCreateContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'CREATE'
        });
        const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return $1c25c33c14b14fda$var$noop;
            const timeoutId = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                    watches: client?.cache?.watches?.size
                });
            }, $1c25c33c14b14fda$var$TRACKING_TIMEOUT);
            return ()=>{
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [
            createAnalyticsEvent,
            loading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextView).Provider, {
            value: IssueTypesAndFieldsViewContextProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextCreate).Provider, {
            value: IssueTypesAndFieldsCreateContextProps
        }, children));
    };
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("1T2vX", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesAndFieldsService", ()=>$90cf08abf5e3ede7$export$3ef3324b7f7d6a38);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextView", ()=>$90cf08abf5e3ede7$export$77937175321fab39);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", ()=>$90cf08abf5e3ede7$export$fbd286e14113bfc);
    $parcel$export(module.exports, "useIssueTypesAndFields", ()=>$90cf08abf5e3ede7$export$d2121b02f0b65782);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $gN11a;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $1nb22;
    var $doZTA;
    var $8Zw8m;
    var $8tTgF;
    const $90cf08abf5e3ede7$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
    const $90cf08abf5e3ede7$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
    const $90cf08abf5e3ede7$var$isProjectPermissionError = (error)=>error.message.indexOf($90cf08abf5e3ede7$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($90cf08abf5e3ede7$export$4c72baf45fce4585) > -1 || error.extensions?.statusCode === 403 || error.extensions?.statusCode === 404;
    const $90cf08abf5e3ede7$export$6b9bc8a33ade0736 = (input)=>{
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(routerState?.match, routerState?.query);
        const variables = (0, $5uXOq.useMemo)(()=>({
                projectKey: projectKey,
                issueOperation: input.issueOperation,
                first: 100
            }), [
            input.issueOperation,
            projectKey
        ]);
        const { query: query, view: view } = (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)[0, (0, parcelRequire("8Zw8m")).DEFAULT];
        return (0, $5uXOq.useMemo)(()=>({
                loading: false,
                query: query,
                view: view,
                variables: variables
            }), [
            query,
            view,
            variables
        ]);
    };
    const $90cf08abf5e3ede7$export$1768f0a0f85b4de9 = (input)=>{
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { variables: queryVariables, query: query } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
        return (0, $5uXOq.useCallback)(({ findField: findField, updateItem: updateItem })=>{
            const getCacheData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: queryVariables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useIssueTypesAndFieldsCache',
                            packageName: 'jiraBusinessEntityProject',
                            teamName: 'wanjel'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(queryVariables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const cacheData = getCacheData();
            const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
            if (existingEdges == null) return;
            let shouldUpdate = false;
            const newEdges = existingEdges.map((edge)=>{
                const existingFields = edge?.node?.fields?.edges;
                if (existingFields == null) return edge;
                const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
                const existingField = existingFields[itemToUpdateIndex]?.node;
                if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
                const itemOverride = updateItem(existingField);
                if (itemOverride === undefined) return edge;
                const newFields = [
                    ...existingFields
                ];
                newFields[itemToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraIssueFieldEdge'
                };
                shouldUpdate = true;
                return {
                    ...edge,
                    node: {
                        ...edge?.node || {},
                        fields: {
                            edges: newFields,
                            __typename: 'JiraIssueFieldConnection'
                        }
                    }
                };
            });
            if (!shouldUpdate) return;
            const newData = {
                ...cacheData,
                jiraBusinessAvailableFields: {
                    ...cacheData?.jiraBusinessAvailableFields || {},
                    edges: newEdges
                }
            };
            try {
                client.writeQuery({
                    query: query,
                    variables: queryVariables,
                    notifyOnNetworkStatusChange: true,
                    data: newData
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            query,
            queryVariables
        ]);
    };
    const $90cf08abf5e3ede7$export$3ef3324b7f7d6a38 = (input)=>{
        const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $5uXOq.useState)(false);
        const fetchAttempts = (0, $5uXOq.useRef)(0);
        const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: queryVariables,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            onError: (apolloError)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if ($90cf08abf5e3ede7$var$isProjectPermissionError(apolloError)) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: `availableFields${view}ViewQuery`,
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: `Failed to fetch available fields in ${view} view`
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (onCompletedData)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if (onCompletedData?.jiraBusinessAvailableFields == null) throw error || new Error('No available fields data');
                onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                    const fieldEdges = e?.node?.fields?.edges;
                    if (fieldEdges == null || fieldEdges?.length === 0) {
                        const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                        const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                        if (fetchAttempts.current < 1) {
                            fetchAttempts.current += 1;
                            refetch();
                        } else throw emptyFieldsError;
                    }
                });
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (queryVariables && !hasStartedFetchingFields && !error) {
                setHasStartedFetchingFields(true);
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$7b887ee35f2b465e));
                getAvailableFields();
            }
        }, [
            error,
            getAvailableFields,
            hasStartedFetchingFields,
            queryVariables,
            view
        ]);
        const refetch = (0, $5uXOq.useCallback)(()=>{
            if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
            const err = new Error('availableFields refetch is undefined because the service has not been called yet');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'availableFieldsRefetchIsUndefined',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        }, [
            called,
            refetchQuery,
            queryVariables
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
        }, [
            hasStartedFetchingFields,
            error
        ]);
        const result = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResult)(data), [
            data
        ]);
        const typesWithFields = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResultToTypesWithFields)(data), [
            data
        ]);
        const hierarchyLevels = (0, $5uXOq.useMemo)(()=>result.issueTypes.map((issueType)=>({
                    level: issueType.hierarchyLevel,
                    name: issueType.name,
                    id: issueType.id
                })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
            result.issueTypes
        ]);
        const isFieldsLoading = hasStartedFetchingFields ? loading : true;
        return {
            error: error,
            loading: error ? false : isQueryLoading || isFieldsLoading,
            data: result,
            typesWithFields: typesWithFields,
            hierarchyLevels: hierarchyLevels,
            refetch: refetch
        };
    };
    const $90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue = {
        data: {
            fields: [],
            issueTypes: []
        },
        loading: false,
        error: undefined,
        typesWithFields: [],
        hierarchyLevels: []
    };
    const $90cf08abf5e3ede7$export$77937175321fab39 = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$fbd286e14113bfc = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$d2121b02f0b65782 = (input)=>{
        const issueTypesAndFieldsViewData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$77937175321fab39);
        const issueTypesAndFieldsCreateData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$fbd286e14113bfc);
        if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
        return issueTypesAndFieldsCreateData;
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("8Zw8m", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT", ()=>$c9bd1f086657e924$export$e6952b12ade67489);
    $parcel$export(module.exports, "HierarchyLevel", ()=>$c9bd1f086657e924$export$7faaf3222dfd10db);
    const $c9bd1f086657e924$export$e6952b12ade67489 = 'default';
    const $c9bd1f086657e924$export$7faaf3222dfd10db = Object.freeze({
        EPIC: 1,
        BASE: 0,
        SUBTASK: -1
    });
});
parcelRegister("8tTgF", function(module, exports) {
    $parcel$export(module.exports, "transformResult", ()=>$66b8ed432f1db6bc$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "transformResultToTypesWithFields", ()=>$66b8ed432f1db6bc$export$55ab7865f91ba09b);
    $parcel$export(module.exports, "JWMQueryByRouteMap", ()=>$66b8ed432f1db6bc$export$7188da46161cbb8f);
    var $65Ltd;
    var $5fc53;
    var $8Zw8m;
    var $e3MSU;
    const $66b8ed432f1db6bc$export$b07b0d8dc0894ecf = {
        fields: [],
        issueTypes: []
    };
    const $66b8ed432f1db6bc$var$emptyArray = [];
    const $66b8ed432f1db6bc$export$bffa388e20165996 = (node, issueType)=>{
        const fieldConfig = {
            isRequired: !!node.fieldConfig?.isRequired,
            isEditable: !!node.fieldConfig?.isEditable
        };
        if (node.type === 'priority') {
            fieldConfig.options = node.priorities.nodes;
            if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
            else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
        }
        if (node.type === 'issuetype') {
            fieldConfig.options = node.issueTypes.nodes;
            fieldConfig.avatarId = issueType.avatarId;
            fieldConfig.avatarUrl = issueType.avatar?.medium;
        }
        if (node.type === 'issuelinks' && node.issueLinkTypeRelations) fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find((linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || node.type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId,
                    color: color?.colorKey ?? null
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        return {
            id: node.fieldId,
            aliasFieldId: node.aliasFieldId,
            name: node.name,
            type: node.type,
            fieldConfig: fieldConfig,
            issueTypes: [],
            __typename: node.__typename
        };
    };
    const $66b8ed432f1db6bc$export$f13b29f9ed0c5a03 = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
            const issueFieldsById = {};
            const issueTypesById = {};
            data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
                issueTypesById[issueType.issueTypeId] = {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? null,
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                };
                fields.edges.map((edge)=>edge && edge.node || {}).forEach((node)=>{
                    if (node.fieldId) {
                        if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $66b8ed432f1db6bc$export$bffa388e20165996(node, issueType);
                        issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                        issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                    }
                });
            });
            return {
                fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
                issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
            };
        }
        return $66b8ed432f1db6bc$export$b07b0d8dc0894ecf;
    };
    const $66b8ed432f1db6bc$export$55ab7865f91ba09b = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
                issueType: {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? '',
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                },
                fields: fields.edges.map((edge)=>edge && edge.node || {}).map((node)=>$66b8ed432f1db6bc$export$bffa388e20165996(node, issueType))
            }));
        return $66b8ed432f1db6bc$var$emptyArray;
    };
    const $66b8ed432f1db6bc$export$7188da46161cbb8f = {
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM)]: {
            view: 'Form',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT)]: {
            view: 'FormSubmit',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR)]: {
            view: 'Calendar',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED)]: {
            view: 'CalendarEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST)]: {
            view: 'List',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED)]: {
            view: 'ListEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE)]: {
            view: 'Timeline',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED)]: {
            view: 'TimelineEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD)]: {
            view: 'Board',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED)]: {
            view: 'BoardEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("8Zw8m")).DEFAULT)]: {
            view: 'Common',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        }
    };
});
parcelRegister("e3MSU", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", ()=>$32ca725097f9e68f$export$ba5f98a8d6136727);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", ()=>$32ca725097f9e68f$export$cba408dff1091b60);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", ()=>$32ca725097f9e68f$export$363435cea078aa93);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", ()=>$32ca725097f9e68f$export$1641a42cf2cdb09a);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", ()=>$32ca725097f9e68f$export$7903c43b0ec55315);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", ()=>$32ca725097f9e68f$export$79304c172f5555ae);
    var $5cllN;
    const $32ca725097f9e68f$export$ec2562ca5badac3b = (0, (0, parcelRequire("5cllN")).default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
    const $32ca725097f9e68f$export$ba5f98a8d6136727 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$cba408dff1091b60 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$363435cea078aa93 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$1641a42cf2cdb09a = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$7903c43b0ec55315 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$79304c172f5555ae = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
});
parcelRegister("388MD", function(module, exports) {
    $parcel$export(module.exports, "useRefetchFields", ()=>$d6a4bf67baf22373$export$715664166ba98964);
    $parcel$export(module.exports, "RefetchFieldsController", ()=>$d6a4bf67baf22373$export$f1f4bd03b141f216);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $3sQ5x;
    var $iXqE5;
    var $1T2vX;
    const $d6a4bf67baf22373$var$REFETCH_TIMEOUT = 500;
    const $d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES = 5;
    const $d6a4bf67baf22373$var$actions = {
        setRefetchFields: (refetchFields)=>({ setState: setState })=>setState({
                    refetchFields: refetchFields
                })
    };
    const $d6a4bf67baf22373$export$c87e497850d70653 = ()=>Promise.resolve(null);
    const $d6a4bf67baf22373$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            refetchFields: $d6a4bf67baf22373$export$c87e497850d70653
        },
        actions: $d6a4bf67baf22373$var$actions,
        name: 'JWMRefetchFieldsStore'
    });
    const $d6a4bf67baf22373$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($d6a4bf67baf22373$var$Store);
    const $d6a4bf67baf22373$export$715664166ba98964 = ()=>{
        const [{ refetchFields: refetchFields }, { setRefetchFields: setRefetchFields }] = $d6a4bf67baf22373$var$useHook();
        return {
            refetchFields: refetchFields,
            setRefetchFields: setRefetchFields
        };
    };
    const $d6a4bf67baf22373$export$f1f4bd03b141f216 = ()=>{
        const pendingRefetch = (0, $5uXOq.useRef)();
        const retryCount = (0, $5uXOq.useRef)(0);
        const { setRefetchFields: setRefetchFields } = $d6a4bf67baf22373$export$715664166ba98964();
        const { refetch: refetchViewFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'VIEW'
        });
        const { refetch: refetchCreateFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'CREATE'
        });
        const setPendingRefetch = (refetch, resolve)=>{
            const toId = setTimeout(()=>{
                pendingRefetch.current = null;
                refetch();
            }, $d6a4bf67baf22373$var$REFETCH_TIMEOUT);
            pendingRefetch.current = {
                timeoutId: toId,
                resolve: resolve
            };
        };
        const clearPendingRefetch = ()=>{
            if (pendingRefetch.current) {
                const { timeoutId: toId, resolve: resolve } = pendingRefetch.current;
                clearTimeout(toId);
                resolve(null);
                pendingRefetch.current = null;
            }
        };
        (0, $5uXOq.useEffect)(()=>()=>{
                setRefetchFields($d6a4bf67baf22373$export$c87e497850d70653);
            }, [
            setRefetchFields
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearPendingRefetch();
            }, []);
        const refetchFields = (0, $5uXOq.useCallback)(({ shouldRetry: shouldRetry } = {})=>{
            clearPendingRefetch();
            return new Promise((resolve, reject)=>{
                const refetch = async ()=>{
                    try {
                        const response = await Promise.all([
                            refetchViewFields(),
                            refetchCreateFields()
                        ]);
                        if (!shouldRetry || !shouldRetry(response)) {
                            resolve(response);
                            retryCount.current = 0;
                        } else if (retryCount.current < $d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES) {
                            retryCount.current += 1;
                            setPendingRefetch(refetch, resolve);
                        } else {
                            const error = new Error('refetching fields exceeded retries count');
                            (0, (0, parcelRequire("jcw0u")).default)({
                                meta: {
                                    id: 'JwmRefetchFields',
                                    packageName: 'jiraBusinessEntityProject',
                                    teamName: 'wanjel'
                                },
                                error: error,
                                attributes: {
                                    message: `Failed to refetch fields after ${$d6a4bf67baf22373$var$MAX_NUMBER_OF_RETRIES} retries`
                                },
                                sendToPrivacyUnsafeSplunk: true,
                                skipSentry: true
                            });
                            reject(error);
                        }
                    } catch (error) {
                        reject(error);
                    }
                };
                setPendingRefetch(refetch, resolve);
            });
        }, [
            refetchCreateFields,
            refetchViewFields
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setRefetchFields(refetchFields);
        }, [
            refetchFields,
            setRefetchFields
        ]);
        return null;
    };
});
parcelRegister("cLGgz", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateProvider", ()=>$dc15b071bf2d5f6e$export$a975cd9627cdf4b6);
    $parcel$export(module.exports, "useCreateIssue", ()=>$dc15b071bf2d5f6e$export$8af2d18142c8506c);
    $parcel$export(module.exports, "isOptimisticIssue", ()=>$dc15b071bf2d5f6e$export$8512029c7fc94e58);
    $parcel$export(module.exports, "useIsHighlighted", ()=>$dc15b071bf2d5f6e$export$2ecca9d8a7f031af);
    var $5uXOq = parcelRequire("5uXOq");
    var $dqDis;
    var $4R6GH;
    var $cYlk7;
    var $ja8d8;
    var $ecPXN;
    class $dc15b071bf2d5f6e$var$IssueCreateJob {
        constructor(createParams){
            this.createParams = createParams;
            this.promise = new Promise((resolve, reject)=>{
                this.reject = reject;
                this.resolve = resolve;
            });
        }
    }
    const $dc15b071bf2d5f6e$var$IssueCreateContext = (0, $5uXOq.createContext)(null);
    const $dc15b071bf2d5f6e$var$reducer = (state, action)=>{
        switch(action.type){
            case 'enqueue':
                return {
                    ...state,
                    jobQueue: [
                        ...state.jobQueue,
                        action.job
                    ]
                };
            case 'start-job':
                return {
                    ...state,
                    runningJob: state.jobQueue[0],
                    jobQueue: state.jobQueue.slice(1)
                };
            case 'end-job':
                return {
                    ...state,
                    runningJob: null
                };
            case 'highlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues,
                        action.issueId
                    ])
                };
            case 'unhighlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues
                    ].filter((id)=>id !== action.issueId))
                };
            case 'save-summary':
                return {
                    ...state,
                    summary: action.summary
                };
            default:
                return state;
        }
    };
    const $dc15b071bf2d5f6e$var$initialState = {
        jobQueue: [],
        runningJob: null,
        highlightedIssues: new Set(),
        summary: ''
    };
    const $dc15b071bf2d5f6e$export$a975cd9627cdf4b6 = ({ onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const currentUser = user;
        const nextIssueId = (0, $5uXOq.useRef)(-1);
        const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $5uXOq.useReducer)($dc15b071bf2d5f6e$var$reducer, $dc15b071bf2d5f6e$var$initialState);
        const createIssueController = (0, (0, parcelRequire("ja8d8")).useCreateIssue)(onCreateIssue, onRefetchIssue);
        const highlightIssue = (0, $5uXOq.useCallback)((issueId)=>dispatch({
                type: 'highlight',
                issueId: issueId
            }), []);
        const unhighlightIssue = (0, $5uXOq.useCallback)((issueId)=>setTimeout(()=>{
                dispatch({
                    type: 'unhighlight',
                    issueId: issueId
                });
            }, 2000), []);
        const createIssue = (0, $5uXOq.useCallback)((createParams)=>{
            const job = new $dc15b071bf2d5f6e$var$IssueCreateJob(createParams);
            dispatch({
                type: 'enqueue',
                job: job
            });
            let rank;
            if (createParams.input.rankAfter) rank = (0, (0, parcelRequire("dqDis")).getNextRank)(createParams.input.rankAfter.rank);
            else if (createParams.input.rankBefore) rank = (0, (0, parcelRequire("dqDis")).getPreviousRank)(createParams.input.rankBefore.rank);
            const reporter = {
                accountId: currentUser.accountId,
                avatarUrl: currentUser.avatarUrls['48x48'],
                displayName: currentUser.displayName
            };
            const optimisticIssuePayload = {
                issueId: nextIssueId.current--,
                rank: rank,
                reporter: reporter,
                ...createParams.input
            };
            return {
                optimisticIssuePayload: optimisticIssuePayload,
                promise: job.promise
            };
        }, [
            currentUser
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (jobQueue.length > 0 && !runningJob) {
                const job = jobQueue[0];
                dispatch({
                    type: 'start-job'
                });
                createIssueController({
                    createParams: job.createParams,
                    highlightIssue: highlightIssue,
                    unhighlightIssue: unhighlightIssue,
                    ignoreFiltersContext: ignoreFiltersContext
                }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                        type: 'end-job'
                    }));
            }
        }, [
            createIssueController,
            highlightedIssues,
            jobQueue,
            runningJob,
            highlightIssue,
            unhighlightIssue,
            ignoreFiltersContext
        ]);
        (0, (0, parcelRequire("ecPXN")).useCreateParamHandler)();
        const saveSummary = (0, $5uXOq.useCallback)((newSummary)=>{
            dispatch({
                type: 'save-summary',
                summary: newSummary
            });
        }, []);
        const value = (0, $5uXOq.useMemo)(()=>({
                createIssue: createIssue,
                highlightedIssues: highlightedIssues,
                summary: summary,
                saveSummary: saveSummary
            }), [
            createIssue,
            highlightedIssues,
            summary,
            saveSummary
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dc15b071bf2d5f6e$var$IssueCreateContext.Provider, {
            value: value
        }, children);
    };
    const $dc15b071bf2d5f6e$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
        const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
        const summaryRef = (0, $5uXOq.useRef)(summary);
        const hasExitedWithoutUserAction = (0, $5uXOq.useRef)(true);
        const submit = (0, $5uXOq.useCallback)((createParams)=>{
            const result = createIssue(createParams);
            onSubmit(result);
            hasExitedWithoutUserAction.current = false;
            setTimeout(()=>{
                hasExitedWithoutUserAction.current = true;
            }, 100);
            return result;
        }, [
            createIssue,
            onSubmit
        ]);
        const blur = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) onBlur?.(event);
            else onBlur?.();
            hasExitedWithoutUserAction.current = false;
        }, [
            onBlur
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
            }, [
            saveSummary
        ]);
        return {
            summaryRef: summaryRef,
            submit: submit,
            blur: blur
        };
    };
    const $dc15b071bf2d5f6e$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
    const $dc15b071bf2d5f6e$export$2ecca9d8a7f031af = ()=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
        const { highlightedIssues: highlightedIssues } = context;
        return (0, $5uXOq.useCallback)((issueId)=>$dc15b071bf2d5f6e$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
            highlightedIssues
        ]);
    };
});
parcelRegister("dqDis", function(module, exports) {
    $parcel$export(module.exports, "getNextRank", ()=>$d36f563d8781dd11$export$5c16a8b7eebff4b8);
    $parcel$export(module.exports, "getPreviousRank", ()=>$d36f563d8781dd11$export$e2047b3433d9f565);
    $parcel$export(module.exports, "useHasRankIssuePermission", ()=>$d36f563d8781dd11$export$2fbfa09555819a54);
    var $daQYX;
    const $d36f563d8781dd11$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
    const $d36f563d8781dd11$export$e2047b3433d9f565 = (s)=>{
        const lastCharCode = s.charCodeAt(s.length - 1);
        const previousLastChar = String.fromCharCode(lastCharCode - 1);
        if (lastCharCode === 0) return $d36f563d8781dd11$export$e2047b3433d9f565(s.substring(0, s.length - 1));
        return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
    };
    const $d36f563d8781dd11$export$2fbfa09555819a54 = ()=>{
        const { permissions: permissions } = (0, (0, parcelRequire("daQYX")).useProject)();
        return permissions.scheduleIssues && permissions.editIssues;
    };
});
parcelRegister("ja8d8", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$50507bfa414423fc$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $l9KLJ;
    var $jcw0u;
    var $6s1PB;
    var $jJZqs;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kpiI3;
    var $8roPX;
    var $lVeTj;
    var $fb3JB;
    const $50507bfa414423fc$export$8edbb6d449614942 = ()=>{
        const workflows = (0, (0, parcelRequire("l9KLJ")).useWorkflows)();
        return (0, $5uXOq.useCallback)((createInput)=>{
            if (createInput.status && workflows != null) {
                const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
                const { statusId: statusId } = createInput.status;
                const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
                return transition?.transitionId;
            }
        }, [
            workflows
        ]);
    };
    const $50507bfa414423fc$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
        const showCreateSuccessFlag = (0, (0, parcelRequire("lVeTj")).useShowCreateSuccessFlag)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        const getTransitionId = $50507bfa414423fc$export$8edbb6d449614942();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
            const transitionId = getTransitionId(createParams.input);
            try {
                if (!(0, (0, parcelRequire("kpiI3")).hasAllRequiredFields)({
                    issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                    createInput: createParams.input
                })) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Missing required fields');
                const response = await onCreateIssue(createParams, {
                    transitionId: transitionId
                });
                highlightIssue(response.itemIdentifiers.issueId);
                if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                    location: createParams.location
                });
                unhighlightIssue(response.itemIdentifiers.issueId);
                return response.item;
            } catch (error) {
                let finalError = error;
                try {
                    if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
                        const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                            transitionId: transitionId
                        });
                        highlightIssue(issueId);
                        const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                        if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                        unhighlightIssue(issueId);
                        return issue;
                    }
                    if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'JWMCreateIssueInline',
                            packageName: 'jiraBusinessIssueCreate',
                            teamName: 'deliveroo'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } catch (refetchError) {
                    finalError = refetchError;
                }
                if (finalError instanceof (0, (0, parcelRequire("8roPX")).CancelledError)) return null;
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fb3JB")).default).errorFlagTitleIssueTermRefresh : (0, (0, parcelRequire("fb3JB")).default).errorFlagTitle),
                    description: formatMessage((0, (0, parcelRequire("fb3JB")).default).errorFlagDescription)
                });
                throw finalError;
            }
        }, [
            getTransitionId,
            typesWithFields,
            onCreateIssue,
            createAnalyticsEvent,
            showCreateSuccessFlag,
            showFlag,
            formatMessage,
            showCreateIssueDialog,
            onRefetchIssue
        ]);
    };
});
parcelRegister("l9KLJ", function(module, exports) {
    $parcel$export(module.exports, "WorkflowsProvider", ()=>$a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75);
    $parcel$export(module.exports, "useWorkflows", ()=>$a3eac8b2a2bf7ce6$export$437f9bd807b88beb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7HGHK;
    var $pa9q9;
    var $6ZYlM;
    var $lDVEA;
    const $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID = (0, (0, parcelRequire("7HGHK")).toFlagId)('fetch-board-error-flag');
    const $a3eac8b2a2bf7ce6$var$WorkflowsContext = (0, $5uXOq.createContext)(undefined);
    const $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { fetch: fetch, data: data, error: error } = (0, (0, parcelRequire("6ZYlM")).useFetchWorkflows)();
        (0, $5uXOq.useEffect)(()=>{
            if (enabled && workflows == null) fetch();
        }, [
            enabled,
            fetch,
            workflows
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) showFlag({
                id: $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID,
                type: 'error',
                title: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorTitle,
                description: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorDescription
            });
        }, [
            error,
            showFlag
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3eac8b2a2bf7ce6$var$WorkflowsContext.Provider, {
            value: workflows ?? data
        }, children);
    };
    const $a3eac8b2a2bf7ce6$export$437f9bd807b88beb = ()=>(0, $5uXOq.useContext)($a3eac8b2a2bf7ce6$var$WorkflowsContext);
});
parcelRegister("6ZYlM", function(module, exports) {
    $parcel$export(module.exports, "useFetchWorkflows", ()=>$8896012bd25091f7$export$41ba56ef14d1b9b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $jcw0u;
    var $6V9lc;
    const $8896012bd25091f7$export$41ba56ef14d1b9b1 = ()=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const [fetch, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("6V9lc")).WORKFLOWS_QUERY), {
            variables: {
                projectId: project.id,
                first: 100
            },
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmFetchWorkflows',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch workflows'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const workflowsDetails = (0, $5uXOq.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
                const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
                return {
                    workflowId: workflow.workflowId,
                    name: workflow?.name ?? undefined,
                    transitions: workflow.transitions.edges.map((transitionEdge)=>({
                            transitionId: transitionEdge.node.transitionId,
                            name: transitionEdge.node.name ?? undefined,
                            isInitial: transitionEdge.node.isInitial,
                            isGlobal: transitionEdge.node.isGlobal,
                            isConditional: transitionEdge.node.isConditional,
                            to: {
                                statusId: transitionEdge.node.to.statusId
                            }
                        })),
                    issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                            issueTypeId: issueTypeEdge.node.issueTypeId,
                            name: issueTypeEdge.node.name,
                            avatarUrl: issueTypeEdge.node.avatar.medium,
                            hierarchyLevel: issueTypeEdge.node.hierarchy.level
                        }))
                };
            }), [
            data
        ]);
        return {
            fetch: fetch,
            data: workflowsDetails,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("6V9lc", function(module, exports) {
    $parcel$export(module.exports, "WORKFLOWS_QUERY", ()=>$ece8b64659728495$export$d54deb6c2b9695b7);
    var $5cllN;
    const $ece8b64659728495$export$d54deb6c2b9695b7 = (0, (0, parcelRequire("5cllN")).default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;
});
parcelRegister("lDVEA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3db26a0042253e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a3db26a0042253e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        workflowsErrorTitle: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-title",
            "defaultMessage": "Failed to load workflows details"
        },
        workflowsErrorDescription: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-description",
            "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
        }
    });
});
parcelRegister("kpiI3", function(module, exports) {
    $parcel$export(module.exports, "hasAllRequiredFields", ()=>$5d73fa9073989726$export$146976a1cbd99cd0);
    var $hE5wF;
    var $5fc53;
    const $5d73fa9073989726$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
        if (!issueType) return false;
        return issueType.fields.every((field)=>{
            if (!field.fieldConfig?.isRequired) return true;
            if (!field.type && !field.aliasFieldId) return false;
            if (field.aliasFieldId && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
            if (field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
            if (field.type) switch(field.type){
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return true;
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return Boolean(createInput.summary);
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return Boolean(createInput.priority);
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                    return Boolean(createInput.assignee);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return Boolean(createInput.dueDate);
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return Boolean(createInput.category);
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return createInput.storyPointEstimate != null;
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    return Boolean(createInput.sprint);
                default:
                    break;
            }
            return false;
        });
    };
});
parcelRegister("8roPX", function(module, exports) {
    $parcel$export(module.exports, "CancelledError", ()=>$549ab3c244a8a20a$export$a8430ed4188f35a9);
    $parcel$export(module.exports, "useCreateIssueDialog", ()=>$549ab3c244a8a20a$export$8254d39962ec7361);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $5eGnF;
    var $9svjh;
    var $hULKg;
    var $5rzqz;
    var $dAmbh;
    var $3ZKGh;
    class $549ab3c244a8a20a$export$a8430ed4188f35a9 extends Error {
    }
    const $549ab3c244a8a20a$export$8d1d8a0d2a7917ac = ()=>{
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        return (0, $5uXOq.useCallback)((issueType, predicate)=>{
            if (!issueType) return undefined;
            const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
            return issueTypeWithFields?.fields.find(predicate);
        }, [
            typesWithFields
        ]);
    };
    const $549ab3c244a8a20a$export$8254d39962ec7361 = ()=>{
        const [, { openIssueCreateModal: openIssueCreateModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const getField = $549ab3c244a8a20a$export$8d1d8a0d2a7917ac();
        const { data: rankField } = (0, (0, parcelRequire("dAmbh")).useRankField)();
        return (0, $5uXOq.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
                const unsubscribe = subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                    onClose(null);
                });
                const onClose = (data)=>{
                    const result = data?.[0];
                    if (result) resolve(result);
                    else setTimeout(()=>{
                        reject(new $549ab3c244a8a20a$export$a8430ed4188f35a9('User cancelled'));
                    }, 100);
                    unsubscribe();
                };
                const { payload: payload, submitApiData: submitApiData } = (0, (0, parcelRequire("3ZKGh")).buildGICPayload)({
                    createInput: createInput,
                    extraPayload: extraPayload,
                    rankField: rankField,
                    getField: getField
                });
                const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
                openIssueCreateModal({
                    id: 'jwm-create-issue-dialog',
                    onClose: onClose,
                    payload: payload,
                    context: {
                        projectId: createInput.projectId,
                        submitApiData: submitApiData
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: (0, (0, parcelRequire("hULKg")).JWM_INLINE_CREATE),
                    disableProjectDropdown: true,
                    disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                    disableCreationSuccessFlag: true,
                    displayCreateAnotherIssueToggle: false,
                    minimizableModalView: 'mini'
                });
            }), [
            getField,
            openIssueCreateModal,
            rankField,
            subscribe
        ]);
    };
});
parcelRegister("5eGnF", function(module, exports) {
    $parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", ()=>$700db8c378cd19d9$export$876003a5b887f37e);
    const $700db8c378cd19d9$export$876003a5b887f37e = {
        MODAL_OPENED: 'MODAL_OPENED',
        MODAL_CLOSED: 'MODAL_CLOSED',
        MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
        MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
        MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
        MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
        MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
        CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
        CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
        ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
        PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
        ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
        RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
        USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
        STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
        CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
        CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
        FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
    };
});
parcelRegister("9svjh", function(module, exports) {
    $parcel$export(module.exports, "useGICLifeCycleEvents", ()=>$d9b2e43e4699b192$export$e3ff72f196296fcc);
    var $1mrD8;
    const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, (0, parcelRequire("1mrD8")).PubSubHub)();
    const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
            ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
        });
});
parcelRegister("1mrD8", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
    class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("hULKg", function(module, exports) {
    $parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", ()=>$62659eb193cd5c9c$export$a05673a22505d5ee);
    $parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$c78d329777576aa0);
    $parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$992ab052fd10f8e8);
    $parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", ()=>$62659eb193cd5c9c$export$affdc3af7a9a4677);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", ()=>$62659eb193cd5c9c$export$7e9cfd1f59e60910);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", ()=>$62659eb193cd5c9c$export$708499dcd016e5e9);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", ()=>$62659eb193cd5c9c$export$e1c8789144c4c810);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", ()=>$62659eb193cd5c9c$export$c5afabb7a17e802);
    $parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$2086a63173b79b56);
    $parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$fe1e5e4597147709);
    $parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$9bc326812a93707);
    $parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", ()=>$62659eb193cd5c9c$export$f352934e06f44599);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", ()=>$62659eb193cd5c9c$export$6ae07c77acc64360);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", ()=>$62659eb193cd5c9c$export$b41d0684e4b6ab1);
    $parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", ()=>$62659eb193cd5c9c$export$be9b2b1329ff7ec9);
    $parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", ()=>$62659eb193cd5c9c$export$aa348159181703a0);
    $parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$f90eec3841adf619);
    $parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$718822a309bffada);
    $parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", ()=>$62659eb193cd5c9c$export$2753dafac81e805c);
    $parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", ()=>$62659eb193cd5c9c$export$7c4d5cc5711d9294);
    $parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", ()=>$62659eb193cd5c9c$export$998dfc72404b9e14);
    $parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", ()=>$62659eb193cd5c9c$export$fc180a4b5785d2f4);
    $parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", ()=>$62659eb193cd5c9c$export$946ec0b21cb84fd0);
    $parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", ()=>$62659eb193cd5c9c$export$5b97e2844e620e54);
    $parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", ()=>$62659eb193cd5c9c$export$b99842c2cf46f6be);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", ()=>$62659eb193cd5c9c$export$8d987f6e80b74000);
    $parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$8de9fa43731c4b5b);
    $parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", ()=>$62659eb193cd5c9c$export$87249ccbfd10fb78);
    $parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", ()=>$62659eb193cd5c9c$export$c0eeeb31d264de76);
    $parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", ()=>$62659eb193cd5c9c$export$f546e18e46478c84);
    $parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", ()=>$62659eb193cd5c9c$export$1784e634ba79f1f9);
    $parcel$export(module.exports, "JWM_INLINE_CREATE", ()=>$62659eb193cd5c9c$export$145eb8935a34e85e);
    $parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", ()=>$62659eb193cd5c9c$export$32648b574a536c8b);
    $parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", ()=>$62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
    const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
    const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
    const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
    const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
    const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
    const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
    const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
    const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
    const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
    const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
    const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
    const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
    const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
    const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
    const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
    const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
    const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
    const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
    const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
    const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
    const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
    const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
    const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
    const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
    const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
    const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
    const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
    const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
    const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
    const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
    const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
    const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
    const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
    const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
    const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
    const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
    const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
    const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
    const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
    const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
    const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
    const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
    const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
    const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
    const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
    const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
        FIELD_IDS: [
            'description'
        ],
        TRIGGER_POINTS: [
            'service-desk-gen-ai-pir'
        ]
    };
});
parcelRegister("5rzqz", function(module, exports) {
    $parcel$export(module.exports, "useTriggerIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
    $parcel$export(module.exports, "useOpenIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$47cf258b1046080b);
    $parcel$export(module.exports, "withNewGICProvider", ()=>$0a31d64d52b4b5e9$export$558a195c5bfe3787);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $1Nspv;
    var $bGrWH;
    var $8zOmE;
    var $2NMNM;
    var $f5nIZ;
    var $2YP9W;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hULKg;
    var $cKWWX;
    var $6k7U1;
    const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
        inProgressIssueID: undefined,
        isModalOpen: false,
        isSubsequentLoad: false,
        isSubTaskCreationOpen: false,
        isCreateLinkedIssue: false,
        wasStateRestored: false,
        payload: null,
        id: 'create-issue-dialog',
        title: null,
        sectionMessage: null,
        submitErrorMessage: undefined,
        globalEventNamespaces: [
            (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
        ],
        fieldsToAddInPublishedData: [],
        alertsToBeLinked: undefined,
        onIssueCreate: null,
        onClose: null,
        displayOnlyRequiredFields: false,
        disableCreationSuccessFlag: false,
        displayCreateAnotherIssueToggle: true,
        displaySitePicker: false,
        disableProjectDropdown: false,
        disableIssueTypeDropdown: false,
        triggerPointKey: (0, (0, parcelRequire("hULKg")).TRIGGER_POINT_KEY_NOT_DEFINED),
        context: undefined,
        minimizableModalView: 'modal',
        persistentModalView: undefined,
        shouldPushMiniModalDiscoverability: undefined,
        shouldShowMiniModalSpotlight: undefined,
        wasModalRetriggered: false,
        openIssueCreateModalNextState: {},
        shouldInitFetchConfig: false,
        interactedWithModalChangerButtons: false,
        isModalLoadInContext: false,
        disableMinimizableModal: false,
        displayMinimizableButtons: true,
        displayHeaderActionContainer: true,
        overrideUseRequestTypeFieldsToggleState: undefined,
        containerStyle: {},
        isMiniDesignEnabled: false,
        isEnrolledAndTargetedForGicMultipleLayouts: false,
        sessionId: undefined,
        FieldWrapperComponent: undefined,
        ExternalControls: undefined,
        isCustomBoardWithIcc: false,
        jqlSwimlaneId: undefined,
        swimlaneMode: undefined,
        prefilledCustomFields: {},
        ecosystemCallback: undefined,
        product: undefined,
        actionSource: undefined
    };
    const $0a31d64d52b4b5e9$export$e324594224ef24da = {
        restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
                const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
                if (!isModalOpen && stateToRestore.isModalOpen) (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(isSubsequentLoad);
                setState(stateToRestore);
            },
        openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isModalOpen) setState({
                    wasModalRetriggered: true,
                    openIssueCreateModalNextState: nextState
                });
                else {
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                    const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                    const nextModalView = isDiscoverabilityPushEnabled ? (0, (0, parcelRequire("6k7U1")).getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, (0, parcelRequire("6k7U1")).discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        ...nextState
                    });
                }
            },
        closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
                const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
                const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    callbackPayload: undefined,
                    ...shouldPersistDiscoverabilityState && {
                        shouldPushMiniModalDiscoverability: true
                    },
                    ...isDiscoverabilityPushEnabled && {
                        persistentModalView: currentState.persistentModalView
                    },
                    ...shouldUpdatePersistentModalView && {
                        persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                    },
                    isModalOpen: false,
                    isSubsequentLoad: true
                });
                (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).abort({
                    metadata: {
                        wasStateRestored: getState().wasStateRestored
                    }
                });
            },
        clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    sectionMessage: null
                });
            },
        setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    displayOnlyRequiredFields: nextState
                });
            },
        setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
                setState({
                    minimizableModalView: minimizableModalView,
                    interactedWithModalChangerButtons: true
                });
            },
        resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
                if (applyNextState) {
                    const currentState = getState();
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                            persistentModalView: currentState.persistentModalView
                        },
                        inProgressIssueID: currentState.inProgressIssueID,
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: false,
                        minimizableModalView: 'modal',
                        openIssueCreateModalNextState: {},
                        shouldInitFetchConfig: true,
                        ...currentState.openIssueCreateModalNextState
                    });
                } else setState({
                    minimizableModalView: 'modal',
                    wasModalRetriggered: false,
                    openIssueCreateModalNextState: {}
                });
            },
        resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
                setState({
                    shouldInitFetchConfig: false
                });
            },
        setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    callbackPayload: {
                        id: currentState.callbackPayload?.id ?? '',
                        data: callbackPayload
                    }
                });
            },
        setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
                });
            },
        dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldShowMiniModalSpotlight: false
                });
            },
        setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    persistentModalView: persistentModalView
                });
            },
        removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
                setState({
                    alertsToBeLinked: alertsToBeLinked
                });
            },
        setSessionId: (sessionId)=>({ setState: setState })=>{
                setState({
                    sessionId: sessionId
                });
            }
    };
    const $0a31d64d52b4b5e9$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
        initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
        actions: $0a31d64d52b4b5e9$export$e324594224ef24da
    });
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
        const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
        const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
        const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal
        ]);
        return [
            createState,
            {
                ...otherActions,
                openIssueCreateModal: openIssueCreateModalWithAnalytics
            }
        ];
    };
    const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
        const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        return (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            if (nextState?.payload?.overrideCloudId && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) setSitePickerState({
                selectedCloudId: nextState?.payload?.overrideCloudId
            });
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal,
            setSitePickerState
        ]);
    };
    const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, (0, parcelRequire("51nlc")).createSubscriber)($0a31d64d52b4b5e9$var$store);
    function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
        return (props)=>{
            const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
            const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
            const currentIssueCreateVisibility = data && data?.gicOptInStatus;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                openIssueCreateModal: openIssueCreateModal,
                closeIssueCreateModal: closeIssueCreateModal,
                currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
                ...props
            });
        };
    }
});
parcelRegister("1Nspv", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueUFOExperience", ()=>$ff7fb599b8d98642$export$cd75c112ac11a83b);
    $parcel$export(module.exports, "StatusFieldLoad", ()=>$ff7fb599b8d98642$export$e890e797a25e655c);
    $parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", ()=>$ff7fb599b8d98642$export$70208657c8d471a7);
    $parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", ()=>$ff7fb599b8d98642$export$b2d8f8edec75f571);
    var $atdLB;
    var $duUGa;
    const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'global-issue-create.create-issue'
    });
    const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue.status-field', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('modern-global-issue-create.modal.issue-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'modern-global-issue-create.modal.issue-submit'
    });
    const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('ecosystem-api-new-gic-prefilling', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'ecosystem-api-new-gic-prefilling'
    });
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
parcelRegister("cKWWX", function(module, exports) {
    $parcel$export(module.exports, "useSitePickerContext", ()=>$c8055d212e869a3c$export$f8b5aae013e4cf77);
    var $3sQ5x;
    var $iXqE5;
    const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
        selectedCloudId: '',
        siteDomain: ''
    };
    const $c8055d212e869a3c$export$e324594224ef24da = {
        setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    selectedCloudId: selectedCloudId || '',
                    siteDomain: siteDomain || ''
                });
            }
    };
    const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue.fields.site-picker',
        initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
        actions: $c8055d212e869a3c$export$e324594224ef24da
    });
    const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, (0, parcelRequire("3sQ5x")).createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);
});
parcelRegister("6k7U1", function(module, exports) {
    $parcel$export(module.exports, "startGlobalIssueCreateMetrics", ()=>$8a2e4df39a48d5af$export$550b19803bc962ec);
    $parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", ()=>$8a2e4df39a48d5af$export$f6bc17a4d9120156);
    $parcel$export(module.exports, "discoverabilityPushModalViewOverride", ()=>$8a2e4df39a48d5af$export$8d246e5e04f0b424);
    $parcel$export(module.exports, "getNextModalView", ()=>$8a2e4df39a48d5af$export$720579602bb055a2);
    var $eTXmK;
    var $1Nspv;
    var $gEaAu;
    var $huY3x;
    const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).start();
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal');
        globalIssueCreateModalLoadMetric.start();
        (0, (0, parcelRequire("huY3x")).startGlobalIssueCreateTTIWithAdjustments)();
    };
    const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
        if (!triggerPoint) return false;
        const acceptedTriggerPoints = [
            'global-create-button',
            'keyboard-shortcut'
        ];
        return acceptedTriggerPoints.includes(triggerPoint);
    };
    const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
        if (!shouldPushDiscoverability) return undefined;
        return {
            minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
            shouldPushMiniModalDiscoverability: true,
            shouldShowMiniModalSpotlight: isTriggerAccepted
        };
    };
    const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
        if (isTriggerAccepted) return persistentView || defaultView;
        return defaultView;
    };
});
parcelRegister("gEaAu", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateModalLoad", ()=>$ee246606338fc99e$export$5a01a7fa84b239c8);
    $parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", ()=>$ee246606338fc99e$export$c50ad3c31b6fcfc6);
    $parcel$export(module.exports, "successFlagDisplay", ()=>$ee246606338fc99e$export$4b2382574525bb0f);
    $parcel$export(module.exports, "successFlagAddToSprintAction", ()=>$ee246606338fc99e$export$7839bdaa2f6a2385);
    $parcel$export(module.exports, "successFlagClearFiltersAction", ()=>$ee246606338fc99e$export$c1592e4d8d98963e);
    var $dGrdR;
    const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal'
    });
    const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal-subsequent'
    });
    const $ee246606338fc99e$export$4b2382574525bb0f = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-display'
    });
    const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
    });
    const $ee246606338fc99e$export$c1592e4d8d98963e = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
    });
});
parcelRegister("huY3x", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874);
    $parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$457c9fb71ad5b3a9);
    $parcel$export(module.exports, "markGicTti", ()=>$06c7e44c59602f0c$export$ef664dac649a716c);
    $parcel$export(module.exports, "stopTTI", ()=>$06c7e44c59602f0c$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$06c7e44c59602f0c$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$06c7e44c59602f0c$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$06c7e44c59602f0c$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$06c7e44c59602f0c$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-tti-with-adjustments',
        timings: [
            {
                key: 'gic-tti-delta',
                startMark: 'gic-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            },
            {
                key: 'gic-all-fields-tti',
                endMark: 'gic-all-fields-loaded'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
    };
    const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
    const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
            customData: customData
        });
    };
    const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
    };
    const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
    };
    const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
    };
    const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("3ZKGh", function(module, exports) {
    $parcel$export(module.exports, "buildGICPayload", ()=>$1e0041a78523c89b$export$eb18ffe6388f217a);
    var $f9ece;
    var $hE5wF;
    var $5fc53;
    const $1e0041a78523c89b$var$assigneeFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE);
    const $1e0041a78523c89b$var$categoryFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE);
    const $1e0041a78523c89b$var$dueDateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE);
    const $1e0041a78523c89b$var$priorityFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE);
    const $1e0041a78523c89b$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE);
    const $1e0041a78523c89b$var$storyPointsFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE) && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$sprintFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
    const $1e0041a78523c89b$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
        const payload = {
            defaultValues: {
                singleLineTextFields: [],
                singleSelectUserPickerFields: [],
                numberFields: [],
                datePickerFields: []
            },
            project: {
                projectId: createInput.projectId
            }
        };
        const additionalFields = {};
        let transition;
        if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
            fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            text: createInput.summary
        });
        if (createInput.issueType) payload.issueType = {
            issueTypeId: createInput.issueType.id
        };
        if (createInput.dueDate && getField(createInput.issueType, $1e0041a78523c89b$var$dueDateFieldPredicate)) {
            const formattedDueDate = (0, (0, parcelRequire("f9ece")).default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                date: {
                    formattedDate: formattedDueDate
                }
            });
            additionalFields.duedate = formattedDueDate;
        }
        const startDateField = getField(createInput.issueType, $1e0041a78523c89b$var$startDateFieldPredicate);
        if (createInput.startDate && startDateField) {
            const formattedStartDate = (0, (0, parcelRequire("f9ece")).default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: startDateField.id,
                date: {
                    formattedDate: formattedStartDate
                }
            });
            additionalFields[startDateField.id] = formattedStartDate;
        }
        if (createInput.assignee && getField(createInput.issueType, $1e0041a78523c89b$var$assigneeFieldPredicate)) {
            payload.defaultValues.singleSelectUserPickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                user: {
                    accountId: createInput.assignee.accountId
                }
            });
            additionalFields[0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE] = {
                id: createInput.assignee.accountId
            };
        }
        if (createInput.priority && getField(createInput.issueType, $1e0041a78523c89b$var$priorityFieldPredicate)) {
            payload.defaultValues.priority = {
                priorityId: createInput.priority.priorityId
            };
            additionalFields[0, (0, parcelRequire("5fc53")).PRIORITY_TYPE] = {
                id: createInput.priority.priorityId
            };
        }
        const categoryField = getField(createInput.issueType, $1e0041a78523c89b$var$categoryFieldPredicate);
        if (createInput.category && categoryField) {
            payload.defaultValues.singleSelectFields = [
                {
                    fieldId: categoryField.id,
                    option: {
                        id: createInput.category.optionId,
                        optionId: createInput.category.optionId
                    }
                }
            ];
            additionalFields[categoryField.id] = {
                id: createInput.category.optionId,
                value: createInput.category.value
            };
        }
        const storyPointEstimateField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointEstimateFieldPredicate);
        if (createInput.storyPointEstimate && storyPointEstimateField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            });
            additionalFields[storyPointEstimateField.id] = {
                id: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            };
        }
        const storyPointsField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointsFieldPredicate);
        if (createInput.storyPoints && storyPointsField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointsField.id,
                value: createInput.storyPoints
            });
            additionalFields[storyPointsField.id] = {
                id: storyPointsField.id,
                value: createInput.storyPoints
            };
        }
        const sprintField = getField(createInput.issueType, $1e0041a78523c89b$var$sprintFieldPredicate);
        if (createInput.sprint && sprintField) {
            payload.defaultValues.sprintsField = {
                fieldId: sprintField.id,
                sprints: [
                    {
                        sprintId: createInput.sprint.id
                    }
                ]
            };
            additionalFields[sprintField.id] = {
                id: sprintField.id,
                value: createInput.sprint.id
            };
        }
        if (createInput.parentIssueId) {
            payload.parentId = {
                parentId: createInput.parentIssueId
            };
            payload.defaultValues.parentField = {
                issueId: createInput.parentIssueId
            };
        }
        if (createInput.status && extraPayload?.transitionId) {
            payload.status = {
                statusId: createInput.status.statusId
            };
            transition = {
                id: extraPayload.transitionId
            };
        }
        if (rankField && (createInput.rankAfter || createInput.rankBefore)) additionalFields[rankField.id] = {
            ...createInput.rankAfter ? {
                rankAfterIssue: createInput.rankAfter.issueId
            } : {},
            ...createInput.rankBefore ? {
                rankBeforeIssue: createInput.rankBefore.issueId
            } : {}
        };
        return {
            payload: payload,
            submitApiData: {
                additionalFields: additionalFields,
                transition: transition
            }
        };
    };
});
parcelRegister("lVeTj", function(module, exports) {
    $parcel$export(module.exports, "useShowCreateSuccessFlag", ()=>$374f26855338ec61$export$dfe953d11a91d407);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $l0oHX;
    var $6s1PB;
    var $pa9q9;
    var $koVbs;
    var $ieDtd;
    var $7dMty;
    const $374f26855338ec61$export$dfe953d11a91d407 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        return (0, $5uXOq.useCallback)((issueKey)=>{
            const flagId = `jwm-create-success-flag-${issueKey}`;
            showFlag({
                id: flagId,
                isAutoDismiss: true,
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitle, {
                    issueKey: issueKey
                }),
                actions: [
                    {
                        content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).viewIssueLinkTextIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).viewIssueLinkText,
                        href: `/browse/${issueKey}`,
                        onClick: (event)=>{
                            if (event && !(0, (0, parcelRequire("l0oHX")).isModifiedEvent)(event)) {
                                setSelectedIssueKey(issueKey);
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            dismissFlag(flagId);
                        }
                    }
                ]
            });
        }, [
            dismissFlag,
            formatMessage,
            setSelectedIssueKey,
            showFlag
        ]);
    };
});
parcelRegister("l0oHX", function(module, exports) {
    $parcel$export(module.exports, "isModifiedEvent", ()=>$6c9cca471f547e7f$export$642c6f14f6d4bbd5);
    const $6c9cca471f547e7f$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
});
parcelRegister("7dMty", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ecb7a23bce33f96$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ecb7a23bce33f96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createSuccessFlagTitle: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
            "defaultMessage": "You've created issue \"{issueKey}\""
        },
        viewIssueLinkText: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
            "defaultMessage": "View issue"
        },
        createSuccessFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
            "defaultMessage": "You've created work item \"{issueKey}\""
        },
        viewIssueLinkTextIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
parcelRegister("fb3JB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87c4612732d8fc8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87c4612732d8fc8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title",
            "defaultMessage": "We weren't able to create an issue"
        },
        errorFlagDescription: {
            "id": "business-issue-create.controllers.create-issue.error-flag-description",
            "defaultMessage": "Refresh the page and try again."
        },
        errorFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
            "defaultMessage": "We weren't able to create a work item"
        }
    });
});
parcelRegister("ecPXN", function(module, exports) {
    $parcel$export(module.exports, "useCreateParamHandler", ()=>$eb6f03408afb5aea$export$294bf5b0ba86140);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $daQYX;
    var $ieDtd;
    var $8roPX;
    const $eb6f03408afb5aea$export$294bf5b0ba86140 = ()=>{
        const [inlineCreateParam, setInlineCreateParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).INLINE_CREATE_PARAM));
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        (0, $5uXOq.useEffect)(()=>{
            if (inlineCreateParam != null) {
                showCreateIssueDialog({
                    projectId: String(project.id)
                }).catch(()=>{});
                setInlineCreateParam(undefined);
            }
        }, [
            inlineCreateParam,
            project,
            setInlineCreateParam,
            showCreateIssueDialog
        ]);
    };
});
parcelRegister("lL5b5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07c2532655d93687$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j0xEB;
    var $j2Jlg;
    var $07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
        const { href: href = null } = (0, (0, parcelRequire("j0xEB")).default)() || {};
        if (href && !href.includes('login.jsp')) {
            const encodedRedirectUrl = encodeURIComponent(href);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j2Jlg")).default), {
                url: `/login.jsp?os_destination=${encodedRedirectUrl}`
            });
        }
        return null;
    };
});
parcelRegister("j0xEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b1198aeec732ce1$export$2e2bcd8739ae039);
    var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
        if (typeof window !== 'undefined') return window.location;
        return undefined;
    };
});
parcelRegister("j2Jlg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$773e6f988af77e5c$export$2e2bcd8739ae039);
    var $773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
        window.location.assign(url);
        return null;
    };
});
parcelRegister("9oIax", function(module, exports) {
    $parcel$export(module.exports, "AuthenticationErrorBoundary", ()=>$e7a35d76515ac063$export$124b2dc1d1aab5e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $fPruT;
    class $e7a35d76515ac063$export$124b2dc1d1aab5e6 extends (0, $5uXOq.Component) {
        componentDidCatch(error, info) {
            if (error instanceof (0, (0, parcelRequire("fPruT")).AuthenticationError)) {
                this.setState({
                    caughtError: {
                        error: error,
                        info: info
                    }
                });
                return;
            }
            throw error;
        }
        render() {
            const { caughtError: caughtError } = this.state;
            const { children: children, render: renderFallback } = this.props;
            if (!caughtError) return children;
            return renderFallback();
        }
        constructor(...args){
            super(...args), this.state = {
                caughtError: null
            };
        }
    }
});
parcelRegister("fPruT", function(module, exports) {
    $parcel$export(module.exports, "AuthenticationError", ()=>$95af1b43dc18895e$export$cf0c46b07324e9c5);
    class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
        constructor(message){
            super(message);
            this.name = 'AuthenticationError';
            this.skipSentry = true;
            this.statusCode = 401;
        }
    }
});
parcelRegister("eTDjN", function(module, exports) {
    $parcel$export(module.exports, "LIST_PADDING_LEFT", ()=>$21d3dbd35ecbeebb$export$a473358fe9122073);
    $parcel$export(module.exports, "LIST_ROW", ()=>$21d3dbd35ecbeebb$export$beca668e8640bfff);
    $parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", ()=>$21d3dbd35ecbeebb$export$258441c8a79bb589);
    $parcel$export(module.exports, "ROW_KEY", ()=>$21d3dbd35ecbeebb$export$1c6db1a0937ef0bd);
    $parcel$export(module.exports, "SELECT_ROW_COLUMN_WIDTH", ()=>$21d3dbd35ecbeebb$export$c9c106422318b1d6);
    $parcel$export(module.exports, "EXPAND_ICON_INDENT_WIDTH", ()=>$21d3dbd35ecbeebb$export$68438aed9d51940e);
    $parcel$export(module.exports, "LIST_FIELD_POPUP_OFFSET", ()=>$21d3dbd35ecbeebb$export$3e36baaa5cb0cfb5);
    $parcel$export(module.exports, "DATE_LOZENGE_ID", ()=>$21d3dbd35ecbeebb$export$9fcfab1f93d2a27a);
    $parcel$export(module.exports, "CHILD_CREATE_BTN_WRAPPER", ()=>$21d3dbd35ecbeebb$export$16bb76a118fce7b4);
    $parcel$export(module.exports, "UP", ()=>$21d3dbd35ecbeebb$export$b29f845fa4b57508);
    $parcel$export(module.exports, "DOWN", ()=>$21d3dbd35ecbeebb$export$c7c029a231f98d34);
    $parcel$export(module.exports, "LEFT", ()=>$21d3dbd35ecbeebb$export$f981f70d61d1405a);
    $parcel$export(module.exports, "RIGHT", ()=>$21d3dbd35ecbeebb$export$1cac5500365a4eb4);
    $parcel$export(module.exports, "BULK_SELECT_CHECKBOX_ID", ()=>$21d3dbd35ecbeebb$export$61ba93f63403a728);
    $parcel$export(module.exports, "DRAG_AND_DROP_BUTTON_FOCUS_EVENT", ()=>$21d3dbd35ecbeebb$export$2e64c33508f031cb);
    $parcel$export(module.exports, "ACTION_DRAG_STARTED", ()=>$21d3dbd35ecbeebb$export$5886ae675e1cc401);
    $parcel$export(module.exports, "ACTION_DRAG_ENDED", ()=>$21d3dbd35ecbeebb$export$736f74130173aad9);
    $parcel$export(module.exports, "NO_ISSUE_TYPE", ()=>$21d3dbd35ecbeebb$export$6a707112f448ba18);
    $parcel$export(module.exports, "NO_PARENT_ISSUE_TYPE", ()=>$21d3dbd35ecbeebb$export$aa7400fdf583255b);
    $parcel$export(module.exports, "TOP_LEVEL_COLLECTION", ()=>$21d3dbd35ecbeebb$export$e9f49e7d94ba81a7);
    $parcel$export(module.exports, "BULK_DELETE_IN_PROGRESS_FLAG_ID", ()=>$21d3dbd35ecbeebb$export$2537d1b6d47b8b99);
    $parcel$export(module.exports, "BULK_DELETE_SUCCESS_FLAG_ID", ()=>$21d3dbd35ecbeebb$export$50d12af09489a2d7);
    $parcel$export(module.exports, "BULK_DELETE_FAILED_FLAG_ID", ()=>$21d3dbd35ecbeebb$export$b4268ee17ddbdd7f);
    $parcel$export(module.exports, "BULK_DELETE_FAILED_CLIENT_FLAG_ID", ()=>$21d3dbd35ecbeebb$export$ebf578347a3066f4);
    $parcel$export(module.exports, "VIEW_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$4a2289be55388ee6);
    $parcel$export(module.exports, "LOAD_CHILDREN_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$16b872ae5b961241);
    $parcel$export(module.exports, "LOAD_GROUP_ITEMS_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$47da82a3abffaada);
    $parcel$export(module.exports, "LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$6c7be7d66ea2537f);
    $parcel$export(module.exports, "BULK_DELETE_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$435db386ec1c226);
    $parcel$export(module.exports, "BULK_COPY_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$dbecc95ea17b546e);
    $parcel$export(module.exports, "CREATE_CATEGORY_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$af494ffa4befd621);
    $parcel$export(module.exports, "UPDATE_CATEGORY_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$15d259507553cf76);
    $parcel$export(module.exports, "DELETE_CATEGORY_EXPERIENCE", ()=>$21d3dbd35ecbeebb$export$a433ff40336ab4a7);
    $parcel$export(module.exports, "SUPPORTED_GROUPS_TYPES", ()=>$21d3dbd35ecbeebb$export$220fd19c26dc2508);
    $parcel$export(module.exports, "BULK_EDIT_CHANGEBOARDING_MESSAGE_ID", ()=>$21d3dbd35ecbeebb$export$5b958d8fec7c426a);
    $parcel$export(module.exports, "DEV_SUMMARY_FIELD", ()=>$21d3dbd35ecbeebb$export$20b3b4741b8cfb64);
    $parcel$export(module.exports, "PARENT_FIELD", ()=>$21d3dbd35ecbeebb$export$bf9df74e065af482);
    var $5fc53;
    const $21d3dbd35ecbeebb$export$a473358fe9122073 = 20;
    const $21d3dbd35ecbeebb$export$beca668e8640bfff = 'listRow';
    const $21d3dbd35ecbeebb$export$258441c8a79bb589 = 40;
    const $21d3dbd35ecbeebb$export$727f6efd406ed55d = 50;
    const $21d3dbd35ecbeebb$export$1c6db1a0937ef0bd = 'rowKey';
    const $21d3dbd35ecbeebb$export$c9c106422318b1d6 = 65;
    const $21d3dbd35ecbeebb$export$1911356e2f572e = 35;
    const $21d3dbd35ecbeebb$export$68438aed9d51940e = 20;
    const $21d3dbd35ecbeebb$export$a2dd5f25b5a4e5d2 = 45;
    const $21d3dbd35ecbeebb$export$56446adcecbeec34 = {
        tableFooter: 1,
        tableShadow: 2,
        inlineFieldCreateControls: 3
    };
    const $21d3dbd35ecbeebb$export$3e36baaa5cb0cfb5 = [
        0,
        -$21d3dbd35ecbeebb$export$258441c8a79bb589
    ];
    const $21d3dbd35ecbeebb$export$eda9e94a9409652f = 'tag-wrapper-highlight-on-hover';
    const $21d3dbd35ecbeebb$export$9fcfab1f93d2a27a = 'list-date-lozenge';
    const $21d3dbd35ecbeebb$export$16bb76a118fce7b4 = 'child-create-btn-wrapper';
    const $21d3dbd35ecbeebb$export$b29f845fa4b57508 = 'up';
    const $21d3dbd35ecbeebb$export$c7c029a231f98d34 = 'down';
    const $21d3dbd35ecbeebb$export$f981f70d61d1405a = 'left';
    const $21d3dbd35ecbeebb$export$1cac5500365a4eb4 = 'right';
    const $21d3dbd35ecbeebb$export$61ba93f63403a728 = 'bulk-select-checkbox';
    const $21d3dbd35ecbeebb$export$2e64c33508f031cb = 'drag-and-drop-button-focus';
    const $21d3dbd35ecbeebb$export$ce523a2c42983704 = 45;
    const $21d3dbd35ecbeebb$export$5886ae675e1cc401 = 'dragStarted';
    const $21d3dbd35ecbeebb$export$736f74130173aad9 = 'dragEnded';
    const $21d3dbd35ecbeebb$export$6a707112f448ba18 = 'noIssueType';
    const $21d3dbd35ecbeebb$export$aa7400fdf583255b = 'noParentIssueType';
    const $21d3dbd35ecbeebb$export$e9f49e7d94ba81a7 = 'topLevelCollection';
    const $21d3dbd35ecbeebb$export$2537d1b6d47b8b99 = 'bulk-delete-in-progress-flag';
    const $21d3dbd35ecbeebb$export$50d12af09489a2d7 = 'bulk-delete-success-flag';
    const $21d3dbd35ecbeebb$export$b4268ee17ddbdd7f = 'bulk-delete-failed-flag';
    const $21d3dbd35ecbeebb$export$ebf578347a3066f4 = 'bulk-delete-failed-client-flag';
    const $21d3dbd35ecbeebb$export$4a2289be55388ee6 = {
        experience: 'listView',
        experienceId: 'main',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$16b872ae5b961241 = {
        experience: 'loadChildren',
        experienceId: 'children',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$47da82a3abffaada = {
        experience: 'loadGroup',
        experienceId: 'groupItems',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$6c7be7d66ea2537f = {
        experience: 'loadGroupChildren',
        experienceId: 'groupItemsChildren',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$435db386ec1c226 = {
        experience: 'bulkDelete',
        experienceId: 'bulkDelete',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$dbecc95ea17b546e = {
        experience: 'bulkCopy',
        experienceId: 'bulkCopy',
        packageName: 'jiraBusinessList',
        teamName: 'keystone'
    };
    const $21d3dbd35ecbeebb$export$af494ffa4befd621 = {
        experience: 'createCategory',
        experienceId: 'createCategory',
        packageName: 'jiraBusinessList',
        teamName: 'jira-warepil'
    };
    const $21d3dbd35ecbeebb$export$15d259507553cf76 = {
        experience: 'updateCategory',
        experienceId: 'updateCategory',
        packageName: 'jiraBusinessList',
        teamName: 'jira-warepil'
    };
    const $21d3dbd35ecbeebb$export$a433ff40336ab4a7 = {
        experience: 'deleteCategory',
        experienceId: 'deleteCategory',
        packageName: 'jiraBusinessList',
        teamName: 'jira-warepil'
    };
    const $21d3dbd35ecbeebb$export$220fd19c26dc2508 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)
    ];
    const $21d3dbd35ecbeebb$export$5b958d8fec7c426a = 'bulk_edit_changeboarding';
    const $21d3dbd35ecbeebb$export$20b3b4741b8cfb64 = 'devSummaryField';
    const $21d3dbd35ecbeebb$export$bf9df74e065af482 = 'parentField';
});
parcelRegister("cpqMw", function(module, exports) {
    $parcel$export(module.exports, "InvalidJQLErrorBoundary", ()=>$7183ea5130be839a$export$c80d0587c83953fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $c9Ur7;
    const $7183ea5130be839a$var$isInvalidJQLError = (error)=>{
        if (error instanceof (0, (0, parcelRequire("c9Ur7")).QueryError)) {
            if ((error.extensions || []).find((err)=>err.statusCode === 400 && err.errorType === 'FIELD_MISSING_HANDLER')) return true;
        }
        return false;
    };
    class $7183ea5130be839a$export$c80d0587c83953fe extends (0, $5uXOq.Component) {
        componentDidCatch(error, info) {
            if ($7183ea5130be839a$var$isInvalidJQLError(error)) {
                this.setState({
                    caughtError: {
                        error: error,
                        info: info
                    }
                });
                return;
            }
            throw error;
        }
        render() {
            const { caughtError: caughtError } = this.state;
            const { children: children, render: renderFallback } = this.props;
            if (!caughtError) return children;
            return renderFallback();
        }
        constructor(...args){
            super(...args), this.state = {
                caughtError: null
            };
        }
    }
});
parcelRegister("c9Ur7", function(module, exports) {
    $parcel$export(module.exports, "QueryError", ()=>$835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
    const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
    class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.extensions = payload.extensions;
            this.message = payload.message ?? '';
            this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
        }
    }
});
parcelRegister("5cP2Q", function(module, exports) {
    $parcel$export(module.exports, "FormsLabelFlag", ()=>$adf17fbc6aec6252$export$acb1b1990395076);
    var $5uXOq = parcelRequire("5uXOq");
    var $2hXfb;
    var $kRkJF;
    var $d4xRU;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $eq1P7;
    const $adf17fbc6aec6252$export$acb1b1990395076 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const containsFilter = (0, $5uXOq.useMemo)(()=>quickFiltersJql && $adf17fbc6aec6252$var$filtersByBusinessFormIdLabel(quickFiltersJql), [
            quickFiltersJql
        ]);
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const flagId = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            if (containsFilter && flagId.current == null) flagId.current = showFlag({
                render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                        id: "",
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
                            label: formatMessage((0, (0, parcelRequire("eq1P7")).default).iconLabel)
                        }),
                        title: formatMessage((0, (0, parcelRequire("eq1P7")).default).title),
                        description: formatMessage((0, (0, parcelRequire("eq1P7")).default).description),
                        onDismissed: ()=>{
                            if (flagId.current) dismissFlag(flagId.current);
                        },
                        actions: [
                            {
                                content: formatMessage((0, (0, parcelRequire("eq1P7")).default).viewAllLink),
                                href: `?filter=${encodeURIComponent('labels = "business-form"')}`,
                                onClick (_, analyticsEvent) {
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'link clicked', 'viewAllBusinessFormsIssues');
                                }
                            }
                        ],
                        ...props
                    })
            });
            return ()=>{
                if (flagId.current) dismissFlag(flagId.current);
            };
        }, [
            containsFilter,
            dismissFlag,
            formatMessage,
            showFlag
        ]);
        return null;
    };
    const $adf17fbc6aec6252$var$filtersByBusinessFormIdLabel = (jql)=>{
        return jql.split(/ AND | OR /).map((statement)=>{
            const tokens = [
                ' = ',
                ' in ',
                ' IN '
            ];
            for (const token of tokens){
                if (statement.includes(token)) return statement.split(token);
            }
            return [];
        }).reduce((acc, curr)=>{
            const [field, values] = curr;
            if (field === 'labels' && values.match(/business-form-\d/)) return true;
            return acc;
        }, false);
    };
});
parcelRegister("kRkJF", function(module, exports) {
    $parcel$export(module.exports, "useFilteredViewJQL", ()=>$6b3238559c925b96$export$a50cc7c1087f7d9b);
    $parcel$export(module.exports, "useFilteredViewContextInput", ()=>$6b3238559c925b96$export$d566b5d8a729afa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $4R6GH;
    var $5fc53;
    var $2UUq6;
    var $17ot5;
    var $l4Ejo;
    var $1T1ir;
    var $7VpiX;
    const $6b3238559c925b96$export$a50cc7c1087f7d9b = ()=>{
        const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlSanitised = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).sanitiseJql)(jql), [
            jql
        ]);
        const filtersJQL = (0, $5uXOq.useMemo)(()=>{
            if (isHidingDoneItems) {
                const filtersJql = [
                    jqlSanitised,
                    "StatusCategory != 'Complete'"
                ].filter(Boolean).join(' AND ');
                return addSimpleSearchToJQL(filtersJql);
            }
            return addSimpleSearchToJQL(jqlSanitised || null);
        }, [
            jqlSanitised,
            addSimpleSearchToJQL,
            isHidingDoneItems
        ]);
        return filtersJQL;
    };
    const $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
    const $6b3238559c925b96$export$d566b5d8a729afa0 = ({ view: view })=>{
        const filtersJQL = $6b3238559c925b96$export$a50cc7c1087f7d9b();
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const [sortingBy] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const isFiltering = jql != null || isSearching;
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
        const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).getJqlErrors)(jql), [
            jql
        ]);
        const sorting = (0, $5uXOq.useMemo)(()=>{
            if (sortingBy.sortBy === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return {
                ...sortingBy,
                sortBy: $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL
            };
            return sortingBy;
        }, [
            sortingBy
        ]);
        return {
            jqlContext: jqlContext,
            quickFiltersJql: filtersJQL,
            sorting: sorting,
            isFiltering: isFiltering,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            jqlErrors: jqlErrors
        };
    };
});
const $8debe7dace56daea$export$9355e489ad16f98e = 'TASK';
const $8debe7dace56daea$export$3cb4a99a332e4186 = 'EPIC';
parcelRegister("2UUq6", function(module, exports) {
    $parcel$export(module.exports, "useSorting", ()=>$46c72127586d4f92$export$21ebc1ba2b2bee67);
    $parcel$export(module.exports, "useSorter", ()=>$46c72127586d4f92$export$f161a6f9d84a6fea);
    var $5uXOq = parcelRequire("5uXOq");
    var $ftuRD;
    var $1T2vX;
    var $x8FYU;
    var $1kpI8;
    var $8841m;
    var $h1cpf;
    var $8Yjb2;
    const $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE = {};
    const $46c72127586d4f92$export$21ebc1ba2b2bee67 = ()=>{
        const [sorting, setSorting] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).SORTING_PREFERENCE));
        return [
            sorting || $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE,
            setSorting
        ];
    };
    const $46c72127586d4f92$var$emptyArray = [];
    const $46c72127586d4f92$export$f161a6f9d84a6fea = ()=>{
        const [sorting] = $46c72127586d4f92$export$21ebc1ba2b2bee67();
        const [sortingFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: sorting.sortBy
        });
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: data } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
        const { statuses: statuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const priorities = priorityFieldConfig?.options || $46c72127586d4f92$var$emptyArray;
        const sortFunction = (0, $5uXOq.useCallback)((issues)=>{
            const getPrioritiesSortedList = ()=>[
                    ...priorities
                ].reverse().reduce((acc, next, index)=>{
                    acc[next.priorityId] = index;
                    return acc;
                }, {});
            const getIssueTypesSortedList = ()=>[
                    ...data.issueTypes
                ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const getStatusSortOrder = (key)=>{
                if (key in (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)) return (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)[key];
                return -1;
            };
            const getStatusesSortedList = ()=>[
                    ...statuses
                ].sort((a, b)=>{
                    const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                    if (orderComparison !== 0) return orderComparison;
                    return a.name.localeCompare(b.name);
                }).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const sortedLists = {
                priorities: getPrioritiesSortedList(),
                issueTypes: getIssueTypesSortedList(),
                statuses: getStatusesSortedList()
            };
            const { getters: getters, orders: orders } = (0, (0, parcelRequire("8Yjb2")).createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
            return (0, (0, parcelRequire("8Yjb2")).sortListBy)(issues, getters, orders);
        }, [
            sorting,
            sortingFieldConfigFieldType,
            priorities,
            data.issueTypes,
            statuses
        ]);
        return {
            sort: sortFunction
        };
    };
});
parcelRegister("ftuRD", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypeFieldConfig", ()=>$66b06940d67822ac$export$42e875bfb69ded2);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $1T2vX;
    const $66b06940d67822ac$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                [screen]: {
                    ...(0, ($parcel$interopDefault($9XE6b)))(getState(), [
                        screen
                    ], {}),
                    [issueTypeId]: configs
                }
            });
        };
    const $66b06940d67822ac$var$actions = {
        merge: $66b06940d67822ac$var$merge
    };
    const $66b06940d67822ac$export$cbf0f7fe9ca42a65 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $66b06940d67822ac$var$actions,
        name: 'issueTypeFieldConfig'
    });
    const $66b06940d67822ac$var$getIssueTypeFieldConfigSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
        if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
        return (0, ($parcel$interopDefault($9XE6b)))(state, [
            screen,
            issueTypeId,
            fieldId
        ], null);
    });
    const $66b06940d67822ac$export$47647eb426e85a25 = (0, (0, parcelRequire("3sQ5x")).createHook)($66b06940d67822ac$export$cbf0f7fe9ca42a65, {
        selector: $66b06940d67822ac$var$getIssueTypeFieldConfigSelector
    });
    const $66b06940d67822ac$export$42e875bfb69ded2 = (props)=>{
        const [state, fieldsConfigActions] = $66b06940d67822ac$export$47647eb426e85a25(props);
        const screen = props?.screen || 'VIEW';
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: screen
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (state != null) return [
                state,
                fieldsConfigActions,
                {
                    loading: false,
                    error: undefined
                }
            ];
            if (loading === false && (0, ($parcel$interopDefault($9XE6b)))(data, [
                'issueTypes'
            ], []).length > 0) data.issueTypes.forEach((issueType)=>{
                const config = {};
                data.fields.forEach((field)=>{
                    if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                        ...field.fieldConfig,
                        fieldType: field.type
                    };
                });
                fieldsConfigActions.merge(screen, issueType.id, config);
                if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
            });
            return [
                state,
                fieldsConfigActions,
                {
                    loading: loading,
                    error: error
                }
            ];
        }, [
            data,
            error,
            fieldsConfigActions,
            loading,
            screen,
            state
        ]);
    };
});
parcelRegister("x8FYU", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", ()=>$3a8fd327ed3934d4$export$5d3f940b56d7af28);
    $parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$8019dfa5a44f6d46);
    $parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$3ef984a9f784490f);
    $parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", ()=>$3a8fd327ed3934d4$export$2df4c3d44dcb1e5b);
    $parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", ()=>$3a8fd327ed3934d4$export$638c3932e4cbdede);
    $parcel$export(module.exports, "FIELDS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$e3ddfc509464e305);
    $parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ffcb5603c64e12d0);
    $parcel$export(module.exports, "FILTER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f50d5db589fb1475);
    $parcel$export(module.exports, "GROUPING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ac8a4771da7f03af);
    $parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$4aace169721c2927);
    $parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$983f0d3325e2938);
    $parcel$export(module.exports, "RANGE_MODE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f43988a3762bf711);
    $parcel$export(module.exports, "SORTING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$373eea1341dcff74);
    $parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$4ec60be96e9eadc0);
    $parcel$export(module.exports, "LIST_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$43fc1ec27b2f1801);
    $parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$14e2a519a8c2881a);
    $parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$8443f3f4fd94276);
    $parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$2e2923d9c9daba20);
    var $hE5wF;
    var $54zCO;
    const $3a8fd327ed3934d4$export$5d3f940b56d7af28 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('activeWorkflow');
    const $3a8fd327ed3934d4$export$8019dfa5a44f6d46 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('collapsedColumns');
    const $3a8fd327ed3934d4$export$3ef984a9f784490f = (0, (0, parcelRequire("54zCO")).createSimplePreference)('columnOrder');
    const $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b = (0, (0, parcelRequire("54zCO")).createSimplePreference)('createType');
    const $3a8fd327ed3934d4$export$638c3932e4cbdede = (0, (0, parcelRequire("54zCO")).createSimplePreference)('expandedIssues');
    const $3a8fd327ed3934d4$export$e3ddfc509464e305 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fields');
    const $3a8fd327ed3934d4$export$ffcb5603c64e12d0 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fieldsDetail');
    const $3a8fd327ed3934d4$export$f50d5db589fb1475 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
    const $3a8fd327ed3934d4$export$ac8a4771da7f03af = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('groupBy');
    const $3a8fd327ed3934d4$export$4aace169721c2927 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideDone');
    const $3a8fd327ed3934d4$export$983f0d3325e2938 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideSoftwareRelease');
    const $3a8fd327ed3934d4$export$f43988a3762bf711 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('rangeMode');
    const $3a8fd327ed3934d4$export$373eea1341dcff74 = {
        ...(0, (0, parcelRequire("54zCO")).createSimplePreference)('sorting'),
        queryParameter: {
            serialize: (value)=>({
                    sortBy: value?.sortBy,
                    direction: value?.direction
                }),
            deserialize: (value)=>value.sortBy ? {
                    sortBy: value.sortBy,
                    direction: value.direction
                } : undefined
        }
    };
    const $3a8fd327ed3934d4$export$4ec60be96e9eadc0 = [
        $3a8fd327ed3934d4$export$5d3f940b56d7af28,
        $3a8fd327ed3934d4$export$8019dfa5a44f6d46,
        $3a8fd327ed3934d4$export$3ef984a9f784490f,
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$638c3932e4cbdede,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af
    ];
    const $3a8fd327ed3934d4$export$43fc1ec27b2f1801 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$ffcb5603c64e12d0,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$373eea1341dcff74
    ];
    const $3a8fd327ed3934d4$export$14e2a519a8c2881a = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$983f0d3325e2938
    ];
    const $3a8fd327ed3934d4$export$8443f3f4fd94276 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$f43988a3762bf711
    ];
    const $3a8fd327ed3934d4$export$2e2923d9c9daba20 = [
        $3a8fd327ed3934d4$export$f50d5db589fb1475
    ];
});
parcelRegister("54zCO", function(module, exports) {
    $parcel$export(module.exports, "createSimplePreference", ()=>$7a26b5020c269cbd$export$464a71be397e5f3d);
    $parcel$export(module.exports, "createSimpleUrlPreference", ()=>$7a26b5020c269cbd$export$78f3983105936d30);
    var $etyzk = parcelRequire("etyzk");
    const $7a26b5020c269cbd$export$464a71be397e5f3d = (id)=>({
            id: id,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk)))
        });
    const $7a26b5020c269cbd$export$78f3983105936d30 = (queryParameter)=>({
            id: queryParameter,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk))),
            queryParameter: {
                serialize: (value)=>({
                        [queryParameter]: value
                    }),
                deserialize: (value)=>value[queryParameter]
            }
        });
});
parcelRegister("1kpI8", function(module, exports) {
    $parcel$export(module.exports, "ViewPreferencesProvider", ()=>$5141bcd6fd206946$export$1db44e21d818b27);
    $parcel$export(module.exports, "useViewPreference", ()=>$5141bcd6fd206946$export$ee494de6c0ff45d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $1XJ20;
    var $doZTA;
    var $kGDhO;
    const $5141bcd6fd206946$var$ViewPreferencesContext = (0, $5uXOq.createContext)(null);
    const $5141bcd6fd206946$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const [{ query: query }, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { updateQueryParam: updateQueryParam } = routerActions;
        const prevQuery = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(query);
        const [store, setStore] = (0, $5uXOq.useState)(()=>preferences.reduce((acc, preference)=>{
                let value;
                const { id: id, queryParameter: queryParameter } = preference;
                const queryValue = queryParameter && queryParameter.deserialize(query);
                if (queryValue) value = queryValue;
                else if (persistChanges) value = preference.deserialize((0, (0, parcelRequire("kGDhO")).getPreference)(entity.id, view, preference.id));
                acc[id] = value;
                return acc;
            }, {}));
        const setPreferenceValue = (0, $5uXOq.useCallback)((preference, value, action)=>{
            setStore((prevStore)=>{
                const newStore = {
                    ...prevStore,
                    [preference.id]: value
                };
                return newStore;
            });
            if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
            if (persistChanges) {
                const serializedValue = preference.serialize(value);
                (0, (0, parcelRequire("kGDhO")).setPreference)(entity.id, view, preference.id, serializedValue);
            }
        }, [
            persistChanges,
            updateQueryParam,
            entity.id,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!persistChanges) return;
            let restoredQuery = {};
            for (const preference of preferences){
                const value = store[preference.id];
                if (value && preference.queryParameter) restoredQuery = {
                    ...restoredQuery,
                    ...preference.queryParameter.serialize(value)
                };
            }
            updateQueryParam({
                ...restoredQuery,
                ...query
            }, 'replace');
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(prevQuery, query)) {
                const newState = preferences.reduce((acc, preference)=>{
                    const { id: id, queryParameter: queryParameter } = preference;
                    if (queryParameter) {
                        const queryValue = queryParameter.deserialize(query);
                        acc[id] = queryValue;
                    }
                    return acc;
                }, {});
                setStore({
                    ...store,
                    ...newState
                });
            }
        }, [
            preferences,
            query,
            store,
            entity.id,
            view,
            prevQuery
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                store: store,
                setPreferenceValue: setPreferenceValue
            }), [
            store,
            setPreferenceValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5141bcd6fd206946$var$ViewPreferencesContext.Provider, {
            value: contextValue
        }, children);
    };
    const $5141bcd6fd206946$export$ee494de6c0ff45d7 = (preference)=>{
        const { store: store, setPreferenceValue: setPreferenceValue } = (0, $5uXOq.useContext)($5141bcd6fd206946$var$ViewPreferencesContext);
        const setValue = (0, $5uXOq.useCallback)((value, action = 'push')=>{
            setPreferenceValue(preference, value, action);
        }, [
            preference,
            setPreferenceValue
        ]);
        const value = store[preference.id];
        return [
            value,
            setValue
        ];
    };
});
parcelRegister("kGDhO", function(module, exports) {
    $parcel$export(module.exports, "setPreference", ()=>$39001b1dd806b76a$export$c6483f3cdc3e51e1);
    $parcel$export(module.exports, "getPreference", ()=>$39001b1dd806b76a$export$5fa261395d19a143);
    var $bSSG7;
    const $39001b1dd806b76a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jwm-view-preferences');
    const $39001b1dd806b76a$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
    const $39001b1dd806b76a$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        $39001b1dd806b76a$var$store.set(key, value);
    };
    const $39001b1dd806b76a$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        return $39001b1dd806b76a$var$store.get(key);
    };
});
parcelRegister("8841m", function(module, exports) {
    $parcel$export(module.exports, "useProjectStatuses", ()=>$f2e77b2d189a9e48$export$11ff6a520db76faf);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qDUb = parcelRequire("7qDUb");
    var $3JOCw = parcelRequire("3JOCw");
    var $daQYX;
    var $dJl1T;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $f2e77b2d189a9e48$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
    const $f2e77b2d189a9e48$var$MAX_RETRIES = 3;
    const $f2e77b2d189a9e48$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
                [projectKey]: statuses
            });
    const $f2e77b2d189a9e48$var$actions = {
        set: $f2e77b2d189a9e48$var$set
    };
    const $f2e77b2d189a9e48$var$ProjectStatusesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $f2e77b2d189a9e48$var$actions,
        name: 'projectStatuses'
    });
    const $f2e77b2d189a9e48$var$getProjectStatusesSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
        if (projectKey === undefined || state[projectKey] == null) return [];
        return state[projectKey];
    });
    const $f2e77b2d189a9e48$export$482f388228eef22c = (0, (0, parcelRequire("3sQ5x")).createHook)($f2e77b2d189a9e48$var$ProjectStatusesStore, {
        selector: $f2e77b2d189a9e48$var$getProjectStatusesSelector
    });
    const $f2e77b2d189a9e48$var$emptyArray = [];
    const $f2e77b2d189a9e48$export$11ff6a520db76faf = ()=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [hasLoaded, setHasLoaded] = (0, $5uXOq.useState)(false);
        const [retriesCount, setRetriesCount] = (0, $5uXOq.useState)(0);
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const [statuses, statusActions] = $f2e77b2d189a9e48$export$482f388228eef22c({
            projectKey: projectKey
        });
        const retry = ()=>{
            setRetriesCount(retriesCount + 1);
            setIsLoading(false);
            setHasLoaded(false);
        };
        if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
            statuses: statuses,
            loading: isLoading
        };
        if (!isLoading && !hasLoaded) {
            fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
                const allStatuses = issueTypes.reduce((acc, next)=>acc.concat(next.statuses), []);
                const dedupedResults = (0, ($parcel$interopDefault($3JOCw)))(allStatuses, 'id');
                return (0, ($parcel$interopDefault($7qDUb)))(dedupedResults, [
                    'name'
                ]);
            }).then((uniqueStatuses)=>{
                statusActions.set(projectKey, uniqueStatuses);
                setIsLoading(false);
                setHasLoaded(true);
            }).catch(()=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f2e77b2d189a9e48$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
                if (retriesCount < $f2e77b2d189a9e48$var$MAX_RETRIES) retry();
            });
            setIsLoading(true);
        }
        return {
            statuses: $f2e77b2d189a9e48$var$emptyArray,
            loading: isLoading
        };
    };
});
parcelRegister("h1cpf", function(module, exports) {
    $parcel$export(module.exports, "STATUS_SORT_ORDER", ()=>$20cadc5cf5f0437c$export$de9c103e53e690d1);
    const $20cadc5cf5f0437c$export$de9c103e53e690d1 = {
        new: 1,
        indeterminate: 2,
        done: 3
    };
});
parcelRegister("8Yjb2", function(module, exports) {
    $parcel$export(module.exports, "sortListBy", ()=>$9b7a6804aae1eb73$export$3793ed28be8699ad);
    $parcel$export(module.exports, "createSortingGettersAndOrders", ()=>$9b7a6804aae1eb73$export$b3fdfcb601c683c3);
    var $1AkQu = parcelRequire("1AkQu");
    var $hE5wF;
    var $ijSZT;
    var $fCkUD;
    var $57lFd;
    var $gULOk;
    var $4R6GH;
    var $5fc53;
    var $ixx6N;
    const $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
    const $9b7a6804aae1eb73$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
    const $9b7a6804aae1eb73$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, ($parcel$interopDefault($1AkQu)))(nodes, getters, orders.map($9b7a6804aae1eb73$var$toAcceptedOrder));
    const $9b7a6804aae1eb73$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, getMapValueCb)=>{
        const fieldValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
        return fieldValue.map(getMapValueCb).join(' ') || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$resolvePriorityOrder = (fields, priorities)=>{
        const priorityId = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'value.priorityId', '') : (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'priorityId', '');
        const priorityOrder = priorities[priorityId];
        if (priorityOrder == null) return -1;
        return priorityOrder;
    };
    const $9b7a6804aae1eb73$var$resolveStatusOrder = (fields, statuses)=>{
        const statusName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'name', '');
        const statusOrder = statuses[statusName];
        if (statusOrder == null) return -1;
        return statusOrder;
    };
    const $9b7a6804aae1eb73$var$resolveTypeOrder = (fields, types)=>{
        const typeName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'value', '');
        const typeOrder = types[typeName];
        if (typeOrder == null) return -1;
        return typeOrder;
    };
    const $9b7a6804aae1eb73$var$resolveIssueKeyOrder = (fields)=>{
        const [, issueKeyNumber = 0] = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuekey', 'value', '').split('-');
        return Number(issueKeyNumber);
    };
    const $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
        const value = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', null);
        return value != null ? value.toLowerCase() : $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
            const { rank: rank, fields: fields = [] } = node;
            if (fieldType != null && (0, (0, parcelRequire("ijSZT")).isSortingSupportedFieldTypePredicated)(fieldType) && (0, (0, parcelRequire("ijSZT")).isSortingSupported)(fieldType) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                const field = (0, (0, parcelRequire("57lFd")).getFieldValue)(fields, sortingField);
                if ((0, (0, parcelRequire("fCkUD")).isNewTransformedFieldPredicated)(field)) return (0, (0, parcelRequire("ijSZT")).getSorting)(fieldType, field) || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
            }
            switch(fieldType){
                case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [
                        ''
                    ], (label)=>label.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return $9b7a6804aae1eb73$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
                case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                    return $9b7a6804aae1eb73$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                    return $9b7a6804aae1eb73$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 'issuekey':
                    return $9b7a6804aae1eb73$var$resolveIssueKeyOrder(fields);
                case 0, (0, parcelRequire("5fc53")).CREATED:
                case 0, (0, parcelRequire("5fc53")).UPDATED:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '');
                case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID:
                    if ((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, (0, parcelRequire("ixx6N")).resolveRank)((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                    return rank ?? '';
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
                case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
                    return $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder(fields, sortingField);
                case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.timeInSeconds', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).URL_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    {
                        const sprintValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                        if (Array.isArray(sprintValue) && sprintValue.length) {
                            const { name: name, state: state } = sprintValue[0];
                            if (state === 'CLOSED') {
                                const statusId = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'value', '');
                                if (statusId?.toString() !== (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE].toString()) return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                            }
                            return name.toLowerCase();
                        }
                        return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                    }
                default:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), 'value', '');
            }
        };
    const $9b7a6804aae1eb73$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
        const getters = [];
        const orders = [];
        let sortFieldType = fieldType;
        if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
        if (sorting != null && sorting.sortBy != null) {
            orders.push(sorting.direction, sorting.direction);
            getters.push($9b7a6804aae1eb73$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        } else {
            orders.push((0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        }
        return {
            getters: getters,
            orders: orders
        };
    };
});
parcelRegister("1AkQu", function(module, exports) {
    var $kE90z = parcelRequire("kE90z");
    var $8LQ84 = parcelRequire("8LQ84");
    function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
        if (collection == null) return [];
        if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
            iteratees
        ];
        orders = guard ? undefined : orders;
        if (!$8LQ84(orders)) orders = orders == null ? [] : [
            orders
        ];
        return $kE90z(collection, iteratees, orders);
    }
    module.exports = $127952ba7d4c15a6$var$orderBy;
});
parcelRegister("ijSZT", function(module, exports) {
    $parcel$export(module.exports, "getSorting", ()=>$426da0baa4d91e21$export$654dceec98f3061f);
    $parcel$export(module.exports, "isSortingSupported", ()=>$426da0baa4d91e21$export$c6c6084d02f37d7e);
    $parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", ()=>$426da0baa4d91e21$export$190ed2ad153b150b);
    $parcel$export(module.exports, "getSortingDisabledFields", ()=>$426da0baa4d91e21$export$56c924491e5617ad);
    var $8QpSo;
    var $1OjAh;
    var $5nNdw;
    var $cBFqc;
    var $coSD0;
    var $55FhM;
    var $gjQcQ;
    var $4CML6;
    var $WhnfX;
    var $aK7yP;
    var $7LNXH;
    var $dtcdd;
    const $426da0baa4d91e21$var$createSortingHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("55FhM")).parentSortingHandler),
            ...(0, (0, parcelRequire("dtcdd")).versionSortingHandler),
            ...(0, (0, parcelRequire("WhnfX")).resolutionSortingHandler),
            ...(0, (0, parcelRequire("coSD0")).groupSortingHandler),
            ...(0, (0, parcelRequire("4CML6")).radioSelectSortingHandler),
            ...(0, (0, parcelRequire("1OjAh")).cascadingSelectSortingHandler),
            ...(0, (0, parcelRequire("gjQcQ")).projectSortingHandler)
        }));
    const $426da0baa4d91e21$export$654dceec98f3061f = (fieldType, ...args)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        if (handlers[fieldType] == null) return;
        return handlers[fieldType]?.(...args);
    };
    const $426da0baa4d91e21$export$c6c6084d02f37d7e = (fieldType)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        return handlers[fieldType] != null;
    };
    const $426da0baa4d91e21$export$190ed2ad153b150b = (fieldType)=>true;
    const $426da0baa4d91e21$export$56c924491e5617ad = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("5nNdw")).devSummaryDisabledSorting),
            ...(0, (0, parcelRequire("7LNXH")).teamDisabledSorting),
            ...(0, (0, parcelRequire("aK7yP")).statusCategoryDisabledSorting),
            ...(0, (0, parcelRequire("cBFqc")).goalsDisabledSorting)
        }));
});
parcelRegister("1OjAh", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectSortingHandler", ()=>$1924a50c91a471c7$export$7b0bfc6838ff3257);
    var $5fc53;
    var $jKNTt;
    const $1924a50c91a471c7$var$getCascadingSelectSorting = (field)=>(0, (0, parcelRequire("jKNTt")).getCascadingSelectStringValue)(field.value);
    const $1924a50c91a471c7$export$7b0bfc6838ff3257 = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $1924a50c91a471c7$var$getCascadingSelectSorting
    };
});
parcelRegister("jKNTt", function(module, exports) {
    $parcel$export(module.exports, "getCascadingSelectStringValue", ()=>$c7661401b6222cfb$export$f110a74eb752aa7e);
    $parcel$export(module.exports, "cascadingSelectStringValueHandler", ()=>$c7661401b6222cfb$export$f39c163ada81742a);
    $parcel$export(module.exports, "cascadingSelectRichValueHandler", ()=>$c7661401b6222cfb$export$af92c160980c340f);
    var $5fc53;
    const $c7661401b6222cfb$export$f110a74eb752aa7e = (fieldValue)=>{
        if (fieldValue && fieldValue.parentOptionValue) {
            if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
            return `${fieldValue.parentOptionValue.value}`;
        }
        return '';
    };
    const $c7661401b6222cfb$var$getCascadingSelectValue = (field)=>$c7661401b6222cfb$export$f110a74eb752aa7e(field.value);
    const $c7661401b6222cfb$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
    const $c7661401b6222cfb$export$f39c163ada81742a = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectValue
    };
    const $c7661401b6222cfb$export$af92c160980c340f = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectRichValue
    };
});
parcelRegister("5nNdw", function(module, exports) {
    $parcel$export(module.exports, "devSummaryDisabledSorting", ()=>$8d45926c3e16e57e$export$8cf683615a3ccf77);
    var $5fc53;
    const $8d45926c3e16e57e$export$8cf683615a3ccf77 = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: false
    };
});
parcelRegister("cBFqc", function(module, exports) {
    $parcel$export(module.exports, "goalsDisabledSorting", ()=>$c7872d24a62cd4a6$export$60ff70c996f5c362);
    var $5fc53;
    const $c7872d24a62cd4a6$export$60ff70c996f5c362 = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: false
    };
});
parcelRegister("coSD0", function(module, exports) {
    $parcel$export(module.exports, "groupSortingHandler", ()=>$a9d8ecbf0dcf5f2d$export$a577fd60fa30451d);
    var $5fc53;
    const $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
    const $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting
    };
});
parcelRegister("55FhM", function(module, exports) {
    $parcel$export(module.exports, "parentSortingHandler", ()=>$a7f27eceaa949fb5$export$20dbdacc158507c9);
    var $5fc53;
    const $a7f27eceaa949fb5$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
    const $a7f27eceaa949fb5$export$20dbdacc158507c9 = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $a7f27eceaa949fb5$var$getParentSorting
    };
});
parcelRegister("gjQcQ", function(module, exports) {
    $parcel$export(module.exports, "projectSortingHandler", ()=>$a97b41f281e121d8$export$18c888fa7805bbf9);
    var $5fc53;
    const $a97b41f281e121d8$var$getProjectSorting = (field)=>field.value?.name ?? '';
    const $a97b41f281e121d8$export$18c888fa7805bbf9 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $a97b41f281e121d8$var$getProjectSorting
    };
});
parcelRegister("4CML6", function(module, exports) {
    $parcel$export(module.exports, "radioSelectSortingHandler", ()=>$0a650a9e38d8f12d$export$d622730346571a2b);
    var $5fc53;
    const $0a650a9e38d8f12d$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
    const $0a650a9e38d8f12d$export$d622730346571a2b = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $0a650a9e38d8f12d$var$getRadioSelectSorting
    };
});
parcelRegister("WhnfX", function(module, exports) {
    $parcel$export(module.exports, "resolutionSortingHandler", ()=>$5149dcabcac386a7$export$596a643f093db9a7);
    var $5fc53;
    const $5149dcabcac386a7$var$getResolutionSorting = (field)=>field.value?.name ?? '';
    const $5149dcabcac386a7$export$596a643f093db9a7 = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: $5149dcabcac386a7$var$getResolutionSorting
    };
});
parcelRegister("aK7yP", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryDisabledSorting", ()=>$a8138d3f5e843f75$export$117cb43589655b27);
    var $5fc53;
    const $a8138d3f5e843f75$export$117cb43589655b27 = {
        [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: false
    };
});
parcelRegister("7LNXH", function(module, exports) {
    $parcel$export(module.exports, "teamDisabledSorting", ()=>$f566370ab4491013$export$1626c947db580b0f);
    var $5fc53;
    const $f566370ab4491013$export$1626c947db580b0f = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: false
    };
});
parcelRegister("dtcdd", function(module, exports) {
    $parcel$export(module.exports, "versionSortingHandler", ()=>$b3c9429c32861e4c$export$f2894a637a250eaa);
    var $5fc53;
    const $b3c9429c32861e4c$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
    const $b3c9429c32861e4c$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $b3c9429c32861e4c$export$f2894a637a250eaa = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getSingleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting
    };
});
parcelRegister("fCkUD", function(module, exports) {
    $parcel$export(module.exports, "isNewTransformedFieldPredicated", ()=>$fb9b3f13d18b237f$export$b018c2b58ea7e0de);
    const $fb9b3f13d18b237f$export$b018c2b58ea7e0de = (field)=>field != null;
});
parcelRegister("57lFd", function(module, exports) {
    $parcel$export(module.exports, "getFieldValue", ()=>$9c93e114366691a0$export$2e85048acc9aea83);
    $parcel$export(module.exports, "safeGetValue", ()=>$9c93e114366691a0$export$f17a5eaf5fe57cff);
    $parcel$export(module.exports, "safeGetTransformedFieldValue", ()=>$9c93e114366691a0$export$16456470899ab77f);
    $parcel$export(module.exports, "safeGetTransformedValue", ()=>$9c93e114366691a0$export$c1cc7bc9b4953394);
    var $9XE6b = parcelRequire("9XE6b");
    const $9c93e114366691a0$export$2e85048acc9aea83 = (fields, fieldKey)=>{
        if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
        return undefined;
    };
    const $9c93e114366691a0$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return (0, ($parcel$interopDefault($9XE6b)))(field, attributeName, defaultValue);
    };
    const $9c93e114366691a0$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return $9c93e114366691a0$export$c1cc7bc9b4953394(field, defaultValue);
    };
    const $9c93e114366691a0$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, ($parcel$interopDefault($9XE6b)))(field, 'value', defaultValue);
});
parcelRegister("ixx6N", function(module, exports) {
    $parcel$export(module.exports, "resolveRank", ()=>$0a08bd66273f9a8c$export$992090b26f7c7f11);
    const $0a08bd66273f9a8c$export$992090b26f7c7f11 = (parentIssue, rank)=>{
        const parentRank = parentIssue?.rank ?? '';
        return parentRank.concat(rank);
    };
});
parcelRegister("17ot5", function(module, exports) {
    $parcel$export(module.exports, "useHideDoneItems", ()=>$f683983c23bf92d0$export$c2cb7b17819b92d4);
    $parcel$export(module.exports, "useInferHideDoneItemsWithFilters", ()=>$f683983c23bf92d0$export$a14bc8305f71e469);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $gULOk;
    var $dpQnO;
    const $f683983c23bf92d0$export$c2cb7b17819b92d4 = ()=>{
        const [hideDoneItems, persistHideDoneItems] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).HIDE_DONE_ITEMS_PREFERENCE));
        const setHideDoneItems = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
            persistHideDoneItems
        ]);
        return [
            hideDoneItems === 'true',
            setHideDoneItems
        ];
    };
    const $f683983c23bf92d0$export$a14bc8305f71e469 = ({ filters: filters })=>{
        const [hideDoneItems, setHideDoneItems] = $f683983c23bf92d0$export$c2cb7b17819b92d4();
        const { quickFilters: quickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (hideDoneItems) {
                const isFilteringByDoneStatus = (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE]);
                if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
            }
        }, [
            filters,
            quickFilters?.DONE
        ]);
    };
});
parcelRegister("dpQnO", function(module, exports) {
    $parcel$export(module.exports, "useQuickFilters", ()=>$59496077a2cce3b6$export$3dae1bb95b659fd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $5fc53;
    var $g4ZHz;
    const $59496077a2cce3b6$var$quickFilterToJQLMapOld = {
        ASSIGNED_TO_ME: 'assignee = currentUser()',
        DONE: "StatusCategory = 'Complete'",
        DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
    };
    const $59496077a2cce3b6$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
        if (sprintJQLTerm == null) return $59496077a2cce3b6$var$quickFilterToJQLMapOld;
        return {
            ...$59496077a2cce3b6$var$quickFilterToJQLMapOld,
            ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
        };
    };
    const $59496077a2cce3b6$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const jqlClauses = Object.entries(quickFilters).map(([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
        const enabledFilters = jqlClauses.filter((jql)=>jql);
        return enabledFilters.join(' AND ') || null;
    };
    const $59496077a2cce3b6$export$9294471da4d3c33f = {
        ASSIGNED_TO_ME: false,
        DONE: false,
        DUE_THIS_WEEK: false,
        ACTIVE_SPRINTS: false
    };
    const $59496077a2cce3b6$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const quickFilters = {
            ...$59496077a2cce3b6$export$9294471da4d3c33f
        };
        if (!jql) return quickFilters;
        if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
        if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
        if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
        if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
        return quickFilters;
    };
    const $59496077a2cce3b6$var$useSprintFieldJQLTerm = ()=>{
        const { data: fields } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        return (0, $5uXOq.useMemo)(()=>{
            if (fields == null) return undefined;
            const sprintField = fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE));
            return sprintField != null ? sprintField.jqlTerm : undefined;
        }, [
            fields
        ]);
    };
    const $59496077a2cce3b6$export$3dae1bb95b659fd4 = ()=>{
        const sprintFieldJQLTerm = $59496077a2cce3b6$var$useSprintFieldJQLTerm();
        const quickFilterToJQLMap = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$808f76242d61e1a5(sprintFieldJQLTerm), [
            sprintFieldJQLTerm
        ]);
        const [filters, setFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters)=>{
            if (newQuickFilters) {
                const jql = $59496077a2cce3b6$var$buildJQLFromQuickFilters(newQuickFilters, {
                    quickFilterToJQLMap: quickFilterToJQLMap
                });
                if (jql == null) setFilters(undefined);
                else setFilters(jql);
            } else setFilters(undefined);
        }, [
            quickFilterToJQLMap,
            setFilters
        ]);
        const quickFilters = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$9692fc1a2fd983f5(filters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            }), [
            filters,
            quickFilterToJQLMap
        ]);
        return {
            quickFilters: quickFilters,
            persistQuickFilters: setQuickFilters,
            quickFiltersJql: $59496077a2cce3b6$var$buildJQLFromQuickFilters(quickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            })
        };
    };
});
parcelRegister("l4Ejo", function(module, exports) {
    $parcel$export(module.exports, "useFilters", ()=>$8a462d10017c11b6$export$973ca22476b0e05f);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $1tESh;
    const $8a462d10017c11b6$export$973ca22476b0e05f = ()=>{
        const [jql, saveFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setFilter = (0, $5uXOq.useCallback)((filters)=>{
            const serialisedJql = (0, (0, parcelRequire("1tESh")).serialiseJql)(filters);
            saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
        }, [
            saveFilters
        ]);
        return {
            setFilter: setFilter,
            jql: jql
        };
    };
});
parcelRegister("1tESh", function(module, exports) {
    $parcel$export(module.exports, "serialiseJql", ()=>$1e9d101255159a24$export$e1718e1e441cb0f6);
    $parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", ()=>$1e9d101255159a24$export$9ee6085825c9cbfa);
    var $gccSB = parcelRequire("gccSB");
    var $2nvJN = parcelRequire("2nvJN");
    var $gwejS;
    var $f9ece;
    var $iEIQF;
    var $bzbto;
    var $l0V05;
    var $7htvz;
    const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
    const $1e9d101255159a24$var$EMPTY = 'EMPTY';
    const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
    const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
        if (fieldName.indexOf('customfield_') === 0) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
        return fieldName;
    };
    const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
    const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
    const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
    const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
        const jqlQuery = (0, (0, parcelRequire("iEIQF")).default).query();
        Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
                if (options.value.to != null) {
                    const toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                    jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(toFieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LT)), (0, (0, parcelRequire("iEIQF")).default).valueOperand(toDate)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                }
                if (options.value.from != null) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS)), (0, (0, parcelRequire("iEIQF")).default).valueOperand(options.value.from)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                return;
            }
            if (Array.isArray(options)) {
                const operands = options.map((option)=>{
                    if (option.isEmptyOption) return (0, (0, parcelRequire("iEIQF")).default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
                    if (option.value) return (0, (0, parcelRequire("iEIQF")).default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                    return null;
                }).filter((operand)=>operand != null);
                if (operands.length === 1) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)), operands[0]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                else if (operands.length > 1) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)), (0, (0, parcelRequire("iEIQF")).default).listOperand(operands)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            }
        });
        const jast = (0, (0, parcelRequire("iEIQF")).default).jast(jqlQuery);
        return (0, (0, parcelRequire("l0V05")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
        const pairs = Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).map(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
                let toDate;
                if (options.value.to) toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                else toDate = options.value.to;
                if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
                if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
                return `${toFieldName} < ${toDate}`;
            }
            if (Array.isArray(options)) {
                const values = options.map((option)=>option.value === (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
                if (options.length > 1) return `${fieldName} in (${values})`;
                if (options.length === 1) return `${fieldName} = ${values}`;
            }
            return null;
        });
        return pairs.join(' AND ');
    };
    const $1e9d101255159a24$var$extractField = (statement)=>{
        let fieldId;
        const dateOperatorRegex = />=|</;
        if (dateOperatorRegex.test(statement)) {
            const operator = statement.includes('>=') ? ' >= ' : ' < ';
            [fieldId] = statement.split(operator);
        }
        if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
        if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
        if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
    };
    const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
        if (!jql) return {};
        return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
            if (curr) acc[curr] = true;
            return acc;
        }, {});
    };
});
parcelRegister("2nvJN", function(module, exports) {
    var $kHBB0 = parcelRequire("kHBB0");
    var $6wH7T = parcelRequire("6wH7T");
    var $gvFfr = parcelRequire("gvFfr");
    var $4TR1Q = parcelRequire("4TR1Q");
    var $c2mKc = parcelRequire("c2mKc");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $jJVtR = parcelRequire("jJVtR");
    function $1bb6592c97235e03$var$trim(string, chars, guard) {
        string = $jJVtR(string);
        if (string && (guard || chars === undefined)) return $6wH7T(string);
        if (!string || !(chars = $kHBB0(chars))) return string;
        var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
        return $gvFfr(strSymbols, start, end).join('');
    }
    module.exports = $1bb6592c97235e03$var$trim;
});
parcelRegister("4TR1Q", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $39156edc40ecb497$var$charsEndIndex;
});
parcelRegister("c2mKc", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $8c37507367fba30b$var$charsStartIndex;
});
const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';
parcelRegister("iEIQF", function(module, exports) {
    $parcel$export(module.exports, "internalCreators", ()=>$76b4580b91797d8b$export$64d991963cfb5532);
    $parcel$export(module.exports, "default", ()=>$76b4580b91797d8b$export$2e2bcd8739ae039);
    var $gzGcl;
    var $awXvh;
    var $3hoxA;
    var $2TUEL;
    var $9TMIk;
    var $23cr9;
    var $an0VC;
    var $kO6UE;
    var $AZ9nU;
    var $9HHq9;
    var $6qN6D;
    var $3J4gf;
    var $her2D;
    var $j37YY;
    var $doe2p;
    var $k9DKN;
    var $jRA9z;
    var $bF1Nb;
    var $bW5aY;
    var $dgZwd;
    var $1zQFd;
    var $eWV0u;
    const $76b4580b91797d8b$export$64d991963cfb5532 = {
        query: (0, (0, parcelRequire("dgZwd")).queryInternal),
        compoundClause: (0, (0, parcelRequire("awXvh")).compoundClauseInternal),
        compoundOperator: (0, (0, parcelRequire("3hoxA")).compoundOperatorInternal),
        terminalClause: (0, (0, parcelRequire("1zQFd")).terminalClauseInternal),
        notClause: (0, (0, parcelRequire("9HHq9")).notClauseInternal),
        notClauseOperator: (0, (0, parcelRequire("6qN6D")).notClauseOperatorInternal),
        predicate: (0, (0, parcelRequire("jRA9z")).predicateInternal),
        predicateOperator: (0, (0, parcelRequire("bF1Nb")).predicateOperatorInternal),
        field: (0, (0, parcelRequire("2TUEL")).fieldInternal),
        property: (0, (0, parcelRequire("bW5aY")).propertyInternal),
        operator: (0, (0, parcelRequire("3J4gf")).operatorInternal),
        valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandInternal),
        keywordOperand: (0, (0, parcelRequire("kO6UE")).keywordOperandInternal),
        functionOperand: (0, (0, parcelRequire("9TMIk")).functionOperandInternal),
        functionString: (0, (0, parcelRequire("23cr9")).functionStringInternal),
        argument: (0, (0, parcelRequire("gzGcl")).argumentInternal),
        listOperand: (0, (0, parcelRequire("AZ9nU")).listOperandInternal),
        orderBy: (0, (0, parcelRequire("her2D")).orderByInternal),
        orderByOperator: (0, (0, parcelRequire("k9DKN")).orderByOperatorInternal),
        orderByField: (0, (0, parcelRequire("doe2p")).orderByFieldInternal),
        orderByDirection: (0, (0, parcelRequire("j37YY")).orderByDirectionInternal)
    };
    var $76b4580b91797d8b$export$2e2bcd8739ae039 = {
        jast: (0, parcelRequire("an0VC")).jast,
        query: (0, parcelRequire("dgZwd")).query,
        compoundClause: (0, parcelRequire("awXvh")).compoundClause,
        compoundOperator: (0, parcelRequire("3hoxA")).compoundOperator,
        terminalClause: (0, parcelRequire("1zQFd")).terminalClause,
        notClause: (0, parcelRequire("9HHq9")).notClause,
        notClauseOperator: (0, parcelRequire("6qN6D")).notClauseOperator,
        predicate: (0, parcelRequire("jRA9z")).predicate,
        predicateOperator: (0, parcelRequire("bF1Nb")).predicateOperator,
        field: (0, parcelRequire("2TUEL")).field,
        property: (0, parcelRequire("bW5aY")).property,
        operator: (0, parcelRequire("3J4gf")).operator,
        valueOperand: (0, parcelRequire("eWV0u")).valueOperand,
        keywordOperand: (0, parcelRequire("kO6UE")).keywordOperand,
        functionOperand: (0, parcelRequire("9TMIk")).functionOperand,
        functionString: (0, parcelRequire("23cr9")).functionString,
        argument: (0, parcelRequire("gzGcl")).argument,
        listOperand: (0, parcelRequire("AZ9nU")).listOperand,
        orderBy: (0, parcelRequire("her2D")).orderBy,
        orderByOperator: (0, parcelRequire("k9DKN")).orderByOperator,
        orderByField: (0, parcelRequire("doe2p")).orderByField,
        orderByDirection: (0, parcelRequire("j37YY")).orderByDirection,
        byText: {
            argument: (0, (0, parcelRequire("gzGcl")).argumentByText),
            valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandByText)
        }
    };
});
parcelRegister("gzGcl", function(module, exports) {
    $parcel$export(module.exports, "argument", ()=>$1f5307df81a07b07$export$6ea29ee575e3f5ff);
    $parcel$export(module.exports, "argumentInternal", ()=>$1f5307df81a07b07$export$5b341d50fa5bcdd5);
    $parcel$export(module.exports, "argumentByText", ()=>$1f5307df81a07b07$export$84c43d23f51170cb);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $1f5307df81a07b07$var$acceptArgument(visitor) {
        return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
    }
    function $1f5307df81a07b07$var$enterNode(listener) {
        listener.enterArgument && listener.enterArgument(this);
    }
    function $1f5307df81a07b07$var$exitNode(listener) {
        listener.exitArgument && listener.exitArgument(this);
    }
    const $1f5307df81a07b07$export$6ea29ee575e3f5ff = (value)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $1f5307df81a07b07$export$84c43d23f51170cb = (text)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $1f5307df81a07b07$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $1f5307df81a07b07$var$acceptArgument,
            enterNode: $1f5307df81a07b07$var$enterNode,
            exitNode: $1f5307df81a07b07$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("gq4pj", function(module, exports) {
    $parcel$export(module.exports, "normaliseJqlString", ()=>$dd481207f70e9cdd$export$cecf78a779acc0ff);
    const $dd481207f70e9cdd$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$d5efd6512db694fd = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$b86601123607fee5 = (maybeQuotedString)=>$dd481207f70e9cdd$export$7a0b99b892e0dda8(maybeQuotedString) || $dd481207f70e9cdd$export$d5efd6512db694fd(maybeQuotedString);
    const $dd481207f70e9cdd$export$cecf78a779acc0ff = (maybeQuotedString)=>{
        if ($dd481207f70e9cdd$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
        if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
        return maybeQuotedString;
    };
});
parcelRegister("2lgiK", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJqlString", ()=>$6e52f9b4063b6286$export$3eb9033c48208278);
    var $8QDwl = parcelRequire("8QDwl");
    const $6e52f9b4063b6286$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, ($parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
    const $6e52f9b4063b6286$export$3eb9033c48208278 = (jqlString)=>{
        if ($6e52f9b4063b6286$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
        return jqlString;
    };
});
parcelRegister("8QDwl", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
    function $6711d60dd8e02df4$var$escapeRegExp(string) {
        string = $jJVtR(string);
        return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
    }
    module.exports = $6711d60dd8e02df4$var$escapeRegExp;
});
parcelRegister("WCvOq", function(module, exports) {
    $parcel$export(module.exports, "noChildren", ()=>$90e2b276351fabc1$export$470bef71e654b804);
    $parcel$export(module.exports, "assignParent", ()=>$90e2b276351fabc1$export$a4685923af2913a);
    const $90e2b276351fabc1$export$470bef71e654b804 = ()=>[];
    const $90e2b276351fabc1$export$a4685923af2913a = (node)=>{
        node.getChildren().forEach((child)=>{
            child.parent = node;
        });
    };
});
parcelRegister("awXvh", function(module, exports) {
    $parcel$export(module.exports, "compoundClause", ()=>$3e337dfb3ad8a3f8$export$ab714e56a32c25f2);
    $parcel$export(module.exports, "compoundClauseInternal", ()=>$3e337dfb3ad8a3f8$export$cd65eed8c10b0911);
    var $3AraL;
    var $WCvOq;
    function $3e337dfb3ad8a3f8$var$acceptCompoundClause(visitor) {
        return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
    }
    function $3e337dfb3ad8a3f8$var$enterNode(listener) {
        listener.enterCompoundClause && listener.enterCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$exitNode(listener) {
        listener.exitCompoundClause && listener.exitCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$getChildren() {
        return [
            this.operator,
            ...this.clauses
        ];
    }
    const $3e337dfb3ad8a3f8$export$ab714e56a32c25f2 = (operator, clauses)=>{
        return $3e337dfb3ad8a3f8$export$cd65eed8c10b0911(operator, clauses);
    };
    const $3e337dfb3ad8a3f8$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b),
            operator: operator,
            clauses: clauses,
            position: position,
            accept: $3e337dfb3ad8a3f8$var$acceptCompoundClause,
            enterNode: $3e337dfb3ad8a3f8$var$enterNode,
            exitNode: $3e337dfb3ad8a3f8$var$exitNode,
            getChildren: $3e337dfb3ad8a3f8$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("3AraL")).appendClause,
            remove: (0, parcelRequire("3AraL")).remove,
            removeClause: (0, parcelRequire("3AraL")).removeClause,
            replace: (0, parcelRequire("3AraL")).replace,
            replaceClause: (0, parcelRequire("3AraL")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';
const $c1dc40b7a30d95e8$export$98dda21ec825792 = 'query';
const $c1dc40b7a30d95e8$export$2d205682cc545947 = 'clause';
const $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d = 'operand';
const $c1dc40b7a30d95e8$export$da0f73edded4a63d = 'order_by';
parcelRegister("3AraL", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function appendClause(clause) {
        let clausesToAppend = [
            clause
        ];
        if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
        this.clauses.push(...clausesToAppend);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        this.clauses = this.clauses.filter((val)=>val !== clause);
        if (this.clauses.length === 1) this.replace(this.clauses[0]);
        else if (this.clauses.length === 0) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        this.clauses = this.clauses.map((child)=>{
            return child === clause ? nextClause : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("3hoxA", function(module, exports) {
    $parcel$export(module.exports, "compoundOperator", ()=>$fe3f499b83b55a64$export$84bb3ebbba491aee);
    $parcel$export(module.exports, "compoundOperatorInternal", ()=>$fe3f499b83b55a64$export$63c33bc3fe74fee6);
    var $WCvOq;
    function $fe3f499b83b55a64$var$acceptCompoundOperator(visitor) {
        return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
    }
    function $fe3f499b83b55a64$var$enterNode(listener) {
        listener.enterCompoundOperator && listener.enterCompoundOperator(this);
    }
    function $fe3f499b83b55a64$var$exitNode(listener) {
        listener.exitCompoundOperator && listener.exitCompoundOperator(this);
    }
    const $fe3f499b83b55a64$export$84bb3ebbba491aee = (value)=>$fe3f499b83b55a64$export$63c33bc3fe74fee6(value, []);
    const $fe3f499b83b55a64$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
            value: value,
            positions: operatorPositions,
            position: null,
            accept: $fe3f499b83b55a64$var$acceptCompoundOperator,
            enterNode: $fe3f499b83b55a64$var$enterNode,
            exitNode: $fe3f499b83b55a64$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("2TUEL", function(module, exports) {
    $parcel$export(module.exports, "field", ()=>$1c31156a69528c72$export$e0f35d825088c098);
    $parcel$export(module.exports, "fieldInternal", ()=>$1c31156a69528c72$export$2193f8c541622b6);
    var $2lgiK;
    var $WCvOq;
    function $1c31156a69528c72$var$acceptField(visitor) {
        return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
    }
    function $1c31156a69528c72$var$enterNode(listener) {
        listener.enterField && listener.enterField(this);
    }
    function $1c31156a69528c72$var$exitNode(listener) {
        listener.exitField && listener.exitField(this);
    }
    function $1c31156a69528c72$var$getChildren() {
        return this.properties ? [
            ...this.properties
        ] : [];
    }
    const $1c31156a69528c72$export$e0f35d825088c098 = (value, properties)=>{
        return $1c31156a69528c72$export$2193f8c541622b6(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value), properties);
    };
    const $1c31156a69528c72$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
        const node = {
            text: text,
            value: value,
            properties: properties,
            position: position,
            accept: $1c31156a69528c72$var$acceptField,
            enterNode: $1c31156a69528c72$var$enterNode,
            exitNode: $1c31156a69528c72$var$exitNode,
            getChildren: $1c31156a69528c72$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("9TMIk", function(module, exports) {
    $parcel$export(module.exports, "functionOperand", ()=>$413f1d947acf321b$export$4f981b0e83488ce);
    $parcel$export(module.exports, "functionOperandInternal", ()=>$413f1d947acf321b$export$c1f2ce91dc05872a);
    var $WCvOq;
    function $413f1d947acf321b$var$acceptFunctionOperand(visitor) {
        return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
    }
    function $413f1d947acf321b$var$enterNode(listener) {
        listener.enterFunctionOperand && listener.enterFunctionOperand(this);
    }
    function $413f1d947acf321b$var$exitNode(listener) {
        listener.exitFunctionOperand && listener.exitFunctionOperand(this);
    }
    function $413f1d947acf321b$var$getChildren() {
        return [
            this.function,
            ...this.arguments
        ];
    }
    const $413f1d947acf321b$export$4f981b0e83488ce = (functionString, args = [])=>$413f1d947acf321b$export$c1f2ce91dc05872a(functionString, args);
    const $413f1d947acf321b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d),
            function: functionString,
            arguments: args,
            position: position,
            accept: $413f1d947acf321b$var$acceptFunctionOperand,
            enterNode: $413f1d947acf321b$var$enterNode,
            exitNode: $413f1d947acf321b$var$exitNode,
            getChildren: $413f1d947acf321b$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';
parcelRegister("23cr9", function(module, exports) {
    $parcel$export(module.exports, "functionString", ()=>$a67350f9199f98c5$export$4e1bb9a7ff8d0ef9);
    $parcel$export(module.exports, "functionStringInternal", ()=>$a67350f9199f98c5$export$7aa9944588b7a69f);
    var $2lgiK;
    var $WCvOq;
    function $a67350f9199f98c5$var$acceptFunctionString(visitor) {
        return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
    }
    function $a67350f9199f98c5$var$enterNode(listener) {
        listener.enterFunction && listener.enterFunction(this);
    }
    function $a67350f9199f98c5$var$exitNode(listener) {
        listener.exitFunction && listener.exitFunction(this);
    }
    const $a67350f9199f98c5$export$4e1bb9a7ff8d0ef9 = (value)=>$a67350f9199f98c5$export$7aa9944588b7a69f(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $a67350f9199f98c5$export$7aa9944588b7a69f = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $a67350f9199f98c5$var$acceptFunctionString,
            enterNode: $a67350f9199f98c5$var$enterNode,
            exitNode: $a67350f9199f98c5$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("an0VC", function(module, exports) {
    $parcel$export(module.exports, "jast", ()=>$99ec58cecea09c23$export$b9e70a00f479ff43);
    const $99ec58cecea09c23$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
            query: query,
            represents: represents,
            errors: errors
        });
});
parcelRegister("kO6UE", function(module, exports) {
    $parcel$export(module.exports, "keywordOperand", ()=>$374a6d53e0ec4f5c$export$2edd4971ed69f2ce);
    $parcel$export(module.exports, "keywordOperandInternal", ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b);
    var $WCvOq;
    function $374a6d53e0ec4f5c$var$acceptKeywordOperand(visitor) {
        return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
    }
    function $374a6d53e0ec4f5c$var$enterNode(listener) {
        listener.enterKeywordOperand && listener.enterKeywordOperand(this);
    }
    function $374a6d53e0ec4f5c$var$exitNode(listener) {
        listener.exitKeywordOperand && listener.exitKeywordOperand(this);
    }
    const $374a6d53e0ec4f5c$export$2edd4971ed69f2ce = ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
    const $374a6d53e0ec4f5c$export$7cc55480b054047b = (value, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$f6049126fd97001f),
            value: value,
            position: position,
            accept: $374a6d53e0ec4f5c$var$acceptKeywordOperand,
            enterNode: $374a6d53e0ec4f5c$var$enterNode,
            exitNode: $374a6d53e0ec4f5c$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("AZ9nU", function(module, exports) {
    $parcel$export(module.exports, "listOperand", ()=>$c52de47ddabd701d$export$769866c3e9d41d50);
    $parcel$export(module.exports, "listOperandInternal", ()=>$c52de47ddabd701d$export$663c7831528c984b);
    var $eDTUO;
    var $WCvOq;
    function $c52de47ddabd701d$var$acceptListOperand(visitor) {
        return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
    }
    function $c52de47ddabd701d$var$enterNode(listener) {
        listener.enterListOperand && listener.enterListOperand(this);
    }
    function $c52de47ddabd701d$var$exitNode(listener) {
        listener.exitListOperand && listener.exitListOperand(this);
    }
    function $c52de47ddabd701d$var$getChildren() {
        return [
            ...this.values
        ];
    }
    const $c52de47ddabd701d$export$769866c3e9d41d50 = (values)=>$c52de47ddabd701d$export$663c7831528c984b(values);
    const $c52de47ddabd701d$export$663c7831528c984b = (values, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$fabec4aebba3f4df),
            values: values,
            position: position,
            accept: $c52de47ddabd701d$var$acceptListOperand,
            enterNode: $c52de47ddabd701d$var$enterNode,
            exitNode: $c52de47ddabd701d$var$exitNode,
            getChildren: $c52de47ddabd701d$var$getChildren,
            parent: null,
            appendOperand: (0, parcelRequire("eDTUO")).appendOperand
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("eDTUO", function(module, exports) {
    $parcel$export(module.exports, "appendOperand", ()=>$9a86be0ad84d7cf1$export$d94c54f1aee177c4);
    var $WCvOq;
    function $9a86be0ad84d7cf1$export$d94c54f1aee177c4(operand) {
        this.values.push(...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
            operand
        ]);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("9HHq9", function(module, exports) {
    $parcel$export(module.exports, "notClause", ()=>$ed106cb5124eff4e$export$b4734a9fedb4d44e);
    $parcel$export(module.exports, "notClauseInternal", ()=>$ed106cb5124eff4e$export$b25621824fea4548);
    var $fjrwK;
    var $WCvOq;
    var $6qN6D;
    function $ed106cb5124eff4e$var$acceptNotClause(visitor) {
        return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
    }
    function $ed106cb5124eff4e$var$enterNode(listener) {
        listener.enterNotClause && listener.enterNotClause(this);
    }
    function $ed106cb5124eff4e$var$exitNode(listener) {
        listener.exitNotClause && listener.exitNotClause(this);
    }
    function $ed106cb5124eff4e$var$getChildren() {
        return [
            this.operator,
            this.clause
        ];
    }
    const $ed106cb5124eff4e$export$b4734a9fedb4d44e = (clause)=>{
        return $ed106cb5124eff4e$export$b25621824fea4548(clause, (0, (0, parcelRequire("6qN6D")).notClauseOperator)());
    };
    const $ed106cb5124eff4e$export$b25621824fea4548 = (clause, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb),
            clause: clause,
            operator: operator,
            position: position,
            accept: $ed106cb5124eff4e$var$acceptNotClause,
            enterNode: $ed106cb5124eff4e$var$enterNode,
            exitNode: $ed106cb5124eff4e$var$exitNode,
            getChildren: $ed106cb5124eff4e$var$getChildren,
            parent: null,
            remove: (0, parcelRequire("fjrwK")).remove,
            removeClause: (0, parcelRequire("fjrwK")).removeClause,
            replace: (0, parcelRequire("fjrwK")).replace,
            replaceClause: (0, parcelRequire("fjrwK")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("fjrwK", function(module, exports) {
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        if (this.clause === clause) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        if (this.clause === clause) {
            this.clause = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
});
parcelRegister("6qN6D", function(module, exports) {
    $parcel$export(module.exports, "notClauseOperator", ()=>$467f41c633037180$export$d2cd8239f99c13d3);
    $parcel$export(module.exports, "notClauseOperatorInternal", ()=>$467f41c633037180$export$1b15a32bb57b9020);
    var $bzbto;
    var $WCvOq;
    function $467f41c633037180$var$acceptNotClauseOperator(visitor) {
        return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
    }
    function $467f41c633037180$var$enterNode(listener) {
        listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
    }
    function $467f41c633037180$var$exitNode(listener) {
        listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
    }
    const $467f41c633037180$export$d2cd8239f99c13d3 = ()=>$467f41c633037180$export$1b15a32bb57b9020();
    const $467f41c633037180$export$1b15a32bb57b9020 = (position = null)=>({
            value: (0, (0, parcelRequire("bzbto")).CLAUSE_OPERATOR_NOT),
            position: position,
            accept: $467f41c633037180$var$acceptNotClauseOperator,
            enterNode: $467f41c633037180$var$enterNode,
            exitNode: $467f41c633037180$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bzbto", function(module, exports) {
    $parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", ()=>$bee8c61d429e7e04$export$c6c71ceedb15cda9);
    $parcel$export(module.exports, "OPERATOR_EQUALS", ()=>$bee8c61d429e7e04$export$466517a888d00195);
    $parcel$export(module.exports, "OPERATOR_NOT_EQUALS", ()=>$bee8c61d429e7e04$export$6d0d8810623974a5);
    $parcel$export(module.exports, "OPERATOR_GT", ()=>$bee8c61d429e7e04$export$bcbb090ab3c498b3);
    $parcel$export(module.exports, "OPERATOR_LT", ()=>$bee8c61d429e7e04$export$4bf1a4aa659c6ea4);
    $parcel$export(module.exports, "OPERATOR_GT_EQUALS", ()=>$bee8c61d429e7e04$export$83ce674214a54b2a);
    $parcel$export(module.exports, "OPERATOR_LT_EQUALS", ()=>$bee8c61d429e7e04$export$9629fd1727ef62ee);
    $parcel$export(module.exports, "OPERATOR_IN", ()=>$bee8c61d429e7e04$export$c4e3fb55e320e979);
    $parcel$export(module.exports, "OPERATOR_NOT_IN", ()=>$bee8c61d429e7e04$export$f9857532eaa24ddc);
    $parcel$export(module.exports, "OPERATOR_LIKE", ()=>$bee8c61d429e7e04$export$221595834b8766ab);
    $parcel$export(module.exports, "OPERATOR_NOT_LIKE", ()=>$bee8c61d429e7e04$export$fcefabf94a9bffbf);
    $parcel$export(module.exports, "OPERATOR_IS", ()=>$bee8c61d429e7e04$export$4feeb3f4ff56bcef);
    $parcel$export(module.exports, "OPERATOR_IS_NOT", ()=>$bee8c61d429e7e04$export$d08d969a0da27188);
    $parcel$export(module.exports, "OPERATOR_WAS", ()=>$bee8c61d429e7e04$export$8f907e179985256d);
    $parcel$export(module.exports, "OPERATOR_WAS_IN", ()=>$bee8c61d429e7e04$export$cc7b9d0b3ee23193);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", ()=>$bee8c61d429e7e04$export$585d3c004af078bb);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT", ()=>$bee8c61d429e7e04$export$123eaa9ccc2d9445);
    $parcel$export(module.exports, "OPERATOR_CHANGED", ()=>$bee8c61d429e7e04$export$15f5b446ba8c941e);
    $parcel$export(module.exports, "EQUALS_OPERATORS", ()=>$bee8c61d429e7e04$export$643c6101f3fc8547);
    $parcel$export(module.exports, "LIKE_OPERATORS", ()=>$bee8c61d429e7e04$export$329664c9cf18cca6);
    $parcel$export(module.exports, "COMPARISON_OPERATORS", ()=>$bee8c61d429e7e04$export$1b167a3705885a8b);
    $parcel$export(module.exports, "IN_OPERATORS", ()=>$bee8c61d429e7e04$export$f25cf16c2270312f);
    $parcel$export(module.exports, "IS_OPERATORS", ()=>$bee8c61d429e7e04$export$eb58cfffe4a6b805);
    $parcel$export(module.exports, "WAS_OPERATORS", ()=>$bee8c61d429e7e04$export$c22a981f581de218);
    $parcel$export(module.exports, "WAS_IN_OPERATORS", ()=>$bee8c61d429e7e04$export$6d08c4699bb75284);
    $parcel$export(module.exports, "CHANGED_OPERATORS", ()=>$bee8c61d429e7e04$export$b7dc214eef214c1c);
    $parcel$export(module.exports, "OPERATORS", ()=>$bee8c61d429e7e04$export$184799fc79ccac89);
    $parcel$export(module.exports, "LIST_OPERATORS", ()=>$bee8c61d429e7e04$export$77c793736847e030);
    const $bee8c61d429e7e04$export$c6c71ceedb15cda9 = 'not';
    const $bee8c61d429e7e04$export$466517a888d00195 = '=';
    const $bee8c61d429e7e04$export$6d0d8810623974a5 = '!=';
    const $bee8c61d429e7e04$export$bcbb090ab3c498b3 = '>';
    const $bee8c61d429e7e04$export$4bf1a4aa659c6ea4 = '<';
    const $bee8c61d429e7e04$export$83ce674214a54b2a = '>=';
    const $bee8c61d429e7e04$export$9629fd1727ef62ee = '<=';
    const $bee8c61d429e7e04$export$c4e3fb55e320e979 = 'in';
    const $bee8c61d429e7e04$export$f9857532eaa24ddc = 'not in';
    const $bee8c61d429e7e04$export$221595834b8766ab = '~';
    const $bee8c61d429e7e04$export$fcefabf94a9bffbf = '!~';
    const $bee8c61d429e7e04$export$4feeb3f4ff56bcef = 'is';
    const $bee8c61d429e7e04$export$d08d969a0da27188 = 'is not';
    const $bee8c61d429e7e04$export$8f907e179985256d = 'was';
    const $bee8c61d429e7e04$export$cc7b9d0b3ee23193 = 'was in';
    const $bee8c61d429e7e04$export$585d3c004af078bb = 'was not in';
    const $bee8c61d429e7e04$export$123eaa9ccc2d9445 = 'was not';
    const $bee8c61d429e7e04$export$15f5b446ba8c941e = 'changed';
    const $bee8c61d429e7e04$export$643c6101f3fc8547 = [
        $bee8c61d429e7e04$export$466517a888d00195,
        $bee8c61d429e7e04$export$6d0d8810623974a5
    ];
    const $bee8c61d429e7e04$export$329664c9cf18cca6 = [
        $bee8c61d429e7e04$export$221595834b8766ab,
        $bee8c61d429e7e04$export$fcefabf94a9bffbf
    ];
    const $bee8c61d429e7e04$export$1b167a3705885a8b = [
        $bee8c61d429e7e04$export$4bf1a4aa659c6ea4,
        $bee8c61d429e7e04$export$bcbb090ab3c498b3,
        $bee8c61d429e7e04$export$9629fd1727ef62ee,
        $bee8c61d429e7e04$export$83ce674214a54b2a
    ];
    const $bee8c61d429e7e04$export$f25cf16c2270312f = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc
    ];
    const $bee8c61d429e7e04$export$eb58cfffe4a6b805 = [
        $bee8c61d429e7e04$export$4feeb3f4ff56bcef,
        $bee8c61d429e7e04$export$d08d969a0da27188
    ];
    const $bee8c61d429e7e04$export$c22a981f581de218 = [
        $bee8c61d429e7e04$export$8f907e179985256d,
        $bee8c61d429e7e04$export$123eaa9ccc2d9445
    ];
    const $bee8c61d429e7e04$export$6d08c4699bb75284 = [
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
    const $bee8c61d429e7e04$export$b7dc214eef214c1c = [
        $bee8c61d429e7e04$export$15f5b446ba8c941e
    ];
    const $bee8c61d429e7e04$export$184799fc79ccac89 = [
        ...$bee8c61d429e7e04$export$643c6101f3fc8547,
        ...$bee8c61d429e7e04$export$329664c9cf18cca6,
        ...$bee8c61d429e7e04$export$1b167a3705885a8b,
        ...$bee8c61d429e7e04$export$f25cf16c2270312f,
        ...$bee8c61d429e7e04$export$eb58cfffe4a6b805,
        ...$bee8c61d429e7e04$export$c22a981f581de218,
        ...$bee8c61d429e7e04$export$6d08c4699bb75284,
        ...$bee8c61d429e7e04$export$b7dc214eef214c1c
    ];
    const $bee8c61d429e7e04$export$77c793736847e030 = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc,
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
});
parcelRegister("3J4gf", function(module, exports) {
    $parcel$export(module.exports, "operator", ()=>$6fd03a148f63af84$export$dbd72860f701d4f3);
    $parcel$export(module.exports, "operatorInternal", ()=>$6fd03a148f63af84$export$649025bc60ab9c3b);
    var $WCvOq;
    function $6fd03a148f63af84$var$acceptOperator(visitor) {
        return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
    }
    function $6fd03a148f63af84$var$enterNode(listener) {
        listener.enterOperator && listener.enterOperator(this);
    }
    function $6fd03a148f63af84$var$exitNode(listener) {
        listener.exitOperator && listener.exitOperator(this);
    }
    const $6fd03a148f63af84$export$dbd72860f701d4f3 = (value)=>$6fd03a148f63af84$export$649025bc60ab9c3b(value, value);
    const $6fd03a148f63af84$export$649025bc60ab9c3b = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $6fd03a148f63af84$var$acceptOperator,
            enterNode: $6fd03a148f63af84$var$enterNode,
            exitNode: $6fd03a148f63af84$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("her2D", function(module, exports) {
    $parcel$export(module.exports, "orderBy", ()=>$37cf08d9a2045c25$export$f18af21d6f4dafd8);
    $parcel$export(module.exports, "orderByInternal", ()=>$37cf08d9a2045c25$export$e4eb1fa6bc8465c1);
    var $5HQt3;
    var $WCvOq;
    var $k9DKN;
    function $37cf08d9a2045c25$var$acceptOrderBy(visitor) {
        return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
    }
    function $37cf08d9a2045c25$var$enterNode(listener) {
        listener.enterOrderBy && listener.enterOrderBy(this);
    }
    function $37cf08d9a2045c25$var$exitNode(listener) {
        listener.exitOrderBy && listener.exitOrderBy(this);
    }
    function $37cf08d9a2045c25$var$getChildren() {
        return [
            this.operator,
            ...this.fields
        ];
    }
    const $37cf08d9a2045c25$export$f18af21d6f4dafd8 = (fields)=>{
        return $37cf08d9a2045c25$export$e4eb1fa6bc8465c1(fields, (0, (0, parcelRequire("k9DKN")).orderByOperator)());
    };
    const $37cf08d9a2045c25$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$da0f73edded4a63d),
            operator: operator,
            fields: fields,
            position: position,
            accept: $37cf08d9a2045c25$var$acceptOrderBy,
            enterNode: $37cf08d9a2045c25$var$enterNode,
            exitNode: $37cf08d9a2045c25$var$exitNode,
            getChildren: $37cf08d9a2045c25$var$getChildren,
            parent: null,
            prependOrderField: (0, parcelRequire("5HQt3")).prependOrderField,
            setOrderDirection: (0, parcelRequire("5HQt3")).setOrderDirection,
            replace: (0, parcelRequire("5HQt3")).replace,
            replaceOrderField: (0, parcelRequire("5HQt3")).replaceOrderField,
            remove: (0, parcelRequire("5HQt3")).remove,
            removeOrderField: (0, parcelRequire("5HQt3")).removeOrderField
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("5HQt3", function(module, exports) {
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceOrderField", ()=>replaceOrderField);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeOrderField", ()=>removeOrderField);
    var $WCvOq;
    function prependOrderField(orderField) {
        this.fields.unshift(orderField);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOrderDirection(orderDirection) {
        if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
    }
    function replace(nextOrderBy) {
        if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
    }
    function replaceOrderField(orderByField, nextOrderByField) {
        this.fields = this.fields.map((child)=>{
            return child === orderByField ? nextOrderByField : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeOrderBy();
    }
    function removeOrderField(orderByField) {
        this.fields = this.fields.filter((field)=>field !== orderByField);
        if (this.fields.length === 0) this.remove();
    }
});
parcelRegister("k9DKN", function(module, exports) {
    $parcel$export(module.exports, "orderByOperator", ()=>$0824f859de091a85$export$c7307b67924c61ea);
    $parcel$export(module.exports, "orderByOperatorInternal", ()=>$0824f859de091a85$export$739e30af23a08da0);
    var $WCvOq;
    function $0824f859de091a85$var$acceptOrderByOperator(visitor) {
        return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
    }
    function $0824f859de091a85$var$enterNode(listener) {
        listener.enterOrderByOperator && listener.enterOrderByOperator(this);
    }
    function $0824f859de091a85$var$exitNode(listener) {
        listener.exitOrderByOperator && listener.exitOrderByOperator(this);
    }
    const $0824f859de091a85$export$c7307b67924c61ea = ()=>$0824f859de091a85$export$739e30af23a08da0();
    const $0824f859de091a85$export$739e30af23a08da0 = (position = null)=>({
            value: (0, $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517),
            position: position,
            accept: $0824f859de091a85$var$acceptOrderByOperator,
            enterNode: $0824f859de091a85$var$enterNode,
            exitNode: $0824f859de091a85$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
const $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517 = 'ORDER BY';
const $9f1dbb2b39d4d9a2$export$6d60017b9e092e73 = 'ASC';
const $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899 = 'DESC';
parcelRegister("j37YY", function(module, exports) {
    $parcel$export(module.exports, "orderByDirection", ()=>$c155c373ff42c873$export$864d934efed3ccaa);
    $parcel$export(module.exports, "orderByDirectionInternal", ()=>$c155c373ff42c873$export$8c65cac1a7852d1f);
    var $WCvOq;
    function $c155c373ff42c873$var$acceptOrderByDirection(visitor) {
        return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
    }
    function $c155c373ff42c873$var$enterNode(listener) {
        listener.enterOrderByDirection && listener.enterOrderByDirection(this);
    }
    function $c155c373ff42c873$var$exitNode(listener) {
        listener.exitOrderByDirection && listener.exitOrderByDirection(this);
    }
    const $c155c373ff42c873$export$864d934efed3ccaa = (value)=>$c155c373ff42c873$export$8c65cac1a7852d1f(value);
    const $c155c373ff42c873$export$8c65cac1a7852d1f = (value, position = null)=>({
            value: value,
            position: position,
            accept: $c155c373ff42c873$var$acceptOrderByDirection,
            enterNode: $c155c373ff42c873$var$enterNode,
            exitNode: $c155c373ff42c873$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("doe2p", function(module, exports) {
    $parcel$export(module.exports, "orderByField", ()=>$b5422aff91034201$export$942df63e5e3d3899);
    $parcel$export(module.exports, "orderByFieldInternal", ()=>$b5422aff91034201$export$661a7786e3d15926);
    var $g2iOq;
    var $WCvOq;
    function $b5422aff91034201$var$acceptOrderByField(visitor) {
        return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
    }
    function $b5422aff91034201$var$enterNode(listener) {
        listener.enterOrderByField && listener.enterOrderByField(this);
    }
    function $b5422aff91034201$var$exitNode(listener) {
        listener.exitOrderByField && listener.exitOrderByField(this);
    }
    function $b5422aff91034201$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.direction) children.push(this.direction);
        return children;
    }
    const $b5422aff91034201$export$942df63e5e3d3899 = (field, direction)=>$b5422aff91034201$export$661a7786e3d15926(field, direction);
    const $b5422aff91034201$export$661a7786e3d15926 = (field, direction, position = null)=>{
        const node = {
            field: field,
            direction: direction,
            position: position,
            accept: $b5422aff91034201$var$acceptOrderByField,
            enterNode: $b5422aff91034201$var$enterNode,
            exitNode: $b5422aff91034201$var$exitNode,
            getChildren: $b5422aff91034201$var$getChildren,
            parent: null,
            setOrderDirection: (0, parcelRequire("g2iOq")).setOrderDirection,
            replace: (0, parcelRequire("g2iOq")).replace,
            remove: (0, parcelRequire("g2iOq")).remove
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("g2iOq", function(module, exports) {
    $parcel$export(module.exports, "setOrderDirection", ()=>$27f36e283e6ff201$export$b596730931a09703);
    $parcel$export(module.exports, "replace", ()=>$27f36e283e6ff201$export$77ad94ebf1c2b9ed);
    $parcel$export(module.exports, "remove", ()=>$27f36e283e6ff201$export$cd7f480d6b8286c3);
    var $WCvOq;
    function $27f36e283e6ff201$export$b596730931a09703(orderDirection) {
        this.direction = orderDirection;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function $27f36e283e6ff201$export$77ad94ebf1c2b9ed(orderByField) {
        if (this.parent) this.parent.replaceOrderField(this, orderByField);
    }
    function $27f36e283e6ff201$export$cd7f480d6b8286c3() {
        if (this.parent) this.parent.removeOrderField(this);
    }
});
parcelRegister("jRA9z", function(module, exports) {
    $parcel$export(module.exports, "predicate", ()=>$ff1c73953498b7ec$export$5fc51e445ce24faf);
    $parcel$export(module.exports, "predicateInternal", ()=>$ff1c73953498b7ec$export$a767a27ad05a38a2);
    var $WCvOq;
    function $ff1c73953498b7ec$var$acceptPredicate(visitor) {
        return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
    }
    function $ff1c73953498b7ec$var$enterNode(listener) {
        listener.enterPredicate && listener.enterPredicate(this);
    }
    function $ff1c73953498b7ec$var$exitNode(listener) {
        listener.exitPredicate && listener.exitPredicate(this);
    }
    function $ff1c73953498b7ec$var$getChildren() {
        const children = [
            this.operator
        ];
        if (this.operand) children.push(this.operand);
        return children;
    }
    const $ff1c73953498b7ec$export$5fc51e445ce24faf = (operator, operand)=>$ff1c73953498b7ec$export$a767a27ad05a38a2(operator, operand);
    const $ff1c73953498b7ec$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
        const node = {
            operator: operator,
            operand: operand,
            position: position,
            accept: $ff1c73953498b7ec$var$acceptPredicate,
            enterNode: $ff1c73953498b7ec$var$enterNode,
            exitNode: $ff1c73953498b7ec$var$exitNode,
            getChildren: $ff1c73953498b7ec$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("bF1Nb", function(module, exports) {
    $parcel$export(module.exports, "predicateOperator", ()=>$fb65b796ae9eab4e$export$5419b7f16910ea62);
    $parcel$export(module.exports, "predicateOperatorInternal", ()=>$fb65b796ae9eab4e$export$c69d893689716768);
    var $WCvOq;
    function $fb65b796ae9eab4e$var$acceptPredicateOperator(visitor) {
        return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
    }
    function $fb65b796ae9eab4e$var$enterNode(listener) {
        listener.enterPredicateOperator && listener.enterPredicateOperator(this);
    }
    function $fb65b796ae9eab4e$var$exitNode(listener) {
        listener.exitPredicateOperator && listener.exitPredicateOperator(this);
    }
    const $fb65b796ae9eab4e$export$5419b7f16910ea62 = (value)=>$fb65b796ae9eab4e$export$c69d893689716768(value, value);
    const $fb65b796ae9eab4e$export$c69d893689716768 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $fb65b796ae9eab4e$var$acceptPredicateOperator,
            enterNode: $fb65b796ae9eab4e$var$enterNode,
            exitNode: $fb65b796ae9eab4e$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bW5aY", function(module, exports) {
    $parcel$export(module.exports, "property", ()=>$1f1ea1ef09d97bb3$export$d541bacb2bda4494);
    $parcel$export(module.exports, "propertyInternal", ()=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad);
    var $WCvOq;
    function $1f1ea1ef09d97bb3$var$acceptProperty(visitor) {
        return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
    }
    function $1f1ea1ef09d97bb3$var$enterNode(listener) {
        listener.enterProperty && listener.enterProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$exitNode(listener) {
        listener.exitProperty && listener.exitProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$getChildren() {
        const children = [];
        if (this.key) children.push(this.key);
        if (this.path) return children.concat(this.path);
        return children;
    }
    const $1f1ea1ef09d97bb3$export$d541bacb2bda4494 = (key, path = [])=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad(key, path);
    const $1f1ea1ef09d97bb3$export$1cbd90994fef1fad = (key, path, position = null)=>{
        const node = {
            key: key,
            path: path,
            position: position,
            accept: $1f1ea1ef09d97bb3$var$acceptProperty,
            enterNode: $1f1ea1ef09d97bb3$var$enterNode,
            exitNode: $1f1ea1ef09d97bb3$var$exitNode,
            getChildren: $1f1ea1ef09d97bb3$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("dgZwd", function(module, exports) {
    $parcel$export(module.exports, "query", ()=>$3aa450a0eb1b166a$export$2fa187e846a241c4);
    $parcel$export(module.exports, "queryInternal", ()=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014);
    var $aqdKa;
    var $WCvOq;
    function $3aa450a0eb1b166a$var$acceptQuery(visitor) {
        return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
    }
    function $3aa450a0eb1b166a$var$enterNode(listener) {
        listener.enterQuery && listener.enterQuery(this);
    }
    function $3aa450a0eb1b166a$var$exitNode(listener) {
        listener.exitQuery && listener.exitQuery(this);
    }
    function $3aa450a0eb1b166a$var$getChildren() {
        const children = [];
        if (this.where) children.push(this.where);
        if (this.orderBy) children.push(this.orderBy);
        return children;
    }
    const $3aa450a0eb1b166a$export$2fa187e846a241c4 = (where, orderBy)=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014(where, orderBy);
    const $3aa450a0eb1b166a$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$98dda21ec825792),
            where: where,
            orderBy: orderBy,
            position: position,
            accept: $3aa450a0eb1b166a$var$acceptQuery,
            enterNode: $3aa450a0eb1b166a$var$enterNode,
            exitNode: $3aa450a0eb1b166a$var$exitNode,
            getChildren: $3aa450a0eb1b166a$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("aqdKa")).appendClause,
            prependOrderField: (0, parcelRequire("aqdKa")).prependOrderField,
            setOrderDirection: (0, parcelRequire("aqdKa")).setOrderDirection,
            removeClause: (0, parcelRequire("aqdKa")).removeClause,
            replaceClause: (0, parcelRequire("aqdKa")).replaceClause,
            replaceOrderBy: (0, parcelRequire("aqdKa")).replaceOrderBy,
            removeOrderBy: (0, parcelRequire("aqdKa")).removeOrderBy
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("aqdKa", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replaceOrderBy", ()=>replaceOrderBy);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    $parcel$export(module.exports, "removeOrderBy", ()=>removeOrderBy);
    var $iEIQF;
    var $WCvOq;
    function appendClause(clause, compoundOperatorValue) {
        if (!this.where) this.where = clause;
        else {
            const nextCompoundOperator = (0, (0, parcelRequire("iEIQF")).default).compoundOperator(compoundOperatorValue);
            const nextClause = (0, (0, parcelRequire("iEIQF")).default).compoundClause(nextCompoundOperator, []);
            nextClause.appendClause(this.where);
            nextClause.appendClause(clause);
            this.where = nextClause;
        }
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function prependOrderField(orderField) {
        if (!this.orderBy) {
            this.orderBy = (0, (0, parcelRequire("iEIQF")).default).orderBy([
                orderField
            ]);
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        } else this.orderBy.prependOrderField(orderField);
    }
    function setOrderDirection(orderDirection) {
        if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
    }
    function removeClause(clause) {
        if (this.where === clause) this.where = undefined;
    }
    function replaceOrderBy(orderBy) {
        if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
        else {
            this.orderBy = orderBy;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function replaceClause(clause, nextClause) {
        if (this.where === clause) {
            this.where = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function removeOrderBy() {
        this.orderBy = undefined;
    }
});
parcelRegister("1zQFd", function(module, exports) {
    $parcel$export(module.exports, "terminalClause", ()=>$ad22ef70da25a752$export$2627cbe08dd86b00);
    $parcel$export(module.exports, "terminalClauseInternal", ()=>$ad22ef70da25a752$export$cc08e43598d091fc);
    var $b6t5q;
    var $WCvOq;
    function $ad22ef70da25a752$var$acceptTerminalClause(visitor) {
        return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
    }
    function $ad22ef70da25a752$var$enterNode(listener) {
        listener.enterTerminalClause && listener.enterTerminalClause(this);
    }
    function $ad22ef70da25a752$var$exitNode(listener) {
        listener.exitTerminalClause && listener.exitTerminalClause(this);
    }
    function $ad22ef70da25a752$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.operator) children.push(this.operator);
        if (this.operand) children.push(this.operand);
        return children.concat(this.predicates);
    }
    const $ad22ef70da25a752$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
        return $ad22ef70da25a752$export$cc08e43598d091fc(field, operator, operand, predicates);
    };
    const $ad22ef70da25a752$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a),
            field: field,
            operator: operator,
            operand: operand,
            predicates: predicates,
            position: position,
            accept: $ad22ef70da25a752$var$acceptTerminalClause,
            enterNode: $ad22ef70da25a752$var$enterNode,
            exitNode: $ad22ef70da25a752$var$exitNode,
            getChildren: $ad22ef70da25a752$var$getChildren,
            parent: null,
            setOperator: (0, parcelRequire("b6t5q")).setOperator,
            setOperand: (0, parcelRequire("b6t5q")).setOperand,
            appendOperand: (0, parcelRequire("b6t5q")).appendOperand,
            remove: (0, parcelRequire("b6t5q")).remove,
            replace: (0, parcelRequire("b6t5q")).replace
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("b6t5q", function(module, exports) {
    $parcel$export(module.exports, "setOperator", ()=>setOperator);
    $parcel$export(module.exports, "setOperand", ()=>setOperand);
    $parcel$export(module.exports, "appendOperand", ()=>appendOperand);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "replace", ()=>replace);
    var $iEIQF;
    var $WCvOq;
    function setOperator(operator) {
        this.operator = operator;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOperand(operand) {
        this.operand = operand;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function appendOperand(operand) {
        if (this.operand) {
            if (this.operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
            else this.setOperand((0, (0, parcelRequire("iEIQF")).default).listOperand([
                this.operand,
                ...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
                    operand
                ]
            ]));
        } else this.setOperand(operand);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
});
parcelRegister("eWV0u", function(module, exports) {
    $parcel$export(module.exports, "valueOperand", ()=>$f1a80cb053576a13$export$2b6e4d2ed8d53bf3);
    $parcel$export(module.exports, "valueOperandInternal", ()=>$f1a80cb053576a13$export$79c37d97caac8627);
    $parcel$export(module.exports, "valueOperandByText", ()=>$f1a80cb053576a13$export$3ac9155bde56a45f);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $f1a80cb053576a13$var$acceptValueOperand(visitor) {
        return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
    }
    function $f1a80cb053576a13$var$enterNode(listener) {
        listener.enterValueOperand && listener.enterValueOperand(this);
    }
    function $f1a80cb053576a13$var$exitNode(listener) {
        listener.exitValueOperand && listener.exitValueOperand(this);
    }
    const $f1a80cb053576a13$export$2b6e4d2ed8d53bf3 = (value)=>$f1a80cb053576a13$export$79c37d97caac8627(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $f1a80cb053576a13$export$3ac9155bde56a45f = (text)=>$f1a80cb053576a13$export$79c37d97caac8627((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $f1a80cb053576a13$export$79c37d97caac8627 = (value, text, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113),
            text: text,
            value: value,
            position: position,
            accept: $f1a80cb053576a13$var$acceptValueOperand,
            enterNode: $f1a80cb053576a13$var$enterNode,
            exitNode: $f1a80cb053576a13$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("l0V05", function(module, exports) {
    $parcel$export(module.exports, "print", ()=>$2a6ee55a17f6829c$export$c2d084dc44961371);
    var $3NMrl = parcelRequire("3NMrl");
    var $jcm7E;
    var $4gL4M;
    const $2a6ee55a17f6829c$export$c2d084dc44961371 = (jast, options = {})=>{
        return (0, (0, parcelRequire("4gL4M")).printDocToString)((0, (0, parcelRequire("jcm7E")).printAstToDoc)(jast, (0, ($parcel$interopDefault($3NMrl)))(options, [
            'operatorCase'
        ])), (0, ($parcel$interopDefault($3NMrl)))(options, [
            'printWidth'
        ]));
    };
});
parcelRegister("jcm7E", function(module, exports) {
    $parcel$export(module.exports, "printAstToDoc", ()=>$7ac43980ca69512e$export$f0ef38932978952);
    var $bv7J5;
    var $d4xUO;
    const $7ac43980ca69512e$var$formatOperator = (operator, operatorCase)=>{
        switch(operatorCase){
            case 'lower':
                return operator.toLowerCase();
            case 'upper':
                return operator.toUpperCase();
            case 'preserve':
                return operator;
        }
    };
    class $7ac43980ca69512e$export$27a275559a5c8102 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor({ operatorCase: operatorCase } = {}){
            super();
            this.operatorCase = operatorCase || 'preserve';
        }
        visitArgument(argument) {
            return argument.text;
        }
        joinNodes(nodes, separator) {
            const docs = [];
            nodes.forEach((node)=>{
                if (separator !== undefined && docs.length > 0) docs.push(separator);
                docs.push(node.accept(this));
            });
            return docs;
        }
        visitCompoundClause(compoundClause) {
            const operatorDoc = compoundClause.operator.accept(this);
            const clauseDocs = [];
            compoundClause.clauses.forEach((clause)=>{
                if (clauseDocs.length > 0) clauseDocs.push((0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '), operatorDoc, ' ');
                if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
                else clauseDocs.push(clause.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(clauseDocs);
        }
        visitCompoundOperator(compoundOperator) {
            return $7ac43980ca69512e$var$formatOperator(compoundOperator.value, this.operatorCase);
        }
        visitField(field) {
            const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
            return (0, (0, parcelRequire("d4xUO")).group)([
                field.text,
                ...propertyDocs
            ]);
        }
        visitFunction(functionString) {
            return functionString.text;
        }
        visitFunctionOperand(functionOperand) {
            const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                functionOperand.function.accept(this),
                '(',
                ...argumentDocs,
                ')'
            ]);
        }
        visitKeywordOperand(keywordOperand) {
            return keywordOperand.value;
        }
        visitListOperand(listOperand) {
            const operandDocs = this.joinNodes(listOperand.values, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                '(',
                ...operandDocs,
                ')'
            ]);
        }
        visitOperator(operator) {
            return $7ac43980ca69512e$var$formatOperator(operator.text, this.operatorCase);
        }
        visitOrderBy(orderBy) {
            const fieldDocs = this.joinNodes(orderBy.fields, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                orderBy.operator.accept(this),
                ' ',
                ...fieldDocs
            ]);
        }
        visitOrderByDirection(orderByDirection) {
            return orderByDirection.value;
        }
        visitOrderByField(orderByField) {
            const docs = [
                orderByField.field.accept(this)
            ];
            if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitOrderByOperator(orderByOperator) {
            return $7ac43980ca69512e$var$formatOperator(orderByOperator.value, this.operatorCase);
        }
        visitPredicate(predicate) {
            const docs = [
                predicate.operator.accept(this)
            ];
            if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitPredicateOperator(predicateOperator) {
            return $7ac43980ca69512e$var$formatOperator(predicateOperator.text, this.operatorCase);
        }
        visitProperty(property) {
            const docs = [];
            if (property.key) docs.push('[', property.key.accept(this), ']');
            if (property.path) {
                const pathDocs = this.joinNodes(property.path, ' ');
                docs.push(...pathDocs);
            }
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitQuery(query) {
            if (query.where && query.orderBy) return (0, (0, parcelRequire("d4xUO")).group)([
                query.where.accept(this),
                (0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '),
                query.orderBy.accept(this)
            ]);
            else if (query.where) return query.where.accept(this);
            else if (query.orderBy) return query.orderBy.accept(this);
            return '';
        }
        visitTerminalClause(terminalClause) {
            const docs = [
                terminalClause.field.accept(this)
            ];
            if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
            if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
            terminalClause.predicates.forEach((predicate)=>{
                docs.push(' ', predicate.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitValueOperand(valueOperand) {
            return valueOperand.text;
        }
        visitNotClause(notClause) {
            const clauseDocs = [];
            if (notClause.clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
            else clauseDocs.push(notClause.clause.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)([
                notClause.operator.accept(this),
                ' ',
                ...clauseDocs
            ]);
        }
        visitNotClauseOperator(notClauseOperator) {
            return notClauseOperator.value;
        }
        visitChildren() {
            throw new Error('Required visit method not implemented for node');
        }
        defaultResult() {
            return '';
        }
    }
    const $7ac43980ca69512e$export$f0ef38932978952 = (jast, options)=>{
        const astToDocVisitor = new $7ac43980ca69512e$export$27a275559a5c8102(options);
        return jast.query ? jast.query.accept(astToDocVisitor) : '';
    };
});
parcelRegister("bv7J5", function(module, exports) {
    $parcel$export(module.exports, "AbstractJastVisitor", ()=>$564d8ceecff04d6a$export$51be62b46ee668fd);
    class $564d8ceecff04d6a$export$51be62b46ee668fd {
        visit(node) {
            return node.accept(this);
        }
        visitChildren(node) {
            let result = this.defaultResult();
            const children = node.getChildren();
            for(let i = 0; i < children.length; i++){
                if (!this.shouldVisitNextChild(node, result)) break;
                const childResult = children[i].accept(this);
                result = this.aggregateResult(result, childResult);
            }
            return result;
        }
        aggregateResult(aggregate, nextResult) {
            return nextResult;
        }
        shouldVisitNextChild(node, currentResult) {
            return true;
        }
    }
});
parcelRegister("d4xUO", function(module, exports) {
    $parcel$export(module.exports, "group", ()=>$9ef2b92937def9ad$export$e5e25fbcc1f7affe);
    $parcel$export(module.exports, "ifBreak", ()=>$9ef2b92937def9ad$export$1db8e61901dcb0fa);
    $parcel$export(module.exports, "newLine", ()=>$9ef2b92937def9ad$export$dc84f6841f96b7da);
    const $9ef2b92937def9ad$export$e5e25fbcc1f7affe = (contents)=>{
        return {
            type: 'group',
            contents: contents
        };
    };
    const $9ef2b92937def9ad$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
        return {
            type: 'if-break',
            breakContents: breakContents,
            flatContents: flatContents
        };
    };
    const $9ef2b92937def9ad$export$dc84f6841f96b7da = ()=>{
        return {
            type: 'new-line'
        };
    };
});
parcelRegister("4gL4M", function(module, exports) {
    $parcel$export(module.exports, "printDocToString", ()=>$b6450d092f32aba3$export$316fc7e94b95b118);
    const $b6450d092f32aba3$var$computeFlatWidth = (doc)=>{
        if (typeof doc === 'string') return doc.length;
        if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $b6450d092f32aba3$var$computeFlatWidth(innerDoc), 0);
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.contents);
            case 'if-break':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.flatContents);
            case 'new-line':
                return 0;
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printDoc = (doc, context)=>{
        if (typeof doc === 'string') return {
            result: doc,
            endIndex: context.startIndex + doc.length
        };
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$printGroup(doc, context);
            case 'if-break':
                return $b6450d092f32aba3$var$printIfBreak(doc, context);
            case 'new-line':
                return $b6450d092f32aba3$var$printNewLine();
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printGroup = (doc, context)=>{
        const docWidth = context.startIndex + $b6450d092f32aba3$var$computeFlatWidth(doc);
        const breakContents = context.printWidth !== null && docWidth > context.printWidth;
        return doc.contents.reduce((agg, innerDoc)=>{
            const innerContext = {
                ...context,
                startIndex: agg.endIndex,
                breakContents: breakContents
            };
            const output = $b6450d092f32aba3$var$printDoc(innerDoc, innerContext);
            return {
                result: agg.result + output.result,
                endIndex: output.endIndex
            };
        }, {
            result: '',
            endIndex: context.startIndex
        });
    };
    const $b6450d092f32aba3$var$printIfBreak = (doc, context)=>{
        if (context.breakContents) return $b6450d092f32aba3$var$printDoc(doc.breakContents, context);
        return $b6450d092f32aba3$var$printDoc(doc.flatContents, context);
    };
    const $b6450d092f32aba3$var$printNewLine = ()=>{
        return {
            result: '\n',
            endIndex: 0
        };
    };
    const $b6450d092f32aba3$var$defaultPrintWidth = 100;
    const $b6450d092f32aba3$export$316fc7e94b95b118 = (doc, options = {})=>{
        const { printWidth: printWidth = $b6450d092f32aba3$var$defaultPrintWidth } = options;
        const output = $b6450d092f32aba3$var$printDoc(doc, {
            printWidth: printWidth,
            startIndex: 0,
            breakContents: false
        });
        return output.result;
    };
});
parcelRegister("7htvz", function(module, exports) {
    $parcel$export(module.exports, "OPTIMISTIC_ID", ()=>$d5b40c70d7e37442$export$6e40821019289c70);
    $parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$d6ceedee35ae2c19);
    $parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$ca3691ea47eec823);
    $parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$2a5fce320f18ac6c);
    $parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$b0ec8deb6068dc3b);
    $parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$6c99c87a0ac0052a);
    $parcel$export(module.exports, "EMPTY_FILTER_VALUE", ()=>$d5b40c70d7e37442$export$9ebaf9fe814731d3);
    $parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", ()=>$d5b40c70d7e37442$export$9b72011e2eb8d7d0);
    const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
    const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
    const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
        experience: 'filtersCreateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
        experience: 'filtersUpdateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
        experience: 'filtersDeleteSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
        experience: 'filtersStarSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
        experience: 'filtersLoadSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
    const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';
});
parcelRegister("1T1ir", function(module, exports) {
    $parcel$export(module.exports, "useSimpleSearch", ()=>$9ff55c3a873f98f5$export$b549f44e7ca96280);
    $parcel$export(module.exports, "useSimpleSearchHighlight", ()=>$9ff55c3a873f98f5$export$fd04dfca01137d2);
    $parcel$export(module.exports, "useSearchText", ()=>$9ff55c3a873f98f5$export$119186efd4186c93);
    $parcel$export(module.exports, "useSimpleSearchJQL", ()=>$9ff55c3a873f98f5$export$42b8d8a5ec5bc873);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XS00;
    var $ieDtd;
    var $7htvz;
    const $9ff55c3a873f98f5$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const $9ff55c3a873f98f5$var$issueKeyRegex = new RegExp(`^${(0, (0, parcelRequire("9XS00")).ISSUEKEY_REGEX)}$`);
    const $9ff55c3a873f98f5$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    const $9ff55c3a873f98f5$export$b549f44e7ca96280 = ()=>{
        const [simpleSearch, persistSimpleSearch] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("7htvz")).SIMPLE_SEARCH_PARAM));
        const setSimpleSearch = (0, $5uXOq.useCallback)((searchText)=>{
            searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
        }, [
            persistSimpleSearch
        ]);
        return [
            simpleSearch ?? '',
            setSimpleSearch
        ];
    };
    const $9ff55c3a873f98f5$export$72839f749ccf76b2 = (text)=>{
        if (text == null) return [];
        return text.split(' ').filter((word)=>word !== '');
    };
    const $9ff55c3a873f98f5$export$fd04dfca01137d2 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        return (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(simpleSearch), [
            simpleSearch
        ]);
    };
    const $9ff55c3a873f98f5$export$abb78553baf1cfac = (text)=>{
        if (text == null || text.trim() === '') return '';
        let search = $9ff55c3a873f98f5$var$sanitize(text);
        if ($9ff55c3a873f98f5$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
        if (!$9ff55c3a873f98f5$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
        return `(summary ~ '${search}' OR description ~ '${search}')`;
    };
    const $9ff55c3a873f98f5$export$119186efd4186c93 = (text)=>{
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(text), [
            text
        ]);
        const highlight = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(text), [
            text
        ]);
        return {
            jql: jql,
            highlight: highlight
        };
    };
    const $9ff55c3a873f98f5$export$42b8d8a5ec5bc873 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(simpleSearch), [
            simpleSearch
        ]);
        const addSimpleSearchToJQL = (0, $5uXOq.useCallback)((currentJQL)=>{
            if (jql === '') return currentJQL;
            if (currentJQL == null) return jql;
            return `${currentJQL} AND ${jql}`;
        }, [
            jql
        ]);
        return {
            jql: jql,
            isSearching: jql !== '',
            addSimpleSearchToJQL: addSimpleSearchToJQL
        };
    };
    var $9ff55c3a873f98f5$export$2e2bcd8739ae039 = $9ff55c3a873f98f5$export$b549f44e7ca96280;
});
parcelRegister("9XS00", function(module, exports) {
    $parcel$export(module.exports, "ISSUEKEY_REGEX", ()=>$76f8b51a225e9798$export$b52c9cee589449a8);
    $parcel$export(module.exports, "default", ()=>$76f8b51a225e9798$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
    var $76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, {});
        const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
        const isMatchingHost = parsedUrl.host === host;
        const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
        const issueKey = matches && matches.length > 1 ? matches[1] : null;
        return isMatchingProtocol && isMatchingHost && issueKey || null;
    };
});
parcelRegister("7VpiX", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJql", ()=>$e5742a6c935cce4a$export$78c9a06ab18996fc);
    $parcel$export(module.exports, "getJqlErrors", ()=>$e5742a6c935cce4a$export$cc387523b0acb16d);
    var $eK6AG;
    var $l0V05;
    const $e5742a6c935cce4a$export$78c9a06ab18996fc = (jql)=>{
        if (!jql) return jql;
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
        return (0, (0, parcelRequire("l0V05")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $e5742a6c935cce4a$export$cc387523b0acb16d = (jql)=>{
        if (!jql) return [];
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        return jast.errors;
    };
});
parcelRegister("eK6AG", function(module, exports) {
    $parcel$export(module.exports, "JastBuilder", ()=>$ccc4ef92204502d2$export$99cae18a5a6ba8cf);
    var $hCaMj = parcelRequire("hCaMj");
    var $8QpSo;
    var $39War;
    var $k9No4;
    var $iEIQF;
    var $lKjSa;
    var $k9iwN;
    var $bK3p2;
    class $ccc4ef92204502d2$export$99cae18a5a6ba8cf {
        setErrorHandler(errorHandler) {
            this.errorHandler = errorHandler;
            return this;
        }
        setErrorListeners(errorListeners) {
            this.errorListeners = this.errorListeners.concat(errorListeners);
            return this;
        }
        build(value) {
            const tokens = this.getTokens(value);
            const parser = this.getParser(tokens);
            const astErrorListener = new (0, (0, parcelRequire("lKjSa")).JastBuilderErrorListener)();
            parser.removeErrorListeners();
            parser.addErrorListener(astErrorListener);
            this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
            if (this.errorHandler) {
                parser.errorHandler = this.errorHandler;
                this.errorHandler.reset(parser);
            }
            const visitor = new (0, (0, parcelRequire("bK3p2")).QueryVisitor)(tokens);
            try {
                const parseTree = parser.jqlQuery();
                const query = parseTree.accept(visitor);
                return (0, (0, parcelRequire("iEIQF")).default).jast(query, value, astErrorListener.errors);
            } catch (error) {
                return (0, (0, parcelRequire("iEIQF")).default).jast(undefined, value, [
                    new (0, (0, parcelRequire("k9iwN")).JQLParseError)(error.message, error)
                ]);
            }
        }
        constructor(){
            this.errorListeners = [];
            this.errorHandler = undefined;
            this.getTokens = (0, (0, parcelRequire("8QpSo")).default)((value)=>{
                const chars = (0, $hCaMj.CharStreams).fromString(value);
                const lexer = new (0, (0, parcelRequire("39War")).JQLLexer)(chars);
                return new (0, $hCaMj.CommonTokenStream)(lexer);
            });
            this.getParser = (0, (0, parcelRequire("8QpSo")).default)((tokens)=>new (0, (0, parcelRequire("k9No4")).JQLParser)(tokens));
        }
    }
});
parcelRegister("hCaMj", function(module, exports) {
    "use strict";
    var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
            enumerable: true,
            get: function() {
                return m[k];
            }
        });
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);
});
parcelRegister("fJ9SA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("1lYFk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("g8XSE", function(module, exports) {
    "use strict";
    var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ANTLRInputStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $d6D31 = parcelRequire("d6D31");
    var $ceaEj = parcelRequire("ceaEj");
    const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
    const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
    class $bc0bd7b6659a2632$var$ANTLRInputStream {
        constructor(input){
            this.p = 0;
            this.data = input;
            this.n = input.length;
        }
        reset() {
            this.p = 0;
        }
        consume() {
            if (this.p >= this.n) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new Error("cannot consume EOF");
            }
            if (this.p < this.n) this.p++;
        }
        LA(i) {
            if (i === 0) return 0;
            if (i < 0) {
                i++;
                if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF;
            }
            if (this.p + i - 1 >= this.n) return $ceaEj.IntStream.EOF;
            return this.data.charCodeAt(this.p + i - 1);
        }
        LT(i) {
            return this.LA(i);
        }
        get index() {
            return this.p;
        }
        get size() {
            return this.n;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            if (index <= this.p) {
                this.p = index;
                return;
            }
            index = Math.min(index, this.n);
            while(this.p < index)this.consume();
        }
        getText(interval) {
            let start = interval.a;
            let stop = interval.b;
            if (stop >= this.n) stop = this.n - 1;
            let count = stop - start + 1;
            if (start >= this.n) return "";
            return this.data.substr(start, count);
        }
        get sourceName() {
            if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return this.name;
        }
        toString() {
            return this.data;
        }
    }
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
    module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;
});
parcelRegister("bbHFU", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $825299b5d0c0a9a5$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $825299b5d0c0a9a5$var$_typeof(o);
    }
    function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
        var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
        return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
        if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $8JAro = parcelRequire("8JAro");
    var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;
    var $3ZLjA = parcelRequire("3ZLjA");
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
    var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;
    var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();
    var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();
    var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
    var $825299b5d0c0a9a5$var$errorCache = new Map();
    var $825299b5d0c0a9a5$var$isDeepEqual;
    var $825299b5d0c0a9a5$var$isDeepStrictEqual;
    var $825299b5d0c0a9a5$var$parseExpressionAt;
    var $825299b5d0c0a9a5$var$findNodeAround;
    var $825299b5d0c0a9a5$var$decoder;
    function $825299b5d0c0a9a5$var$lazyLoadComparison() {
        var comparison = (parcelRequire("dztjv"));
        $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
        $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
    }
    var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
    var $825299b5d0c0a9a5$var$meta = [
        "\\u0000",
        "\\u0001",
        "\\u0002",
        "\\u0003",
        "\\u0004",
        "\\u0005",
        "\\u0006",
        "\\u0007",
        '\\b',
        '',
        '',
        "\\u000b",
        '\\f',
        '',
        "\\u000e",
        "\\u000f",
        "\\u0010",
        "\\u0011",
        "\\u0012",
        "\\u0013",
        "\\u0014",
        "\\u0015",
        "\\u0016",
        "\\u0017",
        "\\u0018",
        "\\u0019",
        "\\u001a",
        "\\u001b",
        "\\u001c",
        "\\u001d",
        "\\u001e",
        "\\u001f"
    ];
    var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
        return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
    };
    var $825299b5d0c0a9a5$var$warned = false;
    var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
    var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
    function $825299b5d0c0a9a5$var$innerFail(obj) {
        if (obj.message instanceof Error) throw obj.message;
        throw new $3ZLjA(obj);
    }
    function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
        var argsLen = arguments.length;
        var internalMessage;
        if (argsLen === 0) internalMessage = 'Failed';
        else if (argsLen === 1) {
            message = actual;
            actual = undefined;
        } else {
            if ($825299b5d0c0a9a5$var$warned === false) {
                $825299b5d0c0a9a5$var$warned = true;
                var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
                warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
            }
            if (argsLen === 2) operator = '!=';
        }
        if (message instanceof Error) throw message;
        var errArgs = {
            actual: actual,
            expected: expected,
            operator: operator === undefined ? 'fail' : operator,
            stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
        };
        if (message !== undefined) errArgs.message = message;
        var err = new $3ZLjA(errArgs);
        if (internalMessage) {
            err.message = internalMessage;
            err.generatedMessage = true;
        }
        throw err;
    }
    $825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
    $825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
    function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
        if (!value) {
            var generatedMessage = false;
            if (argLen === 0) {
                generatedMessage = true;
                message = 'No value argument passed to `assert.ok()`';
            } else if (message instanceof Error) throw message;
            var err = new $3ZLjA({
                actual: value,
                expected: true,
                message: message,
                operator: '==',
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    function $825299b5d0c0a9a5$var$ok() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$ok,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
    $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '==',
            stackStartFn: equal
        });
    };
    $825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '!=',
            stackStartFn: notEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepEqual',
            stackStartFn: deepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepEqual',
            stackStartFn: notDeepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepStrictEqual',
            stackStartFn: deepStrictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
    function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepStrictEqual',
            stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
        });
    }
    $825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'strictEqual',
            stackStartFn: strictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notStrictEqual',
            stackStartFn: notStrictEqual
        });
    };
    var $825299b5d0c0a9a5$var$Comparison = $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
        var _this = this;
        $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
        keys.forEach(function(key) {
            if (key in obj) {
                if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                else _this[key] = obj[key];
            }
        });
    });
    function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
        if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
            if (!message) {
                var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
                var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
                var err = new $3ZLjA({
                    actual: a,
                    expected: b,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.actual = actual;
                err.expected = expected;
                err.operator = fn.name;
                throw err;
            }
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: fn.name,
                stackStartFn: fn
            });
        }
    }
    function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
        if (typeof expected !== 'function') {
            if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
            if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
                'Function',
                'RegExp'
            ], expected);
            if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
                var err = new $3ZLjA({
                    actual: actual,
                    expected: expected,
                    message: msg,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.operator = fn.name;
                throw err;
            }
            var keys = Object.keys(expected);
            if (expected instanceof Error) keys.push('name', 'message');
            else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
            if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
            keys.forEach(function(key) {
                if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
                $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
            });
            return true;
        }
        if (expected.prototype !== undefined && actual instanceof expected) return true;
        if (Error.isPrototypeOf(expected)) return false;
        return expected.call({}, actual) === true;
    }
    function $825299b5d0c0a9a5$var$getActual(fn) {
        if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
        try {
            fn();
        } catch (e) {
            return e;
        }
        return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
    }
    function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
        return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
    }
    function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
        return Promise.resolve().then(function() {
            var resultPromise;
            if (typeof promiseFn === 'function') {
                resultPromise = promiseFn();
                if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
            } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
            else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
                'Function',
                'Promise'
            ], promiseFn);
            return Promise.resolve().then(function() {
                return resultPromise;
            }).then(function() {
                return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
            }).catch(function(e) {
                return e;
            });
        });
    }
    function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
        if (typeof error === 'string') {
            if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
                'Object',
                'Error',
                'Function',
                'RegExp'
            ], error);
            if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
                if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
            } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
            message = error;
            error = undefined;
        } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
            var details = '';
            if (error && error.name) details += " (".concat(error.name, ")");
            details += message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: undefined,
                expected: error,
                operator: stackStartFn.name,
                message: "Missing expected ".concat(fnType).concat(details),
                stackStartFn: stackStartFn
            });
        }
        if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
    }
    function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
        if (typeof error === 'string') {
            message = error;
            error = undefined;
        }
        if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
            var details = message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: error,
                operator: stackStartFn.name,
                message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
                stackStartFn: stackStartFn
            });
        }
        throw actual;
    }
    $825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            throws,
            $825299b5d0c0a9a5$var$getActual(promiseFn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
                rejects,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotThrow,
            $825299b5d0c0a9a5$var$getActual(fn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
        return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
                doesNotReject,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
        if (err !== null && err !== undefined) {
            var message = 'ifError got unwanted exception: ';
            if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
                if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                else message += err.message;
            } else message += $825299b5d0c0a9a5$var$inspect(err);
            var newErr = new $3ZLjA({
                actual: err,
                expected: null,
                operator: 'ifError',
                message: message,
                stackStartFn: ifError
            });
            var origStack = err.stack;
            if (typeof origStack === 'string') {
                var tmp2 = origStack.split('\n');
                tmp2.shift();
                var tmp1 = newErr.stack.split('\n');
                for(var i = 0; i < tmp2.length; i++){
                    var pos = tmp1.indexOf(tmp2[i]);
                    if (pos !== -1) {
                        tmp1 = tmp1.slice(0, pos);
                        break;
                    }
                }
                newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
            }
            throw newErr;
        }
    };
    function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
        if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
        var match = fnName === 'match';
        if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
            if (message instanceof Error) throw message;
            var generatedMessage = !message;
            message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
            var err = new $3ZLjA({
                actual: string,
                expected: regexp,
                message: message,
                operator: fnName,
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    $825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
    };
    $825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
    };
    function $825299b5d0c0a9a5$var$strict() {
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$strict,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
        equal: $825299b5d0c0a9a5$var$assert.strictEqual,
        deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
        notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
        notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
    });
    $825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;
});
parcelRegister("8JAro", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$65becb1820e5a079$export$e45cb6485273080e, (v)=>$65becb1820e5a079$export$e45cb6485273080e = v);
    var $65becb1820e5a079$export$e45cb6485273080e;
    'use strict';
    function $65becb1820e5a079$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $65becb1820e5a079$var$_typeof(o);
    }
    function $65becb1820e5a079$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $65becb1820e5a079$var$_toPropertyKey(arg) {
        var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
        return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $65becb1820e5a079$var$_toPrimitive(input, hint) {
        if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $65becb1820e5a079$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
    }
    function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
        $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $65becb1820e5a079$var$_setPrototypeOf(o, p);
    }
    function $65becb1820e5a079$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
        };
    }
    function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
        if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $65becb1820e5a079$var$_assertThisInitialized(self);
    }
    function $65becb1820e5a079$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $65becb1820e5a079$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $65becb1820e5a079$var$_getPrototypeOf(o) {
        $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $65becb1820e5a079$var$_getPrototypeOf(o);
    }
    var $65becb1820e5a079$var$codes = {};
    var $65becb1820e5a079$var$assert;
    var $65becb1820e5a079$var$util;
    function $65becb1820e5a079$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $65becb1820e5a079$var$_inherits(NodeError, _Base);
            var _super = $65becb1820e5a079$var$_createSuper(NodeError);
            function NodeError(arg1, arg2, arg3) {
                var _this;
                $65becb1820e5a079$var$_classCallCheck(this, NodeError);
                _this = _super.call(this, getMessage(arg1, arg2, arg3));
                _this.code = code;
                return _this;
            }
            return $65becb1820e5a079$var$_createClass(NodeError);
        }(Base);
        $65becb1820e5a079$var$codes[code] = NodeError;
    }
    function $65becb1820e5a079$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $65becb1820e5a079$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $65becb1820e5a079$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $65becb1820e5a079$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
        var determiner;
        if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($65becb1820e5a079$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        else {
            var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
        return msg;
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
        var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
        if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
        var inspected = $65becb1820e5a079$var$util.inspect(value);
        if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
        return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
    }, TypeError, RangeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
        var type;
        if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
        else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
        return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
        var msg = 'The ';
        var len = args.length;
        args = args.map(function(a) {
            return "\"".concat(a, "\"");
        });
        switch(len){
            case 1:
                msg += "".concat(args[0], " argument");
                break;
            case 2:
                msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                break;
            default:
                msg += args.slice(0, len - 1).join(', ');
                msg += ", and ".concat(args[len - 1], " arguments");
                break;
        }
        return "".concat(msg, " must be specified");
    }, TypeError);
    $65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;
});
parcelRegister("9kAQu", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
    module.exports.format = function(f) {
        if (!$6cb29018fbdc8fcc$var$isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
            return objects.join(' ');
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
        else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
        return str;
    };
    module.exports.deprecate = function(fn, msg) {
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
        if (typeof $6cAn5 === 'undefined') return function() {
            return module.exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($6cAn5.throwDeprecation) throw new Error(msg);
                else if ($6cAn5.traceDeprecation) console.trace(msg);
                else console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var $6cb29018fbdc8fcc$var$debugs = {};
    var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
    var $6cb29018fbdc8fcc$var$debugEnv;
    module.exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!$6cb29018fbdc8fcc$var$debugs[set]) {
            if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
                var pid = $6cAn5.pid;
                $6cb29018fbdc8fcc$var$debugs[set] = function() {
                    var msg = module.exports.format.apply(module.exports, arguments);
                    console.error('%s %d: %s', set, pid, msg);
                };
            } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
        }
        return $6cb29018fbdc8fcc$var$debugs[set];
    };
    function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
        var ctx = {
            seen: [],
            stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
        };
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if ($6cb29018fbdc8fcc$var$isBoolean(opts)) ctx.showHidden = opts;
        else if (opts) module.exports._extend(ctx, opts);
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
        return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
    }
    module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
    $6cb29018fbdc8fcc$var$inspect.colors = {
        'bold': [
            1,
            22
        ],
        'italic': [
            3,
            23
        ],
        'underline': [
            4,
            24
        ],
        'inverse': [
            7,
            27
        ],
        'white': [
            37,
            39
        ],
        'grey': [
            90,
            39
        ],
        'black': [
            30,
            39
        ],
        'blue': [
            34,
            39
        ],
        'cyan': [
            36,
            39
        ],
        'green': [
            32,
            39
        ],
        'magenta': [
            35,
            39
        ],
        'red': [
            31,
            39
        ],
        'yellow': [
            33,
            39
        ]
    };
    $6cb29018fbdc8fcc$var$inspect.styles = {
        'special': 'cyan',
        'number': 'yellow',
        'boolean': 'yellow',
        'undefined': 'grey',
        'null': 'bold',
        'string': 'green',
        'date': 'magenta',
        'regexp': 'red'
    };
    function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
        var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
        if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
        else return str;
    }
    function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
        return str;
    }
    function $6cb29018fbdc8fcc$var$arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && value.inspect !== module.exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
        if (primitive) return primitive;
        var keys = Object.keys(value);
        var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0) {
            if ($6cb29018fbdc8fcc$var$isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
            }
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
            if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
        }
        var base = '', array = false, braces = [
            '{',
            '}'
        ];
        if ($6cb29018fbdc8fcc$var$isArray(value)) {
            array = true;
            braces = [
                '[',
                ']'
            ];
        }
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var n = value.name ? ': ' + value.name : '';
            base = ' [Function' + n + ']';
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
        if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
        if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            else return ctx.stylize('[Object]', 'special');
        }
        ctx.seen.push(value);
        var output;
        if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
    }
    function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
        if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
        if ($6cb29018fbdc8fcc$var$isString(value)) {
            var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
            return ctx.stylize(simple, 'string');
        }
        if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
        if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
        if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
    }
    function $6cb29018fbdc8fcc$var$formatError(value) {
        return '[' + Error.prototype.toString.call(value) + ']';
    }
    function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push('');
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
            else str = ctx.stylize('[Getter]', 'special');
        } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
        if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
                else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf('\n') > -1) {
                    if (array) str = str.split('\n').map(function(line) {
                        return '  ' + line;
                    }).join('\n').slice(2);
                    else str = '\n' + str.split('\n').map(function(line) {
                        return '   ' + line;
                    }).join('\n');
                }
            } else str = ctx.stylize('[Circular]', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify('' + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.slice(1, -1);
                name = ctx.stylize(name, 'name');
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
            }
        }
        return name + ': ' + str;
    }
    function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
            numLinesEst++;
            if (cur.indexOf('\n') >= 0) numLinesEst++;
            return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
        return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }
    module.exports.types = (parcelRequire("jGyMi"));
    function $6cb29018fbdc8fcc$var$isArray(ar) {
        return Array.isArray(ar);
    }
    module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
    function $6cb29018fbdc8fcc$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
    function $6cb29018fbdc8fcc$var$isNull(arg) {
        return arg === null;
    }
    module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
    function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
    function $6cb29018fbdc8fcc$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
    function $6cb29018fbdc8fcc$var$isString(arg) {
        return typeof arg === 'string';
    }
    module.exports.isString = $6cb29018fbdc8fcc$var$isString;
    function $6cb29018fbdc8fcc$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
    function $6cb29018fbdc8fcc$var$isUndefined(arg) {
        return arg === void 0;
    }
    module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
    function $6cb29018fbdc8fcc$var$isRegExp(re) {
        return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
    }
    module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    function $6cb29018fbdc8fcc$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
    function $6cb29018fbdc8fcc$var$isDate(d) {
        return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
    }
    module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
    module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
    function $6cb29018fbdc8fcc$var$isError(e) {
        return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
    }
    module.exports.isError = $6cb29018fbdc8fcc$var$isError;
    module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
    function $6cb29018fbdc8fcc$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
    function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;
    module.exports.isBuffer = (parcelRequire("kEU0N"));
    function $6cb29018fbdc8fcc$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function $6cb29018fbdc8fcc$var$pad(n) {
        return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }
    var $6cb29018fbdc8fcc$var$months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    function $6cb29018fbdc8fcc$var$timestamp() {
        var d = new Date();
        var time = [
            $6cb29018fbdc8fcc$var$pad(d.getHours()),
            $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
            $6cb29018fbdc8fcc$var$pad(d.getSeconds())
        ].join(':');
        return [
            d.getDate(),
            $6cb29018fbdc8fcc$var$months[d.getMonth()],
            time
        ].join(' ');
    }
    module.exports.log = function() {
        console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
    };
    module.exports.inherits = (parcelRequire("v3bBu"));
    module.exports._extend = function(origin, add) {
        if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
    module.exports.promisify = function promisify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
            var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
            if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    };
    module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
    function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
        if (!reason) {
            var newReason = new Error('Promise was rejected with a falsy value');
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function $6cb29018fbdc8fcc$var$callbackify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
            var self = this;
            var cb = function() {
                return maybeCb.apply(self, arguments);
            };
            original.apply(this, args).then(function(ret) {
                $6cAn5.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
        return callbackified;
    }
    module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;
});
parcelRegister("jGyMi", function(module, exports) {
    'use strict';
    var $eyPxb = parcelRequire("eyPxb");
    var $kF7vh = parcelRequire("kF7vh");
    var $hdl59;
    var $dFTgY;
    function $e54ceaba9c647d57$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
    var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
    var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
    var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
    var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
    var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
    if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
    if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
    function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== 'object') return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    module.exports.isArgumentsObject = $eyPxb;
    module.exports.isGeneratorFunction = $kF7vh;
    module.exports.isTypedArray = (0, parcelRequire("dFTgY"));
    function $e54ceaba9c647d57$var$isPromise(input) {
        return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
    }
    module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
    function $e54ceaba9c647d57$var$isArrayBufferView(value) {
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return (0, parcelRequire("dFTgY"))(value) || $e54ceaba9c647d57$var$isDataView(value);
    }
    module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
    function $e54ceaba9c647d57$var$isUint8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8Array';
    }
    module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
    function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8ClampedArray';
    }
    module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
    function $e54ceaba9c647d57$var$isUint16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint16Array';
    }
    module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
    function $e54ceaba9c647d57$var$isUint32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint32Array';
    }
    module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
    function $e54ceaba9c647d57$var$isInt8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int8Array';
    }
    module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
    function $e54ceaba9c647d57$var$isInt16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int16Array';
    }
    module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
    function $e54ceaba9c647d57$var$isInt32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int32Array';
    }
    module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
    function $e54ceaba9c647d57$var$isFloat32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float32Array';
    }
    module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
    function $e54ceaba9c647d57$var$isFloat64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float64Array';
    }
    module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
    function $e54ceaba9c647d57$var$isBigInt64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigInt64Array';
    }
    module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
    function $e54ceaba9c647d57$var$isBigUint64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigUint64Array';
    }
    module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
    function $e54ceaba9c647d57$var$isMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
    }
    $e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
    function $e54ceaba9c647d57$var$isMap(value) {
        if (typeof Map === 'undefined') return false;
        return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
    }
    module.exports.isMap = $e54ceaba9c647d57$var$isMap;
    function $e54ceaba9c647d57$var$isSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
    }
    $e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
    function $e54ceaba9c647d57$var$isSet(value) {
        if (typeof Set === 'undefined') return false;
        return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
    }
    module.exports.isSet = $e54ceaba9c647d57$var$isSet;
    function $e54ceaba9c647d57$var$isWeakMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
    }
    $e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
    function $e54ceaba9c647d57$var$isWeakMap(value) {
        if (typeof WeakMap === 'undefined') return false;
        return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
    }
    module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
    function $e54ceaba9c647d57$var$isWeakSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
    }
    $e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
    function $e54ceaba9c647d57$var$isWeakSet(value) {
        return $e54ceaba9c647d57$var$isWeakSetToString(value);
    }
    module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
    function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
    }
    $e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
    function $e54ceaba9c647d57$var$isArrayBuffer(value) {
        if (typeof ArrayBuffer === 'undefined') return false;
        return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
    function $e54ceaba9c647d57$var$isDataViewToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
    }
    $e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function $e54ceaba9c647d57$var$isDataView(value) {
        if (typeof DataView === 'undefined') return false;
        return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
    }
    module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
    var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
    function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
    }
    function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
        if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
        if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
        return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
    }
    module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
    function $e54ceaba9c647d57$var$isAsyncFunction(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
    }
    module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
    function $e54ceaba9c647d57$var$isMapIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
    }
    module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
    function $e54ceaba9c647d57$var$isSetIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
    }
    module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
    function $e54ceaba9c647d57$var$isGeneratorObject(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
    }
    module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
    function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
    }
    module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
    function $e54ceaba9c647d57$var$isNumberObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
    }
    module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
    function $e54ceaba9c647d57$var$isStringObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
    }
    module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
    function $e54ceaba9c647d57$var$isBooleanObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
    }
    module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
    function $e54ceaba9c647d57$var$isBigIntObject(value) {
        return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
    }
    module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
    function $e54ceaba9c647d57$var$isSymbolObject(value) {
        return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
    }
    module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
    function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
        return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
    }
    module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
    function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
        return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
    }
    module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
    [
        'isProxy',
        'isExternal',
        'isModuleNamespaceObject'
    ].forEach(function(method) {
        Object.defineProperty(module.exports, method, {
            enumerable: false,
            value: function() {
                throw new Error(method + ' is not supported in userland');
            }
        });
    });
});
parcelRegister("eyPxb", function(module, exports) {
    'use strict';
    var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $53KqO = parcelRequire("53KqO");
    var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
    var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
        return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
    };
    var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
        return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
    };
    var $a99c3747cd09063d$var$supportsStandardArguments = function() {
        return $a99c3747cd09063d$var$isStandardArguments(arguments);
    }();
    $a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments;
    module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;
});
parcelRegister("fmBzB", function(module, exports) {
    'use strict';
    var $9T9x9 = parcelRequire("9T9x9");
    module.exports = function hasToStringTagShams() {
        return $9T9x9() && !!Symbol.toStringTag;
    };
});
parcelRegister("kF7vh", function(module, exports) {
    'use strict';
    var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
    var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
    var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;
    var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
    var $f0ad750370f41c64$var$getGeneratorFunc = function() {
        if (!$f0ad750370f41c64$var$hasToStringTag) return false;
        try {
            return Function('return function*() {}')();
        } catch (e) {}
    };
    var $f0ad750370f41c64$var$GeneratorFunction;
    module.exports = function isGeneratorFunction(fn) {
        if (typeof fn !== 'function') return false;
        if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
        if (!$f0ad750370f41c64$var$hasToStringTag) {
            var str = $f0ad750370f41c64$var$toStr.call(fn);
            return str === '[object GeneratorFunction]';
        }
        if (!$f0ad750370f41c64$var$getProto) return false;
        if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
            var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
            $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
        }
        return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
    };
});
parcelRegister("hdl59", function(module, exports) {
    'use strict';
    var $258uT = parcelRequire("258uT");
    var $9ME5O;
    var $h05ZS = parcelRequire("h05ZS");
    var $53KqO = parcelRequire("53KqO");
    var $lBvcQ;
    var $c884010d01443113$var$$toString = $53KqO('Object.prototype.toString');
    var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    var $c884010d01443113$var$typedArrays = (0, parcelRequire("9ME5O"))();
    var $c884010d01443113$var$$slice = $53KqO('String.prototype.slice');
    var $c884010d01443113$var$getPrototypeOf = Object.getPrototypeOf;
    var $c884010d01443113$var$$indexOf = $53KqO('Array.prototype.indexOf', true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var $c884010d01443113$var$cache = {
        __proto__: null
    };
    if ($c884010d01443113$var$hasToStringTag && (0, parcelRequire("lBvcQ")) && $c884010d01443113$var$getPrototypeOf) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $c884010d01443113$var$getPrototypeOf(arr);
            var descriptor = (0, parcelRequire("lBvcQ"))(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $c884010d01443113$var$getPrototypeOf(proto);
                descriptor = (0, parcelRequire("lBvcQ"))(superProto, Symbol.toStringTag);
            }
            $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
        }
    });
    else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(fn);
    });
    var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, typedArray) {
            if (!found) try {
                if ('$' + getter(value) === typedArray) found = $c884010d01443113$var$$slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, name) {
            if (!found) try {
                getter(value);
                found = $c884010d01443113$var$$slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    module.exports = function whichTypedArray(value) {
        if (!value || typeof value !== 'object') return false;
        if (!$c884010d01443113$var$hasToStringTag) {
            var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
            if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
            if (tag !== 'Object') return false;
            return $c884010d01443113$var$trySlices(value);
        }
        if (!(0, parcelRequire("lBvcQ"))) return null;
        return $c884010d01443113$var$tryTypedArrays(value);
    };
});
parcelRegister("258uT", function(module, exports) {
    'use strict';
    var $f0Tdg = parcelRequire("f0Tdg");
    var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
    var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
        for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var $1842a3cb7df292b5$var$forEach = function forEach(list, iterator, thisArg) {
        if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if ($1842a3cb7df292b5$var$toStr.call(list) === '[object Array]') $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
        else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
        else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
    };
    module.exports = $1842a3cb7df292b5$var$forEach;
});
parcelRegister("f0Tdg", function(module, exports) {
    'use strict';
    var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
    var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
    var $02d21778b0eebae4$var$badArrayLike;
    var $02d21778b0eebae4$var$isCallableMarker;
    if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
        $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
            get: function() {
                throw $02d21778b0eebae4$var$isCallableMarker;
            }
        });
        $02d21778b0eebae4$var$isCallableMarker = {};
        $02d21778b0eebae4$var$reflectApply(function() {
            throw 42;
        }, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (_) {
        if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
    }
    else $02d21778b0eebae4$var$reflectApply = null;
    var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
    var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
            return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
            $02d21778b0eebae4$var$fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
    var $02d21778b0eebae4$var$objectClass = '[object Object]';
    var $02d21778b0eebae4$var$fnClass = '[object Function]';
    var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
    var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]';
    var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
    var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]';
    var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;
    var $02d21778b0eebae4$var$isIE68 = !(0 in [
        , 
    ]);
    var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === 'object') {
        var $02d21778b0eebae4$var$all = document.all;
        if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
            if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
                var str = $02d21778b0eebae4$var$toStr.call(value);
                return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 || str === $02d21778b0eebae4$var$objectClass) && value('') == null;
            } catch (e) {}
            return false;
        };
    }
    module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        try {
            $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
        } catch (e) {
            if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
        }
        return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
    } : function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        var strClass = $02d21778b0eebae4$var$toStr.call(value);
        if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
        return $02d21778b0eebae4$var$tryFunctionObject(value);
    };
});
parcelRegister("9ME5O", function(module, exports) {
    'use strict';
    var $8a51N;
    var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    module.exports = function availableTypedArrays() {
        var out = [];
        for(var i = 0; i < (0, parcelRequire("8a51N")).length; i++)if (typeof $71f7b254c38edcde$var$g[(0, parcelRequire("8a51N"))[i]] === 'function') out[out.length] = (0, parcelRequire("8a51N"))[i];
        return out;
    };
});
parcelRegister("8a51N", function(module, exports) {
    'use strict';
    module.exports = [
        'Float32Array',
        'Float64Array',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'BigInt64Array',
        'BigUint64Array'
    ];
});
parcelRegister("dFTgY", function(module, exports) {
    'use strict';
    var $hdl59;
    module.exports = function isTypedArray(value) {
        return !!(0, parcelRequire("hdl59"))(value);
    };
});
parcelRegister("kEU0N", function(module, exports) {
    module.exports = function isBuffer(arg) {
        return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("3ZLjA", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $2e8bc5606025d797$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $2e8bc5606025d797$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
                $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
        key = $2e8bc5606025d797$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $2e8bc5606025d797$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $2e8bc5606025d797$var$_toPropertyKey(arg) {
        var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
        return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
        if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
    }
    function $2e8bc5606025d797$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
        };
    }
    function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
        if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $2e8bc5606025d797$var$_assertThisInitialized(self);
    }
    function $2e8bc5606025d797$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
        };
        return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
    }
    function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
        if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
        else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return $2e8bc5606025d797$var$_construct.apply(null, arguments);
    }
    function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $2e8bc5606025d797$var$_isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
        $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
    }
    function $2e8bc5606025d797$var$_getPrototypeOf(o) {
        $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $2e8bc5606025d797$var$_getPrototypeOf(o);
    }
    function $2e8bc5606025d797$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $2e8bc5606025d797$var$_typeof(o);
    }
    var $9kAQu = parcelRequire("9kAQu");
    var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;
    var $8JAro = parcelRequire("8JAro");
    var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
    function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $2e8bc5606025d797$var$repeat(str, count) {
        count = Math.floor(count);
        if (str.length == 0 || count == 0) return '';
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while(count){
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
    var $2e8bc5606025d797$var$blue = '';
    var $2e8bc5606025d797$var$green = '';
    var $2e8bc5606025d797$var$red = '';
    var $2e8bc5606025d797$var$white = '';
    var $2e8bc5606025d797$var$kReadableOperator = {
        deepStrictEqual: 'Expected values to be strictly deep-equal:',
        strictEqual: 'Expected values to be strictly equal:',
        strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
        deepEqual: 'Expected values to be loosely deep-equal:',
        equal: 'Expected values to be loosely equal:',
        notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
        notStrictEqual: 'Expected "actual" to be strictly unequal to:',
        notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
        notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
        notEqual: 'Expected "actual" to be loosely unequal to:',
        notIdentical: 'Values identical but not reference-equal:'
    };
    var $2e8bc5606025d797$var$kMaxShortLength = 10;
    function $2e8bc5606025d797$var$copyError(source) {
        var keys = Object.keys(source);
        var target = Object.create(Object.getPrototypeOf(source));
        keys.forEach(function(key) {
            target[key] = source[key];
        });
        Object.defineProperty(target, 'message', {
            value: source.message
        });
        return target;
    }
    function $2e8bc5606025d797$var$inspectValue(val) {
        return $2e8bc5606025d797$var$inspect(val, {
            compact: false,
            customInspect: false,
            depth: 1000,
            maxArrayLength: Infinity,
            showHidden: false,
            breakLength: Infinity,
            showProxy: false,
            sorted: true,
            getters: true
        });
    }
    function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
        var other = '';
        var res = '';
        var lastPos = 0;
        var end = '';
        var skipped = false;
        var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
        var actualLines = actualInspected.split('\n');
        var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
        var i = 0;
        var indicator = '';
        if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
        if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
            var inputLength = actualLines[0].length + expectedLines[0].length;
            if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
                if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
            } else if (operator !== 'strictEqualObject') {
                var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
                if (inputLength < maxLength) {
                    while(actualLines[0][i] === expectedLines[0][i])i++;
                    if (i > 2) {
                        indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                        i = 0;
                    }
                }
            }
        }
        var a = actualLines[actualLines.length - 1];
        var b = expectedLines[expectedLines.length - 1];
        while(a === b){
            if (i++ < 2) end = "\n  ".concat(a).concat(end);
            else other = a;
            actualLines.pop();
            expectedLines.pop();
            if (actualLines.length === 0 || expectedLines.length === 0) break;
            a = actualLines[actualLines.length - 1];
            b = expectedLines[expectedLines.length - 1];
        }
        var maxLines = Math.max(actualLines.length, expectedLines.length);
        if (maxLines === 0) {
            var _actualLines = actualInspected.split('\n');
            if (_actualLines.length > 30) {
                _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                while(_actualLines.length > 27)_actualLines.pop();
            }
            return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
        }
        if (i > 3) {
            end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
            skipped = true;
        }
        if (other !== '') {
            end = "\n  ".concat(other).concat(end);
            other = '';
        }
        var printedLines = 0;
        var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
        var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
        for(i = 0; i < maxLines; i++){
            var cur = i - lastPos;
            if (actualLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(expectedLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(expectedLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
                printedLines++;
            } else if (expectedLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
                printedLines++;
            } else {
                var expectedLine = expectedLines[i];
                var actualLine = actualLines[i];
                var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
                if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                    divergingLines = false;
                    actualLine += ',';
                }
                if (divergingLines) {
                    if (cur > 1 && i > 2) {
                        if (cur > 4) {
                            res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                            skipped = true;
                        } else if (cur > 3) {
                            res += "\n  ".concat(actualLines[i - 2]);
                            printedLines++;
                        }
                        res += "\n  ".concat(actualLines[i - 1]);
                        printedLines++;
                    }
                    lastPos = i;
                    res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                    other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                    printedLines += 2;
                } else {
                    res += other;
                    other = '';
                    if (cur === 1 || i === 0) {
                        res += "\n  ".concat(actualLine);
                        printedLines++;
                    }
                }
            }
            if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
        }
        return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
    }
    var $2e8bc5606025d797$var$AssertionError = function(_Error, _inspect$custom) {
        $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
        var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
        function AssertionError(options) {
            var _this;
            $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
            if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
            var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
            var actual = options.actual, expected = options.expected;
            var limit = Error.stackTraceLimit;
            Error.stackTraceLimit = 0;
            if (message != null) _this = _super.call(this, String(message));
            else {
                if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                    if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                        $2e8bc5606025d797$var$blue = "\x1B[34m";
                        $2e8bc5606025d797$var$green = "\x1B[32m";
                        $2e8bc5606025d797$var$white = "\x1B[39m";
                        $2e8bc5606025d797$var$red = "\x1B[31m";
                    } else {
                        $2e8bc5606025d797$var$blue = '';
                        $2e8bc5606025d797$var$green = '';
                        $2e8bc5606025d797$var$white = '';
                        $2e8bc5606025d797$var$red = '';
                    }
                }
                if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                    actual = $2e8bc5606025d797$var$copyError(actual);
                    expected = $2e8bc5606025d797$var$copyError(expected);
                }
                if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
                else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                    var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                    var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                    if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                    if (res.length > 30) {
                        res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        while(res.length > 27)res.pop();
                    }
                    if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                    else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
                } else {
                    var _res = $2e8bc5606025d797$var$inspectValue(actual);
                    var other = '';
                    var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                    if (operator === 'notDeepEqual' || operator === 'notEqual') {
                        _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                        if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                    } else {
                        other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                        if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                        if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                        if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                        else other = " ".concat(operator, " ").concat(other);
                    }
                    _this = _super.call(this, "".concat(_res).concat(other));
                }
            }
            Error.stackTraceLimit = limit;
            _this.generatedMessage = !message;
            Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
                value: 'AssertionError [ERR_ASSERTION]',
                enumerable: false,
                writable: true,
                configurable: true
            });
            _this.code = 'ERR_ASSERTION';
            _this.actual = actual;
            _this.expected = expected;
            _this.operator = operator;
            if (Error.captureStackTrace) Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
            _this.stack;
            _this.name = 'AssertionError';
            return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
        }
        $2e8bc5606025d797$var$_createClass(AssertionError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                }
            },
            {
                key: _inspect$custom,
                value: function value(recurseTimes, ctx) {
                    return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                        customInspect: false,
                        depth: 0
                    }));
                }
            }
        ]);
        return AssertionError;
    }($2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
    module.exports = $2e8bc5606025d797$var$AssertionError;
});
parcelRegister("8s5ew", function(module, exports) {
    'use strict';
    var $3WQC3 = parcelRequire("3WQC3");
    var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
        if (!Object.assign) return false;
        var str = 'abcdefghijklmnopqrst';
        var letters = str.split('');
        var map = {};
        for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
        var obj = Object.assign({}, map);
        var actual = '';
        for(var k in obj)actual += k;
        return str !== actual;
    };
    var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
        if (!Object.assign || !Object.preventExtensions) return false;
        var thrower = Object.preventExtensions({
            1: 2
        });
        try {
            Object.assign(thrower, 'xy');
        } catch (e) {
            return thrower[1] === 'y';
        }
        return false;
    };
    module.exports = function getPolyfill() {
        if (!Object.assign) return $3WQC3;
        if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
        if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
        return Object.assign;
    };
});
parcelRegister("3WQC3", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();
    var $53KqO = parcelRequire("53KqO");
    var $2dff99ad8985d37e$var$toObject = Object;
    var $2dff99ad8985d37e$var$$push = $53KqO('Array.prototype.push');
    var $2dff99ad8985d37e$var$$propIsEnumerable = $53KqO('Object.prototype.propertyIsEnumerable');
    var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? Object.getOwnPropertySymbols : null;
    module.exports = function assign(target, source1) {
        if (target == null) throw new TypeError('target must be an object');
        var to = $2dff99ad8985d37e$var$toObject(target);
        if (arguments.length === 1) return to;
        for(var s = 1; s < arguments.length; ++s){
            var from = $2dff99ad8985d37e$var$toObject(arguments[s]);
            var keys = $dZMWQ(from);
            var getSymbols = $2dff99ad8985d37e$var$hasSymbols && (Object.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
            if (getSymbols) {
                var syms = getSymbols(from);
                for(var j = 0; j < syms.length; ++j){
                    var key = syms[j];
                    if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
                }
            }
            for(var i = 0; i < keys.length; ++i){
                var nextKey = keys[i];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                    var propValue = from[nextKey];
                    to[nextKey] = propValue;
                }
            }
        }
        return to;
    };
});
parcelRegister("dZMWQ", function(module, exports) {
    'use strict';
    var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;
    var $1Houy = parcelRequire("1Houy");
    var $a306f0f1bb5f232a$var$origKeys = Object.keys;
    var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
        return $a306f0f1bb5f232a$var$origKeys(o);
    } : (parcelRequire("eQVXL"));
    var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
    $a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
        if (Object.keys) {
            var keysWorksWithArguments = function() {
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
            }(1, 2);
            if (!keysWorksWithArguments) Object.keys = function keys(object) {
                if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
                return $a306f0f1bb5f232a$var$originalKeys(object);
            };
        } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
        return Object.keys || $a306f0f1bb5f232a$var$keysShim;
    };
    module.exports = $a306f0f1bb5f232a$var$keysShim;
});
parcelRegister("1Houy", function(module, exports) {
    'use strict';
    var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
    module.exports = function isArguments(value) {
        var str = $13ccce2fa6936c75$var$toStr.call(value);
        var isArgs = str === '[object Arguments]';
        if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
        return isArgs;
    };
});
parcelRegister("eQVXL", function(module, exports) {
    'use strict';
    var $ad02e23a59d3730f$var$keysShim;
    if (!Object.keys) {
        var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
        var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
        var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy"));
        var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
        var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
            toString: null
        }, 'toString');
        var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
        var $ad02e23a59d3730f$var$dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var $ad02e23a59d3730f$var$excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
            if (typeof window === 'undefined') return false;
            for(var k in window)try {
                if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                    $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
                } catch (e) {
                    return true;
                }
            } catch (e) {
                return true;
            }
            return false;
        }();
        var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
            if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            try {
                return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
        $ad02e23a59d3730f$var$keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
            var isArguments = $ad02e23a59d3730f$var$isArgs(object);
            var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
            var theKeys = [];
            if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
            var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
            if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
            else {
                for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
            }
            if ($ad02e23a59d3730f$var$hasDontEnumBug) {
                var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
                for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
            }
            return theKeys;
        };
    }
    module.exports = $ad02e23a59d3730f$var$keysShim;
});
parcelRegister("eJazH", function(module, exports) {
    'use strict';
    var $iwNFM = parcelRequire("iwNFM");
    module.exports = function getPolyfill() {
        return typeof Object.is === 'function' ? Object.is : $iwNFM;
    };
});
parcelRegister("iwNFM", function(module, exports) {
    'use strict';
    var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
        return value !== value;
    };
    module.exports = function is(a, b) {
        if (a === 0 && b === 0) return 1 / a === 1 / b;
        if (a === b) return true;
        if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
        return false;
    };
});
parcelRegister("dztjv", function(module, exports) {
    'use strict';
    function $9e15485748de85e6$var$_slicedToArray(arr, i) {
        return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
    }
    function $9e15485748de85e6$var$_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    }
    function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function $9e15485748de85e6$var$_arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function $9e15485748de85e6$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $9e15485748de85e6$var$_typeof(o);
    }
    var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
    var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
        var array = [];
        set.forEach(function(value) {
            return array.push(value);
        });
        return array;
    };
    var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
        var array = [];
        map.forEach(function(value, key) {
            return array.push([
                key,
                value
            ]);
        });
        return array;
    };
    var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
    var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
        return [];
    };
    var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
    function $9e15485748de85e6$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
    var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
    var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);
    var $9kAQu = parcelRequire("9kAQu");
    var $9e15485748de85e6$require$_require$types = $9kAQu.types;
    var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
    function $9e15485748de85e6$var$isNonIndex(key) {
        if (key.length === 0 || key.length > 10) return true;
        for(var i = 0; i < key.length; i++){
            var code = key.charCodeAt(i);
            if (code < 48 || code > 57) return true;
        }
        return key.length === 10 && key >= Math.pow(2, 32);
    }
    function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
        return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
    }
    function $9e15485748de85e6$var$compare(a, b) {
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }
    var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
    var $9e15485748de85e6$var$kStrict = true;
    var $9e15485748de85e6$var$kLoose = false;
    var $9e15485748de85e6$var$kNoIterator = 0;
    var $9e15485748de85e6$var$kIsArray = 1;
    var $9e15485748de85e6$var$kIsSet = 2;
    var $9e15485748de85e6$var$kIsMap = 3;
    function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
        return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
    }
    function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        for(var offset = 0; offset < a.byteLength; offset++){
            if (a[offset] !== b[offset]) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
    }
    function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
        return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
    }
    function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
        if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
        if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
        return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
    }
    function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
        if (val1 === val2) {
            if (val1 !== 0) return true;
            return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
        }
        if (strict) {
            if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
            if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
            if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
        } else {
            if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
                if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return val1 == val2;
                return false;
            }
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
        }
        var val1Tag = $9e15485748de85e6$var$objectToString(val1);
        var val2Tag = $9e15485748de85e6$var$objectToString(val2);
        if (val1Tag !== val2Tag) return false;
        if (Array.isArray(val1)) {
            if (val1.length !== val2.length) return false;
            var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (keys1.length !== keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
        }
        if (val1Tag === '[object Object]') {
            if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
        }
        if ($9e15485748de85e6$var$isDate(val1)) {
            if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
        } else if ($9e15485748de85e6$var$isRegExp(val1)) {
            if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
            if (val1.message !== val2.message || val1.name !== val2.name) return false;
        } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
            if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
                if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
            } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
            var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (_keys.length !== _keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
        } else if ($9e15485748de85e6$var$isSet(val1)) {
            if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
        } else if ($9e15485748de85e6$var$isMap(val1)) {
            if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
        } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
            if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
    }
    function $9e15485748de85e6$var$getEnumerables(val, keys) {
        return keys.filter(function(k) {
            return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
        });
    }
    function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
        if (arguments.length === 5) {
            aKeys = Object.keys(val1);
            var bKeys = Object.keys(val2);
            if (aKeys.length !== bKeys.length) return false;
        }
        var i = 0;
        for(; i < aKeys.length; i++){
            if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
        }
        if (strict && arguments.length === 5) {
            var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
            if (symbolKeysA.length !== 0) {
                var count = 0;
                for(i = 0; i < symbolKeysA.length; i++){
                    var key = symbolKeysA[i];
                    if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                        if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                        aKeys.push(key);
                        count++;
                    } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                }
                var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
            } else {
                var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
            }
        }
        if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
        if (memos === undefined) memos = {
            val1: new Map(),
            val2: new Map(),
            position: 0
        };
        else {
            var val2MemoA = memos.val1.get(val1);
            if (val2MemoA !== undefined) {
                var val2MemoB = memos.val2.get(val2);
                if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
            }
            memos.position++;
        }
        memos.val1.set(val1, memos.position);
        memos.val2.set(val2, memos.position);
        var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
        memos.val1.delete(val1);
        memos.val2.delete(val2);
        return areEq;
    }
    function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var val2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
                set.delete(val2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
        switch($9e15485748de85e6$var$_typeof(prim)){
            case 'undefined':
                return null;
            case 'object':
                return undefined;
            case 'symbol':
                return false;
            case 'string':
                prim = +prim;
            case 'number':
                if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        return b.has(altValue) && !a.has(altValue);
    }
    function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        var curB = b.get(altValue);
        if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
        return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
    }
    function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
        var set = null;
        var aValues = $9e15485748de85e6$var$arrayFromSet(a);
        for(var i = 0; i < aValues.length; i++){
            var val = aValues[i];
            if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
                if (set === null) set = new Set();
                set.add(val);
            } else if (!b.has(val)) {
                if (strict) return false;
                if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
                if (set === null) set = new Set();
                set.add(val);
            }
        }
        if (set !== null) {
            var bValues = $9e15485748de85e6$var$arrayFromSet(b);
            for(var _i = 0; _i < bValues.length; _i++){
                var _val = bValues[_i];
                if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                    if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
                } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var key2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
                set.delete(key2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
        var set = null;
        var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
        for(var i = 0; i < aEntries.length; i++){
            var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
            if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
                if (set === null) set = new Set();
                set.add(key);
            } else {
                var item2 = b.get(key);
                if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                    if (strict) return false;
                    if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                    if (set === null) set = new Set();
                    set.add(key);
                }
            }
        }
        if (set !== null) {
            var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
            for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                    if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
        var i = 0;
        if (iterationType === $9e15485748de85e6$var$kIsSet) {
            if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
            if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
            if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
                if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
            } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
            else {
                var keysA = Object.keys(a);
                for(; i < keysA.length; i++){
                    var key = keysA[i];
                    if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
                }
                if (keysA.length !== Object.keys(b).length) return false;
                return true;
            }
        }
        for(i = 0; i < keys.length; i++){
            var _key2 = keys[i];
            if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
    }
    function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
    }
    module.exports = {
        isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
        isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
    };
});
parcelRegister("joK88", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $iwNFM = parcelRequire("iwNFM");
    var $eJazH = parcelRequire("eJazH");
    var $90RaO = parcelRequire("90RaO");
    var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
    $d94D2($e1f40ab7009ea590$var$polyfill, {
        getPolyfill: $eJazH,
        implementation: $iwNFM,
        shim: $90RaO
    });
    module.exports = $e1f40ab7009ea590$var$polyfill;
});
parcelRegister("d94D2", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
    var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
    var $991fb4ca00f3da54$var$concat = Array.prototype.concat;
    var $le88V;
    var $991fb4ca00f3da54$var$isFunction = function(fn) {
        return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
    };
    var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
    var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
        if (name in object) {
            if (predicate === true) {
                if (object[name] === value) return;
            } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
        }
        if ($991fb4ca00f3da54$var$supportsDescriptors) (0, parcelRequire("le88V"))(object, name, value, true);
        else (0, parcelRequire("le88V"))(object, name, value);
    };
    var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
        var predicates = arguments.length > 2 ? arguments[2] : {};
        var props = $dZMWQ(map);
        if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
        for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    };
    $991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
    module.exports = $991fb4ca00f3da54$var$defineProperties;
});
parcelRegister("90RaO", function(module, exports) {
    'use strict';
    var $eJazH = parcelRequire("eJazH");
    var $d94D2 = parcelRequire("d94D2");
    module.exports = function shimObjectIs() {
        var polyfill = $eJazH();
        $d94D2(Object, {
            is: polyfill
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("laO4W", function(module, exports) {
    'use strict';
    var $h05ZS = parcelRequire("h05ZS");
    var $d94D2 = parcelRequire("d94D2");
    var $hdPWo = parcelRequire("hdPWo");
    var $gmOnv = parcelRequire("gmOnv");
    var $hXuHX = parcelRequire("hXuHX");
    var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
    $d94D2($f6a160b687432d3b$var$polyfill, {
        getPolyfill: $gmOnv,
        implementation: $hdPWo,
        shim: $hXuHX
    });
    module.exports = $f6a160b687432d3b$var$polyfill;
});
parcelRegister("hdPWo", function(module, exports) {
    'use strict';
    module.exports = function isNaN(value) {
        return value !== value;
    };
});
parcelRegister("gmOnv", function(module, exports) {
    'use strict';
    var $hdPWo = parcelRequire("hdPWo");
    module.exports = function getPolyfill() {
        if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
        return $hdPWo;
    };
});
parcelRegister("hXuHX", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $gmOnv = parcelRequire("gmOnv");
    module.exports = function shimNumberIsNaN() {
        var polyfill = $gmOnv();
        $d94D2(Number, {
            isNaN: polyfill
        }, {
            isNaN: function testIsNaN() {
                return Number.isNaN !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("d6D31", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
    function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {}
    module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
    function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {}
    module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
    function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {}
    module.exports.Override = $98aa1ff32ce30be5$var$Override;
    function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
        return (target, propertyKey, descriptor)=>{};
    }
    module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;
});
parcelRegister("ceaEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntStream = void 0;
    var $8e6f0d8930cd60b2$var$IntStream;
    (function(IntStream) {
        IntStream.EOF = -1;
        IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
    })($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));
});
parcelRegister("b0kN8", function(module, exports) {
    "use strict";
    var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BailErrorStrategy = void 0;
    var $4CCJj = parcelRequire("4CCJj");
    var $iLUMi = parcelRequire("iLUMi");
    var $d6D31 = parcelRequire("d6D31");
    var $3kXUy = parcelRequire("3kXUy");
    class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
        recover(recognizer, e) {
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        recoverInline(recognizer) {
            let e = new $iLUMi.InputMismatchException(recognizer);
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        sync(recognizer) {}
    }
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
    module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;
});
parcelRegister("4CCJj", function(module, exports) {
    "use strict";
    var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultErrorStrategy = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $hGRod = parcelRequire("hGRod");
    var $hKCjP = parcelRequire("hKCjP");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $d6D31 = parcelRequire("d6D31");
    class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
        constructor(){
            this.errorRecoveryMode = false;
            this.lastErrorIndex = -1;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
        }
        reset(recognizer) {
            this.endErrorCondition(recognizer);
        }
        beginErrorCondition(recognizer) {
            this.errorRecoveryMode = true;
        }
        inErrorRecoveryMode(recognizer) {
            return this.errorRecoveryMode;
        }
        endErrorCondition(recognizer) {
            this.errorRecoveryMode = false;
            this.lastErrorStates = undefined;
            this.lastErrorIndex = -1;
        }
        reportMatch(recognizer) {
            this.endErrorCondition(recognizer);
        }
        reportError(recognizer, e) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
            else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
            else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
            else {
                console.error(`unknown recognition error type: ${e}`);
                this.notifyErrorListeners(recognizer, e.toString(), e);
            }
        }
        notifyErrorListeners(recognizer, message, e) {
            let offendingToken = e.getOffendingToken(recognizer);
            if (offendingToken === undefined) offendingToken = null;
            recognizer.notifyErrorListeners(message, offendingToken, e);
        }
        recover(recognizer, e) {
            if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) recognizer.consume();
            this.lastErrorIndex = recognizer.inputStream.index;
            if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
            this.lastErrorStates.add(recognizer.state);
            let followSet = this.getErrorRecoverySet(recognizer);
            this.consumeUntil(recognizer, followSet);
        }
        sync(recognizer) {
            let s = recognizer.interpreter.atn.states[recognizer.state];
            if (this.inErrorRecoveryMode(recognizer)) return;
            let tokens = recognizer.inputStream;
            let la = tokens.LA(1);
            let nextTokens = recognizer.atn.nextTokens(s);
            if (nextTokens.contains(la)) {
                this.nextTokensContext = undefined;
                this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
                return;
            }
            if (nextTokens.contains($2DVsz.Token.EPSILON)) {
                if (this.nextTokensContext === undefined) {
                    this.nextTokensContext = recognizer.context;
                    this.nextTokensState = recognizer.state;
                }
                return;
            }
            switch(s.stateType){
                case $1bs3X.ATNStateType.BLOCK_START:
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    if (this.singleTokenDeletion(recognizer)) return;
                    throw new $iLUMi.InputMismatchException(recognizer);
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    this.reportUnwantedToken(recognizer);
                    let expecting = recognizer.getExpectedTokens();
                    let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                    this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                    break;
                default:
                    break;
            }
        }
        reportNoViableAlternative(recognizer, e) {
            let tokens = recognizer.inputStream;
            let input;
            if (tokens) {
                if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
                else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
            } else input = "<unknown input>";
            let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportInputMismatch(recognizer, e) {
            let expected = e.expectedTokens;
            let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
            let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportFailedPredicate(recognizer, e) {
            let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
            let msg = "rule " + ruleName + " " + e.message;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportUnwantedToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let tokenName = this.getTokenErrorDisplay(t);
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        reportMissingToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        recoverInline(recognizer) {
            let matchedSymbol = this.singleTokenDeletion(recognizer);
            if (matchedSymbol) {
                recognizer.consume();
                return matchedSymbol;
            }
            if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
            if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
            else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
        }
        singleTokenInsertion(recognizer) {
            let currentSymbolType = recognizer.inputStream.LA(1);
            let currentState = recognizer.interpreter.atn.states[recognizer.state];
            let next = currentState.transition(0).target;
            let atn = recognizer.interpreter.atn;
            let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
            if (expectingAtLL2.contains(currentSymbolType)) {
                this.reportMissingToken(recognizer);
                return true;
            }
            return false;
        }
        singleTokenDeletion(recognizer) {
            let nextTokenType = recognizer.inputStream.LA(2);
            let expecting = this.getExpectedTokens(recognizer);
            if (expecting.contains(nextTokenType)) {
                this.reportUnwantedToken(recognizer);
                recognizer.consume();
                let matchedSymbol = recognizer.currentToken;
                this.reportMatch(recognizer);
                return matchedSymbol;
            }
            return undefined;
        }
        getMissingSymbol(recognizer) {
            let currentSymbol = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
            if (!expecting.isNil) expectedTokenType = expecting.minElement;
            let tokenText;
            if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
            else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
            let current = currentSymbol;
            let lookback = recognizer.inputStream.tryLT(-1);
            if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
            return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
        }
        constructToken(tokenSource, expectedTokenType, tokenText, current) {
            let factory = tokenSource.tokenFactory;
            let x = current.tokenSource;
            let stream = x ? x.inputStream : undefined;
            return factory.create({
                source: tokenSource,
                stream: stream
            }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
        }
        getExpectedTokens(recognizer) {
            return recognizer.getExpectedTokens();
        }
        getTokenErrorDisplay(t) {
            if (!t) return "<no token>";
            let s = this.getSymbolText(t);
            if (!s) {
                if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
                else s = `<${this.getSymbolType(t)}>`;
            }
            return this.escapeWSAndQuote(s);
        }
        getSymbolText(symbol) {
            return symbol.text;
        }
        getSymbolType(symbol) {
            return symbol.type;
        }
        escapeWSAndQuote(s) {
            s = s.replace("\n", "\\n");
            s = s.replace("\r", "\\r");
            s = s.replace("\t", "\\t");
            return "'" + s + "'";
        }
        getErrorRecoverySet(recognizer) {
            let atn = recognizer.interpreter.atn;
            let ctx = recognizer.context;
            let recoverSet = new $hGRod.IntervalSet();
            while(ctx && ctx.invokingState >= 0){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                let follow = atn.nextTokens(rt.followState);
                recoverSet.addAll(follow);
                ctx = ctx._parent;
            }
            recoverSet.remove($2DVsz.Token.EPSILON);
            return recoverSet;
        }
        consumeUntil(recognizer, set) {
            let ttype = recognizer.inputStream.LA(1);
            while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
                recognizer.consume();
                ttype = recognizer.inputStream.LA(1);
            }
        }
    }
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
    module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;
});
parcelRegister("7j0Pc", function(module, exports) {
    "use strict";
    var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
    class $551af28bc8fe1b8c$var$ATNState {
        constructor(){
            this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
            this.ruleIndex = 0;
            this.epsilonOnlyTransitions = false;
            this.transitions = [];
            this.optimizedTransitions = this.transitions;
        }
        getStateNumber() {
            return this.stateNumber;
        }
        get nonStopStateNumber() {
            return this.getStateNumber();
        }
        hashCode() {
            return this.stateNumber;
        }
        equals(o) {
            if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
            return false;
        }
        get isNonGreedyExitState() {
            return false;
        }
        toString() {
            return String(this.stateNumber);
        }
        getTransitions() {
            return this.transitions.slice(0);
        }
        get numberOfTransitions() {
            return this.transitions.length;
        }
        addTransition(e, index) {
            if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
            else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
                this.epsilonOnlyTransitions = false;
                throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
            }
            this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
        }
        transition(i) {
            return this.transitions[i];
        }
        setTransition(i, e) {
            this.transitions[i] = e;
        }
        removeTransition(index) {
            return this.transitions.splice(index, 1)[0];
        }
        get onlyHasEpsilonTransitions() {
            return this.epsilonOnlyTransitions;
        }
        setRuleIndex(ruleIndex) {
            this.ruleIndex = ruleIndex;
        }
        get isOptimized() {
            return this.optimizedTransitions !== this.transitions;
        }
        get numberOfOptimizedTransitions() {
            return this.optimizedTransitions.length;
        }
        getOptimizedTransition(i) {
            return this.optimizedTransitions[i];
        }
        addOptimizedTransition(e) {
            if (!this.isOptimized) this.optimizedTransitions = new Array();
            this.optimizedTransitions.push(e);
        }
        setOptimizedTransition(i, e) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions[i] = e;
        }
        removeOptimizedTransition(i) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions.splice(i, 1);
        }
    }
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
    module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
    (function(ATNState) {
        ATNState.INVALID_STATE_NUMBER = -1;
    })($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));
});
parcelRegister("1bs3X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNStateType = void 0;
    var $0dcc96396a04e502$var$ATNStateType;
    (function(ATNStateType) {
        ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
        ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
        ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
        ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
        ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
        ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
        ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
        ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
        ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
        ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
        ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
        ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
        ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
    })($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));
});
parcelRegister("ea0YW", function(module, exports) {
    "use strict";
    var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.FailedPredicateException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $hnaRv = parcelRequire("hnaRv");
    let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
        constructor(recognizer, predicate, message){
            super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
            let s = recognizer.interpreter.atn.states[recognizer.state];
            let trans = s.transition(0);
            if (trans instanceof $hnaRv.PredicateTransition) {
                this._ruleIndex = trans.ruleIndex;
                this._predicateIndex = trans.predIndex;
            } else {
                this._ruleIndex = 0;
                this._predicateIndex = 0;
            }
            this._predicate = predicate;
            super.setOffendingToken(recognizer, recognizer.currentToken);
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get predicateIndex() {
            return this._predicateIndex;
        }
        get predicate() {
            return this._predicate;
        }
        static formatMessage(predicate, message) {
            if (message) return message;
            return `failed predicate: {${predicate}}?`;
        }
    };
    $a4f2c2ded442ae18$var$__decorate([
        $d6D31.NotNull
    ], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
    $a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
        $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
    ], $a4f2c2ded442ae18$var$FailedPredicateException);
    module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;
});
parcelRegister("fLdDn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RecognitionException = void 0;
    class $b795d243382c1d9c$var$RecognitionException extends Error {
        constructor(recognizer, input, ctx, message){
            super(message);
            this._offendingState = -1;
            this._recognizer = recognizer;
            this.input = input;
            this.ctx = ctx;
            if (recognizer) this._offendingState = recognizer.state;
        }
        get offendingState() {
            return this._offendingState;
        }
        setOffendingState(offendingState) {
            this._offendingState = offendingState;
        }
        get expectedTokens() {
            if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
            return undefined;
        }
        get context() {
            return this.ctx;
        }
        get inputStream() {
            return this.input;
        }
        getOffendingToken(recognizer) {
            if (recognizer && recognizer !== this._recognizer) return undefined;
            return this.offendingToken;
        }
        setOffendingToken(recognizer, offendingToken) {
            if (recognizer === this._recognizer) this.offendingToken = offendingToken;
        }
        get recognizer() {
            return this._recognizer;
        }
    }
    module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;
});
parcelRegister("hnaRv", function(module, exports) {
    "use strict";
    var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, ruleIndex, predIndex, isCtxDependent){
            super(target);
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 4;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
        }
        toString() {
            return "pred_" + this.ruleIndex + ":" + this.predIndex;
        }
    };
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
    $ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
        $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
    ], $ca5d02a3d9cef56c$var$PredicateTransition);
    module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;
});
parcelRegister("fMVaR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AbstractPredicateTransition = void 0;
    var $5tcOQ = parcelRequire("5tcOQ");
    class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
    }
    module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;
});
parcelRegister("5tcOQ", function(module, exports) {
    "use strict";
    var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Transition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $3fb99acb0a3a1848$var$Transition = class Transition {
        constructor(target){
            if (target == null) throw new Error("target cannot be null.");
            this.target = target;
        }
        get isEpsilon() {
            return false;
        }
        get label() {
            return undefined;
        }
    };
    $3fb99acb0a3a1848$var$Transition.serializationNames = [
        "INVALID",
        "EPSILON",
        "RANGE",
        "RULE",
        "PREDICATE",
        "ATOM",
        "ACTION",
        "SET",
        "NOT_SET",
        "WILDCARD",
        "PRECEDENCE"
    ];
    $3fb99acb0a3a1848$var$__decorate([
        $d6D31.NotNull
    ], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
    $3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
        $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
    ], $3fb99acb0a3a1848$var$Transition);
    module.exports.Transition = $3fb99acb0a3a1848$var$Transition;
});
parcelRegister("eHMgW", function(module, exports) {
    "use strict";
    var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SemanticContext = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $2IEP9 = parcelRequire("2IEP9");
    function $ab4a86b5def51fe2$var$max(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison < 0) result = current;
        }
        return result;
    }
    function $ab4a86b5def51fe2$var$min(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison > 0) result = current;
        }
        return result;
    }
    class $ab4a86b5def51fe2$var$SemanticContext {
        static get NONE() {
            if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
            return $ab4a86b5def51fe2$var$SemanticContext._NONE;
        }
        evalPrecedence(parser, parserCallStack) {
            return this;
        }
        static and(a, b) {
            if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
            if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
        static or(a, b) {
            if (!a) return b;
            if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
    }
    module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
    (function(SemanticContext) {
        const AND_HASHCODE = 40363613;
        const OR_HASHCODE = 486279973;
        function filterPrecedencePredicates(collection) {
            let result = [];
            for(let i = 0; i < collection.length; i++){
                let context = collection[i];
                if (context instanceof SemanticContext.PrecedencePredicate) {
                    result.push(context);
                    collection.splice(i, 1);
                    i--;
                }
            }
            return result;
        }
        class Predicate extends SemanticContext {
            constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
                super();
                this.ruleIndex = ruleIndex;
                this.predIndex = predIndex;
                this.isCtxDependent = isCtxDependent;
            }
            eval(parser, parserCallStack) {
                let localctx = this.isCtxDependent ? parserCallStack : undefined;
                return parser.sempred(localctx, this.ruleIndex, this.predIndex);
            }
            hashCode() {
                let hashCode = $iXFjm.MurmurHash.initialize();
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof Predicate)) return false;
                if (this === obj) return true;
                return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
            }
            toString() {
                return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "toString", null);
        SemanticContext.Predicate = Predicate;
        class PrecedencePredicate extends SemanticContext {
            constructor(precedence){
                super();
                this.precedence = precedence;
            }
            eval(parser, parserCallStack) {
                return parser.precpred(parserCallStack, this.precedence);
            }
            evalPrecedence(parser, parserCallStack) {
                if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
                else return undefined;
            }
            compareTo(o) {
                return this.precedence - o.precedence;
            }
            hashCode() {
                let hashCode = 1;
                hashCode = 31 * hashCode + this.precedence;
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof PrecedencePredicate)) return false;
                if (this === obj) return true;
                return this.precedence === obj.precedence;
            }
            toString() {
                return "{" + this.precedence + ">=prec}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "compareTo", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "toString", null);
        SemanticContext.PrecedencePredicate = PrecedencePredicate;
        class Operator extends SemanticContext {
        }
        SemanticContext.Operator = Operator;
        let AND = class AND extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof AND) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof AND) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof AND)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (!opnd.eval(parser, parserCallStack)) return false;
                }
                return true;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated == null) return undefined;
                    else if (evaluated !== SemanticContext.NONE) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return SemanticContext.NONE;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "&&");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "toString", null);
        AND = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], AND);
        SemanticContext.AND = AND;
        let OR = class OR extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof OR) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof OR) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof OR)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (opnd.eval(parser, parserCallStack)) return true;
                }
                return false;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated === SemanticContext.NONE) return SemanticContext.NONE;
                    else if (evaluated) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return undefined;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "||");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "toString", null);
        OR = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], OR);
        SemanticContext.OR = OR;
    })($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));
});
parcelRegister("7Veax", function(module, exports) {
    "use strict";
    var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashSet = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $1EUnG = parcelRequire("1EUnG");
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16;
    const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
    class $5c48d8f2b0160dc3$var$Array2DHashSet {
        constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                this.comparator = comparatorOrSet.comparator;
                this.buckets = comparatorOrSet.buckets.slice(0);
                for(let i = 0; i < this.buckets.length; i++){
                    let bucket = this.buckets[i];
                    if (bucket) this.buckets[i] = bucket.slice(0);
                }
                this.n = comparatorOrSet.n;
                this.threshold = comparatorOrSet.threshold;
            } else {
                this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
                this.buckets = this.createBuckets(initialCapacity);
            }
        }
        getOrAdd(o) {
            if (this.n > this.threshold) this.expand();
            return this.getOrAddImpl(o);
        }
        getOrAddImpl(o) {
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) {
                bucket = [
                    o
                ];
                this.buckets[b] = bucket;
                this.n++;
                return o;
            }
            for (let existing of bucket){
                if (this.comparator.equals(existing, o)) return existing;
            }
            bucket.push(o);
            this.n++;
            return o;
        }
        get(o) {
            if (o == null) return o;
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) return undefined;
            for (let e of bucket){
                if (this.comparator.equals(e, o)) return e;
            }
            return undefined;
        }
        getBucket(o) {
            let hash = this.comparator.hashCode(o);
            let b = hash & this.buckets.length - 1;
            return b;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
                }
            }
            hash = $iXFjm.MurmurHash.finish(hash, this.size);
            return hash;
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
            if (o.size !== this.size) return false;
            let same = this.containsAll(o);
            return same;
        }
        expand() {
            let old = this.buckets;
            let newCapacity = this.buckets.length * 2;
            let newTable = this.createBuckets(newCapacity);
            this.buckets = newTable;
            this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            let oldSize = this.size;
            for (let bucket of old){
                if (!bucket) continue;
                for (let o of bucket){
                    let b = this.getBucket(o);
                    let newBucket = this.buckets[b];
                    if (!newBucket) {
                        newBucket = [];
                        this.buckets[b] = newBucket;
                    }
                    newBucket.push(o);
                }
            }
            $bbHFU(this.n === oldSize);
        }
        add(t) {
            let existing = this.getOrAdd(t);
            return existing === t;
        }
        get size() {
            return this.n;
        }
        get isEmpty() {
            return this.n === 0;
        }
        contains(o) {
            return this.containsFast(this.asElementType(o));
        }
        containsFast(obj) {
            if (obj == null) return false;
            return this.get(obj) != null;
        }
        *[Symbol.iterator]() {
            yield* this.toArray();
        }
        toArray() {
            const a = new Array(this.size);
            let i = 0;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    a[i++] = o;
                }
            }
            return a;
        }
        containsAll(collection) {
            if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                let s = collection;
                for (let bucket of s.buckets){
                    if (bucket == null) continue;
                    for (let o of bucket){
                        if (o == null) break;
                        if (!this.containsFast(this.asElementType(o))) return false;
                    }
                }
            } else for (let o of collection){
                if (!this.containsFast(this.asElementType(o))) return false;
            }
            return true;
        }
        addAll(c) {
            let changed = false;
            for (let o of c){
                let existing = this.getOrAdd(o);
                if (existing !== o) changed = true;
            }
            return changed;
        }
        clear() {
            this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        }
        toString() {
            if (this.size === 0) return "{}";
            let buf = "{";
            let first = true;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (first) first = false;
                    else buf += ", ";
                    buf += o.toString();
                }
            }
            buf += "}";
            return buf;
        }
        toTableString() {
            let buf = "";
            for (let bucket of this.buckets){
                if (bucket == null) {
                    buf += "null\n";
                    continue;
                }
                buf += "[";
                let first = true;
                for (let o of bucket){
                    if (first) first = false;
                    else buf += " ";
                    if (o == null) buf += "_";
                    else buf += o.toString();
                }
                buf += "]\n";
            }
            return buf;
        }
        asElementType(o) {
            return o;
        }
        createBuckets(capacity) {
            return new Array(capacity);
        }
    }
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.NotNull
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
    module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;
});
parcelRegister("1EUnG", function(module, exports) {
    "use strict";
    var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $135542f8f0124ec7$var$DefaultEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
                obj
            ]);
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (typeof a === "string" || typeof a === "number") return a === b;
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
        }
    }
    $135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
    module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;
});
parcelRegister("iXFjm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.MurmurHash = void 0;
    var $dcddc83c17bb111f$var$MurmurHash;
    (function(MurmurHash) {
        const DEFAULT_SEED = 0;
        function initialize(seed = DEFAULT_SEED) {
            return seed;
        }
        MurmurHash.initialize = initialize;
        function update(hash, value) {
            const c1 = 0xCC9E2D51;
            const c2 = 0x1B873593;
            const r1 = 15;
            const r2 = 13;
            const m = 5;
            const n = 0xE6546B64;
            if (value == null) value = 0;
            else if (typeof value === "string") value = hashString(value);
            else if (typeof value === "object") value = value.hashCode();
            let k = value;
            k = Math.imul(k, c1);
            k = k << r1 | k >>> 32 - r1;
            k = Math.imul(k, c2);
            hash = hash ^ k;
            hash = hash << r2 | hash >>> 32 - r2;
            hash = Math.imul(hash, m) + n;
            return hash & 0xFFFFFFFF;
        }
        MurmurHash.update = update;
        function finish(hash, numberOfWords) {
            hash = hash ^ numberOfWords * 4;
            hash = hash ^ hash >>> 16;
            hash = Math.imul(hash, 0x85EBCA6B);
            hash = hash ^ hash >>> 13;
            hash = Math.imul(hash, 0xC2B2AE35);
            hash = hash ^ hash >>> 16;
            return hash;
        }
        MurmurHash.finish = finish;
        function hashCode(data, seed = DEFAULT_SEED) {
            let hash = initialize(seed);
            let length = 0;
            for (let value of data){
                hash = update(hash, value);
                length++;
            }
            hash = finish(hash, length);
            return hash;
        }
        MurmurHash.hashCode = hashCode;
        function hashString(str) {
            let len = str.length;
            if (len === 0) return 0;
            let hash = 0;
            for(let i = 0; i < len; i++){
                let c = str.charCodeAt(i);
                hash = (hash << 5 >>> 0) - hash + c;
                hash |= 0;
            }
            return hash;
        }
    })($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));
});
parcelRegister("a4Flx", function(module, exports) {
    "use strict";
    var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ObjectEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $755a59a5b7943f39$var$ObjectEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return obj.hashCode();
        }
        equals(a, b) {
            if (a == null) return b == null;
            return a.equals(b);
        }
    }
    $755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
    module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;
});
parcelRegister("3sNxf", function(module, exports) {
    "use strict";
    var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ArrayEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $285a6946513e4d3e$var$ArrayEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return $iXFjm.MurmurHash.hashCode(obj, 0);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (b == null) return false;
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
            }
            return true;
        }
    }
    $285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
    module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;
});
parcelRegister("2IEP9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
    function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
        return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
    }
    module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
    function $1faf5ba696168af5$var$join(collection, separator) {
        let buf = "";
        let first = true;
        for (let current of collection){
            if (first) first = false;
            else buf += separator;
            buf += current;
        }
        return buf;
    }
    module.exports.join = $1faf5ba696168af5$var$join;
    function $1faf5ba696168af5$var$equals(x, y) {
        if (x === y) return true;
        if (x === undefined || y === undefined) return false;
        return x.equals(y);
    }
    module.exports.equals = $1faf5ba696168af5$var$equals;
    function $1faf5ba696168af5$var$toMap(keys) {
        let m = new Map();
        for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
        return m;
    }
    module.exports.toMap = $1faf5ba696168af5$var$toMap;
    function $1faf5ba696168af5$var$toCharArray(str) {
        if (typeof str === "string") {
            let result = new Uint16Array(str.length);
            for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
            return result;
        } else return str.toCharArray();
    }
    module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray;
});
parcelRegister("iLUMi", function(module, exports) {
    "use strict";
    var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InputMismatchException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
        constructor(recognizer, state, context){
            if (context === undefined) context = recognizer.context;
            super(recognizer, recognizer.inputStream, context);
            if (state !== undefined) this.setOffendingState(state);
            this.setOffendingToken(recognizer, recognizer.currentToken);
        }
    };
    $daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
        $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
    ], $daa8a8b6b270e309$var$InputMismatchException);
    module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;
});
parcelRegister("hGRod", function(module, exports) {
    "use strict";
    var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntervalSet = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $ce0fc5f35b4fec79$var$IntervalSet {
        constructor(intervals){
            this.readonly = false;
            if (intervals != null) this._intervals = intervals.slice(0);
            else this._intervals = [];
        }
        static get COMPLETE_CHAR_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
        }
        static get EMPTY_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
        }
        static of(a, b = a) {
            let s = new $ce0fc5f35b4fec79$var$IntervalSet();
            s.add(a, b);
            return s;
        }
        clear() {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            this._intervals.length = 0;
        }
        add(a, b = a) {
            this.addRange($gcfUE.Interval.of(a, b));
        }
        addRange(addition) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            if (addition.b < addition.a) return;
            for(let i = 0; i < this._intervals.length; i++){
                let r = this._intervals[i];
                if (addition.equals(r)) return;
                if (addition.adjacent(r) || !addition.disjoint(r)) {
                    let bigger = addition.union(r);
                    this._intervals[i] = bigger;
                    while(i < this._intervals.length - 1){
                        i++;
                        let next = this._intervals[i];
                        if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                        this._intervals.splice(i, 1);
                        i--;
                        this._intervals[i] = bigger.union(next);
                    }
                    return;
                }
                if (addition.startsBeforeDisjoint(r)) {
                    this._intervals.splice(i, 0, addition);
                    return;
                }
            }
            this._intervals.push(addition);
        }
        static or(sets) {
            let r = new $ce0fc5f35b4fec79$var$IntervalSet();
            for (let s of sets)r.addAll(s);
            return r;
        }
        addAll(set) {
            if (set == null) return this;
            if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
                let other = set;
                let n = other._intervals.length;
                for(let i = 0; i < n; i++){
                    let I = other._intervals[i];
                    this.add(I.a, I.b);
                }
            } else for (let value of set.toArray())this.add(value);
            return this;
        }
        complementRange(minElement, maxElement) {
            return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
        }
        complement(vocabulary) {
            if (vocabulary.isNil) return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
            let vocabularyIS;
            if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
            else {
                vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
                vocabularyIS.addAll(vocabulary);
            }
            return vocabularyIS.subtract(this);
        }
        subtract(a) {
            if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
            if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
            let other = new $ce0fc5f35b4fec79$var$IntervalSet();
            other.addAll(a);
            return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
        }
        static subtract(left, right) {
            if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
            if (right.isNil) return result;
            let resultI = 0;
            let rightI = 0;
            while(resultI < result._intervals.length && rightI < right._intervals.length){
                let resultInterval = result._intervals[resultI];
                let rightInterval = right._intervals[rightI];
                if (rightInterval.b < resultInterval.a) {
                    rightI++;
                    continue;
                }
                if (rightInterval.a > resultInterval.b) {
                    resultI++;
                    continue;
                }
                let beforeCurrent;
                let afterCurrent;
                if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
                if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
                if (beforeCurrent) {
                    if (afterCurrent) {
                        result._intervals[resultI] = beforeCurrent;
                        result._intervals.splice(resultI + 1, 0, afterCurrent);
                        resultI++;
                        rightI++;
                        continue;
                    } else {
                        result._intervals[resultI] = beforeCurrent;
                        resultI++;
                        continue;
                    }
                } else if (afterCurrent) {
                    result._intervals[resultI] = afterCurrent;
                    rightI++;
                    continue;
                } else {
                    result._intervals.splice(resultI, 1);
                    continue;
                }
            }
            return result;
        }
        or(a) {
            let o = new $ce0fc5f35b4fec79$var$IntervalSet();
            o.addAll(this);
            o.addAll(a);
            return o;
        }
        and(other) {
            if (other.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let myIntervals = this._intervals;
            let theirIntervals = other._intervals;
            let intersection;
            let mySize = myIntervals.length;
            let theirSize = theirIntervals.length;
            let i = 0;
            let j = 0;
            while(i < mySize && j < theirSize){
                let mine = myIntervals[i];
                let theirs = theirIntervals[j];
                if (mine.startsBeforeDisjoint(theirs)) i++;
                else if (theirs.startsBeforeDisjoint(mine)) j++;
                else if (mine.properlyContains(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    j++;
                } else if (theirs.properlyContains(mine)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    i++;
                } else if (!mine.disjoint(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    if (mine.startsAfterNonDisjoint(theirs)) j++;
                    else if (theirs.startsAfterNonDisjoint(mine)) i++;
                }
            }
            if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
            return intersection;
        }
        contains(el) {
            let n = this._intervals.length;
            let l = 0;
            let r = n - 1;
            while(l <= r){
                let m = l + r >> 1;
                let I = this._intervals[m];
                let a = I.a;
                let b = I.b;
                if (b < el) l = m + 1;
                else if (a > el) r = m - 1;
                else return true;
            }
            return false;
        }
        get isNil() {
            return this._intervals == null || this._intervals.length === 0;
        }
        get maxElement() {
            if (this.isNil) throw new RangeError("set is empty");
            let last = this._intervals[this._intervals.length - 1];
            return last.b;
        }
        get minElement() {
            if (this.isNil) throw new RangeError("set is empty");
            return this._intervals[0].a;
        }
        get intervals() {
            return this._intervals;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let I of this._intervals){
                hash = $iXFjm.MurmurHash.update(hash, I.a);
                hash = $iXFjm.MurmurHash.update(hash, I.b);
            }
            hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
            return hash;
        }
        equals(o) {
            if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
        }
        toString(elemAreChar = false) {
            let buf = "";
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) {
                    if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                    else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                    else buf += a;
                } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
                else buf += a + ".." + b;
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        toStringVocabulary(vocabulary) {
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            let buf = "";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) buf += this.elementName(vocabulary, a);
                else for(let i = a; i <= b; i++){
                    if (i > a) buf += ", ";
                    buf += this.elementName(vocabulary, i);
                }
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        elementName(vocabulary, a) {
            if (a === $2DVsz.Token.EOF) return "<EOF>";
            else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
            else return vocabulary.getDisplayName(a);
        }
        get size() {
            let n = 0;
            let numIntervals = this._intervals.length;
            if (numIntervals === 1) {
                let firstInterval = this._intervals[0];
                return firstInterval.b - firstInterval.a + 1;
            }
            for(let i = 0; i < numIntervals; i++){
                let I = this._intervals[i];
                n += I.b - I.a + 1;
            }
            return n;
        }
        toIntegerList() {
            let values = new $37SGk.IntegerList(this.size);
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.add(v);
            }
            return values;
        }
        toSet() {
            let s = new Set();
            for (let I of this._intervals){
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)s.add(v);
            }
            return s;
        }
        toArray() {
            let values = new Array();
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.push(v);
            }
            return values;
        }
        remove(el) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                if (el < a) break;
                if (el === a && el === b) {
                    this._intervals.splice(i, 1);
                    break;
                }
                if (el === a) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                    break;
                }
                if (el === b) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                    break;
                }
                if (el > a && el < b) {
                    let oldb = I.b;
                    this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1);
                    this.add(el + 1, oldb);
                }
            }
        }
        get isReadonly() {
            return this.readonly;
        }
        setReadonly(readonly) {
            if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
            this.readonly = readonly;
        }
    }
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull,
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
    module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;
});
parcelRegister("37SGk", function(module, exports) {
    "use strict";
    var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerList = void 0;
    var $9yG1X = parcelRequire("9yG1X");
    var $d6D31 = parcelRequire("d6D31");
    const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
    const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
    const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
    class $246c712c5583aa9c$var$IntegerList {
        constructor(arg){
            if (!arg) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
                this._data = arg._data.slice(0);
                this._size = arg._size;
            } else if (typeof arg === "number") {
                if (arg === 0) {
                    this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                    this._size = 0;
                } else {
                    this._data = new Int32Array(arg);
                    this._size = 0;
                }
            } else {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
                for (let value of arg)this.add(value);
            }
        }
        add(value) {
            if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
            this._data[this._size] = value;
            this._size++;
        }
        addAll(list) {
            if (Array.isArray(list)) {
                this.ensureCapacity(this._size + list.length);
                this._data.subarray(this._size, this._size + list.length).set(list);
                this._size += list.length;
            } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
                this.ensureCapacity(this._size + list._size);
                this._data.subarray(this._size, this._size + list.size).set(list._data);
                this._size += list._size;
            } else {
                this.ensureCapacity(this._size + list.size);
                let current = 0;
                for (let xi of list){
                    this._data[this._size + current] = xi;
                    current++;
                }
                this._size += list.size;
            }
        }
        get(index) {
            if (index < 0 || index >= this._size) throw RangeError();
            return this._data[index];
        }
        contains(value) {
            for(let i = 0; i < this._size; i++){
                if (this._data[i] === value) return true;
            }
            return false;
        }
        set(index, value) {
            if (index < 0 || index >= this._size) throw RangeError();
            let previous = this._data[index];
            this._data[index] = value;
            return previous;
        }
        removeAt(index) {
            let value = this.get(index);
            this._data.copyWithin(index, index + 1, this._size);
            this._data[this._size - 1] = 0;
            this._size--;
            return value;
        }
        removeRange(fromIndex, toIndex) {
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
            if (fromIndex > toIndex) throw RangeError();
            this._data.copyWithin(toIndex, fromIndex, this._size);
            this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
            this._size -= toIndex - fromIndex;
        }
        get isEmpty() {
            return this._size === 0;
        }
        get size() {
            return this._size;
        }
        trimToSize() {
            if (this._data.length === this._size) return;
            this._data = this._data.slice(0, this._size);
        }
        clear() {
            this._data.fill(0, 0, this._size);
            this._size = 0;
        }
        toArray() {
            if (this._size === 0) return [];
            return Array.from(this._data.subarray(0, this._size));
        }
        sort() {
            this._data.subarray(0, this._size).sort();
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
            if (this._size !== o._size) return false;
            for(let i = 0; i < this._size; i++){
                if (this._data[i] !== o._data[i]) return false;
            }
            return true;
        }
        hashCode() {
            let hashCode = 1;
            for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
            return hashCode;
        }
        toString() {
            return this._data.toString();
        }
        binarySearch(key, fromIndex, toIndex) {
            if (fromIndex === undefined) fromIndex = 0;
            if (toIndex === undefined) toIndex = this._size;
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
            if (fromIndex > toIndex) throw new RangeError();
            return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
        }
        ensureCapacity(capacity) {
            if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
            let newLength;
            if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
            else newLength = this._data.length;
            while(newLength < capacity){
                newLength = newLength * 2;
                if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
            }
            let tmp = new Int32Array(newLength);
            tmp.set(this._data);
            this._data = tmp;
        }
        toCharArray() {
            let resultArray = new Uint16Array(this._size);
            let resultIdx = 0;
            let calculatedPreciseResultSize = false;
            for(let i = 0; i < this._size; i++){
                let codePoint = this._data[i];
                if (codePoint >= 0 && codePoint < 0x10000) {
                    resultArray[resultIdx] = codePoint;
                    resultIdx++;
                    continue;
                }
                if (!calculatedPreciseResultSize) {
                    let newResultArray = new Uint16Array(this.charArraySize());
                    newResultArray.set(resultArray, 0);
                    resultArray = newResultArray;
                    calculatedPreciseResultSize = true;
                }
                let pair = String.fromCodePoint(codePoint);
                resultArray[resultIdx] = pair.charCodeAt(0);
                resultArray[resultIdx + 1] = pair.charCodeAt(1);
                resultIdx += 2;
            }
            return resultArray;
        }
        charArraySize() {
            let result = 0;
            for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
            return result;
        }
    }
    $246c712c5583aa9c$var$__decorate([
        $d6D31.NotNull
    ], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
    module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;
});
parcelRegister("9yG1X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Arrays = void 0;
    var $6f57e46e4dc9d39b$var$Arrays;
    (function(Arrays) {
        function binarySearch(array, key, fromIndex, toIndex) {
            return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
        }
        Arrays.binarySearch = binarySearch;
        function binarySearch0(array, fromIndex, toIndex, key) {
            let low = fromIndex;
            let high = toIndex - 1;
            while(low <= high){
                let mid = low + high >>> 1;
                let midVal = array[mid];
                if (midVal < key) low = mid + 1;
                else if (midVal > key) high = mid - 1;
                else return mid;
            }
            return -(low + 1);
        }
        function toString(array) {
            let result = "[";
            let first = true;
            for (let element of array){
                if (first) first = false;
                else result += ", ";
                if (element === null) result += "null";
                else if (element === undefined) result += "undefined";
                else result += element;
            }
            result += "]";
            return result;
        }
        Arrays.toString = toString;
    })($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));
});
parcelRegister("gcfUE", function(module, exports) {
    "use strict";
    var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Interval = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
    class $bcaa1c4749d34439$var$Interval {
        constructor(a, b){
            this.a = a;
            this.b = b;
        }
        static get INVALID() {
            return $bcaa1c4749d34439$var$Interval._INVALID;
        }
        static of(a, b) {
            if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
            if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
            return $bcaa1c4749d34439$var$Interval.cache[a];
        }
        get length() {
            if (this.b < this.a) return 0;
            return this.b - this.a + 1;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
            return this.a === o.a && this.b === o.b;
        }
        hashCode() {
            let hash = 23;
            hash = hash * 31 + this.a;
            hash = hash * 31 + this.b;
            return hash;
        }
        startsBeforeDisjoint(other) {
            return this.a < other.a && this.b < other.a;
        }
        startsBeforeNonDisjoint(other) {
            return this.a <= other.a && this.b >= other.a;
        }
        startsAfter(other) {
            return this.a > other.a;
        }
        startsAfterDisjoint(other) {
            return this.a > other.b;
        }
        startsAfterNonDisjoint(other) {
            return this.a > other.a && this.a <= other.b;
        }
        disjoint(other) {
            return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
        }
        adjacent(other) {
            return this.a === other.b + 1 || this.b === other.a - 1;
        }
        properlyContains(other) {
            return other.a >= this.a && other.b <= this.b;
        }
        union(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
        }
        intersection(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
        }
        differenceNotProperlyContained(other) {
            let diff;
            if (other.startsBeforeNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
            else if (other.startsAfterNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
            return diff;
        }
        toString() {
            return this.a + ".." + this.b;
        }
    }
    $bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
    $bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
    module.exports.Interval = $bcaa1c4749d34439$var$Interval;
});
parcelRegister("igNLf", function(module, exports) {
    "use strict";
    var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Lexer = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $6Kebn = parcelRequire("6Kebn");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $lQecE = parcelRequire("lQecE");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2DVsz = parcelRequire("2DVsz");
    class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            this._tokenStartCharIndex = -1;
            this._tokenStartLine = 0;
            this._tokenStartCharPositionInLine = 0;
            this._hitEOF = false;
            this._channel = 0;
            this._type = 0;
            this._modeStack = new $6Kebn.IntegerStack();
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: input
            };
        }
        static get DEFAULT_TOKEN_CHANNEL() {
            return $2DVsz.Token.DEFAULT_CHANNEL;
        }
        static get HIDDEN() {
            return $2DVsz.Token.HIDDEN_CHANNEL;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this._input.seek(0);
            this._token = undefined;
            this._type = $2DVsz.Token.INVALID_TYPE;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this._tokenStartCharIndex = -1;
            this._tokenStartCharPositionInLine = -1;
            this._tokenStartLine = -1;
            this._text = undefined;
            this._hitEOF = false;
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._modeStack.clear();
            this.interpreter.reset();
        }
        nextToken() {
            if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
            let tokenStartMarker = this._input.mark();
            try {
                outer: while(true){
                    if (this._hitEOF) return this.emitEOF();
                    this._token = undefined;
                    this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                    this._tokenStartCharIndex = this._input.index;
                    this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                    this._tokenStartLine = this.interpreter.line;
                    this._text = undefined;
                    do {
                        this._type = $2DVsz.Token.INVALID_TYPE;
                        let ttype;
                        try {
                            ttype = this.interpreter.match(this._input, this._mode);
                        } catch (e) {
                            if (e instanceof $fOEQQ.LexerNoViableAltException) {
                                this.notifyListeners(e);
                                this.recover(e);
                                ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                            } else throw e;
                        }
                        if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                        if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                        if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                    }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE)
                    if (this._token == null) return this.emit();
                    return this._token;
                }
            } finally{
                this._input.release(tokenStartMarker);
            }
        }
        skip() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
        }
        more() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
        }
        mode(m) {
            this._mode = m;
        }
        pushMode(m) {
            if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
            this._modeStack.push(this._mode);
            this.mode(m);
        }
        popMode() {
            if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
            if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
            this.mode(this._modeStack.pop());
            return this._mode;
        }
        get tokenFactory() {
            return this._factory;
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: this._input
            };
        }
        get sourceName() {
            return this._input.sourceName;
        }
        emit(token) {
            if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
            this._token = token;
            return token;
        }
        emitEOF() {
            let cpos = this.charPositionInLine;
            let line = this.line;
            let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
            this.emit(eof);
            return eof;
        }
        get line() {
            return this.interpreter.line;
        }
        set line(line) {
            this.interpreter.line = line;
        }
        get charPositionInLine() {
            return this.interpreter.charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this.interpreter.charPositionInLine = charPositionInLine;
        }
        get charIndex() {
            return this._input.index;
        }
        get text() {
            if (this._text != null) return this._text;
            return this.interpreter.getText(this._input);
        }
        set text(text) {
            this._text = text;
        }
        get token() {
            return this._token;
        }
        set token(_token) {
            this._token = _token;
        }
        set type(ttype) {
            this._type = ttype;
        }
        get type() {
            return this._type;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        getAllTokens() {
            let tokens = [];
            let t = this.nextToken();
            while(t.type !== $2DVsz.Token.EOF){
                tokens.push(t);
                t = this.nextToken();
            }
            return tokens;
        }
        notifyListeners(e) {
            let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
            let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
        }
        getErrorDisplay(s) {
            if (typeof s === "number") {
                switch(s){
                    case $2DVsz.Token.EOF:
                        return "<EOF>";
                    case 0x0a:
                        return "\\n";
                    case 0x09:
                        return "\\t";
                    case 0x0d:
                        return "\\r";
                }
                return String.fromCharCode(s);
            }
            return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        }
        getCharErrorDisplay(c) {
            let s = this.getErrorDisplay(c);
            return "'" + s + "'";
        }
        recover(re) {
            if (re instanceof $fOEQQ.LexerNoViableAltException) {
                if (this._input.LA(1) !== $ceaEj.IntStream.EOF) this.interpreter.consume(this._input);
            } else this._input.consume();
        }
    }
    $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
    $d4d0521f20d9c4ac$var$Lexer.MORE = -2;
    $d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
    $d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
    $d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
    module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;
});
parcelRegister("gWaB3", function(module, exports) {
    "use strict";
    var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenFactory = void 0;
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $c54a4863b793dbc8$var$CommonTokenFactory {
        constructor(copyText = false){
            this.copyText = copyText;
        }
        create(source, type, text, channel, start, stop, line, charPositionInLine) {
            let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
            t.line = line;
            t.charPositionInLine = charPositionInLine;
            if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
            return t;
        }
        createSimple(type, text) {
            return new $j53rr.CommonToken(type, text);
        }
    }
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
    module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
    (function(CommonTokenFactory) {
        CommonTokenFactory.DEFAULT = new CommonTokenFactory();
    })($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));
});
parcelRegister("j53rr", function(module, exports) {
    "use strict";
    var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonToken = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $de41275c931ca469$var$CommonToken = class CommonToken {
        constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
            this._line = 0;
            this._charPositionInLine = -1;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this.index = -1;
            this._text = text;
            this._type = type;
            this.source = source;
            this._channel = channel;
            this.start = start;
            this.stop = stop;
            if (source.source != null) {
                this._line = source.source.line;
                this._charPositionInLine = source.source.charPositionInLine;
            }
        }
        static fromToken(oldToken) {
            let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
            result._line = oldToken.line;
            result.index = oldToken.tokenIndex;
            result._charPositionInLine = oldToken.charPositionInLine;
            if (oldToken instanceof CommonToken) {
                result._text = oldToken._text;
                result.source = oldToken.source;
            } else {
                result._text = oldToken.text;
                result.source = {
                    source: oldToken.tokenSource,
                    stream: oldToken.inputStream
                };
            }
            return result;
        }
        get type() {
            return this._type;
        }
        set type(type) {
            this._type = type;
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get text() {
            if (this._text != null) return this._text;
            let input = this.inputStream;
            if (input == null) return undefined;
            let n = input.size;
            if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
            else return "<EOF>";
        }
        set text(text) {
            this._text = text;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        get channel() {
            return this._channel;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get startIndex() {
            return this.start;
        }
        set startIndex(start) {
            this.start = start;
        }
        get stopIndex() {
            return this.stop;
        }
        set stopIndex(stop) {
            this.stop = stop;
        }
        get tokenIndex() {
            return this.index;
        }
        set tokenIndex(index) {
            this.index = index;
        }
        get tokenSource() {
            return this.source.source;
        }
        get inputStream() {
            return this.source.stream;
        }
        toString(recognizer) {
            let channelStr = "";
            if (this._channel > 0) channelStr = ",channel=" + this._channel;
            let txt = this.text;
            if (txt != null) {
                txt = txt.replace(/\n/g, "\\n");
                txt = txt.replace(/\r/g, "\\r");
                txt = txt.replace(/\t/g, "\\t");
            } else txt = "<no text>";
            let typeString = String(this._type);
            if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
            return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
        }
    };
    $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
        source: undefined,
        stream: undefined
    };
    $de41275c931ca469$var$__decorate([
        $d6D31.NotNull
    ], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "type", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "line", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "text", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
    $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(0, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken, "fromToken", null);
    $de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(2, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken);
    module.exports.CommonToken = $de41275c931ca469$var$CommonToken;
});
parcelRegister("2DVsz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Token = void 0;
    var $ceaEj = parcelRequire("ceaEj");
    var $1ecbcb9fde4eac7e$var$Token;
    (function(Token) {
        Token.INVALID_TYPE = 0;
        Token.EPSILON = -2;
        Token.MIN_USER_TOKEN_TYPE = 1;
        Token.EOF = $ceaEj.IntStream.EOF;
        Token.DEFAULT_CHANNEL = 0;
        Token.HIDDEN_CHANNEL = 1;
        Token.MIN_USER_CHANNEL_VALUE = 2;
    })($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));
});
parcelRegister("6Kebn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerStack = void 0;
    var $37SGk = parcelRequire("37SGk");
    class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
        constructor(arg){
            super(arg);
        }
        push(value) {
            this.add(value);
        }
        pop() {
            return this.removeAt(this.size - 1);
        }
        peek() {
            return this.get(this.size - 1);
        }
    }
    module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;
});
parcelRegister("lQecE", function(module, exports) {
    "use strict";
    var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $2jevZ = parcelRequire("2jevZ");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $igNLf = parcelRequire("igNLf");
    var $3AYVu = parcelRequire("3AYVu");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $9tIYC = parcelRequire("9tIYC");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, recog){
            super(atn);
            this.optimize_tail_calls = true;
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
            this.prevAccept = new LexerATNSimulator.SimState();
            this.recog = recog;
        }
        copyState(simulator) {
            this._charPositionInLine = simulator.charPositionInLine;
            this._line = simulator._line;
            this.mode = simulator.mode;
            this.startIndex = simulator.startIndex;
        }
        match(input, mode) {
            this.mode = mode;
            let mark = input.mark();
            try {
                this.startIndex = input.index;
                this.prevAccept.reset();
                let s0 = this.atn.modeToDFA[mode].s0;
                if (s0 == null) return this.matchATN(input);
                else return this.execATN(input, s0);
            } finally{
                input.release(mark);
            }
        }
        reset() {
            this.prevAccept.reset();
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
        }
        matchATN(input) {
            let startState = this.atn.modeToStartState[this.mode];
            if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
            let old_mode = this.mode;
            let s0_closure = this.computeStartState(input, startState);
            let suppressEdge = s0_closure.hasSemanticContext;
            if (suppressEdge) s0_closure.hasSemanticContext = false;
            let next = this.addDFAState(s0_closure);
            if (!suppressEdge) {
                let dfa = this.atn.modeToDFA[this.mode];
                if (!dfa.s0) dfa.s0 = next;
                else next = dfa.s0;
            }
            let predict = this.execATN(input, next);
            if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
            return predict;
        }
        execATN(input, ds0) {
            if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
            if (ds0.isAcceptState) this.captureSimState(this.prevAccept, input, ds0);
            let t = input.LA(1);
            let s = ds0;
            while(true){
                if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
                let target = this.getExistingTargetState(s, t);
                if (target == null) target = this.computeTargetState(input, s, t);
                if (target === $kr9A1.ATNSimulator.ERROR) break;
                if (t !== $ceaEj.IntStream.EOF) this.consume(input);
                if (target.isAcceptState) {
                    this.captureSimState(this.prevAccept, input, target);
                    if (t === $ceaEj.IntStream.EOF) break;
                }
                t = input.LA(1);
                s = target;
            }
            return this.failOrAccept(this.prevAccept, input, s.configs, t);
        }
        getExistingTargetState(s, t) {
            let target = s.getTarget(t);
            if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
            return target;
        }
        computeTargetState(input, s, t) {
            let reach = new $9tIYC.OrderedATNConfigSet();
            this.getReachableConfigSet(input, s.configs, reach, t);
            if (reach.isEmpty) {
                if (!reach.hasSemanticContext) this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return $kr9A1.ATNSimulator.ERROR;
            }
            return this.addDFAEdge(s, t, reach);
        }
        failOrAccept(prevAccept, input, reach, t) {
            if (prevAccept.dfaState != null) {
                let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
                this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
                return prevAccept.dfaState.prediction;
            } else {
                if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
                throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
            }
        }
        getReachableConfigSet(input, closure, reach, t) {
            let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of closure){
                let currentAltReachedAcceptState = c.alt === skipAlt;
                if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
                if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(trans, t);
                    if (target != null) {
                        let lexerActionExecutor = c.lexerActionExecutor;
                        let config;
                        if (lexerActionExecutor != null) {
                            lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                            config = c.transform(target, true, lexerActionExecutor);
                        } else {
                            $bbHFU(c.lexerActionExecutor == null);
                            config = c.transform(target, true);
                        }
                        let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                        if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                            skipAlt = c.alt;
                            break;
                        }
                    }
                }
            }
        }
        accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
            if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
            input.seek(index);
            this._line = line;
            this._charPositionInLine = charPos;
            if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
        }
        getReachableTarget(trans, t) {
            if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
            return undefined;
        }
        computeStartState(input, p) {
            let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
            let configs = new $9tIYC.OrderedATNConfigSet();
            for(let i = 0; i < p.numberOfTransitions; i++){
                let target = p.transition(i).target;
                let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
                this.closure(input, c, configs, false, false, false);
            }
            return configs;
        }
        closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
            if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (LexerATNSimulator.debug) {
                    if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                    else console.log(`closure at rule stop ${config}`);
                }
                let context = config.context;
                if (context.isEmpty) {
                    configs.add(config);
                    return true;
                } else if (context.hasEmpty) {
                    configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                    currentAltReachedAcceptState = true;
                }
                for(let i = 0; i < context.size; i++){
                    let returnStateNumber = context.getReturnState(i);
                    if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let newContext = context.getParent(i);
                    let returnState = this.atn.states[returnStateNumber];
                    let c = config.transform(returnState, false, newContext);
                    currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
                }
                return currentAltReachedAcceptState;
            }
            if (!config.state.onlyHasEpsilonTransitions) {
                if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
            }
            let p = config.state;
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                let t = p.getOptimizedTransition(i);
                let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
                if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
            let c;
            switch(t.serializationType){
                case 3:
                    let ruleTransition = t;
                    if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                    else {
                        let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                        c = config.transform(t.target, true, newContext);
                    }
                    break;
                case 10:
                    throw new Error("Precedence predicates are not supported in lexers.");
                case 4:
                    let pt = t;
                    if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                    configs.hasSemanticContext = true;
                    if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                    else c = undefined;
                    break;
                case 6:
                    if (config.context.hasEmpty) {
                        let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                        c = config.transform(t.target, true, lexerActionExecutor);
                        break;
                    } else {
                        c = config.transform(t.target, true);
                        break;
                    }
                case 1:
                    c = config.transform(t.target, true);
                    break;
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                            c = config.transform(t.target, false);
                            break;
                        }
                    }
                    c = undefined;
                    break;
                default:
                    c = undefined;
                    break;
            }
            return c;
        }
        evaluatePredicate(input, ruleIndex, predIndex, speculative) {
            if (this.recog == null) return true;
            if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
            let savedCharPositionInLine = this._charPositionInLine;
            let savedLine = this._line;
            let index = input.index;
            let marker = input.mark();
            try {
                this.consume(input);
                return this.recog.sempred(undefined, ruleIndex, predIndex);
            } finally{
                this._charPositionInLine = savedCharPositionInLine;
                this._line = savedLine;
                input.seek(index);
                input.release(marker);
            }
        }
        captureSimState(settings, input, dfaState) {
            settings.index = input.index;
            settings.line = this._line;
            settings.charPos = this._charPositionInLine;
            settings.dfaState = dfaState;
        }
        addDFAEdge(p, t, q) {
            if (q instanceof $c1ClW.ATNConfigSet) {
                let suppressEdge = q.hasSemanticContext;
                if (suppressEdge) q.hasSemanticContext = false;
                let to = this.addDFAState(q);
                if (suppressEdge) return to;
                this.addDFAEdge(p, t, to);
                return to;
            } else {
                if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
                if (p != null) p.setTarget(t, q);
            }
        }
        addDFAState(configs) {
            $bbHFU(!configs.hasSemanticContext);
            let proposed = new $2jevZ.DFAState(configs);
            let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
            if (existing != null) return existing;
            configs.optimizeConfigs(this);
            let newState = new $2jevZ.DFAState(configs.clone(true));
            let firstConfigWithRuleStopState;
            for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
                firstConfigWithRuleStopState = c;
                break;
            }
            if (firstConfigWithRuleStopState != null) {
                let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
                let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
                newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
            }
            return this.atn.modeToDFA[this.mode].addState(newState);
        }
        getDFA(mode) {
            return this.atn.modeToDFA[mode];
        }
        getText(input) {
            return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        consume(input) {
            let curChar = input.LA(1);
            if (curChar === "\n".charCodeAt(0)) {
                this._line++;
                this._charPositionInLine = 0;
            } else this._charPositionInLine++;
            input.consume();
        }
        getTokenName(t) {
            if (t === -1) return "EOF";
            return "'" + String.fromCharCode(t) + "'";
        }
    };
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.Override
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
    $fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator);
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
    (function(LexerATNSimulator) {
        LexerATNSimulator.debug = false;
        LexerATNSimulator.dfa_debug = false;
        class SimState {
            constructor(){
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
            }
            reset() {
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
                this.dfaState = undefined;
            }
        }
        LexerATNSimulator.SimState = SimState;
    })($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
});
parcelRegister("41NTU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AcceptStateInfo = void 0;
    class $2eedf6a56837c02c$var$AcceptStateInfo {
        constructor(prediction, lexerActionExecutor){
            this._prediction = prediction;
            this._lexerActionExecutor = lexerActionExecutor;
        }
        get prediction() {
            return this._prediction;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
    }
    module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;
});
parcelRegister("bcnvE", function(module, exports) {
    "use strict";
    var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATN = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $jJRyp = parcelRequire("jJRyp");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iiE1V = parcelRequire("iiE1V");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $82730d2c6766359c$var$ATN = class ATN {
        constructor(grammarType, maxTokenType){
            this.states = [];
            this.decisionToState = [];
            this.modeNameToStartState = new Map();
            this.modeToStartState = [];
            this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.decisionToDFA = [];
            this.modeToDFA = [];
            this.LL1Table = new Map();
            this.grammarType = grammarType;
            this.maxTokenType = maxTokenType;
        }
        clearDFA() {
            this.decisionToDFA = new Array(this.decisionToState.length);
            for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
            this.modeToDFA = new Array(this.modeToStartState.length);
            for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
            this.contextCache.clear();
            this.LL1Table.clear();
        }
        get contextCacheSize() {
            return this.contextCache.size;
        }
        getCachedContext(context) {
            return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
        }
        getDecisionToDFA() {
            $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
            return this.decisionToDFA;
        }
        nextTokens(s, ctx) {
            if (ctx) {
                let anal = new $iiE1V.LL1Analyzer(this);
                let next = anal.LOOK(s, ctx);
                return next;
            } else {
                if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
                s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
                s.nextTokenWithinRule.setReadonly(true);
                return s.nextTokenWithinRule;
            }
        }
        addState(state) {
            state.atn = this;
            state.stateNumber = this.states.length;
            this.states.push(state);
        }
        removeState(state) {
            let invalidState = new $l4Nh1.InvalidState();
            invalidState.atn = this;
            invalidState.stateNumber = state.stateNumber;
            this.states[state.stateNumber] = invalidState;
        }
        defineMode(name, s) {
            this.modeNameToStartState.set(name, s);
            this.modeToStartState.push(s);
            this.modeToDFA.push(new $jJRyp.DFA(s));
            this.defineDecisionState(s);
        }
        defineDecisionState(s) {
            this.decisionToState.push(s);
            s.decision = this.decisionToState.length - 1;
            this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
            return s.decision;
        }
        getDecisionState(decision) {
            if (this.decisionToState.length > 0) return this.decisionToState[decision];
            return undefined;
        }
        get numberOfDecisions() {
            return this.decisionToState.length;
        }
        getExpectedTokens(stateNumber, context) {
            if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
            let ctx = context;
            let s = this.states[stateNumber];
            let following = this.nextTokens(s);
            if (!following.contains($2DVsz.Token.EPSILON)) return following;
            let expected = new $hGRod.IntervalSet();
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = this.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = this.nextTokens(rt.followState);
                expected.addAll(following);
                expected.remove($2DVsz.Token.EPSILON);
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
            return expected;
        }
    };
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
        $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
    $82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN);
    module.exports.ATN = $82730d2c6766359c$var$ATN;
    (function(ATN) {
        ATN.INVALID_ALT_NUMBER = 0;
    })($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
    module.exports.ATN = $82730d2c6766359c$var$ATN;
});
parcelRegister("fP17P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashMap = void 0;
    var $7Veax = parcelRequire("7Veax");
    class $b84c7de35a10478c$var$MapKeyEqualityComparator {
        constructor(keyComparator){
            this.keyComparator = keyComparator;
        }
        hashCode(obj) {
            return this.keyComparator.hashCode(obj.key);
        }
        equals(a, b) {
            return this.keyComparator.equals(a.key, b.key);
        }
    }
    class $b84c7de35a10478c$var$Array2DHashMap {
        constructor(keyComparer){
            if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
            else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
        }
        clear() {
            this.backingStore.clear();
        }
        containsKey(key) {
            return this.backingStore.contains({
                key: key
            });
        }
        get(key) {
            let bucket = this.backingStore.get({
                key: key
            });
            if (!bucket) return undefined;
            return bucket.value;
        }
        get isEmpty() {
            return this.backingStore.isEmpty;
        }
        put(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else {
                result = element.value;
                element.value = value;
            }
            return result;
        }
        putIfAbsent(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else result = element.value;
            return result;
        }
        get size() {
            return this.backingStore.size;
        }
        hashCode() {
            return this.backingStore.hashCode();
        }
        equals(o) {
            if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
            return this.backingStore.equals(o.backingStore);
        }
    }
    module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;
});
parcelRegister("jJRyp", function(module, exports) {
    "use strict";
    var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFA = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $c1ClW = parcelRequire("c1ClW");
    var $yhTtv = parcelRequire("yhTtv");
    var $2jevZ = parcelRequire("2jevZ");
    var $aeRGo = parcelRequire("aeRGo");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $f9raX = parcelRequire("f9raX");
    var $3n2FE = parcelRequire("3n2FE");
    let $e5ebc30517b3d229$var$DFA = class DFA {
        constructor(atnStartState, decision = 0){
            this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.nextStateNumber = 0;
            if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
            this.atnStartState = atnStartState;
            this.atn = atnStartState.atn;
            this.decision = decision;
            let isPrecedenceDfa = false;
            if (atnStartState instanceof $f9raX.StarLoopEntryState) {
                if (atnStartState.precedenceRuleDecision) {
                    isPrecedenceDfa = true;
                    this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                    this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                }
            }
            this.precedenceDfa = isPrecedenceDfa;
        }
        get isPrecedenceDfa() {
            return this.precedenceDfa;
        }
        getPrecedenceStartState(precedence, fullContext) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (fullContext) return this.s0full.getTarget(precedence);
            else return this.s0.getTarget(precedence);
        }
        setPrecedenceStartState(precedence, fullContext, startState) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (precedence < 0) return;
            if (fullContext) this.s0full.setTarget(precedence, startState);
            else this.s0.setTarget(precedence, startState);
        }
        get isEmpty() {
            if (this.isPrecedenceDfa) return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
            return this.s0 == null && this.s0full == null;
        }
        get isContextSensitive() {
            if (this.isPrecedenceDfa) return this.s0full.getEdgeMap().size > 0;
            return this.s0full != null;
        }
        addState(state) {
            state.stateNumber = this.nextStateNumber++;
            return this.states.getOrAdd(state);
        }
        toString(vocabulary, ruleNames) {
            if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            if (!this.s0) return "";
            let serializer;
            if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
            else serializer = new $yhTtv.DFASerializer(this, vocabulary);
            return serializer.toString();
        }
        toLexerString() {
            if (!this.s0) return "";
            let serializer = new $aeRGo.LexerDFASerializer(this);
            return serializer.toString();
        }
    };
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
    $e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
        $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
    ], $e5ebc30517b3d229$var$DFA);
    module.exports.DFA = $e5ebc30517b3d229$var$DFA;
});
parcelRegister("c1ClW", function(module, exports) {
    "use strict";
    var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfigSet = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    var $2IEP9 = parcelRequire("2IEP9");
    class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
        hashCode(key) {
            return key.state ^ key.alt;
        }
        equals(a, b) {
            return a.state === b.state && a.alt === b.alt;
        }
    }
    $8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
    function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
        if (map) return new $fP17P.Array2DHashMap(map);
        else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
    }
    class $8c13542112ebfd78$var$ATNConfigSet {
        constructor(set, readonly){
            this._uniqueAlt = 0;
            this._hasSemanticContext = false;
            this._dipsIntoOuterContext = false;
            this.outermostConfigSet = false;
            this.cachedHashCode = -1;
            if (!set) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
                this.configs = [];
                this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            } else {
                if (readonly) {
                    this.mergedConfigs = undefined;
                    this.unmerged = undefined;
                } else if (!set.isReadOnly) {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                    this.unmerged = set.unmerged.slice(0);
                } else {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                    this.unmerged = [];
                }
                this.configs = set.configs.slice(0);
                this._dipsIntoOuterContext = set._dipsIntoOuterContext;
                this._hasSemanticContext = set._hasSemanticContext;
                this.outermostConfigSet = set.outermostConfigSet;
                if (readonly || !set.isReadOnly) {
                    this._uniqueAlt = set._uniqueAlt;
                    this._conflictInfo = set._conflictInfo;
                }
            }
        }
        getRepresentedAlternatives() {
            if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
            let alts = new $5BPMp.BitSet();
            for (let config of this)alts.set(config.alt);
            return alts;
        }
        get isReadOnly() {
            return this.mergedConfigs == null;
        }
        get isOutermostConfigSet() {
            return this.outermostConfigSet;
        }
        set isOutermostConfigSet(outermostConfigSet) {
            if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
            $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
            this.outermostConfigSet = outermostConfigSet;
        }
        getStates() {
            let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            for (let c of this.configs)states.add(c.state);
            return states;
        }
        optimizeConfigs(interpreter) {
            if (this.configs.length === 0) return;
            for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
        }
        clone(readonly) {
            let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this.configs);
            return copy;
        }
        get size() {
            return this.configs.length;
        }
        get isEmpty() {
            return this.configs.length === 0;
        }
        contains(o) {
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (this.mergedConfigs && this.unmerged) {
                let config = o;
                let configKey = this.getKey(config);
                let mergedConfig = this.mergedConfigs.get(configKey);
                if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
                for (let c of this.unmerged){
                    if (c.contains(o)) return true;
                }
            } else for (let c of this.configs){
                if (c.contains(o)) return true;
            }
            return false;
        }
        *[Symbol.iterator]() {
            yield* this.configs;
        }
        toArray() {
            return this.configs;
        }
        add(e, contextCache) {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let addKey;
            let key = this.getKey(e);
            let mergedConfig = this.mergedConfigs.get(key);
            addKey = mergedConfig == null;
            if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
                mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (mergedConfig.context === joined) return false;
                mergedConfig.context = joined;
                return true;
            }
            for(let i = 0; i < this.unmerged.length; i++){
                let unmergedConfig = this.unmerged[i];
                if (this.canMerge(e, key, unmergedConfig)) {
                    unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                    if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                    let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                    this.updatePropertiesForMergedConfig(e);
                    if (unmergedConfig.context === joined) return false;
                    unmergedConfig.context = joined;
                    if (addKey) {
                        this.mergedConfigs.put(key, unmergedConfig);
                        this.unmerged.splice(i, 1);
                    }
                    return true;
                }
            }
            this.configs.push(e);
            if (addKey) this.mergedConfigs.put(key, e);
            else this.unmerged.push(e);
            this.updatePropertiesForAddedConfig(e);
            return true;
        }
        updatePropertiesForMergedConfig(config) {
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        updatePropertiesForAddedConfig(config) {
            if (this.configs.length === 1) this._uniqueAlt = config.alt;
            else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        canMerge(left, leftKey, right) {
            if (left.state.stateNumber !== right.state.stateNumber) return false;
            if (leftKey.alt !== right.alt) return false;
            return left.semanticContext.equals(right.semanticContext);
        }
        getKey(e) {
            return {
                state: e.state.stateNumber,
                alt: e.alt
            };
        }
        containsAll(c) {
            for (let o of c){
                if (!(o instanceof $gcX0f.ATNConfig)) return false;
                if (!this.contains(o)) return false;
            }
            return true;
        }
        addAll(c, contextCache) {
            this.ensureWritable();
            let changed = false;
            for (let group of c)if (this.add(group, contextCache)) changed = true;
            return changed;
        }
        clear() {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            this.mergedConfigs.clear();
            this.unmerged.length = 0;
            this.configs.length = 0;
            this._dipsIntoOuterContext = false;
            this._hasSemanticContext = false;
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._conflictInfo = undefined;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
            return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
        }
        hashCode() {
            if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
            let hashCode = 1;
            hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
            hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
            if (this.isReadOnly) this.cachedHashCode = hashCode;
            return hashCode;
        }
        toString(showContext) {
            if (showContext == null) showContext = false;
            let buf = "";
            let sortedConfigs = this.configs.slice(0);
            sortedConfigs.sort((o1, o2)=>{
                if (o1.alt !== o2.alt) return o1.alt - o2.alt;
                else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
                else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
            });
            buf += "[";
            for(let i = 0; i < sortedConfigs.length; i++){
                if (i > 0) buf += ", ";
                buf += sortedConfigs[i].toString(undefined, true, showContext);
            }
            buf += "]";
            if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
            if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
            if (this._conflictInfo != null) {
                buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
                if (!this._conflictInfo.isExact) buf += "*";
            }
            if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
            return buf.toString();
        }
        get uniqueAlt() {
            return this._uniqueAlt;
        }
        get hasSemanticContext() {
            return this._hasSemanticContext;
        }
        set hasSemanticContext(value) {
            this.ensureWritable();
            this._hasSemanticContext = value;
        }
        get conflictInfo() {
            return this._conflictInfo;
        }
        set conflictInfo(conflictInfo) {
            this.ensureWritable();
            this._conflictInfo = conflictInfo;
        }
        get conflictingAlts() {
            if (this._conflictInfo == null) return undefined;
            return this._conflictInfo.conflictedAlts;
        }
        get isExactConflict() {
            if (this._conflictInfo == null) return false;
            return this._conflictInfo.isExact;
        }
        get dipsIntoOuterContext() {
            return this._dipsIntoOuterContext;
        }
        get(index) {
            return this.configs[index];
        }
        ensureWritable() {
            if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
        }
    }
    $8c13542112ebfd78$var$__decorate([
        $d6D31.NotNull
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
    module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;
});
parcelRegister("gcX0f", function(module, exports) {
    "use strict";
    var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfig = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $dPYn6 = parcelRequire("dPYn6");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
    let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
        constructor(state, altOrConfig, context){
            if (typeof altOrConfig === "number") {
                $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig;
                this._context = context;
            } else {
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
                this._context = context;
            }
        }
        static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
            } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
            else return new ATNConfig(state, alt, context);
        }
        get state() {
            return this._state;
        }
        get alt() {
            return this.altAndOuterContextDepth & 0x00FFFFFF;
        }
        get context() {
            return this._context;
        }
        set context(context) {
            this._context = context;
        }
        get reachesIntoOuterContext() {
            return this.outerContextDepth !== 0;
        }
        get outerContextDepth() {
            return this.altAndOuterContextDepth >>> 24 & 0x7F;
        }
        set outerContextDepth(outerContextDepth) {
            $bbHFU(outerContextDepth >= 0);
            outerContextDepth = Math.min(outerContextDepth, 0x7F);
            this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
        }
        get lexerActionExecutor() {
            return undefined;
        }
        get semanticContext() {
            return $eHMgW.SemanticContext.NONE;
        }
        get hasPassedThroughNonGreedyDecision() {
            return false;
        }
        clone() {
            return this.transform(this.state, false);
        }
        transform(state, checkNonGreedy, arg2) {
            if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
            else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
        }
        transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
            let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
            } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
            else return new ATNConfig(state, this, context);
        }
        static checkNonGreedyDecision(source, target) {
            return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
        }
        appendContext(context, contextCache) {
            if (typeof context === "number") {
                let appendedContext = this.context.appendSingleContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            } else {
                let appendedContext = this.context.appendContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            }
        }
        contains(subconfig) {
            if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
            let leftWorkList = [];
            let rightWorkList = [];
            leftWorkList.push(this.context);
            rightWorkList.push(subconfig.context);
            while(true){
                let left = leftWorkList.pop();
                let right = rightWorkList.pop();
                if (!left || !right) break;
                if (left === right) return true;
                if (left.size < right.size) return false;
                if (right.isEmpty) return left.hasEmpty;
                else for(let i = 0; i < right.size; i++){
                    let index = left.findReturnState(right.getReturnState(i));
                    if (index < 0) return false;
                    leftWorkList.push(left.getParent(index));
                    rightWorkList.push(right.getParent(i));
                }
            }
            return false;
        }
        get isPrecedenceFilterSuppressed() {
            return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
        }
        set isPrecedenceFilterSuppressed(value) {
            if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
            else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ATNConfig)) return false;
            return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
            return hashCode;
        }
        toDotString() {
            let builder = "";
            builder += "digraph G {\n";
            builder += "rankdir=LR;\n";
            let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
            let workList = [];
            function getOrAddContext(context) {
                let newNumber = visited.size;
                let result = visited.putIfAbsent(context, newNumber);
                if (result != null) return result;
                workList.push(context);
                return newNumber;
            }
            workList.push(this.context);
            visited.put(this.context, 0);
            while(true){
                let current = workList.pop();
                if (!current) break;
                for(let i = 0; i < current.size; i++){
                    builder += "  s" + getOrAddContext(current);
                    builder += "->";
                    builder += "s" + getOrAddContext(current.getParent(i));
                    builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
                }
            }
            builder += "}\n";
            return builder.toString();
        }
        toString(recog, showAlt, showContext) {
            if (showContext == null) showContext = showAlt != null;
            if (showAlt == null) showAlt = true;
            let buf = "";
            let contexts;
            if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
            else contexts = [
                "?"
            ];
            let first = true;
            for (let contextDesc of contexts){
                if (first) first = false;
                else buf += ", ";
                buf += "(";
                buf += this.state;
                if (showAlt) {
                    buf += ",";
                    buf += this.alt;
                }
                if (this.context) {
                    buf += ",";
                    buf += contextDesc;
                }
                if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                    buf += ",";
                    buf += this.semanticContext;
                }
                if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
                buf += ")";
            }
            return buf.toString();
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull,
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig, "create", null);
    $bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig);
    module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
    let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(semanticContext, state, altOrConfig, context){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else super(state, altOrConfig, context);
            this._semanticContext = semanticContext;
        }
        get semanticContext() {
            return this._semanticContext;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig);
    let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else {
                super(state, altOrConfig, context);
                if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
            }
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionATNConfig);
    let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
        constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
            else super(semanticContext, state, altOrConfig, context);
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);
});
parcelRegister("dPYn6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DecisionState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.decision = -1;
            this.nonGreedy = false;
            this.sll = false;
        }
    }
    module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;
});
parcelRegister("8DTT0", function(module, exports) {
    "use strict";
    var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $6vF7J = parcelRequire("6vF7J");
    var $bbHFU = parcelRequire("bbHFU");
    const $64ad510fde44ff92$var$INITIAL_HASH = 1;
    class $64ad510fde44ff92$var$PredictionContext {
        constructor(cachedHashCode){
            this.cachedHashCode = cachedHashCode;
        }
        static calculateEmptyHashCode() {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.finish(hash, 0);
            return hash;
        }
        static calculateSingleHashCode(parent, returnState) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.update(hash, parent);
            hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2);
            return hash;
        }
        static calculateHashCode(parents, returnStates) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
            for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
            return hash;
        }
        static fromRuleContext(atn, outerContext, fullContext = true) {
            if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let parent;
            if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
            else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let state = atn.states[outerContext.invokingState];
            let transition = state.transition(0);
            return parent.getChild(transition.followState.stateNumber);
        }
        static addEmptyContext(context) {
            return context.addEmptyContext();
        }
        static removeEmptyContext(context) {
            return context.removeEmptyContext();
        }
        static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
            if (context0 === context1) return context0;
            if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
            else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
            let context0size = context0.size;
            let context1size = context1.size;
            if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
                let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
                if (merged === context0.getParent(0)) return context0;
                else if (merged === context1.getParent(0)) return context1;
                else return merged.getChild(context0.getReturnState(0));
            }
            let count = 0;
            let parentsList = new Array(context0size + context1size);
            let returnStatesList = new Array(parentsList.length);
            let leftIndex = 0;
            let rightIndex = 0;
            let canReturnLeft = true;
            let canReturnRight = true;
            while(leftIndex < context0size && rightIndex < context1size){
                if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                    parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                    canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                    leftIndex++;
                    rightIndex++;
                } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                    parentsList[count] = context0.getParent(leftIndex);
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnRight = false;
                    leftIndex++;
                } else {
                    $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                    parentsList[count] = context1.getParent(rightIndex);
                    returnStatesList[count] = context1.getReturnState(rightIndex);
                    canReturnLeft = false;
                    rightIndex++;
                }
                count++;
            }
            while(leftIndex < context0size){
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                leftIndex++;
                canReturnRight = false;
                count++;
            }
            while(rightIndex < context1size){
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                rightIndex++;
                canReturnLeft = false;
                count++;
            }
            if (canReturnLeft) return context0;
            else if (canReturnRight) return context1;
            if (count < parentsList.length) {
                parentsList = parentsList.slice(0, count);
                returnStatesList = returnStatesList.slice(0, count);
            }
            if (parentsList.length === 0) return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
            else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
            else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
        }
        static isEmptyLocal(context) {
            return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        }
        static getCachedContext(context, contextCache, visited) {
            if (context.isEmpty) return context;
            let existing = visited.get(context);
            if (existing) return existing;
            existing = contextCache.get(context);
            if (existing) {
                visited.put(context, existing);
                return existing;
            }
            let changed = false;
            let parents = new Array(context.size);
            for(let i = 0; i < parents.length; i++){
                let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
                if (changed || parent !== context.getParent(i)) {
                    if (!changed) {
                        parents = new Array(context.size);
                        for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                        changed = true;
                    }
                    parents[i] = parent;
                }
            }
            if (!changed) {
                existing = contextCache.putIfAbsent(context, context);
                visited.put(context, existing != null ? existing : context);
                return context;
            }
            let updated;
            if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
            else {
                let returnStates = new Array(context.size);
                for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
                updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
            }
            existing = contextCache.putIfAbsent(updated, updated);
            visited.put(updated, existing || updated);
            visited.put(context, existing || updated);
            return updated;
        }
        appendSingleContext(returnContext, contextCache) {
            return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
        }
        getChild(returnState) {
            return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
        }
        hashCode() {
            return this.cachedHashCode;
        }
        toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
            let result = [];
            outer: for(let perm = 0;; perm++){
                let offset = 0;
                let last = true;
                let p = this;
                let stateNumber = currentState;
                let localBuffer = "";
                localBuffer += "[";
                while(!p.isEmpty && p !== stop){
                    let index = 0;
                    if (p.size > 0) {
                        let bits = 1;
                        while(1 << bits >>> 0 < p.size)bits++;
                        let mask = (1 << bits >>> 0) - 1;
                        index = perm >> offset & mask;
                        last = last && index >= p.size - 1;
                        if (index >= p.size) continue outer;
                        offset += bits;
                    }
                    if (recognizer) {
                        if (localBuffer.length > 1) localBuffer += " ";
                        let atn = recognizer.atn;
                        let s = atn.states[stateNumber];
                        let ruleName = recognizer.ruleNames[s.ruleIndex];
                        localBuffer += ruleName;
                    } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                        if (!p.isEmpty) {
                            if (localBuffer.length > 1) localBuffer += " ";
                            localBuffer += p.getReturnState(index);
                        }
                    }
                    stateNumber = p.getReturnState(index);
                    p = p.getParent(index);
                }
                localBuffer += "]";
                result.push(localBuffer);
                if (last) break;
            }
            return result;
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "join", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
    module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
    class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(fullContext){
            super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
            this.fullContext = fullContext;
        }
        get isFullContext() {
            return this.fullContext;
        }
        addEmptyContext() {
            return this;
        }
        removeEmptyContext() {
            throw new Error("Cannot remove the empty context from itself.");
        }
        getParent(index) {
            throw new Error("index out of bounds");
        }
        getReturnState(index) {
            throw new Error("index out of bounds");
        }
        findReturnState(returnState) {
            return -1;
        }
        get size() {
            return 0;
        }
        appendSingleContext(returnContext, contextCache) {
            return contextCache.getChild(this, returnContext);
        }
        appendContext(suffix, contextCache) {
            return suffix;
        }
        get isEmpty() {
            return true;
        }
        get hasEmpty() {
            return true;
        }
        equals(o) {
            return this === o;
        }
        toStrings(recognizer, currentState, stop) {
            return [
                "[]"
            ];
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
    let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parents, returnStates, hashCode){
            super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
            $bbHFU(parents.length === returnStates.length);
            $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
            this.parents = parents;
            this.returnStates = returnStates;
        }
        getParent(index) {
            return this.parents[index];
        }
        getReturnState(index) {
            return this.returnStates[index];
        }
        findReturnState(returnState) {
            return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
        }
        get size() {
            return this.returnStates.length;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        addEmptyContext() {
            if (this.hasEmpty) return this;
            let parents2 = this.parents.slice(0);
            let returnStates2 = this.returnStates.slice(0);
            parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
            returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
        removeEmptyContext() {
            if (!this.hasEmpty) return this;
            if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
            else {
                let parents2 = this.parents.slice(0, this.parents.length - 1);
                let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
                return new ArrayPredictionContext(parents2, returnStates2);
            }
        }
        appendContext(suffix, contextCache) {
            return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
        }
        static appendContextImpl(context, suffix, visited) {
            if (suffix.isEmpty) {
                if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                    if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                    throw new Error("what to do here?");
                }
                return context;
            }
            if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
            let result = visited.get(context);
            if (!result) {
                if (context.isEmpty) result = suffix;
                else {
                    let parentCount = context.size;
                    if (context.hasEmpty) parentCount--;
                    let updatedParents = new Array(parentCount);
                    let updatedReturnStates = new Array(parentCount);
                    for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                    for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                    if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                    else {
                        $bbHFU(updatedParents.length > 1);
                        result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                    }
                    if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
                }
                visited.put(context, result);
            }
            return result;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ArrayPredictionContext)) return false;
            if (this.hashCode() !== o.hashCode()) return false;
            let other = o;
            return this.equalsImpl(other, new $7Veax.Array2DHashSet());
        }
        equalsImpl(other, visited) {
            let selfWorkList = [];
            let otherWorkList = [];
            selfWorkList.push(this);
            otherWorkList.push(other);
            while(true){
                let currentSelf = selfWorkList.pop();
                let currentOther = otherWorkList.pop();
                if (!currentSelf || !currentOther) break;
                let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
                if (!visited.add(operands)) continue;
                let selfSize = operands.x.size;
                if (selfSize === 0) {
                    if (!operands.x.equals(operands.y)) return false;
                    continue;
                }
                let otherSize = operands.y.size;
                if (selfSize !== otherSize) return false;
                for(let i = 0; i < selfSize; i++){
                    if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                    let selfParent = operands.x.getParent(i);
                    let otherParent = operands.y.getParent(i);
                    if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                    if (selfParent !== otherParent) {
                        selfWorkList.push(selfParent);
                        otherWorkList.push(otherParent);
                    }
                }
            }
            return true;
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$ArrayPredictionContext);
    let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parent, returnState){
            super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
            this.parent = parent;
            this.returnState = returnState;
        }
        getParent(index) {
            return this.parent;
        }
        getReturnState(index) {
            return this.returnState;
        }
        findReturnState(returnState) {
            return this.returnState === returnState ? 0 : -1;
        }
        get size() {
            return 1;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return false;
        }
        appendContext(suffix, contextCache) {
            return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
        }
        addEmptyContext() {
            let parents = [
                this.parent,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
            ];
            let returnStates = [
                this.returnState,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
            ];
            return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
        }
        removeEmptyContext() {
            return this;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof SingletonPredictionContext)) return false;
            let other = o;
            if (this.hashCode() !== other.hashCode()) return false;
            return this.returnState === other.returnState && this.parent.equals(other.parent);
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$SingletonPredictionContext);
    module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
    (function(PredictionContext) {
        PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
        PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
        PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
        PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
        class IdentityHashMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(IdentityEqualityComparator.INSTANCE);
            }
        }
        PredictionContext.IdentityHashMap = IdentityHashMap;
        class IdentityEqualityComparator {
            IdentityEqualityComparator() {}
            hashCode(obj) {
                return obj.hashCode();
            }
            equals(a, b) {
                return a === b;
            }
        }
        IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "hashCode", null);
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "equals", null);
        PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
    })($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));
});
parcelRegister("6vF7J", function(module, exports) {
    "use strict";
    var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionContextCache = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $4bd589a149816580$var$PredictionContextCache {
        constructor(enableCache = true){
            this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.enableCache = enableCache;
        }
        getAsCached(context) {
            if (!this.enableCache) return context;
            let result = this.contexts.get(context);
            if (!result) {
                result = context;
                this.contexts.put(context, context);
            }
            return result;
        }
        getChild(context, invokingState) {
            if (!this.enableCache) return context.getChild(invokingState);
            let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
            let result = this.childContexts.get(operands);
            if (!result) {
                result = context.getChild(invokingState);
                result = this.getAsCached(result);
                this.childContexts.put(operands, result);
            }
            return result;
        }
        join(x, y) {
            if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
            let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
            let result = this.joinContexts.get(operands);
            if (result) return result;
            result = $8DTT0.PredictionContext.join(x, y, this);
            result = this.getAsCached(result);
            this.joinContexts.put(operands, result);
            return result;
        }
    }
    module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
    $4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
    (function(PredictionContextCache) {
        class PredictionContextAndInt {
            constructor(obj, value){
                this.obj = obj;
                this.value = value;
            }
            equals(obj) {
                if (!(obj instanceof PredictionContextAndInt)) return false;
                else if (obj === this) return true;
                let other = obj;
                return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
            }
            hashCode() {
                let hashCode = 5;
                hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
                hashCode = 7 * hashCode + this.value;
                return hashCode;
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "hashCode", null);
        PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
        class IdentityCommutativePredictionContextOperands {
            constructor(x, y){
                $bbHFU(x != null);
                $bbHFU(y != null);
                this._x = x;
                this._y = y;
            }
            get x() {
                return this._x;
            }
            get y() {
                return this._y;
            }
            equals(o) {
                if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
                else if (this === o) return true;
                let other = o;
                return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
            }
            hashCode() {
                return this._x.hashCode() ^ this._y.hashCode();
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
        PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
    })($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));
});
parcelRegister("5BPMp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BitSet = void 0;
    var $9kAQu = parcelRequire("9kAQu");
    var $iXFjm = parcelRequire("iXFjm");
    const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
    function $415892d73e8925a4$var$getIndex(bitNumber) {
        return bitNumber >>> 4;
    }
    function $415892d73e8925a4$var$unIndex(n) {
        return n * 16;
    }
    function $415892d73e8925a4$var$findLSBSet(word) {
        let bit = 1;
        for(let i = 0; i < 16; i++){
            if ((word & bit) !== 0) return i;
            bit = bit << 1 >>> 0;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$findMSBSet(word) {
        let bit = 32768;
        for(let i = 15; i >= 0; i--){
            if ((word & bit) !== 0) return i;
            bit = bit >>> 1;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
        fromBit &= 0xF;
        toBit &= 0xF;
        if (fromBit === toBit) return 1 << fromBit >>> 0;
        return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
    }
    const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
    for(let i = 0; i < 16; i++){
        const stride = 1 << i >>> 0;
        let index = 0;
        while(index < $415892d73e8925a4$var$POP_CNT.length){
            index += stride;
            for(let j = 0; j < stride; j++){
                $415892d73e8925a4$var$POP_CNT[index]++;
                index++;
            }
        }
    }
    class $415892d73e8925a4$var$BitSet {
        constructor(arg){
            if (!arg) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (typeof arg === "number") {
                if (arg < 0) throw new RangeError("nbits cannot be negative");
                else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
            } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0);
            else {
                let max = -1;
                for (let v of arg)if (max < v) max = v;
                this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
                for (let v of arg)this.set(v);
            }
        }
        and(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        andNot(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i] ^ 0xFFFF;
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        cardinality() {
            if (this.isEmpty) return 0;
            const data = this.data;
            const length = data.length;
            let result = 0;
            for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
            return result;
        }
        clear(fromIndex, toIndex) {
            if (fromIndex == null) this.data.fill(0);
            else if (toIndex == null) this.set(fromIndex, false);
            else this.set(fromIndex, toIndex, false);
        }
        flip(fromIndex, toIndex) {
            if (toIndex == null) toIndex = fromIndex;
            if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
            else {
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
                while(word < lastWord)this.data[word++] ^= 0xFFFF;
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
            }
        }
        get(fromIndex, toIndex) {
            if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
            else {
                let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
                for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
                return result;
            }
        }
        intersects(set) {
            let smallerLength = Math.min(this.length(), set.length());
            if (smallerLength === 0) return false;
            let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
            for(let i = 0; i <= bound; i++){
                if ((this.data[i] & set.data[i]) !== 0) return true;
            }
            return false;
        }
        get isEmpty() {
            return this.length() === 0;
        }
        length() {
            if (!this.data.length) return 0;
            return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
        }
        nextClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] | ignore) === 0xFFFF) {
                word++;
                ignore = 0;
                for(; word < length; word++){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word === length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        nextSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] & mask) === 0) {
                word++;
                mask = 0xFFFF;
                for(; word < length; word++){
                    if (data[word] !== 0) break;
                }
                if (word >= length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
        }
        or(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] | other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord);
        }
        previousClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] | ignore) === 0xFFFF) {
                ignore = 0;
                word--;
                for(; word >= 0; word--){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        previousSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] & mask) === 0) {
                word--;
                mask = 0xFFFF;
                for(; word >= 0; word--){
                    if (data[word] !== 0) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
        }
        set(fromIndex, toIndex, value) {
            if (toIndex === undefined) {
                toIndex = fromIndex;
                value = true;
            } else if (typeof toIndex === "boolean") {
                value = toIndex;
                toIndex = fromIndex;
            }
            if (value === undefined) value = true;
            if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (value && lastWord >= this.data.length) {
                let temp = new Uint16Array(lastWord + 1);
                this.data.forEach((value, index)=>temp[index] = value);
                this.data = temp;
            } else if (!value) {
                if (word >= this.data.length) return;
                if (lastWord >= this.data.length) {
                    lastWord = this.data.length - 1;
                    toIndex = this.data.length * 16 - 1;
                }
            }
            if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
            else {
                this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
                while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
                this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
            }
        }
        _setBits(word, value, mask) {
            if (value) this.data[word] |= mask;
            else this.data[word] &= 0xFFFF ^ mask;
        }
        get size() {
            return this.data.byteLength * 8;
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.data, 22);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
            const len = this.length();
            if (len !== obj.length()) return false;
            if (len === 0) return true;
            let bound = $415892d73e8925a4$var$getIndex(len - 1);
            for(let i = 0; i <= bound; i++){
                if (this.data[i] !== obj.data[i]) return false;
            }
            return true;
        }
        toString() {
            let result = "{";
            let first = true;
            for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
                if (first) first = false;
                else result += ", ";
                result += i;
            }
            result += "}";
            return result;
        }
        xor(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] ^ other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord + 1);
        }
        clone() {
            return new $415892d73e8925a4$var$BitSet(this);
        }
        [Symbol.iterator]() {
            return new $415892d73e8925a4$var$BitSetIterator(this.data);
        }
        [$9kAQu.inspect.custom]() {
            return "BitSet " + this.toString();
        }
    }
    module.exports.BitSet = $415892d73e8925a4$var$BitSet;
    class $415892d73e8925a4$var$BitSetIterator {
        constructor(data){
            this.data = data;
            this.index = 0;
            this.mask = 0xFFFF;
        }
        next() {
            while(this.index < this.data.length){
                const bits = this.data[this.index] & this.mask;
                if (bits !== 0) {
                    const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                    this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                    return {
                        done: false,
                        value: bitNumber
                    };
                }
                this.index++;
                this.mask = 0xFFFF;
            }
            return {
                done: true,
                value: -1
            };
        }
        [Symbol.iterator]() {
            return this;
        }
    }
});
parcelRegister("yhTtv", function(module, exports) {
    "use strict";
    var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFASerializer = void 0;
    var $kr9A1 = parcelRequire("kr9A1");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $3n2FE = parcelRequire("3n2FE");
    class $06710e6ae1da410a$var$DFASerializer {
        constructor(dfa, vocabulary, ruleNames, atn){
            if (vocabulary instanceof $kBaAZ.Recognizer) {
                ruleNames = vocabulary.ruleNames;
                atn = vocabulary.atn;
                vocabulary = vocabulary.vocabulary;
            } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            this.dfa = dfa;
            this.vocabulary = vocabulary;
            this.ruleNames = ruleNames;
            this.atn = atn;
        }
        toString() {
            if (!this.dfa.s0) return "";
            let buf = "";
            if (this.dfa.states) {
                let states = new Array(...this.dfa.states.toArray());
                states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
                for (let s of states){
                    let edges = s.getEdgeMap();
                    let edgeKeys = [
                        ...edges.keys()
                    ].sort((a, b)=>a - b);
                    let contextEdges = s.getContextEdgeMap();
                    let contextEdgeKeys = [
                        ...contextEdges.keys()
                    ].sort((a, b)=>a - b);
                    for (let entry of edgeKeys){
                        let value = edges.get(entry);
                        if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                        let contextSymbol = false;
                        buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                        if (s.isContextSymbol(entry)) {
                            buf += "!";
                            contextSymbol = true;
                        }
                        let t = value;
                        if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                        else if (contextSymbol) buf += "ctx\n";
                    }
                    if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
                }
            }
            let output = buf;
            if (output.length === 0) return "";
            return output;
        }
        getContextLabel(i) {
            if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
            else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
            if (this.atn && i > 0 && i <= this.atn.states.length) {
                let state = this.atn.states[i];
                let ruleIndex = state.ruleIndex;
                if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
            }
            return "ctx:" + String(i);
        }
        getEdgeLabel(i) {
            return this.vocabulary.getDisplayName(i);
        }
        getStateString(s) {
            if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
            let n = s.stateNumber;
            let stateStr = "s" + n;
            if (s.isAcceptState) {
                if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
                else stateStr = ":s" + n + "=>" + s.prediction;
            }
            if (s.isContextSensitive) {
                stateStr += "*";
                for (let config of s.configs)if (config.reachesIntoOuterContext) {
                    stateStr += "*";
                    break;
                }
            }
            return stateStr;
        }
    }
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.Override
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
    module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;
});
parcelRegister("kr9A1", function(module, exports) {
    "use strict";
    var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNSimulator = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $2jevZ = parcelRequire("2jevZ");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
        constructor(atn){
            this.atn = atn;
        }
        static get ERROR() {
            if (!ATNSimulator._ERROR) {
                ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            }
            return ATNSimulator._ERROR;
        }
        clearDFA() {
            this.atn.clearDFA();
        }
    };
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
    $ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
        $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
    ], $ee0dc2a763a7368a$var$ATNSimulator);
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
    (function(ATNSimulator) {
        const RULE_VARIANT_DELIMITER = "$";
        const RULE_LF_VARIANT_MARKER = "$lf$";
        const RULE_NOLF_VARIANT_MARKER = "$nolf$";
    })($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
});
parcelRegister("2jevZ", function(module, exports) {
    "use strict";
    var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFAState = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $5BPMp = parcelRequire("5BPMp");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $1ae89d7ac78d8bff$var$DFAState {
        constructor(configs){
            this.stateNumber = -1;
            this.configs = configs;
            this.edges = new Map();
            this.contextEdges = new Map();
        }
        get isContextSensitive() {
            return !!this.contextSymbols;
        }
        isContextSymbol(symbol) {
            if (!this.isContextSensitive) return false;
            return this.contextSymbols.get(symbol);
        }
        setContextSymbol(symbol) {
            $bbHFU(this.isContextSensitive);
            this.contextSymbols.set(symbol);
        }
        setContextSensitive(atn) {
            $bbHFU(!this.configs.isOutermostConfigSet);
            if (this.isContextSensitive) return;
            if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
        }
        get acceptStateInfo() {
            return this._acceptStateInfo;
        }
        set acceptStateInfo(acceptStateInfo) {
            this._acceptStateInfo = acceptStateInfo;
        }
        get isAcceptState() {
            return !!this._acceptStateInfo;
        }
        get prediction() {
            if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            return this._acceptStateInfo.prediction;
        }
        get lexerActionExecutor() {
            if (!this._acceptStateInfo) return undefined;
            return this._acceptStateInfo.lexerActionExecutor;
        }
        getTarget(symbol) {
            return this.edges.get(symbol);
        }
        setTarget(symbol, target) {
            this.edges.set(symbol, target);
        }
        getEdgeMap() {
            return this.edges;
        }
        getContextTarget(invokingState) {
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            return this.contextEdges.get(invokingState);
        }
        setContextTarget(invokingState, target) {
            if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            this.contextEdges.set(invokingState, target);
        }
        getContextEdgeMap() {
            let map = new Map(this.contextEdges);
            let existing = map.get(-1);
            if (existing !== undefined) {
                if (map.size === 1) {
                    let result = new Map();
                    result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                    return result;
                } else {
                    map.delete(-1);
                    map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                }
            }
            return map;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize(7);
            hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
            hash = $iXFjm.MurmurHash.finish(hash, 1);
            return hash;
        }
        equals(o) {
            if (this === o) return true;
            if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
            let other = o;
            let sameSet = this.configs.equals(other.configs);
            return sameSet;
        }
        toString() {
            let buf = "";
            buf += this.stateNumber + ":" + this.configs;
            if (this.isAcceptState) {
                buf += "=>";
                if (this.predicates) buf += this.predicates;
                else buf += this.prediction;
            }
            return buf.toString();
        }
    }
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
    module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
    (function(DFAState) {
        let PredPrediction = class PredPrediction {
            constructor(pred, alt){
                this.alt = alt;
                this.pred = pred;
            }
            toString() {
                return "(" + this.pred + ", " + this.alt + ")";
            }
        };
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.NotNull
        ], PredPrediction.prototype, "pred", void 0);
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.Override
        ], PredPrediction.prototype, "toString", null);
        PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
            $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
        ], PredPrediction);
        DFAState.PredPrediction = PredPrediction;
    })($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));
});
parcelRegister("kBaAZ", function(module, exports) {
    "use strict";
    var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Recognizer = void 0;
    var $e5mHr = parcelRequire("e5mHr");
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $efef7b6bec20bc2a$var$Recognizer {
        constructor(){
            this._listeners = [
                $e5mHr.ConsoleErrorListener.INSTANCE
            ];
            this._stateNumber = -1;
        }
        getTokenTypeMap() {
            let vocabulary = this.vocabulary;
            let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
            if (result == null) {
                let intermediateResult = new Map();
                for(let i = 0; i <= this.atn.maxTokenType; i++){
                    let literalName = vocabulary.getLiteralName(i);
                    if (literalName != null) intermediateResult.set(literalName, i);
                    let symbolicName = vocabulary.getSymbolicName(i);
                    if (symbolicName != null) intermediateResult.set(symbolicName, i);
                }
                intermediateResult.set("EOF", $2DVsz.Token.EOF);
                result = intermediateResult;
                $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
            }
            return result;
        }
        getRuleIndexMap() {
            let ruleNames = this.ruleNames;
            if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
            let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
            if (result == null) {
                result = $2IEP9.toMap(ruleNames);
                $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
            }
            return result;
        }
        getTokenType(tokenName) {
            let ttype = this.getTokenTypeMap().get(tokenName);
            if (ttype != null) return ttype;
            return $2DVsz.Token.INVALID_TYPE;
        }
        get serializedATN() {
            throw new Error("there is no serialized ATN");
        }
        get atn() {
            return this._interp.atn;
        }
        get interpreter() {
            return this._interp;
        }
        set interpreter(interpreter) {
            this._interp = interpreter;
        }
        get parseInfo() {
            return Promise.resolve(undefined);
        }
        getErrorHeader(e) {
            let token = e.getOffendingToken();
            if (!token) return "";
            let line = token.line;
            let charPositionInLine = token.charPositionInLine;
            return "line " + line + ":" + charPositionInLine;
        }
        addErrorListener(listener) {
            if (!listener) throw new TypeError("listener must not be null");
            this._listeners.push(listener);
        }
        removeErrorListener(listener) {
            let position = this._listeners.indexOf(listener);
            if (position !== -1) this._listeners.splice(position, 1);
        }
        removeErrorListeners() {
            this._listeners.length = 0;
        }
        getErrorListeners() {
            return this._listeners.slice(0);
        }
        getErrorListenerDispatch() {
            return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
        }
        sempred(_localctx, ruleIndex, actionIndex) {
            return true;
        }
        precpred(localctx, precedence) {
            return true;
        }
        action(_localctx, ruleIndex, actionIndex) {}
        get state() {
            return this._stateNumber;
        }
        set state(atnState) {
            this._stateNumber = atnState;
        }
    }
    $efef7b6bec20bc2a$var$Recognizer.EOF = -1;
    $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.SuppressWarnings("serial"),
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
    module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;
});
parcelRegister("e5mHr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConsoleErrorListener = void 0;
    class $a413240156cc2e50$var$ConsoleErrorListener {
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            console.error(`line ${line}:${charPositionInLine} ${msg}`);
        }
    }
    module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
    $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();
});
parcelRegister("65iNZ", function(module, exports) {
    "use strict";
    var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyErrorListener = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
        constructor(delegates){
            this.delegates = delegates;
            if (!delegates) throw new Error("Invalid delegates");
        }
        getDelegates() {
            return this.delegates;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            this.delegates.forEach((listener)=>{
                if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
            });
        }
    }
    $46e1cc07c7f5b3d6$var$__decorate([
        $d6D31.Override,
        $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
        $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
    ], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
    module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;
});
parcelRegister("3n2FE", function(module, exports) {
    "use strict";
    var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.VocabularyImpl = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $27459777e7d4e735$var$VocabularyImpl {
        constructor(literalNames, symbolicNames, displayNames){
            this.literalNames = literalNames;
            this.symbolicNames = symbolicNames;
            this.displayNames = displayNames;
            this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
        }
        get maxTokenType() {
            return this._maxTokenType;
        }
        getLiteralName(tokenType) {
            if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
            return undefined;
        }
        getSymbolicName(tokenType) {
            if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
            if (tokenType === $2DVsz.Token.EOF) return "EOF";
            return undefined;
        }
        getDisplayName(tokenType) {
            if (tokenType >= 0 && tokenType < this.displayNames.length) {
                let displayName = this.displayNames[tokenType];
                if (displayName) return displayName;
            }
            let literalName = this.getLiteralName(tokenType);
            if (literalName) return literalName;
            let symbolicName = this.getSymbolicName(tokenType);
            if (symbolicName) return symbolicName;
            return String(tokenType);
        }
    }
    $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
    module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;
});
parcelRegister("aeRGo", function(module, exports) {
    "use strict";
    var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerDFASerializer = void 0;
    var $yhTtv = parcelRequire("yhTtv");
    var $d6D31 = parcelRequire("d6D31");
    var $3n2FE = parcelRequire("3n2FE");
    let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
        constructor(dfa){
            super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
        }
        getEdgeLabel(i) {
            return "'" + String.fromCodePoint(i) + "'";
        }
    };
    $7744da7bed4bb192$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
    $7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
        $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
    ], $7744da7bed4bb192$var$LexerDFASerializer);
    module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;
});
parcelRegister("f9raX", function(module, exports) {
    "use strict";
    var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopEntryState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
        constructor(){
            super(...arguments);
            this.precedenceRuleDecision = false;
            this.precedenceLoopbackStates = new $5BPMp.BitSet();
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
        }
    }
    $b07cc6cfd56668a7$var$__decorate([
        $d6D31.Override
    ], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
    module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;
});
parcelRegister("l4Nh1", function(module, exports) {
    "use strict";
    var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InvalidState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $d6D31 = parcelRequire("d6D31");
    class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
        get stateType() {
            return $1bs3X.ATNStateType.INVALID_TYPE;
        }
    }
    $f580316b3d8851ef$var$__decorate([
        $d6D31.Override
    ], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
    module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;
});
parcelRegister("4yiuQ", function(module, exports) {
    "use strict";
    var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BASIC;
        }
    }
    $3508af691e74fe3f$var$__decorate([
        $d6D31.Override
    ], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
    module.exports.BasicState = $3508af691e74fe3f$var$BasicState;
});
parcelRegister("iiE1V", function(module, exports) {
    "use strict";
    var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LL1Analyzer = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $7Veax = parcelRequire("7Veax");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $2DVsz = parcelRequire("2DVsz");
    var $aPmi9 = parcelRequire("aPmi9");
    let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
        constructor(atn){
            this.atn = atn;
        }
        getDecisionLookahead(s) {
            if (s == null) return undefined;
            let look = new Array(s.numberOfTransitions);
            for(let alt = 0; alt < s.numberOfTransitions; alt++){
                let current = new $hGRod.IntervalSet();
                look[alt] = current;
                let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                let seeThruPreds = false;
                this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
                if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                    current = undefined;
                    look[alt] = current;
                }
            }
            return look;
        }
        LOOK(s, ctx, stopState) {
            if (stopState === undefined) {
                if (s.atn == null) throw new Error("Illegal state");
                stopState = s.atn.ruleToStopState[s.ruleIndex];
            } else if (stopState === null) stopState = undefined;
            let r = new $hGRod.IntervalSet();
            let seeThruPreds = true;
            let addEOF = true;
            this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
            return r;
        }
        _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
            let c = $gcX0f.ATNConfig.create(s, 0, ctx);
            if (!lookBusy.add(c)) return;
            if (s === stopState) {
                if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    look.add($2DVsz.Token.EPSILON);
                    return;
                } else if (ctx.isEmpty) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
            }
            if (s instanceof $4kGBm.RuleStopState) {
                if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
                let removed = calledRuleStack.get(s.ruleIndex);
                try {
                    calledRuleStack.clear(s.ruleIndex);
                    for(let i = 0; i < ctx.size; i++){
                        if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                        let returnState = this.atn.states[ctx.getReturnState(i)];
                        this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    }
                } finally{
                    if (removed) calledRuleStack.set(s.ruleIndex);
                }
            }
            let n = s.numberOfTransitions;
            for(let i = 0; i < n; i++){
                let t = s.transition(i);
                if (t instanceof $aybFP.RuleTransition) {
                    if (calledRuleStack.get(t.ruleIndex)) continue;
                    let newContext = ctx.getChild(t.followState.stateNumber);
                    try {
                        calledRuleStack.set(t.ruleIndex);
                        this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    } finally{
                        calledRuleStack.clear(t.ruleIndex);
                    }
                } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                    if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    else look.add(LL1Analyzer.HIT_PRED);
                } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                else {
                    let set = t.label;
                    if (set != null) {
                        if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                        look.addAll(set);
                    }
                }
            }
        }
    };
    $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull,
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
    $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
    $d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer);
    module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;
});
parcelRegister("FLEKS", function(module, exports) {
    "use strict";
    var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NotSetTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $Np2R3 = parcelRequire("Np2R3");
    let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
        constructor(target, set){
            super(target, set);
        }
        get serializationType() {
            return 8;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
        }
        toString() {
            return "~" + super.toString();
        }
    };
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
    $07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
        $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
        $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
    ], $07d8cc01972b24a7$var$NotSetTransition);
    module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;
});
parcelRegister("Np2R3", function(module, exports) {
    "use strict";
    var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SetTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
        constructor(target, set){
            super(target);
            if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
            this.set = set;
        }
        get serializationType() {
            return 7;
        }
        get label() {
            return this.set;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this.set.contains(symbol);
        }
        toString() {
            return this.set.toString();
        }
    };
    $094801244c2d1a04$var$__decorate([
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
    $094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
        $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
        $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
    ], $094801244c2d1a04$var$SetTransition);
    module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;
});
parcelRegister("4kGBm", function(module, exports) {
    "use strict";
    var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStopState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
        get nonStopStateNumber() {
            return -1;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_STOP;
        }
    }
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
    module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;
});
parcelRegister("aybFP", function(module, exports) {
    "use strict";
    var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
        constructor(ruleStart, ruleIndex, precedence, followState){
            super(ruleStart);
            this.tailCall = false;
            this.optimizedTailCall = false;
            this.ruleIndex = ruleIndex;
            this.precedence = precedence;
            this.followState = followState;
        }
        get serializationType() {
            return 3;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
    };
    $7ae622834621fa3c$var$__decorate([
        $d6D31.NotNull
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
    $7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
        $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
        $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
    ], $7ae622834621fa3c$var$RuleTransition);
    module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;
});
parcelRegister("aPmi9", function(module, exports) {
    "use strict";
    var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.WildcardTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
        get serializationType() {
            return 9;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
        }
        toString() {
            return ".";
        }
    };
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
    $7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
        $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
    ], $7e1ff581bbf7382f$var$WildcardTransition);
    module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;
});
parcelRegister("3AYVu", function(module, exports) {
    "use strict";
    var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerActionExecutor = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $4LVXs = parcelRequire("4LVXs");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
        constructor(lexerActions){
            this._lexerActions = lexerActions;
            let hash = $iXFjm.MurmurHash.initialize();
            for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
            this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
        }
        static append(lexerActionExecutor, lexerAction) {
            if (!lexerActionExecutor) return new LexerActionExecutor([
                lexerAction
            ]);
            let lexerActions = lexerActionExecutor._lexerActions.slice(0);
            lexerActions.push(lexerAction);
            return new LexerActionExecutor(lexerActions);
        }
        fixOffsetBeforeMatch(offset) {
            let updatedLexerActions;
            for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
                if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
                updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
            }
            if (!updatedLexerActions) return this;
            return new LexerActionExecutor(updatedLexerActions);
        }
        get lexerActions() {
            return this._lexerActions;
        }
        execute(lexer, input, startIndex) {
            let requiresSeek = false;
            let stopIndex = input.index;
            try {
                for (let lexerAction of this._lexerActions){
                    if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                        let offset = lexerAction.offset;
                        input.seek(startIndex + offset);
                        lexerAction = lexerAction.action;
                        requiresSeek = startIndex + offset !== stopIndex;
                    } else if (lexerAction.isPositionDependent) {
                        input.seek(stopIndex);
                        requiresSeek = false;
                    }
                    lexerAction.execute(lexer);
                }
            } finally{
                if (requiresSeek) input.seek(stopIndex);
            }
        }
        hashCode() {
            return this.cachedHashCode;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerActionExecutor)) return false;
            return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
        }
    };
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
    $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull,
        $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
    $29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor);
    module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;
});
parcelRegister("4LVXs", function(module, exports) {
    "use strict";
    var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerIndexedCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
        constructor(offset, action){
            this._offset = offset;
            this._action = action;
        }
        get offset() {
            return this._offset;
        }
        get action() {
            return this._action;
        }
        get actionType() {
            return this._action.actionType;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            this._action.execute(lexer);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this._offset);
            hash = $iXFjm.MurmurHash.update(hash, this._action);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerIndexedCustomAction)) return false;
            return this._offset === obj._offset && this._action.equals(obj._action);
        }
    };
    $3798827adeb28bf0$var$__decorate([
        $d6D31.NotNull
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
    $3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
        $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction);
    module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;
});
parcelRegister("fOEQQ", function(module, exports) {
    "use strict";
    var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerNoViableAltException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    var $2IEP9 = parcelRequire("2IEP9");
    let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
        constructor(lexer, input, startIndex, deadEndConfigs){
            super(lexer, input);
            this._startIndex = startIndex;
            this._deadEndConfigs = deadEndConfigs;
        }
        get startIndex() {
            return this._startIndex;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
        get inputStream() {
            return super.inputStream;
        }
        toString() {
            let symbol = "";
            if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
                symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
                symbol = $2IEP9.escapeWhitespace(symbol, false);
            }
            return `LexerNoViableAltException('${symbol}')`;
        }
    };
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
    $b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
        $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
    ], $b83b36c534666cfd$var$LexerNoViableAltException);
    module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;
});
parcelRegister("9tIYC", function(module, exports) {
    "use strict";
    var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.OrderedATNConfigSet = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $d6D31 = parcelRequire("d6D31");
    class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
        constructor(set, readonly){
            if (set != null && readonly != null) super(set, readonly);
            else super();
        }
        clone(readonly) {
            let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this);
            return copy;
        }
        getKey(e) {
            return {
                state: 0,
                alt: e.hashCode()
            };
        }
        canMerge(left, leftKey, right) {
            return left.equals(right);
        }
    }
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
    module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;
});
parcelRegister("hKCjP", function(module, exports) {
    "use strict";
    var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NoViableAltException = void 0;
    var $jIG0W = parcelRequire("jIG0W");
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
        constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
            if (recognizer instanceof $jIG0W.Parser) {
                if (input === undefined) input = recognizer.inputStream;
                if (startToken === undefined) startToken = recognizer.currentToken;
                if (offendingToken === undefined) offendingToken = recognizer.currentToken;
                if (ctx === undefined) ctx = recognizer.context;
            }
            super(recognizer, input, ctx);
            this._deadEndConfigs = deadEndConfigs;
            this._startToken = startToken;
            this.setOffendingToken(recognizer, offendingToken);
        }
        get startToken() {
            return this._startToken;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
    }
    $cec474d99a10f341$var$__decorate([
        $d6D31.NotNull
    ], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
    module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;
});
parcelRegister("jIG0W", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Parser = void 0;
    var $2IEP9 = parcelRequire("2IEP9");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $dvgsl = parcelRequire("dvgsl");
    var $4CCJj = parcelRequire("4CCJj");
    var $cdCft = parcelRequire("cdCft");
    var $6Kebn = parcelRequire("6Kebn");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $3iOjI = parcelRequire("3iOjI");
    var $kzbnL = parcelRequire("kzbnL");
    var $5xwgp = parcelRequire("5xwgp");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    class $e5b2b780657df507$var$TraceListener {
        constructor(ruleNames, tokenStream){
            this.ruleNames = ruleNames;
            this.tokenStream = tokenStream;
        }
        enterEveryRule(ctx) {
            console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        exitEveryRule(ctx) {
            console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        visitErrorNode(node) {}
        visitTerminal(node) {
            let parent = node.parent.ruleContext;
            let token = node.symbol;
            console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
        }
    }
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);
    class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._errHandler = new $4CCJj.DefaultErrorStrategy();
            this._precedenceStack = new $6Kebn.IntegerStack();
            this._buildParseTrees = true;
            this._parseListeners = [];
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this._precedenceStack.push(0);
            this.inputStream = input;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this.inputStream.seek(0);
            this._errHandler.reset(this);
            this._ctx = undefined;
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this.isTrace = false;
            this._precedenceStack.clear();
            this._precedenceStack.push(0);
            let interpreter = this.interpreter;
            if (interpreter != null) interpreter.reset();
        }
        match(ttype) {
            let t = this.currentToken;
            if (t.type === ttype) {
                if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        matchWildcard() {
            let t = this.currentToken;
            if (t.type > 0) {
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        set buildParseTree(buildParseTrees) {
            this._buildParseTrees = buildParseTrees;
        }
        get buildParseTree() {
            return this._buildParseTrees;
        }
        getParseListeners() {
            return this._parseListeners;
        }
        addParseListener(listener) {
            if (listener == null) throw new TypeError("listener cannot be null");
            this._parseListeners.push(listener);
        }
        removeParseListener(listener) {
            let index = this._parseListeners.findIndex((l)=>l === listener);
            if (index !== -1) this._parseListeners.splice(index, 1);
        }
        removeParseListeners() {
            this._parseListeners.length = 0;
        }
        triggerEnterRuleEvent() {
            for (let listener of this._parseListeners){
                if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
                this._ctx.enterRule(listener);
            }
        }
        triggerExitRuleEvent() {
            for(let i = this._parseListeners.length - 1; i >= 0; i--){
                let listener = this._parseListeners[i];
                this._ctx.exitRule(listener);
                if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
            }
        }
        get numberOfSyntaxErrors() {
            return this._syntaxErrors;
        }
        get tokenFactory() {
            return this._input.tokenSource.tokenFactory;
        }
        getATNWithBypassAlts() {
            let serializedAtn = this.serializedATN;
            if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
            let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
            if (result == null) {
                let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
                deserializationOptions.isGenerateRuleBypassTransitions = true;
                result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
                $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
            }
            return result;
        }
        compileParseTreePattern(pattern, patternRuleIndex, lexer) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                if (!lexer) {
                    if (this.inputStream) {
                        let tokenSource = this.inputStream.tokenSource;
                        if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                    }
                    if (!lexer) throw new Error("Parser can't discover a lexer to use");
                }
                let currentLexer = lexer;
                let m = yield Promise.resolve().then(()=>(parcelRequire("dE6Cn")));
                let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
                return matcher.compile(pattern, patternRuleIndex);
            });
        }
        get errorHandler() {
            return this._errHandler;
        }
        set errorHandler(handler) {
            this._errHandler = handler;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
        }
        get currentToken() {
            return this._input.LT(1);
        }
        notifyErrorListeners(msg, offendingToken, e) {
            if (offendingToken === undefined) offendingToken = this.currentToken;
            else if (offendingToken === null) offendingToken = undefined;
            this._syntaxErrors++;
            let line = -1;
            let charPositionInLine = -1;
            if (offendingToken != null) {
                line = offendingToken.line;
                charPositionInLine = offendingToken.charPositionInLine;
            }
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
        }
        consume() {
            let o = this.currentToken;
            if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
            let hasListener = this._parseListeners.length !== 0;
            if (this._buildParseTrees || hasListener) {
                if (this._errHandler.inErrorRecoveryMode(this)) {
                    let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                    }
                } else {
                    let node = this.createTerminalNode(this._ctx, o);
                    this._ctx.addChild(node);
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                    }
                }
            }
            return o;
        }
        createTerminalNode(parent, t) {
            return new $kYC92.TerminalNode(t);
        }
        createErrorNode(parent, t) {
            return new $cdCft.ErrorNode(t);
        }
        addContextToParseTree() {
            let parent = this._ctx._parent;
            if (parent != null) parent.addChild(this._ctx);
        }
        enterRule(localctx, state, ruleIndex) {
            this.state = state;
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        enterLeftFactoredRule(localctx, state, ruleIndex) {
            this.state = state;
            if (this._buildParseTrees) {
                let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
                this._ctx.removeLastChild();
                factoredContext._parent = localctx;
                localctx.addChild(factoredContext);
            }
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        exitRule() {
            if (this.matchedEOF) this._ctx._stop = this._input.LT(1);
            else this._ctx._stop = this._input.tryLT(-1);
            this.triggerExitRuleEvent();
            this.state = this._ctx.invokingState;
            this._ctx = this._ctx._parent;
        }
        enterOuterAlt(localctx, altNum) {
            localctx.altNumber = altNum;
            if (this._buildParseTrees && this._ctx !== localctx) {
                let parent = this._ctx._parent;
                if (parent != null) {
                    parent.removeLastChild();
                    parent.addChild(localctx);
                }
            }
            this._ctx = localctx;
        }
        get precedence() {
            if (this._precedenceStack.isEmpty) return -1;
            return this._precedenceStack.peek();
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this.state = state;
            this._precedenceStack.push(precedence);
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            this.triggerEnterRuleEvent();
        }
        pushNewRecursionContext(localctx, state, ruleIndex) {
            let previous = this._ctx;
            previous._parent = localctx;
            previous.invokingState = state;
            previous._stop = this._input.tryLT(-1);
            this._ctx = localctx;
            this._ctx._start = previous._start;
            if (this._buildParseTrees) this._ctx.addChild(previous);
            this.triggerEnterRuleEvent();
        }
        unrollRecursionContexts(_parentctx) {
            this._precedenceStack.pop();
            this._ctx._stop = this._input.tryLT(-1);
            let retctx = this._ctx;
            if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
                this.triggerExitRuleEvent();
                this._ctx = this._ctx._parent;
            }
            else this._ctx = _parentctx;
            retctx._parent = _parentctx;
            if (this._buildParseTrees && _parentctx != null) _parentctx.addChild(retctx);
        }
        getInvokingContext(ruleIndex) {
            let p = this._ctx;
            while(p && p.ruleIndex !== ruleIndex)p = p._parent;
            return p;
        }
        get context() {
            return this._ctx;
        }
        set context(ctx) {
            this._ctx = ctx;
        }
        precpred(localctx, precedence) {
            return precedence >= this._precedenceStack.peek();
        }
        getErrorListenerDispatch() {
            return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
        }
        inContext(context) {
            return false;
        }
        isExpectedToken(symbol) {
            let atn = this.interpreter.atn;
            let ctx = this._ctx;
            let s = atn.states[this.state];
            let following = atn.nextTokens(s);
            if (following.contains(symbol)) return true;
            if (!following.contains($2DVsz.Token.EPSILON)) return false;
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = atn.nextTokens(rt.followState);
                if (following.contains(symbol)) return true;
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
            return false;
        }
        get isMatchedEOF() {
            return this.matchedEOF;
        }
        getExpectedTokens() {
            return this.atn.getExpectedTokens(this.state, this.context);
        }
        getExpectedTokensWithinCurrentRule() {
            let atn = this.interpreter.atn;
            let s = atn.states[this.state];
            return atn.nextTokens(s);
        }
        getRuleIndex(ruleName) {
            let ruleIndex = this.getRuleIndexMap().get(ruleName);
            if (ruleIndex != null) return ruleIndex;
            return -1;
        }
        get ruleContext() {
            return this._ctx;
        }
        getRuleInvocationStack(ctx = this._ctx) {
            let p = ctx;
            let ruleNames = this.ruleNames;
            let stack = [];
            while(p != null){
                let ruleIndex = p.ruleIndex;
                if (ruleIndex < 0) stack.push("n/a");
                else stack.push(ruleNames[ruleIndex]);
                p = p._parent;
            }
            return stack;
        }
        getDFAStrings() {
            let s = [];
            for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
            return s;
        }
        dumpDFA() {
            let seenOne = false;
            for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
                if (seenOne) console.log();
                console.log("Decision " + dfa.decision + ":");
                $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
                seenOne = true;
            }
        }
        get sourceName() {
            return this._input.sourceName;
        }
        get parseInfo() {
            return Promise.resolve().then(()=>(parcelRequire("kSEFX"))).then((m)=>{
                let interp = this.interpreter;
                if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
                return undefined;
            });
        }
        setProfile(profile) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                let m = yield Promise.resolve().then(()=>(parcelRequire("kSEFX")));
                let interp = this.interpreter;
                if (profile) {
                    if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
                } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
                this.interpreter.setPredictionMode(interp.getPredictionMode());
            });
        }
        set isTrace(trace) {
            if (!trace) {
                if (this._tracer) {
                    this.removeParseListener(this._tracer);
                    this._tracer = undefined;
                }
            } else {
                if (this._tracer) this.removeParseListener(this._tracer);
                else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
                this.addParseListener(this._tracer);
            }
        }
        get isTrace() {
            return this._tracer != null;
        }
    }
    $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "match", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull,
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override,
        $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
    ], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
    module.exports.Parser = $e5b2b780657df507$var$Parser;
});
parcelRegister("2M2qJ", function(module, exports) {
    "use strict";
    var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializationOptions = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $2051f30d0c577226$var$ATNDeserializationOptions {
        constructor(options){
            this.readOnly = false;
            if (options) {
                this.verifyATN = options.verifyATN;
                this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
                this.optimize = options.optimize;
            } else {
                this.verifyATN = true;
                this.generateRuleBypassTransitions = false;
                this.optimize = true;
            }
        }
        static get defaultOptions() {
            if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
            }
            return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
        }
        get isReadOnly() {
            return this.readOnly;
        }
        makeReadOnly() {
            this.readOnly = true;
        }
        get isVerifyATN() {
            return this.verifyATN;
        }
        set isVerifyATN(verifyATN) {
            this.throwIfReadOnly();
            this.verifyATN = verifyATN;
        }
        get isGenerateRuleBypassTransitions() {
            return this.generateRuleBypassTransitions;
        }
        set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
            this.throwIfReadOnly();
            this.generateRuleBypassTransitions = generateRuleBypassTransitions;
        }
        get isOptimize() {
            return this.optimize;
        }
        set isOptimize(optimize) {
            this.throwIfReadOnly();
            this.optimize = optimize;
        }
        throwIfReadOnly() {
            if (this.isReadOnly) throw new Error("The object is read only.");
        }
    }
    $2051f30d0c577226$var$__decorate([
        $d6D31.NotNull
    ], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
    module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;
});
parcelRegister("dvgsl", function(module, exports) {
    "use strict";
    var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializer = void 0;
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $bcnvE = parcelRequire("bcnvE");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $gAm9p = parcelRequire("gAm9p");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $5BPMp = parcelRequire("5BPMp");
    var $loKp0 = parcelRequire("loKp0");
    var $65vNG = parcelRequire("65vNG");
    var $dPYn6 = parcelRequire("dPYn6");
    var $jJRyp = parcelRequire("jJRyp");
    var $bpnRH = parcelRequire("bpnRH");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iw4Ko = parcelRequire("iw4Ko");
    var $RgRAX = parcelRequire("RgRAX");
    var $jgJtt = parcelRequire("jgJtt");
    var $l606e = parcelRequire("l606e");
    var $6hIs4 = parcelRequire("6hIs4");
    var $a9nIX = parcelRequire("a9nIX");
    var $2Gb96 = parcelRequire("2Gb96");
    var $ayRdK = parcelRequire("ayRdK");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $kzbnL = parcelRequire("kzbnL");
    var $d1V7w = parcelRequire("d1V7w");
    var $7qlbM = parcelRequire("7qlbM");
    var $7KGEQ = parcelRequire("7KGEQ");
    var $hnaRv = parcelRequire("hnaRv");
    var $aISkF = parcelRequire("aISkF");
    var $j2zc8 = parcelRequire("j2zc8");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $Np2R3 = parcelRequire("Np2R3");
    var $jEsaF = parcelRequire("jEsaF");
    var $bjwd1 = parcelRequire("bjwd1");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    var $WS4d7 = parcelRequire("WS4d7");
    var $kWxOc = parcelRequire("kWxOc");
    var $aPmi9 = parcelRequire("aPmi9");
    var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
    (function(UnicodeDeserializingMode) {
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
    })($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
    class $9d4aef733dce84f9$var$ATNDeserializer {
        constructor(deserializationOptions){
            if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
            this.deserializationOptions = deserializationOptions;
        }
        static get SERIALIZED_VERSION() {
            return 3;
        }
        static isFeatureSupported(feature, actualUuid) {
            let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
            if (featureIndex < 0) return false;
            return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
        }
        static getUnicodeDeserializer(mode) {
            if (mode === 0) return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                },
                size: 1
            };
            else return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
                },
                size: 2
            };
        }
        deserialize(data) {
            data = data.slice(0);
            for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
            let p = 0;
            let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
                let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
                throw new Error(reason);
            }
            let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
            p += 8;
            if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
                let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
                throw new Error(reason);
            }
            let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
            let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let atn = new $bcnvE.ATN(grammarType, maxTokenType);
            let loopBackStateNumbers = [];
            let endStateNumbers = [];
            let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nstates; i++){
                let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                    atn.addState(new $l4Nh1.InvalidState());
                    continue;
                }
                let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (ruleIndex === 0xFFFF) ruleIndex = -1;
                let s = this.stateFactory(stype, ruleIndex);
                if (stype === $1bs3X.ATNStateType.LOOP_END) {
                    let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    loopBackStateNumbers.push([
                        s,
                        loopBackStateNumber
                    ]);
                } else if (s instanceof $65vNG.BlockStartState) {
                    let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    endStateNumbers.push([
                        s,
                        endStateNumber
                    ]);
                }
                atn.addState(s);
            }
            for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
            for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
            let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numNonGreedyStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].nonGreedy = true;
            }
            let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numSllDecisions; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].sll = true;
            }
            let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numPrecedenceStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].isPrecedenceRule = true;
            }
            let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (atn.grammarType === 0) atn.ruleToTokenType = new Int32Array(nrules);
            atn.ruleToStartState = new Array(nrules);
            for(let i = 0; i < nrules; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let startState = atn.states[s];
                startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                atn.ruleToStartState[i] = startState;
                if (atn.grammarType === 0) {
                    let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                    atn.ruleToTokenType[i] = tokenType;
                    if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                        let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                    }
                }
            }
            atn.ruleToStopState = new Array(nrules);
            for (let state of atn.states){
                if (!(state instanceof $4kGBm.RuleStopState)) continue;
                atn.ruleToStopState[state.ruleIndex] = state;
                atn.ruleToStartState[state.ruleIndex].stopState = state;
            }
            let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nmodes; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.modeToStartState.push(atn.states[s]);
            }
            atn.modeToDFA = new Array(nmodes);
            for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
            let sets = [];
            p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0));
            if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1));
            let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nedges; i++){
                let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
                let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
                let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
                let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
                let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
                let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
                let srcState = atn.states[src];
                srcState.addTransition(trans);
                p += 6;
            }
            let returnTransitionsSet = new $7Veax.Array2DHashSet({
                hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
                equals: (a, b)=>{
                    return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
                }
            });
            let returnTransitions = [];
            for (let state of atn.states){
                let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let t = state.transition(i);
                    if (!(t instanceof $aybFP.RuleTransition)) continue;
                    let ruleTransition = t;
                    let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                    if (!returningFromLeftFactored && returningToLeftFactored) continue;
                    let outermostPrecedenceReturn = -1;
                    if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                        if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                    }
                    let current = {
                        stopState: ruleTransition.target.ruleIndex,
                        returnState: ruleTransition.followState.stateNumber,
                        outermostPrecedenceReturn: outermostPrecedenceReturn
                    };
                    if (returnTransitionsSet.add(current)) returnTransitions.push(current);
                }
            }
            for (let returnTransition of returnTransitions){
                let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
                atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
            }
            for (let state of atn.states){
                if (state instanceof $65vNG.BlockStartState) {
                    if (state.endState === undefined) throw new Error("IllegalStateException");
                    if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                    state.endState.startState = state;
                }
                if (state instanceof $7qlbM.PlusLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                    }
                } else if (state instanceof $bjwd1.StarLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                    }
                }
            }
            let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 1; i <= ndecisions; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let decState = atn.states[s];
                atn.decisionToState.push(decState);
                decState.decision = i - 1;
            }
            if (atn.grammarType === 0) {
                if (supportsLexerActions) {
                    atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                    for(let i = 0; i < atn.lexerActions.length; i++){
                        let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data1 === 0xFFFF) data1 = -1;
                        let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data2 === 0xFFFF) data2 = -1;
                        let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                        atn.lexerActions[i] = lexerAction;
                    }
                } else {
                    let legacyLexerActions = [];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                        let ruleIndex = transition.ruleIndex;
                        let actionIndex = transition.actionIndex;
                        let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                        state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                        legacyLexerActions.push(lexerAction);
                    }
                    atn.lexerActions = legacyLexerActions;
                }
            }
            this.markPrecedenceDecisions(atn);
            atn.decisionToDFA = new Array(ndecisions);
            for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
            if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1) {
                atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
                for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
                for(let i = 0; i < atn.ruleToStartState.length; i++){
                    let bypassStart = new $gAm9p.BasicBlockStartState();
                    bypassStart.ruleIndex = i;
                    atn.addState(bypassStart);
                    let bypassStop = new $loKp0.BlockEndState();
                    bypassStop.ruleIndex = i;
                    atn.addState(bypassStop);
                    bypassStart.endState = bypassStop;
                    atn.defineDecisionState(bypassStart);
                    bypassStop.startState = bypassStart;
                    let endState;
                    let excludeTransition;
                    if (atn.ruleToStartState[i].isPrecedenceRule) {
                        endState = undefined;
                        for (let state of atn.states){
                            if (state.ruleIndex !== i) continue;
                            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                            let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                            if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                            if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                                endState = state;
                                break;
                            }
                        }
                        if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                        excludeTransition = endState.loopBackState.transition(0);
                    } else endState = atn.ruleToStopState[i];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (transition === excludeTransition) continue;
                        if (transition.target === endState) transition.target = bypassStop;
                    }
                    while(atn.ruleToStartState[i].numberOfTransitions > 0){
                        let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                        bypassStart.addTransition(transition);
                    }
                    atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                    bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                    let matchState = new $4yiuQ.BasicState();
                    atn.addState(matchState);
                    matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                    bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            if (this.deserializationOptions.isOptimize) {
                while(true){
                    let optimizationCount = 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                    let preserveOrder = atn.grammarType === 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                    if (optimizationCount === 0) break;
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
            return atn;
        }
        deserializeSets(data, p, sets, unicodeDeserializer) {
            let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nsets; i++){
                let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                p++;
                let set = new $hGRod.IntervalSet();
                sets.push(set);
                let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                if (containsEof) set.add(-1);
                for(let j = 0; j < nintervals; j++){
                    let a = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    let b = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    set.add(a, b);
                }
            }
            return p;
        }
        markPrecedenceDecisions(atn) {
            let rulePrecedenceDecisions = new Map();
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                    let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                    if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            rulePrecedenceDecisions.set(state.ruleIndex, state);
                            state.precedenceRuleDecision = true;
                            state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                        }
                    }
                }
            }
            for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
                if (transition.serializationType !== 1) continue;
                let epsilonTransition = transition;
                if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
                precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
            }
        }
        verifyATN(atn) {
            for (let state of atn.states){
                this.checkCondition(state !== undefined, "ATN states should not be undefined.");
                if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
                this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
                if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $f9raX.StarLoopEntryState) {
                    let starLoopEntryState = state;
                    this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                    this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                    if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                        this.checkCondition(!starLoopEntryState.nonGreedy);
                    } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                        this.checkCondition(starLoopEntryState.nonGreedy);
                    } else throw new Error("IllegalStateException");
                }
                if (state instanceof $bjwd1.StarLoopbackState) {
                    this.checkCondition(state.numberOfTransitions === 1);
                    this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
                }
                if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
                if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
                if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
                if (state instanceof $dPYn6.DecisionState) {
                    let decisionState = state;
                    this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
                } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
            }
        }
        checkCondition(condition, message) {
            if (!condition) throw new Error("IllegalStateException: " + message);
        }
        static inlineSetRules(atn) {
            let inlinedCalls = 0;
            let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let startState = atn.ruleToStartState[i];
                let middleState = startState;
                while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1)middleState = middleState.getOptimizedTransition(0).target;
                if (middleState.numberOfOptimizedTransitions !== 1) continue;
                let matchTransition = middleState.getOptimizedTransition(0);
                let matchTarget = matchTransition.target;
                if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
                switch(matchTransition.serializationType){
                    case 5:
                    case 2:
                    case 7:
                        ruleToInlineTransition[i] = matchTransition;
                        break;
                    case 8:
                    case 9:
                        continue;
                    default:
                        continue;
                }
            }
            for (let state of atn.states){
                if (state.ruleIndex < 0) continue;
                let optimizedTransitions;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    let ruleTransition = transition;
                    let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                    if (effective === undefined) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                    }
                    inlinedCalls++;
                    let target = ruleTransition.followState;
                    let intermediateState = new $4yiuQ.BasicState();
                    intermediateState.setRuleIndex(target.ruleIndex);
                    atn.addState(intermediateState);
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                    switch(effective.serializationType){
                        case 5:
                            intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                            break;
                        case 2:
                            intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                            break;
                        case 7:
                            intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                            break;
                        default:
                            throw new Error("UnsupportedOperationException");
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
            return inlinedCalls;
        }
        static combineChainedEpsilons(atn) {
            let removedEdges = 0;
            for (let state of atn.states){
                if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
                let optimizedTransitions;
                nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    let intermediate = transition.target;
                    if (transition.serializationType !== 1 || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    removedEdges++;
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                        let target = intermediate.getOptimizedTransition(j).target;
                        optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
            return removedEdges;
        }
        static optimizeSets(atn, preserveOrder) {
            if (preserveOrder) return 0;
            let removedPaths = 0;
            let decisions = atn.decisionToState;
            for (let decision of decisions){
                let setTransitions = new $hGRod.IntervalSet();
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                    let epsTransition = decision.getOptimizedTransition(i);
                    if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                    if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                    let transition = epsTransition.target.getOptimizedTransition(0);
                    if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                    if (transition instanceof $FLEKS.NotSetTransition) continue;
                    if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
                }
                if (setTransitions.size <= 1) continue;
                let optimizedTransitions = [];
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
                let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
                let matchSet = new $hGRod.IntervalSet();
                for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                    let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                    if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                    else matchSet.addAll(matchTransition.label);
                }
                let newTransition;
                if (matchSet.intervals.length === 1) {
                    if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                    else {
                        let matchInterval = matchSet.intervals[0];
                        newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                    }
                } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
                let setOptimizedState = new $4yiuQ.BasicState();
                setOptimizedState.setRuleIndex(decision.ruleIndex);
                atn.addState(setOptimizedState);
                setOptimizedState.addTransition(newTransition);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
                removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
                if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
            return removedPaths;
        }
        static identifyTailCalls(atn) {
            for (let state of atn.states){
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
                if (!state.isOptimized) continue;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
            }
        }
        static testTailCall(atn, transition, optimizedPath) {
            if (!optimizedPath && transition.tailCall) return true;
            if (optimizedPath && transition.optimizedTailCall) return true;
            let reachable = new $5BPMp.BitSet(atn.states.length);
            let worklist = [];
            worklist.push(transition.followState);
            while(true){
                let state = worklist.pop();
                if (!state) break;
                if (reachable.get(state.stateNumber)) continue;
                if (state instanceof $4kGBm.RuleStopState) continue;
                if (!state.onlyHasEpsilonTransitions) return false;
                let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
                for(let i = 0; i < transitionCount; i++){
                    let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                    if (t.serializationType !== 1) return false;
                    worklist.push(t.target);
                }
            }
            return true;
        }
        static toInt(c) {
            return c;
        }
        static toInt32(data, offset) {
            return (data[offset] | data[offset + 1] << 16) >>> 0;
        }
        static toUUID(data, offset) {
            let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
            let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
            let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
            let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
            return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
            let target = atn.states[trg];
            switch(type){
                case 1:
                    return new $bpnRH.EpsilonTransition(target);
                case 2:
                    if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                    else return new $aISkF.RangeTransition(target, arg1, arg2);
                case 3:
                    let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                    return rt;
                case 4:
                    let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                    return pt;
                case 10:
                    return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
                case 5:
                    if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                    else return new $5r7n7.AtomTransition(target, arg1);
                case 6:
                    let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                    return a;
                case 7:
                    return new $Np2R3.SetTransition(target, sets[arg1]);
                case 8:
                    return new $FLEKS.NotSetTransition(target, sets[arg1]);
                case 9:
                    return new $aPmi9.WildcardTransition(target);
            }
            throw new Error("The specified transition type is not valid.");
        }
        stateFactory(type, ruleIndex) {
            let s;
            switch(type){
                case $1bs3X.ATNStateType.INVALID_TYPE:
                    return new $l4Nh1.InvalidState();
                case $1bs3X.ATNStateType.BASIC:
                    s = new $4yiuQ.BasicState();
                    break;
                case $1bs3X.ATNStateType.RULE_START:
                    s = new $j2zc8.RuleStartState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_START:
                    s = new $gAm9p.BasicBlockStartState();
                    break;
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                    s = new $d1V7w.PlusBlockStartState();
                    break;
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                    s = new $jEsaF.StarBlockStartState();
                    break;
                case $1bs3X.ATNStateType.TOKEN_START:
                    s = new $WS4d7.TokensStartState();
                    break;
                case $1bs3X.ATNStateType.RULE_STOP:
                    s = new $4kGBm.RuleStopState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_END:
                    s = new $loKp0.BlockEndState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    s = new $bjwd1.StarLoopbackState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    s = new $f9raX.StarLoopEntryState();
                    break;
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                    s = new $7qlbM.PlusLoopbackState();
                    break;
                case $1bs3X.ATNStateType.LOOP_END:
                    s = new $kfqEk.LoopEndState();
                    break;
                default:
                    let message = `The specified state type ${type} is not valid.`;
                    throw new Error(message);
            }
            s.ruleIndex = ruleIndex;
            return s;
        }
        lexerActionFactory(type, data1, data2) {
            switch(type){
                case 0:
                    return new $iw4Ko.LexerChannelAction(data1);
                case 1:
                    return new $RgRAX.LexerCustomAction(data1, data2);
                case 2:
                    return new $jgJtt.LexerModeAction(data1);
                case 3:
                    return $l606e.LexerMoreAction.INSTANCE;
                case 4:
                    return $6hIs4.LexerPopModeAction.INSTANCE;
                case 5:
                    return new $a9nIX.LexerPushModeAction(data1);
                case 6:
                    return $2Gb96.LexerSkipAction.INSTANCE;
                case 7:
                    return new $ayRdK.LexerTypeAction(data1);
                default:
                    let message = `The specified lexer action type ${type} is not valid.`;
                    throw new Error(message);
            }
        }
    }
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
    $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
        $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
    ];
    $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull,
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
    module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;
});
parcelRegister("gxlfY", function(module, exports) {
    "use strict";
    var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ActionTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
        constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
            super(target);
            this.ruleIndex = ruleIndex;
            this.actionIndex = actionIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 6;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "action_" + this.ruleIndex + ":" + this.actionIndex;
        }
    };
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
    $c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
        $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
    ], $c0a0378a1b984eee$var$ActionTransition);
    module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;
});
parcelRegister("5r7n7", function(module, exports) {
    "use strict";
    var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AtomTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
        constructor(target, label){
            super(target);
            this._label = label;
        }
        get serializationType() {
            return 5;
        }
        get label() {
            return $hGRod.IntervalSet.of(this._label);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this._label === symbol;
        }
        toString() {
            return String(this.label);
        }
    };
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
    $010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
        $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
    ], $010580cb6b5878c3$var$AtomTransition);
    module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;
});
parcelRegister("gAm9p", function(module, exports) {
    "use strict";
    var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_START;
        }
    }
    $c13130ce46eb4f6a$var$__decorate([
        $d6D31.Override
    ], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
    module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;
});
parcelRegister("65vNG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockStartState = void 0;
    var $dPYn6 = parcelRequire("dPYn6");
    class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
    }
    module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;
});
parcelRegister("loKp0", function(module, exports) {
    "use strict";
    var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_END;
        }
    }
    $f93fd5601d243552$var$__decorate([
        $d6D31.Override
    ], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
    module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;
});
parcelRegister("bpnRH", function(module, exports) {
    "use strict";
    var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.EpsilonTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
        constructor(target, outermostPrecedenceReturn = -1){
            super(target);
            this._outermostPrecedenceReturn = outermostPrecedenceReturn;
        }
        get outermostPrecedenceReturn() {
            return this._outermostPrecedenceReturn;
        }
        get serializationType() {
            return 1;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "epsilon";
        }
    };
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
    $84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
        $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
    ], $84e48a9cb4812173$var$EpsilonTransition);
    module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;
});
parcelRegister("iw4Ko", function(module, exports) {
    "use strict";
    var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerChannelAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $d7aee5df2113a2bc$var$LexerChannelAction {
        constructor(channel){
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        get actionType() {
            return 0;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.channel = this._channel;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._channel);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
            return this._channel === obj._channel;
        }
        toString() {
            return `channel(${this._channel})`;
        }
    }
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override,
        $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
    module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;
});
parcelRegister("RgRAX", function(module, exports) {
    "use strict";
    var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $0a0208144418eb04$var$LexerCustomAction {
        constructor(ruleIndex, actionIndex){
            this._ruleIndex = ruleIndex;
            this._actionIndex = actionIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get actionIndex() {
            return this._actionIndex;
        }
        get actionType() {
            return 1;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            lexer.action(undefined, this._ruleIndex, this._actionIndex);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
            hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
            return $iXFjm.MurmurHash.finish(hash, 3);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
            return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
        }
    }
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override,
        $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
    module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;
});
parcelRegister("jgJtt", function(module, exports) {
    "use strict";
    var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $e072c93b157fdb6e$var$LexerModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 2;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.mode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `mode(${this._mode})`;
        }
    }
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override,
        $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
    module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;
});
parcelRegister("l606e", function(module, exports) {
    "use strict";
    var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerMoreAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $f5ba3c4a18e49934$var$LexerMoreAction {
        constructor(){}
        get actionType() {
            return 3;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.more();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "more";
        }
    }
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override,
        $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
    module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
    (function(LexerMoreAction) {
        LexerMoreAction.INSTANCE = new LexerMoreAction();
    })($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));
});
parcelRegister("6hIs4", function(module, exports) {
    "use strict";
    var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPopModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $4936cfc70a1820aa$var$LexerPopModeAction {
        constructor(){}
        get actionType() {
            return 4;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.popMode();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "popMode";
        }
    }
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override,
        $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
    module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
    (function(LexerPopModeAction) {
        LexerPopModeAction.INSTANCE = new LexerPopModeAction();
    })($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));
});
parcelRegister("a9nIX", function(module, exports) {
    "use strict";
    var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPushModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $763d25c4cd7cf3b5$var$LexerPushModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 5;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.pushMode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `pushMode(${this._mode})`;
        }
    }
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override,
        $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
    module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;
});
parcelRegister("2Gb96", function(module, exports) {
    "use strict";
    var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerSkipAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $1f3826579173f858$var$LexerSkipAction {
        constructor(){}
        get actionType() {
            return 6;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.skip();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "skip";
        }
    }
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override,
        $1f3826579173f858$var$__param(0, $d6D31.NotNull)
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
    module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
    (function(LexerSkipAction) {
        LexerSkipAction.INSTANCE = new LexerSkipAction();
    })($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));
});
parcelRegister("ayRdK", function(module, exports) {
    "use strict";
    var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerTypeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $7b065cdfc5f207e7$var$LexerTypeAction {
        constructor(type){
            this._type = type;
        }
        get type() {
            return this._type;
        }
        get actionType() {
            return 7;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.type = this._type;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._type);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
            return this._type === obj._type;
        }
        toString() {
            return `type(${this._type})`;
        }
    }
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override,
        $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
    module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;
});
parcelRegister("kfqEk", function(module, exports) {
    "use strict";
    var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LoopEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.LOOP_END;
        }
    }
    $ebd9e16490628daf$var$__decorate([
        $d6D31.Override
    ], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
    module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;
});
parcelRegister("kzbnL", function(module, exports) {
    "use strict";
    var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $5BPMp = parcelRequire("5BPMp");
    var $gsRaX = parcelRequire("gsRaX");
    var $dPYn6 = parcelRequire("dPYn6");
    var $2jevZ = parcelRequire("2jevZ");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $hKCjP = parcelRequire("hKCjP");
    var $a4Flx = parcelRequire("a4Flx");
    var $6bmaO = parcelRequire("6bmaO");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $gDZVV = parcelRequire("gDZVV");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $eHMgW = parcelRequire("eHMgW");
    var $Np2R3 = parcelRequire("Np2R3");
    var $g7SCF = parcelRequire("g7SCF");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $bbHFU = parcelRequire("bbHFU");
    const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
    const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
    let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, parser){
            super(atn);
            this.predictionMode = $gDZVV.PredictionMode.LL;
            this.force_global_context = false;
            this.always_try_local_context = true;
            this.enable_global_context_dfa = false;
            this.optimize_unique_closure = true;
            this.optimize_ll1 = true;
            this.optimize_tail_calls = true;
            this.tail_call_preserves_sll = true;
            this.treat_sllk1_conflict_as_ambiguity = false;
            this.reportAmbiguities = false;
            this.userWantsCtxSensitive = true;
            this._parser = parser;
        }
        getPredictionMode() {
            return this.predictionMode;
        }
        setPredictionMode(predictionMode) {
            this.predictionMode = predictionMode;
        }
        reset() {}
        adaptivePredict(input, decision, outerContext, useContext) {
            if (useContext === undefined) useContext = false;
            let dfa = this.atn.decisionToDFA[decision];
            $bbHFU(dfa != null);
            if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
                let ll_1 = input.LA(1);
                if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                    let key = (decision << 16 >>> 0) + ll_1;
                    let alt = this.atn.LL1Table.get(key);
                    if (alt != null) return alt;
                }
            }
            this.dfa = dfa;
            if (this.force_global_context) useContext = true;
            else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
            this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            let state;
            if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
            if (state == null) {
                if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
                if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
                state = this.computeStartState(dfa, outerContext, useContext);
            }
            let m = input.mark();
            let index = input.index;
            try {
                let alt = this.execDFA(dfa, input, index, state);
                if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                return alt;
            } finally{
                this.dfa = undefined;
                input.seek(index);
                input.release(m);
            }
        }
        getStartState(dfa, input, outerContext, useContext) {
            if (!useContext) {
                if (dfa.isPrecedenceDfa) {
                    let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                    if (state == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
                } else {
                    if (dfa.s0 == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
                }
            }
            if (!this.enable_global_context_dfa) return undefined;
            let remainingContext = outerContext;
            $bbHFU(outerContext != null);
            let s0;
            if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
            else s0 = dfa.s0full;
            while(remainingContext != null && s0 != null && s0.isContextSensitive){
                remainingContext = this.skipTailCalls(remainingContext);
                s0 = s0.getContextTarget(this.getReturnState(remainingContext));
                if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
                else remainingContext = remainingContext.parent;
            }
            if (s0 == null) return undefined;
            return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
        }
        execDFA(dfa, input, startIndex, state) {
            let outerContext = state.outerContext;
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            let s = state.s0;
            let t = input.LA(1);
            let remainingOuterContext = state.remainingOuterContext;
            while(true){
                if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
                if (state.useContext) while(s.isContextSymbol(t)){
                    let next;
                    if (remainingOuterContext != null) {
                        remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                        next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                    }
                    if (next == null) {
                        let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                        return this.execATN(dfa, input, startIndex, initialState);
                    }
                    $bbHFU(remainingOuterContext != null);
                    remainingOuterContext = remainingOuterContext.parent;
                    s = next;
                }
                if (this.isAcceptState(s, state.useContext)) {
                    if (s.predicates != null) {
                        if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                    } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                    break;
                }
                $bbHFU(!this.isAcceptState(s, state.useContext));
                let target = this.getExistingTargetState(s, t);
                if (target == null) {
                    if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                    let alt;
                    if (ParserATNSimulator.dfa_debug) {
                        let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                        console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                    }
                    let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    alt = this.execATN(dfa, input, startIndex, initialState);
                    if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                    if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                    return alt;
                } else if (target === $kr9A1.ATNSimulator.ERROR) {
                    let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    return this.handleNoViableAlt(input, startIndex, errorState);
                }
                s = target;
                if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
            if (!state.useContext && s.configs.conflictInfo != null) {
                if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                    if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                    else {
                        $bbHFU(!state.useContext);
                        let conflictingAlts;
                        let predicates = s.predicates;
                        if (predicates != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                            if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                        if (this.reportAmbiguities) {
                            let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                            this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                        }
                        input.seek(startIndex);
                        return this.adaptivePredict(input, dfa.decision, outerContext, true);
                    }
                }
            }
            let predicates = s.predicates;
            if (predicates != null) {
                let stopIndex = input.index;
                if (startIndex !== stopIndex) input.seek(startIndex);
                let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
                switch(alts.cardinality()){
                    case 0:
                        throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (startIndex !== stopIndex) input.seek(stopIndex);
                        this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                        return alts.nextSetBit(0);
                }
            }
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
            return s.prediction;
        }
        isAcceptState(state, useContext) {
            if (!state.isAcceptState) return false;
            if (state.configs.conflictingAlts == null) return true;
            if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
            return true;
        }
        execATN(dfa, input, startIndex, initialState) {
            if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
            let outerContext = initialState.outerContext;
            let useContext = initialState.useContext;
            let t = input.LA(1);
            let previous = initialState;
            let contextCache = new $6vF7J.PredictionContextCache();
            while(true){
                let nextState = this.computeReachSet(dfa, previous, t, contextCache);
                if (nextState == null) {
                    this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                    return this.handleNoViableAlt(input, startIndex, previous);
                }
                let D = nextState.s0;
                $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
                $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
                if (this.isAcceptState(D, useContext)) {
                    let conflictingAlts = D.configs.conflictingAlts;
                    let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                    if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                        if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                            if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                                let key = (dfa.decision << 16 >>> 0) + t;
                                this.atn.LL1Table.set(key, predictedAlt);
                            }
                        }
                        if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                    }
                    predictedAlt = D.prediction;
                    let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                    if (attemptFullContext) attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                    if (D.configs.hasSemanticContext) {
                        let predPredictions = D.predicates;
                        if (predPredictions != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                            switch(conflictingAlts.cardinality()){
                                case 0:
                                    throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                                case 1:
                                    return conflictingAlts.nextSetBit(0);
                                default:
                                    break;
                            }
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                    }
                    if (!attemptFullContext) {
                        if (conflictingAlts != null) {
                            if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                            predictedAlt = conflictingAlts.nextSetBit(0);
                        }
                        return predictedAlt;
                    } else {
                        $bbHFU(!useContext);
                        $bbHFU(this.isAcceptState(D, false));
                        if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                        let fullContextState = this.computeStartState(dfa, outerContext, true);
                        if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                        input.seek(startIndex);
                        return this.execATN(dfa, input, startIndex, fullContextState);
                    }
                }
                previous = nextState;
                if (t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
        }
        handleNoViableAlt(input, startIndex, previous) {
            if (previous.s0 != null) {
                let alts = new $5BPMp.BitSet();
                let maxAlt = 0;
                for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                    alts.set(config.alt);
                    maxAlt = Math.max(maxAlt, config.alt);
                }
                switch(alts.cardinality()){
                    case 0:
                        break;
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (!previous.s0.configs.hasSemanticContext) return alts.nextSetBit(0);
                        let filteredConfigs = new $c1ClW.ATNConfigSet();
                        for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                        let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                        if (altToPred != null) {
                            let predicates = this.getPredicatePredictions(alts, altToPred);
                            if (predicates != null) {
                                let stopIndex = input.index;
                                try {
                                    input.seek(startIndex);
                                    let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                    if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                                } finally{
                                    input.seek(stopIndex);
                                }
                            }
                        }
                        return alts.nextSetBit(0);
                }
            }
            throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
        }
        computeReachSet(dfa, previous, t, contextCache) {
            let useContext = previous.useContext;
            let remainingGlobalContext = previous.remainingOuterContext;
            let s = previous.s0;
            if (useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingGlobalContext != null) {
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
                }
                if (next == null) break;
                $bbHFU(remainingGlobalContext != null);
                remainingGlobalContext = remainingGlobalContext.parent;
                s = next;
            }
            $bbHFU(!this.isAcceptState(s, useContext));
            if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
            let s0 = s;
            let target = this.getExistingTargetState(s0, t);
            if (target == null) {
                let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
                target = result[0];
                remainingGlobalContext = result[1];
            }
            if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
            $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
            return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
        }
        getExistingTargetState(s, t) {
            return s.getTarget(t);
        }
        computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
            let closureConfigs = s.configs.toArray();
            let contextElements;
            let reach = new $c1ClW.ATNConfigSet();
            let stepIntoGlobal;
            do {
                let hasMoreContext = !useContext || remainingGlobalContext != null;
                if (!hasMoreContext) reach.isOutermostConfigSet = true;
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let skippedStopStates;
                for (let c of closureConfigs){
                    if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                    if (c.state instanceof $4kGBm.RuleStopState) {
                        $bbHFU(c.context.isEmpty);
                        if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                            if (skippedStopStates == null) skippedStopStates = [];
                            skippedStopStates.push(c);
                        }
                        continue;
                    }
                    let n = c.state.numberOfOptimizedTransitions;
                    for(let ti = 0; ti < n; ti++){
                        let trans = c.state.getOptimizedTransition(ti);
                        let target = this.getReachableTarget(c, trans, t);
                        if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                    }
                }
                if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                    reach = reachIntermediate;
                    break;
                }
                let collectPredicates = false;
                let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
                this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
                stepIntoGlobal = reach.dipsIntoOuterContext;
                if (t === $ceaEj.IntStream.EOF) reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
                if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                    $bbHFU(skippedStopStates.length > 0);
                    for (let c of skippedStopStates)reach.add(c, contextCache);
                }
                if (useContext && stepIntoGlobal) {
                    reach.clear();
                    remainingGlobalContext;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    let nextContextElement = this.getReturnState(remainingGlobalContext);
                    if (contextElements == null) contextElements = new $37SGk.IntegerList();
                    if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                    else remainingGlobalContext = remainingGlobalContext.parent;
                    contextElements.add(nextContextElement);
                    if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
                }
            }while (useContext && stepIntoGlobal)
            if (reach.isEmpty) {
                this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return [
                    $kr9A1.ATNSimulator.ERROR,
                    remainingGlobalContext
                ];
            }
            let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
            return [
                result,
                remainingGlobalContext
            ];
        }
        removeAllConfigsNotInRuleStopState(configs, contextCache) {
            if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
            let result = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
                result.add(config, contextCache);
            }
            return result;
        }
        computeStartState(dfa, globalContext, useContext) {
            let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
            if (s0 != null) {
                if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
                s0.setContextSensitive(this.atn);
            }
            let decision = dfa.decision;
            let p = dfa.atnStartState;
            let previousContext = 0;
            let remainingGlobalContext = globalContext;
            let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL;
            let contextCache = new $6vF7J.PredictionContextCache();
            if (useContext) {
                if (!this.enable_global_context_dfa) {
                    while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                }
                while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                    let next;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    if (remainingGlobalContext.isEmpty) {
                        next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        next = s0.getContextTarget(previousContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                    if (next == null) break;
                    s0 = next;
                }
            }
            if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
            let configs = new $c1ClW.ATNConfigSet();
            while(true){
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let n = p.numberOfTransitions;
                for(let ti = 0; ti < n; ti++){
                    let target = p.transition(ti).target;
                    reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
                }
                let hasMoreContext = remainingGlobalContext != null;
                if (!hasMoreContext) configs.isOutermostConfigSet = true;
                let collectPredicates = true;
                this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
                let stepIntoGlobal = configs.dipsIntoOuterContext;
                let next;
                if (useContext && !this.enable_global_context_dfa) {
                    s0 = this.addDFAState(dfa, configs, contextCache);
                    break;
                } else if (s0 == null) {
                    if (!dfa.isPrecedenceDfa) {
                        next = this.addDFAState(dfa, configs, contextCache);
                        if (useContext) {
                            if (!dfa.s0full) dfa.s0full = next;
                            else next = dfa.s0full;
                        } else if (!dfa.s0) dfa.s0 = next;
                        else next = dfa.s0;
                    } else {
                        configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                        next = this.addDFAState(dfa, configs, contextCache);
                        dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                    }
                } else {
                    if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    s0.setContextTarget(previousContext, next);
                }
                s0 = next;
                if (!useContext || !stepIntoGlobal) break;
                next.setContextSensitive(this.atn);
                remainingGlobalContext;
                configs.clear();
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
                previousContext = nextContextElement;
            }
            return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        }
        applyPrecedenceFilter(configs, globalContext, contextCache) {
            let statesFromAlt1 = new Map();
            let configSet = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (config.alt !== 1) continue;
                let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
                if (updatedContext == null) continue;
                statesFromAlt1.set(config.state.stateNumber, config.context);
                if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
                else configSet.add(config, contextCache);
            }
            for (let config of configs){
                if (config.alt === 1) continue;
                if (!config.isPrecedenceFilterSuppressed) {
                    let context = statesFromAlt1.get(config.state.stateNumber);
                    if (context != null && context.equals(config.context)) continue;
                }
                configSet.add(config, contextCache);
            }
            return configSet;
        }
        getReachableTarget(source, trans, ttype) {
            if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
            return undefined;
        }
        predicateDFAState(D, configs, nalts) {
            let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
            if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
            if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
            let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
            let predPredictions;
            if (altToPred != null) {
                predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
                D.predicates = predPredictions;
            }
            return predPredictions;
        }
        getPredsForAmbigAlts(ambigAlts, configs, nalts) {
            let altToPred = new Array(nalts + 1);
            let n = altToPred.length;
            for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
            let nPredAlts = 0;
            for(let i = 0; i < n; i++){
                if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
                else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
            }
            let result = altToPred;
            if (nPredAlts === 0) result = undefined;
            if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
            return result;
        }
        getPredicatePredictions(ambigAlts, altToPred) {
            let pairs = [];
            let containsPredicate = false;
            for(let i = 1; i < altToPred.length; i++){
                let pred = altToPred[i];
                $bbHFU(pred != null);
                if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                else if (pred !== $eHMgW.SemanticContext.NONE) {
                    containsPredicate = true;
                    pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                }
            }
            if (!containsPredicate) return undefined;
            return pairs;
        }
        evalSemanticContext(predPredictions, outerContext, complete) {
            let predictions = new $5BPMp.BitSet();
            for (let pair of predPredictions){
                if (pair.pred === $eHMgW.SemanticContext.NONE) {
                    predictions.set(pair.alt);
                    if (!complete) break;
                    continue;
                }
                let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
                if (evaluatedResult) {
                    if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                    predictions.set(pair.alt);
                    if (!complete) break;
                }
            }
            return predictions;
        }
        evalSemanticContextImpl(pred, parserCallStack, alt) {
            return pred.eval(this._parser, parserCallStack);
        }
        closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let currentConfigs = sourceConfigs;
            let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            while(currentConfigs.size > 0){
                let intermediate = new $c1ClW.ATNConfigSet();
                for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
                currentConfigs = intermediate;
            }
        }
        closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
            if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (!config.context.isEmpty) {
                    let hasEmpty = config.context.hasEmpty;
                    let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                    for(let i = 0; i < nonEmptySize; i++){
                        let newContext = config.context.getParent(i);
                        let returnState = this.atn.states[config.context.getReturnState(i)];
                        let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                        c.outerContextDepth = config.outerContextDepth;
                        c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                        $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                    }
                    if (!hasEmpty || !hasMoreContexts) return;
                    config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                } else if (!hasMoreContexts) {
                    configs.add(config, contextCache);
                    return;
                } else {
                    if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                    if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                    else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) configs.add(config, contextCache);
                }
            }
            let p = config.state;
            if (!p.onlyHasEpsilonTransitions) {
                configs.add(config, contextCache);
                if (ParserATNSimulator.debug) console.log("added config " + configs);
            }
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                    let precedenceDecision = p;
                    let suppress = true;
                    for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                        suppress = false;
                        break;
                    }
                    if (suppress) continue;
                }
                let t = p.getOptimizedTransition(i);
                let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
                let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
                if (c != null) {
                    if (t instanceof $aybFP.RuleTransition) {
                        if (intermediate != null && !collectPredicates) {
                            intermediate.add(c, contextCache);
                            continue;
                        }
                    }
                    let newDepth = depth;
                    if (config.state instanceof $4kGBm.RuleStopState) {
                        if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                            let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                            if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                        }
                        c.outerContextDepth = c.outerContextDepth + 1;
                        if (!closureBusy.add(c)) continue;
                        $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        newDepth--;
                        if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                    } else if (t instanceof $aybFP.RuleTransition) {
                        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                            $bbHFU(c.context === config.context);
                            if (newDepth === 0) {
                                newDepth--;
                                if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) c.outerContextDepth = c.outerContextDepth + 1;
                            }
                        } else if (newDepth >= 0) newDepth++;
                    } else {
                        if (!t.isEpsilon && !closureBusy.add(c)) continue;
                    }
                    this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
                }
            }
        }
        getRuleName(index) {
            if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
            return "<rule " + index + ">";
        }
        getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
            switch(t.serializationType){
                case 3:
                    return this.ruleTransition(config, t, contextCache);
                case 10:
                    return this.precedenceTransition(config, t, collectPredicates, inContext);
                case 4:
                    return this.predTransition(config, t, collectPredicates, inContext);
                case 6:
                    return this.actionTransition(config, t);
                case 1:
                    return config.transform(t.target, false);
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                    }
                    return undefined;
                default:
                    return undefined;
            }
        }
        actionTransition(config, t) {
            if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
            return config.transform(t.target, false);
        }
        precedenceTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && inContext) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        predTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        ruleTransition(config, t, contextCache) {
            if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
            let returnState = t.followState;
            let newContext;
            if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
            else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
            else newContext = config.context.getChild(returnState.stateNumber);
            return config.transform(t.target, false, newContext);
        }
        isConflicted(configset, contextCache) {
            if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
            let configs = configset.toArray();
            configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
            let exact = !configset.dipsIntoOuterContext;
            let alts = new $5BPMp.BitSet();
            let minAlt = configs[0].alt;
            alts.set(minAlt);
            let currentState = configs[0].state.nonStopStateNumber;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                if (stateNumber !== currentState) {
                    if (config.alt !== minAlt) return undefined;
                    currentState = stateNumber;
                }
            }
            let representedAlts;
            if (exact) {
                currentState = configs[0].state.nonStopStateNumber;
                representedAlts = new $5BPMp.BitSet();
                let maxAlt = minAlt;
                for (let config of configs){
                    if (config.state.nonStopStateNumber !== currentState) break;
                    let alt = config.alt;
                    representedAlts.set(alt);
                    maxAlt = alt;
                }
                currentState = configs[0].state.nonStopStateNumber;
                let currentAlt = minAlt;
                for (let config of configs){
                    let stateNumber = config.state.nonStopStateNumber;
                    let alt = config.alt;
                    if (stateNumber !== currentState) {
                        if (currentAlt !== maxAlt) {
                            exact = false;
                            break;
                        }
                        currentState = stateNumber;
                        currentAlt = minAlt;
                    } else if (alt !== currentAlt) {
                        if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                            exact = false;
                            break;
                        }
                        currentAlt = alt;
                    }
                }
            }
            currentState = configs[0].state.nonStopStateNumber;
            let firstIndexCurrentState = 0;
            let lastIndexCurrentStateMinAlt = 0;
            let joinedCheckContext = configs[0].context;
            for(let i = 1; i < configs.length; i++){
                let config = configs[i];
                if (config.alt !== minAlt) break;
                if (config.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
            }
            for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
                let config = configs[i];
                let state = config.state;
                alts.set(config.alt);
                if (state.nonStopStateNumber !== currentState) {
                    currentState = state.nonStopStateNumber;
                    firstIndexCurrentState = i;
                    lastIndexCurrentStateMinAlt = i;
                    joinedCheckContext = config.context;
                    for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                        let config2 = configs[j];
                        if (config2.alt !== minAlt) break;
                        if (config2.state.nonStopStateNumber !== currentState) break;
                        lastIndexCurrentStateMinAlt = j;
                        joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                    }
                    i = lastIndexCurrentStateMinAlt;
                    continue;
                }
                let joinedCheckContext2 = config.context;
                let currentAlt = config.alt;
                let lastIndexCurrentStateCurrentAlt = i;
                for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== currentAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateCurrentAlt = j;
                    joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
                }
                i = lastIndexCurrentStateCurrentAlt;
                let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
                if (!joinedCheckContext.equals(check)) return undefined;
                exact = exact && joinedCheckContext.equals(joinedCheckContext2);
            }
            return new $gsRaX.ConflictInfo(alts, exact);
        }
        getConflictingAltsFromConfigSet(configs) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                conflictingAlts = new $5BPMp.BitSet();
                conflictingAlts.set(configs.uniqueAlt);
            }
            return conflictingAlts;
        }
        getTokenName(t) {
            if (t === $2DVsz.Token.EOF) return "EOF";
            let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            let displayName = vocabulary.getDisplayName(t);
            if (displayName === String(t)) return displayName;
            return displayName + "<" + t + ">";
        }
        getLookaheadName(input) {
            return this.getTokenName(input.LA(1));
        }
        dumpDeadEndConfigs(nvae) {
            console.log("dead end configs: ");
            let deadEndConfigs = nvae.deadEndConfigs;
            if (!deadEndConfigs) return;
            for (let c of deadEndConfigs){
                let trans = "no edges";
                if (c.state.numberOfOptimizedTransitions > 0) {
                    let t = c.state.getOptimizedTransition(0);
                    if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                    else if (t instanceof $Np2R3.SetTransition) {
                        let not = t instanceof $FLEKS.NotSetTransition;
                        trans = (not ? "~" : "") + "Set " + t.set.toString();
                    }
                }
                console.log(c.toString(this._parser, true) + ":" + trans);
            }
        }
        noViableAlt(input, outerContext, configs, startIndex) {
            return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
        }
        getUniqueAlt(configs) {
            let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of configs){
                if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt;
                else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            }
            return alt;
        }
        configWithAltAtStopState(configs, alt) {
            for (let c of configs)if (c.alt === alt) {
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
            $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
            let from = fromState;
            let to = this.addDFAState(dfa, toConfigs, contextCache);
            if (contextTransitions != null) for (let context of contextTransitions.toArray()){
                if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (from.configs.isOutermostConfigSet) continue;
                }
                from.setContextSensitive(this.atn);
                from.setContextSymbol(t);
                let next = from.getContextTarget(context);
                if (next != null) {
                    from = next;
                    continue;
                }
                next = this.addDFAContextState(dfa, from.configs, context, contextCache);
                $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
                from.setContextTarget(context, next);
                from = next;
            }
            if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
            this.setDFAEdge(from, t, to);
            if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
            return to;
        }
        setDFAEdge(p, t, q) {
            if (p != null) p.setTarget(t, q);
        }
        addDFAContextState(dfa, configs, returnContext, contextCache) {
            if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                let contextConfigs = new $c1ClW.ATNConfigSet();
                for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
                return this.addDFAState(dfa, contextConfigs, contextCache);
            } else {
                $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
                configs = configs.clone(true);
                configs.isOutermostConfigSet = true;
                return this.addDFAState(dfa, configs, contextCache);
            }
        }
        addDFAState(dfa, configs, contextCache) {
            let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
            if (enableDfa) {
                if (!configs.isReadOnly) configs.optimizeConfigs(this);
                let proposed = this.createDFAState(dfa, configs);
                let existing = dfa.states.get(proposed);
                if (existing != null) return existing;
            }
            if (!configs.isReadOnly) {
                if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
            }
            let newState = this.createDFAState(dfa, configs.clone(true));
            let decisionState = this.atn.getDecisionState(dfa.decision);
            let predictedAlt = this.getUniqueAlt(configs);
            if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
            else if (configs.conflictingAlts != null) {
                let conflictingAlts = configs.conflictingAlts;
                if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
            }
            if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
            if (!enableDfa) return newState;
            let added = dfa.addState(newState);
            if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
            return added;
        }
        createDFAState(dfa, configs) {
            return new $2jevZ.DFAState(configs);
        }
        reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            }
        }
        reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
            }
        }
        reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            }
        }
        getReturnState(context) {
            if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            let state = this.atn.states[context.invokingState];
            let transition = state.transition(0);
            return transition.followState.stateNumber;
        }
        skipTailCalls(context) {
            if (!this.optimize_tail_calls) return context;
            while(!context.isEmpty){
                let state = this.atn.states[context.invokingState];
                $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3);
                let transition = state.transition(0);
                if (!transition.tailCall) break;
                context = context.parent;
            }
            return context;
        }
        get parser() {
            return this._parser;
        }
    };
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
        let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
        if (diff !== 0) return diff;
        diff = o1.alt - o2.alt;
        if (diff !== 0) return diff;
        return 0;
    };
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Override
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
    $ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
    module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;
});
parcelRegister("gsRaX", function(module, exports) {
    "use strict";
    var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConflictInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2IEP9 = parcelRequire("2IEP9");
    class $bfc8827830a146f2$var$ConflictInfo {
        constructor(conflictedAlts, exact){
            this._conflictedAlts = conflictedAlts;
            this.exact = exact;
        }
        get conflictedAlts() {
            return this._conflictedAlts;
        }
        get isExact() {
            return this.exact;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
            return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
        }
        hashCode() {
            return this.conflictedAlts.hashCode();
        }
    }
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
    module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;
});
parcelRegister("6bmaO", function(module, exports) {
    "use strict";
    var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserRuleContext = void 0;
    var $cdCft = parcelRequire("cdCft");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $c8jEe = parcelRequire("c8jEe");
    var $kYC92 = parcelRequire("kYC92");
    class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber == null) super();
            else super(parent, invokingStateNumber);
        }
        static emptyContext() {
            return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
        }
        copyFrom(ctx) {
            this._parent = ctx._parent;
            this.invokingState = ctx.invokingState;
            this._start = ctx._start;
            this._stop = ctx._stop;
            if (ctx.children) {
                this.children = [];
                for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
            }
        }
        enterRule(listener) {}
        exitRule(listener) {}
        addAnyChild(t) {
            if (!this.children) this.children = [
                t
            ];
            else this.children.push(t);
            return t;
        }
        addChild(t) {
            let result;
            if (t instanceof $kYC92.TerminalNode) {
                t.setParent(this);
                this.addAnyChild(t);
                return;
            } else if (t instanceof $c8jEe.RuleContext) {
                this.addAnyChild(t);
                return;
            } else {
                t = new $kYC92.TerminalNode(t);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        addErrorNode(node) {
            if (node instanceof $cdCft.ErrorNode) {
                const errorNode = node;
                errorNode.setParent(this);
                return this.addAnyChild(errorNode);
            } else {
                const badToken = node;
                let t = new $cdCft.ErrorNode(badToken);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        removeLastChild() {
            if (this.children) this.children.pop();
        }
        get parent() {
            let parent = super.parent;
            if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
            throw new TypeError("Invalid parent type for ParserRuleContext");
        }
        getChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
            if (ctxType == null) return this.children[i];
            let result = this.tryGetChild(i, ctxType);
            if (result === undefined) throw new Error("The specified node does not exist");
            return result;
        }
        tryGetChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof ctxType) {
                j++;
                if (j === i) return o;
            }
            return undefined;
        }
        getToken(ttype, i) {
            let result = this.tryGetToken(ttype, i);
            if (result === undefined) throw new Error("The specified token does not exist");
            return result;
        }
        tryGetToken(ttype, i) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) {
                    j++;
                    if (j === i) return o;
                }
            }
            return undefined;
        }
        getTokens(ttype) {
            let tokens = [];
            if (!this.children) return tokens;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) tokens.push(o);
            }
            return tokens;
        }
        get ruleContext() {
            return this;
        }
        getRuleContext(i, ctxType) {
            return this.getChild(i, ctxType);
        }
        tryGetRuleContext(i, ctxType) {
            return this.tryGetChild(i, ctxType);
        }
        getRuleContexts(ctxType) {
            let contexts = [];
            if (!this.children) return contexts;
            for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
            return contexts;
        }
        get childCount() {
            return this.children ? this.children.length : 0;
        }
        get sourceInterval() {
            if (!this._start) return $gcfUE.Interval.INVALID;
            if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1);
            return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
        }
        get start() {
            return this._start;
        }
        get stop() {
            return this._stop;
        }
        toInfoString(recognizer) {
            let rules = recognizer.getRuleInvocationStack(this).reverse();
            return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
        }
    }
    $4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
    module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;
});
parcelRegister("cdCft", function(module, exports) {
    "use strict";
    var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ErrorNode = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $kYC92 = parcelRequire("kYC92");
    class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
        constructor(token){
            super(token);
        }
        accept(visitor) {
            return visitor.visitErrorNode(this);
        }
    }
    $8e545e4dd69efabc$var$__decorate([
        $d6D31.Override
    ], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
    module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;
});
parcelRegister("kYC92", function(module, exports) {
    "use strict";
    var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TerminalNode = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $f4570001c9e8b34c$var$TerminalNode {
        constructor(symbol){
            this._symbol = symbol;
        }
        getChild(i) {
            throw new RangeError("Terminal Node has no children.");
        }
        get symbol() {
            return this._symbol;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this._symbol;
        }
        get sourceInterval() {
            let tokenIndex = this._symbol.tokenIndex;
            return new $gcfUE.Interval(tokenIndex, tokenIndex);
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitTerminal(this);
        }
        get text() {
            return this._symbol.text || "";
        }
        toStringTree(parser) {
            return this.toString();
        }
        toString() {
            if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
            return this._symbol.text || "";
        }
    }
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
    module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;
});
parcelRegister("c8jEe", function(module, exports) {
    "use strict";
    var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContext = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2WQcE = parcelRequire("2WQcE");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $axprj = parcelRequire("axprj");
    var $6bmaO = parcelRequire("6bmaO");
    class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
        constructor(parent, invokingState){
            super();
            this._parent = parent;
            this.invokingState = invokingState != null ? invokingState : -1;
        }
        static getChildContext(parent, invokingState) {
            return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
        }
        depth() {
            let n = 0;
            let p = this;
            while(p){
                p = p._parent;
                n++;
            }
            return n;
        }
        get isEmpty() {
            return this.invokingState === -1;
        }
        get sourceInterval() {
            return $gcfUE.Interval.INVALID;
        }
        get ruleContext() {
            return this;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this;
        }
        get text() {
            if (this.childCount === 0) return "";
            let builder = "";
            for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
            return builder.toString();
        }
        get ruleIndex() {
            return -1;
        }
        get altNumber() {
            return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        set altNumber(altNumber) {}
        getChild(i) {
            throw new RangeError("i must be greater than or equal to 0 and less than childCount");
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitChildren(this);
        }
        toStringTree(recog) {
            return $axprj.Trees.toStringTree(this, recog);
        }
        toString(arg1, stop) {
            const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
            stop = stop || $6bmaO.ParserRuleContext.emptyContext();
            let buf = "";
            let p = this;
            buf += "[";
            while(p && p !== stop){
                if (!ruleNames) {
                    if (!p.isEmpty) buf += p.invokingState;
                } else {
                    let ruleIndex = p.ruleIndex;
                    let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                    buf += ruleName;
                }
                if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
                p = p._parent;
            }
            buf += "]";
            return buf.toString();
        }
    }
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
    module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;
});
parcelRegister("2WQcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleNode = void 0;
    class $22597dffc9942eb7$var$RuleNode {
    }
    module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;
});
parcelRegister("axprj", function(module, exports) {
    "use strict";
    var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Trees = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $j53rr = parcelRequire("j53rr");
    var $cdCft = parcelRequire("cdCft");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $2WQcE = parcelRequire("2WQcE");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $7ac0b835c35ad12a$var$Trees {
        static toStringTree(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else ruleNames = arg2;
            let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            if (t.childCount === 0) return s;
            let buf = "";
            buf += "(";
            s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            buf += s;
            buf += " ";
            for(let i = 0; i < t.childCount; i++){
                if (i > 0) buf += " ";
                buf += this.toStringTree(t.getChild(i), ruleNames);
            }
            buf += ")";
            return buf;
        }
        static getNodeText(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else if (arg2) ruleNames = arg2;
            else {
                let payload = t.payload;
                if (typeof payload.text === "string") return payload.text;
                return t.payload.toString();
            }
            if (t instanceof $2WQcE.RuleNode) {
                let ruleContext = t.ruleContext;
                let ruleIndex = ruleContext.ruleIndex;
                let ruleName = ruleNames[ruleIndex];
                let altNumber = ruleContext.altNumber;
                if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
                return ruleName;
            } else if (t instanceof $cdCft.ErrorNode) return t.toString();
            else if (t instanceof $kYC92.TerminalNode) {
                let symbol = t.symbol;
                return symbol.text || "";
            }
            throw new TypeError("Unexpected node type");
        }
        static getChildren(t) {
            let kids = [];
            for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
            return kids;
        }
        static getAncestors(t) {
            let ancestors = [];
            let p = t.parent;
            while(p){
                ancestors.unshift(p);
                p = p.parent;
            }
            return ancestors;
        }
        static isAncestorOf(t, u) {
            if (!t || !u || !t.parent) return false;
            let p = u.parent;
            while(p){
                if (t === p) return true;
                p = p.parent;
            }
            return false;
        }
        static findAllTokenNodes(t, ttype) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
        }
        static findAllRuleNodes(t, ruleIndex) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
        }
        static findAllNodes(t, index, findTokens) {
            let nodes = [];
            $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
            return nodes;
        }
        static _findAllNodes(t, index, findTokens, nodes) {
            if (findTokens && t instanceof $kYC92.TerminalNode) {
                if (t.symbol.type === index) nodes.push(t);
            } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
                if (t.ruleIndex === index) nodes.push(t);
            }
            for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
        }
        static getDescendants(t) {
            let nodes = [];
            function recurse(e) {
                nodes.push(e);
                const n = e.childCount;
                for(let i = 0; i < n; i++)recurse(e.getChild(i));
            }
            recurse(t);
            return nodes;
        }
        static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let child = t.getChild(i);
                let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
                if (r) return r;
            }
            if (t instanceof $6bmaO.ParserRuleContext) {
                let stopToken = t.stop;
                if (startTokenIndex >= t.start.tokenIndex && (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) return t;
            }
            return undefined;
        }
        static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
            if (!t) return;
            let count = t.childCount;
            for(let i = 0; i < count; i++){
                let child = t.getChild(i);
                let range = child.sourceInterval;
                if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                    if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                        let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                        t.children[i] = new $kYC92.TerminalNode(abbrev);
                    }
                }
            }
        }
        static findNodeSuchThat(t, pred) {
            if (pred(t)) return t;
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
                if (u !== undefined) return u;
            }
            return undefined;
        }
    }
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
    $7ac0b835c35ad12a$var$__decorate([
        $d6D31.NotNull,
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
    module.exports.Trees = $7ac0b835c35ad12a$var$Trees;
});
parcelRegister("gDZVV", function(module, exports) {
    "use strict";
    var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionMode = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $4kGBm = parcelRequire("4kGBm");
    var $c1e05489d1cdbc78$var$PredictionMode;
    (function(PredictionMode) {
        PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
        PredictionMode[PredictionMode["LL"] = 1] = "LL";
        PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
    (function(PredictionMode) {
        class AltAndContextMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(AltAndContextConfigEqualityComparator.INSTANCE);
            }
        }
        class AltAndContextConfigEqualityComparator {
            AltAndContextConfigEqualityComparator() {}
            hashCode(o) {
                let hashCode = $iXFjm.MurmurHash.initialize(7);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
                return hashCode;
            }
            equals(a, b) {
                if (a === b) return true;
                if (a == null || b == null) return false;
                return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
            }
        }
        AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
        function hasConfigInRuleStopState(configs) {
            for (let c of configs){
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
        function allConfigsInRuleStopStates(configs) {
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
            }
            return true;
        }
        PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
});
parcelRegister("g7SCF", function(module, exports) {
    "use strict";
    var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SimulatorState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
        constructor(outerContext, s0, useContext, remainingOuterContext){
            this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
            this.s0 = s0;
            this.useContext = useContext;
            this.remainingOuterContext = remainingOuterContext;
        }
    };
    $bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
        $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
    ], $bbd7abb561fe52b9$var$SimulatorState);
    module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;
});
parcelRegister("d1V7w", function(module, exports) {
    "use strict";
    var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_BLOCK_START;
        }
    }
    $97c7ad4039a43616$var$__decorate([
        $d6D31.Override
    ], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
    module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;
});
parcelRegister("7qlbM", function(module, exports) {
    "use strict";
    var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusLoopbackState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
        }
    }
    $567b65d0d9bb1bcd$var$__decorate([
        $d6D31.Override
    ], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
    module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;
});
parcelRegister("7KGEQ", function(module, exports) {
    "use strict";
    var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PrecedencePredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, precedence){
            super(target);
            this.precedence = precedence;
        }
        get serializationType() {
            return 10;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
        }
        toString() {
            return this.precedence + " >= _p";
        }
    };
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
    $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
        $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
    module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;
});
parcelRegister("aISkF", function(module, exports) {
    "use strict";
    var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RangeTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
        constructor(target, from, to){
            super(target);
            this.from = from;
            this.to = to;
        }
        get serializationType() {
            return 2;
        }
        get label() {
            return $hGRod.IntervalSet.of(this.from, this.to);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= this.from && symbol <= this.to;
        }
        toString() {
            return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
        }
    };
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
    $7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
        $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
    ], $7ce828b1bf424f49$var$RangeTransition);
    module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;
});
parcelRegister("j2zc8", function(module, exports) {
    "use strict";
    var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStartState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.isPrecedenceRule = false;
            this.leftFactored = false;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_START;
        }
    }
    $ddc981289e81a506$var$__decorate([
        $d6D31.Override
    ], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
    module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;
});
parcelRegister("jEsaF", function(module, exports) {
    "use strict";
    var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.STAR_BLOCK_START;
        }
    }
    $e4e79af439480b0e$var$__decorate([
        $d6D31.Override
    ], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
    module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;
});
parcelRegister("bjwd1", function(module, exports) {
    "use strict";
    var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopbackState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
        get loopEntryState() {
            return this.transition(0).target;
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_BACK;
        }
    }
    $83ca741f127bc1b0$var$__decorate([
        $d6D31.Override
    ], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
    module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;
});
parcelRegister("WS4d7", function(module, exports) {
    "use strict";
    var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TokensStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.TOKEN_START;
        }
    }
    $0b0f5b750847d473$var$__decorate([
        $d6D31.Override
    ], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
    module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;
});
parcelRegister("kWxOc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.UUID = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    class $f3f3731a7838b7f9$var$UUID {
        constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
            this.data = new Uint32Array(4);
            this.data[0] = mostSigBits;
            this.data[1] = moreSigBits;
            this.data[2] = lessSigBits;
            this.data[3] = leastSigBits;
        }
        static fromString(data) {
            if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
            let segments = data.split("-");
            let mostSigBits = parseInt(segments[0], 16);
            let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
            let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
            let leastSigBits = parseInt(segments[4].substr(-8), 16);
            return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode([
                this.data[0],
                this.data[1],
                this.data[2],
                this.data[3]
            ]);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
            return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
        }
        toString() {
            return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
        }
    }
    module.exports.UUID = $f3f3731a7838b7f9$var$UUID;
});
parcelRegister("3iOjI", function(module, exports) {
    "use strict";
    var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $267a15775466fb93$var$ParseInfo = class ParseInfo {
        constructor(atnSimulator){
            this.atnSimulator = atnSimulator;
        }
        getDecisionInfo() {
            return this.atnSimulator.getDecisionInfo();
        }
        getLLDecisions() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let LL = [];
            for(let i = 0; i < decisions.length; i++){
                let fallBack = decisions[i].LL_Fallback;
                if (fallBack > 0) LL.push(i);
            }
            return LL;
        }
        getTotalTimeInPrediction() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let t = 0;
            for (let decision of decisions)t += decision.timeInPrediction;
            return t;
        }
        getTotalSLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_TotalLook;
            return k;
        }
        getTotalLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_TotalLook;
            return k;
        }
        getTotalSLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_ATNTransitions;
            return k;
        }
        getTotalLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_ATNTransitions;
            return k;
        }
        getTotalATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions){
                k += decision.SLL_ATNTransitions;
                k += decision.LL_ATNTransitions;
            }
            return k;
        }
        getDFASize(decision) {
            if (decision) {
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
                return decisionToDFA.states.size;
            } else {
                let n = 0;
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
                for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
                return n;
            }
        }
    };
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
    $267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
        $267a15775466fb93$var$__param(0, $d6D31.NotNull)
    ], $267a15775466fb93$var$ParseInfo);
    module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;
});
parcelRegister("5xwgp", function(module, exports) {
    "use strict";
    var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyParserErrorListener = void 0;
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
        constructor(delegates){
            super(delegates);
        }
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            });
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            });
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
            });
        }
    }
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
    module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;
});
parcelRegister("dE6Cn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1rIkv").then(()=>parcelRequire('gpWGO'));
});
parcelRegister("kSEFX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d6qIW").then(()=>parcelRequire('cJzXV'));
});
parcelRegister("3kXUy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseCancellationException = void 0;
    class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
        constructor(cause){
            super(cause.message);
            this.cause = cause;
            this.stack = cause.stack;
        }
        getCause() {
            return this.cause;
        }
    }
    module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;
});
parcelRegister("1UkCC", function(module, exports) {
    "use strict";
    var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BufferedTokenStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
        constructor(tokenSource){
            this.tokens = [];
            this.p = -1;
            this.fetchedEOF = false;
            if (tokenSource == null) throw new Error("tokenSource cannot be null");
            this._tokenSource = tokenSource;
        }
        get tokenSource() {
            return this._tokenSource;
        }
        set tokenSource(tokenSource) {
            this._tokenSource = tokenSource;
            this.tokens.length = 0;
            this.p = -1;
            this.fetchedEOF = false;
        }
        get index() {
            return this.p;
        }
        mark() {
            return 0;
        }
        release(marker) {}
        seek(index) {
            this.lazyInit();
            this.p = this.adjustSeekIndex(index);
        }
        get size() {
            return this.tokens.length;
        }
        consume() {
            let skipEofCheck;
            if (this.p >= 0) {
                if (this.fetchedEOF) skipEofCheck = this.p < this.tokens.length - 1;
                else skipEofCheck = this.p < this.tokens.length;
            } else skipEofCheck = false;
            if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
            if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
        }
        sync(i) {
            $bbHFU(i >= 0);
            let n = i - this.tokens.length + 1;
            if (n > 0) {
                let fetched = this.fetch(n);
                return fetched >= n;
            }
            return true;
        }
        fetch(n) {
            if (this.fetchedEOF) return 0;
            for(let i = 0; i < n; i++){
                let t = this.tokenSource.nextToken();
                if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
                this.tokens.push(t);
                if (t.type === $2DVsz.Token.EOF) {
                    this.fetchedEOF = true;
                    return i + 1;
                }
            }
            return n;
        }
        get(i) {
            if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
            return this.tokens[i];
        }
        getRange(start, stop) {
            if (start < 0 || stop < 0) return [];
            this.lazyInit();
            let subset = new Array();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                subset.push(t);
            }
            return subset;
        }
        LA(i) {
            let token = this.LT(i);
            if (!token) return $2DVsz.Token.INVALID_TYPE;
            return token.type;
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            return this.tokens[this.p - k];
        }
        LT(k) {
            let result = this.tryLT(k);
            if (result === undefined) throw new RangeError("requested lookback index out of range");
            return result;
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p + k - 1;
            this.sync(i);
            if (i >= this.tokens.length) return this.tokens[this.tokens.length - 1];
            return this.tokens[i];
        }
        adjustSeekIndex(i) {
            return i;
        }
        lazyInit() {
            if (this.p === -1) this.setup();
        }
        setup() {
            this.sync(0);
            this.p = this.adjustSeekIndex(0);
        }
        getTokens(start, stop, types) {
            this.lazyInit();
            if (start === undefined) {
                $bbHFU(stop === undefined && types === undefined);
                return this.tokens;
            } else if (stop === undefined) stop = this.tokens.length - 1;
            if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
            if (start > stop) return [];
            if (types === undefined) return this.tokens.slice(start, stop + 1);
            else if (typeof types === "number") types = new Set().add(types);
            let typesSet = types;
            let filteredTokens = this.tokens.slice(start, stop + 1);
            filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
            return filteredTokens;
        }
        nextTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            let token = this.tokens[i];
            while(token.channel !== channel){
                if (token.type === $2DVsz.Token.EOF) return i;
                i++;
                this.sync(i);
                token = this.tokens[i];
            }
            return i;
        }
        previousTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            while(i >= 0){
                let token = this.tokens[i];
                if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
                i--;
            }
            return i;
        }
        getHiddenTokensToRight(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            let to;
            let from = tokenIndex + 1;
            if (nextOnChannel === -1) to = this.size - 1;
            else to = nextOnChannel;
            return this.filterForChannel(from, to, channel);
        }
        getHiddenTokensToLeft(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            if (tokenIndex === 0) return [];
            let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            if (prevOnChannel === tokenIndex - 1) return [];
            let from = prevOnChannel + 1;
            let to = tokenIndex - 1;
            return this.filterForChannel(from, to, channel);
        }
        filterForChannel(from, to, channel) {
            let hidden = new Array();
            for(let i = from; i <= to; i++){
                let t = this.tokens[i];
                if (channel === -1) {
                    if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
                } else if (t.channel === channel) hidden.push(t);
            }
            return hidden;
        }
        get sourceName() {
            return this.tokenSource.sourceName;
        }
        getText(interval) {
            if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
            else if (!(interval instanceof $gcfUE.Interval)) interval = interval.sourceInterval;
            let start = interval.a;
            let stop = interval.b;
            if (start < 0 || stop < 0) return "";
            this.fill();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            let buf = "";
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                buf += t.text;
            }
            return buf.toString();
        }
        getTextFromRange(start, stop) {
            if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
            return "";
        }
        fill() {
            this.lazyInit();
            const blockSize = 1000;
            while(true){
                let fetched = this.fetch(blockSize);
                if (fetched < blockSize) return;
            }
        }
        isWritableToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
        isToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
    };
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
    $163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
        $163b0480402006d6$var$__param(0, $d6D31.NotNull)
    ], $163b0480402006d6$var$BufferedTokenStream);
    module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;
});
parcelRegister("QidO0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9NnFz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CharStreams = void 0;
    var $1Olk0 = parcelRequire("1Olk0");
    var $7ufNj = parcelRequire("7ufNj");
    var $ceaEj = parcelRequire("ceaEj");
    var $721b0cebe5798117$var$CharStreams;
    (function(CharStreams) {
        function fromString(s, sourceName) {
            if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
            let cb = new Uint16Array(s.length);
            for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
            codePointBufferBuilder.append(cb);
            return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
        }
        CharStreams.fromString = fromString;
    })($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));
});
parcelRegister("1Olk0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointBuffer = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $gIRNa = parcelRequire("gIRNa");
    class $151b0001e5dcadf1$var$CodePointBuffer {
        constructor(buffer, size){
            this.buffer = buffer;
            this._position = 0;
            this._size = size;
        }
        static withArray(buffer) {
            return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
        }
        get position() {
            return this._position;
        }
        set position(newPosition) {
            if (newPosition < 0 || newPosition > this._size) throw new RangeError();
            this._position = newPosition;
        }
        get remaining() {
            return this._size - this.position;
        }
        get(offset) {
            return this.buffer[offset];
        }
        array() {
            return this.buffer.slice(0, this._size);
        }
        static builder(initialBufferSize) {
            return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
        }
    }
    module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
    (function(CodePointBuffer) {
        let Type;
        (function(Type) {
            Type[Type["BYTE"] = 0] = "BYTE";
            Type[Type["CHAR"] = 1] = "CHAR";
            Type[Type["INT"] = 2] = "INT";
        })(Type || (Type = {}));
        class Builder {
            constructor(initialBufferSize){
                this.type = 0;
                this.buffer = new Uint8Array(initialBufferSize);
                this.prevHighSurrogate = -1;
                this.position = 0;
            }
            build() {
                return new CodePointBuffer(this.buffer, this.position);
            }
            static roundUpToNextPowerOfTwo(i) {
                let nextPowerOfTwo = 32 - Math.clz32(i - 1);
                return Math.pow(2, nextPowerOfTwo);
            }
            ensureRemaining(remainingNeeded) {
                switch(this.type){
                    case 0:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint8Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 1:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint16Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 2:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Int32Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                }
            }
            append(utf16In) {
                this.ensureRemaining(utf16In.length);
                this.appendArray(utf16In);
            }
            appendArray(utf16In) {
                switch(this.type){
                    case 0:
                        this.appendArrayByte(utf16In);
                        break;
                    case 1:
                        this.appendArrayChar(utf16In);
                        break;
                    case 2:
                        this.appendArrayInt(utf16In);
                        break;
                }
            }
            appendArrayByte(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outByte = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (c <= 0xFF) outByte[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        if (!$gIRNa.isHighSurrogate(c)) {
                            this.byteToCharBuffer(utf16In.length);
                            this.appendArrayChar(utf16In);
                            return;
                        } else {
                            this.byteToIntBuffer(utf16In.length);
                            this.appendArrayInt(utf16In);
                            return;
                        }
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayChar(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outChar = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        this.charToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayInt(utf16In) {
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outInt = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    inOffset++;
                    if (this.prevHighSurrogate !== -1) {
                        if ($gIRNa.isLowSurrogate(c)) {
                            outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        } else {
                            outInt[outOffset] = this.prevHighSurrogate;
                            outOffset++;
                            if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                            else {
                                outInt[outOffset] = c;
                                outOffset++;
                                this.prevHighSurrogate = -1;
                            }
                        }
                    } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                    else {
                        outInt[outOffset] = c;
                        outOffset++;
                    }
                }
                if (this.prevHighSurrogate !== -1) {
                    outInt[outOffset] = this.prevHighSurrogate;
                    outOffset++;
                }
                this.position = outOffset;
            }
            byteToCharBuffer(toAppend) {
                let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 1;
                this.buffer = newBuffer;
            }
            byteToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
            charToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
        }
        CodePointBuffer.Builder = Builder;
    })($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));
});
parcelRegister("gIRNa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
    function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
        return ch >= 0xD800 && ch <= 0xDBFF;
    }
    module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
    function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
        return ch >= 0xDC00 && ch <= 0xDFFF;
    }
    module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
    function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
        return ch >= 0x10000;
    }
    module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;
});
parcelRegister("7ufNj", function(module, exports) {
    "use strict";
    var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointCharStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $ceaEj = parcelRequire("ceaEj");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $57379632ac21bb89$var$CodePointCharStream {
        constructor(array, position, remaining, name){
            $bbHFU(position === 0);
            this._array = array;
            this._size = remaining;
            this._name = name;
            this._position = 0;
        }
        get internalStorage() {
            return this._array;
        }
        static fromBuffer(codePointBuffer, name) {
            if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
        }
        consume() {
            if (this._size - this._position === 0) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new RangeError("cannot consume EOF");
            }
            this._position++;
        }
        get index() {
            return this._position;
        }
        get size() {
            return this._size;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            this._position = index;
        }
        get sourceName() {
            return this._name;
        }
        toString() {
            return this.getText($gcfUE.Interval.of(0, this.size - 1));
        }
        LA(i) {
            let offset;
            switch(Math.sign(i)){
                case -1:
                    offset = this.index + i;
                    if (offset < 0) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
                case 0:
                    return 0;
                case 1:
                    offset = this.index + i - 1;
                    if (offset >= this.size) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
            }
            throw new RangeError("Not reached");
        }
        getText(interval) {
            const startIdx = Math.min(interval.a, this.size);
            const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
            if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
            else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        }
    }
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
    module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;
});
parcelRegister("a0nC0", function(module, exports) {
    "use strict";
    var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenStream = void 0;
    var $1UkCC = parcelRequire("1UkCC");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
        constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
            super(tokenSource);
            this.channel = channel;
        }
        adjustSeekIndex(i) {
            return this.nextTokenOnChannel(i, this.channel);
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            let i = this.p;
            let n = 1;
            while(n <= k && i > 0){
                i = this.previousTokenOnChannel(i - 1, this.channel);
                n++;
            }
            if (i < 0) return undefined;
            return this.tokens[i];
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p;
            let n = 1;
            while(n < k){
                if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
                n++;
            }
            return this.tokens[i];
        }
        getNumberOfOnChannelTokens() {
            let n = 0;
            this.fill();
            for (let t of this.tokens){
                if (t.channel === this.channel) n++;
                if (t.type === $2DVsz.Token.EOF) break;
            }
            return n;
        }
    };
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
    $748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
        $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
    ], $748c38524e2afd86$var$CommonTokenStream);
    module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;
});
parcelRegister("4a3G0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Dependents = void 0;
    var $307af2a6cd217eb5$var$Dependents;
    (function(Dependents) {
        Dependents[Dependents["SELF"] = 0] = "SELF";
        Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
        Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
        Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
        Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
        Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
        Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
        Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
        Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
        Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
    })($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));
});
parcelRegister("5Poq6", function(module, exports) {
    "use strict";
    var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DiagnosticErrorListener = void 0;
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    class $43e4a87e035cc726$var$DiagnosticErrorListener {
        constructor(exactOnly = true){
            this.exactOnly = exactOnly;
            this.exactOnly = exactOnly;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {}
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (this.exactOnly && !exact) return;
            let decision = this.getDecisionDescription(recognizer, dfa);
            let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            let format = "reportAttemptingFullContext d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            let format = "reportContextSensitivity d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportContextSensitivity d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        getDecisionDescription(recognizer, dfa) {
            let decision = dfa.decision;
            let ruleIndex = dfa.atnStartState.ruleIndex;
            let ruleNames = recognizer.ruleNames;
            if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
            let ruleName = ruleNames[ruleIndex];
            if (!ruleName) return decision.toString();
            return `${decision} (${ruleName})`;
        }
        getConflictingAlts(reportedAlts, configs) {
            if (reportedAlts != null) return reportedAlts;
            let result = new $5BPMp.BitSet();
            for (let config of configs)result.set(config.alt);
            return result;
        }
    }
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
    $43e4a87e035cc726$var$__decorate([
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.NotNull,
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
    module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;
});
parcelRegister("5FrZ8", function(module, exports) {
    "use strict";
    var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InterpreterRuleContext = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
        constructor(ruleIndex, parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._ruleIndex = ruleIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
    }
    $42067d58e54221f4$var$__decorate([
        $d6D31.Override
    ], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
    module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;
});
parcelRegister("gMbxO", function(module, exports) {
    "use strict";
    var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerInterpreter = void 0;
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
        constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
            super(input);
            if (atn.grammarType !== 0) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._channelNames = channelNames.slice(0);
            this._modeNames = modeNames.slice(0);
            this._vocabulary = vocabulary;
            this._interp = new $lQecE.LexerATNSimulator(atn, this);
        }
        get atn() {
            return this._atn;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get channelNames() {
            return this._channelNames;
        }
        get modeNames() {
            return this._modeNames;
        }
        get vocabulary() {
            return this._vocabulary;
        }
    };
    $c36a1586c540a239$var$__decorate([
        $d6D31.NotNull
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
    $c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
        $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
    ], $c36a1586c540a239$var$LexerInterpreter);
    module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;
});
parcelRegister("drCaH", function(module, exports) {
    "use strict";
    var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ListTokenSource = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
        constructor(tokens, sourceName){
            this.i = 0;
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            if (tokens == null) throw new Error("tokens cannot be null");
            this.tokens = tokens;
            this._sourceName = sourceName;
        }
        get charPositionInLine() {
            if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
            else if (this.eofToken != null) return this.eofToken.charPositionInLine;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    let lastNewLine = tokenText.lastIndexOf("\n");
                    if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
                }
                return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
            }
            return 0;
        }
        nextToken() {
            if (this.i >= this.tokens.length) {
                if (this.eofToken == null) {
                    let start = -1;
                    if (this.tokens.length > 0) {
                        let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                        if (previousStop !== -1) start = previousStop + 1;
                    }
                    let stop = Math.max(-1, start - 1);
                    this.eofToken = this._factory.create({
                        source: this,
                        stream: this.inputStream
                    }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
                }
                return this.eofToken;
            }
            let t = this.tokens[this.i];
            if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
            this.i++;
            return t;
        }
        get line() {
            if (this.i < this.tokens.length) return this.tokens[this.i].line;
            else if (this.eofToken != null) return this.eofToken.line;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let line = lastToken.line;
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
                }
                return line;
            }
            return 1;
        }
        get inputStream() {
            if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
            else if (this.eofToken != null) return this.eofToken.inputStream;
            else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
            return undefined;
        }
        get sourceName() {
            if (this._sourceName) return this._sourceName;
            let inputStream = this.inputStream;
            if (inputStream != null) return inputStream.sourceName;
            return "List";
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get tokenFactory() {
            return this._factory;
        }
    };
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull,
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
    $9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource);
    module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;
});
parcelRegister("2pQQd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dReoi", function(module, exports) {
    "use strict";
    var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserInterpreter = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $5FrZ8 = parcelRequire("5FrZ8");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
        constructor(grammarFileName, vocabulary, ruleNames, atn, input){
            super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
            this._parentContextStack = [];
            this.overrideDecision = -1;
            this.overrideDecisionInputIndex = -1;
            this.overrideDecisionAlt = -1;
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
            if (grammarFileName instanceof ParserInterpreter) {
                let old = grammarFileName;
                this._grammarFileName = old._grammarFileName;
                this._atn = old._atn;
                this.pushRecursionContextStates = old.pushRecursionContextStates;
                this._ruleNames = old._ruleNames;
                this._vocabulary = old._vocabulary;
                this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
            } else {
                vocabulary;
                ruleNames;
                atn;
                this._grammarFileName = grammarFileName;
                this._atn = atn;
                this._ruleNames = ruleNames.slice(0);
                this._vocabulary = vocabulary;
                this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
                for (let state of atn.states){
                    if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                    if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
                }
                this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
            }
        }
        reset(resetInput) {
            if (resetInput === undefined) super.reset();
            else super.reset(resetInput);
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
        }
        get atn() {
            return this._atn;
        }
        get vocabulary() {
            return this._vocabulary;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        parse(startRuleIndex) {
            let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
            this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
            if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
            else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
            while(true){
                let p = this.atnState;
                switch(p.stateType){
                    case $1bs3X.ATNStateType.RULE_STOP:
                        if (this._ctx.isEmpty) {
                            if (startRuleStartState.isPrecedenceRule) {
                                let result = this._ctx;
                                let parentContext = this._parentContextStack.pop();
                                this.unrollRecursionContexts(parentContext[0]);
                                return result;
                            } else {
                                this.exitRule();
                                return this._rootContext;
                            }
                        }
                        this.visitRuleStopState(p);
                        break;
                    default:
                        try {
                            this.visitState(p);
                        } catch (e) {
                            if (e instanceof $fLdDn.RecognitionException) {
                                this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                                this.context.exception = e;
                                this.errorHandler.reportError(this, e);
                                this.recover(e);
                            } else throw e;
                        }
                        break;
                }
            }
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this._parentContextStack.push([
                this._ctx,
                localctx.invokingState
            ]);
            super.enterRecursionRule(localctx, state, ruleIndex, precedence);
        }
        get atnState() {
            return this._atn.states[this.state];
        }
        visitState(p) {
            let predictedAlt = 1;
            if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
            let transition = p.transition(predictedAlt - 1);
            switch(transition.serializationType){
                case 1:
                    if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                        let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                        let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                        this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                    }
                    break;
                case 5:
                    this.match(transition._label);
                    break;
                case 2:
                case 7:
                case 8:
                    if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                    this.matchWildcard();
                    break;
                case 9:
                    this.matchWildcard();
                    break;
                case 3:
                    let ruleStartState = transition.target;
                    let ruleIndex = ruleStartState.ruleIndex;
                    let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                    if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                    else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                    break;
                case 4:
                    let predicateTransition = transition;
                    if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                    break;
                case 6:
                    let actionTransition = transition;
                    this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                    break;
                case 10:
                    if (!this.precpred(this._ctx, transition.precedence)) {
                        let precedence = transition.precedence;
                        throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                    }
                    break;
                default:
                    throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
            }
            this.state = transition.target.stateNumber;
        }
        visitDecisionState(p) {
            let predictedAlt;
            this.errorHandler.sync(this);
            let decision = p.decision;
            if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
                predictedAlt = this.overrideDecisionAlt;
                this.overrideDecisionReached = true;
            } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
            return predictedAlt;
        }
        createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
            return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
        }
        visitRuleStopState(p) {
            let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
            if (ruleStartState.isPrecedenceRule) {
                let parentContext = this._parentContextStack.pop();
                this.unrollRecursionContexts(parentContext[0]);
                this.state = parentContext[1];
            } else this.exitRule();
            let ruleTransition = this._atn.states[this.state].transition(0);
            this.state = ruleTransition.followState.stateNumber;
        }
        addDecisionOverride(decision, tokenIndex, forcedAlt) {
            this.overrideDecision = decision;
            this.overrideDecisionInputIndex = tokenIndex;
            this.overrideDecisionAlt = forcedAlt;
        }
        get overrideDecisionRoot() {
            return this._overrideDecisionRoot;
        }
        recover(e) {
            let i = this._input.index;
            this.errorHandler.recover(this, e);
            if (this._input.index === i) {
                let tok = e.getOffendingToken();
                if (!tok) throw new Error("Expected exception to have an offending token");
                let source = tok.tokenSource;
                let stream = source !== undefined ? source.inputStream : undefined;
                let sourcePair = {
                    source: source,
                    stream: stream
                };
                if (e instanceof $iLUMi.InputMismatchException) {
                    let expectedTokens = e.expectedTokens;
                    if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                    let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                    if (!expectedTokens.isNil) expectedTokenType = expectedTokens.minElement;
                    let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                } else {
                    let source = tok.tokenSource;
                    let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                }
            }
        }
        recoverInline() {
            return this._errHandler.recoverInline(this);
        }
        get rootContext() {
            return this._rootContext;
        }
    };
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.NotNull
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
    $a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
        $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
    ], $a16b634f90dd81f4$var$ParserInterpreter);
    module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;
});
parcelRegister("77rdV", function(module, exports) {
    "use strict";
    var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContextWithAltNum = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        get altNumber() {
            return this._altNumber;
        }
        set altNumber(altNum) {
            this._altNumber = altNum;
        }
    }
    $52ee4de454858848$var$__decorate([
        $d6D31.Override
    ], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
    module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;
});
parcelRegister("5IgvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleDependency = void 0;
    function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;
});
parcelRegister("1ivK9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleVersion = void 0;
    function $0f201872a8ca959f$var$RuleVersion(version) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;
});
parcelRegister("eftJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9rAj4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("5jPdD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dIykH", function(module, exports) {
    "use strict";
    var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $9fca043c2d5f0853$var$TokenStreamRewriter {
        constructor(tokens){
            this.tokens = tokens;
            this.programs = new Map();
            this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
            this.lastRewriteTokenIndexes = new Map();
        }
        getTokenStream() {
            return this.tokens;
        }
        rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let is = this.programs.get(programName);
            if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
        }
        deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
        }
        insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        replaceSingle(index, text) {
            if (typeof index === "number") this.replace(index, index, text);
            else this.replace(index, index, text);
        }
        replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (typeof from !== "number") from = from.tokenIndex;
            if (typeof to !== "number") to = to.tokenIndex;
            if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
            rewrites.push(op);
        }
        delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (to === undefined) to = from;
            if (typeof from === "number") this.replace(from, to, "", programName);
            else this.replace(from, to, "", programName);
        }
        getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let I = this.lastRewriteTokenIndexes.get(programName);
            if (I == null) return -1;
            return I;
        }
        setLastRewriteTokenIndex(programName, i) {
            this.lastRewriteTokenIndexes.set(programName, i);
        }
        getProgram(name) {
            let is = this.programs.get(name);
            if (is == null) is = this.initializeProgram(name);
            return is;
        }
        initializeProgram(name) {
            let is = [];
            this.programs.set(name, is);
            return is;
        }
        getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let interval;
            if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
            else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
            if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
            let rewrites = this.programs.get(programName);
            let start = interval.a;
            let stop = interval.b;
            if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
            if (start < 0) start = 0;
            if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval);
            let buf = [];
            let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
            let i = start;
            while(i <= stop && i < this.tokens.size){
                let op = indexToOp.get(i);
                indexToOp.delete(i);
                let t = this.tokens.get(i);
                if (op == null) {
                    if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                    i++;
                } else i = op.execute(buf);
            }
            if (stop === this.tokens.size - 1) {
                for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
            }
            return buf.join("");
        }
        reduceToSingleOperationPerIndex(rewrites) {
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
                let rop = op;
                let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let iop of inserts){
                    if (iop.index === rop.index) {
                        rewrites[iop.instructionIndex] = undefined;
                        rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                    } else if (iop.index > rop.index && iop.index <= rop.lastIndex) rewrites[iop.instructionIndex] = undefined;
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let prevRop of prevReplaces){
                    if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        continue;
                    }
                    let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                    if (prevRop.text == null && rop.text == null && !disjoint) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        rop.index = Math.min(prevRop.index, rop.index);
                        rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                    } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
                }
            }
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
                let iop = op;
                let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                    if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                        iop.text = this.catOpText(prevIop.text, iop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                        iop.text = this.catOpText(iop.text, prevIop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    }
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let rop of prevReplaces){
                    if (iop.index === rop.index) {
                        rop.text = this.catOpText(iop.text, rop.text);
                        rewrites[i] = undefined;
                        continue;
                    }
                    if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
                }
            }
            let m = new Map();
            for (let op of rewrites){
                if (op == null) continue;
                if (m.get(op.index) != null) throw new Error("should only be one op per index");
                m.set(op.index, op);
            }
            return m;
        }
        catOpText(a, b) {
            let x = "";
            let y = "";
            if (a != null) x = a.toString();
            if (b != null) y = b.toString();
            return x + y;
        }
        getKindOfOps(rewrites, kind, before) {
            let ops = [];
            for(let i = 0; i < before && i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (op instanceof kind) ops.push(op);
            }
            return ops;
        }
    }
    module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
    $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
    $9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
    $9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
    class $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            this.tokens = tokens;
            this.instructionIndex = instructionIndex;
            this.index = index;
            this.text = text === undefined ? "" : text;
        }
        execute(buf) {
            return this.index;
        }
        toString() {
            let opName = this.constructor.name;
            let $index = opName.indexOf("$");
            opName = opName.substring($index + 1, opName.length);
            return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
    module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
    class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index, instructionIndex, text);
        }
        execute(buf) {
            buf.push(this.text.toString());
            if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
            return this.index + 1;
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
    class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index + 1, instructionIndex, text);
        }
    }
    class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, from, to, instructionIndex, text){
            super(tokens, from, instructionIndex, text);
            this.lastIndex = to;
        }
        execute(buf) {
            if (this.text != null) buf.push(this.text.toString());
            return this.lastIndex + 1;
        }
        toString() {
            if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
            return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);
});
parcelRegister("1MVGg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("6UcB4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("39War", function(module, exports) {
    $parcel$export(module.exports, "JQLLexer", ()=>$801b4612eb9312ce$export$375c79404cc64c7f);
    var $dvgsl = parcelRequire("dvgsl");
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $801b4612eb9312ce$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.QUOTED_STR = 1;
        }
        static{
            this.SQUOTED_STR = 2;
        }
        static{
            this.channelNames = [
                'DEFAULT_TOKEN_CHANNEL',
                'HIDDEN'
            ];
        }
        static{
            this.modeNames = [
                'DEFAULT_MODE',
                'QUOTED_STR',
                'SQUOTED_STR'
            ];
        }
        static{
            this.ruleNames = [
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'LQUOTE',
                'LSQUOTE',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'QUOTED_CONTENT',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'SQUOTED_CONTENT',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING',
                'VALID_UNQUOTED_CHARS',
                'VALID_QUOTED_CHARS',
                'VALID_SQUOTED_CHARS',
                'RESERVED_CHARS',
                'QUOTE',
                'SQUOTE',
                'BSLASH',
                'NL',
                'CR',
                'SPACE',
                'AMPER',
                'AMPER_AMPER',
                'PIPE',
                'PIPE_PIPE',
                'ESCAPE',
                'NEWLINE',
                'HEXDIGIT',
                'WS',
                'MINUS',
                'DIGIT',
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($801b4612eb9312ce$export$375c79404cc64c7f._LITERAL_NAMES, $801b4612eb9312ce$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.VOCABULARY;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $lQecE.LexerATNSimulator)($801b4612eb9312ce$export$375c79404cc64c7f._ATN, this);
        }
        get grammarFileName() {
            return 'JQLLexer.g4';
        }
        get ruleNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.ruleNames;
        }
        get serializedATN() {
            return $801b4612eb9312ce$export$375c79404cc64c7f._serializedATN;
        }
        get channelNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.channelNames;
        }
        get modeNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.modeNames;
        }
        static{
            this._serializedATNSegments = 3;
        }
        static{
            this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
        }
        static{
            this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
        }
        static{
            this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
        }
        static{
            this._serializedATN = $2IEP9.join([
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment0,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment1,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment2
            ], '');
        }
        static get _ATN() {
            if (!$801b4612eb9312ce$export$375c79404cc64c7f.__ATN) $801b4612eb9312ce$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($801b4612eb9312ce$export$375c79404cc64c7f._serializedATN));
            return $801b4612eb9312ce$export$375c79404cc64c7f.__ATN;
        }
    }
});
parcelRegister("k9No4", function(module, exports) {
    $parcel$export(module.exports, "JQLParser", ()=>$371e898df891458a$export$9c4772e191bdb810);
    var $dvgsl = parcelRequire("dvgsl");
    var $hKCjP = parcelRequire("hKCjP");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $371e898df891458a$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.RULE_jqlQuery = 0;
        }
        static{
            this.RULE_jqlWhere = 1;
        }
        static{
            this.RULE_jqlOrClause = 2;
        }
        static{
            this.RULE_jqlAndClause = 3;
        }
        static{
            this.RULE_jqlNotClause = 4;
        }
        static{
            this.RULE_jqlSubClause = 5;
        }
        static{
            this.RULE_jqlTerminalClause = 6;
        }
        static{
            this.RULE_jqlTerminalClauseRhs = 7;
        }
        static{
            this.RULE_jqlEqualsOperator = 8;
        }
        static{
            this.RULE_jqlLikeOperator = 9;
        }
        static{
            this.RULE_jqlComparisonOperator = 10;
        }
        static{
            this.RULE_jqlInOperator = 11;
        }
        static{
            this.RULE_jqlIsOperator = 12;
        }
        static{
            this.RULE_jqlWasOperator = 13;
        }
        static{
            this.RULE_jqlWasInOperator = 14;
        }
        static{
            this.RULE_jqlChangedOperator = 15;
        }
        static{
            this.RULE_jqlField = 16;
        }
        static{
            this.RULE_jqlFieldProperty = 17;
        }
        static{
            this.RULE_jqlCustomField = 18;
        }
        static{
            this.RULE_jqlString = 19;
        }
        static{
            this.RULE_jqlNumber = 20;
        }
        static{
            this.RULE_jqlOperand = 21;
        }
        static{
            this.RULE_jqlEmpty = 22;
        }
        static{
            this.RULE_jqlValue = 23;
        }
        static{
            this.RULE_jqlFunction = 24;
        }
        static{
            this.RULE_jqlFunctionName = 25;
        }
        static{
            this.RULE_jqlArgumentList = 26;
        }
        static{
            this.RULE_jqlList = 27;
        }
        static{
            this.RULE_jqlListStart = 28;
        }
        static{
            this.RULE_jqlListEnd = 29;
        }
        static{
            this.RULE_jqlPropertyArgument = 30;
        }
        static{
            this.RULE_jqlArgument = 31;
        }
        static{
            this.RULE_jqlWasPredicate = 32;
        }
        static{
            this.RULE_jqlChangedPredicate = 33;
        }
        static{
            this.RULE_jqlDatePredicateOperator = 34;
        }
        static{
            this.RULE_jqlDateRangePredicateOperator = 35;
        }
        static{
            this.RULE_jqlUserPredicateOperator = 36;
        }
        static{
            this.RULE_jqlValuePredicateOperator = 37;
        }
        static{
            this.RULE_jqlPredicateOperand = 38;
        }
        static{
            this.RULE_jqlOrderBy = 39;
        }
        static{
            this.RULE_jqlSearchSort = 40;
        }
        static{
            this.ruleNames = [
                'jqlQuery',
                'jqlWhere',
                'jqlOrClause',
                'jqlAndClause',
                'jqlNotClause',
                'jqlSubClause',
                'jqlTerminalClause',
                'jqlTerminalClauseRhs',
                'jqlEqualsOperator',
                'jqlLikeOperator',
                'jqlComparisonOperator',
                'jqlInOperator',
                'jqlIsOperator',
                'jqlWasOperator',
                'jqlWasInOperator',
                'jqlChangedOperator',
                'jqlField',
                'jqlFieldProperty',
                'jqlCustomField',
                'jqlString',
                'jqlNumber',
                'jqlOperand',
                'jqlEmpty',
                'jqlValue',
                'jqlFunction',
                'jqlFunctionName',
                'jqlArgumentList',
                'jqlList',
                'jqlListStart',
                'jqlListEnd',
                'jqlPropertyArgument',
                'jqlArgument',
                'jqlWasPredicate',
                'jqlChangedPredicate',
                'jqlDatePredicateOperator',
                'jqlDateRangePredicateOperator',
                'jqlUserPredicateOperator',
                'jqlValuePredicateOperator',
                'jqlPredicateOperand',
                'jqlOrderBy',
                'jqlSearchSort'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($371e898df891458a$export$9c4772e191bdb810._LITERAL_NAMES, $371e898df891458a$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $371e898df891458a$export$9c4772e191bdb810.VOCABULARY;
        }
        get grammarFileName() {
            return 'JQLParser.g4';
        }
        get ruleNames() {
            return $371e898df891458a$export$9c4772e191bdb810.ruleNames;
        }
        get serializedATN() {
            return $371e898df891458a$export$9c4772e191bdb810._serializedATN;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $kzbnL.ParserATNSimulator)($371e898df891458a$export$9c4772e191bdb810._ATN, this);
        }
        jqlQuery() {
            let _localctx = new $371e898df891458a$export$ff413535b9575c8(this._ctx, this.state);
            this.enterRule(_localctx, 0, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 83;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LPAREN | 1 << $371e898df891458a$export$9c4772e191bdb810.BANG | 1 << $371e898df891458a$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 82;
                    this.jqlWhere();
                }
                this.state = 86;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ORDER) {
                    this.state = 85;
                    this.jqlOrderBy();
                }
                this.state = 88;
                this.match($371e898df891458a$export$9c4772e191bdb810.EOF);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWhere() {
            let _localctx = new $371e898df891458a$export$4148a879cab28017(this._ctx, this.state);
            this.enterRule(_localctx, 2, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 90;
                this.jqlOrClause();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrClause() {
            let _localctx = new $371e898df891458a$export$d69831d387793480(this._ctx, this.state);
            this.enterRule(_localctx, 4, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 92;
                this.jqlAndClause();
                this.state = 97;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.OR){
                    this.state = 93;
                    this.match($371e898df891458a$export$9c4772e191bdb810.OR);
                    this.state = 94;
                    this.jqlAndClause();
                    this.state = 99;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlAndClause() {
            let _localctx = new $371e898df891458a$export$f16819001158b9e(this._ctx, this.state);
            this.enterRule(_localctx, 6, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 100;
                this.jqlNotClause();
                this.state = 105;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.AND){
                    this.state = 101;
                    this.match($371e898df891458a$export$9c4772e191bdb810.AND);
                    this.state = 102;
                    this.jqlNotClause();
                    this.state = 107;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNotClause() {
            let _localctx = new $371e898df891458a$export$5e9146f8d5cf1330(this._ctx, this.state);
            this.enterRule(_localctx, 8, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause);
            let _la;
            try {
                this.state = 112;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BANG:
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 108;
                        _la = this._input.LA(1);
                        if (!(_la === $371e898df891458a$export$9c4772e191bdb810.BANG || _la === $371e898df891458a$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                        else {
                            if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 109;
                        this.jqlNotClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 110;
                        this.jqlSubClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 111;
                        this.jqlTerminalClause();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSubClause() {
            let _localctx = new $371e898df891458a$export$a136a0e9655bfb04(this._ctx, this.state);
            this.enterRule(_localctx, 10, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 114;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 115;
                this.jqlOrClause();
                this.state = 116;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClause() {
            let _localctx = new $371e898df891458a$export$23486a2f2ddd5bcd(this._ctx, this.state);
            this.enterRule(_localctx, 12, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 118;
                this.jqlField();
                this.state = 119;
                this.jqlTerminalClauseRhs();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClauseRhs() {
            let _localctx = new $371e898df891458a$export$93924a205c12d32c(this._ctx, this.state);
            this.enterRule(_localctx, 14, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
            let _la;
            try {
                this.state = 176;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                    case 1:
                        _localctx = new $371e898df891458a$export$c428f709a58396e5(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 121;
                        this.jqlEqualsOperator();
                        this.state = 125;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                            case 1:
                                this.state = 122;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 123;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 124;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 2:
                        _localctx = new $371e898df891458a$export$1b131204ef9fa33d(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 127;
                        this.jqlLikeOperator();
                        this.state = 131;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                            case 1:
                                this.state = 128;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 129;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 130;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 3:
                        _localctx = new $371e898df891458a$export$d83706ee80a9852a(_localctx);
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 133;
                        this.jqlComparisonOperator();
                        this.state = 136;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                            case 1:
                                this.state = 134;
                                this.jqlValue();
                                break;
                            case 2:
                                this.state = 135;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 4:
                        _localctx = new $371e898df891458a$export$2934b8ff22fddd2d(_localctx);
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 138;
                        this.jqlInOperator();
                        this.state = 141;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 139;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 140;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        break;
                    case 5:
                        _localctx = new $371e898df891458a$export$8b84310182afcf93(_localctx);
                        this.enterOuterAlt(_localctx, 5);
                        this.state = 143;
                        this.jqlIsOperator();
                        this.state = 144;
                        this.jqlEmpty();
                        break;
                    case 6:
                        _localctx = new $371e898df891458a$export$5df295dc7a2cac7c(_localctx);
                        this.enterOuterAlt(_localctx, 6);
                        this.state = 146;
                        this.jqlWasOperator();
                        this.state = 150;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                            case 1:
                                this.state = 147;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 148;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 149;
                                this.jqlFunction();
                                break;
                        }
                        this.state = 155;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 152;
                            this.jqlWasPredicate();
                            this.state = 157;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 7:
                        _localctx = new $371e898df891458a$export$9ac3367aee261b32(_localctx);
                        this.enterOuterAlt(_localctx, 7);
                        this.state = 158;
                        this.jqlWasInOperator();
                        this.state = 161;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 159;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 160;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 166;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 163;
                            this.jqlWasPredicate();
                            this.state = 168;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 8:
                        _localctx = new $371e898df891458a$export$7a7defca8628a13c(_localctx);
                        this.enterOuterAlt(_localctx, 8);
                        this.state = 169;
                        this.jqlChangedOperator();
                        this.state = 173;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.FROM | 1 << $371e898df891458a$export$9c4772e191bdb810.TO | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 170;
                            this.jqlChangedPredicate();
                            this.state = 175;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEqualsOperator() {
            let _localctx = new $371e898df891458a$export$41e475fc1988e413(this._ctx, this.state);
            this.enterRule(_localctx, 16, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 178;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.EQUALS || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlLikeOperator() {
            let _localctx = new $371e898df891458a$export$b76fe5387fdd7efd(this._ctx, this.state);
            this.enterRule(_localctx, 18, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 180;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.LIKE || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlComparisonOperator() {
            let _localctx = new $371e898df891458a$export$d821da0716b3ec95(this._ctx, this.state);
            this.enterRule(_localctx, 20, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 182;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LT | 1 << $371e898df891458a$export$9c4772e191bdb810.GT | 1 << $371e898df891458a$export$9c4772e191bdb810.GTEQ | 1 << $371e898df891458a$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlInOperator() {
            let _localctx = new $371e898df891458a$export$178478bfa8292f72(this._ctx, this.state);
            this.enterRule(_localctx, 22, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator);
            try {
                this.state = 187;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.IN:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 184;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 185;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 186;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlIsOperator() {
            let _localctx = new $371e898df891458a$export$e64c31d2830b66e4(this._ctx, this.state);
            this.enterRule(_localctx, 24, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator);
            try {
                this.state = 192;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 189;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 190;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        this.state = 191;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasOperator() {
            let _localctx = new $371e898df891458a$export$7e283636700e4a6c(this._ctx, this.state);
            this.enterRule(_localctx, 26, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator);
            try {
                this.state = 197;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 194;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 195;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 196;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasInOperator() {
            let _localctx = new $371e898df891458a$export$b9118b1ed9a78d66(this._ctx, this.state);
            this.enterRule(_localctx, 28, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator);
            try {
                this.state = 204;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 199;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 200;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 201;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 202;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 203;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedOperator() {
            let _localctx = new $371e898df891458a$export$493d626ed78ca66(this._ctx, this.state);
            this.enterRule(_localctx, 30, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 206;
                this.match($371e898df891458a$export$9c4772e191bdb810.CHANGED);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlField() {
            let _localctx = new $371e898df891458a$export$b33300c3d916229a(this._ctx, this.state);
            this.enterRule(_localctx, 32, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField);
            let _la;
            try {
                this.state = 219;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        _localctx = new $371e898df891458a$export$11fec15307d2e17b(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 208;
                        this.jqlNumber();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        _localctx = new $371e898df891458a$export$b8b24f99f985ebb3(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 211;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 209;
                                this.jqlString();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                                this.state = 210;
                                this.jqlCustomField();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 216;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while(_la === $371e898df891458a$export$9c4772e191bdb810.LBRACKET){
                            this.state = 213;
                            this.jqlFieldProperty();
                            this.state = 218;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFieldProperty() {
            let _localctx = new $371e898df891458a$export$b02d0b6637ce0593(this._ctx, this.state);
            this.enterRule(_localctx, 34, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 221;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 222;
                this.jqlArgument();
                this.state = 223;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
                this.state = 228;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                    this.state = 225;
                    this.jqlPropertyArgument();
                    this.state = 230;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlCustomField() {
            let _localctx = new $371e898df891458a$export$401a038855cc5b15(this._ctx, this.state);
            this.enterRule(_localctx, 36, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 231;
                this.match($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD);
                this.state = 232;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 233;
                this.match($371e898df891458a$export$9c4772e191bdb810.POSNUMBER);
                this.state = 234;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlString() {
            let _localctx = new $371e898df891458a$export$bde73d8ad7c8b71e(this._ctx, this.state);
            this.enterRule(_localctx, 38, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 236;
                _la = this._input.LA(1);
                if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNumber() {
            let _localctx = new $371e898df891458a$export$8737d94a1880e8b3(this._ctx, this.state);
            this.enterRule(_localctx, 40, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 238;
                _localctx._jqlNum = this._input.LT(1);
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.POSNUMBER || _la === $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOperand() {
            let _localctx = new $371e898df891458a$export$2eaac5a9828bf647(this._ctx, this.state);
            this.enterRule(_localctx, 42, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand);
            try {
                this.state = 244;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 240;
                        this.jqlEmpty();
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 241;
                        this.jqlValue();
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 242;
                        this.jqlFunction();
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 243;
                        this.jqlList();
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEmpty() {
            let _localctx = new $371e898df891458a$export$d85a062f90025e5c(this._ctx, this.state);
            this.enterRule(_localctx, 44, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 246;
                this.match($371e898df891458a$export$9c4772e191bdb810.EMPTY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValue() {
            let _localctx = new $371e898df891458a$export$2e17d457b0933bec(this._ctx, this.state);
            this.enterRule(_localctx, 46, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue);
            try {
                this.state = 250;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 248;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 249;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunction() {
            let _localctx = new $371e898df891458a$export$ebf0cc785e9ee41a(this._ctx, this.state);
            this.enterRule(_localctx, 48, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 252;
                this.jqlFunctionName();
                this.state = 253;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 255;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 254;
                    this.jqlArgumentList();
                }
                this.state = 257;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunctionName() {
            let _localctx = new $371e898df891458a$export$1f5f7ac816788f44(this._ctx, this.state);
            this.enterRule(_localctx, 50, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName);
            try {
                this.state = 261;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 259;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 260;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgumentList() {
            let _localctx = new $371e898df891458a$export$83d7c13849b931c3(this._ctx, this.state);
            this.enterRule(_localctx, 52, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 263;
                this.jqlArgument();
                this.state = 268;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 264;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 265;
                    this.jqlArgument();
                    this.state = 270;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlList() {
            let _localctx = new $371e898df891458a$export$9cb97a63f2be4864(this._ctx, this.state);
            this.enterRule(_localctx, 54, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 271;
                this.jqlListStart();
                this.state = 272;
                this.jqlOperand();
                this.state = 277;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 273;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 274;
                    this.jqlOperand();
                    this.state = 279;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 280;
                this.jqlListEnd();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListStart() {
            let _localctx = new $371e898df891458a$export$c419f717bfc46a5d(this._ctx, this.state);
            this.enterRule(_localctx, 56, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 282;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListEnd() {
            let _localctx = new $371e898df891458a$export$f6cd3e372f5ab120(this._ctx, this.state);
            this.enterRule(_localctx, 58, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 284;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPropertyArgument() {
            let _localctx = new $371e898df891458a$export$e20ce4a2ed16372c(this._ctx, this.state);
            this.enterRule(_localctx, 60, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 286;
                this.jqlArgument();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgument() {
            let _localctx = new $371e898df891458a$export$a95583953c237f88(this._ctx, this.state);
            this.enterRule(_localctx, 62, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument);
            try {
                this.state = 290;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 288;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 289;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasPredicate() {
            let _localctx = new $371e898df891458a$export$9fa1e4d63f31b911(this._ctx, this.state);
            this.enterRule(_localctx, 64, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 295;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 292;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 293;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 294;
                        this.jqlUserPredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 297;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedPredicate() {
            let _localctx = new $371e898df891458a$export$e77e479a48133015(this._ctx, this.state);
            this.enterRule(_localctx, 66, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 303;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 299;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 300;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 301;
                        this.jqlUserPredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.FROM:
                    case $371e898df891458a$export$9c4772e191bdb810.TO:
                        this.state = 302;
                        this.jqlValuePredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 305;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDatePredicateOperator() {
            let _localctx = new $371e898df891458a$export$dc01290aee731418(this._ctx, this.state);
            this.enterRule(_localctx, 68, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 307;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDateRangePredicateOperator() {
            let _localctx = new $371e898df891458a$export$75412b8b6a6442e1(this._ctx, this.state);
            this.enterRule(_localctx, 70, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 309;
                this.match($371e898df891458a$export$9c4772e191bdb810.DURING);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlUserPredicateOperator() {
            let _localctx = new $371e898df891458a$export$ad402332075c8656(this._ctx, this.state);
            this.enterRule(_localctx, 72, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 311;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValuePredicateOperator() {
            let _localctx = new $371e898df891458a$export$4239d7c0fbafd3f1(this._ctx, this.state);
            this.enterRule(_localctx, 74, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 313;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.FROM || _la === $371e898df891458a$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPredicateOperand() {
            let _localctx = new $371e898df891458a$export$6b796c5a4b8c18e(this._ctx, this.state);
            this.enterRule(_localctx, 76, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 315;
                this.jqlOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrderBy() {
            let _localctx = new $371e898df891458a$export$534469b9c8f44139(this._ctx, this.state);
            this.enterRule(_localctx, 78, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 317;
                this.match($371e898df891458a$export$9c4772e191bdb810.ORDER);
                this.state = 318;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
                this.state = 319;
                this.jqlSearchSort();
                this.state = 324;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 320;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 321;
                    this.jqlSearchSort();
                    this.state = 326;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSearchSort() {
            let _localctx = new $371e898df891458a$export$c7d8f03f36952a46(this._ctx, this.state);
            this.enterRule(_localctx, 80, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 327;
                this.jqlField();
                this.state = 329;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC) {
                    this.state = 328;
                    _la = this._input.LA(1);
                    if (!(_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        static{
            this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
        }
        static get _ATN() {
            if (!$371e898df891458a$export$9c4772e191bdb810.__ATN) $371e898df891458a$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($371e898df891458a$export$9c4772e191bdb810._serializedATN));
            return $371e898df891458a$export$9c4772e191bdb810.__ATN;
        }
    }
    class $371e898df891458a$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
        EOF() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EOF, 0);
        }
        jqlWhere() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4148a879cab28017);
        }
        jqlOrderBy() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$534469b9c8f44139);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery;
        }
        enterRule(listener) {
            if (listener.enterJqlQuery) listener.enterJqlQuery(this);
        }
        exitRule(listener) {
            if (listener.exitJqlQuery) listener.exitJqlQuery(this);
        }
        accept(visitor) {
            if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere;
        }
        enterRule(listener) {
            if (listener.enterJqlWhere) listener.enterJqlWhere(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWhere) listener.exitJqlWhere(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
        jqlAndClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$f16819001158b9e);
            else return this.getRuleContext(i, $371e898df891458a$export$f16819001158b9e);
        }
        OR(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.OR);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.OR, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause;
        }
        enterRule(listener) {
            if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$5e9146f8d5cf1330);
            else return this.getRuleContext(i, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        AND(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.AND);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.AND, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause;
        }
        enterRule(listener) {
            if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        BANG() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BANG, 0);
        }
        jqlSubClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a136a0e9655bfb04);
        }
        jqlTerminalClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$23486a2f2ddd5bcd);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause;
        }
        enterRule(listener) {
            if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause;
        }
        enterRule(listener) {
            if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        jqlTerminalClauseRhs() {
            return this.getRuleContext(0, $371e898df891458a$export$93924a205c12d32c);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause;
        }
        enterRule(listener) {
            if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$c428f709a58396e5 extends $371e898df891458a$export$93924a205c12d32c {
        jqlEqualsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$41e475fc1988e413);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1b131204ef9fa33d extends $371e898df891458a$export$93924a205c12d32c {
        jqlLikeOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b76fe5387fdd7efd);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d83706ee80a9852a extends $371e898df891458a$export$93924a205c12d32c {
        jqlComparisonOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$d821da0716b3ec95);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2934b8ff22fddd2d extends $371e898df891458a$export$93924a205c12d32c {
        jqlInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$178478bfa8292f72);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlInClause) listener.enterJqlInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInClause) listener.exitJqlInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8b84310182afcf93 extends $371e898df891458a$export$93924a205c12d32c {
        jqlIsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$e64c31d2830b66e4);
        }
        jqlEmpty() {
            return this.getRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5df295dc7a2cac7c extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$7e283636700e4a6c);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9ac3367aee261b32 extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b9118b1ed9a78d66);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7a7defca8628a13c extends $371e898df891458a$export$93924a205c12d32c {
        jqlChangedOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$493d626ed78ca66);
        }
        jqlChangedPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e77e479a48133015);
            else return this.getRuleContext(i, $371e898df891458a$export$e77e479a48133015);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
        EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.EQUALS, 0);
        }
        NOT_EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
        LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LIKE, 0);
        }
        NOT_LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_LIKE, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
        LT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LT, 0);
        }
        GT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GT, 0);
        }
        LTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LTEQ, 0);
        }
        GTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GTEQ, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
        IS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
        CHANGED() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CHANGED, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$11fec15307d2e17b extends $371e898df891458a$export$b33300c3d916229a {
        jqlNumber() {
            return this.getRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b8b24f99f985ebb3 extends $371e898df891458a$export$b33300c3d916229a {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlCustomField() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$401a038855cc5b15);
        }
        jqlFieldProperty(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$b02d0b6637ce0593);
            else return this.getRuleContext(i, $371e898df891458a$export$b02d0b6637ce0593);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
        LBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        RBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        jqlPropertyArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e20ce4a2ed16372c);
            else return this.getRuleContext(i, $371e898df891458a$export$e20ce4a2ed16372c);
        }
        jqlArgument() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty;
        }
        enterRule(listener) {
            if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
        CUSTOMFIELD() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD, 0);
        }
        LBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        POSNUMBER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        RBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField;
        }
        enterRule(listener) {
            if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
        STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.STRING, 0);
        }
        QUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING, 0);
        }
        SQUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString;
        }
        enterRule(listener) {
            if (listener.enterJqlString) listener.enterJqlString(this);
        }
        exitRule(listener) {
            if (listener.exitJqlString) listener.exitJqlString(this);
        }
        accept(visitor) {
            if (visitor.visitJqlString) return visitor.visitJqlString(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
        POSNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        NEGNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NEGNUMBER, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber;
        }
        enterRule(listener) {
            if (listener.enterJqlNumber) listener.enterJqlNumber(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumber) listener.exitJqlNumber(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlOperand) listener.enterJqlOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOperand) listener.exitJqlOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
        EMPTY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EMPTY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty;
        }
        enterRule(listener) {
            if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue;
        }
        enterRule(listener) {
            if (listener.enterJqlValue) listener.enterJqlValue(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValue) listener.exitJqlValue(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
        jqlFunctionName() {
            return this.getRuleContext(0, $371e898df891458a$export$1f5f7ac816788f44);
        }
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        jqlArgumentList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$83d7c13849b931c3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction;
        }
        enterRule(listener) {
            if (listener.enterJqlFunction) listener.enterJqlFunction(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunction) listener.exitJqlFunction(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName;
        }
        enterRule(listener) {
            if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$a95583953c237f88);
            else return this.getRuleContext(i, $371e898df891458a$export$a95583953c237f88);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList;
        }
        enterRule(listener) {
            if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
        jqlListStart() {
            return this.getRuleContext(0, $371e898df891458a$export$c419f717bfc46a5d);
        }
        jqlOperand(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$2eaac5a9828bf647);
            else return this.getRuleContext(i, $371e898df891458a$export$2eaac5a9828bf647);
        }
        jqlListEnd() {
            return this.getRuleContext(0, $371e898df891458a$export$f6cd3e372f5ab120);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList;
        }
        enterRule(listener) {
            if (listener.enterJqlList) listener.enterJqlList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlList) listener.exitJqlList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlList) return visitor.visitJqlList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart;
        }
        enterRule(listener) {
            if (listener.enterJqlListStart) listener.enterJqlListStart(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListStart) listener.exitJqlListStart(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd;
        }
        enterRule(listener) {
            if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument() {
            return this.getRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlArgument) listener.enterJqlArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgument) listener.exitJqlArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        jqlValuePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4239d7c0fbafd3f1);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
        AFTER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.AFTER, 0);
        }
        BEFORE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BEFORE, 0);
        }
        ON() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ON, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
        DURING() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.DURING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
        FROM() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.FROM, 0);
        }
        TO() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.TO, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
        jqlOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$2eaac5a9828bf647);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
        ORDER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.ORDER, 0);
        }
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        jqlSearchSort(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$c7d8f03f36952a46);
            else return this.getRuleContext(i, $371e898df891458a$export$c7d8f03f36952a46);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy;
        }
        enterRule(listener) {
            if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        DESC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.DESC, 0);
        }
        ASC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ASC, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort;
        }
        enterRule(listener) {
            if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
            else return visitor.visitChildren(this);
        }
    }
});
parcelRegister("lKjSa", function(module, exports) {
    $parcel$export(module.exports, "JastBuilderErrorListener", ()=>$6eeebc6d04d5cc03$export$d0857f60ff1f385);
    var $k9iwN;
    var $gbJ9P;
    class $6eeebc6d04d5cc03$export$d0857f60ff1f385 {
        constructor(){
            this.errors = [];
            this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
                if (offendingSymbol === undefined) this.errors.push(new (0, (0, parcelRequire("k9iwN")).JQLParseError)(msg));
                else this.errors.push(new (0, (0, parcelRequire("gbJ9P")).JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
            };
        }
    }
});
parcelRegister("k9iwN", function(module, exports) {
    $parcel$export(module.exports, "JQLParseError", ()=>$c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b);
    class $c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b extends Error {
        constructor(message, cause){
            super(message);
            this.name = 'JQLParseError';
            this.cause = cause;
            this.description = message;
        }
    }
});
parcelRegister("gbJ9P", function(module, exports) {
    $parcel$export(module.exports, "JQLSyntaxError", ()=>$59495a4ee8e45f22$export$3276184116160c41);
    var $k9iwN;
    class $59495a4ee8e45f22$export$3276184116160c41 extends (0, (0, parcelRequire("k9iwN")).JQLParseError) {
        constructor(message, start, stop, line, charPositionInLine){
            super(message);
            this.name = 'JQLSyntaxError';
            this.start = start;
            this.stop = stop;
            this.line = line;
            this.charPositionInLine = charPositionInLine;
        }
    }
});
parcelRegister("bK3p2", function(module, exports) {
    $parcel$export(module.exports, "QueryVisitor", ()=>$0cc7bd3e15dd4aeb$export$418003b930734805);
    var $iEIQF;
    var $flxWO;
    var $fcxPF;
    var $gW3lb;
    class $0cc7bd3e15dd4aeb$export$418003b930734805 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.whereVisitor = new (0, (0, parcelRequire("gW3lb")).WhereVisitor)(this.tokens), this.orderByVisitor = new (0, (0, parcelRequire("fcxPF")).OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
                const whereContext = ctx.jqlWhere();
                const orderByContext = ctx.jqlOrderBy();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("flxWO", function(module, exports) {
    $parcel$export(module.exports, "JastBuildingVisitor", ()=>$4f91741519176bb0$export$d3c14d7188b09387);
    $parcel$export(module.exports, "getPositionFromToken", ()=>$4f91741519176bb0$export$85a4e6d858dbc6fb);
    $parcel$export(module.exports, "getPositionFromContext", ()=>$4f91741519176bb0$export$264629d4cd3cad3f);
    $parcel$export(module.exports, "getPositionsFromTerminalNodes", ()=>$4f91741519176bb0$export$30d51184879cbaa8);
    $parcel$export(module.exports, "normalizeText", ()=>$4f91741519176bb0$export$7c2714a5250b9239);
    class $4f91741519176bb0$export$d3c14d7188b09387 {
        constructor(tokens){
            this.tokens = tokens;
        }
        visit(tree) {
            throw new Error('Unsupported operation visit(ParseTree)');
        }
        visitChildren(node) {
            throw new Error('Unsupported operation visitChildren(RuleNode)');
        }
        visitErrorNode(node) {
            throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
        }
        visitTerminal(node) {
            throw new Error('Unsupported operation visitTerminal(TerminalNode)');
        }
    }
    const $4f91741519176bb0$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
            startToken.startIndex,
            (stopToken || startToken).stopIndex + 1
        ];
    const $4f91741519176bb0$export$264629d4cd3cad3f = (ctx)=>[
            ctx.start.startIndex,
            ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
        ];
    const $4f91741519176bb0$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$4f91741519176bb0$export$85a4e6d858dbc6fb(node.payload));
    const $4f91741519176bb0$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');
});
parcelRegister("fcxPF", function(module, exports) {
    $parcel$export(module.exports, "OrderByVisitor", ()=>$10359fbb24d00401$export$2774b71b99734811);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    class $10359fbb24d00401$export$2774b71b99734811 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.searchSortVisitor = new $10359fbb24d00401$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
                if (ctx.exception) return undefined;
                const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
                const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderBy(fields, operator, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $10359fbb24d00401$var$SearchSortVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
                const fieldCtx = ctx.jqlField();
                if (fieldCtx.exception) return undefined;
                let direction;
                const desc = ctx.DESC();
                const asc = ctx.ASC();
                if (desc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(desc.payload));
                else if (asc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(asc.payload));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("kzRYu", function(module, exports) {
    $parcel$export(module.exports, "notUndefined", ()=>$7297aaf6104af1ea$export$9a1adf421b69c6a);
    function $7297aaf6104af1ea$export$9a1adf421b69c6a(x) {
        return x !== undefined;
    }
});
parcelRegister("8sbD2", function(module, exports) {
    $parcel$export(module.exports, "FieldVisitor", ()=>$3b522eccd35764cb$export$c6a85c4c3bf2317d);
    var $iEIQF;
    var $31uE9;
    var $flxWO;
    var $gpYZF;
    class $3b522eccd35764cb$export$c6a85c4c3bf2317d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $3b522eccd35764cb$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, undefined, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            }, this.visitJqlNonNumberField = (ctx)=>{
                const stringContext = ctx.jqlString();
                const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).field(stringValue.value, stringValue.text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$FieldPropertyVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $3b522eccd35764cb$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
                const argumentContext = ctx.jqlArgument();
                const propertyArgumentContext = ctx.jqlPropertyArgument();
                const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$PropertyArgumentVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
                return ctx.jqlArgument().accept(this.argumentVisitor);
            };
        }
    }
});
parcelRegister("31uE9", function(module, exports) {
    $parcel$export(module.exports, "ArgumentVisitor", ()=>$11f58529c551c5c5$export$46b5a1f6d962d533);
    var $iEIQF;
    var $flxWO;
    var $gpYZF;
    class $11f58529c551c5c5$export$46b5a1f6d962d533 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
});
parcelRegister("gpYZF", function(module, exports) {
    $parcel$export(module.exports, "StringVisitor", ()=>$15b8c92276e87e16$export$617850cb96304515);
    var $flxWO;
    class $15b8c92276e87e16$export$617850cb96304515 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlString = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                let value;
                if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
                else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
                else value = text;
                return {
                    text: text,
                    value: value,
                    position: position
                };
            };
        }
    }
});
parcelRegister("gW3lb", function(module, exports) {
    $parcel$export(module.exports, "WhereVisitor", ()=>$e8ab3cb2e5350018$export$c573472f1d20e15d);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $aSD70;
    class $e8ab3cb2e5350018$export$c573472f1d20e15d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.terminalClauseVisitor = new (0, (0, parcelRequire("aSD70")).TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            }, this.visitJqlOrClause = (ctx)=>{
                const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.OR()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            }, this.visitJqlAndClause = (ctx)=>{
                const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.AND()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            }, this.visitJqlNotClause = (ctx)=>{
                const notClauseContext = ctx.jqlNotClause();
                const subClauseContext = ctx.jqlSubClause();
                const terminalClauseContext = ctx.jqlTerminalClause();
                let clause;
                if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
                else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
                else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
                let notToken = ctx.NOT();
                notToken = notToken === undefined ? ctx.BANG() : notToken;
                if (notToken && clause) return (0, (0, parcelRequire("iEIQF")).internalCreators).notClause(clause, (0, (0, parcelRequire("iEIQF")).internalCreators).notClauseOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(notToken.payload)), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                return clause;
            }, this.visitJqlSubClause = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
        }
    }
});
parcelRegister("aSD70", function(module, exports) {
    $parcel$export(module.exports, "TerminalClauseVisitor", ()=>$059f8caffc466ad5$export$14576ae5bd1874a9);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    var $dE1pq;
    var $hUHF5;
    var $3qoPC;
    class $059f8caffc466ad5$export$14576ae5bd1874a9 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $059f8caffc466ad5$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
                const field = ctx.jqlField().accept(this.fieldVisitor);
                const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).terminalClause(field, operator, operand, predicates, position);
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseRhsVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operatorVisitor = new (0, (0, parcelRequire("hUHF5")).OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $059f8caffc466ad5$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, (0, parcelRequire("3qoPC")).PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
                const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlLikeClause = (ctx)=>{
                const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlComparisonClause = (ctx)=>{
                const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlInClause = (ctx)=>{
                const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlIsClause = (ctx)=>{
                const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            }, this.visitJqlWasClause = (ctx)=>{
                const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            }, this.visitJqlWasInClause = (ctx)=>{
                const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            }, this.visitJqlChangedClause = (ctx)=>{
                const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
                const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: predicates
                };
            }, this.visitChildren = (node)=>{
                const operator = node.accept(this.operatorVisitor);
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: []
                };
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlLikeClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlComparisonClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlIsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty()
                ]);
            }, this.visitJqlWasClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            }, this.visitJqlWasInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            }, this.getOperandForContexts = (contexts)=>{
                const operandContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("dE1pq", function(module, exports) {
    $parcel$export(module.exports, "OperandVisitor", ()=>$f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af);
    var $iEIQF;
    var $kzRYu;
    var $31uE9;
    var $flxWO;
    var $h5KaL;
    var $gpYZF;
    class $f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.numberVisitor = new (0, (0, parcelRequire("h5KaL")).NumberVisitor)(this.tokens), this.functionNameVisitor = new $f0dc0c50bebb9cb5$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $f0dc0c50bebb9cb5$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
                const operandContext = [
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ].find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this);
            }, this.visitJqlEmpty = (ctx)=>{
                if (ctx.exception) return undefined;
                return (0, (0, parcelRequire("iEIQF")).internalCreators).keywordOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.EMPTY().payload));
            }, this.visitJqlValue = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
                }
                const numberContext = ctx.jqlNumber();
                if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
            }, this.visitJqlList = (ctx)=>{
                const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).listOperand(values, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            }, this.visitJqlFunction = (ctx)=>{
                const argumentListContext = ctx.jqlArgumentList();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$FunctionNameVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$ArgumentListVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
                return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
            };
        }
    }
});
parcelRegister("h5KaL", function(module, exports) {
    $parcel$export(module.exports, "NumberVisitor", ()=>$949fba49fb4026f9$export$a55432f0884633e4);
    var $iEIQF;
    var $flxWO;
    class $949fba49fb4026f9$export$a55432f0884633e4 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlNumber = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("hUHF5", function(module, exports) {
    $parcel$export(module.exports, "OperatorVisitor", ()=>$ce76282d2f3e5bd1$export$e56f89ba95b51d2a);
    var $iEIQF;
    var $dI0u8;
    var $flxWO;
    class $ce76282d2f3e5bd1$export$e56f89ba95b51d2a extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        visitJqlEqualsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlLikeOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlComparisonOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isInOperator)(value)) return undefined;
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlIsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlChangedOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        constructor(...args){
            super(...args), this.visitChildren = (node)=>{
                const { sourceInterval: sourceInterval } = node;
                const text = this.tokens.getText(sourceInterval);
                if (text) {
                    const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
                    const { a: startIndex, b: stopIndex } = sourceInterval;
                    const startToken = this.tokens.get(startIndex);
                    const stopToken = this.tokens.get(stopIndex);
                    const position = (0, (0, parcelRequire("flxWO")).getPositionFromToken)(startToken, stopToken);
                    if ((0, (0, parcelRequire("dI0u8")).isOperator)(value)) return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, position);
                }
            };
        }
    }
});
parcelRegister("dI0u8", function(module, exports) {
    $parcel$export(module.exports, "isOperator", ()=>$ced3977476a8d3df$export$4e40859592ee7ac2);
    $parcel$export(module.exports, "isEqualsOperator", ()=>$ced3977476a8d3df$export$6d0fc196fa8a1673);
    $parcel$export(module.exports, "isLikeOperator", ()=>$ced3977476a8d3df$export$ad91b6d6a89cb64e);
    $parcel$export(module.exports, "isComparisonOperator", ()=>$ced3977476a8d3df$export$4477c442bd5c2a6d);
    $parcel$export(module.exports, "isInOperator", ()=>$ced3977476a8d3df$export$c5e1cdef30e30bff);
    $parcel$export(module.exports, "isIsOperator", ()=>$ced3977476a8d3df$export$ccc3334744e395c7);
    $parcel$export(module.exports, "isWasOperator", ()=>$ced3977476a8d3df$export$2b1c5d7e7856f91d);
    $parcel$export(module.exports, "isWasInOperator", ()=>$ced3977476a8d3df$export$55d8c9b20d99509f);
    $parcel$export(module.exports, "isChangedOperator", ()=>$ced3977476a8d3df$export$b65d23d23ade534b);
    $parcel$export(module.exports, "isListOperator", ()=>$ced3977476a8d3df$export$b09522e4061bbdd6);
    var $bzbto;
    const $ced3977476a8d3df$export$4e40859592ee7ac2 = (operator)=>(0, (0, parcelRequire("bzbto")).OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$6d0fc196fa8a1673 = (operator)=>(0, (0, parcelRequire("bzbto")).EQUALS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ad91b6d6a89cb64e = (operator)=>(0, (0, parcelRequire("bzbto")).LIKE_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$4477c442bd5c2a6d = (operator)=>(0, (0, parcelRequire("bzbto")).COMPARISON_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$c5e1cdef30e30bff = (operator)=>(0, (0, parcelRequire("bzbto")).IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ccc3334744e395c7 = (operator)=>(0, (0, parcelRequire("bzbto")).IS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$2b1c5d7e7856f91d = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$55d8c9b20d99509f = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b65d23d23ade534b = (operator)=>(0, (0, parcelRequire("bzbto")).CHANGED_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b09522e4061bbdd6 = (operator)=>(0, (0, parcelRequire("bzbto")).LIST_OPERATORS).includes(operator);
});
parcelRegister("3qoPC", function(module, exports) {
    $parcel$export(module.exports, "PredicateVisitor", ()=>$377f729dab70cce1$export$33bb52a35c693109);
    var $iEIQF;
    var $k75oj;
    var $kzRYu;
    var $flxWO;
    var $dE1pq;
    class $377f729dab70cce1$export$33bb52a35c693109 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.predicateOperatorVisitor = new $377f729dab70cce1$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $377f729dab70cce1$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            }, this.visitJqlChangedPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator(),
                    ctx.jqlValuePredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            }, this.getOperatorForContexts = (contexts)=>{
                const operatorContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
                else throw new Error('Undefined predicate operator context');
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperatorVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlUserPredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.visitJqlValuePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            }, this.getPredicateOperator = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const value = text.toLowerCase().replace(/\s+/g, ' ');
                if (!(0, (0, parcelRequire("k75oj")).isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicateOperator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args), this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
                return ctx.jqlOperand().accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("k75oj", function(module, exports) {
    $parcel$export(module.exports, "isPredicateOperator", ()=>$d2e5ca8020522bfa$export$188978ad94919403);
    var $2OsFJ;
    const $d2e5ca8020522bfa$export$188978ad94919403 = (operator)=>(0, (0, parcelRequire("2OsFJ")).PREDICATE_OPERATORS).includes(operator);
});
parcelRegister("2OsFJ", function(module, exports) {
    $parcel$export(module.exports, "PREDICATE_OPERATORS", ()=>$7ee5a5e33e4550f1$export$e200440af9f1d9f);
    const $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9 = 'after';
    const $7ee5a5e33e4550f1$export$f0a816341603bb63 = 'before';
    const $7ee5a5e33e4550f1$export$cdc81c84f768d513 = 'by';
    const $7ee5a5e33e4550f1$export$8a5280c65e704c3d = 'during';
    const $7ee5a5e33e4550f1$export$71f882dcac65f97a = 'from';
    const $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8 = 'on';
    const $7ee5a5e33e4550f1$export$5a83c4789e531a = 'to';
    const $7ee5a5e33e4550f1$export$e200440af9f1d9f = [
        $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9,
        $7ee5a5e33e4550f1$export$f0a816341603bb63,
        $7ee5a5e33e4550f1$export$cdc81c84f768d513,
        $7ee5a5e33e4550f1$export$8a5280c65e704c3d,
        $7ee5a5e33e4550f1$export$71f882dcac65f97a,
        $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8,
        $7ee5a5e33e4550f1$export$5a83c4789e531a
    ];
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("eq1P7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7fbca7864143b4e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c7fbca7864143b4e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-list.controllers.forms-label-flag.title",
            "defaultMessage": "We\u2019ve introduced new form labels"
        },
        description: {
            "id": "business-list.controllers.forms-label-flag.description",
            "defaultMessage": "To include older submissions in your search, update your filters."
        },
        viewAllLink: {
            "id": "business-list.controllers.forms-label-flag.view-all-link",
            "defaultMessage": "Update filters"
        },
        iconLabel: {
            "id": "business-list.controllers.forms-label-flag.icon-label",
            "defaultMessage": "Alert"
        }
    });
});
parcelRegister("8e3Yw", function(module, exports) {
    $parcel$export(module.exports, "useGroupBy", ()=>$6c4a56f4e59830d6$export$c4ec754551fa3ff4);
    var $x8FYU;
    var $1kpI8;
    const $6c4a56f4e59830d6$export$c4ec754551fa3ff4 = ()=>{
        const [groupByFieldId, setGroupBy] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).GROUPING_PREFERENCE));
        return [
            groupByFieldId,
            setGroupBy
        ];
    };
});
parcelRegister("g4BWd", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$cf55a53088d59416$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $egmQO;
    var $hE5wF;
    var $5YBrl;
    var $gZEAz;
    var $ePLOx;
    var $kRkJF;
    var $jlq4V;
    var $4R6GH;
    var $jJZqs;
    var $eCBf9;
    var $560mU;
    var $5fc53;
    var $koeKL;
    var $eTDjN;
    var $c82az;
    var $2F7tZ;
    const $cf55a53088d59416$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE);
    const $cf55a53088d59416$var$storyPointsFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE) && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID);
    const $cf55a53088d59416$var$sprintFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
    function $cf55a53088d59416$export$fd83eea6ecd2d8fa(query) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, $5uXOq.useCallback)((variables)=>client.query({
                query: query,
                variables: variables,
                errorPolicy: 'all'
            }), [
            client,
            query
        ]);
    }
    const $cf55a53088d59416$export$8af2d18142c8506c = ()=>{
        const { data: categoryField } = (0, (0, parcelRequire("gZEAz")).useCategoryField)();
        const { data: storyPointEstimateField } = (0, (0, parcelRequire("ePLOx")).useFindField)($cf55a53088d59416$var$storyPointEstimateFieldPredicate);
        const { data: storyPointsField } = (0, (0, parcelRequire("ePLOx")).useFindField)($cf55a53088d59416$var$storyPointsFieldPredicate);
        const { data: sprintField } = (0, (0, parcelRequire("ePLOx")).useFindField)($cf55a53088d59416$var$sprintFieldPredicate);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const filtersJQL = (0, (0, parcelRequire("kRkJF")).useFilteredViewJQL)();
        const { onIssueCreated: onIssueCreated } = (0, (0, parcelRequire("560mU")).useOnboardingGetStartedTourActions)();
        const refetchIssue = $cf55a53088d59416$export$fd83eea6ecd2d8fa((0, (0, parcelRequire("c82az")).ISSUE_REFETCH_QUERY));
        const [createIssue] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("c82az")).CREATE_ISSUE_MUTATION));
        const createIssueService = (0, $5uXOq.useCallback)(async (createParams, extraPayload = {})=>{
            const input = (0, (0, parcelRequire("2F7tZ")).buildInput)(createParams.input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            const isDevSummaryFieldVisible = fieldIdsSet.has((0, (0, parcelRequire("eTDjN")).DEV_SUMMARY_FIELD));
            const isParentFieldVisible = fieldIdsSet.has((0, (0, parcelRequire("eTDjN")).PARENT_FIELD));
            fieldIdsSet.delete((0, (0, parcelRequire("eTDjN")).DEV_SUMMARY_FIELD));
            fieldIdsSet.delete((0, (0, parcelRequire("eTDjN")).PARENT_FIELD));
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible
                },
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, (0, parcelRequire("eCBf9")).MutationError)(firstMutationError);
                }
                throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(errors);
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate')) onIssueCreated(createParams.input.projectId);
            return {
                item: result.item,
                itemIdentifiers: {
                    issueId: result.itemIdentifiers.issueId,
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        }, [
            categoryField,
            createIssue,
            onIssueCreated,
            sprintField,
            storyPointEstimateField,
            storyPointsField
        ]);
        const refetchIssueService = (0, $5uXOq.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
            const jql = (0, (0, parcelRequire("egmQO")).generateJql)({
                jqlContext: jqlContext,
                quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
                issueIds: [
                    issueId
                ]
            });
            const fieldIdsSet = new Set(fieldIds);
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const fieldIdsToRequest = Array.from(fieldIdsSet);
            const { data: data } = await refetchIssue({
                jql: jql,
                fieldIds: fieldIdsToRequest,
                cloudId: cloudId,
                first: 1,
                isParentFieldVisible: false,
                isDevSummaryFieldVisible: false
            });
            const viewItems = data?.jira?.jwmViewItems;
            if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
            const issue = viewItems.edges?.[0]?.node;
            return issue ?? null;
        }, [
            cloudId,
            filtersJQL,
            jqlContext,
            refetchIssue
        ]);
        return {
            createIssue: createIssueService,
            refetchIssue: refetchIssueService
        };
    };
});
parcelRegister("egmQO", function(module, exports) {
    $parcel$export(module.exports, "generateJql", ()=>$da4d6eca1d928e18$export$d43e55153d6948c0);
    $parcel$export(module.exports, "getVariables", ()=>$da4d6eca1d928e18$export$a39eddd73bba62c1);
    var $hE5wF;
    var $42GbZ;
    const $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE = (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE);
    const $da4d6eca1d928e18$var$IS_EMPTY = 'IS EMPTY';
    const $da4d6eca1d928e18$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
    const $da4d6eca1d928e18$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
        const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
        const defaultSorting = `ORDER BY Rank ${(0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION)}`;
        const jql = [];
        const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
        const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, (0, parcelRequire("42GbZ")).getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
        if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
        if (jqlContext) jql.push(jqlContext);
        else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
        if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
            if (typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY})`);
        }
        if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
        if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
        if (groupQuery) {
            const { jqlTerm: jqlTerm, value: value } = groupQuery;
            if (!value) jql.push(`${jqlTerm} ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            else jql.push(`${jqlTerm} = ${value}`);
            if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
                if (typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
                else jql.push(`parent ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            }
        }
        if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
        return `${jql.join(' AND ')} ${sortByClause}`;
    };
    const $da4d6eca1d928e18$export$a39eddd73bba62c1 = (input)=>{
        const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
        const singleQueryJql = {
            jql: $da4d6eca1d928e18$export$d43e55153d6948c0(input, parentIssue)
        };
        const newFieldIds = Array.isArray(fieldIds) ? [
            ...fieldIds
        ] : [];
        const remoteIssueLinksIndex = newFieldIds.indexOf((0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE));
        const hasConfluenceLinks = remoteIssueLinksIndex > -1;
        if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
        return {
            ...singleQueryJql,
            first: parentIssue ? $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE : (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE),
            fieldIds: newFieldIds,
            withConfluenceLinks: hasConfluenceLinks,
            includeDoneItems: input.isHidingDoneItems === false,
            isParentFieldVisible: input.isParentFieldVisible ?? false,
            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false
        };
    };
});
parcelRegister("42GbZ", function(module, exports) {
    $parcel$export(module.exports, "getJqlTerm", ()=>$f8ba3884a7b69792$export$43330b5a5235b231);
    var $6s1PB;
    var $5fc53;
    const $f8ba3884a7b69792$export$43330b5a5235b231 = (fieldId, fieldType)=>{
        if (fieldId.indexOf('customfield_') === 0) {
            const customFieldId = fieldId.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) && (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return 'component';
        return fieldId;
    };
});
parcelRegister("gZEAz", function(module, exports) {
    $parcel$export(module.exports, "useCategoryField", ()=>$23a2f3aed16dc942$export$f7ac7f1f12b4c794);
    var $5fc53;
    var $1T2vX;
    const $23a2f3aed16dc942$export$f7ac7f1f12b4c794 = ()=>{
        const { data: { fields: fields }, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const categoryField = fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) ?? null;
        return {
            data: categoryField,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("ePLOx", function(module, exports) {
    $parcel$export(module.exports, "useFindField", ()=>$7269f16a47ce2a8a$export$4b0b80fa50e6b4be);
    var $1T2vX;
    const $7269f16a47ce2a8a$export$4b0b80fa50e6b4be = (predicate)=>{
        const { data: { fields: fields }, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const field = fields.find(predicate) ?? null;
        return {
            data: field,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eCBf9", function(module, exports) {
    $parcel$export(module.exports, "MutationError", ()=>$5fe48c9a5d56428c$export$10c788363424e94e);
    class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.message = payload.message ?? '';
            this.extensions = payload.extensions;
            this.statusCode = payload.extensions?.statusCode ?? null;
            this.errorType = payload.extensions?.errorType ?? null;
        }
    }
});
parcelRegister("560mU", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CHILD_SPOTLIGHT_ID", ()=>$90c48096f6d773df$export$ee6c1fae9e22c684);
    $parcel$export(module.exports, "CREATE_FIELD_SPOTLIGHT_ID", ()=>$90c48096f6d773df$export$29036d8d6f932a01);
    $parcel$export(module.exports, "useOnboardingGetStartedTourActions", ()=>$90c48096f6d773df$export$65ae8844df2a9c08);
    $parcel$export(module.exports, "useIsIccOpenByDefault", ()=>$90c48096f6d773df$export$291dba6650679451);
    $parcel$export(module.exports, "useListViewOnboarding", ()=>$90c48096f6d773df$export$967b7a7235234c22);
    var $3sQ5x;
    var $iXqE5;
    const $90c48096f6d773df$export$ee6c1fae9e22c684 = 'onboardingGetStartedListViewCreateChildButton';
    const $90c48096f6d773df$export$29036d8d6f932a01 = 'onboardingGetStartedListViewCreateIssueFieldsButton';
    const $90c48096f6d773df$var$defaultNonTourState = {
        projectId: null,
        isTourActive: false,
        isICCOpenByDefault: false,
        previousActiveSpotlight: null,
        currentActiveSpotlight: null
    };
    const $90c48096f6d773df$var$actions = {
        startTour: (projectId)=>({ setState: setState })=>setState({
                    projectId: projectId,
                    isTourActive: true,
                    isICCOpenByDefault: true
                }),
        setActiveSpotlight: ({ projectId: projectId, spotlightId: spotlightId })=>({ setState: setState })=>{
                setState({
                    ...$90c48096f6d773df$var$defaultNonTourState,
                    projectId: projectId,
                    currentActiveSpotlight: spotlightId
                });
            },
        dismissSpotlight: (spotlightId)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                if (!state.isTourActive) return setState($90c48096f6d773df$var$defaultNonTourState);
                if (spotlightId === $90c48096f6d773df$export$29036d8d6f932a01) return setState($90c48096f6d773df$var$defaultNonTourState);
                return setState({
                    previousActiveSpotlight: spotlightId,
                    currentActiveSpotlight: null
                });
            },
        onIssueCreated: (projectId)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                if (projectId !== state.projectId || !state.isTourActive) return;
                if (state.previousActiveSpotlight === null) return setState({
                    currentActiveSpotlight: $90c48096f6d773df$export$ee6c1fae9e22c684,
                    isICCOpenByDefault: false
                });
                if (state.previousActiveSpotlight === $90c48096f6d773df$export$ee6c1fae9e22c684) return setState({
                    currentActiveSpotlight: $90c48096f6d773df$export$29036d8d6f932a01
                });
            }
    };
    const $90c48096f6d773df$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $90c48096f6d773df$var$defaultNonTourState,
        actions: $90c48096f6d773df$var$actions,
        name: 'GetStartedListViewTour'
    });
    const $90c48096f6d773df$export$65ae8844df2a9c08 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($90c48096f6d773df$var$Store);
    const $90c48096f6d773df$export$291dba6650679451 = (0, (0, parcelRequire("3sQ5x")).createHook)($90c48096f6d773df$var$Store, {
        selector: (state, projectId)=>state.isICCOpenByDefault && state.projectId === projectId
    });
    const $90c48096f6d773df$export$967b7a7235234c22 = (0, (0, parcelRequire("3sQ5x")).createHook)($90c48096f6d773df$var$Store, {
        selector: (state, { projectId: projectId, id: id })=>state.currentActiveSpotlight === id && state.projectId === projectId
    });
});
parcelRegister("c82az", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_MUTATION", ()=>$eb757ea22cfcb9ef$export$f5c1cac020b22be4);
    $parcel$export(module.exports, "ISSUE_REFETCH_QUERY", ()=>$eb757ea22cfcb9ef$export$834c81726d4c51eb);
    var $5cllN;
    var $1jIw5;
    var $hgp1u;
    var $kkA5E;
    var $61h55;
    const $eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT = (0, (0, parcelRequire("5cllN")).default)`
fragment CreatedListItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
        totalCount
    }
    commentSummary {
        totalCount
    }
    legacyConfluenceLinks(getFirstOnly: true) {
        ...ConfluenceLinksFragment
    }
    devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
        ...DevSummaryFieldFragment
    }
    ...ListViewIssueFieldsFragment
}
${(0, (0, parcelRequire("61h55")).LIST_VIEW_FIELDS_FRAGMENT)}
${(0, (0, parcelRequire("1jIw5")).CONFLUENCE_LINKS_FRAGMENT)}
${(0, (0, parcelRequire("hgp1u")).JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
    const $eb757ea22cfcb9ef$export$f5c1cac020b22be4 = (0, (0, parcelRequire("5cllN")).default)`

mutation JWMListInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedListItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, (0, parcelRequire("kkA5E")).CREATE_ISSUE_FRAGMENT)}
${$eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT}
`;
    const $eb757ea22cfcb9ef$export$834c81726d4c51eb = (0, (0, parcelRequire("5cllN")).default)`
query JWMListInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedListItemFragment
                    }
                }
            }
        }
    }
}
${$eb757ea22cfcb9ef$var$CREATED_ITEM_FRAGMENT}
`;
});
parcelRegister("1jIw5", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_LINKS_FRAGMENT", ()=>$163c64757226ab14$export$757a6323be066698);
    var $5cllN;
    const $163c64757226ab14$export$757a6323be066698 = (0, (0, parcelRequire("5cllN")).default)`
    fragment ConfluenceLinksFragment on ConfluenceLinks {    
            linkedConfluencePages {
                pageCount
                pages {
                    ... on ConfluencePage {
                        id
                        globalId
                        href
                        title
                        type
                        lastUpdatedContext {
                            user {
                                key
                                accountId
                                emailAddress
                                avatarUrl
                                displayName
                                active
                            }
                        }
                    }
                    ... on FailedRemoteLink {
                        id
                        error
                        link {
                            id
                            globalId
                            href
                        }
                        repairLink {
                            href
                        }
                    }
                }
            }
    }
`;
});
parcelRegister("hgp1u", function(module, exports) {
    $parcel$export(module.exports, "JIRA_BUSINESS_FIELDS_FRAGMENT", ()=>$7e186b77adb3d312$export$16a4e56fe7b29670);
    $parcel$export(module.exports, "JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT", ()=>$7e186b77adb3d312$export$8a6df2ce60bca6f1);
    var $5cllN;
    var $PEXLp;
    var $NP5lF;
    var $iGMM4;
    var $lwUNo;
    var $8zsae;
    var $j7Iys;
    var $1pAp2;
    var $3GIY9;
    var $28LQn;
    var $ggiU6;
    var $ieCa3;
    var $8FrR1;
    var $6VSLz;
    var $cO6xZ;
    var $jXXlm;
    var $baFng;
    var $iNcfS;
    var $9YcjN;
    var $2ix3d;
    var $exG5v;
    var $3f4qN;
    const $7e186b77adb3d312$export$16a4e56fe7b29670 = (0, (0, parcelRequire("5cllN")).default)`
	${(0, (0, parcelRequire("ggiU6")).PARENT_FRAGMENT)}
	${(0, (0, parcelRequire("3f4qN")).VERSION_FRAGMENT)}
	${(0, (0, parcelRequire("iNcfS")).TEAM_FRAGMENT)}
	${(0, (0, parcelRequire("8zsae")).GOALS_FRAGMENT)}
	${(0, (0, parcelRequire("cO6xZ")).RESOLUTION_FRAGMENT)}
	${(0, (0, parcelRequire("j7Iys")).GROUP_FRAGMENT)}
	${(0, (0, parcelRequire("1pAp2")).LABELS_FRAGMENT)}
	${(0, (0, parcelRequire("NP5lF")).DATE_FRAGMENT)}
	${(0, (0, parcelRequire("iGMM4")).DATE_TIME_FRAGMENT)}
	${(0, (0, parcelRequire("exG5v")).ATLASSIAN_ACCOUNT_FRAGMENT)}
	${(0, (0, parcelRequire("exG5v")).USER_FRAGMENT)}
	${(0, (0, parcelRequire("exG5v")).PEOPLE_FRAGMENT)}
	${(0, (0, parcelRequire("exG5v")).MULTIPLE_USER_FRAGMENT)}
	${(0, (0, parcelRequire("ieCa3")).PRIORITY_FRAGMENT)}
	${(0, (0, parcelRequire("3GIY9")).MULTIPLE_SELECT_FRAGMENT)}
	${(0, (0, parcelRequire("28LQn")).NUMBER_FRAGMENT)}
	${(0, (0, parcelRequire("6VSLz")).RADIO_SELECT_FRAGMENT)}
	${(0, (0, parcelRequire("jXXlm")).SINGLE_SELECT_FRAGMENT)}
	${(0, (0, parcelRequire("2ix3d")).URL_FRAGMENT)}
	${(0, (0, parcelRequire("9YcjN")).SINGLE_LINE_TEXT_FRAGMENT)}
	${(0, (0, parcelRequire("baFng")).STATUS_CATEGORY_FRAGMENT)}
	${(0, (0, parcelRequire("PEXLp")).CASCADING_SELECT_FRAGMENT)}
	${(0, (0, parcelRequire("8FrR1")).PROJECT_FRAGMENT)}
`;
    const $7e186b77adb3d312$export$8a6df2ce60bca6f1 = (0, (0, parcelRequire("5cllN")).default)`
	${(0, (0, parcelRequire("lwUNo")).DEV_SUMMARY_FRAGMENT)}
`;
});
parcelRegister("PEXLp", function(module, exports) {
    $parcel$export(module.exports, "CASCADING_SELECT_FRAGMENT", ()=>$ebed62ab0f3bd519$export$88d11aac85f3a5f2);
    var $5cllN;
    const $ebed62ab0f3bd519$export$88d11aac85f3a5f2 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraCascadingSelectFieldFragment on JiraCascadingSelectField {
        id
        fieldId
        fieldConfig {
            isEditable
        }
        cascadingOption {
            parentValue {
                id
                isDisabled
                value
            }
            childOptionValue {
                id
                optionId
                isDisabled
                value
            }
        }
    } 
`;
});
parcelRegister("NP5lF", function(module, exports) {
    $parcel$export(module.exports, "DATE_FRAGMENT", ()=>$68f33dc7015a2fed$export$f8e1b8104aa9273f);
    var $5cllN;
    const $68f33dc7015a2fed$export$f8e1b8104aa9273f = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraDateFieldFragment on JiraDatePickerField {
        date
    } 
`;
});
parcelRegister("iGMM4", function(module, exports) {
    $parcel$export(module.exports, "DATE_TIME_FRAGMENT", ()=>$163b86e1c4c674a9$export$f5c7c2e5cce27d00);
    var $5cllN;
    const $163b86e1c4c674a9$export$f5c7c2e5cce27d00 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraDateTimeFieldFragment on JiraDateTimePickerField {
        dateTime
    } 
`;
});
parcelRegister("lwUNo", function(module, exports) {
    $parcel$export(module.exports, "DEV_SUMMARY_FRAGMENT", ()=>$b217a628105095f2$export$a5751f0d2763fac3);
    var $5cllN;
    const $b217a628105095f2$export$a5751f0d2763fac3 = (0, (0, parcelRequire("5cllN")).default)`
    fragment DevSummaryFieldFragment on JiraIssueDevSummaryResult {
        devSummary {
            commit {
                overall {
                    count
                }
            }
            pullrequest {
                overall {
                    state
                    count
                }
            }
        }
    } 
`;
});
parcelRegister("8zsae", function(module, exports) {
    $parcel$export(module.exports, "GOALS_FRAGMENT", ()=>$d95223f07223b855$export$14859f852d0eecb4);
    var $5cllN;
    const $d95223f07223b855$export$14859f852d0eecb4 = (0, (0, parcelRequire("5cllN")).default)`
    fragment JiraGoalsFieldFragment on JiraGoalsField {
        __typename
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedGoals(first: 1) {
            totalCount,
            edges {
                node {
                    id
                    name
                    status
                }
            }
        }
    }
`;
});
parcelRegister("j7Iys", function(module, exports) {
    $parcel$export(module.exports, "GROUP_FRAGMENT", ()=>$de6f0431613b8dd7$export$91c2ad2e63414b50);
    var $5cllN;
    const $de6f0431613b8dd7$var$gqlTagGira = (0, (0, parcelRequire("5cllN")).default);
    const $de6f0431613b8dd7$export$99b0877e6d0a4712 = $de6f0431613b8dd7$var$gqlTagGira`
	fragment jiraBusinessSingleGroupFieldFragment on JiraSingleGroupPickerField {
		__typename
		id
		fieldId
		name
		selectedGroup {
			id
			groupId
			name
		}
	}
`;
    const $de6f0431613b8dd7$export$27846949a41c873f = $de6f0431613b8dd7$var$gqlTagGira`
	fragment jiraBusinessMultipleGroupFieldFragment on JiraMultipleGroupPickerField {
		__typename
		id
		fieldId
		name
		selectedGroupsConnection {
			edges {
				node {
					id
					groupId
					name
				}
			}
		}
	}
`;
    const $de6f0431613b8dd7$export$91c2ad2e63414b50 = (0, (0, parcelRequire("5cllN")).default)`
	${$de6f0431613b8dd7$export$27846949a41c873f}
	${$de6f0431613b8dd7$export$99b0877e6d0a4712}
`;
});
parcelRegister("1pAp2", function(module, exports) {
    $parcel$export(module.exports, "LABELS_FRAGMENT", ()=>$4df5b87c30bf16eb$export$30f9416168d64de4);
    var $5cllN;
    const $4df5b87c30bf16eb$export$30f9416168d64de4 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraLabelsFieldFragment on JiraLabelsField {
        selectedLabelsConnection {
            edges {
                node {
                    name
                }
            }
        }
    } 
`;
});
parcelRegister("3GIY9", function(module, exports) {
    $parcel$export(module.exports, "MULTIPLE_SELECT_FRAGMENT", ()=>$2f0a11646cf2cfca$export$ed658c6a0e11bdf9);
    var $5cllN;
    const $2f0a11646cf2cfca$export$ed658c6a0e11bdf9 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraMultipleSelectFieldFragment on JiraMultipleSelectField {
        fieldConfig {
            isEditable
          }
        selectedOptions {
            edges {
                node {
                    optionId
                    value
                }
            }
        }
    }
`;
});
parcelRegister("28LQn", function(module, exports) {
    $parcel$export(module.exports, "NUMBER_FRAGMENT", ()=>$c04add054a4eac3a$export$c1b90ff48aa1e878);
    var $5cllN;
    const $c04add054a4eac3a$export$c1b90ff48aa1e878 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;
});
parcelRegister("ggiU6", function(module, exports) {
    $parcel$export(module.exports, "PARENT_FRAGMENT", ()=>$3b4f564338c94723$export$1efcd2a93f28f76e);
    var $5cllN;
    const $3b4f564338c94723$export$1efcd2a93f28f76e = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraBusinessParentFieldFragment on JiraParentIssueField {
        fieldId
        parentIssue {
            id
            issueId
            key
            rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
                aliasFieldId
                ... on JiraSingleLineTextField {
                    text
                }
            }
            fields: fieldsByIdOrAlias(idsOrAliases: ["summary", "issuetype", "issuecolor", "status"], ignoreMissingFields: true) @connection (key: "parentFields") @include(if: $isParentFieldVisible) {
                fieldId
                name
                aliasFieldId
                type
                ... on JiraColorField {
                    color {
                        colorKey
                    }
                }
                ... on JiraSingleLineTextField {
                    text
                }
                ... on JiraStatusField {
                    status {
                        name
                        statusCategory {
                            statusCategoryId
                        }
                    }
                }
                ... on JiraIssueTypeField {
                    issueType {
                        name
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
`;
});
parcelRegister("ieCa3", function(module, exports) {
    $parcel$export(module.exports, "PRIORITY_FRAGMENT", ()=>$6c55e56b9f67ebd2$export$6d5f71aa3bbf9a14);
    var $5cllN;
    const $6c55e56b9f67ebd2$export$6d5f71aa3bbf9a14 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraPriorityFieldFragment on JiraPriorityField {
        priority {
            id
            name
            priorityId
            iconUrl
        }
    }
`;
});
parcelRegister("8FrR1", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_FRAGMENT", ()=>$9a8182c208e3906d$export$e365122194197244);
    var $5cllN;
    const $9a8182c208e3906d$export$e365122194197244 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraProjectFieldFragment on JiraProjectField {
        fieldId
        name
        project {
            id
            projectId
            name
            key
            avatar {
                large
            }
        }
    }
`;
});
parcelRegister("6VSLz", function(module, exports) {
    $parcel$export(module.exports, "RADIO_SELECT_FRAGMENT", ()=>$1385b530ca3edd64$export$55296ac87efdd2c2);
    var $5cllN;
    const $1385b530ca3edd64$export$55296ac87efdd2c2 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraRadioSelectFieldFragment on JiraRadioSelectField {
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedOption {
            optionId
            value
        }
    }
`;
});
parcelRegister("cO6xZ", function(module, exports) {
    $parcel$export(module.exports, "RESOLUTION_FRAGMENT", ()=>$27a75f6f548a47f6$export$e8f52599fbfc8f74);
    var $5cllN;
    const $27a75f6f548a47f6$export$e8f52599fbfc8f74 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraBusinessResolutionFieldFragment on JiraResolutionField {
        fieldId
        name
        resolution {
            id
            name
        }
    } 
`;
});
parcelRegister("jXXlm", function(module, exports) {
    $parcel$export(module.exports, "SINGLE_SELECT_FRAGMENT", ()=>$74a33283ae84d68d$export$f1c5cfc4b5de6700);
    var $5cllN;
    const $74a33283ae84d68d$export$f1c5cfc4b5de6700 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraSingleSelectFragment on JiraSingleSelectField {
        fieldConfig {
            isEditable
        }
        fieldOption {
            optionId
            value
            color {
                colorKey
            }
        }
    }
`;
});
parcelRegister("baFng", function(module, exports) {
    $parcel$export(module.exports, "STATUS_CATEGORY_FRAGMENT", ()=>$a0882d2c1a43f19a$export$a125a2d730e3d413);
    var $5cllN;
    const $a0882d2c1a43f19a$export$a125a2d730e3d413 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraStatusCategoryFragment on JiraStatusCategoryField {
        fieldId
        fieldConfig {
          isEditable
        }
        statusCategory {
          id
          statusCategoryId
          name
        }
    }
`;
});
parcelRegister("iNcfS", function(module, exports) {
    $parcel$export(module.exports, "TEAM_FRAGMENT", ()=>$7c31d1d554d693ca$export$b8a1e15b67d0c801);
    var $5cllN;
    const $7c31d1d554d693ca$export$b8a1e15b67d0c801 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
        }
    } 
`;
});
parcelRegister("9YcjN", function(module, exports) {
    $parcel$export(module.exports, "SINGLE_LINE_TEXT_FRAGMENT", ()=>$f1f674f06c8943a4$export$23113309bffe00ca);
    var $5cllN;
    const $f1f674f06c8943a4$export$23113309bffe00ca = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;
});
parcelRegister("2ix3d", function(module, exports) {
    $parcel$export(module.exports, "URL_FRAGMENT", ()=>$9063163b69045994$export$7044ea8d89b6f59d);
    var $5cllN;
    const $9063163b69045994$export$7044ea8d89b6f59d = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraUrlFieldFragment on JiraUrlField {
        uri
        fieldConfig {
          isEditable
        }
    }
`;
});
parcelRegister("exG5v", function(module, exports) {
    $parcel$export(module.exports, "ATLASSIAN_ACCOUNT_FRAGMENT", ()=>$5c6c513b05f48580$export$7620e2c63d440c49);
    $parcel$export(module.exports, "USER_FRAGMENT", ()=>$5c6c513b05f48580$export$6496fa362c67d06e);
    $parcel$export(module.exports, "PEOPLE_FRAGMENT", ()=>$5c6c513b05f48580$export$49438f3cf8087021);
    $parcel$export(module.exports, "MULTIPLE_USER_FRAGMENT", ()=>$5c6c513b05f48580$export$5267cb871f0541c9);
    var $5cllN;
    const $5c6c513b05f48580$export$7620e2c63d440c49 = (0, (0, parcelRequire("5cllN")).default)`
  fragment AtlassianAccountFragment on AtlassianAccountUser {
    accountId
    accountStatus
    picture
    name
  }
`;
    const $5c6c513b05f48580$export$6496fa362c67d06e = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraSingleUserFieldFragment on JiraSingleSelectUserPickerField {
        user {
            ...AtlassianAccountFragment
        }
        fieldConfig {
            isEditable
        }
    }
`;
    const $5c6c513b05f48580$export$49438f3cf8087021 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraPeopleFieldFragment on JiraPeopleField {
        fieldConfig {
          isEditable
        }
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
    }
`;
    const $5c6c513b05f48580$export$5267cb871f0541c9 = (0, (0, parcelRequire("5cllN")).default)`
    fragment jiraMultipleUserFieldFragment on JiraMultipleSelectUserPickerField {
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
        fieldConfig {
          isEditable
        }
    }
`;
});
parcelRegister("3f4qN", function(module, exports) {
    $parcel$export(module.exports, "VERSION_FRAGMENT", ()=>$e03bc7b37dba3728$export$6f6bf5d27acb96a6);
    var $5cllN;
    const $e03bc7b37dba3728$var$gqlTagGira = (0, (0, parcelRequire("5cllN")).default);
    const $e03bc7b37dba3728$export$4320515340a845c0 = $e03bc7b37dba3728$var$gqlTagGira`
    fragment jiraBusinessSingleVersionFieldFragment on JiraSingleVersionPickerField {
      __typename
      id
      fieldId
      name
      version {
        versionId
        name
      }
    }
`;
    const $e03bc7b37dba3728$export$b336fe1ccb7b1f67 = $e03bc7b37dba3728$var$gqlTagGira`
    fragment jiraBusinessMultipleVersionFieldFragment on JiraMultipleVersionPickerField {
      __typename
      id
      fieldId
      name
      selectedVersionsConnection {
        edges {
          node {
            versionId
            name
          }
        }
      }
    }
`;
    const $e03bc7b37dba3728$export$6f6bf5d27acb96a6 = (0, (0, parcelRequire("5cllN")).default)`
	${$e03bc7b37dba3728$export$b336fe1ccb7b1f67}
	${$e03bc7b37dba3728$export$4320515340a845c0}
`;
});
parcelRegister("kkA5E", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", ()=>$22484cc131c517f0$export$47232071d0e9dfb);
    var $5cllN;
    const $22484cc131c517f0$export$47232071d0e9dfb = (0, (0, parcelRequire("5cllN")).default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;
});
parcelRegister("61h55", function(module, exports) {
    $parcel$export(module.exports, "LIST_VIEW_FIELDS_FRAGMENT", ()=>$165c1ba5d9304c2b$export$878eea3ba159096b);
    $parcel$export(module.exports, "LIST_VIEW_QUERY", ()=>$165c1ba5d9304c2b$export$bf9c5668f03a036d);
    $parcel$export(module.exports, "BACKGROUND_LIST_VIEW_QUERY", ()=>$165c1ba5d9304c2b$export$b0ac16e8fe90de24);
    $parcel$export(module.exports, "LIST_VIEW_ITEM_DETAILS_QUERY", ()=>$165c1ba5d9304c2b$export$3f338783432a1617);
    var $5cllN;
    var $1jIw5;
    var $hgp1u;
    const $165c1ba5d9304c2b$export$878eea3ba159096b = (0, (0, parcelRequire("5cllN")).default)`
  fragment ListViewIssueFieldsFragment on JiraWorkManagementViewItem {
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      fieldId
      name
      aliasFieldId
      type
      ... on JiraIssueTypeField {
        issueType {
          issueTypeId
          name
          avatar {
            medium
          }
          hierarchy {
            level
          }
        }
      }
      ... on JiraStatusField {
        status {
          name
          statusId
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraRichTextField {
        richText {
          adfValue {
            json
            convertedPlainText {
              plainText
              isTruncated
            }
          }
        }
        renderer
      }
      ... on JiraOriginalTimeEstimateField {
        originalEstimate {
          timeInSeconds
        }
        fieldConfig {
          isEditable
        }
      }
      ... on JiraTimeTrackingField {
        originalEstimate {
          timeInSeconds
        }
        timeTrackingSettings {
          defaultUnit
          defaultFormat
          workingHoursPerDay
          workingDaysPerWeek
        }
      }
      ... on JiraComponentsField {
        fieldConfig {
          isEditable
        }
        selectedComponentsConnection {
          edges {
            node {
              name
              componentId
            }
          }
        }
      }
      ... on JiraParentIssueField {
        parentIssue {
          issueId
          key
        }
      }
     ... on JiraCheckboxesField {
        selectedOptions {
          edges {
            node {
              optionId
              value
            }
          }
        }
      }
      ... on JiraSprintField {
        fieldId
        aliasFieldId
        fieldConfig {
          isEditable
        }
        selectedSprintsConnection(first: 1) {
          edges {
            node {
              sprintId
              name
              state
            }
          }
        }
      }
      ...jiraBusinessSingleVersionFieldFragment
      ...jiraBusinessMultipleVersionFieldFragment
      ...jiraBusinessParentFieldFragment
      ...jiraBusinessTeamFieldFragment
      ...JiraGoalsFieldFragment
      ...jiraBusinessResolutionFieldFragment
      ...jiraBusinessSingleGroupFieldFragment
      ...jiraBusinessMultipleGroupFieldFragment
      ...jiraLabelsFieldFragment
      ...jiraDateFieldFragment
      ...jiraDateTimeFieldFragment
      ...jiraSingleUserFieldFragment
      ...jiraMultipleUserFieldFragment
      ...jiraPeopleFieldFragment
      ...jiraPriorityFieldFragment
      ...jiraMultipleSelectFieldFragment
      ...jiraNumberFieldFragment
      ...jiraRadioSelectFieldFragment
      ...jiraSingleSelectFragment
      ...jiraUrlFieldFragment
      ...jiraSingleLineTextFragment
      ...jiraStatusCategoryFragment
      ...jiraCascadingSelectFieldFragment
      ...jiraProjectFieldFragment
    }
  }

  ${(0, (0, parcelRequire("hgp1u")).JIRA_BUSINESS_FIELDS_FRAGMENT)}
`;
    const $165c1ba5d9304c2b$export$5f151982dc1bb93c = (0, (0, parcelRequire("5cllN")).default)`
  fragment ListViewItemEdges on JiraWorkManagementViewItemConnection {
    edges {
      node {
        id
        issueId
        childSummary(includeDone: $includeDoneItems) {
            hasChildren
            totalCount
        }
        commentSummary {
            totalCount
        }
        legacyConfluenceLinks(getFirstOnly: true) @include(if: $withConfluenceLinks) @connection(key: "legacyConfluenceLinks") {
            ...ConfluenceLinksFragment
        }
        devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
          ...DevSummaryFieldFragment
        }
        ...ListViewIssueFieldsFragment
      }
    }
  }
  ${$165c1ba5d9304c2b$export$878eea3ba159096b}
  ${(0, (0, parcelRequire("1jIw5")).CONFLUENCE_LINKS_FRAGMENT)}
  ${(0, (0, parcelRequire("hgp1u")).JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
    const $165c1ba5d9304c2b$export$bf9c5668f03a036d = (0, (0, parcelRequire("5cllN")).default)`
  query JWMListViewItems($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "list", filter:["jql"]) {
        ...on QueryError {
          message
          extensions {
            statusCode
            errorType
          }
        }
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;
    const $165c1ba5d9304c2b$export$b0ac16e8fe90de24 = (0, (0, parcelRequire("5cllN")).default)`
  query JWMListViewItemsBackground($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "backgroundList", filter:["jql"]) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;
    const $165c1ba5d9304c2b$export$3f338783432a1617 = (0, (0, parcelRequire("5cllN")).default)`
  query JWMListViewItemDetails($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
        }
      }
    }
  }

  ${$165c1ba5d9304c2b$export$5f151982dc1bb93c}
`;
});
parcelRegister("2F7tZ", function(module, exports) {
    $parcel$export(module.exports, "buildInput", ()=>$fffa8e113b0d87a3$export$f4db126e014728a3);
    var $5fc53;
    const $fffa8e113b0d87a3$var$RANK_BEFORE_ID = 'rankBefore';
    const $fffa8e113b0d87a3$var$RANK_AFTER_ID = 'rankAfter';
    const $fffa8e113b0d87a3$export$f4db126e014728a3 = (input, extraPayload, categoryField, sprintField, storyPointEstimateField, storyPointsField)=>{
        const singleLineTextFields = [
            {
                fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                text: input.summary
            }
        ];
        const singleSelectUserPickerFields = [];
        const numberFields = [];
        if (input.category && categoryField?.id) singleLineTextFields.push({
            fieldId: categoryField.id,
            text: input.category.optionId
        });
        if (input.assignee) singleSelectUserPickerFields.push({
            fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            user: {
                accountId: input.assignee.accountId
            }
        });
        if (input.storyPointEstimate != null && storyPointEstimateField?.id) numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: input.storyPointEstimate
        });
        if (input.storyPoints != null && storyPointsField?.id) numberFields.push({
            fieldId: storyPointsField.id,
            value: input.storyPoints
        });
        const fields = {
            singleLineTextFields: singleLineTextFields,
            singleSelectUserPickerFields: singleSelectUserPickerFields,
            numberFields: numberFields,
            ...input.sprint && sprintField?.id && {
                sprintsField: {
                    fieldId: sprintField.id,
                    sprints: [
                        {
                            sprintId: input.sprint.id
                        }
                    ]
                }
            },
            ...input.priority && {
                priority: {
                    priorityId: input.priority.priorityId
                }
            },
            ...input.parentIssueId && {
                parentField: {
                    issueId: input.parentIssueId
                }
            }
        };
        const rank = {
            ...input.rankBefore && {
                before: {
                    id: $fffa8e113b0d87a3$var$RANK_BEFORE_ID,
                    issueId: input.rankBefore.issueId
                }
            },
            ...input.rankAfter && {
                after: {
                    id: $fffa8e113b0d87a3$var$RANK_AFTER_ID,
                    issueId: input.rankAfter.issueId
                }
            }
        };
        const result = {
            projectId: input.projectId,
            issueType: input.issueType.id,
            fields: fields,
            rank: rank,
            ...extraPayload?.transitionId && {
                transitionId: extraPayload.transitionId
            }
        };
        return result;
    };
});
parcelRegister("lz9hZ", function(module, exports) {
    $parcel$export(module.exports, "EmptyState", ()=>$7c3c8f03e5b2f97a$export$fddf379e22a74b00);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $hE5wF;
    var $kRkJF;
    var $1T1ir;
    var $he7sk;
    var $6cG4N;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $22OQR;
    var $ieDtd;
    var $4nnGr;
    var $cngB1;
    var $2IAT8;
    const $7c3c8f03e5b2f97a$export$ea3803e2a45d21c4 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, setInlineCreateParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).INLINE_CREATE_PARAM));
        const handleClick = (0, $5uXOq.useCallback)(()=>setInlineCreateParam('true'), [
            setInlineCreateParam
        ]);
        const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        let createButtonText = (0, (0, parcelRequire("2IAT8")).default).createItemButton;
        if (isSoftwareFieldsEnabled) createButtonText = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2IAT8")).default).createIssueButtonIssueTermRefresh : (0, (0, parcelRequire("2IAT8")).default).createIssueButton;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cngB1")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$var$HeadingWrapper, null, formatMessage((0, (0, parcelRequire("2IAT8")).default).emptyStateHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7c3c8f03e5b2f97a$var$contentWrapperStyles
        }, formatMessage((0, (0, parcelRequire("2IAT8")).default).emptyStateDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            appearance: "primary",
            onClick: handleClick
        }, formatMessage(createButtonText)));
    };
    const $7c3c8f03e5b2f97a$export$fddf379e22a74b00 = ({ reason: reason })=>{
        const { isFiltering: isFiltering, jqlErrors: jqlErrors } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        let emptyStateMessage = (0, ($parcel$interopDefault($5uXOq))).createElement($7c3c8f03e5b2f97a$export$ea3803e2a45d21c4, null);
        if (reason === 'INVALID_JQL' && (0, (0, parcelRequire("4R6GH")).fg)('list-handle-field-missing-handler-server-error')) emptyStateMessage = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("he7sk")).ThemedFilterEmptyState), {
            reason: "INVALID_JQL"
        });
        else if (isSearching || isFiltering) emptyStateMessage = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("he7sk")).ThemedFilterEmptyState), {
            reason: jqlErrors.length ? 'INVALID_JQL' : 'NO_RESULTS'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $7c3c8f03e5b2f97a$var$wrapperStyles
        }, emptyStateMessage);
    };
    const $7c3c8f03e5b2f97a$var$Wrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7c3c8f03e5b2f97a$var$emptyWrapperStyles
        }, children);
    const $7c3c8f03e5b2f97a$var$emptyWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textAlign: 'center',
        margin: 'auto',
        width: '400px',
        padding: 'space.300',
        background: (0, (0, parcelRequire("6cG4N")).Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER,
        borderRadius: 'border.radius.200'
    });
    const $7c3c8f03e5b2f97a$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazfrbu _19pku2gc",
                __cmplp.className
            ])
        });
    });
    const $7c3c8f03e5b2f97a$var$contentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150',
        marginBottom: 'space.300'
    });
    const $7c3c8f03e5b2f97a$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.1000',
        paddingTop: 'space.800',
        width: '100%'
    });
});
parcelRegister("he7sk", function(module, exports) {
    $parcel$export(module.exports, "ThemedFilterEmptyState", ()=>$cd3da1c859fecc93$export$e911425bb76dd69e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $x8FYU;
    var $1kpI8;
    var $6cG4N;
    parcelRequire("c7i3D");
    var $5BNLu = parcelRequire("5BNLu");
    var $koVbs;
    var $22OQR;
    var $lVJAU;
    var $7htvz;
    var $23WHC;
    const $cd3da1c859fecc93$export$e911425bb76dd69e = ({ reason: reason })=>{
        const { updateQueryParam: updateQueryParam } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [, setFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            setFilters(undefined, 'none');
            updateQueryParam({
                filter: undefined,
                quickFilters: undefined,
                [(0, (0, parcelRequire("7htvz")).SIMPLE_SEARCH_PARAM)]: undefined
            }, 'push');
        }, [
            updateQueryParam,
            setFilters
        ]);
        const message = reason === 'INVALID_JQL' ? formatMessage((0, (0, parcelRequire("23WHC")).default).invalidStateHeading) : formatMessage((0, (0, parcelRequire("23WHC")).default).emptyStateHeading);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $cd3da1c859fecc93$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$Illustration, {
            src: (0, ($parcel$interopDefault($5BNLu))),
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$HeadingWrapper, null, message), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            appearance: "primary",
            onClick: handleOnClear
        }, formatMessage((0, (0, parcelRequire("23WHC")).default).clearFiltersButton)));
    };
    const $cd3da1c859fecc93$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textAlign: 'center',
        margin: 'auto',
        width: '450px',
        padding: 'space.300',
        borderRadius: 'border.radius.200',
        background: (0, (0, parcelRequire("6cG4N")).Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
    });
    const $cd3da1c859fecc93$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazfrbu _otyr1ejb",
                __cmplp.className
            ])
        });
    });
    const $cd3da1c859fecc93$var$Illustration = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1yk2 _4t3i13i4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("c7i3D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5BNLu")))));
    var $dCLgq;
    var $f3FKt = parcelRequire("f3FKt");
    var $5BNLu = parcelRequire("5BNLu");
    const $e6eff2dc5f73fdbc$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5BNLu)),
        srcDark: ($parcel$interopDefault($f3FKt))
    });
    var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
    const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
        0,
        0,
        208,
        190
    ];
});
parcelRegister("f3FKt", function(module, exports) {
    module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();
});
parcelRegister("5BNLu", function(module, exports) {
    module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("23WHC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4708df9bdc612950$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4708df9bdc612950$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateHeading: {
            "id": "business-filters.themed-filter-empty-state.empty-state-heading",
            "defaultMessage": "It looks like we can't find any results that match."
        },
        invalidStateHeading: {
            "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
            "defaultMessage": "We can't handle the current filters, please clear to continue."
        },
        clearFiltersButton: {
            "id": "business-filters.themed-filter-empty-state.clear-filters-button",
            "defaultMessage": "Clear"
        }
    });
});
parcelRegister("cngB1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0518b6eb1b77d0a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $0518b6eb1b77d0a1$var$Illustration = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("kQPze")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/empty-state/illustration/main.tsx"
    });
    var $0518b6eb1b77d0a1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-list-empty-state",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0518b6eb1b77d0a1$var$Illustration, null));
});
parcelRegister("kQPze", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Gw7N").then(()=>parcelRequire('g69tt'));
});
parcelRegister("2IAT8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$166191219629cb77$export$2e2bcd8739ae039);
    var $7VHMR;
    var $166191219629cb77$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateHeading: {
            "id": "business-list.list-view.empty-state.empty-state-heading",
            "defaultMessage": "View your work in a list"
        },
        emptyStateDescription: {
            "id": "business-list.list-view.empty-state.empty-state-description",
            "defaultMessage": "Manage and sort all your project\u2019s work into a single list that can be easily scanned and sorted by category."
        },
        createItemButton: {
            "id": "business-list.list-view.empty-state.create-item-button",
            "defaultMessage": "Create an item"
        },
        createIssueButton: {
            "id": "business-list.list-view.empty-state.create-issue-button",
            "defaultMessage": "Create issue"
        },
        createIssueButtonIssueTermRefresh: {
            "id": "business-list.list-view.empty-state.create-issue-button-issue-term-refresh",
            "defaultMessage": "Create work item"
        }
    });
});
parcelRegister("aoiYi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79523967be3ef702$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $imZsD;
    var $fNobW;
    var $kMSay;
    var $57r8q;
    var $hE5wF;
    var $e21nk;
    var $cm8b5;
    var $kRkJF;
    var $1T1ir;
    var $2UUq6;
    var $cLGgz;
    var $exeAk;
    var $ltZxv;
    var $3kVj2;
    var $ksKCJ;
    var $7Wnap;
    var $7Q2kM;
    var $eGLgs;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $2gCtH;
    var $iBhrx;
    var $2OMDV;
    var $8zOmE;
    var $2NMNM;
    var $iuzc0;
    var $14XJw;
    var $g5X3G;
    var $koeKL;
    var $l8ruj;
    var $ieDtd;
    var $eTDjN;
    var $dJ1ye;
    var $mk7k0;
    var $iHWvz;
    var $3fU11;
    var $4nnGr;
    var $8TUlY;
    var $8e3Yw;
    var $5HTKY;
    var $9u99d;
    var $gijCE;
    var $g7iDt;
    var $dvvS3;
    var $5t2X8;
    var $hb2SN;
    var $j2Xxu;
    var $7G4Lw;
    var $7pW4c;
    var $5bYhZ;
    var $2CfGf;
    var $fX4kd;
    var $5h7oA;
    var $lz9hZ;
    var $1QC74;
    var $dUCV4;
    var $aQK8w;
    var $dfOFF;
    var $8nhP8;
    var $35R0r;
    const $79523967be3ef702$var$FOOTER_HEIGHT = 45;
    const $79523967be3ef702$var$ROW_HEIGHT = 40;
    const $79523967be3ef702$var$ON_END_REACHED_THRESHOLD = 300;
    const $79523967be3ef702$var$STARGATE_URL = '/gateway/api';
    const $79523967be3ef702$var$BaseTableWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('', {
        onResize: 'resized'
    })((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bYhZ")).default), props));
    const $79523967be3ef702$var$ListContent = ({ projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const interactionMetrics = (0, (0, parcelRequire("dJ1ye")).useInteractionMetrics)();
        const [columnWidths, { setColumnWidth: setColumnWidth }] = (0, (0, parcelRequire("3fU11")).useColumnWidths)();
        const [{ hierarchyData: { data: issues, loading: loading, error: error } }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const viewMode = (0, (0, parcelRequire("2gCtH")).useViewMode)();
        const isViewModeSideBar = viewMode === 'SIDEBAR';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { isFiltering: isFiltering } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const [selectedIssueKey, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const showReparentModal = (0, (0, parcelRequire("hb2SN")).useShouldShowReparentModal)();
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("eTDjN")).VIEW_EXPERIENCE), {
            loading: loading,
            error: error
        });
        const [{ sortBy: sortBy }] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        const isSorting = sortBy != null;
        const { featureView: featureView, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const numIssues = (0, $5uXOq.useMemo)(()=>issues.filter((i)=>!i.id.match('^SKELETON-ITEM-[0-9]+-id$')).length, [
            issues
        ]);
        const [showBulkEditOnboarding, setShowBulkEditOnboarding] = (0, $5uXOq.useState)(false);
        const [coordinationClient, setCoordinationClient] = (0, $5uXOq.useState)(null);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_view_bulk_edit_changeboarding')) {
            if (numIssues >= 2 && cloudId && orgId && !coordinationClient) {
                const coordClient = new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, $79523967be3ef702$var$STARGATE_URL, false, orgId, 'engagement');
                setCoordinationClient(coordClient);
                coordClient.start((0, (0, parcelRequire("eTDjN")).BULK_EDIT_CHANGEBOARDING_MESSAGE_ID)).then(setShowBulkEditOnboarding);
            }
        }
        (0, (0, parcelRequire("j2Xxu")).useTableAnalytics)();
        const ufoPressTracing = (0, (0, parcelRequire("kMSay")).default)('jwm.list.issue-view-opened');
        const onBeforeOpened = (0, $5uXOq.useCallback)((event)=>{
            ufoPressTracing(event.timeStamp);
        }, [
            ufoPressTracing
        ]);
        const filterIssue = (0, $5uXOq.useCallback)((issue)=>Boolean(issue.id && !(0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(issue.id)) && issue.key), []);
        const { createOpenIssueModalHandler: openIssueModal } = (0, (0, parcelRequire("ltZxv")).useIssueModalActions)({
            onBeforeOpened: onBeforeOpened,
            filterIssue: filterIssue
        });
        const { toggleHighlightRow: toggleHighlightRow, getRowClassName: getRowClassName } = (0, (0, parcelRequire("2CfGf")).useHighlightDoneItems)();
        const highlightRow = (0, $5uXOq.useCallback)((issueKey)=>toggleHighlightRow(issueKey, true), [
            toggleHighlightRow
        ]);
        const { onIssueUpdated: onIssueUpdated } = (0, (0, parcelRequire("7pW4c")).useIssueUpdated)();
        const columns = (0, (0, parcelRequire("35R0r")).useGetColumns)({
            columnWidths: columnWidths,
            rowHeight: $79523967be3ef702$var$ROW_HEIGHT,
            openIssueModal: openIssueModal,
            highlightRow: highlightRow,
            loading: loading,
            projectId: projectId,
            onIssueUpdated: onIssueUpdated,
            showBulkEditOnboarding: showBulkEditOnboarding
        });
        const onResize = (columnKey, width, analyticsEvent)=>{
            interactionMetrics[0, (0, parcelRequire("dJ1ye")).COLUMN_RESIZED].start();
            setColumnWidth(columnKey, width);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'column resized', {
                columnKey: columnKey
            });
        };
        const onModalIssueClose = (0, $5uXOq.useCallback)(()=>{
            setSelectedIssueKey(undefined);
        }, [
            setSelectedIssueKey
        ]);
        const { onIssueChange: onIssueChange } = (0, (0, parcelRequire("g7iDt")).useIssueChangeUpdater)();
        const bentoView = (0, $5uXOq.useMemo)(()=>selectedIssueKey != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kVj2")).default), {
                issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(selectedIssueKey),
                onClose: onModalIssueClose,
                analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
                onChange: onIssueChange,
                isSoftwareProject: isSoftwareFieldsEnabled
            }), [
            selectedIssueKey,
            onModalIssueClose,
            onIssueChange,
            isSoftwareFieldsEnabled
        ]);
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGrouping = groupByFieldId != null;
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'list viewed', {
                isGrouping: isGrouping,
                isSorting: isSorting,
                isFiltering: isFiltering,
                isSearching: isSearching
            });
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "list-view",
            hold: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).RenderStartMark), {
            view: featureView,
            loading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gijCE")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement($79523967be3ef702$var$BaseTableWithAnalytics, {
            columns: columns,
            onResize: onResize,
            onEndReachedThreshold: $79523967be3ef702$var$ON_END_REACHED_THRESHOLD,
            footerHeight: $79523967be3ef702$var$FOOTER_HEIGHT,
            rowHeight: $79523967be3ef702$var$ROW_HEIGHT,
            getRowClassName: getRowClassName,
            loadingMessage: formatMessage((0, (0, parcelRequire("aQK8w")).default).loadingMoreItems),
            isSorting: isSorting,
            EmptyState: (0, (0, parcelRequire("lz9hZ")).EmptyState),
            GroupItem: (0, (0, parcelRequire("1QC74")).GroupItem),
            projectId: projectId,
            projectKey: projectKey,
            projectName: projectName
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5t2X8")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HTKY")).default), {
            isBackgroundQueryDisabled: !isGrouping
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TUlY")).UpdateFieldsDetail), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-list-issue-app"
        }, isViewModeSideBar ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ksKCJ")).SidebarIssueView), {
            issueKey: selectedIssueKey,
            onClose: onModalIssueClose,
            analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
            onChange: onIssueChange,
            isSoftwareProject: isSoftwareFieldsEnabled
        }) : bentoView), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Q2kM")).DevDetailsDialogLoaderAsync), {
            scopeId: "software-list.list"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dvvS3")).default), {
            showBulkEditOnboarding: showBulkEditOnboarding,
            coordinationClient: coordinationClient
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fX4kd")).default), null), showReparentModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8nhP8")).AsyncReparentModal), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5h7oA")).default), null), (0, (0, parcelRequire("4R6GH")).fg)('jfind-align-jwm-and-jsw-project-config-killswitch') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBhrx")).AsyncConfigurationModal), {
            source: "list"
        }));
    };
    const $79523967be3ef702$export$84d0dd190d551cd1 = ({ projectId: projectId, projectKey: projectKey, projectName: projectName, isTeamManaged: isTeamManaged, formattingRulesQuery: formattingRulesQuery })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ childrenItems: _childrenQueryData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const pageHeading = formatMessage((0, (0, parcelRequire("aQK8w")).default).listHeading);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClear = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'groupBy cleared', {
                reason: 'stale'
            });
        }, [
            createAnalyticsEvent
        ]);
        (0, (0, parcelRequire("7G4Lw")).useClearStaleGroupBy)({
            onClear: onClear
        });
        (0, (0, parcelRequire("iHWvz")).useWatchBulkSelection)();
        const listViewContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e21nk")).BusinessDocumentTitle), {
            pageHeading: pageHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-list-header-actions"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUCV4")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), {
            blanketIsTinted: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($79523967be3ef702$var$ListContent, {
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isTeamManaged: isTeamManaged
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dfOFF")).InteractionMetrics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("exeAk")).PrefetchIssueDataController), null), formattingRulesQuery && (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57r8q")).FormatRules), {
            query: formattingRulesQuery
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mk7k0")).BulkSelectionContainer), {
            scope: "JWMListBulkSelection"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuzc0")).QuickstartPillVisibilityContainer), {
            scope: "ListPageQuickstartPill"
        }, listViewContent));
    };
    var $79523967be3ef702$export$2e2bcd8739ae039 = $79523967be3ef702$export$84d0dd190d551cd1;
});
parcelRegister("57r8q", function(module, exports) {
    $parcel$export(module.exports, "FormatRules", ()=>$846afdd27dc3631b$export$85cc1c447494ea9e);
    var $ejcnh;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $llMZa;
    var $hug5L;
    const $846afdd27dc3631b$export$85cc1c447494ea9e = ({ query: query })=>{
        const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, (0, parcelRequire("hug5L")).useFormatRulesStore)();
        const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("ejcnh")).default), query);
        (0, $5uXOq.useEffect)(()=>{
            const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
            if (!formattingRulesByProject) return;
            let rowRules = [];
            const cellRulesByFieldId = {};
            const rulesJqlInput = {};
            formattingRulesByProject.edges?.forEach((edge, index)=>{
                const rule = edge?.node;
                if (rule) {
                    const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                    let fieldId = null;
                    let operator = 'IS';
                    let value;
                    switch(rule.expression.__typename){
                        case 'JiraFormattingSingleValueOperand':
                            operator = rule.expression.singleValueOperator;
                            ({ value: value, fieldId: fieldId } = rule.expression);
                            break;
                        case 'JiraFormattingMultipleValueOperand':
                            operator = rule.expression.multipleValueOperator;
                            value = rule.expression.values;
                            fieldId = rule.expression.fieldId;
                            break;
                        case 'JiraFormattingNoValueOperand':
                            operator = rule.expression.noValueOperator;
                            fieldId = rule.expression.fieldId;
                            break;
                        default:
                            break;
                    }
                    const color = (0, (0, parcelRequire("llMZa")).formattingColors)[formattingColor.colorKey || ''];
                    const mappedRule = {
                        id: rule.id,
                        fieldId: fieldId,
                        operator: operator,
                        value: value,
                        color: color?.value,
                        formattingArea: formattingArea,
                        index: index,
                        hoverColor: color?.hoverValue
                    };
                    if (mappedRule.fieldId) {
                        if (mappedRule.formattingArea === 'ROW') rowRules = [
                            ...rowRules,
                            mappedRule
                        ];
                        else cellRulesByFieldId[mappedRule.fieldId] = [
                            ...cellRulesByFieldId[mappedRule.fieldId] || [],
                            mappedRule
                        ];
                        const DUMMY_VALUE = '-';
                        const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                            mappedRule.value
                        ];
                        if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                        values.forEach((ruleValue)=>{
                            if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                                value: ruleValue ?? DUMMY_VALUE,
                                label: ruleValue ?? DUMMY_VALUE
                            });
                        });
                    }
                }
            });
            setFormatRules({
                rowRules: rowRules,
                cellRulesByFieldId: cellRulesByFieldId
            });
            setRulesForJqlInput(rulesJqlInput);
        }, [
            jira?.jiraProjectByKey?.conditionalFormattingRules,
            setFormatRules,
            setRulesForJqlInput
        ]);
        return null;
    };
});
parcelRegister("ejcnh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$653ec3882dd047d6$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $653ec3882dd047d6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v4 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "colorKey"
        }, v7 = {
            "kind": "ScalarField",
            "name": "formattingArea"
        }, v8 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v9 = {
            "kind": "LinkedField",
            "name": "expression",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8,
                        {
                            "alias": "singleValueOperator",
                            "kind": "ScalarField",
                            "name": "operator"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ],
                    "type": "JiraFormattingSingleValueOperand"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8,
                        {
                            "alias": "multipleValueOperator",
                            "kind": "ScalarField",
                            "name": "operator"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "values"
                        }
                    ],
                    "type": "JiraFormattingMultipleValueOperand"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8,
                        {
                            "alias": "noValueOperator",
                            "kind": "ScalarField",
                            "name": "operator"
                        }
                    ],
                    "type": "JiraFormattingNoValueOperand"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "formatRulesQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4,
                                        "concreteType": "JiraFormattingRuleConnection",
                                        "kind": "LinkedField",
                                        "name": "conditionalFormattingRules",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFormattingRuleEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFormattingRule",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "concreteType": "JiraColor",
                                                                "kind": "LinkedField",
                                                                "name": "formattingColor",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6
                                                                ]
                                                            },
                                                            v7,
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "formatRulesQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4,
                                        "concreteType": "JiraFormattingRuleConnection",
                                        "kind": "LinkedField",
                                        "name": "conditionalFormattingRules",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFormattingRuleEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFormattingRule",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "concreteType": "JiraColor",
                                                                "kind": "LinkedField",
                                                                "name": "formattingColor",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6,
                                                                    v5
                                                                ]
                                                            },
                                                            v7,
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
                "metadata": {},
                "name": "formatRulesQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $653ec3882dd047d6$var$node.hash = "43fc879528441b68c4aa3cce2725ca49";
    (0, $eiowN.PreloadableQueryRegistry).set($653ec3882dd047d6$var$node.params.id, $653ec3882dd047d6$var$node);
    var $653ec3882dd047d6$export$2e2bcd8739ae039 = $653ec3882dd047d6$var$node;
});
parcelRegister("llMZa", function(module, exports) {
    $parcel$export(module.exports, "formattingColors", ()=>$b066db4218a81ff1$export$2fedf4ac4eb04087);
    $parcel$export(module.exports, "getColorKeyFromValue", ()=>$b066db4218a81ff1$export$ae7e938b8bdf2df5);
    var $8QpSo;
    var $deuYz;
    const $b066db4218a81ff1$export$2fedf4ac4eb04087 = {
        lightPurple: {
            label: (0, (0, parcelRequire("deuYz")).default).lightPurple,
            value: "var(--ds-background-accent-purple-subtlest, #998DD9)",
            hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)"
        },
        lightBlue: {
            label: (0, (0, parcelRequire("deuYz")).default).lightBlue,
            value: "var(--ds-background-accent-blue-subtlest, #e9f2ff)",
            hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)"
        },
        lightGreen: {
            label: (0, (0, parcelRequire("deuYz")).default).lightGreen,
            value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)"
        },
        lightTeal: {
            label: (0, (0, parcelRequire("deuYz")).default).lightTeal,
            value: "var(--ds-background-accent-teal-subtlest, #79E2F2)",
            hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)"
        },
        lightYellow: {
            label: (0, (0, parcelRequire("deuYz")).default).lightYellow,
            value: "var(--ds-background-accent-yellow-subtlest, #FFE380)",
            hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)"
        },
        lightRed: {
            label: (0, (0, parcelRequire("deuYz")).default).lightRed,
            value: "var(--ds-background-accent-red-subtlest, #FF8F73)",
            hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FF7452)"
        },
        lightGray: {
            label: (0, (0, parcelRequire("deuYz")).default).lightGray,
            value: "var(--ds-background-accent-gray-subtlest, #6B778C)",
            hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)"
        },
        purple: {
            label: (0, (0, parcelRequire("deuYz")).default).purple,
            value: "var(--ds-background-accent-purple-subtler, #f3f0ff)",
            hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #6554C0)"
        },
        blue: {
            label: (0, (0, parcelRequire("deuYz")).default).blue,
            value: "var(--ds-background-accent-blue-subtler, #DFD8FD)",
            hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #0065FF)"
        },
        green: {
            label: (0, (0, parcelRequire("deuYz")).default).green,
            value: "var(--ds-background-accent-green-subtler, #C6EDFB)",
            hoverValue: "var(--ds-background-accent-green-subtler-hovered, #36B37E)"
        },
        teal: {
            label: (0, (0, parcelRequire("deuYz")).default).teal,
            value: "var(--ds-background-accent-teal-subtler, #F8E6A0)",
            hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)"
        },
        yellow: {
            label: (0, (0, parcelRequire("deuYz")).default).yellow,
            value: "var(--ds-background-accent-yellow-subtler, #FFF7D6)",
            hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)"
        },
        red: {
            label: (0, (0, parcelRequire("deuYz")).default).red,
            value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FF5630)"
        },
        gray: {
            label: (0, (0, parcelRequire("deuYz")).default).gray,
            value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #505F79)"
        }
    };
    const $b066db4218a81ff1$export$ae7e938b8bdf2df5 = (0, (0, parcelRequire("8QpSo")).default)((value)=>{
        const selectedColor = Object.entries($b066db4218a81ff1$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
        return selectedColor?.[0];
    });
});
parcelRegister("deuYz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$431e5d2eb706d069$export$2e2bcd8739ae039);
    var $7VHMR;
    var $431e5d2eb706d069$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        lightPurple: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
            "defaultMessage": "Subtle purple"
        },
        lightBlue: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
            "defaultMessage": "Subtle blue"
        },
        lightGreen: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
            "defaultMessage": "Subtle green"
        },
        lightTeal: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
            "defaultMessage": "Subtle teal"
        },
        lightYellow: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
            "defaultMessage": "Subtle yellow"
        },
        lightRed: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
            "defaultMessage": "Subtle red"
        },
        lightGray: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
            "defaultMessage": "Subtle gray"
        },
        purple: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
            "defaultMessage": "Bold purple"
        },
        blue: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
            "defaultMessage": "Bold blue"
        },
        green: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
            "defaultMessage": "Bold green"
        },
        teal: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
            "defaultMessage": "Bold teal"
        },
        yellow: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
            "defaultMessage": "Bold yellow"
        },
        red: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
            "defaultMessage": "Bold red"
        },
        gray: {
            "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
            "defaultMessage": "Bold gray"
        }
    });
});
parcelRegister("hug5L", function(module, exports) {
    $parcel$export(module.exports, "useFormatRulesStore", ()=>$7cf99983147e2a90$export$2fe3fe2e87aa2741);
    $parcel$export(module.exports, "useFormatRulesSerialisedJql", ()=>$7cf99983147e2a90$export$3b2286d9a476f9a1);
    var $1tESh;
    var $3sQ5x;
    var $iXqE5;
    const $7cf99983147e2a90$var$initialState = {
        rowRules: [],
        cellRulesByFieldId: {},
        issueIdRowRuleMatched: {},
        rulesJqlInput: {}
    };
    const $7cf99983147e2a90$var$actions = {
        setFormatRules: (rules)=>({ setState: setState })=>{
                const newState = {
                    ...rules
                };
                setState(newState);
            },
        setRulesForJqlInput: (input)=>({ setState: setState })=>{
                const newState = {
                    rulesJqlInput: input
                };
                setState(newState);
            },
        setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const newState = {
                    issueIdRowRuleMatched: {
                        ...currentState.issueIdRowRuleMatched,
                        [issueId]: rule
                    }
                };
                setState(newState);
            },
        removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
                const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
                const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
                const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
                setState({
                    issueIdRowRuleMatched: newIssueIdRowRuleMatched
                });
            }
    };
    const $7cf99983147e2a90$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $7cf99983147e2a90$var$initialState,
        actions: $7cf99983147e2a90$var$actions,
        name: 'JWMFormatRules'
    });
    const $7cf99983147e2a90$export$2fe3fe2e87aa2741 = (0, (0, parcelRequire("3sQ5x")).createHook)($7cf99983147e2a90$var$Store);
    const $7cf99983147e2a90$var$getSerialisedJql = (state)=>(0, (0, parcelRequire("1tESh")).serialiseJql)(state.rulesJqlInput);
    const $7cf99983147e2a90$export$3b2286d9a476f9a1 = (0, (0, parcelRequire("3sQ5x")).createHook)($7cf99983147e2a90$var$Store, {
        selector: $7cf99983147e2a90$var$getSerialisedJql
    });
});
parcelRegister("e21nk", function(module, exports) {
    $parcel$export(module.exports, "BusinessDocumentTitle", ()=>$aa5670652f17dfc4$export$416064ba09d98e69);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $54qG5;
    const $aa5670652f17dfc4$export$416064ba09d98e69 = (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        });
    });
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("exeAk", function(module, exports) {
    $parcel$export(module.exports, "PrefetchIssueDataController", ()=>$77c62695b59f030f$export$1e95fb877713bf5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $1XJ20;
    var $ieDtd;
    var $1JH9w;
    var $l1hWj;
    const $77c62695b59f030f$var$IssueDataLoader = (0, $5uXOq.memo)(({ issues: issues })=>issues.map((issueKey)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1hWj")).AsyncIssueViewCriticalDataLoader), {
                key: issueKey,
                issueKey: issueKey
            })));
    const $77c62695b59f030f$export$1e95fb877713bf5e = ()=>{
        const { prefetchedIssues: prefetchedIssues } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewData)();
        const { clearCache: clearCache } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewDataActions)();
        const [selectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const prevSelectedIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(selectedIssueKey);
        (0, $5uXOq.useEffect)(()=>{
            const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
            const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
            if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
        }, [
            clearCache,
            prevSelectedIssueKey,
            selectedIssueKey
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearCache();
            }, [
            clearCache
        ]);
        const issues = (0, $5uXOq.useMemo)(()=>Object.keys(prefetchedIssues), [
            prefetchedIssues
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($77c62695b59f030f$var$IssueDataLoader, {
            issues: issues
        });
    };
});
parcelRegister("1JH9w", function(module, exports) {
    $parcel$export(module.exports, "usePrefetchIssueViewData", ()=>$a3ad7c51df3f2dbe$export$519e056a921d9691);
    $parcel$export(module.exports, "usePrefetchIssueViewDataActions", ()=>$a3ad7c51df3f2dbe$export$fee97ccc4dadacbb);
    var $3sQ5x;
    var $iXqE5;
    const $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
    const $a3ad7c51df3f2dbe$var$MAX_DELAY = 300;
    const $a3ad7c51df3f2dbe$var$MIN_DELAY = 0;
    const $a3ad7c51df3f2dbe$export$a87749ac92873cf7 = ()=>100;
    const $a3ad7c51df3f2dbe$var$actions = {
        prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
                const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
                const currentTimestamp = Date.now();
                const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $a3ad7c51df3f2dbe$var$MAX_DELAY : $a3ad7c51df3f2dbe$var$MIN_DELAY;
                const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $a3ad7c51df3f2dbe$export$a87749ac92873cf7() ? {} : prefetchedIssues;
                setState({
                    prefetchedIssues: delay === $a3ad7c51df3f2dbe$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                        ...nextPrefetchedIssues,
                        [issueKey]: true
                    } : prefetchedIssues,
                    timestampOfTheLastPrefetch: currentTimestamp
                });
            },
        clearCache: ()=>({ setState: setState })=>{
                setState({
                    timestampOfTheLastPrefetch: null,
                    prefetchedIssues: {}
                });
            }
    };
    const $a3ad7c51df3f2dbe$var$PrefetchIssueViewStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            timestampOfTheLastPrefetch: null,
            prefetchedIssues: {}
        },
        actions: $a3ad7c51df3f2dbe$var$actions,
        name: 'JWMPrefetchIssueViewStore'
    });
    const $a3ad7c51df3f2dbe$export$519e056a921d9691 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);
    const $a3ad7c51df3f2dbe$export$fee97ccc4dadacbb = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);
});
parcelRegister("l1hWj", function(module, exports) {
    $parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", ()=>$4e841b6ce3a4317a$export$15a49d6c068f7356);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $bNCEz;
    const $4e841b6ce3a4317a$var$entryPointParams = {};
    const $4e841b6ce3a4317a$export$15a49d6c068f7356 = (0, $5uXOq.memo)((props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("bNCEz")).asyncIssueViewCriticalDataLoaderEntrypoint), $4e841b6ce3a4317a$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm-issue-view-critical-data-loader",
            packageName: "jiraBusinessIssueViewCriticalDataLoader",
            runtimeProps: props
        });
    });
});
parcelRegister("bNCEz", function(module, exports) {
    $parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", ()=>$4dc1e3141aa0750a$export$6254258f84be452a);
    var $eufEc;
    var $fEDBv;
    const $4dc1e3141aa0750a$export$6254258f84be452a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("Nte5g")), {
            moduleId: "1f53773a"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("Nte5g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93c9T").then(()=>parcelRequire('5h1fq'));
});
parcelRegister("ltZxv", function(module, exports) {
    $parcel$export(module.exports, "useIssueModalActions", ()=>$938b6b6c79d6d36e$export$6f3a65eba75c0ec1);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $l0oHX;
    var $ieDtd;
    const $938b6b6c79d6d36e$var$alwaysTrue = ()=>true;
    const $938b6b6c79d6d36e$export$6f3a65eba75c0ec1 = ({ onBeforeOpened: onBeforeOpened, filterIssue: filterIssue = $938b6b6c79d6d36e$var$alwaysTrue } = {})=>{
        const [_, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const createOpenIssueModalHandler = (0, $5uXOq.useCallback)((issue)=>(event)=>{
                if (filterIssue(issue)) {
                    if (!(0, (0, parcelRequire("l0oHX")).isModifiedEvent)(event)) {
                        onBeforeOpened && onBeforeOpened(event);
                        setSelectedIssueKey(issue.key);
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            }, [
            filterIssue,
            onBeforeOpened,
            setSelectedIssueKey
        ]);
        return {
            createOpenIssueModalHandler: createOpenIssueModalHandler
        };
    };
});
parcelRegister("3kVj2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9988a92625a64f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $hE5wF;
    var $2gCtH;
    var $gjEtj;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $l8ruj;
    var $kxZPA;
    var $ieDtd;
    const $e9988a92625a64f1$export$843a6e93936e3b60 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("apmLb")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
    });
    const $e9988a92625a64f1$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $fcf97b7a09088940$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
        const [, setSelectedIssue] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
            setSelectedIssue
        ]);
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setSidebarContent(null);
            setDetailViewAsSidebar();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const viewModeOptions = (0, $5uXOq.useMemo)(()=>!viewModeSwitchDisabled ? {
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            } : undefined, [
            onSwitchToModal,
            onSwitchToSidebar,
            viewModeSwitchDisabled
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-modal-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            packageName: isSoftwareProject ? 'software' : 'business',
            id: "issue-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "modal-issue-app",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e9988a92625a64f1$export$843a6e93936e3b60, {
            analyticsSource: analyticsSource,
            issueKey: issueKey,
            onClose: onClose,
            onChange: onChange,
            onIssueDeleteSuccess: onDeleteSuccess,
            onIssueKeyChange: onIssueKeyChange,
            viewModeOptions: viewModeOptions
        })))));
    };
    var $e9988a92625a64f1$export$2e2bcd8739ae039 = $e9988a92625a64f1$var$ModalIssueAppWrapper;
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
parcelRegister("apmLb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8SBrF")
    ]).then(()=>parcelRequire('2555l'));
});
parcelRegister("ksKCJ", function(module, exports) {
    $parcel$export(module.exports, "SidebarIssueView", ()=>$15a07712b759f270$export$ccdf533f42a8d6f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bUSNl;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $cZ5o7;
    var $2ax5r;
    const $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
    const $15a07712b759f270$var$callWhenIdle = (callback)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
        else setTimeout(callback, 3000);
    };
    const $15a07712b759f270$export$ccdf533f42a8d6f8 = (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
        const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, (0, parcelRequire("2ax5r")).useSetSidebarStyleVar)();
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            onClose();
        }, [
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (issueKey === prevIssueKey && !!content) return;
            if (issueKey) {
                const newContent = (0, ($parcel$interopDefault($5uXOq))).createElement($15a07712b759f270$var$CSSAntiCorruptionLayer, {
                    key: $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ5o7")).SidebarIssueApp), {
                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey),
                    onClose: onCloseSidebar,
                    analyticsSource: analyticsSource,
                    onChange: onChange,
                    onIssueDeleteSuccess: onIssueDeleteSuccess,
                    isSoftwareProject: isSoftwareProject
                }));
                setSidebarContent(newContent);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
            } else {
                if (content?.key === $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
            }
        }, [
            analyticsSource,
            content,
            createAnalyticsEvent,
            isSoftwareProject,
            issueKey,
            onChange,
            onCloseSidebar,
            onIssueDeleteSuccess,
            prevIssueKey,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $15a07712b759f270$var$callWhenIdle(()=>{
                (0, (0, parcelRequire("cZ5o7")).IssueApp).preload();
            });
        }, []);
        return null;
    });
    const $15a07712b759f270$var$CSSAntiCorruptionLayer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cZ5o7", function(module, exports) {
    $parcel$export(module.exports, "IssueApp", ()=>$f0984329e6d3d9e6$export$35dd9ab573b87c3f);
    $parcel$export(module.exports, "SidebarIssueApp", ()=>$f0984329e6d3d9e6$export$e402f7c18d4d7f37);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bUSNl;
    var $2gCtH;
    var $7eqRV;
    var $lfTZh;
    var $1XJ20;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $c65JB;
    var $l8ruj;
    var $kxZPA;
    const $f0984329e6d3d9e6$export$35dd9ab573b87c3f = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jO7eF")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $f0984329e6d3d9e6$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
        const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
            setCurrentIssueKey(nextIssueKey);
        }, []);
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        (0, $5uXOq.useEffect)(()=>{
            if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
        }, [
            currentIssueKey,
            issueKey,
            prevIssueKey
        ]);
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsSidebar();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const PACKAGE_NAME = (0, $5uXOq.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
            isSoftwareProject
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-sidebar-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-app",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7eqRV")).IssueBoundary), {
            packageName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0984329e6d3d9e6$export$35dd9ab573b87c3f, {
            viewModeOptions: {
                viewMode: 'SIDEBAR',
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            },
            issueKey: currentIssueKey,
            analyticsSource: analyticsSource,
            shouldShowCloseButton: true,
            onClose: onClose,
            onIssueKeyChange: onIssueKeyChange,
            shouldSetInitialFocus: true,
            shouldShowRootProjectsBreadcrumb: true,
            onIssueDeleteSuccess: onIssueDeleteSuccess,
            onIssueDeleteFailure: (0, ($parcel$interopDefault($8Rkzz))),
            isSpaEnabled: false,
            isLoadedWithPage: false,
            onChange: onChange
        })))));
    };
});
parcelRegister("7eqRV", function(module, exports) {
    $parcel$export(module.exports, "IssueBoundary", ()=>$e3c8771effba3477$export$fbf48ede0cf52b5a);
    $parcel$export(module.exports, "IssueModalBoundary", ()=>$e3c8771effba3477$export$74d408982642a541);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $gjEtj;
    var $lfTZh;
    var $c65JB;
    const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isEmbedView: isEmbedView
            })
        }, children));
    const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "issue-modal",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-modal-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isModalView: true
            })
        }, children));
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("2ax5r", function(module, exports) {
    $parcel$export(module.exports, "useSetSidebarStyleVar", ()=>$f33586d1e0f68dde$export$70b20cd72362e39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $5e5zm;
    const $f33586d1e0f68dde$var$MARGIN = 24;
    const $f33586d1e0f68dde$export$70b20cd72362e39d = ()=>{
        const [{ content: content, sidebarWidth: sidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { setWidth: setWidth } = (0, (0, parcelRequire("5e5zm")).useDetailPanelActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (content !== null) {
                document.documentElement?.style.setProperty((0, $563deb1efef5771e$export$c83c5cba188418d8), `${sidebarWidth}px`);
                setWidth(sidebarWidth + $f33586d1e0f68dde$var$MARGIN);
            } else document.documentElement?.style.removeProperty((0, $563deb1efef5771e$export$c83c5cba188418d8));
            return ()=>{
                setWidth(0);
            };
        }, [
            content,
            setWidth,
            sidebarWidth
        ]);
    };
});
const $563deb1efef5771e$export$c83c5cba188418d8 = '--detailPanelWidth';
parcelRegister("7Wnap", function(module, exports) {
    $parcel$export(module.exports, "RenderStartMark", ()=>$4c177752bab6a832$export$2128f295d6adb861);
    $parcel$export(module.exports, "PageLoadMetrics", ()=>$4c177752bab6a832$export$66b33c055cbb625e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    var $gN11a;
    const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
        if (loading === true) return null;
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
        return null;
    };
    const $4c177752bab6a832$export$66b33c055cbb625e = (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
        const metric = (0, (0, parcelRequire("gN11a")).pageLoadMetrics)[view];
        return metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: `${product}.${view}`,
            metric: metric,
            extra: attributes
        });
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("7Q2kM", function(module, exports) {
    $parcel$export(module.exports, "DevDetailsDialogLoaderAsync", ()=>$1e951f8230b07137$export$f5ffc0f323543e16);
    $parcel$export(module.exports, "default", ()=>$1e951f8230b07137$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lfTZh;
    var $kxZPA;
    const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jmhGO")), {
        ssr: false,
        moduleId: "./src/packages/development/details-loader/src/ui/main.tsx"
    });
    const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dev-detail-dialog-loader-with-container",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
    $1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
        onCloseDevDetailDialog: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $1e951f8230b07137$export$2e2bcd8739ae039 = $1e951f8230b07137$export$f5ffc0f323543e16;
});
parcelRegister("jmhGO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4DoQ8")
    ]).then(()=>parcelRequire('bmGNV'));
});
parcelRegister("iBhrx", function(module, exports) {
    $parcel$export(module.exports, "AsyncConfigurationModal", ()=>$e3bfbed8f27fe2e5$export$34f51aa2795224c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ivDCs;
    var $4mO32;
    var $dVwj1;
    var $4C22F;
    const $e3bfbed8f27fe2e5$export$34f51aa2795224c0 = ({ source: source })=>{
        const shouldShowConfigurationModal = (0, (0, parcelRequire("4C22F")).useShouldShowConfigurationModal)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("dVwj1")).configurationModalEntryPoint), {});
        (0, $5uXOq.useEffect)(()=>{
            if (shouldShowConfigurationModal) {
                entryPointActions.load();
                return ()=>{
                    entryPointActions.unload();
                };
            }
        }, [
            shouldShowConfigurationModal,
            entryPointActions
        ]);
        if (!shouldShowConfigurationModal) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            id: "jira-onboarding-configuration-modal",
            packageName: "jiraOnboarding",
            teamName: "Growth-Jira-Find",
            runtimeProps: {
                onClose: entryPointActions.unload,
                source: source
            },
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            errorFallback: "flag"
        });
    };
});
parcelRegister("dVwj1", function(module, exports) {
    $parcel$export(module.exports, "configurationModalEntryPoint", ()=>$7dc449e55e25f530$export$7158ef6f461fa04d);
    var $eufEc;
    var $fEDBv;
    const $7dc449e55e25f530$export$7158ef6f461fa04d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("1fxFj")), {
            moduleId: "ef5424b8"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("1fxFj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("17mPp")
    ]).then(()=>parcelRequire('hLzBu'));
});
parcelRegister("4C22F", function(module, exports) {
    $parcel$export(module.exports, "useShouldShowConfigurationModal", ()=>$2b11db451ff540ae$export$312c5451298f3e5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yQlD;
    const $2b11db451ff540ae$export$312c5451298f3e5d = ()=>{
        const sessionStorageVal = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9yQlD")).sessionStorageProvider).get((0, $2b25ecc91c46c84c$export$de91a9e5892a42f0)), []);
        (0, $5uXOq.useEffect)(()=>{
            if (sessionStorageVal) (0, (0, parcelRequire("9yQlD")).sessionStorageProvider).remove((0, $2b25ecc91c46c84c$export$de91a9e5892a42f0));
        }, [
            sessionStorageVal
        ]);
        if (sessionStorageVal === undefined) return false;
        return sessionStorageVal === true;
    };
});
parcelRegister("9yQlD", function(module, exports) {
    $parcel$export(module.exports, "sessionStorage", ()=>$816fbeb16311dd64$export$f119d83aa936d634);
    $parcel$export(module.exports, "sessionStorageProvider", ()=>$816fbeb16311dd64$export$5a24cb3021127ff7);
    $parcel$export(module.exports, "localStorage", ()=>$816fbeb16311dd64$export$c2ed3351cac403d1);
    var $bSSG7;
    var $eNf8a;
    const $816fbeb16311dd64$export$f119d83aa936d634 = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('onboarding-core');
    const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('onboarding-core');
    const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalExpirableStorageProvider)('onboarding-core');
});
const $2b25ecc91c46c84c$export$de91a9e5892a42f0 = 'shouldShowConfigurationModal';
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("iuzc0", function(module, exports) {
    $parcel$export(module.exports, "QuickstartPillVisibilityContainer", ()=>$eb306ed6e1ecf691$export$1a5202e8ea7b76ab);
    $parcel$export(module.exports, "useQuickstartPillVisibilityStore", ()=>$eb306ed6e1ecf691$export$70dc54081d2075ff);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $eb306ed6e1ecf691$var$actions = {
        toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
                setState({
                    showQuickstartPill: showQuickstartPill
                });
            }
    };
    const $eb306ed6e1ecf691$var$initialState = {
        showQuickstartPill: null
    };
    const $eb306ed6e1ecf691$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $eb306ed6e1ecf691$var$initialState,
        actions: $eb306ed6e1ecf691$var$actions,
        name: 'JiraQuickstartPillVisibility'
    });
    const $eb306ed6e1ecf691$export$1a5202e8ea7b76ab = (0, (0, parcelRequire("gg7kZ")).createContainer)($eb306ed6e1ecf691$var$Store, {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    ...$eb306ed6e1ecf691$var$initialState
                });
            }
    });
    const $eb306ed6e1ecf691$export$70dc54081d2075ff = (0, (0, parcelRequire("3sQ5x")).createHook)($eb306ed6e1ecf691$var$Store);
});
parcelRegister("dJ1ye", function(module, exports) {
    $parcel$export(module.exports, "COLUMN_RESIZED", ()=>$78b8694f0d6e1ba7$export$8b3afcfe2043df19);
    $parcel$export(module.exports, "COLUMN_VISIBILITY_CHANGED", ()=>$78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf);
    $parcel$export(module.exports, "DND_ROW_DROPPED", ()=>$78b8694f0d6e1ba7$export$fcf01bd231fb8f52);
    $parcel$export(module.exports, "DND_ROW_LIFTED", ()=>$78b8694f0d6e1ba7$export$96db5145b3b810a2);
    $parcel$export(module.exports, "useInteractionMetrics", ()=>$78b8694f0d6e1ba7$export$6f239bf5d81555c8);
    var $dGrdR;
    const $78b8694f0d6e1ba7$export$8b3afcfe2043df19 = 'column-resized';
    const $78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf = 'column-visibility-changed';
    const $78b8694f0d6e1ba7$export$fcf01bd231fb8f52 = 'dnd-row-droppped';
    const $78b8694f0d6e1ba7$export$96db5145b3b810a2 = 'dnd-row-lifted';
    const $78b8694f0d6e1ba7$export$eee8b97030e3c397 = 'more-fields-button-clicked';
    const $78b8694f0d6e1ba7$var$interactionMetrics = {
        [$78b8694f0d6e1ba7$export$8b3afcfe2043df19]: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: `jwm.list.${$78b8694f0d6e1ba7$export$8b3afcfe2043df19}`
        }),
        [$78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf]: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: `jwm.list.${$78b8694f0d6e1ba7$export$8d5ff5bc3618f0bf}`
        }),
        [$78b8694f0d6e1ba7$export$eee8b97030e3c397]: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: `jwm.list.${$78b8694f0d6e1ba7$export$eee8b97030e3c397}`
        }),
        [$78b8694f0d6e1ba7$export$96db5145b3b810a2]: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: `jwm.list.${$78b8694f0d6e1ba7$export$96db5145b3b810a2}`
        }),
        [$78b8694f0d6e1ba7$export$fcf01bd231fb8f52]: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: `jwm.list.${$78b8694f0d6e1ba7$export$fcf01bd231fb8f52}`
        })
    };
    const $78b8694f0d6e1ba7$export$6f239bf5d81555c8 = ()=>$78b8694f0d6e1ba7$var$interactionMetrics;
});
parcelRegister("mk7k0", function(module, exports) {
    $parcel$export(module.exports, "BulkSelectionContainer", ()=>$cccb1c5255a2f5be$export$ba7d4447e46b479e);
    $parcel$export(module.exports, "useBulkSelectionStore", ()=>$cccb1c5255a2f5be$export$2addfe65a8c51586);
    $parcel$export(module.exports, "useIsIssueSelected", ()=>$cccb1c5255a2f5be$export$cfefd69fc8a5ac52);
    $parcel$export(module.exports, "useIsGroupSelected", ()=>$cccb1c5255a2f5be$export$5810b0d7bc5c531d);
    $parcel$export(module.exports, "useDiffIssuesSelected", ()=>$cccb1c5255a2f5be$export$84ca3a6195e96ba);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $d3Bn9;
    const $cccb1c5255a2f5be$var$actions = {
        selectIssues: ({ issues: issues, issuesData: issuesData, selectGroup: selectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const selectedIssuesDataMap = new Map(state.selectedIssuesData);
                issuesData?.forEach((issue)=>{
                    selectedIssuesDataMap.set(issue.issueId, issue);
                });
                const newState = {
                    ...state,
                    selectedIssues: new Set([
                        ...state.selectedIssues,
                        ...issues
                    ]),
                    ...issuesData && {
                        selectedIssuesData: selectedIssuesDataMap
                    },
                    ...selectGroup ? {
                        selectedGroups: new Set([
                            ...state.selectedGroups,
                            selectGroup
                        ])
                    } : {},
                    ...rowIndex !== undefined ? {
                        lastSelectedRowIndex: rowIndex
                    } : {}
                };
                setState(newState);
            },
        selectAllIssues: ({ issues: issues, issuesData: issuesData = [] })=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const selectedIssuesDataMap = new Map();
                issuesData?.forEach((issue)=>{
                    selectedIssuesDataMap.set(issue.issueId, issue);
                });
                const newState = {
                    ...state,
                    areAllIssuesSelected: true,
                    selectedIssues: new Set(issues),
                    selectedIssuesData: selectedIssuesDataMap,
                    lastSelectedRowIndex: undefined
                };
                setState(newState);
            },
        selectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    selectedGroups: new Set([
                        ...state.selectedGroups,
                        groupId
                    ])
                });
            },
        selectAll: ()=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    areAllIssuesSelected: true
                });
            },
        unselectAll: ()=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    areAllIssuesSelected: false,
                    lastSelectedRowIndex: undefined
                });
            },
        unselectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
                const { selectedGroups: selectedGroups, ...state } = getState();
                selectedGroups.delete(groupId);
                setState({
                    ...state,
                    areAllIssuesSelected: false,
                    selectedGroups: new Set(selectedGroups)
                });
            },
        unselectIssues: ({ issues: issues, unselectGroup: unselectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
                const { selectedIssues: selectedIssues, selectedIssuesData: selectedIssuesData, ...state } = getState();
                if (unselectGroup) state.selectedGroups.delete(unselectGroup);
                issues.forEach((issueId)=>{
                    selectedIssues.delete(issueId);
                    selectedIssuesData.delete(issueId);
                });
                const newState = {
                    ...state,
                    areAllIssuesSelected: false,
                    selectedIssues: new Set(selectedIssues),
                    selectedIssuesData: selectedIssuesData,
                    ...unselectGroup ? {
                        selectedGroups: new Set(state.selectedGroups)
                    } : {},
                    ...rowIndex !== undefined ? {
                        lastSelectedRowIndex: rowIndex
                    } : {}
                };
                setState(newState);
            },
        clearSelection: ()=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    areAllIssuesSelected: false,
                    selectedGroups: new Set(),
                    selectedIssues: new Set(),
                    selectedIssuesData: new Map()
                });
            },
        toggleShowDeleteModal: ({ showDeleteModal: showDeleteModal })=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    showDeleteModal: showDeleteModal
                });
            },
        toggleBulkEditSidebar: ({ showBulkEditSidebar: showBulkEditSidebar })=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const { selectedIssues: selectedIssues } = state;
                if (showBulkEditSidebar) setState({
                    ...state,
                    showBulkEditSidebar: showBulkEditSidebar,
                    bulkEditableIssues: new Set(selectedIssues)
                });
                else setState({
                    ...state,
                    showBulkEditSidebar: showBulkEditSidebar,
                    bulkEditableIssues: new Set()
                });
            },
        setBulkChangePermission: ({ bulkChangePermission: bulkChangePermission })=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    bulkChangePermission: bulkChangePermission
                });
            },
        setFetchingGroups: (groups)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    fetchingGroups: groups
                });
            },
        setLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    lastSelectedRowIndex: lastSelectedRowIndex
                });
            }
    };
    const $cccb1c5255a2f5be$var$initialState = {
        areAllIssuesSelected: false,
        selectedIssues: new Set(),
        selectedIssuesData: new Map(),
        selectedGroups: new Set(),
        showDeleteModal: false,
        showBulkEditSidebar: false,
        fetchingGroups: [],
        bulkEditableIssues: new Set()
    };
    const $cccb1c5255a2f5be$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cccb1c5255a2f5be$var$initialState,
        actions: $cccb1c5255a2f5be$var$actions,
        name: 'JWMListBulkSelection'
    });
    const $cccb1c5255a2f5be$export$ba7d4447e46b479e = (0, (0, parcelRequire("gg7kZ")).createContainer)($cccb1c5255a2f5be$var$Store, {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    ...$cccb1c5255a2f5be$var$initialState
                });
            }
    });
    const $cccb1c5255a2f5be$export$2addfe65a8c51586 = (0, (0, parcelRequire("3sQ5x")).createHook)($cccb1c5255a2f5be$var$Store);
    const $cccb1c5255a2f5be$export$cfefd69fc8a5ac52 = (0, (0, parcelRequire("3sQ5x")).createHook)($cccb1c5255a2f5be$var$Store, {
        selector: (0, (0, parcelRequire("d3Bn9")).isIssueSelected)
    });
    const $cccb1c5255a2f5be$export$5810b0d7bc5c531d = (0, (0, parcelRequire("3sQ5x")).createHook)($cccb1c5255a2f5be$var$Store, {
        selector: (0, (0, parcelRequire("d3Bn9")).isGroupSelected)
    });
    const $cccb1c5255a2f5be$export$84ca3a6195e96ba = (0, (0, parcelRequire("3sQ5x")).createHook)($cccb1c5255a2f5be$var$Store, {
        selector: (0, (0, parcelRequire("d3Bn9")).diffIssuesSelected)
    });
});
parcelRegister("d3Bn9", function(module, exports) {
    $parcel$export(module.exports, "isIssueSelected", ()=>$9e3433dc4bb608a0$export$32568110248dd20a);
    $parcel$export(module.exports, "isGroupSelected", ()=>$9e3433dc4bb608a0$export$9a23656adbf96f8a);
    $parcel$export(module.exports, "diffIssuesSelected", ()=>$9e3433dc4bb608a0$export$bb31aa8fa8f2c5e0);
    var $6dDSs;
    const $9e3433dc4bb608a0$export$32568110248dd20a = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>({
            selectedIssues: state.selectedIssues,
            fetchingGroups: state.fetchingGroups
        }), (__, { issueId: issueId, parentIssueId: parentIssueId })=>({
            issueId: issueId,
            parentIssueId: parentIssueId
        }), ({ selectedIssues: selectedIssues, fetchingGroups: fetchingGroups }, issue)=>{
        if (selectedIssues.has(String(issue.issueId))) return true;
        if (issue.parentIssueId) return fetchingGroups.includes(String(issue.parentIssueId));
        return false;
    });
    const $9e3433dc4bb608a0$export$9a23656adbf96f8a = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.selectedGroups, (__, groupId)=>groupId, (selectedGroups, groupId)=>{
        if (!groupId) return false;
        return selectedGroups.has(groupId);
    });
    const $9e3433dc4bb608a0$export$bb31aa8fa8f2c5e0 = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.selectedIssues, (__, issues)=>issues, (selectedIssues, issues)=>{
        if (!issues) return undefined;
        const diff = [];
        issues.forEach((issueId)=>{
            if (!selectedIssues.has(issueId)) diff.push(issueId);
        });
        return diff;
    });
});
parcelRegister("iHWvz", function(module, exports) {
    $parcel$export(module.exports, "useWatchBulkSelection", ()=>$73f7008f7d336b8f$export$5cafb03426b5addb);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $daQYX;
    var $l4Ejo;
    var $dpQnO;
    var $1XJ20;
    var $8e3Yw;
    var $9u99d;
    var $mk7k0;
    var $4DEgE;
    const $73f7008f7d336b8f$export$5cafb03426b5addb = ()=>{
        const [{ selectedIssues: selectedIssues }, { clearSelection: clearSelection, unselectIssues: unselectIssues }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectId = projectData.id;
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        const [{ hierarchyData: { data: issues }, childrenItems: childrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGrouping = groupByFieldId != null;
        const [hasFiltersBeenUpdated, setHasFiltersBeenUpdated] = (0, $5uXOq.useState)(false);
        const prevIssues = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issues);
        (0, $5uXOq.useEffect)(()=>{
            if (selectedIssues.size && (jql || quickFiltersJql)) {
                if (isGrouping) clearSelection();
                else setHasFiltersBeenUpdated(true);
            }
        }, [
            jql,
            quickFiltersJql
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasFiltersBeenUpdated && !(0, ($parcel$interopDefault($ajpes)))(prevIssues, issues) && !isGrouping) {
                const allIssueIds = (0, (0, parcelRequire("4DEgE")).getAllIssuesIds)({
                    data: issues,
                    childrenItems: childrenItems
                });
                const issuesToUnselect = [
                    ...selectedIssues
                ].filter((issueId)=>allIssueIds.indexOf(issueId) === -1);
                if (issuesToUnselect.length > 0) unselectIssues({
                    issues: issuesToUnselect
                });
                setHasFiltersBeenUpdated(false);
            }
        }, [
            childrenItems,
            hasFiltersBeenUpdated,
            isGrouping,
            issues,
            prevIssues,
            selectedIssues,
            unselectIssues
        ]);
        (0, $5uXOq.useEffect)(()=>{
            clearSelection();
        }, [
            projectId,
            clearSelection
        ]);
    };
});
parcelRegister("9u99d", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyStore", ()=>$587b2d62b109ceda$export$2fc259d06066fab6);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $57lFd;
    var $jDUax;
    var $5fc53;
    var $3sQ5x;
    var $iXqE5;
    var $3fT9O;
    const $587b2d62b109ceda$export$21726efd4013edfd = 1;
    const $587b2d62b109ceda$var$createLoadingItems = ()=>Array.from(Array((0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE)).keys()).map((i)=>(0, (0, parcelRequire("3fT9O")).createItemSkeleton)({
                issueId: String(i)
            }));
    const $587b2d62b109ceda$var$getInitialState = ()=>({
            hierarchyData: {
                data: $587b2d62b109ceda$var$createLoadingItems(),
                loading: true,
                totalCount: 0,
                isLoadingNextPage: false,
                loadNextPage: (0, ($parcel$interopDefault($8Rkzz)))
            },
            expandedItems: {},
            childrenItems: {},
            issuesMap: new Map(),
            issueParentMap: new Map()
        });
    const $587b2d62b109ceda$export$d4c72bab9d6cc13a = $587b2d62b109ceda$var$getInitialState();
    const $587b2d62b109ceda$var$findAnchorIndex = (issues, anchorId)=>{
        if (anchorId == null) return undefined;
        const index = issues.findIndex((issue)=>String(issue.issueId) === anchorId);
        if (index === -1) return undefined;
        return index;
    };
    const $587b2d62b109ceda$var$createHierarchy = ({ item: item, childrenItems: childrenItems, issuesMap: issuesMap, extendItemsWithChildCreate: extendItemsWithChildCreate, hierarchyLevels: hierarchyLevels, showFlatList: showFlatList, issueParentMap: issueParentMap })=>{
        const childQueryData = childrenItems[item.issueId] || {};
        const childrenData = Array.isArray(childQueryData.data) ? childQueryData.data : [];
        const childrenCount = item.childSummary?.totalCount ?? 0;
        const epicLevelIssueTypeIds = hierarchyLevels.filter((hierarchyLevel)=>hierarchyLevel.level === $587b2d62b109ceda$export$21726efd4013edfd).map((hierarchyLevel)=>hierarchyLevel.id);
        const hasChildren = item.issuetype?.id && epicLevelIssueTypeIds.includes(item.issuetype.id) ? true : childrenCount > 0;
        let children = [];
        if (((0, (0, parcelRequire("jDUax")).isGroupItem)(item.issueId) || showFlatList !== true) && hasChildren) {
            const depth = (item.depth || 0) + 1;
            const skeletonItem = childQueryData.loading ? [
                (0, (0, parcelRequire("3fT9O")).createItemSkeleton)({
                    issueId: item.issueId
                })
            ] : [];
            children = childrenData.length ? childrenData.map((childItem, index)=>{
                issueParentMap.set(`${childItem.issueId}`, `${item.issueId}`);
                return $587b2d62b109ceda$var$createHierarchy({
                    item: {
                        ...childItem,
                        rankIndex: index,
                        depth: depth,
                        rowKey: `${childItem.id}-${depth}`
                    },
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    hierarchyLevels: hierarchyLevels,
                    extendItemsWithChildCreate: extendItemsWithChildCreate,
                    issueParentMap: issueParentMap
                });
            }) : skeletonItem;
            if (childQueryData.hasNextPage === true) children.push((0, (0, parcelRequire("3fT9O")).createRowForShowMore)(item.issueId));
        }
        const newItem = extendItemsWithChildCreate(item, children);
        issuesMap.set(`${item.issueId}`, newItem);
        return newItem;
    };
    const $587b2d62b109ceda$var$extendItemsWithChildCreate = (rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels)=>(item, children)=>{
            const expandItem = (issueId)=>{
                const state = getState();
                if (!state.expandedItems[issueId]) setState({
                    ...state,
                    expandedItems: {
                        ...state.expandedItems,
                        [issueId]: true
                    }
                });
            };
            const insertInlineCreate = (anchorIndex, type, issueId)=>{
                if (anchorIndex != null) children.splice(anchorIndex, 0, (0, (0, parcelRequire("3fT9O")).createRowForInlineCreate)(type, String(issueId)));
                else children.unshift((0, (0, parcelRequire("3fT9O")).createRowForInlineCreate)(type, String(issueId)));
            };
            const hierarchyLevel = hierarchyLevels.find((x)=>x.id === item.issuetype?.id)?.level;
            const anchorIndex = $587b2d62b109ceda$var$findAnchorIndex(children, rowCreateState.anchorId);
            const { parentId: parentId } = rowCreateState;
            if (String(parentId) === String(item.issueId)) {
                if ((0, (0, parcelRequire("jDUax")).isGroupItem)(item.issueId)) insertInlineCreate(anchorIndex, 'group', item.issueId);
                else if (hierarchyLevel === 0) insertInlineCreate(anchorIndex, 'subtask', item.issueId);
                else if (hierarchyLevel && hierarchyLevel >= 1) insertInlineCreate(anchorIndex, 'task', item.issueId);
            }
            return {
                ...item,
                children: children,
                onChildCreateButtonClicked: hierarchyLevel !== -1 ? ()=>{
                    setRowCreatePosition({
                        parentId: item.issueId
                    });
                    expandItem(item.issueId);
                } : undefined
            };
        };
    const $587b2d62b109ceda$var$transformTopLevelIssues = (data, rowCreateState)=>{
        const { parentId: parentId, anchorId: anchorId } = rowCreateState;
        const topLevelIssues = data.filter((item)=>!(0, (0, parcelRequire("3fT9O")).isItemAnInlineCreate)(String(item.issueId)));
        if (anchorId && !parentId) {
            const anchorIndex = $587b2d62b109ceda$var$findAnchorIndex(topLevelIssues, rowCreateState.anchorId);
            if (anchorIndex != null) topLevelIssues.splice(anchorIndex, 0, (0, (0, parcelRequire("3fT9O")).createRowForInlineCreate)('sibling'));
        }
        return topLevelIssues;
    };
    const $587b2d62b109ceda$var$setHierarchyData = (queryData, rowCreateState, setRowCreatePosition, hierarchyLevels, showFlatList)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { childrenItems: childrenItems, issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
            const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            if (queryData.loading) return;
            const topLevelIssues = $587b2d62b109ceda$var$transformTopLevelIssues(queryData.data, rowCreateState);
            const data = queryData.loading ? $587b2d62b109ceda$var$createLoadingItems() : topLevelIssues.map((item, index)=>$587b2d62b109ceda$var$createHierarchy({
                    item: {
                        ...item,
                        rankIndex: index,
                        depth: 0,
                        rowKey: `${item.id}-0`
                    },
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    extendItemsWithChildCreate: childCreateCallback,
                    showFlatList: showFlatList,
                    hierarchyLevels: hierarchyLevels,
                    issueParentMap: issueParentMap
                }));
            setState({
                ...state,
                hierarchyData: {
                    ...queryData,
                    data: data
                }
            });
        };
    const $587b2d62b109ceda$var$setExpandedItems = (issueId, isExpanded)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    [issueId]: isExpanded
                }
            });
        };
    const $587b2d62b109ceda$var$setChildrenItems = (parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const childrenItems = {
                ...state.childrenItems,
                [parentIssueId]: {
                    ...queryData,
                    ...queryData.data ? {
                        data: queryData.data.map((issue)=>({
                                ...issue,
                                parentIssueId: parentIssueId
                            }))
                    } : {}
                }
            };
            const { issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
            let targetFound = false;
            const updateHierarchy = ({ rootIssueId: rootIssueId })=>{
                const item = issuesMap.get(`${rootIssueId}`);
                if (targetFound || !item) return null;
                const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
                if (String(item.issueId) === String(parentIssueId)) {
                    targetFound = true;
                    return $587b2d62b109ceda$var$createHierarchy({
                        item: item,
                        childrenItems: childrenItems,
                        issuesMap: issuesMap,
                        extendItemsWithChildCreate: childCreateCallback,
                        hierarchyLevels: hierarchyLevels,
                        issueParentMap: issueParentMap
                    });
                }
                const { children: children } = item;
                const updatedChild = children?.reduce((acc, curr, index)=>{
                    const newChild = updateHierarchy({
                        rootIssueId: curr.issueId
                    });
                    if (newChild) children[index] = newChild;
                    return newChild ?? acc;
                }, undefined);
                if (updatedChild) {
                    const newItem = {
                        ...item,
                        children: children
                    };
                    issuesMap.set(`${item.issueId}`, newItem);
                    return newItem;
                }
                return null;
            };
            const topLevelItems = state.hierarchyData.data;
            for(let index = 0, count = topLevelItems.length; index < count; index += 1){
                const item = topLevelItems[index];
                const newItem = updateHierarchy({
                    rootIssueId: item.issueId
                });
                if (newItem) topLevelItems[index] = newItem;
                if (targetFound) break;
            }
            setState({
                ...state,
                childrenItems: childrenItems,
                hierarchyData: {
                    ...state.hierarchyData,
                    data: [
                        ...topLevelItems
                    ]
                }
            });
        };
    const $587b2d62b109ceda$var$refreshHierarchy = (rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { issuesMap: issuesMap, childrenItems: childrenItems, issueParentMap: issueParentMap } = state;
            const topLevelIssues = $587b2d62b109ceda$var$transformTopLevelIssues(state.hierarchyData.data, rowCreateState);
            for(let index = 0, count = topLevelIssues.length; index < count; index += 1){
                const item = topLevelIssues[index];
                const childCreateCallback = $587b2d62b109ceda$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
                const newItem = $587b2d62b109ceda$var$createHierarchy({
                    item: item,
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    extendItemsWithChildCreate: childCreateCallback,
                    hierarchyLevels: hierarchyLevels,
                    issueParentMap: issueParentMap
                });
                if (newItem) topLevelIssues[index] = newItem;
            }
            setState({
                ...state,
                childrenItems: childrenItems,
                hierarchyData: {
                    ...state.hierarchyData,
                    data: [
                        ...topLevelIssues
                    ]
                }
            });
        };
    const $587b2d62b109ceda$var$resetCache = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                childrenItems: {},
                expandedItems: {}
            });
        };
    const $587b2d62b109ceda$var$expandFirstItems = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const firstIssueId = state.hierarchyData.data[0]?.issueId;
            setState({
                ...state,
                expandedItems: firstIssueId != null ? {
                    [firstIssueId]: true
                } : {}
            });
        };
    const $587b2d62b109ceda$var$clearExpandedItems = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                expandedItems: Object.fromEntries(Object.keys(state.expandedItems).map((key)=>[
                        key,
                        false
                    ]))
            });
        };
    const $587b2d62b109ceda$var$getParentIssueKeysByChildId = (issueId)=>({ getState: getState })=>{
            const { issuesMap: issuesMap } = getState();
            let parents = [];
            let node = issuesMap.get(`${issueId}`);
            do {
                const parentIssue = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(node?.fields, (0, (0, parcelRequire("5fc53")).PARENT_TYPE), 'issue', null);
                const cachedParentIssueId = !(0, (0, parcelRequire("jDUax")).isGroupItem)(`${node?.parentIssueId}`) ? node?.parentIssueId : null;
                const parentIssueId = parentIssue?.issueId ? parentIssue?.issueId : cachedParentIssueId;
                if (parentIssueId) {
                    node = issuesMap.get(`${parentIssueId}`);
                    if (node) parents = [
                        {
                            id: `${parentIssueId}`,
                            key: `${node.key}`
                        },
                        ...parents
                    ];
                    else if (parentIssue?.issueKey) {
                        const key = `${parentIssue?.issueKey || ''}`;
                        parents = [
                            {
                                id: `${parentIssueId}`,
                                key: key
                            },
                            ...parents
                        ];
                    }
                } else node = undefined;
            }while (node)
            if (parents.length) return parents;
            return null;
        };
    const $587b2d62b109ceda$var$clearHierarchyData = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                hierarchyData: $587b2d62b109ceda$var$getInitialState().hierarchyData
            });
        };
    const $587b2d62b109ceda$var$initState = ({ projectKey: projectKey })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                projectKey: projectKey
            });
        };
    const $587b2d62b109ceda$var$actions = {
        setHierarchyData: $587b2d62b109ceda$var$setHierarchyData,
        setExpandedItems: $587b2d62b109ceda$var$setExpandedItems,
        setChildrenItems: $587b2d62b109ceda$var$setChildrenItems,
        refreshHierarchy: $587b2d62b109ceda$var$refreshHierarchy,
        expandFirstItems: $587b2d62b109ceda$var$expandFirstItems,
        clearExpandedItems: $587b2d62b109ceda$var$clearExpandedItems,
        clearHierarchyData: $587b2d62b109ceda$var$clearHierarchyData,
        resetCache: $587b2d62b109ceda$var$resetCache,
        getParentIssueKeysByChildId: $587b2d62b109ceda$var$getParentIssueKeysByChildId,
        initState: $587b2d62b109ceda$var$initState
    };
    const $587b2d62b109ceda$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $587b2d62b109ceda$export$d4c72bab9d6cc13a,
        actions: $587b2d62b109ceda$var$actions,
        name: 'JWMHierarchyStore'
    });
    const $587b2d62b109ceda$export$2fc259d06066fab6 = (0, (0, parcelRequire("3sQ5x")).createHook)($587b2d62b109ceda$var$Store);
});
parcelRegister("jDUax", function(module, exports) {
    $parcel$export(module.exports, "getParentIssueId", ()=>$6e16617835cc2337$export$846a0afb93794223);
    $parcel$export(module.exports, "isGroupItem", ()=>$6e16617835cc2337$export$dcc23ed179776a3b);
    $parcel$export(module.exports, "getGroupItemId", ()=>$6e16617835cc2337$export$4f6368343f5d1a95);
    $parcel$export(module.exports, "isRootLevel", ()=>$6e16617835cc2337$export$7044e84e19490c29);
    var $57lFd;
    var $4R6GH;
    var $deqCE;
    const $6e16617835cc2337$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
        const parentIssueFields = parentIssue.fields || [];
        const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
        const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
        if (subtasksFieldIndex === -1 || subtasksField == null) return parentIssue;
        const updatedFields = [
            ...parentIssueFields
        ];
        updatedFields[subtasksFieldIndex] = {
            ...updatedFields[subtasksFieldIndex],
            issues: [
                subtaskFieldIssue,
                ...subtasksField?.issues || []
            ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
        };
        return {
            ...parentIssue,
            fields: updatedFields
        };
    };
    const $6e16617835cc2337$export$30019f8058090ccb = (isFiltering, id)=>{
        if (id === (0, (0, parcelRequire("deqCE")).OPTIMISTIC_ISSUE_ID)) return false;
        return !isFiltering;
    };
    const $6e16617835cc2337$export$d9893aac42f29b60 = (node)=>{
        const issueKey = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'issuekey', 'text', undefined);
        const parentIssue = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
        const projectKey1 = (issueKey ?? '').split('-')[0];
        const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
        const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
        return sameProject ? parentIssue?.issueId : undefined;
    };
    const $6e16617835cc2337$export$846a0afb93794223 = (node)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_-_get_parent_id_should_support_group')) {
            const parentIssue = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
            if ($6e16617835cc2337$export$dcc23ed179776a3b(parentIssue?.issueId)) return parentIssue?.issueId;
        }
        return $6e16617835cc2337$export$d9893aac42f29b60(node);
    };
    const $6e16617835cc2337$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, (0, parcelRequire("deqCE")).GROUP_ITEM_PREFIX));
    const $6e16617835cc2337$export$4f6368343f5d1a95 = (issueId)=>{
        const [_, groupItemId] = issueId.split(`${(0, (0, parcelRequire("deqCE")).GROUP_ITEM_PREFIX)}_`);
        return groupItemId ?? issueId;
    };
    const $6e16617835cc2337$export$7044e84e19490c29 = (issueId)=>issueId === (0, (0, parcelRequire("deqCE")).ROOT_LEVEL);
});
parcelRegister("deqCE", function(module, exports) {
    $parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", ()=>$13edc00a14335139$export$a76c6afcd77fffd8);
    $parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", ()=>$13edc00a14335139$export$2bc461aaabcabfc9);
    $parcel$export(module.exports, "ROOT_LEVEL", ()=>$13edc00a14335139$export$d24bbd23c8a5d65e);
    $parcel$export(module.exports, "GROUP_ITEM_PREFIX", ()=>$13edc00a14335139$export$b29b9e70f9850100);
    const $13edc00a14335139$export$a76c6afcd77fffd8 = '-optimistic';
    const $13edc00a14335139$export$2bc461aaabcabfc9 = -1;
    const $13edc00a14335139$export$d24bbd23c8a5d65e = 'rootLevel';
    const $13edc00a14335139$export$b29b9e70f9850100 = 'GROUP_BY';
});
parcelRegister("3fT9O", function(module, exports) {
    $parcel$export(module.exports, "isItemAnIssue", ()=>$c4aa3153d0b8fbae$export$975d97cb9b482d9f);
    $parcel$export(module.exports, "createItemSkeleton", ()=>$c4aa3153d0b8fbae$export$ac4443ed642486ab);
    $parcel$export(module.exports, "isItemSkeleton", ()=>$c4aa3153d0b8fbae$export$121c11fd7ecbe3e1);
    $parcel$export(module.exports, "INLINE_CREATE_ITEM_PREFIX", ()=>$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2);
    $parcel$export(module.exports, "createRowForInlineCreate", ()=>$c4aa3153d0b8fbae$export$eb550cfe09336f0d);
    $parcel$export(module.exports, "isItemAnInlineCreate", ()=>$c4aa3153d0b8fbae$export$f785dc554f71ae43);
    $parcel$export(module.exports, "isItemAnInlineCreateTask", ()=>$c4aa3153d0b8fbae$export$76703e048af589f9);
    $parcel$export(module.exports, "isItemAnInlineCreateSubTask", ()=>$c4aa3153d0b8fbae$export$7bcd44296e4ddac3);
    $parcel$export(module.exports, "isItemAnInlineCreateGroup", ()=>$c4aa3153d0b8fbae$export$a18c1da7342b1b86);
    $parcel$export(module.exports, "isItemASiblingTopLevelHierarchyInlineCreate", ()=>$c4aa3153d0b8fbae$export$6341a221cf48c3e1);
    $parcel$export(module.exports, "isItemShowMore", ()=>$c4aa3153d0b8fbae$export$20c8aeca27cd0961);
    $parcel$export(module.exports, "createRowForShowMore", ()=>$c4aa3153d0b8fbae$export$4a6167a75be5ff06);
    var $gULOk;
    var $3rO9r;
    const $c4aa3153d0b8fbae$export$975d97cb9b482d9f = (issueId)=>Number(issueId) > 0;
    const $c4aa3153d0b8fbae$export$8764542593218704 = 'SKELETON-ITEM-';
    const $c4aa3153d0b8fbae$export$ac4443ed642486ab = ({ issueId: issueId })=>({
            id: `${$c4aa3153d0b8fbae$export$8764542593218704}${issueId}-id`,
            issueId: `${$c4aa3153d0b8fbae$export$8764542593218704}${issueId}`,
            typeId: 'loading',
            issuetype: {},
            key: 'loading',
            rank: '',
            status: {
                name: 'To do',
                categoryId: (0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)((0, (0, parcelRequire("gULOk")).TODO)).toString()
            },
            totalSubtasks: 0,
            rankIndex: 0,
            cacheVariables: (0, (0, parcelRequire("3rO9r")).DEFAULT_CACHE_VARIABLES)
        });
    const $c4aa3153d0b8fbae$export$121c11fd7ecbe3e1 = (issueId = '')=>String(issueId).startsWith($c4aa3153d0b8fbae$export$8764542593218704);
    const $c4aa3153d0b8fbae$export$cdc74f7556cd3fa2 = 'INLINE-CREATE-';
    const $c4aa3153d0b8fbae$export$eb550cfe09336f0d = (type = 'subtask', issueId = 'InlineCreate')=>({
            id: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}${type}-id`,
            issueId: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}${type}-issueId`,
            parentIssueId: issueId,
            typeId: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-typeId--${issueId}`,
            issuetype: {},
            key: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-key-${issueId}`,
            rank: '',
            rankIndex: -1,
            status: {
                name: 'To do',
                categoryId: (0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)((0, (0, parcelRequire("gULOk")).TODO)).toString()
            },
            totalSubtasks: 0,
            rowKey: `${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}-${issueId}`,
            cacheVariables: (0, (0, parcelRequire("3rO9r")).DEFAULT_CACHE_VARIABLES)
        });
    const $c4aa3153d0b8fbae$export$f785dc554f71ae43 = (issueId = '')=>issueId.startsWith($c4aa3153d0b8fbae$export$cdc74f7556cd3fa2);
    const $c4aa3153d0b8fbae$export$76703e048af589f9 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}task`);
    const $c4aa3153d0b8fbae$export$7bcd44296e4ddac3 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}subtask`);
    const $c4aa3153d0b8fbae$export$a18c1da7342b1b86 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}group`);
    const $c4aa3153d0b8fbae$export$6341a221cf48c3e1 = (issueId = '')=>issueId.startsWith(`${$c4aa3153d0b8fbae$export$cdc74f7556cd3fa2}sibling`);
    const $c4aa3153d0b8fbae$export$8fca45ac4bf48d8a = 'SHOW_MORE-';
    const $c4aa3153d0b8fbae$export$20c8aeca27cd0961 = (issueId = '')=>issueId.startsWith($c4aa3153d0b8fbae$export$8fca45ac4bf48d8a);
    const $c4aa3153d0b8fbae$export$4a6167a75be5ff06 = (issueId)=>({
            id: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-id`,
            issueId: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-issueId`,
            parentIssueId: issueId,
            typeId: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-typeId--${issueId}`,
            issuetype: {},
            key: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-key-${issueId}`,
            rank: '',
            rankIndex: -1,
            status: {
                name: 'To do',
                categoryId: (0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)((0, (0, parcelRequire("gULOk")).TODO)).toString()
            },
            totalSubtasks: 0,
            rowKey: `${$c4aa3153d0b8fbae$export$8fca45ac4bf48d8a}-${issueId}`,
            cacheVariables: (0, (0, parcelRequire("3rO9r")).DEFAULT_CACHE_VARIABLES)
        });
});
parcelRegister("3rO9r", function(module, exports) {
    $parcel$export(module.exports, "SELECT_ROW_COLUMN_ID", ()=>$ee5861e63098ead5$export$2862da21a9b5c4c7);
    $parcel$export(module.exports, "COLUMNS_WITH_DISABLED_REORDERING", ()=>$ee5861e63098ead5$export$d4e2ef02d58b3b19);
    $parcel$export(module.exports, "DEFAULT_CACHE_VARIABLES", ()=>$ee5861e63098ead5$export$fc14c7f3b5089b5d);
    $parcel$export(module.exports, "PLACEHOLDER_COLUMN", ()=>$ee5861e63098ead5$export$b74e0ecca7ce25fe);
    var $5fc53;
    const $ee5861e63098ead5$export$2862da21a9b5c4c7 = 'selectRow';
    const $ee5861e63098ead5$export$394fb015dc5fe3a6 = 'summary';
    const $ee5861e63098ead5$export$b76d46aaf0fea4b4 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $ee5861e63098ead5$export$e7d0f09e45be184e = 'column-draggable-helper-class';
    const $ee5861e63098ead5$export$d4e2ef02d58b3b19 = [
        $ee5861e63098ead5$export$2862da21a9b5c4c7,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        'key'
    ];
    const $ee5861e63098ead5$export$7b293683c3b210c9 = 'JWMCategoryCustomField';
    const $ee5861e63098ead5$export$fc14c7f3b5089b5d = {
        jql: ''
    };
    const $ee5861e63098ead5$export$b74e0ecca7ce25fe = 'PLACEHOLDER';
});
parcelRegister("4DEgE", function(module, exports) {
    $parcel$export(module.exports, "getFlattenIssuesList", ()=>$affbcffbecf7083a$export$f47d7c5b44a813c0);
    $parcel$export(module.exports, "getAllIssueChildren", ()=>$affbcffbecf7083a$export$1945e9d463a28215);
    $parcel$export(module.exports, "getAllIssuesIds", ()=>$affbcffbecf7083a$export$1b9aa9aa607a46fc);
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $deqCE;
    var $jDUax;
    var $g5X3G;
    var $3fT9O;
    const $affbcffbecf7083a$export$f47d7c5b44a813c0 = ({ issues: issues, expandedItems: expandedItems })=>{
        if (!issues || issues.length === 0) return [];
        const flattenedIssues = issues.flatMap((issue)=>{
            const isExpanded = expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(issue.issueId)];
            const children = isExpanded ? $affbcffbecf7083a$export$f47d7c5b44a813c0({
                issues: issue.children,
                expandedItems: expandedItems
            }) : [];
            return [
                issue,
                ...children
            ];
        });
        return flattenedIssues;
    };
    const $affbcffbecf7083a$export$1945e9d463a28215 = (0, (0, parcelRequire("8QpSo")).default)(({ issue: issue, childrenItems: childrenItems })=>{
        if (!issue) return [];
        const issueChildren = childrenItems[issue.issueId];
        if (!issueChildren) return [];
        let issuesIds = [];
        issueChildren.data?.forEach((child)=>{
            issuesIds = [
                ...issuesIds,
                String(child.issueId),
                ...$affbcffbecf7083a$export$1945e9d463a28215({
                    issue: child,
                    childrenItems: childrenItems
                })
            ];
        });
        return issuesIds;
    }, (0, ($parcel$interopDefault($ajpes))));
    const $affbcffbecf7083a$export$1b9aa9aa607a46fc = ({ data: data, childrenItems: childrenItems })=>{
        let issuesIds = [];
        data.forEach((issue)=>{
            const { issueId: issueId, id: id } = issue;
            if (!(0, (0, parcelRequire("jDUax")).isGroupItem)(issueId) && !(0, (0, parcelRequire("3fT9O")).isItemSkeleton)(issueId) && !id.startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX))) issuesIds.push(String(issueId));
            if (childrenItems[issueId]) issuesIds = [
                ...issuesIds,
                ...$affbcffbecf7083a$export$1945e9d463a28215({
                    issue: issue,
                    childrenItems: childrenItems
                })
            ];
        });
        return issuesIds;
    };
});
parcelRegister("3fU11", function(module, exports) {
    $parcel$export(module.exports, "useColumnWidths", ()=>$956c71744ece40c4$export$d598237875812773);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $3sQ5x;
    var $iXqE5;
    var $5bGaW;
    const $956c71744ece40c4$export$86880b4b2e1a2384 = 'column.widths';
    const $956c71744ece40c4$var$actions = {
        setColumnWidth: (columnKey, width)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const { columnsWidths: columnsWidths, storageKey: storageKey } = state;
                if (storageKey == null) return;
                const newState = {
                    ...state,
                    columnsWidths: {
                        ...columnsWidths,
                        [columnKey]: width
                    }
                };
                (0, (0, parcelRequire("5bGaW")).localStorage).set(storageKey, newState.columnsWidths);
                setState(newState);
            },
        initState: (projectKey)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                if (state.storageKey != null) return;
                const storageKey = `${projectKey}-${$956c71744ece40c4$export$86880b4b2e1a2384}`;
                setState({
                    ...state,
                    storageKey: storageKey,
                    columnsWidths: (0, (0, parcelRequire("5bGaW")).localStorage).get(storageKey) || {}
                });
            }
    };
    const $956c71744ece40c4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            storageKey: null,
            columnsWidths: {}
        },
        actions: $956c71744ece40c4$var$actions,
        name: 'JBusListViewColumnWidthStore'
    });
    const $956c71744ece40c4$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($956c71744ece40c4$var$Store);
    const $956c71744ece40c4$export$d598237875812773 = ()=>{
        const [{ columnsWidths: columnsWidths }, { setColumnWidth: setColumnWidth, initState: initState }] = $956c71744ece40c4$var$useHook();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        (0, $5uXOq.useEffect)(()=>{
            if (projectKey != null) initState(projectKey);
        }, [
            initState,
            projectKey
        ]);
        return [
            columnsWidths,
            {
                setColumnWidth: setColumnWidth
            }
        ];
    };
});
parcelRegister("5bGaW", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$443d62cf2aefea7c$export$c2ed3351cac403d1);
    var $bSSG7;
    const $443d62cf2aefea7c$export$74cea4b24a6bc9fa = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_list-view');
    const $443d62cf2aefea7c$export$c2ed3351cac403d1 = $443d62cf2aefea7c$export$74cea4b24a6bc9fa;
});
parcelRegister("8TUlY", function(module, exports) {
    $parcel$export(module.exports, "useIssueFields", ()=>$caa9955f3c0147ae$export$3dd4dc75e8b8fc8a);
    $parcel$export(module.exports, "UpdateFieldsDetail", ()=>$caa9955f3c0147ae$export$fc1188611b218081);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $kGsr8 = parcelRequire("kGsr8");
    var $8QpSo;
    var $1T2vX;
    var $6eSqc;
    var $jcw0u;
    var $4R6GH;
    var $5fc53;
    var $lt1LT;
    var $avVp3;
    var $4yxtN;
    const $caa9955f3c0147ae$var$fieldIdsToQuery = [
        'rank',
        'parent'
    ];
    const $caa9955f3c0147ae$var$buildListOfAvailableFields = (0, (0, parcelRequire("8QpSo")).default)((fields, constants)=>fields.concat(constants.MISSING_FIELDS).filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field.type ?? '')).sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '')), (0, ($parcel$interopDefault($ajpes))));
    const $caa9955f3c0147ae$var$getSortedAvailableFields = (0, (0, parcelRequire("8QpSo")).default)((availableFields, fieldsOrder, constants)=>availableFields.sort((a, b)=>{
            const aFieldsOrderIdx = a?.type && (0, (0, parcelRequire("lt1LT")).DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(a?.type) ? fieldsOrder.indexOf(a.type) : fieldsOrder.indexOf(a.id);
            const bFieldsOrderIdx = b?.type && (0, (0, parcelRequire("lt1LT")).DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(b?.type) ? fieldsOrder.indexOf(b.type) : fieldsOrder.indexOf(b.id);
            if (aFieldsOrderIdx === -1 || bFieldsOrderIdx === -1) {
                if (aFieldsOrderIdx !== -1) return -1;
                if (bFieldsOrderIdx !== -1) return 1;
                return constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '');
            }
            return aFieldsOrderIdx - bFieldsOrderIdx;
        }));
    const $caa9955f3c0147ae$export$3dd4dc75e8b8fc8a = ()=>{
        const constants = (0, (0, parcelRequire("lt1LT")).useConstants)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const availableFields = $caa9955f3c0147ae$var$buildListOfAvailableFields(data.fields, constants);
        const { fields: { order: order, details: details }, toggleField: toggleField, reorderFields: reorderFields, resetCache: resetCache } = (0, (0, parcelRequire("avVp3")).useFieldsActions)(!loading && error == null ? availableFields : null);
        const getAvailableFields = (0, $5uXOq.useCallback)(()=>{
            try {
                return $caa9955f3c0147ae$var$getSortedAvailableFields(availableFields, order, constants);
            } catch (err) {
                resetCache && resetCache();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getAvailableFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to get available fields from cache'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                return $caa9955f3c0147ae$var$getSortedAvailableFields(availableFields, [], constants);
            }
        }, [
            availableFields,
            constants,
            order,
            resetCache
        ]);
        const shouldGetVisibleFieldsFromCache = (0, $5uXOq.useMemo)(()=>(loading || error != null) && details != null, [
            details,
            error,
            loading
        ]);
        const getVisibleFields = (0, $5uXOq.useCallback)(()=>{
            if (shouldGetVisibleFieldsFromCache) try {
                return order.map((id)=>details?.[id]).filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field?.type ?? ''));
            } catch (err) {
                resetCache && resetCache();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getVisibleFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to get visible fields from cache'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                return [];
            }
            return getAvailableFields().filter((field)=>constants.ALWAYS_VISIBLE_FIELDS.includes(field.id) || field.id != null && order.includes(field.id) || field.type !== undefined && order.includes(field.type));
        }, [
            shouldGetVisibleFieldsFromCache,
            getAvailableFields,
            order,
            details,
            constants.SUPPORTED_FIELD_TYPES,
            constants.ALWAYS_VISIBLE_FIELDS,
            resetCache
        ]);
        const getQueryFieldIds = (0, $5uXOq.useCallback)(()=>{
            if (loading) return [];
            let visibleFieldIds;
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) visibleFieldIds = getVisibleFields().filter((field)=>field.type !== (0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)).map((field)=>field.id === 'key' ? 'issuekey' : field.id).sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($caa9955f3c0147ae$var$fieldIdsToQuery);
            else visibleFieldIds = getVisibleFields().map((field)=>field.id === 'key' ? 'issuekey' : field.id).sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($caa9955f3c0147ae$var$fieldIdsToQuery);
            if (visibleFieldIds.includes('timeoriginalestimate') && !visibleFieldIds.includes('timetracking')) visibleFieldIds.splice(visibleFieldIds.indexOf('timeoriginalestimate'), 1, 'timetracking');
            const queryFieldIds = visibleFieldIds.filter((field)=>field !== 'commentsummary');
            return (0, ($parcel$interopDefault($kGsr8)))(queryFieldIds);
        }, [
            constants.SUPPORTED_FIELD_TYPES,
            getVisibleFields,
            loading
        ]);
        const { getQueryFieldIdsWithCache: getQueryFieldIdsWithCache } = (0, (0, parcelRequire("4yxtN")).useFieldsCache)({
            loading: loading,
            error: error,
            getQueryFieldIds: getQueryFieldIds
        });
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, (0, parcelRequire("6eSqc")).useHierarchyCache)({
            view: 'list'
        });
        const isParentFieldVisible = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.id === 'parent') : false, [
            getVisibleFields
        ]);
        const isDevSummaryFieldVisible = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.type === (0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)) : false, [
            getVisibleFields
        ]);
        return {
            constants: constants,
            toggleField: toggleField,
            getVisibleFields: getVisibleFields,
            getAvailableFields: getAvailableFields,
            getQueryFieldIds: getQueryFieldIdsWithCache,
            isParentFieldVisible: isParentFieldVisible,
            isDevSummaryFieldVisible: isDevSummaryFieldVisible,
            hierarchyLevelsWithCache: hierarchyLevelsWithCache,
            reorderFields: reorderFields,
            fieldsOrder: order,
            isVisibleFieldsCached: shouldGetVisibleFieldsFromCache,
            loading: loading,
            error: error
        };
    };
    const $caa9955f3c0147ae$export$fc1188611b218081 = ()=>{
        const constants = (0, (0, parcelRequire("lt1LT")).useConstants)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const availableFields = $caa9955f3c0147ae$var$buildListOfAvailableFields(data.fields, constants);
        (0, (0, parcelRequire("avVp3")).useUpdateFieldsDetail)(!loading && error == null ? availableFields : null);
        return null;
    };
});
parcelRegister("6eSqc", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyCache", ()=>$bd31eaa7cf3733ec$export$c2cd1510e81d00ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $1T2vX;
    var $ae0ja;
    const $bd31eaa7cf3733ec$export$c2cd1510e81d00ce = ({ view: view })=>{
        const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const localStorage = (0, (0, parcelRequire("ae0ja")).getLocalStorage)(view);
        const hierarchyStorageKey = `${entity.id}_${(0, $17d9937555b623d9$export$2cab30374aa79c41)}`;
        const [hierarchyLevels, setHierarchyLevels] = (0, $5uXOq.useState)(localStorage.get(hierarchyStorageKey));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !error) {
                if (!(0, ($parcel$interopDefault($ajpes)))(hierarchyLevels, newHierarchyLevels)) {
                    setHierarchyLevels(newHierarchyLevels);
                    localStorage.set(hierarchyStorageKey, newHierarchyLevels);
                }
            }
        }, [
            loading,
            error,
            hierarchyLevels,
            hierarchyStorageKey,
            setHierarchyLevels,
            localStorage,
            newHierarchyLevels
        ]);
        const hierarchyLevelsWithCache = (0, $5uXOq.useMemo)(()=>{
            if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
            if (loading) return [];
            return newHierarchyLevels;
        }, [
            hierarchyLevels,
            loading,
            newHierarchyLevels
        ]);
        return {
            hierarchyLevelsWithCache: hierarchyLevelsWithCache
        };
    };
});
const $17d9937555b623d9$export$2cab30374aa79c41 = 'hierarchy_levels';
parcelRegister("ae0ja", function(module, exports) {
    $parcel$export(module.exports, "getLocalStorage", ()=>$d865db96ae8c3b63$export$d3720feff416e85b);
    var $bSSG7;
    const $d865db96ae8c3b63$export$d3720feff416e85b = (view)=>(0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)(`jira_business_${view}-view`);
});
parcelRegister("lt1LT", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CUSTOM_FIELDS_BY_TYPE", ()=>$41419a4f7af35dcb$export$5150e2d13825462d);
    $parcel$export(module.exports, "getInitVisibleFields", ()=>$41419a4f7af35dcb$export$86172108eb1873dd);
    $parcel$export(module.exports, "getAlwaysVisibleFields", ()=>$41419a4f7af35dcb$export$de476ed52b559d9);
    $parcel$export(module.exports, "useConstants", ()=>$41419a4f7af35dcb$export$eedf91b09a0fe0d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $imVeH;
    var $hE5wF;
    var $daQYX;
    var $7q7Al;
    var $4R6GH;
    var $koVbs;
    var $5fc53;
    var $4nnGr;
    var $dwwxm;
    const $41419a4f7af35dcb$export$5150e2d13825462d = [
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)
    ];
    const $41419a4f7af35dcb$export$86172108eb1873dd = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>[
            (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
            'key',
            (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
            isCategoryEnabled ? (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE) : undefined,
            isScrumProject ? (0, (0, parcelRequire("5fc53")).SPRINT_TYPE) : undefined,
            (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
            (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
            (0, (0, parcelRequire("5fc53")).CREATED),
            (0, (0, parcelRequire("5fc53")).UPDATED),
            (0, (0, parcelRequire("5fc53")).REPORTER_TYPE)
        ].filter(Boolean);
    const $41419a4f7af35dcb$export$db265ae985088fd7 = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>({
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: true,
            key: true,
            [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: true,
            [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: true,
            ...isCategoryEnabled ? {
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: true
            } : {},
            ...isScrumProject ? {
                [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: true
            } : {},
            [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: true,
            [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: true,
            [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: true,
            [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: true,
            [(0, (0, parcelRequire("5fc53")).CREATED)]: true,
            [(0, (0, parcelRequire("5fc53")).UPDATED)]: true,
            [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: true
        });
    const $41419a4f7af35dcb$export$de476ed52b559d9 = ()=>[
            (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
            'key',
            (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)
        ];
    const $41419a4f7af35dcb$export$e4330d77fd93d1de = ({ defaultVisibleFields: defaultVisibleFields, hasConfluence: hasConfluence = false, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled = false, isBusinessFieldsEnabled: isBusinessFieldsEnabled = true, isTeamManaged: isTeamManaged = true, isScrumProject: isScrumProject = false } = {})=>Object.keys(defaultVisibleFields ?? $41419a4f7af35dcb$export$db265ae985088fd7({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        })).concat([
            (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE),
            (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
            (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE)
        ]).concat(isSoftwareFieldsEnabled && isTeamManaged ? [
            (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)
        ] : []).concat(isSoftwareFieldsEnabled && !isTeamManaged ? [
            (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)
        ] : []).concat(isSoftwareFieldsEnabled && !isScrumProject ? [
            (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)
        ] : []).concat(hasConfluence ? [
            (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)
        ] : []).concat((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? (0, (0, parcelRequire("7q7Al")).getSupportedFieldTypes)(isSoftwareFieldsEnabled) : []);
    const $41419a4f7af35dcb$export$c7b8f0505fa10763 = (hasConfluence)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, $5uXOq.useMemo)(()=>[
                {
                    id: 'key',
                    type: 'key',
                    name: formatMessage((0, (0, parcelRequire("dwwxm")).default).key),
                    issueTypes: [],
                    fieldConfig: {
                        isRequired: true,
                        isEditable: false
                    }
                },
                {
                    id: (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE),
                    type: (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE),
                    name: formatMessage((0, (0, parcelRequire("dwwxm")).default).comments),
                    issueTypes: [],
                    fieldConfig: {
                        isRequired: true,
                        isEditable: false
                    }
                },
                ...hasConfluence ? [
                    {
                        id: (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE),
                        type: (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE),
                        name: formatMessage((0, (0, parcelRequire("dwwxm")).default).confluencePages),
                        issueTypes: [],
                        fieldConfig: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? {
                            isRequired: false,
                            isEditable: true
                        } : {
                            isRequired: true,
                            isEditable: false
                        }
                    }
                ] : []
            ], [
            formatMessage,
            hasConfluence
        ]);
    };
    const $41419a4f7af35dcb$export$eedf91b09a0fe0d1 = ()=>{
        const hasConfluence = (0, (0, parcelRequire("imVeH")).useTenantHasConfluence)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isTeamManaged = projectData.isSimplified;
        const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled, isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const missingFields = $41419a4f7af35dcb$export$c7b8f0505fa10763(hasConfluence);
        return (0, $5uXOq.useMemo)(()=>{
            const defaultVisibleFields = $41419a4f7af35dcb$export$db265ae985088fd7({
                isCategoryEnabled: isBusinessFieldsEnabled,
                isScrumProject: isScrumProject
            });
            const alwaysVisibleFields = $41419a4f7af35dcb$export$de476ed52b559d9();
            const supportedFieldTypes = $41419a4f7af35dcb$export$e4330d77fd93d1de({
                defaultVisibleFields: defaultVisibleFields,
                hasConfluence: hasConfluence,
                isSoftwareFieldsEnabled: isSoftwareFieldsEnabled,
                isBusinessFieldsEnabled: isBusinessFieldsEnabled,
                isTeamManaged: isTeamManaged,
                isScrumProject: isScrumProject
            });
            return {
                DEFAULT_VISIBLE_FIELDS: defaultVisibleFields,
                ALWAYS_VISIBLE_FIELDS: alwaysVisibleFields,
                SUPPORTED_FIELD_TYPES: supportedFieldTypes,
                MISSING_FIELDS: missingFields
            };
        }, [
            isBusinessFieldsEnabled,
            hasConfluence,
            isSoftwareFieldsEnabled,
            isTeamManaged,
            isScrumProject,
            missingFields
        ]);
    };
});
parcelRegister("7q7Al", function(module, exports) {
    $parcel$export(module.exports, "getSupportedFieldTypes", ()=>$06a9162b5061f29f$export$e4330d77fd93d1de);
    $parcel$export(module.exports, "newInitVisibleFields", ()=>$06a9162b5061f29f$export$e8fa0cca823ce465);
    $parcel$export(module.exports, "isSupportedTypePredicated", ()=>$06a9162b5061f29f$export$6868d04e3954dca5);
    $parcel$export(module.exports, "getTopLevelFieldKey", ()=>$06a9162b5061f29f$export$5a7b6a57d325d92);
    $parcel$export(module.exports, "isTopLevelField", ()=>$06a9162b5061f29f$export$9ce71a7c226d8918);
    var $8QpSo;
    var $4R6GH;
    var $5fc53;
    var $fDZ77;
    var $733SL;
    var $8FNbi;
    var $ekKiJ;
    var $7cLw1;
    var $k7N5y;
    var $cyODY;
    var $8WpsQ;
    var $3dSsD;
    var $fQVSU;
    var $8g1d0;
    const $06a9162b5061f29f$export$e4330d77fd93d1de = (0, (0, parcelRequire("8QpSo")).default)((isSoftwareFieldsEnabled)=>[
            ...(0, (0, parcelRequire("7cLw1")).parentSupportedTypes),
            ...(0, (0, parcelRequire("fQVSU")).teamSupportedTypes),
            ...(0, (0, parcelRequire("8WpsQ")).resolutionSupportedTypes),
            ...(0, (0, parcelRequire("ekKiJ")).groupSupportedTypes),
            ...(0, (0, parcelRequire("3dSsD")).statusCategorySupportedTypes),
            ...(0, (0, parcelRequire("k7N5y")).projectSupportedTypes),
            ...(0, (0, parcelRequire("fDZ77")).cascadingSelectSupportedTypes),
            ...(0, (0, parcelRequire("cyODY")).radioSelectSupportedTypes),
            ...(0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? (0, (0, parcelRequire("8FNbi")).goalsSupportedTypes) : [],
            ...isSoftwareFieldsEnabled ? [
                ...(0, (0, parcelRequire("733SL")).devSummarySupportedTypes),
                ...(0, (0, parcelRequire("8g1d0")).versionSupportedTypes)
            ] : []
        ]);
    const $06a9162b5061f29f$export$e8fa0cca823ce465 = (0, (0, parcelRequire("8QpSo")).default)((isSoftwareFieldsEnabled)=>[
            ...(0, (0, parcelRequire("7cLw1")).parentSupportedTypes),
            ...(0, (0, parcelRequire("fQVSU")).teamSupportedTypes),
            ...isSoftwareFieldsEnabled ? [
                (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE),
                ...(0, (0, parcelRequire("733SL")).devSummarySupportedTypes)
            ] : []
        ]);
    const $06a9162b5061f29f$export$6868d04e3954dca5 = (fieldType, isSoftwareFieldsEnabled = true)=>$06a9162b5061f29f$export$e4330d77fd93d1de(isSoftwareFieldsEnabled).includes(fieldType);
    const $06a9162b5061f29f$var$TOP_LEVEL_FIELD = [
        ...(0, (0, parcelRequire("733SL")).devSummarySupportedTypes)
    ];
    const $06a9162b5061f29f$var$isValidTopFieldType = (typename)=>true;
    const $06a9162b5061f29f$export$5a7b6a57d325d92 = (fieldType)=>{
        if (!fieldType || !$06a9162b5061f29f$var$isValidTopFieldType(fieldType)) return null;
        if ((0, (0, parcelRequire("733SL")).devSummarySupportedTypes).includes(fieldType)) return 0, $677cd2eb13864f6c$export$72b5bd2391f1e7c0;
        return null;
    };
    const $06a9162b5061f29f$export$9ce71a7c226d8918 = (fieldType)=>{
        if (!fieldType || !$06a9162b5061f29f$var$isValidTopFieldType(fieldType)) return false;
        return $06a9162b5061f29f$var$TOP_LEVEL_FIELD.includes(fieldType);
    };
});
parcelRegister("fDZ77", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectSupportedTypes", ()=>$5bd2fe36390d1f16$export$caf76d0a4f04f1d);
    var $5fc53;
    const $5bd2fe36390d1f16$export$caf76d0a4f04f1d = [
        (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)
    ];
});
const $677cd2eb13864f6c$export$72b5bd2391f1e7c0 = 'devSummary';
parcelRegister("733SL", function(module, exports) {
    $parcel$export(module.exports, "devSummarySupportedTypes", ()=>$02845184c1eb8060$export$22d58d85f8d7faea);
    var $5fc53;
    const $02845184c1eb8060$export$22d58d85f8d7faea = [
        (0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)
    ];
});
parcelRegister("8FNbi", function(module, exports) {
    $parcel$export(module.exports, "goalsSupportedTypes", ()=>$470c8570b6d1341d$export$bc170bcdefb8333f);
    var $5fc53;
    const $470c8570b6d1341d$export$bc170bcdefb8333f = [
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)
    ];
});
parcelRegister("ekKiJ", function(module, exports) {
    $parcel$export(module.exports, "groupSupportedTypes", ()=>$114ec89a4fb2dc61$export$f3ef0b84bd022156);
    var $5fc53;
    const $114ec89a4fb2dc61$export$f3ef0b84bd022156 = [
        (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)
    ];
});
parcelRegister("7cLw1", function(module, exports) {
    $parcel$export(module.exports, "parentSupportedTypes", ()=>$c5fb36828627f566$export$cc8590a96c2280c);
    var $5fc53;
    const $c5fb36828627f566$export$cc8590a96c2280c = [
        (0, (0, parcelRequire("5fc53")).PARENT_TYPE)
    ];
});
parcelRegister("k7N5y", function(module, exports) {
    $parcel$export(module.exports, "projectSupportedTypes", ()=>$017f46c4670101d3$export$ecab9c2d3c8390e9);
    var $5fc53;
    const $017f46c4670101d3$export$ecab9c2d3c8390e9 = [
        (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)
    ];
});
parcelRegister("cyODY", function(module, exports) {
    $parcel$export(module.exports, "radioSelectSupportedTypes", ()=>$d22f5b68d5f35a42$export$a92ad538b45df386);
    var $5fc53;
    const $d22f5b68d5f35a42$export$a92ad538b45df386 = [
        (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)
    ];
});
parcelRegister("8WpsQ", function(module, exports) {
    $parcel$export(module.exports, "resolutionSupportedTypes", ()=>$ee0e811848af2dc6$export$89876769ad40213e);
    var $5fc53;
    const $ee0e811848af2dc6$export$89876769ad40213e = [
        (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)
    ];
});
parcelRegister("3dSsD", function(module, exports) {
    $parcel$export(module.exports, "statusCategorySupportedTypes", ()=>$d093394df406eef3$export$ce1a6f07ee0c2fd4);
    var $5fc53;
    const $d093394df406eef3$export$ce1a6f07ee0c2fd4 = [
        (0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)
    ];
});
parcelRegister("fQVSU", function(module, exports) {
    $parcel$export(module.exports, "teamSupportedTypes", ()=>$9c5d2ff9e9ba22cf$export$7fe9ceb0183f4a3e);
    var $5fc53;
    const $9c5d2ff9e9ba22cf$export$7fe9ceb0183f4a3e = [
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)
    ];
});
parcelRegister("8g1d0", function(module, exports) {
    $parcel$export(module.exports, "versionSupportedTypes", ()=>$c4377a5f6bed15e4$export$c35776c44a9e8a18);
    var $5fc53;
    const $c4377a5f6bed15e4$export$c35776c44a9e8a18 = [
        (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE),
        (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)
    ];
});
parcelRegister("dwwxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b0f17238a94f2d5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3b0f17238a94f2d5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        key: {
            "id": "business-list.controllers.get-issue-fields.constants.key",
            "defaultMessage": "Key"
        },
        comments: {
            "id": "business-list.controllers.get-issue-fields.constants.comments",
            "defaultMessage": "Comments"
        },
        confluencePages: {
            "id": "business-list.controllers.get-issue-fields.constants.confluence-pages",
            "defaultMessage": "Confluence pages"
        }
    });
});
parcelRegister("avVp3", function(module, exports) {
    $parcel$export(module.exports, "useUpdateFieldsDetail", ()=>$351f74ddc29ec171$export$33428c970fa4bad3);
    $parcel$export(module.exports, "useFieldsActions", ()=>$351f74ddc29ec171$export$4027818e87c46ba5);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $7q7Al;
    var $jcw0u;
    var $4R6GH;
    var $5bGaW;
    var $4nnGr;
    var $gEb1A;
    var $lt1LT;
    var $drIRL;
    const $351f74ddc29ec171$var$getFieldsCache = ({ availableFields: availableFields, fields: fields, order: order })=>{
        if (availableFields == null) return fields.details;
        const newDetails = {};
        availableFields.forEach(({ id: id, name: name, type: type })=>{
            if (order.includes(id)) newDetails[id] = {
                id: id,
                name: name,
                type: type
            };
            else if (type != null && order.includes(type)) newDetails[type] = {
                id: id,
                name: name,
                type: type
            };
        });
        return newDetails;
    };
    const $351f74ddc29ec171$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY = 'list_new_fields_onboarding';
    const $351f74ddc29ec171$export$33428c970fa4bad3 = (availableFields)=>{
        const [fields, setFields] = (0, (0, parcelRequire("drIRL")).useFieldsPreference)();
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const { isScrumProject: isScrumProject } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const newFieldsOnboardingStorageKey = `${entity.id}_${$351f74ddc29ec171$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY}`;
        (0, $5uXOq.useEffect)(()=>{
            if (availableFields != null) {
                const isOnboardingDone = (0, (0, parcelRequire("5bGaW")).localStorage).get(newFieldsOnboardingStorageKey);
                if (!isOnboardingDone && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                    const newFields = availableFields.filter((field)=>field.type && (0, (0, parcelRequire("7q7Al")).isSupportedTypePredicated)(field.type, isScrumProject) ? (0, (0, parcelRequire("7q7Al")).newInitVisibleFields)(isScrumProject).includes(field.type) : false).map((field)=>field.id);
                    const newFieldsOrder = [
                        ...fields.order,
                        ...newFields
                    ];
                    setFields({
                        order: newFieldsOrder,
                        details: $351f74ddc29ec171$var$getFieldsCache({
                            availableFields: availableFields,
                            fields: fields,
                            order: newFieldsOrder
                        })
                    });
                    (0, (0, parcelRequire("5bGaW")).localStorage).set(newFieldsOnboardingStorageKey, true);
                } else setFields({
                    order: fields.order,
                    details: $351f74ddc29ec171$var$getFieldsCache({
                        order: fields.order,
                        fields: fields,
                        availableFields: availableFields
                    })
                });
            }
        }, [
            availableFields,
            newFieldsOnboardingStorageKey
        ]);
    };
    const $351f74ddc29ec171$export$4027818e87c46ba5 = (availableFields)=>{
        const [fields, setFields, setFieldsOld] = (0, (0, parcelRequire("drIRL")).useFieldsPreference)();
        const [{ createIndex: createIndex, createFields: createFields }] = (0, (0, parcelRequire("gEb1A")).useInlineFieldCreateControls)();
        const resetCache = (0, $5uXOq.useCallback)(()=>{
            setFields(undefined);
            setFieldsOld(undefined);
        }, [
            setFields,
            setFieldsOld
        ]);
        const reorderFields = (0, $5uXOq.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
            try {
                if (oldIndex === newIndex) return;
                let oldFieldIndex = oldIndex;
                let newFieldIndex = newIndex;
                if (newFieldIndex < 3) return;
                oldFieldIndex -= 1;
                newFieldIndex -= 1;
                const reorderedFields = [
                    ...visibleFields
                ];
                const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
                reorderedFields.splice(newFieldIndex, 0, reorderedField);
                const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, (0, parcelRequire("lt1LT")).DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
                setFields({
                    ...fields,
                    order: fieldsOrder
                });
            } catch (error) {
                resetCache();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'reorderFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to reorder the fields'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            fields,
            resetCache,
            setFields
        ]);
        const toggleField = (0, $5uXOq.useCallback)((fieldId)=>{
            try {
                const isVisible = fields.order.includes(fieldId);
                const newFieldsOrder = [
                    ...fields.order
                ];
                let createColumnIndex = createIndex;
                if (createFields) {
                    const createField = createFields.find((f)=>f.fieldId === fieldId);
                    createColumnIndex = createField?.createIndex ?? createColumnIndex;
                }
                if (!isVisible) {
                    if (typeof createColumnIndex !== 'undefined') newFieldsOrder.splice(createColumnIndex, 0, fieldId);
                    else newFieldsOrder.push(fieldId);
                } else {
                    const fieldIndex = newFieldsOrder.findIndex((fId)=>fId === fieldId);
                    if (fieldIndex >= 0) newFieldsOrder.splice(fieldIndex, 1);
                }
                setFields({
                    order: newFieldsOrder,
                    details: $351f74ddc29ec171$var$getFieldsCache({
                        availableFields: availableFields,
                        fields: fields,
                        order: newFieldsOrder
                    })
                });
            } catch (error) {
                resetCache();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'toggleFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to toogle a field'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            fields,
            createIndex,
            createFields,
            setFields,
            availableFields,
            resetCache
        ]);
        return {
            fields: fields,
            toggleField: toggleField,
            reorderFields: reorderFields,
            resetCache: resetCache
        };
    };
});
parcelRegister("gEb1A", function(module, exports) {
    $parcel$export(module.exports, "useInlineFieldCreateControls", ()=>$a0cf18d02e0a77bd$export$d98d27d7d9c6b61f);
    var $3sQ5x;
    var $iXqE5;
    const $a0cf18d02e0a77bd$var$actions = {
        setIsSelected: (isSelected)=>({ setState: setState })=>{
                setState({
                    isSelected: isSelected
                });
            },
        setCreateIndex: (columnIndex)=>({ setState: setState })=>{
                setState({
                    createIndex: columnIndex !== undefined ? columnIndex + 1 : undefined
                });
            },
        clearCreateIndex: ()=>({ setState: setState })=>{
                setState({
                    createIndex: undefined
                });
            },
        addCreateField: ({ fieldId: fieldId, name: name, type: type })=>({ setState: setState, getState: getState })=>{
                setState({
                    createFields: [
                        ...getState().createFields,
                        {
                            fieldId: fieldId,
                            name: name,
                            type: type,
                            createIndex: getState().createIndex
                        }
                    ]
                });
            },
        removeCreateField: (fieldId)=>({ setState: setState, getState: getState })=>{
                setState({
                    createFields: [
                        ...getState().createFields.filter((field)=>field.fieldId !== fieldId)
                    ]
                });
            }
    };
    const $a0cf18d02e0a77bd$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isSelected: false,
            createIndex: undefined,
            createFields: []
        },
        actions: $a0cf18d02e0a77bd$var$actions,
        name: 'JwmListInlineFieldCreate'
    });
    const $a0cf18d02e0a77bd$export$d98d27d7d9c6b61f = (0, (0, parcelRequire("3sQ5x")).createHook)($a0cf18d02e0a77bd$var$Store);
});
parcelRegister("drIRL", function(module, exports) {
    $parcel$export(module.exports, "useFieldsPreference", ()=>$6d00c670b20c3715$export$46ce869a6df40a8b);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $4nnGr;
    var $lt1LT;
    const $6d00c670b20c3715$export$46ce869a6df40a8b = ()=>{
        const [fields, setFieldsOld] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FIELDS_PREFERENCE));
        const [fieldsDetail, setFields] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FIELDS_DETAIL_PREFERENCE));
        const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const fieldsPreferences = (0, $5uXOq.useMemo)(()=>{
            if (fieldsDetail == null && fields != null) return {
                order: fields,
                details: null
            };
            if (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) return {
                order: (0, (0, parcelRequire("lt1LT")).getInitVisibleFields)({
                    isCategoryEnabled: isBusinessFieldsEnabled,
                    isScrumProject: isScrumProject
                }),
                details: null
            };
            return fieldsDetail;
        }, [
            fieldsDetail,
            fields,
            isBusinessFieldsEnabled,
            isScrumProject
        ]);
        return [
            fieldsPreferences,
            setFields,
            setFieldsOld
        ];
    };
});
parcelRegister("4yxtN", function(module, exports) {
    $parcel$export(module.exports, "useFieldsCache", ()=>$8364c6e8a86b2f99$export$2fa1686d7312ac20);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $5bGaW;
    const $8364c6e8a86b2f99$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY = 'query_fields_id';
    const $8364c6e8a86b2f99$export$2fa1686d7312ac20 = ({ loading: loading, error: error, getQueryFieldIds: getQueryFieldIds })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const queryFieldsStorageKey = `${entity.id}_${$8364c6e8a86b2f99$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY}`;
        const [queryFieldIds, setQueryFieldsIds] = (0, $5uXOq.useState)((0, (0, parcelRequire("5bGaW")).localStorage).get(queryFieldsStorageKey));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !error) {
                const newQueryFieldIds = getQueryFieldIds();
                if (!(0, ($parcel$interopDefault($ajpes)))(queryFieldIds, newQueryFieldIds)) {
                    setQueryFieldsIds(newQueryFieldIds);
                    (0, (0, parcelRequire("5bGaW")).localStorage).set(queryFieldsStorageKey, newQueryFieldIds);
                }
            }
        }, [
            loading,
            error,
            getQueryFieldIds,
            queryFieldsStorageKey,
            queryFieldIds,
            setQueryFieldsIds
        ]);
        const getQueryFieldIdsWithCache = (0, $5uXOq.useCallback)(()=>{
            if (queryFieldIds && Array.isArray(queryFieldIds)) return queryFieldIds;
            if (loading) return [];
            return getQueryFieldIds();
        }, [
            getQueryFieldIds,
            loading,
            queryFieldIds
        ]);
        return {
            getQueryFieldIdsWithCache: getQueryFieldIdsWithCache
        };
    };
});
parcelRegister("5HTKY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da0cd9ca4631d484$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $da0cd9ca4631d484$var$GroupUpdater = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fZ6hq")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/controllers/group-updater/main.tsx"
    });
    var $da0cd9ca4631d484$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-group-updater",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($da0cd9ca4631d484$var$GroupUpdater, props));
});
parcelRegister("fZ6hq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jvilT").then(()=>parcelRequire('a1ET1'));
});
parcelRegister("gijCE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2667eebc48b622e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8e3Yw;
    var $ayaYc;
    var $jahNX;
    var $aKtkc;
    const $e2667eebc48b622e$var$Hierarchy = ()=>{
        const { childrenLoader: childrenLoader } = (0, (0, parcelRequire("ayaYc")).useChildrenLoader)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const childItemsLoader = (0, $5uXOq.useMemo)(()=>childrenLoader, [
            childrenLoader
        ]);
        const shouldGroupItems = groupByFieldId != null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, shouldGroupItems ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jahNX")).default), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKtkc")).default), null), childItemsLoader);
    };
    var $e2667eebc48b622e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e2667eebc48b622e$var$Hierarchy);
});
parcelRegister("ayaYc", function(module, exports) {
    $parcel$export(module.exports, "useChildrenLoader", ()=>$6ac6c3206164d3b9$export$10e8857fe2182cb4);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $deqCE;
    var $jDUax;
    var $fel5A;
    var $eSwsD;
    var $9u99d;
    var $8Ugqh;
    const $6ac6c3206164d3b9$export$10e8857fe2182cb4 = ()=>{
        const [{ expandedItems: expandedItems, childrenItems: childrenItems, issuesMap: issuesMap }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { data: data } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { setChildrenItems: setChildrenItems } = (0, (0, parcelRequire("8Ugqh")).useSetChildrenItems)();
        const getHierarchyLevel = (0, $5uXOq.useCallback)((issueId)=>{
            const maybeIssue = issuesMap.get(issueId);
            if (!maybeIssue) return undefined;
            const maybeIssueTypeData = data.issueTypes.find((issueType)=>issueType.id === maybeIssue.issuetype.id);
            if (!maybeIssueTypeData) return undefined;
            return maybeIssueTypeData.hierarchyLevel;
        }, [
            data.issueTypes,
            issuesMap
        ]);
        const childrenLoader = (0, $5uXOq.useMemo)(()=>{
            const expandedItemIssueIds = Object.keys(expandedItems).filter((issueId)=>!(0, (0, parcelRequire("jDUax")).isGroupItem)(issueId) && String(issueId) !== String((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ISSUE_ID)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fel5A")).ChildrenController), {
                expandedItemIssueIds: expandedItemIssueIds,
                loadingIssueIds: expandedItemIssueIds.filter((expandedItemId)=>!childrenItems[expandedItemId] || childrenItems[expandedItemId].loading),
                setChildrenQueryData: setChildrenItems,
                ChildQueryController: (0, (0, parcelRequire("eSwsD")).ListViewChildQueryController),
                getHierarchyLevel: getHierarchyLevel
            });
        }, [
            expandedItems,
            setChildrenItems,
            getHierarchyLevel,
            childrenItems
        ]);
        return {
            childrenLoader: childrenLoader
        };
    };
});
parcelRegister("fel5A", function(module, exports) {
    $parcel$export(module.exports, "ChildrenController", ()=>$0a07eaf715c6ad45$export$8c3512dd18e9e8f);
    var $5uXOq = parcelRequire("5uXOq");
    const $0a07eaf715c6ad45$export$8c3512dd18e9e8f = (0, $5uXOq.memo)(({ expandedItemIssueIds: expandedItemIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, getHierarchyLevel: getHierarchyLevel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, expandedItemIssueIds.map((expandedItemIssueId)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ChildQueryController, {
                parentIssueId: expandedItemIssueId,
                parentHierarchyType: (0, $8debe7dace56daea$export$9355e489ad16f98e),
                parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
                onDataChange: setChildrenQueryData,
                key: expandedItemIssueId
            }))), (prevProps, nextProps)=>{
        const prevIssueIds = prevProps.expandedItemIssueIds.sort();
        const nextIssueIds = nextProps.expandedItemIssueIds.sort();
        const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
        const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
        let loadingIssuesMatch = true;
        if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
        else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
        return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
    });
});
parcelRegister("eSwsD", function(module, exports) {
    $parcel$export(module.exports, "ListViewChildQueryController", ()=>$206788a0341995dd$export$fffae14cb4664bb4);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $kRkJF;
    var $9SwwX;
    var $8tf7c;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $h7hV2;
    var $8TUlY;
    var $dC9wp;
    const $206788a0341995dd$export$fffae14cb4664bb4 = (0, $5uXOq.memo)(({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const onComplete = (0, $5uXOq.useCallback)((responseData)=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'listChildrenData fetched', {
                totalChildren: (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(responseData, 'list')?.edges?.length,
                parentIssueId: parentIssueId,
                hierarchyLevel: parentHierarchyLevel
            });
        }, [
            createAnalyticsEvent,
            parentHierarchyLevel,
            parentIssueId
        ]);
        const { data: data, error: error, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage, loading: loading, loadNextPage: loadNextPage } = (0, (0, parcelRequire("h7hV2")).useListViewIssues)({
            input: {
                jqlContext: jqlContext,
                fieldIds: getQueryFieldIds(),
                quickFiltersJql: quickFiltersJql,
                parentIssue: {
                    hierarchyType: parentHierarchyType,
                    hierarchyLevel: parentHierarchyLevel,
                    issueId: parentIssueId
                },
                sorting: sorting,
                isHidingDoneItems: isHidingDoneItems,
                isParentFieldVisible: isParentFieldVisible(),
                isDevSummaryFieldVisible: isDevSummaryFieldVisible()
            },
            condition: !isLoadingFields,
            onComplete: onComplete
        });
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("eTDjN")).LOAD_CHILDREN_EXPERIENCE), {
            loading: loading,
            error: error,
            shouldStartExperience: true
        });
        (0, $5uXOq.useEffect)(()=>{
            onDataChange(parentIssueId, {
                data: data,
                error: error,
                hasNextPage: hasNextPage,
                isLoadingNextPage: isLoadingNextPage,
                loading: loading,
                loadNextPage: loadNextPage
            });
        }, [
            data,
            error,
            hasNextPage,
            isLoadingNextPage,
            loading,
            loadNextPage,
            onDataChange,
            parentIssueId
        ]);
        return error ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tf7c")).ErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("dC9wp")).default).errorTitle,
            description: (0, (0, parcelRequire("dC9wp")).default).errorMessage
        }) : null;
    });
});
parcelRegister("9SwwX", function(module, exports) {
    $parcel$export(module.exports, "useFetchMore", ()=>$0f8617a70c5d6b6c$export$d84f34af2f3f5d9f);
    $parcel$export(module.exports, "getAGGCompliantData", ()=>$0f8617a70c5d6b6c$export$5a178cf599565b50);
    var $5tTFS;
    var $e3a3O;
    var $8Qi2I;
    var $c9Ur7;
    var $fPruT;
    function $0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
        const variablesWithAfter = {
            ...variables,
            after: after
        };
        return client.query({
            query: query,
            variables: variablesWithAfter,
            fetchPolicy: 'no-cache',
            errorPolicy: errorPolicy
        }).then((response)=>{
            if (!response) return;
            if (response.errors) {
                onError && onError(new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: response.errors
                }));
                if (errorPolicy === 'none') return;
            }
            if (response.data == null) return;
            const prevData = client.readQuery({
                query: query,
                variables: variables
            });
            if (prevData == null) return;
            const newData = updateQuery(prevData, {
                fetchMoreResult: response.data,
                variables: variablesWithAfter
            });
            client.writeQuery({
                query: query,
                variables: variables,
                notifyOnNetworkStatusChange: true,
                data: newData
            });
        }).catch((err)=>{
            onError && onError(err);
        });
    }
    function $0f8617a70c5d6b6c$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, (0, parcelRequire("8Qi2I")).useDeepMemo)(()=>(options)=>$0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({
                    ...options,
                    variables: variables,
                    query: query,
                    client: client
                }), [
            client,
            variables,
            query
        ]);
    }
    function $0f8617a70c5d6b6c$export$5a178cf599565b50(data, listName, onError) {
        if (listName && data?.jira?.[listName]) {
            const _data = data.jira[listName];
            if (_data?.__typename === 'QueryError') {
                const queryError = new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
                if (queryError.extensions?.find((ex)=>ex.statusCode === 401)) throw new (0, (0, parcelRequire("fPruT")).AuthenticationError)(_data.message);
                if (onError) {
                    onError(_data);
                    return undefined;
                }
                throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
            }
            return _data;
        }
        return undefined;
    }
});
parcelRegister("8Qi2I", function(module, exports) {
    $parcel$export(module.exports, "useDeepMemo", ()=>$5b0bf94477e3396a$export$722debc0e56fea39);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $5b0bf94477e3396a$export$722debc0e56fea39 = (memoFn, deps)=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, ($parcel$interopDefault($ajpes)))(ref.current.deps, deps)) ref.current = {
            value: memoFn(),
            deps: deps
        };
        return ref.current.value;
    };
});
parcelRegister("8tf7c", function(module, exports) {
    $parcel$export(module.exports, "ErrorFlag", ()=>$b20ca95c735c7779$export$518ba8e0e60f145f);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $jJZqs;
    var $LJaTB;
    const $b20ca95c735c7779$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
        if (!error) return null;
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
            const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
                flag: {
                    type: 'warning',
                    title: title,
                    description: errorMessage,
                    testId: (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.warning' : undefined
                }
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
            flag: {
                type: 'error',
                title: title,
                description: description,
                testId: (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.error' : undefined
            }
        });
    };
});
parcelRegister("LJaTB", function(module, exports) {
    $parcel$export(module.exports, "FlagRenderer", ()=>$2de6889b93863972$export$7c38ebd1f7ca6a5a);
    var $hkhmi;
    var $34Vv8;
    const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("hkhmi")).default));
});
parcelRegister("hkhmi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2971dd786c0add8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHfPB;
    class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { flagService: flagService, flag: flag } = this.props;
            if (flagService) this.flagId = flagService.showFlag(flag);
        }
        componentWillUnmount() {
            const { flagService: flagService } = this.props;
            if (flagService && this.flagId) flagService.dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(this.flagId));
        }
        render() {
            return null;
        }
    }
});
parcelRegister("h7hV2", function(module, exports) {
    $parcel$export(module.exports, "useListViewIssues", ()=>$03b2587a35d6e361$export$3c9c5774f09af6c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $8Wswo;
    var $2UUq6;
    var $cvbVg;
    var $9SwwX;
    var $gN11a;
    var $jcw0u;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $4NLOw;
    var $61h55;
    var $bsMMx;
    const $03b2587a35d6e361$var$emptyArray = [];
    const $03b2587a35d6e361$export$3c9c5774f09af6c0 = ({ input: input, condition: condition = true, onComplete: onComplete })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [hasLoadingStarted, setHasLoadingStarted] = (0, $5uXOq.useState)(false);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const onNextPageLoaded = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
        }, [
            createAnalyticsEvent
        ]);
        const queryVariables = (0, (0, parcelRequire("egmQO")).getVariables)(input);
        const { data: data, loadFirstPage: loadFirstPage, hasNextPage: hasNextPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, (0, parcelRequire("cvbVg")).useJqlPagination)({
            variables: {
                cloudId: cloudId,
                ...queryVariables
            },
            errorPolicy: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures') ? 'all' : 'none',
            query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
            onCompleted: (responseData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemsQuery succeeded', {
                    issuesCount: (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(responseData, 'list')?.edges?.length
                });
                (0, (0, parcelRequire("gN11a")).markViewMetric)('list', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                if (onComplete) onComplete(responseData);
            },
            onError: (apolloError)=>{
                if (!(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(apolloError) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures')) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewItemsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch issues in list view',
                        ...(0, (0, parcelRequire("8Wswo")).getGraphqlErrorAttributes)(apolloError)
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, (0, parcelRequire("gN11a")).markViewMetric)('list', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            },
            onPaginationError: (apolloError)=>{
                if (!(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(apolloError) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures')) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewPaginationQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch more issues in list view',
                        ...(0, (0, parcelRequire("8Wswo")).getGraphqlErrorAttributes)(apolloError)
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onNextPageLoaded: onNextPageLoaded
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!data && condition) {
                (0, (0, parcelRequire("gN11a")).markViewMetric)('list', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
                loadFirstPage();
                setHasLoadingStarted(true);
            }
        }, [
            condition,
            data
        ]);
        const { sort: sort } = (0, (0, parcelRequire("2UUq6")).useSorter)();
        const _data = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, 'list');
        const edges = _data?.edges || $03b2587a35d6e361$var$emptyArray;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const result = (0, $5uXOq.useMemo)(()=>{
            if (Array.isArray(edges) && edges.length === 0) return edges;
            const cacheVariables = {
                jql: queryVariables.jql,
                withConfluenceLinks: queryVariables.withConfluenceLinks,
                includeDoneItems: queryVariables.includeDoneItems,
                isParentFieldVisible: queryVariables.isParentFieldVisible,
                isDevSummaryFieldVisible: queryVariables.isDevSummaryFieldVisible
            };
            return sort((0, (0, parcelRequire("bsMMx")).transformResult)(edges, {
                cacheVariables: cacheVariables,
                intl: intl
            }));
        }, [
            edges,
            sort,
            queryVariables.jql,
            queryVariables.withConfluenceLinks,
            queryVariables.includeDoneItems,
            queryVariables.isParentFieldVisible,
            queryVariables.isDevSummaryFieldVisible,
            intl
        ]);
        return {
            data: result,
            loading: hasLoadingStarted ? loading : true,
            error: !(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(error) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures') ? undefined : error,
            loadNextPage: loadNextPage,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage
        };
    };
});
parcelRegister("cvbVg", function(module, exports) {
    $parcel$export(module.exports, "useIssuePagination", ()=>$0bf39943290cab91$export$b49565a42289e6b);
    $parcel$export(module.exports, "useJqlPagination", ()=>$0bf39943290cab91$export$9408824d9baedabc);
    $parcel$export(module.exports, "useRefreshInterval", ()=>$0bf39943290cab91$export$7cfdc4e3bbeb1790);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $5tTFS;
    var $9SwwX;
    const $0bf39943290cab91$var$paginationOptionsForIssuesByJql = {
        uniqueId: 'issueId',
        filter: 'jql'
    };
    function $0bf39943290cab91$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
        const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
        const _data = data && (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, listName, onError);
        const hasNextPage = _data?.pageInfo?.hasNextPage || false;
        const endCursor = _data?.pageInfo?.endCursor || '';
        const fetchMore = (0, (0, parcelRequire("9SwwX")).useFetchMore)({
            query: query,
            variables: variables
        });
        const onErrorRef = (0, $5uXOq.useRef)();
        onErrorRef.current = onError;
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setIsLoadingNextPage(false);
        }, [
            resetWhenChanged
        ]);
        const updateQueryAGGCompliant = (0, $5uXOq.useCallback)((prev, { fetchMoreResult: fetchMoreResult })=>{
            setIsLoadingNextPage(false);
            if (!fetchMoreResult) return prev;
            const edges = [
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(prev, listName)?.edges || [],
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
            ];
            return {
                jira: {
                    ...fetchMoreResult.jira,
                    [listName]: {
                        ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName),
                        edges: (0, ($parcel$interopDefault($3JOCw)))(edges, (edge)=>edge?.node && edge.node[uniqueId])
                    }
                }
            };
        }, [
            setIsLoadingNextPage,
            listName,
            uniqueId
        ]);
        const next = (0, $5uXOq.useCallback)((after)=>{
            setIsLoadingNextPage(true);
            fetchMore({
                after: after,
                onError: onErrorRef.current,
                errorPolicy: errorPolicy,
                updateQuery: updateQueryAGGCompliant
            });
        }, [
            fetchMore,
            updateQueryAGGCompliant,
            errorPolicy
        ]);
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            isLoadingNextPage: isLoadingNextPage,
            next: next
        };
    }
    const $0bf39943290cab91$export$b49565a42289e6b = (options)=>$0bf39943290cab91$export$f80c710216eae131({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
        const [inFlightPage, setInFlightPage] = (0, $5uXOq.useState)();
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setInFlightPage(null);
        }, [
            resetWhenChanged
        ]);
        const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy || 'network-only',
            onCompleted: onCompleted,
            onError: onError
        });
        if (data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
        const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $0bf39943290cab91$export$f80c710216eae131({
            data: data,
            variables: variables,
            listName: 'list',
            onError: onPaginationError,
            errorPolicy: errorPolicy,
            query: query,
            uniqueId: uniqueId,
            filter: filter
        });
        const loadNextPage = (0, $5uXOq.useCallback)(()=>{
            if (!hasNextPage || endCursor === inFlightPage || loading) return;
            setInFlightPage(endCursor);
            next(endCursor);
            onNextPageLoaded && onNextPageLoaded();
        }, [
            endCursor,
            hasNextPage,
            inFlightPage,
            next,
            onNextPageLoaded,
            loading
        ]);
        return {
            loading: loading,
            error: error,
            data: data,
            loadFirstPage: loadFirstPage,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loadNextPage: loadNextPage,
            refetch: refetch
        };
    };
    const $0bf39943290cab91$export$9408824d9baedabc = (options)=>$0bf39943290cab91$export$ea10f704343077db({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (interval == null) return ()=>{};
            const timer = setTimeout(()=>{
                if (condition) callback();
            }, interval * 1000);
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            interval,
            callback,
            condition
        ]);
    };
});
parcelRegister("4NLOw", function(module, exports) {
    $parcel$export(module.exports, "shouldHandleTheError", ()=>$772da81157c64678$export$47770c8b6d645cdb);
    const $772da81157c64678$var$IGNORED_ERRORS = [
        {
            errorType: 'ISSUE_UNAVAILABLE',
            statusCode: 404
        },
        {
            errorType: 'FIELD_VALUE_UNAVAILABLE',
            statusCode: 500
        },
        {
            errorType: 'DATA_FETCHER_THREW',
            statusCode: 500
        }
    ];
    const $772da81157c64678$export$47770c8b6d645cdb = (error)=>{
        if (error?.networkError) return true;
        const filterIssueUnavailableErrors = (graphQLError)=>!$772da81157c64678$var$IGNORED_ERRORS.find((ignoredError)=>ignoredError.errorType === graphQLError?.extensions?.errorType && ignoredError.statusCode === graphQLError?.extensions?.statusCode);
        const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueUnavailableErrors);
        return errorsToShow.length > 0;
    };
});
parcelRegister("bsMMx", function(module, exports) {
    $parcel$export(module.exports, "addChildToParentListView", ()=>$11e9e7ac961f2fe3$export$a79dcdc594f4a8c4);
    $parcel$export(module.exports, "removeChildFromParentListView", ()=>$11e9e7ac961f2fe3$export$1ea2ddc4aab7921f);
    $parcel$export(module.exports, "transformResult", ()=>$11e9e7ac961f2fe3$export$f13b29f9ed0c5a03);
    var $hE5wF;
    var $fqrog;
    var $4R6GH;
    var $5fc53;
    var $4kK95;
    var $jUV6i;
    const $11e9e7ac961f2fe3$export$a79dcdc594f4a8c4 = (parentIssue)=>({
            ...parentIssue,
            childSummary: {
                __typename: 'JiraWorkManagementChildSummary',
                hasChildren: true,
                totalCount: parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount + 1 : 1
            }
        });
    const $11e9e7ac961f2fe3$export$1ea2ddc4aab7921f = (parentIssue, childrenToRemove = 1)=>{
        const newCount = parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount - childrenToRemove : 0;
        return {
            ...parentIssue,
            childSummary: {
                __typename: 'JiraWorkManagementChildSummary',
                hasChildren: newCount > 0,
                totalCount: newCount
            }
        };
    };
    const $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer = ()=>(field)=>({
                [field.aliasFieldId || field.fieldId]: (field.dateTime && (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date(field.dateTime))) ?? null
            });
    const $11e9e7ac961f2fe3$var$createDateFieldTransformer = ()=>(field)=>({
                [field.aliasFieldId || field.fieldId]: (field.date && (0, (0, parcelRequire("4kK95")).toDateOnly)(field.date)) ?? null
            });
    const $11e9e7ac961f2fe3$var$atlassianAccountUserTransformer = (user)=>({
            accountId: user.accountId,
            avatarUrl: user.picture,
            displayName: user.name
        });
    const $11e9e7ac961f2fe3$var$createJiraSingleSelectUserPickeTransformer = ()=>(field)=>field.user && {
                [field.aliasFieldId || field.fieldId]: $11e9e7ac961f2fe3$var$atlassianAccountUserTransformer(field.user)
            } || null;
    const $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer = (fieldId)=>(field)=>({
                [fieldId || field.aliasFieldId || field.fieldId]: field.text
            });
    const $11e9e7ac961f2fe3$var$createJiraLabelsTransformer = ()=>(field)=>({
                [field.aliasFieldId || field.fieldId]: field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) || []
            });
    const $11e9e7ac961f2fe3$var$topLevelFieldTransformers = {
        [(0, (0, parcelRequire("5fc53")).ISSUE_KEY_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer('key'),
        [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: (field)=>({
                issuetype: {
                    iconUrl: field.issueType?.avatar?.medium,
                    id: field.issueType?.issueTypeId,
                    name: field.issueType?.name,
                    level: field.issueType?.hierarchy?.level
                }
            }),
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer(),
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: (field)=>({
                status: {
                    id: field.status.statusId,
                    name: field.status.name,
                    categoryId: field.status.statusCategory?.statusCategoryId
                }
            }),
        [(0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)]: $11e9e7ac961f2fe3$var$createDateFieldTransformer(),
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $11e9e7ac961f2fe3$var$createDateFieldTransformer(),
        [(0, (0, parcelRequire("5fc53")).UPDATED)]: $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer(),
        [(0, (0, parcelRequire("5fc53")).CREATED)]: $11e9e7ac961f2fe3$var$createDateTimeFieldTransformer(),
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleSelectUserPickeTransformer(),
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: (field)=>({
                priority: (field.priority && {
                    id: field.priority.id,
                    name: field.priority.name,
                    iconUrl: field.priority.iconUrl
                }) ?? null
            }),
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $11e9e7ac961f2fe3$var$createJiraLabelsTransformer(),
        [(0, (0, parcelRequire("5fc53")).RANK_CF_TYPE)]: $11e9e7ac961f2fe3$var$createJiraSingleLineTextTransformer(),
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: (field)=>({
                timeoriginalestimate: field.originalEstimate?.timeInSeconds ?? null
            })
    };
    const $11e9e7ac961f2fe3$var$getTopLevelField = (field)=>{
        const transformer = $11e9e7ac961f2fe3$var$topLevelFieldTransformers[field.type];
        if (transformer) return transformer(field);
        return null;
    };
    const $11e9e7ac961f2fe3$export$f13b29f9ed0c5a03 = (edges, options)=>{
        if (edges) return edges.filter((edge)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures')) return Array.isArray(edge?.node?.fields);
            return edge?.node;
        }).map((edge)=>{
            const { id: id, fields: fields, issueId: issueId, childSummary: childSummary, legacyConfluenceLinks: legacyConfluenceLinks, commentSummary: commentSummary } = edge.node;
            const listViewIssue = {
                id: id,
                issueId: issueId,
                childSummary: {
                    totalCount: childSummary?.totalCount,
                    hasChildren: childSummary?.hasChildren ?? false
                },
                cacheVariables: options.cacheVariables,
                fields: (0, (0, parcelRequire("jUV6i")).listViewTransformFields)(fields, options.intl),
                confluenceLinks: legacyConfluenceLinks ?? undefined,
                commentSummary: {
                    totalCount: commentSummary?.totalCount
                },
                ...(0, (0, parcelRequire("fqrog")).transformTopLevelFields)(edge?.node)
            };
            fields?.forEach((field)=>{
                if (field != null) {
                    const fieldValues = $11e9e7ac961f2fe3$var$getTopLevelField(field);
                    Object.assign(listViewIssue, fieldValues);
                }
            });
            return listViewIssue;
        });
        return [];
    };
});
parcelRegister("fqrog", function(module, exports) {
    $parcel$export(module.exports, "transformField", ()=>$e630afa64fd6ceac$export$fbce423ada1f57a0);
    $parcel$export(module.exports, "isTransformFieldSupported", ()=>$e630afa64fd6ceac$export$d3f2873cf2713a58);
    $parcel$export(module.exports, "transformTopLevelFields", ()=>$e630afa64fd6ceac$export$82a9f94774eb7857);
    var $8QpSo;
    var $gTfZ2;
    var $fLdM4;
    var $fTh7Q;
    var $la89U;
    var $8n29C;
    var $8wFTy;
    var $dUPoX;
    var $aC1CM;
    var $h0F6x;
    var $gQbVm;
    var $gygm0;
    var $erqgq;
    const $e630afa64fd6ceac$var$createSupportedTransformations = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("gygm0")).transformVersionField)(),
            ...(0, (0, parcelRequire("8n29C")).transformParentField)(),
            ...(0, (0, parcelRequire("gQbVm")).transformTeamField)(),
            ...(0, (0, parcelRequire("fTh7Q")).transformGoalsField)(),
            ...(0, (0, parcelRequire("aC1CM")).transformResolutionField)(),
            ...(0, (0, parcelRequire("la89U")).transformGroupField)(),
            ...(0, (0, parcelRequire("dUPoX")).transformRadioSelectField)(),
            ...(0, (0, parcelRequire("h0F6x")).transformStatusCategoryField)(),
            ...(0, (0, parcelRequire("8wFTy")).transformProjectField)(),
            ...(0, (0, parcelRequire("gTfZ2")).transformCascadingSelectField)()
        }));
    const $e630afa64fd6ceac$var$isValidTypename = (typename)=>true;
    const $e630afa64fd6ceac$export$66480ae6e701514d = (field)=>true;
    const $e630afa64fd6ceac$export$fbce423ada1f57a0 = (field, intl)=>{
        const supportedTransformations = $e630afa64fd6ceac$var$createSupportedTransformations();
        if (field == null) return null;
        const typename = field.__typename;
        if (!$e630afa64fd6ceac$var$isValidTypename(typename)) return null;
        const transform = supportedTransformations[typename];
        if (transform == null) return null;
        return transform(field, intl);
    };
    const $e630afa64fd6ceac$export$d3f2873cf2713a58 = (field)=>{
        const supportedTransformations = $e630afa64fd6ceac$var$createSupportedTransformations();
        if (!(0, (0, parcelRequire("erqgq")).isJiraBusinessFields)(field)) return false;
        if (!$e630afa64fd6ceac$var$isValidTypename(field.__typename)) return false;
        return supportedTransformations[field.__typename] != null;
    };
    const $e630afa64fd6ceac$export$82a9f94774eb7857 = (issueNode)=>issueNode ? {
            [(0, $677cd2eb13864f6c$export$72b5bd2391f1e7c0)]: (0, (0, parcelRequire("fLdM4")).transformDevSummaryField)(issueNode.devSummaryCache)
        } : {};
});
parcelRegister("gTfZ2", function(module, exports) {
    $parcel$export(module.exports, "transformCascadingSelectField", ()=>$9854766c7dcd472c$export$b5257861e8de13fa);
    var $e9E9F;
    var $5fc53;
    const $9854766c7dcd472c$export$b5257861e8de13fa = ()=>({
            [(0, $206b407a57faed7a$export$c5c9bcd04d3610df)]: (field)=>{
                if (field.__typename !== (0, $206b407a57faed7a$export$c5c9bcd04d3610df)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE),
                    id: field.id,
                    fieldId: field.fieldId,
                    value: field.cascadingOption && field.cascadingOption.parentValue ? {
                        parentOptionValue: {
                            id: field.cascadingOption.parentValue.id,
                            optionId: (0, (0, parcelRequire("e9E9F")).JiraIssueFieldOptionAri).parse(field.cascadingOption.parentValue.id).optionId,
                            value: field.cascadingOption.parentValue.value,
                            isDisabled: field.cascadingOption.parentValue.isDisabled
                        },
                        ...field.cascadingOption.childOptionValue ? {
                            childOptionValue: {
                                id: field.cascadingOption.childOptionValue.id,
                                optionId: field.cascadingOption.childOptionValue.optionId,
                                value: field.cascadingOption.childOptionValue.value,
                                isDisabled: field.cascadingOption.childOptionValue.isDisabled
                            }
                        } : {}
                    } : null
                };
            }
        });
});
parcelRegister("e9E9F", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueFieldOptionAri", ()=>$a4e10de13cd7bf40$export$e3bc1ec22f941fbe);
    var $aeXsV;
    var $9KGzW;
    var $1C2Ux;
    var $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("aeXsV")).JiraIssueFieldOptionAriResourceOwner),
        resourceType: (0, (0, parcelRequire("aeXsV")).JiraIssueFieldOptionAriResourceType),
        resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
            optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $a4e10de13cd7bf40$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get fieldId() {
            return this._fieldId;
        }
        get optionId() {
            return this._optionId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
                platformQualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
                resourceType: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    fieldId: opts.fieldId,
                    optionId: opts.optionId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
            return new _JiraIssueFieldOptionAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
            return new _JiraIssueFieldOptionAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                fieldId: this.fieldId,
                optionId: this.optionId
            };
        }
    };
});
parcelRegister("aeXsV", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", ()=>$774956c9da7baac8$export$eb4f4cf0880fe5a8);
    $parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", ()=>$774956c9da7baac8$export$4bec333360908e78);
    var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";
});
const $206b407a57faed7a$export$c5c9bcd04d3610df = 'JiraCascadingSelectField';
parcelRegister("fLdM4", function(module, exports) {
    $parcel$export(module.exports, "transformDevSummaryField", ()=>$d62ec76730f01701$export$2093d68e8a6114b5);
    const $d62ec76730f01701$var$hasPullRequest = (field)=>Number(field?.devSummary?.pullrequest?.overall?.count) > 0;
    const $d62ec76730f01701$var$isUnderReview = (field)=>$d62ec76730f01701$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'OPEN';
    const $d62ec76730f01701$var$isMerged = (field)=>$d62ec76730f01701$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'MERGED';
    const $d62ec76730f01701$export$2093d68e8a6114b5 = (field)=>field ? {
            pullRequestsCount: Number(field?.devSummary?.pullrequest?.overall?.count),
            isUnderReview: $d62ec76730f01701$var$isUnderReview(field),
            isMerged: $d62ec76730f01701$var$isMerged(field),
            commitCount: Number(field?.devSummary?.commit?.overall?.count)
        } : null;
});
parcelRegister("fTh7Q", function(module, exports) {
    $parcel$export(module.exports, "transformGoalsField", ()=>$80b6ef74eef34661$export$c34241865478278);
    var $5fc53;
    const $80b6ef74eef34661$export$c34241865478278 = ()=>({
            [(0, $79c833f42551f759$export$aac6761ddd37ded5)]: (field)=>{
                if (field.__typename !== (0, $79c833f42551f759$export$aac6761ddd37ded5)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    isEditable: !!field.fieldConfig?.isEditable,
                    value: {
                        goals: field.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                                id: edge?.node?.id || '',
                                name: edge?.node?.name || '',
                                status: edge?.node?.status || null
                            })) || [],
                        totalCount: field.selectedGoals?.totalCount || 0
                    }
                };
            }
        });
});
const $79c833f42551f759$export$aac6761ddd37ded5 = 'JiraGoalsField';
parcelRegister("la89U", function(module, exports) {
    $parcel$export(module.exports, "transformGroupField", ()=>$9ca99cda73f0ee52$export$5090c8e3ce3e3e36);
    var $5fc53;
    const $9ca99cda73f0ee52$export$5090c8e3ce3e3e36 = ()=>({
            [(0, $340a31f3aa62c282$export$e67f77aeba6db6c8)]: (field)=>{
                if (field.__typename !== (0, $340a31f3aa62c282$export$e67f77aeba6db6c8)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    value: field.selectedGroup ? {
                        id: field.selectedGroup.id,
                        groupId: field.selectedGroup.groupId,
                        name: field.selectedGroup.name ?? ''
                    } : null
                };
            },
            [(0, $340a31f3aa62c282$export$bf73c80438672453)]: (field)=>{
                if (field.__typename !== (0, $340a31f3aa62c282$export$bf73c80438672453)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    value: field.selectedGroupsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                            id: edge.node.id,
                            groupId: edge.node.groupId,
                            name: edge.node.name ?? ''
                        } : null).filter(Boolean) ?? null
                };
            }
        });
});
const $340a31f3aa62c282$export$e67f77aeba6db6c8 = 'JiraSingleGroupPickerField';
const $340a31f3aa62c282$export$bf73c80438672453 = 'JiraMultipleGroupPickerField';
parcelRegister("8n29C", function(module, exports) {
    $parcel$export(module.exports, "transformParentField", ()=>$9cbd1149b243724f$export$9154eb05be84db49);
    var $5fc53;
    var $57lFd;
    const $9cbd1149b243724f$export$9154eb05be84db49 = ()=>({
            [(0, $96199b0c0c91be44$export$89cbdbc2fa7a3b27)]: (field)=>{
                if (field.__typename !== (0, $96199b0c0c91be44$export$89cbdbc2fa7a3b27)) return null;
                let fields = {};
                if (Array.isArray(field.parentIssue?.fields)) {
                    const issueType = (0, (0, parcelRequire("57lFd")).safeGetValue)(field.parentIssue.fields, 'issuetype', 'issueType', null);
                    const color = (0, (0, parcelRequire("57lFd")).safeGetValue)(field.parentIssue.fields, 'issuecolor', 'color.colorKey', null);
                    fields = {
                        summary: (0, (0, parcelRequire("57lFd")).safeGetValue)(field.parentIssue.fields, 'summary', 'text', null),
                        statusCategoryId: (0, (0, parcelRequire("57lFd")).safeGetValue)(field.parentIssue?.fields, 'status', 'status.statusCategory.statusCategoryId', null),
                        issueType: issueType ? {
                            name: issueType.name,
                            iconUrl: issueType.avatar?.medium
                        } : null,
                        color: color != null ? color.toUpperCase() : null
                    };
                }
                if (Array.isArray(field.parentIssue?.rankField)) {
                    const rank = (0, (0, parcelRequire("57lFd")).safeGetValue)(field.parentIssue?.rankField, 'rank', 'text', null);
                    fields = {
                        ...fields,
                        rank: rank ?? null
                    };
                }
                return {
                    type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                    fieldId: field.fieldId,
                    value: field.parentIssue ? {
                        id: field.parentIssue?.id,
                        issueId: field.parentIssue?.issueId,
                        issueKey: field.parentIssue?.key,
                        ...fields
                    } : null
                };
            }
        });
});
const $96199b0c0c91be44$export$89cbdbc2fa7a3b27 = 'JiraParentIssueField';
parcelRegister("8wFTy", function(module, exports) {
    $parcel$export(module.exports, "transformProjectField", ()=>$171682a66941f140$export$1fd74e5690ffdae3);
    var $6s1PB;
    var $5fc53;
    const $171682a66941f140$export$1fd74e5690ffdae3 = ()=>({
            [(0, $76dad3b4843304d3$export$32cecd77017de859)]: (field)=>{
                if (field.__typename !== (0, $76dad3b4843304d3$export$32cecd77017de859)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    value: field.project ? {
                        id: field.project.id,
                        name: field.project.name ?? '',
                        key: field.project.key ?? '',
                        avatarUrls: {
                            '48x48': field.project.avatar?.large ?? ''
                        },
                        projectId: (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? field.project.projectId : undefined
                    } : null
                };
            }
        });
});
const $76dad3b4843304d3$export$32cecd77017de859 = 'JiraProjectField';
parcelRegister("dUPoX", function(module, exports) {
    $parcel$export(module.exports, "transformRadioSelectField", ()=>$5b81f5d47241d28b$export$ee3d5244f5f85b47);
    var $5fc53;
    const $5b81f5d47241d28b$export$ee3d5244f5f85b47 = ()=>({
            [(0, $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b)]: (field)=>{
                if (field.__typename !== (0, $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    isEditable: !!field.fieldConfig?.isEditable,
                    value: field.selectedOption ? {
                        id: field.selectedOption.optionId,
                        value: field.selectedOption.value ?? ''
                    } : null
                };
            }
        });
});
const $d6c7b5757fc9ff6e$export$561e8c47e4fa1c1b = 'JiraRadioSelectField';
parcelRegister("aC1CM", function(module, exports) {
    $parcel$export(module.exports, "transformResolutionField", ()=>$64ed186dee127bcd$export$3441c85b045ddb32);
    var $5fc53;
    const $64ed186dee127bcd$export$3441c85b045ddb32 = ()=>({
            [(0, $a3d8c7863d334786$export$a7bcc074cfedc376)]: (field)=>{
                if (field.__typename !== (0, $a3d8c7863d334786$export$a7bcc074cfedc376)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                    fieldId: field.fieldId,
                    value: field.resolution ? {
                        id: field.resolution.id,
                        name: field.resolution.name ?? ''
                    } : null
                };
            }
        });
});
const $a3d8c7863d334786$export$a7bcc074cfedc376 = 'JiraResolutionField';
parcelRegister("h0F6x", function(module, exports) {
    $parcel$export(module.exports, "transformStatusCategoryField", ()=>$84a62c9cfa413a6f$export$daffdd43f256def6);
    var $5fc53;
    const $84a62c9cfa413a6f$export$daffdd43f256def6 = ()=>({
            [(0, $0109c63a793596b4$export$aa464b56f1076111)]: (field)=>{
                if (field.__typename !== (0, $0109c63a793596b4$export$aa464b56f1076111)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE),
                    fieldId: field.fieldId,
                    value: field.statusCategory ? {
                        statusCategoryId: field.statusCategory.statusCategoryId,
                        name: field.statusCategory.name ?? ''
                    } : null
                };
            }
        });
});
const $0109c63a793596b4$export$aa464b56f1076111 = 'JiraStatusCategoryField';
parcelRegister("gQbVm", function(module, exports) {
    $parcel$export(module.exports, "transformTeamField", ()=>$9e03399a683d167a$export$c924eaa42d1ef062);
    var $5fc53;
    const $9e03399a683d167a$export$c924eaa42d1ef062 = ()=>({
            [(0, $d01e345798316c77$export$4b2dddaf094af935)]: (field)=>{
                if (field.__typename !== (0, $d01e345798316c77$export$4b2dddaf094af935)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
                    fieldId: field.fieldId,
                    value: field.selectedTeam ? {
                        id: field.selectedTeam.jiraSuppliedTeamId,
                        name: field.selectedTeam.jiraSuppliedName ?? ''
                    } : null
                };
            }
        });
});
const $d01e345798316c77$export$4b2dddaf094af935 = 'JiraTeamViewField';
parcelRegister("gygm0", function(module, exports) {
    $parcel$export(module.exports, "transformVersionField", ()=>$2cc8ced84840d9fe$export$7beb4bd99d0c30b);
    var $5fc53;
    const $2cc8ced84840d9fe$export$7beb4bd99d0c30b = ()=>({
            [(0, $2768c56582d92138$export$7d00c90aa4f1f657)]: (field)=>{
                if (field.__typename !== (0, $2768c56582d92138$export$7d00c90aa4f1f657)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    value: field.version ? {
                        id: field.version.versionId,
                        name: field.version.name ?? ''
                    } : null
                };
            },
            [(0, $2768c56582d92138$export$f240ecd334700f48)]: (field)=>{
                if (field.__typename !== (0, $2768c56582d92138$export$f240ecd334700f48)) return null;
                return {
                    type: (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE),
                    fieldId: field.fieldId,
                    name: field.name,
                    value: field.selectedVersionsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                            id: edge?.node.versionId,
                            name: edge?.node.name ?? ''
                        } : null).filter((version)=>version != null) ?? null
                };
            }
        });
});
const $2768c56582d92138$export$7d00c90aa4f1f657 = 'JiraSingleVersionPickerField';
const $2768c56582d92138$export$f240ecd334700f48 = 'JiraMultipleVersionPickerField';
parcelRegister("erqgq", function(module, exports) {
    $parcel$export(module.exports, "isJiraBusinessFields", ()=>$b41b61505251b1ca$export$257745f9c8865601);
    const $b41b61505251b1ca$export$257745f9c8865601 = (_)=>true;
});
parcelRegister("4kK95", function(module, exports) {
    $parcel$export(module.exports, "DateOnly", ()=>$a1048e23edd181e2$export$988b361b394263b6);
    $parcel$export(module.exports, "toDateOnly", ()=>$a1048e23edd181e2$export$b0961ad8aee63b8b);
    const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
    const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    const $a1048e23edd181e2$var$daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
        if ([
            year,
            month,
            day
        ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
        if (year < 0) return false;
        if (month < 1 || month > 12) return false;
        if (day < 1) return false;
        if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
        return true;
    };
    const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
    class $a1048e23edd181e2$export$988b361b394263b6 {
        static isISODateString(dateString) {
            try {
                $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
            } catch (e) {
                if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
                throw e;
            }
            return true;
        }
        static fromISODateString(dateString) {
            const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
            if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            const [, year, month, day] = matches;
            return new $a1048e23edd181e2$export$988b361b394263b6(...[
                year,
                month,
                day
            ].map((s)=>Number.parseInt(s, 10)));
        }
        static fromDateAccordingToLocalTime(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
        static fromDateAccordingToUTC(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        }
        static compare(a, b) {
            if (a.year === b.year) {
                if (a.month === b.month) {
                    if (a.day === b.day) return 0;
                    return a.day < b.day ? -1 : 1;
                }
                return a.month < b.month ? -1 : 1;
            }
            return a.year < b.year ? -1 : 1;
        }
        constructor(year, month, day){
            if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            this.year = year;
            this.month = month;
            this.day = day;
        }
        getYear() {
            return this.year;
        }
        getMonth() {
            return this.month;
        }
        getDay() {
            return this.day;
        }
        toISOString() {
            return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
        }
        toUTCDate() {
            return new Date(Date.UTC(this.year, this.month - 1, this.day));
        }
        toLocalDate() {
            const localDate = new Date();
            const currentMonth = localDate.getMonth();
            localDate.setFullYear(this.year);
            localDate.setHours(0);
            localDate.setMinutes(0);
            localDate.setSeconds(0);
            localDate.setMilliseconds(0);
            localDate.setDate(this.day);
            if (localDate.getMonth() !== currentMonth) {
                localDate.setMonth(this.month - 1);
                localDate.setDate(this.day);
            } else localDate.setMonth(this.month - 1);
            return localDate;
        }
        equals(dateOnly) {
            return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
        }
    }
    const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;
});
parcelRegister("jUV6i", function(module, exports) {
    $parcel$export(module.exports, "listViewTransformFields", ()=>$7dbf501f1c077c87$export$34af57b660300007);
    var $fqrog;
    var $2Igls;
    var $6s1PB;
    var $4R6GH;
    var $5fc53;
    var $etKNj;
    var $k698r;
    const $7dbf501f1c077c87$var$transformTimeTracking = (originalEstimate, timeTrackingOptions, intl)=>{
        if (originalEstimate) return {
            timeInSeconds: Number(originalEstimate.timeInSeconds) || undefined,
            timeAsString: (0, (0, parcelRequire("etKNj")).timeTrackingFormatter)(Number(originalEstimate.timeInSeconds), {
                ...timeTrackingOptions,
                timeFormat: (0, (0, parcelRequire("k698r")).timeFormatMap).get(timeTrackingOptions.timeFormat) || (0, (0, parcelRequire("2Igls")).PRETTY)
            }, intl)
        };
        return null;
    };
    const $7dbf501f1c077c87$var$transformUser = (user)=>{
        if (user) return {
            accountId: user.accountId,
            name: user.name,
            picture: user.picture ?? ''
        };
        return null;
    };
    const $7dbf501f1c077c87$var$transformUsers = (users)=>{
        if (users) return users.map((user)=>$7dbf501f1c077c87$var$transformUser(user?.node));
        return null;
    };
    const $7dbf501f1c077c87$var$transformSelectField = (selectedOption)=>{
        if (selectedOption) return {
            optionId: String(selectedOption.optionId),
            value: selectedOption.value,
            ...selectedOption.color ? {
                color: selectedOption.color?.colorKey
            } : {}
        };
        return null;
    };
    const $7dbf501f1c077c87$export$d4a0295c1cbaac03 = (selectedOptions)=>{
        if (selectedOptions) return selectedOptions.map((option)=>option?.node?.optionId && option?.node?.value ? $7dbf501f1c077c87$var$transformSelectField(option.node) : null).filter((option)=>option !== null);
        return null;
    };
    const $7dbf501f1c077c87$export$c072126708d93f04 = (labels)=>{
        if (labels) return labels.map((label)=>label?.node?.name ?? null).filter((label)=>label !== null);
        return null;
    };
    const $7dbf501f1c077c87$var$transformSprint = (sprints)=>{
        if (sprints) return sprints.map((sprint)=>sprint?.node ?? null).filter((sprint)=>sprint !== null);
        return null;
    };
    const $7dbf501f1c077c87$export$b5df62b8f5dea4f9 = (componentValues)=>{
        if (componentValues?.length) return componentValues.map((componentValue)=>componentValue?.node?.componentId ? {
                componentId: componentValue.node?.componentId ?? '',
                name: componentValue.node?.name ?? null
            } : null).filter((componentValue)=>componentValue !== null);
        return null;
    };
    const $7dbf501f1c077c87$var$transformParent = (parentIssue)=>{
        if (parentIssue) return {
            issueId: parentIssue.issueId,
            issueKey: parentIssue.key
        };
        return null;
    };
    const $7dbf501f1c077c87$var$listFieldTransformers = {
        JiraIssueTypeField: (field)=>{
            if (field.__typename !== 'JiraIssueTypeField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                fieldId: field.fieldId,
                value: field.issueType?.name ?? null,
                level: field.issueType?.hierarchy?.level,
                issueTypeId: (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? field.issueType?.issueTypeId : undefined
            };
        },
        JiraSingleLineTextField: (field)=>{
            if (field.__typename !== 'JiraSingleLineTextField') return null;
            return {
                type: field.type === 'issuekey' ? 'key' : field.type,
                fieldId: field.fieldId,
                value: field.text
            };
        },
        JiraUrlField: (field)=>{
            if (field.__typename !== 'JiraUrlField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                fieldId: field.fieldId,
                value: field.uri
            };
        },
        JiraRichTextField: (field)=>{
            if (field.__typename !== 'JiraRichTextField') return null;
            const value = field.richText?.adfValue?.json;
            return {
                type: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                fieldId: field.fieldId,
                value: value ? JSON.stringify(value) : ''
            };
        },
        JiraStatusField: (field)=>{
            if (field.__typename !== 'JiraStatusField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                fieldId: field.fieldId,
                name: field.status?.name,
                statusId: (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? field.status?.statusId : null,
                value: Number(field.status?.statusCategory?.statusCategoryId) ? Number(field.status?.statusCategory?.statusCategoryId) : null
            };
        },
        JiraSingleSelectUserPickerField: (field)=>{
            if (field.__typename !== 'JiraSingleSelectUserPickerField') return null;
            return {
                type: field.type,
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformUser(field.user)
            };
        },
        JiraLabelsField: (field)=>{
            if (field.__typename !== 'JiraLabelsField') return null;
            return {
                type: field.fieldId === 'labels' ? (0, (0, parcelRequire("5fc53")).LABELS_TYPE) : (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$export$c072126708d93f04(field.selectedLabelsConnection?.edges ?? null)
            };
        },
        JiraPriorityField: (field)=>{
            if (field.__typename !== 'JiraPriorityField') return null;
            if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) return {
                type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                fieldId: field.fieldId,
                value: field.priority ? {
                    name: field.priority.name,
                    priorityId: field.priority.priorityId,
                    iconUrl: field.priority.iconUrl
                } : null
            };
            return {
                type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                fieldId: field.fieldId,
                value: field.priority?.name ?? null,
                priorityId: field.priority?.priorityId ?? null
            };
        },
        JiraDateTimePickerField: (field)=>{
            if (field.__typename !== 'JiraDateTimePickerField') return null;
            return {
                type: field.type,
                fieldId: field.fieldId,
                value: field.dateTime
            };
        },
        JiraMultipleSelectField: (field)=>{
            if (field.__typename !== 'JiraMultipleSelectField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
            };
        },
        JiraSingleSelectField: (field)=>{
            if (field.__typename !== 'JiraSingleSelectField') return null;
            return {
                type: field.type,
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformSelectField(field.fieldOption) ?? null
            };
        },
        JiraTimeTrackingField: (field, intl)=>{
            if (field.__typename !== 'JiraTimeTrackingField' || field.originalEstimate?.timeInSeconds == null || field.timeTrackingSettings?.workingHoursPerDay == null || field.timeTrackingSettings?.workingDaysPerWeek == null || field.timeTrackingSettings?.defaultUnit == null || intl == null) {
                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) return {
                    type: (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE),
                    fieldId: 'timeoriginalestimate',
                    value: null
                };
                return null;
            }
            const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: timeFormat, defaultUnit: defaultUnit } = field.timeTrackingSettings;
            return {
                type: (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE),
                fieldId: 'timeoriginalestimate',
                value: $7dbf501f1c077c87$var$transformTimeTracking(field.originalEstimate, {
                    workingHoursPerDay: workingHoursPerDay,
                    workingDaysPerWeek: workingDaysPerWeek,
                    timeFormat: timeFormat || (0, (0, parcelRequire("2Igls")).PRETTY),
                    defaultUnit: defaultUnit
                }, intl)
            };
        },
        JiraDatePickerField: (field)=>{
            if (field.__typename !== 'JiraDatePickerField') return null;
            return {
                type: field.type,
                fieldId: field.fieldId,
                value: field.date
            };
        },
        JiraNumberField: (field)=>{
            if (field.__typename !== 'JiraNumberField') return null;
            return {
                type: field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE) || field.type === (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE) ? field.type : (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
                fieldId: field.fieldId,
                value: field.number
            };
        },
        JiraMultipleSelectUserPickerField: (field)=>{
            if (field.__typename !== 'JiraMultipleSelectUserPickerField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
            };
        },
        JiraPeopleField: (field)=>{
            if (field.__typename !== 'JiraPeopleField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
            };
        },
        JiraComponentsField: (field)=>{
            if (field.__typename !== 'JiraComponentsField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$export$b5df62b8f5dea4f9(field.selectedComponentsConnection?.edges ?? null)
            };
        },
        JiraParentIssueField: (field)=>{
            if (field.__typename !== 'JiraParentIssueField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformParent(field.parentIssue)
            };
        },
        JiraCheckboxesField: (field)=>{
            if (field.__typename !== 'JiraCheckboxesField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
            };
        },
        JiraSprintField: (field)=>{
            if (field.__typename !== 'JiraSprintField') return null;
            return {
                type: (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
                fieldId: field.fieldId,
                value: $7dbf501f1c077c87$var$transformSprint(field.selectedSprintsConnection?.edges ?? null)
            };
        }
    };
    const $7dbf501f1c077c87$var$listViewTransformField = (field, intl)=>{
        if (field == null) return null;
        if ((0, (0, parcelRequire("fqrog")).isTransformFieldSupported)(field)) return (0, (0, parcelRequire("fqrog")).transformField)(field, intl);
        if (field.__typename in $7dbf501f1c077c87$var$listFieldTransformers) return $7dbf501f1c077c87$var$listFieldTransformers[field.__typename](field, intl);
        return null;
    };
    const $7dbf501f1c077c87$export$34af57b660300007 = (fields, intl)=>{
        const toReturn = [];
        fields?.forEach((field)=>{
            const transformedField = $7dbf501f1c077c87$var$listViewTransformField(field, intl);
            if (transformedField != null) toReturn.push(transformedField);
        });
        return toReturn;
    };
});
parcelRegister("2Igls", function(module, exports) {
    $parcel$export(module.exports, "MINUTE", ()=>$88f80910cde3e0d3$export$f4aba04677f37907);
    $parcel$export(module.exports, "HOUR", ()=>$88f80910cde3e0d3$export$1bf939ebcf31ef0e);
    $parcel$export(module.exports, "DAY", ()=>$88f80910cde3e0d3$export$1a58b8d7f494dd72);
    $parcel$export(module.exports, "WEEK", ()=>$88f80910cde3e0d3$export$3241045aa1844a20);
    $parcel$export(module.exports, "DAYS", ()=>$88f80910cde3e0d3$export$b387b66963374517);
    $parcel$export(module.exports, "HOURS", ()=>$88f80910cde3e0d3$export$f25ebc73c10ad2c);
    $parcel$export(module.exports, "PRETTY", ()=>$88f80910cde3e0d3$export$d39e6ebabedff673);
    $parcel$export(module.exports, "defaultTimeTrackingConfiguration", ()=>$88f80910cde3e0d3$export$e17ebf14f4144ede);
    $parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", ()=>$88f80910cde3e0d3$export$83f9ac2d887bd06a);
    const $88f80910cde3e0d3$export$f4aba04677f37907 = 'minute';
    const $88f80910cde3e0d3$export$1bf939ebcf31ef0e = 'hour';
    const $88f80910cde3e0d3$export$1a58b8d7f494dd72 = 'day';
    const $88f80910cde3e0d3$export$3241045aa1844a20 = 'week';
    const $88f80910cde3e0d3$export$b387b66963374517 = 'days';
    const $88f80910cde3e0d3$export$f25ebc73c10ad2c = 'hours';
    const $88f80910cde3e0d3$export$d39e6ebabedff673 = 'pretty';
    const $88f80910cde3e0d3$export$e17ebf14f4144ede = {
        isTimeTrackingEnabled: false,
        daysPerWeek: 5,
        hoursPerDay: 8,
        defaultUnit: $88f80910cde3e0d3$export$f4aba04677f37907,
        format: $88f80910cde3e0d3$export$d39e6ebabedff673
    };
    const $88f80910cde3e0d3$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
    const $88f80910cde3e0d3$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
    const $88f80910cde3e0d3$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
});
parcelRegister("etKNj", function(module, exports) {
    $parcel$export(module.exports, "timeTrackingFormatter", ()=>$5d7d4350edc91a82$export$5169d8c8f9327e33);
    $parcel$export(module.exports, "timeTrackingFormatterWithDefaults", ()=>$5d7d4350edc91a82$export$71be3aa954f6065b);
    $parcel$export(module.exports, "timeTrackingFormatterLongForm", ()=>$5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
    $parcel$export(module.exports, "transformAGGToJiraTimeFormat", ()=>$5d7d4350edc91a82$export$9dccd3a07969375d);
    $parcel$export(module.exports, "transformAGGToJiraTimeUnit", ()=>$5d7d4350edc91a82$export$8516173ab945b52f);
    var $gBj4V;
    var $lgkxY;
    var $4TB2x;
    const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
    const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
    const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
        const timeForZero = `0${formatMessage(units[3].suffix)}`;
        if (timeInSeconds <= 0) return timeForZero;
        const initialTimeObj = {
            secondsRemaining: timeInSeconds,
            time: ''
        };
        const result = units.reduce((timeObj, unit)=>{
            if (unit.seconds <= 0) return timeObj;
            const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
            const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
            const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
            return {
                secondsRemaining: secondsRemaining,
                time: time
            };
        }, initialTimeObj);
        return result.time.trim() || timeForZero;
    };
    const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
        const timeForZero = `0 ${formatMessage(units[3].suffix, {
            [units[3].type]: 0
        })}`;
        if (timeInSeconds <= 0) return timeForZero;
        const initialTimeObj = {
            secondsRemaining: timeInSeconds,
            time: ''
        };
        const result = units.reduce((timeObj, unit)=>{
            if (unit.seconds <= 0) return timeObj;
            const { suffix: suffix, type: type } = unit;
            const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
            if (currentTimeValue === 1) return {
                secondsRemaining: timeObj.secondsRemaining % unit.seconds,
                time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                    [type]: currentTimeValue
                })}`
            };
            const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
            const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}` : timeObj.time;
            return {
                secondsRemaining: secondsRemaining,
                time: time
            };
        }, initialTimeObj);
        return result.time.trim() || timeForZero;
    };
    const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
        const isTimeValid = timeInSeconds > 0;
        const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
        const unit = (0, (0, parcelRequire("4TB2x")).createUnit)(timeInSeconds);
        const units = [
            unit({
                type: 'week',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitWeek,
                seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'day',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitDay,
                transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
                seconds: Math.max(workingHoursPerDay, 0) * (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'hour',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitHour,
                transform: $5d7d4350edc91a82$var$validate(isTimeValid),
                seconds: (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'minute',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitMinute,
                seconds: (0, (0, parcelRequire("gBj4V")).SECONDS_PER_MINUTE)
            })
        ];
        switch(timeFormat){
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).DAYS:
                return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).HOURS:
                return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).PRETTY:
            default:
                return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
        }
    };
    const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
        const timeTrackingSettings = {
            workingHoursPerDay: workingHoursPerDay || (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions).workingHoursPerDay,
            workingDaysPerWeek: workingDaysPerWeek || (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions).workingDaysPerWeek,
            timeFormat: timeFormat || (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions).timeFormat,
            defaultUnit: (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions).defaultUnit
        };
        return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
    };
    const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, (0, parcelRequire("gBj4V")).defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
        const isTimeValid = timeInSeconds > 0;
        const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
        const unit = (0, (0, parcelRequire("4TB2x")).createUnit)(timeInSeconds);
        const units = [
            unit({
                type: 'week',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitLongWeek,
                seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'day',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitLongDay,
                transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
                seconds: Math.max(workingHoursPerDay, 0) * (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'hour',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitLongHour,
                transform: $5d7d4350edc91a82$var$validate(isTimeValid),
                seconds: (0, (0, parcelRequire("gBj4V")).SECONDS_PER_HOUR)
            }),
            unit({
                type: 'minute',
                suffix: (0, (0, parcelRequire("lgkxY")).default).timeUnitLongMinute,
                seconds: (0, (0, parcelRequire("gBj4V")).SECONDS_PER_MINUTE)
            })
        ];
        switch(timeFormat){
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).DAYS:
                return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                    day: units[1].time
                })}`);
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).HOURS:
                return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                    hour: units[2].time
                })}`);
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).PRETTY:
            default:
                return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
        }
    };
    const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
        switch(String(format).toLowerCase()){
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).DAYS:
                return (0, (0, parcelRequire("gBj4V")).TimeFormats).DAYS;
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).HOURS:
                return (0, (0, parcelRequire("gBj4V")).TimeFormats).HOURS;
            case (0, (0, parcelRequire("gBj4V")).TimeFormats).PRETTY:
                return (0, (0, parcelRequire("gBj4V")).TimeFormats).PRETTY;
            default:
                return (0, (0, parcelRequire("gBj4V")).TimeFormats).DAYS;
        }
    };
    const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
        switch(String(defaultUnit).toLowerCase()){
            case (0, (0, parcelRequire("gBj4V")).TimeUnits).DAY:
                return (0, (0, parcelRequire("gBj4V")).TimeUnits).DAY;
            case (0, (0, parcelRequire("gBj4V")).TimeUnits).HOUR:
                return (0, (0, parcelRequire("gBj4V")).TimeUnits).HOUR;
            case (0, (0, parcelRequire("gBj4V")).TimeUnits).MINUTE:
                return (0, (0, parcelRequire("gBj4V")).TimeUnits).MINUTE;
            case (0, (0, parcelRequire("gBj4V")).TimeUnits).WEEK:
                return (0, (0, parcelRequire("gBj4V")).TimeUnits).WEEK;
            default:
                return (0, (0, parcelRequire("gBj4V")).TimeUnits).DAY;
        }
    };
});
parcelRegister("gBj4V", function(module, exports) {
    $parcel$export(module.exports, "SECONDS_PER_MINUTE", ()=>$f8bb2765f8828f08$export$544c576050746347);
    $parcel$export(module.exports, "SECONDS_PER_HOUR", ()=>$f8bb2765f8828f08$export$3cc7ae4b390f50a);
    $parcel$export(module.exports, "TimeFormats", ()=>$f8bb2765f8828f08$export$5d7ed58d46354b1);
    $parcel$export(module.exports, "TimeUnits", ()=>$f8bb2765f8828f08$export$5d7753c8ad881494);
    $parcel$export(module.exports, "defaultTimeTrackingOptions", ()=>$f8bb2765f8828f08$export$f8d48c1fed813e90);
    const $f8bb2765f8828f08$export$544c576050746347 = 60;
    const $f8bb2765f8828f08$export$a4982fdb1458274 = 60;
    const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$export$a4982fdb1458274 * $f8bb2765f8828f08$export$544c576050746347;
    const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
    const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
    const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
    const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
        PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
        DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
        HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
    });
    const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
    const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
    const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
    const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
    const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
        WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
        DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
        HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
        MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
    });
    const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
        workingHoursPerDay: 8,
        workingDaysPerWeek: 5,
        timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
        defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
    };
});
parcelRegister("lgkxY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00e424f4a1d744f3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeUnitWeek: {
            "id": "time-tracking-formatter.time-unit-week",
            "defaultMessage": "w"
        },
        timeUnitDay: {
            "id": "time-tracking-formatter.time-unit-day",
            "defaultMessage": "d"
        },
        timeUnitHour: {
            "id": "time-tracking-formatter.time-unit-hour",
            "defaultMessage": "h"
        },
        timeUnitMinute: {
            "id": "time-tracking-formatter.time-unit-minute",
            "defaultMessage": "m"
        },
        timeUnitLongWeek: {
            "id": "time-tracking-formatter.time-unit-long-week",
            "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
        },
        timeUnitLongDay: {
            "id": "time-tracking-formatter.time-unit-long-day",
            "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
        },
        timeUnitLongHour: {
            "id": "time-tracking-formatter.time-unit-long-hour",
            "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
        },
        timeUnitLongMinute: {
            "id": "time-tracking-formatter.time-unit-long-minute",
            "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
        }
    });
});
parcelRegister("4TB2x", function(module, exports) {
    $parcel$export(module.exports, "createUnit", ()=>$d8f5ee4c356dec74$export$aab44654646f3ccc);
    const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
            const distance = timeInSeconds / seconds;
            const time = transform ? transform(distance) : distance;
            return {
                seconds: seconds,
                suffix: suffix,
                time: time,
                type: type
            };
        };
});
parcelRegister("k698r", function(module, exports) {
    $parcel$export(module.exports, "timeFormatMap", ()=>$f501f8b965f0cf20$export$17f3cee8c0df1);
    var $2Igls;
    const $f501f8b965f0cf20$export$17f3cee8c0df1 = new Map([
        [
            'HOURS',
            (0, (0, parcelRequire("2Igls")).HOURS)
        ],
        [
            'hours',
            (0, (0, parcelRequire("2Igls")).HOURS)
        ],
        [
            'DAYS',
            (0, (0, parcelRequire("2Igls")).DAYS)
        ],
        [
            'days',
            (0, (0, parcelRequire("2Igls")).DAYS)
        ],
        [
            'PRETTY',
            (0, (0, parcelRequire("2Igls")).PRETTY)
        ],
        [
            'pretty',
            (0, (0, parcelRequire("2Igls")).PRETTY)
        ]
    ]);
});
parcelRegister("dC9wp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5aae8c49d2090cb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f5aae8c49d2090cb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.controllers.children-query.error-title",
            "defaultMessage": "We couldn't load items."
        },
        errorMessage: {
            "id": "business-list.controllers.children-query.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("8Ugqh", function(module, exports) {
    $parcel$export(module.exports, "useSetChildrenItems", ()=>$ddd86149d753423f$export$1d27e69d8e0f02db);
    var $5uXOq = parcelRequire("5uXOq");
    var $8TUlY;
    var $acMuh;
    var $9u99d;
    const $ddd86149d753423f$export$1d27e69d8e0f02db = ()=>{
        const [, { setChildrenItems: setChildrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, (0, parcelRequire("acMuh")).useRowCreateStore)();
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const setChildrenItemsWithDependencies = (0, $5uXOq.useCallback)((parentIssueId, queryData)=>setChildrenItems(parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache), [
            setChildrenItems,
            rowCreateState,
            setRowCreatePosition,
            hierarchyLevelsWithCache
        ]);
        return {
            setChildrenItems: setChildrenItemsWithDependencies
        };
    };
});
parcelRegister("acMuh", function(module, exports) {
    $parcel$export(module.exports, "useRowCreateStore", ()=>$4b5fb03663355d26$export$b9c0fc956229dde8);
    var $3sQ5x;
    var $iXqE5;
    const $4b5fb03663355d26$var$initialState = {
        parentId: undefined,
        anchorId: undefined
    };
    const $4b5fb03663355d26$var$actions = {
        setRowCreatePosition: (rowCreatePosition)=>({ setState: setState })=>{
                if (rowCreatePosition) setState(rowCreatePosition);
            },
        resetRowCreatePosition: ()=>({ setState: setState })=>setState($4b5fb03663355d26$var$initialState)
    };
    const $4b5fb03663355d26$var$ListViewRowCreateStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $4b5fb03663355d26$var$initialState,
        actions: $4b5fb03663355d26$var$actions,
        name: 'JWMListViewRowInlineCreate'
    });
    const $4b5fb03663355d26$export$b9c0fc956229dde8 = (0, (0, parcelRequire("3sQ5x")).createHook)($4b5fb03663355d26$var$ListViewRowCreateStore);
});
parcelRegister("jahNX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$299757a118bd0bad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $8tf7c;
    var $1XJ20;
    var $eTDjN;
    var $8e3Yw;
    var $gwq1c;
    var $igEI3;
    var $4k0re;
    var $9u99d;
    var $5mOA5;
    var $1Qz1F;
    const $299757a118bd0bad$var$GroupsLoader = ()=>{
        const items = (0, (0, parcelRequire("gwq1c")).useListItemGroups)();
        const { childrenLoader: childrenLoader } = (0, (0, parcelRequire("4k0re")).useGroupChildrenLoader)({
            groups: items.data
        });
        const prevItems = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(items);
        const [, { expandFirstItems: expandFirstItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { setHierarchyData: setHierarchyData } = (0, (0, parcelRequire("1Qz1F")).useSetHierarchyData)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("eTDjN")).LOAD_GROUP_ITEMS_EXPERIENCE), {
            loading: items.loading,
            error: items.error,
            shouldStartExperience: true
        });
        (0, (0, parcelRequire("5mOA5")).useResetItems)();
        (0, $5uXOq.useEffect)(()=>{
            if (items.loading) return;
            setHierarchyData(items);
        }, [
            items.loading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (prevItems.totalCount !== items.totalCount || prevItems.loading !== items.loading || prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
        }, [
            items,
            prevItems,
            setHierarchyData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!items.loading && groupByFieldId != null) expandFirstItems();
        }, [
            items.loading,
            groupByFieldId
        ]);
        const groupChildrenLoader = (0, $5uXOq.useMemo)(()=>childrenLoader, [
            childrenLoader
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, groupChildrenLoader, items.error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tf7c")).ErrorFlag), {
            error: items.error,
            title: (0, (0, parcelRequire("igEI3")).default).errorTitle,
            description: (0, (0, parcelRequire("igEI3")).default).errorMessage
        }));
    };
    var $299757a118bd0bad$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($299757a118bd0bad$var$GroupsLoader);
});
parcelRegister("gwq1c", function(module, exports) {
    $parcel$export(module.exports, "useListItemGroups", ()=>$e2a9a1a3d0a8153f$export$cc19d2aa74250242);
    var $5YBrl;
    var $gribp;
    var $8e3Yw;
    const $e2a9a1a3d0a8153f$export$cc19d2aa74250242 = ()=>{
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        return (0, (0, parcelRequire("gribp")).useListItemGroups)({
            input: {
                jqlContext: jqlContext,
                groupByFieldId: groupByFieldId
            }
        });
    };
});
parcelRegister("gribp", function(module, exports) {
    $parcel$export(module.exports, "getGroupVariables", ()=>$b5de0af99da479ba$export$5c591b26f9c07c51);
    $parcel$export(module.exports, "useListViewGroupRecovery", ()=>$b5de0af99da479ba$export$30e59d989a124a32);
    $parcel$export(module.exports, "useListItemGroups", ()=>$b5de0af99da479ba$export$cc19d2aa74250242);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $5tTFS;
    var $hE5wF;
    var $fyPbs;
    var $jcw0u;
    var $4R6GH;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $4NLOw;
    var $3WUKM;
    var $ktYkO;
    const $b5de0af99da479ba$var$DEFAULT_ITEMS_PER_PAGE = 50;
    const $b5de0af99da479ba$var$emptyArray = [];
    const $b5de0af99da479ba$var$fieldIds = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID),
        (0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    ];
    const $b5de0af99da479ba$export$5c591b26f9c07c51 = ({ groupByFieldId: groupByFieldId, jqlContext: jqlContext })=>{
        const jql = jqlContext || '';
        return {
            jql: jql,
            first: $b5de0af99da479ba$var$DEFAULT_ITEMS_PER_PAGE,
            groupByFieldId: groupByFieldId != null ? groupByFieldId : '',
            fieldIds: $b5de0af99da479ba$var$fieldIds
        };
    };
    const $b5de0af99da479ba$export$30e59d989a124a32 = (input, settings)=>{
        const variables = $b5de0af99da479ba$export$5c591b26f9c07c51(input);
        return (0, (0, parcelRequire("fyPbs")).useGroupRecovery)({
            settings: settings,
            queryList: (0, (0, parcelRequire("3WUKM")).LIST_VIEW_ITEM_GROUPS_QUERY),
            queryBackgroundList: (0, (0, parcelRequire("3WUKM")).BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY),
            variables: variables,
            onError: (apolloError)=>{
                if (!(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(apolloError) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures_services')) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listRecoveryGroupQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch issues in background in list view while grouping'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    };
    const $b5de0af99da479ba$export$cc19d2aa74250242 = ({ input: input })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
        const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, (0, parcelRequire("5tTFS")).useQuery)((0, (0, parcelRequire("3WUKM")).LIST_VIEW_ITEM_GROUPS_QUERY), {
            variables: $b5de0af99da479ba$export$5c591b26f9c07c51(input),
            onCompleted: (responseData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemGroupsQuery succeeded', {
                    groupsCount: responseData.groups?.nodes?.length
                });
            },
            onError: (apolloError)=>{
                if (!(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(apolloError) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures_services')) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewItemGroupsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch item groups in list view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const totalCount = data?.groups?.totalCount || 0;
        const nodes = data?.groups?.nodes || $b5de0af99da479ba$var$emptyArray;
        const hasNextPage = data?.groups?.pageInfo?.hasNextPage || false;
        const endCursor = data?.groups?.pageInfo?.endCursor || '';
        const result = (0, $5uXOq.useMemo)(()=>{
            if (!Array.isArray(nodes) || nodes.length === 0) return [];
            return (0, (0, parcelRequire("ktYkO")).transformResult)(nodes);
        }, [
            nodes
        ]);
        const loadNextPage = (0, $5uXOq.useCallback)(()=>{
            if (!hasNextPage || loading) return;
            setIsLoadingNextPage(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
            fetchMore({
                variables: {
                    ...$b5de0af99da479ba$export$5c591b26f9c07c51(input),
                    after: endCursor
                },
                updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                    setIsLoadingNextPage(false);
                    if (!fetchMoreResult) return prev;
                    const updatedNodes = [
                        ...prev?.groups?.nodes || [],
                        ...fetchMoreResult?.groups?.nodes || []
                    ];
                    return {
                        groups: {
                            ...fetchMoreResult.groups,
                            nodes: (0, ($parcel$interopDefault($3JOCw)))(updatedNodes, 'id')
                        }
                    };
                },
                onError: (apolloError)=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'listViewItemGroupsQuery',
                            packageName: 'jiraBusinessList',
                            teamName: 'keystone'
                        },
                        attributes: {
                            message: 'Failed to fetch more item groups in list view'
                        },
                        error: apolloError,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }, [
            createAnalyticsEvent,
            endCursor,
            fetchMore,
            hasNextPage,
            input,
            loading
        ]);
        return {
            data: result,
            loading: loading,
            error: error,
            totalCount: totalCount,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loadNextPage: loadNextPage
        };
    };
});
parcelRegister("fyPbs", function(module, exports) {
    $parcel$export(module.exports, "useGroupRecovery", ()=>$21c2f85161b33d23$export$b5990c6f00139390);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $8my64;
    var $jcw0u;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $cvbVg;
    const $21c2f85161b33d23$var$MAX_ITEMS_PER_PAGE = 50;
    const $21c2f85161b33d23$var$getOperationName = (query)=>{
        const operation = (0, (0, parcelRequire("8my64")).getOperationAST)(query, undefined);
        return operation && operation.name && operation.name.value || '';
    };
    const $21c2f85161b33d23$export$b5990c6f00139390 = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onError: onError })=>{
        const analyticsTaskId = $21c2f85161b33d23$var$getOperationName(queryBackgroundList);
        const analyticsTaskName = 'groupsBackgroundRefetch';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const backgroundQueryVariables = (0, $5uXOq.useMemo)(()=>({
                ...variables,
                first: $21c2f85161b33d23$var$MAX_ITEMS_PER_PAGE
            }), [
            variables
        ]);
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const [fetchListInBackground, { loading: loading, data: data, fetchMore: fetchMore }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(queryBackgroundList, {
            fetchPolicy: 'network-only',
            onError: onError
        });
        const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(false);
        const [hasFinished, setHasFinished] = (0, $5uXOq.useState)(false);
        const [refreshCount, setRefreshCount] = (0, $5uXOq.useState)(0);
        const [currentQuery, setCurrentQuery] = (0, $5uXOq.useState)();
        const [currentGroup, setCurrentGroup] = (0, $5uXOq.useState)();
        const listEndCursor = (0, $5uXOq.useRef)(undefined);
        const { hasNextPage: hasNextPage, endCursor: endCursor } = data?.backgroundGroups?.pageInfo || {};
        const prevEndCursor = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(endCursor);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStarted && hasNextPage && endCursor !== listEndCursor.current && endCursor !== prevEndCursor) fetchMore({
                variables: {
                    ...backgroundQueryVariables,
                    after: endCursor
                },
                updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prev;
                    const updatedNodes = [
                        ...prev?.backgroundGroups?.nodes || [],
                        ...fetchMoreResult?.backgroundGroups?.nodes || []
                    ];
                    return {
                        backgroundGroups: {
                            ...fetchMoreResult.backgroundGroups,
                            nodes: updatedNodes
                        }
                    };
                }
            });
        }, [
            hasStarted,
            hasNextPage,
            endCursor,
            prevEndCursor,
            fetchListInBackground,
            backgroundQueryVariables,
            fetchMore
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasStarted || variables.jql === currentQuery && variables.groupByFieldId === currentGroup) return;
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                reason: 'query has changed'
            });
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            setCurrentGroup(undefined);
        }, [
            analyticsTaskId,
            createAnalyticsEvent,
            currentGroup,
            currentQuery,
            hasStarted,
            variables,
            variables.groupByFieldId,
            variables.jql
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
                const backgroundListData = client.readQuery({
                    query: queryBackgroundList,
                    variables: backgroundQueryVariables
                });
                const getCachedListData = ()=>{
                    try {
                        const read = client.readQuery({
                            query: queryList,
                            variables: variables
                        });
                        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                            task: analyticsTaskName,
                            taskId: analyticsTaskId
                        });
                        return read;
                    } catch (e) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: e instanceof Error ? e : new Error('Unknown cache read error'),
                            meta: {
                                id: 'useGroupRecovery',
                                packageName: 'jiraBusinessListHandlers',
                                teamName: 'keystone'
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true,
                            attributes: {
                                task: analyticsTaskName,
                                taskId: analyticsTaskId,
                                query: JSON.stringify(queryList),
                                variables: JSON.stringify(variables),
                                eventName: 'apolloCacheRead taskFail',
                                error: JSON.stringify(e)
                            }
                        });
                        return null;
                    }
                };
                const listData = getCachedListData();
                setRefreshCount(refreshCount + 1);
                setHasFinished(true);
                setHasStarted(false);
                setCurrentQuery(undefined);
                setCurrentGroup(undefined);
                if (!backgroundListData || backgroundListData.backgroundGroups == null || !listData || listData.groups == null || !Array.isArray(backgroundListData.backgroundGroups.nodes) || !Array.isArray(listData.groups.nodes)) throw new Error('Conditions not met');
                const { backgroundGroups: backgroundGroups } = backgroundListData;
                if (backgroundGroups.nodes == null) return;
                client.writeQuery({
                    query: queryList,
                    variables: variables,
                    data: {
                        groups: {
                            ...backgroundGroups,
                            nodes: backgroundGroups.nodes
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                    task: analyticsTaskName,
                    taskId: analyticsTaskId,
                    details: `${backgroundGroups.nodes.length} items updated`
                });
            } catch (e) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                    task: analyticsTaskName,
                    taskId: analyticsTaskId,
                    error: `Failed to refresh data in the background (${e.name || 'error'})`
                });
            }
        }, [
            hasStarted,
            client,
            loading,
            hasFinished,
            refreshCount,
            backgroundQueryVariables,
            queryList,
            queryBackgroundList,
            variables,
            createAnalyticsEvent,
            analyticsTaskId,
            endCursor
        ]);
        const refreshList = (0, $5uXOq.useCallback)(()=>{
            if (hasStarted && !hasFinished || settings.isDisabled) return;
            const listData = client.readQuery({
                query: queryList,
                variables: variables
            });
            listEndCursor.current = listData?.groups?.pageInfo?.endCursor;
            fetchListInBackground({
                variables: backgroundQueryVariables
            });
            setCurrentQuery(variables.jql);
            setCurrentGroup(variables.groupByFieldId);
            setHasStarted(true);
            setHasFinished(false);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
                task: analyticsTaskName,
                taskId: analyticsTaskId
            });
        }, [
            analyticsTaskId,
            backgroundQueryVariables,
            client,
            createAnalyticsEvent,
            fetchListInBackground,
            hasFinished,
            hasStarted,
            queryList,
            settings.isDisabled,
            variables
        ]);
        const isRefreshing = hasStarted && !hasFinished;
        (0, (0, parcelRequire("cvbVg")).useRefreshInterval)(refreshList, settings.isVisible && !isRefreshing, settings.updateInterval);
        return {
            isRefreshing: isRefreshing,
            refreshCount: refreshCount,
            refreshList: refreshList
        };
    };
});
parcelRegister("8my64", function(module, exports) {
    $parcel$export(module.exports, "getOperationAST", ()=>$616ad3b99120bff0$export$1f718485f6b6643f);
    var $bzIlO;
    function $616ad3b99120bff0$export$1f718485f6b6643f(documentAST, operationName) {
        var operation = null;
        for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
            var definition = _documentAST$definiti2[_i2];
            if (definition.kind === (0, (0, parcelRequire("bzIlO")).Kind).OPERATION_DEFINITION) {
                var _definition$name;
                if (operationName == null) {
                    if (operation) return null;
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
            }
        }
        return operation;
    }
});
parcelRegister("3WUKM", function(module, exports) {
    $parcel$export(module.exports, "LIST_VIEW_ITEM_GROUPS_QUERY", ()=>$ece5837ebbdf5681$export$ee6c63a9d588e5da);
    $parcel$export(module.exports, "BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY", ()=>$ece5837ebbdf5681$export$1531880e8d0ec6bc);
    var $5cllN;
    var $cNu0r;
    const $ece5837ebbdf5681$export$ee6c63a9d588e5da = (0, (0, parcelRequire("5cllN")).default)`
    query JWMListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        groups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "groups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, (0, parcelRequire("cNu0r")).JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
    const $ece5837ebbdf5681$export$1531880e8d0ec6bc = (0, (0, parcelRequire("5cllN")).default)`
    query JiraBusinessBackgroundListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        backgroundGroups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "backgroundGroups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, (0, parcelRequire("cNu0r")).JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
});
parcelRegister("cNu0r", function(module, exports) {
    $parcel$export(module.exports, "JWM_CATEGORY_OPTIONS_FRAGMENT", ()=>$1a2ec678845bd42b$export$61519670a3514192);
    var $5cllN;
    const $1a2ec678845bd42b$export$61519670a3514192 = (0, (0, parcelRequire("5cllN")).default)`
    fragment JwmCategoryOptionsFragment on JiraWorkManagementCategoryOption {
        id
        color
        option {
            id
            optionId
            value
            isDisabled
        }
    }
`;
});
parcelRegister("ktYkO", function(module, exports) {
    $parcel$export(module.exports, "createGroupIssueId", ()=>$f28447dc530bd153$export$4ac2cce4af64b535);
    $parcel$export(module.exports, "transformResult", ()=>$f28447dc530bd153$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "getGroupQuery", ()=>$f28447dc530bd153$export$399b257fbf191156);
    $parcel$export(module.exports, "findItemGroup", ()=>$f28447dc530bd153$export$326ed4587250ed11);
    $parcel$export(module.exports, "createItemGroup", ()=>$f28447dc530bd153$export$c8d5f559d504cbde);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $42GbZ;
    var $hE5wF;
    var $57lFd;
    var $deqCE;
    var $jDUax;
    var $dXq4S;
    var $5fc53;
    const $f28447dc530bd153$export$4ac2cce4af64b535 = (nodeId)=>`${0, (0, parcelRequire("deqCE")).GROUP_ITEM_PREFIX}_${nodeId}`;
    const $f28447dc530bd153$export$eb0e89edd4882353 = (statusIdPath = '')=>{
        if (statusIdPath == null) return '';
        const splitStatusIdPath = statusIdPath.split('/');
        return splitStatusIdPath[splitStatusIdPath.length - 1];
    };
    const $f28447dc530bd153$var$getCategory = (field)=>{
        if (field && 'category' in field && field.category != null && field.category.option != null) return {
            fieldKey: field.fieldKey,
            name: field.category.option.value,
            optionId: field.category.option.optionId,
            color: field.category.color ?? null
        };
        return {};
    };
    const $f28447dc530bd153$var$getStoryPoints = (field)=>field?.__typename === 'FloatCustomField' && 'floatValue' in field ? field.floatValue : null;
    const $f28447dc530bd153$var$getSprint = (field)=>{
        if (field && field.__typename === 'SprintCustomField' && field.values && field.values[0]) return {
            fieldKey: field.fieldKey,
            title: field.title,
            id: field.values[0].id,
            name: field.values[0].name,
            state: field.values[0].state
        };
        return null;
    };
    const $f28447dc530bd153$export$f13b29f9ed0c5a03 = (nodes)=>{
        if (!nodes) return [];
        return nodes.map((node)=>{
            const { id: id, field: field } = node || {};
            const values = {};
            if (field && 'fieldKey' in field && field.fieldKey != null) values[field.fieldKey] = field;
            const totalCount = node?.totalCount;
            const groupItem = {
                id: id,
                issueId: $f28447dc530bd153$export$4ac2cce4af64b535(id || ''),
                key: '',
                typeId: '',
                issuetype: {},
                rank: '',
                status: values.status ? {
                    id: values.status.statusId,
                    name: values.status.name,
                    categoryId: values.status.statusCategoryId
                } : {},
                ...values.assignee ? values.assignee.userValue && {
                    assignee: {
                        accountId: values.assignee.userValue.accountId,
                        displayName: values.assignee.userValue.displayName,
                        avatarUrl: values.assignee.userValue.avatarUrl
                    }
                } : {},
                labels: values.labels && values.labels.labels || [],
                priority: values.priority ? {
                    id: values.priority.id,
                    name: values.priority.name,
                    iconUrl: values.priority.iconUrl
                } : {},
                category: $f28447dc530bd153$var$getCategory(field),
                childSummary: {
                    totalCount: totalCount,
                    hasChildren: (totalCount ?? 0) > 0
                },
                storypoints: $f28447dc530bd153$var$getStoryPoints(field),
                storypointestimate: $f28447dc530bd153$var$getStoryPoints(field),
                sprint: $f28447dc530bd153$var$getSprint(field)
            };
            return groupItem;
        });
    };
    const $f28447dc530bd153$export$399b257fbf191156 = ({ groupIssueId: groupIssueId, groupByFieldId: groupByFieldId, groups: groups })=>{
        if (!groups || !groupByFieldId) return undefined;
        const groupItem = groups.find((group)=>group.issueId === groupIssueId);
        if (!groupItem) return undefined;
        if (groupByFieldId === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)) return {
            jqlTerm: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            value: groupItem.assignee?.accountId
        };
        if (groupByFieldId === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)) {
            const priorityId = groupItem?.priority?.id;
            return {
                jqlTerm: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                value: priorityId ? (0, (0, parcelRequire("dXq4S")).getAriConfig)(priorityId).resourceId : undefined
            };
        }
        if (groupByFieldId === (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) {
            const statusId = groupItem?.status?.id;
            return {
                jqlTerm: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                value: statusId ? (0, (0, parcelRequire("dXq4S")).getAriConfig)(statusId).resourceId : undefined
            };
        }
        if (groupByFieldId.startsWith('customfield_')) {
            const getValue = ()=>{
                if (groupItem.category) {
                    const categoryName = groupItem.category?.name ?? undefined;
                    if (categoryName) return `"${categoryName.replace(/"/g, '\\"')}"`;
                }
                if (typeof groupItem.storypoints === 'number') return groupItem.storypoints;
                if (typeof groupItem.storypointestimate === 'number') return groupItem.storypointestimate;
                if (groupItem.sprint) return groupItem.sprint && String(groupItem.sprint?.id) || undefined;
                return undefined;
            };
            return {
                jqlTerm: (0, (0, parcelRequire("42GbZ")).getJqlTerm)(groupByFieldId),
                value: getValue()
            };
        }
        return undefined;
    };
    const $f28447dc530bd153$export$326ed4587250ed11 = ({ item: item, groups: groups, groupByFieldId: groupByFieldId, isGroupingByCategory: isGroupingByCategory = false })=>{
        if (!groups || !groupByFieldId) return undefined;
        const field = (0, (0, parcelRequire("57lFd")).getFieldValue)(item.fields, groupByFieldId);
        if (!field && isGroupingByCategory) return groups.find((group)=>!group.category?.name);
        return groups.find((group)=>{
            switch(field?.type){
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return String(group?.category?.optionId) === String((0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'fieldOption', undefined)?.optionId);
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                    return groupByFieldId && group.assignee?.accountId === (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'user', undefined)?.accountId;
                case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                    return groupByFieldId && $f28447dc530bd153$export$eb0e89edd4882353(group.status?.id) === (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'status.statusId', undefined);
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return groupByFieldId && group.priority?.name === (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'priority.name', undefined);
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    return $f28447dc530bd153$var$getSprintGroup(item, group);
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return groupByFieldId && group.storypointestimate === (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
                case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                    if (field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return groupByFieldId && group.storypoints === (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
                    return false;
                default:
                    return false;
            }
        });
    };
    const $f28447dc530bd153$var$getSprintGroup = (item, group)=>{
        const sprintId = (0, (0, parcelRequire("57lFd")).safeGetValue)(item.fields, 'sprint', 'selectedSprintsConnection.edges[0].node.sprintId', undefined);
        if (!sprintId) return group.sprint === null;
        return group.sprint?.id === Number(sprintId);
    };
    const $f28447dc530bd153$export$c86575e2d4de1020 = ({ item: item, groupItemsQueryData: groupItemsQueryData })=>{
        if (!groupItemsQueryData) return undefined;
        const keys = Object.keys(groupItemsQueryData);
        const matchingGroups = keys.filter((groupIssueId)=>groupItemsQueryData[groupIssueId].data?.find((node)=>node.issueId === item.issueId));
        return matchingGroups.find((groupName)=>(0, (0, parcelRequire("jDUax")).isGroupItem)(groupName)) ?? matchingGroups[0];
    };
    const $f28447dc530bd153$var$convertFieldToGroupItemField = (groupByFieldId, field)=>{
        if (groupByFieldId === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE) && field) {
            const userField = field;
            const convertedField = {
                fieldKey: groupByFieldId,
                userValue: {
                    accountId: userField.user?.accountId ?? null,
                    displayName: userField.user?.name ?? null,
                    avatarUrl: userField.user?.picture,
                    __typename: 'UserValue'
                },
                __typename: 'UserField'
            };
            return convertedField;
        }
        if (groupByFieldId === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE) && field) {
            const priorityField = field;
            const convertedField = {
                fieldKey: groupByFieldId,
                name: priorityField.priority?.name ?? null,
                id: priorityField.priority?.id ?? null,
                iconUrl: priorityField.priority?.iconUrl,
                __typename: 'PriorityField'
            };
            return convertedField;
        }
        if (groupByFieldId?.startsWith('customfield_') && field) {
            if (field.__typename === 'JiraSingleSelectField' && field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                const categoryField = field;
                if (categoryField.fieldOption) {
                    const convertedField = {
                        category: {
                            color: categoryField.fieldOption?.color?.colorKey ?? null,
                            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                            option: {
                                id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                                isDisabled: false,
                                optionId: categoryField.fieldOption.optionId,
                                value: categoryField.fieldOption.value,
                                __typename: 'JiraOption'
                            },
                            __typename: 'JiraWorkManagementCategoryOption'
                        },
                        selectedValue: {
                            optionId: categoryField.fieldOption.optionId,
                            value: categoryField.fieldOption.value ?? '',
                            __typename: 'Option'
                        },
                        fieldKey: field.fieldId,
                        __typename: 'JWMCategoryCustomField'
                    };
                    return convertedField;
                }
            }
            if (field.__typename === 'JiraNumberField') {
                const convertedField = {
                    fieldKey: field.fieldId,
                    floatValue: field.number,
                    __typename: 'FloatCustomField'
                };
                return convertedField;
            }
        }
        return field;
    };
    const $f28447dc530bd153$export$c8d5f559d504cbde = ({ item: item, groupByFieldId: groupByFieldId })=>{
        if (!item || !groupByFieldId) return undefined;
        let field = (0, (0, parcelRequire("57lFd")).getFieldValue)(item.fields, groupByFieldId);
        if (!field) return;
        if (field && groupByFieldId) field = $f28447dc530bd153$var$convertFieldToGroupItemField(groupByFieldId, field);
        return {
            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
            field: field,
            totalCount: 1,
            __typename: 'JWMItemGroup'
        };
    };
});
parcelRegister("igEI3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c124b0de0e2a63f6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c124b0de0e2a63f6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.controllers.with-grouping.error-title",
            "defaultMessage": "We couldn't load item groups."
        },
        errorMessage: {
            "id": "business-list.controllers.with-grouping.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("4k0re", function(module, exports) {
    $parcel$export(module.exports, "useGroupChildrenLoader", ()=>$65f2238f74c2c43e$export$2f8ce4dc0f882a8a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jDUax;
    var $8e3Yw;
    var $gUe9l;
    var $9u99d;
    var $8Ugqh;
    const $65f2238f74c2c43e$export$2f8ce4dc0f882a8a = ({ groups: groups })=>{
        const [{ expandedItems: expandedItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const { setChildrenItems: setChildrenItems } = (0, (0, parcelRequire("8Ugqh")).useSetChildrenItems)();
        const childrenLoader = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUe9l")).GroupItemsController), {
                expandedGroupItemIssueIds: Object.keys(expandedItems).filter((0, (0, parcelRequire("jDUax")).isGroupItem)),
                groupByFieldId: groupByFieldId,
                onDataChange: setChildrenItems,
                groups: groups
            }), [
            expandedItems,
            groupByFieldId,
            groups,
            setChildrenItems
        ]);
        return {
            childrenLoader: childrenLoader
        };
    };
});
parcelRegister("gUe9l", function(module, exports) {
    $parcel$export(module.exports, "GroupItemsController", ()=>$566720f75a8bbd98$export$bf0c6c1ff455a90f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ktYkO;
    var $8BlVu;
    const $566720f75a8bbd98$export$bf0c6c1ff455a90f = (0, $5uXOq.memo)(({ expandedGroupItemIssueIds: expandedGroupItemIssueIds, groupByFieldId: groupByFieldId, groups: groups, onDataChange: onDataChange })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, expandedGroupItemIssueIds.map((expandedGroupItemIssueId)=>{
            const groupQuery = (0, (0, parcelRequire("ktYkO")).getGroupQuery)({
                groups: groups,
                groupIssueId: expandedGroupItemIssueId,
                groupByFieldId: groupByFieldId
            });
            if (!groupQuery) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8BlVu")).GroupItemsQueryController), {
                groupIssueId: expandedGroupItemIssueId,
                onDataChange: onDataChange,
                key: expandedGroupItemIssueId,
                groupQuery: groupQuery
            });
        })), (prevProps, nextProps)=>{
        const prevIssueIds = prevProps.expandedGroupItemIssueIds.sort();
        const nextIssueIds = nextProps.expandedGroupItemIssueIds.sort();
        return prevProps.onDataChange === nextProps.onDataChange && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]);
    });
});
parcelRegister("8BlVu", function(module, exports) {
    $parcel$export(module.exports, "GroupItemsQueryController", ()=>$a5348e1835fae9e7$export$e689a28b990fb20b);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $cm8b5;
    var $kRkJF;
    var $jcw0u;
    var $8tf7c;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $h7hV2;
    var $8TUlY;
    var $mH57d;
    var $39n00;
    const $a5348e1835fae9e7$export$e689a28b990fb20b = (0, $5uXOq.memo)(({ groupIssueId: groupIssueId, groupQuery: groupQuery, onDataChange: onDataChange })=>{
        const { hierarchyParent: hierarchyParent } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const isValidFiltersJql = !jqlErrors.length;
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const { data: data, loading: isLoadingItems, error: error, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage } = (0, (0, parcelRequire("h7hV2")).useListViewIssues)({
            input: {
                jqlContext: jqlContext,
                fieldIds: getQueryFieldIds(),
                quickFiltersJql: quickFiltersJql,
                sorting: sorting,
                groupQuery: groupQuery,
                hierarchyParent: hierarchyParent,
                isHidingDoneItems: isHidingDoneItems,
                projectIdOrKey: projectKey,
                isParentFieldVisible: isParentFieldVisible(),
                isDevSummaryFieldVisible: isDevSummaryFieldVisible()
            },
            condition: isLoadingFields === false && isValidFiltersJql
        });
        const loading = !isValidFiltersJql ? false : isLoadingFields || isLoadingItems;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const totalIssues = data?.length;
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("eTDjN")).LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE), {
            loading: loading,
            error: error,
            shouldStartExperience: true
        });
        (0, $5uXOq.useEffect)(()=>{
            if (loading || typeof totalIssues !== 'number') return;
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'listGroupItemsQuery succeeded', {
                totalIssues: totalIssues
            });
        }, [
            loading,
            createAnalyticsEvent,
            totalIssues
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'listGroupItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to query group items in list view'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            error
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (jqlErrors.length) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'listGroupItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error in the JQL query'
                },
                error: jqlErrors[0],
                skipSentry: true
            });
        }, [
            jqlErrors
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onDataChange(groupIssueId, {
                data: data,
                loading: loading,
                error: error,
                loadNextPage: loadNextPage,
                isLoadingNextPage: isLoadingNextPage,
                hasNextPage: hasNextPage
            });
        }, [
            data,
            error,
            loading,
            loadNextPage,
            isLoadingNextPage,
            onDataChange,
            groupIssueId,
            hasNextPage
        ]);
        return error ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tf7c")).ErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("39n00")).default).errorTitle,
            description: (0, (0, parcelRequire("39n00")).default).errorMessage
        }) : null;
    });
});
parcelRegister("mH57d", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyConfig", ()=>$a6cf1187f2a7220c$export$4691cc2dea373ff0);
    var $kRkJF;
    const $a6cf1187f2a7220c$export$4691cc2dea373ff0 = ()=>{
        const { isFiltering: isFiltering } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const hierarchyParent = !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
        return {
            showFlatList: isFiltering,
            hierarchyParent: hierarchyParent
        };
    };
});
parcelRegister("39n00", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3568df50bca07fe3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3568df50bca07fe3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.controllers.group-items-query.error-title",
            "defaultMessage": "We couldn't load group items."
        },
        errorMessage: {
            "id": "business-list.controllers.group-items-query.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("5mOA5", function(module, exports) {
    $parcel$export(module.exports, "useResetItems", ()=>$b066ea047574cf0c$export$266465ecb6779ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $kRkJF;
    var $l4Ejo;
    var $dpQnO;
    var $8e3Yw;
    var $9u99d;
    const $b066ea047574cf0c$export$266465ecb6779ef7 = ()=>{
        const { sorting: sorting } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const [{ hierarchyData: { loading: loading } }, { resetCache: resetCache, clearHierarchyData: clearHierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const lastSorting = (0, $5uXOq.useRef)({
            ...sorting
        });
        const lastJqlFiltering = (0, $5uXOq.useRef)(jql);
        const lastQuickFilterJql = (0, $5uXOq.useRef)(quickFiltersJql);
        const lastGroupByFieldId = (0, $5uXOq.useRef)(groupByFieldId);
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return;
            const hasSortingChanged = lastSorting.current.sortBy !== sorting.sortBy || lastSorting.current.direction !== sorting.direction;
            const hasFilteringChanged = lastJqlFiltering.current !== jql || lastQuickFilterJql.current !== quickFiltersJql;
            const hasGroupByFieldIdChanged = lastGroupByFieldId.current !== groupByFieldId;
            if (hasGroupByFieldIdChanged || hasSortingChanged || hasFilteringChanged) {
                resetCache();
                lastSorting.current = sorting;
                lastJqlFiltering.current = jql;
                lastQuickFilterJql.current = quickFiltersJql;
                lastGroupByFieldId.current = groupByFieldId;
            }
        }, [
            groupByFieldId,
            loading,
            sorting,
            resetCache,
            jql,
            quickFiltersJql
        ]);
        (0, $5uXOq.useEffect)(()=>{
            clearHierarchyData();
        }, [
            projectKey,
            clearHierarchyData
        ]);
    };
});
parcelRegister("1Qz1F", function(module, exports) {
    $parcel$export(module.exports, "useSetHierarchyData", ()=>$261cbc59f08097d5$export$b96814cd86fd4960);
    var $5uXOq = parcelRequire("5uXOq");
    var $8TUlY;
    var $acMuh;
    var $mH57d;
    var $9u99d;
    const $261cbc59f08097d5$export$b96814cd86fd4960 = ()=>{
        const [, { setHierarchyData: setHierarchyData, refreshHierarchy: refreshHierarchy }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, (0, parcelRequire("acMuh")).useRowCreateStore)();
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const { showFlatList: showFlatList } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        (0, $5uXOq.useEffect)(()=>{
            refreshHierarchy(rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache);
        }, [
            rowCreateState,
            setRowCreatePosition,
            hierarchyLevelsWithCache,
            refreshHierarchy
        ]);
        const setHierarchyDataWithDependencies = (0, $5uXOq.useCallback)((queryData)=>setHierarchyData(queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache, showFlatList), [
            setHierarchyData,
            rowCreateState,
            setRowCreatePosition,
            hierarchyLevelsWithCache,
            showFlatList
        ]);
        return {
            setHierarchyData: setHierarchyDataWithDependencies
        };
    };
});
parcelRegister("aKtkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$937e553ba1f63081$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $cm8b5;
    var $kRkJF;
    var $jcw0u;
    var $8tf7c;
    var $1XJ20;
    var $eTDjN;
    var $h7hV2;
    var $tx8ST;
    var $8TUlY;
    var $mH57d;
    var $9u99d;
    var $5mOA5;
    var $1Qz1F;
    var $4AG94;
    const $937e553ba1f63081$export$9e1fb4c88b271603 = ()=>{
        const [{ hierarchyLevel: hierarchyLevel }, { resetHierarchyLevel: resetHierarchyLevel, setHierarchyLevel: setHierarchyLevel }] = (0, (0, parcelRequire("tx8ST")).useHierarchyLevel)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { showFlatList: showFlatList, hierarchyParent: hierarchyParent } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const prevShowFlatList = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(showFlatList);
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const queryFieldIds = getQueryFieldIds();
        const isValidFiltersJql = !jqlErrors.length;
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const items = (0, (0, parcelRequire("h7hV2")).useListViewIssues)({
            input: {
                jqlContext: jqlContext,
                quickFiltersJql: quickFiltersJql,
                fieldIds: queryFieldIds,
                sorting: sorting,
                hierarchyLevel: hierarchyLevel,
                hierarchyParent: hierarchyParent,
                isHidingDoneItems: isHidingDoneItems,
                projectIdOrKey: projectKey,
                isParentFieldVisible: isParentFieldVisible(),
                isDevSummaryFieldVisible: isDevSummaryFieldVisible()
            },
            condition: typeof hierarchyLevel === 'number' && queryFieldIds.length > 0 && isValidFiltersJql
        });
        (0, $5uXOq.useEffect)(()=>{
            if (hierarchyLevel == null && hierarchyLevelsWithCache.length) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
        }, [
            hierarchyLevel,
            hierarchyLevelsWithCache,
            setHierarchyLevel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hierarchyLevelsWithCache.length && prevShowFlatList && !showFlatList) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
        }, [
            showFlatList,
            prevShowFlatList,
            setHierarchyLevel,
            hierarchyLevelsWithCache
        ]);
        (0, $5uXOq.useEffect)(()=>()=>resetHierarchyLevel(), []);
        const levels = (0, $5uXOq.useMemo)(()=>[
                ...new Set(hierarchyLevelsWithCache.map((x)=>x.level))
            ], [
            hierarchyLevelsWithCache
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!items.loading && !items.data.length && hierarchyLevel != null) {
                const nextIndex = levels.indexOf(hierarchyLevel) + 1;
                if (typeof levels[nextIndex] === 'number') setHierarchyLevel(levels[nextIndex]);
            }
        }, [
            hierarchyLevel,
            levels,
            items.data.length,
            items.loading,
            setHierarchyLevel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (jqlErrors.length) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'listHierarchyLoader',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error in the JQL query'
                },
                error: jqlErrors[0],
                skipSentry: true
            });
        }, [
            jqlErrors
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                ...items,
                loading: isValidFiltersJql ? items.loading : false
            }), [
            items,
            isValidFiltersJql
        ]);
    };
    const $937e553ba1f63081$var$HierarchyLoader = ()=>{
        const items = $937e553ba1f63081$export$9e1fb4c88b271603();
        const prevItems = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(items);
        const [, { resetCache: resetCache }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { setHierarchyData: setHierarchyData } = (0, (0, parcelRequire("1Qz1F")).useSetHierarchyData)();
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("eTDjN")).VIEW_EXPERIENCE), {
            loading: items.loading,
            error: items.error
        });
        (0, (0, parcelRequire("5mOA5")).useResetItems)();
        (0, $5uXOq.useEffect)(()=>{
            setHierarchyData(items);
            resetCache();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
        }, [
            items,
            prevItems,
            setHierarchyData
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, items.error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tf7c")).ErrorFlag), {
            error: items.error,
            title: (0, (0, parcelRequire("4AG94")).default).errorTitle,
            description: (0, (0, parcelRequire("4AG94")).default).errorMessage
        }));
    };
    var $937e553ba1f63081$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($937e553ba1f63081$var$HierarchyLoader);
});
parcelRegister("tx8ST", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyLevel", ()=>$2beebbfe8785f523$export$62fdc6b7b35d2861);
    var $3sQ5x;
    var $iXqE5;
    const $2beebbfe8785f523$var$initialState = {
        hierarchyLevel: undefined
    };
    const $2beebbfe8785f523$var$resetHierarchyLevel = ()=>({ setState: setState })=>setState({
                ...$2beebbfe8785f523$var$initialState
            });
    const $2beebbfe8785f523$var$setHierarchyLevel = (hierarchyLevel)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                hierarchyLevel: hierarchyLevel
            });
        };
    const $2beebbfe8785f523$var$actions = {
        resetHierarchyLevel: $2beebbfe8785f523$var$resetHierarchyLevel,
        setHierarchyLevel: $2beebbfe8785f523$var$setHierarchyLevel
    };
    const $2beebbfe8785f523$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2beebbfe8785f523$var$initialState,
        actions: $2beebbfe8785f523$var$actions,
        name: 'JWMHierarchyLevelStore'
    });
    const $2beebbfe8785f523$export$62fdc6b7b35d2861 = (0, (0, parcelRequire("3sQ5x")).createHook)($2beebbfe8785f523$var$Store);
});
parcelRegister("4AG94", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a83dfa9276871092$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a83dfa9276871092$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.controllers.hierarchy.hierarchy-loader.error-title",
            "defaultMessage": "We couldn't load items."
        },
        errorMessage: {
            "id": "business-list.controllers.hierarchy.hierarchy-loader.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("g7iDt", function(module, exports) {
    $parcel$export(module.exports, "useIssueChangeUpdater", ()=>$6303542b071cd29b$export$55b903604085ad27);
    var $5uXOq = parcelRequire("5uXOq");
    var $FTaAj;
    var $aMwM1;
    const $6303542b071cd29b$export$55b903604085ad27 = ()=>{
        const { onIssueRemoved: onIssueRemoved } = (0, (0, parcelRequire("aMwM1")).useListViewUpdaterService)();
        const onIssueChange = (0, $5uXOq.useCallback)((event)=>{
            if (event.type === (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
                const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
                onIssueRemoved({
                    issueId: Number(issueId),
                    parentId: oldParentIssueId || undefined
                });
            }
        }, [
            onIssueRemoved
        ]);
        return {
            onIssueChange: onIssueChange
        };
    };
});
parcelRegister("FTaAj", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
    const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
    const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
    const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
    const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
    const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
        [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
        [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
        [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
        [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
    };
});
parcelRegister("aMwM1", function(module, exports) {
    $parcel$export(module.exports, "useListViewUpdaterService", ()=>$1d9f6e41892ada2f$export$8fe666044644d3c0);
    var $5tTFS;
    var $egmQO;
    var $daQYX;
    var $kRkJF;
    var $jDUax;
    var $hlKA4;
    var $9SwwX;
    var $dCjtG;
    var $gwNxS;
    var $jcw0u;
    var $5fc53;
    var $g5X3G;
    var $koeKL;
    var $ktYkO;
    var $61h55;
    var $bsMMx;
    var $tx8ST;
    var $mk7k0;
    var $8e3Yw;
    var $3xYz2;
    var $mH57d;
    var $9u99d;
    var $dvriG;
    const $1d9f6e41892ada2f$export$8fe666044644d3c0 = ()=>{
        const [{ selectedIssues: selectedIssues, showDeleteModal: showDeleteModal }, { toggleShowDeleteModal: toggleShowDeleteModal, unselectIssues: unselectIssues }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const [{ hierarchyLevel: hierarchyLevel }] = (0, (0, parcelRequire("tx8ST")).useHierarchyLevel)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const fieldIds = (0, (0, parcelRequire("dvriG")).useSupportedFieldIds)();
        const { hierarchyParent: hierarchyParent } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenQueryData, hierarchyData: hierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const groups = hierarchyData.data;
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGroupingByStatus = groupByFieldId === (0, (0, parcelRequire("5fc53")).STATUS_TYPE);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const topLevelVariables = {
            ...(0, (0, parcelRequire("egmQO")).getVariables)({
                jqlContext: jqlContext,
                fieldIds: fieldIds,
                quickFiltersJql: quickFiltersJql,
                sorting: sorting,
                hierarchyLevel: hierarchyLevel,
                hierarchyParent: hierarchyParent,
                isHidingDoneItems: isHidingDoneItems,
                projectIdOrKey: projectKey
            }),
            cloudId: cloudId
        };
        const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, (0, parcelRequire("gwNxS")).createViewUpdaterCallbacksWithCacheActions)({
            query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
            addToCache: addToCache,
            updateItemsInCache: updateItemsInCache,
            removeFromCache: removeFromCache,
            isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
            isInfiniteHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
            createVariablesForItemWithoutParent: ()=>topLevelVariables,
            createVariablesForGroupItem: (groupIssueId)=>({
                    cloudId: cloudId,
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        sorting: sorting,
                        groupQuery: (0, (0, parcelRequire("ktYkO")).getGroupQuery)({
                            groups: groups,
                            groupIssueId: groupIssueId,
                            groupByFieldId: groupByFieldId
                        }),
                        hierarchyParent: hierarchyParent,
                        isHidingDoneItems: isHidingDoneItems
                    })
                }),
            createVariablesForItemWithParent: (parentIssueId)=>{
                if (!hierarchyParent) return topLevelVariables;
                return {
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        sorting: sorting,
                        isHidingDoneItems: isHidingDoneItems,
                        hierarchyParent: undefined,
                        projectIdOrKey: projectKey,
                        parentIssue: {
                            hierarchyType: hierarchyParent,
                            issueId: parentIssueId
                        }
                    }),
                    cloudId: cloudId
                };
            },
            shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, (0, parcelRequire("g5X3G")).toIssueId)(parentIssueId)] !== undefined),
            getParentOfIssueIfExist: (issueId)=>{
                const maybeIssue = issuesMap.get(issueId);
                if (!maybeIssue) return undefined;
                return maybeIssue.parentIssueId ?? (0, (0, parcelRequire("jDUax")).getParentIssueId)(maybeIssue);
            },
            getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
            onUpdateParentWithNewChild: (0, (0, parcelRequire("bsMMx")).addChildToParentListView),
            updateIssueParentMap: (issueId, newParentId)=>{
                if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
                else issueParentMap.delete(String(issueId));
            },
            removeChildFromParent: (0, (0, parcelRequire("bsMMx")).removeChildFromParentListView),
            isGroupingByStatus: isGroupingByStatus,
            isGrouping: !!groupByFieldId
        });
        const isGrouping = groupByFieldId != null;
        const { addToGroupCache: addToGroupCache, removeFromGroupCache: removeFromGroupCache } = (0, (0, parcelRequire("3xYz2")).useGroupCacheActions)({
            fieldIds: fieldIds
        });
        const [getUpdatedIssue] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("61h55")).LIST_VIEW_ITEM_DETAILS_QUERY), {
            fetchPolicy: 'network-only',
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewUpdaterQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch updated issue by id in list view updater'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (result)=>{
                const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list');
                const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
                if (validNodes && validNodes.length > 0) addToGroupCache(validNodes, {
                    updateCountOnly: true
                });
            }
        });
        const handleFilteredUpdate = (issueIds)=>{
            getUpdatedIssue({
                variables: {
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        issueIds: issueIds,
                        fieldIds: fieldIds
                    }),
                    cloudId: cloudId
                }
            });
        };
        const getGroupChildItems = (items)=>{
            const groupChildItems = [];
            const nestedItems = [];
            items.forEach((item)=>{
                const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                if (parentIssueId != null && !(0, (0, parcelRequire("jDUax")).isGroupItem)(parentIssueId) && childrenQueryData && childrenQueryData[parentIssueId]) nestedItems.push(item);
                else groupChildItems.push(item);
            });
            return {
                groupChildItems: groupChildItems,
                nestedItems: nestedItems
            };
        };
        return (0, (0, parcelRequire("dCjtG")).useViewUpdater)({
            input: {
                projectKey: projectKey,
                fieldIds: fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems
            },
            query: (0, (0, parcelRequire("61h55")).LIST_VIEW_ITEM_DETAILS_QUERY),
            actions: [
                {
                    addToCache: (items)=>{
                        if (isGrouping) {
                            const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                            if (groupChildItems.length) return addToGroupCache(groupChildItems);
                            if (nestedItems.length) return addToCacheCallback(items);
                        }
                        return addToCacheCallback(items);
                    },
                    removeFromCache: (items)=>{
                        if (selectedIssues?.size) {
                            let issuesToUnselect = [];
                            items.forEach(({ issueId: issueId })=>{
                                if (selectedIssues.has(String(issueId))) issuesToUnselect = [
                                    ...issuesToUnselect,
                                    String(issueId)
                                ];
                            });
                            if (issuesToUnselect.length) {
                                unselectIssues({
                                    issues: issuesToUnselect
                                });
                                if (issuesToUnselect.length === selectedIssues.size && showDeleteModal) toggleShowDeleteModal({
                                    showDeleteModal: false
                                });
                            }
                        }
                        if (isGrouping) {
                            const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                            if (groupChildItems.length) return removeFromGroupCache(groupChildItems);
                            if (nestedItems.length) return removeFromCacheCallback(items);
                        }
                        return removeFromCacheCallback(items);
                    },
                    handleFilteredUpdate: (issueIds)=>isGrouping ? handleFilteredUpdate(issueIds) : undefined
                }
            ],
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewUpdaterQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch issues in list view updater'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onAppendItemsError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'listViewAppendItemsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to append issues by id in list view updater'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    };
});
parcelRegister("hlKA4", function(module, exports) {
    $parcel$export(module.exports, "useCacheActions", ()=>$f61770b894122deb$export$f79bd85e41a6298f);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $5tTFS;
    var $hE5wF;
    var $57lFd;
    var $jcw0u;
    var $3fAi8;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $ieDtd;
    var $deqCE;
    var $jDUax;
    var $9SwwX;
    const $f61770b894122deb$var$getIssueKey = (fields)=>(0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuekey', 'text', '');
    const $f61770b894122deb$var$getIndexById = (listData, issueId)=>{
        if (listData == null || listData.edges == null) return -1;
        const { edges: edges } = listData;
        return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
    };
    const $f61770b894122deb$export$f79bd85e41a6298f = ()=>{
        const analyticsTaskName = 'useCacheActionsApolloCacheActions';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const [, extractedFieldValueActions] = (0, (0, parcelRequire("3fAi8")).useFieldsValuesActions)();
        const [currentIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const removeIssueFromExtractedFieldsCache = (0, $5uXOq.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
            issueKey != null && issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey), {});
        }, [
            currentIssueKey,
            extractedFieldValueActions
        ]);
        const addToCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'addToCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
            try {
                const newIssueIds = new Set(newNodes.map((item)=>{
                    if (item != null && item.issueId != null) return item.issueId;
                    return undefined;
                }).filter(Boolean));
                newNodes.forEach((item)=>{
                    if (item == null || item.fields == null) return;
                    const issueKey = $f61770b894122deb$var$getIssueKey(item.fields);
                    if (issueKey != null && issueKey !== '') {
                        const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                        const currentIssueId = item.issueId;
                        removeIssueFromExtractedFieldsCache({
                            currentIssueId: currentIssueId,
                            issueKey: issueKey,
                            parentIssueId: parentIssueId
                        });
                    }
                });
                const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                    const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                    const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                    return issue.id.toString().startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
                };
                const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                        node: node,
                        __typename: 'JiraWorkManagementViewItemEdge'
                    }))) ?? [];
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: newIssues,
                                totalCount: newIssues.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            removeIssueFromExtractedFieldsCache
        ]);
        const removeFromCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
            const issueIds = Array.isArray(issueId) ? issueId : [
                issueId
            ];
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'removeFromCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            if (!listData?.edges || !Array.isArray(listData.edges)) return;
            try {
                const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: updatedEdges,
                                totalCount: updatedEdges.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                issueIds.forEach((issue)=>{
                    const index = $f61770b894122deb$var$getIndexById(listData ?? undefined, issue);
                    const item = updatedEdges[index];
                    const issueKey = $f61770b894122deb$var$getIssueKey(item?.node?.fields ?? []);
                    const currentIssueId = (0, ($parcel$interopDefault($9XE6b)))(item, 'issueId', 0);
                    if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey
                    });
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            removeIssueFromExtractedFieldsCache
        ]);
        const getCachedIssueById = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'getCachedIssueById',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
                task: analyticsTaskName
            });
            return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
        }, [
            client,
            createAnalyticsEvent
        ]);
        const updateItemsInCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'updateItemsInCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            const existingEdges = listData?.edges;
            if (existingEdges == null) return;
            try {
                const newEdges = [
                    ...existingEdges
                ];
                let hasItemOverride = false;
                issueIds.forEach((issueId)=>{
                    const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                    const existingIssue = existingEdges[issueToUpdateIndex];
                    if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                    const itemOverride = updateItem(existingIssue.node);
                    if (itemOverride === undefined) return;
                    hasItemOverride = true;
                    newEdges[issueToUpdateIndex] = {
                        node: itemOverride,
                        __typename: 'JiraWorkManagementViewItemEdge'
                    };
                });
                if (!hasItemOverride) return;
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: newEdges,
                                totalCount: newEdges.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent
        ]);
        return {
            addToCache: addToCache,
            removeFromCache: removeFromCache,
            getCachedIssueById: getCachedIssueById,
            updateItemsInCache: updateItemsInCache
        };
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
parcelRegister("dCjtG", function(module, exports) {
    $parcel$export(module.exports, "useViewUpdater", ()=>$92d86c8da94b73a1$export$a7d7c9fa51f6f9e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $egmQO;
    var $5YBrl;
    var $3ItGl;
    var $5fc53;
    var $koeKL;
    var $9SwwX;
    var $1TVaR;
    var $1RfvD;
    const $92d86c8da94b73a1$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [updateInFlightList, setUpdateInFlightList] = (0, $5uXOq.useState)([]);
        const [cacheActionIssues, dispatch] = (0, (0, parcelRequire("1RfvD")).useCacheActionsReducer)();
        const getIssuesByIdVariablesRef = (0, $5uXOq.useRef)();
        const getIssuesByIdOnCompletedRef = (0, $5uXOq.useRef)(null);
        const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            onCompleted: (0, $5uXOq.useCallback)((result)=>{
                const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list');
                const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
                if (validNodes && validNodes.length > 0) dispatch({
                    type: 'REMOVE_FROM_CACHE',
                    issues: validNodes
                });
            }, [
                dispatch
            ]),
            onError: onAppendItemsError
        });
        const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
            onError: (0, $5uXOq.useCallback)((error)=>{
                if ((0, (0, parcelRequire("3ItGl")).isAbortError)(error.networkError)) return;
                onError(error);
            }, [
                onError
            ]),
            onCompleted: (0, $5uXOq.useCallback)((result)=>getIssuesByIdOnCompletedRef.current?.(result), [])
        });
        if (getIssuesByIdVariablesRef.current !== getIssuesByIdVariables) getIssuesByIdVariablesRef.current = getIssuesByIdVariables;
        const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            onCompleted: (0, $5uXOq.useCallback)((result)=>{
                const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list', onError);
                const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
                if (validNodes && validNodes.length > 0) dispatch({
                    type: 'ADD_TO_CACHE',
                    issues: validNodes
                });
            }, [
                dispatch,
                onError
            ]),
            onError: onAppendItemsError
        });
        const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, (0, parcelRequire("1TVaR")).useRequestQueue)({
            isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
        });
        const removeIssueById = (0, $5uXOq.useCallback)((issueIdsToRemove)=>{
            addRequestToQueue(()=>fetchIssueToRemove({
                    variables: {
                        ...(0, (0, parcelRequire("egmQO")).getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIdsToRemove,
                            fieldIds: input.fieldIds,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: input.projectKey,
                            quickFiltersJql: null
                        }),
                        cloudId: cloudId
                    }
                }));
        }, [
            addRequestToQueue,
            fetchIssueToRemove,
            jqlContext,
            input.fieldIds,
            input.isHidingDoneItems,
            input.isParentFieldVisible,
            input.isDevSummaryFieldVisible,
            input.projectKey,
            cloudId
        ]);
        const removeIssue = (0, $5uXOq.useCallback)(({ issueId: issueId, parentId: parentId })=>{
            const issueNode = {
                issueId: issueId,
                fields: parentId != null ? [
                    {
                        fieldId: 'parent',
                        type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                        parentIssue: {
                            issueId: parentId
                        }
                    }
                ] : []
            };
            dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: [
                    issueNode
                ]
            });
        }, [
            dispatch
        ]);
        const handleFilterMismatch = (0, $5uXOq.useCallback)((variables, result)=>{
            if (!variables.jql) return;
            if (!result || !result.jira) return;
            const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, (0, parcelRequire("egmQO")).getVariables)(updateInput).jql === variables.jql);
            if (updateIndex === -1) return;
            const currentUpdate = updateInFlightList[updateIndex];
            const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
            const issueIds = [
                ...currentUpdate.issueIds || []
            ];
            const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (isUsingSameFilter) {
                const issueIdsToRemove = [];
                issueIds.forEach((issueId, idIndex)=>{
                    const item = validNodes?.find((node)=>node?.issueId === issueId);
                    if (item == null) issueIdsToRemove.push(issueId);
                    issueIds.splice(idIndex, 0);
                    updateInFlightList[updateIndex] = {
                        ...currentUpdate,
                        issueIds: issueIds
                    };
                });
                if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
            }
            setUpdateInFlightList((prevUpdateInFlightList)=>{
                prevUpdateInFlightList.splice(updateIndex, 1);
                return prevUpdateInFlightList;
            });
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
            const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
            if (filteredIssueIds.length > 0) dispatch({
                type: 'HANDLE_FILTERED_UPDATE',
                issues: filteredIssueIds
            });
        }, [
            updateInFlightList,
            input,
            removeIssueById,
            dispatch
        ]);
        getIssuesByIdOnCompletedRef.current = (result)=>handleFilterMismatch(getIssuesByIdVariables, result);
        (0, $5uXOq.useEffect)(()=>{
            if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
            Object.entries(cacheActionIssues).forEach(([actionName, issues])=>{
                if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                    actionEntry?.[actionName]?.(issues);
                });
            });
            dispatch({
                type: 'CLEAR'
            });
        }, [
            cacheActionIssues,
            actions,
            dispatch
        ]);
        return {
            onIssueUpdated: (issueIds)=>{
                const updateInput = {
                    jqlContext: jqlContext,
                    issueIds: issueIds,
                    fieldIds: input.fieldIds,
                    quickFiltersJql: input.quickFiltersJql,
                    isHidingDoneItems: input.isHidingDoneItems,
                    isParentFieldVisible: input.isParentFieldVisible,
                    isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                    projectIdOrKey: input.projectKey
                };
                setUpdateInFlightList((prevUpdateInFlightList)=>[
                        ...prevUpdateInFlightList,
                        updateInput
                    ]);
                addRequestToAbortableQueue(issueIds, getIssuesById, {
                    variables: {
                        ...(0, (0, parcelRequire("egmQO")).getVariables)(updateInput),
                        cloudId: cloudId
                    }
                });
            },
            onIssueCreated: (issueIds)=>{
                addRequestToQueue(()=>appendIssuesById({
                        variables: {
                            ...(0, (0, parcelRequire("egmQO")).getVariables)({
                                jqlContext: jqlContext,
                                issueIds: issueIds,
                                fieldIds: input.fieldIds,
                                quickFiltersJql: input.quickFiltersJql,
                                isHidingDoneItems: input.isHidingDoneItems,
                                isParentFieldVisible: input.isParentFieldVisible,
                                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                                projectIdOrKey: input.projectKey
                            }),
                            cloudId: cloudId
                        }
                    }));
            },
            onIssueRemoved: (params)=>removeIssue(params)
        };
    };
});
parcelRegister("3ItGl", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", ()=>$d72d9e0bee84c3ed$export$6131a8d209a21250);
    $parcel$export(module.exports, "AbortError", ()=>$d72d9e0bee84c3ed$export$18b052ffd8c84d7);
    $parcel$export(module.exports, "isAbortError", ()=>$d72d9e0bee84c3ed$export$d2c30ea522b3259e);
    const $d72d9e0bee84c3ed$export$6131a8d209a21250 = 'The operation was aborted.';
    class $d72d9e0bee84c3ed$export$18b052ffd8c84d7 extends Error {
        constructor(message, statusCode = 499){
            super(message);
            this.name = 'AbortError';
            this.statusCode = statusCode;
        }
    }
    const $d72d9e0bee84c3ed$export$d2c30ea522b3259e = (error)=>error instanceof $d72d9e0bee84c3ed$export$18b052ffd8c84d7;
});
parcelRegister("1TVaR", function(module, exports) {
    $parcel$export(module.exports, "useRequestQueue", ()=>$c49911f50c422071$export$a90df70eeafb262f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ItGl;
    const $c49911f50c422071$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
        const [abortableQueueMap, setAbortableQueueMap] = (0, $5uXOq.useState)(new Map());
        const abortControllerMap = (0, $5uXOq.useRef)(new Map());
        const inProgressRequestId = (0, $5uXOq.useRef)(null);
        const addRequestToAbortableQueue = (0, $5uXOq.useCallback)((issueIds, queryFunction, queryOptions)=>{
            const id = issueIds.join('-');
            const existingAbortController = abortControllerMap.current.get(id);
            existingAbortController?.abort(new (0, (0, parcelRequire("3ItGl")).AbortError)((0, (0, parcelRequire("3ItGl")).DEFAULT_ABORT_ERROR_MESSAGE)));
            const abortController = new AbortController();
            abortControllerMap.current.set(id, abortController);
            const request = ()=>{
                queryFunction({
                    ...queryOptions,
                    context: {
                        ...queryOptions.context,
                        fetchOptions: {
                            ...queryOptions.context?.fetchOptions,
                            signal: abortController.signal
                        }
                    }
                });
            };
            setAbortableQueueMap((prevQueueMap)=>new Map([
                    ...prevQueueMap,
                    [
                        id,
                        request
                    ]
                ]));
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!isRequestLoading && abortableQueueMap.size) {
                const iterator = abortableQueueMap.entries();
                const nextResult = iterator.next();
                if (!nextResult.done) {
                    const [id, request] = nextResult.value;
                    inProgressRequestId.current = id;
                    request();
                }
                setAbortableQueueMap(new Map(iterator));
            }
        }, [
            abortableQueueMap,
            isRequestLoading
        ]);
        const [queue, setQueue] = (0, $5uXOq.useState)([]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
                const [nextItem, ...restOfQueue] = prevQueue;
                nextItem();
                return restOfQueue;
            });
        }, [
            queue,
            isRequestLoading
        ]);
        const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                    ...prevQueue,
                    request
                ]);
        return {
            addRequestToQueue: addRequestToQueue,
            addRequestToAbortableQueue: addRequestToAbortableQueue
        };
    };
});
parcelRegister("1RfvD", function(module, exports) {
    $parcel$export(module.exports, "useCacheActionsReducer", ()=>$9eb3afdf1d8deb15$export$83303d410e8412eb);
    var $5uXOq = parcelRequire("5uXOq");
    const $9eb3afdf1d8deb15$var$cacheActionsReducer = (state, action)=>{
        switch(action.type){
            case 'ADD_TO_CACHE':
                return {
                    ...state,
                    addToCache: [
                        ...state.addToCache,
                        ...action.issues
                    ]
                };
            case 'REMOVE_FROM_CACHE':
                return {
                    ...state,
                    removeFromCache: [
                        ...state.removeFromCache,
                        ...action.issues
                    ]
                };
            case 'HANDLE_FILTERED_UPDATE':
                return {
                    ...state,
                    handleFilteredUpdate: [
                        ...state.handleFilteredUpdate,
                        ...action.issues
                    ]
                };
            case 'CLEAR':
                return {
                    addToCache: [],
                    removeFromCache: [],
                    handleFilteredUpdate: []
                };
            default:
                return state;
        }
    };
    const $9eb3afdf1d8deb15$export$83303d410e8412eb = ()=>(0, $5uXOq.useReducer)($9eb3afdf1d8deb15$var$cacheActionsReducer, {
            addToCache: [],
            removeFromCache: [],
            handleFilteredUpdate: []
        });
});
parcelRegister("gwNxS", function(module, exports) {
    $parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", ()=>$65b2bcc93c8e1166$export$cc1c02509eec9edb);
    $parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", ()=>$65b2bcc93c8e1166$export$c410d2a23de7830a);
    var $jDUax;
    const $65b2bcc93c8e1166$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
        const getParentVariables = (parentId)=>{
            const variables = createVariablesForItemWithoutParent();
            if (!parentId) return variables;
            if (createVariablesForGroupItem && (0, (0, parcelRequire("jDUax")).isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
            return createVariablesForItemWithParent(parentId);
        };
        const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
            updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
            if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
                query: query,
                variables: getParentVariables(prevParentIssueId),
                issueId: Number(item.issueId)
            });
            if (isGroupingByStatus) return;
            const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
            if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
                const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
                if ((0, (0, parcelRequire("jDUax")).isGroupItem)(grandParentId) || (0, (0, parcelRequire("jDUax")).isGroupItem)(prevParentIssueId)) return;
                updateItemsInCache({
                    query: query,
                    variables: getParentVariables(grandParentId),
                    issueIds: [
                        String(prevParentIssueId)
                    ],
                    updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                });
            }
            if (!parentIssueId) return;
            const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(newGrandParentId) || (0, (0, parcelRequire("jDUax")).isGroupItem)(parentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(newGrandParentId),
                issueIds: [
                    parentIssueId
                ],
                updateItem: (existingIssue)=>{
                    const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                    return updatedIssueWithNewChild;
                }
            });
        };
        const addToCacheCallback = (items)=>{
            if (isHierarchyEnabled()) {
                const itemsWithoutParent = items.filter((i)=>(0, (0, parcelRequire("jDUax")).getParentIssueId)(i) === undefined);
                const itemsWithParent = items.filter((i)=>(0, (0, parcelRequire("jDUax")).getParentIssueId)(i) !== undefined);
                if (itemsWithoutParent.length > 0) {
                    addToCache({
                        newNodes: itemsWithoutParent,
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    items.forEach((item)=>{
                        const parentIssueId = undefined;
                        const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                        if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                            prevParentIssueId: prevParentIssueId,
                            parentIssueId: parentIssueId,
                            item: item
                        });
                    });
                }
                itemsWithParent.forEach((item)=>{
                    const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                    if (parentIssueId === undefined) return;
                    if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                        addToCache({
                            newNodes: [
                                item
                            ],
                            query: query,
                            variables: createVariablesForItemWithoutParent()
                        });
                        return;
                    }
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    const shouldUpdateIssueParent = isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                    const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                    if (shouldUpdateIssueParent) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                    if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                        let variables = createVariablesForItemWithoutParent();
                        if (isInfiniteHierarchyEnabled() && getParentOfIssueIfExist) {
                            const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                            if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                        }
                        updateItemsInCache({
                            query: query,
                            variables: variables,
                            issueIds: [
                                parentIssueId
                            ],
                            updateItem: (existingIssue)=>{
                                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                                return updatedIssueWithNewChild;
                            }
                        });
                    }
                });
                return;
            }
            addToCache({
                newNodes: items,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        };
        const removeFromCacheCallback = (items)=>{
            items.forEach((item)=>{
                if (isHierarchyEnabled()) {
                    const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                    if (parentIssueId !== undefined) {
                        if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                            issueId: item.issueId,
                            query: query,
                            variables: createVariablesForItemWithParent(parentIssueId)
                        });
                        return;
                    }
                }
                removeFromCache({
                    issueId: item.issueId,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
            });
        };
        return {
            addToCacheCallback: addToCacheCallback,
            removeFromCacheCallback: removeFromCacheCallback
        };
    };
    const $65b2bcc93c8e1166$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
        const getReparentingInfo = (item)=>{
            const currentParent = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const isUnlinkParent = (!currentParent || (0, (0, parcelRequire("jDUax")).isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
            const isReparenting = currentParent && currentParent !== prevParent;
            return {
                isReparenting: isReparenting,
                isUnlinkParent: isUnlinkParent,
                currentParent: currentParent,
                prevParent: prevParent
            };
        };
        const removeItemFromCache = (item, currentGroupIssueId)=>{
            const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
            if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, (0, parcelRequire("jDUax")).isGroupItem)(prevParent))) removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForGroupItem(currentGroupIssueId)
            });
            else if (prevParent && (isReparenting || isUnlinkParent) && !(0, (0, parcelRequire("jDUax")).isGroupItem)(prevParent)) removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithParent(prevParent)
            });
            const groupItem = findGroupById(currentGroupIssueId);
            const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
            if (groupItem) {
                if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) updateItemsInCache({
                    query: query,
                    variables: (0, (0, parcelRequire("jDUax")).isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                    issueIds: [
                        prevParent
                    ],
                    updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                });
                else if (isChildIssueInGroup(groupItem, item.issueId)) updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: groupItem.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                        })
                });
            }
        };
        const getGroupIssueId = (issueId)=>{
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(issueId)) return issueId;
            const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
            if (!parentId) return null;
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(parentId)) return parentId;
            return getGroupIssueId(parentId);
        };
        const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
        const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
            updateCountOnly: false
        })=>{
            items.forEach((item)=>{
                const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
                const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
                const nextGroup = findItemGroup(item);
                if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
                if (nextGroup != null) {
                    const shouldAddToCache = canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly;
                    if (shouldAddToCache) {
                        addToCache({
                            newNodes: [
                                item
                            ],
                            query: query,
                            variables: createVariablesForGroupItem(nextGroup.issueId)
                        });
                        updateIssueParentMap(item.issueId);
                    }
                    const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                    if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                        query: query,
                        variables: (0, (0, parcelRequire("jDUax")).isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                        issueIds: [
                            currentParent
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                    else updateGroupItemInCache({
                        query: groupsQuery,
                        variables: createVariablesForGroups(),
                        id: nextGroup.id,
                        updateItem: (group)=>({
                                ...group,
                                totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                            })
                    });
                } else {
                    const newGroup = createItemGroup(item);
                    if (newGroup != null) addGroupItemToCache({
                        query: groupsQuery,
                        variables: createVariablesForGroups(),
                        newNodes: [
                            newGroup
                        ]
                    });
                }
            });
        };
        const removeFromGroupCache = (items)=>{
            items.forEach((item)=>{
                const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
                const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
                if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
            });
        };
        return {
            addToCache: addToGroupCache,
            removeFromCache: removeFromGroupCache
        };
    };
});
parcelRegister("3xYz2", function(module, exports) {
    $parcel$export(module.exports, "useGroupCacheActions", ()=>$3125aeceaae206dd$export$3083f2cce6510ba2);
    var $egmQO;
    var $daQYX;
    var $kRkJF;
    var $jDUax;
    var $dNchx;
    var $hlKA4;
    var $gwNxS;
    var $5fc53;
    var $g5X3G;
    var $koeKL;
    var $3WUKM;
    var $gribp;
    var $ktYkO;
    var $61h55;
    var $bsMMx;
    var $tx8ST;
    var $8TUlY;
    var $8e3Yw;
    var $mH57d;
    var $9u99d;
    var $aQbWi;
    var $eg2To;
    const $3125aeceaae206dd$export$3083f2cce6510ba2 = ({ fieldIds: fieldIds } = {})=>{
        const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const { addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache } = (0, (0, parcelRequire("dNchx")).useItemGroupsCacheActions)();
        const { hierarchyParent: hierarchyParent } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const [{ rankParentIssueId: rankParentIssueId }] = (0, (0, parcelRequire("aQbWi")).useRankParent)();
        const input = (0, (0, parcelRequire("eg2To")).useIssuesInput)({
            groupIssueId: (0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
            parentIssueId: !(0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
        });
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenItems, hierarchyData: hierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const groupItemsQueryData = childrenItems;
        const groups = hierarchyData.data;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { getAvailableFields: getAvailableFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const availableFields = getAvailableFields();
        const categoryField = availableFields.find((field)=>field?.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE));
        const isGroupingByCategory = groupByFieldId === categoryField?.id;
        const [{ hierarchyLevel: hierarchyLevel }] = (0, (0, parcelRequire("tx8ST")).useHierarchyLevel)();
        const { addToCache: addToGroupCache, removeFromCache: removeFromGroupCache } = (0, (0, parcelRequire("gwNxS")).createGroupingViewUpdaterCacheActions)({
            query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
            groupsQuery: (0, (0, parcelRequire("3WUKM")).LIST_VIEW_ITEM_GROUPS_QUERY),
            addToCache: addToCache,
            removeFromCache: removeFromCache,
            updateItemsInCache: updateItemsInCache,
            addGroupItemToCache: addGroupItemToCache,
            updateGroupItemInCache: updateGroupItemInCache,
            canUpdateGroupCache: (groupIssueId)=>groupItemsQueryData ? !!groupItemsQueryData[(0, (0, parcelRequire("g5X3G")).toIssueId)(groupIssueId)] : false,
            findItemGroup: (item)=>(0, (0, parcelRequire("ktYkO")).findItemGroup)({
                    groups: groups,
                    groupByFieldId: groupByFieldId,
                    item: item,
                    isGroupingByCategory: isGroupingByCategory
                }),
            createItemGroup: (item)=>(0, (0, parcelRequire("ktYkO")).createItemGroup)({
                    groupByFieldId: groupByFieldId,
                    item: item
                }),
            findGroupById: (groupIssueId)=>groups?.find((group)=>groupIssueId === (0, (0, parcelRequire("ktYkO")).createGroupIssueId)(group.id)),
            createVariablesForGroupItem: (groupIssueId)=>({
                    cloudId: cloudId,
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: fieldIds || input.fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        sorting: sorting,
                        groupQuery: (0, (0, parcelRequire("ktYkO")).getGroupQuery)({
                            groups: groups,
                            groupIssueId: groupIssueId,
                            groupByFieldId: groupByFieldId
                        }),
                        hierarchyParent: input.hierarchyParent,
                        isHidingDoneItems: isHidingDoneItems,
                        projectIdOrKey: projectKey
                    })
                }),
            createVariablesForGroups: ()=>(0, (0, parcelRequire("gribp")).getGroupVariables)({
                    groupByFieldId: groupByFieldId,
                    jqlContext: jqlContext
                }),
            getParentOfIssueIfExist: (issueId)=>{
                const maybeIssue = issuesMap.get(String(issueId));
                if (!maybeIssue) return undefined;
                return maybeIssue.parentIssueId ?? (0, (0, parcelRequire("jDUax")).getParentIssueId)(maybeIssue);
            },
            getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
            onUpdateParentWithNewChild: (0, (0, parcelRequire("bsMMx")).addChildToParentListView),
            removeChildFromParent: (0, (0, parcelRequire("bsMMx")).removeChildFromParentListView),
            createVariablesForItemWithParent: (parentIssueId)=>{
                if (!hierarchyParent) return {
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: fieldIds || input.fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        sorting: sorting,
                        hierarchyLevel: hierarchyLevel,
                        hierarchyParent: hierarchyParent,
                        isHidingDoneItems: isHidingDoneItems
                    }),
                    cloudId: cloudId
                };
                return {
                    ...(0, (0, parcelRequire("egmQO")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: fieldIds || input.fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        sorting: sorting,
                        isHidingDoneItems: isHidingDoneItems,
                        hierarchyParent: undefined,
                        parentIssue: {
                            hierarchyType: hierarchyParent,
                            issueId: parentIssueId
                        }
                    }),
                    cloudId: cloudId
                };
            },
            updateIssueParentMap: (issueId, newParentId)=>{
                if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
                else issueParentMap.delete(String(issueId));
            }
        });
        return {
            addToGroupCache: addToGroupCache,
            removeFromGroupCache: removeFromGroupCache
        };
    };
});
parcelRegister("dNchx", function(module, exports) {
    $parcel$export(module.exports, "useItemGroupsCacheActions", ()=>$62cdbc15a2470d27$export$a49f2fc3773a6a0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    const $62cdbc15a2470d27$export$a49f2fc3773a6a0f = ()=>{
        const analyticsTaskName = 'useItemGroupsCacheActionsApolloCacheActions';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const updateGroupItemInCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, id: id, updateItem: updateItem })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'updateGroupItemInCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const existingNodes = data?.groups.nodes;
            if (existingNodes == null) return;
            const itemToUpdateIndex = existingNodes.findIndex((issue)=>issue?.id === id) ?? undefined;
            const existingItem = existingNodes[itemToUpdateIndex];
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingItem == null) return;
            const itemOverride = updateItem(existingItem);
            if (itemOverride === undefined) return;
            const newNodes = [
                ...existingNodes
            ];
            newNodes[itemToUpdateIndex] = itemOverride;
            try {
                client.writeQuery({
                    query: query,
                    variables: variables,
                    notifyOnNetworkStatusChange: true,
                    data: {
                        ...data,
                        groups: {
                            ...data?.groups || {},
                            nodes: newNodes
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'updateGroupItemInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent
        ]);
        const addGroupItemToCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'addGroupItemToCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            if (data == null || data.groups == null || !Array.isArray(newNodes) || newNodes.length === 0 || !Array.isArray(newNodes)) return;
            const newGroupsIds = new Set(newNodes.map((item)=>item != null && item.id != null ? item.id : undefined).filter(Boolean));
            if (data == null || data.groups == null || !Array.isArray(data.groups.nodes)) return;
            try {
                const newGroups = data.groups.nodes.filter((node)=>node != null && node.id != null && !newGroupsIds.has(node.id)).concat(newNodes) ?? [];
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        groups: {
                            ...data.groups,
                            nodes: newGroups
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'addGroupItemToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent
        ]);
        return {
            updateGroupItemInCache: updateGroupItemInCache,
            addGroupItemToCache: addGroupItemToCache
        };
    };
});
parcelRegister("aQbWi", function(module, exports) {
    $parcel$export(module.exports, "useRankParent", ()=>$57f47ab7dd554ef0$export$70ab091cfa570abd);
    var $3sQ5x;
    var $iXqE5;
    const $57f47ab7dd554ef0$var$actions = {
        setRankParentIssueId: (rankParentIssueId)=>({ setState: setState })=>setState({
                    rankParentIssueId: rankParentIssueId
                })
    };
    const $57f47ab7dd554ef0$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            rankParentIssueId: null
        },
        actions: $57f47ab7dd554ef0$var$actions,
        name: 'JBusListViewRankParentIssueIdStore'
    });
    const $57f47ab7dd554ef0$export$70ab091cfa570abd = (0, (0, parcelRequire("3sQ5x")).createHook)($57f47ab7dd554ef0$var$Store);
});
parcelRegister("eg2To", function(module, exports) {
    $parcel$export(module.exports, "useIssuesInput", ()=>$0f1e3192f550f0e8$export$242d22b97c239de6);
    var $daQYX;
    var $kRkJF;
    var $ktYkO;
    var $tx8ST;
    var $8TUlY;
    var $8e3Yw;
    var $mH57d;
    var $9u99d;
    const $0f1e3192f550f0e8$export$242d22b97c239de6 = (options)=>{
        const { groupIssueId: groupIssueId, parentIssueId: parentIssueId } = options || {};
        const [{ hierarchyLevel: hierarchyLevel }] = (0, (0, parcelRequire("tx8ST")).useHierarchyLevel)();
        const [{ hierarchyData: hierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const { hierarchyParent: hierarchyParent } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const groups = hierarchyData.data;
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        let input = {
            jqlContext: jqlContext,
            quickFiltersJql: quickFiltersJql,
            projectIdOrKey: projectKey,
            fieldIds: getQueryFieldIds(),
            isHidingDoneItems: isHidingDoneItems,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        };
        if (groupIssueId != null) input = {
            ...input,
            hierarchyParent: hierarchyParent,
            groupQuery: (0, (0, parcelRequire("ktYkO")).getGroupQuery)({
                groupIssueId: groupIssueId,
                groupByFieldId: groupByFieldId,
                groups: groups
            })
        };
        else if (parentIssueId != null && hierarchyParent != null) input = {
            ...input,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: parentIssueId
            }
        };
        else {
            input.hierarchyLevel = hierarchyLevel;
            input.hierarchyParent = hierarchyParent;
        }
        return input;
    };
});
parcelRegister("dvriG", function(module, exports) {
    $parcel$export(module.exports, "useSupportedFieldIds", ()=>$62b3f66933d336ef$export$ec520f6de95e7778);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTDjN;
    var $8TUlY;
    const $62b3f66933d336ef$export$ec520f6de95e7778 = ()=>{
        const { getQueryFieldIds: getQueryFieldIds, getAvailableFields: getAvailableFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const queryFieldIds = getQueryFieldIds();
        return (0, $5uXOq.useMemo)(()=>[
                ...queryFieldIds,
                ...getAvailableFields().filter((field)=>field.type ? !queryFieldIds.includes(field.id) && (0, (0, parcelRequire("eTDjN")).SUPPORTED_GROUPS_TYPES).includes(field.type) : false).map((field)=>field.id)
            ], [
            getAvailableFields,
            queryFieldIds
        ]);
    };
});
parcelRegister("dvvS3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c7eb75530dece9b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $5c7eb75530dece9b$var$ListActionsBanner = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9nbF9")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/controllers/list-actions-banner/main.tsx"
    });
    var $5c7eb75530dece9b$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "list-actions-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5c7eb75530dece9b$var$ListActionsBanner, props));
});
parcelRegister("9nbF9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6rmRd").then(()=>parcelRequire('5wbFn'));
});
parcelRegister("5t2X8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ab4865a45b6485e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $6ab4865a45b6485e$var$ListViewUpdater = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("kPnxZ")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/controllers/list-updater/main.tsx"
    });
    var $6ab4865a45b6485e$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "list-view-updater",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6ab4865a45b6485e$var$ListViewUpdater, props));
});
parcelRegister("kPnxZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fVk76").then(()=>parcelRequire('krSOQ'));
});
parcelRegister("hb2SN", function(module, exports) {
    $parcel$export(module.exports, "useReparentModalStore", ()=>$4948937417ccdc13$export$2e755c9651c94d7f);
    $parcel$export(module.exports, "useShouldShowReparentModal", ()=>$4948937417ccdc13$export$bb435bd62aedac9f);
    var $3sQ5x;
    var $iXqE5;
    const $4948937417ccdc13$var$actions = {
        openReparentModal: (issueIdToReparent)=>({ setState: setState })=>{
                setState({
                    issueIdToReparent: issueIdToReparent
                });
            },
        closeReparentModal: ()=>({ setState: setState })=>{
                setState({
                    issueIdToReparent: null
                });
            }
    };
    const $4948937417ccdc13$var$ReparentModalStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            issueIdToReparent: null
        },
        actions: $4948937417ccdc13$var$actions,
        name: 'JWMReparentModal'
    });
    const $4948937417ccdc13$export$2e755c9651c94d7f = (0, (0, parcelRequire("3sQ5x")).createHook)($4948937417ccdc13$var$ReparentModalStore);
    const $4948937417ccdc13$export$e88c9698e4ec8c24 = (state)=>state.issueIdToReparent != null;
    const $4948937417ccdc13$export$bb435bd62aedac9f = (0, (0, parcelRequire("3sQ5x")).createHook)($4948937417ccdc13$var$ReparentModalStore, {
        selector: $4948937417ccdc13$export$e88c9698e4ec8c24
    });
});
parcelRegister("j2Xxu", function(module, exports) {
    $parcel$export(module.exports, "useTableAnalytics", ()=>$2b851d25530fa3ca$export$d0703a75f31864f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $2LpEi;
    const $2b851d25530fa3ca$export$d0703a75f31864f4 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ tableRef: tableRef }] = (0, (0, parcelRequire("2LpEi")).useTableRefStore)();
        const tableInitialised = (0, $5uXOq.useRef)(false);
        const _columns = tableRef.current?.getColumnManager()?._columns;
        const columns = (0, $5uXOq.useMemo)(()=>_columns ?? [], [
            _columns
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!tableInitialised.current && columns.length > 0) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'table init', {
                    numberOfColumns: columns.length
                });
                tableInitialised.current = true;
            }
        }, [
            columns.length,
            createAnalyticsEvent
        ]);
    };
});
parcelRegister("2LpEi", function(module, exports) {
    $parcel$export(module.exports, "useTableRefStore", ()=>$cc7f9390c2d8a809$export$18c478ca7c21c86a);
    var $3sQ5x;
    var $iXqE5;
    const $cc7f9390c2d8a809$var$actions = {
        setTableRef: (tableRef)=>({ setState: setState })=>{
                setState({
                    tableRef: tableRef
                });
            }
    };
    const $cc7f9390c2d8a809$var$TableRefStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            tableRef: {
                current: null
            }
        },
        actions: $cc7f9390c2d8a809$var$actions,
        name: 'JWMTableRef'
    });
    const $cc7f9390c2d8a809$export$18c478ca7c21c86a = (0, (0, parcelRequire("3sQ5x")).createHook)($cc7f9390c2d8a809$var$TableRefStore);
});
parcelRegister("7G4Lw", function(module, exports) {
    $parcel$export(module.exports, "useClearStaleGroupBy", ()=>$ecb5c32198935408$export$33497e7241a3f128);
    var $5uXOq = parcelRequire("5uXOq");
    var $8TUlY;
    var $8e3Yw;
    const $ecb5c32198935408$export$33497e7241a3f128 = ({ onClear: onClear })=>{
        const [groupByFieldId, setGroupBy] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const { getAvailableFields: getAvailableFields, loading: loading } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const availableFields = getAvailableFields();
        (0, $5uXOq.useEffect)(()=>{
            if (!groupByFieldId || loading) return;
            const isGroupedFieldAvailable = availableFields.some((field)=>field.id === groupByFieldId);
            if (!isGroupedFieldAvailable) {
                setGroupBy(undefined);
                onClear();
            }
        }, [
            groupByFieldId,
            setGroupBy,
            availableFields,
            loading,
            onClear
        ]);
        return null;
    };
});
parcelRegister("7pW4c", function(module, exports) {
    $parcel$export(module.exports, "useIssueUpdated", ()=>$e768416e23dc9126$export$5ed6d188c4dd5d1d);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $aMwM1;
    const $e768416e23dc9126$var$canRemoveIssue = ({ fieldType: fieldType, issueKey: issueKey, newValue: newValue, oldValue: oldValue })=>{
        switch(fieldType){
            case 0, (0, parcelRequire("5fc53")).PARENT_TYPE:
                {
                    const currentProject = (issueKey ?? '').split('-')[0];
                    const oldValueProjectKey = (oldValue?.key ?? '').split('-')[0];
                    const newValueProjectKey = (newValue?.key ?? '').split('-')[0];
                    if (!oldValue?.value && newValueProjectKey !== currentProject || !newValue?.value && oldValueProjectKey !== currentProject) return false;
                    return newValue?.value !== oldValue?.value;
                }
            default:
                return false;
        }
    };
    const $e768416e23dc9126$export$5ed6d188c4dd5d1d = ()=>{
        const { onIssueRemoved: onIssueRemoved } = (0, (0, parcelRequire("aMwM1")).useListViewUpdaterService)();
        const onIssueUpdated = (0, $5uXOq.useCallback)(({ issueKey: issueKey, issueId: issueId, fieldType: fieldType, newValue: newValue, oldValue: oldValue })=>{
            if ($e768416e23dc9126$var$canRemoveIssue({
                issueKey: issueKey,
                fieldType: fieldType,
                newValue: newValue,
                oldValue: oldValue
            })) onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldValue?.value ?? undefined
            });
        }, [
            onIssueRemoved
        ]);
        return {
            onIssueUpdated: onIssueUpdated
        };
    };
});
parcelRegister("5bYhZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2419d18feedd8ecf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7EOTc;
    var $2419d18feedd8ecf$export$2e2bcd8739ae039 = (props)=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("7EOTc")).Table).preload();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7EOTc")).default), props);
    };
});
parcelRegister("7EOTc", function(module, exports) {
    $parcel$export(module.exports, "Table", ()=>$9c8b8cb8c940984c$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "default", ()=>$9c8b8cb8c940984c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $ihWa4;
    const $9c8b8cb8c940984c$export$54ec01a60f47d33d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("yY8BN")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/base-table/main.tsx"
    });
    var $9c8b8cb8c940984c$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "base-table",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ihWa4")).LoadingTable), props)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9c8b8cb8c940984c$export$54ec01a60f47d33d, props));
});
parcelRegister("ihWa4", function(module, exports) {
    $parcel$export(module.exports, "LoadingTable", ()=>$6b3086f0727377e7$export$b353ee8dbb8fb09e);
    var $5uXOq = parcelRequire("5uXOq");
    var $lob44;
    var $i63x4;
    const $6b3086f0727377e7$var$getRowSkeleton = (columns, rowHeight, SkeletonRow, SkeletonField, key = 0)=>(0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonRow, {
            key: key
        }, columns.map((column)=>(0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonField, {
                key: column.key,
                height: rowHeight,
                width: column.width
            })));
    const $6b3086f0727377e7$var$getLoadingSkeleton = (columns, rowHeight, SkeletonRow, SkeletonField)=>Array.from({
            length: 20
        }, (_, i)=>$6b3086f0727377e7$var$getRowSkeleton(columns, rowHeight, SkeletonRow, SkeletonField, i));
    const $6b3086f0727377e7$export$b353ee8dbb8fb09e = (0, $5uXOq.memo)(({ columns: columns, rowHeight: rowHeight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).Wrapper), null, columns.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).TableWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).LoadingRow), {
            key: "loading-header-row"
        }, columns.map((column)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).LoadingWrapper), {
                key: column.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).LoadingIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).LoadingField), {
                height: rowHeight,
                width: column.width - (0, (0, parcelRequire("i63x4")).ICON_OFFSET)
            })))), $6b3086f0727377e7$var$getLoadingSkeleton(columns, rowHeight, (0, (0, parcelRequire("i63x4")).LoadingRow), (0, (0, parcelRequire("i63x4")).LoadingField))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i63x4")).SpinnerWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lob44")).ThemedSpinner), null))), (prevProps, nextProps)=>prevProps.columns.length === nextProps.columns.length);
});
parcelRegister("i63x4", function(module, exports) {
    $parcel$export(module.exports, "LoadingRow", ()=>$291a4f365813f7cf$export$d1e723d3001badba);
    $parcel$export(module.exports, "LoadingField", ()=>$291a4f365813f7cf$export$2304bbb03949f4f1);
    $parcel$export(module.exports, "ICON_OFFSET", ()=>$291a4f365813f7cf$export$382610e783aa2ae8);
    $parcel$export(module.exports, "LoadingWrapper", ()=>$291a4f365813f7cf$export$43a792a870d28db2);
    $parcel$export(module.exports, "LoadingIcon", ()=>$291a4f365813f7cf$export$b936c55164dcf1db);
    $parcel$export(module.exports, "Wrapper", ()=>$291a4f365813f7cf$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SpinnerWrapper", ()=>$291a4f365813f7cf$export$52b4dfd89a6b3a1b);
    $parcel$export(module.exports, "TableWrapper", ()=>$291a4f365813f7cf$export$4267411171632d35);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $291a4f365813f7cf$var$LOADING_VIEW_HEIGHT = '76vh';
    const $291a4f365813f7cf$export$d1e723d3001badba = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$export$2304bbb03949f4f1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1rjw0ur": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width - (0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`),
                "--_mkz9at": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.height - (0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbra4q _4t3i2wna _bfhk15j7 _18s8u2gc _19bvv77o _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$var$ICON_SIZE = 24;
    const $291a4f365813f7cf$export$382610e783aa2ae8 = $291a4f365813f7cf$var$ICON_SIZE + (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $291a4f365813f7cf$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$export$b936c55164dcf1db = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _4t3i1tcg _bfhk1aqf _18s8u2gc _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rkoftgi _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$export$52b4dfd89a6b3a1b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1h6o _4cvr1h6o _1tkeo1og",
                __cmplp.className
            ])
        });
    });
    const $291a4f365813f7cf$export$4267411171632d35 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _1e0c1ule _4t3io1og _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("yY8BN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9wB43")
    ]).then(()=>parcelRequire('fIVjM'));
});
parcelRegister("2CfGf", function(module, exports) {
    $parcel$export(module.exports, "getColumnVisibilityIndexes", ()=>$ee7d1ec793425b8d$export$2b4b1825d849585e);
    $parcel$export(module.exports, "useHighlightDoneItems", ()=>$ee7d1ec793425b8d$export$10dde765bae17fce);
    $parcel$export(module.exports, "calculateIssuesHeight", ()=>$ee7d1ec793425b8d$export$e12173811eb87ac);
    $parcel$export(module.exports, "getIssueCreateRankBefore", ()=>$ee7d1ec793425b8d$export$963872cb9359ad45);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $cLGgz;
    var $g5X3G;
    var $3fT9O;
    var $9eTTF;
    const $ee7d1ec793425b8d$export$2b4b1825d849585e = (0, (0, parcelRequire("8QpSo")).default)((scrollLeft, tableWidth, columns)=>{
        const leftEdge = scrollLeft;
        const rightEdge = scrollLeft + tableWidth;
        const visibleColumnsIdx = [];
        const invisibleColumnsIdx = [];
        let totalOffset = 0;
        const columnsOffset = columns.reduce((acc, column)=>{
            acc.push(totalOffset);
            totalOffset += column.width;
            return acc;
        }, []);
        columnsOffset.forEach((columnOffset, colIdx)=>{
            const isNotVisible = columnOffset + columns[colIdx].width < leftEdge || columnOffset > rightEdge;
            isNotVisible ? invisibleColumnsIdx.push(colIdx) : visibleColumnsIdx.push(colIdx);
        });
        return {
            visibleColumns: visibleColumnsIdx,
            invisibleColumns: invisibleColumnsIdx
        };
    });
    const $ee7d1ec793425b8d$export$10dde765bae17fce = ()=>{
        const [highlightedIssues, setHightlightedIssues] = (0, $5uXOq.useState)({});
        const toggleHighlightRow = (0, $5uXOq.useCallback)((issueKey, value, timeout = 5000)=>{
            setHightlightedIssues((prev)=>({
                    ...prev,
                    [issueKey]: value
                }));
            if (value) setTimeout(()=>{
                setHightlightedIssues((prevState)=>{
                    const newState = {
                        ...prevState
                    };
                    delete newState[issueKey];
                    return newState;
                });
            }, timeout);
        }, []);
        const getRowClassName = (0, $5uXOq.useCallback)(({ rowData: rowData })=>highlightedIssues[rowData.key] && 'highlight', [
            highlightedIssues
        ]);
        return {
            toggleHighlightRow: toggleHighlightRow,
            getRowClassName: getRowClassName
        };
    };
    const $ee7d1ec793425b8d$export$e12173811eb87ac = (issues, rowHeight, expandedItems, expandedGroups)=>issues.reduce((totalHeight, issue)=>{
            let accumulatedHeight = totalHeight;
            accumulatedHeight += rowHeight;
            if (issue.children && issue.children.length > 0 && (expandedItems && expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(issue.issueId)] === true || expandedGroups && expandedGroups[(0, (0, parcelRequire("g5X3G")).toIssueId)(issue.issueId)] === true)) accumulatedHeight += $ee7d1ec793425b8d$export$e12173811eb87ac(issue.children, rowHeight, expandedItems, expandedGroups);
            return accumulatedHeight;
        }, 0);
    const $ee7d1ec793425b8d$export$963872cb9359ad45 = ({ items: items, startIndex: startIndex })=>{
        let rankBefore;
        const itemsCount = items?.length ?? 0;
        if (itemsCount > 0) for(let i = startIndex; i < itemsCount; i++){
            const { issueId: issueId, rank: rank } = items[i];
            const isItemAnIssue = !(0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(issueId) && !(0, (0, parcelRequire("9eTTF")).isEmptyRow)(String(issueId)) && !(0, (0, parcelRequire("3fT9O")).isItemAnInlineCreate)(String(issueId)) && !(0, (0, parcelRequire("3fT9O")).isItemShowMore)(String(issueId));
            if (isItemAnIssue) {
                rankBefore = {
                    issueId: String(issueId),
                    rank: rank
                };
                break;
            }
        }
        return rankBefore;
    };
});
parcelRegister("9eTTF", function(module, exports) {
    $parcel$export(module.exports, "isEmptyRow", ()=>$372e6f5f965af8b8$export$ee1d59c3151f153d);
    var $jDUax;
    var $g5X3G;
    var $3fT9O;
    var $3rO9r;
    const $372e6f5f965af8b8$export$36f6900d705f61ab = ({ data: data, childrenQueryData: childrenQueryData, rowCreateState: rowCreateState, setRowCreatePosition: setRowCreatePosition, setIssueExpanded: setIssueExpanded, groups: groups, groupItemsQueryData: groupItemsQueryData })=>{
        const issuesMap = new Map();
        const addAndReturnIssue = (issue)=>{
            issuesMap.set(String(issue.issueId), issue);
            return issue;
        };
        const convertListViewIssueToListViewControllerData = ({ issue: issue, children: children, issueHasChildCreateOpen: issueHasChildCreateOpen, canCreateChild: canCreateChild, rankIndex: rankIndex, parentIssueId: parentIssueId })=>{
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(issue.issueId) && groupItemsQueryData) return addAndReturnIssue({
                ...issue,
                rankIndex: rankIndex,
                children: issueHasChildCreateOpen ? [
                    (0, (0, parcelRequire("3fT9O")).createRowForInlineCreate)('group'),
                    ...children || []
                ] : children
            });
            if (childrenQueryData) return addAndReturnIssue({
                ...issue,
                rankIndex: rankIndex,
                parentIssueId: parentIssueId,
                children: issueHasChildCreateOpen ? [
                    ...children || [],
                    (0, (0, parcelRequire("3fT9O")).createRowForInlineCreate)('subtask')
                ] : children,
                onChildCreateButtonClicked: canCreateChild ? ()=>{
                    setRowCreatePosition({
                        parentId: issue.issueId
                    });
                    if (setIssueExpanded) setIssueExpanded((0, (0, parcelRequire("g5X3G")).toIssueId)(issue.issueId), true);
                } : undefined
            });
            return addAndReturnIssue({
                ...issue,
                rankIndex: rankIndex
            });
        };
        const isGrouping = typeof groups !== 'undefined' ? groups.length > 0 : false;
        if (isGrouping && !groupItemsQueryData || !childrenQueryData) return {
            convertedData: data.map((issue, index)=>convertListViewIssueToListViewControllerData({
                    issue: issue,
                    children: undefined,
                    issueHasChildCreateOpen: false,
                    canCreateChild: false,
                    rankIndex: index,
                    parentIssueId: undefined
                })),
            issuesMap: issuesMap
        };
        const items = isGrouping ? groups : data;
        const convertedData = (items || []).map((issue, index)=>{
            const { issueId: issueIdNumber, childSummary: childSummary } = issue;
            const issueId = String(issueIdNumber);
            const { parentId: parentId } = rowCreateState;
            const issueHasChildCreateOpen = parentId === issue.issueId;
            const hasNoChildren = !childSummary?.hasChildren;
            if (hasNoChildren) return convertListViewIssueToListViewControllerData({
                issue: issue,
                children: undefined,
                issueHasChildCreateOpen: issueHasChildCreateOpen,
                canCreateChild: true,
                parentIssueId: undefined,
                rankIndex: index
            });
            let children;
            const childIssuesData = childrenQueryData ? childrenQueryData[issue.issueId] : undefined;
            const groupItemsData = groupItemsQueryData ? groupItemsQueryData[issue.issueId] : undefined;
            const childItemsData = isGrouping ? groupItemsData : childIssuesData;
            const loading = isGrouping ? !groupItemsData || groupItemsData?.loading : !childIssuesData || childIssuesData?.loading;
            if (loading === true) children = [
                (0, (0, parcelRequire("3fT9O")).createItemSkeleton)({
                    issueId: issueId
                })
            ];
            else children = childItemsData ? childItemsData.data.map((childIssue, childIndex)=>{
                const convertedChildIssue = convertListViewIssueToListViewControllerData({
                    issue: childIssue,
                    children: undefined,
                    issueHasChildCreateOpen: false,
                    canCreateChild: false,
                    parentIssueId: issueId,
                    rankIndex: childIndex
                });
                return convertedChildIssue;
            }) : [];
            const convertedIssue = convertListViewIssueToListViewControllerData({
                issue: issue,
                children: children,
                issueHasChildCreateOpen: issueHasChildCreateOpen,
                canCreateChild: true,
                parentIssueId: undefined,
                rankIndex: index
            });
            return convertedIssue;
        });
        return {
            convertedData: convertedData,
            issuesMap: issuesMap
        };
    };
    const $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX = 'EMPTY_ROW';
    const $372e6f5f965af8b8$export$ee1d59c3151f153d = (issueId = '')=>issueId.toString().startsWith($372e6f5f965af8b8$var$EMTPY_ROW_PREFIX);
    const $372e6f5f965af8b8$export$4293a35894588c6e = [
        {
            id: '',
            rowKey: $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX,
            issueId: $372e6f5f965af8b8$var$EMTPY_ROW_PREFIX,
            typeId: '',
            issuetype: {},
            key: '',
            rank: '',
            rankIndex: -1,
            status: {
                categoryId: '',
                name: ''
            },
            totalSubtasks: 0,
            cacheVariables: (0, (0, parcelRequire("3rO9r")).DEFAULT_CACHE_VARIABLES)
        }
    ];
});
parcelRegister("fX4kd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81b26d5d56c1748a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $81b26d5d56c1748a$var$LazyBulkDeleteModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("dKMSl")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/bulk-delete-modal/main.tsx"
    });
    var $81b26d5d56c1748a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "bulk-delete-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($81b26d5d56c1748a$var$LazyBulkDeleteModal, null));
});
parcelRegister("dKMSl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8skTx")
    ]).then(()=>parcelRequire('bIZ4A'));
});
parcelRegister("5h7oA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6329f0d83059ca6f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iAbh9;
    var $5vJHu;
    var $4R6GH;
    var $iuzc0;
    var $mk7k0;
    var $aJDYj;
    var $hPruQ;
    var $2Len7;
    const $6329f0d83059ca6f$var$BulkEdit = ()=>{
        const bulkChangePermission = (0, (0, parcelRequire("aJDYj")).useBulkChangePermission)();
        const bulkOperationsForm = (0, (0, parcelRequire("5vJHu")).useReferenceLoader)();
        const [, { toggleBulkEditSidebar: toggleBulkEditSidebar }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const [, { toggleShowQuickstart: toggleShowQuickstart }] = (0, (0, parcelRequire("iuzc0")).useQuickstartPillVisibilityStore)();
        const onOpenSidebar = (0, $5uXOq.useCallback)(()=>{
            toggleBulkEditSidebar({
                showBulkEditSidebar: true
            });
        }, [
            toggleBulkEditSidebar
        ]);
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            toggleBulkEditSidebar({
                showBulkEditSidebar: false
            });
            (0, (0, parcelRequire("4R6GH")).fg)('jira_hide_qs_pill_on_bulk_edit') && toggleShowQuickstart({
                showQuickstartPill: true
            });
        }, [
            toggleBulkEditSidebar,
            toggleShowQuickstart
        ]);
        if (!bulkChangePermission) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iAbh9")).BulkOpsAnalyticsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Len7")).BulkEditSidebar), {
            bulkOperationsForm: bulkOperationsForm
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hPruQ")).BulkOperationsLoader), {
            bulkOperationsForm: bulkOperationsForm,
            onCloseSidebar: onCloseSidebar,
            onOpenSidebar: onOpenSidebar
        }));
    };
    var $6329f0d83059ca6f$export$2e2bcd8739ae039 = $6329f0d83059ca6f$var$BulkEdit;
});
parcelRegister("iAbh9", function(module, exports) {
    $parcel$export(module.exports, "BulkOpsAnalyticsProvider", ()=>$477c8df705ed825f$export$8ab440f197429d1e);
    $parcel$export(module.exports, "useBulkOpsSessionContext", ()=>$477c8df705ed825f$export$95271787b6ae4d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $8p26c;
    const $477c8df705ed825f$var$BulkOpsAnalyticsContext = (0, $5uXOq.createContext)(null);
    const $477c8df705ed825f$export$8ab440f197429d1e = (props)=>{
        const [bulkOpsFlow] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("8p26c")).DefaultBulkOpsFlow)());
        const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $5uXOq.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
                setBulkOpsSessionID(sessionId);
            });
            return ()=>{
                unsubscribe?.();
            };
        }, [
            bulkOpsFlow
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($477c8df705ed825f$var$BulkOpsAnalyticsContext.Provider, {
            value: bulkOpsFlow
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: {
                bulkOpsSessionID: bulkOpsSessionID
            }
        }, props.children));
    };
    const $477c8df705ed825f$export$95271787b6ae4d3c = ()=>(0, $5uXOq.useContext)($477c8df705ed825f$var$BulkOpsAnalyticsContext);
});
parcelRegister("8p26c", function(module, exports) {
    $parcel$export(module.exports, "DefaultBulkOpsFlow", ()=>$66219c4f12f760b8$export$74bf75c57acfbb74);
    var $7Jxgt = parcelRequire("7Jxgt");
    class $66219c4f12f760b8$export$74bf75c57acfbb74 {
        isInFlow() {
            return this.bulkOpsSessionID !== undefined;
        }
        get sessionID() {
            return this.bulkOpsSessionID;
        }
        get bulkActionsCompleted() {
            return this.numBulkActionsCompleted;
        }
        get bulkOperationType() {
            return this.bulkOperationTypeValue;
        }
        notifyAnalyticsEventPublishers(sessionID) {
            let index = 0;
            this.analyticsEventPublishers.forEach((listener)=>{
                listener(sessionID, index);
                index += 1;
            });
            this.analyticsEventPublishers.clear();
        }
        start(_attributes) {
            if (this.isInFlow()) return;
            this.bulkOpsSessionID = (0, ($parcel$interopDefault($7Jxgt))).v4();
            this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
        }
        end(_attributes) {
            this.bulkOpsSessionID = undefined;
            this.numBulkActionsCompleted = 0;
        }
        executeAction() {
            if (!this.isInFlow()) this.start();
            this.numBulkActionsCompleted += 1;
        }
        setBulkOperationType(bulkOperationType) {
            this.bulkOperationTypeValue = bulkOperationType;
        }
        getFlowAttributes() {
            if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
                bulkOpsSessionID: this.bulkOpsSessionID,
                numBulkActionsCompleted: this.numBulkActionsCompleted
            };
            return this.bulkOpsSessionID ? {
                bulkOpsSessionID: this.bulkOpsSessionID
            } : {};
        }
        registerAnalyticsEventPublisher(analyticsEventPublisher) {
            this.analyticsEventPublishers.add(analyticsEventPublisher);
            return ()=>{
                this.analyticsEventPublishers.delete(analyticsEventPublisher);
            };
        }
        constructor(){
            this.numBulkActionsCompleted = 0;
            this.analyticsEventPublishers = new Set();
        }
    }
});
parcelRegister("5vJHu", function(module, exports) {
    $parcel$export(module.exports, "useReferenceLoader", ()=>$6eeb97186bbafb10$export$727d936bc4a88f4e);
    var $5uXOq = parcelRequire("5uXOq");
    const $6eeb97186bbafb10$export$727d936bc4a88f4e = ()=>{
        const [ref, setRef] = (0, $5uXOq.useState)(null);
        return (0, $5uXOq.useMemo)(()=>({
                setRef: setRef,
                ref: ref
            }), [
            setRef,
            ref
        ]);
    };
});
parcelRegister("aJDYj", function(module, exports) {
    $parcel$export(module.exports, "useBulkChangePermission", ()=>$947d33e7b3e45493$export$9a67849ec94d7b59);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqQXn;
    var $mk7k0;
    const $947d33e7b3e45493$export$9a67849ec94d7b59 = ()=>{
        const [, { setBulkChangePermission: setBulkChangePermission }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const bulkChangePermission = (0, (0, parcelRequire("lqQXn")).useBulkChangePermissionService)();
        (0, $5uXOq.useEffect)(()=>{
            bulkChangePermission !== null && bulkChangePermission !== undefined && setBulkChangePermission({
                bulkChangePermission: bulkChangePermission
            });
        }, [
            bulkChangePermission,
            setBulkChangePermission
        ]);
        return bulkChangePermission;
    };
});
parcelRegister("lqQXn", function(module, exports) {
    $parcel$export(module.exports, "useBulkChangePermissionService", ()=>$07b9a9bb1eab5d1d$export$cd2838b9aad6b912);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $9OXo1;
    const $07b9a9bb1eab5d1d$export$cd2838b9aad6b912 = ()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [bulkChangePermission, setPermission] = (0, $5uXOq.useState)();
        const getBulkChangePermission = (0, $5uXOq.useCallback)(async ()=>{
            try {
                const gqlResponse = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                    body: JSON.stringify({
                        query: (0, $ce37d40571922cc2$export$f9d7f5d9663f3e0c),
                        variables: {
                            cloudId: cloudId
                        }
                    })
                });
                setPermission(gqlResponse?.data?.jira?.permission?.hasPermission ?? false);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchBulkChangePermission',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to get bulk change permission.'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setPermission(false);
            }
        }, [
            cloudId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!cloudId) return;
            getBulkChangePermission();
        }, [
            getBulkChangePermission,
            cloudId
        ]);
        return bulkChangePermission;
    };
});
const $ce37d40571922cc2$export$f9d7f5d9663f3e0c = `
query GetBulkEditPermission ($cloudId: ID!) {
    jira {
      permission(cloudId: $cloudId, type: BULK_CHANGE)
        @optIn(to: "JiraPermission")
        {
            hasPermission
        }
    }
  }
`;
parcelRegister("hPruQ", function(module, exports) {
    $parcel$export(module.exports, "BulkOperationsLoader", ()=>$c3a3afd760fb1a0d$export$3af81192d3c2a190);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6aXrw;
    var $6s1PB;
    var $a4GFE;
    var $mk7k0;
    var $8e3Yw;
    var $jBW5k;
    const $c3a3afd760fb1a0d$export$3af81192d3c2a190 = ({ bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const { bulkOptimisticUpdate: bulkOptimisticUpdate } = (0, (0, parcelRequire("jBW5k")).useUpdateGroupIssue)();
        const { updateSelectedItemsInCache: updateSelectedItemsInCache } = (0, (0, parcelRequire("a4GFE")).useBulkEditCacheActions)();
        const [{ bulkEditableIssues: selectedIssues }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const onUpdateStart = (0, $5uXOq.useCallback)((res)=>{
            const { data: data, issueIds: issueIds } = res[0];
            if (data) {
                if (groupByFieldId) bulkOptimisticUpdate(issueIds, []);
                else updateSelectedItemsInCache({
                    data: data,
                    issueIds: issueIds
                });
            }
        }, [
            groupByFieldId,
            bulkOptimisticUpdate,
            updateSelectedItemsInCache
        ]);
        const onUpdateError = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($8Rkzz))), []);
        const onUpdateSuccess = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($8Rkzz))), []);
        const onOpenForm = (0, $5uXOq.useCallback)(()=>{
            onOpenSidebar();
        }, [
            onOpenSidebar
        ]);
        const onCloseForm = (0, $5uXOq.useCallback)(()=>{
            onCloseSidebar();
        }, [
            onCloseSidebar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6aXrw")).AsyncBulkOpsCore), {
            bulkOperationsForm: bulkOperationsForm,
            onOpenForm: onOpenForm,
            onCloseForm: onCloseForm,
            onUpdateStart: onUpdateStart,
            onUpdateError: onUpdateError,
            onUpdateSuccess: onUpdateSuccess,
            onLegacyBulkEditRequest: (0, ($parcel$interopDefault($8Rkzz))),
            onSelectAll: (0, ($parcel$interopDefault($8Rkzz))),
            selectableIssueIds: [],
            selectedIssueIds: Array.from(selectedIssues).map(Number) ?? [],
            extraAnalyticsAttributes: {},
            onClearAll: (0, ($parcel$interopDefault($8Rkzz))),
            onClearAllVisible: (0, ($parcel$interopDefault($8Rkzz))),
            hasBulkEditPermission: true,
            ...(0, (0, parcelRequire("6s1PB")).expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && {
                shouldHideToolbar: true
            }
        });
    };
});
parcelRegister("6aXrw", function(module, exports) {
    $parcel$export(module.exports, "AsyncBulkOpsCore", ()=>$dd195193bf05f4ed$export$ac7b39f8b8a9f5cd);
    $parcel$export(module.exports, "BulkOpsCoreWithToolbar", ()=>$dd195193bf05f4ed$export$e277fa5a9b41268f);
    var $5uXOq = parcelRequire("5uXOq");
    var $Pdfe3;
    var $7XluA;
    var $4mO32;
    var $8G5F5;
    var $fvbIR;
    const $dd195193bf05f4ed$var$entryPointParams = {};
    const $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("fvbIR")).asyncBulkOpsCoreEntryPoint), $dd195193bf05f4ed$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira.backlog.bulk.operations.core",
            packageName: "jiraBulkOperationsCore",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            runtimeProps: props
        });
    };
    const $dd195193bf05f4ed$export$e277fa5a9b41268f = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, ...props })=>{
        const hasSelectAllButton = Boolean(props.onSelectAll);
        const extraToolbarButtonsSkeleton = props.extraToolbarButtons?.map((button)=>({
                hasIcon: Boolean(button.icon),
                text: button.name
            })) || [];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8G5F5")).ToolbarWrapper), {
            show: props.selectedIssueIds.length > 0,
            width: "calc(100% - var(--leftSidebarWidth, 0px))"
        }, bulkOpsCoreEntryPointReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jiraAsyncBulkOperationsCoreWithToolBar",
            packageName: "jiraBulkOperationsCoreWithToolBar",
            teamName: "deliveroo",
            entryPointReferenceSubject: bulkOpsCoreEntryPointReference,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Pdfe3")).BulkOperationsToolbarSkeleton), {
                buttons: extraToolbarButtonsSkeleton,
                hasSelectAllButton: hasSelectAllButton
            }),
            runtimeProps: props
        }));
    };
});
parcelRegister("Pdfe3", function(module, exports) {
    $parcel$export(module.exports, "BulkOperationsToolbarSkeleton", ()=>$b74ffcc19e228775$export$59bb23e2f88d002d);
    var $5uXOq = parcelRequire("5uXOq");
    var $eNciG;
    var $koVbs;
    var $3a9td;
    var $98iV2;
    const $b74ffcc19e228775$export$59bb23e2f88d002d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const allButtons = [
            {
                text: formatMessage((0, (0, parcelRequire("98iV2")).messages).editFields),
                hasIcon: true
            },
            {
                text: formatMessage((0, (0, parcelRequire("3a9td")).messages).changeStatus),
                hasIcon: true
            },
            ...buttons
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNciG")).ToolbarSkeleton), {
            hasSelectAllButton: hasSelectAllButton,
            buttons: allButtons
        });
    };
});
parcelRegister("eNciG", function(module, exports) {
    $parcel$export(module.exports, "ToolbarSkeleton", ()=>$ff19fad29388fb19$export$5e29225d56ca7c7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $1DVhQ;
    var $ousew;
    var $koVbs;
    var $eyjpj;
    var $hGxOR;
    const $ff19fad29388fb19$var$SkeletonBase = (props)=>$5uXOq.createElement((0, (0, parcelRequire("1DVhQ")).default), {
            ...props,
            height: "7px",
            isShimmering: true,
            color: "var(--ds-background-accent-gray-subtle, #8590A2)",
            ShimmeringEndColor: "var(--ds-background-accent-gray-bolder, #626F86)",
            width: props.width || '100%',
            "aria-hidden": "true"
        });
    const $ff19fad29388fb19$var$SkeletonActionButton = ({ width: width, text: text, hasIcon: hasIcon })=>{
        return $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff19fad29388fb19$var$skeletonButtonStyles,
            "aria-hidden": "true",
            testId: "floating-toolbar.ui.skeleton.box"
        }, $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
            width: width
        }), $5uXOq.createElement((0, (0, parcelRequire("f5TWP")).default), null, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff19fad29388fb19$var$invisibleTextStyles
        }, text), $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: hasIcon ? $ff19fad29388fb19$var$iconSpacerStyles : $ff19fad29388fb19$var$noIconSpacerStyles
        })));
    };
    const $ff19fad29388fb19$var$SkeletonCloseIcon = ()=>$5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff19fad29388fb19$var$closeIconContainerStyles
        }, $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
            width: "16px"
        }));
    const $ff19fad29388fb19$export$5e29225d56ca7c7d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement((0, (0, parcelRequire("eyjpj")).FloatingToolbarContainer), null, $5uXOq.createElement((0, (0, parcelRequire("eyjpj")).FloatingToolbarContent), null, $5uXOq.createElement((0, (0, parcelRequire("eyjpj")).FloatingToolbarSideContent), null, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), null, $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, null), $5uXOq.createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            "aria-hidden": "true"
        }, $5uXOq.createElement("h2", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _1e0c1txw _1n261g80 _4cvr1h6o _ae4v1h6o _3um015vq _4t3iidpf"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("hGxOR")).default).selectedItemsLabel,
            values: {
                numberOfSelectedItems: 1,
                numberSelected: $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $ff19fad29388fb19$var$numberSelectedStyles
                }, 1)
            }
        }))))), hasSelectAllButton && $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
            text: formatMessage((0, (0, parcelRequire("hGxOR")).default).selectAllButtonLabel),
            hasIcon: true
        }), $5uXOq.createElement((0, (0, parcelRequire("eyjpj")).FloatingToolbarSeparator), null), $5uXOq.createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, buttons.map((button)=>{
            return $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
                key: button.text,
                ...button
            });
        }), $5uXOq.createElement($ff19fad29388fb19$var$SkeletonCloseIcon, null))));
    };
    const $ff19fad29388fb19$var$skeletonButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.100',
        paddingInlineEnd: 'space.150'
    });
    const $ff19fad29388fb19$var$closeIconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.100',
        paddingInlineEnd: 'space.100'
    });
    const $ff19fad29388fb19$var$selectedContainer = null;
    const $ff19fad29388fb19$var$iconSpacerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '26px'
    });
    const $ff19fad29388fb19$var$noIconSpacerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '4px'
    });
    const $ff19fad29388fb19$var$invisibleTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '0',
        visibility: 'hidden'
    });
    const $ff19fad29388fb19$var$numberSelectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        marginRight: 'space.050'
    });
});
parcelRegister("eyjpj", function(module, exports) {
    $parcel$export(module.exports, "FloatingToolbarContainer", ()=>$65d4363d5da90d3d$export$da9876c16f406ff3);
    $parcel$export(module.exports, "FloatingToolbarContent", ()=>$65d4363d5da90d3d$export$634954b758f92d4);
    $parcel$export(module.exports, "FloatingToolbarSeparator", ()=>$65d4363d5da90d3d$export$e9d27765ebab091b);
    $parcel$export(module.exports, "FloatingToolbarSideContent", ()=>$65d4363d5da90d3d$export$fcfdbfa230cd1442);
    $parcel$export(module.exports, "ContentSlider", ()=>$65d4363d5da90d3d$export$ff7934be9f806b5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $35XSW;
    var $8Sbj3;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $koVbs;
    var $faL1o;
    const $65d4363d5da90d3d$export$da9876c16f406ff3 = ({ children: children, onKeyDown: onKeyDown })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "toolbar",
            xcss: $65d4363d5da90d3d$var$floatingContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("faL1o")).messages).toolbarName),
            onKeyDown: onKeyDown
        }, children);
    };
    const $65d4363d5da90d3d$export$634954b758f92d4 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $65d4363d5da90d3d$var$contentContainerStyles,
            alignBlock: "center"
        }, children);
    const $65d4363d5da90d3d$export$e9d27765ebab091b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $65d4363d5da90d3d$var$separatorStyles
        });
    const $65d4363d5da90d3d$export$fcfdbfa230cd1442 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $65d4363d5da90d3d$var$sideContentContainer
        }, children);
    const $65d4363d5da90d3d$export$ff7934be9f806b5f = ({ children: children, show: show })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), null, show && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Sbj3")).default), {
            enterFrom: "bottom",
            fade: "inout"
        }, (slideInProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", slideInProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $65d4363d5da90d3d$var$mainContainerStyles
            }, children))));
    const $65d4363d5da90d3d$var$floatingContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.100',
        backgroundColor: 'color.background.neutral.bold.pressed',
        borderRadius: '6px',
        boxShadow: 'elevation.shadow.overlay'
    });
    const $65d4363d5da90d3d$var$contentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '32px',
        color: 'color.text.inverse',
        fontVariantNumeric: 'tabular-nums'
    });
    const $65d4363d5da90d3d$var$separatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '16px',
        width: '1px',
        backgroundColor: 'elevation.surface.raised',
        borderRadius: '2px',
        marginLeft: 'space.100',
        marginRight: 'space.100'
    });
    const $65d4363d5da90d3d$var$sideContentContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.100',
        paddingRight: 'space.100'
    });
    const $65d4363d5da90d3d$var$mainContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'auto'
    });
});
parcelRegister("faL1o", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$39ec34d441f2b8b5$export$defe85febe8b728c);
    var $7VHMR;
    const $39ec34d441f2b8b5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toolbarName: {
            "id": "floating-toolbar.common.toolbar-name",
            "defaultMessage": "Bulk actions"
        }
    });
});
parcelRegister("hGxOR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5f61683952119ea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d5f61683952119ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectedItemsLabel: {
            "id": "floating-toolbar.selected-items-label",
            "defaultMessage": "{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}"
        },
        clearAllButton: {
            "id": "floating-toolbar.clear-all-button",
            "defaultMessage": "Clear all"
        },
        selectAllButtonLabel: {
            "id": "floating-toolbar.select-all-button-label",
            "defaultMessage": "Select all"
        }
    });
});
parcelRegister("3a9td", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7b322b00365a05e1$export$defe85febe8b728c);
    var $7VHMR;
    const $7b322b00365a05e1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeStatus: {
            "id": "bulk-operations-core.toolbar.change-status-button.change-status",
            "defaultMessage": "Change status"
        }
    });
});
parcelRegister("98iV2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ce2ddaac145135a8$export$defe85febe8b728c);
    var $7VHMR;
    const $ce2ddaac145135a8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editFields: {
            "id": "bulk-operations-core.toolbar.edit-button.edit-fields",
            "defaultMessage": "Edit fields"
        }
    });
});
parcelRegister("8G5F5", function(module, exports) {
    $parcel$export(module.exports, "ToolbarWrapper", ()=>$bb1a9147c120653f$export$b705b0380e6fe1b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $eyjpj;
    const $bb1a9147c120653f$export$b705b0380e6fe1b0 = ({ children: children, show: show, width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $bb1a9147c120653f$var$floatingPositionerStyles
            ],
            style: {
                width: width || '100%'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eyjpj")).ContentSlider), {
            show: show
        }, children));
    const $bb1a9147c120653f$var$floatingPositionerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'fixed',
        bottom: 'space.100',
        zIndex: 'layer',
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'center',
        transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)'
    });
});
parcelRegister("fvbIR", function(module, exports) {
    $parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", ()=>$187b82d9aad4ec6a$export$d90d57132636bb1);
    var $eufEc;
    var $fEDBv;
    const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("aan64")), {
            moduleId: "f81933b6"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("aan64", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXddo")
    ]).then(()=>parcelRequire('k9wdm'));
});
parcelRegister("a4GFE", function(module, exports) {
    $parcel$export(module.exports, "useBulkEditCacheActions", ()=>$e13377b68f17ae57$export$cbb9dab75d903148);
    var $5uXOq = parcelRequire("5uXOq");
    var $fn8B5 = parcelRequire("fn8B5");
    var $daQYX;
    var $deqCE;
    var $hlKA4;
    var $5VgIi;
    var $5fc53;
    var $61h55;
    var $bsMMx;
    var $8TUlY;
    var $9u99d;
    var $4u33f;
    const $e13377b68f17ae57$export$cbb9dab75d903148 = ()=>{
        const { updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [{ issuesMap: issuesMap, issueParentMap: issueParentMap, childrenItems: childrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { getQueryFieldIds: getQueryFieldIds } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const queryFieldIds = getQueryFieldIds();
        const { key: projectKey } = (0, (0, parcelRequire("daQYX")).useProject)();
        const { updateIssueParent: updateIssueParent, unlinkParentIssue: unlinkParentIssue } = (0, (0, parcelRequire("5VgIi")).useUpdateIssueParent)({
            childrenQueryData: childrenItems,
            fieldIds: queryFieldIds,
            issuesMap: issuesMap,
            issueParentMap: issueParentMap,
            cacheQuery: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
            removeChildFromParent: (0, (0, parcelRequire("bsMMx")).removeChildFromParentListView),
            addChildToParent: (0, (0, parcelRequire("bsMMx")).addChildToParentListView),
            view: 'list',
            packageName: 'jiraBusinessList',
            shouldOnlyUpdateCache: true,
            projectKey: projectKey
        });
        const updateSelectedItemsInCache = (0, $5uXOq.useCallback)(({ data: data, issueIds: issueIds })=>{
            const selectedIssuesByParent = (0, ($parcel$interopDefault($fn8B5)))([
                ...issueIds.map((issueId)=>issueId.toString())
            ], (issueId)=>issuesMap.get(issueId)?.parentIssueId || (0, (0, parcelRequire("deqCE")).ROOT_LEVEL));
            const parents = Object.entries(selectedIssuesByParent);
            const optimisticUpdateIssue = (existingIssue)=>{
                const updatedIssue = {
                    ...existingIssue,
                    fields: [
                        ...existingIssue.fields?.filter((field)=>!Object.keys(data).includes(field?.fieldId)) ?? [],
                        ...(0, (0, parcelRequire("4u33f")).transformData)(existingIssue, data)
                    ]
                };
                return updatedIssue;
            };
            parents.forEach(([, issues])=>{
                const variables = issuesMap.get(issues[0])?.cacheVariables;
                if (variables !== undefined) {
                    updateItemsInCache({
                        query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
                        variables: variables,
                        issueIds: issues,
                        updateItem: optimisticUpdateIssue
                    });
                    if (data?.[0, (0, parcelRequire("5fc53")).PARENT_TYPE] !== undefined) issues.forEach((issueId)=>{
                        if (data?.[0, (0, parcelRequire("5fc53")).PARENT_TYPE]?.id) {
                            const parentIssue = issuesMap.get(data?.[0, (0, parcelRequire("5fc53")).PARENT_TYPE].id.toString());
                            if (parentIssue) updateIssueParent({
                                issueKey: issueId,
                                parentIssue: parentIssue
                            });
                        } else unlinkParentIssue({
                            issueKey: issueId
                        });
                    });
                }
            });
        }, [
            issuesMap,
            updateItemsInCache,
            updateIssueParent,
            unlinkParentIssue
        ]);
        return {
            updateSelectedItemsInCache: updateSelectedItemsInCache
        };
    };
});
parcelRegister("5VgIi", function(module, exports) {
    $parcel$export(module.exports, "useUpdateIssueParent", ()=>$31f00dbe71d3540f$export$346cb12ae0ad6251);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $1T2vX;
    var $cm8b5;
    var $kRkJF;
    var $dqDis;
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $pa9q9;
    var $5fc53;
    var $hlKA4;
    var $eVIe2;
    var $cM59n;
    var $4KWeK;
    var $keaDy;
    const $31f00dbe71d3540f$export$346cb12ae0ad6251 = ({ childrenQueryData: childrenQueryData = {}, fieldIds: fieldIds, issueParentMap: issueParentMap, issuesMap: issuesMap, cacheQuery: cacheQuery, addChildToParent: addChildToParent, removeChildFromParent: removeChildFromParent, view: view, packageName: packageName, shouldOnlyUpdateCache: shouldOnlyUpdateCache = false, projectKey: projectKey })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { hierarchyLevels: hierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: view
        });
        const { addToCache: addToCache, getCachedIssueById: getCachedIssueById, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [newParentIssue, setNewParentIssue] = (0, $5uXOq.useState)();
        const [reparentIssue, setReparentIssue] = (0, $5uXOq.useState)();
        const [optimisticRank, setOptimisticRank] = (0, $5uXOq.useState)('');
        const shouldAddToCache = (0, $5uXOq.useRef)(false);
        const [revertData, setRevertData] = (0, $5uXOq.useState)(null);
        const updateParentIssueExperience = (0, (0, parcelRequire("4KWeK")).getUpdateParentIssueExperience)(packageName);
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(updateParentIssueExperience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(updateParentIssueExperience);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(updateParentIssueExperience);
        const updateIssueField = (0, (0, parcelRequire("cM59n")).useUpdateIssueField)({
            onSuccess: ()=>{
                markExperienceSuccess();
            },
            onError: (error)=>{
                if (error.statusCode === 400) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM) : (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_400_FLAG));
                else if (error.statusCode === 404) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_404_FLAG));
                else {
                    showFlag((0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                    markExperienceFailed('update issue parent failed', error);
                }
                throw error;
            }
        });
        const getRankPosition = (0, $5uXOq.useCallback)((rankRequest)=>{
            if (!rankRequest) return;
            const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
            if (relativeIssueId) {
                const relativeIssue = issuesMap.get(relativeIssueId);
                const relativeIssueRank = rankRequest.rankPosition || relativeIssue?.rank;
                if (relativeIssueRank) {
                    const { rankBeforeId: rankBeforeId } = rankRequest;
                    return rankBeforeId ? (0, (0, parcelRequire("dqDis")).getPreviousRank)(relativeIssueRank) : (0, (0, parcelRequire("dqDis")).getNextRank)(relativeIssueRank);
                }
            }
        }, [
            issuesMap
        ]);
        const getVariablesInput = (0, $5uXOq.useCallback)((parentId)=>{
            const defaultVariableInput = {
                jqlContext: jqlContext,
                fieldIds: fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                ...hierarchyLevels !== undefined && {
                    hierarchyLevel: hierarchyLevels[0]?.level
                },
                projectIdOrKey: projectKey
            };
            if (hierarchyParent && parentId) return {
                ...defaultVariableInput,
                hierarchyParent: undefined,
                parentIssue: {
                    hierarchyType: hierarchyParent,
                    issueId: parentId
                }
            };
            return {
                ...defaultVariableInput,
                hierarchyParent: hierarchyParent
            };
        }, [
            jqlContext,
            fieldIds,
            quickFiltersJql,
            isHidingDoneItems,
            hierarchyLevels,
            projectKey,
            hierarchyParent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hierarchyParent && newParentIssue && reparentIssue) {
                const { issueId: newParentId, hasChildren: hasChildren, childSummary: childSummary } = newParentIssue;
                if (childrenQueryData[newParentId] && childrenQueryData[newParentId].loading === false) {
                    const grandParentId = issueParentMap?.get(newParentId) ?? newParentIssue?.parentIssueId;
                    if (!hasChildren || typeof childSummary?.totalCount === 'number') updateItemsInCache({
                        query: cacheQuery,
                        variables: (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId)),
                        issueIds: [
                            newParentIssue.issueId
                        ],
                        updateItem: (existingIssue)=>addChildToParent(existingIssue)
                    });
                    if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                        if (shouldAddToCache.current) {
                            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(newParentId));
                            const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                            addToCache({
                                query: cacheQuery,
                                variables: variables,
                                newNodes: [
                                    optimisticRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, optimisticRank) : newNode
                                ]
                            });
                            shouldAddToCache.current = false;
                            setReparentIssue(undefined);
                            setNewParentIssue(undefined);
                            setOptimisticRank('');
                        }
                    } else {
                        const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(newParentId));
                        const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                        addToCache({
                            query: cacheQuery,
                            variables: variables,
                            newNodes: [
                                optimisticRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, optimisticRank) : newNode
                            ]
                        });
                        setReparentIssue(undefined);
                        setNewParentIssue(undefined);
                        setOptimisticRank('');
                    }
                }
            }
        }, [
            addToCache,
            childrenQueryData,
            getVariablesInput,
            hierarchyParent,
            isHidingDoneItems,
            jqlContext,
            quickFiltersJql,
            newParentIssue,
            reparentIssue,
            updateItemsInCache,
            getCachedIssueById,
            issueParentMap,
            optimisticRank,
            cacheQuery,
            addChildToParent,
            issuesMap,
            view
        ]);
        const updateIssueParentCache = (0, $5uXOq.useCallback)(({ oldParentId: oldParentId, issueKey: issueKey, parentIssue: parentIssue, isMeatballsAction: isMeatballsAction })=>{
            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(oldParentId));
            const issue = getCachedIssueById({
                issueId: issueKey,
                query: cacheQuery,
                variables: variables
            });
            setNewParentIssue(parentIssue);
            if (issue) {
                setReparentIssue(issue);
                if (isMeatballsAction && !(childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) && (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) return;
                removeFromCache({
                    query: cacheQuery,
                    variables: variables,
                    issueId: Number(issueKey)
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                    if (childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) {
                        const originalRank = issuesMap.get(String(issueKey))?.rank;
                        const newVariable = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(parentIssue.issueId));
                        const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(issue, parentIssue, view);
                        addToCache({
                            query: cacheQuery,
                            variables: newVariable,
                            newNodes: [
                                originalRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, originalRank) : newNode
                            ]
                        });
                    } else shouldAddToCache.current = true;
                }
                if (oldParentId && removeChildFromParent) {
                    const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
                    const queryVariables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId));
                    updateItemsInCache({
                        query: cacheQuery,
                        variables: queryVariables,
                        issueIds: [
                            String(oldParentId)
                        ],
                        updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                    });
                }
            }
        }, [
            getVariablesInput,
            getCachedIssueById,
            cacheQuery,
            removeFromCache,
            childrenQueryData,
            removeChildFromParent,
            view,
            addToCache,
            issuesMap,
            updateItemsInCache
        ]);
        const unlinkParentIssueCache = (0, $5uXOq.useCallback)(({ issueKey: issueKey, oldParentId: oldParentId, updateRank: updateRank })=>{
            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(oldParentId));
            const issue = getCachedIssueById({
                issueId: issueKey,
                query: cacheQuery,
                variables: variables
            });
            removeFromCache({
                query: cacheQuery,
                variables: variables,
                issueId: Number(issueKey)
            });
            if (oldParentId && removeChildFromParent) {
                const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
                const queryVariables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId));
                updateItemsInCache({
                    query: cacheQuery,
                    variables: queryVariables,
                    issueIds: [
                        String(oldParentId)
                    ],
                    updateItem: (parentIssue)=>removeChildFromParent(parentIssue, 1)
                });
            }
            const reparentIssueVariable = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput());
            if (issue) {
                const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(issue, undefined, view);
                addToCache({
                    query: cacheQuery,
                    variables: reparentIssueVariable,
                    newNodes: [
                        updateRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, updateRank) : newNode
                    ]
                });
            }
        }, [
            getVariablesInput,
            getCachedIssueById,
            cacheQuery,
            removeFromCache,
            removeChildFromParent,
            issuesMap,
            updateItemsInCache,
            view,
            addToCache
        ]);
        const revertOptimisticCacheUpdate = (0, $5uXOq.useCallback)(({ originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank })=>{
            const originalParent = originalParentId && issuesMap.get(originalParentId);
            if (originalParent) updateIssueParentCache({
                oldParentId: parentIssue?.issueId,
                issueKey: issueKey,
                parentIssue: originalParent
            });
            else if (originalRank && parentIssue) unlinkParentIssueCache({
                oldParentId: parentIssue.issueId,
                issueKey: issueKey,
                updateRank: originalRank
            });
        }, [
            issuesMap,
            unlinkParentIssueCache,
            updateIssueParentCache
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (revertData && revertData.parentIssue?.issueId && childrenQueryData[revertData.parentIssue.issueId] && childrenQueryData[revertData.parentIssue.issueId].loading === false) {
                const { originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank } = revertData;
                originalRank && setOptimisticRank(originalRank);
                revertOptimisticCacheUpdate({
                    originalParentId: originalParentId,
                    parentIssue: parentIssue,
                    issueKey: issueKey,
                    originalRank: originalRank
                });
                setRevertData(null);
            }
        }, [
            childrenQueryData,
            revertData,
            revertOptimisticCacheUpdate
        ]);
        const updateIssueParent = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, parentIssue: parentIssue, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId, isMeatballsAction: isMeatballsAction })=>{
            !shouldOnlyUpdateCache && startExperience();
            const updateRank = getRankPosition(rankRequest);
            if (updateRank) setOptimisticRank(updateRank);
            const issue = issuesMap.get(String(issueKey));
            const originalRank = issue?.rank;
            const oldParentId = oldParentIssueId ?? issueParentMap?.get(issueKey);
            updateIssueParentCache({
                oldParentId: oldParentId,
                issueKey: issueKey,
                parentIssue: parentIssue,
                isMeatballsAction: isMeatballsAction
            });
            if (shouldOnlyUpdateCache) {
                await Promise.resolve();
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
                };
            }
            try {
                await updateIssueField({
                    issueKey: issueKey,
                    fieldKey: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                    newValue: {
                        id: String(parentIssue.issueId)
                    }
                });
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: (0, (0, parcelRequire("4KWeK")).ERROR_ID),
                        packageName: (0, (0, parcelRequire("4KWeK")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("4KWeK")).TEAM_NAME)
                    },
                    attributes: {
                        message: 'update issue parent failed',
                        parentLevel: parentIssue?.issueType?.hierarchyLevel,
                        issueLevel: issue?.issueType?.hierarchyLevel,
                        view: view
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setRevertData({
                    originalParentId: oldParentId,
                    parentIssue: parentIssue,
                    issueKey: issueKey,
                    originalRank: originalRank
                });
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).FAILED)
                };
            }
            return {
                updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
            };
        }, [
            shouldOnlyUpdateCache,
            startExperience,
            getRankPosition,
            issuesMap,
            issueParentMap,
            updateIssueParentCache,
            updateIssueField,
            view
        ]);
        const unlinkParentIssue = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
            !shouldOnlyUpdateCache && startExperience();
            const oldParentId = oldParentIssueId || issueParentMap?.get(issueKey);
            const updateRank = getRankPosition(rankRequest);
            const originalRank = issuesMap.get(String(issueKey))?.rank;
            unlinkParentIssueCache({
                issueKey: issueKey,
                oldParentId: oldParentId,
                updateRank: updateRank
            });
            if (shouldOnlyUpdateCache) {
                await Promise.resolve();
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
                };
            }
            try {
                await updateIssueField({
                    issueKey: issueKey,
                    fieldKey: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                    newValue: {
                        id: null
                    }
                });
            } catch (error) {
                const issue = issuesMap.get(String(issueKey));
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: (0, (0, parcelRequire("4KWeK")).ERROR_ID),
                        packageName: (0, (0, parcelRequire("4KWeK")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("4KWeK")).TEAM_NAME)
                    },
                    attributes: {
                        message: 'unlink issue parent failed',
                        issueLevel: issue?.issueType?.hierarchyLevel,
                        view: view
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                if (originalRank) {
                    setOptimisticRank(originalRank);
                    revertOptimisticCacheUpdate({
                        originalParentId: oldParentId,
                        issueKey: issueKey
                    });
                }
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).FAILED)
                };
            }
            return {
                updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
            };
        }, [
            shouldOnlyUpdateCache,
            startExperience,
            issueParentMap,
            getRankPosition,
            issuesMap,
            unlinkParentIssueCache,
            updateIssueField,
            view,
            revertOptimisticCacheUpdate
        ]);
        return {
            updateIssueParent: updateIssueParent,
            unlinkParentIssue: unlinkParentIssue
        };
    };
});
parcelRegister("eVIe2", function(module, exports) {
    $parcel$export(module.exports, "getOptimisticRanked", ()=>$c396479aef7761d0$export$44963c8ed1f74aef);
    $parcel$export(module.exports, "getListViewRelativeIssueInfo", ()=>$c396479aef7761d0$export$caf645882630a6c1);
    var $5fc53;
    const $c396479aef7761d0$export$44963c8ed1f74aef = (issue, rank)=>{
        const newRank = {
            ...issue?.fields?.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).RANK_CF_TYPE) || field.aliasFieldId === 'rank')
        };
        newRank.text = rank;
        return {
            ...issue,
            fields: [
                ...issue?.fields?.filter((field)=>field.type !== (0, (0, parcelRequire("5fc53")).RANK_CF_TYPE) && field.aliasFieldId !== 'rank') || [],
                newRank
            ]
        };
    };
    const $c396479aef7761d0$export$caf645882630a6c1 = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
        let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';
        if (instruction) rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
        let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);
        if (newIndex === oldIndex) afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
        let relativeIssue = relativeIssueOverride ?? issues[afterIndex];
        if (!relativeIssue?.rank) {
            const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
            relativeIssue = issues[beforeIndex];
            rankCall = 'rankBefore';
        }
        return {
            rankCall: rankCall,
            relativeIssue: relativeIssue
        };
    };
});
parcelRegister("cM59n", function(module, exports) {
    $parcel$export(module.exports, "useUpdateIssueField", ()=>$9bfd5ad22b59743a$export$cc74d3329dbba44d);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $99cgx;
    var $8zOmE;
    var $2NMNM;
    const $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE = 'jwmIssueFieldUpdate';
    const $9bfd5ad22b59743a$export$cc74d3329dbba44d = ({ onError: onError, onSuccess: onSuccess })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const updateIssueField = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue })=>(0, (0, parcelRequire("99cgx")).defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} succeeded`, {
                    field: newValue
                });
                onSuccess && onSuccess();
                return response;
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE,
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} failed`,
                        field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                onError && onError(error);
            }), [
            createAnalyticsEvent,
            onError,
            onSuccess
        ]);
        return updateIssueField;
    };
});
parcelRegister("99cgx", function(module, exports) {
    $parcel$export(module.exports, "defaultSaveField", ()=>$2a246664763defba$export$b74e6b7f831f1cb2);
    $parcel$export(module.exports, "defaultSaveFieldById", ()=>$2a246664763defba$export$b2c49aae5d84cced);
    $parcel$export(module.exports, "defaultAddValuesToField", ()=>$2a246664763defba$export$c46c7284cd9c5d3);
    $parcel$export(module.exports, "defaultRemoveValuesFromField", ()=>$2a246664763defba$export$33b78476f5d734b3);
    var $eusud;
    const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
            fields: {
                [fieldKey]: value
            }
        });
    const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'add',
                        value: valuesToAdd
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
    const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'remove',
                        value: valuesToRemove
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
});
parcelRegister("4KWeK", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", ()=>$524da9ace56d1024$export$e80b28191e1d3602);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", ()=>$524da9ace56d1024$export$29d372313e7a3d7b);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", ()=>$524da9ace56d1024$export$a75bfbb3fb2f437c);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", ()=>$524da9ace56d1024$export$6a4ca5120f2baf63);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", ()=>$524da9ace56d1024$export$4cba4bafd925e182);
    $parcel$export(module.exports, "getUpdateParentIssueExperience", ()=>$524da9ace56d1024$export$8f39ff4e40cb6a05);
    $parcel$export(module.exports, "SUCCEEDED", ()=>$524da9ace56d1024$export$11823571c61d4d02);
    $parcel$export(module.exports, "FAILED", ()=>$524da9ace56d1024$export$d71930f7f5807a72);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$524da9ace56d1024$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "ERROR_ID", ()=>$524da9ace56d1024$export$f3390a0e172fee41);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$524da9ace56d1024$export$d57b6b390e78d90f);
    var $gqQjF;
    const $524da9ace56d1024$export$e80b28191e1d3602 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentGenericErrorDescription
    };
    const $524da9ace56d1024$export$29d372313e7a3d7b = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent400ErrorDescription
    };
    const $524da9ace56d1024$export$a75bfbb3fb2f437c = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent400ErrorDescriptionIssueTermRefresh
    };
    const $524da9ace56d1024$export$6a4ca5120f2baf63 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent404ErrorDescription
    };
    const $524da9ace56d1024$export$4cba4bafd925e182 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent404ErrorDescriptionIssueTermRefresh
    };
    const $524da9ace56d1024$export$8f39ff4e40cb6a05 = (packageName)=>({
            experience: 'updateParentIssue',
            packageName: packageName,
            teamName: 'keystone'
        });
    const $524da9ace56d1024$export$11823571c61d4d02 = 'SUCCEEDED';
    const $524da9ace56d1024$export$d71930f7f5807a72 = 'FAILED';
    const $524da9ace56d1024$export$b8b9d90f9e5bd72b = 'jiraBusinessListHandlers';
    const $524da9ace56d1024$export$f3390a0e172fee41 = 'useUpdateIssueParent';
    const $524da9ace56d1024$export$d57b6b390e78d90f = 'keystone';
});
parcelRegister("gqQjF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0fc83ceaf8c6923$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c0fc83ceaf8c6923$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateIssueParentErrorTitle: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        updateIssueParentGenericErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-generic-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        updateIssueParent400ErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description",
            "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
        },
        updateIssueParent404ErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description",
            "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
        },
        updateIssueParent400ErrorDescriptionIssueTermRefresh: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-issue-term-refresh",
            "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
        },
        updateIssueParent404ErrorDescriptionIssueTermRefresh: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-issue-term-refresh",
            "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
        }
    });
});
parcelRegister("keaDy", function(module, exports) {
    $parcel$export(module.exports, "generateIssueWithUpdatedParent", ()=>$2bb42896f508435e$export$2b799a607e235a03);
    var $4R6GH;
    var $5fc53;
    const $2bb42896f508435e$export$32c176d5dc779b09 = (rank)=>rank ? [
            {
                aliasFieldId: 'rank',
                text: rank,
                __typename: 'JiraSingleLineTextField'
            }
        ] : null;
    const $2bb42896f508435e$var$generateParentField = (issueId, key, id, rank, view)=>{
        const shouldHaveIdAttribute = (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && view === 'list';
        return {
            aliasFieldId: null,
            fieldId: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
            type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
            name: 'Parent',
            parentIssue: issueId && key ? {
                __typename: 'JiraIssue',
                issueId: issueId,
                key: key,
                ...shouldHaveIdAttribute ? {
                    id: id
                } : {},
                rankField: $2bb42896f508435e$export$32c176d5dc779b09(rank)
            } : null,
            __typename: 'JiraParentIssueField'
        };
    };
    const $2bb42896f508435e$export$2b799a607e235a03 = (issue, newParentIssue, view)=>{
        const { issueId: newParentIssueId, key: newParentKey, id: newParentId, rank: newParentRank } = newParentIssue || {};
        const parentFieldIndex = issue?.fields?.findIndex((field)=>field.type === (0, (0, parcelRequire("5fc53")).PARENT_TYPE) || field.fieldId === (0, (0, parcelRequire("5fc53")).PARENT_TYPE));
        const shouldHaveIdAttribute = (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && view === 'list';
        const parentField = parentFieldIndex !== -1 && parentFieldIndex !== undefined ? {
            ...issue?.fields?.[parentFieldIndex],
            parentIssue: !newParentIssueId || !newParentKey ? null : {
                ...shouldHaveIdAttribute ? {
                    id: newParentId
                } : {},
                issueId: newParentIssueId,
                rankField: $2bb42896f508435e$export$32c176d5dc779b09(newParentRank),
                key: newParentKey,
                __typename: 'JiraIssue'
            }
        } : $2bb42896f508435e$var$generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);
        return {
            ...issue,
            fields: [
                ...issue?.fields?.filter((field)=>field.type !== (0, (0, parcelRequire("5fc53")).PARENT_TYPE) && field.fieldId !== (0, (0, parcelRequire("5fc53")).PARENT_TYPE)) || [],
                parentField
            ]
        };
    };
});
parcelRegister("4u33f", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$fd962ec12b5e85da$export$3ceb62baab058c6b);
    var $1tNy6;
    const $fd962ec12b5e85da$export$3ceb62baab058c6b = (existingIssue, data)=>{
        const optimisticUpdateFields = [];
        return Object.keys(data).reduce((acc, fieldId)=>{
            const accumulator = acc;
            const existingField = existingIssue.fields?.find((field)=>field.fieldId === fieldId);
            if (existingField) {
                if ((0, (0, parcelRequire("1tNy6")).isOptimisticUpdateSupported)(existingField.type)) {
                    const fieldFormValue = data[existingField.fieldId];
                    if (fieldFormValue === undefined) return accumulator;
                    const transformedField = (0, (0, parcelRequire("1tNy6")).transformFieldForOptimisticUpdates)(existingField.type, existingField, fieldFormValue);
                    if (transformedField !== undefined) accumulator.push(transformedField);
                } else accumulator.push(existingField);
            }
            return accumulator;
        }, optimisticUpdateFields);
    };
});
parcelRegister("1tNy6", function(module, exports) {
    $parcel$export(module.exports, "transformFieldForOptimisticUpdates", ()=>$f81bbc933ba84564$export$efcd89b84c6a3e91);
    $parcel$export(module.exports, "isOptimisticUpdateSupported", ()=>$f81bbc933ba84564$export$d96ec240de147154);
    var $8QpSo;
    var $cjwQR;
    var $7TMJD;
    var $8gg2R;
    var $ipj45;
    var $dfRts;
    var $huhmz;
    var $1W9Eo;
    var $5Tu55;
    var $5oQ5q;
    var $bHeL8;
    var $cTipH;
    var $8fxvG;
    const $f81bbc933ba84564$var$createSupportedBulkEditTransformations = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("1W9Eo")).priorityOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("cTipH")).userOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("8gg2R")).labelsOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("cjwQR")).dateOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("7TMJD")).dateTimeOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("ipj45")).multiSelectOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("dfRts")).numberOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("huhmz")).parentOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("8fxvG")).versionOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("5Tu55")).singleSelectOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("bHeL8")).urlOptimisticUpdatesHandler),
            ...(0, (0, parcelRequire("5oQ5q")).textOptimisticUpdatesHandler)
        }));
    const $f81bbc933ba84564$export$efcd89b84c6a3e91 = (fieldType, ...args)=>{
        const handlers = $f81bbc933ba84564$var$createSupportedBulkEditTransformations();
        if (!handlers[fieldType]) return;
        return handlers[fieldType](...args);
    };
    const $f81bbc933ba84564$export$d96ec240de147154 = (fieldType)=>{
        const handlers = $f81bbc933ba84564$var$createSupportedBulkEditTransformations();
        return handlers[fieldType] !== null;
    };
});
parcelRegister("cjwQR", function(module, exports) {
    $parcel$export(module.exports, "dateOptimisticUpdatesHandler", ()=>$675901b25b250cde$export$f6ab9c7ce755192);
    var $5fc53;
    const $675901b25b250cde$export$fb826df18639e2fa = (existingField, fieldData)=>({
            ...existingField,
            date: fieldData ?? null
        });
    const $675901b25b250cde$export$f6ab9c7ce755192 = {
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa,
        [(0, (0, parcelRequire("5fc53")).START_DATE_TYPE)]: $675901b25b250cde$export$fb826df18639e2fa
    };
});
parcelRegister("7TMJD", function(module, exports) {
    $parcel$export(module.exports, "dateTimeOptimisticUpdatesHandler", ()=>$5d84f1e94dc3713c$export$a24474a096daecea);
    var $5fc53;
    const $5d84f1e94dc3713c$export$3863479bf706ee55 = (existingField, fieldData)=>({
            ...existingField,
            dateTime: fieldData ?? null
        });
    const $5d84f1e94dc3713c$export$a24474a096daecea = {
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $5d84f1e94dc3713c$export$3863479bf706ee55
    };
});
parcelRegister("8gg2R", function(module, exports) {
    $parcel$export(module.exports, "labelsOptimisticUpdatesHandler", ()=>$69575aae1fc11e8b$export$ae3a6c05d0376219);
    var $5fc53;
    var $1s49T;
    const $69575aae1fc11e8b$export$24889be11660a2f9 = (existingField, fieldData)=>{
        const action = fieldData.action;
        const existingLabels = existingField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
        const labelNodes = (0, (0, parcelRequire("1s49T")).transformOptionsUsingMultiAction)({
            existingOptions: existingLabels,
            options: fieldData.value.map((value)=>({
                    __typename: 'JiraLabel',
                    labelId: null,
                    name: value.value
                })),
            action: action,
            isEqual: (option, existingOption)=>option.name === existingOption.name
        });
        return {
            ...existingField,
            selectedLabelsConnection: {
                __typename: 'JiraLabelConnection',
                edges: labelNodes?.map((node)=>({
                        __typename: 'JiraLabelEdge',
                        node: node
                    })) ?? null
            }
        };
    };
    const $69575aae1fc11e8b$export$ae3a6c05d0376219 = {
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $69575aae1fc11e8b$export$24889be11660a2f9
    };
});
parcelRegister("1s49T", function(module, exports) {
    $parcel$export(module.exports, "transformOptionsUsingMultiAction", ()=>$553b6571b5146a7e$export$de5a9a8aa203227b);
    const $553b6571b5146a7e$export$de5a9a8aa203227b = ({ existingOptions: existingOptions, options: options, action: action, isEqual: isEqual })=>{
        if (action === 'set') return options;
        if (action === 'add') return [
            ...existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption))),
            ...options
        ];
        if (action === 'remove') return existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption)));
        return null;
    };
});
parcelRegister("ipj45", function(module, exports) {
    $parcel$export(module.exports, "multiSelectOptimisticUpdatesHandler", ()=>$4c6a47d622007833$export$451576b5e993a4c6);
    var $5fc53;
    const $4c6a47d622007833$export$6308785fb410c4b7 = (existingField, fieldData)=>({
            ...existingField,
            selectedOptions: {
                __typename: 'JiraOptionConnection',
                edges: fieldData.map((field)=>({
                        __typename: 'JiraOptionEdge',
                        node: {
                            __typename: 'JiraOption',
                            optionId: '',
                            value: field.value
                        }
                    }))
            }
        });
    const $4c6a47d622007833$export$451576b5e993a4c6 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $4c6a47d622007833$export$6308785fb410c4b7
    };
});
parcelRegister("dfRts", function(module, exports) {
    $parcel$export(module.exports, "numberOptimisticUpdatesHandler", ()=>$65867e0dbf8cbf13$export$b507b41c3a04d8b2);
    var $5fc53;
    const $65867e0dbf8cbf13$export$db1d3572e95020a7 = (existingField, fieldData)=>({
            ...existingField,
            number: fieldData
        });
    const $65867e0dbf8cbf13$export$b507b41c3a04d8b2 = {
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7,
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7,
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: $65867e0dbf8cbf13$export$db1d3572e95020a7
    };
});
parcelRegister("huhmz", function(module, exports) {
    $parcel$export(module.exports, "parentOptimisticUpdatesHandler", ()=>$948415c29bf235c9$export$beaef88a0d44b30c);
    var $5fc53;
    const $948415c29bf235c9$export$b807f08dd17c9fef = (existingField, fieldData)=>({
            ...existingField,
            parentIssue: {
                __typename: 'JiraIssue',
                id: fieldData.id?.toString() || '',
                issueId: fieldData.value.toString(),
                key: fieldData.key,
                rankField: [],
                fields: [
                    {
                        fieldId: 'summary',
                        aliasFieldId: null,
                        name: 'Summary',
                        type: 'summary',
                        text: fieldData.fields.summary,
                        __typename: 'JiraSingleLineTextField'
                    },
                    {
                        fieldId: 'issuetype',
                        aliasFieldId: null,
                        name: 'Issue Type',
                        type: 'issuetype',
                        __typename: 'JiraIssueTypeField',
                        issueType: {
                            __typename: 'JiraIssueType',
                            name: fieldData?.fields?.issuetype?.name || '',
                            avatar: {
                                medium: fieldData?.fields?.issuetype?.iconUrl?.replace('xsmall', 'medium'),
                                __typename: 'JiraAvatar'
                            }
                        }
                    }
                ]
            }
        });
    const $948415c29bf235c9$export$beaef88a0d44b30c = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $948415c29bf235c9$export$b807f08dd17c9fef
    };
});
parcelRegister("1W9Eo", function(module, exports) {
    $parcel$export(module.exports, "priorityOptimisticUpdatesHandler", ()=>$4e87693315b8215f$export$1722f398d0e70c01);
    var $fNrEJ;
    var $5fc53;
    const $4e87693315b8215f$export$5096de161ee14da = (existingField, fieldData)=>{
        const priorityId = fieldData.value && (0, (0, parcelRequire("fNrEJ")).JiraPriorityAri).check(fieldData.value) ? (0, (0, parcelRequire("fNrEJ")).JiraPriorityAri).parse(fieldData.value).resourceId : fieldData?.value ?? '';
        return {
            ...existingField,
            priority: {
                id: fieldData.value ?? '',
                name: fieldData.label,
                priorityId: priorityId,
                iconUrl: fieldData.iconUrl,
                __typename: 'JiraPriority'
            }
        };
    };
    const $4e87693315b8215f$export$1722f398d0e70c01 = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $4e87693315b8215f$export$5096de161ee14da
    };
});
parcelRegister("fNrEJ", function(module, exports) {
    $parcel$export(module.exports, "JiraPriorityAri", ()=>$b800e28661efd3f9$export$5f41709ebd395cb1);
    var $7ZK4B;
    var $9KGzW;
    var $1C2Ux;
    var $b800e28661efd3f9$var$jiraPriorityAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("7ZK4B")).JiraPriorityAriResourceOwner),
        resourceType: (0, (0, parcelRequire("7ZK4B")).JiraPriorityAriResourceType),
        resourceIdSlug: "activation/{activationId}/{priorityId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            priorityId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $b800e28661efd3f9$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get priorityId() {
            return this._priorityId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $b800e28661efd3f9$var$jiraPriorityAriStaticOpts.qualifier,
                platformQualifier: $b800e28661efd3f9$var$jiraPriorityAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $b800e28661efd3f9$var$jiraPriorityAriStaticOpts.resourceOwner,
                resourceType: $b800e28661efd3f9$var$jiraPriorityAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    priorityId: opts.priorityId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $b800e28661efd3f9$var$jiraPriorityAriStaticOpts);
            return new _JiraPriorityAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $b800e28661efd3f9$var$jiraPriorityAriStaticOpts);
            return new _JiraPriorityAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                priorityId: this.priorityId
            };
        }
    };
});
parcelRegister("7ZK4B", function(module, exports) {
    $parcel$export(module.exports, "JiraPriorityAriResourceOwner", ()=>$5d21f81242417687$export$a154bdc743e3d7f4);
    $parcel$export(module.exports, "JiraPriorityAriResourceType", ()=>$5d21f81242417687$export$f5f5f4d1fc71ee3e);
    var $5d21f81242417687$export$a154bdc743e3d7f4 = "jira", $5d21f81242417687$export$f5f5f4d1fc71ee3e = "priority";
});
parcelRegister("5Tu55", function(module, exports) {
    $parcel$export(module.exports, "singleSelectOptimisticUpdatesHandler", ()=>$376f9aee475cbb0c$export$3bfe96bec4aaa3d1);
    var $5fc53;
    const $376f9aee475cbb0c$export$1c2a2f3ef1a9bb3 = (existingField, fieldData)=>{
        if (fieldData === null) return {
            ...existingField,
            fieldOption: null
        };
        return {
            ...existingField,
            fieldOption: {
                __typename: 'JiraOption',
                optionId: fieldData.value,
                value: fieldData.label,
                color: null
            }
        };
    };
    const $376f9aee475cbb0c$export$3bfe96bec4aaa3d1 = {
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $376f9aee475cbb0c$export$1c2a2f3ef1a9bb3
    };
});
parcelRegister("5oQ5q", function(module, exports) {
    $parcel$export(module.exports, "textOptimisticUpdatesHandler", ()=>$26cb1f779e5562aa$export$6d32d6f2341892ca);
    var $5fc53;
    const $26cb1f779e5562aa$export$dff85ea10550e176 = (existingField, fieldData)=>({
            ...existingField,
            text: !fieldData ? ' ' : fieldData
        });
    const $26cb1f779e5562aa$export$6d32d6f2341892ca = {
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $26cb1f779e5562aa$export$dff85ea10550e176
    };
});
parcelRegister("bHeL8", function(module, exports) {
    $parcel$export(module.exports, "urlOptimisticUpdatesHandler", ()=>$1a3fe8279dbe22b4$export$5275c3199d66bb55);
    var $5fc53;
    const $1a3fe8279dbe22b4$export$2fdc0fb9ea4e0c38 = (existingField, fieldData)=>({
            ...existingField,
            uri: !fieldData ? null : fieldData
        });
    const $1a3fe8279dbe22b4$export$5275c3199d66bb55 = {
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: $1a3fe8279dbe22b4$export$2fdc0fb9ea4e0c38
    };
});
parcelRegister("cTipH", function(module, exports) {
    $parcel$export(module.exports, "userOptimisticUpdatesHandler", ()=>$8ac8bda4358749d4$export$2205d16240a6327f);
    var $hE5wF;
    var $5fc53;
    const $8ac8bda4358749d4$var$activeAccountStatus = 'active';
    const $8ac8bda4358749d4$export$ae35491859a54223 = (existingField, fieldData)=>({
            ...existingField,
            user: fieldData != null ? {
                accountId: fieldData.accountId ?? '',
                accountStatus: $8ac8bda4358749d4$var$activeAccountStatus,
                picture: fieldData.avatarUrls[0, (0, parcelRequire("hE5wF")).DEFAULT_AVATAR_RES],
                name: fieldData.displayName,
                __typename: 'AtlassianAccountUser'
            } : null
        });
    const $8ac8bda4358749d4$export$741c2fd1d5e759e7 = (existingField, fieldData)=>({
            ...existingField,
            user: fieldData != null ? {
                accountId: fieldData.id ?? '',
                accountStatus: $8ac8bda4358749d4$var$activeAccountStatus,
                picture: fieldData.avatarUrl,
                name: fieldData.name,
                __typename: 'AtlassianAccountUser'
            } : null
        });
    const $8ac8bda4358749d4$export$2205d16240a6327f = {
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $8ac8bda4358749d4$export$741c2fd1d5e759e7,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $8ac8bda4358749d4$export$ae35491859a54223
    };
});
parcelRegister("8fxvG", function(module, exports) {
    $parcel$export(module.exports, "versionOptimisticUpdatesHandler", ()=>$1174451c6262e677$export$ded24c5df4d4a072);
    var $5fc53;
    var $1s49T;
    const $1174451c6262e677$export$23dfa4890df81d45 = (existingField, fieldData)=>({
            ...existingField,
            version: fieldData ? {
                __typename: 'JiraVersion',
                versionId: fieldData.value,
                name: fieldData.label
            } : null
        });
    const $1174451c6262e677$export$ab0e3c9aa41c8369 = (existingField, fieldData)=>{
        const action = fieldData.action;
        const existingVersions = existingField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
        const versionNodes = (0, (0, parcelRequire("1s49T")).transformOptionsUsingMultiAction)({
            existingOptions: existingVersions,
            options: fieldData.value.map((value)=>({
                    __typename: 'JiraVersion',
                    versionId: value.value,
                    name: value.label
                })),
            action: action,
            isEqual: (option, existingOption)=>option.versionId === existingOption.versionId
        });
        return {
            ...existingField,
            selectedVersionsConnection: {
                __typename: 'JiraVersionConnection',
                edges: versionNodes?.map((node)=>({
                        __typename: 'JiraVersionEdge',
                        node: node
                    })) ?? null
            }
        };
    };
    const $1174451c6262e677$export$ded24c5df4d4a072 = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $1174451c6262e677$export$23dfa4890df81d45,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $1174451c6262e677$export$ab0e3c9aa41c8369
    };
});
parcelRegister("jBW5k", function(module, exports) {
    $parcel$export(module.exports, "useUpdateGroupIssue", ()=>$030e59a1f2f630ab$export$43b9ca95cc220db0);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $jDUax;
    var $hlKA4;
    var $jcw0u;
    var $6s1PB;
    var $eusud;
    var $pa9q9;
    var $99cgx;
    var $dXq4S;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $koeKL;
    var $bs8Kk;
    var $61h55;
    var $4FAe4;
    var $3xYz2;
    var $9u99d;
    var $aQbWi;
    var $eg2To;
    var $Jhh8D;
    const $030e59a1f2f630ab$export$43b9ca95cc220db0 = ()=>{
        const { getCachedIssueById: getCachedIssueById } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const { addToGroupCache: addToGroupCache } = (0, (0, parcelRequire("3xYz2")).useGroupCacheActions)();
        const [{ rankParentIssueId: rankParentIssueId }] = (0, (0, parcelRequire("aQbWi")).useRankParent)();
        const input = (0, (0, parcelRequire("eg2To")).useIssuesInput)({
            groupIssueId: (0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
            parentIssueId: !(0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
        });
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [originalIssue, setOriginalIssue] = (0, $5uXOq.useState)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [updateError, setUpdateError] = (0, $5uXOq.useState)(null);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        (0, $5uXOq.useEffect)(()=>{
            if (updateError) {
                setUpdateError(null);
                if (originalIssue) {
                    addToGroupCache([
                        originalIssue
                    ]);
                    setOriginalIssue(null);
                }
                showFlag({
                    type: 'error',
                    title: [
                        (0, (0, parcelRequire("Jhh8D")).default).errorTitle,
                        {
                            field: updateError.field
                        }
                    ],
                    description: [
                        (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("Jhh8D")).default).errorMessageIssueTermRefresh : (0, (0, parcelRequire("Jhh8D")).default).errorMessage,
                        {
                            field: updateError.field
                        }
                    ]
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: updateError.query,
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    error: updateError.error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            originalIssue,
            updateError,
            addToGroupCache,
            showFlag
        ]);
        const optimisticUpdate = (0, $5uXOq.useCallback)((issue, fieldType, field)=>{
            const cachedIssue = getCachedIssueById({
                issueId: issue.issueId,
                query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
                variables: {
                    ...(0, (0, parcelRequire("egmQO")).getVariables)(input),
                    cloudId: cloudId
                }
            });
            setOriginalIssue(cachedIssue);
            if (cachedIssue) {
                const updatedIssue = {
                    ...cachedIssue,
                    fields: [
                        ...cachedIssue.fields?.filter((cachedField)=>cachedField.fieldId !== fieldType) ?? [],
                        field
                    ]
                };
                addToGroupCache([
                    updatedIssue
                ]);
            }
        }, [
            getCachedIssueById,
            input,
            cloudId,
            addToGroupCache
        ]);
        const bulkOptimisticUpdate = (0, $5uXOq.useCallback)((issueIds, fields)=>{
            const cachedIssues = issueIds.map((issueId)=>getCachedIssueById({
                    issueId: issueId.toString(),
                    query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
                    variables: {
                        ...issuesMap.get(issueId.toString())?.cacheVariables,
                        cloudId: cloudId
                    }
                })).filter(Boolean);
            const fieldIds = fields.map((field)=>field.fieldId);
            if (cachedIssues.length) {
                const updatedIssues = cachedIssues.map((cachedIssue)=>({
                        ...cachedIssue,
                        fields: [
                            ...cachedIssue.fields?.filter((cachedField)=>!fieldIds.includes(cachedField.fieldId)) ?? [],
                            ...fields
                        ]
                    }));
                addToGroupCache(updatedIssues);
            }
        }, [
            getCachedIssueById,
            issuesMap,
            cloudId,
            addToGroupCache
        ]);
        const updateField = (0, $5uXOq.useCallback)((issue, fieldType, fieldValue, analyticsAlias)=>{
            (0, (0, parcelRequire("99cgx")).defaultSaveField)((0, (0, parcelRequire("g5X3G")).toIssueKey)(issue.key), fieldType, fieldValue, '').then(()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $7d2725467dc93480$export$406cbd2164fd0d71)} succeeded`, {
                    field: (0, (0, parcelRequire("bs8Kk")).getFieldForAnalytics)(fieldType, analyticsAlias)
                });
            }).catch((error)=>{
                setUpdateError({
                    error: error,
                    field: (0, (0, parcelRequire("bs8Kk")).getFieldForAnalytics)(fieldType, analyticsAlias),
                    query: (0, $7d2725467dc93480$export$406cbd2164fd0d71)
                });
            });
        }, [
            setUpdateError,
            createAnalyticsEvent
        ]);
        const updateAssignee = (0, $5uXOq.useCallback)((issue, fieldValue)=>{
            const newField = {
                aliasFieldId: null,
                fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                name: 'assignee',
                type: 'assignee',
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                __typename: 'JiraSingleSelectUserPickerField',
                user: fieldValue != null ? {
                    accountId: fieldValue.accountId,
                    accountStatus: (0, (0, parcelRequire("4FAe4")).AccountStatus).active,
                    picture: fieldValue.avatarUrl,
                    name: fieldValue.displayName,
                    __typename: 'AtlassianAccountUser'
                } : null
            };
            optimisticUpdate(issue, (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE), newField);
            if (fieldValue === null || fieldValue === undefined) updateField(issue, (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE), null);
            else (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/2/user/assignable/search?issueKey=${issue.key}&accountId=${fieldValue.accountId}`).then((response)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $7d2725467dc93480$export$3e3161555559eda3)} succeeded`);
                if (Array.isArray(response) && response[0]) updateField(issue, (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE), response[0]);
                else setUpdateError({
                    error: new Error('User does not exist or is not allowed to be assigned to the issue'),
                    field: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                    query: (0, $7d2725467dc93480$export$3e3161555559eda3)
                });
            }).catch((error)=>{
                setUpdateError({
                    error: error,
                    field: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                    query: (0, $7d2725467dc93480$export$3e3161555559eda3)
                });
            });
        }, [
            optimisticUpdate,
            updateField,
            setUpdateError,
            createAnalyticsEvent
        ]);
        const updatePriority = (0, $5uXOq.useCallback)((issue, fieldValue)=>{
            if (fieldValue) {
                const priorityId = fieldValue.id && (0, (0, parcelRequire("dXq4S")).isAri)(fieldValue.id) ? (0, (0, parcelRequire("dXq4S")).getAriConfig)(fieldValue.id).resourceId : fieldValue?.id ?? null;
                const newField = {
                    aliasFieldId: null,
                    fieldId: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                    type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                    name: 'Priority',
                    priority: {
                        id: fieldValue.id ?? '',
                        name: fieldValue.name,
                        priorityId: priorityId ?? '',
                        iconUrl: fieldValue.iconUrl,
                        __typename: 'JiraPriority'
                    },
                    __typename: 'JiraPriorityField'
                };
                optimisticUpdate(issue, (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE), newField);
                updateField(issue, (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE), {
                    ...fieldValue,
                    id: priorityId
                });
            }
        }, [
            optimisticUpdate,
            updateField
        ]);
        const updateCategory = (0, $5uXOq.useCallback)((issue, fieldKey, fieldValue)=>{
            const category = fieldValue ? {
                value: fieldValue.name,
                label: fieldValue.name
            } : null;
            const newField = {
                aliasFieldId: null,
                fieldId: fieldKey,
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                __typename: 'JiraSingleSelectField',
                name: 'Category',
                type: (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
                fieldOption: fieldValue ? {
                    optionId: fieldValue.optionId,
                    value: fieldValue.name,
                    color: fieldValue.color ? {
                        colorKey: fieldValue.color,
                        __typename: 'JiraColor'
                    } : null,
                    __typename: 'JiraOption'
                } : null
            };
            optimisticUpdate(issue, fieldKey, newField);
            updateField(issue, fieldKey, category, 'category');
        }, [
            optimisticUpdate,
            updateField
        ]);
        const updateJiraNumber = (0, $5uXOq.useCallback)((issue, field, number)=>{
            if (typeof number !== 'undefined') {
                const newField = {
                    fieldId: field.id,
                    aliasFieldId: field.aliasFieldId || null,
                    name: field.name,
                    type: field.type,
                    number: number,
                    fieldConfig: {
                        isEditable: true,
                        __typename: 'JiraFieldConfig'
                    },
                    __typename: 'JiraNumberField'
                };
                optimisticUpdate(issue, field.id, newField);
                updateField(issue, field.id, number, newField.aliasFieldId || newField.type);
            }
        }, [
            optimisticUpdate,
            updateField
        ]);
        const updateSprint = (0, $5uXOq.useCallback)((issue, field, sprint)=>{
            if (typeof sprint !== 'undefined') {
                const newField = {
                    fieldId: field.id,
                    name: field.name,
                    aliasFieldId: 'sprint',
                    type: (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
                    fieldConfig: {
                        isEditable: true,
                        __typename: 'JiraFieldConfig'
                    },
                    selectedSprintsConnection: {
                        edges: sprint === null ? [] : [
                            {
                                node: {
                                    sprintId: String(sprint.id),
                                    name: sprint.name,
                                    state: sprint.state,
                                    __typename: 'JiraSprint'
                                },
                                __typename: 'JiraSprintEdge'
                            }
                        ],
                        __typename: 'JiraSprintConnection'
                    },
                    __typename: 'JiraSprintField'
                };
                optimisticUpdate(issue, field.id, newField);
                updateField(issue, field.id, sprint === null ? null : Number(sprint.id), 'sprint');
            }
        }, [
            optimisticUpdate,
            updateField
        ]);
        return {
            updateAssignee: updateAssignee,
            updatePriority: updatePriority,
            updateCategory: updateCategory,
            updateJiraNumber: updateJiraNumber,
            updateSprint: updateSprint,
            bulkOptimisticUpdate: bulkOptimisticUpdate
        };
    };
});
parcelRegister("bs8Kk", function(module, exports) {
    $parcel$export(module.exports, "getFieldForAnalytics", ()=>$4e9f4ccdb8980f86$export$af1963dc1f827ac2);
    var $5fc53;
    const $4e9f4ccdb8980f86$export$af1963dc1f827ac2 = (fieldType, analyticsAlias)=>{
        if (analyticsAlias) {
            if (analyticsAlias === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) return 'category';
            return analyticsAlias;
        }
        return fieldType;
    };
});
parcelRegister("4FAe4", function(module, exports) {
    $parcel$export(module.exports, "AccountStatus", ()=>$83fafda9779bb4f3$export$3693f74db10d5f88);
    var $83fafda9779bb4f3$export$3693f74db10d5f88;
    (function(AccountStatus) {
        AccountStatus["active"] = "active";
        AccountStatus["closed"] = "closed";
        AccountStatus["inactive"] = "inactive";
    })($83fafda9779bb4f3$export$3693f74db10d5f88 || ($83fafda9779bb4f3$export$3693f74db10d5f88 = {}));
});
const $7d2725467dc93480$export$3e3161555559eda3 = 'updateGroupIssueAssigneeSearch';
const $7d2725467dc93480$export$406cbd2164fd0d71 = 'updateGroupIssueUpdateField';
parcelRegister("Jhh8D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f701cde766a4ed4b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f701cde766a4ed4b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.controllers.update-group-issue.error-title",
            "defaultMessage": "Failed to update {field}"
        },
        errorMessage: {
            "id": "business-list.controllers.update-group-issue.error-message",
            "defaultMessage": "Something went wrong updating the issue's {field} field. Please try again or contact your administrator if the problem persists."
        },
        errorMessageIssueTermRefresh: {
            "id": "business-list.controllers.update-group-issue.error-message-issue-term-refresh",
            "defaultMessage": "Something went wrong updating the {field} field in the work item. Try again or contact your admin."
        }
    });
});
parcelRegister("2Len7", function(module, exports) {
    $parcel$export(module.exports, "BulkEditSidebar", ()=>$601fad54799fc304$export$43008afc76943d65);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $bUSNl;
    var $mk7k0;
    const $601fad54799fc304$var$useOnUnmount = (fn)=>{
        const currentFn = (0, $5uXOq.useRef)(fn);
        currentFn.current = fn;
        (0, $5uXOq.useEffect)(()=>()=>currentFn.current(), []);
    };
    const $601fad54799fc304$export$43008afc76943d65 = ({ bulkOperationsForm: bulkOperationsForm })=>{
        const [{ content: content }, { resetSidebarQueryParams: resetSidebarQueryParams, setSidebarContent: _setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const [{ showBulkEditSidebar: showBulkEditSidebar }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const lastSetSidebarContent = (0, $5uXOq.useRef)(null);
        const setSidebarContent = (0, $5uXOq.useCallback)((newContent)=>{
            _setSidebarContent(newContent);
            lastSetSidebarContent.current = newContent;
        }, [
            _setSidebarContent
        ]);
        const resetSidebarContent = (0, $5uXOq.useCallback)(()=>{
            if (lastSetSidebarContent.current) setSidebarContent(null);
        }, [
            setSidebarContent
        ]);
        $601fad54799fc304$var$useOnUnmount(resetSidebarContent);
        const sidebarContent = (0, $5uXOq.useMemo)(()=>showBulkEditSidebar ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.wrapper",
                xcss: $601fad54799fc304$var$wrapperStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.bulkops-sidebar",
                ref: bulkOperationsForm.setRef,
                xcss: $601fad54799fc304$var$containerStyles
            })) : null, [
            bulkOperationsForm.setRef,
            showBulkEditSidebar
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!sidebarContent) return;
            if (!lastSetSidebarContent.current) resetSidebarQueryParams();
            if (content !== sidebarContent) setSidebarContent(sidebarContent);
        }, [
            content,
            resetSidebarQueryParams,
            setSidebarContent,
            sidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (sidebarContent) return;
            if (content && content === lastSetSidebarContent.current) resetSidebarContent();
        }, [
            content,
            resetSidebarContent,
            sidebarContent
        ]);
        return null;
    };
    const $601fad54799fc304$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        inset: 'space.0',
        justifyContent: 'stretch'
    });
    const $601fad54799fc304$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        flexGrow: 1,
        marginBottom: 'space.negative.100',
        marginTop: 'space.negative.100'
    });
});
parcelRegister("1QC74", function(module, exports) {
    $parcel$export(module.exports, "GroupItem", ()=>$632d45ab0c250375$export$3142cb2f1b79aeb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9pdbW;
    var $17ot5;
    var $5njbg;
    var $gULOk;
    var $koVbs;
    var $dXq4S;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $1CXMr;
    var $fc0Dc;
    var $8TUlY;
    var $8e3Yw;
    var $9u99d;
    var $acMuh;
    var $6GT2e;
    var $5ZOAc;
    var $f7bpX;
    var $hWLf6;
    var $240fW;
    var $9wkeV;
    var $iaKbb;
    var $dMoqa;
    var $gC8QP;
    var $earxJ;
    const $632d45ab0c250375$var$ICON_SIZE = 24;
    const $632d45ab0c250375$var$LoadingIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsbu2gc _4t3i1tcg _bfhk1aqf _18s81l84 _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $632d45ab0c250375$var$CreateIssuePlusButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $632d45ab0c250375$var$GroupItemRenderer = ({ field: field, data: data })=>{
        switch(field.__typename){
            case 'JiraSingleSelectUserPickerField':
                if (field.type === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6GT2e")).AssigneeItem), {
                    data: data
                });
                return null;
            case 'GenericIssueField':
                if (field.type === (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dMoqa")).StatusItem), {
                    data: data
                });
                return null;
            case 'JiraPriorityField':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("240fW")).PriorityItem), {
                    data: data
                });
            case 'JWMCategoryField':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ZOAc")).CategoryItem), {
                    data: data
                });
            case 'JiraNumberField':
                if (field.aliasFieldId === 'storypoints') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gC8QP")).StoryPointsItem), {
                    value: data.storypoints
                });
                if (field.aliasFieldId === 'storypointestimate') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gC8QP")).StoryPointsItem), {
                    value: data.storypointestimate
                });
                return null;
            case 'JiraSprintField':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaKbb")).SprintItem), {
                    data: data
                });
            default:
                return null;
        }
    };
    const $632d45ab0c250375$export$3142cb2f1b79aeb9 = (0, $5uXOq.memo)(({ data: data, rowIndex: rowIndex, canCreateIssues: canCreateIssues })=>{
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const [, setHideDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const issueId = (0, (0, parcelRequire("g5X3G")).toIssueId)(data.issueId);
        const totalGroupItems = data.childSummary?.totalCount ?? 0;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ expandedItems: expandedGroups, hierarchyData: { loading: loading } }, { setExpandedItems: setGroupExpanded }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [{ shouldExpandAllItems: shouldExpandAllItems }, { disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, (0, parcelRequire("9pdbW")).useExpandCollapseAllItems)({
            view: 'list'
        });
        const [, { setRowCreatePosition: setRowCreatePosition }] = (0, (0, parcelRequire("acMuh")).useRowCreateStore)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { getAvailableFields: getAvailableFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const availableFields = getAvailableFields();
        const categoryFieldId = availableFields.find((fieldItem)=>fieldItem.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE))?.id;
        const field = (0, (0, parcelRequire("fc0Dc")).useGetGroupByField)();
        const onExpand = (0, $5uXOq.useCallback)(()=>{
            const isExpanded = Boolean(expandedGroups[issueId]);
            const isStatusGroup = groupByFieldId === (0, (0, parcelRequire("5fc53")).STATUS_TYPE);
            const isDoneStatus = data.status?.categoryId === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE];
            if (isStatusGroup && isDoneStatus && !isExpanded) setHideDoneItems(false);
            if (isExpanded && shouldExpandAllItems) disableExpandCollapseAllItems();
            setGroupExpanded(issueId, !isExpanded);
        }, [
            data,
            disableExpandCollapseAllItems,
            expandedGroups,
            groupByFieldId,
            issueId,
            setGroupExpanded,
            setHideDoneItems,
            shouldExpandAllItems
        ]);
        const handleAddInlineCreateRow = (0, $5uXOq.useCallback)((e)=>{
            e.preventDefault();
            setRowCreatePosition({
                parentId: String(issueId)
            });
            if (setGroupExpanded) setGroupExpanded(issueId, true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowCreateGroupItemIcon', {
                groupByFieldId: groupByFieldId
            });
        }, [
            setRowCreatePosition,
            issueId,
            setGroupExpanded,
            createAnalyticsEvent,
            groupByFieldId
        ]);
        const checkIfHasIssueCreation = (0, (0, parcelRequire("5njbg")).useCanCreateIssueInStatus)();
        const canInlineCreate = (0, $5uXOq.useMemo)(()=>{
            if (!canCreateIssues) return false;
            if (groupByFieldId !== (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) return true;
            const statusId = data.status?.id && (0, (0, parcelRequire("dXq4S")).getAriConfig)(data.status.id).resourceId;
            if (!statusId) return false;
            return checkIfHasIssueCreation(statusId);
        }, [
            canCreateIssues,
            checkIfHasIssueCreation,
            data.status,
            groupByFieldId
        ]);
        const CreateIssueComponent = (0, $5uXOq.useMemo)(()=>canInlineCreate && (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$CreateIssuePlusButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CXMr")).default), {
                tooltip: formatMessage((0, (0, parcelRequire("hWLf6")).default).createIssue),
                label: formatMessage((0, (0, parcelRequire("hWLf6")).default).addGroupItem),
                onClick: handleAddInlineCreateRow,
                shouldDisplayBtn: true
            })), [
            canInlineCreate,
            formatMessage,
            handleAddInlineCreateRow
        ]);
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingRow, {
            key: "loading-grouping-header-row",
            "data-testid": "business-list.ui.list-view.group-item.loading-row"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingWrapper, {
            key: data.key
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingIcon, null), (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$LoadingField, null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("earxJ")).Wrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wkeV")).SelectGroupCheckbox), {
            group: data,
            rowIndex: rowIndex
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("earxJ")).GroupContainer), null, totalGroupItems > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f7bpX")).ExpandIcon), {
            onClick: onExpand,
            totalGroupItems: totalGroupItems,
            rowIndex: rowIndex,
            expanded: expandedGroups[issueId] === true
        }), field ? (0, ($parcel$interopDefault($5uXOq))).createElement($632d45ab0c250375$var$GroupItemRenderer, {
            field: field,
            data: data
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, groupByFieldId === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6GT2e")).AssigneeItem), {
            data: data
        }), groupByFieldId === (0, (0, parcelRequire("5fc53")).STATUS_TYPE) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dMoqa")).StatusItem), {
            data: data
        }), groupByFieldId === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("240fW")).PriorityItem), {
            data: data
        }), groupByFieldId === categoryFieldId && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ZOAc")).CategoryItem), {
            data: data
        })), CreateIssueComponent));
    });
    const $632d45ab0c250375$var$LoadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $632d45ab0c250375$var$LoadingField = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _bfhk1aqf _18s8u2gc _2rko1l7b",
                __cmplp.className
            ])
        });
    });
    const $632d45ab0c250375$var$LoadingRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9pdbW", function(module, exports) {
    $parcel$export(module.exports, "useExpandCollapseAllItems", ()=>$3b02fa0a8e1492e4$export$38cfcb71ce0d3b89);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    const $3b02fa0a8e1492e4$var$actions = {
        toggleExpanding: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: !state[view].shouldExpandAllItems,
                        shouldCollapseAllItems: false
                    }
                });
            },
        setCollapsing: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: false,
                        shouldCollapseAllItems: true
                    }
                });
            },
        disableExpandCollapse: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: false,
                        shouldCollapseAllItems: false
                    }
                });
            },
        setHasExpandedAllItems: (view, hasExpanded)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        hasExpandedAllItems: hasExpanded
                    }
                });
            },
        setHasCollapsedAllItems: (view, hasCollapsed)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        hasCollapsedAllItems: hasCollapsed
                    }
                });
            }
    };
    const $3b02fa0a8e1492e4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            list: {
                shouldExpandAllItems: false,
                shouldCollapseAllItems: false,
                hasExpandedAllItems: false,
                hasCollapsedAllItems: false
            },
            timeline: {
                shouldExpandAllItems: false,
                shouldCollapseAllItems: false,
                hasExpandedAllItems: false,
                hasCollapsedAllItems: false
            }
        },
        actions: $3b02fa0a8e1492e4$var$actions,
        name: 'JWMExpandCollapseStore'
    });
    const $3b02fa0a8e1492e4$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($3b02fa0a8e1492e4$var$Store);
    const $3b02fa0a8e1492e4$export$38cfcb71ce0d3b89 = ({ view: view, onCollapse: onCollapse })=>{
        const [state, { toggleExpanding: toggleExpanding, setCollapsing: setCollapsing, disableExpandCollapse: disableExpandCollapse, setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems }] = $3b02fa0a8e1492e4$var$useHook();
        const { shouldExpandAllItems: shouldExpandAllItems, shouldCollapseAllItems: shouldCollapseAllItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems } = state[view];
        const toggleExpandingForView = (0, $5uXOq.useCallback)(()=>toggleExpanding(view), [
            toggleExpanding,
            view
        ]);
        const setCollapsingForView = (0, $5uXOq.useCallback)(()=>setCollapsing(view), [
            setCollapsing,
            view
        ]);
        const setHasCollapsedAllItemsForView = (0, $5uXOq.useCallback)((hasCollapsed)=>setHasCollapsedAllItems(view, hasCollapsed), [
            setHasCollapsedAllItems,
            view
        ]);
        const setHasExpandedAllItemsForView = (0, $5uXOq.useCallback)((hasExpanded)=>setHasExpandedAllItems(view, hasExpanded), [
            setHasExpandedAllItems,
            view
        ]);
        const disableExpandCollapseForView = (0, $5uXOq.useCallback)(()=>disableExpandCollapse(view), [
            disableExpandCollapse,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onCollapse && shouldCollapseAllItems) {
                onCollapse();
                disableExpandCollapseForView();
            }
        }, [
            disableExpandCollapseForView,
            onCollapse,
            shouldCollapseAllItems
        ]);
        return [
            {
                shouldExpandAllItems: shouldExpandAllItems,
                shouldCollapseAllItems: shouldCollapseAllItems,
                hasExpandedAllItems: hasExpandedAllItems,
                hasCollapsedAllItems: hasCollapsedAllItems
            },
            {
                toggleExpandAllItems: toggleExpandingForView,
                collapseAllItems: setCollapsingForView,
                disableExpandCollapseAllItems: disableExpandCollapseForView,
                setHasExpandedAllItems: setHasExpandedAllItemsForView,
                setHasCollapsedAllItems: setHasCollapsedAllItemsForView
            }
        ];
    };
});
parcelRegister("5njbg", function(module, exports) {
    $parcel$export(module.exports, "useCanCreateIssueInStatus", ()=>$fee15ae5c2026453$export$efe8838d1712139f);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $l9KLJ;
    const $fee15ae5c2026453$export$efe8838d1712139f = ()=>{
        const workflows = (0, (0, parcelRequire("l9KLJ")).useWorkflows)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        return (0, $5uXOq.useCallback)((statusId, workflow = null)=>{
            if (!workflows) return false;
            const eligibleWorkflows = workflow != null ? [
                workflow
            ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
            return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
        }, [
            project,
            workflows
        ]);
    };
});
parcelRegister("1CXMr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97edc763cb6a35fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $42CjB;
    var $99M5v;
    var $7ymNM;
    var $3bDjY;
    var $gwIPs;
    var $dCm1o;
    var $eTDjN;
    var $97edc763cb6a35fa$export$2e2bcd8739ae039 = (0, $5uXOq.memo)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: props.tooltip
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97edc763cb6a35fa$var$ChildCreateButtonWrapper, {
            id: (0, (0, parcelRequire("eTDjN")).CHILD_CREATE_BTN_WRAPPER),
            shouldDisplayBtn: props.shouldDisplayBtn,
            "data-testid": "business-list.common.ui.create-issue-plus-button.child-create-button-wrapper"
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            onClick: props.onClick,
            spacing: "compact",
            appearance: "subtle",
            label: props.label,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("99M5v")))))
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($97edc763cb6a35fa$var$ChildCreateButton, {
            onClick: props.onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
            label: props.label,
            size: "small"
        })))));
    const $97edc763cb6a35fa$var$BUTTON_SIZE = 2 * (0, (0, parcelRequire("gwIPs")).gridSize);
    const $97edc763cb6a35fa$var$ICON_SIZE = 12;
    const $97edc763cb6a35fa$var$ChildCreateButton = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb7vkz _4t3i7vkz _2rko1sit _s7n4jp4b _bfhkiw92 _syaz10s3 _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _11r712vo _e2oo1crf _1xjx1crf _z2391qo1 _19y510s3 _16uvt94y _jomr74gs _irr374gs _1di6uh8s _9h8h705v",
                __cmplp.className
            ])
        });
    });
    const $97edc763cb6a35fa$var$ChildCreateButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldDisplayBtn: shouldDisplayBtn, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.shouldDisplayBtn ? "_1e0c1txw" : "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("99M5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));
    var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
    function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6aaa418e9a366cd8$var$AddIcon = (props)=>$6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
            LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
        }, props));
    $6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
    var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;
});
parcelRegister("fc0Dc", function(module, exports) {
    $parcel$export(module.exports, "useGetGroupByField", ()=>$64e17e972578427d$export$7a0354af7d69ba55);
    var $hE5wF;
    var $ePLOx;
    var $5fc53;
    var $8TUlY;
    var $8e3Yw;
    const $64e17e972578427d$export$1aef70471c979441 = (field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE);
    const $64e17e972578427d$export$48f560f91a048a7f = (field)=>field.type === (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE) && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID);
    const $64e17e972578427d$export$8b6cfed4387d2f77 = (field)=>field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE);
    const $64e17e972578427d$export$ea68dd9055d500e2 = (field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
    const $64e17e972578427d$export$7a0354af7d69ba55 = ()=>{
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const { getAvailableFields: getAvailableFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const availableFields = getAvailableFields();
        const { data: categoryField } = (0, (0, parcelRequire("ePLOx")).useFindField)($64e17e972578427d$export$1aef70471c979441);
        const { data: storyPointsField } = (0, (0, parcelRequire("ePLOx")).useFindField)($64e17e972578427d$export$48f560f91a048a7f);
        const { data: storyPointEstimateField } = (0, (0, parcelRequire("ePLOx")).useFindField)($64e17e972578427d$export$8b6cfed4387d2f77);
        const { data: sprintField } = (0, (0, parcelRequire("ePLOx")).useFindField)($64e17e972578427d$export$ea68dd9055d500e2);
        switch(groupByFieldId){
            case categoryField?.id:
                return categoryField;
            case storyPointsField?.id:
                return storyPointsField;
            case storyPointEstimateField?.id:
                return storyPointEstimateField;
            case sprintField?.id:
                return sprintField;
            default:
                return availableFields.find((availableField)=>availableField.type === groupByFieldId);
        }
    };
});
parcelRegister("6GT2e", function(module, exports) {
    $parcel$export(module.exports, "AssigneeItem", ()=>$ba9678029c920422$export$be57e3a2d4264803);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $bmZvc;
    var $koVbs;
    var $lI995;
    var $hYB1g;
    const $ba9678029c920422$export$be57e3a2d4264803 = ({ data: data })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isUnassigned = !data.assignee;
        const unassignedDisplayName = formatMessage((0, (0, parcelRequire("hYB1g")).default).unassignedDisplayName);
        const displayName = isUnassigned ? unassignedDisplayName : data.assignee?.displayName;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isUnassigned ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            src: "",
            size: "small"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bmZvc")).AvatarLite), {
            avatarUrl: data.assignee?.avatarUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).DisplayName), null, displayName));
    };
});
parcelRegister("bmZvc", function(module, exports) {
    $parcel$export(module.exports, "AvatarLite", ()=>$0b2cc805665652bb$export$8b9560cc4e12c651);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $0b2cc805665652bb$var$AVATAR_SIZE = 24;
    const $0b2cc805665652bb$var$Avatar = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1fzlxay": (0, (0, parcelRequire("lD23V")).default)(`url(${__cmplp.avatarUrl})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _2rko1ssb _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _80om1kw7 _18s8v77o",
                __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $0b2cc805665652bb$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
    const $0b2cc805665652bb$export$8b9560cc4e12c651 = (0, $5uXOq.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
        const isHighlighted = highlight && highlight.some($0b2cc805665652bb$var$hasKeywords(name));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0b2cc805665652bb$var$Avatar, {
            avatarUrl: avatarUrl,
            title: name,
            isHighlighted: isHighlighted,
            "data-testid": testId
        });
    });
});
parcelRegister("lI995", function(module, exports) {
    $parcel$export(module.exports, "WrapperCommon", ()=>$3f8a6a40f1bb00b7$export$2cd335d97b9054d6);
    $parcel$export(module.exports, "CellWrapper", ()=>$3f8a6a40f1bb00b7$export$4812fadef83edffe);
    $parcel$export(module.exports, "CellContentContainer", ()=>$3f8a6a40f1bb00b7$export$bd476b087602e432);
    $parcel$export(module.exports, "CellContainer", ()=>$3f8a6a40f1bb00b7$export$287da707e3318210);
    $parcel$export(module.exports, "CellContentWrapper", ()=>$3f8a6a40f1bb00b7$export$f76c50a859269a04);
    $parcel$export(module.exports, "TextFieldWrapper", ()=>$3f8a6a40f1bb00b7$export$e6dcd4f050b24d88);
    $parcel$export(module.exports, "AvatarItem", ()=>$3f8a6a40f1bb00b7$export$15f08c141eda7939);
    $parcel$export(module.exports, "DisplayName", ()=>$3f8a6a40f1bb00b7$export$101fbca3a406e1fd);
    $parcel$export(module.exports, "EmptyCellContent", ()=>$3f8a6a40f1bb00b7$export$78bba2733575aa77);
    $parcel$export(module.exports, "Container", ()=>$3f8a6a40f1bb00b7$export$42a852a2b6b56249);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $gwIPs;
    var $6s1PB;
    const $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d = 2;
    const $3f8a6a40f1bb00b7$export$e643c5fb607dbcc5 = `0 0 0 ${$3f8a6a40f1bb00b7$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`} inset`;
    const $3f8a6a40f1bb00b7$export$85e848b114283663 = 160;
    const $3f8a6a40f1bb00b7$export$df441c04a8cf98f7 = 40;
    const $3f8a6a40f1bb00b7$export$2cd335d97b9054d6 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFocused: isFocused, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)($3f8a6a40f1bb00b7$export$e643c5fb607dbcc5)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36",
                __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
                __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$4812fadef83edffe = (0, $5uXOq.forwardRef)(({ as: C = $3f8a6a40f1bb00b7$export$2cd335d97b9054d6, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _2rko1sit _19bvu2gc",
                __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$bd476b087602e432 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_g3ey1q": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width - ((0, (0, parcelRequire("gwIPs")).gridSize) * 3 + $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d * 2), "px"),
                "--_1nq8131": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height - $3f8a6a40f1bb00b7$export$95bfdfec8f6b837d * 2, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _1bsb6uc2 _4t3i4226",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$b9800fb826bc73d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFocused: isFocused, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)($3f8a6a40f1bb00b7$export$e643c5fb607dbcc5)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _p7r11txw _dzc21h6o _bhl9upfu _k8em1osq _bd9w1r31 _ezapglyw _1qzf1o36 _zbayglpi",
                __cmplp.isFocused ? "_bp7o179s" : "_bp7oglyw",
                __cmplp.isFocused ? "_1gzevuon" : "_1gze18uv",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$var$focusedStyle = null;
    const $3f8a6a40f1bb00b7$var$formattedStyle = null;
    const $3f8a6a40f1bb00b7$var$cellContainerStyles = null;
    const $3f8a6a40f1bb00b7$export$287da707e3318210 = (0, $5uXOq.forwardRef)(({ isFocused: isFocused, formatRuleBackgroundColor: formatRuleBackgroundColor, ...props }, ref)=>{
        if ((0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _p7r11txw _dzc21h6o _bhl91osq _k8em1osq _bd9w1r31 _ezapglyw _1qzf1o36 _1gze18uv _zbayglpi",
                isFocused && "_bp7o179s _1gzevuon",
                formatRuleBackgroundColor && !isFocused && "_bfhk1olo"
            ]),
            style: {
                '--local-format-color': formatRuleBackgroundColor,
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)($3f8a6a40f1bb00b7$export$e643c5fb607dbcc5)
            }
        }, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3f8a6a40f1bb00b7$export$b9800fb826bc73d, {
            ref: ref,
            isFocused: isFocused,
            ...props
        });
    });
    const $3f8a6a40f1bb00b7$export$f76c50a859269a04 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { preferredWidth: preferredWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1kfanob": (0, (0, parcelRequire("lD23V")).default)(__cmplp.preferredWidth, "px"),
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)($3f8a6a40f1bb00b7$export$e643c5fb607dbcc5)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1rw8 _1ul91178 _1p3lidpf _13ce179s",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$e6dcd4f050b24d88 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFocused: isFocused, isEditable: isEditable, isSelected: isSelected, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)($3f8a6a40f1bb00b7$export$e643c5fb607dbcc5)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _2rkoglpi _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _cj13v77o _1v5nidpf _qbsg179s _1yds1osq _kgm11cy0 _17kn15vq _1hrp15vq _x3fa1l2s",
                __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
                __cmplp.isEditable ?? true ? "_80om1kdv" : "_80om73ad",
                __cmplp.isSelected || __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$15f08c141eda7939 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isUnassigned: isUnassigned, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1reo15vq _18m915vq _o5721q9c _1bsb1osq _4t3imslj _16l4kb7n",
                __cmplp.isUnassigned ? "_tzy4idpf" : "_tzy4kb7n",
                __cmplp.isUnassigned ? "_syaz1e9r" : "_syaz1kw7",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$101fbca3a406e1fd = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$export$78bba2733575aa77 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1e9r _lcxvglyw _12qeu2gc",
                __cmplp.className
            ])
        });
    });
    const $3f8a6a40f1bb00b7$var$containerBaseStyles = null;
    const $3f8a6a40f1bb00b7$var$containerMenuOpenStyles = null;
    const $3f8a6a40f1bb00b7$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ width: width, isMenuOpen: isMenuOpen, children: children, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            style: {
                width: width ? `${width}px` : '100%'
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1osq _2rko1hkb _80omtlke _bfhk18uv _19bvu2gc _16qsglyw",
                isMenuOpen && "_bfhkvuon _19bvze3t _16qs1f5q"
            ])
        }, children));
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("hYB1g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35d87a01fb128cf8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $35d87a01fb128cf8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassignedDisplayName: {
            "id": "business-list.list-view.group-item.assignee-item.unassigned-display-name",
            "defaultMessage": "Unassigned"
        }
    });
});
parcelRegister("5ZOAc", function(module, exports) {
    $parcel$export(module.exports, "CategoryItem", ()=>$80825934ae99d844$export$41d1d7fbacf843);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $DhnKp;
    var $koVbs;
    var $1J45B;
    const $80825934ae99d844$export$41d1d7fbacf843 = (0, $5uXOq.memo)(({ data: data })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return data.category?.name != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("DhnKp")).default), {
            categoryColor: data.category.color,
            categoryName: data.category.name,
            isInteractive: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($80825934ae99d844$var$UncategorizedLabel, null, formatMessage((0, (0, parcelRequire("1J45B")).default).noCategory));
    });
    const $80825934ae99d844$var$UncategorizedLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz14xw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("DhnKp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3fabf56d1291b24$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7XYc4;
    var $dCm1o;
    var $gSwFG;
    const $f3fabf56d1291b24$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
        const { textColor: textColor, backgroundColor: tagColor } = (0, (0, parcelRequire("gSwFG")).getColorMetadata)(categoryColor);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f3fabf56d1291b24$var$CategoryTagWrapper, {
            isInteractive: isInteractive,
            textColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
            "aria-label": categoryName,
            "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f3fabf56d1291b24$var$StyledTag, {
            color: tagColor
        }, categoryName));
    };
    var $f3fabf56d1291b24$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f3fabf56d1291b24$var$CategoryTag);
    const $f3fabf56d1291b24$var$CategoryTagWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1qrlcdp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.textColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1bah1e5h _4cvr1h6o _v564188d _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
                __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
                __cmplp.className
            ])
        });
    });
    const $f3fabf56d1291b24$var$StyledTagOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rkoiti9 _bfhk1cj8 _1yt41b66 _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
                __cmplp.className
            ])
        });
    });
    const $f3fabf56d1291b24$var$StyledTagNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_14v0t1n": (0, (0, parcelRequire("lD23V")).default)(`1px solid ${__cmplp.color}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko5n0m _bfhk18uv _19it11we _1yt4u49m _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
                __cmplp.className
            ])
        });
    });
    const $f3fabf56d1291b24$var$StyledTag = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $f3fabf56d1291b24$var$StyledTagNew, $f3fabf56d1291b24$var$StyledTagOld);
});
parcelRegister("gSwFG", function(module, exports) {
    $parcel$export(module.exports, "getRandomColor", ()=>$371e0387ab2e6a89$export$e4369cabd7e84cd9);
    $parcel$export(module.exports, "getColorNameFromValue", ()=>$371e0387ab2e6a89$export$b5ccbadd112d8ce9);
    $parcel$export(module.exports, "getValueFromColorName", ()=>$371e0387ab2e6a89$export$9eff62e8ee2aaa2c);
    $parcel$export(module.exports, "getColorMetadata", ()=>$371e0387ab2e6a89$export$49fce7fdcf55f26d);
    var $3m7Ch;
    const $371e0387ab2e6a89$export$e4369cabd7e84cd9 = ()=>{
        const randomIndex = Math.floor(Math.random() * (0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).length);
        return (0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES)[randomIndex].name;
    };
    const $371e0387ab2e6a89$export$b5ccbadd112d8ce9 = (colorValue)=>(0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
    const $371e0387ab2e6a89$export$9eff62e8ee2aaa2c = (colorName)=>(0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
    const $371e0387ab2e6a89$export$49fce7fdcf55f26d = (colorName)=>{
        if (!colorName) return 0, (0, parcelRequire("3m7Ch")).GREY_LIGHTEST_META;
        return (0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, (0, parcelRequire("3m7Ch")).GREY_LIGHTEST_META);
    };
    const $371e0387ab2e6a89$export$4ef6b7574883e63d = ()=>(0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).map((item)=>item.name);
});
parcelRegister("3m7Ch", function(module, exports) {
    $parcel$export(module.exports, "GREY_LIGHTEST_META", ()=>$b019b47b4798283a$export$cb19a604bb399a88);
    $parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", ()=>$b019b47b4798283a$export$270aee965367aeb3);
    $parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", ()=>$b019b47b4798283a$export$941ef40ef5fdd2b1);
    $parcel$export(module.exports, "CATEGORY_THEMES", ()=>$b019b47b4798283a$export$845e69f3af4133a6);
    var $fy6VQ;
    var $gAmq4;
    const $b019b47b4798283a$export$cb19a604bb399a88 = {
        name: 'GREY_LIGHTEST',
        backgroundColor: `var(--ds-background-neutral, ${(0, parcelRequire("fy6VQ")).N100})`,
        textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greyLightest
    };
    const $b019b47b4798283a$export$7c3ad8ed1eaec359 = {
        name: 'GREY_LIGHTER',
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, parcelRequire("fy6VQ")).N200})`,
        textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greyLighter
    };
    const $b019b47b4798283a$export$11b75436f568ab00 = {
        name: 'GREY',
        backgroundColor: `var(--ds-background-neutral-pressed, ${(0, parcelRequire("fy6VQ")).N300})`,
        textColor: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N900})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).grey
    };
    const $b019b47b4798283a$export$680a025ac49fcedd = {
        name: 'GREY_DARKER',
        backgroundColor: `var(--ds-background-neutral-bold, ${(0, parcelRequire("fy6VQ")).N400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greyDarker
    };
    const $b019b47b4798283a$export$c63acd769779da32 = {
        name: 'GREY_DARKEST',
        backgroundColor: `var(--ds-background-neutral-bold-pressed, ${(0, parcelRequire("fy6VQ")).N500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greyDarkest
    };
    const $b019b47b4798283a$export$d6bc0064d6a00b4b = {
        name: 'PURPLE_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-purple-subtlest, ${(0, parcelRequire("fy6VQ")).P100})`,
        textColor: `var(--ds-text-accent-purple-bolder, ${(0, parcelRequire("fy6VQ")).P500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).purpleLightest
    };
    const $b019b47b4798283a$export$7a53a04457b57cc7 = {
        name: 'PURPLE_LIGHTER',
        backgroundColor: `var(--ds-background-accent-purple-subtler, ${(0, parcelRequire("fy6VQ")).P200})`,
        textColor: `var(--ds-text-accent-purple-bolder, ${(0, parcelRequire("fy6VQ")).P500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).purpleLighter
    };
    const $b019b47b4798283a$export$d6f3928d12bf329c = {
        name: 'PURPLE',
        backgroundColor: `var(--ds-background-accent-purple-subtle, ${(0, parcelRequire("fy6VQ")).P300})`,
        textColor: `var(--ds-text-accent-purple-bolder, ${(0, parcelRequire("fy6VQ")).P500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).purple
    };
    const $b019b47b4798283a$export$7c314e2461a7241b = {
        name: 'PURPLE_DARKER',
        backgroundColor: `var(--ds-text-accent-purple, ${(0, parcelRequire("fy6VQ")).P400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).purpleDarker
    };
    const $b019b47b4798283a$export$5e3ecd219265b1d5 = {
        name: 'PURPLE_DARKEST',
        backgroundColor: `var(--ds-text-accent-purple-bolder, ${(0, parcelRequire("fy6VQ")).P500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).purpleDarkest
    };
    const $b019b47b4798283a$export$4b98b31eae42f719 = {
        name: 'BLUE_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-blue-subtlest, ${(0, parcelRequire("fy6VQ")).B100})`,
        textColor: `var(--ds-text-accent-blue-bolder, ${(0, parcelRequire("fy6VQ")).B500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).blueLightest
    };
    const $b019b47b4798283a$export$e92a5b8219b97745 = {
        name: 'BLUE_LIGHTER',
        backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, parcelRequire("fy6VQ")).B200})`,
        textColor: `var(--ds-text-accent-blue-bolder, ${(0, parcelRequire("fy6VQ")).B500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).blueLighter
    };
    const $b019b47b4798283a$export$b761714c24fd7f1c = {
        name: 'BLUE',
        backgroundColor: `var(--ds-background-accent-blue-subtle, ${(0, parcelRequire("fy6VQ")).B300})`,
        textColor: `var(--ds-text-accent-blue-bolder, ${(0, parcelRequire("fy6VQ")).B500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).blue
    };
    const $b019b47b4798283a$export$50b37b24459ab9d9 = {
        name: 'BLUE_DARKER',
        backgroundColor: `var(--ds-text-accent-blue, ${(0, parcelRequire("fy6VQ")).B400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).blueDarker
    };
    const $b019b47b4798283a$export$69c4eac71b813fba = {
        name: 'BLUE_DARKEST',
        backgroundColor: `var(--ds-text-accent-blue-bolder, ${(0, parcelRequire("fy6VQ")).B500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).blueDarkest
    };
    const $b019b47b4798283a$export$1fe5b156c0ba3acb = {
        name: 'TEAL_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-teal-subtlest, ${(0, parcelRequire("fy6VQ")).T100})`,
        textColor: `var(--ds-text-accent-teal-bolder, ${(0, parcelRequire("fy6VQ")).T500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).tealLightest
    };
    const $b019b47b4798283a$export$fb40f4c2f659b9bb = {
        name: 'TEAL_LIGHTER',
        backgroundColor: `var(--ds-background-accent-teal-subtler, ${(0, parcelRequire("fy6VQ")).T200})`,
        textColor: `var(--ds-text-accent-teal-bolder, ${(0, parcelRequire("fy6VQ")).T500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).tealLighter
    };
    const $b019b47b4798283a$export$d177e878b5837287 = {
        name: 'TEAL',
        backgroundColor: `var(--ds-background-accent-teal-subtle, ${(0, parcelRequire("fy6VQ")).T300})`,
        textColor: `var(--ds-text-accent-teal-bolder, ${(0, parcelRequire("fy6VQ")).T500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).teal
    };
    const $b019b47b4798283a$export$6daaa1cc3f46f41 = {
        name: 'TEAL_DARKER',
        backgroundColor: `var(--ds-text-accent-teal, ${(0, parcelRequire("fy6VQ")).T400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).tealDarker
    };
    const $b019b47b4798283a$export$fc1c501cf599d75a = {
        name: 'TEAL_DARKEST',
        backgroundColor: `var(--ds-text-accent-teal-bolder, ${(0, parcelRequire("fy6VQ")).T500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).tealDarkest
    };
    const $b019b47b4798283a$export$d977521f30fbcdeb = {
        name: 'GREEN_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-green-subtlest, ${(0, parcelRequire("fy6VQ")).G100})`,
        textColor: `var(--ds-text-accent-green-bolder, ${(0, parcelRequire("fy6VQ")).G500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greenLightest
    };
    const $b019b47b4798283a$export$911ea8fce963369 = {
        name: 'GREEN_LIGHTER',
        backgroundColor: `var(--ds-background-accent-green-subtler, ${(0, parcelRequire("fy6VQ")).G200})`,
        textColor: `var(--ds-text-accent-green-bolder, ${(0, parcelRequire("fy6VQ")).G500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greenLighter
    };
    const $b019b47b4798283a$export$814f677491d6ea0d = {
        name: 'GREEN',
        backgroundColor: `var(--ds-background-accent-green-subtle, ${(0, parcelRequire("fy6VQ")).G300})`,
        textColor: `var(--ds-text-accent-green-bolder, ${(0, parcelRequire("fy6VQ")).G500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).green
    };
    const $b019b47b4798283a$export$376a849da12d546d = {
        name: 'GREEN_DARKER',
        backgroundColor: `var(--ds-background-accent-green-bolder, ${(0, parcelRequire("fy6VQ")).G400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greenDarker
    };
    const $b019b47b4798283a$export$808ba7d394e8f2c4 = {
        name: 'GREEN_DARKEST',
        backgroundColor: `var(--ds-text-accent-green-bolder, ${(0, parcelRequire("fy6VQ")).G500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).greenDarkest
    };
    const $b019b47b4798283a$export$46ad9119b0fbf094 = {
        name: 'LIME_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-lime-subtlest, ${(0, parcelRequire("fy6VQ")).L100})`,
        textColor: `var(--ds-text-accent-lime-bolder, ${(0, parcelRequire("fy6VQ")).L500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).limeLightest
    };
    const $b019b47b4798283a$export$e5e5e485aa3ce630 = {
        name: 'LIME_LIGHTER',
        backgroundColor: `var(--ds-background-accent-lime-subtler, ${(0, parcelRequire("fy6VQ")).L200})`,
        textColor: `var(--ds-text-accent-lime-bolder, ${(0, parcelRequire("fy6VQ")).L500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).limeLighter
    };
    const $b019b47b4798283a$export$166a57cda148857c = {
        name: 'LIME',
        backgroundColor: `var(--ds-background-accent-lime-subtle, ${(0, parcelRequire("fy6VQ")).L300})`,
        textColor: `var(--ds-text-accent-lime-bolder, ${(0, parcelRequire("fy6VQ")).L500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).lime
    };
    const $b019b47b4798283a$export$40663533c0b649cc = {
        name: 'LIME_DARKER',
        backgroundColor: `var(--ds-text-accent-lime, ${(0, parcelRequire("fy6VQ")).L400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).limeDarker
    };
    const $b019b47b4798283a$export$78557ba4a4ffc502 = {
        name: 'LIME_DARKEST',
        backgroundColor: `var(--ds-text-accent-lime-bolder, ${(0, parcelRequire("fy6VQ")).L500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).limeDarkest
    };
    const $b019b47b4798283a$export$12021cfc394e311e = {
        name: 'YELLOW_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${(0, parcelRequire("fy6VQ")).Y100})`,
        textColor: `var(--ds-text-accent-yellow-bolder, ${(0, parcelRequire("fy6VQ")).Y500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).yellowLightest
    };
    const $b019b47b4798283a$export$eab7ec7309efe3db = {
        name: 'YELLOW_LIGHTER',
        backgroundColor: `var(--ds-background-accent-yellow-subtler, ${(0, parcelRequire("fy6VQ")).Y200})`,
        textColor: `var(--ds-text-accent-yellow-bolder, ${(0, parcelRequire("fy6VQ")).Y500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).yellowLighter
    };
    const $b019b47b4798283a$export$8d5b340327da7fa3 = {
        name: 'YELLOW',
        backgroundColor: `var(--ds-background-accent-yellow-subtle, ${(0, parcelRequire("fy6VQ")).Y300})`,
        textColor: `var(--ds-text-accent-yellow-bolder, ${(0, parcelRequire("fy6VQ")).Y500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).yellow
    };
    const $b019b47b4798283a$export$b0a7a0813708318e = {
        name: 'YELLOW_DARKER',
        backgroundColor: `var(--ds-text-accent-yellow, ${(0, parcelRequire("fy6VQ")).Y400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).yellowDarker
    };
    const $b019b47b4798283a$export$dde9759b2d3b0e02 = {
        name: 'YELLOW_DARKEST',
        backgroundColor: `var(--ds-text-accent-yellow-bolder, ${(0, parcelRequire("fy6VQ")).Y500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).yellowDarkest
    };
    const $b019b47b4798283a$export$4718b8cf3799954b = {
        name: 'ORANGE_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-orange-subtlest, ${(0, parcelRequire("fy6VQ")).O100})`,
        textColor: `var(--ds-text-accent-orange-bolder, ${(0, parcelRequire("fy6VQ")).O500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).orangeLightest
    };
    const $b019b47b4798283a$export$8fac1fdda0aa4e41 = {
        name: 'ORANGE_LIGHTER',
        backgroundColor: `var(--ds-background-accent-orange-subtler, ${(0, parcelRequire("fy6VQ")).O200})`,
        textColor: `var(--ds-text-accent-orange-bolder, ${(0, parcelRequire("fy6VQ")).O500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).orangeLighter
    };
    const $b019b47b4798283a$export$2efe350451bcec02 = {
        name: 'ORANGE',
        backgroundColor: `var(--ds-background-accent-orange-subtle, ${(0, parcelRequire("fy6VQ")).O300})`,
        textColor: `var(--ds-text-accent-orange-bolder, ${(0, parcelRequire("fy6VQ")).O500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).orange
    };
    const $b019b47b4798283a$export$5ba9bd795da8d7d5 = {
        name: 'ORANGE_DARKER',
        backgroundColor: `var(--ds-background-accent-orange-bolder, ${(0, parcelRequire("fy6VQ")).O400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).orangeDarker
    };
    const $b019b47b4798283a$export$93a7b89503a97d81 = {
        name: 'ORANGE_DARKEST',
        backgroundColor: `var(--ds-text-accent-orange-bolder, ${(0, parcelRequire("fy6VQ")).O500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).orangeDarkest
    };
    const $b019b47b4798283a$export$56873b0b30501dbe = {
        name: 'RED_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-red-subtlest, ${(0, parcelRequire("fy6VQ")).R100})`,
        textColor: `var(--ds-text-accent-red-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).redLightest
    };
    const $b019b47b4798283a$export$344aa49a80760380 = {
        name: 'RED_LIGHTER',
        backgroundColor: `var(--ds-background-accent-red-subtler, ${(0, parcelRequire("fy6VQ")).R200})`,
        textColor: `var(--ds-text-accent-red-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).redLighter
    };
    const $b019b47b4798283a$export$c760bedaf9085f90 = {
        name: 'RED',
        backgroundColor: `var(--ds-background-accent-red-subtle, ${(0, parcelRequire("fy6VQ")).R300})`,
        textColor: `var(--ds-text-accent-red-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).red
    };
    const $b019b47b4798283a$export$38493b731be63d77 = {
        name: 'RED_DARKER',
        backgroundColor: `var(--ds-background-accent-red-bolder, ${(0, parcelRequire("fy6VQ")).R400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).redDarker
    };
    const $b019b47b4798283a$export$dda419d8311f8d4a = {
        name: 'RED_DARKEST',
        backgroundColor: `var(--ds-text-accent-red-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).redDarkest
    };
    const $b019b47b4798283a$export$e0957dc0d569e65f = {
        name: 'MAGENTA_LIGHTEST',
        backgroundColor: `var(--ds-background-accent-magenta-subtlest, ${(0, parcelRequire("fy6VQ")).M100})`,
        textColor: `var(--ds-text-accent-magenta-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).magentaLightest
    };
    const $b019b47b4798283a$export$299af16a857bf4ca = {
        name: 'MAGENTA_LIGHTER',
        backgroundColor: `var(--ds-background-accent-magenta-subtler, ${(0, parcelRequire("fy6VQ")).M200})`,
        textColor: `var(--ds-text-accent-magenta-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).magentaLighter
    };
    const $b019b47b4798283a$export$d7208e47aa15bafe = {
        name: 'MAGENTA',
        backgroundColor: `var(--ds-background-accent-magenta-subtle-hovered, ${(0, parcelRequire("fy6VQ")).M300})`,
        textColor: `var(--ds-text-accent-magenta-bolder, ${(0, parcelRequire("fy6VQ")).R500})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).magenta
    };
    const $b019b47b4798283a$export$b3aea5a31105d4e3 = {
        name: 'MAGENTA_DARKER',
        backgroundColor: `var(--ds-text-accent-magenta, ${(0, parcelRequire("fy6VQ")).M400})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).magentaDarker
    };
    const $b019b47b4798283a$export$faf43e54615bce6b = {
        name: 'MAGENTA_DARKEST',
        backgroundColor: `var(--ds-text-accent-magenta-bolder, ${(0, parcelRequire("fy6VQ")).M500})`,
        textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        messageLabel: (0, (0, parcelRequire("gAmq4")).default).magentaDarkest
    };
    const $b019b47b4798283a$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $b019b47b4798283a$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $829f609a65d26a98$exports).N500})`;
    const $b019b47b4798283a$export$845e69f3af4133a6 = [
        $b019b47b4798283a$export$cb19a604bb399a88,
        $b019b47b4798283a$export$d6bc0064d6a00b4b,
        $b019b47b4798283a$export$4b98b31eae42f719,
        $b019b47b4798283a$export$1fe5b156c0ba3acb,
        $b019b47b4798283a$export$d977521f30fbcdeb,
        $b019b47b4798283a$export$46ad9119b0fbf094,
        $b019b47b4798283a$export$12021cfc394e311e,
        $b019b47b4798283a$export$4718b8cf3799954b,
        $b019b47b4798283a$export$56873b0b30501dbe,
        $b019b47b4798283a$export$e0957dc0d569e65f,
        $b019b47b4798283a$export$7c3ad8ed1eaec359,
        $b019b47b4798283a$export$7a53a04457b57cc7,
        $b019b47b4798283a$export$e92a5b8219b97745,
        $b019b47b4798283a$export$fb40f4c2f659b9bb,
        $b019b47b4798283a$export$911ea8fce963369,
        $b019b47b4798283a$export$e5e5e485aa3ce630,
        $b019b47b4798283a$export$eab7ec7309efe3db,
        $b019b47b4798283a$export$8fac1fdda0aa4e41,
        $b019b47b4798283a$export$344aa49a80760380,
        $b019b47b4798283a$export$299af16a857bf4ca,
        $b019b47b4798283a$export$11b75436f568ab00,
        $b019b47b4798283a$export$d6f3928d12bf329c,
        $b019b47b4798283a$export$b761714c24fd7f1c,
        $b019b47b4798283a$export$d177e878b5837287,
        $b019b47b4798283a$export$814f677491d6ea0d,
        $b019b47b4798283a$export$166a57cda148857c,
        $b019b47b4798283a$export$8d5b340327da7fa3,
        $b019b47b4798283a$export$2efe350451bcec02,
        $b019b47b4798283a$export$c760bedaf9085f90,
        $b019b47b4798283a$export$d7208e47aa15bafe,
        $b019b47b4798283a$export$680a025ac49fcedd,
        $b019b47b4798283a$export$7c314e2461a7241b,
        $b019b47b4798283a$export$50b37b24459ab9d9,
        $b019b47b4798283a$export$6daaa1cc3f46f41,
        $b019b47b4798283a$export$376a849da12d546d,
        $b019b47b4798283a$export$40663533c0b649cc,
        $b019b47b4798283a$export$b0a7a0813708318e,
        $b019b47b4798283a$export$5ba9bd795da8d7d5,
        $b019b47b4798283a$export$38493b731be63d77,
        $b019b47b4798283a$export$b3aea5a31105d4e3,
        $b019b47b4798283a$export$c63acd769779da32,
        $b019b47b4798283a$export$5e3ecd219265b1d5,
        $b019b47b4798283a$export$69c4eac71b813fba,
        $b019b47b4798283a$export$fc1c501cf599d75a,
        $b019b47b4798283a$export$808ba7d394e8f2c4,
        $b019b47b4798283a$export$78557ba4a4ffc502,
        $b019b47b4798283a$export$dde9759b2d3b0e02,
        $b019b47b4798283a$export$93a7b89503a97d81,
        $b019b47b4798283a$export$dda419d8311f8d4a,
        $b019b47b4798283a$export$faf43e54615bce6b
    ];
});
parcelRegister("fy6VQ", function(module, exports) {
    $parcel$export(module.exports, "N100", ()=>$58cb83647f5ab93c$export$d6447c357493214f);
    $parcel$export(module.exports, "N200", ()=>$58cb83647f5ab93c$export$f563ee71e9ee74cd);
    $parcel$export(module.exports, "N300", ()=>$58cb83647f5ab93c$export$e2ef2124cf4024b1);
    $parcel$export(module.exports, "N400", ()=>$58cb83647f5ab93c$export$eece5f492e429f08);
    $parcel$export(module.exports, "N500", ()=>$58cb83647f5ab93c$export$c39c0fe0f26207ae);
    $parcel$export(module.exports, "P100", ()=>$58cb83647f5ab93c$export$6011520a64d9a187);
    $parcel$export(module.exports, "P200", ()=>$58cb83647f5ab93c$export$a7175d4e9206bc80);
    $parcel$export(module.exports, "P300", ()=>$58cb83647f5ab93c$export$b48405b95304b5a1);
    $parcel$export(module.exports, "P400", ()=>$58cb83647f5ab93c$export$c71e4279dd54a18d);
    $parcel$export(module.exports, "P500", ()=>$58cb83647f5ab93c$export$147899de772240ec);
    $parcel$export(module.exports, "B100", ()=>$58cb83647f5ab93c$export$ecfc1dff386a3e7a);
    $parcel$export(module.exports, "B200", ()=>$58cb83647f5ab93c$export$215b7063051591f1);
    $parcel$export(module.exports, "B300", ()=>$58cb83647f5ab93c$export$e62e8919cca44969);
    $parcel$export(module.exports, "B400", ()=>$58cb83647f5ab93c$export$b3de0ae08da2ce64);
    $parcel$export(module.exports, "B500", ()=>$58cb83647f5ab93c$export$a6ee3d71bc067634);
    $parcel$export(module.exports, "T100", ()=>$58cb83647f5ab93c$export$776c9c497ef08533);
    $parcel$export(module.exports, "T200", ()=>$58cb83647f5ab93c$export$69cb3ca10c1e330e);
    $parcel$export(module.exports, "T300", ()=>$58cb83647f5ab93c$export$9dc1ef0f3f48059b);
    $parcel$export(module.exports, "T400", ()=>$58cb83647f5ab93c$export$7c835c78b6fcdef8);
    $parcel$export(module.exports, "T500", ()=>$58cb83647f5ab93c$export$6036577f95c3877e);
    $parcel$export(module.exports, "G100", ()=>$58cb83647f5ab93c$export$afbce1382ec95f73);
    $parcel$export(module.exports, "G200", ()=>$58cb83647f5ab93c$export$747d86715d4175de);
    $parcel$export(module.exports, "G300", ()=>$58cb83647f5ab93c$export$940e1f69e873f202);
    $parcel$export(module.exports, "G400", ()=>$58cb83647f5ab93c$export$a49394138f7b8e85);
    $parcel$export(module.exports, "G500", ()=>$58cb83647f5ab93c$export$6fa04827ac68a4fb);
    $parcel$export(module.exports, "L100", ()=>$58cb83647f5ab93c$export$fbb30b762ae4fcda);
    $parcel$export(module.exports, "L200", ()=>$58cb83647f5ab93c$export$f72948ef771f6f15);
    $parcel$export(module.exports, "L300", ()=>$58cb83647f5ab93c$export$59d89537e7d73aa4);
    $parcel$export(module.exports, "L400", ()=>$58cb83647f5ab93c$export$4b0a7cabffffd4f5);
    $parcel$export(module.exports, "L500", ()=>$58cb83647f5ab93c$export$58808b1c527bd1b0);
    $parcel$export(module.exports, "Y100", ()=>$58cb83647f5ab93c$export$1cc05bbbf340e559);
    $parcel$export(module.exports, "Y200", ()=>$58cb83647f5ab93c$export$5aae31392d72caaa);
    $parcel$export(module.exports, "Y300", ()=>$58cb83647f5ab93c$export$c6930421db9fa514);
    $parcel$export(module.exports, "Y400", ()=>$58cb83647f5ab93c$export$59619663aa6500fb);
    $parcel$export(module.exports, "Y500", ()=>$58cb83647f5ab93c$export$874739ea9e379ab6);
    $parcel$export(module.exports, "O100", ()=>$58cb83647f5ab93c$export$4d0048026652f54a);
    $parcel$export(module.exports, "O200", ()=>$58cb83647f5ab93c$export$51716a84e62e022c);
    $parcel$export(module.exports, "O300", ()=>$58cb83647f5ab93c$export$59e5b1f9a23fd718);
    $parcel$export(module.exports, "O400", ()=>$58cb83647f5ab93c$export$e30ed75d70748b1);
    $parcel$export(module.exports, "O500", ()=>$58cb83647f5ab93c$export$d93a44e5c84e8256);
    $parcel$export(module.exports, "R100", ()=>$58cb83647f5ab93c$export$be802dd0d8b57f35);
    $parcel$export(module.exports, "R200", ()=>$58cb83647f5ab93c$export$60847d42f9da92a6);
    $parcel$export(module.exports, "R300", ()=>$58cb83647f5ab93c$export$4a7404f376229999);
    $parcel$export(module.exports, "R400", ()=>$58cb83647f5ab93c$export$2010d0fb4295b346);
    $parcel$export(module.exports, "R500", ()=>$58cb83647f5ab93c$export$2837b5a1a71d5c02);
    $parcel$export(module.exports, "M100", ()=>$58cb83647f5ab93c$export$6755153cd35f90b1);
    $parcel$export(module.exports, "M200", ()=>$58cb83647f5ab93c$export$a19f0c33186f7767);
    $parcel$export(module.exports, "M300", ()=>$58cb83647f5ab93c$export$a46884cf0037b203);
    $parcel$export(module.exports, "M400", ()=>$58cb83647f5ab93c$export$a1d4686c17e1cdef);
    $parcel$export(module.exports, "M500", ()=>$58cb83647f5ab93c$export$16814b01d9742bf7);
    const $58cb83647f5ab93c$export$d6447c357493214f = '#F0F1F4';
    const $58cb83647f5ab93c$export$f563ee71e9ee74cd = 'rgba(9, 30, 66, 0.14)';
    const $58cb83647f5ab93c$export$e2ef2124cf4024b1 = (0, $829f609a65d26a98$exports).N60A;
    const $58cb83647f5ab93c$export$eece5f492e429f08 = '#44546F';
    const $58cb83647f5ab93c$export$c39c0fe0f26207ae = (0, $829f609a65d26a98$exports).N800;
    const $58cb83647f5ab93c$export$6011520a64d9a187 = '#F3F0FF';
    const $58cb83647f5ab93c$export$a7175d4e9206bc80 = '#DFD8FD';
    const $58cb83647f5ab93c$export$b48405b95304b5a1 = '#9F8FEF';
    const $58cb83647f5ab93c$export$c71e4279dd54a18d = '#5E4DB2';
    const $58cb83647f5ab93c$export$147899de772240ec = '#352C63';
    const $58cb83647f5ab93c$export$ecfc1dff386a3e7a = '#E9F2FF';
    const $58cb83647f5ab93c$export$215b7063051591f1 = '#CCE0FF';
    const $58cb83647f5ab93c$export$e62e8919cca44969 = '#579DFF';
    const $58cb83647f5ab93c$export$b3de0ae08da2ce64 = '#0055CC';
    const $58cb83647f5ab93c$export$a6ee3d71bc067634 = '#09326C';
    const $58cb83647f5ab93c$export$776c9c497ef08533 = '#E3FAFC';
    const $58cb83647f5ab93c$export$69cb3ca10c1e330e = '#C1F0F5';
    const $58cb83647f5ab93c$export$9dc1ef0f3f48059b = '#60C6D2';
    const $58cb83647f5ab93c$export$7c835c78b6fcdef8 = '#206B74';
    const $58cb83647f5ab93c$export$6036577f95c3877e = '#1D474C';
    const $58cb83647f5ab93c$export$afbce1382ec95f73 = '#DFFCF0';
    const $58cb83647f5ab93c$export$747d86715d4175de = '#BAF3DB';
    const $58cb83647f5ab93c$export$940e1f69e873f202 = '#4BCE97';
    const $58cb83647f5ab93c$export$a49394138f7b8e85 = '#216E4E';
    const $58cb83647f5ab93c$export$6fa04827ac68a4fb = '#164B35';
    const $58cb83647f5ab93c$export$fbb30b762ae4fcda = '#EEFBDA';
    const $58cb83647f5ab93c$export$f72948ef771f6f15 = '#D3F1A7';
    const $58cb83647f5ab93c$export$59d89537e7d73aa4 = '#94C748';
    const $58cb83647f5ab93c$export$4b0a7cabffffd4f5 = '#4C6B1F';
    const $58cb83647f5ab93c$export$58808b1c527bd1b0 = '#37471F';
    const $58cb83647f5ab93c$export$1cc05bbbf340e559 = '#FFF7D6';
    const $58cb83647f5ab93c$export$5aae31392d72caaa = (0, $829f609a65d26a98$exports).Y75;
    const $58cb83647f5ab93c$export$c6930421db9fa514 = '#E2B203';
    const $58cb83647f5ab93c$export$59619663aa6500fb = '#7F5F01';
    const $58cb83647f5ab93c$export$874739ea9e379ab6 = '#533F04';
    const $58cb83647f5ab93c$export$4d0048026652f54a = '#FFF4E5';
    const $58cb83647f5ab93c$export$51716a84e62e022c = '#FFE2BD';
    const $58cb83647f5ab93c$export$59e5b1f9a23fd718 = '#FAA53D';
    const $58cb83647f5ab93c$export$e30ed75d70748b1 = '#974F0C';
    const $58cb83647f5ab93c$export$d93a44e5c84e8256 = '#5F3811';
    const $58cb83647f5ab93c$export$be802dd0d8b57f35 = '#FFEDEB';
    const $58cb83647f5ab93c$export$60847d42f9da92a6 = '#FFD2CC';
    const $58cb83647f5ab93c$export$4a7404f376229999 = '#F87462';
    const $58cb83647f5ab93c$export$2010d0fb4295b346 = '#AE2A19';
    const $58cb83647f5ab93c$export$2837b5a1a71d5c02 = '#601E16';
    const $58cb83647f5ab93c$export$6755153cd35f90b1 = '#FFECF8';
    const $58cb83647f5ab93c$export$a19f0c33186f7767 = '#FDD0EC';
    const $58cb83647f5ab93c$export$a46884cf0037b203 = '#F797D2';
    const $58cb83647f5ab93c$export$a1d4686c17e1cdef = '#943D73';
    const $58cb83647f5ab93c$export$16814b01d9742bf7 = '#50253F';
});
parcelRegister("gAmq4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d59c1f29a6afb9ec$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d59c1f29a6afb9ec$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        greyLightest: {
            "id": "business-categories.category-form.category-color-picker.grey-lightest",
            "defaultMessage": "Grey lightest"
        },
        greyLighter: {
            "id": "business-categories.category-form.category-color-picker.grey-lighter",
            "defaultMessage": "Grey lighter"
        },
        grey: {
            "id": "business-categories.category-form.category-color-picker.grey",
            "defaultMessage": "Grey"
        },
        greyDarker: {
            "id": "business-categories.category-form.category-color-picker.grey-darker",
            "defaultMessage": "Grey darker"
        },
        greyDarkest: {
            "id": "business-categories.category-form.category-color-picker.grey-darkest",
            "defaultMessage": "Grey darkest"
        },
        purpleLightest: {
            "id": "business-categories.category-form.category-color-picker.purple-lightest",
            "defaultMessage": "Purple lightest"
        },
        purpleLighter: {
            "id": "business-categories.category-form.category-color-picker.purple-lighter",
            "defaultMessage": "Purple lighter"
        },
        purple: {
            "id": "business-categories.category-form.category-color-picker.purple",
            "defaultMessage": "Purple"
        },
        purpleDarker: {
            "id": "business-categories.category-form.category-color-picker.purple-darker",
            "defaultMessage": "Purple darker"
        },
        purpleDarkest: {
            "id": "business-categories.category-form.category-color-picker.purple-darkest",
            "defaultMessage": "Purple darkest"
        },
        blueLightest: {
            "id": "business-categories.category-form.category-color-picker.blue-lightest",
            "defaultMessage": "Blue lightest"
        },
        blueLighter: {
            "id": "business-categories.category-form.category-color-picker.blue-lighter",
            "defaultMessage": "Blue lighter"
        },
        blue: {
            "id": "business-categories.category-form.category-color-picker.blue",
            "defaultMessage": "Blue"
        },
        blueDarker: {
            "id": "business-categories.category-form.category-color-picker.blue-darker",
            "defaultMessage": "Blue darker"
        },
        blueDarkest: {
            "id": "business-categories.category-form.category-color-picker.blue-darkest",
            "defaultMessage": "Blue darkest"
        },
        tealLightest: {
            "id": "business-categories.category-form.category-color-picker.teal-lightest",
            "defaultMessage": "Teal lightest"
        },
        tealLighter: {
            "id": "business-categories.category-form.category-color-picker.teal-lighter",
            "defaultMessage": "Teal lighter"
        },
        teal: {
            "id": "business-categories.category-form.category-color-picker.teal",
            "defaultMessage": "Teal"
        },
        tealDarker: {
            "id": "business-categories.category-form.category-color-picker.teal-darker",
            "defaultMessage": "Teal darker"
        },
        tealDarkest: {
            "id": "business-categories.category-form.category-color-picker.teal-darkest",
            "defaultMessage": "Teal darkest"
        },
        greenLightest: {
            "id": "business-categories.category-form.category-color-picker.green-lightest",
            "defaultMessage": "Green lightest"
        },
        greenLighter: {
            "id": "business-categories.category-form.category-color-picker.green-lighter",
            "defaultMessage": "Green lighter"
        },
        green: {
            "id": "business-categories.category-form.category-color-picker.green",
            "defaultMessage": "Green"
        },
        greenDarker: {
            "id": "business-categories.category-form.category-color-picker.green-darker",
            "defaultMessage": "Green darker"
        },
        greenDarkest: {
            "id": "business-categories.category-form.category-color-picker.green-darkest",
            "defaultMessage": "Green darkest"
        },
        limeLightest: {
            "id": "business-categories.category-form.category-color-picker.lime-lightest",
            "defaultMessage": "Lime lightest"
        },
        limeLighter: {
            "id": "business-categories.category-form.category-color-picker.lime-lighter",
            "defaultMessage": "Lime lighter"
        },
        lime: {
            "id": "business-categories.category-form.category-color-picker.lime",
            "defaultMessage": "Lime"
        },
        limeDarker: {
            "id": "business-categories.category-form.category-color-picker.lime-darker",
            "defaultMessage": "Lime darker"
        },
        limeDarkest: {
            "id": "business-categories.category-form.category-color-picker.lime-darkest",
            "defaultMessage": "Lime darkest"
        },
        yellowLightest: {
            "id": "business-categories.category-form.category-color-picker.yellow-lightest",
            "defaultMessage": "Yellow lightest"
        },
        yellowLighter: {
            "id": "business-categories.category-form.category-color-picker.yellow-lighter",
            "defaultMessage": "Yellow lighter"
        },
        yellow: {
            "id": "business-categories.category-form.category-color-picker.yellow",
            "defaultMessage": "Yellow"
        },
        yellowDarker: {
            "id": "business-categories.category-form.category-color-picker.yellow-darker",
            "defaultMessage": "Yellow darker"
        },
        yellowDarkest: {
            "id": "business-categories.category-form.category-color-picker.yellow-darkest",
            "defaultMessage": "Yellow darkest"
        },
        orangeLightest: {
            "id": "business-categories.category-form.category-color-picker.orange-lightest",
            "defaultMessage": "Orange lightest"
        },
        orangeLighter: {
            "id": "business-categories.category-form.category-color-picker.orange-lighter",
            "defaultMessage": "Orange lighter"
        },
        orange: {
            "id": "business-categories.category-form.category-color-picker.orange",
            "defaultMessage": "Orange"
        },
        orangeDarker: {
            "id": "business-categories.category-form.category-color-picker.orange-darker",
            "defaultMessage": "Orange darker"
        },
        orangeDarkest: {
            "id": "business-categories.category-form.category-color-picker.orange-darkest",
            "defaultMessage": "Orange darkest"
        },
        redLightest: {
            "id": "business-categories.category-form.category-color-picker.red-lightest",
            "defaultMessage": "Red lightest"
        },
        redLighter: {
            "id": "business-categories.category-form.category-color-picker.red-lighter",
            "defaultMessage": "Red lighter"
        },
        red: {
            "id": "business-categories.category-form.category-color-picker.red",
            "defaultMessage": "Red"
        },
        redDarker: {
            "id": "business-categories.category-form.category-color-picker.red-darker",
            "defaultMessage": "Red darker"
        },
        redDarkest: {
            "id": "business-categories.category-form.category-color-picker.red-darkest",
            "defaultMessage": "Red darkest"
        },
        magentaLightest: {
            "id": "business-categories.category-form.category-color-picker.magenta-lightest",
            "defaultMessage": "Magenta lightest"
        },
        magentaLighter: {
            "id": "business-categories.category-form.category-color-picker.magenta-lighter",
            "defaultMessage": "Magenta lighter"
        },
        magenta: {
            "id": "business-categories.category-form.category-color-picker.magenta",
            "defaultMessage": "Magenta"
        },
        magentaDarker: {
            "id": "business-categories.category-form.category-color-picker.magenta-darker",
            "defaultMessage": "Magenta darker"
        },
        magentaDarkest: {
            "id": "business-categories.category-form.category-color-picker.magenta-darkest",
            "defaultMessage": "Magenta darkest"
        }
    });
});
parcelRegister("1J45B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d1bb813bc020276$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3d1bb813bc020276$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noCategory: {
            "id": "business-list.list-view.group-item.category-item.no-category",
            "defaultMessage": "Uncategorized"
        }
    });
});
parcelRegister("f7bpX", function(module, exports) {
    $parcel$export(module.exports, "ExpandIcon", ()=>$d04d9993a92cad32$export$fcdb0af0473ee9e4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $6Ingq;
    var $ebd3R;
    var $hORKG;
    var $3dGN0;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $k409E;
    const $d04d9993a92cad32$var$CONTENT_OFFSET = "var(--ds-space-100, 8px)";
    const $d04d9993a92cad32$var$WRAPPER_TRANSFORM = `translate(calc(-100% - ${$d04d9993a92cad32$var$CONTENT_OFFSET}), -50%)`;
    const $d04d9993a92cad32$export$fcdb0af0473ee9e4 = ({ expanded: expanded, onClick: onClick, rowIndex: rowIndex, totalGroupItems: totalGroupItems })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const Icon = expanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
            label: formatMessage((0, (0, parcelRequire("k409E")).default).collapseLabel),
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            LEGACY_primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6Ingq")))))
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
            label: formatMessage((0, (0, parcelRequire("k409E")).default).open),
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            LEGACY_primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("ebd3R")))))
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            onClick();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowGroupExpandIcon', {
                direction: expanded ? 'collapse' : 'expand',
                totalGroupItems: totalGroupItems
            });
        }, [
            createAnalyticsEvent,
            expanded,
            onClick,
            totalGroupItems
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage(expanded ? (0, (0, parcelRequire("k409E")).default).collapse : (0, (0, parcelRequire("k409E")).default).expand)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d04d9993a92cad32$var$ExpandIconWrapper, {
            onClick: handleClick,
            iconBefore: Icon,
            appearance: "subtle",
            testId: `business-list.ui.list-view.group-item.expand-icon.expand-icon-wrapper-${rowIndex}`
        }));
    };
    const $d04d9993a92cad32$var$ExpandIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t9ec1mu3 _14n4stnw _w1ap1tcg _btpd1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("k409E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9854930fac9ad6a3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9854930fac9ad6a3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expand: {
            "id": "business-list.list-view.group-item.expand-icon.expand",
            "defaultMessage": "Expand"
        },
        collapse: {
            "id": "business-list.list-view.group-item.expand-icon.collapse",
            "defaultMessage": "Collapse"
        },
        collapseLabel: {
            "id": "business-list.list-view.group-item.expand-icon.collapse-label",
            "defaultMessage": "collapse"
        },
        open: {
            "id": "business-list.list-view.group-item.expand-icon.open",
            "defaultMessage": "open"
        }
    });
});
parcelRegister("hWLf6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26876a53e8b553de$export$2e2bcd8739ae039);
    var $7VHMR;
    var $26876a53e8b553de$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        visibleItemsCount: {
            "id": "business-list.list-view.group-item.visible-items-count",
            "defaultMessage": "{ visibleItems } of { totalGroupItems }"
        },
        addGroupItem: {
            "id": "business-list.list-view.group-item.add-group-item",
            "defaultMessage": "Add group item"
        },
        createIssue: {
            "id": "business-list.list-view.group-item.create-issue",
            "defaultMessage": "Create"
        }
    });
});
parcelRegister("240fW", function(module, exports) {
    $parcel$export(module.exports, "PriorityItem", ()=>$62f1151e65aa2226$export$2ea27b6e6a4479a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $aVM5G;
    var $jDI2j;
    const $62f1151e65aa2226$export$2ea27b6e6a4479a7 = ({ data: data })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const priorityName = data.priority?.name != null ? data.priority.name : formatMessage((0, (0, parcelRequire("jDI2j")).default).noPriority);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVM5G")).default), {
            iconUrl: data.priority?.iconUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($62f1151e65aa2226$var$PriorityLabel, null, priorityName));
    };
    const $62f1151e65aa2226$var$PriorityLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aVM5G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad71f64ee21bbdf9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ad71f64ee21bbdf9$var$PRIORITY_ICON_SIZE = 20;
    const $ad71f64ee21bbdf9$var$PriorityIcon = ({ iconUrl: iconUrl })=>iconUrl == null ? null : (0, ($parcel$interopDefault($5uXOq))).createElement($ad71f64ee21bbdf9$var$ImageIcon, {
            src: iconUrl,
            alt: ""
        });
    var $ad71f64ee21bbdf9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ad71f64ee21bbdf9$var$PriorityIcon);
    const $ad71f64ee21bbdf9$var$ImageIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jDI2j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99fc1044a3441d0c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $99fc1044a3441d0c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPriority: {
            "id": "business-list.list-view.group-item.priority-item.no-priority",
            "defaultMessage": "No priority"
        }
    });
});
parcelRegister("9wkeV", function(module, exports) {
    $parcel$export(module.exports, "SelectGroupCheckbox", ()=>$c271e39c3161153e$export$5740ccbed0a2bd61);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $2GQqf;
    var $mk7k0;
    var $79pxk;
    var $bW4OH;
    var $4DEgE;
    var $9u99d;
    var $2SSu7;
    const $c271e39c3161153e$var$getFirstParent = ({ issuesMap: issuesMap, issueId: issueId })=>{
        const parentIssueId = issuesMap.get(issueId)?.parentIssueId;
        if (parentIssueId) return $c271e39c3161153e$var$getFirstParent({
            issuesMap: issuesMap,
            issueId: parentIssueId
        });
        return issueId;
    };
    const $c271e39c3161153e$export$5740ccbed0a2bd61 = (0, $5uXOq.memo)(({ group: group, rowIndex: rowIndex, onKeyDown: onKeyDown })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ issuesMap: issuesMap, expandedItems: expandedItems, childrenItems: childrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectIssues: selectIssues, unselectIssues: unselectIssues, selectGroup: selectGroup, unselectGroup: unselectGroup }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const [isGroupSelected] = (0, (0, parcelRequire("mk7k0")).useIsGroupSelected)(group.issueId);
        const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, (0, parcelRequire("bW4OH")).useShiftKeySelection)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, (0, parcelRequire("79pxk")).useSelectCollapsedGroups)();
        const isLoadingGroupIssues = childrenItems[group.issueId]?.loading;
        const groupIssues = (0, $5uXOq.useMemo)(()=>!isLoadingGroupIssues ? (0, (0, parcelRequire("4DEgE")).getAllIssueChildren)({
                issue: group,
                childrenItems: childrenItems
            }) : undefined, [
            childrenItems,
            group,
            isLoadingGroupIssues
        ]);
        const [diffGroupIssuesSelected] = (0, (0, parcelRequire("mk7k0")).useDiffIssuesSelected)(groupIssues);
        (0, $5uXOq.useEffect)(()=>{
            if (!areAllIssuesSelected && !fetchingGroups && !isLoadingGroupIssues && diffGroupIssuesSelected && groupIssues?.length) {
                if (diffGroupIssuesSelected.length === 0 && !isGroupSelected) selectGroup(group.issueId);
                else if (diffGroupIssuesSelected.length && isGroupSelected) unselectGroup(group.issueId);
            }
        }, [
            areAllIssuesSelected,
            diffGroupIssuesSelected,
            fetchingGroups,
            group.issueId,
            groupIssues?.length,
            isGroupSelected,
            isLoadingGroupIssues,
            selectGroup,
            unselectGroup
        ]);
        const hasChildren = group.childSummary?.hasChildren;
        const hasFirstIssuesToFetch = (0, $5uXOq.useMemo)(()=>expandedItems[group.issueId] === undefined && hasChildren && groupIssues?.length === 0, [
            expandedItems,
            group.issueId,
            groupIssues?.length,
            hasChildren
        ]);
        const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectGroup', {
                isChecked: isChecked,
                rowIndex: rowIndex,
                shiftKeyPressed: shiftKeyPressed
            });
            if (isChecked) {
                selectCollapsedGroups([
                    group
                ]);
                selectIssues({
                    issues: groupIssues || [],
                    selectGroup: group.issueId,
                    rowIndex: rowIndex
                });
            } else {
                let issuesToUnselect = groupIssues || [];
                if (!groupIssues?.length) issuesToUnselect = [
                    ...selectedIssues
                ].filter((issueId)=>$c271e39c3161153e$var$getFirstParent({
                        issuesMap: issuesMap,
                        issueId: issueId
                    }) === group.issueId);
                unselectIssues({
                    issues: issuesToUnselect,
                    unselectGroup: group.issueId,
                    rowIndex: rowIndex
                });
            }
            if (shiftKeyPressed) onShiftKeyBulkSelection({
                isChecked: isChecked,
                rowIndex: rowIndex
            });
        }, [
            createAnalyticsEvent,
            group,
            groupIssues,
            issuesMap,
            onShiftKeyBulkSelection,
            rowIndex,
            selectCollapsedGroups,
            selectIssues,
            selectedIssues,
            unselectIssues
        ]);
        let hasSomeGroupIssueSelected = !!(Number(diffGroupIssuesSelected?.length) > 0 && Number(diffGroupIssuesSelected?.length) < Number(groupIssues?.length));
        const shouldBeSelected = Number(diffGroupIssuesSelected?.length) === 0 && hasChildren && Number(groupIssues?.length) > 0 && !hasFirstIssuesToFetch;
        let isChecked = isGroupSelected || hasSomeGroupIssueSelected || !!shouldBeSelected;
        if (!isChecked && selectedIssues.size) {
            hasSomeGroupIssueSelected = [
                ...selectedIssues
            ].some((issueId)=>$c271e39c3161153e$var$getFirstParent({
                    issuesMap: issuesMap,
                    issueId: issueId
                }) === group.issueId);
            isChecked = hasSomeGroupIssueSelected;
        }
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                onClickCheckbox({
                    isChecked: !isChecked,
                    shiftKeyPressed: e.shiftKey
                });
                return;
            }
            onKeyDown?.(e);
        }, [
            isChecked,
            onClickCheckbox,
            onKeyDown
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GQqf")).BulkSelectCheckbox), {
            onClick: onClickCheckbox,
            onKeyDown: handleKeyDown,
            isChecked: isChecked,
            isIndeterminate: hasSomeGroupIssueSelected,
            label: formatMessage((0, (0, parcelRequire("2SSu7")).default).selectGroup)
        });
    });
});
parcelRegister("2GQqf", function(module, exports) {
    $parcel$export(module.exports, "BulkSelectCheckbox", ()=>$05c4778a6afe1316$export$9d26591b0d1643b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bXrHm = parcelRequire("bXrHm");
    var $kkJfY;
    var $k6T4f;
    var $5Fk4Z;
    var $jldZL;
    var $4R6GH;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    const $05c4778a6afe1316$export$9d26591b0d1643b6 = (0, $5uXOq.memo)(({ id: id, onClick: onClick, isChecked: isChecked, isIndeterminate: isIndeterminate, isSelected: isSelected, wrapperRef: wrapperRef, onKeyDown: onKeyDown, isDisabled: isDisabled, hasPulse: hasPulse, label: label, ...props })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const bulkSelectId = id ?? `${0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID}_${(0, ($parcel$interopDefault($bXrHm)))()}`;
        const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
            if (hasPulse) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'checkbox'
            }), 'checkbox clicked', 'bulkEditChangeboardingCheckboxPulse');
            onClick({
                isChecked: event?.currentTarget?.checked,
                shiftKeyPressed: !!event?.shiftKey
            });
        }, [
            hasPulse,
            onClick,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected && wrapperRef?.current) wrapperRef.current.focus();
        }, [
            isSelected,
            wrapperRef
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: bulkSelectId
        }, label)), hasPulse && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_view_bulk_edit_changeboarding') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "bulk-select-checkbox"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).Pulse), {
            radius: 3,
            testId: "business-list.common.ui.bulk-select-checkbox.spotlight-pulse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            id: bulkSelectId,
            onClick: handleOnClick,
            isChecked: isChecked,
            isDisabled: isDisabled,
            isIndeterminate: isIndeterminate,
            testId: "business-list.common.ui.bulk-select-checkbox",
            onKeyDown: onKeyDown,
            ...wrapperRef ? {
                ref: onWrapperRef
            } : {},
            ...props
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                messageId: (0, (0, parcelRequire("eTDjN")).BULK_EDIT_CHANGEBOARDING_MESSAGE_ID),
                componentType: 'spotlight-pulse'
            }
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            id: bulkSelectId,
            onClick: handleOnClick,
            isChecked: isChecked,
            isDisabled: isDisabled,
            isIndeterminate: isIndeterminate,
            testId: "business-list.common.ui.bulk-select-checkbox",
            onKeyDown: onKeyDown,
            ...wrapperRef ? {
                ref: onWrapperRef
            } : {},
            ...props
        }));
    });
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("79pxk", function(module, exports) {
    $parcel$export(module.exports, "useSelectCollapsedGroups", ()=>$15bcf90ef5bfa851$export$fb1b9a2145b5780d);
    var $5uXOq = parcelRequire("5uXOq");
    var $9u99d;
    var $mk7k0;
    const $15bcf90ef5bfa851$export$fb1b9a2145b5780d = ()=>{
        const [{ expandedItems: expandedItems, childrenItems: childrenItems }, { setExpandedItems: setExpandedItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [{ fetchingGroups: fetchingGroups, selectedGroups: selectedGroups }, { selectIssues: selectIssues, selectGroup: selectGroup, setFetchingGroups: setFetchingGroups }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        (0, $5uXOq.useEffect)(()=>{
            if (fetchingGroups.length) {
                let groupFetchDone = [];
                fetchingGroups.forEach((groupId)=>{
                    const group = childrenItems[groupId];
                    if (group?.loading === false && selectedGroups.has(groupId)) {
                        selectIssues({
                            issues: group.data.map((i)=>String(i.issueId))
                        });
                        groupFetchDone = [
                            ...groupFetchDone,
                            groupId
                        ];
                    }
                });
                if (groupFetchDone.length) setFetchingGroups(fetchingGroups.filter((g)=>!groupFetchDone.includes(g)));
            }
        }, [
            childrenItems,
            fetchingGroups,
            selectIssues,
            selectedGroups,
            setFetchingGroups
        ]);
        const selectCollapsedGroups = (0, $5uXOq.useCallback)((groups)=>{
            let groupToFetch = [];
            groups.forEach((group)=>{
                const { issueId: issueId, childSummary: childSummary } = group;
                const hasChildren = childSummary?.hasChildren;
                selectGroup(issueId);
                const hasIssuesToFetch = expandedItems[issueId] === undefined && childrenItems[issueId] === undefined && hasChildren;
                setExpandedItems(issueId, true);
                if (hasIssuesToFetch) groupToFetch = [
                    ...groupToFetch,
                    issueId
                ];
            });
            setFetchingGroups(groupToFetch);
        }, [
            childrenItems,
            expandedItems,
            selectGroup,
            setExpandedItems,
            setFetchingGroups
        ]);
        return {
            selectCollapsedGroups: selectCollapsedGroups,
            fetchingGroups: fetchingGroups.length > 0
        };
    };
});
parcelRegister("bW4OH", function(module, exports) {
    $parcel$export(module.exports, "useShiftKeySelection", ()=>$c97ee04499e140fa$export$e105f3cb55da1b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $fn8B5 = parcelRequire("fn8B5");
    var $jDUax;
    var $8e3Yw;
    var $9u99d;
    var $mk7k0;
    var $79pxk;
    var $4DEgE;
    const $c97ee04499e140fa$export$e105f3cb55da1b14 = ()=>{
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const [{ issuesMap: issuesMap, expandedItems: expandedItems, hierarchyData: hierarchyData, childrenItems: childrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [{ selectedIssues: selectedIssuesStore, fetchingGroups: fetchingGroups, lastSelectedRowIndex: lastSelectedRowIndex }, { selectIssues: selectIssues, unselectIssues: unselectIssues, setLastSelectedRowIndex: setLastSelectedRowIndex }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const { selectCollapsedGroups: selectCollapsedGroups } = (0, (0, parcelRequire("79pxk")).useSelectCollapsedGroups)();
        const [lastIssueIdSelected, setLastIssueIdSelected] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const isGrouping = groupByFieldId != null;
            if (isGrouping && !fetchingGroups.length && lastSelectedRowIndex !== undefined && lastIssueIdSelected) {
                const issues = (0, (0, parcelRequire("4DEgE")).getFlattenIssuesList)({
                    issues: hierarchyData.data,
                    expandedItems: expandedItems
                });
                const newIndex = issues.findIndex((i)=>String(i.issueId) === lastIssueIdSelected);
                if (newIndex >= 0) {
                    setLastSelectedRowIndex(newIndex);
                    setLastIssueIdSelected(undefined);
                }
            }
        }, [
            expandedItems,
            fetchingGroups
        ]);
        const onShiftKeyBulkSelection = (0, $5uXOq.useCallback)(({ isChecked: isChecked, rowIndex: selectedRowIndex })=>{
            let rowIndex = selectedRowIndex;
            if (lastSelectedRowIndex !== undefined && rowIndex !== undefined) {
                const lastIssueSelected = issuesMap.get([
                    ...selectedIssuesStore
                ].pop() || '');
                const parentLastIssueSelected = lastIssueSelected?.parentIssueId;
                let expandedItemsToGetFlattenList = expandedItems;
                if (parentLastIssueSelected && !(0, (0, parcelRequire("jDUax")).isGroupItem)(parentLastIssueSelected) && !expandedItems[parentLastIssueSelected]) {
                    expandedItemsToGetFlattenList = {
                        ...expandedItemsToGetFlattenList,
                        [parentLastIssueSelected]: true
                    };
                    rowIndex += issuesMap.get(parentLastIssueSelected)?.children?.length || 0;
                }
                const issues = expandedItems ? (0, (0, parcelRequire("4DEgE")).getFlattenIssuesList)({
                    issues: hierarchyData.data,
                    expandedItems: expandedItemsToGetFlattenList
                }) : hierarchyData.data;
                let selectedIssues = [];
                if (lastSelectedRowIndex < rowIndex) selectedIssues = issues.slice(lastSelectedRowIndex, rowIndex + 1);
                else selectedIssues = issues.slice(rowIndex, !isChecked ? lastSelectedRowIndex + 1 : lastSelectedRowIndex);
                let issueIds = [];
                const isGrouping = groupByFieldId != null;
                if (isGrouping) {
                    const groups = (0, ($parcel$interopDefault($fn8B5)))(selectedIssues, (issue)=>(0, (0, parcelRequire("jDUax")).isGroupItem)(issue.issueId));
                    issueIds = groups.false.map((issue)=>String(issue.issueId));
                    const pressedIssue = issues[rowIndex];
                    const groupsToSelect = groups.true?.filter((group)=>group.issueId !== pressedIssue.parentIssueId) || [];
                    if (groupsToSelect.length) {
                        setLastIssueIdSelected(pressedIssue.issueId);
                        if (isChecked) selectCollapsedGroups(groupsToSelect);
                        else groupsToSelect.forEach((group)=>{
                            const groupIssues = (0, (0, parcelRequire("4DEgE")).getAllIssueChildren)({
                                issue: group,
                                childrenItems: childrenItems
                            });
                            unselectIssues({
                                issues: groupIssues || [],
                                unselectGroup: group.issueId,
                                rowIndex: rowIndex
                            });
                        });
                    }
                } else issueIds = selectedIssues.map((issue)=>String(issue.issueId));
                if (!isChecked) unselectIssues({
                    issues: issueIds
                });
                else selectIssues({
                    issues: issueIds
                });
            }
        }, [
            childrenItems,
            expandedItems,
            groupByFieldId,
            hierarchyData.data,
            issuesMap,
            lastSelectedRowIndex,
            selectCollapsedGroups,
            selectIssues,
            selectedIssuesStore,
            unselectIssues
        ]);
        return {
            onShiftKeyBulkSelection: onShiftKeyBulkSelection
        };
    };
});
parcelRegister("2SSu7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$033eedec001f2bfe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $033eedec001f2bfe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectGroup: {
            "id": "business-list.list-view.group-item.select-group-checkbox.select-group",
            "defaultMessage": "Select group"
        }
    });
});
parcelRegister("iaKbb", function(module, exports) {
    $parcel$export(module.exports, "SprintItem", ()=>$559bdcd95b3fa7c0$export$c40eb2da058b4e36);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9xxV;
    var $koVbs;
    var $fZK5l;
    const $559bdcd95b3fa7c0$export$c40eb2da058b4e36 = ({ data: data })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { sprint: sprint } = data;
        let text;
        if (!sprint) text = formatMessage((0, (0, parcelRequire("fZK5l")).default).backlog);
        else if (sprint.state === 'CLOSED') text = formatMessage((0, (0, parcelRequire("fZK5l")).default).completedSprint);
        else text = sprint.name;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            text: text,
            testId: "business-list.ui.list-view.group-item.sprint-item.simple-tag"
        });
    };
});
parcelRegister("d9xxV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87927dab24395a15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5oSQr;
    var $aXLIT;
    var $eYXIO;
    const $87927dab24395a15$var$SimpleTagComponent = (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eYXIO")).default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5oSQr")).default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aXLIT")).default), {
                elemBefore: elemBefore
            }),
            contentElement: content
        });
    });
    const $87927dab24395a15$var$SimpleTag = (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
    var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;
});
parcelRegister("5oSQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db35d9df42c66ff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    var $2hnSR;
    function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $db35d9df42c66ff0$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        padding: "var(--ds-space-0, 0px)",
        position: 'relative',
        backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.default})`,
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.default})`,
        cursor: 'default'
    });
    const $db35d9df42c66ff0$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        position: 'relative',
        alignItems: 'center',
        gap: "var(--ds-space-050, 4px)",
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        border: 'solid',
        borderColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        color: "var(--ds-text, #172B4D)",
        cursor: 'default',
        paddingInline: "var(--ds-space-050, 4px)"
    });
    const $db35d9df42c66ff0$var$interactiveStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover})`
        },
        '&:active': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.active})`
        }
    });
    const $db35d9df42c66ff0$var$interactiveStyles = {
        name: "jcdcgl",
        styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    };
    const $db35d9df42c66ff0$var$focusRingStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            boxShadow: `0 0 0 2px var(${(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing})`,
            outline: 'none'
        }
    });
    const $db35d9df42c66ff0$var$focusRingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            outline: `2px solid ${(0, parcelRequire("2hnSR")).focusRingColors}`,
            outlineOffset: '2px '
        }
    });
    const $db35d9df42c66ff0$var$nonStandardLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`
        }
    });
    const $db35d9df42c66ff0$var$BaseTag = (0, ($parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
        const isLink = Boolean(href);
        const isRemovable = Boolean(after);
        const isInteractive = isLink || isRemovable;
        const isStandardLink = isLink && color === 'standard';
        const textLinkColors = isStandardLink ? (0, parcelRequire("2hnSR")).textColors['standardLink'] : (0, parcelRequire("2hnSR")).textColors[color];
        const backgroundHoverColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkHoverBackgroundColors[color];
        const backgroundActiveColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkActiveBackgroundColors[color];
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...other,
            ref: ref,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
                isInteractive && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
            ],
            style: {
                [(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor]: (0, parcelRequire("2hnSR")).borderColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.default]: (0, parcelRequire("2hnSR")).textColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover]: (0, parcelRequire("2hnSR")).textHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.active]: (0, parcelRequire("2hnSR")).textActiveColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.link]: textLinkColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.default]: (0, parcelRequire("2hnSR")).backgroundColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover]: backgroundHoverColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.active]: backgroundActiveColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing]: (0, parcelRequire("2hnSR")).focusRingColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.default]: (0, parcelRequire("2hnSR")).removeButtonColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.hover]: (0, parcelRequire("2hnSR")).removeButtonHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).borderRadius]: (0, parcelRequire("2hnSR")).borderRadius[appearance],
                ...style
            },
            className: className,
            "data-testid": testId
        }, before, contentElement, after);
    });
    var $db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;
});
parcelRegister("e6s40", function(module, exports) {
    $parcel$export(module.exports, "tagHeight", ()=>$1dd8b7ac532261be$export$5b2b1030a679f37);
    $parcel$export(module.exports, "buttonWidthUnitless", ()=>$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
    $parcel$export(module.exports, "maxTextWidthUnitless", ()=>$1dd8b7ac532261be$export$2e3bcb01bf928995);
    $parcel$export(module.exports, "maxTextWidth", ()=>$1dd8b7ac532261be$export$982d4a1a6de11130);
    $parcel$export(module.exports, "defaultBorderRadius", ()=>$1dd8b7ac532261be$export$35d5d1e251b985cf);
    $parcel$export(module.exports, "defaultRoundedBorderRadius", ()=>$1dd8b7ac532261be$export$c49771100fee18c8);
    $parcel$export(module.exports, "defaultMargin", ()=>$1dd8b7ac532261be$export$6728fea658cfb92e);
    $parcel$export(module.exports, "defaultTextPadding", ()=>$1dd8b7ac532261be$export$c2d03c4c68282362);
    $parcel$export(module.exports, "textPaddingRight", ()=>$1dd8b7ac532261be$export$b5686dedf408caa0);
    $parcel$export(module.exports, "textMarginLeft", ()=>$1dd8b7ac532261be$export$b824cac86306f7a2);
    $parcel$export(module.exports, "cssVar", ()=>$1dd8b7ac532261be$export$8b4981022bd80a4e);
    var $k5uoT;
    const $1dd8b7ac532261be$var$gridSizeValue = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $1dd8b7ac532261be$var$borderRadiusValue = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $1dd8b7ac532261be$export$b4d89c3994664204 = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$export$b4d89c3994664204}px`})`;
    const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$aba002ef70684916 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$d5949a2c2ea9dcea = 25 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$488fda99655ff65a = `${$1dd8b7ac532261be$export$d5949a2c2ea9dcea}px`;
    const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$export$d5949a2c2ea9dcea - $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
    const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
    const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
    const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
    const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
        color: {
            background: {
                default: '--ds-cb',
                hover: '--ds-cbh',
                active: '--ds-cba'
            },
            borderColor: '--ds-bc',
            focusRing: '--ds-cfr',
            text: {
                default: '--ds-ct',
                hover: '--ds-cth',
                active: '--ds-ctp',
                link: '--ds-ctl'
            },
            removeButton: {
                default: '--ds-rb',
                hover: '--ds-rbh'
            }
        },
        borderRadius: '--ds-br'
    };
});
parcelRegister("2hnSR", function(module, exports) {
    $parcel$export(module.exports, "textColors", ()=>$5b444d8505b9cc3c$export$daa0ace263cb20d2);
    $parcel$export(module.exports, "borderColors", ()=>$5b444d8505b9cc3c$export$1c1b571cf296eca7);
    $parcel$export(module.exports, "textHoverColors", ()=>$5b444d8505b9cc3c$export$7c7104a5f052cab7);
    $parcel$export(module.exports, "textActiveColors", ()=>$5b444d8505b9cc3c$export$382469baad253eb7);
    $parcel$export(module.exports, "backgroundColors", ()=>$5b444d8505b9cc3c$export$b9d7c59a579c23c6);
    $parcel$export(module.exports, "linkHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$4410079763249c74);
    $parcel$export(module.exports, "linkActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$76be99c5e13e3566);
    $parcel$export(module.exports, "focusRingColors", ()=>$5b444d8505b9cc3c$export$2a31dbe82788f940);
    $parcel$export(module.exports, "borderRadius", ()=>$5b444d8505b9cc3c$export$7a57f79000377ca2);
    $parcel$export(module.exports, "removalHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$1202b7eb21da7b58);
    $parcel$export(module.exports, "removalActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$62ace793ebb16bda);
    $parcel$export(module.exports, "removalTextColors", ()=>$5b444d8505b9cc3c$export$17d206ccea111bbb);
    $parcel$export(module.exports, "removeButtonColors", ()=>$5b444d8505b9cc3c$export$f64c7641cbc22da7);
    $parcel$export(module.exports, "removeButtonHoverColors", ()=>$5b444d8505b9cc3c$export$b03fbc2a369c563e);
    var $e6s40;
    const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
        standard: '#B7B9BE',
        blue: '#669DF1',
        red: '#F87168',
        yellow: '#DDB30E',
        green: '#4BCE97',
        teal: '#6CC3E0',
        purple: '#C97CF4',
        lime: '#94C748',
        magenta: '#E774BB',
        orange: '#FCA700',
        grey: '#B7B9BE',
        standardLink: '#B7B9BE',
        blueLight: '#669DF1',
        redLight: '#F87168',
        yellowLight: '#DDB30E',
        greenLight: '#4BCE97',
        tealLight: '#6CC3E0',
        purpleLight: '#C97CF4',
        limeLight: '#94C748',
        magentaLight: '#E774BB',
        orangeLight: '#FCA700',
        greyLight: '#B7B9BE'
    };
    const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
        standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$382469baad253eb7 = {
        standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime, #4C6B1F)",
        magenta: "var(--ds-text-accent-magenta, #943D73)",
        orange: "var(--ds-text-accent-orange, #974F0C)",
        grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
        magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
        greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
        standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
        teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        lime: "var(--ds-background-accent-lime-subtle, #94C748)",
        magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
        greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    };
    const $5b444d8505b9cc3c$export$4410079763249c74 = {
        standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
        magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
        orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
        grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
        limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
        orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
        greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
    const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
        standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
        grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
        magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
        orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
        blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
        tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
        orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
        greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
    };
    const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
    const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
        default: (0, (0, parcelRequire("e6s40")).defaultBorderRadius),
        rounded: (0, (0, parcelRequire("e6s40")).defaultRoundedBorderRadius)
    };
    const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
    const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
        standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
});
parcelRegister("aXLIT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b11e671062d0fc5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4b11e671062d0fc5$var$beforeElementStyles = {
        name: "cfjv6",
        styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
    };
    const $4b11e671062d0fc5$var$beforeElementStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        insetBlockStart: "var(--ds-space-0, 0px)"
    });
    const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
        }, elemBefore) : null;
    var $4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;
});
parcelRegister("eYXIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c46b06918fbe54e8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c46b06918fbe54e8$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        paddingInlineStart: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$linkStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.link})`,
        pointerEvents: 'auto',
        textDecoration: 'none',
        '&:hover': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`,
            textDecoration: 'underline'
        },
        '&:focus': {
            outline: 'none'
        }
    });
    const $c46b06918fbe54e8$var$linkStyles = {
        name: "1e5oc06",
        styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
    };
    const $c46b06918fbe54e8$var$hasAfterStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`,
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).textPaddingRight)
    });
    const $c46b06918fbe54e8$var$hasAfterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`
    });
    const $c46b06918fbe54e8$var$hasBeforeStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: (0, (0, parcelRequire("e6s40")).textMarginLeft)
    });
    const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
        const Link = linkComponent ?? 'a';
        if (href) return (0, (0, parcelRequire("f8Sb3")).jsx)(Link, {
            href: href,
            "data-color": color,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
    };
    var $c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;
});
parcelRegister("fZK5l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90d99ce7164fc949$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90d99ce7164fc949$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        completedSprint: {
            "id": "business-list.list-view.group-item.sprint-item.completed-sprint",
            "defaultMessage": "Completed sprint"
        },
        backlog: {
            "id": "business-list.list-view.group-item.sprint-item.backlog",
            "defaultMessage": "Backlog"
        }
    });
});
parcelRegister("dMoqa", function(module, exports) {
    $parcel$export(module.exports, "StatusItem", ()=>$fa1e0dcc1a1c7374$export$a687524c95d42e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $gULOk;
    var $dCm1o;
    const $fa1e0dcc1a1c7374$var$appearanceMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 'default',
        [(0, (0, parcelRequire("gULOk")).TODO)]: 'default',
        [(0, (0, parcelRequire("gULOk")).DONE)]: 'success',
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 'inprogress'
    };
    const $fa1e0dcc1a1c7374$export$cbc76b787f60c037 = (categoryId)=>categoryId != null ? $fa1e0dcc1a1c7374$var$appearanceMap[(0, (0, parcelRequire("gULOk")).statusCategoryForId)(categoryId)] : $fa1e0dcc1a1c7374$var$appearanceMap[0, (0, parcelRequire("gULOk")).UNDEFINED];
    const $fa1e0dcc1a1c7374$export$a687524c95d42e5 = ({ data: data })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: $fa1e0dcc1a1c7374$export$cbc76b787f60c037(data.status?.categoryId),
            isBold: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, data.status?.name);
});
parcelRegister("gC8QP", function(module, exports) {
    $parcel$export(module.exports, "StoryPointsItem", ()=>$c90d8c76411d1744$export$93b96298887b28d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $d9xxV;
    var $koVbs;
    var $dCm1o;
    var $2WW6a;
    const $c90d8c76411d1744$export$93b96298887b28d0 = ({ value: value })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
            appearance: "default"
        }, typeof value === 'number' ? formatMessage((0, (0, parcelRequire("2WW6a")).default).storyPoints, {
            points: value
        }) : formatMessage((0, (0, parcelRequire("2WW6a")).default).noStoryPoints)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
            text: typeof value === 'number' ? formatMessage((0, (0, parcelRequire("2WW6a")).default).storyPoints, {
                points: value
            }) : formatMessage((0, (0, parcelRequire("2WW6a")).default).noStoryPoints)
        });
    };
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("2WW6a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd099e29f4e03970$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bd099e29f4e03970$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        storyPoints: {
            "id": "business-list.list-view.group-item.storypoints-item.story-points",
            "defaultMessage": "{points, plural, one {# point} other {# points}}"
        },
        noStoryPoints: {
            "id": "business-list.list-view.group-item.storypoints-item.no-story-points",
            "defaultMessage": "No points"
        }
    });
});
parcelRegister("earxJ", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$aa807fa9ae1daad0$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "GroupContainer", ()=>$aa807fa9ae1daad0$export$dd05ea0be7e7193a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    const $aa807fa9ae1daad0$var$ICON_SIZE = 24;
    const $aa807fa9ae1daad0$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.250'
    });
    const $aa807fa9ae1daad0$export$e6dfd72ab29f8598 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            xcss: $aa807fa9ae1daad0$var$wrapperStyles
        }, children);
    const $aa807fa9ae1daad0$var$groupContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.500'
    });
    const $aa807fa9ae1daad0$export$dd05ea0be7e7193a = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            xcss: $aa807fa9ae1daad0$var$groupContainerStyles
        }, children);
    const $aa807fa9ae1daad0$export$caa7a2fe02de419c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $aa807fa9ae1daad0$export$b936c55164dcf1db = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsbu2gc _4t3i1tcg _bfhk1aqf _18s81l84 _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $aa807fa9ae1daad0$export$d1e723d3001badba = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $aa807fa9ae1daad0$export$2304bbb03949f4f1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _bfhk1aqf _18s8u2gc _2rko1l7b",
                __cmplp.className
            ])
        });
    });
    const $aa807fa9ae1daad0$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dUCV4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d4f608e0dc3b08b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jldZL;
    var $lQFjJ;
    var $Q7Myb;
    var $9pdbW;
    var $gzkAf;
    var $17ot5;
    var $5hI3W;
    var $4Mmyc;
    var $17X6Y;
    var $ccsmj;
    var $70g8n;
    var $dXCxS;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $2NMNM;
    var $5GqLe;
    var $73w1P;
    var $aSUiK;
    var $dCm1o;
    var $4nnGr;
    var $8e3Yw;
    var $mH57d;
    var $kALEJ;
    var $9WaRX;
    var $i0CN8;
    var $h4BPz;
    const $9d4f608e0dc3b08b$export$223875819fd7cf93 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { inviteButtonInteraction: inviteButtonInteraction, isShareButtonEnabled: isShareButtonEnabled, isPresenceEnabled: isPresenceEnabled, hasFilterCustomFields: hasFilterCustomFields, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const [hideDoneItems, setHideDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const [{ hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems }, { toggleExpandAllItems: toggleExpandAllItems, collapseAllItems: collapseAllItems }] = (0, (0, parcelRequire("9pdbW")).useExpandCollapseAllItems)({
            view: 'list'
        });
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGrouping = groupByFieldId != null;
        const { showFlatList: showFlatList } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { hiddenQuickFilters: hiddenQuickFilters, allowedAliasFieldId: allowedAliasFieldId } = (0, (0, parcelRequire("h4BPz")).useFilterProps)();
        const projectType = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && isSoftwareFieldsEnabled ? 'software' : 'business';
        const hasFeedbackButton = projectType === 'software';
        const shareButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccsmj")).JWMShareButton), {
            shareTitle: (0, (0, parcelRequire("i0CN8")).default).shareTitle,
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).LIST,
            shareContentType: "list"
        });
        const handleExpandCollapseAllItems = (0, $5uXOq.useCallback)((operation)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseAll', {
                operation: operation
            });
            if (operation === 'collapse') collapseAllItems();
            else if (operation === 'expand') toggleExpandAllItems();
        }, [
            collapseAllItems,
            createAnalyticsEvent,
            toggleExpandAllItems
        ]);
        const searchBarLabelId = 'header-actions-search-field-label';
        const searchBar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), {
            id: searchBarLabelId
        }, formatMessage((0, (0, parcelRequire("i0CN8")).default).searchLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Mmyc")).SimpleSearchField), {
            placeholder: (0, (0, parcelRequire("i0CN8")).default).simpleSearch,
            view: "list",
            describedbyId: searchBarLabelId
        }));
        const addPeopleWithPresence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17X6Y")).default), {
            view: "list",
            isPresenceEnabledInContext: isPresenceEnabled,
            isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
            allowCustomFields: (0, (0, parcelRequire("4R6GH")).fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? hasFilterCustomFields : false,
            allowedAliasFieldId: (0, (0, parcelRequire("4R6GH")).fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? allowedAliasFieldId : undefined
        });
        const shareActionButton = isShareButtonEnabled && shareButton;
        const allowedFieldTypes = (0, $5uXOq.useMemo)(()=>isSoftwareFieldsEnabled ? new Set([
                ...(0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES),
                ...(0, (0, parcelRequire("gzkAf")).SOFTWARE_FIELD_TYPES)
            ]) : undefined, [
            isSoftwareFieldsEnabled
        ]);
        const filters = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("73w1P")).FilterDropdownListNudgeAsync), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5hI3W")).Filters), {
            view: "list",
            allowedFieldTypes: allowedFieldTypes,
            allowCustomFields: hasFilterCustomFields,
            allowedAliasFieldId: allowedAliasFieldId,
            hiddenQuickFilters: hiddenQuickFilters
        }));
        const groupByDropdown = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kALEJ")).default), null);
        const formatRulesBtn = (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Q7Myb")).FormatButton), null) : null;
        const fieldStatistics = (0, (0, parcelRequire("6s1PB")).expValEquals)('helios_list_view_experiment_m2', 'cohort', 'variation') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9WaRX")).default), null) : null;
        const visualRefeshEnabled = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2');
        const settingsMenu = visualRefeshEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dXCxS")).default), {
            hideDoneItems: Boolean(hideDoneItems),
            onChangeHideDoneItems: setHideDoneItems,
            onExpandCollapseAllItems: handleExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems
        });
        const moreMenu = visualRefeshEnabled && hasFeedbackButton || !visualRefeshEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aSUiK")).MoreDropdownListNudgeAsync), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("70g8n")).default), {
            hideDoneItems: Boolean(hideDoneItems),
            onChangeHideDoneItems: setHideDoneItems,
            onExpandCollapseAllItems: handleExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            hasFeedbackButton: hasFeedbackButton,
            projectType: projectType,
            hideItemsMenuOptions: visualRefeshEnabled
        })) : null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).ActionsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && filters), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).RightActionsWrapper), null, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && shareActionButton, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && filters, groupByDropdown, formatRulesBtn, fieldStatistics, settingsMenu, moreMenu));
    };
    var $9d4f608e0dc3b08b$export$2e2bcd8739ae039 = $9d4f608e0dc3b08b$export$223875819fd7cf93;
});
parcelRegister("lQFjJ", function(module, exports) {
    $parcel$export(module.exports, "ActionsWrapper", ()=>$31ed5059f3fb9550$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "ActionsWrapperStyled", ()=>$31ed5059f3fb9550$export$ac9cdc71f29d2899);
    $parcel$export(module.exports, "LeftActionsWrapper", ()=>$31ed5059f3fb9550$export$42cb1c7ab389bf4d);
    $parcel$export(module.exports, "RightActionsWrapper", ()=>$31ed5059f3fb9550$export$4aa2cd250ec24dcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dCm1o;
    var $bUSNl;
    const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
        const [{ content: content }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
            sidebarOpen: !!content,
            "data-testid": testId,
            isVisualRefreshEnabledFG: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, children);
    };
    const $31ed5059f3fb9550$var$CenterAlignedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10qff79": (0, (0, parcelRequire("lD23V")).default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1ylp _18s8l1uc _1n261g80 _bfhk1iew _18k9ad7r",
                __cmplp.isVisualRefreshEnabledFG ? "_1yt41big" : "_1yt46hdp",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;
});
parcelRegister("Q7Myb", function(module, exports) {
    $parcel$export(module.exports, "FormatButton", ()=>$0c73312955acd57c$export$4ce756b69a643bb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $ciYaM;
    var $dRNbD;
    var $imZsD;
    var $5Fk4Z;
    var $daQYX;
    var $cm8b5;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $4R6GH;
    var $koVbs;
    var $7mPT9;
    var $22OQR;
    var $koeKL;
    var $dCm1o;
    var $8iVnX;
    var $hug5L;
    var $eTGH6;
    var $7HvuF;
    var $dkq9p;
    var $9Unx5;
    var $hgUKb;
    const $0c73312955acd57c$export$4ce756b69a643bb2 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [hydrateJql] = (0, (0, parcelRequire("hug5L")).useFormatRulesSerialisedJql)();
        const formatButtonRef = (0, $5uXOq.useRef)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("dkq9p")).formatRulesEntryPoint), {
            projectKey: projectData.key,
            cloudId: cloudId,
            hydrateJql: hydrateJql
        });
        const buttonTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
                experience: (0, (0, parcelRequire("8iVnX")).LIST_FORMAT_RULE_EXPERIENCE),
                error: error
            }), []);
        const { onClickFormatButton: onClickFormatButton, isFormatRulesSidebarOpen: isFormatRulesSidebarOpen } = (0, (0, parcelRequire("eTGH6")).useFormatRulesSidebar)({
            SidebarComponent: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "jwm.business.format.rules",
                    packageName: "jiraBusinessFormatRules",
                    runtimeProps: props,
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Unx5")).SidebarFallback), null),
                    errorFallback: errorFallback
                }),
            projectId: String(projectData.id),
            formatButtonRef: formatButtonRef
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "format-rule-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            onClick: ()=>onClickFormatButton({
                    showOnboarding: false
                }),
            iconBefore: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ciYaM"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dRNbD"))))), {
                label: "",
                size: "medium"
            }),
            isSelected: isFormatRulesSidebarOpen,
            "aria-label": (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? formatMessage((0, (0, parcelRequire("7HvuF")).default).formatRulesTooltip) : formatMessage((0, (0, parcelRequire("7HvuF")).default).format) : undefined,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'default' : 'subtle',
            ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(buttonTriggerRef, formatButtonRef),
            testId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.themed-button",
            title: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? formatMessage((0, (0, parcelRequire("7HvuF")).default).formatRulesTooltip) : undefined
        }, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && formatMessage((0, (0, parcelRequire("7HvuF")).default).format))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgUKb")).Onboarding), {
            ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(buttonTriggerRef, formatButtonRef),
            onClickFormatButton: onClickFormatButton
        }));
    };
});
parcelRegister("ciYaM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8f55d7939f8010e4$var$_react = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8f55d7939f8010e4$var$_UNSAFE_baseNew = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8f55d7939f8010e4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8f55d7939f8010e4$var$PaintBucketIcon = (props)=>$8f55d7939f8010e4$var$_react.default.createElement($8f55d7939f8010e4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 2.25 1.134 7.866a1.25 1.25 0 0 0 0 1.768l4.732 4.732a1.25 1.25 0 0 0 1.768 0L13.25 8.75zm0 0L5.125.625M1.25 8.75h11m3 5.75a.75.75 0 0 1-1.5 0c0-.414.75-1.75.75-1.75s.75 1.336.75 1.75Z"/>`
        }, props));
    $8f55d7939f8010e4$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
    var $8f55d7939f8010e4$var$_default = module.exports.default = $8f55d7939f8010e4$var$PaintBucketIcon;
});
parcelRegister("dRNbD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a186610b26bee8b1$var$_react = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a186610b26bee8b1$var$_paintBucket = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("ciYaM")));
    function $a186610b26bee8b1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a186610b26bee8b1$var$EditorBackgroundColorIcon = (props)=>$a186610b26bee8b1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
        }, props, {
            newIcon: $a186610b26bee8b1$var$_paintBucket.default
        }));
    $a186610b26bee8b1$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
    var $a186610b26bee8b1$var$_default = module.exports.default = $a186610b26bee8b1$var$EditorBackgroundColorIcon;
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("8iVnX", function(module, exports) {
    $parcel$export(module.exports, "MAX_RULES_FETCHED", ()=>$1cd48cac4950abc6$export$6e645d821ccb2e78);
    $parcel$export(module.exports, "DATE_VALUES", ()=>$1cd48cac4950abc6$export$42247ee7424a5edb);
    $parcel$export(module.exports, "DATE_PICKER_OPERATORS", ()=>$1cd48cac4950abc6$export$5a5ebc5948b83a8a);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$1cd48cac4950abc6$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$1cd48cac4950abc6$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "CREATE_FORMAT_RULE_EXPERIENCE", ()=>$1cd48cac4950abc6$export$fa13d8a70748751a);
    $parcel$export(module.exports, "LIST_FORMAT_RULE_EXPERIENCE", ()=>$1cd48cac4950abc6$export$a81756a20f687e60);
    $parcel$export(module.exports, "DELETE_FORMAT_RULE_EXPERIENCE", ()=>$1cd48cac4950abc6$export$aec4d62b875e16db);
    $parcel$export(module.exports, "UPDATE_FORMAT_RULE_EXPERIENCE", ()=>$1cd48cac4950abc6$export$3f6ab32e23b3d013);
    $parcel$export(module.exports, "SORT_FORMAT_RULE_EXPERIENCE", ()=>$1cd48cac4950abc6$export$2f9cc81b0092d33b);
    $parcel$export(module.exports, "HELP_ARTICLE", ()=>$1cd48cac4950abc6$export$5b1d06b602bd68c5);
    var $42ioY;
    const $1cd48cac4950abc6$export$6e645d821ccb2e78 = 20;
    const $1cd48cac4950abc6$export$42247ee7424a5edb = (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS);
    const $1cd48cac4950abc6$export$5a5ebc5948b83a8a = [
        (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).EXACT_DATE
    ];
    const $1cd48cac4950abc6$export$b8b9d90f9e5bd72b = 'jiraBusinessFormatRule';
    const $1cd48cac4950abc6$export$d57b6b390e78d90f = 'keystone';
    const $1cd48cac4950abc6$export$fa13d8a70748751a = {
        experience: 'createFormatRule',
        packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
        teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
    };
    const $1cd48cac4950abc6$export$a81756a20f687e60 = {
        experience: 'listFormatRule',
        packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
        teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
    };
    const $1cd48cac4950abc6$export$aec4d62b875e16db = {
        experience: 'deleteFormatRule',
        packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
        teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
    };
    const $1cd48cac4950abc6$export$3f6ab32e23b3d013 = {
        experience: 'updateFormatRule',
        packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
        teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
    };
    const $1cd48cac4950abc6$export$2f9cc81b0092d33b = {
        experience: 'sortFormatRule',
        packageName: $1cd48cac4950abc6$export$b8b9d90f9e5bd72b,
        teamName: $1cd48cac4950abc6$export$d57b6b390e78d90f
    };
    const $1cd48cac4950abc6$export$5b1d06b602bd68c5 = {
        helpArticleId: '7afzXgtL4UauMCJZ3IxTTH',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-format-rules/'
    };
});
parcelRegister("42ioY", function(module, exports) {
    $parcel$export(module.exports, "DATE_VALUE_OPERATORS", ()=>$d9db4359c930d400$export$6a2fdc772d1c71fb);
    const $d9db4359c930d400$export$6a2fdc772d1c71fb = {
        EXACT_DATE: 'EXACT_DATE',
        TODAY: 'TODAY',
        TOMORROW: 'TOMORROW',
        YESTERDAY: 'YESTERDAY',
        THIS_WEEK: 'THIS_WEEK',
        LAST_WEEK: 'LAST_WEEK',
        NEXT_WEEK: 'NEXT_WEEK',
        THIS_QUARTER: 'THIS_QUARTER',
        LAST_QUARTER: 'LAST_QUARTER',
        NEXT_QUARTER: 'NEXT_QUARTER',
        THIS_YEAR: 'THIS_YEAR',
        LAST_YEAR: 'LAST_YEAR',
        NEXT_YEAR: 'NEXT_YEAR'
    };
});
parcelRegister("eTGH6", function(module, exports) {
    $parcel$export(module.exports, "useFormatRulesSidebar", ()=>$36f7a848a98dec9a$export$5bcab55a2e93dc2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $hE5wF;
    var $cm8b5;
    var $8zOmE;
    var $2NMNM;
    var $ieDtd;
    var $8iVnX;
    const $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY = 'formatRulesSidebar';
    const $36f7a848a98dec9a$export$5bcab55a2e93dc2d = ({ projectId: projectId, SidebarComponent: SidebarComponent, formatButtonRef: formatButtonRef })=>{
        const [, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isFormatRulesSidebarOpen = (0, $5uXOq.useMemo)(()=>content?.key === $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY, [
            content
        ]);
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("8iVnX")).LIST_FORMAT_RULE_EXPERIENCE));
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesCloseButton');
            setSidebarContent(null);
            formatButtonRef?.current?.focus();
        }, [
            createAnalyticsEvent,
            formatButtonRef,
            setSidebarContent
        ]);
        const onClickFormatButton = (0, $5uXOq.useCallback)(({ showOnboarding: showOnboarding })=>{
            if (isFormatRulesSidebarOpen) onCloseSidebar();
            else {
                setSelectedIssueKey(undefined);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'formatRulesSidebarButton');
                startExperience();
                setSidebarContent((0, ($parcel$interopDefault($5uXOq))).createElement(SidebarComponent, {
                    key: $36f7a848a98dec9a$var$FORMAT_SIDEBAR_SIDEBAR_CONTENT_KEY,
                    onCloseSidebar: onCloseSidebar,
                    projectId: projectId,
                    showOnboarding: showOnboarding
                }));
            }
        }, [
            isFormatRulesSidebarOpen,
            onCloseSidebar,
            setSelectedIssueKey,
            createAnalyticsEvent,
            startExperience,
            setSidebarContent,
            SidebarComponent,
            projectId
        ]);
        return {
            onClickFormatButton: onClickFormatButton,
            isFormatRulesSidebarOpen: isFormatRulesSidebarOpen
        };
    };
});
parcelRegister("7HvuF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ca7955f4716097e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0ca7955f4716097e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        format: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.format",
            "defaultMessage": "Format"
        },
        formatRulesTooltip: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.format-rules-tooltip",
            "defaultMessage": "Format rules"
        }
    });
});
parcelRegister("dkq9p", function(module, exports) {
    $parcel$export(module.exports, "formatRulesEntryPoint", ()=>$921d0df9c4a9863b$export$a812fb5060f92ae9);
    var $576dU;
    var $lO1QX;
    var $eufEc;
    var $fEDBv;
    const $921d0df9c4a9863b$export$a812fb5060f92ae9 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("9rowz")), {
            moduleId: "b6770cbd"
        }),
        getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
                queries: {
                    listViewFormattingRulesQuery: {
                        parameters: (0, (0, parcelRequire("lO1QX")).default),
                        variables: {
                            projectKey: projectKey,
                            cloudId: cloudId,
                            first: 20
                        },
                        options: {
                            fetchPolicy: 'store-or-network'
                        }
                    },
                    listViewFormattingRulesHydrateJqlQuery: {
                        parameters: (0, (0, parcelRequire("576dU")).default),
                        variables: {
                            cloudId: cloudId,
                            jql: hydrateJql
                        },
                        options: {
                            fetchPolicy: 'store-or-network'
                        }
                    }
                }
            })
    });
});
parcelRegister("576dU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29b8f0a12b567a40$export$2e2bcd8739ae039);
    const $29b8f0a12b567a40$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v3 = [
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "jql"
            }
        ], v4 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v5 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v6 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v7 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = [
            v8
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "list_hydrateJql_Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v3,
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "fieldValueData_businessConditionalFormattingSidebar"
                                                            }
                                                        ],
                                                        "type": "JiraJqlHydratedQuery"
                                                    },
                                                    v4
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jqlBuilder.hydrateJqlQuery"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "list_hydrateJql_Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v3,
                                        "kind": "LinkedField",
                                        "name": "hydrateJqlQuery",
                                        "plural": false,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": true,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraJqlField",
                                                                        "kind": "LinkedField",
                                                                        "name": "field",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            v7,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "type"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "values",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v5,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "values",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5,
                                                                                            v6,
                                                                                            v7,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v5,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "accountId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlUserFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraPriority",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "priority",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "priorityId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlPriorityFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraSprint",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "sprint",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "sprintId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlSprintFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraGroup",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "group",
                                                                                                        "plural": false,
                                                                                                        "selections": v9
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlGroupFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraStatus",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "status",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "statusId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlStatusFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraProject",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "project",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "projectId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlProjectFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueType",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "issueTypes",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "issueTypeId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraVersion",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "version",
                                                                                                        "plural": false,
                                                                                                        "selections": v9
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlVersionFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraComponent",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "component",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "componentId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlComponentFieldValue"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraOption",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "option",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "optionId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraJqlOptionFieldValue"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraJqlQueryHydratedValue"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlQueryHydratedField"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlHydratedQuery"
                                            },
                                            v4
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0da32c6286953e253b4c87ac4dae3561c26afba277b98f8c19bb3efa09e88e83",
                "metadata": {},
                "name": "list_hydrateJql_Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $29b8f0a12b567a40$var$node.hash = "29ea070df4a573820b0818573b62d704";
    var $29b8f0a12b567a40$export$2e2bcd8739ae039 = $29b8f0a12b567a40$var$node;
});
parcelRegister("lO1QX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c158b5869b83a61f$export$2e2bcd8739ae039);
    const $c158b5869b83a61f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v4 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v7 = [
            v6
        ], v8 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "list_RuleList_Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v4,
                                                "concreteType": "JiraFormattingRuleConnection",
                                                "kind": "LinkedField",
                                                "name": "conditionalFormattingRules",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFormattingRuleEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraFormattingRule",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "expression",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "JiraFormattingMultipleValueOperand"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "JiraFormattingSingleValueOperand"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "JiraFormattingNoValueOperand"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "ruleItem_businessConditionalFormattingSidebar"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v8
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "list_RuleList_Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4,
                                        "concreteType": "JiraFormattingRuleConnection",
                                        "kind": "LinkedField",
                                        "name": "conditionalFormattingRules",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFormattingRuleEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFormattingRule",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "expression",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "alias": "multipleValueOperator",
                                                                                "kind": "ScalarField",
                                                                                "name": "operator"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "values"
                                                                            }
                                                                        ],
                                                                        "type": "JiraFormattingMultipleValueOperand"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "alias": "singleValueOperator",
                                                                                "kind": "ScalarField",
                                                                                "name": "operator"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "value"
                                                                            }
                                                                        ],
                                                                        "type": "JiraFormattingSingleValueOperand"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "alias": "noValueOperator",
                                                                                "kind": "ScalarField",
                                                                                "name": "operator"
                                                                            }
                                                                        ],
                                                                        "type": "JiraFormattingNoValueOperand"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraColor",
                                                                "kind": "LinkedField",
                                                                "name": "formattingColor",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "colorKey"
                                                                    },
                                                                    v5
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "formattingArea"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v8
                                        ]
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0",
                "metadata": {},
                "name": "list_RuleList_Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c158b5869b83a61f$var$node.hash = "bec8fc4cc19c330e28e463dc69485d6f";
    var $c158b5869b83a61f$export$2e2bcd8739ae039 = $c158b5869b83a61f$var$node;
});
parcelRegister("9rowz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3UQsv")
    ]).then(()=>parcelRequire('dMDrl'));
});
parcelRegister("9Unx5", function(module, exports) {
    $parcel$export(module.exports, "ListFallback", ()=>$5e6ab21bf2ceafb8$export$a207fef8aae38be9);
    $parcel$export(module.exports, "SidebarFallback", ()=>$5e6ab21bf2ceafb8$export$289c886cdbc6d1e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $dC5iT;
    var $8CUq3;
    const $5e6ab21bf2ceafb8$export$a207fef8aae38be9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            hasIcon: true,
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            isShimmering: true,
            width: "120px"
        }));
    const $5e6ab21bf2ceafb8$export$289c886cdbc6d1e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5e6ab21bf2ceafb8$var$containerStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            isShimmering: true,
            width: "120px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            isShimmering: true,
            width: "100%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($5e6ab21bf2ceafb8$export$a207fef8aae38be9, null)));
    const $5e6ab21bf2ceafb8$var$containerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.250'
    });
});
parcelRegister("hgUKb", function(module, exports) {
    $parcel$export(module.exports, "Onboarding", ()=>$653c3dd67cf5534e$export$70238cd3868b67c9);
    $parcel$export(module.exports, "SidebarOnboarding", ()=>$653c3dd67cf5534e$export$d4bff02b549bd7de);
    var $5uXOq = parcelRequire("5uXOq");
    var $kbqIt;
    var $1QiBP;
    var $kgoHi;
    var $8CUq3;
    var $ioD1B;
    var $eGLgs;
    var $koVbs;
    var $ehdJY;
    var $koeKL;
    var $2tT7R;
    var $cHrcY = parcelRequire("cHrcY");
    var $2ccxh;
    const $653c3dd67cf5534e$export$53e766134521dfd3 = 'STG-EXT-1441';
    const $653c3dd67cf5534e$export$5cbe8adda16e7b01 = 'jira-list-view-format-rules-onboarding';
    const $653c3dd67cf5534e$var$ENV_STAGING = 'staging';
    const $653c3dd67cf5534e$var$STARGATE_URL = '/gateway/api';
    const $653c3dd67cf5534e$export$70238cd3868b67c9 = (0, $5uXOq.forwardRef)(({ onClickFormatButton: onClickFormatButton }, ref)=>{
        const ONBOARDING_ENGAGEMENT_ID = (0, (0, parcelRequire("2tT7R")).useEnvironment)() === $653c3dd67cf5534e$var$ENV_STAGING ? $653c3dd67cf5534e$export$53e766134521dfd3 : $653c3dd67cf5534e$export$5cbe8adda16e7b01;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, $653c3dd67cf5534e$var$STARGATE_URL, false, '', 'engagement'), [
            cloudId
        ]);
        const [isEnrolled, stopEnrolment] = (0, (0, parcelRequire("kbqIt")).useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
        const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (isEnrolled) stopEnrolment(false);
        }, [
            isEnrolled,
            stopEnrolment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: coordinationClient.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, isEnrolled && isSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.format-rule-button",
            messageType: "engagement",
            image: (0, ($parcel$interopDefault($cHrcY))),
            actionsBeforeElement: "1/3",
            actions: [
                {
                    onClick: ()=>{
                        setIsSpotlightActive(false);
                        onClickFormatButton({
                            showOnboarding: true
                        });
                    },
                    text: formatMessage((0, (0, parcelRequire("2ccxh")).default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>setIsSpotlightActive(false),
                    text: formatMessage((0, (0, parcelRequire("2ccxh")).default).dismiss)
                }
            ],
            dialogWidth: 320,
            heading: formatMessage((0, (0, parcelRequire("2ccxh")).default).onboardingHeading),
            target: "format-rule-button",
            key: "format-rule-button",
            targetRadius: 3,
            footer: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                    ref: ref,
                    alignItems: "center",
                    justifyContent: "space-between",
                    xcss: $653c3dd67cf5534e$var$footerContainerStyle
                }, children)
        }, formatMessage((0, (0, parcelRequire("2ccxh")).default).onboardingDescription))));
    });
    const $653c3dd67cf5534e$export$d4bff02b549bd7de = ({ showOnboarding: showOnboarding })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
        const next = ()=>setActiveSpotlight((activeSpotlight || 0) + 1);
        const end = ()=>setActiveSpotlight(null);
        (0, $5uXOq.useEffect)(()=>{
            if (showOnboarding) setTimeout(()=>{
                setActiveSpotlight(0);
            }, 100);
        }, [
            showOnboarding
        ]);
        const renderActiveSpotlight = ()=>{
            const spotlights = [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
                    messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.create-rule-form",
                    messageType: "engagement",
                    actionsBeforeElement: "2/3",
                    actions: [
                        {
                            onClick: next,
                            text: 'Next'
                        },
                        {
                            appearance: 'subtle',
                            onClick: end,
                            text: formatMessage((0, (0, parcelRequire("2ccxh")).default).dismiss)
                        }
                    ],
                    dialogWidth: 280,
                    target: "create-rule-form",
                    key: "create-rule-form",
                    targetRadius: 3
                }, formatMessage((0, (0, parcelRequire("2ccxh")).default).createRuleOnboarding)),
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
                    messageId: "business-conditional-formatting-sidebar.ui.format-rules-sidebar.sidebar.onboarding.jira-spotlight.drag-rule-form",
                    messageType: "engagement",
                    actionsBeforeElement: "3/3",
                    actions: [
                        {
                            onClick: end,
                            text: formatMessage((0, (0, parcelRequire("2ccxh")).default).done)
                        }
                    ],
                    dialogWidth: 280,
                    target: "drag-rule-form",
                    key: "drag-rule-form",
                    targetRadius: 3
                }, formatMessage((0, (0, parcelRequire("2ccxh")).default).rulesOrderOnboarding))
            ];
            if (activeSpotlight === null) return null;
            return spotlights[activeSpotlight];
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, renderActiveSpotlight());
    };
    const $653c3dd67cf5534e$var$footerContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.050'
    });
});
parcelRegister("cHrcY", function(module, exports) {
    module.exports = new URL("onboarding.d274e357.svg", import.meta.url).toString();
});
parcelRegister("2ccxh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6516f853326487b4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6516f853326487b4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        onboardingHeading: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
            "defaultMessage": "Highlight important work with color"
        },
        onboardingDescription: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
            "defaultMessage": "Create a format rule to quickly view work that needs attention. Only you\u2019ll be able to view the rules you create or edit."
        },
        next: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
            "defaultMessage": "Next"
        },
        createRuleOnboarding: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.create-rule-onboarding",
            "defaultMessage": "For example, you could create a rule that formats rows red when the due date is before today."
        },
        rulesOrderOnboarding: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
            "defaultMessage": "If you have multiple rules that apply to the same cell, the rule at the top takes precedence. Drag rules up or down to reorder them."
        },
        done: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
            "defaultMessage": "Done"
        },
        dismiss: {
            "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("5hI3W", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$afeed5d78bb3bf98$export$92a576f896a9bf72);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $l8ruj;
    var $lM9c1;
    var $1TU9r;
    var $gxGcZ;
    var $dpQnO;
    var $ab4a1;
    var $6xNkv;
    const $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault = [
        'ACTIVE_SPRINTS'
    ];
    const $afeed5d78bb3bf98$export$92a576f896a9bf72 = (0, $5uXOq.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const allowedFieldTypes = (0, (0, parcelRequire("gxGcZ")).useAllowedFieldTypes)(inputAllowedFieldTypes);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const close = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const toggle = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((prevIsOpen)=>!prevIsOpen);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
        }, [
            createAnalyticsEvent
        ]);
        const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, (0, parcelRequire("1TU9r")).useDeserialiseJqlFiltersWithContext)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
        (0, $5uXOq.useEffect)(()=>{
            if (handleHasFiltersApplied) handleHasFiltersApplied(count);
        }, [
            count,
            handleHasFiltersApplied
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')) (0, (0, parcelRequire("lM9c1")).useGoalsFilterAnalyticsEvent)({
            filters: filters,
            view: view
        });
        const hasFiltersApplied = count > 0 || hasFilterError;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: close,
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab4a1")).MenuContent), {
                    "data-testid": "business-filters.ui.filters.menu-content",
                    count: count,
                    fieldConfig: fieldConfig,
                    filters: filters,
                    quickFilters: quickFilters,
                    setQuickFilters: setQuickFilters,
                    setFilters: setFilters,
                    hiddenQuickFilters: hiddenQuickFilters,
                    view: view,
                    allowCustomFields: allowCustomFields,
                    allowSavedFilters: allowSavedFilters,
                    hasFilterError: hasFilterError
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xNkv")).Trigger), {
                    ...triggerProps,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') && {
                        appearance: appearance
                    },
                    count: count,
                    hasFiltersApplied: hasFiltersApplied,
                    isSelected: isOpen,
                    onClick: toggle
                })
        }), customFieldsLoader));
    });
});
parcelRegister("lM9c1", function(module, exports) {
    $parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", ()=>$a083b46fb378eaf3$export$c9b2aef46b42c898);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $8DJTW;
    const $a083b46fb378eaf3$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { data: filterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const goalField = (0, $5uXOq.useMemo)(()=>filterFields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)), [
            filterFields
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (goalField && filters[goalField.id]) {
                const goalsFilter = filters[goalField.id];
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                    source: view,
                    goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
                });
            }
        }, [
            createAnalyticsEvent,
            filters,
            goalField,
            view
        ]);
    };
});
parcelRegister("8DJTW", function(module, exports) {
    $parcel$export(module.exports, "useFilterFields", ()=>$058acf7f8802e33f$export$b2d30fa5478b571a);
    var $5uXOq = parcelRequire("5uXOq");
    var $g4ZHz;
    const $058acf7f8802e33f$export$b2d30fa5478b571a = ()=>{
        const { data: fields, loading: loading } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        const data = (0, $5uXOq.useMemo)(()=>fields?.map((field)=>({
                    id: field.jqlTerm,
                    name: field.displayName,
                    type: field.type
                })) ?? [], [
            fields
        ]);
        return {
            data: data,
            loading: loading,
            error: undefined
        };
    };
});
parcelRegister("1TU9r", function(module, exports) {
    $parcel$export(module.exports, "DeserialisedFiltersProvider", ()=>$fbaf3c30d9711dbc$export$c5640c1fbeb250b6);
    $parcel$export(module.exports, "useDeserialisedFilters", ()=>$fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7);
    $parcel$export(module.exports, "useDeserialiseJqlFilters", ()=>$fbaf3c30d9711dbc$export$eaa578dc219a620a);
    $parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", ()=>$fbaf3c30d9711dbc$export$87f52da20e747485);
    var $5uXOq = parcelRequire("5uXOq");
    var $g9ql5;
    var $8DJTW;
    var $17ot5;
    var $l4Ejo;
    var $dpQnO;
    var $2RV6Z;
    const $fbaf3c30d9711dbc$var$DEFAULT_VALUE = {
        filters: {}
    };
    const $fbaf3c30d9711dbc$var$DeserialisedFiltersContext = (0, $5uXOq.createContext)($fbaf3c30d9711dbc$var$DEFAULT_VALUE);
    const $fbaf3c30d9711dbc$export$c5640c1fbeb250b6 = ({ children: children })=>{
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const value = (0, $5uXOq.useMemo)(()=>({
                filters: filters,
                setFilters: setFilters,
                isLoading: isLoading,
                setIsLoading: setIsLoading
            }), [
            filters,
            isLoading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fbaf3c30d9711dbc$var$DeserialisedFiltersContext.Provider, {
            value: value
        }, children);
    };
    const $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7 = ()=>(0, $5uXOq.useContext)($fbaf3c30d9711dbc$var$DeserialisedFiltersContext);
    const $fbaf3c30d9711dbc$var$EMPTY_FILTER = {};
    const $fbaf3c30d9711dbc$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
        const { jql: jql, setFilter: setFilter } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, (0, parcelRequire("g9ql5")).useFieldConfigWithCustomFields)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [error, setError] = (0, $5uXOq.useState)(null);
        const hasFilterError = error != null;
        const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $5uXOq.useState)(false);
        const [filtersCache, setFiltersCache] = (0, $5uXOq.useState)({});
        const { data: filterFields, loading: isLoadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
            if (!Object.keys(fieldConfig).length) return;
            if (jql != null && filters === filtersCache[jql]) return;
            if (hasFilterError && jql != null) return;
            if (jql == null) {
                if (hasFilterError) setError(null);
                if (filters !== $fbaf3c30d9711dbc$var$EMPTY_FILTER) setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (quickFiltersJql !== null) {
                setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (filtersCache[jql]) {
                setFilters(filtersCache[jql]);
                return;
            }
            setIsDeserialisingFilters(true);
            (0, (0, parcelRequire("2RV6Z")).deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
                setFilters(result);
                setFiltersCache({
                    ...filtersCache,
                    [jql]: result
                });
            }).catch((e)=>{
                setError(e);
            }).finally(()=>{
                setIsDeserialisingFilters(false);
            });
        }, [
            hasFilterError,
            quickFiltersJql,
            error,
            filters,
            isLoadingFieldConfig,
            isLoadingFilterFields,
            fieldConfig,
            jql,
            filtersCache,
            filterFields,
            resolvers,
            isDeserialisingFilters
        ]);
        (0, (0, parcelRequire("17ot5")).useInferHideDoneItemsWithFilters)({
            filters: filters
        });
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilter,
            loading: isLoadingFieldConfig || isDeserialisingFilters
        };
    };
    const $fbaf3c30d9711dbc$export$87f52da20e747485 = (props)=>{
        const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $fbaf3c30d9711dbc$export$eaa578dc219a620a(props);
        const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
        (0, $5uXOq.useEffect)(()=>{
            if (setContextFilters) setContextFilters(filters);
        }, [
            filters,
            setContextFilters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (setIsLoadingFilters) setIsLoadingFilters(loading);
        }, [
            loading,
            setIsLoadingFilters
        ]);
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilters
        };
    };
});
parcelRegister("g9ql5", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigWithCustomFields", ()=>$937abfae1d89db7d$export$9f6dc7e3584916fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    var $5FlVd;
    var $RjSi3;
    var $cLe9v;
    const $937abfae1d89db7d$var$emptySet = new Set();
    const $937abfae1d89db7d$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
        const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, (0, parcelRequire("cLe9v")).useFieldConfig)({
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId
        });
        (0, $5uXOq.useEffect)(()=>{
            setFieldConfig({
                fieldConfig: fieldConfig,
                resolvers: resolvers,
                loading: loading
            });
        }, [
            fieldConfig,
            resolvers,
            loading,
            setFieldConfig
        ]);
        return null;
    };
    const $937abfae1d89db7d$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
        const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $5uXOq.useMemo)(()=>{
            const newTypes = new Set(allowedFieldTypes);
            const oldTypes = new Set();
            (0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
                if (allowedFieldTypes.has(type)) {
                    newTypes.delete(type);
                    oldTypes.add(type);
                }
            });
            return [
                newTypes,
                oldTypes
            ];
        }, [
            allowedFieldTypes
        ]);
        const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
        const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
        const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
        const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, (0, parcelRequire("RjSi3")).useFieldConfigV2)({
            view: view,
            allowedFieldTypes: newAllowedFieldTypes
        });
        const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $5uXOq.useState)({
            fieldConfig: {},
            resolvers: {},
            loading: shouldLoadOldFieldConfig
        });
        const customFieldsLoader = (0, $5uXOq.useMemo)(()=>{
            if (!shouldLoadOldFieldConfig) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($937abfae1d89db7d$var$CustomFieldsLoader, {
                allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $937abfae1d89db7d$var$emptySet,
                allowedAliasFieldId: allowedAliasFieldId,
                setFieldConfig: setFieldConfig
            });
        }, [
            allowCustomFields,
            allowedAliasFieldId,
            oldAllowedFieldTypes,
            shouldLoadOldFieldConfig
        ]);
        const { fetchUsers: fetchUsers } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes
        });
        const fieldConfig = (0, $5uXOq.useMemo)(()=>{
            const aliasFields = {};
            const otherFields = {};
            Object.keys(fieldConfigOld).forEach((id)=>{
                if (fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).USER_CF_TYPE)) fieldConfigOld[id] = {
                    ...fieldConfigOld[id],
                    loadOptions: fetchUsers
                };
                if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
                else otherFields[id] = fieldConfigOld[id];
            });
            return {
                ...otherFields,
                ...fieldConfigNew,
                ...aliasFields
            };
        }, [
            fieldConfigOld,
            fieldConfigNew,
            fetchUsers
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: {
                ...resolversOld,
                ...resolversNew
            },
            customFieldsLoader: customFieldsLoader,
            loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
        };
    };
});
parcelRegister("5FlVd", function(module, exports) {
    $parcel$export(module.exports, "useFetchFieldValues", ()=>$b6820483a00ce3be$export$6cb851ed13e3949e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $hE5wF;
    var $5YBrl;
    var $jlq4V;
    var $4R6GH;
    var $eusud;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $b4fG8;
    var $34JdM;
    var $czmU8;
    var $84pWT;
    var $ldL1T;
    const $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50;
    const $b6820483a00ce3be$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
    const $b6820483a00ce3be$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$a48313dd44fc9855),
                    variables: {
                        cloudId: cloudId,
                        first: $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                        jql: jqlContext,
                        shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE))),
                        shouldFetchSoftwareFields: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE))),
                        shouldFetchParentField: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')),
                        shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')),
                        goalsJqlTerm: goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? goalsJqlTerm : '',
                        sprintsJqlContext: allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) ? `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}` : undefined
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            const hydratedValues = jqlURLParam ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParam) : null;
            const transformedInitialData = (0, (0, parcelRequire("ldL1T")).transformInitialData)(response.data);
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                return (0, (0, parcelRequire("84pWT")).mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
            }
            return transformedInitialData;
        } catch (err) {
            (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
        }
        return null;
    };
    const $b6820483a00ce3be$var$memoizedFetchInitialData = (0, (0, parcelRequire("8QpSo")).default)($b6820483a00ce3be$var$fetchInitialDataInternal);
    const $b6820483a00ce3be$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, (0, parcelRequire("34JdM")).EMPTY_TEAMS));
    const $b6820483a00ce3be$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const goalsJqlTerm = (0, (0, parcelRequire("ldL1T")).useGoalsJqlTerm)(filterFields);
        let fetchTeamsService = $b6820483a00ce3be$var$fetchTeamsServiceFnc;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) fetchTeamsService = (0, (0, parcelRequire("34JdM")).useFetchTeams)();
        const fetchInitialData = (0, $5uXOq.useCallback)(async ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
                $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
                fetchTeamsService({
                    first: $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS
                })
            ]).then((values)=>{
                let result = (0, (0, parcelRequire("b4fG8")).EMPTY_TRANSFORMED_DATA);
                values.forEach((value)=>{
                    result = {
                        ...result,
                        ...value
                    };
                });
                return result;
            });
            return $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
        }, [
            allowedFieldTypes,
            cloudId,
            fetchTeamsService,
            goalsJqlTerm,
            jqlContext
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$f8e8a5f34f6ea725),
                    variables: {
                        cloudId: cloudId,
                        first: first,
                        jqlTerm: fieldName,
                        jql: jqlContextProp ?? jqlContext,
                        searchString: query,
                        after: afterCursor
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return response.data.jira.jqlBuilder.fieldValues;
        }, [
            cloudId,
            jqlContext
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'labels',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchComponents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'component',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchPriorities = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'priority',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'assignee',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformUsers)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchIssueTypes = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'issuetype',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                let options = (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(fieldValuesData);
                if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: options
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            view
        ]);
        const fetchStatuses = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'status',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchCategories = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS })=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                    body: JSON.stringify({
                        query: (0, $c4148dc6c1f759d4$export$562e34ec948f373d),
                        variables: {
                            first: first,
                            jql: jqlContext,
                            searchQuery: query,
                            after: afterCursor
                        }
                    })
                });
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
                return {
                    totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformCategories)(response.data.jira.jwmCategoryOptions)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            jqlContext
        ]);
        const fetchSprints = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'sprint',
                    query: query,
                    first: first,
                    afterCursor: afterCursor,
                    jqlContext: `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}`
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformSprints)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            jqlContext
        ]);
        const fetchFixVersions = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'fixVersion',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchParents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'parent',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformParent)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchGoals = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            if (!goalsJqlTerm) return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
            try {
                const fieldValuesData = await fetchData({
                    fieldName: goalsJqlTerm,
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformGoals)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            goalsJqlTerm
        ]);
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchTeamsService({
                    query: query,
                    first: first,
                    after: afterCursor
                });
                return fieldValuesData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE];
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchTeamsService
        ]);
        return {
            fetchInitialData: fetchInitialData,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchPriorities: fetchPriorities,
            fetchUsers: fetchUsers,
            fetchIssueTypes: fetchIssueTypes,
            fetchStatuses: fetchStatuses,
            fetchCategories: fetchCategories,
            fetchSprints: fetchSprints,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                fetchFixVersions: fetchFixVersions,
                fetchParents: fetchParents,
                fetchTeams: fetchTeams
            } : {},
            fetchGoals: fetchGoals
        };
    };
});
parcelRegister("b4fG8", function(module, exports) {
    $parcel$export(module.exports, "transformPriorities", ()=>$7c1a01ddd808f237$export$86ca92dec35c4797);
    $parcel$export(module.exports, "transformUsers", ()=>$7c1a01ddd808f237$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformIssueTypes", ()=>$7c1a01ddd808f237$export$4c05e2584b34e4d8);
    $parcel$export(module.exports, "transformStatuses", ()=>$7c1a01ddd808f237$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformCategories", ()=>$7c1a01ddd808f237$export$1b389c47cf1df04e);
    $parcel$export(module.exports, "transformDefaultField", ()=>$7c1a01ddd808f237$export$6133e08eeff30d5f);
    $parcel$export(module.exports, "transformSprints", ()=>$7c1a01ddd808f237$export$6a33be7fc7f04943);
    $parcel$export(module.exports, "transformGoals", ()=>$7c1a01ddd808f237$export$673d4fceed3e8383);
    $parcel$export(module.exports, "transformParent", ()=>$7c1a01ddd808f237$export$87e9766fb5100314);
    $parcel$export(module.exports, "transformTeams", ()=>$7c1a01ddd808f237$export$fd398a52d6f57b46);
    $parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", ()=>$7c1a01ddd808f237$export$ca9df9cab9cc134f);
    $parcel$export(module.exports, "transformValuesData", ()=>$7c1a01ddd808f237$export$8e327b5f9ebc175d);
    var $3JOCw = parcelRequire("3JOCw");
    var $5fc53;
    var $dCm1o;
    const $7c1a01ddd808f237$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
    const $7c1a01ddd808f237$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
    const $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
    const $7c1a01ddd808f237$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node.priority.iconUrl || ''
            }));
    const $7c1a01ddd808f237$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node?.user?.picture || ''
            }));
    const $7c1a01ddd808f237$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                id: $7c1a01ddd808f237$var$getFirstIssueTypeId(node),
                avatar: $7c1a01ddd808f237$var$getFirstIssueTypeAvatar(node) || '',
                square: true,
                hierarchyLevel: $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel(node) || 0
            }));
    const $7c1a01ddd808f237$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                categoryId: node.statusCategory.statusCategoryId
            }));
    const $7c1a01ddd808f237$export$1b389c47cf1df04e = (data)=>{
        const transformedCategories = data.edges.map((edge)=>({
                cursor: edge?.cursor,
                value: edge.node.option.value,
                label: edge.node.option.value,
                color: edge.node.color
            }));
        return (0, ($parcel$interopDefault($3JOCw)))(transformedCategories, ({ value: value })=>value);
    };
    const $7c1a01ddd808f237$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName
            }));
    const $7c1a01ddd808f237$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.displayName,
                label: node.sprint?.name || ''
            }));
    const $7c1a01ddd808f237$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.goal.name || '',
                status: node.goal.status || ''
            }));
    const $7c1a01ddd808f237$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
            let avatar = '';
            if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
            return {
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: avatar,
                ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                    square: true
                }
            };
        });
    const $7c1a01ddd808f237$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
                cursor: data.pageInfo?.endCursor,
                value: node.team.id.replace('ari:cloud:identity::team/', ''),
                label: node.team.displayName || '',
                avatar: node.team.smallAvatarImageUrl || ''
            }));
    const $7c1a01ddd808f237$var$isIssueType = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issueTypes' in node);
    };
    const $7c1a01ddd808f237$var$isPriority = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'priority' in node);
    };
    const $7c1a01ddd808f237$var$isStatus = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'statusCategory' in node);
    };
    const $7c1a01ddd808f237$var$isSprint = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'sprint' in node);
    };
    const $7c1a01ddd808f237$var$isGoal = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'goal' in node);
    };
    const $7c1a01ddd808f237$var$isParent = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issue' in node);
    };
    const $7c1a01ddd808f237$var$isUser = (fieldValue)=>true;
    const $7c1a01ddd808f237$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
    const $7c1a01ddd808f237$export$ca9df9cab9cc134f = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $7c1a01ddd808f237$export$8e327b5f9ebc175d = (data)=>{
        const transformedData = {
            ...$7c1a01ddd808f237$export$ca9df9cab9cc134f
        };
        Object.entries(data).forEach(([key, fieldValue])=>{
            if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
                case 'issuetype':
                    if ($7c1a01ddd808f237$var$isIssueType(fieldValue)) transformedData.issuetype = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$4c05e2584b34e4d8(fieldValue)
                    };
                    break;
                case 'priority':
                    if ($7c1a01ddd808f237$var$isPriority(fieldValue)) transformedData.priority = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$86ca92dec35c4797(fieldValue)
                    };
                    break;
                case 'status':
                    if ($7c1a01ddd808f237$var$isStatus(fieldValue)) transformedData.status = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$20a57a5ec025f2d(fieldValue)
                    };
                    break;
                case 'component':
                case 'components':
                case 'fixVersions':
                case 'labels':
                    if ($7c1a01ddd808f237$var$isDefaultField(fieldValue)) {
                        const transformedKey = key === 'component' ? (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) : key;
                        transformedData[transformedKey] = {
                            totalCount: fieldValue.totalCount,
                            options: $7c1a01ddd808f237$export$6133e08eeff30d5f(fieldValue)
                        };
                    }
                    break;
                case 'parent':
                    if ($7c1a01ddd808f237$var$isParent(fieldValue)) transformedData[key] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$87e9766fb5100314(fieldValue)
                    };
                    break;
                default:
                    if ($7c1a01ddd808f237$var$isSprint(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$6a33be7fc7f04943(fieldValue)
                    };
                    else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $7c1a01ddd808f237$var$isUser(fieldValue)) {
                        const usersData = $7c1a01ddd808f237$export$fb8c90bfc4beaa59(fieldValue);
                        const userOptions = (0, ($parcel$interopDefault($3JOCw)))([
                            ...usersData,
                            ...transformedData.users?.options ?? []
                        ], ({ value: value })=>value);
                        transformedData.users = {
                            totalCount: userOptions.length,
                            options: userOptions
                        };
                    } else if ($7c1a01ddd808f237$var$isGoal(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$673d4fceed3e8383(fieldValue)
                    };
            }
        });
        return transformedData;
    };
});
parcelRegister("34JdM", function(module, exports) {
    $parcel$export(module.exports, "EMPTY_TEAMS", ()=>$96faa576a82047b8$export$37430da53242c305);
    $parcel$export(module.exports, "useFetchTeams", ()=>$96faa576a82047b8$export$da1ab223b3f1410c);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $5fc53;
    var $14XJw;
    var $koeKL;
    var $b4fG8;
    const $96faa576a82047b8$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
    const $96faa576a82047b8$export$37430da53242c305 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $96faa576a82047b8$export$da1ab223b3f1410c = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query, first: first = $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
            if (orgId) try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                    body: JSON.stringify({
                        query: (0, $31f39d27d8739895$export$cbe5a6af25588495),
                        variables: {
                            orgId: $96faa576a82047b8$var$prependOrgIdAri(orgId),
                            cloudId: cloudId,
                            queryString: query,
                            first: first,
                            after: after
                        }
                    })
                });
                const options = (0, (0, parcelRequire("b4fG8")).transformTeams)(response.data.team.teamSearchV2) || [];
                const totalCount = options.length >= first ? first : options.length;
                return {
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                        totalCount: totalCount,
                        options: options
                    }
                };
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchTeams',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch team filter data'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return $96faa576a82047b8$export$37430da53242c305;
        }, [
            cloudId,
            orgId
        ]);
        return fetchTeams;
    };
});
const $31f39d27d8739895$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;
parcelRegister("czmU8", function(module, exports) {
    $parcel$export(module.exports, "hydrateFilterValues", ()=>$3268558672fc0eb1$export$b18eef22aaa99c21);
    var $8QpSo;
    var $c9Ur7;
    var $jlq4V;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    const $3268558672fc0eb1$export$3361e9be8093ddcc = (fields)=>{
        const hydratedValues = {};
        fields.forEach((hydratedField)=>{
            if (!hydratedField) return;
            const { field: field, values: values } = hydratedField;
            if (!field || !values) return;
            hydratedValues[field.jqlTerm] = {
                edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                        node: item
                    })),
                totalCount: 0
            };
        });
        return hydratedValues;
    };
    const $3268558672fc0eb1$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? (0, $d73ce8e52a931002$export$2bd792833522f1f1) : (0, $d73ce8e52a931002$export$e8b5e80812d4a604),
                    variables: {
                        cloudId: cloudId,
                        jql: jqlContext
                    }
                })
            });
            if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
                if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
                throw new Error('Failed to fetch on hydrateFilterValuesService');
            }
            return $3268558672fc0eb1$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'JWMHydrateFilterValues',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $3268558672fc0eb1$export$b18eef22aaa99c21 = (0, (0, parcelRequire("8QpSo")).default)($3268558672fc0eb1$export$7a89edfb546e2344);
});
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT}
`;
parcelRegister("84pWT", function(module, exports) {
    $parcel$export(module.exports, "transformHydratedValues", ()=>$b845ee1bf81ff96f$export$56282b201a60959e);
    $parcel$export(module.exports, "mergeHydratedValues", ()=>$b845ee1bf81ff96f$export$8f60413c08081990);
    var $3JOCw = parcelRequire("3JOCw");
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $b845ee1bf81ff96f$var$transformHydratedValuesOld = (data)=>{
        const transformedHydratedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        Object.keys(data).forEach((key)=>{
            if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
                case 'issuetype':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(data[key])
                    };
                    return;
                case 'priority':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(data[key])
                    };
                    return;
                case 'status':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(data[key])
                    };
                    return;
                case 'labels':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                case 'component':
                    transformedHydratedData.components = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                default:
                    if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                        totalCount: 0,
                        options: (0, ($parcel$interopDefault($3JOCw)))([
                            ...(0, (0, parcelRequire("b4fG8")).transformUsers)(data[key]),
                            ...transformedHydratedData.users?.options ?? []
                        ], ({ value: value })=>value)
                    };
                    else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformSprints)(data[key])
                    };
            }
        });
        return transformedHydratedData;
    };
    const $b845ee1bf81ff96f$export$56282b201a60959e = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return (0, (0, parcelRequire("b4fG8")).transformValuesData)(data);
        return $b845ee1bf81ff96f$var$transformHydratedValuesOld(data);
    };
    const $b845ee1bf81ff96f$export$8f60413c08081990 = (initialData, hydratedValues)=>({
            labels: {
                totalCount: initialData.labels.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.labels.options,
                    ...initialData.labels.options
                ], ({ value: value })=>value)
            },
            components: {
                totalCount: initialData.components.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.components.options,
                    ...initialData.components.options
                ], ({ value: value })=>value)
            },
            priority: {
                totalCount: initialData.priority.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.priority.options,
                    ...initialData.priority.options
                ], ({ value: value })=>value)
            },
            users: {
                totalCount: initialData.users.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.users.options,
                    ...initialData.users.options
                ], ({ value: value })=>value)
            },
            issuetype: {
                totalCount: initialData.issuetype.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.issuetype.options,
                    ...initialData.issuetype.options
                ], ({ value: value })=>value)
            },
            status: {
                totalCount: initialData.status.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.status.options,
                    ...initialData.status.options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE],
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options,
                    ...initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            }
        });
});
const $c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $c4148dc6c1f759d4$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
parcelRegister("ldL1T", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$6a7ee4f9267edb3b$export$93219b8691fe49a0);
    $parcel$export(module.exports, "fireFieldValuesErrorAnalytics", ()=>$6a7ee4f9267edb3b$export$c3c62a63250fc6f8);
    $parcel$export(module.exports, "useGoalsJqlTerm", ()=>$6a7ee4f9267edb3b$export$674eff5ec8403101);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $jcw0u;
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $6a7ee4f9267edb3b$var$transformInitialCategories = (data)=>{
        if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
            totalCount: data.jira.jwmCategoryOptions.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformCategories)(data.jira.jwmCategoryOptions)
        };
        return undefined;
    };
    const $6a7ee4f9267edb3b$var$transformInitialDataOld = (data)=>{
        const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
        const transformedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
            totalCount: components.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(components)
        };
        if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
            totalCount: issuetype.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(issuetype)
        };
        if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
            totalCount: priority.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(priority)
        };
        if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
            totalCount: labels.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(labels)
        };
        if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
            totalCount: status.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(status)
        };
        if (users?.edges != null && Array.isArray(users.edges)) {
            const usersData = (0, (0, parcelRequire("b4fG8")).transformUsers)(users);
            const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, (0, parcelRequire("b4fG8")).transformUsers)(recentlyUsedUsers) : null;
            transformedData.users = {
                totalCount: users.totalCount,
                options: recentlyUsedUsersData != null ? (0, ($parcel$interopDefault($3JOCw)))([
                    ...recentlyUsedUsersData,
                    ...usersData
                ], ({ value: value })=>value) : usersData
            };
        }
        const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
        if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
        if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
            options: (0, (0, parcelRequire("b4fG8")).transformSprints)(sprints),
            totalCount: sprints.totalCount
        };
        return transformedData;
    };
    const $6a7ee4f9267edb3b$export$93219b8691fe49a0 = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
            const transformedData = (0, (0, parcelRequire("b4fG8")).transformValuesData)(data.jira.jqlBuilder);
            const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
            if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
            return transformedData;
        }
        return $6a7ee4f9267edb3b$var$transformInitialDataOld(data);
    };
    const $6a7ee4f9267edb3b$export$c3c62a63250fc6f8 = (errorId, errorMessage, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: errorId,
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: errorMessage
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $6a7ee4f9267edb3b$export$674eff5ec8403101 = (filterFields)=>{
        const goalsJqlTerm = (0, $5uXOq.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE))?.id, [
            filterFields
        ]);
        return goalsJqlTerm;
    };
});
parcelRegister("RjSi3", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigV2", ()=>$95c9fbd80a67ba2b$export$c041141a7ef797c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $aJfd5;
    var $4R6GH;
    var $koVbs;
    var $5fc53;
    var $5FlVd;
    var $8DJTW;
    var $gxGcZ;
    var $1qi71;
    const $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA = {
        initialUsers: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialLabels: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialComponents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialPriorities: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialIssueTypes: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialStatuses: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialCategories: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialSprints: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialFixVersions: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialParents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialGoals: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialTeams: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA
    };
    const $95c9fbd80a67ba2b$var$initialState = {
        data: undefined,
        loadingData: true
    };
    const $95c9fbd80a67ba2b$var$reducer = (state, action)=>{
        switch(action.type){
            case 'init':
                return $95c9fbd80a67ba2b$var$initialState;
            case 'fetch-data-success':
                return {
                    ...state,
                    data: action.value,
                    loadingData: false
                };
            case 'fetch-data-error':
                return {
                    ...state,
                    data: $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA,
                    loadingData: false
                };
            default:
                return state;
        }
    };
    const $95c9fbd80a67ba2b$var$emptyFieldValue = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectFieldData = (0, (0, parcelRequire("gxGcZ")).useProjectFilter)();
        const { data: filterFields, loading: loadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const [{ data: data, loadingData: loadingData }, dispatch] = (0, $5uXOq.useReducer)($95c9fbd80a67ba2b$var$reducer, $95c9fbd80a67ba2b$var$initialState);
        const userResolver = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            filterFields: filterFields
        });
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const businessEntityId = entity.id;
        const initialiseDefaultData = (0, $5uXOq.useCallback)(()=>{
            fetchInitialData().then((initialData)=>{
                dispatch({
                    type: 'fetch-data-success',
                    value: {
                        initialUsers: initialData?.users ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialLabels: initialData?.labels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialComponents: initialData?.components ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialPriorities: initialData?.priority ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialIssueTypes: initialData?.issuetype ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialStatuses: initialData?.status ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialCategories: initialData?.[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialSprints: initialData?.[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                            initialFixVersions: initialData?.[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialParents: initialData?.[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialTeams: initialData?.[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                        } : {},
                        initialGoals: initialData?.[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                    }
                });
            }).catch(()=>{
                dispatch({
                    type: 'fetch-data-error'
                });
            });
        }, [
            fetchInitialData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!loadingFilterFields) {
                dispatch({
                    type: 'init'
                });
                initialiseDefaultData();
            }
        }, [
            initialiseDefaultData,
            loadingFilterFields,
            businessEntityId
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $5uXOq.useMemo)(()=>{
            const fieldOptionsData = {
                priority: data?.initialPriorities ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                issuetype: data?.initialIssueTypes ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                status: data?.initialStatuses ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                users: data?.initialUsers ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                labels: data?.initialLabels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                components: data?.initialComponents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: data?.initialCategories ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: data?.initialSprints ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                project: projectFieldData,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                    [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: data?.initialParents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                } : {},
                [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: data?.initialGoals ?? $95c9fbd80a67ba2b$var$emptyFieldValue
            };
            return (0, (0, parcelRequire("1qi71")).getFilterFieldConfigAndResolvers)({
                view: view,
                formatMessage: formatMessage,
                allFields: filterFields,
                allowedFieldTypes: allowedFieldTypes,
                fieldOptionsData: fieldOptionsData,
                fetchUsers: fetchUsers,
                fetchLabels: fetchLabels,
                fetchComponents: fetchComponents,
                fetchCategories: fetchCategories,
                ...fetchOptions,
                userResolver: userResolver.current
            });
        }, [
            data?.initialPriorities,
            data?.initialIssueTypes,
            data?.initialStatuses,
            data?.initialUsers,
            data?.initialLabels,
            data?.initialComponents,
            data?.initialCategories,
            data?.initialSprints,
            data?.initialFixVersions,
            data?.initialParents,
            data?.initialGoals,
            data?.initialTeams,
            projectFieldData,
            view,
            formatMessage,
            filterFields,
            allowedFieldTypes,
            fetchUsers,
            fetchLabels,
            fetchComponents,
            fetchCategories,
            fetchOptions
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingData || loadingFilterFields || data == null
        };
    };
});
parcelRegister("aJfd5", function(module, exports) {
    $parcel$export(module.exports, "UserResolver", ()=>$c1905445333aa67f$export$723df28d03868f02);
    var $dJl1T;
    var $7f4tk;
    class $c1905445333aa67f$export$723df28d03868f02 {
        constructor(){
            this.getUsersFromAccountId = (accountIds)=>{
                const recoveredFromCache = [];
                const missingFromCache = [];
                accountIds.forEach((accountId)=>{
                    const user = this.cache.get(accountId);
                    if (user) recoveredFromCache.push(user);
                    else missingFromCache.push(accountId);
                });
                if (missingFromCache.length === 0) return Promise.resolve(recoveredFromCache);
                return (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && response.values.forEach((user)=>{
                        if (user) this.cache.set(user.accountId, user);
                    })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
                });
            };
            this.cache = new Map();
        }
    }
});
parcelRegister("1qi71", function(module, exports) {
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$beea8d83023eb0fe$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $4R6GH;
    var $5fc53;
    var $dCm1o;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $j0h5m;
    const $beea8d83023eb0fe$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $beea8d83023eb0fe$var$getType = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
            case 0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).ProjectFilter;
            case 0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).GoalsSelectFilter;
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $beea8d83023eb0fe$var$getValues = (type, fieldOptionsData)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return fieldOptionsData.users;
            default:
                return fieldOptionsData[type];
        }
    };
    const $beea8d83023eb0fe$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$isCustomField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$beea8d83023eb0fe$export$fb8c90bfc4beaa59(response)));
    const $beea8d83023eb0fe$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("j0h5m")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter,
            fromLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).startDateLabel),
            toLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).dueDateLabel)
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id } = field;
            const fieldType = type ?? '';
            const fieldValues = $beea8d83023eb0fe$var$getValues(fieldType, fieldOptionsData);
            fieldConfig[id] = {
                label: name,
                type: $beea8d83023eb0fe$var$getType(fieldType),
                placeholder: formatMessage((0, (0, parcelRequire("j0h5m")).default).filterPlaceholder),
                options: fieldValues?.options || [],
                totalCount: fieldValues?.totalCount || 0,
                isCustomField: $beea8d83023eb0fe$var$isCustomField(fieldType),
                fieldConfigVersion: 2
            };
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) {
                let options = fieldValues?.options || [];
                if (view === 'board') {
                    options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                    fieldConfig[id].options = options;
                }
                if (fetchIssueTypes) {
                    fieldConfig[id].loadOptions = fetchIssueTypes;
                    fieldConfig[id].defaultOptions = options;
                }
            } else if ($beea8d83023eb0fe$var$isUserField(fieldType)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                resolvers[id] = $beea8d83023eb0fe$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noLabelsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noComponentsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noCategoriesLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).STATUS_TYPE) && fetchStatuses) {
                fieldConfig[id].loadOptions = fetchStatuses;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE) && fetchPriorities) {
                fieldConfig[id].loadOptions = fetchPriorities;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE) && fetchSprints) {
                fieldConfig[id].loadOptions = fetchSprints;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noSprintLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && fetchFixVersions && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchFixVersions;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noVersionLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE) && fetchParents && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchParents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noParentLabel),
                        isEmptyOption: true,
                        ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                            square: true
                        }
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE) && fetchGoals) {
                fieldConfig[id].loadOptions = fetchGoals;
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noGoalLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fetchTeams && fieldType === (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchTeams;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noTeamLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            }
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("gBF4Z", function(module, exports) {
    $parcel$export(module.exports, "FieldType", ()=>$8ecd5c1ebfc76de6$export$ed12481c953b8653);
    $parcel$export(module.exports, "isDateField", ()=>$8ecd5c1ebfc76de6$export$7d34c8548269835d);
    const $8ecd5c1ebfc76de6$export$ed12481c953b8653 = {
        AsyncSelectFilter: 'AsyncSelectFilter',
        AvatarSelectFilter: 'AvatarSelectFilter',
        AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
        PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
        LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
        PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
        LozengeSelectFilter: 'LozengeSelectFilter',
        PrioritySelectFilter: 'PrioritySelectFilter',
        CategorySelectFilter: 'CategorySelectFilter',
        GoalsSelectFilter: 'GoalsSelectFilter',
        PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
        NumberFilter: 'NumberFilter',
        SelectFilter: 'SelectFilter',
        SearchFilter: 'SearchFilter',
        TextFilter: 'TextFilter',
        DateFilter: 'DateFilter',
        ProjectFilter: 'ProjectFilter'
    };
    const $8ecd5c1ebfc76de6$export$7d34c8548269835d = (field)=>field.type === $8ecd5c1ebfc76de6$export$ed12481c953b8653.DateFilter;
});
parcelRegister("j0h5m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73773c42d63775af$export$2e2bcd8739ae039);
    var $7VHMR;
    var $73773c42d63775af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config-v2.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config-v2.date-range-label",
            "defaultMessage": "Date range"
        },
        startDateLabel: {
            "id": "business-filters.controllers.field-config-v2.start-date-label",
            "defaultMessage": "Start date"
        },
        dueDateLabel: {
            "id": "business-filters.controllers.field-config-v2.due-date-label",
            "defaultMessage": "Due date"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config-v2.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noLabelsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-labels-label",
            "defaultMessage": "No label"
        },
        noCategoriesLabel: {
            "id": "business-filters.controllers.field-config-v2.no-categories-label",
            "defaultMessage": "No category"
        },
        noComponentsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-components-label",
            "defaultMessage": "No component"
        },
        noSprintLabel: {
            "id": "business-filters.controllers.field-config-v2.no-sprint-label",
            "defaultMessage": "Backlog"
        },
        noVersionLabel: {
            "id": "business-filters.controllers.field-config-v2.no-version-label",
            "defaultMessage": "No version"
        },
        noParentLabel: {
            "id": "business-filters.controllers.field-config-v2.no-parent-label",
            "defaultMessage": "No parent"
        },
        noGoalLabel: {
            "id": "business-filters.controllers.field-config-v2.no-goal-label",
            "defaultMessage": "No goal"
        },
        noTeamLabel: {
            "id": "business-filters.controllers.field-config-v2.no-team-label",
            "defaultMessage": "No team"
        }
    });
});
parcelRegister("cLe9v", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfig", ()=>$bad07c14bc3eb691$export$70da50df1be2dbe1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $hE5wF;
    var $ftuRD;
    var $1T2vX;
    var $2H8QW;
    var $2Lcoi;
    var $aJfd5;
    var $jcw0u;
    var $7f4tk;
    var $koVbs;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $doZTA;
    var $czmU8;
    var $84pWT;
    var $8841m;
    var $1vUxa;
    var $e3P1V;
    const $bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS = 10;
    const $bad07c14bc3eb691$var$useFilterMapper = true;
    const $bad07c14bc3eb691$var$EMPTY_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_USER_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY = [];
    const $bad07c14bc3eb691$export$1fe8227c57fa0d68 = ()=>({
            initialUsers: {
                data: $bad07c14bc3eb691$var$EMPTY_USER_ARRAY,
                isLoading: false
            },
            initialLabels: {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            },
            initialComponents: {
                data: $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY,
                isLoading: false
            },
            initialCategories: {
                data: $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY,
                isLoading: false
            },
            projectKey: null
        });
    const $bad07c14bc3eb691$export$74cea4b24a6bc9fa = $bad07c14bc3eb691$export$1fe8227c57fa0d68();
    const $bad07c14bc3eb691$var$useForceUpdate = ()=>{
        const [, setValue] = (0, $5uXOq.useState)(0);
        return (0, $5uXOq.useCallback)(()=>setValue((value)=>value + 1), []);
    };
    const $bad07c14bc3eb691$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userResolver] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const forceUpdate = $bad07c14bc3eb691$var$useForceUpdate();
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const formattedCategoryOptions = (0, $5uXOq.useMemo)(()=>{
            const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
            return categoryOptions.map(({ value: value })=>({
                    label: value,
                    value: value
                }));
        }, [
            issueTypeData
        ]);
        const { statuses: statuses, loading: loadingStatuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const hydratedUsers = (0, $5uXOq.useRef)(null);
        const fetchInitialUsers = (0, $5uXOq.useCallback)(async ()=>{
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
            let users = [];
            const hydratedValues = jqlURLParamRef.current ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                hydratedUsers.current = transformedHydratedValues.users.options;
            }
            const url = `/rest/api/3/user/search?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=`;
            users = await (0, (0, parcelRequire("7f4tk")).default)(url);
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers = {
                data: users,
                isLoading: false
            };
            forceUpdate();
            return users;
        }, [
            cloudId,
            forceUpdate
        ]);
        const fetchInitialLabels = (0, $5uXOq.useCallback)(async ()=>{
            const url = `/rest/api/3/label?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}`;
            try {
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const labels = response.values;
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                    data: labels,
                    isLoading: false
                };
                forceUpdate();
                return labels;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterInitialLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch initial labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            };
            forceUpdate();
            return $bad07c14bc3eb691$var$EMPTY_ARRAY;
        }, [
            forceUpdate
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) {
                const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
                try {
                    const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                    return response;
                } catch (err) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'searchFilterUsers',
                            packageName: 'jiraBusinessFilters',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to search users',
                            errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            return $bad07c14bc3eb691$var$EMPTY_USER_ARRAY;
        }, [
            projectKey
        ]);
        const fetchProjectComponents = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) try {
                const response = await (0, (0, parcelRequire("2Lcoi")).fetchComponents)({
                    inputValue: query,
                    autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                    useFilterMapper: $bad07c14bc3eb691$var$useFilterMapper
                });
                return response;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterComponents',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch components',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return [];
        }, [
            projectKey
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)((query = '')=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'searchFilterLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }), []);
        const fetchProjectCategories = (0, $5uXOq.useCallback)((query = '')=>{
            const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
            return Promise.resolve(filteredCategoriesQuery ?? []);
        }, [
            formattedCategoryOptions
        ]);
        const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)
        });
        const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsEstimateData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (projectKey != null && ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey !== projectKey || $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.data === $bad07c14bc3eb691$var$EMPTY_USER_ARRAY)) {
                if ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                    $bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey = projectKey;
                    fetchInitialUsers();
                }
            }
        }, [
            fetchInitialUsers,
            fetchProjectComponents,
            projectKey,
            fetchInitialLabels,
            fetchProjectCategories,
            forceUpdate
        ]);
        const { data: initialUsers, isLoading: isLoadingUsers } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers;
        const { data: initialLabels, isLoading: isLoadingLabels } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels;
        const { data: initialComponents, isLoading: isLoadingComponents } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialComponents;
        const { data: initialCategories, isLoading: isLoadingCategories } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialCategories;
        const fieldOptionsData = (0, $5uXOq.useMemo)(()=>({
                priority: (0, (0, parcelRequire("e3P1V")).transformPriority)(priorityFieldConfig),
                issuetype: (0, (0, parcelRequire("e3P1V")).transformIssueType)(issueTypeData),
                status: (0, (0, parcelRequire("e3P1V")).transformStatuses)(statuses),
                users: (0, (0, parcelRequire("e3P1V")).transformUsers)(initialUsers),
                labels: (0, (0, parcelRequire("e3P1V")).transformLabels)(initialLabels),
                components: initialComponents,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialCategories,
                [(0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
                [(0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
            }), [
            priorityFieldConfig,
            issueTypeData,
            statuses,
            initialUsers,
            initialLabels,
            initialComponents,
            initialCategories,
            initialStoryPoints?.options,
            initialStoryPointsEstimate?.options
        ]);
        fieldOptionsData.users = (0, $5uXOq.useMemo)(()=>{
            if (hydratedUsers.current === null) return fieldOptionsData.users;
            return (0, ($parcel$interopDefault($3JOCw)))([
                ...hydratedUsers.current ?? [],
                ...fieldOptionsData.users ?? []
            ], ({ value: value })=>value);
        }, [
            fieldOptionsData
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, (0, parcelRequire("e3P1V")).getFilterFieldConfigAndResolvers)({
            formatMessage: formatMessage,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allFields: issueTypeData.fields,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, (0, parcelRequire("e3P1V")).transformUsers)(users || [])),
            fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, (0, parcelRequire("e3P1V")).transformLabelSuggestions)(labels) : []),
            fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
            fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
            userResolver: userResolver
        });
        const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingIssueTypesAndFields || loadingStatuses || fetching
        };
    };
});
parcelRegister("2H8QW", function(module, exports) {
    $parcel$export(module.exports, "getErrorType", ()=>$3122aab38ac46d24$export$e19f9f08a6d79fd2);
    var $jJZqs;
    const $3122aab38ac46d24$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
    const $3122aab38ac46d24$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
    const $3122aab38ac46d24$export$d46a05f8561f868a = 'OTHER';
    const $3122aab38ac46d24$export$c748438cec453c9f = {
        FAILED_TO_FETCH: 'Failed to fetch',
        NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
        NETWORK_REQUEST_FAILED: 'Network request failed',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        ABORTED: 'operation was aborted.',
        CANCELLED: 'cancelled',
        TIMEOUT: 'The request timed out.'
    };
    const $3122aab38ac46d24$var$isApolloClientNetworkError = (error)=>error.networkError !== undefined && error.networkError !== null;
    const $3122aab38ac46d24$export$e19f9f08a6d79fd2 = (error)=>{
        if (error == null) return $3122aab38ac46d24$export$9705762bba4e9e25;
        const message = String(error instanceof Error ? error.message : error).trim();
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode) return `FETCH_ERROR_${statusCode}`;
        }
        if ($3122aab38ac46d24$var$isApolloClientNetworkError(error)) return $3122aab38ac46d24$export$7453182ebe5973d4;
        const entry = Object.entries($3122aab38ac46d24$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        return entry ? entry[0] : $3122aab38ac46d24$export$d46a05f8561f868a;
    };
});
parcelRegister("2Lcoi", function(module, exports) {
    $parcel$export(module.exports, "fetchComponents", ()=>$14f8d378ed2868dc$export$4f703ddb7c8cc5b3);
    var $ebyGx = parcelRequire("ebyGx");
    var $2H8QW;
    var $jcw0u;
    var $eusud;
    var $lb7V6;
    const $14f8d378ed2868dc$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, queryParameters: queryParameters })=>{
        const mapperFunction = useFilterMapper === true ? (0, (0, parcelRequire("lb7V6")).mapComponentsToFilterOptions) : (0, (0, parcelRequire("lb7V6")).mapComponentsToOptions);
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify({
            query: inputValue,
            ...queryParameters
        });
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchProjectComponents',
                    packageName: 'jiraBusinessFetchComponents',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch jwm project components',
                    errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
});
parcelRegister("lb7V6", function(module, exports) {
    $parcel$export(module.exports, "mapComponentsToOptions", ()=>$4c5d47ac0f899709$export$85e44418187c2c1e);
    $parcel$export(module.exports, "mapComponentsToFilterOptions", ()=>$4c5d47ac0f899709$export$b4ef58d3e943e4d5);
    const $4c5d47ac0f899709$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
                label: name,
                value: componentId !== undefined ? String(componentId) : String(id)
            }));
    const $4c5d47ac0f899709$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
                label: name,
                value: name
            }));
});
parcelRegister("1vUxa", function(module, exports) {
    $parcel$export(module.exports, "useGroupItemValues", ()=>$f2df8273d684a2c0$export$f05af123f98299b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ccvFs;
    var $5YBrl;
    var $jlq4V;
    var $koVbs;
    var $g31qf;
    var $baeZQ;
    const $f2df8273d684a2c0$var$reducer = (state, action)=>{
        switch(action.type){
            case 'loading':
                return {
                    loading: true
                };
            case 'success':
                return {
                    loading: false,
                    data: action.payload
                };
            case 'error':
                return {
                    loading: false,
                    data: null
                };
            default:
                return state;
        }
    };
    const $f2df8273d684a2c0$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
        const [state, dispatch] = (0, $5uXOq.useReducer)($f2df8273d684a2c0$var$reducer, {
            loading: false
        });
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fetchDataAbortable = (0, (0, parcelRequire("ccvFs")).useAbortable)((0, (0, parcelRequire("g31qf")).fetchGroupItemValues));
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            try {
                dispatch({
                    type: 'loading'
                });
                const response = await fetchDataAbortable(groupFieldId, jqlContext);
                if (response.data?.items == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                dispatch({
                    type: 'success',
                    payload: (0, (0, parcelRequire("baeZQ")).transformInitialData)({
                        data: response.data,
                        formatMessage: formatMessage
                    })
                });
            } catch (error) {
                if (error === (0, (0, parcelRequire("ccvFs")).ABORTED)) return;
                dispatch({
                    type: 'error'
                });
            }
        }, [
            fetchDataAbortable,
            formatMessage,
            groupFieldId,
            jqlContext
        ]);
        return {
            fetch: fetch,
            data: state.data,
            loading: state.loading
        };
    };
});
parcelRegister("ccvFs", function(module, exports) {
    $parcel$export(module.exports, "ABORTED", ()=>$e04e223192d877be$export$23e29024ea698a35);
    $parcel$export(module.exports, "useAbortable", ()=>$e04e223192d877be$export$a487c7eb4387f959);
    var $5uXOq = parcelRequire("5uXOq");
    const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
    const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
        const prevControllerRef = (0, $5uXOq.useRef)(null);
        return (0, $5uXOq.useCallback)((...args)=>{
            if (prevControllerRef.current) prevControllerRef.current.abort();
            const controller = new AbortController();
            prevControllerRef.current = controller;
            return fetch(controller.signal, ...args).catch((error)=>{
                if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
                else throw error;
            });
        }, [
            fetch
        ]);
    };
});
parcelRegister("g31qf", function(module, exports) {
    $parcel$export(module.exports, "fetchGroupItemValues", ()=>$71087c8bd1916bd2$export$7e6e0c3f4468ce45);
    var $jcw0u;
    var $fZneA;
    var $eusud;
    const $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $71087c8bd1916bd2$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
        try {
            const variables = {
                fieldId: groupFieldId,
                first: $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS,
                jql: jqlContext
            };
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
                body: JSON.stringify({
                    query: (0, $626c877b75948b48$export$a48313dd44fc9855),
                    variables: variables
                })
            });
            return response;
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error) && !signal.aborted) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'initializeFilterGroupItemsData',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to initialize filter data using the group query'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $626c877b75948b48$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;
parcelRegister("baeZQ", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$a3e52c0a295405a4$export$93219b8691fe49a0);
    var $9D5f1;
    const $a3e52c0a295405a4$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
            totalCount: data.items.totalCount,
            options: data.items.edges.map((edge)=>{
                if (edge.node.field.floatValue == null) return {
                    value: null,
                    label: formatMessage((0, (0, parcelRequire("9D5f1")).default).noneOption)
                };
                const stringFloatValue = String(edge.node.field.floatValue);
                return {
                    value: stringFloatValue,
                    label: stringFloatValue
                };
            })
        });
});
parcelRegister("9D5f1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff2b830268d99634$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff2b830268d99634$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneOption: {
            "id": "business-filters.controllers.group-item-values.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("e3P1V", function(module, exports) {
    $parcel$export(module.exports, "transformPriority", ()=>$b808701b322de4e8$export$1b9f55a39456e911);
    $parcel$export(module.exports, "transformIssueType", ()=>$b808701b322de4e8$export$96520244689f81c1);
    $parcel$export(module.exports, "transformStatuses", ()=>$b808701b322de4e8$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformUsers", ()=>$b808701b322de4e8$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformLabels", ()=>$b808701b322de4e8$export$c072126708d93f04);
    $parcel$export(module.exports, "transformLabelSuggestions", ()=>$b808701b322de4e8$export$cdfcc40760c1a4f8);
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$b808701b322de4e8$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $hE5wF;
    var $5fc53;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $6S22M;
    const $b808701b322de4e8$export$1b9f55a39456e911 = (0, (0, parcelRequire("8QpSo")).default)((priorityFieldConfig)=>[
            ...priorityFieldConfig?.options || []
        ].reduce((acc, next)=>{
            acc.push({
                value: next.name,
                label: next.name,
                avatar: next.iconUrl || ''
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$96520244689f81c1 = (0, (0, parcelRequire("8QpSo")).default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
            acc.push({
                value: next.id,
                label: next.name,
                id: next.id,
                avatar: next.avatarUrl,
                square: true
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$20a57a5ec025f2d = (0, (0, parcelRequire("8QpSo")).default)((statuses)=>statuses.reduce((acc, next)=>{
            acc.push({
                value: next.untranslatedName,
                label: next.name,
                categoryId: next.statusCategory.id,
                id: Number(next.id)
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$c072126708d93f04 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels.reduce((acc, next)=>{
            acc.push({
                value: next || '',
                label: next
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$cdfcc40760c1a4f8 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
            acc.push({
                value: next.label || '',
                label: next.label
            });
            return acc;
        }, []));
    const $b808701b322de4e8$var$getType = ({ type: type })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $b808701b322de4e8$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
                label: value,
                value: value
            }));
    const $b808701b322de4e8$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return fieldOptionsData.users;
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return $b808701b322de4e8$var$getSelectCustomFieldValues(field);
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                if (aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID];
                return fieldOptionsData[type];
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
            default:
                return fieldOptionsData[type];
        }
    };
    const $b808701b322de4e8$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $b808701b322de4e8$var$isCustomField = (type)=>(0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).has(type);
    const $b808701b322de4e8$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$b808701b322de4e8$export$fb8c90bfc4beaa59(response)));
    const $b808701b322de4e8$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("6S22M")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
            if (type == null || aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return;
            const selectType = $b808701b322de4e8$var$getType({
                type: type
            });
            fieldConfig[id] = {
                systemType: type,
                label: name,
                type: selectType,
                placeholder: formatMessage((0, (0, parcelRequire("6S22M")).default).filterPlaceholder),
                options: $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData,
                    field: field,
                    aliasFieldId: aliasFieldId
                }),
                isCustomField: $b808701b322de4e8$var$isCustomField(type),
                fieldConfigVersion: 1
            };
            if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, (0, parcelRequire("6S22M")).default).typeLabel);
            if ($b808701b322de4e8$var$isUserField(type)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
                resolvers[id] = $b808701b322de4e8$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: 'EMPTY',
                        label: formatMessage((0, (0, parcelRequire("6S22M")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
            }
            if (type === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                    label: formatMessage((0, (0, parcelRequire("6S22M")).default).noneOption),
                    isEmptyOption: true
                }
            ];
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("6S22M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0167d244ddce5b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c0167d244ddce5b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config.date-range-label",
            "defaultMessage": "Date range"
        },
        typeLabel: {
            "id": "business-filters.controllers.field-config.type-label",
            "defaultMessage": "Type"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noneOption: {
            "id": "business-filters.controllers.field-config.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("2RV6Z", function(module, exports) {
    $parcel$export(module.exports, "deserialiseJql", ()=>$42cbf7cea9b7c40a$export$214464255b766962);
    var $3dHKF = parcelRequire("3dHKF");
    var $2nvJN = parcelRequire("2nvJN");
    var $pyK8a;
    var $f9ece;
    var $bv7J5;
    var $eK6AG;
    var $bzbto;
    var $5fc53;
    var $gBF4Z;
    var $7htvz;
    const $42cbf7cea9b7c40a$var$START_DATE_JQL = 'Start date[Date]';
    const $42cbf7cea9b7c40a$var$EMPTY = 'EMPTY';
    const $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption = (filterField)=>{
        const allowedFieldTypes = new Set([
            (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
            (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
            (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
        ]);
        return allowedFieldTypes.has(filterField?.type ?? '');
    };
    const $42cbf7cea9b7c40a$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $42cbf7cea9b7c40a$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $42cbf7cea9b7c40a$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
        if (resolver && typeof resolver === 'function') return resolver(list);
        const allowUnknownOption = $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption(filterField);
        return list.map((value)=>{
            if (field && !(0, (0, parcelRequire("gBF4Z")).isDateField)(field) && Array.isArray(field.options)) {
                const optionInField = field.options.find((option)=>{
                    if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                    if (option.isEmptyOption) return value === $42cbf7cea9b7c40a$var$EMPTY;
                    return option.value === value;
                });
                if (!optionInField && allowUnknownOption) return {
                    value: value,
                    label: value
                };
                return optionInField;
            }
            return undefined;
        }).filter((item)=>item != null && 'value' in item);
    };
    class $42cbf7cea9b7c40a$export$5299115fe71e8b39 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor(fieldConfig, filterFields, resolvers){
            super(), this.getOption = (fieldName, items)=>$42cbf7cea9b7c40a$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName)), this.visitCompoundClause = async (compoundClause)=>{
                const clauseMap = {};
                const operator = compoundClause.operator.value;
                if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) {
                    const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                    return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
                }
                throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
            }, this.parseDateOperand = (operator, operand)=>{
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) {
                    let date = (0, (0, parcelRequire("f9ece")).default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                    if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT)) date = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("pyK8a")).default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                    const dateType = operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT) ? 'to' : 'from';
                    return {
                        value: {
                            [dateType]: date
                        }
                    };
                }
                throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
            }, this.parseSelectOperand = async (fieldName, operand)=>{
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
                    const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                    return (await Promise.all(optionPromises)).flatMap((option)=>option);
                }
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                    operand.value
                ]);
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
                    {
                        isEmptyOption: true,
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: ''
                    }
                ];
                throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
            }, this.visitTerminalClause = async (terminalClause)=>{
                const { field: field, operand: operand, operator: operator } = terminalClause;
                if (!operand || !operator) return Promise.resolve({});
                const getShouldConvertCustomField = (fieldName)=>!(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
                const fieldName = $42cbf7cea9b7c40a$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
                if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
                let value = [];
                if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS) || operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
                else if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS) || operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
                else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
                return {
                    [fieldName]: value
                };
            };
            this.fieldConfig = fieldConfig;
            this.filterFields = filterFields;
            this.resolvers = resolvers;
        }
        visitNotClause() {
            throw new Error('JQL contains invalid clause: NOT');
        }
        defaultResult() {
            return Promise.resolve({});
        }
        async aggregateResult(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(await nextResult, await aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
        aggregateResultSync(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(nextResult, aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
    }
    const $42cbf7cea9b7c40a$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
        const parser = new $42cbf7cea9b7c40a$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
        const parsedJql = await jast.query?.accept(parser);
        return parsedJql ?? {};
    };
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("ab4a1", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$1b74022ad6f4d372$export$479f0f2f71193efe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $hMVQe;
    var $kn3Xd;
    const $1b74022ad6f4d372$var$LazyMenuContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("i5AI2")), {
        moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
    });
    const $1b74022ad6f4d372$export$479f0f2f71193efe = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kn3Xd")).DropdownWrapper), {
            "data-testid": "business-filters.ui.filters.menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "menu-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMVQe")).MenuFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1b74022ad6f4d372$var$LazyMenuContent, props)));
});
parcelRegister("hMVQe", function(module, exports) {
    $parcel$export(module.exports, "MenuFallback", ()=>$a630aa0f7c48ef76$export$1198e585d599d03);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $a630aa0f7c48ef76$export$1198e585d599d03 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a630aa0f7c48ef76$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium",
            testId: "business-filters.common.ui.menu-fallback.spinner"
        }));
    const $a630aa0f7c48ef76$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kn3Xd", function(module, exports) {
    $parcel$export(module.exports, "DropdownWrapper", ()=>$5ca6b1e17ddf2f10$export$5f7211d21bfdae05);
    $parcel$export(module.exports, "ScrollableContent", ()=>$5ca6b1e17ddf2f10$export$6c560fdadeb11d78);
    $parcel$export(module.exports, "DropdownHeaderWrapper", ()=>$5ca6b1e17ddf2f10$export$e23294aded7a8a49);
    $parcel$export(module.exports, "DropdownHeaderButtons", ()=>$5ca6b1e17ddf2f10$export$53ca7a3701b98335);
    $parcel$export(module.exports, "FiltersListSeparator", ()=>$5ca6b1e17ddf2f10$export$1a67069896d998b9);
    $parcel$export(module.exports, "FiltersListWrapper", ()=>$5ca6b1e17ddf2f10$export$a5a9080bd2c85987);
    $parcel$export(module.exports, "Section", ()=>$5ca6b1e17ddf2f10$export$6e2c8f0811a474ce);
    $parcel$export(module.exports, "LastSection", ()=>$5ca6b1e17ddf2f10$export$1faf3c7558df435);
    $parcel$export(module.exports, "SectionMessageWrapper", ()=>$5ca6b1e17ddf2f10$export$c5e20d5e200edfe2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gzkAf;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT = 52;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
    const $5ca6b1e17ddf2f10$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6c560fdadeb11d78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uik9ob": (0, (0, parcelRequire("lD23V")).default)(`calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${(__cmplp.offsetTop ?? (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP)) + $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$e23294aded7a8a49 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
                __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$53ca7a3701b98335 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1a67069896d998b9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81alc _x3do13y8",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$a5a9080bd2c85987 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1faf3c7558df435 = (0, $5uXOq.forwardRef)(({ as: C = $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdidpf _zulpidpf",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5AI2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("44yBr")
    ]).then(()=>parcelRequire('lk6eZ'));
});
parcelRegister("6xNkv", function(module, exports) {
    $parcel$export(module.exports, "Trigger", ()=>$9499219f0b3ef189$export$41fb9f06171c75f4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bTqXB;
    var $hORKG;
    var $4R6GH;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $fj0YT;
    const $9499219f0b3ef189$var$FILTER_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bTqXB"))))), {
        label: "",
        size: "small"
    });
    const $9499219f0b3ef189$export$41fb9f06171c75f4 = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterMessageOld = (0, $5uXOq.useMemo)(()=>{
            if (count > 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            });
            if (hasFiltersApplied) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const filterMessage = (0, $5uXOq.useMemo)(()=>{
            if (hasFiltersApplied && count === 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const TriggerButton = withThemedButton ? (0, (0, parcelRequire("22OQR")).ThemedButton) : (0, (0, parcelRequire("fVnbM")).default);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            "aria-label": formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            }),
            ref: ref,
            isDisabled: isDisabled,
            isSelected: isSelected || count > 0,
            onClick: onClick,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconAfter: count === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                label: "",
                color: "currentColor"
            }) : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessage, count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$BadgeContents, null, count))) : (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            ref: ref,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconBefore: $9499219f0b3ef189$var$FILTER_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: (0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') ? appearance : 'subtle',
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessageOld));
    });
    const $9499219f0b3ef189$var$ButtonContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _zulp12x7 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9499219f0b3ef189$var$BadgeContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _bfhkllho _ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _4t3i1j6v _1ul91j6v _2rkogqwt _11c81oud",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fj0YT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$483bd49c4d6c7782$export$2e2bcd8739ae039);
    var $7VHMR;
    var $483bd49c4d6c7782$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filtersCount: {
            "id": "business-filters.filters.trigger.filters-count",
            "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
        },
        filterButton: {
            "id": "business-filters.filters.trigger.filter-button",
            "defaultMessage": "Filter"
        },
        buttonWithFilters: {
            "id": "business-filters.filters.trigger.button-with-filters",
            "defaultMessage": "Filters applied"
        },
        newLozenge: {
            "id": "business-filters.filters.trigger.new-lozenge",
            "defaultMessage": "New"
        },
        newLozengeTooltip: {
            "id": "business-filters.filters.trigger.new-lozenge-tooltip",
            "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
        }
    });
});
parcelRegister("4Mmyc", function(module, exports) {
    $parcel$export(module.exports, "SimpleSearchTextField", ()=>$c9154e4bfb02bfbe$export$63f96dda4bd4f7dc);
    $parcel$export(module.exports, "SimpleSearchField", ()=>$c9154e4bfb02bfbe$export$44e8ccf3428dc1d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $42CjB;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $8CUq3;
    var $kY99m;
    var $6cG4N;
    var $4R6GH;
    var $koVbs;
    var $jDrwg;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $l4v6E;
    var $1T1ir;
    var $emybt;
    const $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH = 184;
    const $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc = (0, $5uXOq.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId = 'searchfield', isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [searchValue, setSearchValue] = (0, $5uXOq.useState)(externalValue);
        const handleSearchChange = (0, $5uXOq.useCallback)((newValue)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
                view: view,
                ...(0, (0, parcelRequire("l4v6E")).getTextFieldAttributes)(newValue)
            });
            onChange(newValue);
        }, [
            createAnalyticsEvent,
            onChange,
            view
        ]);
        const [handleSearchChangeDebounced] = (0, (0, parcelRequire("jDrwg")).default)(handleSearchChange, 500);
        const handleChange = (0, $5uXOq.useCallback)((e)=>{
            setSearchValue(e.target.value);
            handleSearchChangeDebounced(e.target.value);
        }, [
            handleSearchChangeDebounced
        ]);
        const handleClear = (0, $5uXOq.useCallback)(()=>{
            setSearchValue('');
            handleSearchChangeDebounced('');
        }, [
            setSearchValue,
            handleSearchChangeDebounced
        ]);
        const themedIconPrimaryColor = isDisabled ? (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_DISABLED : (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_SUBTLEST;
        const Container = themedField ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? $c9154e4bfb02bfbe$var$ThemedContainer : $c9154e4bfb02bfbe$var$ThemedContainerOld : (0, $5uXOq.Fragment);
        (0, $5uXOq.useEffect)(()=>{
            setSearchValue(externalValue);
        }, [
            externalValue
        ]);
        const elemAfterSearchIcon = !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
        }) : null;
        let textFieldWidth;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ref: inputRef,
            "aria-describedby": describedbyId,
            testId: testId,
            value: searchValue,
            isCompact: true,
            placeholder: formatMessage(placeholder),
            "aria-label": label || formatMessage(placeholder),
            onChange: handleChange,
            onFocus: onFocus,
            isDisabled: isDisabled,
            elemAfterInput: searchValue !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                paddingInlineEnd: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'space.025' : undefined
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                        ...iconProps,
                        label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                        spacing: "none",
                        color: "var(--ds-text, #172B4D)",
                        LEGACY_size: "small",
                        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                testId: "business-filters.ui.simple-search-field.clear-button",
                onClick: handleClear
            })) : elemAfterSearchIcon,
            elemBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c9154e4bfb02bfbe$var$iconStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
                color: "currentColor",
                label: "",
                spacing: "none"
            })),
            width: textFieldWidth,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_dzcou2gc"
            ])
        }));
    });
    const $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5 = (0, $5uXOq.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
        const [simpleSearch, setSimpleSearch] = (0, (0, parcelRequire("1T1ir")).useSimpleSearch)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleFocus = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
                view: view
            });
        }, [
            createAnalyticsEvent,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onChange) onChange(simpleSearch);
        }, [
            onChange,
            simpleSearch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$export$63f96dda4bd4f7dc, {
            view: view,
            onFocus: handleFocus,
            describedbyId: describedbyId,
            onChange: (text)=>{
                if (onChange) onChange(text);
                return setSimpleSearch(text);
            },
            value: simpleSearch,
            placeholder: placeholder
        }));
    });
    const $c9154e4bfb02bfbe$var$textFieldStyles = null;
    const $c9154e4bfb02bfbe$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginLeft: 'space.075'
    });
    const $c9154e4bfb02bfbe$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_6l8rjjc1 _x2xkjjc1 _sg3vjjc1 _w15ajjc1 _n8yf4zrn _jeievy9e _7n83frbu _1o8h13fh _n2ul1jo4",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$ThemedContainerOld = (0, $5uXOq.forwardRef)(({ as: C = $c9154e4bfb02bfbe$var$ThemedContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n8yfim6e",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
parcelRegister("l4v6E", function(module, exports) {
    $parcel$export(module.exports, "getTextFieldAttributes", ()=>$211f318fc379b0d9$export$dfd7972bcd113afb);
    const $211f318fc379b0d9$export$dfd7972bcd113afb = (value = '')=>{
        const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
        return {
            queryLength: value.length,
            wordCount: wordCount
        };
    };
});
parcelRegister("emybt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5a1b27b61b41126$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5a1b27b61b41126$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "business-filters.simple-search-field.clear",
            "defaultMessage": "Clear"
        }
    });
});
parcelRegister("17X6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a40c8fa5f1e21a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    var $e1OxR;
    const $0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("5Kdrw")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
    });
    const $0a40c8fa5f1e21a1$var$AddPeopleWithAvatar = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.invite-people.add-people-with-avatars",
            packageName: "jiraBusinessInvitePeople",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "invite-button-with-avatars",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$AvatarFallback, null)
        }, props?.hasInviteButton === false ? (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1OxR")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props))));
    const $0a40c8fa5f1e21a1$var$AvatarFallback = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp",
                __cmplp.className
            ])
        });
    });
    var $0a40c8fa5f1e21a1$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0a40c8fa5f1e21a1$var$AddPeopleWithAvatar);
});
parcelRegister("e1OxR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f3117b4e456671f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $7wK4b;
    var $bZLPe;
    const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
        const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        if (isModalOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZLPe")).ProjectInvitePeopleModal), {
            onModalClose: closeAddPeopleModal,
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        });
        return null;
    };
    const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7wK4b")).AddPeopleProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira-business.invite-people.ui.add-people",
            packageName: "jira-business.invite-people.ui.add-people",
            teamName: "jira-warepil"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
            "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        }))));
    var $0f3117b4e456671f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
    const $0f3117b4e456671f$var$InviteWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7wK4b", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleProvider", ()=>$3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
    $parcel$export(module.exports, "useAddPeople", ()=>$3ebbf4ad1e53c7be$export$93ea361ec674cff6);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $8zOmE;
    var $2NMNM;
    const $3ebbf4ad1e53c7be$var$AddPeopleContext = (0, $5uXOq.createContext)({
        triggerBtnRef: {
            current: null
        },
        isModalOpen: false,
        openAddPeopleModal: ()=>{},
        closeAddPeopleModal: ()=>{}
    });
    const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const triggerBtnRef = (0, $5uXOq.useRef)(null);
        const onCloseCallbackRef = (0, $5uXOq.useRef)();
        const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
            setIsModalOpen(true);
            const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
                source: source
            });
            if (onClose) onCloseCallbackRef.current = onClose;
        }, [
            createAnalyticsEvent,
            projectData.isSimplified
        ]);
        const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
            setIsModalOpen(false);
            if (typeof onCloseCallbackRef.current === 'function') {
                onCloseCallbackRef.current();
                onCloseCallbackRef.current = null;
            }
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                triggerBtnRef: triggerBtnRef,
                isModalOpen: isModalOpen,
                openAddPeopleModal: openAddPeopleModal,
                closeAddPeopleModal: closeAddPeopleModal
            }), [
            triggerBtnRef,
            isModalOpen,
            openAddPeopleModal,
            closeAddPeopleModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
            value: context
        }, children);
    };
    const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);
});
parcelRegister("bZLPe", function(module, exports) {
    $parcel$export(module.exports, "ProjectInvitePeopleModal", ()=>$74aeebd820c67267$export$6dfea89767cb5ac1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $2erM2;
    var $cb8cx;
    var $9AFuM;
    const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, (0, parcelRequire("2erM2")).useInviteModalHandlers)();
        if (!shouldUseInvitePeopleModal && projectData.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb8cx")).AddPeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AFuM")).InvitePeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError,
            source: source
        });
    };
});
parcelRegister("2erM2", function(module, exports) {
    $parcel$export(module.exports, "useInviteModalHandlers", ()=>$d23a63b1c343bca5$export$f696e14fc423d0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $99ejj;
    var $kPioc;
    const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
            const hasSentInvitation = inviteStatus === (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
            const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
            showFlag(hasSuccessfullyAddedPeople ? (0, (0, parcelRequire("kPioc")).createAddSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                projectKey: projectData.key
            }) : (0, (0, parcelRequire("kPioc")).createInviteSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                hasSentInvitation: hasSentInvitation
            }));
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
                inviteStatus: inviteStatus
            });
        }, [
            createAnalyticsEvent,
            showFlag,
            projectData
        ]);
        const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
            if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
                showFlag((0, (0, parcelRequire("kPioc")).createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
                return;
            }
            if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailGenericFlagConfig));
            else showFlag((0, (0, parcelRequire("kPioc")).inviteFailFlagConfig));
            const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
            if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `jwm${modalType}Invite`,
                    packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: errorMessage
                },
                error: new Error(errorMessage),
                sendToPrivacyUnsafeSplunk: true
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
        }, [
            createAnalyticsEvent,
            isSiteAdmin,
            showFlag
        ]);
        return {
            handleAddSuccess: handleAddSuccess,
            handleError: handleError
        };
    };
});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';
parcelRegister("99ejj", function(module, exports) {
    $parcel$export(module.exports, "InvitationStatusEnum", ()=>$e49e7d7763027049$export$2e0a7d2dc28c9a18);
    const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
        ACCESS_REQUESTED: 'ACCESS_REQUESTED',
        INVITED: 'INVITED'
    };
});
parcelRegister("kPioc", function(module, exports) {
    $parcel$export(module.exports, "inviteFailFlagConfig", ()=>$366128c003d2496b$export$95c6157ced8b3439);
    $parcel$export(module.exports, "inviteFailGenericFlagConfig", ()=>$366128c003d2496b$export$1108ab4b8a5d8a7d);
    $parcel$export(module.exports, "inviteFailBadRequestFlagConfig", ()=>$366128c003d2496b$export$7f2d6442eed4d708);
    $parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", ()=>$366128c003d2496b$export$c3bdacfc2255a9ed);
    $parcel$export(module.exports, "createInviteSuccessFlagConfig", ()=>$366128c003d2496b$export$d456881895c2a0b2);
    $parcel$export(module.exports, "createAddSuccessFlagConfig", ()=>$366128c003d2496b$export$cca35dec2a083169);
    $parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", ()=>$366128c003d2496b$export$251dc06b3962c565);
    var $8zOmE;
    var $6OFcj;
    const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
        if (totalPeopleAdded <= 0) return [
            agnosticDescription,
            {}
        ];
        return [
            specificDescription,
            {
                totalPeopleAddedMinusOne: totalPeopleAdded - 1,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }
        ];
    };
    const $366128c003d2496b$export$95c6157ced8b3439 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageDescription,
        actions: [
            {
                content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
            }
        ],
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedGenericMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$7f2d6442eed4d708 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedBadRequestMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$c3bdacfc2255a9ed = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedNetworkErrorMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
        if (!hasSentInvitation) return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
        return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
    };
    const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            actions: [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).peopleAddedManageAccess,
                    onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
                }
            ],
            messageType: 'transactional'
        });
    const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
            type: 'warning',
            title: (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorTitle,
            description: isSiteAdmin ? (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescriptionAdmin : (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescription,
            actions: isSiteAdmin ? [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).upgradePlan,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                        window.open('/admin/billing/applications', '_blank');
                    }
                },
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).viewUsers,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                        window.open('/admin/users', '_blank');
                    }
                }
            ] : [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                        window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                    }
                }
            ],
            messageType: 'transactional'
        });
});
parcelRegister("6OFcj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87007b6d35f6d31$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
            "defaultMessage": "Invitation sent"
        },
        inviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
            "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
        },
        inviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
            "defaultMessage": "You've successfully invited people to your business project."
        },
        inviteFailedMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
            "defaultMessage": "Something went wrong"
        },
        inviteFailedMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
        },
        inviteFailedMessageCta: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
            "defaultMessage": "Contact your admin"
        },
        inviteFailedGenericMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users, please try again."
        },
        inviteFailedBadRequestMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
        },
        inviteFailedNetworkErrorMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
        },
        requestInviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
            "defaultMessage": "Access request sent to your admin"
        },
        requestInviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
            "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
        },
        requestInviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
            "defaultMessage": "Your admin needs to approve access for people to your business project."
        },
        peopleAddedSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
            "defaultMessage": "New people added"
        },
        peopleAddedSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
            "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
            "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedManageAccess: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
            "defaultMessage": "Manage access"
        },
        userLimitInviteErrorTitle: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
            "defaultMessage": "Can't add more people"
        },
        userLimitInviteErrorDescriptionAdmin: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
            "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
        },
        userLimitInviteErrorDescription: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
            "defaultMessage": "You've reached your user limit. Contact your admin for help."
        },
        viewUsers: {
            "id": "business-invite-people.controllers.modal-handlers.view-users",
            "defaultMessage": "View users"
        },
        upgradePlan: {
            "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
            "defaultMessage": "Upgrade plan"
        }
    });
});
parcelRegister("cb8cx", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleModal", ()=>$4afbb4a2961eae5f$export$b28f48897cdf7241);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $daQYX;
    var $heNNl;
    var $lfTZh;
    var $5oFIy;
    var $itmJb;
    var $kxZPA;
    var $7wK4b;
    const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7HRyA")), {
        ssr: false,
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
        BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
        NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
        AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
        SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
        USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
    };
    const $4afbb4a2961eae5f$export$b28f48897cdf7241 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
        const { triggerBtnRef: triggerBtnRef } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
            onInviteSuccess({
                totalPeopleAdded: addedParties.length,
                email: addedParties[0]?.email || addedParties[0]?.displayName,
                modalType: 'Project'
            });
        }, [
            onInviteSuccess
        ]);
        const extractErrorCode = (message)=>{
            for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
                const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
                if (message.includes(errorMessage)) return errorCode;
            }
            return message;
        };
        const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
            const userInviteErrorsWithCode = {};
            errors.forEach((error)=>{
                const errorCode = extractErrorCode(error.message);
                if (errorCode) {
                    if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                    userInviteErrorsWithCode[errorCode].push(error);
                }
            });
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode;
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
        }, [
            onInviteError
        ]);
        const { id: id, key: key } = projectData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.add-people",
            packageName: "jira-business.project-invite-people-modal.add-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmProjectInviteComponent viewed"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-people-modal-lazy",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
            isOpen: true,
            triggerBtnRef: triggerBtnRef,
            onClose: onModalClose,
            onAddSuccess: handleInviteSuccess,
            onError: handleInviteFailure,
            projectId: id,
            projectKey: key,
            projectType: "business",
            isAdmin: isAdmin,
            baseUrl: "",
            analyticsPrefix: "",
            allowFlags: false,
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz)))
        })));
    });
});
parcelRegister("7HRyA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("9AFuM", function(module, exports) {
    $parcel$export(module.exports, "InvitePeopleModal", ()=>$5ae346fd9b1f20af$export$e3ec81c4d0451f63);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $9fuVs;
    var $65Ltd;
    var $heNNl;
    var $7NYq5;
    var $lfTZh;
    var $6jY6G;
    var $5oFIy;
    var $12hlA;
    var $14XJw;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    var $koeKL;
    var $itmJb;
    var $kxZPA;
    var $99ejj;
    const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("i57tV")), {
        ssr: false,
        moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
    });
    const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
        if (res.accessRequested?.length) return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).ACCESS_REQUESTED;
        return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
    };
    const $5ae346fd9b1f20af$var$LIST_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST)
    ];
    const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>res.failure !== undefined;
    const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
            if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
                const { message: message, status: status } = response.failure;
                onInviteError({
                    modalType: 'Instance',
                    errorMessage: message,
                    statusCode: status
                });
                return;
            }
            const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
            const { invited: invited, accessRequested: accessRequested } = response;
            onInviteSuccess({
                totalPeopleAdded: invited.length || accessRequested.length,
                email: invited[0]?.email || accessRequested[0]?.email || '',
                modalType: 'Instance',
                inviteStatus: inviteStatus
            });
        }, [
            onInviteError,
            onInviteSuccess
        ]);
        const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
            route
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.invite-people",
            packageName: "jira-business.project-invite-people-modal.invite-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal.invite-people",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NYq5")).JiraModal), {
            messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
            messageType: "transactional",
            onClose: onModalClose,
            width: "small",
            shouldScrollInViewport: true,
            testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmInstanceInviteComponent viewed"
        }), isSoftwareRoute ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12hlA")).default), {
            isOpen: true,
            cloudId: cloudId,
            projectId: projectData.id,
            jiraProjectKey: projectData.key,
            isSiteAdmin: isAdmin,
            onClose: onModalClose,
            appEdition: (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions),
            jiraProjectName: projectData.name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
            onSendHandler: onModalClose,
            onInviteCompletedHandler: onInviteCompleteHandler,
            onCancelHandler: onModalClose,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            continueUrl: window.location.href,
            enableThirdParty: true,
            source: source,
            orgId: orgId
        })))));
    });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("7NYq5", function(module, exports) {
    $parcel$export(module.exports, "JiraModal", ()=>$d308ab9275c4cac7$export$3782fcca1f68992e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $10xFf;
    var $1WAOl;
    const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1WAOl")).ChoreographerModal), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), rest);
    };
    $d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';
});
parcelRegister("1WAOl", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerModal", ()=>$ae3d8c3c4e97b978$export$3f5d627caa6fc630);
    var $1R1Ge;
    var $cSWNW;
    const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("1R1Ge")).default));
});
parcelRegister("12hlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bc8c7c74346f034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $0bc8c7c74346f034$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jWZZk")), {
        moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
    });
    const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-invite-people-modal",
            packageName: "jira-project-invite-people-modal",
            teamName: "groot-growth"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
    var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;
});
parcelRegister("jWZZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6C6tQ")
    ]).then(()=>parcelRequire('3dNZP'));
});
parcelRegister("i57tV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gPcKY")
    ]).then(()=>parcelRequire('ddHJI'));
});
parcelRegister("5Kdrw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eeBXE")
    ]).then(()=>parcelRequire('62h3r'));
});
parcelRegister("ccsmj", function(module, exports) {
    $parcel$export(module.exports, "JWMShareButton", ()=>$e895e30d5d3d8dcc$export$b326da26415fdf10);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZX0t;
    var $12jwF;
    var $koVbs;
    var $22OQR;
    var $iL8EU;
    var $9j8is;
    var $fjgF8;
    var $4XKuc;
    const $e895e30d5d3d8dcc$var$SHARE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
        label: "",
        size: "small"
    });
    const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { shareIntegrations: shareIntegrations } = (0, (0, parcelRequire("9j8is")).useShareIntegrations)(shareContentType);
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const shareButtonRef = (0, $5uXOq.useRef)(null);
        const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                ...triggerProps,
                ref: shareButtonRef,
                onClick: onClick,
                isSelected: isSelected,
                iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("4XKuc")).default).share))), [
            formatMessage
        ]);
        const handleDialogClose = ()=>{
            onDialogClose?.();
            shareButtonRef?.current?.focus();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjgF8")).AsyncShareProjectNudge), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            isAutoOpenDialog: isAutoOpenDialog,
            integrationType: integrationType,
            triggerButtonStyle: "icon-with-text",
            productId: "jira",
            subProductId: "jira-core",
            shareLink: false ? '' : window.location.href,
            shareTitle: formatMessage(shareTitle),
            shareContentType: shareContentType,
            renderCustomTriggerButton: renderCustomTriggerButton,
            objectAri: entityAri,
            onDialogClose: handleDialogClose,
            copyTooltipText: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareTooltipText),
            shareIntegrations: shareIntegrations,
            integrationMode: "tabs",
            shareFormHelperMessage: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareJwmHelperMessage)
        }));
    };
});
parcelRegister("jZX0t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
    function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e8f17c524b03e26b$var$ShareIcon = (props)=>$e8f17c524b03e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $e8f17c524b03e26b$var$_share.default
        }));
    $e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
    var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;
});
parcelRegister("empdx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a746ae65a0e1944c$var$ShareIcon = (props)=>$a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
    var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $jZX0t;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("9j8is", function(module, exports) {
    $parcel$export(module.exports, "useShareIntegrations", ()=>$d021f3111fd4c646$export$58a9f7a7ab3466f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $bCdIp;
    var $pa9q9;
    var $koeKL;
    var $2UEtd;
    var $aMZmw;
    const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
            const reasons = [];
            if ((0, (0, parcelRequire("bCdIp")).default)()) reasons.push('notDesktop');
            if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) reasons.push('isFedRAMP');
            return reasons;
        }, []);
        const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
                {
                    type: 'Slack',
                    Icon: (0, (0, parcelRequire("aMZmw")).default),
                    Content: ({ onClose: onClose, changeTab: changeTab })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2UEtd")).ShareToSlack), {
                            showFlag: showFlag,
                            product: "jira",
                            channel: "productAnalytics",
                            onClose: onClose,
                            cloudId: cloudId,
                            changeTab: changeTab,
                            shareContentType: shareContentType
                        })
                }
            ] : [], [
            ineligibilityReasons.length,
            showFlag,
            cloudId,
            shareContentType
        ]);
        return {
            shareIntegrations: shareIntegrations
        };
    };
});
parcelRegister("2UEtd", function(module, exports) {
    $parcel$export(module.exports, "ShareToSlack", ()=>$168b88234834bfea$export$2cc56764fd9edb21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $heNNl;
    var $lfTZh;
    var $3xc3R;
    const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async-share-to-slack",
            packageName: "integrations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-to-slack",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
    const $168b88234834bfea$var$StyledShareToSlackLoader = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("eZJjh")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
    const $168b88234834bfea$var$StyledShareToSlack = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("3xc3R")).LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8ax2b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3xc3R", function(module, exports) {
    $parcel$export(module.exports, "LazyShareToSlack", ()=>$0733f18014b5074d$export$24281652e6b89b3b);
    var $kxZPA;
    const $0733f18014b5074d$export$24281652e6b89b3b = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3MPjw")), {
        ssr: false,
        moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
    });
});
parcelRegister("3MPjw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("mbt92")
    ]).then(()=>parcelRequire('2B8HF'));
});
parcelRegister("aMZmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1ef732ae0096135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "4 4 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
            fill: "#ECB22E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("fjgF8", function(module, exports) {
    $parcel$export(module.exports, "AsyncShareProjectNudge", ()=>$7ce891b6fd7965bb$export$d95995d6ca76620b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iEJkp")), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
    });
    const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-share-project-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("iEJkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qj8a").then(()=>parcelRequire('dRf63'));
});
parcelRegister("4XKuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ed6b88152ef6ea6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "business-invite-people.jwm-share-button.share",
            "defaultMessage": "Share"
        },
        shareTooltipText: {
            "id": "business-invite-people.jwm-share-button.share-tooltip-text",
            "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
        },
        shareJwmHelperMessage: {
            "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
            "defaultMessage": "This view, along with any applied groups and filters are shared"
        }
    });
});
parcelRegister("70g8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bc06decfa7dde08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $2h2vc;
    var $2SbUq;
    const $1bc06decfa7dde08$export$7174b56226171cc3 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("134F6")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
    });
    const $1bc06decfa7dde08$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, hasFeedbackButton: hasFeedbackButton, projectType: projectType, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems, hideItemsMenuOptions: hideItemsMenuOptions })=>{
        const renderContent = (0, $5uXOq.useCallback)((onCloseMenu)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "menu-content",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2h2vc")).default), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($1bc06decfa7dde08$export$7174b56226171cc3, {
                hideDoneItems: hideDoneItems,
                onChangeHideDoneItems: onChangeHideDoneItems,
                onExpandCollapseAllItems: onExpandCollapseAllItems,
                isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
                hasExpandedAllItems: hasExpandedAllItems,
                hasCollapsedAllItems: hasCollapsedAllItems,
                hasFeedbackButton: hasFeedbackButton,
                projectType: projectType,
                onCloseMenu: onCloseMenu,
                hideItemsMenuOptions: hideItemsMenuOptions
            })), [
            hideDoneItems,
            onChangeHideDoneItems,
            onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled,
            hasExpandedAllItems,
            hasCollapsedAllItems,
            hasFeedbackButton,
            projectType,
            hideItemsMenuOptions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2SbUq")).default), {
            renderContent: renderContent
        });
    };
    var $1bc06decfa7dde08$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1bc06decfa7dde08$var$MoreMenu);
});
parcelRegister("2h2vc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b39db453d8ec83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $c4b39db453d8ec83$var$MenuFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($c4b39db453d8ec83$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    var $c4b39db453d8ec83$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c4b39db453d8ec83$var$MenuFallback);
    const $c4b39db453d8ec83$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2SbUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d5dde4b111cc89$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $1I7E8;
    var $l8ruj;
    var $loRkl;
    const $86d5dde4b111cc89$var$MoreMenuCore = (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f1bdb30d4d079129$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
        (0, $5uXOq.useEffect)(()=>{
            setIsOpen(forceVisibility);
        }, [
            forceVisibility
        ]);
        const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($86d5dde4b111cc89$export$5f7211d21bfdae05, {
                width: minWidth
            }, renderContent(closeMenu)), [
            closeMenu,
            renderContent,
            minWidth
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loRkl")).default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: toggleMenu
            }), [
            isOpen,
            toggleMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-more-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: closeMenu,
            placement: "bottom-end",
            content: content,
            trigger: trigger
        }));
    });
    var $86d5dde4b111cc89$export$2e2bcd8739ae039 = $86d5dde4b111cc89$var$MoreMenuCore;
    const $86d5dde4b111cc89$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_6f8077": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1hdq",
                __cmplp.className
            ])
        });
    });
});
const $f1bdb30d4d079129$export$8c68b096b2d5e9f6 = 320;
parcelRegister("loRkl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbbabf378481667d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8U6zd;
    var $3oUqw;
    var $7XYc4;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $dSexS;
    const $fbbabf378481667d$var$MORE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
        label: "",
        size: "small"
    });
    const $fbbabf378481667d$var$TriggerOld = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconBefore: $fbbabf378481667d$var$MORE_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle",
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel)
        }, formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton));
    });
    const $fbbabf378481667d$var$Trigger = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            isSelected: isSelected,
            onClick: onClick,
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel),
            title: formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton)
        });
    });
    var $fbbabf378481667d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $fbbabf378481667d$var$Trigger, $fbbabf378481667d$var$TriggerOld);
});
parcelRegister("dSexS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52d3441e2e3906d4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52d3441e2e3906d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreButton: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
            "defaultMessage": "More"
        },
        moreButtonLabel: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
            "defaultMessage": "More actions on the view options"
        }
    });
});
parcelRegister("134F6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOlk3").then(()=>parcelRequire('fhUV3'));
});
parcelRegister("dXCxS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0ad71e5c6a4bee7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hYRTO;
    var $kxZPA;
    var $ej8Wl;
    var $5UVwA;
    const $b0ad71e5c6a4bee7$export$7174b56226171cc3 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("b6kGD")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/settings-menu/src/ui/settings-menu/menu-content/index.tsx"
    });
    const $b0ad71e5c6a4bee7$var$SettingsMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems })=>{
        const renderContent = (0, $5uXOq.useCallback)((onCloseMenu)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYRTO")).default), {
                name: "menu-content",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ej8Wl")).default), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($b0ad71e5c6a4bee7$export$7174b56226171cc3, {
                hideDoneItems: hideDoneItems,
                onChangeHideDoneItems: onChangeHideDoneItems,
                onExpandCollapseAllItems: onExpandCollapseAllItems,
                isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
                hasExpandedAllItems: hasExpandedAllItems,
                hasCollapsedAllItems: hasCollapsedAllItems,
                onCloseMenu: onCloseMenu
            })), [
            hideDoneItems,
            onChangeHideDoneItems,
            onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled,
            hasExpandedAllItems,
            hasCollapsedAllItems
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5UVwA")).default), {
            renderContent: renderContent
        });
    };
    var $b0ad71e5c6a4bee7$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b0ad71e5c6a4bee7$var$SettingsMenu);
});
parcelRegister("ej8Wl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$277612fdcac905c3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    const $277612fdcac905c3$var$MenuFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $277612fdcac905c3$var$spinnedWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    var $277612fdcac905c3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($277612fdcac905c3$var$MenuFallback);
    const $277612fdcac905c3$var$spinnedWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.200'
    });
});
parcelRegister("5UVwA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$442f66c0b9177f44$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $1I7E8;
    var $co1wz;
    var $l8ruj;
    var $egJIl;
    const $442f66c0b9177f44$var$SettingMenuCore = (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $7d19812bf97f27a1$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
        (0, $5uXOq.useEffect)(()=>{
            setIsOpen(forceVisibility);
        }, [
            forceVisibility
        ]);
        const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($442f66c0b9177f44$var$DropdownWrapper, {
                width: minWidth
            }, renderContent(closeMenu)), [
            closeMenu,
            renderContent,
            minWidth
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egJIl")).default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: toggleMenu
            }), [
            isOpen,
            toggleMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-settings-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: closeMenu,
            placement: "bottom-end",
            content: content,
            trigger: trigger,
            shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds'),
            strategy: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
        }));
    });
    var $442f66c0b9177f44$export$2e2bcd8739ae039 = $442f66c0b9177f44$var$SettingMenuCore;
    const $442f66c0b9177f44$var$DropdownWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_6f8077": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1hdq",
                __cmplp.className
            ])
        });
    });
});
const $7d19812bf97f27a1$export$8c68b096b2d5e9f6 = 320;
parcelRegister("egJIl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c59696bb775620b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4QAwn;
    var $koVbs;
    var $22OQR;
    var $gGI3m;
    const $2c59696bb775620b$var$Trigger = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-settings-menu.ui.settings-menu.settings-menu-core.trigger.trigger",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4QAwn"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            isSelected: isSelected,
            onClick: onClick,
            "aria-label": formatMessage((0, (0, parcelRequire("gGI3m")).default).settingsButtonLabel),
            title: formatMessage((0, (0, parcelRequire("gGI3m")).default).settingsButton)
        });
    });
    var $2c59696bb775620b$export$2e2bcd8739ae039 = $2c59696bb775620b$var$Trigger;
});
parcelRegister("4QAwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3878591d802e976a$var$_UNSAFE_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3878591d802e976a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3878591d802e976a$var$CustomizeIcon = (props)=>$3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
        }, props));
    $3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
    var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;
});
parcelRegister("gGI3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85a34ec1433aa56b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $85a34ec1433aa56b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        settingsButton: {
            "id": "business-setting-menu.setting-menu.setting-menu-core.trigger.setting-button",
            "defaultMessage": "View settings"
        },
        settingsButtonLabel: {
            "id": "business-setting-menu.setting-menu.setting-menu-core.trigger.setting-button-label",
            "defaultMessage": "Settings actions on the view options"
        }
    });
});
parcelRegister("b6kGD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8bqGO").then(()=>parcelRequire('3bfOh'));
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments',
        DEPENDENCIES: 'dependencies',
        INCREMENT: 'increment'
    };
});
parcelRegister("73w1P", function(module, exports) {
    $parcel$export(module.exports, "FilterDropdownListNudgeAsync", ()=>$daf5d2329291861d$export$7d038d6ad1823996);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $4DpHn;
    var $2zvUh;
    const $daf5d2329291861d$var$runtimeProps = {};
    const $daf5d2329291861d$var$entryPointParams = {};
    const $daf5d2329291861d$export$7d038d6ad1823996 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("2zvUh")).filterDropdownNudgeEntrypoint), $daf5d2329291861d$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        const { ref: filterDropdownNudgeRef } = (0, (0, parcelRequire("4DpHn")).useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$5908fa8acd2c0739), true);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: filterDropdownNudgeRef
        }, props.children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
            packageName: "jiraListOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            runtimeProps: $daf5d2329291861d$var$runtimeProps
        }));
    };
});
parcelRegister("4DpHn", function(module, exports) {
    $parcel$export(module.exports, "useRegisterNudgeTarget", ()=>$d75f58749c39c26d$export$eb8a96124d659f2d);
    var $9dZ1c;
    var $e5wyW;
    var $4R6GH;
    var $9USr3;
    const $d75f58749c39c26d$export$eb8a96124d659f2d = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsw_portalled_nudge_migration_and_choreographing'), (0, (0, parcelRequire("9dZ1c")).useRegisterNudgeTarget), (0, (0, parcelRequire("9USr3")).useRegisterNudgeTarget));
});
parcelRegister("9USr3", function(module, exports) {
    $parcel$export(module.exports, "useRegisterNudgeTarget", ()=>$1aa5136c8225a4e1$export$eb8a96124d659f2d);
    $parcel$export(module.exports, "PortalledNudge", ()=>$1aa5136c8225a4e1$export$74f8d45d75dfda4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fqbGj;
    class $1aa5136c8225a4e1$var$NudgeController {
        static{
            this.instance = new $1aa5136c8225a4e1$var$NudgeController();
        }
        registerNudgeTarget(id, ref) {
            this.nudgeTargetsMap.set(id, ref);
            this.notifySubscribers(id);
            return ()=>{
                this.nudgeTargetsMap.delete(id);
            };
        }
        subscribe(id, callback) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.push(callback);
            this.subscribers.set(id, subscribers);
            return ()=>{
                const subscribersOnCleanup = this.subscribers.get(id) ?? [];
                this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
            };
        }
        notifySubscribers(id) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.forEach((subscriber)=>{
                subscriber();
            });
        }
        constructor(){
            this.nudgeTargetsMap = new Map();
            this.subscribers = new Map();
        }
    }
    const $1aa5136c8225a4e1$var$useNudgeController = ()=>$1aa5136c8225a4e1$var$NudgeController.instance;
    const $1aa5136c8225a4e1$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (shouldRegister) {
                const unregister = controller.registerNudgeTarget(id, ref);
                return ()=>{
                    unregister();
                };
            }
        }, [
            controller,
            id,
            shouldRegister
        ]);
        return {
            ref: ref
        };
    };
    const $1aa5136c8225a4e1$var$useHasNudgeTargetNode = (id)=>{
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
            const unsubscribe = controller.subscribe(id, ()=>{
                setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
            });
            return ()=>{
                unsubscribe();
            };
        }, [
            controller,
            id
        ]);
        return hasRefValue;
    };
    const $1aa5136c8225a4e1$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
        const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
        const frameId = (0, $5uXOq.useRef)(null);
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!isShown || !nudgeTarget || !nudgeContainer.current) {
                if (innerRectangle !== null) setInnerRectangle(null);
                return undefined;
            }
            const loop = ()=>{
                const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
                if (!targetRectangle) return undefined;
                const newRectangle = {
                    top: targetRectangle.top,
                    left: targetRectangle.left,
                    width: targetRectangle.width,
                    height: targetRectangle.height
                };
                if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
                else frameId.current = requestAnimationFrame(loop);
            };
            frameId.current = requestAnimationFrame(loop);
            return ()=>{
                if (frameId.current != null) cancelAnimationFrame(frameId.current);
            };
        }, [
            isShown,
            nudgeContainer,
            innerRectangle,
            nudgeTarget,
            controller.nudgeTargetsMap,
            id
        ]);
        return innerRectangle;
    };
    const $1aa5136c8225a4e1$var$usePortalContainer = ()=>{
        const nudgeContainer = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!nudgeContainer.current) {
                nudgeContainer.current = document.createElement('div');
                document.body.appendChild(nudgeContainer.current);
            }
            return ()=>{
                if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
            };
        }, []);
        return nudgeContainer;
    };
    const $1aa5136c8225a4e1$export$74f8d45d75dfda4f = (props)=>{
        const nudgeContainer = $1aa5136c8225a4e1$var$usePortalContainer();
        const hasRefValue = $1aa5136c8225a4e1$var$useHasNudgeTargetNode(props.nudgeTargetId);
        const innerRectangle = $1aa5136c8225a4e1$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
        const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
        const spotlightRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
                innerRectanglePrevious.current = innerRectangle;
                if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
            }
        }, [
            innerRectangle
        ]);
        const hasNudgeTarget = hasRefValue;
        if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'fixed',
                top: innerRectangle.top,
                left: innerRectangle.left,
                height: innerRectangle.height,
                width: innerRectangle.width,
                zIndex: props.zIndex
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fqbGj")).NudgeSpotlight), {
            ...props,
            ref: spotlightRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                height: innerRectangle.height,
                width: innerRectangle.width
            }
        }))), nudgeContainer.current);
    };
});
parcelRegister("2zvUh", function(module, exports) {
    $parcel$export(module.exports, "filterDropdownNudgeEntrypoint", ()=>$521e74bd60ef2f2c$export$5cbb00667240a7df);
    var $eufEc;
    var $fEDBv;
    const $521e74bd60ef2f2c$export$5cbb00667240a7df = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("gRNse")), {
            moduleId: "202abeae"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("gRNse", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dDVZd").then(()=>parcelRequire('2r6KU'));
});
parcelRegister("aSUiK", function(module, exports) {
    $parcel$export(module.exports, "MoreDropdownListNudgeAsync", ()=>$c87a83e41839d810$export$49ce8a5fd7f1f225);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $4DpHn;
    var $196vF;
    const $c87a83e41839d810$var$runtimeProps = {};
    const $c87a83e41839d810$var$entryPointParams = {};
    const $c87a83e41839d810$export$49ce8a5fd7f1f225 = ({ children: children })=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("196vF")).moreDropdownNudgeEntrypoint), $c87a83e41839d810$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        const { ref: filterDropdownNudgeRef } = (0, (0, parcelRequire("4DpHn")).useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$50192b0fdc9bdacf), true);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: filterDropdownNudgeRef
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
            packageName: "jiraListOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            runtimeProps: $c87a83e41839d810$var$runtimeProps
        }));
    };
});
parcelRegister("196vF", function(module, exports) {
    $parcel$export(module.exports, "moreDropdownNudgeEntrypoint", ()=>$bc9dc0fefc252a4a$export$32cd09a154d643d4);
    var $eufEc;
    var $fEDBv;
    const $bc9dc0fefc252a4a$export$32cd09a154d643d4 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("d5dP1")), {
            moduleId: "2bbbd889"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d5dP1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("022l1").then(()=>parcelRequire('f9SRM'));
});
parcelRegister("kALEJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d85a15e1832e2433$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1I7E8;
    var $8zOmE;
    var $2NMNM;
    var $g42u8;
    var $gIddQ;
    const $d85a15e1832e2433$var$GroupByDropdown = ()=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const close = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const toggle = (0, $5uXOq.useCallback)(()=>setIsOpen((wasOpen)=>!wasOpen), []);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($d85a15e1832e2433$export$5f7211d21bfdae05, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g42u8")).default), {
                popupWidth: (0, $59c3baa05de8fae5$export$8c68b096b2d5e9f6),
                onToggle: toggle
            })), [
            toggle
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gIddQ")).default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
                    toggle();
                }
            }), [
            createAnalyticsEvent,
            isOpen,
            toggle
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: close,
            placement: "bottom-end",
            content: content,
            trigger: trigger
        });
    };
    var $d85a15e1832e2433$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d85a15e1832e2433$var$GroupByDropdown);
    const $d85a15e1832e2433$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul9uuw1",
                __cmplp.className
            ])
        });
    });
});
const $59c3baa05de8fae5$export$8c68b096b2d5e9f6 = 200;
parcelRegister("g42u8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d84f5f6445ec8919$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2h2vc;
    var $lfTZh;
    var $kxZPA;
    const $d84f5f6445ec8919$var$GroupByDropdownOptions = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("5YN2R")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/header-actions/group-by-dropdown/dropdown-options/main.tsx"
    });
    var $d84f5f6445ec8919$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "group-by-dropdown-options",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2h2vc")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d84f5f6445ec8919$var$GroupByDropdownOptions, props));
});
parcelRegister("5YN2R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eLzok").then(()=>parcelRequire('b8GXi'));
});
parcelRegister("gIddQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b13f2bfafbce69f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aLbwz;
    var $hORKG;
    var $kgoHi;
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $fc0Dc;
    var $8e3Yw;
    var $7j7Ki;
    const $b13f2bfafbce69f7$var$GROUP_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aLbwz"))))), {
        label: "",
        size: "small"
    });
    const $b13f2bfafbce69f7$var$Trigger = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const groupByField = (0, (0, parcelRequire("fc0Dc")).useGetGroupByField)();
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) {
            if ((0, (0, parcelRequire("4R6GH")).fg)('list_view_a11y_aria-required-children_group_by')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                ref: ref,
                "aria-label": formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByActiveButtonAriaLabel, {
                    label: groupByField?.name
                }),
                testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
                isSelected: isSelected || groupByFieldId != null,
                onClick: onClick,
                iconAfter: groupByFieldId == null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                    label: "",
                    color: "currentColor"
                }) : undefined,
                ...otherProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                as: "span",
                columnGap: "space.075",
                alignItems: "center"
            }, groupByFieldId == null ? formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByButton) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("7j7Ki")).default).groupByActiveButton,
                values: {
                    groupByFieldId: groupByField?.name
                }
            })));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                ...otherProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                "aria-label": formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByActiveButtonAriaLabel, {
                    label: groupByField?.name
                }),
                testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
                isSelected: isSelected || groupByFieldId != null,
                onClick: onClick,
                iconAfter: groupByFieldId == null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                    label: "",
                    color: "currentColor"
                }) : undefined
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                as: "span",
                columnGap: "space.075",
                alignItems: "center"
            }, groupByFieldId == null ? formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByButton) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("7j7Ki")).default).groupByActiveButton,
                values: {
                    groupByFieldId: groupByField?.name
                }
            }))));
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_view_a11y_aria-required-children_group_by')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ref: ref,
            testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
            iconBefore: $b13f2bfafbce69f7$var$GROUP_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle",
            ...otherProps
        }, groupByFieldId == null ? formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByButton) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7j7Ki")).default).groupByActiveButtonOld,
            values: {
                groupByFieldId: groupByField?.name
            }
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            ...otherProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
            iconBefore: $b13f2bfafbce69f7$var$GROUP_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle"
        }, groupByFieldId == null ? formatMessage((0, (0, parcelRequire("7j7Ki")).default).groupByButton) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7j7Ki")).default).groupByActiveButtonOld,
            values: {
                groupByFieldId: groupByField?.name
            }
        })));
    });
    var $b13f2bfafbce69f7$export$2e2bcd8739ae039 = $b13f2bfafbce69f7$var$Trigger;
});
parcelRegister("aLbwz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7d573baeaf377068$var$_react = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7d573baeaf377068$var$_menu = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("fYy29")));
    function $7d573baeaf377068$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7d573baeaf377068$var$MenuExpandIcon = (props)=>$7d573baeaf377068$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 12m0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 16m0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 8"/></svg>`
        }, props, {
            newIcon: $7d573baeaf377068$var$_menu.default
        }));
    $7d573baeaf377068$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
    var $7d573baeaf377068$var$_default = module.exports.default = $7d573baeaf377068$var$MenuExpandIcon;
});
parcelRegister("fYy29", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ba16dbfa24557687$var$_react = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ba16dbfa24557687$var$_UNSAFE_baseNew = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ba16dbfa24557687$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ba16dbfa24557687$var$MenuIcon = (props)=>$ba16dbfa24557687$var$_react.default.createElement($ba16dbfa24557687$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
        }, props));
    $ba16dbfa24557687$var$MenuIcon.displayName = 'MenuIcon';
    var $ba16dbfa24557687$var$_default = module.exports.default = $ba16dbfa24557687$var$MenuIcon;
});
parcelRegister("7j7Ki", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86a89e86f49ce18c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86a89e86f49ce18c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        groupByButton: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-button",
            "defaultMessage": "Group"
        },
        groupByActiveButtonAriaLabel: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-aria-label",
            "defaultMessage": "Group by {label}"
        },
        groupByActiveButtonOld: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-old",
            "defaultMessage": "Group by: {groupByFieldId}"
        },
        groupByActiveButton: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button",
            "defaultMessage": "Group: {groupByFieldId}"
        },
        groupByAssignee: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-assignee",
            "defaultMessage": "Assignee"
        },
        groupByStatus: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-status",
            "defaultMessage": "Status"
        },
        groupByPriority: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-priority",
            "defaultMessage": "Priority"
        },
        groupByCategory: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-category",
            "defaultMessage": "Category"
        },
        groupByStoryPoints: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-points",
            "defaultMessage": "Story points"
        },
        groupByStoryPointEstimate: {
            "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-point-estimate",
            "defaultMessage": "Story point estimate"
        }
    });
});
parcelRegister("9WaRX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9bdd1cdbd6448dd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $imZsD;
    var $k6T4f;
    var $5Fk4Z;
    var $egmQO;
    var $cts5j;
    var $jDUax;
    var $ioD1B;
    var $eGLgs;
    var $koeKL;
    var $8TUlY;
    var $aQbWi;
    var $eg2To;
    const $c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID = 'issue-field-statistics-button-m2';
    const $c9bdd1cdbd6448dd$var$STARGATE_URL = '/gateway/api';
    const $c9bdd1cdbd6448dd$var$IssueFieldStatisticsButtonWithPulse = ()=>{
        const { getVisibleFields: getVisibleFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ rankParentIssueId: rankParentIssueId }] = (0, (0, parcelRequire("aQbWi")).useRankParent)();
        const [showPulse, setShowPulse] = (0, $5uXOq.useState)(true);
        const [isMessageActive, setIsMessageActive] = (0, $5uXOq.useState)(undefined);
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, $c9bdd1cdbd6448dd$var$STARGATE_URL, false, '', 'engagement'), [
            cloudId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            coordinationClient.start($c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID).then(setIsMessageActive);
        }, [
            coordinationClient
        ]);
        const { hierarchyLevel: hierarchyLevel, ...input } = (0, (0, parcelRequire("eg2To")).useIssuesInput)({
            groupIssueId: (0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
            parentIssueId: !(0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
        });
        const generateJqlInput = {
            ...input,
            hierarchyParent: undefined
        };
        const handlePulseStop = ()=>{
            if (showPulse) {
                coordinationClient.stop?.($c9bdd1cdbd6448dd$var$ONBOARDING_ENGAGEMENT_ID);
                setShowPulse(false);
            }
        };
        const jql = (0, (0, parcelRequire("egmQO")).generateJql)(generateJqlInput, input.parentIssue);
        return isMessageActive && showPulse ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: coordinationClient.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "issue-field-statistics-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).Pulse), {
            radius: 3,
            pulse: showPulse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cts5j")).IssueFieldStatisticsButton), {
            visibleFields: getVisibleFields(),
            jql: jql,
            stopPulse: handlePulseStop
        }))))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cts5j")).IssueFieldStatisticsButton), {
            visibleFields: getVisibleFields(),
            jql: jql
        });
    };
    var $c9bdd1cdbd6448dd$export$2e2bcd8739ae039 = $c9bdd1cdbd6448dd$var$IssueFieldStatisticsButtonWithPulse;
});
parcelRegister("cts5j", function(module, exports) {
    $parcel$export(module.exports, "IssueFieldStatisticsButton", ()=>$94460d2495d86cc9$export$38cc32afd1948a0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1LvsK;
    var $bUSNl;
    var $39xOx;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $22OQR;
    var $dCm1o;
    var $ieDtd;
    var $i90eS;
    var $vH6UY;
    var $5ea6B;
    const $94460d2495d86cc9$export$154de29b24345e19 = 'issueFieldStatisticsSidebar';
    const $94460d2495d86cc9$export$38cc32afd1948a0a = ({ jql: jql, visibleFields: visibleFields, stopPulse: stopPulse })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, closeSidebar: closeSidebar }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const selectableFields = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5ea6B")).filterStatisticFields)(visibleFields), [
            visibleFields
        ]);
        const [sidebar] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('sidebar');
        const isStatisticsSidebarOpen = (0, $5uXOq.useMemo)(()=>content?.key === $94460d2495d86cc9$export$154de29b24345e19, [
            content
        ]);
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            closeSidebar();
        }, [
            closeSidebar
        ]);
        const onError = (0, $5uXOq.useCallback)(()=>{
            const flagId = showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("i90eS")).default).errorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("i90eS")).default).errorFlagDescription),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("i90eS")).default).errorFlagContactSupportActionText),
                        href: 'https://support.atlassian.com/contact',
                        target: '_blank',
                        onClick: ()=>flagId && dismissFlag(flagId)
                    }
                ]
            });
            onCloseSidebar();
        }, [
            onCloseSidebar,
            showFlag,
            dismissFlag,
            formatMessage
        ]);
        const renderStatisticsSidebar = (0, $5uXOq.useCallback)(()=>{
            setSidebarContent((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                key: $94460d2495d86cc9$export$154de29b24345e19,
                id: "sidebarContent",
                packageName: "jiraBusinessIssueFieldStatistics",
                teamName: "helios-reports",
                onError: onError
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("vH6UY")).StatisticsSidebar), {
                selectableFields: selectableFields,
                jql: jql,
                onClose: onCloseSidebar
            })));
        }, [
            onError,
            selectableFields,
            jql,
            onCloseSidebar,
            setSidebarContent
        ]);
        const hasAutoOpened = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasAutoOpened.current && sidebar === 'statistics' && !isStatisticsSidebarOpen) {
                hasAutoOpened.current = true;
                renderStatisticsSidebar();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jira.issueFieldStatistics.openedSharedLink');
            }
        }, [
            createAnalyticsEvent,
            sidebar,
            isStatisticsSidebarOpen,
            renderStatisticsSidebar
        ]);
        const onClick = (_, analyticsEvent)=>{
            if (stopPulse) stopPulse();
            if (!isStatisticsSidebarOpen) {
                renderStatisticsSidebar();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openIssueFieldStatistics');
            } else closeSidebar();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            onClick: onClick,
            iconBefore: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1LvsK"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1LvsK"))))), {
                label: "",
                color: "currentColor"
            }),
            isSelected: isStatisticsSidebarOpen,
            "aria-label": (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? formatMessage((0, (0, parcelRequire("i90eS")).default).tooltip) : undefined,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'default' : 'subtle',
            label: formatMessage((0, (0, parcelRequire("i90eS")).default).tooltip),
            title: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? formatMessage((0, (0, parcelRequire("i90eS")).default).tooltip) : undefined
        }, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && formatMessage((0, (0, parcelRequire("i90eS")).default).chartButtonLabel));
    };
});
parcelRegister("1LvsK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1492960aa1cfc9ed$var$_react = $1492960aa1cfc9ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1492960aa1cfc9ed$var$_UNSAFE_baseNew = $1492960aa1cfc9ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $1492960aa1cfc9ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1492960aa1cfc9ed$var$ChartPieIcon = (props)=>$1492960aa1cfc9ed$var$_react.default.createElement($1492960aa1cfc9ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.25 8A7.25 7.25 0 0 0 8 .75V8z" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 1 1 8 .75M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H8V.75"/>`
        }, props));
    $1492960aa1cfc9ed$var$ChartPieIcon.displayName = 'ChartPieIcon';
    var $1492960aa1cfc9ed$var$_default = module.exports.default = $1492960aa1cfc9ed$var$ChartPieIcon;
});
parcelRegister("i90eS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7220fa4608b58393$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7220fa4608b58393$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "business-issue-field-statistics.tooltip",
            "defaultMessage": "View as chart"
        },
        errorFlagTitle: {
            "id": "business-issue-field-statistics.error-flag-title-non-final",
            "defaultMessage": "Something went wrong"
        },
        errorFlagDescription: {
            "id": "business-issue-field-statistics.error-flag-description-non-final",
            "defaultMessage": "We couldn't open the chart. Please try again or contact support."
        },
        errorFlagContactSupportActionText: {
            "id": "business-issue-field-statistics.error-flag-contact-support-action-text-non-final",
            "defaultMessage": "Contact support"
        },
        chartButtonLabel: {
            "id": "business-issue-field-statistics.chart-button-label",
            "defaultMessage": "Chart"
        }
    });
});
parcelRegister("vH6UY", function(module, exports) {
    $parcel$export(module.exports, "StatisticsSidebar", ()=>$902c52eaf170b1c9$export$20b212fbbfc9cea2);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $2x3Cb;
    var $l1N8i;
    var $lLLkM;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $8CUq3;
    var $7K5PP;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $cCFkQ;
    var $j6shD;
    var $lo35h;
    var $2yN2c;
    var $CVuCA;
    var $9QPGZ;
    var $9WcDz;
    const $902c52eaf170b1c9$export$20b212fbbfc9cea2 = ({ selectableFields: selectableFields, jql: jql, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [selectedFieldId, setSelectedFieldId] = (0, (0, parcelRequire("lo35h")).useStatisticsStorage)((0, (0, parcelRequire("cCFkQ")).SELECTED_FIELD_ID_KEY));
        const [selectedChartType, setSelectedChartType] = (0, (0, parcelRequire("lo35h")).useStatisticsStorage)((0, (0, parcelRequire("cCFkQ")).SELECTED_CHART_TYPE_KEY));
        const [, setParams] = (0, (0, parcelRequire("j6shD")).useQueryParams)();
        const selectedField = selectableFields.find((field)=>field.id === selectedFieldId);
        const selectFieldValue = selectedField ? {
            label: selectedField.name,
            value: selectedField.id
        } : null;
        const selectFieldOptions = selectableFields.map((field)=>({
                label: field.name,
                value: field.id
            }));
        (0, $5uXOq.useEffect)(()=>{
            const startTime = Date.now();
            return ()=>{
                const endTime = Date.now();
                const duration = endTime - startTime;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueFieldStatisticsSidebar open', {
                    duration: duration
                });
            };
        }, [
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                setParams((0, (0, parcelRequire("cCFkQ")).CLEAR_ALL_QUERY_PARAMS), 'replace');
            };
        }, [
            setParams
        ]);
        const onSelectField = (option)=>{
            if (!option) setSelectedFieldId(undefined);
            else setSelectedFieldId(option.value);
            setParams((0, (0, parcelRequire("cCFkQ")).CLEAR_ALL_QUERY_PARAMS), 'replace');
        };
        const onChartTypeChange = (chartType)=>{
            setSelectedChartType(chartType);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'radio changed', 'jira.issueFieldStatistics.sidebarChart', {
                chartType: chartType
            });
            setParams((0, (0, parcelRequire("cCFkQ")).CLEAR_ALL_QUERY_PARAMS), 'replace');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $902c52eaf170b1c9$var$sidebarWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $902c52eaf170b1c9$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium"
        }, formatMessage((0, (0, parcelRequire("CVuCA")).default).heading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9QPGZ")).ShareButton), {
            selectedFieldId: selectedFieldId,
            selectedChartType: selectedChartType
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))),
            label: formatMessage((0, (0, parcelRequire("CVuCA")).default).close),
            isTooltipDisabled: false,
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closeIssueFieldStatistics');
                onClose();
            }
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.250",
            xcss: $902c52eaf170b1c9$var$mainContentStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("CVuCA")).default).info)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: "issue-field-statistics-single-select"
        }, formatMessage((0, (0, parcelRequire("CVuCA")).default).selectLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            value: selectFieldValue,
            onChange: onSelectField,
            inputId: "issue-field-statistics-single-select",
            options: selectFieldOptions
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9WcDz")).StatisticsRenderer), {
            selectedFieldId: selectedFieldId,
            selectedField: selectedField,
            selectedChartType: selectedChartType,
            onChartTypeChange: onChartTypeChange,
            jql: jql
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $902c52eaf170b1c9$var$feedbackButtonWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2yN2c")).FeedbackButton), null))));
    };
    const $902c52eaf170b1c9$var$sidebarWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        paddingInline: 'space.250',
        paddingBlock: 'space.200'
    });
    const $902c52eaf170b1c9$var$mainContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1
    });
    const $902c52eaf170b1c9$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.150'
    });
    const $902c52eaf170b1c9$var$feedbackButtonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'flex-start',
        paddingBlock: 'space.100'
    });
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } })=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } })=>({
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } })=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } })=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("cCFkQ", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_NAME", ()=>$b3b7fd06c839fba8$export$6d9ce65a72493aac);
    $parcel$export(module.exports, "SELECTED_FIELD_ID_KEY", ()=>$b3b7fd06c839fba8$export$b229a6bf782d77e7);
    $parcel$export(module.exports, "SELECTED_CHART_TYPE_KEY", ()=>$b3b7fd06c839fba8$export$c4ec2849fcb32515);
    $parcel$export(module.exports, "CLEAR_ALL_QUERY_PARAMS", ()=>$b3b7fd06c839fba8$export$1816113812ed602d);
    var $e4eHl = parcelRequire("e4eHl");
    const $b3b7fd06c839fba8$export$6d9ce65a72493aac = 'statistics';
    const $b3b7fd06c839fba8$export$ace847e3912a65bb = 'sidebar';
    const $b3b7fd06c839fba8$export$d86c59472ec0686f = 'statistics';
    const $b3b7fd06c839fba8$export$b229a6bf782d77e7 = 'selected-field-id';
    const $b3b7fd06c839fba8$export$c4ec2849fcb32515 = 'selected-chart-type';
    const $b3b7fd06c839fba8$export$70a91e824238865d = (0, ($parcel$interopDefault($e4eHl)))($b3b7fd06c839fba8$export$b229a6bf782d77e7);
    const $b3b7fd06c839fba8$export$60179bff81db3578 = (0, ($parcel$interopDefault($e4eHl)))($b3b7fd06c839fba8$export$c4ec2849fcb32515);
    const $b3b7fd06c839fba8$export$1816113812ed602d = Object.freeze({
        [$b3b7fd06c839fba8$export$ace847e3912a65bb]: undefined,
        [$b3b7fd06c839fba8$export$70a91e824238865d]: undefined,
        [$b3b7fd06c839fba8$export$60179bff81db3578]: undefined
    });
});
parcelRegister("j6shD", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$29baf9ca76d383e1$export$b37ee0d76c6d2fbc);
    var $lODMY;
    const $29baf9ca76d383e1$var$useQuery = (0, (0, parcelRequire("lODMY")).createRouterSelector)((o)=>o.query);
    const $29baf9ca76d383e1$export$b37ee0d76c6d2fbc = ()=>{
        const routerStoreActions = (0, (0, parcelRequire("lODMY")).useRouterStoreActions)();
        const query = $29baf9ca76d383e1$var$useQuery();
        return [
            query,
            routerStoreActions.updateQueryParam
        ];
    };
});
parcelRegister("lo35h", function(module, exports) {
    $parcel$export(module.exports, "useStatisticsStorage", ()=>$f9065a10e234aa7b$export$a13d038d4f793f75);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $54qG5;
    var $47u1P;
    var $90yGq;
    var $ieDtd;
    var $cDCY0;
    var $1vKDd;
    const $f9065a10e234aa7b$export$a13d038d4f793f75 = (namespace)=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        if ((0, (0, parcelRequire("cDCY0")).isKebabCase)(namespace) === false) throw new Error('localStorageNamespace must be in kebab-case');
        const queryParamNamespace = (0, ($parcel$interopDefault($e4eHl)))(namespace);
        const [queryValue] = (0, (0, parcelRequire("ieDtd")).useQueryParam)(queryParamNamespace);
        const [initialQueryValue, setInitialQueryValue] = (0, $5uXOq.useState)(queryValue);
        const [localValue, setLocalValue] = (0, (0, parcelRequire("47u1P")).useLocalStorageWithExpiry)(`${(0, (0, parcelRequire("1vKDd")).NAMESPACE_PREFIX)}-${namespace}`, `${accountId}-${entity.id}`, (0, (0, parcelRequire("1vKDd")).DAY_IN_MS) * 30);
        (0, $5uXOq.useEffect)(()=>{
            if (initialQueryValue) {
                setLocalValue(initialQueryValue);
                setInitialQueryValue(undefined);
            }
        }, [
            initialQueryValue,
            setLocalValue
        ]);
        return [
            initialQueryValue ?? localValue,
            setLocalValue
        ];
    };
});
parcelRegister("47u1P", function(module, exports) {
    $parcel$export(module.exports, "useLocalStorage", ()=>$4772a73a96e71e67$export$86e2cef2561044ac);
    $parcel$export(module.exports, "useLocalStorageWithExpiry", ()=>$4772a73a96e71e67$export$9c89ac8256e92fbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSSG7;
    const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
    const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)(namespace);
        const initialValue = localStorage.get(key) ?? options?.defaultValue;
        const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
        const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
            if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
                const newVal = setStateAction(prevVal);
                localStorage.set(key, newVal);
                return newVal;
            });
            else {
                localStorage.set(key, setStateAction);
                setValueInState(setStateAction);
            }
        }, [
            key,
            localStorage
        ]);
        return [
            value,
            setValue
        ];
    };
    const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalExpirableStorageProvider)(namespace);
        const initialValue = localStorage.get(key) ?? options?.defaultValue;
        const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
        const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
            if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
                const newVal = setStateAction(prevVal);
                localStorage.set(key, newVal, Date.now() + ttlInMs);
                return newVal;
            });
            else {
                localStorage.set(key, setStateAction, Date.now() + ttlInMs);
                setValueInState(setStateAction);
            }
        }, [
            key,
            localStorage,
            ttlInMs
        ]);
        return [
            value,
            setValue
        ];
    };
    const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
        const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
        return [
            state,
            (objectKey, value)=>setState((prevState)=>({
                        ...prevState,
                        [objectKey]: value
                    }))
        ];
    };
    const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
        const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
        return [
            state,
            (objectKey, value)=>setState((prevState)=>({
                        ...prevState,
                        [objectKey]: value
                    }))
        ];
    };
});
parcelRegister("cDCY0", function(module, exports) {
    $parcel$export(module.exports, "isKebabCase", ()=>$2de7658afb9aad88$export$8f62caee7325c0cd);
    const $2de7658afb9aad88$export$8f62caee7325c0cd = (value)=>{
        const kebabCaseRegex = /^[a-z]+(-[a-z]+)*$/;
        return kebabCaseRegex.test(value);
    };
});
parcelRegister("1vKDd", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE_PREFIX", ()=>$c31e62345861442d$export$44f66d558865bced);
    $parcel$export(module.exports, "DAY_IN_MS", ()=>$c31e62345861442d$export$8217db641c4c0a89);
    const $c31e62345861442d$export$44f66d558865bced = 'jira-list-view-statistics';
    const $c31e62345861442d$export$8217db641c4c0a89 = 86400000;
});
parcelRegister("2yN2c", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$be6e18fccf4b60db$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $3g1Fk;
    var $jPxJ7;
    var $koVbs;
    var $aoWZv;
    const $be6e18fccf4b60db$var$FEEDBACK_GROUP_ID = 'list-view-issue-field-statistics-feedback';
    const $be6e18fccf4b60db$export$116fedbe5e2e2bd8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const openFeedbackModal = (0, (0, parcelRequire("jPxJ7")).useFeedbackCollector)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            openFeedbackModal($be6e18fccf4b60db$var$FEEDBACK_GROUP_ID);
        }, [
            openFeedbackModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            spacing: "default",
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("3g1Fk"))))),
            onClick: onClick,
            appearance: "subtle"
        }, formatMessage((0, (0, parcelRequire("aoWZv")).default).feedback));
    };
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("aoWZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69734258dffcaf4b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $69734258dffcaf4b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedback: {
            "id": "business-issue-field-statistics.statistics-sidebar.feedback-button.feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("CVuCA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65d3f105302a27fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $65d3f105302a27fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "business-issue-field-statistics.statistics-sidebar.heading",
            "defaultMessage": "View this list as a chart"
        },
        info: {
            "id": "business-issue-field-statistics.statistics-sidebar.info",
            "defaultMessage": "Select the data you'd like to see in a chart."
        },
        close: {
            "id": "business-issue-field-statistics.statistics-sidebar.close",
            "defaultMessage": "Close"
        },
        selectLabel: {
            "id": "business-issue-field-statistics.statistics-sidebar.select-label",
            "defaultMessage": "Field"
        }
    });
});
parcelRegister("9QPGZ", function(module, exports) {
    $parcel$export(module.exports, "ShareButton", ()=>$ce79709f25dbb335$export$e980dfbc2840e8bc);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $btivG;
    var $eE13R;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $8zOmE;
    var $cCFkQ;
    var $byNIx;
    var $fkf2G;
    const $ce79709f25dbb335$export$38b2d434cce3ea22 = ()=>window;
    const $ce79709f25dbb335$var$PopupContent = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ce79709f25dbb335$var$popupContentContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
        }), "\xa0", formatMessage((0, (0, parcelRequire("byNIx")).default).linkCopiedPopup));
    };
    const $ce79709f25dbb335$export$e980dfbc2840e8bc = ({ selectedFieldId: selectedFieldId, selectedChartType: selectedChartType })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClipboardError = (0, (0, parcelRequire("fkf2G")).useClipboardError)();
        const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
        const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            if (!selectedFieldId) return null;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'jira.issueFieldStatistics.shareButton', {
                fieldId: selectedFieldId,
                selectedChartType: selectedChartType
            });
            const currentWindow = $ce79709f25dbb335$export$38b2d434cce3ea22();
            const currentNavigator = currentWindow?.navigator;
            if (typeof currentNavigator !== 'undefined') {
                const currentUrl = new URL(currentWindow.location.href);
                currentUrl.searchParams.set('sidebar', (0, (0, parcelRequire("cCFkQ")).SIDEBAR_NAME));
                currentUrl.searchParams.set('selectedFieldId', selectedFieldId);
                if (selectedChartType) currentUrl.searchParams.set('selectedChartType', selectedChartType);
                const urlString = currentUrl.toString().replace(/\/(?=\?)/, '');
                currentNavigator.clipboard.writeText(urlString).catch((err)=>{
                    onClipboardError(err);
                });
                setIsCopied(true);
            } else onClipboardError(new Error('Clipboard is not supported'));
        }, [
            selectedFieldId,
            selectedChartType,
            onClipboardError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let timeout;
            if (isCopied) timeout = setTimeout(()=>{
                setIsCopied(false);
            }, 3000);
            return ()=>clearTimeout(timeout);
        }, [
            isCopied
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isCopied,
            onClose: ()=>setIsCopied(false),
            placement: "top-start",
            content: $ce79709f25dbb335$var$PopupContent,
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...triggerProps,
                    appearance: "subtle",
                    isDisabled: selectedFieldId === undefined,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("eE13R"))))),
                    label: formatMessage((0, (0, parcelRequire("byNIx")).default).share),
                    isTooltipDisabled: false,
                    onClick: onClick
                })
        });
    };
    const $ce79709f25dbb335$var$popupContentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200'
    });
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("byNIx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad9cd037fbf50263$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ad9cd037fbf50263$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "business-issue-field-statistics.statistics-sidebar.share-button.share-non-final",
            "defaultMessage": "Share this chart"
        },
        errorFlagTitle: {
            "id": "business-issue-field-statistics.error-flag-title-non-final",
            "defaultMessage": "Something went wrong"
        },
        errorFlagDescription: {
            "id": "business-issue-field-statistics.error-flag-description-non-final",
            "defaultMessage": "We were unable to copy the link to clipboard. Please try again or contact support."
        },
        errorFlagContactSupportActionText: {
            "id": "business-issue-field-statistics.error-flag-contact-support-action-text-non-final",
            "defaultMessage": "Contact support"
        },
        linkCopiedPopup: {
            "id": "business-issue-field-statistics.statistics-sidebar.share-button.link-copied-popup",
            "defaultMessage": "Link copied to clipboard"
        }
    });
});
parcelRegister("fkf2G", function(module, exports) {
    $parcel$export(module.exports, "useClipboardError", ()=>$9c0131d4da6fa20d$export$90a150a33a5e5322);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $byNIx;
    const $9c0131d4da6fa20d$export$90a150a33a5e5322 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: (0, $d290b8794b3d33dc$export$f3390a0e172fee41),
                    packageName: (0, $d290b8794b3d33dc$export$b8b9d90f9e5bd72b),
                    teamName: (0, $d290b8794b3d33dc$export$d57b6b390e78d90f)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            const flagId = showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("byNIx")).default).errorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("byNIx")).default).errorFlagDescription),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("byNIx")).default).errorFlagContactSupportActionText),
                        href: 'https://support.atlassian.com/contact',
                        target: '_blank',
                        onClick: ()=>flagId && dismissFlag(flagId)
                    }
                ]
            });
        }, [
            showFlag,
            dismissFlag,
            formatMessage
        ]);
    };
});
const $d290b8794b3d33dc$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $d290b8794b3d33dc$export$f3390a0e172fee41 = 'copyToClipboard';
const $d290b8794b3d33dc$export$d57b6b390e78d90f = 'helios-reports';
parcelRegister("9WcDz", function(module, exports) {
    $parcel$export(module.exports, "StatisticsRenderer", ()=>$a8b3cccaa9cf6f30$export$94ae349d8c6a2871);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $bUSNl;
    var $koVbs;
    var $hjYzz;
    var $Ogg4Q;
    var $nfUJy;
    var $iXVV6;
    var $1ovIw;
    const $a8b3cccaa9cf6f30$var$shouldShowSingleSelectChart = (visualRepresentation)=>visualRepresentation === 'SINGLE_SELECT_CHART';
    const $a8b3cccaa9cf6f30$var$shouldShowStatisticsTable = (visualRepresentation)=>visualRepresentation === 'STATISTICS_TABLE';
    const $a8b3cccaa9cf6f30$var$calculateSingleSelectChartWidth = (sidebarWidth)=>sidebarWidth - (0, $03857339d4f662fa$export$eb686c593382b322) - (0, $03857339d4f662fa$export$6b0a922783b1a3e9);
    const $a8b3cccaa9cf6f30$var$getVisualRepresentation = (selectedField)=>{
        if (selectedField === undefined) return 'NONE';
        switch(selectedField?.__typename){
            case 'JiraNumberField':
                return 'STATISTICS_TABLE';
            default:
                return 'SINGLE_SELECT_CHART';
        }
    };
    const $a8b3cccaa9cf6f30$export$94ae349d8c6a2871 = ({ selectedFieldId: selectedFieldId, selectedField: selectedField, selectedChartType: selectedChartType, onChartTypeChange: onChartTypeChange, jql: jql })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ sidebarWidth: sidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const visualRepresentation = $a8b3cccaa9cf6f30$var$getVisualRepresentation(selectedField);
        if (selectedField) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: {
                fieldId: selectedField.id
            }
        }, $a8b3cccaa9cf6f30$var$shouldShowSingleSelectChart(visualRepresentation) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("nfUJy")).SingleSelectChartContainer), {
            customFieldId: selectedField.id,
            query: jql,
            width: $a8b3cccaa9cf6f30$var$calculateSingleSelectChartWidth(sidebarWidth),
            chartType: selectedChartType || 'DONUT_CHART',
            onChartTypeChange: onChartTypeChange
        }), $a8b3cccaa9cf6f30$var$shouldShowStatisticsTable(visualRepresentation) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ogg4Q")).NumericStatsContainer), {
            customFieldId: selectedField.id,
            query: jql
        })));
        if (selectedFieldId !== undefined && selectedField === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjYzz")).SidebarError), {
            errorMessage: formatMessage((0, (0, parcelRequire("1ovIw")).default).noFieldSelectedError)
        }));
        return null;
    };
});
parcelRegister("hjYzz", function(module, exports) {
    $parcel$export(module.exports, "SidebarError", ()=>$736638b4717f96ff$export$6a393cdd679621ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    const $736638b4717f96ff$export$6a393cdd679621ef = ({ errorMessage: errorMessage })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            xcss: $736638b4717f96ff$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            align: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            primaryColor: "var(--ds-icon-warning, #E56910)",
            size: "small",
            label: ""
        }), errorMessage));
    };
    const $736638b4717f96ff$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.800',
        paddingBottom: 'space.800'
    });
});
parcelRegister("Ogg4Q", function(module, exports) {
    $parcel$export(module.exports, "NumericStatsContainer", ()=>$6f6237d6d746be60$export$82a560ce398a7de0);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $koH6I;
    var $a5Nyt;
    var $8eVJ6;
    const $6f6237d6d746be60$export$82a560ce398a7de0 = ({ customFieldId: customFieldId, query: query })=>{
        const [{ loading: loading, data: data, error: error }] = (0, (0, parcelRequire("a5Nyt")).useNumberFieldStatistics)({
            customFieldId: customFieldId,
            query: query
        });
        const isDataEmpty = data?.count === 0 || data?.min === undefined && data?.max === undefined && data?.sum === undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koH6I")).SidebarDataHandler), {
            error: error,
            loading: loading,
            data: data,
            isEmpty: isDataEmpty
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            sourceName: "jira.issueFieldStatistics.numericStats"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), data && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8eVJ6")).NumericStatsTable), {
            data: data
        })));
    };
});
parcelRegister("koH6I", function(module, exports) {
    $parcel$export(module.exports, "SidebarDataHandler", ()=>$96f7b5e008f1c0d5$export$1bc4d26c70cb89fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4yMr;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $eZJjh;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $hjYzz;
    var $3m0tF;
    const $96f7b5e008f1c0d5$export$1bc4d26c70cb89fb = ({ data: data, loading: loading, error: error, isEmpty: isEmpty, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjYzz")).SidebarError), {
            errorMessage: formatMessage((0, (0, parcelRequire("3m0tF")).default).error, {
                link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                        href: "https://support.atlassian.com/contact",
                        appearance: "default"
                    }, chunks)
            })
        });
        if (loading || !data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            alignItems: "center",
            xcss: $96f7b5e008f1c0d5$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "xlarge",
            label: formatMessage((0, (0, parcelRequire("3m0tF")).default).spinnerLabel)
        }));
        if (isEmpty) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            sourceName: "jira.issueFieldStatistics.emptyState"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            alignItems: "center",
            xcss: $96f7b5e008f1c0d5$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "bold",
            align: "center"
        }, formatMessage((0, (0, parcelRequire("3m0tF")).default).noData))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        return children;
    };
    const $96f7b5e008f1c0d5$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.800',
        paddingBottom: 'space.800'
    });
});
parcelRegister("3m0tF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c43f3777cdc7ba5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7c43f3777cdc7ba5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "issue-field-statistics.numeric-stats-container.error-non-final",
            "defaultMessage": " We couldn't load your data. Try again or <link>contact support</link>."
        },
        spinnerLabel: {
            "id": "issue-field-statistics.common.async-handler.spinner-label",
            "defaultMessage": "Loading"
        },
        noData: {
            "id": "issue-field-statistics.common.async-handler.no-data",
            "defaultMessage": "No data available"
        }
    });
});
parcelRegister("a5Nyt", function(module, exports) {
    $parcel$export(module.exports, "useNumberFieldStatistics", ()=>$2403cb90302dff68$export$5adbcf6eb1301c8d);
    var $iuEfD;
    var $48DMb;
    const $2403cb90302dff68$var$getNumberFieldStatistics = async ({ customFieldId: customFieldId, query: jql, fetchOptions: fetchOptions = {} })=>{
        const query = new URLSearchParams({
            query: jql
        });
        const url = `/rest/internal/list-view-chart/number/${customFieldId}?${query.toString()}`;
        return (0, (0, parcelRequire("48DMb")).fetchJson)(url, fetchOptions);
    };
    const $2403cb90302dff68$export$5adbcf6eb1301c8d = ({ customFieldId: customFieldId, query: query })=>(0, (0, parcelRequire("iuEfD")).useFetch)({
            onFetch: async (fetchOptions)=>$2403cb90302dff68$var$getNumberFieldStatistics({
                    customFieldId: customFieldId,
                    query: query,
                    fetchOptions: fetchOptions
                }),
            analyticsTracking: {
                actionSubject: `useFetch.${(0, $053a7e7c0b960d07$export$8d4ac56f443fb551)}`,
                packageName: (0, $053a7e7c0b960d07$export$b8b9d90f9e5bd72b),
                action: 'dataFetch'
            },
            loggingKey: `${(0, $053a7e7c0b960d07$export$b8b9d90f9e5bd72b)}.${(0, $053a7e7c0b960d07$export$8d4ac56f443fb551)}`,
            isAutoFetchable: true
        }, [
            customFieldId,
            query
        ]);
});
parcelRegister("iuEfD", function(module, exports) {
    $parcel$export(module.exports, "useFetch", ()=>$082fa94a7a9fe60c$export$d852f5f778460fa4);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $aAhmV;
    var $d6Xq4;
    var $bYINM;
    var $lUlda;
    var $dg0bO;
    var $eW4Xh;
    const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
        const [state, dispatch] = (0, $5uXOq.useReducer)((0, (0, parcelRequire("bYINM")).reducer), {
            ...(0, (0, parcelRequire("dg0bO")).initialState),
            data: initialData
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { initialized: initialized, fetched: fetched, loading: loading } = state;
        const abortControllerRef = (0, $5uXOq.useRef)();
        const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
        const isMounted = (0, $5uXOq.useRef)(true);
        const getAbortController = (0, $5uXOq.useCallback)(()=>{
            const controller = abortControllerRef.current;
            if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
            return abortControllerRef.current;
        }, []);
        const callFetch = (0, $5uXOq.useCallback)((...args)=>{
            const { signal: signal } = getAbortController();
            (0, (0, parcelRequire("eW4Xh")).thunks).fetch({
                onFetch: async ()=>{
                    try {
                        return await onFetch({
                            signal: signal
                        }, ...args);
                    } catch (e) {
                        throw new (0, (0, parcelRequire("d6Xq4")).UseFetchHandledError)(isMounted.current, e);
                    }
                },
                analyticsTracking: analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent,
                browserMetricsKey: browserMetricsKey,
                loggingKey: loggingKey,
                signal: signal
            })({
                actions: (0, (0, parcelRequire("aAhmV")).buildActionDispatchers)(dispatch)
            });
        }, [
            onFetch,
            analyticsTracking,
            browserMetricsKey,
            createAnalyticsEvent,
            loggingKey,
            getAbortController
        ]);
        const doAbort = (0, $5uXOq.useCallback)(()=>{
            if (isAbortable) getAbortController().abort();
        }, [
            getAbortController,
            isAbortable
        ]);
        const doFetch = (0, $5uXOq.useCallback)((...args)=>{
            if (loading) doAbort();
            callFetch(...args);
        }, [
            loading,
            callFetch,
            doAbort
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const hasEffectsChanged = (0, (0, parcelRequire("lUlda")).isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
            if (!initialized && !fetched || hasEffectsChanged) {
                if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
                if (hasEffectsChanged) doAbort();
                if (isAutoFetchable) callFetch();
                else if (initialized && hasEffectsChanged) dispatch({
                    type: 'resetInitialState',
                    payload: null
                });
            }
        }, [
            initialized,
            doAbort,
            fetched,
            callFetch,
            isAutoFetchable,
            ...fetchDependencies
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
                doAbort();
            };
        }, [
            doAbort
        ]);
        return [
            state,
            {
                doFetch: doFetch,
                doAbort: doAbort
            }
        ];
    };
});
parcelRegister("aAhmV", function(module, exports) {
    $parcel$export(module.exports, "buildActionDispatchers", ()=>$b5443ab87e9d487f$export$5297818927df1cbf);
    var $aTJxm;
    const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>Object.keys((0, (0, parcelRequire("aTJxm")).strategies)).reduce((accumulator, strategy)=>{
            accumulator[strategy] = (payload)=>dispatch({
                    type: strategy,
                    payload: payload
                });
            return accumulator;
        }, {});
    const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>Object.keys((0, (0, parcelRequire("aTJxm")).strategies)).reduce((accumulator, strategy)=>{
            accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                    const state = getState();
                    const sliceState = state.fetchables[key] || initialData;
                    const nextSliceState = (0, (0, parcelRequire("aTJxm")).strategies)[strategy](sliceState, {
                        type: strategy,
                        payload: payload
                    });
                    const nextState = {
                        ...state,
                        fetchables: {
                            ...state.fetchables,
                            [key]: nextSliceState
                        }
                    };
                    setState(nextState);
                };
            return accumulator;
        }, {});
    const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>Object.keys(actions).reduce((accumulator, strategy)=>{
            const actionExecutor = actions[strategy];
            accumulator[strategy] = (payload)=>{
                actionExecutor(key, initialData, payload);
            };
            return accumulator;
        }, {});
});
parcelRegister("aTJxm", function(module, exports) {
    $parcel$export(module.exports, "strategies", ()=>$e708554df9e0cc9d$export$c5491a8691a23b9e);
    var $dg0bO;
    const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, (0, parcelRequire("dg0bO")).initialState);
    const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
            ...state,
            initialized: true,
            loading: true,
            fetched: false,
            hasError: false,
            aborted: false
        });
    const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
            initialized: true,
            loading: false,
            fetched: true,
            hasError: false,
            aborted: false,
            data: action.payload
        });
    const $e708554df9e0cc9d$var$setError = (_, action)=>({
            error: action.payload,
            initialized: true,
            loading: false,
            fetched: false,
            hasError: true,
            aborted: false
        });
    const $e708554df9e0cc9d$var$setAborted = ()=>({
            initialized: true,
            loading: false,
            fetched: false,
            hasError: false,
            aborted: true
        });
    const $e708554df9e0cc9d$var$setDefault = (state)=>state;
    const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
        resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
        setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
        setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
        setError: $e708554df9e0cc9d$var$setError,
        setAborted: $e708554df9e0cc9d$var$setAborted,
        default: $e708554df9e0cc9d$var$setDefault
    };
});
parcelRegister("dg0bO", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$147c98f07a60815a$export$d4c72bab9d6cc13a);
    const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
        initialized: false,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: false,
        error: undefined,
        data: undefined
    };
});
parcelRegister("d6Xq4", function(module, exports) {
    $parcel$export(module.exports, "UseFetchHandledError", ()=>$7de9d917d4a5c394$export$2801d9c787d65a99);
    class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
        constructor(componentMounted, e){
            super(e?.message || 'Unknown');
            this.originalError = e;
            this.componentMounted = !!componentMounted;
        }
    }
});
parcelRegister("bYINM", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$82dfd012f8e9e396$export$1650419e431d3ba3);
    var $aTJxm;
    var $dg0bO;
    const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, (0, parcelRequire("dg0bO")).initialState), action)=>{
        const transformer = (0, (0, parcelRequire("aTJxm")).strategies)[action.type] || (0, (0, parcelRequire("aTJxm")).strategies).default;
        return transformer(state, action);
    };
});
parcelRegister("lUlda", function(module, exports) {
    $parcel$export(module.exports, "isShallowDifferent", ()=>$76bb872f5000fbec$export$a42e2ec7d66a0c03);
    const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
});
parcelRegister("eW4Xh", function(module, exports) {
    $parcel$export(module.exports, "thunks", ()=>$4eddb453cf1aa4e2$export$eb2332b8a94a914a);
    var $eUcR1;
    var $dTD3b;
    var $7lFwJ;
    const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
        fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
            const metricsTracker = (0, (0, parcelRequire("eUcR1")).trackBrowserMetricsForJira)({
                browserMetricsKey: browserMetricsKey
            });
            const logger = (0, (0, parcelRequire("7lFwJ")).loggingHandler)({
                loggingKey: loggingKey
            });
            return async ({ actions: actions })=>{
                const analyticsTracker = (0, (0, parcelRequire("dTD3b")).trackDataFetchAnalytics)({
                    ...analyticsTracking,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                metricsTracker.start();
                analyticsTracker.start();
                actions.setFetchStart();
                try {
                    const data = await onFetch({
                        signal: signal
                    });
                    actions.setFetchEnd(data);
                    metricsTracker.end();
                    analyticsTracker.succeeded();
                } catch (e) {
                    metricsTracker.cancel();
                    if (e.componentMounted) {
                        if (signal.aborted) {
                            actions.setAborted();
                            analyticsTracker.aborted();
                        } else {
                            const thrownError = e.originalError;
                            actions.setError(thrownError);
                            analyticsTracker.failed(thrownError);
                            logger.error(thrownError);
                        }
                    }
                }
            };
        }
    };
});
parcelRegister("eUcR1", function(module, exports) {
    $parcel$export(module.exports, "trackBrowserMetricsForJira", ()=>$ce81c3c268f844ac$export$d8b2320f7d41dc1d);
    var $dGrdR;
    var $30KM0;
    const $ce81c3c268f844ac$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: histogram })=>{
        if (browserMetricsKey === null || browserMetricsKey === undefined) return {
            start: ()=>{},
            end: ()=>{},
            cancel: ()=>{}
        };
        const bm3MetricsTracker = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: browserMetricsKey,
            histogram: {
                result: histogram || (0, (0, parcelRequire("30KM0")).DEFAULT_HISTOGRAM_BUCKETS)
            }
        });
        const startHandler = ()=>{
            bm3MetricsTracker.start();
        };
        const endHandler = ()=>{
            bm3MetricsTracker.stop({
                customData: attributes
            });
        };
        const cancelHandler = ()=>{
            bm3MetricsTracker.cancel();
        };
        return {
            start: startHandler,
            end: endHandler,
            cancel: cancelHandler
        };
    };
});
parcelRegister("30KM0", function(module, exports) {
    $parcel$export(module.exports, "STORE_NAME", ()=>$b92906e2cd9ec8a5$export$cd79d01fb3d2f506);
    $parcel$export(module.exports, "experiences", ()=>$b92906e2cd9ec8a5$export$9848ee2a7d21002f);
    $parcel$export(module.exports, "TIMEOUT_IN_MS", ()=>$b92906e2cd9ec8a5$export$9ebf97d10ce21f3b);
    $parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", ()=>$b92906e2cd9ec8a5$export$e3b77a602bc4d0e6);
    const $b92906e2cd9ec8a5$export$cd79d01fb3d2f506 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.experience-tracker-store`;
    const $b92906e2cd9ec8a5$export$9848ee2a7d21002f = {
        RENDER: 'render'
    };
    const $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b = 7000;
    const $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';
});
const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;
parcelRegister("dTD3b", function(module, exports) {
    $parcel$export(module.exports, "trackDataFetchAnalytics", ()=>$e920ac60c98f1376$export$bc65acfb4b442c00);
    var $jcw0u;
    var $jJZqs;
    var $fZneA;
    var $8zOmE;
    var $93kZ7;
    const $e920ac60c98f1376$export$d14e9b22afc87cb3 = (statusCode)=>{
        if (statusCode === null) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).UNKNOWN;
        if (statusCode >= 100 && statusCode <= 199) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).INFORMATIONAL_RESPONSES;
        if (statusCode >= 200 && statusCode <= 299) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).SUCCESS_RESPONSES;
        if (statusCode >= 300 && statusCode <= 399) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).REDIRECTS;
        if (statusCode >= 400 && statusCode <= 499) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).CLIENT_ERRORS;
        if (statusCode >= 500 && statusCode <= 599) return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).SERVER_ERRORS;
        return (0, (0, parcelRequire("93kZ7")).statusCodeGroups).UNKNOWN;
    };
    const $e920ac60c98f1376$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
    const $e920ac60c98f1376$var$noopAnalytics = Object.freeze({
        start: ()=>{},
        succeeded: ()=>{},
        failed: ()=>{},
        aborted: ()=>{}
    });
    const $e920ac60c98f1376$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
        if (actionSubject == null) return $e920ac60c98f1376$var$noopAnalytics;
        if (sampleRate != null && !$e920ac60c98f1376$var$includeSample(sampleRate)) return $e920ac60c98f1376$var$noopAnalytics;
        const actionSubjectAndAction = `${actionSubject} ${action}`;
        return Object.freeze({
            start: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    status: (0, (0, parcelRequire("93kZ7")).analyticsStatuses).STARTED,
                    packageName: packageName
                });
            },
            succeeded: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: '2xx',
                    status: (0, (0, parcelRequire("93kZ7")).analyticsStatuses).SUCCEEDED,
                    packageName: packageName
                });
            },
            failed: (e)=>{
                const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
                if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(e)) {
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                        statusCodeGroup: $e920ac60c98f1376$export$d14e9b22afc87cb3(error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error.statusCode : -1),
                        status: (0, (0, parcelRequire("93kZ7")).analyticsStatuses).FAILED,
                        packageName: packageName
                    });
                    return;
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: actionSubject,
                        packageName: packageName
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            aborted: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    status: (0, (0, parcelRequire("93kZ7")).analyticsStatuses).ABORTED,
                    packageName: packageName
                });
            }
        });
    };
});
parcelRegister("93kZ7", function(module, exports) {
    $parcel$export(module.exports, "statusCodeGroups", ()=>$88683eadd8082ef6$export$fddea1bcaead87d5);
    $parcel$export(module.exports, "analyticsStatuses", ()=>$88683eadd8082ef6$export$f0fa81eb65b496a1);
    const $88683eadd8082ef6$export$fddea1bcaead87d5 = {
        INFORMATIONAL_RESPONSES: '1xx',
        SUCCESS_RESPONSES: '2xx',
        REDIRECTS: '3xx',
        CLIENT_ERRORS: '4xx',
        SERVER_ERRORS: '5xx',
        UNKNOWN: 'unknown'
    };
    const $88683eadd8082ef6$export$f0fa81eb65b496a1 = {
        SUCCEEDED: 'succeeded',
        FAILED: 'failed',
        ABORTED: 'aborted',
        STARTED: 'started'
    };
});
parcelRegister("7lFwJ", function(module, exports) {
    $parcel$export(module.exports, "loggingHandler", ()=>$81689b1ad2d5cba4$export$f35316da257b76e4);
    var $dJl1T;
    var $fZneA;
    const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
        if (loggingKey === null || loggingKey === undefined) return {
            error: ()=>{}
        };
        const errorHandler = (thrownError)=>{
            if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(thrownError)) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
        };
        return {
            error: errorHandler
        };
    };
});
parcelRegister("48DMb", function(module, exports) {
    $parcel$export(module.exports, "fetchJson", ()=>$cfd862e6e9d86034$export$6d71b655afe1638d);
    var $7f4tk;
    var $3wzQ9;
    const $cfd862e6e9d86034$export$6d71b655afe1638d = async (url, options = {})=>(0, (0, parcelRequire("7f4tk")).default)(url, options).catch((error)=>{
            throw new (0, (0, parcelRequire("3wzQ9")).FetchUrlError)(url, error);
        });
});
parcelRegister("3wzQ9", function(module, exports) {
    $parcel$export(module.exports, "FetchUrlError", ()=>$f57667a2adaf29d3$export$5cdfc90b27d7ab6c);
    var $jJZqs;
    var $fZneA;
    var $bw7Gm;
    var $kFy8J;
    const $f57667a2adaf29d3$var$getStatusCodeGroup = (statusCode)=>{
        if (statusCode === null) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).UNKNOWN;
        if (statusCode >= 100 && statusCode <= 199) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).INFORMATIONAL_RESPONSES;
        if (statusCode >= 200 && statusCode <= 299) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).SUCCESS_RESPONSES;
        if (statusCode >= 300 && statusCode <= 399) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).REDIRECTS;
        if (statusCode >= 400 && statusCode <= 499) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).CLIENT_ERRORS;
        if (statusCode >= 500 && statusCode <= 599) return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).SERVER_ERRORS;
        return (0, (0, parcelRequire("kFy8J")).statusCodeGroups).UNKNOWN;
    };
    const $f57667a2adaf29d3$var$stringifySafe = (obj)=>{
        try {
            return JSON.stringify(obj);
        } catch  {
            return null;
        }
    };
    class $f57667a2adaf29d3$export$5cdfc90b27d7ab6c extends (0, (0, parcelRequire("jJZqs")).default) {
        constructor(url, fetchError){
            if (fetchError instanceof (0, (0, parcelRequire("jJZqs")).default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
            else super(-1, fetchError.message);
            this.name = 'FetchUrlError';
            this.url = (0, (0, parcelRequire("bw7Gm")).default)(url);
            this.aborted = fetchError.name === (0, (0, parcelRequire("jJZqs")).ABORT_ERROR_NAME);
            this.isClientError = (0, (0, parcelRequire("fZneA")).isClientFetchError)(fetchError) || this.statusCode === -1;
            this.statusCodeGroup = $f57667a2adaf29d3$var$getStatusCodeGroup(fetchError instanceof (0, (0, parcelRequire("jJZqs")).default) ? fetchError.statusCode : null);
            this.cause = $f57667a2adaf29d3$var$stringifySafe(fetchError);
        }
    }
});
parcelRegister("kFy8J", function(module, exports) {
    $parcel$export(module.exports, "statusCodeGroups", ()=>$cb89e2c05d3c28e8$export$fddea1bcaead87d5);
    const $cb89e2c05d3c28e8$export$fddea1bcaead87d5 = {
        INFORMATIONAL_RESPONSES: '1xx',
        SUCCESS_RESPONSES: '2xx',
        REDIRECTS: '3xx',
        CLIENT_ERRORS: '4xx',
        SERVER_ERRORS: '5xx',
        UNKNOWN: 'unknown'
    };
});
const $053a7e7c0b960d07$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $053a7e7c0b960d07$export$8d4ac56f443fb551 = 'getNumericFieldStatistics';
parcelRegister("8eVJ6", function(module, exports) {
    $parcel$export(module.exports, "NumericStatsTable", ()=>$b348e1c439e70064$export$fa8956702bebcaa8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $eNkw6;
    const $b348e1c439e70064$var$tableStyles = null;
    const $b348e1c439e70064$var$cellStyles = null;
    const $b348e1c439e70064$var$statisticStyles = null;
    const $b348e1c439e70064$var$valueStyles = null;
    const $b348e1c439e70064$var$grayBackgroundStyles = null;
    const $b348e1c439e70064$export$1945042cb2b5a024 = ({ left: left, right: right, rowNumber: rowNumber })=>{
        const Tag = rowNumber === 0 ? 'th' : 'td';
        const isGrayBackground = rowNumber % 2 === 1;
        return $5uXOq.createElement("tr", null, $5uXOq.createElement(Tag, {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qutpp _n3tdutpp",
                "_1vykpxbi",
                isGrayBackground && "_11q711bn"
            ])
        }, left), $5uXOq.createElement(Tag, {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qutpp _n3tdutpp",
                "_1kl7zgxb _19bvpxbi",
                isGrayBackground && "_11q711bn"
            ])
        }, right));
    };
    const $b348e1c439e70064$export$fa8956702bebcaa8 = ({ data: data })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return $5uXOq.createElement("table", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_yq5h18uv _btyzidpf _2rko1l7b _189et94y _1dqonqa1 _1h6dmuej"
            ])
        }, $5uXOq.createElement("thead", null, $5uXOq.createElement($b348e1c439e70064$export$1945042cb2b5a024, {
            left: formatMessage((0, (0, parcelRequire("eNkw6")).default).statistic),
            right: formatMessage((0, (0, parcelRequire("eNkw6")).default).value),
            rowNumber: 0
        })), $5uXOq.createElement("tbody", null, $5uXOq.createElement($b348e1c439e70064$export$1945042cb2b5a024, {
            left: formatMessage((0, (0, parcelRequire("eNkw6")).default).maximum),
            right: data.max,
            rowNumber: 1
        }), $5uXOq.createElement($b348e1c439e70064$export$1945042cb2b5a024, {
            left: formatMessage((0, (0, parcelRequire("eNkw6")).default).minimum),
            right: data.min,
            rowNumber: 2
        }), $5uXOq.createElement($b348e1c439e70064$export$1945042cb2b5a024, {
            left: formatMessage((0, (0, parcelRequire("eNkw6")).default).sum),
            right: data.sum,
            rowNumber: 3
        }), $5uXOq.createElement($b348e1c439e70064$export$1945042cb2b5a024, {
            left: formatMessage((0, (0, parcelRequire("eNkw6")).default).count),
            right: data.count,
            rowNumber: 4
        })));
    };
});
parcelRegister("eNkw6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f144e2fea3cc86e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f144e2fea3cc86e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statistic: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.statistic",
            "defaultMessage": "Statistic"
        },
        value: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.value",
            "defaultMessage": "Value"
        },
        minimum: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.minimum",
            "defaultMessage": "Min"
        },
        maximum: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.maximum",
            "defaultMessage": "Max"
        },
        sum: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.sum",
            "defaultMessage": "Sum"
        },
        count: {
            "id": "issue-field-statistics.numeric-stats-container.numeric-stats-table.count",
            "defaultMessage": "Total issue count"
        }
    });
});
parcelRegister("nfUJy", function(module, exports) {
    $parcel$export(module.exports, "SingleSelectChartContainer", ()=>$807d2fc59c0ae890$export$f37d245665d6d6fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $iHvFq = parcelRequire("iHvFq");
    var $9pctO = parcelRequire("9pctO");
    var $2x3Cb;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $7K5PP;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $koH6I;
    var $hjYzz;
    var $d8ogS;
    var $dem5p;
    var $eTLvM;
    var $bI9TW;
    var $dUJCJ;
    const $807d2fc59c0ae890$var$isValidChartType = (type)=>{
        return (0, (0, parcelRequire("d8ogS")).SingleSelectChartTypes).includes(type);
    };
    const $807d2fc59c0ae890$var$SUPPORTED_CHART_TYPES = [
        'DONUT_CHART',
        'HORIZONTAL_BAR_CHART'
    ];
    const $807d2fc59c0ae890$var$convertToSentenceCase = (input)=>{
        const lowerCased = (0, ($parcel$interopDefault($iHvFq)))(input);
        const titleFormat = (0, ($parcel$interopDefault($9pctO)))(lowerCased);
        return titleFormat.charAt(0) + titleFormat.slice(1).toLowerCase();
    };
    const $807d2fc59c0ae890$export$f37d245665d6d6fc = ({ customFieldId: customFieldId, query: query, width: width, chartType: chartType, onChartTypeChange: onChartTypeChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ loading: loading, data: data, error: error }] = (0, (0, parcelRequire("dem5p")).useSelectFieldStatistics)({
            customFieldId: customFieldId,
            query: query,
            limit: (0, $b38edbf0a34c884f$export$9acb02e1367cd538)
        });
        const renderChart = ()=>{
            if (!data) return null;
            switch(chartType){
                case 'DONUT_CHART':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eTLvM")).DonutChart), {
                        data: data,
                        width: width
                    });
                case 'HORIZONTAL_BAR_CHART':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bI9TW")).HorizontalBarChart), {
                        data: data,
                        width: width
                    });
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjYzz")).SidebarError), {
                        errorMessage: formatMessage((0, (0, parcelRequire("dUJCJ")).default).chartTypeErrorNonFinal)
                    });
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koH6I")).SidebarDataHandler), {
            error: error,
            loading: loading,
            data: data,
            isEmpty: data?.length === 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            sourceName: "jira.issueFieldStatistics.singleSelectChart",
            attributes: {
                chartType: chartType
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.300"
        }, $807d2fc59c0ae890$var$isValidChartType(chartType) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: "issue-field-statistics-chart-type-select"
        }, formatMessage((0, (0, parcelRequire("dUJCJ")).default).chartTypeSelectLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            value: {
                label: $807d2fc59c0ae890$var$convertToSentenceCase(chartType),
                value: chartType
            },
            onChange: (newChartType)=>{
                newChartType && onChartTypeChange(newChartType.value);
            },
            options: $807d2fc59c0ae890$var$SUPPORTED_CHART_TYPES.map((type)=>({
                    label: $807d2fc59c0ae890$var$convertToSentenceCase(type),
                    value: type
                })),
            id: "issue-field-statistics-chart-type-select"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "center",
            xcss: $807d2fc59c0ae890$var$chartStyles
        }, renderChart()))));
    };
    const $807d2fc59c0ae890$var$chartStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.150',
        paddingBlock: 'space.200'
    });
});
parcelRegister("iHvFq", function(module, exports) {
    var $gDRiW = parcelRequire("gDRiW");
    var $d9d4ce91007e2cba$var$lowerCase = $gDRiW(function(result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
    });
    module.exports = $d9d4ce91007e2cba$var$lowerCase;
});
const $b38edbf0a34c884f$export$9acb02e1367cd538 = 7;
parcelRegister("d8ogS", function(module, exports) {
    $parcel$export(module.exports, "SingleSelectChartTypes", ()=>$25462bc214d2abd7$export$68a2f2a9d3dba536);
    const $25462bc214d2abd7$export$68a2f2a9d3dba536 = [
        'BAR_CHART',
        'HORIZONTAL_BAR_CHART',
        'LINE_CHART',
        'PIE_CHART',
        'DONUT_CHART'
    ];
});
parcelRegister("dem5p", function(module, exports) {
    $parcel$export(module.exports, "useSelectFieldStatistics", ()=>$478bbbbc278976a5$export$5540229e7ae0ba04);
    var $iuEfD;
    var $48DMb;
    var $eL5UX;
    const $478bbbbc278976a5$var$getSelectFieldStatistics = async ({ customFieldId: customFieldId, query: jql, limit: limit = (0, $b38edbf0a34c884f$export$9acb02e1367cd538), fetchOptions: fetchOptions = {} })=>{
        const query = new URLSearchParams({
            query: jql,
            limit: limit.toString()
        });
        const url = `/rest/internal/list-view-chart/select/${customFieldId}?${query.toString()}`;
        return (0, (0, parcelRequire("48DMb")).fetchJson)(url, fetchOptions);
    };
    const $478bbbbc278976a5$export$5540229e7ae0ba04 = ({ customFieldId: customFieldId, query: query, limit: limit })=>{
        const { transform: transform } = (0, (0, parcelRequire("eL5UX")).useTransformer)();
        return (0, (0, parcelRequire("iuEfD")).useFetch)({
            onFetch: async (fetchOptions)=>{
                const response = await $478bbbbc278976a5$var$getSelectFieldStatistics({
                    customFieldId: customFieldId,
                    query: query,
                    limit: limit,
                    fetchOptions: fetchOptions
                });
                return transform(response);
            },
            analyticsTracking: {
                actionSubject: `useFetch.${(0, $70bcc60b885bccc7$export$33d4e32fdc33abbf)}`,
                packageName: (0, $70bcc60b885bccc7$export$b8b9d90f9e5bd72b),
                action: 'dataFetch'
            },
            loggingKey: `${(0, $70bcc60b885bccc7$export$b8b9d90f9e5bd72b)}.${(0, $70bcc60b885bccc7$export$33d4e32fdc33abbf)}`,
            isAutoFetchable: true
        }, [
            customFieldId,
            query
        ]);
    };
});
const $70bcc60b885bccc7$export$b8b9d90f9e5bd72b = 'jiraIssueFieldStatistics';
const $70bcc60b885bccc7$export$33d4e32fdc33abbf = 'getSelectFieldStatistics';
parcelRegister("eL5UX", function(module, exports) {
    $parcel$export(module.exports, "useTransformer", ()=>$381ff7675cc30cc5$export$c187a9117419b263);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2Ot3K;
    const $381ff7675cc30cc5$export$c187a9117419b263 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const transform = (0, $5uXOq.useCallback)((data)=>{
            return [
                ...Object.entries(data.slices).map(([label, value])=>({
                        label: label,
                        value: value
                    })),
                ...data.other > 0 ? [
                    {
                        label: formatMessage((0, (0, parcelRequire("2Ot3K")).default).otherLabel),
                        value: data.other
                    }
                ] : []
            ];
        }, [
            formatMessage
        ]);
        return {
            transform: transform
        };
    };
});
parcelRegister("2Ot3K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aacb0e794bec047$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5aacb0e794bec047$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        otherLabel: {
            "id": "issue-field-statistics.services.select-field.transformer.other-label",
            "defaultMessage": "Other"
        }
    });
});
parcelRegister("eTLvM", function(module, exports) {
    $parcel$export(module.exports, "DonutChart", ()=>$698e316c85a886e9$export$533707e2f61b59ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gXw8D;
    var $cJzGZ;
    var $8XQi0;
    var $7xWSv;
    const $698e316c85a886e9$var$MAX_WIDTH = 600;
    const $698e316c85a886e9$export$533707e2f61b59ec = ({ data: data, width: initialWidth })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const width = Math.min(initialWidth, $698e316c85a886e9$var$MAX_WIDTH);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXw8D")).default), {
            data: data,
            width: width,
            valueAccessor: (d)=>d.value,
            labelAccessor: (d)=>d.label,
            colorAccessor: (d)=>d.label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXw8D")).default).elements.MarkLabels, {
            hide: false
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXw8D")).default).elements.MetricLabel, {
            label: formatMessage((0, (0, parcelRequire("7xWSv")).default).centerTextLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cJzGZ")).CustomLayout), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8XQi0")).CustomLegend), null));
    };
});
parcelRegister("gXw8D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c58b1607dac96615$export$2e2bcd8739ae039);
    var $9ZuYc;
    var $4Yvz8;
    parcelRequire("4wRz3");
    var $2OPEf;
    var $4wRz3;
    var $jsFNI;
    var $jogiL;
    var $jogiL;
    var $9BEAR;
    var $dBbYh;
    var $dZ3lg;
    var $gUvRg;
    var $1iqMi;
    var $7rySF;
    var $2dgU7;
    var $d9Y89;
    var $8upbu;
    var $dcCcf;
    var $dFdp9;
    var $dwEoN;
    var $8Yq1M;
    var $8aZwB;
    var $6MKTx;
    var $2OMIu = parcelRequire("2OMIu");
    function $c58b1607dac96615$export$2e2bcd8739ae039(_ref) {
        let { width: width, height: height, data: data, children: children, ...restProps } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("9ZuYc")).ElementsProvider), {
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("d9Y89")).default), {
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("dBbYh")).MenuProvider), {
                    children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("2dgU7")).default), {
                        children: [
                            children,
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("4wRz3")).LayoutContainer), {
                                width: width,
                                height: height,
                                data: data,
                                gridTemplate: [
                                    'title',
                                    'subtitle',
                                    'plot',
                                    'legend'
                                ],
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("jsFNI")).DimensionsWrapper), {
                                    children: (_ref2)=>{
                                        let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                        return (0, $2OMIu.jsx)((0, (0, parcelRequire("6MKTx")).PureDonutChart), {
                                            svgRef: plotSvgRef,
                                            height: plotHeight,
                                            width: plotWidth,
                                            margin: margin,
                                            data: data,
                                            ...restProps
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    $c58b1607dac96615$export$2e2bcd8739ae039.elements = {
        Legend: (0, (0, parcelRequire("jogiL")).OrdinalLegend).Component,
        LegendLabel: (0, (0, parcelRequire("jogiL")).LegendLabel).Component,
        Layout: (0, (0, parcelRequire("2OPEf")).Layout).Component,
        Title: (0, (0, parcelRequire("7rySF")).Title).Component,
        SubTitle: (0, (0, parcelRequire("1iqMi")).Subtitle).Component,
        Mark: (0, (0, parcelRequire("dZ3lg")).Arc).Component,
        Marks: (0, (0, parcelRequire("dwEoN")).DonutMarks).Component,
        MarkLabels: (0, (0, parcelRequire("dFdp9")).DonutMarkLabels).Component,
        Metric: (0, (0, parcelRequire("dcCcf")).DonutMetric).Component,
        MetricLabel: (0, (0, parcelRequire("dcCcf")).DonutMetricLabel).Component,
        MetricValue: (0, (0, parcelRequire("dcCcf")).DonutMetricValue).Component,
        TooltipOverlay: (0, (0, parcelRequire("8aZwB")).DonutTooltipOverlay).Component,
        Tooltip: (0, (0, parcelRequire("8upbu")).SingleSeriesTooltip).Component,
        Scales: (0, (0, parcelRequire("8Yq1M")).DonutScalesElement).Component,
        Theme: (0, (0, parcelRequire("gUvRg")).Theme).Component,
        Menu: (0, (0, parcelRequire("9BEAR")).Menu).Component,
        DataTable: (0, (0, parcelRequire("4Yvz8")).DataTable).Component
    };
});
parcelRegister("9ZuYc", function(module, exports) {
    $parcel$export(module.exports, "ElementsProvider", ()=>$7461d58af668f317$export$71c0ba76abe92a7e);
    $parcel$export(module.exports, "useElements", ()=>$7461d58af668f317$export$83d5c6859f2ae3df);
    $parcel$export(module.exports, "useElementProps", ()=>$7461d58af668f317$export$8edbe6dd5606980);
    var $5uXOq = parcelRequire("5uXOq");
    var $2OMIu = parcelRequire("2OMIu");
    var $6cAn5 = parcelRequire("6cAn5");
    const $7461d58af668f317$export$a92ee76f0b1f4e66 = (0, $5uXOq.createContext)(null);
    function $7461d58af668f317$export$71c0ba76abe92a7e(_ref) {
        let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
        const ctx = $7461d58af668f317$export$83d5c6859f2ae3df();
        const value = (0, $5uXOq.useMemo)(()=>{
            const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
            const registeredOverrideComponents = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registeredOverrideComponents) || new Map();
            return {
                registry: registry,
                registeredOverrideComponents: registeredOverrideComponents,
                register: (kind, value)=>{
                    if (!registeredOverrideComponents.get(kind)) registeredOverrideComponents.set(kind, []);
                    const overrideComps = registeredOverrideComponents.get(kind) || [];
                    if (!overrideComps.includes(value.Component)) overrideComps.push(value.Component);
                    if (overrideComps[overrideComps.length - 1] === value.Component) registry.set(kind, value);
                },
                retrieve: (kind)=>registry.get(kind),
                isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
                getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
                getOuterProps: (k)=>{
                    var _registry$get;
                    return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
                }
            };
        }, [
            kind,
            defaultProps
        ]);
        return (0, $2OMIu.jsx)($7461d58af668f317$export$a92ee76f0b1f4e66.Provider, {
            value: value,
            children: children
        });
    }
    const $7461d58af668f317$export$83d5c6859f2ae3df = ()=>(0, $5uXOq.useContext)($7461d58af668f317$export$a92ee76f0b1f4e66);
    function $7461d58af668f317$export$8edbe6dd5606980(element, _temp) {
        var _process, _process$env, _useElements, _useElements2, _useElements3;
        let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
        if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
        if (((_process = $6cAn5) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $7461d58af668f317$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
        return {
            ...(_useElements2 = $7461d58af668f317$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
            ...(_useElements3 = $7461d58af668f317$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
            ...mergeWith
        };
    }
});
parcelRegister("4Yvz8", function(module, exports) {
    $parcel$export(module.exports, "DataTable", ()=>$39f5404de5c26a41$export$df30df7ec97b32b5);
    $parcel$export(module.exports, "DataTableModal", ()=>$39f5404de5c26a41$export$4717a7afeef78908);
    var $bwpsq;
    var $42CjB;
    var $k3qRI;
    var $lLLkM;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $1xLej;
    var $7rySF;
    var $lCjFE;
    var $2OMIu = parcelRequire("2OMIu");
    const $39f5404de5c26a41$var$gridStyles = null;
    const $39f5404de5c26a41$export$a8a28302b48950e6 = null;
    function $39f5404de5c26a41$var$getHeaders(headers) {
        const cellHeaders = headers.map((header)=>({
                key: header,
                content: (0, (0, parcelRequire("lCjFE")).toSentenceCase)(header),
                isSortable: true
            }));
        return {
            cells: cellHeaders
        };
    }
    function $39f5404de5c26a41$var$getRows(data) {
        if (!data.length) {
            const keys = Object.keys(data);
            const rowData = keys.map((k)=>{
                var _data;
                const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
                return {
                    key: cellData,
                    content: cellData
                };
            });
            return [
                {
                    key: 'row-0',
                    cells: rowData
                }
            ];
        }
        const rows = data.map((d, i)=>{
            const keys = Object.keys(d);
            const rowData = keys.map((k)=>{
                var _d$k;
                const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
                return {
                    key: cellData,
                    content: cellData
                };
            });
            return {
                key: `row-${i}`,
                cells: rowData
            };
        });
        return rows;
    }
    function $39f5404de5c26a41$export$84cbf2d941927b3b(_ref) {
        let { data: data, headers: userDefinedHeaders } = _ref;
        if (!data || Array.isArray(data) && data.length === 0) return null;
        const headers = userDefinedHeaders ? $39f5404de5c26a41$var$getHeaders(userDefinedHeaders) : data && $39f5404de5c26a41$var$getHeaders(Object.keys(data[0]));
        const rows = $39f5404de5c26a41$var$getRows(data);
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih1gjq _1ouib76v _cnoh16g6 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"
            ]),
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("k3qRI")).default), {
                head: headers,
                rows: rows,
                rowsPerPage: 10,
                defaultPage: 1,
                loadingSpinnerSize: "large"
            })
        });
    }
    const $39f5404de5c26a41$export$df30df7ec97b32b5 = (0, (0, parcelRequire("1xLej")).element)($39f5404de5c26a41$export$84cbf2d941927b3b);
    function $39f5404de5c26a41$export$4717a7afeef78908(_ref2) {
        let { data: data, closeModal: closeModal } = _ref2;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: closeModal,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("jgVsb")).default), {
                    children: (0, $2OMIu.jsxs)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"
                        ]),
                        children: [
                            (0, $2OMIu.jsx)("div", {
                                className: (0, (0, parcelRequire("bwpsq")).default)([
                                    "_1bahh9n0 _nd5l1bvj"
                                ]),
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("42CjB")).default), {
                                    appearance: "subtle",
                                    icon: (0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))),
                                    label: "Close Modal",
                                    onClick: closeModal
                                })
                            }),
                            (0, $2OMIu.jsx)("div", {
                                className: (0, (0, parcelRequire("bwpsq")).default)([
                                    "_1bahv2br _nd5l1cy2"
                                ]),
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("7rySF")).Title), {})
                            })
                        ]
                    })
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("7QSqG")).default), {
                    children: (0, $2OMIu.jsx)($39f5404de5c26a41$export$df30df7ec97b32b5, {
                        data: data
                    })
                })
            ]
        });
    }
});
parcelRegister("k3qRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e4f0159aa1c87c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $gS5Cm;
    var $dHbUn;
    class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("eGmKJ")).default),
                onSort: (0, (0, parcelRequire("eGmKJ")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args), this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            }, this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            }, this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            }, this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("gS5Cm")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args), this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            }, this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            }, this.componentWillUnmount = ()=>{
                this.detachListeners();
            }, this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            }, this.handleResize = ()=>{
                this.updateSpinnerPosition();
            }, this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            }, this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    refWidth: 0,
                    refHeight: 0
                }, this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                }, this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("1xLej", function(module, exports) {
    $parcel$export(module.exports, "element", ()=>$11fd8259a8258aa3$export$8454457683f90105);
    var $9ZuYc;
    var $2OMIu = parcelRequire("2OMIu");
    function $11fd8259a8258aa3$export$8454457683f90105(DefaultComponent, options) {
        var _options$as;
        if (options === void 0) options = {};
        const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
        const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
        if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
        const ElementComponent = (outerProps)=>{
            const ctx = (0, (0, parcelRequire("9ZuYc")).useElements)();
            if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
            if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return (0, $2OMIu.jsx)(DefaultComponent, {
                ...!options.as && ctx.getProps(kind),
                ...outerProps
            });
            else {
                ctx.register(kind, {
                    Component: DefaultComponent,
                    outerProps: outerProps
                });
                return null;
            }
        };
        ElementComponent.kind = kind;
        if (options.as) return ElementComponent;
        const ElementSlot = (defaultProps)=>{
            const ctx = (0, (0, parcelRequire("9ZuYc")).useElements)();
            const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
            const isSelf = Component === DefaultComponent;
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("9ZuYc")).ElementsProvider), {
                kind: kind,
                defaultProps: defaultProps,
                children: (0, $2OMIu.jsx)(Component, {
                    ...isSelf && defaultProps,
                    ...outerProps
                })
            });
        };
        ElementSlot.kind = kind;
        ElementSlot.Component = ElementComponent;
        ElementSlot.displayName = `element(${displayName})`;
        return ElementSlot;
    }
});
parcelRegister("7rySF", function(module, exports) {
    $parcel$export(module.exports, "Title", ()=>$56b61c97525445d3$export$f99233281efd08a0);
    var $bwpsq;
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    const $56b61c97525445d3$var$titleTextStyle = null;
    function $56b61c97525445d3$var$Title(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("h2", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _k48pni7l _zg8l4jg8 _ect4e86e _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt461nu"
            ]),
            children: children
        });
    }
    const $56b61c97525445d3$export$f99233281efd08a0 = (0, (0, parcelRequire("1xLej")).element)($56b61c97525445d3$var$Title);
});
parcelRegister("lCjFE", function(module, exports) {
    $parcel$export(module.exports, "toSentenceCase", ()=>$fbcc67cc8b4b56fb$export$dcbb097fa84257c1);
    $parcel$export(module.exports, "default", ()=>$fbcc67cc8b4b56fb$export$2e2bcd8739ae039);
    var $hjll3 = parcelRequire("hjll3");
    const $fbcc67cc8b4b56fb$var$formatNumberAbbreviated = (value)=>{
        if (value === null) return 'null';
        let numberValue;
        if (typeof value === 'string') {
            const parsedValue = Number(value);
            if (isNaN(parsedValue)) return value;
            numberValue = parsedValue;
        } else numberValue = value;
        return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            compactDisplay: 'short'
        }).format(numberValue);
    };
    const $fbcc67cc8b4b56fb$var$percentChange = (currentValue, previousValue)=>{
        if (previousValue === 0) return (currentValue * 100).toFixed();
        return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
    };
    const $fbcc67cc8b4b56fb$var$formatMillisecond = (0, $hjll3.timeFormat)('.%L'), $fbcc67cc8b4b56fb$var$formatSecond = (0, $hjll3.timeFormat)(':%S'), $fbcc67cc8b4b56fb$var$formatMinute = (0, $hjll3.timeFormat)('%I:%M'), $fbcc67cc8b4b56fb$var$formatHour = (0, $hjll3.timeFormat)('%I %p'), $fbcc67cc8b4b56fb$var$formatDay = (0, $hjll3.timeFormat)('%b %d'), $fbcc67cc8b4b56fb$var$formatWeek = (0, $hjll3.timeFormat)('%b %d'), $fbcc67cc8b4b56fb$var$formatMonth = (0, $hjll3.timeFormat)('%b'), $fbcc67cc8b4b56fb$var$formatYear = (0, $hjll3.timeFormat)('%Y');
    function $fbcc67cc8b4b56fb$export$16cec29b78b14126(date) {
        return ((0, $hjll3.timeSecond)(date) < date ? $fbcc67cc8b4b56fb$var$formatMillisecond : (0, $hjll3.timeMinute)(date) < date ? $fbcc67cc8b4b56fb$var$formatSecond : (0, $hjll3.timeHour)(date) < date ? $fbcc67cc8b4b56fb$var$formatMinute : (0, $hjll3.timeDay)(date) < date ? $fbcc67cc8b4b56fb$var$formatHour : (0, $hjll3.timeMonth)(date) < date ? (0, $hjll3.timeWeek)(date) < date ? $fbcc67cc8b4b56fb$var$formatDay : $fbcc67cc8b4b56fb$var$formatWeek : (0, $hjll3.timeYear)(date) < date ? $fbcc67cc8b4b56fb$var$formatMonth : $fbcc67cc8b4b56fb$var$formatYear)(date);
    }
    function $fbcc67cc8b4b56fb$export$dcbb097fa84257c1(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    var $fbcc67cc8b4b56fb$export$2e2bcd8739ae039 = {
        formatNumberAbbreviated: $fbcc67cc8b4b56fb$var$formatNumberAbbreviated,
        percentChange: $fbcc67cc8b4b56fb$var$percentChange,
        multiTimeFormat: $fbcc67cc8b4b56fb$export$16cec29b78b14126,
        toSentenceCase: $fbcc67cc8b4b56fb$export$dcbb097fa84257c1
    };
});
parcelRegister("hjll3", function(module, exports) {
    (function(global, factory) {
        factory(module.exports);
    })(module.exports, function(exports1) {
        'use strict';
        var version = "7.7.0";
        function ascending$3(a, b) {
            return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        }
        function descending$2(a, b) {
            return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
        }
        function bisector(f) {
            let compare1, compare2, delta;
            if (f.length !== 2) {
                compare1 = ascending$3;
                compare2 = (d, x)=>ascending$3(f(d), x);
                delta = (d, x)=>f(d) - x;
            } else {
                compare1 = f === ascending$3 || f === descending$2 ? f : zero$1;
                compare2 = f;
                delta = f;
            }
            function left(a, x, lo = 0, hi = a.length) {
                if (lo < hi) {
                    if (compare1(x, x) !== 0) return hi;
                    do {
                        const mid = lo + hi >>> 1;
                        if (compare2(a[mid], x) < 0) lo = mid + 1;
                        else hi = mid;
                    }while (lo < hi)
                }
                return lo;
            }
            function right(a, x, lo = 0, hi = a.length) {
                if (lo < hi) {
                    if (compare1(x, x) !== 0) return hi;
                    do {
                        const mid = lo + hi >>> 1;
                        if (compare2(a[mid], x) <= 0) lo = mid + 1;
                        else hi = mid;
                    }while (lo < hi)
                }
                return lo;
            }
            function center(a, x, lo = 0, hi = a.length) {
                const i = left(a, x, lo, hi - 1);
                return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
            }
            return {
                left: left,
                center: center,
                right: right
            };
        }
        function zero$1() {
            return 0;
        }
        function number$3(x) {
            return x === null ? NaN : +x;
        }
        function* numbers(values, valueof) {
            if (valueof === undefined) {
                for (let value of values)if (value != null && (value = +value) >= value) yield value;
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
            }
        }
        const ascendingBisect = bisector(ascending$3);
        const bisectRight = ascendingBisect.right;
        const bisectLeft = ascendingBisect.left;
        const bisectCenter = bisector(number$3).center;
        var bisect = bisectRight;
        function blur(values, r) {
            if (!((r = +r) >= 0)) throw new RangeError("invalid r");
            let length = values.length;
            if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
            if (!length || !r) return values;
            const blur = blurf(r);
            const temp = values.slice();
            blur(values, temp, 0, length, 1);
            blur(temp, values, 0, length, 1);
            blur(values, temp, 0, length, 1);
            return values;
        }
        const blur2 = Blur2(blurf);
        const blurImage = Blur2(blurfImage);
        function Blur2(blur) {
            return function(data, rx, ry = rx) {
                if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
                if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
                let { data: values, width: width, height: height } = data;
                if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
                if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
                if (!width || !height || !rx && !ry) return data;
                const blurx = rx && blur(rx);
                const blury = ry && blur(ry);
                const temp = values.slice();
                if (blurx && blury) {
                    blurh(blurx, temp, values, width, height);
                    blurh(blurx, values, temp, width, height);
                    blurh(blurx, temp, values, width, height);
                    blurv(blury, values, temp, width, height);
                    blurv(blury, temp, values, width, height);
                    blurv(blury, values, temp, width, height);
                } else if (blurx) {
                    blurh(blurx, values, temp, width, height);
                    blurh(blurx, temp, values, width, height);
                    blurh(blurx, values, temp, width, height);
                } else if (blury) {
                    blurv(blury, values, temp, width, height);
                    blurv(blury, temp, values, width, height);
                    blurv(blury, values, temp, width, height);
                }
                return data;
            };
        }
        function blurh(blur, T, S, w, h) {
            for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
        }
        function blurv(blur, T, S, w, h) {
            for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
        }
        function blurfImage(radius) {
            const blur = blurf(radius);
            return (T, S, start, stop, step)=>{
                start <<= 2, stop <<= 2, step <<= 2;
                blur(T, S, start + 0, stop + 0, step);
                blur(T, S, start + 1, stop + 1, step);
                blur(T, S, start + 2, stop + 2, step);
                blur(T, S, start + 3, stop + 3, step);
            };
        }
        function blurf(radius) {
            const radius0 = Math.floor(radius);
            if (radius0 === radius) return bluri(radius);
            const t = radius - radius0;
            const w = 2 * radius + 1;
            return (T, S, start, stop, step)=>{
                if (!((stop -= step) >= start)) return;
                let sum = radius0 * S[start];
                const s0 = step * radius0;
                const s1 = s0 + step;
                for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
                for(let i = start, j = stop; i <= j; i += step){
                    sum += S[Math.min(stop, i + s0)];
                    T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
                    sum -= S[Math.max(start, i - s0)];
                }
            };
        }
        function bluri(radius) {
            const w = 2 * radius + 1;
            return (T, S, start, stop, step)=>{
                if (!((stop -= step) >= start)) return;
                let sum = radius * S[start];
                const s = step * radius;
                for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
                for(let i = start, j = stop; i <= j; i += step){
                    sum += S[Math.min(stop, i + s)];
                    T[i] = sum / w;
                    sum -= S[Math.max(start, i - s)];
                }
            };
        }
        function count$1(values, valueof) {
            let count = 0;
            if (valueof === undefined) {
                for (let value of values)if (value != null && (value = +value) >= value) ++count;
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
            }
            return count;
        }
        function length$3(array) {
            return array.length | 0;
        }
        function empty$2(length) {
            return !(length > 0);
        }
        function arrayify(values) {
            return typeof values !== "object" || "length" in values ? values : Array.from(values);
        }
        function reducer(reduce) {
            return (values)=>reduce(...values);
        }
        function cross$2(...values) {
            const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
            values = values.map(arrayify);
            const lengths = values.map(length$3);
            const j = values.length - 1;
            const index = new Array(j + 1).fill(0);
            const product = [];
            if (j < 0 || lengths.some(empty$2)) return product;
            while(true){
                product.push(index.map((j, i)=>values[i][j]));
                let i = j;
                while(++index[i] === lengths[i]){
                    if (i === 0) return reduce ? product.map(reduce) : product;
                    index[i--] = 0;
                }
            }
        }
        function cumsum(values, valueof) {
            var sum = 0, index = 0;
            return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
        }
        function variance(values, valueof) {
            let count = 0;
            let delta;
            let mean = 0;
            let sum = 0;
            if (valueof === undefined) {
                for (let value of values)if (value != null && (value = +value) >= value) {
                    delta = value - mean;
                    mean += delta / ++count;
                    sum += delta * (value - mean);
                }
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
                    delta = value - mean;
                    mean += delta / ++count;
                    sum += delta * (value - mean);
                }
            }
            if (count > 1) return sum / (count - 1);
        }
        function deviation(values, valueof) {
            const v = variance(values, valueof);
            return v ? Math.sqrt(v) : v;
        }
        function extent$1(values, valueof) {
            let min;
            let max;
            if (valueof === undefined) {
                for (const value of values)if (value != null) {
                    if (min === undefined) {
                        if (value >= value) min = max = value;
                    } else {
                        if (min > value) min = value;
                        if (max < value) max = value;
                    }
                }
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                    if (min === undefined) {
                        if (value >= value) min = max = value;
                    } else {
                        if (min > value) min = value;
                        if (max < value) max = value;
                    }
                }
            }
            return [
                min,
                max
            ];
        }
        class Adder {
            constructor(){
                this._partials = new Float64Array(32);
                this._n = 0;
            }
            add(x) {
                const p = this._partials;
                let i = 0;
                for(let j = 0; j < this._n && j < 32; j++){
                    const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                    if (lo) p[i++] = lo;
                    x = hi;
                }
                p[i] = x;
                this._n = i + 1;
                return this;
            }
            valueOf() {
                const p = this._partials;
                let n = this._n, x, y, lo, hi = 0;
                if (n > 0) {
                    hi = p[--n];
                    while(n > 0){
                        x = hi;
                        y = p[--n];
                        hi = x + y;
                        lo = y - (hi - x);
                        if (lo) break;
                    }
                    if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                        y = lo * 2;
                        x = hi + y;
                        if (y == x - hi) hi = x;
                    }
                }
                return hi;
            }
        }
        function fsum(values, valueof) {
            const adder = new Adder();
            if (valueof === undefined) {
                for (let value of values)if (value = +value) adder.add(value);
            } else {
                let index = -1;
                for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
            }
            return +adder;
        }
        function fcumsum(values, valueof) {
            const adder = new Adder();
            let index = -1;
            return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
        }
        class InternMap extends Map {
            constructor(entries, key = keyof){
                super();
                Object.defineProperties(this, {
                    _intern: {
                        value: new Map()
                    },
                    _key: {
                        value: key
                    }
                });
                if (entries != null) for (const [key, value] of entries)this.set(key, value);
            }
            get(key) {
                return super.get(intern_get(this, key));
            }
            has(key) {
                return super.has(intern_get(this, key));
            }
            set(key, value) {
                return super.set(intern_set(this, key), value);
            }
            delete(key) {
                return super.delete(intern_delete(this, key));
            }
        }
        class InternSet extends Set {
            constructor(values, key = keyof){
                super();
                Object.defineProperties(this, {
                    _intern: {
                        value: new Map()
                    },
                    _key: {
                        value: key
                    }
                });
                if (values != null) for (const value of values)this.add(value);
            }
            has(value) {
                return super.has(intern_get(this, value));
            }
            add(value) {
                return super.add(intern_set(this, value));
            }
            delete(value) {
                return super.delete(intern_delete(this, value));
            }
        }
        function intern_get({ _intern: _intern, _key: _key }, value) {
            const key = _key(value);
            return _intern.has(key) ? _intern.get(key) : value;
        }
        function intern_set({ _intern: _intern, _key: _key }, value) {
            const key = _key(value);
            if (_intern.has(key)) return _intern.get(key);
            _intern.set(key, value);
            return value;
        }
        function intern_delete({ _intern: _intern, _key: _key }, value) {
            const key = _key(value);
            if (_intern.has(key)) {
                value = _intern.get(key);
                _intern.delete(key);
            }
            return value;
        }
        function keyof(value) {
            return value !== null && typeof value === "object" ? value.valueOf() : value;
        }
        function identity$9(x) {
            return x;
        }
        function group(values, ...keys) {
            return nest(values, identity$9, identity$9, keys);
        }
        function groups(values, ...keys) {
            return nest(values, Array.from, identity$9, keys);
        }
        function flatten$1(groups, keys) {
            for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                        ...g,
                        key,
                        value
                    ]));
            return groups;
        }
        function flatGroup(values, ...keys) {
            return flatten$1(groups(values, ...keys), keys);
        }
        function flatRollup(values, reduce, ...keys) {
            return flatten$1(rollups(values, reduce, ...keys), keys);
        }
        function rollup(values, reduce, ...keys) {
            return nest(values, identity$9, reduce, keys);
        }
        function rollups(values, reduce, ...keys) {
            return nest(values, Array.from, reduce, keys);
        }
        function index$4(values, ...keys) {
            return nest(values, identity$9, unique, keys);
        }
        function indexes(values, ...keys) {
            return nest(values, Array.from, unique, keys);
        }
        function unique(values) {
            if (values.length !== 1) throw new Error("duplicate key");
            return values[0];
        }
        function nest(values, map, reduce, keys) {
            return function regroup(values, i) {
                if (i >= keys.length) return reduce(values);
                const groups = new InternMap();
                const keyof = keys[i++];
                let index = -1;
                for (const value of values){
                    const key = keyof(value, ++index, values);
                    const group = groups.get(key);
                    if (group) group.push(value);
                    else groups.set(key, [
                        value
                    ]);
                }
                for (const [key, values] of groups)groups.set(key, regroup(values, i));
                return map(groups);
            }(values, 0);
        }
        function permute(source, keys) {
            return Array.from(keys, (key)=>source[key]);
        }
        function sort(values, ...F) {
            if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
            values = Array.from(values);
            let [f] = F;
            if (f && f.length !== 2 || F.length > 1) {
                const index = Uint32Array.from(values, (d, i)=>i);
                if (F.length > 1) {
                    F = F.map((f)=>values.map(f));
                    index.sort((i, j)=>{
                        for (const f of F){
                            const c = ascendingDefined(f[i], f[j]);
                            if (c) return c;
                        }
                    });
                } else {
                    f = values.map(f);
                    index.sort((i, j)=>ascendingDefined(f[i], f[j]));
                }
                return permute(values, index);
            }
            return values.sort(compareDefined(f));
        }
        function compareDefined(compare = ascending$3) {
            if (compare === ascending$3) return ascendingDefined;
            if (typeof compare !== "function") throw new TypeError("compare is not a function");
            return (a, b)=>{
                const x = compare(a, b);
                if (x || x === 0) return x;
                return (compare(b, b) === 0) - (compare(a, a) === 0);
            };
        }
        function ascendingDefined(a, b) {
            return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
        }
        function groupSort(values, reduce, key) {
            return (reduce.length !== 2 ? sort(rollup(values, reduce, key), ([ak, av], [bk, bv])=>ascending$3(av, bv) || ascending$3(ak, bk)) : sort(group(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || ascending$3(ak, bk))).map(([key])=>key);
        }
        var array$5 = Array.prototype;
        var slice$3 = array$5.slice;
        function constant$b(x) {
            return ()=>x;
        }
        var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
        function ticks(start, stop, count) {
            var reverse, i = -1, n, ticks, step;
            stop = +stop, start = +start, count = +count;
            if (start === stop && count > 0) return [
                start
            ];
            if (reverse = stop < start) n = start, start = stop, stop = n;
            if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
            if (step > 0) {
                let r0 = Math.round(start / step), r1 = Math.round(stop / step);
                if (r0 * step < start) ++r0;
                if (r1 * step > stop) --r1;
                ticks = new Array(n = r1 - r0 + 1);
                while(++i < n)ticks[i] = (r0 + i) * step;
            } else {
                step = -step;
                let r0 = Math.round(start * step), r1 = Math.round(stop * step);
                if (r0 / step < start) ++r0;
                if (r1 / step > stop) --r1;
                ticks = new Array(n = r1 - r0 + 1);
                while(++i < n)ticks[i] = (r0 + i) / step;
            }
            if (reverse) ticks.reverse();
            return ticks;
        }
        function tickIncrement(start, stop, count) {
            var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
            return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
        }
        function tickStep(start, stop, count) {
            var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
            if (error >= e10) step1 *= 10;
            else if (error >= e5) step1 *= 5;
            else if (error >= e2) step1 *= 2;
            return stop < start ? -step1 : step1;
        }
        function nice$1(start, stop, count) {
            let prestep;
            while(true){
                const step = tickIncrement(start, stop, count);
                if (step === prestep || step === 0 || !isFinite(step)) return [
                    start,
                    stop
                ];
                else if (step > 0) {
                    start = Math.floor(start / step) * step;
                    stop = Math.ceil(stop / step) * step;
                } else if (step < 0) {
                    start = Math.ceil(start * step) / step;
                    stop = Math.floor(stop * step) / step;
                }
                prestep = step;
            }
        }
        function thresholdSturges(values) {
            return Math.ceil(Math.log(count$1(values)) / Math.LN2) + 1;
        }
        function bin() {
            var value = identity$9, domain = extent$1, threshold = thresholdSturges;
            function histogram(data) {
                if (!Array.isArray(data)) data = Array.from(data);
                var i, n = data.length, x, step, values = new Array(n);
                for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
                var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
                if (!Array.isArray(tz)) {
                    const max = x1, tn = +tz;
                    if (domain === extent$1) [x0, x1] = nice$1(x0, x1, tn);
                    tz = ticks(x0, x1, tn);
                    if (tz[0] <= x0) step = tickIncrement(x0, x1, tn);
                    if (tz[tz.length - 1] >= x1) {
                        if (max >= x1 && domain === extent$1) {
                            const step = tickIncrement(x0, x1, tn);
                            if (isFinite(step)) {
                                if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                                else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                            }
                        } else tz.pop();
                    }
                }
                var m = tz.length, a = 0, b = m;
                while(tz[a] <= x0)++a;
                while(tz[b - 1] > x1)--b;
                if (a || b < m) tz = tz.slice(a, b), m = b - a;
                var bins = new Array(m + 1), bin;
                for(i = 0; i <= m; ++i){
                    bin = bins[i] = [];
                    bin.x0 = i > 0 ? tz[i - 1] : x0;
                    bin.x1 = i < m ? tz[i] : x1;
                }
                if (isFinite(step)) {
                    if (step > 0) {
                        for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
                    } else if (step < 0) {
                        for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                            const j = Math.floor((x0 - x) * step);
                            bins[Math.min(m, j + (tz[j] <= x))].push(data[i]);
                        }
                    }
                } else {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[bisect(tz, x, 0, m)].push(data[i]);
                }
                return bins;
            }
            histogram.value = function(_) {
                return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(_), histogram) : value;
            };
            histogram.domain = function(_) {
                return arguments.length ? (domain = typeof _ === "function" ? _ : constant$b([
                    _[0],
                    _[1]
                ]), histogram) : domain;
            };
            histogram.thresholds = function(_) {
                return arguments.length ? (threshold = typeof _ === "function" ? _ : constant$b(Array.isArray(_) ? slice$3.call(_) : _), histogram) : threshold;
            };
            return histogram;
        }
        function max$3(values, valueof) {
            let max;
            if (valueof === undefined) {
                for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
            }
            return max;
        }
        function maxIndex(values, valueof) {
            let max;
            let maxIndex = -1;
            let index = -1;
            if (valueof === undefined) for (const value of values){
                ++index;
                if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
            }
            else {
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
            }
            return maxIndex;
        }
        function min$2(values, valueof) {
            let min;
            if (valueof === undefined) {
                for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
            }
            return min;
        }
        function minIndex(values, valueof) {
            let min;
            let minIndex = -1;
            let index = -1;
            if (valueof === undefined) for (const value of values){
                ++index;
                if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
            }
            else {
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
            }
            return minIndex;
        }
        function quickselect(array, k, left = 0, right = Infinity, compare) {
            k = Math.floor(k);
            left = Math.floor(Math.max(0, left));
            right = Math.floor(Math.min(array.length - 1, right));
            if (!(left <= k && k <= right)) return array;
            compare = compare === undefined ? ascendingDefined : compareDefined(compare);
            while(right > left){
                if (right - left > 600) {
                    const n = right - left + 1;
                    const m = k - left + 1;
                    const z = Math.log(n);
                    const s = 0.5 * Math.exp(2 * z / 3);
                    const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                    const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                    const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                    quickselect(array, k, newLeft, newRight, compare);
                }
                const t = array[k];
                let i = left;
                let j = right;
                swap$1(array, left, k);
                if (compare(array[right], t) > 0) swap$1(array, left, right);
                while(i < j){
                    swap$1(array, i, j), ++i, --j;
                    while(compare(array[i], t) < 0)++i;
                    while(compare(array[j], t) > 0)--j;
                }
                if (compare(array[left], t) === 0) swap$1(array, left, j);
                else ++j, swap$1(array, j, right);
                if (j <= k) left = j + 1;
                if (k <= j) right = j - 1;
            }
            return array;
        }
        function swap$1(array, i, j) {
            const t = array[i];
            array[i] = array[j];
            array[j] = t;
        }
        function greatest(values, compare = ascending$3) {
            let max;
            let defined = false;
            if (compare.length === 1) {
                let maxValue;
                for (const element of values){
                    const value = compare(element);
                    if (defined ? ascending$3(value, maxValue) > 0 : ascending$3(value, value) === 0) {
                        max = element;
                        maxValue = value;
                        defined = true;
                    }
                }
            } else {
                for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
                    max = value;
                    defined = true;
                }
            }
            return max;
        }
        function quantile$1(values, p, valueof) {
            values = Float64Array.from(numbers(values, valueof));
            if (!(n = values.length) || isNaN(p = +p)) return;
            if (p <= 0 || n < 2) return min$2(values);
            if (p >= 1) return max$3(values);
            var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$2(values.subarray(i0 + 1));
            return value0 + (value1 - value0) * (i - i0);
        }
        function quantileSorted(values, p, valueof = number$3) {
            if (!(n = values.length) || isNaN(p = +p)) return;
            if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
            if (p >= 1) return +valueof(values[n - 1], n - 1, values);
            var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
            return value0 + (value1 - value0) * (i - i0);
        }
        function quantileIndex(values, p, valueof) {
            values = Float64Array.from(numbers(values, valueof));
            if (!(n = values.length) || isNaN(p = +p)) return;
            if (p <= 0 || n < 2) return minIndex(values);
            if (p >= 1) return maxIndex(values);
            var n, i = Math.floor((n - 1) * p), order = (i, j)=>ascendingDefined(values[i], values[j]), index = quickselect(Uint32Array.from(values, (_, i)=>i), i, 0, n - 1, order);
            return greatest(index.subarray(0, i + 1), (i)=>values[i]);
        }
        function thresholdFreedmanDiaconis(values, min, max) {
            return Math.ceil((max - min) / (2 * (quantile$1(values, 0.75) - quantile$1(values, 0.25)) * Math.pow(count$1(values), -1 / 3)));
        }
        function thresholdScott(values, min, max) {
            return Math.ceil((max - min) * Math.cbrt(count$1(values)) / (3.49 * deviation(values)));
        }
        function mean(values, valueof) {
            let count = 0;
            let sum = 0;
            if (valueof === undefined) {
                for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
            }
            if (count) return sum / count;
        }
        function median(values, valueof) {
            return quantile$1(values, 0.5, valueof);
        }
        function medianIndex(values, valueof) {
            return quantileIndex(values, 0.5, valueof);
        }
        function* flatten(arrays) {
            for (const array of arrays)yield* array;
        }
        function merge(arrays) {
            return Array.from(flatten(arrays));
        }
        function mode(values, valueof) {
            const counts = new InternMap();
            if (valueof === undefined) {
                for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
            } else {
                let index = -1;
                for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
            }
            let modeValue;
            let modeCount = 0;
            for (const [value, count] of counts)if (count > modeCount) {
                modeCount = count;
                modeValue = value;
            }
            return modeValue;
        }
        function pairs(values, pairof = pair) {
            const pairs1 = [];
            let previous;
            let first = false;
            for (const value of values){
                if (first) pairs1.push(pairof(previous, value));
                previous = value;
                first = true;
            }
            return pairs1;
        }
        function pair(a, b) {
            return [
                a,
                b
            ];
        }
        function range$2(start, stop, step) {
            start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
            var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
            while(++i < n)range[i] = start + i * step;
            return range;
        }
        function rank(values, valueof = ascending$3) {
            if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
            let V = Array.from(values);
            const R = new Float64Array(V.length);
            if (valueof.length !== 2) V = V.map(valueof), valueof = ascending$3;
            const compareIndex = (i, j)=>valueof(V[i], V[j]);
            let k, r;
            Uint32Array.from(V, (_, i)=>i).sort(valueof === ascending$3 ? (i, j)=>ascendingDefined(V[i], V[j]) : compareDefined(compareIndex)).forEach((j, i)=>{
                const c = compareIndex(j, k === undefined ? j : k);
                if (c >= 0) {
                    if (k === undefined || c > 0) k = j, r = i;
                    R[j] = r;
                } else R[j] = NaN;
            });
            return R;
        }
        function least(values, compare = ascending$3) {
            let min;
            let defined = false;
            if (compare.length === 1) {
                let minValue;
                for (const element of values){
                    const value = compare(element);
                    if (defined ? ascending$3(value, minValue) < 0 : ascending$3(value, value) === 0) {
                        min = element;
                        minValue = value;
                        defined = true;
                    }
                }
            } else {
                for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
                    min = value;
                    defined = true;
                }
            }
            return min;
        }
        function leastIndex(values, compare = ascending$3) {
            if (compare.length === 1) return minIndex(values, compare);
            let minValue;
            let min = -1;
            let index = -1;
            for (const value of values){
                ++index;
                if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                    minValue = value;
                    min = index;
                }
            }
            return min;
        }
        function greatestIndex(values, compare = ascending$3) {
            if (compare.length === 1) return maxIndex(values, compare);
            let maxValue;
            let max = -1;
            let index = -1;
            for (const value of values){
                ++index;
                if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                    maxValue = value;
                    max = index;
                }
            }
            return max;
        }
        function scan(values, compare) {
            const index = leastIndex(values, compare);
            return index < 0 ? undefined : index;
        }
        var shuffle$1 = shuffler(Math.random);
        function shuffler(random) {
            return function shuffle(array, i0 = 0, i1 = array.length) {
                let m = i1 - (i0 = +i0);
                while(m){
                    const i = random() * m-- | 0, t = array[m + i0];
                    array[m + i0] = array[i + i0];
                    array[i + i0] = t;
                }
                return array;
            };
        }
        function sum$2(values, valueof) {
            let sum = 0;
            if (valueof === undefined) {
                for (let value of values)if (value = +value) sum += value;
            } else {
                let index = -1;
                for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
            }
            return sum;
        }
        function transpose(matrix) {
            if (!(n = matrix.length)) return [];
            for(var i = -1, m = min$2(matrix, length$2), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
            return transpose;
        }
        function length$2(d) {
            return d.length;
        }
        function zip() {
            return transpose(arguments);
        }
        function every(values, test) {
            if (typeof test !== "function") throw new TypeError("test is not a function");
            let index = -1;
            for (const value of values){
                if (!test(value, ++index, values)) return false;
            }
            return true;
        }
        function some(values, test) {
            if (typeof test !== "function") throw new TypeError("test is not a function");
            let index = -1;
            for (const value of values){
                if (test(value, ++index, values)) return true;
            }
            return false;
        }
        function filter$1(values, test) {
            if (typeof test !== "function") throw new TypeError("test is not a function");
            const array = [];
            let index = -1;
            for (const value of values)if (test(value, ++index, values)) array.push(value);
            return array;
        }
        function map$1(values, mapper) {
            if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
            if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
            return Array.from(values, (value, index)=>mapper(value, index, values));
        }
        function reduce(values, reducer, value) {
            if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
            const iterator = values[Symbol.iterator]();
            let done, next, index = -1;
            if (arguments.length < 3) {
                ({ done: done, value: value } = iterator.next());
                if (done) return;
                ++index;
            }
            while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
            return value;
        }
        function reverse$1(values) {
            if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
            return Array.from(values).reverse();
        }
        function difference(values, ...others) {
            values = new InternSet(values);
            for (const other of others)for (const value of other)values.delete(value);
            return values;
        }
        function disjoint(values, other) {
            const iterator = other[Symbol.iterator](), set = new InternSet();
            for (const v of values){
                if (set.has(v)) return false;
                let value, done;
                while({ value: value, done: done } = iterator.next()){
                    if (done) break;
                    if (Object.is(v, value)) return false;
                    set.add(value);
                }
            }
            return true;
        }
        function intersection(values, ...others) {
            values = new InternSet(values);
            others = others.map(set$2);
            out: for (const value of values){
                for (const other of others)if (!other.has(value)) {
                    values.delete(value);
                    continue out;
                }
            }
            return values;
        }
        function set$2(values) {
            return values instanceof InternSet ? values : new InternSet(values);
        }
        function superset(values, other) {
            const iterator = values[Symbol.iterator](), set = new Set();
            for (const o of other){
                const io = intern(o);
                if (set.has(io)) continue;
                let value, done;
                while({ value: value, done: done } = iterator.next()){
                    if (done) return false;
                    const ivalue = intern(value);
                    set.add(ivalue);
                    if (Object.is(io, ivalue)) break;
                }
            }
            return true;
        }
        function intern(value) {
            return value !== null && typeof value === "object" ? value.valueOf() : value;
        }
        function subset(values, other) {
            return superset(other, values);
        }
        function union(...others) {
            const set = new InternSet();
            for (const other of others)for (const o of other)set.add(o);
            return set;
        }
        function identity$8(x) {
            return x;
        }
        var top = 1, right = 2, bottom = 3, left = 4, epsilon$6 = 1e-6;
        function translateX(x) {
            return "translate(" + x + ",0)";
        }
        function translateY(y) {
            return "translate(0," + y + ")";
        }
        function number$2(scale) {
            return (d)=>+scale(d);
        }
        function center$1(scale, offset) {
            offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
            if (scale.round()) offset = Math.round(offset);
            return (d)=>+scale(d) + offset;
        }
        function entering() {
            return !this.__axis;
        }
        function axis(orient, scale) {
            var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
            function axis(context) {
                var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$8 : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center$1 : number$2)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
                    null
                ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
                path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
                tick = tick.merge(tickEnter);
                line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
                text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
                if (context !== selection) {
                    path = path.transition(context);
                    tick = tick.transition(context);
                    line = line.transition(context);
                    text = text.transition(context);
                    tickExit = tickExit.transition(context).attr("opacity", epsilon$6).attr("transform", function(d) {
                        return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
                    });
                    tickEnter.attr("opacity", epsilon$6).attr("transform", function(d) {
                        var p = this.parentNode.__axis;
                        return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
                    });
                }
                tickExit.remove();
                path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
                tick.attr("opacity", 1).attr("transform", function(d) {
                    return transform(position(d) + offset);
                });
                line.attr(x + "2", k * tickSizeInner);
                text.attr(x, k * spacing).text(format);
                selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
                selection.each(function() {
                    this.__axis = position;
                });
            }
            axis.scale = function(_) {
                return arguments.length ? (scale = _, axis) : scale;
            };
            axis.ticks = function() {
                return tickArguments = Array.from(arguments), axis;
            };
            axis.tickArguments = function(_) {
                return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
            };
            axis.tickValues = function(_) {
                return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
            };
            axis.tickFormat = function(_) {
                return arguments.length ? (tickFormat = _, axis) : tickFormat;
            };
            axis.tickSize = function(_) {
                return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
            };
            axis.tickSizeInner = function(_) {
                return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
            };
            axis.tickSizeOuter = function(_) {
                return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
            };
            axis.tickPadding = function(_) {
                return arguments.length ? (tickPadding = +_, axis) : tickPadding;
            };
            axis.offset = function(_) {
                return arguments.length ? (offset = +_, axis) : offset;
            };
            return axis;
        }
        function axisTop(scale) {
            return axis(top, scale);
        }
        function axisRight(scale) {
            return axis(right, scale);
        }
        function axisBottom(scale) {
            return axis(bottom, scale);
        }
        function axisLeft(scale) {
            return axis(left, scale);
        }
        var noop$3 = {
            value: ()=>{}
        };
        function dispatch() {
            for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
                if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
                _[t] = [];
            }
            return new Dispatch(_);
        }
        function Dispatch(_) {
            this._ = _;
        }
        function parseTypenames$1(typenames, types) {
            return typenames.trim().split(/^|\s+/).map(function(t) {
                var name = "", i = t.indexOf(".");
                if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
                if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
                return {
                    type: t,
                    name: name
                };
            });
        }
        Dispatch.prototype = dispatch.prototype = {
            constructor: Dispatch,
            on: function(typename, callback) {
                var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
                if (arguments.length < 2) {
                    while(++i < n)if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
                    return;
                }
                if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
                while(++i < n){
                    if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
                    else if (callback == null) for(t in _)_[t] = set$1(_[t], typename.name, null);
                }
                return this;
            },
            copy: function() {
                var copy = {}, _ = this._;
                for(var t in _)copy[t] = _[t].slice();
                return new Dispatch(copy);
            },
            call: function(type, that) {
                if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
                if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
                for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
            },
            apply: function(type, that, args) {
                if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
                for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
            }
        };
        function get$1(type, name) {
            for(var i = 0, n = type.length, c; i < n; ++i){
                if ((c = type[i]).name === name) return c.value;
            }
        }
        function set$1(type, name, callback) {
            for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
                type[i] = noop$3, type = type.slice(0, i).concat(type.slice(i + 1));
                break;
            }
            if (callback != null) type.push({
                name: name,
                value: callback
            });
            return type;
        }
        var xhtml = "http://www.w3.org/1999/xhtml";
        var namespaces = {
            svg: "http://www.w3.org/2000/svg",
            xhtml: xhtml,
            xlink: "http://www.w3.org/1999/xlink",
            xml: "http://www.w3.org/XML/1998/namespace",
            xmlns: "http://www.w3.org/2000/xmlns/"
        };
        function namespace(name) {
            var prefix = name += "", i = prefix.indexOf(":");
            if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
            return namespaces.hasOwnProperty(prefix) ? {
                space: namespaces[prefix],
                local: name
            } : name;
        }
        function creatorInherit(name) {
            return function() {
                var document1 = this.ownerDocument, uri = this.namespaceURI;
                return uri === xhtml && document1.documentElement.namespaceURI === xhtml ? document1.createElement(name) : document1.createElementNS(uri, name);
            };
        }
        function creatorFixed(fullname) {
            return function() {
                return this.ownerDocument.createElementNS(fullname.space, fullname.local);
            };
        }
        function creator(name) {
            var fullname = namespace(name);
            return (fullname.local ? creatorFixed : creatorInherit)(fullname);
        }
        function none$2() {}
        function selector(selector) {
            return selector == null ? none$2 : function() {
                return this.querySelector(selector);
            };
        }
        function selection_select(select) {
            if (typeof select !== "function") select = selector(select);
            for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                    if ("__data__" in node) subnode.__data__ = node.__data__;
                    subgroup[i] = subnode;
                }
            }
            return new Selection$1(subgroups, this._parents);
        }
        function array$4(x) {
            return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
        }
        function empty$1() {
            return [];
        }
        function selectorAll(selector) {
            return selector == null ? empty$1 : function() {
                return this.querySelectorAll(selector);
            };
        }
        function arrayAll(select) {
            return function() {
                return array$4(select.apply(this, arguments));
            };
        }
        function selection_selectAll(select) {
            if (typeof select === "function") select = arrayAll(select);
            else select = selectorAll(select);
            for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                    subgroups.push(select.call(node, node.__data__, i, group));
                    parents.push(node);
                }
            }
            return new Selection$1(subgroups, parents);
        }
        function matcher(selector) {
            return function() {
                return this.matches(selector);
            };
        }
        function childMatcher(selector) {
            return function(node) {
                return node.matches(selector);
            };
        }
        var find$1 = Array.prototype.find;
        function childFind(match) {
            return function() {
                return find$1.call(this.children, match);
            };
        }
        function childFirst() {
            return this.firstElementChild;
        }
        function selection_selectChild(match) {
            return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
        }
        var filter = Array.prototype.filter;
        function children() {
            return Array.from(this.children);
        }
        function childrenFilter(match) {
            return function() {
                return filter.call(this.children, match);
            };
        }
        function selection_selectChildren(match) {
            return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
        }
        function selection_filter(match) {
            if (typeof match !== "function") match = matcher(match);
            for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
            }
            return new Selection$1(subgroups, this._parents);
        }
        function sparse(update) {
            return new Array(update.length);
        }
        function selection_enter() {
            return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
        }
        function EnterNode(parent, datum) {
            this.ownerDocument = parent.ownerDocument;
            this.namespaceURI = parent.namespaceURI;
            this._next = null;
            this._parent = parent;
            this.__data__ = datum;
        }
        EnterNode.prototype = {
            constructor: EnterNode,
            appendChild: function(child) {
                return this._parent.insertBefore(child, this._next);
            },
            insertBefore: function(child, next) {
                return this._parent.insertBefore(child, next);
            },
            querySelector: function(selector) {
                return this._parent.querySelector(selector);
            },
            querySelectorAll: function(selector) {
                return this._parent.querySelectorAll(selector);
            }
        };
        function constant$a(x) {
            return function() {
                return x;
            };
        }
        function bindIndex(parent, group, enter, update, exit, data) {
            var i = 0, node, groupLength = group.length, dataLength = data.length;
            for(; i < dataLength; ++i)if (node = group[i]) {
                node.__data__ = data[i];
                update[i] = node;
            } else enter[i] = new EnterNode(parent, data[i]);
            for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
        }
        function bindKey(parent, group, enter, update, exit, data, key) {
            var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
            for(i = 0; i < groupLength; ++i)if (node = group[i]) {
                keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
                if (nodeByKeyValue.has(keyValue)) exit[i] = node;
                else nodeByKeyValue.set(keyValue, node);
            }
            for(i = 0; i < dataLength; ++i){
                keyValue = key.call(parent, data[i], i, data) + "";
                if (node = nodeByKeyValue.get(keyValue)) {
                    update[i] = node;
                    node.__data__ = data[i];
                    nodeByKeyValue.delete(keyValue);
                } else enter[i] = new EnterNode(parent, data[i]);
            }
            for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
        }
        function datum(node) {
            return node.__data__;
        }
        function selection_data(value, key) {
            if (!arguments.length) return Array.from(this, datum);
            var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
            if (typeof value !== "function") value = constant$a(value);
            for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
                var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
                bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
                for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                    if (i0 >= i1) i1 = i0 + 1;
                    while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                    previous._next = next || null;
                }
            }
            update = new Selection$1(update, parents);
            update._enter = enter;
            update._exit = exit;
            return update;
        }
        function arraylike(data) {
            return typeof data === "object" && "length" in data ? data : Array.from(data);
        }
        function selection_exit() {
            return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
        }
        function selection_join(onenter, onupdate, onexit) {
            var enter = this.enter(), update = this, exit = this.exit();
            if (typeof onenter === "function") {
                enter = onenter(enter);
                if (enter) enter = enter.selection();
            } else enter = enter.append(onenter + "");
            if (onupdate != null) {
                update = onupdate(update);
                if (update) update = update.selection();
            }
            if (onexit == null) exit.remove();
            else onexit(exit);
            return enter && update ? enter.merge(update).order() : update;
        }
        function selection_merge(context) {
            var selection = context.selection ? context.selection() : context;
            for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
                for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
            }
            for(; j < m0; ++j)merges[j] = groups0[j];
            return new Selection$1(merges, this._parents);
        }
        function selection_order() {
            for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
                for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                    if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                    next = node;
                }
            }
            return this;
        }
        function selection_sort(compare) {
            if (!compare) compare = ascending$2;
            function compareNode(a, b) {
                return a && b ? compare(a.__data__, b.__data__) : !a - !b;
            }
            for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
                sortgroup.sort(compareNode);
            }
            return new Selection$1(sortgroups, this._parents).order();
        }
        function ascending$2(a, b) {
            return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        }
        function selection_call() {
            var callback = arguments[0];
            arguments[0] = this;
            callback.apply(null, arguments);
            return this;
        }
        function selection_nodes() {
            return Array.from(this);
        }
        function selection_node() {
            for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
                var node = group[i];
                if (node) return node;
            }
            return null;
        }
        function selection_size() {
            let size = 0;
            for (const node of this)++size;
            return size;
        }
        function selection_empty() {
            return !this.node();
        }
        function selection_each(callback) {
            for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
                for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
            }
            return this;
        }
        function attrRemove$1(name) {
            return function() {
                this.removeAttribute(name);
            };
        }
        function attrRemoveNS$1(fullname) {
            return function() {
                this.removeAttributeNS(fullname.space, fullname.local);
            };
        }
        function attrConstant$1(name, value) {
            return function() {
                this.setAttribute(name, value);
            };
        }
        function attrConstantNS$1(fullname, value) {
            return function() {
                this.setAttributeNS(fullname.space, fullname.local, value);
            };
        }
        function attrFunction$1(name, value) {
            return function() {
                var v = value.apply(this, arguments);
                if (v == null) this.removeAttribute(name);
                else this.setAttribute(name, v);
            };
        }
        function attrFunctionNS$1(fullname, value) {
            return function() {
                var v = value.apply(this, arguments);
                if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
                else this.setAttributeNS(fullname.space, fullname.local, v);
            };
        }
        function selection_attr(name, value) {
            var fullname = namespace(name);
            if (arguments.length < 2) {
                var node = this.node();
                return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
            }
            return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
        }
        function defaultView(node) {
            return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
        }
        function styleRemove$1(name) {
            return function() {
                this.style.removeProperty(name);
            };
        }
        function styleConstant$1(name, value, priority) {
            return function() {
                this.style.setProperty(name, value, priority);
            };
        }
        function styleFunction$1(name, value, priority) {
            return function() {
                var v = value.apply(this, arguments);
                if (v == null) this.style.removeProperty(name);
                else this.style.setProperty(name, v, priority);
            };
        }
        function selection_style(name, value, priority) {
            return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
        }
        function styleValue(node, name) {
            return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
        }
        function propertyRemove(name) {
            return function() {
                delete this[name];
            };
        }
        function propertyConstant(name, value) {
            return function() {
                this[name] = value;
            };
        }
        function propertyFunction(name, value) {
            return function() {
                var v = value.apply(this, arguments);
                if (v == null) delete this[name];
                else this[name] = v;
            };
        }
        function selection_property(name, value) {
            return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
        }
        function classArray(string) {
            return string.trim().split(/^|\s+/);
        }
        function classList(node) {
            return node.classList || new ClassList(node);
        }
        function ClassList(node) {
            this._node = node;
            this._names = classArray(node.getAttribute("class") || "");
        }
        ClassList.prototype = {
            add: function(name) {
                var i = this._names.indexOf(name);
                if (i < 0) {
                    this._names.push(name);
                    this._node.setAttribute("class", this._names.join(" "));
                }
            },
            remove: function(name) {
                var i = this._names.indexOf(name);
                if (i >= 0) {
                    this._names.splice(i, 1);
                    this._node.setAttribute("class", this._names.join(" "));
                }
            },
            contains: function(name) {
                return this._names.indexOf(name) >= 0;
            }
        };
        function classedAdd(node, names) {
            var list = classList(node), i = -1, n = names.length;
            while(++i < n)list.add(names[i]);
        }
        function classedRemove(node, names) {
            var list = classList(node), i = -1, n = names.length;
            while(++i < n)list.remove(names[i]);
        }
        function classedTrue(names) {
            return function() {
                classedAdd(this, names);
            };
        }
        function classedFalse(names) {
            return function() {
                classedRemove(this, names);
            };
        }
        function classedFunction(names, value) {
            return function() {
                (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
            };
        }
        function selection_classed(name, value) {
            var names = classArray(name + "");
            if (arguments.length < 2) {
                var list = classList(this.node()), i = -1, n = names.length;
                while(++i < n)if (!list.contains(names[i])) return false;
                return true;
            }
            return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
        }
        function textRemove() {
            this.textContent = "";
        }
        function textConstant$1(value) {
            return function() {
                this.textContent = value;
            };
        }
        function textFunction$1(value) {
            return function() {
                var v = value.apply(this, arguments);
                this.textContent = v == null ? "" : v;
            };
        }
        function selection_text(value) {
            return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
        }
        function htmlRemove() {
            this.innerHTML = "";
        }
        function htmlConstant(value) {
            return function() {
                this.innerHTML = value;
            };
        }
        function htmlFunction(value) {
            return function() {
                var v = value.apply(this, arguments);
                this.innerHTML = v == null ? "" : v;
            };
        }
        function selection_html(value) {
            return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
        }
        function raise() {
            if (this.nextSibling) this.parentNode.appendChild(this);
        }
        function selection_raise() {
            return this.each(raise);
        }
        function lower() {
            if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }
        function selection_lower() {
            return this.each(lower);
        }
        function selection_append(name) {
            var create = typeof name === "function" ? name : creator(name);
            return this.select(function() {
                return this.appendChild(create.apply(this, arguments));
            });
        }
        function constantNull() {
            return null;
        }
        function selection_insert(name, before) {
            var create = typeof name === "function" ? name : creator(name), select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
            return this.select(function() {
                return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
            });
        }
        function remove() {
            var parent = this.parentNode;
            if (parent) parent.removeChild(this);
        }
        function selection_remove() {
            return this.each(remove);
        }
        function selection_cloneShallow() {
            var clone = this.cloneNode(false), parent = this.parentNode;
            return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
        }
        function selection_cloneDeep() {
            var clone = this.cloneNode(true), parent = this.parentNode;
            return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
        }
        function selection_clone(deep) {
            return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
        }
        function selection_datum(value) {
            return arguments.length ? this.property("__data__", value) : this.node().__data__;
        }
        function contextListener(listener) {
            return function(event) {
                listener.call(this, event, this.__data__);
            };
        }
        function parseTypenames(typenames) {
            return typenames.trim().split(/^|\s+/).map(function(t) {
                var name = "", i = t.indexOf(".");
                if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
                return {
                    type: t,
                    name: name
                };
            });
        }
        function onRemove(typename) {
            return function() {
                var on = this.__on;
                if (!on) return;
                for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
                else on[++i] = o;
                if (++i) on.length = i;
                else delete this.__on;
            };
        }
        function onAdd(typename, value, options) {
            return function() {
                var on = this.__on, o, listener = contextListener(value);
                if (on) {
                    for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                        this.removeEventListener(o.type, o.listener, o.options);
                        this.addEventListener(o.type, o.listener = listener, o.options = options);
                        o.value = value;
                        return;
                    }
                }
                this.addEventListener(typename.type, listener, options);
                o = {
                    type: typename.type,
                    name: typename.name,
                    value: value,
                    listener: listener,
                    options: options
                };
                if (!on) this.__on = [
                    o
                ];
                else on.push(o);
            };
        }
        function selection_on(typename, value, options) {
            var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
            if (arguments.length < 2) {
                var on = this.node().__on;
                if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                    if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
                }
                return;
            }
            on = value ? onAdd : onRemove;
            for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
            return this;
        }
        function dispatchEvent(node, type, params) {
            var window1 = defaultView(node), event = window1.CustomEvent;
            if (typeof event === "function") event = new event(type, params);
            else {
                event = window1.document.createEvent("Event");
                if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
                else event.initEvent(type, false, false);
            }
            node.dispatchEvent(event);
        }
        function dispatchConstant(type, params) {
            return function() {
                return dispatchEvent(this, type, params);
            };
        }
        function dispatchFunction(type, params) {
            return function() {
                return dispatchEvent(this, type, params.apply(this, arguments));
            };
        }
        function selection_dispatch(type, params) {
            return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
        }
        function* selection_iterator() {
            for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
                for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
            }
        }
        var root$1 = [
            null
        ];
        function Selection$1(groups, parents) {
            this._groups = groups;
            this._parents = parents;
        }
        function selection() {
            return new Selection$1([
                [
                    document.documentElement
                ]
            ], root$1);
        }
        function selection_selection() {
            return this;
        }
        Selection$1.prototype = selection.prototype = {
            constructor: Selection$1,
            select: selection_select,
            selectAll: selection_selectAll,
            selectChild: selection_selectChild,
            selectChildren: selection_selectChildren,
            filter: selection_filter,
            data: selection_data,
            enter: selection_enter,
            exit: selection_exit,
            join: selection_join,
            merge: selection_merge,
            selection: selection_selection,
            order: selection_order,
            sort: selection_sort,
            call: selection_call,
            nodes: selection_nodes,
            node: selection_node,
            size: selection_size,
            empty: selection_empty,
            each: selection_each,
            attr: selection_attr,
            style: selection_style,
            property: selection_property,
            classed: selection_classed,
            text: selection_text,
            html: selection_html,
            raise: selection_raise,
            lower: selection_lower,
            append: selection_append,
            insert: selection_insert,
            remove: selection_remove,
            clone: selection_clone,
            datum: selection_datum,
            on: selection_on,
            dispatch: selection_dispatch,
            [Symbol.iterator]: selection_iterator
        };
        function select(selector) {
            return typeof selector === "string" ? new Selection$1([
                [
                    document.querySelector(selector)
                ]
            ], [
                document.documentElement
            ]) : new Selection$1([
                [
                    selector
                ]
            ], root$1);
        }
        function create$1(name) {
            return select(creator(name).call(document.documentElement));
        }
        var nextId = 0;
        function local$1() {
            return new Local;
        }
        function Local() {
            this._ = "@" + (++nextId).toString(36);
        }
        Local.prototype = local$1.prototype = {
            constructor: Local,
            get: function(node) {
                var id = this._;
                while(!(id in node))if (!(node = node.parentNode)) return;
                return node[id];
            },
            set: function(node, value) {
                return node[this._] = value;
            },
            remove: function(node) {
                return this._ in node && delete node[this._];
            },
            toString: function() {
                return this._;
            }
        };
        function sourceEvent(event) {
            let sourceEvent;
            while(sourceEvent = event.sourceEvent)event = sourceEvent;
            return event;
        }
        function pointer(event, node) {
            event = sourceEvent(event);
            if (node === undefined) node = event.currentTarget;
            if (node) {
                var svg = node.ownerSVGElement || node;
                if (svg.createSVGPoint) {
                    var point = svg.createSVGPoint();
                    point.x = event.clientX, point.y = event.clientY;
                    point = point.matrixTransform(node.getScreenCTM().inverse());
                    return [
                        point.x,
                        point.y
                    ];
                }
                if (node.getBoundingClientRect) {
                    var rect = node.getBoundingClientRect();
                    return [
                        event.clientX - rect.left - node.clientLeft,
                        event.clientY - rect.top - node.clientTop
                    ];
                }
            }
            return [
                event.pageX,
                event.pageY
            ];
        }
        function pointers(events, node) {
            if (events.target) {
                events = sourceEvent(events);
                if (node === undefined) node = events.currentTarget;
                events = events.touches || [
                    events
                ];
            }
            return Array.from(events, (event)=>pointer(event, node));
        }
        function selectAll(selector) {
            return typeof selector === "string" ? new Selection$1([
                document.querySelectorAll(selector)
            ], [
                document.documentElement
            ]) : new Selection$1([
                array$4(selector)
            ], root$1);
        }
        const nonpassive = {
            passive: false
        };
        const nonpassivecapture = {
            capture: true,
            passive: false
        };
        function nopropagation$2(event) {
            event.stopImmediatePropagation();
        }
        function noevent$2(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        function dragDisable(view) {
            var root = view.document.documentElement, selection = select(view).on("dragstart.drag", noevent$2, nonpassivecapture);
            if ("onselectstart" in root) selection.on("selectstart.drag", noevent$2, nonpassivecapture);
            else {
                root.__noselect = root.style.MozUserSelect;
                root.style.MozUserSelect = "none";
            }
        }
        function yesdrag(view, noclick) {
            var root = view.document.documentElement, selection = select(view).on("dragstart.drag", null);
            if (noclick) {
                selection.on("click.drag", noevent$2, nonpassivecapture);
                setTimeout(function() {
                    selection.on("click.drag", null);
                }, 0);
            }
            if ("onselectstart" in root) selection.on("selectstart.drag", null);
            else {
                root.style.MozUserSelect = root.__noselect;
                delete root.__noselect;
            }
        }
        var constant$9 = (x)=>()=>x;
        function DragEvent(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
            Object.defineProperties(this, {
                type: {
                    value: type,
                    enumerable: true,
                    configurable: true
                },
                sourceEvent: {
                    value: sourceEvent,
                    enumerable: true,
                    configurable: true
                },
                subject: {
                    value: subject,
                    enumerable: true,
                    configurable: true
                },
                target: {
                    value: target,
                    enumerable: true,
                    configurable: true
                },
                identifier: {
                    value: identifier,
                    enumerable: true,
                    configurable: true
                },
                active: {
                    value: active,
                    enumerable: true,
                    configurable: true
                },
                x: {
                    value: x,
                    enumerable: true,
                    configurable: true
                },
                y: {
                    value: y,
                    enumerable: true,
                    configurable: true
                },
                dx: {
                    value: dx,
                    enumerable: true,
                    configurable: true
                },
                dy: {
                    value: dy,
                    enumerable: true,
                    configurable: true
                },
                _: {
                    value: dispatch
                }
            });
        }
        DragEvent.prototype.on = function() {
            var value = this._.on.apply(this._, arguments);
            return value === this._ ? this : value;
        };
        function defaultFilter$2(event) {
            return !event.ctrlKey && !event.button;
        }
        function defaultContainer() {
            return this.parentNode;
        }
        function defaultSubject(event, d) {
            return d == null ? {
                x: event.x,
                y: event.y
            } : d;
        }
        function defaultTouchable$2() {
            return navigator.maxTouchPoints || "ontouchstart" in this;
        }
        function drag() {
            var filter = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
            function drag(selection) {
                selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, nonpassive).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
            }
            function mousedowned(event, d) {
                if (touchending || !filter.call(this, event, d)) return;
                var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
                if (!gesture) return;
                select(event.view).on("mousemove.drag", mousemoved, nonpassivecapture).on("mouseup.drag", mouseupped, nonpassivecapture);
                dragDisable(event.view);
                nopropagation$2(event);
                mousemoving = false;
                mousedownx = event.clientX;
                mousedowny = event.clientY;
                gesture("start", event);
            }
            function mousemoved(event) {
                noevent$2(event);
                if (!mousemoving) {
                    var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                    mousemoving = dx * dx + dy * dy > clickDistance2;
                }
                gestures.mouse("drag", event);
            }
            function mouseupped(event) {
                select(event.view).on("mousemove.drag mouseup.drag", null);
                yesdrag(event.view, mousemoving);
                noevent$2(event);
                gestures.mouse("end", event);
            }
            function touchstarted(event, d) {
                if (!filter.call(this, event, d)) return;
                var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
                for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                    nopropagation$2(event);
                    gesture("start", event, touches[i]);
                }
            }
            function touchmoved(event) {
                var touches = event.changedTouches, n = touches.length, i, gesture;
                for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                    noevent$2(event);
                    gesture("drag", event, touches[i]);
                }
            }
            function touchended(event) {
                var touches = event.changedTouches, n = touches.length, i, gesture;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500);
                for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                    nopropagation$2(event);
                    gesture("end", event, touches[i]);
                }
            }
            function beforestart(that, container, event, d, identifier, touch) {
                var dispatch = listeners.copy(), p = pointer(touch || event, container), dx, dy, s;
                if ((s = subject.call(that, new DragEvent("beforestart", {
                    sourceEvent: event,
                    target: drag,
                    identifier: identifier,
                    active: active,
                    x: p[0],
                    y: p[1],
                    dx: 0,
                    dy: 0,
                    dispatch: dispatch
                }), d)) == null) return;
                dx = s.x - p[0] || 0;
                dy = s.y - p[1] || 0;
                return function gesture(type, event, touch) {
                    var p0 = p, n;
                    switch(type){
                        case "start":
                            gestures[identifier] = gesture, n = active++;
                            break;
                        case "end":
                            delete gestures[identifier], --active;
                        case "drag":
                            p = pointer(touch || event, container), n = active;
                            break;
                    }
                    dispatch.call(type, that, new DragEvent(type, {
                        sourceEvent: event,
                        subject: s,
                        target: drag,
                        identifier: identifier,
                        active: n,
                        x: p[0] + dx,
                        y: p[1] + dy,
                        dx: p[0] - p0[0],
                        dy: p[1] - p0[1],
                        dispatch: dispatch
                    }), d);
                };
            }
            drag.filter = function(_) {
                return arguments.length ? (filter = typeof _ === "function" ? _ : constant$9(!!_), drag) : filter;
            };
            drag.container = function(_) {
                return arguments.length ? (container = typeof _ === "function" ? _ : constant$9(_), drag) : container;
            };
            drag.subject = function(_) {
                return arguments.length ? (subject = typeof _ === "function" ? _ : constant$9(_), drag) : subject;
            };
            drag.touchable = function(_) {
                return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$9(!!_), drag) : touchable;
            };
            drag.on = function() {
                var value = listeners.on.apply(listeners, arguments);
                return value === listeners ? drag : value;
            };
            drag.clickDistance = function(_) {
                return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
            };
            return drag;
        }
        function define(constructor, factory, prototype) {
            constructor.prototype = factory.prototype = prototype;
            prototype.constructor = constructor;
        }
        function extend(parent, definition) {
            var prototype = Object.create(parent.prototype);
            for(var key in definition)prototype[key] = definition[key];
            return prototype;
        }
        function Color() {}
        var darker = 0.7;
        var brighter = 1 / darker;
        var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
        var named = {
            aliceblue: 0xf0f8ff,
            antiquewhite: 0xfaebd7,
            aqua: 0x00ffff,
            aquamarine: 0x7fffd4,
            azure: 0xf0ffff,
            beige: 0xf5f5dc,
            bisque: 0xffe4c4,
            black: 0x000000,
            blanchedalmond: 0xffebcd,
            blue: 0x0000ff,
            blueviolet: 0x8a2be2,
            brown: 0xa52a2a,
            burlywood: 0xdeb887,
            cadetblue: 0x5f9ea0,
            chartreuse: 0x7fff00,
            chocolate: 0xd2691e,
            coral: 0xff7f50,
            cornflowerblue: 0x6495ed,
            cornsilk: 0xfff8dc,
            crimson: 0xdc143c,
            cyan: 0x00ffff,
            darkblue: 0x00008b,
            darkcyan: 0x008b8b,
            darkgoldenrod: 0xb8860b,
            darkgray: 0xa9a9a9,
            darkgreen: 0x006400,
            darkgrey: 0xa9a9a9,
            darkkhaki: 0xbdb76b,
            darkmagenta: 0x8b008b,
            darkolivegreen: 0x556b2f,
            darkorange: 0xff8c00,
            darkorchid: 0x9932cc,
            darkred: 0x8b0000,
            darksalmon: 0xe9967a,
            darkseagreen: 0x8fbc8f,
            darkslateblue: 0x483d8b,
            darkslategray: 0x2f4f4f,
            darkslategrey: 0x2f4f4f,
            darkturquoise: 0x00ced1,
            darkviolet: 0x9400d3,
            deeppink: 0xff1493,
            deepskyblue: 0x00bfff,
            dimgray: 0x696969,
            dimgrey: 0x696969,
            dodgerblue: 0x1e90ff,
            firebrick: 0xb22222,
            floralwhite: 0xfffaf0,
            forestgreen: 0x228b22,
            fuchsia: 0xff00ff,
            gainsboro: 0xdcdcdc,
            ghostwhite: 0xf8f8ff,
            gold: 0xffd700,
            goldenrod: 0xdaa520,
            gray: 0x808080,
            green: 0x008000,
            greenyellow: 0xadff2f,
            grey: 0x808080,
            honeydew: 0xf0fff0,
            hotpink: 0xff69b4,
            indianred: 0xcd5c5c,
            indigo: 0x4b0082,
            ivory: 0xfffff0,
            khaki: 0xf0e68c,
            lavender: 0xe6e6fa,
            lavenderblush: 0xfff0f5,
            lawngreen: 0x7cfc00,
            lemonchiffon: 0xfffacd,
            lightblue: 0xadd8e6,
            lightcoral: 0xf08080,
            lightcyan: 0xe0ffff,
            lightgoldenrodyellow: 0xfafad2,
            lightgray: 0xd3d3d3,
            lightgreen: 0x90ee90,
            lightgrey: 0xd3d3d3,
            lightpink: 0xffb6c1,
            lightsalmon: 0xffa07a,
            lightseagreen: 0x20b2aa,
            lightskyblue: 0x87cefa,
            lightslategray: 0x778899,
            lightslategrey: 0x778899,
            lightsteelblue: 0xb0c4de,
            lightyellow: 0xffffe0,
            lime: 0x00ff00,
            limegreen: 0x32cd32,
            linen: 0xfaf0e6,
            magenta: 0xff00ff,
            maroon: 0x800000,
            mediumaquamarine: 0x66cdaa,
            mediumblue: 0x0000cd,
            mediumorchid: 0xba55d3,
            mediumpurple: 0x9370db,
            mediumseagreen: 0x3cb371,
            mediumslateblue: 0x7b68ee,
            mediumspringgreen: 0x00fa9a,
            mediumturquoise: 0x48d1cc,
            mediumvioletred: 0xc71585,
            midnightblue: 0x191970,
            mintcream: 0xf5fffa,
            mistyrose: 0xffe4e1,
            moccasin: 0xffe4b5,
            navajowhite: 0xffdead,
            navy: 0x000080,
            oldlace: 0xfdf5e6,
            olive: 0x808000,
            olivedrab: 0x6b8e23,
            orange: 0xffa500,
            orangered: 0xff4500,
            orchid: 0xda70d6,
            palegoldenrod: 0xeee8aa,
            palegreen: 0x98fb98,
            paleturquoise: 0xafeeee,
            palevioletred: 0xdb7093,
            papayawhip: 0xffefd5,
            peachpuff: 0xffdab9,
            peru: 0xcd853f,
            pink: 0xffc0cb,
            plum: 0xdda0dd,
            powderblue: 0xb0e0e6,
            purple: 0x800080,
            rebeccapurple: 0x663399,
            red: 0xff0000,
            rosybrown: 0xbc8f8f,
            royalblue: 0x4169e1,
            saddlebrown: 0x8b4513,
            salmon: 0xfa8072,
            sandybrown: 0xf4a460,
            seagreen: 0x2e8b57,
            seashell: 0xfff5ee,
            sienna: 0xa0522d,
            silver: 0xc0c0c0,
            skyblue: 0x87ceeb,
            slateblue: 0x6a5acd,
            slategray: 0x708090,
            slategrey: 0x708090,
            snow: 0xfffafa,
            springgreen: 0x00ff7f,
            steelblue: 0x4682b4,
            tan: 0xd2b48c,
            teal: 0x008080,
            thistle: 0xd8bfd8,
            tomato: 0xff6347,
            turquoise: 0x40e0d0,
            violet: 0xee82ee,
            wheat: 0xf5deb3,
            white: 0xffffff,
            whitesmoke: 0xf5f5f5,
            yellow: 0xffff00,
            yellowgreen: 0x9acd32
        };
        define(Color, color, {
            copy (channels) {
                return Object.assign(new this.constructor, this, channels);
            },
            displayable () {
                return this.rgb().displayable();
            },
            hex: color_formatHex,
            formatHex: color_formatHex,
            formatHex8: color_formatHex8,
            formatHsl: color_formatHsl,
            formatRgb: color_formatRgb,
            toString: color_formatRgb
        });
        function color_formatHex() {
            return this.rgb().formatHex();
        }
        function color_formatHex8() {
            return this.rgb().formatHex8();
        }
        function color_formatHsl() {
            return hslConvert(this).formatHsl();
        }
        function color_formatRgb() {
            return this.rgb().formatRgb();
        }
        function color(format) {
            var m, l;
            format = (format + "").trim().toLowerCase();
            return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) : null) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
        }
        function rgbn(n) {
            return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
        }
        function rgba(r, g, b, a) {
            if (a <= 0) r = g = b = NaN;
            return new Rgb(r, g, b, a);
        }
        function rgbConvert(o) {
            if (!(o instanceof Color)) o = color(o);
            if (!o) return new Rgb;
            o = o.rgb();
            return new Rgb(o.r, o.g, o.b, o.opacity);
        }
        function rgb(r, g, b, opacity) {
            return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
        }
        function Rgb(r, g, b, opacity) {
            this.r = +r;
            this.g = +g;
            this.b = +b;
            this.opacity = +opacity;
        }
        define(Rgb, rgb, extend(Color, {
            brighter (k) {
                k = k == null ? brighter : Math.pow(brighter, k);
                return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
            },
            darker (k) {
                k = k == null ? darker : Math.pow(darker, k);
                return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
            },
            rgb () {
                return this;
            },
            clamp () {
                return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
            },
            displayable () {
                return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
            },
            hex: rgb_formatHex,
            formatHex: rgb_formatHex,
            formatHex8: rgb_formatHex8,
            formatRgb: rgb_formatRgb,
            toString: rgb_formatRgb
        }));
        function rgb_formatHex() {
            return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
        }
        function rgb_formatHex8() {
            return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
        }
        function rgb_formatRgb() {
            const a = clampa(this.opacity);
            return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
        }
        function clampa(opacity) {
            return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
        }
        function clampi(value) {
            return Math.max(0, Math.min(255, Math.round(value) || 0));
        }
        function hex(value) {
            value = clampi(value);
            return (value < 16 ? "0" : "") + value.toString(16);
        }
        function hsla(h, s, l, a) {
            if (a <= 0) h = s = l = NaN;
            else if (l <= 0 || l >= 1) h = s = NaN;
            else if (s <= 0) h = NaN;
            return new Hsl(h, s, l, a);
        }
        function hslConvert(o) {
            if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
            if (!(o instanceof Color)) o = color(o);
            if (!o) return new Hsl;
            if (o instanceof Hsl) return o;
            o = o.rgb();
            var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
            if (s) {
                if (r === max) h = (g - b) / s + (g < b) * 6;
                else if (g === max) h = (b - r) / s + 2;
                else h = (r - g) / s + 4;
                s /= l < 0.5 ? max + min : 2 - max - min;
                h *= 60;
            } else s = l > 0 && l < 1 ? 0 : h;
            return new Hsl(h, s, l, o.opacity);
        }
        function hsl$2(h, s, l, opacity) {
            return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
        }
        function Hsl(h, s, l, opacity) {
            this.h = +h;
            this.s = +s;
            this.l = +l;
            this.opacity = +opacity;
        }
        define(Hsl, hsl$2, extend(Color, {
            brighter (k) {
                k = k == null ? brighter : Math.pow(brighter, k);
                return new Hsl(this.h, this.s, this.l * k, this.opacity);
            },
            darker (k) {
                k = k == null ? darker : Math.pow(darker, k);
                return new Hsl(this.h, this.s, this.l * k, this.opacity);
            },
            rgb () {
                var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
                return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
            },
            clamp () {
                return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
            },
            displayable () {
                return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
            },
            formatHsl () {
                const a = clampa(this.opacity);
                return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
            }
        }));
        function clamph(value) {
            value = (value || 0) % 360;
            return value < 0 ? value + 360 : value;
        }
        function clampt(value) {
            return Math.max(0, Math.min(1, value || 0));
        }
        function hsl2rgb(h, m1, m2) {
            return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
        }
        const radians$1 = Math.PI / 180;
        const degrees$2 = 180 / Math.PI;
        const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
        function labConvert(o) {
            if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
            if (o instanceof Hcl) return hcl2lab(o);
            if (!(o instanceof Rgb)) o = rgbConvert(o);
            var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
            if (r === g && g === b) x = z = y;
            else {
                x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
                z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
            }
            return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
        }
        function gray(l, opacity) {
            return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
        }
        function lab$1(l, a, b, opacity) {
            return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
        }
        function Lab(l, a, b, opacity) {
            this.l = +l;
            this.a = +a;
            this.b = +b;
            this.opacity = +opacity;
        }
        define(Lab, lab$1, extend(Color, {
            brighter (k) {
                return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
            },
            darker (k) {
                return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
            },
            rgb () {
                var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
                x = Xn * lab2xyz(x);
                y = Yn * lab2xyz(y);
                z = Zn * lab2xyz(z);
                return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
            }
        }));
        function xyz2lab(t) {
            return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
        }
        function lab2xyz(t) {
            return t > t1$1 ? t * t * t : t2 * (t - t0$1);
        }
        function lrgb2rgb(x) {
            return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
        }
        function rgb2lrgb(x) {
            return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
        }
        function hclConvert(o) {
            if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
            if (!(o instanceof Lab)) o = labConvert(o);
            if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
            var h = Math.atan2(o.b, o.a) * degrees$2;
            return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
        }
        function lch(l, c, h, opacity) {
            return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
        }
        function hcl$2(h, c, l, opacity) {
            return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
        }
        function Hcl(h, c, l, opacity) {
            this.h = +h;
            this.c = +c;
            this.l = +l;
            this.opacity = +opacity;
        }
        function hcl2lab(o) {
            if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
            var h = o.h * radians$1;
            return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
        }
        define(Hcl, hcl$2, extend(Color, {
            brighter (k) {
                return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
            },
            darker (k) {
                return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
            },
            rgb () {
                return hcl2lab(this).rgb();
            }
        }));
        var A = -0.14861, B$1 = 1.78277, C = -0.29227, D$1 = -0.90649, E = 1.97294, ED = E * D$1, EB = E * B$1, BC_DA = B$1 * C - D$1 * A;
        function cubehelixConvert(o) {
            if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
            if (!(o instanceof Rgb)) o = rgbConvert(o);
            var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D$1, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
            return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
        }
        function cubehelix$3(h, s, l, opacity) {
            return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
        }
        function Cubehelix(h, s, l, opacity) {
            this.h = +h;
            this.s = +s;
            this.l = +l;
            this.opacity = +opacity;
        }
        define(Cubehelix, cubehelix$3, extend(Color, {
            brighter (k) {
                k = k == null ? brighter : Math.pow(brighter, k);
                return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
            },
            darker (k) {
                k = k == null ? darker : Math.pow(darker, k);
                return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
            },
            rgb () {
                var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
                return new Rgb(255 * (l + a * (A * cosh + B$1 * sinh)), 255 * (l + a * (C * cosh + D$1 * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
            }
        }));
        function basis$1(t1, v0, v1, v2, v3) {
            var t2 = t1 * t1, t3 = t2 * t1;
            return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
        }
        function basis$2(values) {
            var n = values.length - 1;
            return function(t) {
                var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
                return basis$1((t - i / n) * n, v0, v1, v2, v3);
            };
        }
        function basisClosed$1(values) {
            var n = values.length;
            return function(t) {
                var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
                return basis$1((t - i / n) * n, v0, v1, v2, v3);
            };
        }
        var constant$8 = (x)=>()=>x;
        function linear$2(a, d) {
            return function(t) {
                return a + t * d;
            };
        }
        function exponential$1(a, b, y) {
            return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
                return Math.pow(a + t * b, y);
            };
        }
        function hue$1(a, b) {
            var d = b - a;
            return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$8(isNaN(a) ? b : a);
        }
        function gamma$1(y) {
            return (y = +y) === 1 ? nogamma : function(a, b) {
                return b - a ? exponential$1(a, b, y) : constant$8(isNaN(a) ? b : a);
            };
        }
        function nogamma(a, b) {
            var d = b - a;
            return d ? linear$2(a, d) : constant$8(isNaN(a) ? b : a);
        }
        var interpolateRgb = function rgbGamma(y) {
            var color = gamma$1(y);
            function rgb$1(start, end) {
                var r = color((start = rgb(start)).r, (end = rgb(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.r = r(t);
                    start.g = g(t);
                    start.b = b(t);
                    start.opacity = opacity(t);
                    return start + "";
                };
            }
            rgb$1.gamma = rgbGamma;
            return rgb$1;
        }(1);
        function rgbSpline(spline) {
            return function(colors) {
                var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
                for(i = 0; i < n; ++i){
                    color = rgb(colors[i]);
                    r[i] = color.r || 0;
                    g[i] = color.g || 0;
                    b[i] = color.b || 0;
                }
                r = spline(r);
                g = spline(g);
                b = spline(b);
                color.opacity = 1;
                return function(t) {
                    color.r = r(t);
                    color.g = g(t);
                    color.b = b(t);
                    return color + "";
                };
            };
        }
        var rgbBasis = rgbSpline(basis$2);
        var rgbBasisClosed = rgbSpline(basisClosed$1);
        function numberArray(a, b) {
            if (!b) b = [];
            var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
            return function(t) {
                for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
                return c;
            };
        }
        function isNumberArray(x) {
            return ArrayBuffer.isView(x) && !(x instanceof DataView);
        }
        function array$3(a, b) {
            return (isNumberArray(b) ? numberArray : genericArray)(a, b);
        }
        function genericArray(a, b) {
            var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
            for(i = 0; i < na; ++i)x[i] = interpolate$2(a[i], b[i]);
            for(; i < nb; ++i)c[i] = b[i];
            return function(t) {
                for(i = 0; i < na; ++i)c[i] = x[i](t);
                return c;
            };
        }
        function date$1(a, b) {
            var d = new Date;
            return a = +a, b = +b, function(t) {
                return d.setTime(a * (1 - t) + b * t), d;
            };
        }
        function interpolateNumber(a, b) {
            return a = +a, b = +b, function(t) {
                return a * (1 - t) + b * t;
            };
        }
        function object$1(a, b) {
            var i = {}, c = {}, k;
            if (a === null || typeof a !== "object") a = {};
            if (b === null || typeof b !== "object") b = {};
            for(k in b)if (k in a) i[k] = interpolate$2(a[k], b[k]);
            else c[k] = b[k];
            return function(t) {
                for(k in i)c[k] = i[k](t);
                return c;
            };
        }
        var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
        function zero(b) {
            return function() {
                return b;
            };
        }
        function one(b) {
            return function(t) {
                return b(t) + "";
            };
        }
        function interpolateString(a, b) {
            var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
            a = a + "", b = b + "";
            while((am = reA.exec(a)) && (bm = reB.exec(b))){
                if ((bs = bm.index) > bi) {
                    bs = b.slice(bi, bs);
                    if (s[i]) s[i] += bs;
                    else s[++i] = bs;
                }
                if ((am = am[0]) === (bm = bm[0])) {
                    if (s[i]) s[i] += bm;
                    else s[++i] = bm;
                } else {
                    s[++i] = null;
                    q.push({
                        i: i,
                        x: interpolateNumber(am, bm)
                    });
                }
                bi = reB.lastIndex;
            }
            if (bi < b.length) {
                bs = b.slice(bi);
                if (s[i]) s[i] += bs;
                else s[++i] = bs;
            }
            return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
                for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
                return s.join("");
            });
        }
        function interpolate$2(a, b) {
            var t = typeof b, c;
            return b == null || t === "boolean" ? constant$8(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
        }
        function discrete(range) {
            var n = range.length;
            return function(t) {
                return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
            };
        }
        function hue(a, b) {
            var i = hue$1(+a, +b);
            return function(t) {
                var x = i(t);
                return x - 360 * Math.floor(x / 360);
            };
        }
        function interpolateRound(a, b) {
            return a = +a, b = +b, function(t) {
                return Math.round(a * (1 - t) + b * t);
            };
        }
        var degrees$1 = 180 / Math.PI;
        var identity$7 = {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            skewX: 0,
            scaleX: 1,
            scaleY: 1
        };
        function decompose(a, b, c, d, e, f) {
            var scaleX, scaleY, skewX;
            if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
            if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
            if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
            if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
            return {
                translateX: e,
                translateY: f,
                rotate: Math.atan2(b, a) * degrees$1,
                skewX: Math.atan(skewX) * degrees$1,
                scaleX: scaleX,
                scaleY: scaleY
            };
        }
        var svgNode;
        function parseCss(value) {
            const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
            return m.isIdentity ? identity$7 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
        }
        function parseSvg(value) {
            if (value == null) return identity$7;
            if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svgNode.setAttribute("transform", value);
            if (!(value = svgNode.transform.baseVal.consolidate())) return identity$7;
            value = value.matrix;
            return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
        }
        function interpolateTransform(parse, pxComma, pxParen, degParen) {
            function pop(s) {
                return s.length ? s.pop() + " " : "";
            }
            function translate(xa, ya, xb, yb, s, q) {
                if (xa !== xb || ya !== yb) {
                    var i = s.push("translate(", null, pxComma, null, pxParen);
                    q.push({
                        i: i - 4,
                        x: interpolateNumber(xa, xb)
                    }, {
                        i: i - 2,
                        x: interpolateNumber(ya, yb)
                    });
                } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
            }
            function rotate(a, b, s, q) {
                if (a !== b) {
                    if (a - b > 180) b += 360;
                    else if (b - a > 180) a += 360;
                    q.push({
                        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                        x: interpolateNumber(a, b)
                    });
                } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
            }
            function skewX(a, b, s, q) {
                if (a !== b) q.push({
                    i: s.push(pop(s) + "skewX(", null, degParen) - 2,
                    x: interpolateNumber(a, b)
                });
                else if (b) s.push(pop(s) + "skewX(" + b + degParen);
            }
            function scale(xa, ya, xb, yb, s, q) {
                if (xa !== xb || ya !== yb) {
                    var i = s.push(pop(s) + "scale(", null, ",", null, ")");
                    q.push({
                        i: i - 4,
                        x: interpolateNumber(xa, xb)
                    }, {
                        i: i - 2,
                        x: interpolateNumber(ya, yb)
                    });
                } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
            }
            return function(a, b) {
                var s = [], q = [];
                a = parse(a), b = parse(b);
                translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
                rotate(a.rotate, b.rotate, s, q);
                skewX(a.skewX, b.skewX, s, q);
                scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
                a = b = null;
                return function(t) {
                    var i = -1, n = q.length, o;
                    while(++i < n)s[(o = q[i]).i] = o.x(t);
                    return s.join("");
                };
            };
        }
        var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
        var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
        var epsilon2$1 = 1e-12;
        function cosh(x) {
            return ((x = Math.exp(x)) + 1 / x) / 2;
        }
        function sinh(x) {
            return ((x = Math.exp(x)) - 1 / x) / 2;
        }
        function tanh(x) {
            return ((x = Math.exp(2 * x)) - 1) / (x + 1);
        }
        var interpolateZoom = function zoomRho(rho, rho2, rho4) {
            function zoom(p0, p1) {
                var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
                if (d2 < epsilon2$1) {
                    S = Math.log(w1 / w0) / rho;
                    i = function(t) {
                        return [
                            ux0 + t * dx,
                            uy0 + t * dy,
                            w0 * Math.exp(rho * t * S)
                        ];
                    };
                } else {
                    var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
                    S = (r1 - r0) / rho;
                    i = function(t) {
                        var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                        return [
                            ux0 + u * dx,
                            uy0 + u * dy,
                            w0 * coshr0 / cosh(rho * s + r0)
                        ];
                    };
                }
                i.duration = S * 1000 * rho / Math.SQRT2;
                return i;
            }
            zoom.rho = function(_) {
                var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
                return zoomRho(_1, _2, _4);
            };
            return zoom;
        }(Math.SQRT2, 2, 4);
        function hsl(hue) {
            return function(start, end) {
                var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.s = s(t);
                    start.l = l(t);
                    start.opacity = opacity(t);
                    return start + "";
                };
            };
        }
        var hsl$1 = hsl(hue$1);
        var hslLong = hsl(nogamma);
        function lab(start, end) {
            var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l), a = nogamma(start.a, end.a), b = nogamma(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.l = l(t);
                start.a = a(t);
                start.b = b(t);
                start.opacity = opacity(t);
                return start + "";
            };
        }
        function hcl(hue) {
            return function(start, end) {
                var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h), c = nogamma(start.c, end.c), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.c = c(t);
                    start.l = l(t);
                    start.opacity = opacity(t);
                    return start + "";
                };
            };
        }
        var hcl$1 = hcl(hue$1);
        var hclLong = hcl(nogamma);
        function cubehelix$1(hue) {
            return function cubehelixGamma(y) {
                y = +y;
                function cubehelix(start, end) {
                    var h = hue((start = cubehelix$3(start)).h, (end = cubehelix$3(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                    return function(t) {
                        start.h = h(t);
                        start.s = s(t);
                        start.l = l(Math.pow(t, y));
                        start.opacity = opacity(t);
                        return start + "";
                    };
                }
                cubehelix.gamma = cubehelixGamma;
                return cubehelix;
            }(1);
        }
        var cubehelix$2 = cubehelix$1(hue$1);
        var cubehelixLong = cubehelix$1(nogamma);
        function piecewise(interpolate, values) {
            if (values === undefined) values = interpolate, interpolate = interpolate$2;
            var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
            while(i < n)I[i] = interpolate(v, v = values[++i]);
            return function(t) {
                var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
                return I[i](t - i);
            };
        }
        function quantize$1(interpolator, n) {
            var samples = new Array(n);
            for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
            return samples;
        }
        var frame = 0, timeout$1 = 0, interval$1 = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
            setTimeout(f, 17);
        };
        function now() {
            return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
        }
        function clearNow() {
            clockNow = 0;
        }
        function Timer() {
            this._call = this._time = this._next = null;
        }
        Timer.prototype = timer.prototype = {
            constructor: Timer,
            restart: function(callback, delay, time) {
                if (typeof callback !== "function") throw new TypeError("callback is not a function");
                time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
                if (!this._next && taskTail !== this) {
                    if (taskTail) taskTail._next = this;
                    else taskHead = this;
                    taskTail = this;
                }
                this._call = callback;
                this._time = time;
                sleep();
            },
            stop: function() {
                if (this._call) {
                    this._call = null;
                    this._time = Infinity;
                    sleep();
                }
            }
        };
        function timer(callback, delay, time) {
            var t = new Timer;
            t.restart(callback, delay, time);
            return t;
        }
        function timerFlush() {
            now();
            ++frame;
            var t = taskHead, e;
            while(t){
                if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
                t = t._next;
            }
            --frame;
        }
        function wake() {
            clockNow = (clockLast = clock.now()) + clockSkew;
            frame = timeout$1 = 0;
            try {
                timerFlush();
            } finally{
                frame = 0;
                nap();
                clockNow = 0;
            }
        }
        function poke() {
            var now = clock.now(), delay = now - clockLast;
            if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
        }
        function nap() {
            var t0, t1 = taskHead, t2, time = Infinity;
            while(t1)if (t1._call) {
                if (time > t1._time) time = t1._time;
                t0 = t1, t1 = t1._next;
            } else {
                t2 = t1._next, t1._next = null;
                t1 = t0 ? t0._next = t2 : taskHead = t2;
            }
            taskTail = t0;
            sleep(time);
        }
        function sleep(time) {
            if (frame) return;
            if (timeout$1) timeout$1 = clearTimeout(timeout$1);
            var delay = time - clockNow;
            if (delay > 24) {
                if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
                if (interval$1) interval$1 = clearInterval(interval$1);
            } else {
                if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
                frame = 1, setFrame(wake);
            }
        }
        function timeout(callback, delay, time) {
            var t = new Timer;
            delay = delay == null ? 0 : +delay;
            t.restart((elapsed)=>{
                t.stop();
                callback(elapsed + delay);
            }, delay, time);
            return t;
        }
        function interval(callback, delay, time) {
            var t = new Timer, total = delay;
            if (delay == null) return t.restart(callback, delay, time), t;
            t._restart = t.restart;
            t.restart = function(callback, delay, time) {
                delay = +delay, time = time == null ? now() : +time;
                t._restart(function tick(elapsed) {
                    elapsed += total;
                    t._restart(tick, total += delay, time);
                    callback(elapsed);
                }, delay, time);
            };
            t.restart(callback, delay, time);
            return t;
        }
        var emptyOn = dispatch("start", "end", "cancel", "interrupt");
        var emptyTween = [];
        var CREATED = 0;
        var SCHEDULED = 1;
        var STARTING = 2;
        var STARTED = 3;
        var RUNNING = 4;
        var ENDING = 5;
        var ENDED = 6;
        function schedule(node, name, id, index, group, timing) {
            var schedules = node.__transition;
            if (!schedules) node.__transition = {};
            else if (id in schedules) return;
            create(node, id, {
                name: name,
                index: index,
                group: group,
                on: emptyOn,
                tween: emptyTween,
                time: timing.time,
                delay: timing.delay,
                duration: timing.duration,
                ease: timing.ease,
                timer: null,
                state: CREATED
            });
        }
        function init(node, id) {
            var schedule = get(node, id);
            if (schedule.state > CREATED) throw new Error("too late; already scheduled");
            return schedule;
        }
        function set(node, id) {
            var schedule = get(node, id);
            if (schedule.state > STARTED) throw new Error("too late; already running");
            return schedule;
        }
        function get(node, id) {
            var schedule = node.__transition;
            if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
            return schedule;
        }
        function create(node, id, self) {
            var schedules = node.__transition, tween;
            schedules[id] = self;
            self.timer = timer(schedule, 0, self.time);
            function schedule(elapsed) {
                self.state = SCHEDULED;
                self.timer.restart(start, self.delay, self.time);
                if (self.delay <= elapsed) start(elapsed - self.delay);
            }
            function start(elapsed) {
                var i, j, n, o;
                if (self.state !== SCHEDULED) return stop();
                for(i in schedules){
                    o = schedules[i];
                    if (o.name !== self.name) continue;
                    if (o.state === STARTED) return timeout(start);
                    if (o.state === RUNNING) {
                        o.state = ENDED;
                        o.timer.stop();
                        o.on.call("interrupt", node, node.__data__, o.index, o.group);
                        delete schedules[i];
                    } else if (+i < id) {
                        o.state = ENDED;
                        o.timer.stop();
                        o.on.call("cancel", node, node.__data__, o.index, o.group);
                        delete schedules[i];
                    }
                }
                timeout(function() {
                    if (self.state === STARTED) {
                        self.state = RUNNING;
                        self.timer.restart(tick, self.delay, self.time);
                        tick(elapsed);
                    }
                });
                self.state = STARTING;
                self.on.call("start", node, node.__data__, self.index, self.group);
                if (self.state !== STARTING) return;
                self.state = STARTED;
                tween = new Array(n = self.tween.length);
                for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
                tween.length = j + 1;
            }
            function tick(elapsed) {
                var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
                while(++i < n)tween[i].call(node, t);
                if (self.state === ENDING) {
                    self.on.call("end", node, node.__data__, self.index, self.group);
                    stop();
                }
            }
            function stop() {
                self.state = ENDED;
                self.timer.stop();
                delete schedules[id];
                for(var i in schedules)return;
                delete node.__transition;
            }
        }
        function interrupt(node, name) {
            var schedules = node.__transition, schedule, active, empty = true, i;
            if (!schedules) return;
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).name !== name) {
                    empty = false;
                    continue;
                }
                active = schedule.state > STARTING && schedule.state < ENDING;
                schedule.state = ENDED;
                schedule.timer.stop();
                schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
                delete schedules[i];
            }
            if (empty) delete node.__transition;
        }
        function selection_interrupt(name) {
            return this.each(function() {
                interrupt(this, name);
            });
        }
        function tweenRemove(id, name) {
            var tween0, tween1;
            return function() {
                var schedule = set(this, id), tween = schedule.tween;
                if (tween !== tween0) {
                    tween1 = tween0 = tween;
                    for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                        tween1 = tween1.slice();
                        tween1.splice(i, 1);
                        break;
                    }
                }
                schedule.tween = tween1;
            };
        }
        function tweenFunction(id, name, value) {
            var tween0, tween1;
            if (typeof value !== "function") throw new Error;
            return function() {
                var schedule = set(this, id), tween = schedule.tween;
                if (tween !== tween0) {
                    tween1 = (tween0 = tween).slice();
                    for(var t = {
                        name: name,
                        value: value
                    }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                        tween1[i] = t;
                        break;
                    }
                    if (i === n) tween1.push(t);
                }
                schedule.tween = tween1;
            };
        }
        function transition_tween(name, value) {
            var id = this._id;
            name += "";
            if (arguments.length < 2) {
                var tween = get(this.node(), id).tween;
                for(var i = 0, n = tween.length, t; i < n; ++i){
                    if ((t = tween[i]).name === name) return t.value;
                }
                return null;
            }
            return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
        }
        function tweenValue(transition, name, value) {
            var id = transition._id;
            transition.each(function() {
                var schedule = set(this, id);
                (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
            });
            return function(node) {
                return get(node, id).value[name];
            };
        }
        function interpolate$1(a, b) {
            var c;
            return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
        }
        function attrRemove(name) {
            return function() {
                this.removeAttribute(name);
            };
        }
        function attrRemoveNS(fullname) {
            return function() {
                this.removeAttributeNS(fullname.space, fullname.local);
            };
        }
        function attrConstant(name, interpolate, value1) {
            var string00, string1 = value1 + "", interpolate0;
            return function() {
                var string0 = this.getAttribute(name);
                return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
            };
        }
        function attrConstantNS(fullname, interpolate, value1) {
            var string00, string1 = value1 + "", interpolate0;
            return function() {
                var string0 = this.getAttributeNS(fullname.space, fullname.local);
                return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
            };
        }
        function attrFunction(name, interpolate, value) {
            var string00, string10, interpolate0;
            return function() {
                var string0, value1 = value(this), string1;
                if (value1 == null) return void this.removeAttribute(name);
                string0 = this.getAttribute(name);
                string1 = value1 + "";
                return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
            };
        }
        function attrFunctionNS(fullname, interpolate, value) {
            var string00, string10, interpolate0;
            return function() {
                var string0, value1 = value(this), string1;
                if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
                string0 = this.getAttributeNS(fullname.space, fullname.local);
                string1 = value1 + "";
                return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
            };
        }
        function transition_attr(name, value) {
            var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
            return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
        }
        function attrInterpolate(name, i) {
            return function(t) {
                this.setAttribute(name, i.call(this, t));
            };
        }
        function attrInterpolateNS(fullname, i) {
            return function(t) {
                this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
            };
        }
        function attrTweenNS(fullname, value) {
            var t0, i0;
            function tween() {
                var i = value.apply(this, arguments);
                if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
                return t0;
            }
            tween._value = value;
            return tween;
        }
        function attrTween(name, value) {
            var t0, i0;
            function tween() {
                var i = value.apply(this, arguments);
                if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
                return t0;
            }
            tween._value = value;
            return tween;
        }
        function transition_attrTween(name, value) {
            var key = "attr." + name;
            if (arguments.length < 2) return (key = this.tween(key)) && key._value;
            if (value == null) return this.tween(key, null);
            if (typeof value !== "function") throw new Error;
            var fullname = namespace(name);
            return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
        }
        function delayFunction(id, value) {
            return function() {
                init(this, id).delay = +value.apply(this, arguments);
            };
        }
        function delayConstant(id, value) {
            return value = +value, function() {
                init(this, id).delay = value;
            };
        }
        function transition_delay(value) {
            var id = this._id;
            return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : get(this.node(), id).delay;
        }
        function durationFunction(id, value) {
            return function() {
                set(this, id).duration = +value.apply(this, arguments);
            };
        }
        function durationConstant(id, value) {
            return value = +value, function() {
                set(this, id).duration = value;
            };
        }
        function transition_duration(value) {
            var id = this._id;
            return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : get(this.node(), id).duration;
        }
        function easeConstant(id, value) {
            if (typeof value !== "function") throw new Error;
            return function() {
                set(this, id).ease = value;
            };
        }
        function transition_ease(value) {
            var id = this._id;
            return arguments.length ? this.each(easeConstant(id, value)) : get(this.node(), id).ease;
        }
        function easeVarying(id, value) {
            return function() {
                var v = value.apply(this, arguments);
                if (typeof v !== "function") throw new Error;
                set(this, id).ease = v;
            };
        }
        function transition_easeVarying(value) {
            if (typeof value !== "function") throw new Error;
            return this.each(easeVarying(this._id, value));
        }
        function transition_filter(match) {
            if (typeof match !== "function") match = matcher(match);
            for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
            }
            return new Transition(subgroups, this._parents, this._name, this._id);
        }
        function transition_merge(transition) {
            if (transition._id !== this._id) throw new Error;
            for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
                for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
            }
            for(; j < m0; ++j)merges[j] = groups0[j];
            return new Transition(merges, this._parents, this._name, this._id);
        }
        function start(name) {
            return (name + "").trim().split(/^|\s+/).every(function(t) {
                var i = t.indexOf(".");
                if (i >= 0) t = t.slice(0, i);
                return !t || t === "start";
            });
        }
        function onFunction(id, name, listener) {
            var on0, on1, sit = start(name) ? init : set;
            return function() {
                var schedule = sit(this, id), on = schedule.on;
                if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
                schedule.on = on1;
            };
        }
        function transition_on(name, listener) {
            var id = this._id;
            return arguments.length < 2 ? get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
        }
        function removeFunction(id) {
            return function() {
                var parent = this.parentNode;
                for(var i in this.__transition)if (+i !== id) return;
                if (parent) parent.removeChild(this);
            };
        }
        function transition_remove() {
            return this.on("end.remove", removeFunction(this._id));
        }
        function transition_select(select) {
            var name = this._name, id = this._id;
            if (typeof select !== "function") select = selector(select);
            for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                    if ("__data__" in node) subnode.__data__ = node.__data__;
                    subgroup[i] = subnode;
                    schedule(subgroup[i], name, id, i, subgroup, get(node, id));
                }
            }
            return new Transition(subgroups, this._parents, name, id);
        }
        function transition_selectAll(select) {
            var name = this._name, id = this._id;
            if (typeof select !== "function") select = selectorAll(select);
            for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                    for(var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) schedule(child, name, id, k, children, inherit);
                    subgroups.push(children);
                    parents.push(node);
                }
            }
            return new Transition(subgroups, parents, name, id);
        }
        var Selection = selection.prototype.constructor;
        function transition_selection() {
            return new Selection(this._groups, this._parents);
        }
        function styleNull(name, interpolate) {
            var string00, string10, interpolate0;
            return function() {
                var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
                return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
            };
        }
        function styleRemove(name) {
            return function() {
                this.style.removeProperty(name);
            };
        }
        function styleConstant(name, interpolate, value1) {
            var string00, string1 = value1 + "", interpolate0;
            return function() {
                var string0 = styleValue(this, name);
                return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
            };
        }
        function styleFunction(name, interpolate, value) {
            var string00, string10, interpolate0;
            return function() {
                var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
                if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
                return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
            };
        }
        function styleMaybeRemove(id, name) {
            var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
            return function() {
                var schedule = set(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
                if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
                schedule.on = on1;
            };
        }
        function transition_style(name, value, priority) {
            var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
            return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
        }
        function styleInterpolate(name, i, priority) {
            return function(t) {
                this.style.setProperty(name, i.call(this, t), priority);
            };
        }
        function styleTween(name, value, priority) {
            var t, i0;
            function tween() {
                var i = value.apply(this, arguments);
                if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
                return t;
            }
            tween._value = value;
            return tween;
        }
        function transition_styleTween(name, value, priority) {
            var key = "style." + (name += "");
            if (arguments.length < 2) return (key = this.tween(key)) && key._value;
            if (value == null) return this.tween(key, null);
            if (typeof value !== "function") throw new Error;
            return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
        }
        function textConstant(value) {
            return function() {
                this.textContent = value;
            };
        }
        function textFunction(value) {
            return function() {
                var value1 = value(this);
                this.textContent = value1 == null ? "" : value1;
            };
        }
        function transition_text(value) {
            return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
        }
        function textInterpolate(i) {
            return function(t) {
                this.textContent = i.call(this, t);
            };
        }
        function textTween(value) {
            var t0, i0;
            function tween() {
                var i = value.apply(this, arguments);
                if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
                return t0;
            }
            tween._value = value;
            return tween;
        }
        function transition_textTween(value) {
            var key = "text";
            if (arguments.length < 1) return (key = this.tween(key)) && key._value;
            if (value == null) return this.tween(key, null);
            if (typeof value !== "function") throw new Error;
            return this.tween(key, textTween(value));
        }
        function transition_transition() {
            var name = this._name, id0 = this._id, id1 = newId();
            for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                    var inherit = get(node, id0);
                    schedule(node, name, id1, i, group, {
                        time: inherit.time + inherit.delay + inherit.duration,
                        delay: 0,
                        duration: inherit.duration,
                        ease: inherit.ease
                    });
                }
            }
            return new Transition(groups, this._parents, name, id1);
        }
        function transition_end() {
            var on0, on1, that = this, id = that._id, size = that.size();
            return new Promise(function(resolve, reject) {
                var cancel = {
                    value: reject
                }, end = {
                    value: function() {
                        if (--size === 0) resolve();
                    }
                };
                that.each(function() {
                    var schedule = set(this, id), on = schedule.on;
                    if (on !== on0) {
                        on1 = (on0 = on).copy();
                        on1._.cancel.push(cancel);
                        on1._.interrupt.push(cancel);
                        on1._.end.push(end);
                    }
                    schedule.on = on1;
                });
                if (size === 0) resolve();
            });
        }
        var id = 0;
        function Transition(groups, parents, name, id) {
            this._groups = groups;
            this._parents = parents;
            this._name = name;
            this._id = id;
        }
        function transition(name) {
            return selection().transition(name);
        }
        function newId() {
            return ++id;
        }
        var selection_prototype = selection.prototype;
        Transition.prototype = transition.prototype = {
            constructor: Transition,
            select: transition_select,
            selectAll: transition_selectAll,
            selectChild: selection_prototype.selectChild,
            selectChildren: selection_prototype.selectChildren,
            filter: transition_filter,
            merge: transition_merge,
            selection: transition_selection,
            transition: transition_transition,
            call: selection_prototype.call,
            nodes: selection_prototype.nodes,
            node: selection_prototype.node,
            size: selection_prototype.size,
            empty: selection_prototype.empty,
            each: selection_prototype.each,
            on: transition_on,
            attr: transition_attr,
            attrTween: transition_attrTween,
            style: transition_style,
            styleTween: transition_styleTween,
            text: transition_text,
            textTween: transition_textTween,
            remove: transition_remove,
            tween: transition_tween,
            delay: transition_delay,
            duration: transition_duration,
            ease: transition_ease,
            easeVarying: transition_easeVarying,
            end: transition_end,
            [Symbol.iterator]: selection_prototype[Symbol.iterator]
        };
        const linear$1 = (t)=>+t;
        function quadIn(t) {
            return t * t;
        }
        function quadOut(t) {
            return t * (2 - t);
        }
        function quadInOut(t) {
            return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
        }
        function cubicIn(t) {
            return t * t * t;
        }
        function cubicOut(t) {
            return --t * t * t + 1;
        }
        function cubicInOut(t) {
            return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
        }
        var exponent$1 = 3;
        var polyIn = function custom(e) {
            e = +e;
            function polyIn(t) {
                return Math.pow(t, e);
            }
            polyIn.exponent = custom;
            return polyIn;
        }(exponent$1);
        var polyOut = function custom(e) {
            e = +e;
            function polyOut(t) {
                return 1 - Math.pow(1 - t, e);
            }
            polyOut.exponent = custom;
            return polyOut;
        }(exponent$1);
        var polyInOut = function custom(e) {
            e = +e;
            function polyInOut(t) {
                return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
            }
            polyInOut.exponent = custom;
            return polyInOut;
        }(exponent$1);
        var pi$4 = Math.PI, halfPi$3 = pi$4 / 2;
        function sinIn(t) {
            return +t === 1 ? 1 : 1 - Math.cos(t * halfPi$3);
        }
        function sinOut(t) {
            return Math.sin(t * halfPi$3);
        }
        function sinInOut(t) {
            return (1 - Math.cos(pi$4 * t)) / 2;
        }
        function tpmt(x) {
            return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
        }
        function expIn(t) {
            return tpmt(1 - +t);
        }
        function expOut(t) {
            return 1 - tpmt(t);
        }
        function expInOut(t) {
            return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
        }
        function circleIn(t) {
            return 1 - Math.sqrt(1 - t * t);
        }
        function circleOut(t) {
            return Math.sqrt(1 - --t * t);
        }
        function circleInOut(t) {
            return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
        }
        var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
        function bounceIn(t) {
            return 1 - bounceOut(1 - t);
        }
        function bounceOut(t) {
            return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
        }
        function bounceInOut(t) {
            return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
        }
        var overshoot = 1.70158;
        var backIn = function custom(s) {
            s = +s;
            function backIn(t) {
                return (t = +t) * t * (s * (t - 1) + t);
            }
            backIn.overshoot = custom;
            return backIn;
        }(overshoot);
        var backOut = function custom(s) {
            s = +s;
            function backOut(t) {
                return --t * t * ((t + 1) * s + t) + 1;
            }
            backOut.overshoot = custom;
            return backOut;
        }(overshoot);
        var backInOut = function custom(s) {
            s = +s;
            function backInOut(t) {
                return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
            }
            backInOut.overshoot = custom;
            return backInOut;
        }(overshoot);
        var tau$5 = 2 * Math.PI, amplitude = 1, period = 0.3;
        var elasticIn = function custom(a, p) {
            var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
            function elasticIn(t) {
                return a * tpmt(- --t) * Math.sin((s - t) / p);
            }
            elasticIn.amplitude = function(a) {
                return custom(a, p * tau$5);
            };
            elasticIn.period = function(p) {
                return custom(a, p);
            };
            return elasticIn;
        }(amplitude, period);
        var elasticOut = function custom(a, p) {
            var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
            function elasticOut(t) {
                return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
            }
            elasticOut.amplitude = function(a) {
                return custom(a, p * tau$5);
            };
            elasticOut.period = function(p) {
                return custom(a, p);
            };
            return elasticOut;
        }(amplitude, period);
        var elasticInOut = function custom(a, p) {
            var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
            function elasticInOut(t) {
                return ((t = t * 2 - 1) < 0 ? a * tpmt(-t) * Math.sin((s - t) / p) : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
            }
            elasticInOut.amplitude = function(a) {
                return custom(a, p * tau$5);
            };
            elasticInOut.period = function(p) {
                return custom(a, p);
            };
            return elasticInOut;
        }(amplitude, period);
        var defaultTiming = {
            time: null,
            delay: 0,
            duration: 250,
            ease: cubicInOut
        };
        function inherit(node, id) {
            var timing;
            while(!(timing = node.__transition) || !(timing = timing[id])){
                if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
            }
            return timing;
        }
        function selection_transition(name) {
            var id, timing;
            if (name instanceof Transition) id = name._id, name = name._name;
            else id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
            for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
                for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) schedule(node, name, id, i, group, timing || inherit(node, id));
            }
            return new Transition(groups, this._parents, name, id);
        }
        selection.prototype.interrupt = selection_interrupt;
        selection.prototype.transition = selection_transition;
        var root = [
            null
        ];
        function active(node, name) {
            var schedules = node.__transition, schedule, i;
            if (schedules) {
                name = name == null ? null : name + "";
                for(i in schedules){
                    if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) return new Transition([
                        [
                            node
                        ]
                    ], root, name, +i);
                }
            }
            return null;
        }
        var constant$7 = (x)=>()=>x;
        function BrushEvent(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
            Object.defineProperties(this, {
                type: {
                    value: type,
                    enumerable: true,
                    configurable: true
                },
                sourceEvent: {
                    value: sourceEvent,
                    enumerable: true,
                    configurable: true
                },
                target: {
                    value: target,
                    enumerable: true,
                    configurable: true
                },
                selection: {
                    value: selection,
                    enumerable: true,
                    configurable: true
                },
                mode: {
                    value: mode,
                    enumerable: true,
                    configurable: true
                },
                _: {
                    value: dispatch
                }
            });
        }
        function nopropagation$1(event) {
            event.stopImmediatePropagation();
        }
        function noevent$1(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        var MODE_DRAG = {
            name: "drag"
        }, MODE_SPACE = {
            name: "space"
        }, MODE_HANDLE = {
            name: "handle"
        }, MODE_CENTER = {
            name: "center"
        };
        const { abs: abs$3, max: max$2, min: min$1 } = Math;
        function number1(e) {
            return [
                +e[0],
                +e[1]
            ];
        }
        function number2(e) {
            return [
                number1(e[0]),
                number1(e[1])
            ];
        }
        var X = {
            name: "x",
            handles: [
                "w",
                "e"
            ].map(type),
            input: function(x, e) {
                return x == null ? null : [
                    [
                        +x[0],
                        e[0][1]
                    ],
                    [
                        +x[1],
                        e[1][1]
                    ]
                ];
            },
            output: function(xy) {
                return xy && [
                    xy[0][0],
                    xy[1][0]
                ];
            }
        };
        var Y = {
            name: "y",
            handles: [
                "n",
                "s"
            ].map(type),
            input: function(y, e) {
                return y == null ? null : [
                    [
                        e[0][0],
                        +y[0]
                    ],
                    [
                        e[1][0],
                        +y[1]
                    ]
                ];
            },
            output: function(xy) {
                return xy && [
                    xy[0][1],
                    xy[1][1]
                ];
            }
        };
        var XY = {
            name: "xy",
            handles: [
                "n",
                "w",
                "e",
                "s",
                "nw",
                "ne",
                "sw",
                "se"
            ].map(type),
            input: function(xy) {
                return xy == null ? null : number2(xy);
            },
            output: function(xy) {
                return xy;
            }
        };
        var cursors = {
            overlay: "crosshair",
            selection: "move",
            n: "ns-resize",
            e: "ew-resize",
            s: "ns-resize",
            w: "ew-resize",
            nw: "nwse-resize",
            ne: "nesw-resize",
            se: "nwse-resize",
            sw: "nesw-resize"
        };
        var flipX = {
            e: "w",
            w: "e",
            nw: "ne",
            ne: "nw",
            se: "sw",
            sw: "se"
        };
        var flipY = {
            n: "s",
            s: "n",
            nw: "sw",
            ne: "se",
            se: "ne",
            sw: "nw"
        };
        var signsX = {
            overlay: 1,
            selection: 1,
            n: null,
            e: 1,
            s: null,
            w: -1,
            nw: -1,
            ne: 1,
            se: 1,
            sw: -1
        };
        var signsY = {
            overlay: 1,
            selection: 1,
            n: -1,
            e: null,
            s: 1,
            w: null,
            nw: -1,
            ne: -1,
            se: 1,
            sw: 1
        };
        function type(t) {
            return {
                type: t
            };
        }
        function defaultFilter$1(event) {
            return !event.ctrlKey && !event.button;
        }
        function defaultExtent$1() {
            var svg = this.ownerSVGElement || this;
            if (svg.hasAttribute("viewBox")) {
                svg = svg.viewBox.baseVal;
                return [
                    [
                        svg.x,
                        svg.y
                    ],
                    [
                        svg.x + svg.width,
                        svg.y + svg.height
                    ]
                ];
            }
            return [
                [
                    0,
                    0
                ],
                [
                    svg.width.baseVal.value,
                    svg.height.baseVal.value
                ]
            ];
        }
        function defaultTouchable$1() {
            return navigator.maxTouchPoints || "ontouchstart" in this;
        }
        function local(node) {
            while(!node.__brush)if (!(node = node.parentNode)) return;
            return node.__brush;
        }
        function empty(extent) {
            return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
        }
        function brushSelection(node) {
            var state = node.__brush;
            return state ? state.dim.output(state.selection) : null;
        }
        function brushX() {
            return brush$1(X);
        }
        function brushY() {
            return brush$1(Y);
        }
        function brush() {
            return brush$1(XY);
        }
        function brush$1(dim) {
            var extent = defaultExtent$1, filter = defaultFilter$1, touchable = defaultTouchable$1, keys = true, listeners = dispatch("start", "brush", "end"), handleSize = 6, touchending;
            function brush(group) {
                var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
                    type("overlay")
                ]);
                overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
                    var extent = local(this).extent;
                    select(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
                });
                group.selectAll(".selection").data([
                    type("selection")
                ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
                var handle = group.selectAll(".handle").data(dim.handles, function(d) {
                    return d.type;
                });
                handle.exit().remove();
                handle.enter().append("rect").attr("class", function(d) {
                    return "handle handle--" + d.type;
                }).attr("cursor", function(d) {
                    return cursors[d.type];
                });
                group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
            }
            brush.move = function(group, selection, event) {
                if (group.tween) group.on("start.brush", function(event) {
                    emitter(this, arguments).beforestart().start(event);
                }).on("interrupt.brush end.brush", function(event) {
                    emitter(this, arguments).end(event);
                }).tween("brush", function() {
                    var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = interpolate$2(selection0, selection1);
                    function tween(t) {
                        state.selection = t === 1 && selection1 === null ? null : i(t);
                        redraw.call(that);
                        emit.brush();
                    }
                    return selection0 !== null && selection1 !== null ? tween : tween(1);
                });
                else group.each(function() {
                    var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
                    interrupt(that);
                    state.selection = selection1 === null ? null : selection1;
                    redraw.call(that);
                    emit.start(event).brush(event).end(event);
                });
            };
            brush.clear = function(group, event) {
                brush.move(group, null, event);
            };
            function redraw() {
                var group = select(this), selection = local(this).selection;
                if (selection) {
                    group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
                    group.selectAll(".handle").style("display", null).attr("x", function(d) {
                        return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
                    }).attr("y", function(d) {
                        return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
                    }).attr("width", function(d) {
                        return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
                    }).attr("height", function(d) {
                        return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
                    });
                } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
            }
            function emitter(that, args, clean) {
                var emit = that.__brush.emitter;
                return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
            }
            function Emitter(that, args, clean) {
                this.that = that;
                this.args = args;
                this.state = that.__brush;
                this.active = 0;
                this.clean = clean;
            }
            Emitter.prototype = {
                beforestart: function() {
                    if (++this.active === 1) this.state.emitter = this, this.starting = true;
                    return this;
                },
                start: function(event, mode) {
                    if (this.starting) this.starting = false, this.emit("start", event, mode);
                    else this.emit("brush", event);
                    return this;
                },
                brush: function(event, mode) {
                    this.emit("brush", event, mode);
                    return this;
                },
                end: function(event, mode) {
                    if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
                    return this;
                },
                emit: function(type, event, mode) {
                    var d = select(this.that).datum();
                    listeners.call(type, this.that, new BrushEvent(type, {
                        sourceEvent: event,
                        target: brush,
                        selection: dim.output(this.state.selection),
                        mode: mode,
                        dispatch: listeners
                    }), d);
                }
            };
            function started(event) {
                if (touchending && !event.touches) return;
                if (!filter.apply(this, arguments)) return;
                var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
                    event
                ], (t)=>{
                    const i = t.identifier;
                    t = pointer(t, that);
                    t.point0 = t.slice();
                    t.identifier = i;
                    return t;
                });
                interrupt(that);
                var emit = emitter(that, arguments, true).beforestart();
                if (type === "overlay") {
                    if (selection) moving = true;
                    const pts = [
                        points[0],
                        points[1] || points[0]
                    ];
                    state.selection = selection = [
                        [
                            w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]),
                            n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])
                        ],
                        [
                            e0 = dim === Y ? E : max$2(pts[0][0], pts[1][0]),
                            s0 = dim === X ? S : max$2(pts[0][1], pts[1][1])
                        ]
                    ];
                    if (points.length > 1) move(event);
                } else {
                    w0 = selection[0][0];
                    n0 = selection[0][1];
                    e0 = selection[1][0];
                    s0 = selection[1][1];
                }
                w1 = w0;
                n1 = n0;
                e1 = e0;
                s1 = s0;
                var group = select(that).attr("pointer-events", "none");
                var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
                if (event.touches) {
                    emit.moved = moved;
                    emit.ended = ended;
                } else {
                    var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
                    if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
                    dragDisable(event.view);
                }
                redraw.call(that);
                emit.start(event, mode.name);
                function moved(event) {
                    for (const p of event.changedTouches || [
                        event
                    ]){
                        for (const d of points)if (d.identifier === p.identifier) d.cur = pointer(p, that);
                    }
                    if (shifting && !lockX && !lockY && points.length === 1) {
                        const point = points[0];
                        if (abs$3(point.cur[0] - point[0]) > abs$3(point.cur[1] - point[1])) lockY = true;
                        else lockX = true;
                    }
                    for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
                    moving = true;
                    noevent$1(event);
                    move(event);
                }
                function move(event) {
                    const point = points[0], point0 = point.point0;
                    var t;
                    dx = point[0] - point0[0];
                    dy = point[1] - point0[1];
                    switch(mode){
                        case MODE_SPACE:
                        case MODE_DRAG:
                            if (signX) dx = max$2(W - w0, min$1(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                            if (signY) dy = max$2(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                            break;
                        case MODE_HANDLE:
                            if (points[1]) {
                                if (signX) w1 = max$2(W, min$1(E, points[0][0])), e1 = max$2(W, min$1(E, points[1][0])), signX = 1;
                                if (signY) n1 = max$2(N, min$1(S, points[0][1])), s1 = max$2(N, min$1(S, points[1][1])), signY = 1;
                            } else {
                                if (signX < 0) dx = max$2(W - w0, min$1(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                                else if (signX > 0) dx = max$2(W - e0, min$1(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                                if (signY < 0) dy = max$2(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                                else if (signY > 0) dy = max$2(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                            }
                            break;
                        case MODE_CENTER:
                            if (signX) w1 = max$2(W, min$1(E, w0 - dx * signX)), e1 = max$2(W, min$1(E, e0 + dx * signX));
                            if (signY) n1 = max$2(N, min$1(S, n0 - dy * signY)), s1 = max$2(N, min$1(S, s0 + dy * signY));
                            break;
                    }
                    if (e1 < w1) {
                        signX *= -1;
                        t = w0, w0 = e0, e0 = t;
                        t = w1, w1 = e1, e1 = t;
                        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
                    }
                    if (s1 < n1) {
                        signY *= -1;
                        t = n0, n0 = s0, s0 = t;
                        t = n1, n1 = s1, s1 = t;
                        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
                    }
                    if (state.selection) selection = state.selection;
                    if (lockX) w1 = selection[0][0], e1 = selection[1][0];
                    if (lockY) n1 = selection[0][1], s1 = selection[1][1];
                    if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                        state.selection = [
                            [
                                w1,
                                n1
                            ],
                            [
                                e1,
                                s1
                            ]
                        ];
                        redraw.call(that);
                        emit.brush(event, mode.name);
                    }
                }
                function ended(event) {
                    nopropagation$1(event);
                    if (event.touches) {
                        if (event.touches.length) return;
                        if (touchending) clearTimeout(touchending);
                        touchending = setTimeout(function() {
                            touchending = null;
                        }, 500);
                    } else {
                        yesdrag(event.view, moving);
                        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
                    }
                    group.attr("pointer-events", "all");
                    overlay.attr("cursor", cursors.overlay);
                    if (state.selection) selection = state.selection;
                    if (empty(selection)) state.selection = null, redraw.call(that);
                    emit.end(event, mode.name);
                }
                function keydowned(event) {
                    switch(event.keyCode){
                        case 16:
                            shifting = signX && signY;
                            break;
                        case 18:
                            if (mode === MODE_HANDLE) {
                                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                                mode = MODE_CENTER;
                                move(event);
                            }
                            break;
                        case 32:
                            if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                                if (signX < 0) e0 = e1 - dx;
                                else if (signX > 0) w0 = w1 - dx;
                                if (signY < 0) s0 = s1 - dy;
                                else if (signY > 0) n0 = n1 - dy;
                                mode = MODE_SPACE;
                                overlay.attr("cursor", cursors.selection);
                                move(event);
                            }
                            break;
                        default:
                            return;
                    }
                    noevent$1(event);
                }
                function keyupped(event) {
                    switch(event.keyCode){
                        case 16:
                            if (shifting) {
                                lockX = lockY = shifting = false;
                                move(event);
                            }
                            break;
                        case 18:
                            if (mode === MODE_CENTER) {
                                if (signX < 0) e0 = e1;
                                else if (signX > 0) w0 = w1;
                                if (signY < 0) s0 = s1;
                                else if (signY > 0) n0 = n1;
                                mode = MODE_HANDLE;
                                move(event);
                            }
                            break;
                        case 32:
                            if (mode === MODE_SPACE) {
                                if (event.altKey) {
                                    if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                                    if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                                    mode = MODE_CENTER;
                                } else {
                                    if (signX < 0) e0 = e1;
                                    else if (signX > 0) w0 = w1;
                                    if (signY < 0) s0 = s1;
                                    else if (signY > 0) n0 = n1;
                                    mode = MODE_HANDLE;
                                }
                                overlay.attr("cursor", cursors[type]);
                                move(event);
                            }
                            break;
                        default:
                            return;
                    }
                    noevent$1(event);
                }
            }
            function touchmoved(event) {
                emitter(this, arguments).moved(event);
            }
            function touchended(event) {
                emitter(this, arguments).ended(event);
            }
            function initialize() {
                var state = this.__brush || {
                    selection: null
                };
                state.extent = number2(extent.apply(this, arguments));
                state.dim = dim;
                return state;
            }
            brush.extent = function(_) {
                return arguments.length ? (extent = typeof _ === "function" ? _ : constant$7(number2(_)), brush) : extent;
            };
            brush.filter = function(_) {
                return arguments.length ? (filter = typeof _ === "function" ? _ : constant$7(!!_), brush) : filter;
            };
            brush.touchable = function(_) {
                return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$7(!!_), brush) : touchable;
            };
            brush.handleSize = function(_) {
                return arguments.length ? (handleSize = +_, brush) : handleSize;
            };
            brush.keyModifiers = function(_) {
                return arguments.length ? (keys = !!_, brush) : keys;
            };
            brush.on = function() {
                var value = listeners.on.apply(listeners, arguments);
                return value === listeners ? brush : value;
            };
            return brush;
        }
        var abs$2 = Math.abs;
        var cos$2 = Math.cos;
        var sin$2 = Math.sin;
        var pi$3 = Math.PI;
        var halfPi$2 = pi$3 / 2;
        var tau$4 = pi$3 * 2;
        var max$1 = Math.max;
        var epsilon$5 = 1e-12;
        function range$1(i, j) {
            return Array.from({
                length: j - i
            }, (_, k)=>i + k);
        }
        function compareValue(compare) {
            return function(a, b) {
                return compare(a.source.value + a.target.value, b.source.value + b.target.value);
            };
        }
        function chord() {
            return chord$1(false, false);
        }
        function chordTranspose() {
            return chord$1(false, true);
        }
        function chordDirected() {
            return chord$1(true, false);
        }
        function chord$1(directed, transpose) {
            var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
            function chord(matrix) {
                var n = matrix.length, groupSums = new Array(n), groupIndex = range$1(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
                matrix = Float64Array.from({
                    length: n * n
                }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
                for(let i = 0; i < n; ++i){
                    let x = 0;
                    for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
                    k += groupSums[i] = x;
                }
                k = max$1(0, tau$4 - padAngle * n) / k;
                dx = k ? padAngle : tau$4 / n;
                {
                    let x = 0;
                    if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
                    for (const i of groupIndex){
                        const x0 = x;
                        if (directed) {
                            const subgroupIndex = range$1(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                            if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                            for (const j of subgroupIndex)if (j < 0) {
                                const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                                    source: null,
                                    target: null
                                });
                                chord.target = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[~j * n + i] * k,
                                    value: matrix[~j * n + i]
                                };
                            } else {
                                const chord = chords[i * n + j] || (chords[i * n + j] = {
                                    source: null,
                                    target: null
                                });
                                chord.source = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                            }
                            groups[i] = {
                                index: i,
                                startAngle: x0,
                                endAngle: x,
                                value: groupSums[i]
                            };
                        } else {
                            const subgroupIndex = range$1(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                            if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                            for (const j of subgroupIndex){
                                let chord;
                                if (i < j) {
                                    chord = chords[i * n + j] || (chords[i * n + j] = {
                                        source: null,
                                        target: null
                                    });
                                    chord.source = {
                                        index: i,
                                        startAngle: x,
                                        endAngle: x += matrix[i * n + j] * k,
                                        value: matrix[i * n + j]
                                    };
                                } else {
                                    chord = chords[j * n + i] || (chords[j * n + i] = {
                                        source: null,
                                        target: null
                                    });
                                    chord.target = {
                                        index: i,
                                        startAngle: x,
                                        endAngle: x += matrix[i * n + j] * k,
                                        value: matrix[i * n + j]
                                    };
                                    if (i === j) chord.source = chord.target;
                                }
                                if (chord.source && chord.target && chord.source.value < chord.target.value) {
                                    const source = chord.source;
                                    chord.source = chord.target;
                                    chord.target = source;
                                }
                            }
                            groups[i] = {
                                index: i,
                                startAngle: x0,
                                endAngle: x,
                                value: groupSums[i]
                            };
                        }
                        x += dx;
                    }
                }
                chords = Object.values(chords);
                chords.groups = groups;
                return sortChords ? chords.sort(sortChords) : chords;
            }
            chord.padAngle = function(_) {
                return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
            };
            chord.sortGroups = function(_) {
                return arguments.length ? (sortGroups = _, chord) : sortGroups;
            };
            chord.sortSubgroups = function(_) {
                return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
            };
            chord.sortChords = function(_) {
                return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
            };
            return chord;
        }
        const pi$2 = Math.PI, tau$3 = 2 * pi$2, epsilon$4 = 1e-6, tauEpsilon = tau$3 - epsilon$4;
        function Path$1() {
            this._x0 = this._y0 = this._x1 = this._y1 = null;
            this._ = "";
        }
        function path() {
            return new Path$1;
        }
        Path$1.prototype = path.prototype = {
            constructor: Path$1,
            moveTo: function(x, y) {
                this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
            },
            closePath: function() {
                if (this._x1 !== null) {
                    this._x1 = this._x0, this._y1 = this._y0;
                    this._ += "Z";
                }
            },
            lineTo: function(x, y) {
                this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
            },
            quadraticCurveTo: function(x1, y1, x, y) {
                this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
            },
            bezierCurveTo: function(x1, y1, x2, y2, x, y) {
                this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
            },
            arcTo: function(x1, y1, x2, y2, r) {
                x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
                var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
                if (r < 0) throw new Error("negative radius: " + r);
                if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
                else if (!(l01_2 > epsilon$4)) ;
                else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
                else {
                    var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
                    if (Math.abs(t01 - 1) > epsilon$4) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
                    this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
                }
            },
            arc: function(x, y, r, a0, a1, ccw) {
                x = +x, y = +y, r = +r, ccw = !!ccw;
                var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
                if (r < 0) throw new Error("negative radius: " + r);
                if (this._x1 === null) this._ += "M" + x0 + "," + y0;
                else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) this._ += "L" + x0 + "," + y0;
                if (!r) return;
                if (da < 0) da = da % tau$3 + tau$3;
                if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
                else if (da > epsilon$4) this._ += "A" + r + "," + r + ",0," + +(da >= pi$2) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
            },
            rect: function(x, y, w, h) {
                this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
            },
            toString: function() {
                return this._;
            }
        };
        var slice$2 = Array.prototype.slice;
        function constant$6(x) {
            return function() {
                return x;
            };
        }
        function defaultSource$1(d) {
            return d.source;
        }
        function defaultTarget(d) {
            return d.target;
        }
        function defaultRadius$1(d) {
            return d.radius;
        }
        function defaultStartAngle(d) {
            return d.startAngle;
        }
        function defaultEndAngle(d) {
            return d.endAngle;
        }
        function defaultPadAngle() {
            return 0;
        }
        function defaultArrowheadRadius() {
            return 10;
        }
        function ribbon(headRadius) {
            var source = defaultSource$1, target = defaultTarget, sourceRadius = defaultRadius$1, targetRadius = defaultRadius$1, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
            function ribbon() {
                var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice$2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - halfPi$2, sa1 = endAngle.apply(this, argv) - halfPi$2, tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - halfPi$2, ta1 = endAngle.apply(this, argv) - halfPi$2;
                if (!context) context = buffer = path();
                if (ap > epsilon$5) {
                    if (abs$2(sa1 - sa0) > ap * 2 + epsilon$5) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
                    else sa0 = sa1 = (sa0 + sa1) / 2;
                    if (abs$2(ta1 - ta0) > ap * 2 + epsilon$5) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
                    else ta0 = ta1 = (ta0 + ta1) / 2;
                }
                context.moveTo(sr * cos$2(sa0), sr * sin$2(sa0));
                context.arc(0, 0, sr, sa0, sa1);
                if (sa0 !== ta0 || sa1 !== ta1) {
                    if (headRadius) {
                        var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                        context.quadraticCurveTo(0, 0, tr2 * cos$2(ta0), tr2 * sin$2(ta0));
                        context.lineTo(tr * cos$2(ta2), tr * sin$2(ta2));
                        context.lineTo(tr2 * cos$2(ta1), tr2 * sin$2(ta1));
                    } else {
                        context.quadraticCurveTo(0, 0, tr * cos$2(ta0), tr * sin$2(ta0));
                        context.arc(0, 0, tr, ta0, ta1);
                    }
                }
                context.quadraticCurveTo(0, 0, sr * cos$2(sa0), sr * sin$2(sa0));
                context.closePath();
                if (buffer) return context = null, buffer + "" || null;
            }
            if (headRadius) ribbon.headRadius = function(_) {
                return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : headRadius;
            };
            ribbon.radius = function(_) {
                return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
            };
            ribbon.sourceRadius = function(_) {
                return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
            };
            ribbon.targetRadius = function(_) {
                return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : targetRadius;
            };
            ribbon.startAngle = function(_) {
                return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : startAngle;
            };
            ribbon.endAngle = function(_) {
                return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : endAngle;
            };
            ribbon.padAngle = function(_) {
                return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : padAngle;
            };
            ribbon.source = function(_) {
                return arguments.length ? (source = _, ribbon) : source;
            };
            ribbon.target = function(_) {
                return arguments.length ? (target = _, ribbon) : target;
            };
            ribbon.context = function(_) {
                return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
            };
            return ribbon;
        }
        function ribbon$1() {
            return ribbon();
        }
        function ribbonArrow() {
            return ribbon(defaultArrowheadRadius);
        }
        var array$2 = Array.prototype;
        var slice$1 = array$2.slice;
        function ascending$1(a, b) {
            return a - b;
        }
        function area$3(ring) {
            var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
            while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
            return area;
        }
        var constant$5 = (x)=>()=>x;
        function contains$2(ring, hole) {
            var i = -1, n = hole.length, c;
            while(++i < n)if (c = ringContains(ring, hole[i])) return c;
            return 0;
        }
        function ringContains(ring, point) {
            var x = point[0], y = point[1], contains = -1;
            for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
                var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
                if (segmentContains(pi, pj, point)) return 0;
                if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
            }
            return contains;
        }
        function segmentContains(a, b, c) {
            var i;
            return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
        }
        function collinear$1(a, b, c) {
            return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
        }
        function within(p, q, r) {
            return p <= q && q <= r || r <= q && q <= p;
        }
        function noop$2() {}
        var cases = [
            [],
            [
                [
                    [
                        1.0,
                        1.5
                    ],
                    [
                        0.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        1.5,
                        1.0
                    ],
                    [
                        1.0,
                        1.5
                    ]
                ]
            ],
            [
                [
                    [
                        1.5,
                        1.0
                    ],
                    [
                        0.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        0.5
                    ],
                    [
                        1.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        1.5
                    ],
                    [
                        0.5,
                        1.0
                    ]
                ],
                [
                    [
                        1.0,
                        0.5
                    ],
                    [
                        1.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        0.5
                    ],
                    [
                        1.0,
                        1.5
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        0.5
                    ],
                    [
                        0.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        0.5,
                        1.0
                    ],
                    [
                        1.0,
                        0.5
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        1.5
                    ],
                    [
                        1.0,
                        0.5
                    ]
                ]
            ],
            [
                [
                    [
                        0.5,
                        1.0
                    ],
                    [
                        1.0,
                        0.5
                    ]
                ],
                [
                    [
                        1.5,
                        1.0
                    ],
                    [
                        1.0,
                        1.5
                    ]
                ]
            ],
            [
                [
                    [
                        1.5,
                        1.0
                    ],
                    [
                        1.0,
                        0.5
                    ]
                ]
            ],
            [
                [
                    [
                        0.5,
                        1.0
                    ],
                    [
                        1.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        1.0,
                        1.5
                    ],
                    [
                        1.5,
                        1.0
                    ]
                ]
            ],
            [
                [
                    [
                        0.5,
                        1.0
                    ],
                    [
                        1.0,
                        1.5
                    ]
                ]
            ],
            []
        ];
        function Contours() {
            var dx = 1, dy = 1, threshold = thresholdSturges, smooth = smoothLinear;
            function contours(values) {
                var tz = threshold(values);
                if (!Array.isArray(tz)) {
                    const e = extent$1(values), ts = tickStep(e[0], e[1], tz);
                    tz = ticks(Math.floor(e[0] / ts) * ts, Math.floor(e[1] / ts - 1) * ts, tz);
                } else tz = tz.slice().sort(ascending$1);
                return tz.map((value)=>contour(values, value));
            }
            function contour(values, value) {
                var polygons = [], holes = [];
                isorings(values, value, function(ring) {
                    smooth(ring, values, value);
                    if (area$3(ring) > 0) polygons.push([
                        ring
                    ]);
                    else holes.push(ring);
                });
                holes.forEach(function(hole) {
                    for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains$2((polygon = polygons[i])[0], hole) !== -1) {
                        polygon.push(hole);
                        return;
                    }
                });
                return {
                    type: "MultiPolygon",
                    value: value,
                    coordinates: polygons
                };
            }
            function isorings(values, value, callback) {
                var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
                x = y = -1;
                t1 = values[0] >= value;
                cases[t1 << 1].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = values[x + 1] >= value;
                    cases[t0 | t1 << 1].forEach(stitch);
                }
                cases[t1 << 0].forEach(stitch);
                while(++y < dy - 1){
                    x = -1;
                    t1 = values[y * dx + dx] >= value;
                    t2 = values[y * dx] >= value;
                    cases[t1 << 1 | t2 << 2].forEach(stitch);
                    while(++x < dx - 1){
                        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                        t3 = t2, t2 = values[y * dx + x + 1] >= value;
                        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                    }
                    cases[t1 | t2 << 3].forEach(stitch);
                }
                x = -1;
                t2 = values[y * dx] >= value;
                cases[t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t3 = t2, t2 = values[y * dx + x + 1] >= value;
                    cases[t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t2 << 3].forEach(stitch);
                function stitch(line) {
                    var start = [
                        line[0][0] + x,
                        line[0][1] + y
                    ], end = [
                        line[1][0] + x,
                        line[1][1] + y
                    ], startIndex = index(start), endIndex = index(end), f, g;
                    if (f = fragmentByEnd[startIndex]) {
                        if (g = fragmentByStart[endIndex]) {
                            delete fragmentByEnd[f.end];
                            delete fragmentByStart[g.start];
                            if (f === g) {
                                f.ring.push(end);
                                callback(f.ring);
                            } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                                start: f.start,
                                end: g.end,
                                ring: f.ring.concat(g.ring)
                            };
                        } else {
                            delete fragmentByEnd[f.end];
                            f.ring.push(end);
                            fragmentByEnd[f.end = endIndex] = f;
                        }
                    } else if (f = fragmentByStart[endIndex]) {
                        if (g = fragmentByEnd[startIndex]) {
                            delete fragmentByStart[f.start];
                            delete fragmentByEnd[g.end];
                            if (f === g) {
                                f.ring.push(end);
                                callback(f.ring);
                            } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                                start: g.start,
                                end: f.end,
                                ring: g.ring.concat(f.ring)
                            };
                        } else {
                            delete fragmentByStart[f.start];
                            f.ring.unshift(start);
                            fragmentByStart[f.start = startIndex] = f;
                        }
                    } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                        start: startIndex,
                        end: endIndex,
                        ring: [
                            start,
                            end
                        ]
                    };
                }
            }
            function index(point) {
                return point[0] * 2 + point[1] * (dx + 1) * 4;
            }
            function smoothLinear(ring, values, value) {
                ring.forEach(function(point) {
                    var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
                    if (x > 0 && x < dx && xt === x) {
                        v0 = values[yt * dx + xt - 1];
                        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
                    }
                    if (y > 0 && y < dy && yt === y) {
                        v0 = values[(yt - 1) * dx + xt];
                        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
                    }
                });
            }
            contours.contour = contour;
            contours.size = function(_) {
                if (!arguments.length) return [
                    dx,
                    dy
                ];
                var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
                if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
                return dx = _0, dy = _1, contours;
            };
            contours.thresholds = function(_) {
                return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), contours) : threshold;
            };
            contours.smooth = function(_) {
                return arguments.length ? (smooth = _ ? smoothLinear : noop$2, contours) : smooth === smoothLinear;
            };
            return contours;
        }
        function defaultX$1(d) {
            return d[0];
        }
        function defaultY$1(d) {
            return d[1];
        }
        function defaultWeight() {
            return 1;
        }
        function density() {
            var x = defaultX$1, y = defaultY$1, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = constant$5(20);
            function grid(data) {
                var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
                for (const d of data){
                    var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                    if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
                        var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                        values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                        values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                        values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                        values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                    }
                }
                blur2({
                    data: values,
                    width: n,
                    height: m
                }, r * pow2k);
                return values;
            }
            function density(data) {
                var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
                if (!Array.isArray(tz)) tz = ticks(Number.MIN_VALUE, max$3(values) / pow4k, tz);
                return Contours().size([
                    n,
                    m
                ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
            }
            density.contours = function(data) {
                var values = grid(data), contours = Contours().size([
                    n,
                    m
                ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                    value = +value;
                    var c = transform(contours.contour(values, value * pow4k));
                    c.value = value;
                    return c;
                };
                Object.defineProperty(contour, "max", {
                    get: ()=>max$3(values) / pow4k
                });
                return contour;
            };
            function transform(geometry) {
                geometry.coordinates.forEach(transformPolygon);
                return geometry;
            }
            function transformPolygon(coordinates) {
                coordinates.forEach(transformRing);
            }
            function transformRing(coordinates) {
                coordinates.forEach(transformPoint);
            }
            function transformPoint(coordinates) {
                coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
                coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
            }
            function resize() {
                o = r * 3;
                n = dx + o * 2 >> k;
                m = dy + o * 2 >> k;
                return density;
            }
            density.x = function(_) {
                return arguments.length ? (x = typeof _ === "function" ? _ : constant$5(+_), density) : x;
            };
            density.y = function(_) {
                return arguments.length ? (y = typeof _ === "function" ? _ : constant$5(+_), density) : y;
            };
            density.weight = function(_) {
                return arguments.length ? (weight = typeof _ === "function" ? _ : constant$5(+_), density) : weight;
            };
            density.size = function(_) {
                if (!arguments.length) return [
                    dx,
                    dy
                ];
                var _0 = +_[0], _1 = +_[1];
                if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
                return dx = _0, dy = _1, resize();
            };
            density.cellSize = function(_) {
                if (!arguments.length) return 1 << k;
                if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
                return k = Math.floor(Math.log(_) / Math.LN2), resize();
            };
            density.thresholds = function(_) {
                return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), density) : threshold;
            };
            density.bandwidth = function(_) {
                if (!arguments.length) return Math.sqrt(r * (r + 1));
                if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
                return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
            };
            return density;
        }
        const epsilon$3 = 1.1102230246251565e-16;
        const splitter = 134217729;
        const resulterrbound = (3 + 8 * epsilon$3) * epsilon$3;
        function sum$1(elen, e, flen, f, h) {
            let Q, Qnew, hh, bvirt;
            let enow = e[0];
            let fnow = f[0];
            let eindex = 0;
            let findex = 0;
            if (fnow > enow === fnow > -enow) {
                Q = enow;
                enow = e[++eindex];
            } else {
                Q = fnow;
                fnow = f[++findex];
            }
            let hindex = 0;
            if (eindex < elen && findex < flen) {
                if (fnow > enow === fnow > -enow) {
                    Qnew = enow + Q;
                    hh = Q - (Qnew - enow);
                    enow = e[++eindex];
                } else {
                    Qnew = fnow + Q;
                    hh = Q - (Qnew - fnow);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
                while(eindex < elen && findex < flen){
                    if (fnow > enow === fnow > -enow) {
                        Qnew = Q + enow;
                        bvirt = Qnew - Q;
                        hh = Q - (Qnew - bvirt) + (enow - bvirt);
                        enow = e[++eindex];
                    } else {
                        Qnew = Q + fnow;
                        bvirt = Qnew - Q;
                        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                        fnow = f[++findex];
                    }
                    Q = Qnew;
                    if (hh !== 0) h[hindex++] = hh;
                }
            }
            while(eindex < elen){
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
            while(findex < flen){
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
            if (Q !== 0 || hindex === 0) h[hindex++] = Q;
            return hindex;
        }
        function estimate(elen, e) {
            let Q = e[0];
            for(let i = 1; i < elen; i++)Q += e[i];
            return Q;
        }
        function vec(n) {
            return new Float64Array(n);
        }
        const ccwerrboundA = (3 + 16 * epsilon$3) * epsilon$3;
        const ccwerrboundB = (2 + 12 * epsilon$3) * epsilon$3;
        const ccwerrboundC = (9 + 64 * epsilon$3) * epsilon$3 * epsilon$3;
        const B = vec(4);
        const C1 = vec(8);
        const C2 = vec(12);
        const D = vec(16);
        const u = vec(4);
        function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
            let acxtail, acytail, bcxtail, bcytail;
            let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
            const acx = ax - cx;
            const bcx = bx - cx;
            const acy = ay - cy;
            const bcy = by - cy;
            s1 = acx * bcy;
            c = splitter * acx;
            ahi = c - (c - acx);
            alo = acx - ahi;
            c = splitter * bcy;
            bhi = c - (c - bcy);
            blo = bcy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = acy * bcx;
            c = splitter * acy;
            ahi = c - (c - acy);
            alo = acy - ahi;
            c = splitter * bcx;
            bhi = c - (c - bcx);
            blo = bcx - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            B[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            B[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            B[2] = _j - (u3 - bvirt) + (_i - bvirt);
            B[3] = u3;
            let det = estimate(4, B);
            let errbound = ccwerrboundB * detsum;
            if (det >= errbound || -det >= errbound) return det;
            bvirt = ax - acx;
            acxtail = ax - (acx + bvirt) + (bvirt - cx);
            bvirt = bx - bcx;
            bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
            bvirt = ay - acy;
            acytail = ay - (acy + bvirt) + (bvirt - cy);
            bvirt = by - bcy;
            bcytail = by - (bcy + bvirt) + (bvirt - cy);
            if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
            errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
            det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
            if (det >= errbound || -det >= errbound) return det;
            s1 = acxtail * bcy;
            c = splitter * acxtail;
            ahi = c - (c - acxtail);
            alo = acxtail - ahi;
            c = splitter * bcy;
            bhi = c - (c - bcy);
            blo = bcy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = acytail * bcx;
            c = splitter * acytail;
            ahi = c - (c - acytail);
            alo = acytail - ahi;
            c = splitter * bcx;
            bhi = c - (c - bcx);
            blo = bcx - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            u[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            u[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            const C1len = sum$1(4, B, 4, u, C1);
            s1 = acx * bcytail;
            c = splitter * acx;
            ahi = c - (c - acx);
            alo = acx - ahi;
            c = splitter * bcytail;
            bhi = c - (c - bcytail);
            blo = bcytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = acy * bcxtail;
            c = splitter * acy;
            ahi = c - (c - acy);
            alo = acy - ahi;
            c = splitter * bcxtail;
            bhi = c - (c - bcxtail);
            blo = bcxtail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            u[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            u[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            const C2len = sum$1(C1len, C1, 4, u, C2);
            s1 = acxtail * bcytail;
            c = splitter * acxtail;
            ahi = c - (c - acxtail);
            alo = acxtail - ahi;
            c = splitter * bcytail;
            bhi = c - (c - bcytail);
            blo = bcytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = acytail * bcxtail;
            c = splitter * acytail;
            ahi = c - (c - acytail);
            alo = acytail - ahi;
            c = splitter * bcxtail;
            bhi = c - (c - bcxtail);
            blo = bcxtail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            u[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            u[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            const Dlen = sum$1(C2len, C2, 4, u, D);
            return D[Dlen - 1];
        }
        function orient2d(ax, ay, bx, by, cx, cy) {
            const detleft = (ay - cy) * (bx - cx);
            const detright = (ax - cx) * (by - cy);
            const det = detleft - detright;
            if (detleft === 0 || detright === 0 || detleft > 0 !== detright > 0) return det;
            const detsum = Math.abs(detleft + detright);
            if (Math.abs(det) >= ccwerrboundA * detsum) return det;
            return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
        }
        const EPSILON = Math.pow(2, -52);
        const EDGE_STACK = new Uint32Array(512);
        class Delaunator {
            static from(points, getX = defaultGetX, getY = defaultGetY) {
                const n = points.length;
                const coords = new Float64Array(n * 2);
                for(let i = 0; i < n; i++){
                    const p = points[i];
                    coords[2 * i] = getX(p);
                    coords[2 * i + 1] = getY(p);
                }
                return new Delaunator(coords);
            }
            constructor(coords){
                const n = coords.length >> 1;
                if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
                this.coords = coords;
                const maxTriangles = Math.max(2 * n - 5, 0);
                this._triangles = new Uint32Array(maxTriangles * 3);
                this._halfedges = new Int32Array(maxTriangles * 3);
                this._hashSize = Math.ceil(Math.sqrt(n));
                this._hullPrev = new Uint32Array(n);
                this._hullNext = new Uint32Array(n);
                this._hullTri = new Uint32Array(n);
                this._hullHash = new Int32Array(this._hashSize).fill(-1);
                this._ids = new Uint32Array(n);
                this._dists = new Float64Array(n);
                this.update();
            }
            update() {
                const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
                const n = coords.length >> 1;
                let minX = Infinity;
                let minY = Infinity;
                let maxX = -Infinity;
                let maxY = -Infinity;
                for(let i = 0; i < n; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                    this._ids[i] = i;
                }
                const cx = (minX + maxX) / 2;
                const cy = (minY + maxY) / 2;
                let minDist = Infinity;
                let i0, i1, i2;
                for(let i = 0; i < n; i++){
                    const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
                    if (d < minDist) {
                        i0 = i;
                        minDist = d;
                    }
                }
                const i0x = coords[2 * i0];
                const i0y = coords[2 * i0 + 1];
                minDist = Infinity;
                for(let i = 0; i < n; i++){
                    if (i === i0) continue;
                    const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
                    if (d < minDist && d > 0) {
                        i1 = i;
                        minDist = d;
                    }
                }
                let i1x = coords[2 * i1];
                let i1y = coords[2 * i1 + 1];
                let minRadius = Infinity;
                for(let i = 0; i < n; i++){
                    if (i === i0 || i === i1) continue;
                    const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
                    if (r < minRadius) {
                        i2 = i;
                        minRadius = r;
                    }
                }
                let i2x = coords[2 * i2];
                let i2y = coords[2 * i2 + 1];
                if (minRadius === Infinity) {
                    for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
                    quicksort(this._ids, this._dists, 0, n - 1);
                    const hull = new Uint32Array(n);
                    let j = 0;
                    for(let i = 0, d0 = -Infinity; i < n; i++){
                        const id = this._ids[i];
                        if (this._dists[id] > d0) {
                            hull[j++] = id;
                            d0 = this._dists[id];
                        }
                    }
                    this.hull = hull.subarray(0, j);
                    this.triangles = new Uint32Array(0);
                    this.halfedges = new Uint32Array(0);
                    return;
                }
                if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
                    const i = i1;
                    const x = i1x;
                    const y = i1y;
                    i1 = i2;
                    i1x = i2x;
                    i1y = i2y;
                    i2 = i;
                    i2x = x;
                    i2y = y;
                }
                const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
                this._cx = center.x;
                this._cy = center.y;
                for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
                quicksort(this._ids, this._dists, 0, n - 1);
                this._hullStart = i0;
                let hullSize = 3;
                hullNext[i0] = hullPrev[i2] = i1;
                hullNext[i1] = hullPrev[i0] = i2;
                hullNext[i2] = hullPrev[i1] = i0;
                hullTri[i0] = 0;
                hullTri[i1] = 1;
                hullTri[i2] = 2;
                hullHash.fill(-1);
                hullHash[this._hashKey(i0x, i0y)] = i0;
                hullHash[this._hashKey(i1x, i1y)] = i1;
                hullHash[this._hashKey(i2x, i2y)] = i2;
                this.trianglesLen = 0;
                this._addTriangle(i0, i1, i2, -1, -1, -1);
                for(let k = 0, xp, yp; k < this._ids.length; k++){
                    const i = this._ids[k];
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
                    xp = x;
                    yp = y;
                    if (i === i0 || i === i1 || i === i2) continue;
                    let start = 0;
                    for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                        start = hullHash[(key + j) % this._hashSize];
                        if (start !== -1 && start !== hullNext[start]) break;
                    }
                    start = hullPrev[start];
                    let e = start, q;
                    while(q = hullNext[e], orient2d(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                        e = q;
                        if (e === start) {
                            e = -1;
                            break;
                        }
                    }
                    if (e === -1) continue;
                    let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
                    hullTri[i] = this._legalize(t + 2);
                    hullTri[e] = t;
                    hullSize++;
                    let n = hullNext[e];
                    while(q = hullNext[n], orient2d(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                        t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                        hullTri[i] = this._legalize(t + 2);
                        hullNext[n] = n;
                        hullSize--;
                        n = q;
                    }
                    if (e === start) while(q = hullPrev[e], orient2d(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                        t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                        this._legalize(t + 2);
                        hullTri[q] = t;
                        hullNext[e] = e;
                        hullSize--;
                        e = q;
                    }
                    this._hullStart = hullPrev[i] = e;
                    hullNext[e] = hullPrev[n] = i;
                    hullNext[i] = n;
                    hullHash[this._hashKey(x, y)] = i;
                    hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
                }
                this.hull = new Uint32Array(hullSize);
                for(let i = 0, e = this._hullStart; i < hullSize; i++){
                    this.hull[i] = e;
                    e = hullNext[e];
                }
                this.triangles = this._triangles.subarray(0, this.trianglesLen);
                this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
            }
            _hashKey(x, y) {
                return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
            }
            _legalize(a) {
                const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
                let i = 0;
                let ar = 0;
                while(true){
                    const b = halfedges[a];
                    const a0 = a - a % 3;
                    ar = a0 + (a + 2) % 3;
                    if (b === -1) {
                        if (i === 0) break;
                        a = EDGE_STACK[--i];
                        continue;
                    }
                    const b0 = b - b % 3;
                    const al = a0 + (a + 1) % 3;
                    const bl = b0 + (b + 2) % 3;
                    const p0 = triangles[ar];
                    const pr = triangles[a];
                    const pl = triangles[al];
                    const p1 = triangles[bl];
                    const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
                    if (illegal) {
                        triangles[a] = p1;
                        triangles[b] = p0;
                        const hbl = halfedges[bl];
                        if (hbl === -1) {
                            let e = this._hullStart;
                            do {
                                if (this._hullTri[e] === bl) {
                                    this._hullTri[e] = a;
                                    break;
                                }
                                e = this._hullPrev[e];
                            }while (e !== this._hullStart)
                        }
                        this._link(a, hbl);
                        this._link(b, halfedges[ar]);
                        this._link(ar, bl);
                        const br = b0 + (b + 1) % 3;
                        if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
                    } else {
                        if (i === 0) break;
                        a = EDGE_STACK[--i];
                    }
                }
                return ar;
            }
            _link(a, b) {
                this._halfedges[a] = b;
                if (b !== -1) this._halfedges[b] = a;
            }
            _addTriangle(i0, i1, i2, a, b, c) {
                const t = this.trianglesLen;
                this._triangles[t] = i0;
                this._triangles[t + 1] = i1;
                this._triangles[t + 2] = i2;
                this._link(t, a);
                this._link(t + 1, b);
                this._link(t + 2, c);
                this.trianglesLen += 3;
                return t;
            }
        }
        function pseudoAngle(dx, dy) {
            const p = dx / (Math.abs(dx) + Math.abs(dy));
            return (dy > 0 ? 3 - p : 1 + p) / 4;
        }
        function dist(ax, ay, bx, by) {
            const dx = ax - bx;
            const dy = ay - by;
            return dx * dx + dy * dy;
        }
        function inCircle(ax, ay, bx, by, cx, cy, px, py) {
            const dx = ax - px;
            const dy = ay - py;
            const ex = bx - px;
            const ey = by - py;
            const fx = cx - px;
            const fy = cy - py;
            const ap = dx * dx + dy * dy;
            const bp = ex * ex + ey * ey;
            const cp = fx * fx + fy * fy;
            return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
        }
        function circumradius(ax, ay, bx, by, cx, cy) {
            const dx = bx - ax;
            const dy = by - ay;
            const ex = cx - ax;
            const ey = cy - ay;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const d = 0.5 / (dx * ey - dy * ex);
            const x = (ey * bl - dy * cl) * d;
            const y = (dx * cl - ex * bl) * d;
            return x * x + y * y;
        }
        function circumcenter(ax, ay, bx, by, cx, cy) {
            const dx = bx - ax;
            const dy = by - ay;
            const ex = cx - ax;
            const ey = cy - ay;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const d = 0.5 / (dx * ey - dy * ex);
            const x = ax + (ey * bl - dy * cl) * d;
            const y = ay + (dx * cl - ex * bl) * d;
            return {
                x: x,
                y: y
            };
        }
        function quicksort(ids, dists, left, right) {
            if (right - left <= 20) for(let i = left + 1; i <= right; i++){
                const temp = ids[i];
                const tempDist = dists[temp];
                let j = i - 1;
                while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
                ids[j + 1] = temp;
            }
            else {
                const median = left + right >> 1;
                let i = left + 1;
                let j = right;
                swap(ids, median, i);
                if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
                if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
                if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
                const temp = ids[i];
                const tempDist = dists[temp];
                while(true){
                    do i++;
                    while (dists[ids[i]] < tempDist)
                    do j--;
                    while (dists[ids[j]] > tempDist)
                    if (j < i) break;
                    swap(ids, i, j);
                }
                ids[left + 1] = ids[j];
                ids[j] = temp;
                if (right - i + 1 >= j - left) {
                    quicksort(ids, dists, i, right);
                    quicksort(ids, dists, left, j - 1);
                } else {
                    quicksort(ids, dists, left, j - 1);
                    quicksort(ids, dists, i, right);
                }
            }
        }
        function swap(arr, i, j) {
            const tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
        }
        function defaultGetX(p) {
            return p[0];
        }
        function defaultGetY(p) {
            return p[1];
        }
        const epsilon$2 = 1e-6;
        class Path {
            constructor(){
                this._x0 = this._y0 = this._x1 = this._y1 = null;
                this._ = "";
            }
            moveTo(x, y) {
                this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
            }
            closePath() {
                if (this._x1 !== null) {
                    this._x1 = this._x0, this._y1 = this._y0;
                    this._ += "Z";
                }
            }
            lineTo(x, y) {
                this._ += `L${this._x1 = +x},${this._y1 = +y}`;
            }
            arc(x, y, r) {
                x = +x, y = +y, r = +r;
                const x0 = x + r;
                const y0 = y;
                if (r < 0) throw new Error("negative radius");
                if (this._x1 === null) this._ += `M${x0},${y0}`;
                else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) this._ += "L" + x0 + "," + y0;
                if (!r) return;
                this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
            }
            rect(x, y, w, h) {
                this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
            }
            value() {
                return this._ || null;
            }
        }
        class Polygon {
            constructor(){
                this._ = [];
            }
            moveTo(x, y) {
                this._.push([
                    x,
                    y
                ]);
            }
            closePath() {
                this._.push(this._[0].slice());
            }
            lineTo(x, y) {
                this._.push([
                    x,
                    y
                ]);
            }
            value() {
                return this._.length ? this._ : null;
            }
        }
        class Voronoi {
            constructor(delaunay, [xmin, ymin, xmax, ymax] = [
                0,
                0,
                960,
                500
            ]){
                if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
                this.delaunay = delaunay;
                this._circumcenters = new Float64Array(delaunay.points.length * 2);
                this.vectors = new Float64Array(delaunay.points.length * 2);
                this.xmax = xmax, this.xmin = xmin;
                this.ymax = ymax, this.ymin = ymin;
                this._init();
            }
            update() {
                this.delaunay.update();
                this._init();
                return this;
            }
            _init() {
                const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
                const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
                for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
                    const t1 = triangles[i] * 2;
                    const t2 = triangles[i + 1] * 2;
                    const t3 = triangles[i + 2] * 2;
                    const x1 = points[t1];
                    const y1 = points[t1 + 1];
                    const x2 = points[t2];
                    const y2 = points[t2 + 1];
                    const x3 = points[t3];
                    const y3 = points[t3 + 1];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const ex = x3 - x1;
                    const ey = y3 - y1;
                    const ab = (dx * ey - dy * ex) * 2;
                    if (Math.abs(ab) < 1e-9) {
                        let a = 1e9;
                        const r = triangles[0] * 2;
                        a *= Math.sign((points[r] - x1) * ey - (points[r + 1] - y1) * ex);
                        x = (x1 + x3) / 2 - a * ey;
                        y = (y1 + y3) / 2 + a * ex;
                    } else {
                        const d = 1 / ab;
                        const bl = dx * dx + dy * dy;
                        const cl = ex * ex + ey * ey;
                        x = x1 + (ey * bl - dy * cl) * d;
                        y = y1 + (dx * cl - ex * bl) * d;
                    }
                    circumcenters[j] = x;
                    circumcenters[j + 1] = y;
                }
                let h = hull[hull.length - 1];
                let p0, p1 = h * 4;
                let x0, x1 = points[2 * h];
                let y0, y1 = points[2 * h + 1];
                vectors.fill(0);
                for(let i = 0; i < hull.length; ++i){
                    h = hull[i];
                    p0 = p1, x0 = x1, y0 = y1;
                    p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
                    vectors[p0 + 2] = vectors[p1] = y0 - y1;
                    vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
                }
            }
            render(context) {
                const buffer = context == null ? context = new Path : undefined;
                const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
                if (hull.length <= 1) return null;
                for(let i = 0, n = halfedges.length; i < n; ++i){
                    const j = halfedges[i];
                    if (j < i) continue;
                    const ti = Math.floor(i / 3) * 2;
                    const tj = Math.floor(j / 3) * 2;
                    const xi = circumcenters[ti];
                    const yi = circumcenters[ti + 1];
                    const xj = circumcenters[tj];
                    const yj = circumcenters[tj + 1];
                    this._renderSegment(xi, yi, xj, yj, context);
                }
                let h0, h1 = hull[hull.length - 1];
                for(let i = 0; i < hull.length; ++i){
                    h0 = h1, h1 = hull[i];
                    const t = Math.floor(inedges[h1] / 3) * 2;
                    const x = circumcenters[t];
                    const y = circumcenters[t + 1];
                    const v = h0 * 4;
                    const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
                    if (p) this._renderSegment(x, y, p[0], p[1], context);
                }
                return buffer && buffer.value();
            }
            renderBounds(context) {
                const buffer = context == null ? context = new Path : undefined;
                context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
                return buffer && buffer.value();
            }
            renderCell(i, context) {
                const buffer = context == null ? context = new Path : undefined;
                const points = this._clip(i);
                if (points === null || !points.length) return;
                context.moveTo(points[0], points[1]);
                let n = points.length;
                while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
                for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
                context.closePath();
                return buffer && buffer.value();
            }
            *cellPolygons() {
                const { delaunay: { points: points } } = this;
                for(let i = 0, n = points.length / 2; i < n; ++i){
                    const cell = this.cellPolygon(i);
                    if (cell) cell.index = i, yield cell;
                }
            }
            cellPolygon(i) {
                const polygon = new Polygon;
                this.renderCell(i, polygon);
                return polygon.value();
            }
            _renderSegment(x0, y0, x1, y1, context) {
                let S;
                const c0 = this._regioncode(x0, y0);
                const c1 = this._regioncode(x1, y1);
                if (c0 === 0 && c1 === 0) {
                    context.moveTo(x0, y0);
                    context.lineTo(x1, y1);
                } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
                    context.moveTo(S[0], S[1]);
                    context.lineTo(S[2], S[3]);
                }
            }
            contains(i, x, y) {
                if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
                return this.delaunay._step(i, x, y) === i;
            }
            *neighbors(i) {
                const ci = this._clip(i);
                if (ci) for (const j of this.delaunay.neighbors(i)){
                    const cj = this._clip(j);
                    if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                        for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                            yield j;
                            break loop;
                        }
                    }
                }
            }
            _cell(i) {
                const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
                const e0 = inedges[i];
                if (e0 === -1) return null;
                const points = [];
                let e = e0;
                do {
                    const t = Math.floor(e / 3);
                    points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
                    e = e % 3 === 2 ? e - 2 : e + 1;
                    if (triangles[e] !== i) break;
                    e = halfedges[e];
                }while (e !== e0 && e !== -1)
                return points;
            }
            _clip(i) {
                if (i === 0 && this.delaunay.hull.length === 1) return [
                    this.xmax,
                    this.ymin,
                    this.xmax,
                    this.ymax,
                    this.xmin,
                    this.ymax,
                    this.xmin,
                    this.ymin
                ];
                const points = this._cell(i);
                if (points === null) return null;
                const { vectors: V } = this;
                const v = i * 4;
                return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
            }
            _clipFinite(i, points) {
                const n = points.length;
                let P = null;
                let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
                let c0, c1 = this._regioncode(x1, y1);
                let e0, e1 = 0;
                for(let j = 0; j < n; j += 2){
                    x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
                    c0 = c1, c1 = this._regioncode(x1, y1);
                    if (c0 === 0 && c1 === 0) {
                        e0 = e1, e1 = 0;
                        if (P) P.push(x1, y1);
                        else P = [
                            x1,
                            y1
                        ];
                    } else {
                        let S, sx0, sy0, sx1, sy1;
                        if (c0 === 0) {
                            if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                            [sx0, sy0, sx1, sy1] = S;
                        } else {
                            if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                            [sx1, sy1, sx0, sy0] = S;
                            e0 = e1, e1 = this._edgecode(sx0, sy0);
                            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                            if (P) P.push(sx0, sy0);
                            else P = [
                                sx0,
                                sy0
                            ];
                        }
                        e0 = e1, e1 = this._edgecode(sx1, sy1);
                        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                        if (P) P.push(sx1, sy1);
                        else P = [
                            sx1,
                            sy1
                        ];
                    }
                }
                if (P) {
                    e0 = e1, e1 = this._edgecode(P[0], P[1]);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
                    this.xmax,
                    this.ymin,
                    this.xmax,
                    this.ymax,
                    this.xmin,
                    this.ymax,
                    this.xmin,
                    this.ymin
                ];
                return P;
            }
            _clipSegment(x0, y0, x1, y1, c0, c1) {
                while(true){
                    if (c0 === 0 && c1 === 0) return [
                        x0,
                        y0,
                        x1,
                        y1
                    ];
                    if (c0 & c1) return null;
                    let x, y, c = c0 || c1;
                    if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
                    else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
                    else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
                    else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
                    if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
                    else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
                }
            }
            _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
                let P = Array.from(points), p;
                if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
                if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
                if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
                    c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
                    if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
                }
                else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
                    this.xmin,
                    this.ymin,
                    this.xmax,
                    this.ymin,
                    this.xmax,
                    this.ymax,
                    this.xmin,
                    this.ymax
                ];
                return P;
            }
            _edge(i, e0, e1, P, j) {
                while(e0 !== e1){
                    let x, y;
                    switch(e0){
                        case 5:
                            e0 = 4;
                            continue;
                        case 4:
                            e0 = 6, x = this.xmax, y = this.ymin;
                            break;
                        case 6:
                            e0 = 2;
                            continue;
                        case 2:
                            e0 = 10, x = this.xmax, y = this.ymax;
                            break;
                        case 10:
                            e0 = 8;
                            continue;
                        case 8:
                            e0 = 9, x = this.xmin, y = this.ymax;
                            break;
                        case 9:
                            e0 = 1;
                            continue;
                        case 1:
                            e0 = 5, x = this.xmin, y = this.ymin;
                            break;
                    }
                    if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
                }
                if (P.length > 4) for(let i = 0; i < P.length; i += 2){
                    const j = (i + 2) % P.length, k = (i + 4) % P.length;
                    if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
                }
                return j;
            }
            _project(x0, y0, vx, vy) {
                let t = Infinity, c, x, y;
                if (vy < 0) {
                    if (y0 <= this.ymin) return null;
                    if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
                } else if (vy > 0) {
                    if (y0 >= this.ymax) return null;
                    if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
                }
                if (vx > 0) {
                    if (x0 >= this.xmax) return null;
                    if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
                } else if (vx < 0) {
                    if (x0 <= this.xmin) return null;
                    if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
                }
                return [
                    x,
                    y
                ];
            }
            _edgecode(x, y) {
                return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
            }
            _regioncode(x, y) {
                return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
            }
        }
        const tau$2 = 2 * Math.PI, pow$2 = Math.pow;
        function pointX(p) {
            return p[0];
        }
        function pointY(p) {
            return p[1];
        }
        function collinear(d) {
            const { triangles: triangles, coords: coords } = d;
            for(let i = 0; i < triangles.length; i += 3){
                const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
                if (cross > 1e-10) return false;
            }
            return true;
        }
        function jitter(x, y, r) {
            return [
                x + Math.sin(x + y) * r,
                y + Math.cos(x - y) * r
            ];
        }
        class Delaunay {
            static from(points, fx = pointX, fy = pointY, that) {
                return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
            }
            constructor(points){
                this._delaunator = new Delaunator(points);
                this.inedges = new Int32Array(points.length / 2);
                this._hullIndex = new Int32Array(points.length / 2);
                this.points = this._delaunator.coords;
                this._init();
            }
            update() {
                this._delaunator.update();
                this._init();
                return this;
            }
            _init() {
                const d = this._delaunator, points = this.points;
                if (d.hull && d.hull.length > 2 && collinear(d)) {
                    this.collinear = Int32Array.from({
                        length: points.length / 2
                    }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]);
                    const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                        points[2 * e],
                        points[2 * e + 1],
                        points[2 * f],
                        points[2 * f + 1]
                    ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
                    for(let i = 0, n = points.length / 2; i < n; ++i){
                        const p = jitter(points[2 * i], points[2 * i + 1], r);
                        points[2 * i] = p[0];
                        points[2 * i + 1] = p[1];
                    }
                    this._delaunator = new Delaunator(points);
                } else delete this.collinear;
                const halfedges = this.halfedges = this._delaunator.halfedges;
                const hull = this.hull = this._delaunator.hull;
                const triangles = this.triangles = this._delaunator.triangles;
                const inedges = this.inedges.fill(-1);
                const hullIndex = this._hullIndex.fill(-1);
                for(let e = 0, n = halfedges.length; e < n; ++e){
                    const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
                    if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
                }
                for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
                if (hull.length <= 2 && hull.length > 0) {
                    this.triangles = new Int32Array(3).fill(-1);
                    this.halfedges = new Int32Array(3).fill(-1);
                    this.triangles[0] = hull[0];
                    inedges[hull[0]] = 1;
                    if (hull.length === 2) {
                        inedges[hull[1]] = 0;
                        this.triangles[1] = hull[1];
                        this.triangles[2] = hull[1];
                    }
                }
            }
            voronoi(bounds) {
                return new Voronoi(this, bounds);
            }
            *neighbors(i) {
                const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
                if (collinear) {
                    const l = collinear.indexOf(i);
                    if (l > 0) yield collinear[l - 1];
                    if (l < collinear.length - 1) yield collinear[l + 1];
                    return;
                }
                const e0 = inedges[i];
                if (e0 === -1) return;
                let e = e0, p0 = -1;
                do {
                    yield p0 = triangles[e];
                    e = e % 3 === 2 ? e - 2 : e + 1;
                    if (triangles[e] !== i) return;
                    e = halfedges[e];
                    if (e === -1) {
                        const p = hull[(_hullIndex[i] + 1) % hull.length];
                        if (p !== p0) yield p;
                        return;
                    }
                }while (e !== e0)
            }
            find(x, y, i = 0) {
                if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
                const i0 = i;
                let c;
                while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
                return c;
            }
            _step(i, x, y) {
                const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
                if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
                let c = i;
                let dc = pow$2(x - points[i * 2], 2) + pow$2(y - points[i * 2 + 1], 2);
                const e0 = inedges[i];
                let e = e0;
                do {
                    let t = triangles[e];
                    const dt = pow$2(x - points[t * 2], 2) + pow$2(y - points[t * 2 + 1], 2);
                    if (dt < dc) dc = dt, c = t;
                    e = e % 3 === 2 ? e - 2 : e + 1;
                    if (triangles[e] !== i) break;
                    e = halfedges[e];
                    if (e === -1) {
                        e = hull[(_hullIndex[i] + 1) % hull.length];
                        if (e !== t) {
                            if (pow$2(x - points[e * 2], 2) + pow$2(y - points[e * 2 + 1], 2) < dc) return e;
                        }
                        break;
                    }
                }while (e !== e0)
                return c;
            }
            render(context) {
                const buffer = context == null ? context = new Path : undefined;
                const { points: points, halfedges: halfedges, triangles: triangles } = this;
                for(let i = 0, n = halfedges.length; i < n; ++i){
                    const j = halfedges[i];
                    if (j < i) continue;
                    const ti = triangles[i] * 2;
                    const tj = triangles[j] * 2;
                    context.moveTo(points[ti], points[ti + 1]);
                    context.lineTo(points[tj], points[tj + 1]);
                }
                this.renderHull(context);
                return buffer && buffer.value();
            }
            renderPoints(context, r) {
                if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
                r = r == undefined ? 2 : +r;
                const buffer = context == null ? context = new Path : undefined;
                const { points: points } = this;
                for(let i = 0, n = points.length; i < n; i += 2){
                    const x = points[i], y = points[i + 1];
                    context.moveTo(x + r, y);
                    context.arc(x, y, r, 0, tau$2);
                }
                return buffer && buffer.value();
            }
            renderHull(context) {
                const buffer = context == null ? context = new Path : undefined;
                const { hull: hull, points: points } = this;
                const h = hull[0] * 2, n = hull.length;
                context.moveTo(points[h], points[h + 1]);
                for(let i = 1; i < n; ++i){
                    const h = 2 * hull[i];
                    context.lineTo(points[h], points[h + 1]);
                }
                context.closePath();
                return buffer && buffer.value();
            }
            hullPolygon() {
                const polygon = new Polygon;
                this.renderHull(polygon);
                return polygon.value();
            }
            renderTriangle(i, context) {
                const buffer = context == null ? context = new Path : undefined;
                const { points: points, triangles: triangles } = this;
                const t0 = triangles[i *= 3] * 2;
                const t1 = triangles[i + 1] * 2;
                const t2 = triangles[i + 2] * 2;
                context.moveTo(points[t0], points[t0 + 1]);
                context.lineTo(points[t1], points[t1 + 1]);
                context.lineTo(points[t2], points[t2 + 1]);
                context.closePath();
                return buffer && buffer.value();
            }
            *trianglePolygons() {
                const { triangles: triangles } = this;
                for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
            }
            trianglePolygon(i) {
                const polygon = new Polygon;
                this.renderTriangle(i, polygon);
                return polygon.value();
            }
        }
        function flatArray(points, fx, fy, that) {
            const n = points.length;
            const array = new Float64Array(n * 2);
            for(let i = 0; i < n; ++i){
                const p = points[i];
                array[i * 2] = fx.call(that, p, i, points);
                array[i * 2 + 1] = fy.call(that, p, i, points);
            }
            return array;
        }
        function* flatIterable(points, fx, fy, that) {
            let i = 0;
            for (const p of points){
                yield fx.call(that, p, i, points);
                yield fy.call(that, p, i, points);
                ++i;
            }
        }
        var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
        function objectConverter(columns) {
            return new Function("d", "return {" + columns.map(function(name, i) {
                return JSON.stringify(name) + ": d[" + i + "] || \"\"";
            }).join(",") + "}");
        }
        function customConverter(columns, f) {
            var object = objectConverter(columns);
            return function(row, i) {
                return f(object(row), i, columns);
            };
        }
        function inferColumns(rows) {
            var columnSet = Object.create(null), columns = [];
            rows.forEach(function(row) {
                for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
            });
            return columns;
        }
        function pad$1(value, width) {
            var s = value + "", length = s.length;
            return length < width ? new Array(width - length + 1).join(0) + s : s;
        }
        function formatYear$1(year) {
            return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
        }
        function formatDate(date) {
            var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
            return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
        }
        function dsvFormat(delimiter) {
            var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
            function parse(text, f) {
                var convert, columns, rows = parseRows(text, function(row, i) {
                    if (convert) return convert(row, i - 1);
                    columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
                });
                rows.columns = columns || [];
                return rows;
            }
            function parseRows(text, f) {
                var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
                if (text.charCodeAt(N - 1) === NEWLINE) --N;
                if (text.charCodeAt(N - 1) === RETURN) --N;
                function token() {
                    if (eof) return EOF;
                    if (eol) return eol = false, EOL;
                    var i, j = I, c;
                    if (text.charCodeAt(j) === QUOTE) {
                        while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                        if ((i = I) >= N) eof = true;
                        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                        else if (c === RETURN) {
                            eol = true;
                            if (text.charCodeAt(I) === NEWLINE) ++I;
                        }
                        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                    }
                    while(I < N){
                        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                        else if (c === RETURN) {
                            eol = true;
                            if (text.charCodeAt(I) === NEWLINE) ++I;
                        } else if (c !== DELIMITER) continue;
                        return text.slice(j, i);
                    }
                    return eof = true, text.slice(j, N);
                }
                while((t = token()) !== EOF){
                    var row = [];
                    while(t !== EOL && t !== EOF)row.push(t), t = token();
                    if (f && (row = f(row, n++)) == null) continue;
                    rows.push(row);
                }
                return rows;
            }
            function preformatBody(rows, columns) {
                return rows.map(function(row) {
                    return columns.map(function(column) {
                        return formatValue(row[column]);
                    }).join(delimiter);
                });
            }
            function format(rows, columns) {
                if (columns == null) columns = inferColumns(rows);
                return [
                    columns.map(formatValue).join(delimiter)
                ].concat(preformatBody(rows, columns)).join("\n");
            }
            function formatBody(rows, columns) {
                if (columns == null) columns = inferColumns(rows);
                return preformatBody(rows, columns).join("\n");
            }
            function formatRows(rows) {
                return rows.map(formatRow).join("\n");
            }
            function formatRow(row) {
                return row.map(formatValue).join(delimiter);
            }
            function formatValue(value) {
                return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
            }
            return {
                parse: parse,
                parseRows: parseRows,
                format: format,
                formatBody: formatBody,
                formatRows: formatRows,
                formatRow: formatRow,
                formatValue: formatValue
            };
        }
        var csv$1 = dsvFormat(",");
        var csvParse = csv$1.parse;
        var csvParseRows = csv$1.parseRows;
        var csvFormat = csv$1.format;
        var csvFormatBody = csv$1.formatBody;
        var csvFormatRows = csv$1.formatRows;
        var csvFormatRow = csv$1.formatRow;
        var csvFormatValue = csv$1.formatValue;
        var tsv$1 = dsvFormat("\t");
        var tsvParse = tsv$1.parse;
        var tsvParseRows = tsv$1.parseRows;
        var tsvFormat = tsv$1.format;
        var tsvFormatBody = tsv$1.formatBody;
        var tsvFormatRows = tsv$1.formatRows;
        var tsvFormatRow = tsv$1.formatRow;
        var tsvFormatValue = tsv$1.formatValue;
        function autoType(object) {
            for(var key in object){
                var value = object[key].trim(), number, m;
                if (!value) value = null;
                else if (value === "true") value = true;
                else if (value === "false") value = false;
                else if (value === "NaN") value = NaN;
                else if (!isNaN(number = +value)) value = number;
                else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
                    if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
                    value = new Date(value);
                } else continue;
                object[key] = value;
            }
            return object;
        }
        const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
        function responseBlob(response) {
            if (!response.ok) throw new Error(response.status + " " + response.statusText);
            return response.blob();
        }
        function blob(input, init) {
            return fetch(input, init).then(responseBlob);
        }
        function responseArrayBuffer(response) {
            if (!response.ok) throw new Error(response.status + " " + response.statusText);
            return response.arrayBuffer();
        }
        function buffer(input, init) {
            return fetch(input, init).then(responseArrayBuffer);
        }
        function responseText(response) {
            if (!response.ok) throw new Error(response.status + " " + response.statusText);
            return response.text();
        }
        function text(input, init) {
            return fetch(input, init).then(responseText);
        }
        function dsvParse(parse) {
            return function(input, init, row) {
                if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
                return text(input, init).then(function(response) {
                    return parse(response, row);
                });
            };
        }
        function dsv(delimiter, input, init, row) {
            if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
            var format = dsvFormat(delimiter);
            return text(input, init).then(function(response) {
                return format.parse(response, row);
            });
        }
        var csv = dsvParse(csvParse);
        var tsv = dsvParse(tsvParse);
        function image(input, init) {
            return new Promise(function(resolve, reject) {
                var image = new Image;
                for(var key in init)image[key] = init[key];
                image.onerror = reject;
                image.onload = function() {
                    resolve(image);
                };
                image.src = input;
            });
        }
        function responseJson(response) {
            if (!response.ok) throw new Error(response.status + " " + response.statusText);
            if (response.status === 204 || response.status === 205) return;
            return response.json();
        }
        function json(input, init) {
            return fetch(input, init).then(responseJson);
        }
        function parser(type) {
            return (input, init)=>text(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
        }
        var xml = parser("application/xml");
        var html = parser("text/html");
        var svg = parser("image/svg+xml");
        function center(x, y) {
            var nodes, strength = 1;
            if (x == null) x = 0;
            if (y == null) y = 0;
            function force() {
                var i, n = nodes.length, node, sx = 0, sy = 0;
                for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
                for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
            }
            force.initialize = function(_) {
                nodes = _;
            };
            force.x = function(_) {
                return arguments.length ? (x = +_, force) : x;
            };
            force.y = function(_) {
                return arguments.length ? (y = +_, force) : y;
            };
            force.strength = function(_) {
                return arguments.length ? (strength = +_, force) : strength;
            };
            return force;
        }
        function tree_add(d) {
            const x = +this._x.call(null, d), y = +this._y.call(null, d);
            return add(this.cover(x, y), x, y, d);
        }
        function add(tree, x, y, d) {
            if (isNaN(x) || isNaN(y)) return tree;
            var parent, node = tree._root, leaf = {
                data: d
            }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
            if (!node) return tree._root = leaf, tree;
            while(node.length){
                if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
                else x1 = xm;
                if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
                else y1 = ym;
                if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
            }
            xp = +tree._x.call(null, node.data);
            yp = +tree._y.call(null, node.data);
            if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
            do {
                parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
                if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
                else x1 = xm;
                if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
                else y1 = ym;
            }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm))
            return parent[j] = node, parent[i] = leaf, tree;
        }
        function addAll(data) {
            var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
            for(i = 0; i < n; ++i){
                if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
                xz[i] = x;
                yz[i] = y;
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
            }
            if (x0 > x1 || y0 > y1) return this;
            this.cover(x0, y0).cover(x1, y1);
            for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
            return this;
        }
        function tree_cover(x, y) {
            if (isNaN(x = +x) || isNaN(y = +y)) return this;
            var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
            if (isNaN(x0)) {
                x1 = (x0 = Math.floor(x)) + 1;
                y1 = (y0 = Math.floor(y)) + 1;
            } else {
                var z = x1 - x0 || 1, node = this._root, parent, i;
                while(x0 > x || x >= x1 || y0 > y || y >= y1){
                    i = (y < y0) << 1 | x < x0;
                    parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                    switch(i){
                        case 0:
                            x1 = x0 + z, y1 = y0 + z;
                            break;
                        case 1:
                            x0 = x1 - z, y1 = y0 + z;
                            break;
                        case 2:
                            x1 = x0 + z, y0 = y1 - z;
                            break;
                        case 3:
                            x0 = x1 - z, y0 = y1 - z;
                            break;
                    }
                }
                if (this._root && this._root.length) this._root = node;
            }
            this._x0 = x0;
            this._y0 = y0;
            this._x1 = x1;
            this._y1 = y1;
            return this;
        }
        function tree_data() {
            var data = [];
            this.visit(function(node) {
                if (!node.length) do data.push(node.data);
                while (node = node.next)
            });
            return data;
        }
        function tree_extent(_) {
            return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
                [
                    this._x0,
                    this._y0
                ],
                [
                    this._x1,
                    this._y1
                ]
            ];
        }
        function Quad(node, x0, y0, x1, y1) {
            this.node = node;
            this.x0 = x0;
            this.y0 = y0;
            this.x1 = x1;
            this.y1 = y1;
        }
        function tree_find(x, y, radius) {
            var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
            if (node) quads.push(new Quad(node, x0, y0, x3, y3));
            if (radius == null) radius = Infinity;
            else {
                x0 = x - radius, y0 = y - radius;
                x3 = x + radius, y3 = y + radius;
                radius *= radius;
            }
            while(q = quads.pop()){
                if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
                if (node.length) {
                    var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                    quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym));
                    if (i = (y >= ym) << 1 | x >= xm) {
                        q = quads[quads.length - 1];
                        quads[quads.length - 1] = quads[quads.length - 1 - i];
                        quads[quads.length - 1 - i] = q;
                    }
                } else {
                    var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                    if (d2 < radius) {
                        var d = Math.sqrt(radius = d2);
                        x0 = x - d, y0 = y - d;
                        x3 = x + d, y3 = y + d;
                        data = node.data;
                    }
                }
            }
            return data;
        }
        function tree_remove(d) {
            if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this;
            var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
            if (!node) return this;
            if (node.length) while(true){
                if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
                else x1 = xm;
                if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
                else y1 = ym;
                if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
                if (!node.length) break;
                if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
            }
            while(node.data !== d)if (!(previous = node, node = node.next)) return this;
            if (next = node.next) delete node.next;
            if (previous) return next ? previous.next = next : delete previous.next, this;
            if (!parent) return this._root = next, this;
            next ? parent[i] = next : delete parent[i];
            if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
                if (retainer) retainer[j] = node;
                else this._root = node;
            }
            return this;
        }
        function removeAll(data) {
            for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
            return this;
        }
        function tree_root() {
            return this._root;
        }
        function tree_size() {
            var size = 0;
            this.visit(function(node) {
                if (!node.length) do ++size;
                while (node = node.next)
            });
            return size;
        }
        function tree_visit(callback) {
            var quads = [], q, node = this._root, child, x0, y0, x1, y1;
            if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
            while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
                var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
                if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
                if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
                if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
            }
            return this;
        }
        function tree_visitAfter(callback) {
            var quads = [], next = [], q;
            if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
            while(q = quads.pop()){
                var node = q.node;
                if (node.length) {
                    var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                    if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
                    if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
                    if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
                    if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
                }
                next.push(q);
            }
            while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
            return this;
        }
        function defaultX(d) {
            return d[0];
        }
        function tree_x(_) {
            return arguments.length ? (this._x = _, this) : this._x;
        }
        function defaultY(d) {
            return d[1];
        }
        function tree_y(_) {
            return arguments.length ? (this._y = _, this) : this._y;
        }
        function quadtree(nodes, x, y) {
            var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
            return nodes == null ? tree : tree.addAll(nodes);
        }
        function Quadtree(x, y, x0, y0, x1, y1) {
            this._x = x;
            this._y = y;
            this._x0 = x0;
            this._y0 = y0;
            this._x1 = x1;
            this._y1 = y1;
            this._root = undefined;
        }
        function leaf_copy(leaf) {
            var copy = {
                data: leaf.data
            }, next = copy;
            while(leaf = leaf.next)next = next.next = {
                data: leaf.data
            };
            return copy;
        }
        var treeProto = quadtree.prototype = Quadtree.prototype;
        treeProto.copy = function() {
            var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
            if (!node) return copy;
            if (!node.length) return copy._root = leaf_copy(node), copy;
            nodes = [
                {
                    source: node,
                    target: copy._root = new Array(4)
                }
            ];
            while(node = nodes.pop()){
                for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
                    if (child.length) nodes.push({
                        source: child,
                        target: node.target[i] = new Array(4)
                    });
                    else node.target[i] = leaf_copy(child);
                }
            }
            return copy;
        };
        treeProto.add = tree_add;
        treeProto.addAll = addAll;
        treeProto.cover = tree_cover;
        treeProto.data = tree_data;
        treeProto.extent = tree_extent;
        treeProto.find = tree_find;
        treeProto.remove = tree_remove;
        treeProto.removeAll = removeAll;
        treeProto.root = tree_root;
        treeProto.size = tree_size;
        treeProto.visit = tree_visit;
        treeProto.visitAfter = tree_visitAfter;
        treeProto.x = tree_x;
        treeProto.y = tree_y;
        function constant$4(x) {
            return function() {
                return x;
            };
        }
        function jiggle(random) {
            return (random() - 0.5) * 1e-6;
        }
        function x$4(d) {
            return d.x + d.vx;
        }
        function y$3(d) {
            return d.y + d.vy;
        }
        function collide(radius) {
            var nodes, radii, random, strength = 1, iterations = 1;
            if (typeof radius !== "function") radius = constant$4(radius == null ? 1 : +radius);
            function force() {
                var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
                for(var k = 0; k < iterations; ++k){
                    tree = quadtree(nodes, x$4, y$3).visitAfter(prepare);
                    for(i = 0; i < n; ++i){
                        node = nodes[i];
                        ri = radii[node.index], ri2 = ri * ri;
                        xi = node.x + node.vx;
                        yi = node.y + node.vy;
                        tree.visit(apply);
                    }
                }
                function apply(quad, x0, y0, x1, y1) {
                    var data = quad.data, rj = quad.r, r = ri + rj;
                    if (data) {
                        if (data.index > node.index) {
                            var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                            if (l < r * r) {
                                if (x === 0) x = jiggle(random), l += x * x;
                                if (y === 0) y = jiggle(random), l += y * y;
                                l = (r - (l = Math.sqrt(l))) / l * strength;
                                node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                                node.vy += (y *= l) * r;
                                data.vx -= x * (r = 1 - r);
                                data.vy -= y * r;
                            }
                        }
                        return;
                    }
                    return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
                }
            }
            function prepare(quad) {
                if (quad.data) return quad.r = radii[quad.data.index];
                for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length, node;
                radii = new Array(n);
                for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
            }
            force.initialize = function(_nodes, _random) {
                nodes = _nodes;
                random = _random;
                initialize();
            };
            force.iterations = function(_) {
                return arguments.length ? (iterations = +_, force) : iterations;
            };
            force.strength = function(_) {
                return arguments.length ? (strength = +_, force) : strength;
            };
            force.radius = function(_) {
                return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
            };
            return force;
        }
        function index$3(d) {
            return d.index;
        }
        function find(nodeById, nodeId) {
            var node = nodeById.get(nodeId);
            if (!node) throw new Error("node not found: " + nodeId);
            return node;
        }
        function link$2(links) {
            var id = index$3, strength = defaultStrength, strengths, distance = constant$4(30), distances, nodes, count, bias, random, iterations = 1;
            if (links == null) links = [];
            function defaultStrength(link) {
                return 1 / Math.min(count[link.source.index], count[link.target.index]);
            }
            function force(alpha) {
                for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                    link = links[i], source = link.source, target = link.target;
                    x = target.x + target.vx - source.x - source.vx || jiggle(random);
                    y = target.y + target.vy - source.y - source.vy || jiggle(random);
                    l = Math.sqrt(x * x + y * y);
                    l = (l - distances[i]) / l * alpha * strengths[i];
                    x *= l, y *= l;
                    target.vx -= x * (b = bias[i]);
                    target.vy -= y * b;
                    source.vx += x * (b = 1 - b);
                    source.vy += y * b;
                }
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                        id(d, i, nodes),
                        d
                    ])), link;
                for(i = 0, count = new Array(n); i < m; ++i){
                    link = links[i], link.index = i;
                    if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                    if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                    count[link.source.index] = (count[link.source.index] || 0) + 1;
                    count[link.target.index] = (count[link.target.index] || 0) + 1;
                }
                for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
                strengths = new Array(m), initializeStrength();
                distances = new Array(m), initializeDistance();
            }
            function initializeStrength() {
                if (!nodes) return;
                for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
            }
            function initializeDistance() {
                if (!nodes) return;
                for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
            }
            force.initialize = function(_nodes, _random) {
                nodes = _nodes;
                random = _random;
                initialize();
            };
            force.links = function(_) {
                return arguments.length ? (links = _, initialize(), force) : links;
            };
            force.id = function(_) {
                return arguments.length ? (id = _, force) : id;
            };
            force.iterations = function(_) {
                return arguments.length ? (iterations = +_, force) : iterations;
            };
            force.strength = function(_) {
                return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initializeStrength(), force) : strength;
            };
            force.distance = function(_) {
                return arguments.length ? (distance = typeof _ === "function" ? _ : constant$4(+_), initializeDistance(), force) : distance;
            };
            return force;
        }
        const a$2 = 1664525;
        const c$4 = 1013904223;
        const m$1 = 4294967296;
        function lcg$2() {
            let s = 1;
            return ()=>(s = (a$2 * s + c$4) % m$1) / m$1;
        }
        function x$3(d) {
            return d.x;
        }
        function y$2(d) {
            return d.y;
        }
        var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
        function simulation(nodes) {
            var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = timer(step), event = dispatch("tick", "end"), random = lcg$2();
            if (nodes == null) nodes = [];
            function step() {
                tick();
                event.call("tick", simulation);
                if (alpha < alphaMin) {
                    stepper.stop();
                    event.call("end", simulation);
                }
            }
            function tick(iterations) {
                var i, n = nodes.length, node;
                if (iterations === undefined) iterations = 1;
                for(var k = 0; k < iterations; ++k){
                    alpha += (alphaTarget - alpha) * alphaDecay;
                    forces.forEach(function(force) {
                        force(alpha);
                    });
                    for(i = 0; i < n; ++i){
                        node = nodes[i];
                        if (node.fx == null) node.x += node.vx *= velocityDecay;
                        else node.x = node.fx, node.vx = 0;
                        if (node.fy == null) node.y += node.vy *= velocityDecay;
                        else node.y = node.fy, node.vy = 0;
                    }
                }
                return simulation;
            }
            function initializeNodes() {
                for(var i = 0, n = nodes.length, node; i < n; ++i){
                    node = nodes[i], node.index = i;
                    if (node.fx != null) node.x = node.fx;
                    if (node.fy != null) node.y = node.fy;
                    if (isNaN(node.x) || isNaN(node.y)) {
                        var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                        node.x = radius * Math.cos(angle);
                        node.y = radius * Math.sin(angle);
                    }
                    if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
                }
            }
            function initializeForce(force) {
                if (force.initialize) force.initialize(nodes, random);
                return force;
            }
            initializeNodes();
            return simulation = {
                tick: tick,
                restart: function() {
                    return stepper.restart(step), simulation;
                },
                stop: function() {
                    return stepper.stop(), simulation;
                },
                nodes: function(_) {
                    return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
                },
                alpha: function(_) {
                    return arguments.length ? (alpha = +_, simulation) : alpha;
                },
                alphaMin: function(_) {
                    return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
                },
                alphaDecay: function(_) {
                    return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
                },
                alphaTarget: function(_) {
                    return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
                },
                velocityDecay: function(_) {
                    return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
                },
                randomSource: function(_) {
                    return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
                },
                force: function(name, _) {
                    return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
                },
                find: function(x, y, radius) {
                    var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                    if (radius == null) radius = Infinity;
                    else radius *= radius;
                    for(i = 0; i < n; ++i){
                        node = nodes[i];
                        dx = x - node.x;
                        dy = y - node.y;
                        d2 = dx * dx + dy * dy;
                        if (d2 < radius) closest = node, radius = d2;
                    }
                    return closest;
                },
                on: function(name, _) {
                    return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
                }
            };
        }
        function manyBody() {
            var nodes, node, random, alpha, strength = constant$4(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
            function force(_) {
                var i, n = nodes.length, tree = quadtree(nodes, x$3, y$2).visitAfter(accumulate);
                for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length, node;
                strengths = new Array(n);
                for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
            }
            function accumulate(quad) {
                var strength = 0, q, c, weight = 0, x, y, i;
                if (quad.length) {
                    for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                    quad.x = x / weight;
                    quad.y = y / weight;
                } else {
                    q = quad;
                    q.x = q.data.x;
                    q.y = q.data.y;
                    do strength += strengths[q.data.index];
                    while (q = q.next)
                }
                quad.value = strength;
            }
            function apply(quad, x1, _, x2) {
                if (!quad.value) return true;
                var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
                if (w * w / theta2 < l) {
                    if (l < distanceMax2) {
                        if (x === 0) x = jiggle(random), l += x * x;
                        if (y === 0) y = jiggle(random), l += y * y;
                        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                        node.vx += x * quad.value * alpha / l;
                        node.vy += y * quad.value * alpha / l;
                    }
                    return true;
                } else if (quad.length || l >= distanceMax2) return;
                if (quad.data !== node || quad.next) {
                    if (x === 0) x = jiggle(random), l += x * x;
                    if (y === 0) y = jiggle(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                }
                do if (quad.data !== node) {
                    w = strengths[quad.data.index] * alpha / l;
                    node.vx += x * w;
                    node.vy += y * w;
                }
                while (quad = quad.next)
            }
            force.initialize = function(_nodes, _random) {
                nodes = _nodes;
                random = _random;
                initialize();
            };
            force.strength = function(_) {
                return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
            };
            force.distanceMin = function(_) {
                return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
            };
            force.distanceMax = function(_) {
                return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
            };
            force.theta = function(_) {
                return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
            };
            return force;
        }
        function radial$1(radius, x, y) {
            var nodes, strength = constant$4(0.1), strengths, radiuses;
            if (typeof radius !== "function") radius = constant$4(+radius);
            if (x == null) x = 0;
            if (y == null) y = 0;
            function force(alpha) {
                for(var i = 0, n = nodes.length; i < n; ++i){
                    var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                    node.vx += dx * k;
                    node.vy += dy * k;
                }
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length;
                strengths = new Array(n);
                radiuses = new Array(n);
                for(i = 0; i < n; ++i){
                    radiuses[i] = +radius(nodes[i], i, nodes);
                    strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
                }
            }
            force.initialize = function(_) {
                nodes = _, initialize();
            };
            force.strength = function(_) {
                return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
            };
            force.radius = function(_) {
                return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
            };
            force.x = function(_) {
                return arguments.length ? (x = +_, force) : x;
            };
            force.y = function(_) {
                return arguments.length ? (y = +_, force) : y;
            };
            return force;
        }
        function x$2(x) {
            var strength = constant$4(0.1), nodes, strengths, xz;
            if (typeof x !== "function") x = constant$4(x == null ? 0 : +x);
            function force(alpha) {
                for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length;
                strengths = new Array(n);
                xz = new Array(n);
                for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
            }
            force.initialize = function(_) {
                nodes = _;
                initialize();
            };
            force.strength = function(_) {
                return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
            };
            force.x = function(_) {
                return arguments.length ? (x = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : x;
            };
            return force;
        }
        function y$1(y) {
            var strength = constant$4(0.1), nodes, strengths, yz;
            if (typeof y !== "function") y = constant$4(y == null ? 0 : +y);
            function force(alpha) {
                for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
            }
            function initialize() {
                if (!nodes) return;
                var i, n = nodes.length;
                strengths = new Array(n);
                yz = new Array(n);
                for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
            }
            force.initialize = function(_) {
                nodes = _;
                initialize();
            };
            force.strength = function(_) {
                return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
            };
            force.y = function(_) {
                return arguments.length ? (y = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : y;
            };
            return force;
        }
        function formatDecimal(x) {
            return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
        }
        function formatDecimalParts(x, p) {
            if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
            var i, coefficient = x.slice(0, i);
            return [
                coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
                +x.slice(i + 1)
            ];
        }
        function exponent(x) {
            return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
        }
        function formatGroup(grouping, thousands) {
            return function(value, width) {
                var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
                while(i > 0 && g > 0){
                    if (length + g + 1 > width) g = Math.max(1, width - length);
                    t.push(value.substring(i -= g, i + g));
                    if ((length += g + 1) > width) break;
                    g = grouping[j = (j + 1) % grouping.length];
                }
                return t.reverse().join(thousands);
            };
        }
        function formatNumerals(numerals) {
            return function(value) {
                return value.replace(/[0-9]/g, function(i) {
                    return numerals[+i];
                });
            };
        }
        var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
        function formatSpecifier(specifier) {
            if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
            var match;
            return new FormatSpecifier({
                fill: match[1],
                align: match[2],
                sign: match[3],
                symbol: match[4],
                zero: match[5],
                width: match[6],
                comma: match[7],
                precision: match[8] && match[8].slice(1),
                trim: match[9],
                type: match[10]
            });
        }
        formatSpecifier.prototype = FormatSpecifier.prototype;
        function FormatSpecifier(specifier) {
            this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
            this.align = specifier.align === undefined ? ">" : specifier.align + "";
            this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
            this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
            this.zero = !!specifier.zero;
            this.width = specifier.width === undefined ? undefined : +specifier.width;
            this.comma = !!specifier.comma;
            this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
            this.trim = !!specifier.trim;
            this.type = specifier.type === undefined ? "" : specifier.type + "";
        }
        FormatSpecifier.prototype.toString = function() {
            return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
        };
        function formatTrim(s) {
            out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
                case ".":
                    i0 = i1 = i;
                    break;
                case "0":
                    if (i0 === 0) i0 = i;
                    i1 = i;
                    break;
                default:
                    if (!+s[i]) break out;
                    if (i0 > 0) i0 = 0;
                    break;
            }
            return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
        }
        var prefixExponent;
        function formatPrefixAuto(x, p) {
            var d = formatDecimalParts(x, p);
            if (!d) return x + "";
            var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
            return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
        }
        function formatRounded(x, p) {
            var d = formatDecimalParts(x, p);
            if (!d) return x + "";
            var coefficient = d[0], exponent = d[1];
            return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
        }
        var formatTypes = {
            "%": (x, p)=>(x * 100).toFixed(p),
            "b": (x)=>Math.round(x).toString(2),
            "c": (x)=>x + "",
            "d": formatDecimal,
            "e": (x, p)=>x.toExponential(p),
            "f": (x, p)=>x.toFixed(p),
            "g": (x, p)=>x.toPrecision(p),
            "o": (x)=>Math.round(x).toString(8),
            "p": (x, p)=>formatRounded(x * 100, p),
            "r": formatRounded,
            "s": formatPrefixAuto,
            "X": (x)=>Math.round(x).toString(16).toUpperCase(),
            "x": (x)=>Math.round(x).toString(16)
        };
        function identity$6(x) {
            return x;
        }
        var map = Array.prototype.map, prefixes = [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\xB5",
            "m",
            "",
            "k",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ];
        function formatLocale$1(locale) {
            var group = locale.grouping === undefined || locale.thousands === undefined ? identity$6 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? identity$6 : formatNumerals(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
            function newFormat(specifier) {
                specifier = formatSpecifier(specifier);
                var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
                if (type === "n") comma = true, type = "g";
                else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
                if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
                var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
                var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
                precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
                function format(value) {
                    var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                    if (type === "c") {
                        valueSuffix = formatType(value) + valueSuffix;
                        value = "";
                    } else {
                        value = +value;
                        var valueNegative = value < 0 || 1 / value < 0;
                        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                        if (trim) value = formatTrim(value);
                        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                        if (maybeSuffix) {
                            i = -1, n = value.length;
                            while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                                value = value.slice(0, i);
                                break;
                            }
                        }
                    }
                    if (comma && !zero) value = group(value, Infinity);
                    var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                    if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                    switch(align){
                        case "<":
                            value = valuePrefix + value + valueSuffix + padding;
                            break;
                        case "=":
                            value = valuePrefix + padding + value + valueSuffix;
                            break;
                        case "^":
                            value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                            break;
                        default:
                            value = padding + valuePrefix + value + valueSuffix;
                            break;
                    }
                    return numerals(value);
                }
                format.toString = function() {
                    return specifier + "";
                };
                return format;
            }
            function formatPrefix(specifier, value) {
                var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
                return function(value) {
                    return f(k * value) + prefix;
                };
            }
            return {
                format: newFormat,
                formatPrefix: formatPrefix
            };
        }
        var locale$1;
        exports1.format = void 0;
        exports1.formatPrefix = void 0;
        defaultLocale$1({
            thousands: ",",
            grouping: [
                3
            ],
            currency: [
                "$",
                ""
            ]
        });
        function defaultLocale$1(definition) {
            locale$1 = formatLocale$1(definition);
            exports1.format = locale$1.format;
            exports1.formatPrefix = locale$1.formatPrefix;
            return locale$1;
        }
        function precisionFixed(step) {
            return Math.max(0, -exponent(Math.abs(step)));
        }
        function precisionPrefix(step, value) {
            return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
        }
        function precisionRound(step, max) {
            step = Math.abs(step), max = Math.abs(max) - step;
            return Math.max(0, exponent(max) - exponent(step)) + 1;
        }
        var epsilon$1 = 1e-6;
        var epsilon2 = 1e-12;
        var pi$1 = Math.PI;
        var halfPi$1 = pi$1 / 2;
        var quarterPi = pi$1 / 4;
        var tau$1 = pi$1 * 2;
        var degrees = 180 / pi$1;
        var radians = pi$1 / 180;
        var abs$1 = Math.abs;
        var atan = Math.atan;
        var atan2$1 = Math.atan2;
        var cos$1 = Math.cos;
        var ceil = Math.ceil;
        var exp = Math.exp;
        var hypot = Math.hypot;
        var log$1 = Math.log;
        var pow$1 = Math.pow;
        var sin$1 = Math.sin;
        var sign$1 = Math.sign || function(x) {
            return x > 0 ? 1 : x < 0 ? -1 : 0;
        };
        var sqrt$2 = Math.sqrt;
        var tan = Math.tan;
        function acos$1(x) {
            return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
        }
        function asin$1(x) {
            return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
        }
        function haversin(x) {
            return (x = sin$1(x / 2)) * x;
        }
        function noop$1() {}
        function streamGeometry(geometry, stream) {
            if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
        }
        var streamObjectType = {
            Feature: function(object, stream) {
                streamGeometry(object.geometry, stream);
            },
            FeatureCollection: function(object, stream) {
                var features = object.features, i = -1, n = features.length;
                while(++i < n)streamGeometry(features[i].geometry, stream);
            }
        };
        var streamGeometryType = {
            Sphere: function(object, stream) {
                stream.sphere();
            },
            Point: function(object, stream) {
                object = object.coordinates;
                stream.point(object[0], object[1], object[2]);
            },
            MultiPoint: function(object, stream) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
            },
            LineString: function(object, stream) {
                streamLine(object.coordinates, stream, 0);
            },
            MultiLineString: function(object, stream) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)streamLine(coordinates[i], stream, 0);
            },
            Polygon: function(object, stream) {
                streamPolygon(object.coordinates, stream);
            },
            MultiPolygon: function(object, stream) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)streamPolygon(coordinates[i], stream);
            },
            GeometryCollection: function(object, stream) {
                var geometries = object.geometries, i = -1, n = geometries.length;
                while(++i < n)streamGeometry(geometries[i], stream);
            }
        };
        function streamLine(coordinates, stream, closed) {
            var i = -1, n = coordinates.length - closed, coordinate;
            stream.lineStart();
            while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
            stream.lineEnd();
        }
        function streamPolygon(coordinates, stream) {
            var i = -1, n = coordinates.length;
            stream.polygonStart();
            while(++i < n)streamLine(coordinates[i], stream, 1);
            stream.polygonEnd();
        }
        function geoStream(object, stream) {
            if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
            else streamGeometry(object, stream);
        }
        var areaRingSum$1 = new Adder();
        var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
        var areaStream$1 = {
            point: noop$1,
            lineStart: noop$1,
            lineEnd: noop$1,
            polygonStart: function() {
                areaRingSum$1 = new Adder();
                areaStream$1.lineStart = areaRingStart$1;
                areaStream$1.lineEnd = areaRingEnd$1;
            },
            polygonEnd: function() {
                var areaRing = +areaRingSum$1;
                areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
                this.lineStart = this.lineEnd = this.point = noop$1;
            },
            sphere: function() {
                areaSum$1.add(tau$1);
            }
        };
        function areaRingStart$1() {
            areaStream$1.point = areaPointFirst$1;
        }
        function areaRingEnd$1() {
            areaPoint$1(lambda00$2, phi00$2);
        }
        function areaPointFirst$1(lambda, phi) {
            areaStream$1.point = areaPoint$1;
            lambda00$2 = lambda, phi00$2 = phi;
            lambda *= radians, phi *= radians;
            lambda0$2 = lambda, cosPhi0$1 = cos$1(phi = phi / 2 + quarterPi), sinPhi0$1 = sin$1(phi);
        }
        function areaPoint$1(lambda, phi) {
            lambda *= radians, phi *= radians;
            phi = phi / 2 + quarterPi;
            var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos$1(phi), sinPhi = sin$1(phi), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos$1(adLambda), v = k * sdLambda * sin$1(adLambda);
            areaRingSum$1.add(atan2$1(v, u));
            lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
        }
        function area$2(object) {
            areaSum$1 = new Adder();
            geoStream(object, areaStream$1);
            return areaSum$1 * 2;
        }
        function spherical(cartesian) {
            return [
                atan2$1(cartesian[1], cartesian[0]),
                asin$1(cartesian[2])
            ];
        }
        function cartesian(spherical) {
            var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
            return [
                cosPhi * cos$1(lambda),
                cosPhi * sin$1(lambda),
                sin$1(phi)
            ];
        }
        function cartesianDot(a, b) {
            return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
        }
        function cartesianCross(a, b) {
            return [
                a[1] * b[2] - a[2] * b[1],
                a[2] * b[0] - a[0] * b[2],
                a[0] * b[1] - a[1] * b[0]
            ];
        }
        function cartesianAddInPlace(a, b) {
            a[0] += b[0], a[1] += b[1], a[2] += b[2];
        }
        function cartesianScale(vector, k) {
            return [
                vector[0] * k,
                vector[1] * k,
                vector[2] * k
            ];
        }
        function cartesianNormalizeInPlace(d) {
            var l = sqrt$2(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
            d[0] /= l, d[1] /= l, d[2] /= l;
        }
        var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
        var boundsStream$2 = {
            point: boundsPoint$1,
            lineStart: boundsLineStart,
            lineEnd: boundsLineEnd,
            polygonStart: function() {
                boundsStream$2.point = boundsRingPoint;
                boundsStream$2.lineStart = boundsRingStart;
                boundsStream$2.lineEnd = boundsRingEnd;
                deltaSum = new Adder();
                areaStream$1.polygonStart();
            },
            polygonEnd: function() {
                areaStream$1.polygonEnd();
                boundsStream$2.point = boundsPoint$1;
                boundsStream$2.lineStart = boundsLineStart;
                boundsStream$2.lineEnd = boundsLineEnd;
                if (areaRingSum$1 < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
                else if (deltaSum > epsilon$1) phi1 = 90;
                else if (deltaSum < -epsilon$1) phi0 = -90;
                range[0] = lambda0$1, range[1] = lambda1;
            },
            sphere: function() {
                lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
            }
        };
        function boundsPoint$1(lambda, phi) {
            ranges.push(range = [
                lambda0$1 = lambda,
                lambda1 = lambda
            ]);
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        function linePoint(lambda, phi) {
            var p = cartesian([
                lambda * radians,
                phi * radians
            ]);
            if (p0) {
                var normal = cartesianCross(p0, p), equatorial = [
                    normal[1],
                    -normal[0],
                    0
                ], inflection = cartesianCross(equatorial, normal);
                cartesianNormalizeInPlace(inflection);
                inflection = spherical(inflection);
                var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign, phii, antimeridian = abs$1(delta) > 180;
                if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                    phii = inflection[1] * degrees;
                    if (phii > phi1) phi1 = phii;
                } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                    phii = -inflection[1] * degrees;
                    if (phii < phi0) phi0 = phii;
                } else {
                    if (phi < phi0) phi0 = phi;
                    if (phi > phi1) phi1 = phi;
                }
                if (antimeridian) {
                    if (lambda < lambda2) {
                        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                    } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
                } else if (lambda1 >= lambda0$1) {
                    if (lambda < lambda0$1) lambda0$1 = lambda;
                    if (lambda > lambda1) lambda1 = lambda;
                } else {
                    if (lambda > lambda2) {
                        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                    } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
                }
            } else ranges.push(range = [
                lambda0$1 = lambda,
                lambda1 = lambda
            ]);
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
            p0 = p, lambda2 = lambda;
        }
        function boundsLineStart() {
            boundsStream$2.point = linePoint;
        }
        function boundsLineEnd() {
            range[0] = lambda0$1, range[1] = lambda1;
            boundsStream$2.point = boundsPoint$1;
            p0 = null;
        }
        function boundsRingPoint(lambda, phi) {
            if (p0) {
                var delta = lambda - lambda2;
                deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
            } else lambda00$1 = lambda, phi00$1 = phi;
            areaStream$1.point(lambda, phi);
            linePoint(lambda, phi);
        }
        function boundsRingStart() {
            areaStream$1.lineStart();
        }
        function boundsRingEnd() {
            boundsRingPoint(lambda00$1, phi00$1);
            areaStream$1.lineEnd();
            if (abs$1(deltaSum) > epsilon$1) lambda0$1 = -(lambda1 = 180);
            range[0] = lambda0$1, range[1] = lambda1;
            p0 = null;
        }
        function angle(lambda0, lambda1) {
            return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
        }
        function rangeCompare(a, b) {
            return a[0] - b[0];
        }
        function rangeContains(range, x) {
            return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
        }
        function bounds(feature) {
            var i, n, a, b, merged, deltaMax, delta;
            phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
            ranges = [];
            geoStream(feature, boundsStream$2);
            if (n = ranges.length) {
                ranges.sort(rangeCompare);
                for(i = 1, a = ranges[0], merged = [
                    a
                ]; i < n; ++i){
                    b = ranges[i];
                    if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                    } else merged.push(a = b);
                }
                for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                    b = merged[i];
                    if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
                }
            }
            ranges = range = null;
            return lambda0$1 === Infinity || phi0 === Infinity ? [
                [
                    NaN,
                    NaN
                ],
                [
                    NaN,
                    NaN
                ]
            ] : [
                [
                    lambda0$1,
                    phi0
                ],
                [
                    lambda1,
                    phi1
                ]
            ];
        }
        var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0;
        var centroidStream$1 = {
            sphere: noop$1,
            point: centroidPoint$1,
            lineStart: centroidLineStart$1,
            lineEnd: centroidLineEnd$1,
            polygonStart: function() {
                centroidStream$1.lineStart = centroidRingStart$1;
                centroidStream$1.lineEnd = centroidRingEnd$1;
            },
            polygonEnd: function() {
                centroidStream$1.lineStart = centroidLineStart$1;
                centroidStream$1.lineEnd = centroidLineEnd$1;
            }
        };
        function centroidPoint$1(lambda, phi) {
            lambda *= radians, phi *= radians;
            var cosPhi = cos$1(phi);
            centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
        }
        function centroidPointCartesian(x, y, z) {
            ++W0;
            X0$1 += (x - X0$1) / W0;
            Y0$1 += (y - Y0$1) / W0;
            Z0$1 += (z - Z0$1) / W0;
        }
        function centroidLineStart$1() {
            centroidStream$1.point = centroidLinePointFirst;
        }
        function centroidLinePointFirst(lambda, phi) {
            lambda *= radians, phi *= radians;
            var cosPhi = cos$1(phi);
            x0$4 = cosPhi * cos$1(lambda);
            y0$4 = cosPhi * sin$1(lambda);
            z0 = sin$1(phi);
            centroidStream$1.point = centroidLinePoint;
            centroidPointCartesian(x0$4, y0$4, z0);
        }
        function centroidLinePoint(lambda, phi) {
            lambda *= radians, phi *= radians;
            var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), w = atan2$1(sqrt$2((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
            W1 += w;
            X1$1 += w * (x0$4 + (x0$4 = x));
            Y1$1 += w * (y0$4 + (y0$4 = y));
            Z1$1 += w * (z0 + (z0 = z));
            centroidPointCartesian(x0$4, y0$4, z0);
        }
        function centroidLineEnd$1() {
            centroidStream$1.point = centroidPoint$1;
        }
        function centroidRingStart$1() {
            centroidStream$1.point = centroidRingPointFirst;
        }
        function centroidRingEnd$1() {
            centroidRingPoint(lambda00, phi00);
            centroidStream$1.point = centroidPoint$1;
        }
        function centroidRingPointFirst(lambda, phi) {
            lambda00 = lambda, phi00 = phi;
            lambda *= radians, phi *= radians;
            centroidStream$1.point = centroidRingPoint;
            var cosPhi = cos$1(phi);
            x0$4 = cosPhi * cos$1(lambda);
            y0$4 = cosPhi * sin$1(lambda);
            z0 = sin$1(phi);
            centroidPointCartesian(x0$4, y0$4, z0);
        }
        function centroidRingPoint(lambda, phi) {
            lambda *= radians, phi *= radians;
            var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin$1(m), v = m && -w / m;
            X2$1.add(v * cx);
            Y2$1.add(v * cy);
            Z2$1.add(v * cz);
            W1 += w;
            X1$1 += w * (x0$4 + (x0$4 = x));
            Y1$1 += w * (y0$4 + (y0$4 = y));
            Z1$1 += w * (z0 + (z0 = z));
            centroidPointCartesian(x0$4, y0$4, z0);
        }
        function centroid$1(object) {
            W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
            X2$1 = new Adder();
            Y2$1 = new Adder();
            Z2$1 = new Adder();
            geoStream(object, centroidStream$1);
            var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
            if (m < epsilon2) {
                x = X1$1, y = Y1$1, z = Z1$1;
                if (W1 < epsilon$1) x = X0$1, y = Y0$1, z = Z0$1;
                m = hypot(x, y, z);
                if (m < epsilon2) return [
                    NaN,
                    NaN
                ];
            }
            return [
                atan2$1(y, x) * degrees,
                asin$1(z / m) * degrees
            ];
        }
        function constant$3(x) {
            return function() {
                return x;
            };
        }
        function compose(a, b) {
            function compose(x, y) {
                return x = a(x, y), b(x[0], x[1]);
            }
            if (a.invert && b.invert) compose.invert = function(x, y) {
                return x = b.invert(x, y), x && a.invert(x[0], x[1]);
            };
            return compose;
        }
        function rotationIdentity(lambda, phi) {
            return [
                abs$1(lambda) > pi$1 ? lambda + Math.round(-lambda / tau$1) * tau$1 : lambda,
                phi
            ];
        }
        rotationIdentity.invert = rotationIdentity;
        function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
            return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
        }
        function forwardRotationLambda(deltaLambda) {
            return function(lambda, phi) {
                return lambda += deltaLambda, [
                    lambda > pi$1 ? lambda - tau$1 : lambda < -pi$1 ? lambda + tau$1 : lambda,
                    phi
                ];
            };
        }
        function rotationLambda(deltaLambda) {
            var rotation = forwardRotationLambda(deltaLambda);
            rotation.invert = forwardRotationLambda(-deltaLambda);
            return rotation;
        }
        function rotationPhiGamma(deltaPhi, deltaGamma) {
            var cosDeltaPhi = cos$1(deltaPhi), sinDeltaPhi = sin$1(deltaPhi), cosDeltaGamma = cos$1(deltaGamma), sinDeltaGamma = sin$1(deltaGamma);
            function rotation(lambda, phi) {
                var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
                return [
                    atan2$1(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
                    asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
                ];
            }
            rotation.invert = function(lambda, phi) {
                var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
                return [
                    atan2$1(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
                    asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
                ];
            };
            return rotation;
        }
        function rotation(rotate) {
            rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
            function forward(coordinates) {
                coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
                return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
            }
            forward.invert = function(coordinates) {
                coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
                return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
            };
            return forward;
        }
        function circleStream(stream, radius, delta, direction, t0, t1) {
            if (!delta) return;
            var cosRadius = cos$1(radius), sinRadius = sin$1(radius), step = direction * delta;
            if (t0 == null) {
                t0 = radius + direction * tau$1;
                t1 = radius - step / 2;
            } else {
                t0 = circleRadius(cosRadius, t0);
                t1 = circleRadius(cosRadius, t1);
                if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
            }
            for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
                point = spherical([
                    cosRadius,
                    -sinRadius * cos$1(t),
                    -sinRadius * sin$1(t)
                ]);
                stream.point(point[0], point[1]);
            }
        }
        function circleRadius(cosRadius, point) {
            point = cartesian(point), point[0] -= cosRadius;
            cartesianNormalizeInPlace(point);
            var radius = acos$1(-point[1]);
            return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$1) % tau$1;
        }
        function circle$2() {
            var center = constant$3([
                0,
                0
            ]), radius = constant$3(90), precision = constant$3(6), ring, rotate, stream = {
                point: point
            };
            function point(x, y) {
                ring.push(x = rotate(x, y));
                x[0] *= degrees, x[1] *= degrees;
            }
            function circle() {
                var c = center.apply(this, arguments), r = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
                ring = [];
                rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
                circleStream(stream, r, p, 1);
                c = {
                    type: "Polygon",
                    coordinates: [
                        ring
                    ]
                };
                ring = rotate = null;
                return c;
            }
            circle.center = function(_) {
                return arguments.length ? (center = typeof _ === "function" ? _ : constant$3([
                    +_[0],
                    +_[1]
                ]), circle) : center;
            };
            circle.radius = function(_) {
                return arguments.length ? (radius = typeof _ === "function" ? _ : constant$3(+_), circle) : radius;
            };
            circle.precision = function(_) {
                return arguments.length ? (precision = typeof _ === "function" ? _ : constant$3(+_), circle) : precision;
            };
            return circle;
        }
        function clipBuffer() {
            var lines = [], line;
            return {
                point: function(x, y, m) {
                    line.push([
                        x,
                        y,
                        m
                    ]);
                },
                lineStart: function() {
                    lines.push(line = []);
                },
                lineEnd: noop$1,
                rejoin: function() {
                    if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
                },
                result: function() {
                    var result = lines;
                    lines = [];
                    line = null;
                    return result;
                }
            };
        }
        function pointEqual(a, b) {
            return abs$1(a[0] - b[0]) < epsilon$1 && abs$1(a[1] - b[1]) < epsilon$1;
        }
        function Intersection(point, points, other, entry) {
            this.x = point;
            this.z = points;
            this.o = other;
            this.e = entry;
            this.v = false;
            this.n = this.p = null;
        }
        function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
            var subject = [], clip = [], i, n;
            segments.forEach(function(segment) {
                if ((n = segment.length - 1) <= 0) return;
                var n, p0 = segment[0], p1 = segment[n], x;
                if (pointEqual(p0, p1)) {
                    if (!p0[2] && !p1[2]) {
                        stream.lineStart();
                        for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                        stream.lineEnd();
                        return;
                    }
                    p1[0] += 2 * epsilon$1;
                }
                subject.push(x = new Intersection(p0, segment, null, true));
                clip.push(x.o = new Intersection(p0, null, x, false));
                subject.push(x = new Intersection(p1, segment, null, false));
                clip.push(x.o = new Intersection(p1, null, x, true));
            });
            if (!subject.length) return;
            clip.sort(compareIntersection);
            link$1(subject);
            link$1(clip);
            for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
            var start = subject[0], points, point;
            while(true){
                var current = start, isSubject = true;
                while(current.v)if ((current = current.n) === start) return;
                points = current.z;
                stream.lineStart();
                do {
                    current.v = current.o.v = true;
                    if (current.e) {
                        if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                        else interpolate(current.x, current.n.x, 1, stream);
                        current = current.n;
                    } else {
                        if (isSubject) {
                            points = current.p.z;
                            for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                        } else interpolate(current.x, current.p.x, -1, stream);
                        current = current.p;
                    }
                    current = current.o;
                    points = current.z;
                    isSubject = !isSubject;
                }while (!current.v)
                stream.lineEnd();
            }
        }
        function link$1(array) {
            if (!(n = array.length)) return;
            var n, i = 0, a = array[0], b;
            while(++i < n){
                a.n = b = array[i];
                b.p = a;
                a = b;
            }
            a.n = b = array[0];
            b.p = a;
        }
        function longitude(point) {
            return abs$1(point[0]) <= pi$1 ? point[0] : sign$1(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
        }
        function polygonContains(polygon, point) {
            var lambda = longitude(point), phi = point[1], sinPhi = sin$1(phi), normal = [
                sin$1(lambda),
                -cos$1(lambda),
                0
            ], angle = 0, winding = 0;
            var sum = new Adder();
            if (sinPhi === 1) phi = halfPi$1 + epsilon$1;
            else if (sinPhi === -1) phi = -halfPi$1 - epsilon$1;
            for(var i = 0, n = polygon.length; i < n; ++i){
                if (!(m = (ring = polygon[i]).length)) continue;
                var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + quarterPi, sinPhi0 = sin$1(phi0), cosPhi0 = cos$1(phi0);
                for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                    var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + quarterPi, sinPhi1 = sin$1(phi1), cosPhi1 = cos$1(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > pi$1, k = sinPhi0 * sinPhi1;
                    sum.add(atan2$1(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
                    angle += antimeridian ? delta + sign * tau$1 : delta;
                    if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                        var arc = cartesianCross(cartesian(point0), cartesian(point1));
                        cartesianNormalizeInPlace(arc);
                        var intersection = cartesianCross(normal, arc);
                        cartesianNormalizeInPlace(intersection);
                        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
                        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                    }
                }
            }
            return (angle < -epsilon$1 || angle < epsilon$1 && sum < -epsilon2) ^ winding & 1;
        }
        function clip(pointVisible, clipLine, interpolate, start) {
            return function(sink) {
                var line = clipLine(sink), ringBuffer = clipBuffer(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
                var clip = {
                    point: point,
                    lineStart: lineStart,
                    lineEnd: lineEnd,
                    polygonStart: function() {
                        clip.point = pointRing;
                        clip.lineStart = ringStart;
                        clip.lineEnd = ringEnd;
                        segments = [];
                        polygon = [];
                    },
                    polygonEnd: function() {
                        clip.point = point;
                        clip.lineStart = lineStart;
                        clip.lineEnd = lineEnd;
                        segments = merge(segments);
                        var startInside = polygonContains(polygon, start);
                        if (segments.length) {
                            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                            clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
                        } else if (startInside) {
                            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                            sink.lineStart();
                            interpolate(null, null, 1, sink);
                            sink.lineEnd();
                        }
                        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                        segments = polygon = null;
                    },
                    sphere: function() {
                        sink.polygonStart();
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                        sink.polygonEnd();
                    }
                };
                function point(lambda, phi) {
                    if (pointVisible(lambda, phi)) sink.point(lambda, phi);
                }
                function pointLine(lambda, phi) {
                    line.point(lambda, phi);
                }
                function lineStart() {
                    clip.point = pointLine;
                    line.lineStart();
                }
                function lineEnd() {
                    clip.point = point;
                    line.lineEnd();
                }
                function pointRing(lambda, phi) {
                    ring.push([
                        lambda,
                        phi
                    ]);
                    ringSink.point(lambda, phi);
                }
                function ringStart() {
                    ringSink.lineStart();
                    ring = [];
                }
                function ringEnd() {
                    pointRing(ring[0][0], ring[0][1]);
                    ringSink.lineEnd();
                    var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                    ring.pop();
                    polygon.push(ring);
                    ring = null;
                    if (!n) return;
                    if (clean & 1) {
                        segment = ringSegments[0];
                        if ((m = segment.length - 1) > 0) {
                            if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                            sink.lineStart();
                            for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                            sink.lineEnd();
                        }
                        return;
                    }
                    if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                    segments.push(ringSegments.filter(validSegment));
                }
                return clip;
            };
        }
        function validSegment(segment) {
            return segment.length > 1;
        }
        function compareIntersection(a, b) {
            return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$1 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$1 : halfPi$1 - b[1]);
        }
        var clipAntimeridian = clip(function() {
            return true;
        }, clipAntimeridianLine, clipAntimeridianInterpolate, [
            -pi$1,
            -halfPi$1
        ]);
        function clipAntimeridianLine(stream) {
            var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean;
            return {
                lineStart: function() {
                    stream.lineStart();
                    clean = 1;
                },
                point: function(lambda1, phi1) {
                    var sign1 = lambda1 > 0 ? pi$1 : -pi$1, delta = abs$1(lambda1 - lambda0);
                    if (abs$1(delta - pi$1) < epsilon$1) {
                        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
                        stream.point(sign0, phi0);
                        stream.lineEnd();
                        stream.lineStart();
                        stream.point(sign1, phi0);
                        stream.point(lambda1, phi0);
                        clean = 0;
                    } else if (sign0 !== sign1 && delta >= pi$1) {
                        if (abs$1(lambda0 - sign0) < epsilon$1) lambda0 -= sign0 * epsilon$1;
                        if (abs$1(lambda1 - sign1) < epsilon$1) lambda1 -= sign1 * epsilon$1;
                        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                        stream.point(sign0, phi0);
                        stream.lineEnd();
                        stream.lineStart();
                        stream.point(sign1, phi0);
                        clean = 0;
                    }
                    stream.point(lambda0 = lambda1, phi0 = phi1);
                    sign0 = sign1;
                },
                lineEnd: function() {
                    stream.lineEnd();
                    lambda0 = phi0 = NaN;
                },
                clean: function() {
                    return 2 - clean;
                }
            };
        }
        function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
            var cosPhi0, cosPhi1, sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
            return abs$1(sinLambda0Lambda1) > epsilon$1 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
        }
        function clipAntimeridianInterpolate(from, to, direction, stream) {
            var phi;
            if (from == null) {
                phi = direction * halfPi$1;
                stream.point(-pi$1, phi);
                stream.point(0, phi);
                stream.point(pi$1, phi);
                stream.point(pi$1, 0);
                stream.point(pi$1, -phi);
                stream.point(0, -phi);
                stream.point(-pi$1, -phi);
                stream.point(-pi$1, 0);
                stream.point(-pi$1, phi);
            } else if (abs$1(from[0] - to[0]) > epsilon$1) {
                var lambda = from[0] < to[0] ? pi$1 : -pi$1;
                phi = direction * lambda / 2;
                stream.point(-lambda, phi);
                stream.point(0, phi);
                stream.point(lambda, phi);
            } else stream.point(to[0], to[1]);
        }
        function clipCircle(radius) {
            var cr = cos$1(radius), delta = 6 * radians, smallRadius = cr > 0, notHemisphere = abs$1(cr) > epsilon$1;
            function interpolate(from, to, direction, stream) {
                circleStream(stream, radius, delta, direction, from, to);
            }
            function visible(lambda, phi) {
                return cos$1(lambda) * cos$1(phi) > cr;
            }
            function clipLine(stream) {
                var point0, c0, v0, v00, clean;
                return {
                    lineStart: function() {
                        v00 = v0 = false;
                        clean = 1;
                    },
                    point: function(lambda, phi) {
                        var point1 = [
                            lambda,
                            phi
                        ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
                        if (!point0 && (v00 = v0 = v)) stream.lineStart();
                        if (v !== v0) {
                            point2 = intersect(point0, point1);
                            if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
                        }
                        if (v !== v0) {
                            clean = 0;
                            if (v) {
                                stream.lineStart();
                                point2 = intersect(point1, point0);
                                stream.point(point2[0], point2[1]);
                            } else {
                                point2 = intersect(point0, point1);
                                stream.point(point2[0], point2[1], 2);
                                stream.lineEnd();
                            }
                            point0 = point2;
                        } else if (notHemisphere && point0 && smallRadius ^ v) {
                            var t;
                            if (!(c & c0) && (t = intersect(point1, point0, true))) {
                                clean = 0;
                                if (smallRadius) {
                                    stream.lineStart();
                                    stream.point(t[0][0], t[0][1]);
                                    stream.point(t[1][0], t[1][1]);
                                    stream.lineEnd();
                                } else {
                                    stream.point(t[1][0], t[1][1]);
                                    stream.lineEnd();
                                    stream.lineStart();
                                    stream.point(t[0][0], t[0][1], 3);
                                }
                            }
                        }
                        if (v && (!point0 || !pointEqual(point0, point1))) stream.point(point1[0], point1[1]);
                        point0 = point1, v0 = v, c0 = c;
                    },
                    lineEnd: function() {
                        if (v0) stream.lineEnd();
                        point0 = null;
                    },
                    clean: function() {
                        return clean | (v00 && v0) << 1;
                    }
                };
            }
            function intersect(a, b, two) {
                var pa = cartesian(a), pb = cartesian(b);
                var n1 = [
                    1,
                    0,
                    0
                ], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
                if (!determinant) return !two && a;
                var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A = cartesianScale(n1, c1), B = cartesianScale(n2, c2);
                cartesianAddInPlace(A, B);
                var u = n1xn2, w = cartesianDot(A, u), uu = cartesianDot(u, u), t2 = w * w - uu * (cartesianDot(A, A) - 1);
                if (t2 < 0) return;
                var t = sqrt$2(t2), q = cartesianScale(u, (-w - t) / uu);
                cartesianAddInPlace(q, A);
                q = spherical(q);
                if (!two) return q;
                var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
                if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
                var delta = lambda1 - lambda0, polar = abs$1(delta - pi$1) < epsilon$1, meridian = polar || delta < epsilon$1;
                if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
                if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$1 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                    var q1 = cartesianScale(u, (-w + t) / uu);
                    cartesianAddInPlace(q1, A);
                    return [
                        q,
                        spherical(q1)
                    ];
                }
            }
            function code(lambda, phi) {
                var r = smallRadius ? radius : pi$1 - radius, code = 0;
                if (lambda < -r) code |= 1;
                else if (lambda > r) code |= 2;
                if (phi < -r) code |= 4;
                else if (phi > r) code |= 8;
                return code;
            }
            return clip(visible, clipLine, interpolate, smallRadius ? [
                0,
                -radius
            ] : [
                -pi$1,
                radius - pi$1
            ]);
        }
        function clipLine(a, b, x0, y0, x1, y1) {
            var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
            r = x0 - ax;
            if (!dx && r > 0) return;
            r /= dx;
            if (dx < 0) {
                if (r < t0) return;
                if (r < t1) t1 = r;
            } else if (dx > 0) {
                if (r > t1) return;
                if (r > t0) t0 = r;
            }
            r = x1 - ax;
            if (!dx && r < 0) return;
            r /= dx;
            if (dx < 0) {
                if (r > t1) return;
                if (r > t0) t0 = r;
            } else if (dx > 0) {
                if (r < t0) return;
                if (r < t1) t1 = r;
            }
            r = y0 - ay;
            if (!dy && r > 0) return;
            r /= dy;
            if (dy < 0) {
                if (r < t0) return;
                if (r < t1) t1 = r;
            } else if (dy > 0) {
                if (r > t1) return;
                if (r > t0) t0 = r;
            }
            r = y1 - ay;
            if (!dy && r < 0) return;
            r /= dy;
            if (dy < 0) {
                if (r > t1) return;
                if (r > t0) t0 = r;
            } else if (dy > 0) {
                if (r < t0) return;
                if (r < t1) t1 = r;
            }
            if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
            if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
            return true;
        }
        var clipMax = 1e9, clipMin = -clipMax;
        function clipRectangle(x0, y0, x1, y1) {
            function visible(x, y) {
                return x0 <= x && x <= x1 && y0 <= y && y <= y1;
            }
            function interpolate(from, to, direction, stream) {
                var a = 0, a1 = 0;
                if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
                while ((a = (a + direction + 4) % 4) !== a1)
                else stream.point(to[0], to[1]);
            }
            function corner(p, direction) {
                return abs$1(p[0] - x0) < epsilon$1 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$1 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$1 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
            }
            function compareIntersection(a, b) {
                return comparePoint(a.x, b.x);
            }
            function comparePoint(a, b) {
                var ca = corner(a, 1), cb = corner(b, 1);
                return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
            }
            return function(stream) {
                var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
                var clipStream = {
                    point: point,
                    lineStart: lineStart,
                    lineEnd: lineEnd,
                    polygonStart: polygonStart,
                    polygonEnd: polygonEnd
                };
                function point(x, y) {
                    if (visible(x, y)) activeStream.point(x, y);
                }
                function polygonInside() {
                    var winding = 0;
                    for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                        a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                        if (a1 <= y1) {
                            if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                        } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
                    }
                    return winding;
                }
                function polygonStart() {
                    activeStream = bufferStream, segments = [], polygon = [], clean = true;
                }
                function polygonEnd() {
                    var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = merge(segments)).length;
                    if (cleanInside || visible) {
                        stream.polygonStart();
                        if (cleanInside) {
                            stream.lineStart();
                            interpolate(null, null, 1, stream);
                            stream.lineEnd();
                        }
                        if (visible) clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
                        stream.polygonEnd();
                    }
                    activeStream = stream, segments = polygon = ring = null;
                }
                function lineStart() {
                    clipStream.point = linePoint;
                    if (polygon) polygon.push(ring = []);
                    first = true;
                    v_ = false;
                    x_ = y_ = NaN;
                }
                function lineEnd() {
                    if (segments) {
                        linePoint(x__, y__);
                        if (v__ && v_) bufferStream.rejoin();
                        segments.push(bufferStream.result());
                    }
                    clipStream.point = point;
                    if (v_) activeStream.lineEnd();
                }
                function linePoint(x, y) {
                    var v = visible(x, y);
                    if (polygon) ring.push([
                        x,
                        y
                    ]);
                    if (first) {
                        x__ = x, y__ = y, v__ = v;
                        first = false;
                        if (v) {
                            activeStream.lineStart();
                            activeStream.point(x, y);
                        }
                    } else if (v && v_) activeStream.point(x, y);
                    else {
                        var a = [
                            x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                            y_ = Math.max(clipMin, Math.min(clipMax, y_))
                        ], b = [
                            x = Math.max(clipMin, Math.min(clipMax, x)),
                            y = Math.max(clipMin, Math.min(clipMax, y))
                        ];
                        if (clipLine(a, b, x0, y0, x1, y1)) {
                            if (!v_) {
                                activeStream.lineStart();
                                activeStream.point(a[0], a[1]);
                            }
                            activeStream.point(b[0], b[1]);
                            if (!v) activeStream.lineEnd();
                            clean = false;
                        } else if (v) {
                            activeStream.lineStart();
                            activeStream.point(x, y);
                            clean = false;
                        }
                    }
                    x_ = x, y_ = y, v_ = v;
                }
                return clipStream;
            };
        }
        function extent() {
            var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
            return clip = {
                stream: function(stream) {
                    return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
                },
                extent: function(_) {
                    return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ]
                    ];
                }
            };
        }
        var lengthSum$1, lambda0, sinPhi0, cosPhi0;
        var lengthStream$1 = {
            sphere: noop$1,
            point: noop$1,
            lineStart: lengthLineStart,
            lineEnd: noop$1,
            polygonStart: noop$1,
            polygonEnd: noop$1
        };
        function lengthLineStart() {
            lengthStream$1.point = lengthPointFirst$1;
            lengthStream$1.lineEnd = lengthLineEnd;
        }
        function lengthLineEnd() {
            lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
        }
        function lengthPointFirst$1(lambda, phi) {
            lambda *= radians, phi *= radians;
            lambda0 = lambda, sinPhi0 = sin$1(phi), cosPhi0 = cos$1(phi);
            lengthStream$1.point = lengthPoint$1;
        }
        function lengthPoint$1(lambda, phi) {
            lambda *= radians, phi *= radians;
            var sinPhi = sin$1(phi), cosPhi = cos$1(phi), delta = abs$1(lambda - lambda0), cosDelta = cos$1(delta), sinDelta = sin$1(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
            lengthSum$1.add(atan2$1(sqrt$2(x * x + y * y), z));
            lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
        }
        function length$1(object) {
            lengthSum$1 = new Adder();
            geoStream(object, lengthStream$1);
            return +lengthSum$1;
        }
        var coordinates = [
            null,
            null
        ], object = {
            type: "LineString",
            coordinates: coordinates
        };
        function distance(a, b) {
            coordinates[0] = a;
            coordinates[1] = b;
            return length$1(object);
        }
        var containsObjectType = {
            Feature: function(object, point) {
                return containsGeometry(object.geometry, point);
            },
            FeatureCollection: function(object, point) {
                var features = object.features, i = -1, n = features.length;
                while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
                return false;
            }
        };
        var containsGeometryType = {
            Sphere: function() {
                return true;
            },
            Point: function(object, point) {
                return containsPoint(object.coordinates, point);
            },
            MultiPoint: function(object, point) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)if (containsPoint(coordinates[i], point)) return true;
                return false;
            },
            LineString: function(object, point) {
                return containsLine(object.coordinates, point);
            },
            MultiLineString: function(object, point) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)if (containsLine(coordinates[i], point)) return true;
                return false;
            },
            Polygon: function(object, point) {
                return containsPolygon(object.coordinates, point);
            },
            MultiPolygon: function(object, point) {
                var coordinates = object.coordinates, i = -1, n = coordinates.length;
                while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
                return false;
            },
            GeometryCollection: function(object, point) {
                var geometries = object.geometries, i = -1, n = geometries.length;
                while(++i < n)if (containsGeometry(geometries[i], point)) return true;
                return false;
            }
        };
        function containsGeometry(geometry, point) {
            return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
        }
        function containsPoint(coordinates, point) {
            return distance(coordinates, point) === 0;
        }
        function containsLine(coordinates, point) {
            var ao, bo, ab;
            for(var i = 0, n = coordinates.length; i < n; i++){
                bo = distance(coordinates[i], point);
                if (bo === 0) return true;
                if (i > 0) {
                    ab = distance(coordinates[i], coordinates[i - 1]);
                    if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab) return true;
                }
                ao = bo;
            }
            return false;
        }
        function containsPolygon(coordinates, point) {
            return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
        }
        function ringRadians(ring) {
            return ring = ring.map(pointRadians), ring.pop(), ring;
        }
        function pointRadians(point) {
            return [
                point[0] * radians,
                point[1] * radians
            ];
        }
        function contains$1(object, point) {
            return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
        }
        function graticuleX(y0, y1, dy) {
            var y = range$2(y0, y1 - epsilon$1, dy).concat(y1);
            return function(x) {
                return y.map(function(y) {
                    return [
                        x,
                        y
                    ];
                });
            };
        }
        function graticuleY(x0, x1, dx) {
            var x = range$2(x0, x1 - epsilon$1, dx).concat(x1);
            return function(y) {
                return x.map(function(x) {
                    return [
                        x,
                        y
                    ];
                });
            };
        }
        function graticule() {
            var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
            function graticule() {
                return {
                    type: "MultiLineString",
                    coordinates: lines()
                };
            }
            function lines() {
                return range$2(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$2(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$2(ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                    return abs$1(x % DX) > epsilon$1;
                }).map(x)).concat(range$2(ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                    return abs$1(y % DY) > epsilon$1;
                }).map(y));
            }
            graticule.lines = function() {
                return lines().map(function(coordinates) {
                    return {
                        type: "LineString",
                        coordinates: coordinates
                    };
                });
            };
            graticule.outline = function() {
                return {
                    type: "Polygon",
                    coordinates: [
                        X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                    ]
                };
            };
            graticule.extent = function(_) {
                if (!arguments.length) return graticule.extentMinor();
                return graticule.extentMajor(_).extentMinor(_);
            };
            graticule.extentMajor = function(_) {
                if (!arguments.length) return [
                    [
                        X0,
                        Y0
                    ],
                    [
                        X1,
                        Y1
                    ]
                ];
                X0 = +_[0][0], X1 = +_[1][0];
                Y0 = +_[0][1], Y1 = +_[1][1];
                if (X0 > X1) _ = X0, X0 = X1, X1 = _;
                if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
                return graticule.precision(precision);
            };
            graticule.extentMinor = function(_) {
                if (!arguments.length) return [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
                x0 = +_[0][0], x1 = +_[1][0];
                y0 = +_[0][1], y1 = +_[1][1];
                if (x0 > x1) _ = x0, x0 = x1, x1 = _;
                if (y0 > y1) _ = y0, y0 = y1, y1 = _;
                return graticule.precision(precision);
            };
            graticule.step = function(_) {
                if (!arguments.length) return graticule.stepMinor();
                return graticule.stepMajor(_).stepMinor(_);
            };
            graticule.stepMajor = function(_) {
                if (!arguments.length) return [
                    DX,
                    DY
                ];
                DX = +_[0], DY = +_[1];
                return graticule;
            };
            graticule.stepMinor = function(_) {
                if (!arguments.length) return [
                    dx,
                    dy
                ];
                dx = +_[0], dy = +_[1];
                return graticule;
            };
            graticule.precision = function(_) {
                if (!arguments.length) return precision;
                precision = +_;
                x = graticuleX(y0, y1, 90);
                y = graticuleY(x0, x1, precision);
                X = graticuleX(Y0, Y1, 90);
                Y = graticuleY(X0, X1, precision);
                return graticule;
            };
            return graticule.extentMajor([
                [
                    -180,
                    -90 + epsilon$1
                ],
                [
                    180,
                    90 - epsilon$1
                ]
            ]).extentMinor([
                [
                    -180,
                    -80 - epsilon$1
                ],
                [
                    180,
                    80 + epsilon$1
                ]
            ]);
        }
        function graticule10() {
            return graticule()();
        }
        function interpolate(a, b) {
            var x0 = a[0] * radians, y0 = a[1] * radians, x1 = b[0] * radians, y1 = b[1] * radians, cy0 = cos$1(y0), sy0 = sin$1(y0), cy1 = cos$1(y1), sy1 = sin$1(y1), kx0 = cy0 * cos$1(x0), ky0 = cy0 * sin$1(x0), kx1 = cy1 * cos$1(x1), ky1 = cy1 * sin$1(x1), d = 2 * asin$1(sqrt$2(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))), k = sin$1(d);
            var interpolate = d ? function(t) {
                var B = sin$1(t *= d) / k, A = sin$1(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
                return [
                    atan2$1(y, x) * degrees,
                    atan2$1(z, sqrt$2(x * x + y * y)) * degrees
                ];
            } : function() {
                return [
                    x0 * degrees,
                    y0 * degrees
                ];
            };
            interpolate.distance = d;
            return interpolate;
        }
        var identity$5 = (x)=>x;
        var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
        var areaStream = {
            point: noop$1,
            lineStart: noop$1,
            lineEnd: noop$1,
            polygonStart: function() {
                areaStream.lineStart = areaRingStart;
                areaStream.lineEnd = areaRingEnd;
            },
            polygonEnd: function() {
                areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
                areaSum.add(abs$1(areaRingSum));
                areaRingSum = new Adder();
            },
            result: function() {
                var area = areaSum / 2;
                areaSum = new Adder();
                return area;
            }
        };
        function areaRingStart() {
            areaStream.point = areaPointFirst;
        }
        function areaPointFirst(x, y) {
            areaStream.point = areaPoint;
            x00$2 = x0$3 = x, y00$2 = y0$3 = y;
        }
        function areaPoint(x, y) {
            areaRingSum.add(y0$3 * x - x0$3 * y);
            x0$3 = x, y0$3 = y;
        }
        function areaRingEnd() {
            areaPoint(x00$2, y00$2);
        }
        var pathArea = areaStream;
        var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
        var boundsStream = {
            point: boundsPoint,
            lineStart: noop$1,
            lineEnd: noop$1,
            polygonStart: noop$1,
            polygonEnd: noop$1,
            result: function() {
                var bounds = [
                    [
                        x0$2,
                        y0$2
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
                x1 = y1 = -(y0$2 = x0$2 = Infinity);
                return bounds;
            }
        };
        function boundsPoint(x, y) {
            if (x < x0$2) x0$2 = x;
            if (x > x1) x1 = x;
            if (y < y0$2) y0$2 = y;
            if (y > y1) y1 = y;
        }
        var boundsStream$1 = boundsStream;
        var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
        var centroidStream = {
            point: centroidPoint,
            lineStart: centroidLineStart,
            lineEnd: centroidLineEnd,
            polygonStart: function() {
                centroidStream.lineStart = centroidRingStart;
                centroidStream.lineEnd = centroidRingEnd;
            },
            polygonEnd: function() {
                centroidStream.point = centroidPoint;
                centroidStream.lineStart = centroidLineStart;
                centroidStream.lineEnd = centroidLineEnd;
            },
            result: function() {
                var centroid = Z2 ? [
                    X2 / Z2,
                    Y2 / Z2
                ] : Z1 ? [
                    X1 / Z1,
                    Y1 / Z1
                ] : Z0 ? [
                    X0 / Z0,
                    Y0 / Z0
                ] : [
                    NaN,
                    NaN
                ];
                X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
                return centroid;
            }
        };
        function centroidPoint(x, y) {
            X0 += x;
            Y0 += y;
            ++Z0;
        }
        function centroidLineStart() {
            centroidStream.point = centroidPointFirstLine;
        }
        function centroidPointFirstLine(x, y) {
            centroidStream.point = centroidPointLine;
            centroidPoint(x0$1 = x, y0$1 = y);
        }
        function centroidPointLine(x, y) {
            var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
            X1 += z * (x0$1 + x) / 2;
            Y1 += z * (y0$1 + y) / 2;
            Z1 += z;
            centroidPoint(x0$1 = x, y0$1 = y);
        }
        function centroidLineEnd() {
            centroidStream.point = centroidPoint;
        }
        function centroidRingStart() {
            centroidStream.point = centroidPointFirstRing;
        }
        function centroidRingEnd() {
            centroidPointRing(x00$1, y00$1);
        }
        function centroidPointFirstRing(x, y) {
            centroidStream.point = centroidPointRing;
            centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
        }
        function centroidPointRing(x, y) {
            var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
            X1 += z * (x0$1 + x) / 2;
            Y1 += z * (y0$1 + y) / 2;
            Z1 += z;
            z = y0$1 * x - x0$1 * y;
            X2 += z * (x0$1 + x);
            Y2 += z * (y0$1 + y);
            Z2 += z * 3;
            centroidPoint(x0$1 = x, y0$1 = y);
        }
        var pathCentroid = centroidStream;
        function PathContext(context) {
            this._context = context;
        }
        PathContext.prototype = {
            _radius: 4.5,
            pointRadius: function(_) {
                return this._radius = _, this;
            },
            polygonStart: function() {
                this._line = 0;
            },
            polygonEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._point = 0;
            },
            lineEnd: function() {
                if (this._line === 0) this._context.closePath();
                this._point = NaN;
            },
            point: function(x, y) {
                switch(this._point){
                    case 0:
                        this._context.moveTo(x, y);
                        this._point = 1;
                        break;
                    case 1:
                        this._context.lineTo(x, y);
                        break;
                    default:
                        this._context.moveTo(x + this._radius, y);
                        this._context.arc(x, y, this._radius, 0, tau$1);
                        break;
                }
            },
            result: noop$1
        };
        var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
        var lengthStream = {
            point: noop$1,
            lineStart: function() {
                lengthStream.point = lengthPointFirst;
            },
            lineEnd: function() {
                if (lengthRing) lengthPoint(x00, y00);
                lengthStream.point = noop$1;
            },
            polygonStart: function() {
                lengthRing = true;
            },
            polygonEnd: function() {
                lengthRing = null;
            },
            result: function() {
                var length = +lengthSum;
                lengthSum = new Adder();
                return length;
            }
        };
        function lengthPointFirst(x, y) {
            lengthStream.point = lengthPoint;
            x00 = x0 = x, y00 = y0 = y;
        }
        function lengthPoint(x, y) {
            x0 -= x, y0 -= y;
            lengthSum.add(sqrt$2(x0 * x0 + y0 * y0));
            x0 = x, y0 = y;
        }
        var pathMeasure = lengthStream;
        function PathString() {
            this._string = [];
        }
        PathString.prototype = {
            _radius: 4.5,
            _circle: circle$1(4.5),
            pointRadius: function(_) {
                if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
                return this;
            },
            polygonStart: function() {
                this._line = 0;
            },
            polygonEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._point = 0;
            },
            lineEnd: function() {
                if (this._line === 0) this._string.push("Z");
                this._point = NaN;
            },
            point: function(x, y) {
                switch(this._point){
                    case 0:
                        this._string.push("M", x, ",", y);
                        this._point = 1;
                        break;
                    case 1:
                        this._string.push("L", x, ",", y);
                        break;
                    default:
                        if (this._circle == null) this._circle = circle$1(this._radius);
                        this._string.push("M", x, ",", y, this._circle);
                        break;
                }
            },
            result: function() {
                if (this._string.length) {
                    var result = this._string.join("");
                    this._string = [];
                    return result;
                } else return null;
            }
        };
        function circle$1(radius) {
            return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
        }
        function index$2(projection, context) {
            var pointRadius = 4.5, projectionStream, contextStream;
            function path(object) {
                if (object) {
                    if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                    geoStream(object, projectionStream(contextStream));
                }
                return contextStream.result();
            }
            path.area = function(object) {
                geoStream(object, projectionStream(pathArea));
                return pathArea.result();
            };
            path.measure = function(object) {
                geoStream(object, projectionStream(pathMeasure));
                return pathMeasure.result();
            };
            path.bounds = function(object) {
                geoStream(object, projectionStream(boundsStream$1));
                return boundsStream$1.result();
            };
            path.centroid = function(object) {
                geoStream(object, projectionStream(pathCentroid));
                return pathCentroid.result();
            };
            path.projection = function(_) {
                return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$5) : (projection = _).stream, path) : projection;
            };
            path.context = function(_) {
                if (!arguments.length) return context;
                contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
                if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
                return path;
            };
            path.pointRadius = function(_) {
                if (!arguments.length) return pointRadius;
                pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
                return path;
            };
            return path.projection(projection).context(context);
        }
        function transform$1(methods) {
            return {
                stream: transformer$3(methods)
            };
        }
        function transformer$3(methods) {
            return function(stream) {
                var s = new TransformStream;
                for(var key in methods)s[key] = methods[key];
                s.stream = stream;
                return s;
            };
        }
        function TransformStream() {}
        TransformStream.prototype = {
            constructor: TransformStream,
            point: function(x, y) {
                this.stream.point(x, y);
            },
            sphere: function() {
                this.stream.sphere();
            },
            lineStart: function() {
                this.stream.lineStart();
            },
            lineEnd: function() {
                this.stream.lineEnd();
            },
            polygonStart: function() {
                this.stream.polygonStart();
            },
            polygonEnd: function() {
                this.stream.polygonEnd();
            }
        };
        function fit(projection, fitBounds, object) {
            var clip = projection.clipExtent && projection.clipExtent();
            projection.scale(150).translate([
                0,
                0
            ]);
            if (clip != null) projection.clipExtent(null);
            geoStream(object, projection.stream(boundsStream$1));
            fitBounds(boundsStream$1.result());
            if (clip != null) projection.clipExtent(clip);
            return projection;
        }
        function fitExtent(projection, extent, object) {
            return fit(projection, function(b) {
                var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
                projection.scale(150 * k).translate([
                    x,
                    y
                ]);
            }, object);
        }
        function fitSize(projection, size, object) {
            return fitExtent(projection, [
                [
                    0,
                    0
                ],
                size
            ], object);
        }
        function fitWidth(projection, width, object) {
            return fit(projection, function(b) {
                var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
                projection.scale(150 * k).translate([
                    x,
                    y
                ]);
            }, object);
        }
        function fitHeight(projection, height, object) {
            return fit(projection, function(b) {
                var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
                projection.scale(150 * k).translate([
                    x,
                    y
                ]);
            }, object);
        }
        var maxDepth = 16, cosMinDistance = cos$1(30 * radians);
        function resample(project, delta2) {
            return +delta2 ? resample$1(project, delta2) : resampleNone(project);
        }
        function resampleNone(project) {
            return transformer$3({
                point: function(x, y) {
                    x = project(x, y);
                    this.stream.point(x[0], x[1]);
                }
            });
        }
        function resample$1(project, delta2) {
            function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
                var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
                if (d2 > 4 * delta2 && depth--) {
                    var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = sqrt$2(a * a + b * b + c * c), phi2 = asin$1(c /= m), lambda2 = abs$1(abs$1(c) - 1) < epsilon$1 || abs$1(lambda0 - lambda1) < epsilon$1 ? (lambda0 + lambda1) / 2 : atan2$1(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                    if (dz * dz / d2 > delta2 || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                        stream.point(x2, y2);
                        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
                    }
                }
            }
            return function(stream) {
                var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0;
                var resampleStream = {
                    point: point,
                    lineStart: lineStart,
                    lineEnd: lineEnd,
                    polygonStart: function() {
                        stream.polygonStart();
                        resampleStream.lineStart = ringStart;
                    },
                    polygonEnd: function() {
                        stream.polygonEnd();
                        resampleStream.lineStart = lineStart;
                    }
                };
                function point(x, y) {
                    x = project(x, y);
                    stream.point(x[0], x[1]);
                }
                function lineStart() {
                    x0 = NaN;
                    resampleStream.point = linePoint;
                    stream.lineStart();
                }
                function linePoint(lambda, phi) {
                    var c = cartesian([
                        lambda,
                        phi
                    ]), p = project(lambda, phi);
                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                    stream.point(x0, y0);
                }
                function lineEnd() {
                    resampleStream.point = point;
                    stream.lineEnd();
                }
                function ringStart() {
                    lineStart();
                    resampleStream.point = ringPoint;
                    resampleStream.lineEnd = ringEnd;
                }
                function ringPoint(lambda, phi) {
                    linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                    resampleStream.point = linePoint;
                }
                function ringEnd() {
                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
                    resampleStream.lineEnd = lineEnd;
                    lineEnd();
                }
                return resampleStream;
            };
        }
        var transformRadians = transformer$3({
            point: function(x, y) {
                this.stream.point(x * radians, y * radians);
            }
        });
        function transformRotate(rotate) {
            return transformer$3({
                point: function(x, y) {
                    var r = rotate(x, y);
                    return this.stream.point(r[0], r[1]);
                }
            });
        }
        function scaleTranslate(k, dx, dy, sx, sy) {
            function transform(x, y) {
                x *= sx;
                y *= sy;
                return [
                    dx + k * x,
                    dy - k * y
                ];
            }
            transform.invert = function(x, y) {
                return [
                    (x - dx) / k * sx,
                    (dy - y) / k * sy
                ];
            };
            return transform;
        }
        function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
            if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
            var cosAlpha = cos$1(alpha), sinAlpha = sin$1(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
            function transform(x, y) {
                x *= sx;
                y *= sy;
                return [
                    a * x - b * y + dx,
                    dy - b * x - a * y
                ];
            }
            transform.invert = function(x, y) {
                return [
                    sx * (ai * x - bi * y + ci),
                    sy * (fi - bi * x - ai * y)
                ];
            };
            return transform;
        }
        function projection(project) {
            return projectionMutator(function() {
                return project;
            })();
        }
        function projectionMutator(projectAt) {
            var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x0 = null, y0, x1, y1, postclip = identity$5, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
            function projection(point) {
                return projectRotateTransform(point[0] * radians, point[1] * radians);
            }
            function invert(point) {
                point = projectRotateTransform.invert(point[0], point[1]);
                return point && [
                    point[0] * degrees,
                    point[1] * degrees
                ];
            }
            projection.stream = function(stream) {
                return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
            };
            projection.preclip = function(_) {
                return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
            };
            projection.postclip = function(_) {
                return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
            };
            projection.clipAngle = function(_) {
                return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
            };
            projection.clipExtent = function(_) {
                return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            };
            projection.scale = function(_) {
                return arguments.length ? (k = +_, recenter()) : k;
            };
            projection.translate = function(_) {
                return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
                    x,
                    y
                ];
            };
            projection.center = function(_) {
                return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [
                    lambda * degrees,
                    phi * degrees
                ];
            };
            projection.rotate = function(_) {
                return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [
                    deltaLambda * degrees,
                    deltaPhi * degrees,
                    deltaGamma * degrees
                ];
            };
            projection.angle = function(_) {
                return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
            };
            projection.reflectX = function(_) {
                return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
            };
            projection.reflectY = function(_) {
                return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
            };
            projection.precision = function(_) {
                return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$2(delta2);
            };
            projection.fitExtent = function(extent, object) {
                return fitExtent(projection, extent, object);
            };
            projection.fitSize = function(size, object) {
                return fitSize(projection, size, object);
            };
            projection.fitWidth = function(width, object) {
                return fitWidth(projection, width, object);
            };
            projection.fitHeight = function(height, object) {
                return fitHeight(projection, height, object);
            };
            function recenter() {
                var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
                rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
                projectTransform = compose(project, transform);
                projectRotateTransform = compose(rotate, projectTransform);
                projectResample = resample(projectTransform, delta2);
                return reset();
            }
            function reset() {
                cache = cacheStream = null;
                return projection;
            }
            return function() {
                project = projectAt.apply(this, arguments);
                projection.invert = project.invert && invert;
                return recenter();
            };
        }
        function conicProjection(projectAt) {
            var phi0 = 0, phi1 = pi$1 / 3, m = projectionMutator(projectAt), p = m(phi0, phi1);
            p.parallels = function(_) {
                return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [
                    phi0 * degrees,
                    phi1 * degrees
                ];
            };
            return p;
        }
        function cylindricalEqualAreaRaw(phi0) {
            var cosPhi0 = cos$1(phi0);
            function forward(lambda, phi) {
                return [
                    lambda * cosPhi0,
                    sin$1(phi) / cosPhi0
                ];
            }
            forward.invert = function(x, y) {
                return [
                    x / cosPhi0,
                    asin$1(y * cosPhi0)
                ];
            };
            return forward;
        }
        function conicEqualAreaRaw(y0, y1) {
            var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
            if (abs$1(n) < epsilon$1) return cylindricalEqualAreaRaw(y0);
            var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$2(c) / n;
            function project(x, y) {
                var r = sqrt$2(c - 2 * n * sin$1(y)) / n;
                return [
                    r * sin$1(x *= n),
                    r0 - r * cos$1(x)
                ];
            }
            project.invert = function(x, y) {
                var r0y = r0 - y, l = atan2$1(x, abs$1(r0y)) * sign$1(r0y);
                if (r0y * n < 0) l -= pi$1 * sign$1(x) * sign$1(r0y);
                return [
                    l / n,
                    asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))
                ];
            };
            return project;
        }
        function conicEqualArea() {
            return conicProjection(conicEqualAreaRaw).scale(155.424).center([
                0,
                33.6442
            ]);
        }
        function albers() {
            return conicEqualArea().parallels([
                29.5,
                45.5
            ]).scale(1070).translate([
                480,
                250
            ]).rotate([
                96,
                0
            ]).center([
                -0.6,
                38.7
            ]);
        }
        function multiplex(streams) {
            var n = streams.length;
            return {
                point: function(x, y) {
                    var i = -1;
                    while(++i < n)streams[i].point(x, y);
                },
                sphere: function() {
                    var i = -1;
                    while(++i < n)streams[i].sphere();
                },
                lineStart: function() {
                    var i = -1;
                    while(++i < n)streams[i].lineStart();
                },
                lineEnd: function() {
                    var i = -1;
                    while(++i < n)streams[i].lineEnd();
                },
                polygonStart: function() {
                    var i = -1;
                    while(++i < n)streams[i].polygonStart();
                },
                polygonEnd: function() {
                    var i = -1;
                    while(++i < n)streams[i].polygonEnd();
                }
            };
        }
        function albersUsa() {
            var cache, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([
                154,
                0
            ]).center([
                -2,
                58.5
            ]).parallels([
                55,
                65
            ]), alaskaPoint, hawaii = conicEqualArea().rotate([
                157,
                0
            ]).center([
                -3,
                19.9
            ]).parallels([
                8,
                18
            ]), hawaiiPoint, point, pointStream = {
                point: function(x, y) {
                    point = [
                        x,
                        y
                    ];
                }
            };
            function albersUsa(coordinates) {
                var x = coordinates[0], y = coordinates[1];
                return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
            }
            albersUsa.invert = function(coordinates) {
                var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
                return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
            };
            albersUsa.stream = function(stream) {
                return cache && cacheStream === stream ? cache : cache = multiplex([
                    lower48.stream(cacheStream = stream),
                    alaska.stream(stream),
                    hawaii.stream(stream)
                ]);
            };
            albersUsa.precision = function(_) {
                if (!arguments.length) return lower48.precision();
                lower48.precision(_), alaska.precision(_), hawaii.precision(_);
                return reset();
            };
            albersUsa.scale = function(_) {
                if (!arguments.length) return lower48.scale();
                lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
                return albersUsa.translate(lower48.translate());
            };
            albersUsa.translate = function(_) {
                if (!arguments.length) return lower48.translate();
                var k = lower48.scale(), x = +_[0], y = +_[1];
                lower48Point = lower48.translate(_).clipExtent([
                    [
                        x - 0.455 * k,
                        y - 0.238 * k
                    ],
                    [
                        x + 0.455 * k,
                        y + 0.238 * k
                    ]
                ]).stream(pointStream);
                alaskaPoint = alaska.translate([
                    x - 0.307 * k,
                    y + 0.201 * k
                ]).clipExtent([
                    [
                        x - 0.425 * k + epsilon$1,
                        y + 0.120 * k + epsilon$1
                    ],
                    [
                        x - 0.214 * k - epsilon$1,
                        y + 0.234 * k - epsilon$1
                    ]
                ]).stream(pointStream);
                hawaiiPoint = hawaii.translate([
                    x - 0.205 * k,
                    y + 0.212 * k
                ]).clipExtent([
                    [
                        x - 0.214 * k + epsilon$1,
                        y + 0.166 * k + epsilon$1
                    ],
                    [
                        x - 0.115 * k - epsilon$1,
                        y + 0.234 * k - epsilon$1
                    ]
                ]).stream(pointStream);
                return reset();
            };
            albersUsa.fitExtent = function(extent, object) {
                return fitExtent(albersUsa, extent, object);
            };
            albersUsa.fitSize = function(size, object) {
                return fitSize(albersUsa, size, object);
            };
            albersUsa.fitWidth = function(width, object) {
                return fitWidth(albersUsa, width, object);
            };
            albersUsa.fitHeight = function(height, object) {
                return fitHeight(albersUsa, height, object);
            };
            function reset() {
                cache = cacheStream = null;
                return albersUsa;
            }
            return albersUsa.scale(1070);
        }
        function azimuthalRaw(scale) {
            return function(x, y) {
                var cx = cos$1(x), cy = cos$1(y), k = scale(cx * cy);
                if (k === Infinity) return [
                    2,
                    0
                ];
                return [
                    k * cy * sin$1(x),
                    k * sin$1(y)
                ];
            };
        }
        function azimuthalInvert(angle) {
            return function(x, y) {
                var z = sqrt$2(x * x + y * y), c = angle(z), sc = sin$1(c), cc = cos$1(c);
                return [
                    atan2$1(x * sc, z * cc),
                    asin$1(z && y * sc / z)
                ];
            };
        }
        var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
            return sqrt$2(2 / (1 + cxcy));
        });
        azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
            return 2 * asin$1(z / 2);
        });
        function azimuthalEqualArea() {
            return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
        }
        var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
            return (c = acos$1(c)) && c / sin$1(c);
        });
        azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
            return z;
        });
        function azimuthalEquidistant() {
            return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
        }
        function mercatorRaw(lambda, phi) {
            return [
                lambda,
                log$1(tan((halfPi$1 + phi) / 2))
            ];
        }
        mercatorRaw.invert = function(x, y) {
            return [
                x,
                2 * atan(exp(y)) - halfPi$1
            ];
        };
        function mercator() {
            return mercatorProjection(mercatorRaw).scale(961 / tau$1);
        }
        function mercatorProjection(project) {
            var m = projection(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1;
            m.scale = function(_) {
                return arguments.length ? (scale(_), reclip()) : scale();
            };
            m.translate = function(_) {
                return arguments.length ? (translate(_), reclip()) : translate();
            };
            m.center = function(_) {
                return arguments.length ? (center(_), reclip()) : center();
            };
            m.clipExtent = function(_) {
                return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            };
            function reclip() {
                var k = pi$1 * scale(), t = m(rotation(m.rotate()).invert([
                    0,
                    0
                ]));
                return clipExtent(x0 == null ? [
                    [
                        t[0] - k,
                        t[1] - k
                    ],
                    [
                        t[0] + k,
                        t[1] + k
                    ]
                ] : project === mercatorRaw ? [
                    [
                        Math.max(t[0] - k, x0),
                        y0
                    ],
                    [
                        Math.min(t[0] + k, x1),
                        y1
                    ]
                ] : [
                    [
                        x0,
                        Math.max(t[1] - k, y0)
                    ],
                    [
                        x1,
                        Math.min(t[1] + k, y1)
                    ]
                ]);
            }
            return reclip();
        }
        function tany(y) {
            return tan((halfPi$1 + y) / 2);
        }
        function conicConformalRaw(y0, y1) {
            var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)), f = cy0 * pow$1(tany(y0), n) / n;
            if (!n) return mercatorRaw;
            function project(x, y) {
                if (f > 0) {
                    if (y < -halfPi$1 + epsilon$1) y = -halfPi$1 + epsilon$1;
                } else if (y > halfPi$1 - epsilon$1) y = halfPi$1 - epsilon$1;
                var r = f / pow$1(tany(y), n);
                return [
                    r * sin$1(n * x),
                    f - r * cos$1(n * x)
                ];
            }
            project.invert = function(x, y) {
                var fy = f - y, r = sign$1(n) * sqrt$2(x * x + fy * fy), l = atan2$1(x, abs$1(fy)) * sign$1(fy);
                if (fy * n < 0) l -= pi$1 * sign$1(x) * sign$1(fy);
                return [
                    l / n,
                    2 * atan(pow$1(f / r, 1 / n)) - halfPi$1
                ];
            };
            return project;
        }
        function conicConformal() {
            return conicProjection(conicConformalRaw).scale(109.5).parallels([
                30,
                30
            ]);
        }
        function equirectangularRaw(lambda, phi) {
            return [
                lambda,
                phi
            ];
        }
        equirectangularRaw.invert = equirectangularRaw;
        function equirectangular() {
            return projection(equirectangularRaw).scale(152.63);
        }
        function conicEquidistantRaw(y0, y1) {
            var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0), g = cy0 / n + y0;
            if (abs$1(n) < epsilon$1) return equirectangularRaw;
            function project(x, y) {
                var gy = g - y, nx = n * x;
                return [
                    gy * sin$1(nx),
                    g - gy * cos$1(nx)
                ];
            }
            project.invert = function(x, y) {
                var gy = g - y, l = atan2$1(x, abs$1(gy)) * sign$1(gy);
                if (gy * n < 0) l -= pi$1 * sign$1(x) * sign$1(gy);
                return [
                    l / n,
                    g - sign$1(n) * sqrt$2(x * x + gy * gy)
                ];
            };
            return project;
        }
        function conicEquidistant() {
            return conicProjection(conicEquidistantRaw).scale(131.154).center([
                0,
                13.9389
            ]);
        }
        var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = sqrt$2(3) / 2, iterations = 12;
        function equalEarthRaw(lambda, phi) {
            var l = asin$1(M * sin$1(phi)), l2 = l * l, l6 = l2 * l2 * l2;
            return [
                lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
                l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
            ];
        }
        equalEarthRaw.invert = function(x, y) {
            var l = y, l2 = l * l, l6 = l2 * l2 * l2;
            for(var i = 0, delta, fy, fpy; i < iterations; ++i){
                fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
                fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
                l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
                if (abs$1(delta) < epsilon2) break;
            }
            return [
                M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l),
                asin$1(sin$1(l) / M)
            ];
        };
        function equalEarth() {
            return projection(equalEarthRaw).scale(177.158);
        }
        function gnomonicRaw(x, y) {
            var cy = cos$1(y), k = cos$1(x) * cy;
            return [
                cy * sin$1(x) / k,
                sin$1(y) / k
            ];
        }
        gnomonicRaw.invert = azimuthalInvert(atan);
        function gnomonic() {
            return projection(gnomonicRaw).scale(144.049).clipAngle(60);
        }
        function identity$4() {
            var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = transformer$3({
                point: function(x, y) {
                    var p = projection([
                        x,
                        y
                    ]);
                    this.stream.point(p[0], p[1]);
                }
            }), postclip = identity$5, cache, cacheStream;
            function reset() {
                kx = k * sx;
                ky = k * sy;
                cache = cacheStream = null;
                return projection;
            }
            function projection(p) {
                var x = p[0] * kx, y = p[1] * ky;
                if (alpha) {
                    var t = y * ca - x * sa;
                    x = x * ca + y * sa;
                    y = t;
                }
                return [
                    x + tx,
                    y + ty
                ];
            }
            projection.invert = function(p) {
                var x = p[0] - tx, y = p[1] - ty;
                if (alpha) {
                    var t = y * ca + x * sa;
                    x = x * ca - y * sa;
                    y = t;
                }
                return [
                    x / kx,
                    y / ky
                ];
            };
            projection.stream = function(stream) {
                return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
            };
            projection.postclip = function(_) {
                return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
            };
            projection.clipExtent = function(_) {
                return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            };
            projection.scale = function(_) {
                return arguments.length ? (k = +_, reset()) : k;
            };
            projection.translate = function(_) {
                return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                    tx,
                    ty
                ];
            };
            projection.angle = function(_) {
                return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
            };
            projection.reflectX = function(_) {
                return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
            };
            projection.reflectY = function(_) {
                return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
            };
            projection.fitExtent = function(extent, object) {
                return fitExtent(projection, extent, object);
            };
            projection.fitSize = function(size, object) {
                return fitSize(projection, size, object);
            };
            projection.fitWidth = function(width, object) {
                return fitWidth(projection, width, object);
            };
            projection.fitHeight = function(height, object) {
                return fitHeight(projection, height, object);
            };
            return projection;
        }
        function naturalEarth1Raw(lambda, phi) {
            var phi2 = phi * phi, phi4 = phi2 * phi2;
            return [
                lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
                phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
            ];
        }
        naturalEarth1Raw.invert = function(x, y) {
            var phi = y, i = 25, delta;
            do {
                var phi2 = phi * phi, phi4 = phi2 * phi2;
                phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
            }while (abs$1(delta) > epsilon$1 && --i > 0)
            return [
                x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
                phi
            ];
        };
        function naturalEarth1() {
            return projection(naturalEarth1Raw).scale(175.295);
        }
        function orthographicRaw(x, y) {
            return [
                cos$1(y) * sin$1(x),
                sin$1(y)
            ];
        }
        orthographicRaw.invert = azimuthalInvert(asin$1);
        function orthographic() {
            return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$1);
        }
        function stereographicRaw(x, y) {
            var cy = cos$1(y), k = 1 + cos$1(x) * cy;
            return [
                cy * sin$1(x) / k,
                sin$1(y) / k
            ];
        }
        stereographicRaw.invert = azimuthalInvert(function(z) {
            return 2 * atan(z);
        });
        function stereographic() {
            return projection(stereographicRaw).scale(250).clipAngle(142);
        }
        function transverseMercatorRaw(lambda, phi) {
            return [
                log$1(tan((halfPi$1 + phi) / 2)),
                -lambda
            ];
        }
        transverseMercatorRaw.invert = function(x, y) {
            return [
                -y,
                2 * atan(exp(x)) - halfPi$1
            ];
        };
        function transverseMercator() {
            var m = mercatorProjection(transverseMercatorRaw), center = m.center, rotate = m.rotate;
            m.center = function(_) {
                return arguments.length ? center([
                    -_[1],
                    _[0]
                ]) : (_ = center(), [
                    _[1],
                    -_[0]
                ]);
            };
            m.rotate = function(_) {
                return arguments.length ? rotate([
                    _[0],
                    _[1],
                    _.length > 2 ? _[2] + 90 : 90
                ]) : (_ = rotate(), [
                    _[0],
                    _[1],
                    _[2] - 90
                ]);
            };
            return rotate([
                0,
                0,
                90
            ]).scale(159.155);
        }
        function defaultSeparation$1(a, b) {
            return a.parent === b.parent ? 1 : 2;
        }
        function meanX(children) {
            return children.reduce(meanXReduce, 0) / children.length;
        }
        function meanXReduce(x, c) {
            return x + c.x;
        }
        function maxY(children) {
            return 1 + children.reduce(maxYReduce, 0);
        }
        function maxYReduce(y, c) {
            return Math.max(y, c.y);
        }
        function leafLeft(node) {
            var children;
            while(children = node.children)node = children[0];
            return node;
        }
        function leafRight(node) {
            var children;
            while(children = node.children)node = children[children.length - 1];
            return node;
        }
        function cluster() {
            var separation = defaultSeparation$1, dx = 1, dy = 1, nodeSize = false;
            function cluster(root) {
                var previousNode, x = 0;
                root.eachAfter(function(node) {
                    var children = node.children;
                    if (children) {
                        node.x = meanX(children);
                        node.y = maxY(children);
                    } else {
                        node.x = previousNode ? x += separation(node, previousNode) : 0;
                        node.y = 0;
                        previousNode = node;
                    }
                });
                var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
                return root.eachAfter(nodeSize ? function(node) {
                    node.x = (node.x - root.x) * dx;
                    node.y = (root.y - node.y) * dy;
                } : function(node) {
                    node.x = (node.x - x0) / (x1 - x0) * dx;
                    node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
                });
            }
            cluster.separation = function(x) {
                return arguments.length ? (separation = x, cluster) : separation;
            };
            cluster.size = function(x) {
                return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                    dx,
                    dy
                ];
            };
            cluster.nodeSize = function(x) {
                return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                    dx,
                    dy
                ] : null;
            };
            return cluster;
        }
        function count(node) {
            var sum = 0, children = node.children, i = children && children.length;
            if (!i) sum = 1;
            else while(--i >= 0)sum += children[i].value;
            node.value = sum;
        }
        function node_count() {
            return this.eachAfter(count);
        }
        function node_each(callback, that) {
            let index = -1;
            for (const node of this)callback.call(that, node, ++index, this);
            return this;
        }
        function node_eachBefore(callback, that) {
            var node = this, nodes = [
                node
            ], children, i, index = -1;
            while(node = nodes.pop()){
                callback.call(that, node, ++index, this);
                if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
            }
            return this;
        }
        function node_eachAfter(callback, that) {
            var node = this, nodes = [
                node
            ], next = [], children, i, n, index = -1;
            while(node = nodes.pop()){
                next.push(node);
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
            }
            while(node = next.pop())callback.call(that, node, ++index, this);
            return this;
        }
        function node_find(callback, that) {
            let index = -1;
            for (const node of this){
                if (callback.call(that, node, ++index, this)) return node;
            }
        }
        function node_sum(value) {
            return this.eachAfter(function(node) {
                var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
                while(--i >= 0)sum += children[i].value;
                node.value = sum;
            });
        }
        function node_sort(compare) {
            return this.eachBefore(function(node) {
                if (node.children) node.children.sort(compare);
            });
        }
        function node_path(end) {
            var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
                start
            ];
            while(start !== ancestor){
                start = start.parent;
                nodes.push(start);
            }
            var k = nodes.length;
            while(end !== ancestor){
                nodes.splice(k, 0, end);
                end = end.parent;
            }
            return nodes;
        }
        function leastCommonAncestor(a, b) {
            if (a === b) return a;
            var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
            a = aNodes.pop();
            b = bNodes.pop();
            while(a === b){
                c = a;
                a = aNodes.pop();
                b = bNodes.pop();
            }
            return c;
        }
        function node_ancestors() {
            var node = this, nodes = [
                node
            ];
            while(node = node.parent)nodes.push(node);
            return nodes;
        }
        function node_descendants() {
            return Array.from(this);
        }
        function node_leaves() {
            var leaves = [];
            this.eachBefore(function(node) {
                if (!node.children) leaves.push(node);
            });
            return leaves;
        }
        function node_links() {
            var root = this, links = [];
            root.each(function(node) {
                if (node !== root) links.push({
                    source: node.parent,
                    target: node
                });
            });
            return links;
        }
        function* node_iterator() {
            var node = this, current, next = [
                node
            ], children, i, n;
            do {
                current = next.reverse(), next = [];
                while(node = current.pop()){
                    yield node;
                    if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
                }
            }while (next.length)
        }
        function hierarchy(data, children) {
            if (data instanceof Map) {
                data = [
                    undefined,
                    data
                ];
                if (children === undefined) children = mapChildren;
            } else if (children === undefined) children = objectChildren;
            var root = new Node$1(data), node, nodes = [
                root
            ], child, childs, i, n;
            while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
                node.children = childs;
                for(i = n - 1; i >= 0; --i){
                    nodes.push(child = childs[i] = new Node$1(childs[i]));
                    child.parent = node;
                    child.depth = node.depth + 1;
                }
            }
            return root.eachBefore(computeHeight);
        }
        function node_copy() {
            return hierarchy(this).eachBefore(copyData);
        }
        function objectChildren(d) {
            return d.children;
        }
        function mapChildren(d) {
            return Array.isArray(d) ? d[1] : null;
        }
        function copyData(node) {
            if (node.data.value !== undefined) node.value = node.data.value;
            node.data = node.data.data;
        }
        function computeHeight(node) {
            var height = 0;
            do node.height = height;
            while ((node = node.parent) && node.height < ++height)
        }
        function Node$1(data) {
            this.data = data;
            this.depth = this.height = 0;
            this.parent = null;
        }
        Node$1.prototype = hierarchy.prototype = {
            constructor: Node$1,
            count: node_count,
            each: node_each,
            eachAfter: node_eachAfter,
            eachBefore: node_eachBefore,
            find: node_find,
            sum: node_sum,
            sort: node_sort,
            path: node_path,
            ancestors: node_ancestors,
            descendants: node_descendants,
            leaves: node_leaves,
            links: node_links,
            copy: node_copy,
            [Symbol.iterator]: node_iterator
        };
        function optional(f) {
            return f == null ? null : required(f);
        }
        function required(f) {
            if (typeof f !== "function") throw new Error;
            return f;
        }
        function constantZero() {
            return 0;
        }
        function constant$2(x) {
            return function() {
                return x;
            };
        }
        const a$1 = 1664525;
        const c$3 = 1013904223;
        const m = 4294967296;
        function lcg$1() {
            let s = 1;
            return ()=>(s = (a$1 * s + c$3) % m) / m;
        }
        function array$1(x) {
            return typeof x === "object" && "length" in x ? x : Array.from(x);
        }
        function shuffle(array, random) {
            let m = array.length, t, i;
            while(m){
                i = random() * m-- | 0;
                t = array[m];
                array[m] = array[i];
                array[i] = t;
            }
            return array;
        }
        function enclose(circles) {
            return packEncloseRandom(circles, lcg$1());
        }
        function packEncloseRandom(circles, random) {
            var i = 0, n = (circles = shuffle(Array.from(circles), random)).length, B = [], p, e;
            while(i < n){
                p = circles[i];
                if (e && enclosesWeak(e, p)) ++i;
                else e = encloseBasis(B = extendBasis(B, p)), i = 0;
            }
            return e;
        }
        function extendBasis(B, p) {
            var i, j;
            if (enclosesWeakAll(p, B)) return [
                p
            ];
            for(i = 0; i < B.length; ++i){
                if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
                    B[i],
                    p
                ];
            }
            for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
                if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
                    B[i],
                    B[j],
                    p
                ];
            }
            throw new Error;
        }
        function enclosesNot(a, b) {
            var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
            return dr < 0 || dr * dr < dx * dx + dy * dy;
        }
        function enclosesWeak(a, b) {
            var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
            return dr > 0 && dr * dr > dx * dx + dy * dy;
        }
        function enclosesWeakAll(a, B) {
            for(var i = 0; i < B.length; ++i){
                if (!enclosesWeak(a, B[i])) return false;
            }
            return true;
        }
        function encloseBasis(B) {
            switch(B.length){
                case 1:
                    return encloseBasis1(B[0]);
                case 2:
                    return encloseBasis2(B[0], B[1]);
                case 3:
                    return encloseBasis3(B[0], B[1], B[2]);
            }
        }
        function encloseBasis1(a) {
            return {
                x: a.x,
                y: a.y,
                r: a.r
            };
        }
        function encloseBasis2(a, b) {
            var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
            return {
                x: (x1 + x2 + x21 / l * r21) / 2,
                y: (y1 + y2 + y21 / l * r21) / 2,
                r: (l + r1 + r2) / 2
            };
        }
        function encloseBasis3(a, b, c) {
            var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
            return {
                x: x1 + xa + xb * r,
                y: y1 + ya + yb * r,
                r: r
            };
        }
        function place(b, a, c) {
            var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
            if (d2) {
                a2 = a.r + c.r, a2 *= a2;
                b2 = b.r + c.r, b2 *= b2;
                if (a2 > b2) {
                    x = (d2 + b2 - a2) / (2 * d2);
                    y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
                    c.x = b.x - x * dx - y * dy;
                    c.y = b.y - x * dy + y * dx;
                } else {
                    x = (d2 + a2 - b2) / (2 * d2);
                    y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
                    c.x = a.x + x * dx - y * dy;
                    c.y = a.y + x * dy + y * dx;
                }
            } else {
                c.x = a.x + c.r;
                c.y = a.y;
            }
        }
        function intersects(a, b) {
            var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
            return dr > 0 && dr * dr > dx * dx + dy * dy;
        }
        function score(node) {
            var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
            return dx * dx + dy * dy;
        }
        function Node(circle) {
            this._ = circle;
            this.next = null;
            this.previous = null;
        }
        function packSiblingsRandom(circles, random) {
            if (!(n = (circles = array$1(circles)).length)) return 0;
            var a, b, c, n, aa, ca, i, j, k, sj, sk;
            a = circles[0], a.x = 0, a.y = 0;
            if (!(n > 1)) return a.r;
            b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
            if (!(n > 2)) return a.r + b.r;
            place(b, a, c = circles[2]);
            a = new Node(a), b = new Node(b), c = new Node(c);
            a.next = c.previous = b;
            b.next = a.previous = c;
            c.next = b.previous = a;
            pack: for(i = 3; i < n; ++i){
                place(a._, b._, c = circles[i]), c = new Node(c);
                j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
                do if (sj <= sk) {
                    if (intersects(j._, c._)) {
                        b = j, a.next = b, b.previous = a, --i;
                        continue pack;
                    }
                    sj += j._.r, j = j.next;
                } else {
                    if (intersects(k._, c._)) {
                        a = k, a.next = b, b.previous = a, --i;
                        continue pack;
                    }
                    sk += k._.r, k = k.previous;
                }
                while (j !== k.next)
                c.previous = a, c.next = b, a.next = b.previous = b = c;
                aa = score(a);
                while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
                b = a.next;
            }
            a = [
                b._
            ], c = b;
            while((c = c.next) !== b)a.push(c._);
            c = packEncloseRandom(a, random);
            for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
            return c.r;
        }
        function siblings(circles) {
            packSiblingsRandom(circles, lcg$1());
            return circles;
        }
        function defaultRadius(d) {
            return Math.sqrt(d.value);
        }
        function index$1() {
            var radius = null, dx = 1, dy = 1, padding = constantZero;
            function pack(root) {
                const random = lcg$1();
                root.x = dx / 2, root.y = dy / 2;
                if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
                else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
                return root;
            }
            pack.radius = function(x) {
                return arguments.length ? (radius = optional(x), pack) : radius;
            };
            pack.size = function(x) {
                return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                    dx,
                    dy
                ];
            };
            pack.padding = function(x) {
                return arguments.length ? (padding = typeof x === "function" ? x : constant$2(+x), pack) : padding;
            };
            return pack;
        }
        function radiusLeaf(radius) {
            return function(node) {
                if (!node.children) node.r = Math.max(0, +radius(node) || 0);
            };
        }
        function packChildrenRandom(padding, k, random) {
            return function(node) {
                if (children = node.children) {
                    var children, i, n = children.length, r = padding(node) * k || 0, e;
                    if (r) for(i = 0; i < n; ++i)children[i].r += r;
                    e = packSiblingsRandom(children, random);
                    if (r) for(i = 0; i < n; ++i)children[i].r -= r;
                    node.r = e + r;
                }
            };
        }
        function translateChild(k) {
            return function(node) {
                var parent = node.parent;
                node.r *= k;
                if (parent) {
                    node.x = parent.x + k * node.x;
                    node.y = parent.y + k * node.y;
                }
            };
        }
        function roundNode(node) {
            node.x0 = Math.round(node.x0);
            node.y0 = Math.round(node.y0);
            node.x1 = Math.round(node.x1);
            node.y1 = Math.round(node.y1);
        }
        function treemapDice(parent, x0, y0, x1, y1) {
            var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
            while(++i < n){
                node = nodes[i], node.y0 = y0, node.y1 = y1;
                node.x0 = x0, node.x1 = x0 += node.value * k;
            }
        }
        function partition() {
            var dx = 1, dy = 1, padding = 0, round = false;
            function partition(root) {
                var n = root.height + 1;
                root.x0 = root.y0 = padding;
                root.x1 = dx;
                root.y1 = dy / n;
                root.eachBefore(positionNode(dy, n));
                if (round) root.eachBefore(roundNode);
                return root;
            }
            function positionNode(dy, n) {
                return function(node) {
                    if (node.children) treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                    var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                    node.x0 = x0;
                    node.y0 = y0;
                    node.x1 = x1;
                    node.y1 = y1;
                };
            }
            partition.round = function(x) {
                return arguments.length ? (round = !!x, partition) : round;
            };
            partition.size = function(x) {
                return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                    dx,
                    dy
                ];
            };
            partition.padding = function(x) {
                return arguments.length ? (padding = +x, partition) : padding;
            };
            return partition;
        }
        var preroot = {
            depth: -1
        }, ambiguous = {}, imputed = {};
        function defaultId(d) {
            return d.id;
        }
        function defaultParentId(d) {
            return d.parentId;
        }
        function stratify() {
            var id = defaultId, parentId = defaultParentId, path;
            function stratify(data) {
                var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
                if (path != null) {
                    const I = nodes.map((d, i)=>normalize$1(path(d, i, data)));
                    const P = I.map(parentof);
                    const S = new Set(I).add("");
                    for (const i of P)if (!S.has(i)) {
                        S.add(i);
                        I.push(i);
                        P.push(parentof(i));
                        nodes.push(imputed);
                    }
                    currentId = (_, i)=>I[i];
                    currentParentId = (_, i)=>P[i];
                }
                for(i = 0, n = nodes.length; i < n; ++i){
                    d = nodes[i], node = nodes[i] = new Node$1(d);
                    if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                        nodeKey = node.id = nodeId;
                        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                    }
                    if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
                }
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (nodeId = node.parent) {
                        parent = nodeByKey.get(nodeId);
                        if (!parent) throw new Error("missing: " + nodeId);
                        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                        if (parent.children) parent.children.push(node);
                        else parent.children = [
                            node
                        ];
                        node.parent = parent;
                    } else {
                        if (root) throw new Error("multiple roots");
                        root = node;
                    }
                }
                if (!root) throw new Error("no root");
                if (path != null) {
                    while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                    for(let i = nodes.length - 1; i >= 0; --i){
                        node = nodes[i];
                        if (node.data !== imputed) break;
                        node.data = null;
                    }
                }
                root.parent = preroot;
                root.eachBefore(function(node) {
                    node.depth = node.parent.depth + 1;
                    --n;
                }).eachBefore(computeHeight);
                root.parent = null;
                if (n > 0) throw new Error("cycle");
                return root;
            }
            stratify.id = function(x) {
                return arguments.length ? (id = optional(x), stratify) : id;
            };
            stratify.parentId = function(x) {
                return arguments.length ? (parentId = optional(x), stratify) : parentId;
            };
            stratify.path = function(x) {
                return arguments.length ? (path = optional(x), stratify) : path;
            };
            return stratify;
        }
        function normalize$1(path) {
            path = `${path}`;
            let i = path.length;
            if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
            return path[0] === "/" ? path : `/${path}`;
        }
        function parentof(path) {
            let i = path.length;
            if (i < 2) return "";
            while(--i > 1)if (slash(path, i)) break;
            return path.slice(0, i);
        }
        function slash(path, i) {
            if (path[i] === "/") {
                let k = 0;
                while(i > 0 && path[--i] === "\\")++k;
                if ((k & 1) === 0) return true;
            }
            return false;
        }
        function defaultSeparation(a, b) {
            return a.parent === b.parent ? 1 : 2;
        }
        function nextLeft(v) {
            var children = v.children;
            return children ? children[0] : v.t;
        }
        function nextRight(v) {
            var children = v.children;
            return children ? children[children.length - 1] : v.t;
        }
        function moveSubtree(wm, wp, shift) {
            var change = shift / (wp.i - wm.i);
            wp.c -= change;
            wp.s += shift;
            wm.c += change;
            wp.z += shift;
            wp.m += shift;
        }
        function executeShifts(v) {
            var shift = 0, change = 0, children = v.children, i = children.length, w;
            while(--i >= 0){
                w = children[i];
                w.z += shift;
                w.m += shift;
                shift += w.s + (change += w.c);
            }
        }
        function nextAncestor(vim, v, ancestor) {
            return vim.a.parent === v.parent ? vim.a : ancestor;
        }
        function TreeNode(node, i) {
            this._ = node;
            this.parent = null;
            this.children = null;
            this.A = null;
            this.a = this;
            this.z = 0;
            this.m = 0;
            this.c = 0;
            this.s = 0;
            this.t = null;
            this.i = i;
        }
        TreeNode.prototype = Object.create(Node$1.prototype);
        function treeRoot(root) {
            var tree = new TreeNode(root, 0), node, nodes = [
                tree
            ], child, children, i, n;
            while(node = nodes.pop())if (children = node._.children) {
                node.children = new Array(n = children.length);
                for(i = n - 1; i >= 0; --i){
                    nodes.push(child = node.children[i] = new TreeNode(children[i], i));
                    child.parent = node;
                }
            }
            (tree.parent = new TreeNode(null, 0)).children = [
                tree
            ];
            return tree;
        }
        function tree() {
            var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
            function tree(root) {
                var t = treeRoot(root);
                t.eachAfter(firstWalk), t.parent.m = -t.z;
                t.eachBefore(secondWalk);
                if (nodeSize) root.eachBefore(sizeNode);
                else {
                    var left = root, right = root, bottom = root;
                    root.eachBefore(function(node) {
                        if (node.x < left.x) left = node;
                        if (node.x > right.x) right = node;
                        if (node.depth > bottom.depth) bottom = node;
                    });
                    var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                    root.eachBefore(function(node) {
                        node.x = (node.x + tx) * kx;
                        node.y = node.depth * ky;
                    });
                }
                return root;
            }
            function firstWalk(v) {
                var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
                if (children) {
                    executeShifts(v);
                    var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                    if (w) {
                        v.z = w.z + separation(v._, w._);
                        v.m = v.z - midpoint;
                    } else v.z = midpoint;
                } else if (w) v.z = w.z + separation(v._, w._);
                v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
            }
            function secondWalk(v) {
                v._.x = v.z + v.parent.m;
                v.m += v.parent.m;
            }
            function apportion(v, w, ancestor) {
                if (w) {
                    var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                    while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                        vom = nextLeft(vom);
                        vop = nextRight(vop);
                        vop.a = v;
                        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                        if (shift > 0) {
                            moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                            sip += shift;
                            sop += shift;
                        }
                        sim += vim.m;
                        sip += vip.m;
                        som += vom.m;
                        sop += vop.m;
                    }
                    if (vim && !nextRight(vop)) {
                        vop.t = vim;
                        vop.m += sim - sop;
                    }
                    if (vip && !nextLeft(vom)) {
                        vom.t = vip;
                        vom.m += sip - som;
                        ancestor = v;
                    }
                }
                return ancestor;
            }
            function sizeNode(node) {
                node.x *= dx;
                node.y = node.depth * dy;
            }
            tree.separation = function(x) {
                return arguments.length ? (separation = x, tree) : separation;
            };
            tree.size = function(x) {
                return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                    dx,
                    dy
                ];
            };
            tree.nodeSize = function(x) {
                return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                    dx,
                    dy
                ] : null;
            };
            return tree;
        }
        function treemapSlice(parent, x0, y0, x1, y1) {
            var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
            while(++i < n){
                node = nodes[i], node.x0 = x0, node.x1 = x1;
                node.y0 = y0, node.y1 = y0 += node.value * k;
            }
        }
        var phi = (1 + Math.sqrt(5)) / 2;
        function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
            var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
            while(i0 < n){
                dx = x1 - x0, dy = y1 - y0;
                do sumValue = nodes[i1++].value;
                while (!sumValue && i1 < n)
                minValue = maxValue = sumValue;
                alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
                beta = sumValue * sumValue * alpha;
                minRatio = Math.max(maxValue / beta, beta / minValue);
                for(; i1 < n; ++i1){
                    sumValue += nodeValue = nodes[i1].value;
                    if (nodeValue < minValue) minValue = nodeValue;
                    if (nodeValue > maxValue) maxValue = nodeValue;
                    beta = sumValue * sumValue * alpha;
                    newRatio = Math.max(maxValue / beta, beta / minValue);
                    if (newRatio > minRatio) {
                        sumValue -= nodeValue;
                        break;
                    }
                    minRatio = newRatio;
                }
                rows.push(row = {
                    value: sumValue,
                    dice: dx < dy,
                    children: nodes.slice(i0, i1)
                });
                if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
                else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
                value -= sumValue, i0 = i1;
            }
            return rows;
        }
        var squarify = function custom(ratio) {
            function squarify(parent, x0, y0, x1, y1) {
                squarifyRatio(ratio, parent, x0, y0, x1, y1);
            }
            squarify.ratio = function(x) {
                return custom((x = +x) > 1 ? x : 1);
            };
            return squarify;
        }(phi);
        function index() {
            var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [
                0
            ], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
            function treemap(root) {
                root.x0 = root.y0 = 0;
                root.x1 = dx;
                root.y1 = dy;
                root.eachBefore(positionNode);
                paddingStack = [
                    0
                ];
                if (round) root.eachBefore(roundNode);
                return root;
            }
            function positionNode(node) {
                var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
                if (node.children) {
                    p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                    x0 += paddingLeft(node) - p;
                    y0 += paddingTop(node) - p;
                    x1 -= paddingRight(node) - p;
                    y1 -= paddingBottom(node) - p;
                    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                    tile(node, x0, y0, x1, y1);
                }
            }
            treemap.round = function(x) {
                return arguments.length ? (round = !!x, treemap) : round;
            };
            treemap.size = function(x) {
                return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                    dx,
                    dy
                ];
            };
            treemap.tile = function(x) {
                return arguments.length ? (tile = required(x), treemap) : tile;
            };
            treemap.padding = function(x) {
                return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
            };
            treemap.paddingInner = function(x) {
                return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$2(+x), treemap) : paddingInner;
            };
            treemap.paddingOuter = function(x) {
                return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
            };
            treemap.paddingTop = function(x) {
                return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$2(+x), treemap) : paddingTop;
            };
            treemap.paddingRight = function(x) {
                return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$2(+x), treemap) : paddingRight;
            };
            treemap.paddingBottom = function(x) {
                return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$2(+x), treemap) : paddingBottom;
            };
            treemap.paddingLeft = function(x) {
                return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$2(+x), treemap) : paddingLeft;
            };
            return treemap;
        }
        function binary(parent, x0, y0, x1, y1) {
            var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
            for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
            partition(0, n, parent.value, x0, y0, x1, y1);
            function partition(i, j, value, x0, y0, x1, y1) {
                if (i >= j - 1) {
                    var node = nodes[i];
                    node.x0 = x0, node.y0 = y0;
                    node.x1 = x1, node.y1 = y1;
                    return;
                }
                var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
                while(k < hi){
                    var mid = k + hi >>> 1;
                    if (sums[mid] < valueTarget) k = mid + 1;
                    else hi = mid;
                }
                if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
                var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
                if (x1 - x0 > y1 - y0) {
                    var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                    partition(i, k, valueLeft, x0, y0, xk, y1);
                    partition(k, j, valueRight, xk, y0, x1, y1);
                } else {
                    var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                    partition(i, k, valueLeft, x0, y0, x1, yk);
                    partition(k, j, valueRight, x0, yk, x1, y1);
                }
            }
        }
        function sliceDice(parent, x0, y0, x1, y1) {
            (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
        }
        var resquarify = function custom(ratio) {
            function resquarify(parent, x0, y0, x1, y1) {
                if ((rows = parent._squarify) && rows.ratio === ratio) {
                    var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
                    while(++j < m){
                        row = rows[j], nodes = row.children;
                        for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                        if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                        else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                        value -= row.value;
                    }
                } else {
                    parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
                    rows.ratio = ratio;
                }
            }
            resquarify.ratio = function(x) {
                return custom((x = +x) > 1 ? x : 1);
            };
            return resquarify;
        }(phi);
        function area$1(polygon) {
            var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
            while(++i < n){
                a = b;
                b = polygon[i];
                area += a[1] * b[0] - a[0] * b[1];
            }
            return area / 2;
        }
        function centroid(polygon) {
            var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
            while(++i < n){
                a = b;
                b = polygon[i];
                k += c = a[0] * b[1] - b[0] * a[1];
                x += (a[0] + b[0]) * c;
                y += (a[1] + b[1]) * c;
            }
            return k *= 3, [
                x / k,
                y / k
            ];
        }
        function cross$1(a, b, c) {
            return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
        }
        function lexicographicOrder(a, b) {
            return a[0] - b[0] || a[1] - b[1];
        }
        function computeUpperHullIndexes(points) {
            const n = points.length, indexes = [
                0,
                1
            ];
            let size = 2, i;
            for(i = 2; i < n; ++i){
                while(size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
                indexes[size++] = i;
            }
            return indexes.slice(0, size);
        }
        function hull(points) {
            if ((n = points.length) < 3) return null;
            var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
            for(i = 0; i < n; ++i)sortedPoints[i] = [
                +points[i][0],
                +points[i][1],
                i
            ];
            sortedPoints.sort(lexicographicOrder);
            for(i = 0; i < n; ++i)flippedPoints[i] = [
                sortedPoints[i][0],
                -sortedPoints[i][1]
            ];
            var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
            var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
            for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
            for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
            return hull;
        }
        function contains(polygon, point) {
            var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
            for(var i = 0; i < n; ++i){
                p = polygon[i], x1 = p[0], y1 = p[1];
                if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
                x0 = x1, y0 = y1;
            }
            return inside;
        }
        function length(polygon) {
            var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
            while(++i < n){
                xa = xb;
                ya = yb;
                b = polygon[i];
                xb = b[0];
                yb = b[1];
                xa -= xb;
                ya -= yb;
                perimeter += Math.hypot(xa, ya);
            }
            return perimeter;
        }
        var defaultSource = Math.random;
        var uniform = function sourceRandomUniform(source) {
            function randomUniform(min, max) {
                min = min == null ? 0 : +min;
                max = max == null ? 1 : +max;
                if (arguments.length === 1) max = min, min = 0;
                else max -= min;
                return function() {
                    return source() * max + min;
                };
            }
            randomUniform.source = sourceRandomUniform;
            return randomUniform;
        }(defaultSource);
        var int = function sourceRandomInt(source) {
            function randomInt(min, max) {
                if (arguments.length < 2) max = min, min = 0;
                min = Math.floor(min);
                max = Math.floor(max) - min;
                return function() {
                    return Math.floor(source() * max + min);
                };
            }
            randomInt.source = sourceRandomInt;
            return randomInt;
        }(defaultSource);
        var normal = function sourceRandomNormal(source) {
            function randomNormal(mu, sigma) {
                var x, r;
                mu = mu == null ? 0 : +mu;
                sigma = sigma == null ? 1 : +sigma;
                return function() {
                    var y;
                    if (x != null) y = x, x = null;
                    else do {
                        x = source() * 2 - 1;
                        y = source() * 2 - 1;
                        r = x * x + y * y;
                    }while (!r || r > 1)
                    return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
                };
            }
            randomNormal.source = sourceRandomNormal;
            return randomNormal;
        }(defaultSource);
        var logNormal = function sourceRandomLogNormal(source) {
            var N = normal.source(source);
            function randomLogNormal() {
                var randomNormal = N.apply(this, arguments);
                return function() {
                    return Math.exp(randomNormal());
                };
            }
            randomLogNormal.source = sourceRandomLogNormal;
            return randomLogNormal;
        }(defaultSource);
        var irwinHall = function sourceRandomIrwinHall(source) {
            function randomIrwinHall(n) {
                if ((n = +n) <= 0) return ()=>0;
                return function() {
                    for(var sum = 0, i = n; i > 1; --i)sum += source();
                    return sum + i * source();
                };
            }
            randomIrwinHall.source = sourceRandomIrwinHall;
            return randomIrwinHall;
        }(defaultSource);
        var bates = function sourceRandomBates(source) {
            var I = irwinHall.source(source);
            function randomBates(n) {
                if ((n = +n) === 0) return source;
                var randomIrwinHall = I(n);
                return function() {
                    return randomIrwinHall() / n;
                };
            }
            randomBates.source = sourceRandomBates;
            return randomBates;
        }(defaultSource);
        var exponential = function sourceRandomExponential(source) {
            function randomExponential(lambda) {
                return function() {
                    return -Math.log1p(-source()) / lambda;
                };
            }
            randomExponential.source = sourceRandomExponential;
            return randomExponential;
        }(defaultSource);
        var pareto = function sourceRandomPareto(source) {
            function randomPareto(alpha) {
                if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
                alpha = 1 / -alpha;
                return function() {
                    return Math.pow(1 - source(), alpha);
                };
            }
            randomPareto.source = sourceRandomPareto;
            return randomPareto;
        }(defaultSource);
        var bernoulli = function sourceRandomBernoulli(source) {
            function randomBernoulli(p) {
                if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
                return function() {
                    return Math.floor(source() + p);
                };
            }
            randomBernoulli.source = sourceRandomBernoulli;
            return randomBernoulli;
        }(defaultSource);
        var geometric = function sourceRandomGeometric(source) {
            function randomGeometric(p) {
                if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
                if (p === 0) return ()=>Infinity;
                if (p === 1) return ()=>1;
                p = Math.log1p(-p);
                return function() {
                    return 1 + Math.floor(Math.log1p(-source()) / p);
                };
            }
            randomGeometric.source = sourceRandomGeometric;
            return randomGeometric;
        }(defaultSource);
        var gamma = function sourceRandomGamma(source) {
            var randomNormal = normal.source(source)();
            function randomGamma(k, theta) {
                if ((k = +k) < 0) throw new RangeError("invalid k");
                if (k === 0) return ()=>0;
                theta = theta == null ? 1 : +theta;
                if (k === 1) return ()=>-Math.log1p(-source()) * theta;
                var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
                return function() {
                    do {
                        do var x = randomNormal(), v = 1 + c * x;
                        while (v <= 0)
                        v *= v * v;
                        var u = 1 - source();
                    }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)))
                    return d * v * multiplier() * theta;
                };
            }
            randomGamma.source = sourceRandomGamma;
            return randomGamma;
        }(defaultSource);
        var beta = function sourceRandomBeta(source) {
            var G = gamma.source(source);
            function randomBeta(alpha, beta) {
                var X = G(alpha), Y = G(beta);
                return function() {
                    var x = X();
                    return x === 0 ? 0 : x / (x + Y());
                };
            }
            randomBeta.source = sourceRandomBeta;
            return randomBeta;
        }(defaultSource);
        var binomial = function sourceRandomBinomial(source) {
            var G = geometric.source(source), B = beta.source(source);
            function randomBinomial(n, p) {
                n = +n;
                if ((p = +p) >= 1) return ()=>n;
                if (p <= 0) return ()=>0;
                return function() {
                    var acc = 0, nn = n, pp = p;
                    while(nn * pp > 16 && nn * (1 - pp) > 16){
                        var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                        if (y <= pp) {
                            acc += i;
                            nn -= i;
                            pp = (pp - y) / (1 - y);
                        } else {
                            nn = i - 1;
                            pp /= y;
                        }
                    }
                    var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
                    for(var s = g(), k = 0; s <= nn; ++k)s += g();
                    return acc + (sign ? k : nn - k);
                };
            }
            randomBinomial.source = sourceRandomBinomial;
            return randomBinomial;
        }(defaultSource);
        var weibull = function sourceRandomWeibull(source) {
            function randomWeibull(k, a, b) {
                var outerFunc;
                if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
                else {
                    k = 1 / k;
                    outerFunc = (x)=>Math.pow(x, k);
                }
                a = a == null ? 0 : +a;
                b = b == null ? 1 : +b;
                return function() {
                    return a + b * outerFunc(-Math.log1p(-source()));
                };
            }
            randomWeibull.source = sourceRandomWeibull;
            return randomWeibull;
        }(defaultSource);
        var cauchy = function sourceRandomCauchy(source) {
            function randomCauchy(a, b) {
                a = a == null ? 0 : +a;
                b = b == null ? 1 : +b;
                return function() {
                    return a + b * Math.tan(Math.PI * source());
                };
            }
            randomCauchy.source = sourceRandomCauchy;
            return randomCauchy;
        }(defaultSource);
        var logistic = function sourceRandomLogistic(source) {
            function randomLogistic(a, b) {
                a = a == null ? 0 : +a;
                b = b == null ? 1 : +b;
                return function() {
                    var u = source();
                    return a + b * Math.log(u / (1 - u));
                };
            }
            randomLogistic.source = sourceRandomLogistic;
            return randomLogistic;
        }(defaultSource);
        var poisson = function sourceRandomPoisson(source) {
            var G = gamma.source(source), B = binomial.source(source);
            function randomPoisson(lambda) {
                return function() {
                    var acc = 0, l = lambda;
                    while(l > 16){
                        var n = Math.floor(0.875 * l), t = G(n)();
                        if (t > l) return acc + B(n - 1, l / t)();
                        acc += n;
                        l -= t;
                    }
                    for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
                    return acc + k;
                };
            }
            randomPoisson.source = sourceRandomPoisson;
            return randomPoisson;
        }(defaultSource);
        const mul = 0x19660D;
        const inc = 0x3C6EF35F;
        const eps = 1 / 0x100000000;
        function lcg(seed = Math.random()) {
            let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
            return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
        }
        function initRange(domain, range) {
            switch(arguments.length){
                case 0:
                    break;
                case 1:
                    this.range(domain);
                    break;
                default:
                    this.range(range).domain(domain);
                    break;
            }
            return this;
        }
        function initInterpolator(domain, interpolator) {
            switch(arguments.length){
                case 0:
                    break;
                case 1:
                    if (typeof domain === "function") this.interpolator(domain);
                    else this.range(domain);
                    break;
                default:
                    this.domain(domain);
                    if (typeof interpolator === "function") this.interpolator(interpolator);
                    else this.range(interpolator);
                    break;
            }
            return this;
        }
        const implicit = Symbol("implicit");
        function ordinal() {
            var index = new InternMap(), domain = [], range = [], unknown = implicit;
            function scale(d) {
                let i = index.get(d);
                if (i === undefined) {
                    if (unknown !== implicit) return unknown;
                    index.set(d, i = domain.push(d) - 1);
                }
                return range[i % range.length];
            }
            scale.domain = function(_) {
                if (!arguments.length) return domain.slice();
                domain = [], index = new InternMap();
                for (const value of _){
                    if (index.has(value)) continue;
                    index.set(value, domain.push(value) - 1);
                }
                return scale;
            };
            scale.range = function(_) {
                return arguments.length ? (range = Array.from(_), scale) : range.slice();
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            scale.copy = function() {
                return ordinal(domain, range).unknown(unknown);
            };
            initRange.apply(scale, arguments);
            return scale;
        }
        function band() {
            var scale = ordinal().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
            delete scale.unknown;
            function rescale() {
                var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
                step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
                if (round) step = Math.floor(step);
                start += (stop - start - step * (n - paddingInner)) * align;
                bandwidth = step * (1 - paddingInner);
                if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
                var values = range$2(n).map(function(i) {
                    return start + step * i;
                });
                return ordinalRange(reverse ? values.reverse() : values);
            }
            scale.domain = function(_) {
                return arguments.length ? (domain(_), rescale()) : domain();
            };
            scale.range = function(_) {
                return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
                    r0,
                    r1
                ];
            };
            scale.rangeRound = function(_) {
                return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
            };
            scale.bandwidth = function() {
                return bandwidth;
            };
            scale.step = function() {
                return step;
            };
            scale.round = function(_) {
                return arguments.length ? (round = !!_, rescale()) : round;
            };
            scale.padding = function(_) {
                return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
            };
            scale.paddingInner = function(_) {
                return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
            };
            scale.paddingOuter = function(_) {
                return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
            };
            scale.align = function(_) {
                return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
            };
            scale.copy = function() {
                return band(domain(), [
                    r0,
                    r1
                ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
            };
            return initRange.apply(rescale(), arguments);
        }
        function pointish(scale) {
            var copy = scale.copy;
            scale.padding = scale.paddingOuter;
            delete scale.paddingInner;
            delete scale.paddingOuter;
            scale.copy = function() {
                return pointish(copy());
            };
            return scale;
        }
        function point$4() {
            return pointish(band.apply(null, arguments).paddingInner(1));
        }
        function constants(x) {
            return function() {
                return x;
            };
        }
        function number$1(x) {
            return +x;
        }
        var unit = [
            0,
            1
        ];
        function identity$3(x) {
            return x;
        }
        function normalize(a, b) {
            return (b -= a = +a) ? function(x) {
                return (x - a) / b;
            } : constants(isNaN(b) ? NaN : 0.5);
        }
        function clamper(a, b) {
            var t;
            if (a > b) t = a, a = b, b = t;
            return function(x) {
                return Math.max(a, Math.min(b, x));
            };
        }
        function bimap(domain, range, interpolate) {
            var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
            if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
            else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
            return function(x) {
                return r0(d0(x));
            };
        }
        function polymap(domain, range, interpolate) {
            var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
            if (domain[j] < domain[0]) {
                domain = domain.slice().reverse();
                range = range.slice().reverse();
            }
            while(++i < j){
                d[i] = normalize(domain[i], domain[i + 1]);
                r[i] = interpolate(range[i], range[i + 1]);
            }
            return function(x) {
                var i = bisect(domain, x, 1, j) - 1;
                return r[i](d[i](x));
            };
        }
        function copy$1(source, target) {
            return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
        }
        function transformer$2() {
            var domain = unit, range = unit, interpolate = interpolate$2, transform, untransform, unknown, clamp = identity$3, piecewise, output, input;
            function rescale() {
                var n = Math.min(domain.length, range.length);
                if (clamp !== identity$3) clamp = clamper(domain[0], domain[n - 1]);
                piecewise = n > 2 ? polymap : bimap;
                output = input = null;
                return scale;
            }
            function scale(x) {
                return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
            }
            scale.invert = function(y) {
                return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
            };
            scale.domain = function(_) {
                return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
            };
            scale.range = function(_) {
                return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
            };
            scale.rangeRound = function(_) {
                return range = Array.from(_), interpolate = interpolateRound, rescale();
            };
            scale.clamp = function(_) {
                return arguments.length ? (clamp = _ ? true : identity$3, rescale()) : clamp !== identity$3;
            };
            scale.interpolate = function(_) {
                return arguments.length ? (interpolate = _, rescale()) : interpolate;
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            return function(t, u) {
                transform = t, untransform = u;
                return rescale();
            };
        }
        function continuous() {
            return transformer$2()(identity$3, identity$3);
        }
        function tickFormat(start, stop, count, specifier) {
            var step = tickStep(start, stop, count), precision;
            specifier = formatSpecifier(specifier == null ? ",f" : specifier);
            switch(specifier.type){
                case "s":
                    var value = Math.max(Math.abs(start), Math.abs(stop));
                    if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
                    return exports1.formatPrefix(specifier, value);
                case "":
                case "e":
                case "g":
                case "p":
                case "r":
                    if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                    break;
                case "f":
                case "%":
                    if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                    break;
            }
            return exports1.format(specifier);
        }
        function linearish(scale) {
            var domain = scale.domain;
            scale.ticks = function(count) {
                var d = domain();
                return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
            };
            scale.tickFormat = function(count, specifier) {
                var d = domain();
                return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
            };
            scale.nice = function(count) {
                if (count == null) count = 10;
                var d = domain();
                var i0 = 0;
                var i1 = d.length - 1;
                var start = d[i0];
                var stop = d[i1];
                var prestep;
                var step;
                var maxIter = 10;
                if (stop < start) {
                    step = start, start = stop, stop = step;
                    step = i0, i0 = i1, i1 = step;
                }
                while(maxIter-- > 0){
                    step = tickIncrement(start, stop, count);
                    if (step === prestep) {
                        d[i0] = start;
                        d[i1] = stop;
                        return domain(d);
                    } else if (step > 0) {
                        start = Math.floor(start / step) * step;
                        stop = Math.ceil(stop / step) * step;
                    } else if (step < 0) {
                        start = Math.ceil(start * step) / step;
                        stop = Math.floor(stop * step) / step;
                    } else break;
                    prestep = step;
                }
                return scale;
            };
            return scale;
        }
        function linear() {
            var scale = continuous();
            scale.copy = function() {
                return copy$1(scale, linear());
            };
            initRange.apply(scale, arguments);
            return linearish(scale);
        }
        function identity$2(domain) {
            var unknown;
            function scale(x) {
                return x == null || isNaN(x = +x) ? unknown : x;
            }
            scale.invert = scale;
            scale.domain = scale.range = function(_) {
                return arguments.length ? (domain = Array.from(_, number$1), scale) : domain.slice();
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            scale.copy = function() {
                return identity$2(domain).unknown(unknown);
            };
            domain = arguments.length ? Array.from(domain, number$1) : [
                0,
                1
            ];
            return linearish(scale);
        }
        function nice(domain, interval) {
            domain = domain.slice();
            var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
            if (x1 < x0) {
                t = i0, i0 = i1, i1 = t;
                t = x0, x0 = x1, x1 = t;
            }
            domain[i0] = interval.floor(x0);
            domain[i1] = interval.ceil(x1);
            return domain;
        }
        function transformLog(x) {
            return Math.log(x);
        }
        function transformExp(x) {
            return Math.exp(x);
        }
        function transformLogn(x) {
            return -Math.log(-x);
        }
        function transformExpn(x) {
            return -Math.exp(-x);
        }
        function pow10(x) {
            return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
        }
        function powp(base) {
            return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
        }
        function logp(base) {
            return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
        }
        function reflect(f) {
            return (x, k)=>-f(-x, k);
        }
        function loggish(transform) {
            const scale = transform(transformLog, transformExp);
            const domain = scale.domain;
            let base = 10;
            let logs;
            let pows;
            function rescale() {
                logs = logp(base), pows = powp(base);
                if (domain()[0] < 0) {
                    logs = reflect(logs), pows = reflect(pows);
                    transform(transformLogn, transformExpn);
                } else transform(transformLog, transformExp);
                return scale;
            }
            scale.base = function(_) {
                return arguments.length ? (base = +_, rescale()) : base;
            };
            scale.domain = function(_) {
                return arguments.length ? (domain(_), rescale()) : domain();
            };
            scale.ticks = (count)=>{
                const d = domain();
                let u = d[0];
                let v = d[d.length - 1];
                const r = v < u;
                if (r) [u, v] = [
                    v,
                    u
                ];
                let i = logs(u);
                let j = logs(v);
                let k;
                let t;
                const n = count == null ? 10 : +count;
                let z = [];
                if (!(base % 1) && j - i < n) {
                    i = Math.floor(i), j = Math.ceil(j);
                    if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                        t = i < 0 ? k / pows(-i) : k * pows(i);
                        if (t < u) continue;
                        if (t > v) break;
                        z.push(t);
                    }
                    else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                        t = i > 0 ? k / pows(-i) : k * pows(i);
                        if (t < u) continue;
                        if (t > v) break;
                        z.push(t);
                    }
                    if (z.length * 2 < n) z = ticks(u, v, n);
                } else z = ticks(i, j, Math.min(j - i, n)).map(pows);
                return r ? z.reverse() : z;
            };
            scale.tickFormat = (count, specifier)=>{
                if (count == null) count = 10;
                if (specifier == null) specifier = base === 10 ? "s" : ",";
                if (typeof specifier !== "function") {
                    if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
                    specifier = exports1.format(specifier);
                }
                if (count === Infinity) return specifier;
                const k = Math.max(1, base * count / scale.ticks().length);
                return (d)=>{
                    let i = d / pows(Math.round(logs(d)));
                    if (i * base < base - 0.5) i *= base;
                    return i <= k ? specifier(d) : "";
                };
            };
            scale.nice = ()=>{
                return domain(nice(domain(), {
                    floor: (x)=>pows(Math.floor(logs(x))),
                    ceil: (x)=>pows(Math.ceil(logs(x)))
                }));
            };
            return scale;
        }
        function log() {
            const scale = loggish(transformer$2()).domain([
                1,
                10
            ]);
            scale.copy = ()=>copy$1(scale, log()).base(scale.base());
            initRange.apply(scale, arguments);
            return scale;
        }
        function transformSymlog(c) {
            return function(x) {
                return Math.sign(x) * Math.log1p(Math.abs(x / c));
            };
        }
        function transformSymexp(c) {
            return function(x) {
                return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
            };
        }
        function symlogish(transform) {
            var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
            scale.constant = function(_) {
                return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
            };
            return linearish(scale);
        }
        function symlog() {
            var scale = symlogish(transformer$2());
            scale.copy = function() {
                return copy$1(scale, symlog()).constant(scale.constant());
            };
            return initRange.apply(scale, arguments);
        }
        function transformPow(exponent) {
            return function(x) {
                return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
            };
        }
        function transformSqrt(x) {
            return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
        }
        function transformSquare(x) {
            return x < 0 ? -x * x : x * x;
        }
        function powish(transform) {
            var scale = transform(identity$3, identity$3), exponent = 1;
            function rescale() {
                return exponent === 1 ? transform(identity$3, identity$3) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
            }
            scale.exponent = function(_) {
                return arguments.length ? (exponent = +_, rescale()) : exponent;
            };
            return linearish(scale);
        }
        function pow() {
            var scale = powish(transformer$2());
            scale.copy = function() {
                return copy$1(scale, pow()).exponent(scale.exponent());
            };
            initRange.apply(scale, arguments);
            return scale;
        }
        function sqrt$1() {
            return pow.apply(null, arguments).exponent(0.5);
        }
        function square$1(x) {
            return Math.sign(x) * x * x;
        }
        function unsquare(x) {
            return Math.sign(x) * Math.sqrt(Math.abs(x));
        }
        function radial() {
            var squared = continuous(), range = [
                0,
                1
            ], round = false, unknown;
            function scale(x) {
                var y = unsquare(squared(x));
                return isNaN(y) ? unknown : round ? Math.round(y) : y;
            }
            scale.invert = function(y) {
                return squared.invert(square$1(y));
            };
            scale.domain = function(_) {
                return arguments.length ? (squared.domain(_), scale) : squared.domain();
            };
            scale.range = function(_) {
                return arguments.length ? (squared.range((range = Array.from(_, number$1)).map(square$1)), scale) : range.slice();
            };
            scale.rangeRound = function(_) {
                return scale.range(_).round(true);
            };
            scale.round = function(_) {
                return arguments.length ? (round = !!_, scale) : round;
            };
            scale.clamp = function(_) {
                return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            scale.copy = function() {
                return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
            };
            initRange.apply(scale, arguments);
            return linearish(scale);
        }
        function quantile() {
            var domain = [], range = [], thresholds = [], unknown;
            function rescale() {
                var i = 0, n = Math.max(1, range.length);
                thresholds = new Array(n - 1);
                while(++i < n)thresholds[i - 1] = quantileSorted(domain, i / n);
                return scale;
            }
            function scale(x) {
                return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
            }
            scale.invertExtent = function(y) {
                var i = range.indexOf(y);
                return i < 0 ? [
                    NaN,
                    NaN
                ] : [
                    i > 0 ? thresholds[i - 1] : domain[0],
                    i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
                ];
            };
            scale.domain = function(_) {
                if (!arguments.length) return domain.slice();
                domain = [];
                for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
                domain.sort(ascending$3);
                return rescale();
            };
            scale.range = function(_) {
                return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            scale.quantiles = function() {
                return thresholds.slice();
            };
            scale.copy = function() {
                return quantile().domain(domain).range(range).unknown(unknown);
            };
            return initRange.apply(scale, arguments);
        }
        function quantize() {
            var x0 = 0, x1 = 1, n = 1, domain = [
                0.5
            ], range = [
                0,
                1
            ], unknown;
            function scale(x) {
                return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
            }
            function rescale() {
                var i = -1;
                domain = new Array(n);
                while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
                return scale;
            }
            scale.domain = function(_) {
                return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
                    x0,
                    x1
                ];
            };
            scale.range = function(_) {
                return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
            };
            scale.invertExtent = function(y) {
                var i = range.indexOf(y);
                return i < 0 ? [
                    NaN,
                    NaN
                ] : i < 1 ? [
                    x0,
                    domain[0]
                ] : i >= n ? [
                    domain[n - 1],
                    x1
                ] : [
                    domain[i - 1],
                    domain[i]
                ];
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : scale;
            };
            scale.thresholds = function() {
                return domain.slice();
            };
            scale.copy = function() {
                return quantize().domain([
                    x0,
                    x1
                ]).range(range).unknown(unknown);
            };
            return initRange.apply(linearish(scale), arguments);
        }
        function threshold() {
            var domain = [
                0.5
            ], range = [
                0,
                1
            ], unknown, n = 1;
            function scale(x) {
                return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
            }
            scale.domain = function(_) {
                return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
            };
            scale.range = function(_) {
                return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
            };
            scale.invertExtent = function(y) {
                var i = range.indexOf(y);
                return [
                    domain[i - 1],
                    domain[i]
                ];
            };
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            scale.copy = function() {
                return threshold().domain(domain).range(range).unknown(unknown);
            };
            return initRange.apply(scale, arguments);
        }
        const t0 = new Date, t1 = new Date;
        function timeInterval(floori, offseti, count, field) {
            function interval(date) {
                return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
            }
            interval.floor = (date)=>{
                return floori(date = new Date(+date)), date;
            };
            interval.ceil = (date)=>{
                return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
            };
            interval.round = (date)=>{
                const d0 = interval(date), d1 = interval.ceil(date);
                return date - d0 < d1 - date ? d0 : d1;
            };
            interval.offset = (date, step)=>{
                return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
            };
            interval.range = (start, stop, step)=>{
                const range = [];
                start = interval.ceil(start);
                step = step == null ? 1 : Math.floor(step);
                if (!(start < stop) || !(step > 0)) return range;
                let previous;
                do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
                while (previous < start && start < stop)
                return range;
            };
            interval.filter = (test)=>{
                return timeInterval((date)=>{
                    if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
                }, (date, step)=>{
                    if (date >= date) {
                        if (step < 0) while(++step <= 0){
                            while(offseti(date, -1), !test(date));
                        }
                        else while(--step >= 0){
                            while(offseti(date, 1), !test(date));
                        }
                    }
                });
            };
            if (count) {
                interval.count = (start, end)=>{
                    t0.setTime(+start), t1.setTime(+end);
                    floori(t0), floori(t1);
                    return Math.floor(count(t0, t1));
                };
                interval.every = (step)=>{
                    step = Math.floor(step);
                    return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
                };
            }
            return interval;
        }
        const millisecond = timeInterval(()=>{}, (date, step)=>{
            date.setTime(+date + step);
        }, (start, end)=>{
            return end - start;
        });
        millisecond.every = (k)=>{
            k = Math.floor(k);
            if (!isFinite(k) || !(k > 0)) return null;
            if (!(k > 1)) return millisecond;
            return timeInterval((date)=>{
                date.setTime(Math.floor(date / k) * k);
            }, (date, step)=>{
                date.setTime(+date + step * k);
            }, (start, end)=>{
                return (end - start) / k;
            });
        };
        const milliseconds = millisecond.range;
        const durationSecond = 1000;
        const durationMinute = durationSecond * 60;
        const durationHour = durationMinute * 60;
        const durationDay = durationHour * 24;
        const durationWeek = durationDay * 7;
        const durationMonth = durationDay * 30;
        const durationYear = durationDay * 365;
        const second = timeInterval((date)=>{
            date.setTime(date - date.getMilliseconds());
        }, (date, step)=>{
            date.setTime(+date + step * durationSecond);
        }, (start, end)=>{
            return (end - start) / durationSecond;
        }, (date)=>{
            return date.getUTCSeconds();
        });
        const seconds = second.range;
        const timeMinute = timeInterval((date)=>{
            date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
        }, (date, step)=>{
            date.setTime(+date + step * durationMinute);
        }, (start, end)=>{
            return (end - start) / durationMinute;
        }, (date)=>{
            return date.getMinutes();
        });
        const timeMinutes = timeMinute.range;
        const utcMinute = timeInterval((date)=>{
            date.setUTCSeconds(0, 0);
        }, (date, step)=>{
            date.setTime(+date + step * durationMinute);
        }, (start, end)=>{
            return (end - start) / durationMinute;
        }, (date)=>{
            return date.getUTCMinutes();
        });
        const utcMinutes = utcMinute.range;
        const timeHour = timeInterval((date)=>{
            date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
        }, (date, step)=>{
            date.setTime(+date + step * durationHour);
        }, (start, end)=>{
            return (end - start) / durationHour;
        }, (date)=>{
            return date.getHours();
        });
        const timeHours = timeHour.range;
        const utcHour = timeInterval((date)=>{
            date.setUTCMinutes(0, 0, 0);
        }, (date, step)=>{
            date.setTime(+date + step * durationHour);
        }, (start, end)=>{
            return (end - start) / durationHour;
        }, (date)=>{
            return date.getUTCHours();
        });
        const utcHours = utcHour.range;
        const timeDay = timeInterval((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay, (date)=>date.getDate() - 1);
        const timeDays = timeDay.range;
        const utcDay = timeInterval((date)=>{
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step);
        }, (start, end)=>{
            return (end - start) / durationDay;
        }, (date)=>{
            return date.getUTCDate() - 1;
        });
        const utcDays = utcDay.range;
        const unixDay = timeInterval((date)=>{
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step);
        }, (start, end)=>{
            return (end - start) / durationDay;
        }, (date)=>{
            return Math.floor(date / durationDay);
        });
        const unixDays = unixDay.range;
        function timeWeekday(i) {
            return timeInterval((date)=>{
                date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
                date.setHours(0, 0, 0, 0);
            }, (date, step)=>{
                date.setDate(date.getDate() + step * 7);
            }, (start, end)=>{
                return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
            });
        }
        const timeSunday = timeWeekday(0);
        const timeMonday = timeWeekday(1);
        const timeTuesday = timeWeekday(2);
        const timeWednesday = timeWeekday(3);
        const timeThursday = timeWeekday(4);
        const timeFriday = timeWeekday(5);
        const timeSaturday = timeWeekday(6);
        const timeSundays = timeSunday.range;
        const timeMondays = timeMonday.range;
        const timeTuesdays = timeTuesday.range;
        const timeWednesdays = timeWednesday.range;
        const timeThursdays = timeThursday.range;
        const timeFridays = timeFriday.range;
        const timeSaturdays = timeSaturday.range;
        function utcWeekday(i) {
            return timeInterval((date)=>{
                date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
                date.setUTCHours(0, 0, 0, 0);
            }, (date, step)=>{
                date.setUTCDate(date.getUTCDate() + step * 7);
            }, (start, end)=>{
                return (end - start) / durationWeek;
            });
        }
        const utcSunday = utcWeekday(0);
        const utcMonday = utcWeekday(1);
        const utcTuesday = utcWeekday(2);
        const utcWednesday = utcWeekday(3);
        const utcThursday = utcWeekday(4);
        const utcFriday = utcWeekday(5);
        const utcSaturday = utcWeekday(6);
        const utcSundays = utcSunday.range;
        const utcMondays = utcMonday.range;
        const utcTuesdays = utcTuesday.range;
        const utcWednesdays = utcWednesday.range;
        const utcThursdays = utcThursday.range;
        const utcFridays = utcFriday.range;
        const utcSaturdays = utcSaturday.range;
        const timeMonth = timeInterval((date)=>{
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setMonth(date.getMonth() + step);
        }, (start, end)=>{
            return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
        }, (date)=>{
            return date.getMonth();
        });
        const timeMonths = timeMonth.range;
        const utcMonth = timeInterval((date)=>{
            date.setUTCDate(1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCMonth(date.getUTCMonth() + step);
        }, (start, end)=>{
            return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
        }, (date)=>{
            return date.getUTCMonth();
        });
        const utcMonths = utcMonth.range;
        const timeYear = timeInterval((date)=>{
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setFullYear(date.getFullYear() + step);
        }, (start, end)=>{
            return end.getFullYear() - start.getFullYear();
        }, (date)=>{
            return date.getFullYear();
        });
        timeYear.every = (k)=>{
            return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
                date.setFullYear(Math.floor(date.getFullYear() / k) * k);
                date.setMonth(0, 1);
                date.setHours(0, 0, 0, 0);
            }, (date, step)=>{
                date.setFullYear(date.getFullYear() + step * k);
            });
        };
        const timeYears = timeYear.range;
        const utcYear = timeInterval((date)=>{
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCFullYear(date.getUTCFullYear() + step);
        }, (start, end)=>{
            return end.getUTCFullYear() - start.getUTCFullYear();
        }, (date)=>{
            return date.getUTCFullYear();
        });
        utcYear.every = (k)=>{
            return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
                date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
                date.setUTCMonth(0, 1);
                date.setUTCHours(0, 0, 0, 0);
            }, (date, step)=>{
                date.setUTCFullYear(date.getUTCFullYear() + step * k);
            });
        };
        const utcYears = utcYear.range;
        function ticker(year, month, week, day, hour, minute) {
            const tickIntervals = [
                [
                    second,
                    1,
                    durationSecond
                ],
                [
                    second,
                    5,
                    5 * durationSecond
                ],
                [
                    second,
                    15,
                    15 * durationSecond
                ],
                [
                    second,
                    30,
                    30 * durationSecond
                ],
                [
                    minute,
                    1,
                    durationMinute
                ],
                [
                    minute,
                    5,
                    5 * durationMinute
                ],
                [
                    minute,
                    15,
                    15 * durationMinute
                ],
                [
                    minute,
                    30,
                    30 * durationMinute
                ],
                [
                    hour,
                    1,
                    durationHour
                ],
                [
                    hour,
                    3,
                    3 * durationHour
                ],
                [
                    hour,
                    6,
                    6 * durationHour
                ],
                [
                    hour,
                    12,
                    12 * durationHour
                ],
                [
                    day,
                    1,
                    durationDay
                ],
                [
                    day,
                    2,
                    2 * durationDay
                ],
                [
                    week,
                    1,
                    durationWeek
                ],
                [
                    month,
                    1,
                    durationMonth
                ],
                [
                    month,
                    3,
                    3 * durationMonth
                ],
                [
                    year,
                    1,
                    durationYear
                ]
            ];
            function ticks(start, stop, count) {
                const reverse = stop < start;
                if (reverse) [start, stop] = [
                    stop,
                    start
                ];
                const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
                const ticks = interval ? interval.range(start, +stop + 1) : [];
                return reverse ? ticks.reverse() : ticks;
            }
            function tickInterval(start, stop, count) {
                const target = Math.abs(stop - start) / count;
                const i = bisector(([, , step])=>step).right(tickIntervals, target);
                if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
                if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
                const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                return t.every(step);
            }
            return [
                ticks,
                tickInterval
            ];
        }
        const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
        const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
        function localDate(d) {
            if (0 <= d.y && d.y < 100) {
                var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
                date.setFullYear(d.y);
                return date;
            }
            return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
        }
        function utcDate(d) {
            if (0 <= d.y && d.y < 100) {
                var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
                date.setUTCFullYear(d.y);
                return date;
            }
            return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
        }
        function newDate(y, m, d) {
            return {
                y: y,
                m: m,
                d: d,
                H: 0,
                M: 0,
                S: 0,
                L: 0
            };
        }
        function formatLocale(locale) {
            var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
            var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
            var formats = {
                "a": formatShortWeekday,
                "A": formatWeekday,
                "b": formatShortMonth,
                "B": formatMonth,
                "c": null,
                "d": formatDayOfMonth,
                "e": formatDayOfMonth,
                "f": formatMicroseconds,
                "g": formatYearISO,
                "G": formatFullYearISO,
                "H": formatHour24,
                "I": formatHour12,
                "j": formatDayOfYear,
                "L": formatMilliseconds,
                "m": formatMonthNumber,
                "M": formatMinutes,
                "p": formatPeriod,
                "q": formatQuarter,
                "Q": formatUnixTimestamp,
                "s": formatUnixTimestampSeconds,
                "S": formatSeconds,
                "u": formatWeekdayNumberMonday,
                "U": formatWeekNumberSunday,
                "V": formatWeekNumberISO,
                "w": formatWeekdayNumberSunday,
                "W": formatWeekNumberMonday,
                "x": null,
                "X": null,
                "y": formatYear,
                "Y": formatFullYear,
                "Z": formatZone,
                "%": formatLiteralPercent
            };
            var utcFormats = {
                "a": formatUTCShortWeekday,
                "A": formatUTCWeekday,
                "b": formatUTCShortMonth,
                "B": formatUTCMonth,
                "c": null,
                "d": formatUTCDayOfMonth,
                "e": formatUTCDayOfMonth,
                "f": formatUTCMicroseconds,
                "g": formatUTCYearISO,
                "G": formatUTCFullYearISO,
                "H": formatUTCHour24,
                "I": formatUTCHour12,
                "j": formatUTCDayOfYear,
                "L": formatUTCMilliseconds,
                "m": formatUTCMonthNumber,
                "M": formatUTCMinutes,
                "p": formatUTCPeriod,
                "q": formatUTCQuarter,
                "Q": formatUnixTimestamp,
                "s": formatUnixTimestampSeconds,
                "S": formatUTCSeconds,
                "u": formatUTCWeekdayNumberMonday,
                "U": formatUTCWeekNumberSunday,
                "V": formatUTCWeekNumberISO,
                "w": formatUTCWeekdayNumberSunday,
                "W": formatUTCWeekNumberMonday,
                "x": null,
                "X": null,
                "y": formatUTCYear,
                "Y": formatUTCFullYear,
                "Z": formatUTCZone,
                "%": formatLiteralPercent
            };
            var parses = {
                "a": parseShortWeekday,
                "A": parseWeekday,
                "b": parseShortMonth,
                "B": parseMonth,
                "c": parseLocaleDateTime,
                "d": parseDayOfMonth,
                "e": parseDayOfMonth,
                "f": parseMicroseconds,
                "g": parseYear,
                "G": parseFullYear,
                "H": parseHour24,
                "I": parseHour24,
                "j": parseDayOfYear,
                "L": parseMilliseconds,
                "m": parseMonthNumber,
                "M": parseMinutes,
                "p": parsePeriod,
                "q": parseQuarter,
                "Q": parseUnixTimestamp,
                "s": parseUnixTimestampSeconds,
                "S": parseSeconds,
                "u": parseWeekdayNumberMonday,
                "U": parseWeekNumberSunday,
                "V": parseWeekNumberISO,
                "w": parseWeekdayNumberSunday,
                "W": parseWeekNumberMonday,
                "x": parseLocaleDate,
                "X": parseLocaleTime,
                "y": parseYear,
                "Y": parseFullYear,
                "Z": parseZone,
                "%": parseLiteralPercent
            };
            formats.x = newFormat(locale_date, formats);
            formats.X = newFormat(locale_time, formats);
            formats.c = newFormat(locale_dateTime, formats);
            utcFormats.x = newFormat(locale_date, utcFormats);
            utcFormats.X = newFormat(locale_time, utcFormats);
            utcFormats.c = newFormat(locale_dateTime, utcFormats);
            function newFormat(specifier, formats) {
                return function(date) {
                    var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
                    if (!(date instanceof Date)) date = new Date(+date);
                    while(++i < n)if (specifier.charCodeAt(i) === 37) {
                        string.push(specifier.slice(j, i));
                        if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                        else pad = c === "e" ? " " : "0";
                        if (format = formats[c]) c = format(date, pad);
                        string.push(c);
                        j = i + 1;
                    }
                    string.push(specifier.slice(j, i));
                    return string.join("");
                };
            }
            function newParse(specifier, Z) {
                return function(string) {
                    var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
                    if (i != string.length) return null;
                    if ("Q" in d) return new Date(d.Q);
                    if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
                    if (Z && !("Z" in d)) d.Z = 0;
                    if ("p" in d) d.H = d.H % 12 + d.p * 12;
                    if (d.m === undefined) d.m = "q" in d ? d.q : 0;
                    if ("V" in d) {
                        if (d.V < 1 || d.V > 53) return null;
                        if (!("w" in d)) d.w = 1;
                        if ("Z" in d) {
                            week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                            week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
                            week = utcDay.offset(week, (d.V - 1) * 7);
                            d.y = week.getUTCFullYear();
                            d.m = week.getUTCMonth();
                            d.d = week.getUTCDate() + (d.w + 6) % 7;
                        } else {
                            week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                            week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
                            week = timeDay.offset(week, (d.V - 1) * 7);
                            d.y = week.getFullYear();
                            d.m = week.getMonth();
                            d.d = week.getDate() + (d.w + 6) % 7;
                        }
                    } else if ("W" in d || "U" in d) {
                        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                        d.m = 0;
                        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
                    }
                    if ("Z" in d) {
                        d.H += d.Z / 100 | 0;
                        d.M += d.Z % 100;
                        return utcDate(d);
                    }
                    return localDate(d);
                };
            }
            function parseSpecifier(d, specifier, string, j) {
                var i = 0, n = specifier.length, m = string.length, c, parse;
                while(i < n){
                    if (j >= m) return -1;
                    c = specifier.charCodeAt(i++);
                    if (c === 37) {
                        c = specifier.charAt(i++);
                        parse = parses[c in pads ? specifier.charAt(i++) : c];
                        if (!parse || (j = parse(d, string, j)) < 0) return -1;
                    } else if (c != string.charCodeAt(j++)) return -1;
                }
                return j;
            }
            function parsePeriod(d, string, i) {
                var n = periodRe.exec(string.slice(i));
                return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
            }
            function parseShortWeekday(d, string, i) {
                var n = shortWeekdayRe.exec(string.slice(i));
                return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
            }
            function parseWeekday(d, string, i) {
                var n = weekdayRe.exec(string.slice(i));
                return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
            }
            function parseShortMonth(d, string, i) {
                var n = shortMonthRe.exec(string.slice(i));
                return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
            }
            function parseMonth(d, string, i) {
                var n = monthRe.exec(string.slice(i));
                return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
            }
            function parseLocaleDateTime(d, string, i) {
                return parseSpecifier(d, locale_dateTime, string, i);
            }
            function parseLocaleDate(d, string, i) {
                return parseSpecifier(d, locale_date, string, i);
            }
            function parseLocaleTime(d, string, i) {
                return parseSpecifier(d, locale_time, string, i);
            }
            function formatShortWeekday(d) {
                return locale_shortWeekdays[d.getDay()];
            }
            function formatWeekday(d) {
                return locale_weekdays[d.getDay()];
            }
            function formatShortMonth(d) {
                return locale_shortMonths[d.getMonth()];
            }
            function formatMonth(d) {
                return locale_months[d.getMonth()];
            }
            function formatPeriod(d) {
                return locale_periods[+(d.getHours() >= 12)];
            }
            function formatQuarter(d) {
                return 1 + ~~(d.getMonth() / 3);
            }
            function formatUTCShortWeekday(d) {
                return locale_shortWeekdays[d.getUTCDay()];
            }
            function formatUTCWeekday(d) {
                return locale_weekdays[d.getUTCDay()];
            }
            function formatUTCShortMonth(d) {
                return locale_shortMonths[d.getUTCMonth()];
            }
            function formatUTCMonth(d) {
                return locale_months[d.getUTCMonth()];
            }
            function formatUTCPeriod(d) {
                return locale_periods[+(d.getUTCHours() >= 12)];
            }
            function formatUTCQuarter(d) {
                return 1 + ~~(d.getUTCMonth() / 3);
            }
            return {
                format: function(specifier) {
                    var f = newFormat(specifier += "", formats);
                    f.toString = function() {
                        return specifier;
                    };
                    return f;
                },
                parse: function(specifier) {
                    var p = newParse(specifier += "", false);
                    p.toString = function() {
                        return specifier;
                    };
                    return p;
                },
                utcFormat: function(specifier) {
                    var f = newFormat(specifier += "", utcFormats);
                    f.toString = function() {
                        return specifier;
                    };
                    return f;
                },
                utcParse: function(specifier) {
                    var p = newParse(specifier += "", true);
                    p.toString = function() {
                        return specifier;
                    };
                    return p;
                }
            };
        }
        var pads = {
            "-": "",
            "_": " ",
            "0": "0"
        }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
        function pad(value, fill, width) {
            var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
            return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
        }
        function requote(s) {
            return s.replace(requoteRe, "\\$&");
        }
        function formatRe(names) {
            return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
        }
        function formatLookup(names) {
            return new Map(names.map((name, i)=>[
                    name.toLowerCase(),
                    i
                ]));
        }
        function parseWeekdayNumberSunday(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 1));
            return n ? (d.w = +n[0], i + n[0].length) : -1;
        }
        function parseWeekdayNumberMonday(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 1));
            return n ? (d.u = +n[0], i + n[0].length) : -1;
        }
        function parseWeekNumberSunday(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.U = +n[0], i + n[0].length) : -1;
        }
        function parseWeekNumberISO(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.V = +n[0], i + n[0].length) : -1;
        }
        function parseWeekNumberMonday(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.W = +n[0], i + n[0].length) : -1;
        }
        function parseFullYear(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 4));
            return n ? (d.y = +n[0], i + n[0].length) : -1;
        }
        function parseYear(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
        }
        function parseZone(d, string, i) {
            var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
            return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
        }
        function parseQuarter(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 1));
            return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
        }
        function parseMonthNumber(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
        }
        function parseDayOfMonth(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.d = +n[0], i + n[0].length) : -1;
        }
        function parseDayOfYear(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 3));
            return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
        }
        function parseHour24(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.H = +n[0], i + n[0].length) : -1;
        }
        function parseMinutes(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.M = +n[0], i + n[0].length) : -1;
        }
        function parseSeconds(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 2));
            return n ? (d.S = +n[0], i + n[0].length) : -1;
        }
        function parseMilliseconds(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 3));
            return n ? (d.L = +n[0], i + n[0].length) : -1;
        }
        function parseMicroseconds(d, string, i) {
            var n = numberRe.exec(string.slice(i, i + 6));
            return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
        }
        function parseLiteralPercent(d, string, i) {
            var n = percentRe.exec(string.slice(i, i + 1));
            return n ? i + n[0].length : -1;
        }
        function parseUnixTimestamp(d, string, i) {
            var n = numberRe.exec(string.slice(i));
            return n ? (d.Q = +n[0], i + n[0].length) : -1;
        }
        function parseUnixTimestampSeconds(d, string, i) {
            var n = numberRe.exec(string.slice(i));
            return n ? (d.s = +n[0], i + n[0].length) : -1;
        }
        function formatDayOfMonth(d, p) {
            return pad(d.getDate(), p, 2);
        }
        function formatHour24(d, p) {
            return pad(d.getHours(), p, 2);
        }
        function formatHour12(d, p) {
            return pad(d.getHours() % 12 || 12, p, 2);
        }
        function formatDayOfYear(d, p) {
            return pad(1 + timeDay.count(timeYear(d), d), p, 3);
        }
        function formatMilliseconds(d, p) {
            return pad(d.getMilliseconds(), p, 3);
        }
        function formatMicroseconds(d, p) {
            return formatMilliseconds(d, p) + "000";
        }
        function formatMonthNumber(d, p) {
            return pad(d.getMonth() + 1, p, 2);
        }
        function formatMinutes(d, p) {
            return pad(d.getMinutes(), p, 2);
        }
        function formatSeconds(d, p) {
            return pad(d.getSeconds(), p, 2);
        }
        function formatWeekdayNumberMonday(d) {
            var day = d.getDay();
            return day === 0 ? 7 : day;
        }
        function formatWeekNumberSunday(d, p) {
            return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
        }
        function dISO(d) {
            var day = d.getDay();
            return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
        }
        function formatWeekNumberISO(d, p) {
            d = dISO(d);
            return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
        }
        function formatWeekdayNumberSunday(d) {
            return d.getDay();
        }
        function formatWeekNumberMonday(d, p) {
            return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
        }
        function formatYear(d, p) {
            return pad(d.getFullYear() % 100, p, 2);
        }
        function formatYearISO(d, p) {
            d = dISO(d);
            return pad(d.getFullYear() % 100, p, 2);
        }
        function formatFullYear(d, p) {
            return pad(d.getFullYear() % 10000, p, 4);
        }
        function formatFullYearISO(d, p) {
            var day = d.getDay();
            d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
            return pad(d.getFullYear() % 10000, p, 4);
        }
        function formatZone(d) {
            var z = d.getTimezoneOffset();
            return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
        }
        function formatUTCDayOfMonth(d, p) {
            return pad(d.getUTCDate(), p, 2);
        }
        function formatUTCHour24(d, p) {
            return pad(d.getUTCHours(), p, 2);
        }
        function formatUTCHour12(d, p) {
            return pad(d.getUTCHours() % 12 || 12, p, 2);
        }
        function formatUTCDayOfYear(d, p) {
            return pad(1 + utcDay.count(utcYear(d), d), p, 3);
        }
        function formatUTCMilliseconds(d, p) {
            return pad(d.getUTCMilliseconds(), p, 3);
        }
        function formatUTCMicroseconds(d, p) {
            return formatUTCMilliseconds(d, p) + "000";
        }
        function formatUTCMonthNumber(d, p) {
            return pad(d.getUTCMonth() + 1, p, 2);
        }
        function formatUTCMinutes(d, p) {
            return pad(d.getUTCMinutes(), p, 2);
        }
        function formatUTCSeconds(d, p) {
            return pad(d.getUTCSeconds(), p, 2);
        }
        function formatUTCWeekdayNumberMonday(d) {
            var dow = d.getUTCDay();
            return dow === 0 ? 7 : dow;
        }
        function formatUTCWeekNumberSunday(d, p) {
            return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
        }
        function UTCdISO(d) {
            var day = d.getUTCDay();
            return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
        }
        function formatUTCWeekNumberISO(d, p) {
            d = UTCdISO(d);
            return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
        }
        function formatUTCWeekdayNumberSunday(d) {
            return d.getUTCDay();
        }
        function formatUTCWeekNumberMonday(d, p) {
            return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
        }
        function formatUTCYear(d, p) {
            return pad(d.getUTCFullYear() % 100, p, 2);
        }
        function formatUTCYearISO(d, p) {
            d = UTCdISO(d);
            return pad(d.getUTCFullYear() % 100, p, 2);
        }
        function formatUTCFullYear(d, p) {
            return pad(d.getUTCFullYear() % 10000, p, 4);
        }
        function formatUTCFullYearISO(d, p) {
            var day = d.getUTCDay();
            d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
            return pad(d.getUTCFullYear() % 10000, p, 4);
        }
        function formatUTCZone() {
            return "+0000";
        }
        function formatLiteralPercent() {
            return "%";
        }
        function formatUnixTimestamp(d) {
            return +d;
        }
        function formatUnixTimestampSeconds(d) {
            return Math.floor(+d / 1000);
        }
        var locale;
        exports1.timeFormat = void 0;
        exports1.timeParse = void 0;
        exports1.utcFormat = void 0;
        exports1.utcParse = void 0;
        defaultLocale({
            dateTime: "%x, %X",
            date: "%-m/%-d/%Y",
            time: "%-I:%M:%S %p",
            periods: [
                "AM",
                "PM"
            ],
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            shortDays: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            shortMonths: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ]
        });
        function defaultLocale(definition) {
            locale = formatLocale(definition);
            exports1.timeFormat = locale.format;
            exports1.timeParse = locale.parse;
            exports1.utcFormat = locale.utcFormat;
            exports1.utcParse = locale.utcParse;
            return locale;
        }
        var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
        function formatIsoNative(date) {
            return date.toISOString();
        }
        var formatIso = Date.prototype.toISOString ? formatIsoNative : exports1.utcFormat(isoSpecifier);
        var formatIso$1 = formatIso;
        function parseIsoNative(string) {
            var date = new Date(string);
            return isNaN(date) ? null : date;
        }
        var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : exports1.utcParse(isoSpecifier);
        var parseIso$1 = parseIso;
        function date(t) {
            return new Date(t);
        }
        function number(t) {
            return t instanceof Date ? +t : +new Date(+t);
        }
        function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
            var scale = continuous(), invert = scale.invert, domain = scale.domain;
            var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
            function tickFormat(date) {
                return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
            }
            scale.invert = function(y) {
                return new Date(invert(y));
            };
            scale.domain = function(_) {
                return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
            };
            scale.ticks = function(interval) {
                var d = domain();
                return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
            };
            scale.tickFormat = function(count, specifier) {
                return specifier == null ? tickFormat : format(specifier);
            };
            scale.nice = function(interval) {
                var d = domain();
                if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
                return interval ? domain(nice(d, interval)) : scale;
            };
            scale.copy = function() {
                return copy$1(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
            };
            return scale;
        }
        function time() {
            return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, exports1.timeFormat).domain([
                new Date(2000, 0, 1),
                new Date(2000, 0, 2)
            ]), arguments);
        }
        function utcTime() {
            return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, exports1.utcFormat).domain([
                Date.UTC(2000, 0, 1),
                Date.UTC(2000, 0, 2)
            ]), arguments);
        }
        function transformer$1() {
            var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity$3, clamp = false, unknown;
            function scale(x) {
                return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
            }
            scale.domain = function(_) {
                return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
                    x0,
                    x1
                ];
            };
            scale.clamp = function(_) {
                return arguments.length ? (clamp = !!_, scale) : clamp;
            };
            scale.interpolator = function(_) {
                return arguments.length ? (interpolator = _, scale) : interpolator;
            };
            function range(interpolate) {
                return function(_) {
                    var r0, r1;
                    return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                        interpolator(0),
                        interpolator(1)
                    ];
                };
            }
            scale.range = range(interpolate$2);
            scale.rangeRound = range(interpolateRound);
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            return function(t) {
                transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
                return scale;
            };
        }
        function copy(source, target) {
            return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
        }
        function sequential() {
            var scale = linearish(transformer$1()(identity$3));
            scale.copy = function() {
                return copy(scale, sequential());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function sequentialLog() {
            var scale = loggish(transformer$1()).domain([
                1,
                10
            ]);
            scale.copy = function() {
                return copy(scale, sequentialLog()).base(scale.base());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function sequentialSymlog() {
            var scale = symlogish(transformer$1());
            scale.copy = function() {
                return copy(scale, sequentialSymlog()).constant(scale.constant());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function sequentialPow() {
            var scale = powish(transformer$1());
            scale.copy = function() {
                return copy(scale, sequentialPow()).exponent(scale.exponent());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function sequentialSqrt() {
            return sequentialPow.apply(null, arguments).exponent(0.5);
        }
        function sequentialQuantile() {
            var domain = [], interpolator = identity$3;
            function scale(x) {
                if (x != null && !isNaN(x = +x)) return interpolator((bisect(domain, x, 1) - 1) / (domain.length - 1));
            }
            scale.domain = function(_) {
                if (!arguments.length) return domain.slice();
                domain = [];
                for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
                domain.sort(ascending$3);
                return scale;
            };
            scale.interpolator = function(_) {
                return arguments.length ? (interpolator = _, scale) : interpolator;
            };
            scale.range = function() {
                return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
            };
            scale.quantiles = function(n) {
                return Array.from({
                    length: n + 1
                }, (_, i)=>quantile$1(domain, i / n));
            };
            scale.copy = function() {
                return sequentialQuantile(interpolator).domain(domain);
            };
            return initInterpolator.apply(scale, arguments);
        }
        function transformer() {
            var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = identity$3, transform, clamp = false, unknown;
            function scale(x) {
                return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
            }
            scale.domain = function(_) {
                return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
                    x0,
                    x1,
                    x2
                ];
            };
            scale.clamp = function(_) {
                return arguments.length ? (clamp = !!_, scale) : clamp;
            };
            scale.interpolator = function(_) {
                return arguments.length ? (interpolator = _, scale) : interpolator;
            };
            function range(interpolate) {
                return function(_) {
                    var r0, r1, r2;
                    return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [
                        r0,
                        r1,
                        r2
                    ]), scale) : [
                        interpolator(0),
                        interpolator(0.5),
                        interpolator(1)
                    ];
                };
            }
            scale.range = range(interpolate$2);
            scale.rangeRound = range(interpolateRound);
            scale.unknown = function(_) {
                return arguments.length ? (unknown = _, scale) : unknown;
            };
            return function(t) {
                transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
                return scale;
            };
        }
        function diverging$1() {
            var scale = linearish(transformer()(identity$3));
            scale.copy = function() {
                return copy(scale, diverging$1());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function divergingLog() {
            var scale = loggish(transformer()).domain([
                0.1,
                1,
                10
            ]);
            scale.copy = function() {
                return copy(scale, divergingLog()).base(scale.base());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function divergingSymlog() {
            var scale = symlogish(transformer());
            scale.copy = function() {
                return copy(scale, divergingSymlog()).constant(scale.constant());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function divergingPow() {
            var scale = powish(transformer());
            scale.copy = function() {
                return copy(scale, divergingPow()).exponent(scale.exponent());
            };
            return initInterpolator.apply(scale, arguments);
        }
        function divergingSqrt() {
            return divergingPow.apply(null, arguments).exponent(0.5);
        }
        function colors(specifier) {
            var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
            while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
            return colors;
        }
        var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
        var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
        var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
        var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
        var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
        var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
        var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
        var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
        var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
        var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
        var ramp$1 = (scheme)=>rgbBasis(scheme[scheme.length - 1]);
        var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
        var BrBG = ramp$1(scheme$q);
        var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
        var PRGn = ramp$1(scheme$p);
        var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
        var PiYG = ramp$1(scheme$o);
        var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
        var PuOr = ramp$1(scheme$n);
        var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
        var RdBu = ramp$1(scheme$m);
        var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
        var RdGy = ramp$1(scheme$l);
        var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
        var RdYlBu = ramp$1(scheme$k);
        var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
        var RdYlGn = ramp$1(scheme$j);
        var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
        var Spectral = ramp$1(scheme$i);
        var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
        var BuGn = ramp$1(scheme$h);
        var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
        var BuPu = ramp$1(scheme$g);
        var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
        var GnBu = ramp$1(scheme$f);
        var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
        var OrRd = ramp$1(scheme$e);
        var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
        var PuBuGn = ramp$1(scheme$d);
        var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
        var PuBu = ramp$1(scheme$c);
        var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
        var PuRd = ramp$1(scheme$b);
        var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
        var RdPu = ramp$1(scheme$a);
        var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
        var YlGnBu = ramp$1(scheme$9);
        var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
        var YlGn = ramp$1(scheme$8);
        var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
        var YlOrBr = ramp$1(scheme$7);
        var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
        var YlOrRd = ramp$1(scheme$6);
        var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
        var Blues = ramp$1(scheme$5);
        var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
        var Greens = ramp$1(scheme$4);
        var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
        var Greys = ramp$1(scheme$3);
        var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
        var Purples = ramp$1(scheme$2);
        var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
        var Reds = ramp$1(scheme$1);
        var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
        var Oranges = ramp$1(scheme);
        function cividis(t) {
            t = Math.max(0, Math.min(1, t));
            return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
        }
        var cubehelix = cubehelixLong(cubehelix$3(300, 0.5, 0.0), cubehelix$3(-240, 0.5, 1.0));
        var warm = cubehelixLong(cubehelix$3(-100, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
        var cool = cubehelixLong(cubehelix$3(260, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
        var c$2 = cubehelix$3();
        function rainbow(t) {
            if (t < 0 || t > 1) t -= Math.floor(t);
            var ts = Math.abs(t - 0.5);
            c$2.h = 360 * t - 100;
            c$2.s = 1.5 - 1.5 * ts;
            c$2.l = 0.8 - 0.9 * ts;
            return c$2 + "";
        }
        var c$1 = rgb(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;
        function sinebow(t) {
            var x;
            t = (0.5 - t) * Math.PI;
            c$1.r = 255 * (x = Math.sin(t)) * x;
            c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
            c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
            return c$1 + "";
        }
        function turbo(t) {
            t = Math.max(0, Math.min(1, t));
            return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
        }
        function ramp(range) {
            var n = range.length;
            return function(t) {
                return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
            };
        }
        var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
        var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
        var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
        var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
        function constant$1(x) {
            return function constant() {
                return x;
            };
        }
        const abs = Math.abs;
        const atan2 = Math.atan2;
        const cos = Math.cos;
        const max = Math.max;
        const min = Math.min;
        const sin = Math.sin;
        const sqrt = Math.sqrt;
        const epsilon = 1e-12;
        const pi = Math.PI;
        const halfPi = pi / 2;
        const tau = 2 * pi;
        function acos(x) {
            return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
        }
        function asin(x) {
            return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
        }
        function arcInnerRadius(d) {
            return d.innerRadius;
        }
        function arcOuterRadius(d) {
            return d.outerRadius;
        }
        function arcStartAngle(d) {
            return d.startAngle;
        }
        function arcEndAngle(d) {
            return d.endAngle;
        }
        function arcPadAngle(d) {
            return d && d.padAngle;
        }
        function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
            var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
            if (t * t < epsilon) return;
            t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
            return [
                x0 + t * x10,
                y0 + t * y10
            ];
        }
        function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
            var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
            if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
            return {
                cx: cx0,
                cy: cy0,
                x01: -ox,
                y01: -oy,
                x11: cx0 * (r1 / r - 1),
                y11: cy0 * (r1 / r - 1)
            };
        }
        function arc() {
            var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$1(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
            function arc() {
                var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
                if (!context) context = buffer = path();
                if (r1 < r0) r = r1, r1 = r0, r0 = r;
                if (!(r1 > epsilon)) context.moveTo(0, 0);
                else if (da > tau - epsilon) {
                    context.moveTo(r1 * cos(a0), r1 * sin(a0));
                    context.arc(0, 0, r1, a0, a1, !cw);
                    if (r0 > epsilon) {
                        context.moveTo(r0 * cos(a1), r0 * sin(a1));
                        context.arc(0, 0, r0, a1, a0, cw);
                    }
                } else {
                    var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                    if (rp > epsilon) {
                        var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
                        if ((da0 -= p0 * 2) > epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                        if ((da1 -= p1 * 2) > epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                    }
                    var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
                    if (rc > epsilon) {
                        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
                        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = min(rc, (r0 - lc) / (kc - 1));
                            rc1 = min(rc, (r1 - lc) / (kc + 1));
                        }
                    }
                    if (!(da1 > epsilon)) context.moveTo(x01, y01);
                    else if (rc1 > epsilon) {
                        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                        else {
                            context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                            context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                            context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                        }
                    } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                    if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
                    else if (rc0 > epsilon) {
                        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                        else {
                            context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                            context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                            context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                        }
                    } else context.arc(0, 0, r0, a10, a00, cw);
                }
                context.closePath();
                if (buffer) return context = null, buffer + "" || null;
            }
            arc.centroid = function() {
                var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
                return [
                    cos(a) * r,
                    sin(a) * r
                ];
            };
            arc.innerRadius = function(_) {
                return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
            };
            arc.outerRadius = function(_) {
                return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
            };
            arc.cornerRadius = function(_) {
                return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
            };
            arc.padRadius = function(_) {
                return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
            };
            arc.startAngle = function(_) {
                return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
            };
            arc.endAngle = function(_) {
                return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
            };
            arc.padAngle = function(_) {
                return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
            };
            arc.context = function(_) {
                return arguments.length ? (context = _ == null ? null : _, arc) : context;
            };
            return arc;
        }
        var slice = Array.prototype.slice;
        function array(x) {
            return typeof x === "object" && "length" in x ? x : Array.from(x);
        }
        function Linear(context) {
            this._context = context;
        }
        Linear.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._point = 0;
            },
            lineEnd: function() {
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                    default:
                        this._context.lineTo(x, y);
                        break;
                }
            }
        };
        function curveLinear(context) {
            return new Linear(context);
        }
        function x$1(p) {
            return p[0];
        }
        function y(p) {
            return p[1];
        }
        function line(x, y$1) {
            var defined = constant$1(true), context = null, curve = curveLinear, output = null;
            x = typeof x === "function" ? x : x === undefined ? x$1 : constant$1(x);
            y$1 = typeof y$1 === "function" ? y$1 : y$1 === undefined ? y : constant$1(y$1);
            function line(data) {
                var i, n = (data = array(data)).length, d, defined0 = false, buffer;
                if (context == null) output = curve(buffer = path());
                for(i = 0; i <= n; ++i){
                    if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                        if (defined0 = !defined0) output.lineStart();
                        else output.lineEnd();
                    }
                    if (defined0) output.point(+x(d, i, data), +y$1(d, i, data));
                }
                if (buffer) return output = null, buffer + "" || null;
            }
            line.x = function(_) {
                return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), line) : x;
            };
            line.y = function(_) {
                return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$1;
            };
            line.defined = function(_) {
                return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
            };
            line.curve = function(_) {
                return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
            };
            line.context = function(_) {
                return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
            };
            return line;
        }
        function area(x0, y0, y1) {
            var x1 = null, defined = constant$1(true), context = null, curve = curveLinear, output = null;
            x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x$1 : constant$1(+x0);
            y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$1(0) : constant$1(+y0);
            y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y : constant$1(+y1);
            function area(data) {
                var i, j, k, n = (data = array(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
                if (context == null) output = curve(buffer = path());
                for(i = 0; i <= n; ++i){
                    if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                        if (defined0 = !defined0) {
                            j = i;
                            output.areaStart();
                            output.lineStart();
                        } else {
                            output.lineEnd();
                            output.lineStart();
                            for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                            output.lineEnd();
                            output.areaEnd();
                        }
                    }
                    if (defined0) {
                        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                    }
                }
                if (buffer) return output = null, buffer + "" || null;
            }
            function arealine() {
                return line().defined(defined).curve(curve).context(context);
            }
            area.x = function(_) {
                return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
            };
            area.x0 = function(_) {
                return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
            };
            area.x1 = function(_) {
                return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
            };
            area.y = function(_) {
                return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
            };
            area.y0 = function(_) {
                return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
            };
            area.y1 = function(_) {
                return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
            };
            area.lineX0 = area.lineY0 = function() {
                return arealine().x(x0).y(y0);
            };
            area.lineY1 = function() {
                return arealine().x(x0).y(y1);
            };
            area.lineX1 = function() {
                return arealine().x(x1).y(y0);
            };
            area.defined = function(_) {
                return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
            };
            area.curve = function(_) {
                return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
            };
            area.context = function(_) {
                return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
            };
            return area;
        }
        function descending$1(a, b) {
            return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
        }
        function identity$1(d) {
            return d;
        }
        function pie() {
            var value = identity$1, sortValues = descending$1, sort = null, startAngle = constant$1(0), endAngle = constant$1(tau), padAngle = constant$1(0);
            function pie(data) {
                var i, n = (data = array(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
                for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
                if (sortValues != null) index.sort(function(i, j) {
                    return sortValues(arcs[i], arcs[j]);
                });
                else if (sort != null) index.sort(function(i, j) {
                    return sort(data[i], data[j]);
                });
                for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                    data: data[j],
                    index: i,
                    value: v,
                    startAngle: a0,
                    endAngle: a1,
                    padAngle: p
                };
                return arcs;
            }
            pie.value = function(_) {
                return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
            };
            pie.sortValues = function(_) {
                return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
            };
            pie.sort = function(_) {
                return arguments.length ? (sort = _, sortValues = null, pie) : sort;
            };
            pie.startAngle = function(_) {
                return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
            };
            pie.endAngle = function(_) {
                return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
            };
            pie.padAngle = function(_) {
                return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
            };
            return pie;
        }
        var curveRadialLinear = curveRadial(curveLinear);
        function Radial(curve) {
            this._curve = curve;
        }
        Radial.prototype = {
            areaStart: function() {
                this._curve.areaStart();
            },
            areaEnd: function() {
                this._curve.areaEnd();
            },
            lineStart: function() {
                this._curve.lineStart();
            },
            lineEnd: function() {
                this._curve.lineEnd();
            },
            point: function(a, r) {
                this._curve.point(r * Math.sin(a), r * -Math.cos(a));
            }
        };
        function curveRadial(curve) {
            function radial(context) {
                return new Radial(curve(context));
            }
            radial._curve = curve;
            return radial;
        }
        function lineRadial(l) {
            var c = l.curve;
            l.angle = l.x, delete l.x;
            l.radius = l.y, delete l.y;
            l.curve = function(_) {
                return arguments.length ? c(curveRadial(_)) : c()._curve;
            };
            return l;
        }
        function lineRadial$1() {
            return lineRadial(line().curve(curveRadialLinear));
        }
        function areaRadial() {
            var a = area().curve(curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
            a.angle = a.x, delete a.x;
            a.startAngle = a.x0, delete a.x0;
            a.endAngle = a.x1, delete a.x1;
            a.radius = a.y, delete a.y;
            a.innerRadius = a.y0, delete a.y0;
            a.outerRadius = a.y1, delete a.y1;
            a.lineStartAngle = function() {
                return lineRadial(x0());
            }, delete a.lineX0;
            a.lineEndAngle = function() {
                return lineRadial(x1());
            }, delete a.lineX1;
            a.lineInnerRadius = function() {
                return lineRadial(y0());
            }, delete a.lineY0;
            a.lineOuterRadius = function() {
                return lineRadial(y1());
            }, delete a.lineY1;
            a.curve = function(_) {
                return arguments.length ? c(curveRadial(_)) : c()._curve;
            };
            return a;
        }
        function pointRadial(x, y) {
            return [
                (y = +y) * Math.cos(x -= Math.PI / 2),
                y * Math.sin(x)
            ];
        }
        class Bump {
            constructor(context, x){
                this._context = context;
                this._x = x;
            }
            areaStart() {
                this._line = 0;
            }
            areaEnd() {
                this._line = NaN;
            }
            lineStart() {
                this._point = 0;
            }
            lineEnd() {
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            }
            point(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        if (this._line) this._context.lineTo(x, y);
                        else this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                    default:
                        if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                        else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                        break;
                }
                this._x0 = x, this._y0 = y;
            }
        }
        class BumpRadial {
            constructor(context){
                this._context = context;
            }
            lineStart() {
                this._point = 0;
            }
            lineEnd() {}
            point(x, y) {
                x = +x, y = +y;
                if (this._point++ === 0) this._x0 = x, this._y0 = y;
                else {
                    const p0 = pointRadial(this._x0, this._y0);
                    const p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
                    const p2 = pointRadial(x, this._y0);
                    const p3 = pointRadial(x, y);
                    this._context.moveTo(...p0);
                    this._context.bezierCurveTo(...p1, ...p2, ...p3);
                }
            }
        }
        function bumpX(context) {
            return new Bump(context, true);
        }
        function bumpY(context) {
            return new Bump(context, false);
        }
        function bumpRadial(context) {
            return new BumpRadial(context);
        }
        function linkSource(d) {
            return d.source;
        }
        function linkTarget(d) {
            return d.target;
        }
        function link(curve) {
            let source = linkSource;
            let target = linkTarget;
            let x = x$1;
            let y$1 = y;
            let context = null;
            let output = null;
            function link() {
                let buffer;
                const argv = slice.call(arguments);
                const s = source.apply(this, argv);
                const t = target.apply(this, argv);
                if (context == null) output = curve(buffer = path());
                output.lineStart();
                argv[0] = s, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
                argv[0] = t, output.point(+x.apply(this, argv), +y$1.apply(this, argv));
                output.lineEnd();
                if (buffer) return output = null, buffer + "" || null;
            }
            link.source = function(_) {
                return arguments.length ? (source = _, link) : source;
            };
            link.target = function(_) {
                return arguments.length ? (target = _, link) : target;
            };
            link.x = function(_) {
                return arguments.length ? (x = typeof _ === "function" ? _ : constant$1(+_), link) : x;
            };
            link.y = function(_) {
                return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), link) : y$1;
            };
            link.context = function(_) {
                return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
            };
            return link;
        }
        function linkHorizontal() {
            return link(bumpX);
        }
        function linkVertical() {
            return link(bumpY);
        }
        function linkRadial() {
            const l = link(bumpRadial);
            l.angle = l.x, delete l.x;
            l.radius = l.y, delete l.y;
            return l;
        }
        const sqrt3$2 = sqrt(3);
        var asterisk = {
            draw (context, size) {
                const r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
                const t = r / 2;
                const u = t * sqrt3$2;
                context.moveTo(0, r);
                context.lineTo(0, -r);
                context.moveTo(-u, -t);
                context.lineTo(u, t);
                context.moveTo(-u, t);
                context.lineTo(u, -t);
            }
        };
        var circle = {
            draw (context, size) {
                const r = sqrt(size / pi);
                context.moveTo(r, 0);
                context.arc(0, 0, r, 0, tau);
            }
        };
        var cross = {
            draw (context, size) {
                const r = sqrt(size / 5) / 2;
                context.moveTo(-3 * r, -r);
                context.lineTo(-r, -r);
                context.lineTo(-r, -3 * r);
                context.lineTo(r, -3 * r);
                context.lineTo(r, -r);
                context.lineTo(3 * r, -r);
                context.lineTo(3 * r, r);
                context.lineTo(r, r);
                context.lineTo(r, 3 * r);
                context.lineTo(-r, 3 * r);
                context.lineTo(-r, r);
                context.lineTo(-3 * r, r);
                context.closePath();
            }
        };
        const tan30 = sqrt(1 / 3);
        const tan30_2 = tan30 * 2;
        var diamond = {
            draw (context, size) {
                const y = sqrt(size / tan30_2);
                const x = y * tan30;
                context.moveTo(0, -y);
                context.lineTo(x, 0);
                context.lineTo(0, y);
                context.lineTo(-x, 0);
                context.closePath();
            }
        };
        var diamond2 = {
            draw (context, size) {
                const r = sqrt(size) * 0.62625;
                context.moveTo(0, -r);
                context.lineTo(r, 0);
                context.lineTo(0, r);
                context.lineTo(-r, 0);
                context.closePath();
            }
        };
        var plus = {
            draw (context, size) {
                const r = sqrt(size - min(size / 7, 2)) * 0.87559;
                context.moveTo(-r, 0);
                context.lineTo(r, 0);
                context.moveTo(0, r);
                context.lineTo(0, -r);
            }
        };
        var square = {
            draw (context, size) {
                const w = sqrt(size);
                const x = -w / 2;
                context.rect(x, x, w, w);
            }
        };
        var square2 = {
            draw (context, size) {
                const r = sqrt(size) * 0.4431;
                context.moveTo(r, r);
                context.lineTo(r, -r);
                context.lineTo(-r, -r);
                context.lineTo(-r, r);
                context.closePath();
            }
        };
        const ka = 0.89081309152928522810;
        const kr = sin(pi / 10) / sin(7 * pi / 10);
        const kx = sin(tau / 10) * kr;
        const ky = -cos(tau / 10) * kr;
        var star = {
            draw (context, size) {
                const r = sqrt(size * ka);
                const x = kx * r;
                const y = ky * r;
                context.moveTo(0, -r);
                context.lineTo(x, y);
                for(let i = 1; i < 5; ++i){
                    const a = tau * i / 5;
                    const c = cos(a);
                    const s = sin(a);
                    context.lineTo(s * r, -c * r);
                    context.lineTo(c * x - s * y, s * x + c * y);
                }
                context.closePath();
            }
        };
        const sqrt3$1 = sqrt(3);
        var triangle = {
            draw (context, size) {
                const y = -sqrt(size / (sqrt3$1 * 3));
                context.moveTo(0, y * 2);
                context.lineTo(-sqrt3$1 * y, -y);
                context.lineTo(sqrt3$1 * y, -y);
                context.closePath();
            }
        };
        const sqrt3 = sqrt(3);
        var triangle2 = {
            draw (context, size) {
                const s = sqrt(size) * 0.6824;
                const t = s / 2;
                const u = s * sqrt3 / 2;
                context.moveTo(0, -s);
                context.lineTo(u, t);
                context.lineTo(-u, t);
                context.closePath();
            }
        };
        const c = -0.5;
        const s = sqrt(3) / 2;
        const k = 1 / sqrt(12);
        const a = (k / 2 + 1) * 3;
        var wye = {
            draw (context, size) {
                const r = sqrt(size / a);
                const x0 = r / 2, y0 = r * k;
                const x1 = x0, y1 = r * k + r;
                const x2 = -x1, y2 = y1;
                context.moveTo(x0, y0);
                context.lineTo(x1, y1);
                context.lineTo(x2, y2);
                context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
                context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
                context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
                context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
                context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
                context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
                context.closePath();
            }
        };
        var x = {
            draw (context, size) {
                const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
                context.moveTo(-r, -r);
                context.lineTo(r, r);
                context.moveTo(-r, r);
                context.lineTo(r, -r);
            }
        };
        const symbolsFill = [
            circle,
            cross,
            diamond,
            square,
            star,
            triangle,
            wye
        ];
        const symbolsStroke = [
            circle,
            plus,
            x,
            triangle2,
            asterisk,
            square2,
            diamond2
        ];
        function Symbol$1(type, size) {
            let context = null;
            type = typeof type === "function" ? type : constant$1(type || circle);
            size = typeof size === "function" ? size : constant$1(size === undefined ? 64 : +size);
            function symbol() {
                let buffer;
                if (!context) context = buffer = path();
                type.apply(this, arguments).draw(context, +size.apply(this, arguments));
                if (buffer) return context = null, buffer + "" || null;
            }
            symbol.type = function(_) {
                return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
            };
            symbol.size = function(_) {
                return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
            };
            symbol.context = function(_) {
                return arguments.length ? (context = _ == null ? null : _, symbol) : context;
            };
            return symbol;
        }
        function noop() {}
        function point$3(that, x, y) {
            that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
        }
        function Basis(context) {
            this._context = context;
        }
        Basis.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._y0 = this._y1 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 3:
                        point$3(this, this._x1, this._y1);
                    case 2:
                        this._context.lineTo(this._x1, this._y1);
                        break;
                }
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
                    default:
                        point$3(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = x;
                this._y0 = this._y1, this._y1 = y;
            }
        };
        function basis(context) {
            return new Basis(context);
        }
        function BasisClosed(context) {
            this._context = context;
        }
        BasisClosed.prototype = {
            areaStart: noop,
            areaEnd: noop,
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 1:
                        this._context.moveTo(this._x2, this._y2);
                        this._context.closePath();
                        break;
                    case 2:
                        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                        this._context.closePath();
                        break;
                    case 3:
                        this.point(this._x2, this._y2);
                        this.point(this._x3, this._y3);
                        this.point(this._x4, this._y4);
                        break;
                }
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._x2 = x, this._y2 = y;
                        break;
                    case 1:
                        this._point = 2;
                        this._x3 = x, this._y3 = y;
                        break;
                    case 2:
                        this._point = 3;
                        this._x4 = x, this._y4 = y;
                        this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                        break;
                    default:
                        point$3(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = x;
                this._y0 = this._y1, this._y1 = y;
            }
        };
        function basisClosed(context) {
            return new BasisClosed(context);
        }
        function BasisOpen(context) {
            this._context = context;
        }
        BasisOpen.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._y0 = this._y1 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                        var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                        break;
                    case 3:
                        this._point = 4;
                    default:
                        point$3(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = x;
                this._y0 = this._y1, this._y1 = y;
            }
        };
        function basisOpen(context) {
            return new BasisOpen(context);
        }
        function Bundle(context, beta) {
            this._basis = new Basis(context);
            this._beta = beta;
        }
        Bundle.prototype = {
            lineStart: function() {
                this._x = [];
                this._y = [];
                this._basis.lineStart();
            },
            lineEnd: function() {
                var x = this._x, y = this._y, j = x.length - 1;
                if (j > 0) {
                    var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
                    while(++i <= j){
                        t = i / j;
                        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
                    }
                }
                this._x = this._y = null;
                this._basis.lineEnd();
            },
            point: function(x, y) {
                this._x.push(+x);
                this._y.push(+y);
            }
        };
        var bundle = function custom(beta) {
            function bundle(context) {
                return beta === 1 ? new Basis(context) : new Bundle(context, beta);
            }
            bundle.beta = function(beta) {
                return custom(+beta);
            };
            return bundle;
        }(0.85);
        function point$2(that, x, y) {
            that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
        }
        function Cardinal(context, tension) {
            this._context = context;
            this._k = (1 - tension) / 6;
        }
        Cardinal.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 2:
                        this._context.lineTo(this._x2, this._y2);
                        break;
                    case 3:
                        point$2(this, this._x1, this._y1);
                        break;
                }
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                        this._x1 = x, this._y1 = y;
                        break;
                    case 2:
                        this._point = 3;
                    default:
                        point$2(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var cardinal = function custom(tension) {
            function cardinal(context) {
                return new Cardinal(context, tension);
            }
            cardinal.tension = function(tension) {
                return custom(+tension);
            };
            return cardinal;
        }(0);
        function CardinalClosed(context, tension) {
            this._context = context;
            this._k = (1 - tension) / 6;
        }
        CardinalClosed.prototype = {
            areaStart: noop,
            areaEnd: noop,
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 1:
                        this._context.moveTo(this._x3, this._y3);
                        this._context.closePath();
                        break;
                    case 2:
                        this._context.lineTo(this._x3, this._y3);
                        this._context.closePath();
                        break;
                    case 3:
                        this.point(this._x3, this._y3);
                        this.point(this._x4, this._y4);
                        this.point(this._x5, this._y5);
                        break;
                }
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._x3 = x, this._y3 = y;
                        break;
                    case 1:
                        this._point = 2;
                        this._context.moveTo(this._x4 = x, this._y4 = y);
                        break;
                    case 2:
                        this._point = 3;
                        this._x5 = x, this._y5 = y;
                        break;
                    default:
                        point$2(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var cardinalClosed = function custom(tension) {
            function cardinal(context) {
                return new CardinalClosed(context, tension);
            }
            cardinal.tension = function(tension) {
                return custom(+tension);
            };
            return cardinal;
        }(0);
        function CardinalOpen(context, tension) {
            this._context = context;
            this._k = (1 - tension) / 6;
        }
        CardinalOpen.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                        break;
                    case 3:
                        this._point = 4;
                    default:
                        point$2(this, x, y);
                        break;
                }
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var cardinalOpen = function custom(tension) {
            function cardinal(context) {
                return new CardinalOpen(context, tension);
            }
            cardinal.tension = function(tension) {
                return custom(+tension);
            };
            return cardinal;
        }(0);
        function point$1(that, x, y) {
            var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
            if (that._l01_a > epsilon) {
                var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
                x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
                y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
            }
            if (that._l23_a > epsilon) {
                var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
                x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
                y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
            }
            that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
        }
        function CatmullRom(context, alpha) {
            this._context = context;
            this._alpha = alpha;
        }
        CatmullRom.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
                this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 2:
                        this._context.lineTo(this._x2, this._y2);
                        break;
                    case 3:
                        this.point(this._x2, this._y2);
                        break;
                }
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                if (this._point) {
                    var x23 = this._x2 - x, y23 = this._y2 - y;
                    this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
                }
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                    default:
                        point$1(this, x, y);
                        break;
                }
                this._l01_a = this._l12_a, this._l12_a = this._l23_a;
                this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var catmullRom = function custom(alpha) {
            function catmullRom(context) {
                return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
            }
            catmullRom.alpha = function(alpha) {
                return custom(+alpha);
            };
            return catmullRom;
        }(0.5);
        function CatmullRomClosed(context, alpha) {
            this._context = context;
            this._alpha = alpha;
        }
        CatmullRomClosed.prototype = {
            areaStart: noop,
            areaEnd: noop,
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
                this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 1:
                        this._context.moveTo(this._x3, this._y3);
                        this._context.closePath();
                        break;
                    case 2:
                        this._context.lineTo(this._x3, this._y3);
                        this._context.closePath();
                        break;
                    case 3:
                        this.point(this._x3, this._y3);
                        this.point(this._x4, this._y4);
                        this.point(this._x5, this._y5);
                        break;
                }
            },
            point: function(x, y) {
                x = +x, y = +y;
                if (this._point) {
                    var x23 = this._x2 - x, y23 = this._y2 - y;
                    this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
                }
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._x3 = x, this._y3 = y;
                        break;
                    case 1:
                        this._point = 2;
                        this._context.moveTo(this._x4 = x, this._y4 = y);
                        break;
                    case 2:
                        this._point = 3;
                        this._x5 = x, this._y5 = y;
                        break;
                    default:
                        point$1(this, x, y);
                        break;
                }
                this._l01_a = this._l12_a, this._l12_a = this._l23_a;
                this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var catmullRomClosed = function custom(alpha) {
            function catmullRom(context) {
                return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
            }
            catmullRom.alpha = function(alpha) {
                return custom(+alpha);
            };
            return catmullRom;
        }(0.5);
        function CatmullRomOpen(context, alpha) {
            this._context = context;
            this._alpha = alpha;
        }
        CatmullRomOpen.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
                this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
            },
            lineEnd: function() {
                if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                if (this._point) {
                    var x23 = this._x2 - x, y23 = this._y2 - y;
                    this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
                }
                switch(this._point){
                    case 0:
                        this._point = 1;
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                        break;
                    case 3:
                        this._point = 4;
                    default:
                        point$1(this, x, y);
                        break;
                }
                this._l01_a = this._l12_a, this._l12_a = this._l23_a;
                this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
                this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
                this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
            }
        };
        var catmullRomOpen = function custom(alpha) {
            function catmullRom(context) {
                return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
            }
            catmullRom.alpha = function(alpha) {
                return custom(+alpha);
            };
            return catmullRom;
        }(0.5);
        function LinearClosed(context) {
            this._context = context;
        }
        LinearClosed.prototype = {
            areaStart: noop,
            areaEnd: noop,
            lineStart: function() {
                this._point = 0;
            },
            lineEnd: function() {
                if (this._point) this._context.closePath();
            },
            point: function(x, y) {
                x = +x, y = +y;
                if (this._point) this._context.lineTo(x, y);
                else this._point = 1, this._context.moveTo(x, y);
            }
        };
        function linearClosed(context) {
            return new LinearClosed(context);
        }
        function sign(x) {
            return x < 0 ? -1 : 1;
        }
        function slope3(that, x2, y2) {
            var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
            return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
        }
        function slope2(that, t) {
            var h = that._x1 - that._x0;
            return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
        }
        function point(that, t0, t1) {
            var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
            that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
        }
        function MonotoneX(context) {
            this._context = context;
        }
        MonotoneX.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                switch(this._point){
                    case 2:
                        this._context.lineTo(this._x1, this._y1);
                        break;
                    case 3:
                        point(this, this._t0, slope2(this, this._t0));
                        break;
                }
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            },
            point: function(x, y) {
                var t1 = NaN;
                x = +x, y = +y;
                if (x === this._x1 && y === this._y1) return;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                        break;
                    case 2:
                        this._point = 3;
                        point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                        break;
                    default:
                        point(this, this._t0, t1 = slope3(this, x, y));
                        break;
                }
                this._x0 = this._x1, this._x1 = x;
                this._y0 = this._y1, this._y1 = y;
                this._t0 = t1;
            }
        };
        function MonotoneY(context) {
            this._context = new ReflectContext(context);
        }
        (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
            MonotoneX.prototype.point.call(this, y, x);
        };
        function ReflectContext(context) {
            this._context = context;
        }
        ReflectContext.prototype = {
            moveTo: function(x, y) {
                this._context.moveTo(y, x);
            },
            closePath: function() {
                this._context.closePath();
            },
            lineTo: function(x, y) {
                this._context.lineTo(y, x);
            },
            bezierCurveTo: function(x1, y1, x2, y2, x, y) {
                this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
            }
        };
        function monotoneX(context) {
            return new MonotoneX(context);
        }
        function monotoneY(context) {
            return new MonotoneY(context);
        }
        function Natural(context) {
            this._context = context;
        }
        Natural.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x = [];
                this._y = [];
            },
            lineEnd: function() {
                var x = this._x, y = this._y, n = x.length;
                if (n) {
                    this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
                    if (n === 2) this._context.lineTo(x[1], y[1]);
                    else {
                        var px = controlPoints(x), py = controlPoints(y);
                        for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
                    }
                }
                if (this._line || this._line !== 0 && n === 1) this._context.closePath();
                this._line = 1 - this._line;
                this._x = this._y = null;
            },
            point: function(x, y) {
                this._x.push(+x);
                this._y.push(+y);
            }
        };
        function controlPoints(x) {
            var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
            a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
            for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
            a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
            for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
            a[n - 1] = r[n - 1] / b[n - 1];
            for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
            b[n - 1] = (x[n] + a[n - 1]) / 2;
            for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
            return [
                a,
                b
            ];
        }
        function natural(context) {
            return new Natural(context);
        }
        function Step(context, t) {
            this._context = context;
            this._t = t;
        }
        Step.prototype = {
            areaStart: function() {
                this._line = 0;
            },
            areaEnd: function() {
                this._line = NaN;
            },
            lineStart: function() {
                this._x = this._y = NaN;
                this._point = 0;
            },
            lineEnd: function() {
                if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
            },
            point: function(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                    default:
                        if (this._t <= 0) {
                            this._context.lineTo(this._x, y);
                            this._context.lineTo(x, y);
                        } else {
                            var x1 = this._x * (1 - this._t) + x * this._t;
                            this._context.lineTo(x1, this._y);
                            this._context.lineTo(x1, y);
                        }
                        break;
                }
                this._x = x, this._y = y;
            }
        };
        function step(context) {
            return new Step(context, 0.5);
        }
        function stepBefore(context) {
            return new Step(context, 0);
        }
        function stepAfter(context) {
            return new Step(context, 1);
        }
        function none$1(series, order) {
            if (!((n = series.length) > 1)) return;
            for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
                s0 = s1, s1 = series[order[i]];
                for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
            }
        }
        function none(series) {
            var n = series.length, o = new Array(n);
            while(--n >= 0)o[n] = n;
            return o;
        }
        function stackValue(d, key) {
            return d[key];
        }
        function stackSeries(key) {
            const series = [];
            series.key = key;
            return series;
        }
        function stack() {
            var keys = constant$1([]), order = none, offset = none$1, value = stackValue;
            function stack(data) {
                var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
                for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                    0,
                    +value(d, sz[i].key, j, data)
                ]).data = d;
                for(i = 0, oz = array(order(sz)); i < n; ++i)sz[oz[i]].index = i;
                offset(sz, oz);
                return sz;
            }
            stack.keys = function(_) {
                return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys;
            };
            stack.value = function(_) {
                return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
            };
            stack.order = function(_) {
                return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order;
            };
            stack.offset = function(_) {
                return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
            };
            return stack;
        }
        function expand(series, order) {
            if (!((n = series.length) > 0)) return;
            for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
                for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
                if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
            }
            none$1(series, order);
        }
        function diverging(series, order) {
            if (!((n = series.length) > 0)) return;
            for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
                if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
                else if (dy < 0) d[1] = yn, d[0] = yn += dy;
                else d[0] = 0, d[1] = dy;
            }
        }
        function silhouette(series, order) {
            if (!((n = series.length) > 0)) return;
            for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
                for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
                s0[j][1] += s0[j][0] = -y / 2;
            }
            none$1(series, order);
        }
        function wiggle(series, order) {
            if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
            for(var y = 0, j = 1, s0, m, n; j < m; ++j){
                for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                    var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                    for(var k = 0; k < i; ++k){
                        var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                        s3 += skj0 - skj1;
                    }
                    s1 += sij0, s2 += s3 * sij0;
                }
                s0[j - 1][1] += s0[j - 1][0] = y;
                if (s1) y -= s2 / s1;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            none$1(series, order);
        }
        function appearance(series) {
            var peaks = series.map(peak);
            return none(series).sort(function(a, b) {
                return peaks[a] - peaks[b];
            });
        }
        function peak(series) {
            var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
            while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
            return j;
        }
        function ascending(series) {
            var sums = series.map(sum);
            return none(series).sort(function(a, b) {
                return sums[a] - sums[b];
            });
        }
        function sum(series) {
            var s = 0, i = -1, n = series.length, v;
            while(++i < n)if (v = +series[i][1]) s += v;
            return s;
        }
        function descending(series) {
            return ascending(series).reverse();
        }
        function insideOut(series) {
            var n = series.length, i, j, sums = series.map(sum), order = appearance(series), top = 0, bottom = 0, tops = [], bottoms = [];
            for(i = 0; i < n; ++i){
                j = order[i];
                if (top < bottom) {
                    top += sums[j];
                    tops.push(j);
                } else {
                    bottom += sums[j];
                    bottoms.push(j);
                }
            }
            return bottoms.reverse().concat(tops);
        }
        function reverse(series) {
            return none(series).reverse();
        }
        var constant = (x)=>()=>x;
        function ZoomEvent(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
            Object.defineProperties(this, {
                type: {
                    value: type,
                    enumerable: true,
                    configurable: true
                },
                sourceEvent: {
                    value: sourceEvent,
                    enumerable: true,
                    configurable: true
                },
                target: {
                    value: target,
                    enumerable: true,
                    configurable: true
                },
                transform: {
                    value: transform,
                    enumerable: true,
                    configurable: true
                },
                _: {
                    value: dispatch
                }
            });
        }
        function Transform(k, x, y) {
            this.k = k;
            this.x = x;
            this.y = y;
        }
        Transform.prototype = {
            constructor: Transform,
            scale: function(k) {
                return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
            },
            translate: function(x, y) {
                return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
            },
            apply: function(point) {
                return [
                    point[0] * this.k + this.x,
                    point[1] * this.k + this.y
                ];
            },
            applyX: function(x) {
                return x * this.k + this.x;
            },
            applyY: function(y) {
                return y * this.k + this.y;
            },
            invert: function(location) {
                return [
                    (location[0] - this.x) / this.k,
                    (location[1] - this.y) / this.k
                ];
            },
            invertX: function(x) {
                return (x - this.x) / this.k;
            },
            invertY: function(y) {
                return (y - this.y) / this.k;
            },
            rescaleX: function(x) {
                return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
            },
            rescaleY: function(y) {
                return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
            },
            toString: function() {
                return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
            }
        };
        var identity = new Transform(1, 0, 0);
        transform.prototype = Transform.prototype;
        function transform(node) {
            while(!node.__zoom)if (!(node = node.parentNode)) return identity;
            return node.__zoom;
        }
        function nopropagation(event) {
            event.stopImmediatePropagation();
        }
        function noevent(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        function defaultFilter(event) {
            return (!event.ctrlKey || event.type === 'wheel') && !event.button;
        }
        function defaultExtent() {
            var e = this;
            if (e instanceof SVGElement) {
                e = e.ownerSVGElement || e;
                if (e.hasAttribute("viewBox")) {
                    e = e.viewBox.baseVal;
                    return [
                        [
                            e.x,
                            e.y
                        ],
                        [
                            e.x + e.width,
                            e.y + e.height
                        ]
                    ];
                }
                return [
                    [
                        0,
                        0
                    ],
                    [
                        e.width.baseVal.value,
                        e.height.baseVal.value
                    ]
                ];
            }
            return [
                [
                    0,
                    0
                ],
                [
                    e.clientWidth,
                    e.clientHeight
                ]
            ];
        }
        function defaultTransform() {
            return this.__zoom || identity;
        }
        function defaultWheelDelta(event) {
            return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
        }
        function defaultTouchable() {
            return navigator.maxTouchPoints || "ontouchstart" in this;
        }
        function defaultConstrain(transform, extent, translateExtent) {
            var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
            return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
        }
        function zoom() {
            var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
                0,
                Infinity
            ], translateExtent = [
                [
                    -Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    Infinity
                ]
            ], duration = 250, interpolate = interpolateZoom, listeners = dispatch("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
            function zoom(selection) {
                selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                    passive: false
                }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
            }
            zoom.transform = function(collection, transform, point, event) {
                var selection = collection.selection ? collection.selection() : collection;
                selection.property("__zoom", defaultTransform);
                if (collection !== selection) schedule(collection, transform, point, event);
                else selection.interrupt().each(function() {
                    gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
                });
            };
            zoom.scaleBy = function(selection, k, p, event) {
                zoom.scaleTo(selection, function() {
                    var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                    return k0 * k1;
                }, p, event);
            };
            zoom.scaleTo = function(selection, k, p, event) {
                zoom.transform(selection, function() {
                    var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                    return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
                }, p, event);
            };
            zoom.translateBy = function(selection, x, y, event) {
                zoom.transform(selection, function() {
                    return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
                }, null, event);
            };
            zoom.translateTo = function(selection, x, y, p, event) {
                zoom.transform(selection, function() {
                    var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                    return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
                }, p, event);
            };
            function scale(transform, k) {
                k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
                return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
            }
            function translate(transform, p0, p1) {
                var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
                return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
            }
            function centroid(extent) {
                return [
                    (+extent[0][0] + +extent[1][0]) / 2,
                    (+extent[0][1] + +extent[1][1]) / 2
                ];
            }
            function schedule(transition, transform, point, event) {
                transition.on("start.zoom", function() {
                    gesture(this, arguments).event(event).start();
                }).on("interrupt.zoom end.zoom", function() {
                    gesture(this, arguments).event(event).end();
                }).tween("zoom", function() {
                    var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                    return function(t) {
                        if (t === 1) t = b;
                        else {
                            var l = i(t), k = w / l[2];
                            t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
                        }
                        g.zoom(null, t);
                    };
                });
            }
            function gesture(that, args, clean) {
                return !clean && that.__zooming || new Gesture(that, args);
            }
            function Gesture(that, args) {
                this.that = that;
                this.args = args;
                this.active = 0;
                this.sourceEvent = null;
                this.extent = extent.apply(that, args);
                this.taps = 0;
            }
            Gesture.prototype = {
                event: function(event) {
                    if (event) this.sourceEvent = event;
                    return this;
                },
                start: function() {
                    if (++this.active === 1) {
                        this.that.__zooming = this;
                        this.emit("start");
                    }
                    return this;
                },
                zoom: function(key, transform) {
                    if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                    if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                    if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                    this.that.__zoom = transform;
                    this.emit("zoom");
                    return this;
                },
                end: function() {
                    if (--this.active === 0) {
                        delete this.that.__zooming;
                        this.emit("end");
                    }
                    return this;
                },
                emit: function(type) {
                    var d = select(this.that).datum();
                    listeners.call(type, this.that, new ZoomEvent(type, {
                        sourceEvent: this.sourceEvent,
                        target: zoom,
                        type: type,
                        transform: this.that.__zoom,
                        dispatch: listeners
                    }), d);
                }
            };
            function wheeled(event, ...args) {
                if (!filter.apply(this, arguments)) return;
                var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
                if (g.wheel) {
                    if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                    clearTimeout(g.wheel);
                } else if (t.k === k) return;
                else {
                    g.mouse = [
                        p,
                        t.invert(p)
                    ];
                    interrupt(this);
                    g.start();
                }
                noevent(event);
                g.wheel = setTimeout(wheelidled, wheelDelay);
                g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
                function wheelidled() {
                    g.wheel = null;
                    g.end();
                }
            }
            function mousedowned(event, ...args) {
                if (touchending || !filter.apply(this, arguments)) return;
                var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
                dragDisable(event.view);
                nopropagation(event);
                g.mouse = [
                    p,
                    this.__zoom.invert(p)
                ];
                interrupt(this);
                g.start();
                function mousemoved(event) {
                    noevent(event);
                    if (!g.moved) {
                        var dx = event.clientX - x0, dy = event.clientY - y0;
                        g.moved = dx * dx + dy * dy > clickDistance2;
                    }
                    g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
                }
                function mouseupped(event) {
                    v.on("mousemove.zoom mouseup.zoom", null);
                    yesdrag(event.view, g.moved);
                    noevent(event);
                    g.event(event).end();
                }
            }
            function dblclicked(event, ...args) {
                if (!filter.apply(this, arguments)) return;
                var t0 = this.__zoom, p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
                noevent(event);
                if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);
                else select(this).call(zoom.transform, t1, p0, event);
            }
            function touchstarted(event, ...args) {
                if (!filter.apply(this, arguments)) return;
                var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
                nopropagation(event);
                for(i = 0; i < n; ++i){
                    t = touches[i], p = pointer(t, this);
                    p = [
                        p,
                        this.__zoom.invert(p),
                        t.identifier
                    ];
                    if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                    else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
                }
                if (touchstarting) touchstarting = clearTimeout(touchstarting);
                if (started) {
                    if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                        touchstarting = null;
                    }, touchDelay);
                    interrupt(this);
                    g.start();
                }
            }
            function touchmoved(event, ...args) {
                if (!this.__zooming) return;
                var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
                noevent(event);
                for(i = 0; i < n; ++i){
                    t = touches[i], p = pointer(t, this);
                    if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                    else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
                }
                t = g.that.__zoom;
                if (g.touch1) {
                    var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                    t = scale(t, Math.sqrt(dp / dl));
                    p = [
                        (p0[0] + p1[0]) / 2,
                        (p0[1] + p1[1]) / 2
                    ];
                    l = [
                        (l0[0] + l1[0]) / 2,
                        (l0[1] + l1[1]) / 2
                    ];
                } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
                else return;
                g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
            }
            function touchended(event, ...args) {
                if (!this.__zooming) return;
                var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
                nopropagation(event);
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, touchDelay);
                for(i = 0; i < n; ++i){
                    t = touches[i];
                    if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                    else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
                }
                if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
                if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
                else {
                    g.end();
                    if (g.taps === 2) {
                        t = pointer(t, this);
                        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                            var p = select(this).on("dblclick.zoom");
                            if (p) p.apply(this, arguments);
                        }
                    }
                }
            }
            zoom.wheelDelta = function(_) {
                return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
            };
            zoom.filter = function(_) {
                return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
            };
            zoom.touchable = function(_) {
                return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
            };
            zoom.extent = function(_) {
                return arguments.length ? (extent = typeof _ === "function" ? _ : constant([
                    [
                        +_[0][0],
                        +_[0][1]
                    ],
                    [
                        +_[1][0],
                        +_[1][1]
                    ]
                ]), zoom) : extent;
            };
            zoom.scaleExtent = function(_) {
                return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                    scaleExtent[0],
                    scaleExtent[1]
                ];
            };
            zoom.translateExtent = function(_) {
                return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                    [
                        translateExtent[0][0],
                        translateExtent[0][1]
                    ],
                    [
                        translateExtent[1][0],
                        translateExtent[1][1]
                    ]
                ];
            };
            zoom.constrain = function(_) {
                return arguments.length ? (constrain = _, zoom) : constrain;
            };
            zoom.duration = function(_) {
                return arguments.length ? (duration = +_, zoom) : duration;
            };
            zoom.interpolate = function(_) {
                return arguments.length ? (interpolate = _, zoom) : interpolate;
            };
            zoom.on = function() {
                var value = listeners.on.apply(listeners, arguments);
                return value === listeners ? zoom : value;
            };
            zoom.clickDistance = function(_) {
                return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
            };
            zoom.tapDistance = function(_) {
                return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
            };
            return zoom;
        }
        exports1.Adder = Adder;
        exports1.Delaunay = Delaunay;
        exports1.FormatSpecifier = FormatSpecifier;
        exports1.InternMap = InternMap;
        exports1.InternSet = InternSet;
        exports1.Node = Node$1;
        exports1.Voronoi = Voronoi;
        exports1.ZoomTransform = Transform;
        exports1.active = active;
        exports1.arc = arc;
        exports1.area = area;
        exports1.areaRadial = areaRadial;
        exports1.ascending = ascending$3;
        exports1.autoType = autoType;
        exports1.axisBottom = axisBottom;
        exports1.axisLeft = axisLeft;
        exports1.axisRight = axisRight;
        exports1.axisTop = axisTop;
        exports1.bin = bin;
        exports1.bisect = bisect;
        exports1.bisectCenter = bisectCenter;
        exports1.bisectLeft = bisectLeft;
        exports1.bisectRight = bisectRight;
        exports1.bisector = bisector;
        exports1.blob = blob;
        exports1.blur = blur;
        exports1.blur2 = blur2;
        exports1.blurImage = blurImage;
        exports1.brush = brush;
        exports1.brushSelection = brushSelection;
        exports1.brushX = brushX;
        exports1.brushY = brushY;
        exports1.buffer = buffer;
        exports1.chord = chord;
        exports1.chordDirected = chordDirected;
        exports1.chordTranspose = chordTranspose;
        exports1.cluster = cluster;
        exports1.color = color;
        exports1.contourDensity = density;
        exports1.contours = Contours;
        exports1.count = count$1;
        exports1.create = create$1;
        exports1.creator = creator;
        exports1.cross = cross$2;
        exports1.csv = csv;
        exports1.csvFormat = csvFormat;
        exports1.csvFormatBody = csvFormatBody;
        exports1.csvFormatRow = csvFormatRow;
        exports1.csvFormatRows = csvFormatRows;
        exports1.csvFormatValue = csvFormatValue;
        exports1.csvParse = csvParse;
        exports1.csvParseRows = csvParseRows;
        exports1.cubehelix = cubehelix$3;
        exports1.cumsum = cumsum;
        exports1.curveBasis = basis;
        exports1.curveBasisClosed = basisClosed;
        exports1.curveBasisOpen = basisOpen;
        exports1.curveBumpX = bumpX;
        exports1.curveBumpY = bumpY;
        exports1.curveBundle = bundle;
        exports1.curveCardinal = cardinal;
        exports1.curveCardinalClosed = cardinalClosed;
        exports1.curveCardinalOpen = cardinalOpen;
        exports1.curveCatmullRom = catmullRom;
        exports1.curveCatmullRomClosed = catmullRomClosed;
        exports1.curveCatmullRomOpen = catmullRomOpen;
        exports1.curveLinear = curveLinear;
        exports1.curveLinearClosed = linearClosed;
        exports1.curveMonotoneX = monotoneX;
        exports1.curveMonotoneY = monotoneY;
        exports1.curveNatural = natural;
        exports1.curveStep = step;
        exports1.curveStepAfter = stepAfter;
        exports1.curveStepBefore = stepBefore;
        exports1.descending = descending$2;
        exports1.deviation = deviation;
        exports1.difference = difference;
        exports1.disjoint = disjoint;
        exports1.dispatch = dispatch;
        exports1.drag = drag;
        exports1.dragDisable = dragDisable;
        exports1.dragEnable = yesdrag;
        exports1.dsv = dsv;
        exports1.dsvFormat = dsvFormat;
        exports1.easeBack = backInOut;
        exports1.easeBackIn = backIn;
        exports1.easeBackInOut = backInOut;
        exports1.easeBackOut = backOut;
        exports1.easeBounce = bounceOut;
        exports1.easeBounceIn = bounceIn;
        exports1.easeBounceInOut = bounceInOut;
        exports1.easeBounceOut = bounceOut;
        exports1.easeCircle = circleInOut;
        exports1.easeCircleIn = circleIn;
        exports1.easeCircleInOut = circleInOut;
        exports1.easeCircleOut = circleOut;
        exports1.easeCubic = cubicInOut;
        exports1.easeCubicIn = cubicIn;
        exports1.easeCubicInOut = cubicInOut;
        exports1.easeCubicOut = cubicOut;
        exports1.easeElastic = elasticOut;
        exports1.easeElasticIn = elasticIn;
        exports1.easeElasticInOut = elasticInOut;
        exports1.easeElasticOut = elasticOut;
        exports1.easeExp = expInOut;
        exports1.easeExpIn = expIn;
        exports1.easeExpInOut = expInOut;
        exports1.easeExpOut = expOut;
        exports1.easeLinear = linear$1;
        exports1.easePoly = polyInOut;
        exports1.easePolyIn = polyIn;
        exports1.easePolyInOut = polyInOut;
        exports1.easePolyOut = polyOut;
        exports1.easeQuad = quadInOut;
        exports1.easeQuadIn = quadIn;
        exports1.easeQuadInOut = quadInOut;
        exports1.easeQuadOut = quadOut;
        exports1.easeSin = sinInOut;
        exports1.easeSinIn = sinIn;
        exports1.easeSinInOut = sinInOut;
        exports1.easeSinOut = sinOut;
        exports1.every = every;
        exports1.extent = extent$1;
        exports1.fcumsum = fcumsum;
        exports1.filter = filter$1;
        exports1.flatGroup = flatGroup;
        exports1.flatRollup = flatRollup;
        exports1.forceCenter = center;
        exports1.forceCollide = collide;
        exports1.forceLink = link$2;
        exports1.forceManyBody = manyBody;
        exports1.forceRadial = radial$1;
        exports1.forceSimulation = simulation;
        exports1.forceX = x$2;
        exports1.forceY = y$1;
        exports1.formatDefaultLocale = defaultLocale$1;
        exports1.formatLocale = formatLocale$1;
        exports1.formatSpecifier = formatSpecifier;
        exports1.fsum = fsum;
        exports1.geoAlbers = albers;
        exports1.geoAlbersUsa = albersUsa;
        exports1.geoArea = area$2;
        exports1.geoAzimuthalEqualArea = azimuthalEqualArea;
        exports1.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
        exports1.geoAzimuthalEquidistant = azimuthalEquidistant;
        exports1.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
        exports1.geoBounds = bounds;
        exports1.geoCentroid = centroid$1;
        exports1.geoCircle = circle$2;
        exports1.geoClipAntimeridian = clipAntimeridian;
        exports1.geoClipCircle = clipCircle;
        exports1.geoClipExtent = extent;
        exports1.geoClipRectangle = clipRectangle;
        exports1.geoConicConformal = conicConformal;
        exports1.geoConicConformalRaw = conicConformalRaw;
        exports1.geoConicEqualArea = conicEqualArea;
        exports1.geoConicEqualAreaRaw = conicEqualAreaRaw;
        exports1.geoConicEquidistant = conicEquidistant;
        exports1.geoConicEquidistantRaw = conicEquidistantRaw;
        exports1.geoContains = contains$1;
        exports1.geoDistance = distance;
        exports1.geoEqualEarth = equalEarth;
        exports1.geoEqualEarthRaw = equalEarthRaw;
        exports1.geoEquirectangular = equirectangular;
        exports1.geoEquirectangularRaw = equirectangularRaw;
        exports1.geoGnomonic = gnomonic;
        exports1.geoGnomonicRaw = gnomonicRaw;
        exports1.geoGraticule = graticule;
        exports1.geoGraticule10 = graticule10;
        exports1.geoIdentity = identity$4;
        exports1.geoInterpolate = interpolate;
        exports1.geoLength = length$1;
        exports1.geoMercator = mercator;
        exports1.geoMercatorRaw = mercatorRaw;
        exports1.geoNaturalEarth1 = naturalEarth1;
        exports1.geoNaturalEarth1Raw = naturalEarth1Raw;
        exports1.geoOrthographic = orthographic;
        exports1.geoOrthographicRaw = orthographicRaw;
        exports1.geoPath = index$2;
        exports1.geoProjection = projection;
        exports1.geoProjectionMutator = projectionMutator;
        exports1.geoRotation = rotation;
        exports1.geoStereographic = stereographic;
        exports1.geoStereographicRaw = stereographicRaw;
        exports1.geoStream = geoStream;
        exports1.geoTransform = transform$1;
        exports1.geoTransverseMercator = transverseMercator;
        exports1.geoTransverseMercatorRaw = transverseMercatorRaw;
        exports1.gray = gray;
        exports1.greatest = greatest;
        exports1.greatestIndex = greatestIndex;
        exports1.group = group;
        exports1.groupSort = groupSort;
        exports1.groups = groups;
        exports1.hcl = hcl$2;
        exports1.hierarchy = hierarchy;
        exports1.histogram = bin;
        exports1.hsl = hsl$2;
        exports1.html = html;
        exports1.image = image;
        exports1.index = index$4;
        exports1.indexes = indexes;
        exports1.interpolate = interpolate$2;
        exports1.interpolateArray = array$3;
        exports1.interpolateBasis = basis$2;
        exports1.interpolateBasisClosed = basisClosed$1;
        exports1.interpolateBlues = Blues;
        exports1.interpolateBrBG = BrBG;
        exports1.interpolateBuGn = BuGn;
        exports1.interpolateBuPu = BuPu;
        exports1.interpolateCividis = cividis;
        exports1.interpolateCool = cool;
        exports1.interpolateCubehelix = cubehelix$2;
        exports1.interpolateCubehelixDefault = cubehelix;
        exports1.interpolateCubehelixLong = cubehelixLong;
        exports1.interpolateDate = date$1;
        exports1.interpolateDiscrete = discrete;
        exports1.interpolateGnBu = GnBu;
        exports1.interpolateGreens = Greens;
        exports1.interpolateGreys = Greys;
        exports1.interpolateHcl = hcl$1;
        exports1.interpolateHclLong = hclLong;
        exports1.interpolateHsl = hsl$1;
        exports1.interpolateHslLong = hslLong;
        exports1.interpolateHue = hue;
        exports1.interpolateInferno = inferno;
        exports1.interpolateLab = lab;
        exports1.interpolateMagma = magma;
        exports1.interpolateNumber = interpolateNumber;
        exports1.interpolateNumberArray = numberArray;
        exports1.interpolateObject = object$1;
        exports1.interpolateOrRd = OrRd;
        exports1.interpolateOranges = Oranges;
        exports1.interpolatePRGn = PRGn;
        exports1.interpolatePiYG = PiYG;
        exports1.interpolatePlasma = plasma;
        exports1.interpolatePuBu = PuBu;
        exports1.interpolatePuBuGn = PuBuGn;
        exports1.interpolatePuOr = PuOr;
        exports1.interpolatePuRd = PuRd;
        exports1.interpolatePurples = Purples;
        exports1.interpolateRainbow = rainbow;
        exports1.interpolateRdBu = RdBu;
        exports1.interpolateRdGy = RdGy;
        exports1.interpolateRdPu = RdPu;
        exports1.interpolateRdYlBu = RdYlBu;
        exports1.interpolateRdYlGn = RdYlGn;
        exports1.interpolateReds = Reds;
        exports1.interpolateRgb = interpolateRgb;
        exports1.interpolateRgbBasis = rgbBasis;
        exports1.interpolateRgbBasisClosed = rgbBasisClosed;
        exports1.interpolateRound = interpolateRound;
        exports1.interpolateSinebow = sinebow;
        exports1.interpolateSpectral = Spectral;
        exports1.interpolateString = interpolateString;
        exports1.interpolateTransformCss = interpolateTransformCss;
        exports1.interpolateTransformSvg = interpolateTransformSvg;
        exports1.interpolateTurbo = turbo;
        exports1.interpolateViridis = viridis;
        exports1.interpolateWarm = warm;
        exports1.interpolateYlGn = YlGn;
        exports1.interpolateYlGnBu = YlGnBu;
        exports1.interpolateYlOrBr = YlOrBr;
        exports1.interpolateYlOrRd = YlOrRd;
        exports1.interpolateZoom = interpolateZoom;
        exports1.interrupt = interrupt;
        exports1.intersection = intersection;
        exports1.interval = interval;
        exports1.isoFormat = formatIso$1;
        exports1.isoParse = parseIso$1;
        exports1.json = json;
        exports1.lab = lab$1;
        exports1.lch = lch;
        exports1.least = least;
        exports1.leastIndex = leastIndex;
        exports1.line = line;
        exports1.lineRadial = lineRadial$1;
        exports1.link = link;
        exports1.linkHorizontal = linkHorizontal;
        exports1.linkRadial = linkRadial;
        exports1.linkVertical = linkVertical;
        exports1.local = local$1;
        exports1.map = map$1;
        exports1.matcher = matcher;
        exports1.max = max$3;
        exports1.maxIndex = maxIndex;
        exports1.mean = mean;
        exports1.median = median;
        exports1.medianIndex = medianIndex;
        exports1.merge = merge;
        exports1.min = min$2;
        exports1.minIndex = minIndex;
        exports1.mode = mode;
        exports1.namespace = namespace;
        exports1.namespaces = namespaces;
        exports1.nice = nice$1;
        exports1.now = now;
        exports1.pack = index$1;
        exports1.packEnclose = enclose;
        exports1.packSiblings = siblings;
        exports1.pairs = pairs;
        exports1.partition = partition;
        exports1.path = path;
        exports1.permute = permute;
        exports1.pie = pie;
        exports1.piecewise = piecewise;
        exports1.pointRadial = pointRadial;
        exports1.pointer = pointer;
        exports1.pointers = pointers;
        exports1.polygonArea = area$1;
        exports1.polygonCentroid = centroid;
        exports1.polygonContains = contains;
        exports1.polygonHull = hull;
        exports1.polygonLength = length;
        exports1.precisionFixed = precisionFixed;
        exports1.precisionPrefix = precisionPrefix;
        exports1.precisionRound = precisionRound;
        exports1.quadtree = quadtree;
        exports1.quantile = quantile$1;
        exports1.quantileIndex = quantileIndex;
        exports1.quantileSorted = quantileSorted;
        exports1.quantize = quantize$1;
        exports1.quickselect = quickselect;
        exports1.radialArea = areaRadial;
        exports1.radialLine = lineRadial$1;
        exports1.randomBates = bates;
        exports1.randomBernoulli = bernoulli;
        exports1.randomBeta = beta;
        exports1.randomBinomial = binomial;
        exports1.randomCauchy = cauchy;
        exports1.randomExponential = exponential;
        exports1.randomGamma = gamma;
        exports1.randomGeometric = geometric;
        exports1.randomInt = int;
        exports1.randomIrwinHall = irwinHall;
        exports1.randomLcg = lcg;
        exports1.randomLogNormal = logNormal;
        exports1.randomLogistic = logistic;
        exports1.randomNormal = normal;
        exports1.randomPareto = pareto;
        exports1.randomPoisson = poisson;
        exports1.randomUniform = uniform;
        exports1.randomWeibull = weibull;
        exports1.range = range$2;
        exports1.rank = rank;
        exports1.reduce = reduce;
        exports1.reverse = reverse$1;
        exports1.rgb = rgb;
        exports1.ribbon = ribbon$1;
        exports1.ribbonArrow = ribbonArrow;
        exports1.rollup = rollup;
        exports1.rollups = rollups;
        exports1.scaleBand = band;
        exports1.scaleDiverging = diverging$1;
        exports1.scaleDivergingLog = divergingLog;
        exports1.scaleDivergingPow = divergingPow;
        exports1.scaleDivergingSqrt = divergingSqrt;
        exports1.scaleDivergingSymlog = divergingSymlog;
        exports1.scaleIdentity = identity$2;
        exports1.scaleImplicit = implicit;
        exports1.scaleLinear = linear;
        exports1.scaleLog = log;
        exports1.scaleOrdinal = ordinal;
        exports1.scalePoint = point$4;
        exports1.scalePow = pow;
        exports1.scaleQuantile = quantile;
        exports1.scaleQuantize = quantize;
        exports1.scaleRadial = radial;
        exports1.scaleSequential = sequential;
        exports1.scaleSequentialLog = sequentialLog;
        exports1.scaleSequentialPow = sequentialPow;
        exports1.scaleSequentialQuantile = sequentialQuantile;
        exports1.scaleSequentialSqrt = sequentialSqrt;
        exports1.scaleSequentialSymlog = sequentialSymlog;
        exports1.scaleSqrt = sqrt$1;
        exports1.scaleSymlog = symlog;
        exports1.scaleThreshold = threshold;
        exports1.scaleTime = time;
        exports1.scaleUtc = utcTime;
        exports1.scan = scan;
        exports1.schemeAccent = Accent;
        exports1.schemeBlues = scheme$5;
        exports1.schemeBrBG = scheme$q;
        exports1.schemeBuGn = scheme$h;
        exports1.schemeBuPu = scheme$g;
        exports1.schemeCategory10 = category10;
        exports1.schemeDark2 = Dark2;
        exports1.schemeGnBu = scheme$f;
        exports1.schemeGreens = scheme$4;
        exports1.schemeGreys = scheme$3;
        exports1.schemeOrRd = scheme$e;
        exports1.schemeOranges = scheme;
        exports1.schemePRGn = scheme$p;
        exports1.schemePaired = Paired;
        exports1.schemePastel1 = Pastel1;
        exports1.schemePastel2 = Pastel2;
        exports1.schemePiYG = scheme$o;
        exports1.schemePuBu = scheme$c;
        exports1.schemePuBuGn = scheme$d;
        exports1.schemePuOr = scheme$n;
        exports1.schemePuRd = scheme$b;
        exports1.schemePurples = scheme$2;
        exports1.schemeRdBu = scheme$m;
        exports1.schemeRdGy = scheme$l;
        exports1.schemeRdPu = scheme$a;
        exports1.schemeRdYlBu = scheme$k;
        exports1.schemeRdYlGn = scheme$j;
        exports1.schemeReds = scheme$1;
        exports1.schemeSet1 = Set1;
        exports1.schemeSet2 = Set2;
        exports1.schemeSet3 = Set3;
        exports1.schemeSpectral = scheme$i;
        exports1.schemeTableau10 = Tableau10;
        exports1.schemeYlGn = scheme$8;
        exports1.schemeYlGnBu = scheme$9;
        exports1.schemeYlOrBr = scheme$7;
        exports1.schemeYlOrRd = scheme$6;
        exports1.select = select;
        exports1.selectAll = selectAll;
        exports1.selection = selection;
        exports1.selector = selector;
        exports1.selectorAll = selectorAll;
        exports1.shuffle = shuffle$1;
        exports1.shuffler = shuffler;
        exports1.some = some;
        exports1.sort = sort;
        exports1.stack = stack;
        exports1.stackOffsetDiverging = diverging;
        exports1.stackOffsetExpand = expand;
        exports1.stackOffsetNone = none$1;
        exports1.stackOffsetSilhouette = silhouette;
        exports1.stackOffsetWiggle = wiggle;
        exports1.stackOrderAppearance = appearance;
        exports1.stackOrderAscending = ascending;
        exports1.stackOrderDescending = descending;
        exports1.stackOrderInsideOut = insideOut;
        exports1.stackOrderNone = none;
        exports1.stackOrderReverse = reverse;
        exports1.stratify = stratify;
        exports1.style = styleValue;
        exports1.subset = subset;
        exports1.sum = sum$2;
        exports1.superset = superset;
        exports1.svg = svg;
        exports1.symbol = Symbol$1;
        exports1.symbolAsterisk = asterisk;
        exports1.symbolCircle = circle;
        exports1.symbolCross = cross;
        exports1.symbolDiamond = diamond;
        exports1.symbolDiamond2 = diamond2;
        exports1.symbolPlus = plus;
        exports1.symbolSquare = square;
        exports1.symbolSquare2 = square2;
        exports1.symbolStar = star;
        exports1.symbolTriangle = triangle;
        exports1.symbolTriangle2 = triangle2;
        exports1.symbolWye = wye;
        exports1.symbolX = x;
        exports1.symbols = symbolsFill;
        exports1.symbolsFill = symbolsFill;
        exports1.symbolsStroke = symbolsStroke;
        exports1.text = text;
        exports1.thresholdFreedmanDiaconis = thresholdFreedmanDiaconis;
        exports1.thresholdScott = thresholdScott;
        exports1.thresholdSturges = thresholdSturges;
        exports1.tickFormat = tickFormat;
        exports1.tickIncrement = tickIncrement;
        exports1.tickStep = tickStep;
        exports1.ticks = ticks;
        exports1.timeDay = timeDay;
        exports1.timeDays = timeDays;
        exports1.timeFormatDefaultLocale = defaultLocale;
        exports1.timeFormatLocale = formatLocale;
        exports1.timeFriday = timeFriday;
        exports1.timeFridays = timeFridays;
        exports1.timeHour = timeHour;
        exports1.timeHours = timeHours;
        exports1.timeInterval = timeInterval;
        exports1.timeMillisecond = millisecond;
        exports1.timeMilliseconds = milliseconds;
        exports1.timeMinute = timeMinute;
        exports1.timeMinutes = timeMinutes;
        exports1.timeMonday = timeMonday;
        exports1.timeMondays = timeMondays;
        exports1.timeMonth = timeMonth;
        exports1.timeMonths = timeMonths;
        exports1.timeSaturday = timeSaturday;
        exports1.timeSaturdays = timeSaturdays;
        exports1.timeSecond = second;
        exports1.timeSeconds = seconds;
        exports1.timeSunday = timeSunday;
        exports1.timeSundays = timeSundays;
        exports1.timeThursday = timeThursday;
        exports1.timeThursdays = timeThursdays;
        exports1.timeTickInterval = timeTickInterval;
        exports1.timeTicks = timeTicks;
        exports1.timeTuesday = timeTuesday;
        exports1.timeTuesdays = timeTuesdays;
        exports1.timeWednesday = timeWednesday;
        exports1.timeWednesdays = timeWednesdays;
        exports1.timeWeek = timeSunday;
        exports1.timeWeeks = timeSundays;
        exports1.timeYear = timeYear;
        exports1.timeYears = timeYears;
        exports1.timeout = timeout;
        exports1.timer = timer;
        exports1.timerFlush = timerFlush;
        exports1.transition = transition;
        exports1.transpose = transpose;
        exports1.tree = tree;
        exports1.treemap = index;
        exports1.treemapBinary = binary;
        exports1.treemapDice = treemapDice;
        exports1.treemapResquarify = resquarify;
        exports1.treemapSlice = treemapSlice;
        exports1.treemapSliceDice = sliceDice;
        exports1.treemapSquarify = squarify;
        exports1.tsv = tsv;
        exports1.tsvFormat = tsvFormat;
        exports1.tsvFormatBody = tsvFormatBody;
        exports1.tsvFormatRow = tsvFormatRow;
        exports1.tsvFormatRows = tsvFormatRows;
        exports1.tsvFormatValue = tsvFormatValue;
        exports1.tsvParse = tsvParse;
        exports1.tsvParseRows = tsvParseRows;
        exports1.union = union;
        exports1.unixDay = unixDay;
        exports1.unixDays = unixDays;
        exports1.utcDay = utcDay;
        exports1.utcDays = utcDays;
        exports1.utcFriday = utcFriday;
        exports1.utcFridays = utcFridays;
        exports1.utcHour = utcHour;
        exports1.utcHours = utcHours;
        exports1.utcMillisecond = millisecond;
        exports1.utcMilliseconds = milliseconds;
        exports1.utcMinute = utcMinute;
        exports1.utcMinutes = utcMinutes;
        exports1.utcMonday = utcMonday;
        exports1.utcMondays = utcMondays;
        exports1.utcMonth = utcMonth;
        exports1.utcMonths = utcMonths;
        exports1.utcSaturday = utcSaturday;
        exports1.utcSaturdays = utcSaturdays;
        exports1.utcSecond = second;
        exports1.utcSeconds = seconds;
        exports1.utcSunday = utcSunday;
        exports1.utcSundays = utcSundays;
        exports1.utcThursday = utcThursday;
        exports1.utcThursdays = utcThursdays;
        exports1.utcTickInterval = utcTickInterval;
        exports1.utcTicks = utcTicks;
        exports1.utcTuesday = utcTuesday;
        exports1.utcTuesdays = utcTuesdays;
        exports1.utcWednesday = utcWednesday;
        exports1.utcWednesdays = utcWednesdays;
        exports1.utcWeek = utcSunday;
        exports1.utcWeeks = utcSundays;
        exports1.utcYear = utcYear;
        exports1.utcYears = utcYears;
        exports1.variance = variance;
        exports1.version = version;
        exports1.window = defaultView;
        exports1.xml = xml;
        exports1.zip = zip;
        exports1.zoom = zoom;
        exports1.zoomIdentity = identity;
        exports1.zoomTransform = transform;
    });
});
parcelRegister("4wRz3", function(module, exports) {
    $parcel$export(module.exports, "LayoutContainer", ()=>$34c3b357a3a754f8$export$faad8b178f68f912);
    $parcel$export(module.exports, "Layout", ()=>(parcelRequire("2OPEf")).Layout);
    var $2OPEf;
    var $2OMIu = parcelRequire("2OMIu");
    function $34c3b357a3a754f8$export$faad8b178f68f912(_ref) {
        let { height: height, width: width, children: children, ...props } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("2OPEf")).Layout), {
            showBorder: true,
            width: width,
            height: height,
            hasSubtitle: true,
            gridTemplate: (0, (0, parcelRequire("2OPEf")).defaultGrid),
            ...props,
            children: children
        });
    }
});
parcelRegister("2OPEf", function(module, exports) {
    $parcel$export(module.exports, "defaultGrid", ()=>$20d85081ecba80a6$export$aed5b7d86c3777ab);
    $parcel$export(module.exports, "Layout", ()=>$20d85081ecba80a6$export$c84671f46d6a1ca);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1xLej;
    var $5IT70;
    var $9BEAR;
    var $1iqMi;
    var $7rySF;
    var $2OMIu = parcelRequire("2OMIu");
    const $20d85081ecba80a6$export$aed5b7d86c3777ab = [
        'title',
        'subtitle',
        'legend',
        'plot'
    ];
    function $20d85081ecba80a6$var$Layout(_ref) {
        var _ref2, _ordering$plot;
        let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, overflow: overflow = 'hidden', showBorder: showBorder = true } = _ref;
        const ordering = gridTemplate.reduce((acc, key, i)=>{
            acc[key] = i + 1;
            return acc;
        }, {});
        const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
        const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
        const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
        const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const ref = window.requestAnimationFrame(()=>{
                if (isMounted) setFadeInOpacity(1);
            });
            return ()=>{
                isMounted = false;
                window.cancelAnimationFrame(ref);
            };
        }, [
            setFadeInOpacity
        ]);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $2OMIu.jsxs)("div", {
                "data-element": "layout",
                style: {
                    width: width,
                    height: height,
                    backgroundColor: "var(--ds-surface, white)",
                    border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                    padding: showBorder ? "var(--ds-space-200, 16px)" : 0,
                    overflow: overflow
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
                ]),
                children: [
                    (0, $2OMIu.jsxs)("div", {
                        style: {
                            order: ordering.title,
                            position: 'relative'
                        },
                        children: [
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("5IT70")).Icon), {}),
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("7rySF")).Title), {})
                        ]
                    }),
                    (0, $2OMIu.jsx)("div", {
                        style: {
                            order: ordering.subtitle
                        },
                        children: hasSubtitle && (0, $2OMIu.jsx)((0, (0, parcelRequire("1iqMi")).Subtitle), {})
                    }),
                    (0, $2OMIu.jsx)("div", {
                        "data-element": "chart",
                        style: {
                            opacity: fadeInOpacity,
                            transition: 'opacity .3s ease-in-out',
                            order: chartOrder,
                            flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                        },
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                        ]),
                        children: children
                    }),
                    (0, $2OMIu.jsx)((0, (0, parcelRequire("9BEAR")).ChartMenu), {})
                ]
            })
        });
    }
    const $20d85081ecba80a6$export$c84671f46d6a1ca = (0, (0, parcelRequire("1xLej")).element)($20d85081ecba80a6$var$Layout);
});
parcelRegister("5IT70", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$42abcfeb7064501b$export$f04a61298a47a40f);
    var $bwpsq;
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    const $42abcfeb7064501b$var$iconStyle = null;
    function $42abcfeb7064501b$var$Icon(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i1tcg _syaz1oju"
            ]),
            children: children
        });
    }
    const $42abcfeb7064501b$export$f04a61298a47a40f = (0, (0, parcelRequire("1xLej")).element)($42abcfeb7064501b$var$Icon);
});
parcelRegister("9BEAR", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$6fe70ec35a14ba96$export$d9b273488cd8ce6f);
    $parcel$export(module.exports, "ChartMenu", ()=>$6fe70ec35a14ba96$export$597da2837c1a3c88);
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $1xLej;
    var $9ZuYc;
    parcelRequire("4wRz3");
    var $2OPEf;
    var $wM6Wl;
    var $dBbYh;
    var $2OMIu = parcelRequire("2OMIu");
    const $6fe70ec35a14ba96$export$d9b273488cd8ce6f = (0, (0, parcelRequire("1xLej")).element)((_ref)=>{
        let { children: children, hide: hide = false, toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns, disablePatternOption: disablePatternOption = false } = _ref;
        if (hide) return null;
        const { showBorder: showBorder } = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("2OPEf")).Layout));
        return (0, $2OMIu.jsx)("div", {
            style: {
                position: 'absolute',
                top: 0,
                right: 0,
                padding: showBorder ? "var(--ds-space-200, 16px)" : 0
            },
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("BLPHT")).default), {
                trigger: (_ref2)=>{
                    let { triggerRef: triggerRef, ...props } = _ref2;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("42CjB")).default), {
                        ...props,
                        appearance: "subtle",
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))),
                        label: "Chart Menu",
                        ref: triggerRef,
                        spacing: "compact"
                    });
                },
                label: "Chart Menu",
                shouldRenderToParent: true,
                placement: "top-end",
                spacing: "compact",
                children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("aRoVz")).default), {
                    children: [
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("6B7KL")).default), {
                            onClick: toggleDataTable,
                            testId: (0, (0, parcelRequire("wM6Wl")).a11yStrings).showDataTable,
                            children: (0, (0, parcelRequire("wM6Wl")).a11yStrings).showDataTable
                        }, (0, (0, parcelRequire("wM6Wl")).a11yStrings).showDataTable),
                        !disablePatternOption ? (0, $2OMIu.jsx)((0, (0, parcelRequire("6B7KL")).default), {
                            onClick: toggleShowPatterns,
                            testId: (0, (0, parcelRequire("wM6Wl")).a11yStrings).enablePatterns,
                            children: showPatterns ? (0, (0, parcelRequire("wM6Wl")).a11yStrings).disablePatterns : (0, (0, parcelRequire("wM6Wl")).a11yStrings).enablePatterns
                        }, (0, (0, parcelRequire("wM6Wl")).a11yStrings).enablePatterns) : null,
                        children
                    ]
                })
            })
        });
    });
    function $6fe70ec35a14ba96$export$597da2837c1a3c88(props) {
        const { toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns } = (0, (0, parcelRequire("dBbYh")).useMenuData)();
        return (0, $2OMIu.jsx)($6fe70ec35a14ba96$export$d9b273488cd8ce6f, {
            ...props,
            toggleDataTable: toggleDataTable,
            toggleShowPatterns: toggleShowPatterns,
            showPatterns: showPatterns
        });
    }
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("wM6Wl", function(module, exports) {
    $parcel$export(module.exports, "a11yStrings", ()=>$06284f1a6f56f375$export$1bab900455080d68);
    const $06284f1a6f56f375$export$1bab900455080d68 = {
        enablePatterns: 'Enable Patterns',
        disablePatterns: 'Disable Patterns',
        showDataTable: 'Show Data Table'
    };
});
parcelRegister("dBbYh", function(module, exports) {
    $parcel$export(module.exports, "useMenuData", ()=>$9e68044b36ea3667$export$bf0039e2171862f5);
    $parcel$export(module.exports, "MenuProvider", ()=>$9e68044b36ea3667$export$62b22d151866115d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2OMIu = parcelRequire("2OMIu");
    function $9e68044b36ea3667$export$2ce5e940c4008526() {
        const [showDataTable, setShowDataTable] = (0, $5uXOq.useState)(false);
        const [showPatterns, setShowPatterns] = (0, $5uXOq.useState)(false);
        const toggleDataTable = (0, $5uXOq.useCallback)(()=>{
            setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
        }, [
            setShowDataTable
        ]);
        const closeDataTable = (0, $5uXOq.useCallback)(()=>{
            setShowDataTable(false);
        }, [
            setShowDataTable
        ]);
        const toggleShowPatterns = (0, $5uXOq.useCallback)(()=>{
            setShowPatterns((prevShowPatterns)=>!prevShowPatterns);
        }, [
            setShowPatterns
        ]);
        return {
            showDataTable: showDataTable,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable,
            showPatterns: showPatterns,
            toggleShowPatterns: toggleShowPatterns
        };
    }
    const $9e68044b36ea3667$export$c7e742effb1c51e2 = (0, $5uXOq.createContext)({});
    function $9e68044b36ea3667$export$bf0039e2171862f5() {
        return (0, $5uXOq.useContext)($9e68044b36ea3667$export$c7e742effb1c51e2);
    }
    const $9e68044b36ea3667$export$62b22d151866115d = (_ref)=>{
        let { children: children } = _ref;
        const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable, showPatterns: showPatterns, toggleShowPatterns: toggleShowPatterns } = $9e68044b36ea3667$export$2ce5e940c4008526();
        return (0, $2OMIu.jsx)($9e68044b36ea3667$export$c7e742effb1c51e2.Provider, {
            value: {
                showDataTable: showDataTable,
                showPatterns: showPatterns,
                closeDataTable: closeDataTable,
                toggleDataTable: toggleDataTable,
                toggleShowPatterns: toggleShowPatterns
            },
            children: children
        });
    };
});
parcelRegister("1iqMi", function(module, exports) {
    $parcel$export(module.exports, "Subtitle", ()=>$0f1c3e683a2010d1$export$cf345ef34cd72655);
    var $bwpsq;
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    const $0f1c3e683a2010d1$var$subTitleTextStyle = null;
    function $0f1c3e683a2010d1$var$Subtitle(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("h3", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _k48p1nn1 _ect41wi2 _1wyb1crf _zg8l4jg8 _vwz47vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"
            ]),
            children: children
        });
    }
    const $0f1c3e683a2010d1$export$cf345ef34cd72655 = (0, (0, parcelRequire("1xLej")).element)($0f1c3e683a2010d1$var$Subtitle);
});
parcelRegister("jsFNI", function(module, exports) {
    $parcel$export(module.exports, "DimensionsWrapper", ()=>$e2b10ea7064a4053$export$a263c0cd0abdd921);
    var $5uXOq = parcelRequire("5uXOq");
    const $e2b10ea7064a4053$var$INITIAL_DIMENSIONS = {
        plotHeight: 100,
        plotWidth: 100,
        margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    };
    function $e2b10ea7064a4053$export$a263c0cd0abdd921(_ref) {
        let { children: children } = _ref;
        const [, forceUpdate] = (0, $5uXOq.useState)({});
        const dimensions = (0, $5uXOq.useRef)($e2b10ea7064a4053$var$INITIAL_DIMENSIONS);
        const plotSvgRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const resizeObserverSvg = new ResizeObserver((entries)=>{
                if (entries && entries[0]) {
                    const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                    const newMargin = Object.assign({}, dimensions.current.margin);
                    dimensions.current = {
                        margin: newMargin,
                        plotHeight: hs,
                        plotWidth: ws
                    };
                    forceUpdate({});
                }
            });
            if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
            return ()=>{
                resizeObserverSvg.disconnect();
            };
        }, []);
        return children({
            ...dimensions.current,
            plotSvgRef: plotSvgRef
        });
    }
});
parcelRegister("jogiL", function(module, exports) {
    $parcel$export(module.exports, "LegendLabel", ()=>$e1dce75aa10566c3$export$f77025011665b85c);
    $parcel$export(module.exports, "OrdinalLegend", ()=>$e1dce75aa10566c3$export$7f71253a43a34ee6);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $l5VfC;
    var $1xLej;
    var $9ZuYc;
    var $2OPEf;
    var $Ge7ik;
    var $2OMIu = parcelRequire("2OMIu");
    const $e1dce75aa10566c3$export$83dfac8e05432e26 = {
        color: "var(--ds-text-subtlest, #626F86)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: '12px',
        margin: '8px 0px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
    const $e1dce75aa10566c3$var$LegendSymbol = (_ref)=>{
        let { color: color, shape: shape } = _ref;
        let symbol;
        switch(shape){
            case 'square':
                symbol = (0, $2OMIu.jsx)("rect", {
                    fill: color,
                    width: (0, $924b13d0d377477c$export$1949567a35c96224),
                    height: (0, $924b13d0d377477c$export$1949567a35c96224),
                    rx: 1,
                    ry: 1
                });
                break;
            case 'line':
                symbol = (0, $2OMIu.jsx)("line", {
                    x1: 0,
                    y1: (0, $924b13d0d377477c$export$1949567a35c96224) / 2,
                    x2: (0, $924b13d0d377477c$export$1949567a35c96224),
                    y2: (0, $924b13d0d377477c$export$1949567a35c96224) / 2,
                    stroke: color,
                    strokeWidth: 2
                });
                break;
            case 'circle':
            default:
                symbol = (0, $2OMIu.jsx)("rect", {
                    fill: color,
                    width: (0, $924b13d0d377477c$export$1949567a35c96224),
                    height: (0, $924b13d0d377477c$export$1949567a35c96224),
                    rx: (0, $924b13d0d377477c$export$1949567a35c96224) / 2,
                    ry: (0, $924b13d0d377477c$export$1949567a35c96224) / 2
                });
        }
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o"
            ]),
            children: (0, $2OMIu.jsx)("svg", {
                width: (0, $924b13d0d377477c$export$1949567a35c96224),
                height: (0, $924b13d0d377477c$export$1949567a35c96224),
                children: symbol
            })
        });
    };
    const $e1dce75aa10566c3$export$f77025011665b85c = (0, (0, parcelRequire("1xLej")).element)((_ref2)=>{
        let { labelAccessor: labelAccessor, datum: datum } = _ref2;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
            ]),
            children: labelAccessor(datum)
        });
    });
    const $e1dce75aa10566c3$var$VerticalLegendMark = (_ref3)=>{
        let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref3;
        const label = labelAccessor(datum);
        const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, (0, parcelRequire("l5VfC")).default)();
        return (0, $2OMIu.jsxs)("div", {
            style: {
                opacity: opacity
            },
            onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
            onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"
            ]),
            children: [
                (0, $2OMIu.jsx)($e1dce75aa10566c3$var$LegendSymbol, {
                    color: color,
                    shape: shape
                }),
                (0, $2OMIu.jsx)($e1dce75aa10566c3$export$f77025011665b85c, {
                    datum: datum,
                    labelAccessor: labelAccessor
                })
            ]
        });
    };
    const $e1dce75aa10566c3$var$HorizontalLegendMark = (_ref4)=>{
        let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref4;
        const label = labelAccessor(datum);
        const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, (0, parcelRequire("l5VfC")).default)();
        return (0, $2OMIu.jsxs)("div", {
            style: {
                opacity: opacity
            },
            onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
            onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"
            ]),
            children: [
                (0, $2OMIu.jsx)($e1dce75aa10566c3$var$LegendSymbol, {
                    color: color,
                    shape: shape
                }),
                (0, $2OMIu.jsx)($e1dce75aa10566c3$export$f77025011665b85c, {
                    labelAccessor: labelAccessor,
                    datum: datum
                })
            ]
        });
    };
    function $e1dce75aa10566c3$var$VerticalLegend(_ref5) {
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref5;
        const legendRef = (0, $5uXOq.useRef)(null);
        const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $924b13d0d377477c$export$7bf402e928540137));
        const flatData = (0, (0, parcelRequire("Ge7ik")).useFlatData)({
            labelAccessor: labelAccessor,
            data: data
        });
        (0, (0, parcelRequire("Ge7ik")).useTruncationIndexObserver)({
            legendRefCurrent: legendRef.current,
            setTruncationIndex: setTruncationIndex
        });
        const itemsToTruncate = flatData.length - (truncationIndex || 0);
        return (0, $2OMIu.jsx)("div", {
            ref: legendRef,
            style: {
                maxHeight: `${maxRows * (0, $924b13d0d377477c$export$bc48d9a7fd313bb2) + 2}px`,
                justifyContent: justifyContent
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"
            ]),
            children: flatData.map((d, i)=>(0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsxs)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: [
                                (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegendMark, {
                                    color: colorScale(colorAccessor(d)),
                                    labelAccessor: labelAccessor,
                                    shape: shape,
                                    opacity: 0,
                                    datum: d
                                }, labelAccessor(d)),
                                truncationIndex - 1 === i && (0, $2OMIu.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0
                                    },
                                    className: (0, (0, parcelRequire("bwpsq")).default)([
                                        "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                    ]),
                                    children: ` ... ${itemsToTruncate + 1} more`
                                })
                            ]
                        })
                    }) : (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegendMark, {
                        color: colorScale(colorAccessor(d)),
                        labelAccessor: labelAccessor,
                        shape: shape,
                        datum: d
                    }, labelAccessor(d))
                }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
        });
    }
    function $e1dce75aa10566c3$var$HorizontalLegend(_ref6) {
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', flexDirection: flexDirection = 'row', maxRows: maxRows = 5 } = _ref6;
        const legendRef = (0, $5uXOq.useRef)(null);
        const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $924b13d0d377477c$export$7bf402e928540137));
        const flatData = (0, (0, parcelRequire("Ge7ik")).useFlatData)({
            labelAccessor: labelAccessor,
            data: data
        });
        (0, (0, parcelRequire("Ge7ik")).useTruncationIndexObserver)({
            legendRefCurrent: legendRef.current,
            setTruncationIndex: setTruncationIndex
        });
        const itemsToTruncate = flatData.length - (truncationIndex || 0);
        return (0, $2OMIu.jsx)("div", {
            ref: legendRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx21o5q _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"
            ]),
            style: {
                maxHeight: `${maxRows * (0, $924b13d0d377477c$export$bc48d9a7fd313bb2) + 2}px`,
                justifyContent: justifyContent,
                "--_j9pi5t": (0, (0, parcelRequire("lD23V")).default)(flexDirection)
            },
            children: flatData.map((d, i)=>(0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: itemsToTruncate > 0 && truncationIndex - 1 === i ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsxs)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: [
                                (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegendMark, {
                                    color: colorScale(colorAccessor(d)),
                                    labelAccessor: labelAccessor,
                                    shape: shape,
                                    opacity: 0,
                                    datum: d
                                }, labelAccessor(d)),
                                (0, $2OMIu.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0
                                    },
                                    className: (0, (0, parcelRequire("bwpsq")).default)([
                                        "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                    ]),
                                    children: ` ... ${itemsToTruncate + 1} more`
                                })
                            ]
                        })
                    }) : (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegendMark, {
                        color: colorScale(colorAccessor(d)),
                        labelAccessor: labelAccessor,
                        shape: shape,
                        datum: d
                    }, labelAccessor(d))
                }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
        });
    }
    function $e1dce75aa10566c3$export$734b3ee2d20431e7(_ref7) {
        var _layoutProps$gridTemp;
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, flexDirection: flexDirection = 'row', hide: hide = false } = _ref7;
        const layoutProps = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("2OPEf")).Layout));
        const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
        if (hide) return null;
        if (sideBySide) return (0, $2OMIu.jsx)($e1dce75aa10566c3$var$VerticalLegend, {
            data: data,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            labelAccessor: labelAccessor,
            shape: shape,
            maxRows: maxRows,
            justifyContent: justifyContent
        });
        return (0, $2OMIu.jsx)($e1dce75aa10566c3$var$HorizontalLegend, {
            data: data,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            labelAccessor: labelAccessor,
            shape: shape,
            maxRows: maxRows,
            justifyContent: justifyContent,
            flexDirection: flexDirection
        });
    }
    const $e1dce75aa10566c3$export$7f71253a43a34ee6 = (0, (0, parcelRequire("1xLej")).element)($e1dce75aa10566c3$export$734b3ee2d20431e7);
});
parcelRegister("l5VfC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5b679770729ba21$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfbyn;
    const $f5b679770729ba21$export$76a2e4c433c23bb9 = 'pointermove';
    const $f5b679770729ba21$export$8312cda563b4f1d7 = 'series-key-highlight';
    function $f5b679770729ba21$export$2e2bcd8739ae039(eventType) {
        if (eventType === void 0) eventType = $f5b679770729ba21$export$76a2e4c433c23bb9;
        const emit = (0, (0, parcelRequire("lfbyn")).default)();
        const emitActiveSeriesKey = (0, $5uXOq.useCallback)((event, label)=>emit === null || emit === void 0 ? void 0 : emit(eventType, event, $f5b679770729ba21$export$8312cda563b4f1d7, label), [
            emit
        ]);
        return {
            emitActiveSeriesKey: emitActiveSeriesKey
        };
    }
});
parcelRegister("lfbyn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f773f5f511eb23cf$export$2e2bcd8739ae039);
    var $eIrko;
    var $5uXOq = parcelRequire("5uXOq");
    var $ce7aF;
    function $f773f5f511eb23cf$export$2e2bcd8739ae039(eventType, handler, allowedSources) {
        const emitter = (0, $5uXOq.useContext)((0, (0, parcelRequire("ce7aF")).default));
        const allowedSourcesRef = (0, $5uXOq.useRef)();
        allowedSourcesRef.current = allowedSources;
        const emit = (0, $5uXOq.useCallback)((type, event, source, datum)=>{
            if (emitter) emitter.emit(type, {
                event: event,
                svgPoint: (0, (0, parcelRequire("eIrko")).default)(event),
                source: source,
                datum: datum
            });
        }, [
            emitter
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (emitter && eventType && handler) {
                const handlerWithSourceFilter = (params)=>{
                    var _allowedSourcesRef$cu;
                    if (!allowedSourcesRef.current || params !== null && params !== void 0 && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) !== null && _allowedSourcesRef$cu !== void 0 && _allowedSourcesRef$cu.includes(params.source)) handler(params);
                };
                emitter.on(eventType, handlerWithSourceFilter);
                return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
            }
            return undefined;
        }, [
            emitter,
            eventType,
            handler
        ]);
        return emitter ? emit : null;
    }
});
parcelRegister("eIrko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab6a5f852b569ad0$export$2e2bcd8739ae039);
    var $9hsAU;
    var $koq5f;
    function $ab6a5f852b569ad0$export$2e2bcd8739ae039(nodeOrEvent, maybeEvent) {
        if ((0, (0, parcelRequire("koq5f")).isElement)(nodeOrEvent) && maybeEvent) return (0, (0, parcelRequire("9hsAU")).default)(nodeOrEvent, maybeEvent);
        if ((0, (0, parcelRequire("koq5f")).isEvent)(nodeOrEvent)) {
            var event = nodeOrEvent;
            var node = event.target;
            if (node) return (0, (0, parcelRequire("9hsAU")).default)(node, event);
        }
        return null;
    }
});
parcelRegister("9hsAU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1be1cd7b69982c$export$2e2bcd8739ae039);
    var $9c8sC;
    var $koq5f;
    var $g6Ir5;
    function $6c1be1cd7b69982c$export$2e2bcd8739ae039(node, event) {
        if (!node || !event) return null;
        var coords = (0, (0, parcelRequire("g6Ir5")).default)(event);
        var svg = (0, (0, parcelRequire("koq5f")).isSVGElement)(node) ? node.ownerSVGElement : node;
        var screenCTM = (0, (0, parcelRequire("koq5f")).isSVGGraphicsElement)(svg) ? svg.getScreenCTM() : null;
        if ((0, (0, parcelRequire("koq5f")).isSVGSVGElement)(svg) && screenCTM) {
            var point = svg.createSVGPoint();
            point.x = coords.x;
            point.y = coords.y;
            point = point.matrixTransform(screenCTM.inverse());
            return new (0, (0, parcelRequire("9c8sC")).default)({
                x: point.x,
                y: point.y
            });
        }
        var rect = node.getBoundingClientRect();
        return new (0, (0, parcelRequire("9c8sC")).default)({
            x: coords.x - rect.left - node.clientLeft,
            y: coords.y - rect.top - node.clientTop
        });
    }
});
parcelRegister("9c8sC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b1bcc229a165e03$export$2e2bcd8739ae039);
    var $6b1bcc229a165e03$export$2e2bcd8739ae039 = function() {
        function Point(_ref) {
            var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y;
            this.x = 0;
            this.y = 0;
            this.x = x;
            this.y = y;
        }
        var _proto = Point.prototype;
        _proto.value = function value() {
            return {
                x: this.x,
                y: this.y
            };
        };
        _proto.toArray = function toArray() {
            return [
                this.x,
                this.y
            ];
        };
        return Point;
    }();
});
parcelRegister("koq5f", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$ed8a4839102faef6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isSVGElement", ()=>$ed8a4839102faef6$export$17eda790a720ec57);
    $parcel$export(module.exports, "isSVGSVGElement", ()=>$ed8a4839102faef6$export$66957ea77182581d);
    $parcel$export(module.exports, "isSVGGraphicsElement", ()=>$ed8a4839102faef6$export$d320b9df0ffd0744);
    $parcel$export(module.exports, "isTouchEvent", ()=>$ed8a4839102faef6$export$c4dfce035d43d1e0);
    $parcel$export(module.exports, "isMouseEvent", ()=>$ed8a4839102faef6$export$764db16956f554f8);
    $parcel$export(module.exports, "isEvent", ()=>$ed8a4839102faef6$export$9671ea99bd126ace);
    function $ed8a4839102faef6$export$45a5e7f76e0caa8d(elem) {
        return !!elem && elem instanceof Element;
    }
    function $ed8a4839102faef6$export$17eda790a720ec57(elem) {
        return !!elem && (elem instanceof SVGElement || 'ownerSVGElement' in elem);
    }
    function $ed8a4839102faef6$export$66957ea77182581d(elem) {
        return !!elem && 'createSVGPoint' in elem;
    }
    function $ed8a4839102faef6$export$d320b9df0ffd0744(elem) {
        return !!elem && 'getScreenCTM' in elem;
    }
    function $ed8a4839102faef6$export$c4dfce035d43d1e0(event) {
        return !!event && 'changedTouches' in event;
    }
    function $ed8a4839102faef6$export$764db16956f554f8(event) {
        return !!event && 'clientX' in event;
    }
    function $ed8a4839102faef6$export$9671ea99bd126ace(event) {
        return !!event && (event instanceof Event || 'nativeEvent' in event && event.nativeEvent instanceof Event);
    }
});
parcelRegister("g6Ir5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb9facec00996761$export$2e2bcd8739ae039);
    var $koq5f;
    function $bb9facec00996761$var$_extends() {
        $bb9facec00996761$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return $bb9facec00996761$var$_extends.apply(this, arguments);
    }
    var $bb9facec00996761$var$DEFAULT_POINT = {
        x: 0,
        y: 0
    };
    function $bb9facec00996761$export$2e2bcd8739ae039(event) {
        if (!event) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
        if ((0, (0, parcelRequire("koq5f")).isTouchEvent)(event)) return event.changedTouches.length > 0 ? {
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        } : $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
        if ((0, (0, parcelRequire("koq5f")).isMouseEvent)(event)) return {
            x: event.clientX,
            y: event.clientY
        };
        var target = event == null ? void 0 : event.target;
        var boundingClientRect = target && 'getBoundingClientRect' in target ? target.getBoundingClientRect() : null;
        if (!boundingClientRect) return $bb9facec00996761$var$_extends({}, $bb9facec00996761$var$DEFAULT_POINT);
        return {
            x: boundingClientRect.x + boundingClientRect.width / 2,
            y: boundingClientRect.y + boundingClientRect.height / 2
        };
    }
});
parcelRegister("ce7aF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e6c5adf8430c872$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $8e6c5adf8430c872$var$EventEmitterContext = (0, $5uXOq.createContext)(null);
    var $8e6c5adf8430c872$export$2e2bcd8739ae039 = $8e6c5adf8430c872$var$EventEmitterContext;
});
const $924b13d0d377477c$export$e64d201155cc8fe2 = 160;
const $924b13d0d377477c$export$bc48d9a7fd313bb2 = 32;
const $924b13d0d377477c$export$fece36e05d7a6c7b = 8;
const $924b13d0d377477c$export$57cb39d4eda3140a = 16;
const $924b13d0d377477c$export$1949567a35c96224 = 12;
const $924b13d0d377477c$export$3a3ed70a2e553a67 = 2;
const $924b13d0d377477c$export$7bf402e928540137 = 10000;
parcelRegister("Ge7ik", function(module, exports) {
    $parcel$export(module.exports, "useTruncationIndexObserver", ()=>$07eedfa1c3d431d5$export$ec599d67f76e7af7);
    $parcel$export(module.exports, "useFlatData", ()=>$07eedfa1c3d431d5$export$f27cffe517b2d3a3);
    var $5uXOq = parcelRequire("5uXOq");
    const $07eedfa1c3d431d5$export$178827bcd84b6d71 = (data, labelAccessor)=>{
        return data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = d;
            return newFlatData;
        }, {});
    };
    const $07eedfa1c3d431d5$export$5303528d1070ff6f = (value)=>{
        if (value === 'normal') return 8;
        else return parseFloat(value);
    };
    function $07eedfa1c3d431d5$export$ec599d67f76e7af7(_ref) {
        let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
        (0, $5uXOq.useEffect)(()=>{
            const observer = new ResizeObserver((entries)=>{
                let fit = 0;
                const content = [
                    ...entries[0].target.children
                ];
                content.forEach((d)=>{
                    if (!$07eedfa1c3d431d5$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
                });
                setTruncationIndex(fit);
            });
            if (legendRefCurrent) observer.observe(legendRefCurrent);
            return ()=>{
                if (legendRefCurrent) observer.unobserve(legendRefCurrent);
            };
        }, [
            legendRefCurrent,
            setTruncationIndex
        ]);
    }
    const $07eedfa1c3d431d5$export$660f61eb7bd5242a = (parent, child)=>{
        const box1coords = parent.getBoundingClientRect();
        const box2coords = child.getBoundingClientRect();
        if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
        return false;
    };
    function $07eedfa1c3d431d5$export$f27cffe517b2d3a3(_ref2) {
        let { labelAccessor: labelAccessor, data: data } = _ref2;
        return (0, $5uXOq.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
                const label = labelAccessor(d);
                if (flat[label]) return flat;
                const newFlatData = {
                    ...flat
                };
                newFlatData[label] = {
                    ...d
                };
                return newFlatData;
            }, {})), [
            labelAccessor,
            data
        ]);
    }
});
parcelRegister("dZ3lg", function(module, exports) {
    $parcel$export(module.exports, "Arc", ()=>$a2e3908135d5fd8e$export$6ef80ffb606dd232);
    var $bwpsq;
    var $hjll3 = parcelRequire("hjll3");
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    function $a2e3908135d5fd8e$export$596321273a76f453(func, value) {
        if (typeof value === 'number') func(value);
        else func(value);
    }
    const $a2e3908135d5fd8e$var$arcStyles = null;
    function $a2e3908135d5fd8e$export$ff1ef9a5c671f043(_temp) {
        let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius } = _temp === void 0 ? {} : _temp;
        const path = (0, $hjll3.arc)();
        if (innerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.innerRadius, innerRadius);
        if (outerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.outerRadius, outerRadius);
        if (cornerRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.cornerRadius, cornerRadius);
        if (startAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.startAngle, startAngle);
        if (endAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.endAngle, endAngle);
        if (padAngle != null) $a2e3908135d5fd8e$export$596321273a76f453(path.padAngle, padAngle);
        if (padRadius != null) $a2e3908135d5fd8e$export$596321273a76f453(path.padRadius, padRadius);
        return path;
    }
    function $a2e3908135d5fd8e$var$Arc(_ref) {
        let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius, datum: datum, opacity: opacity, children: children, innerRef: innerRef, ariaLabel: ariaLabel, fill: fill, stroke: stroke, ...rest } = _ref;
        const path = $a2e3908135d5fd8e$export$ff1ef9a5c671f043({
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            cornerRadius: cornerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            padAngle: padAngle,
            padRadius: padRadius
        });
        if (children) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children({
                path: path
            })
        });
        if (!datum && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
            console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
            return null;
        }
        return (0, $2OMIu.jsx)("path", {
            ref: innerRef,
            d: path(datum) || '',
            role: "img",
            "aria-label": ariaLabel,
            opacity: opacity,
            fill: fill,
            stroke: stroke,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_v564g17y"
            ])
        });
    }
    const $a2e3908135d5fd8e$export$6ef80ffb606dd232 = (0, (0, parcelRequire("1xLej")).element)($a2e3908135d5fd8e$var$Arc);
});
parcelRegister("gUvRg", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ORDINAL_COLORS", ()=>$c4fa96a3b63de071$export$1a2fb10b6c1fe2eb);
    $parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS_DEFS", ()=>$c4fa96a3b63de071$export$3b4caf16b18628d7);
    $parcel$export(module.exports, "useThemeFillStyles", ()=>$c4fa96a3b63de071$export$c533e33795ec3ca2);
    $parcel$export(module.exports, "Theme", ()=>$c4fa96a3b63de071$export$14faa19a0f3bbeb2);
    var $1xLej;
    var $36FXm;
    var $1vFS2;
    var $eI0U6;
    var $at5Kr;
    var $tzkRL;
    var $fmpgQ;
    var $2OMIu = parcelRequire("2OMIu");
    const $c4fa96a3b63de071$export$f32b764d072ed1b7 = [
        "var(--ds-chart-categorical-1, #2898BD)",
        "var(--ds-chart-categorical-2, #5E4DB2)",
        "var(--ds-chart-categorical-3, #E56910)",
        "var(--ds-chart-categorical-4, #943D73)",
        "var(--ds-chart-categorical-5, #09326C)",
        "var(--ds-chart-categorical-6, #8F7EE7)",
        "var(--ds-chart-categorical-7, #50253F)",
        "var(--ds-chart-categorical-8, #A54800)"
    ];
    const $c4fa96a3b63de071$export$5d11cb9bccf8f5db = [
        {
            key: 'danger',
            value: "var(--ds-chart-danger, #F15B50)"
        },
        {
            key: 'warning',
            value: "var(--ds-chart-warning, #B38600)"
        },
        {
            key: 'success',
            value: "var(--ds-chart-success, #22A06B)"
        },
        {
            key: 'discovery',
            value: "var(--ds-chart-discovery, #8F7EE7)"
        },
        {
            key: 'information',
            value: "var(--ds-chart-information, #388BFF)"
        },
        {
            key: 'neutral',
            value: "var(--ds-chart-neutral, #8590A2)"
        }
    ];
    const $c4fa96a3b63de071$export$f29a3c9071a2ca9 = [
        "var(--ds-chart-red-bold, #2898BD)",
        "var(--ds-chart-orange-bold, #943D73)",
        "var(--ds-chart-yellow-bold, #E56910)",
        "var(--ds-chart-lime-bold, #5E4DB2)",
        "var(--ds-chart-green-bold, #09326C)",
        "var(--ds-chart-teal-bold, #09326C)",
        "var(--ds-chart-blue-bold, #8F7EE7)",
        "var(--ds-chart-purple-bold, #50253F)",
        "var(--ds-chart-magenta-bold, #A54800)",
        "var(--ds-chart-gray-bold, #A54800)",
        "var(--ds-chart-red-boldest, #2898BD)",
        "var(--ds-chart-orange-boldest, #943D73)",
        "var(--ds-chart-yellow-boldest, #E56910)",
        "var(--ds-chart-lime-boldest, #5E4DB2)",
        "var(--ds-chart-green-boldest, #09326C)",
        "var(--ds-chart-teal-boldest, #09326C)",
        "var(--ds-chart-blue-boldest, #8F7EE7)",
        "var(--ds-chart-purple-boldest, #50253F)",
        "var(--ds-chart-magenta-boldest, #A54800)",
        "var(--ds-chart-gray-boldest, #A54800)"
    ];
    const $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb = [
        "var(--ds-chart-brand, #2898BD)",
        "var(--ds-chart-orange-bold, #943D73)",
        "var(--ds-chart-magenta-bold, #E56910)",
        "var(--ds-chart-lime-bold, #5E4DB2)",
        "var(--ds-chart-purple-bold, #09326C)",
        "var(--ds-chart-teal-bold, #8F7EE7)",
        "var(--ds-chart-green-bold, #50253F)",
        "var(--ds-chart-blue-boldest, #A54800)"
    ];
    const $c4fa96a3b63de071$export$3b4caf16b18628d7 = [
        (0, $2OMIu.jsx)((0, (0, parcelRequire("tzkRL")).default), {
            id: 'lines1',
            height: 5,
            width: 5,
            stroke: '#000000',
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[0],
            strokeWidth: 1,
            orientation: [
                'diagonal'
            ]
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("eI0U6")).default), {
            id: 'crosshair1',
            width: 5,
            height: 5,
            stroke: '#000000',
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[1],
            strokeWidth: 0.7,
            rotation: 45,
            gap: 7
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("tzkRL")).default), {
            id: 'lines2',
            height: 5,
            width: 5,
            stroke: '#000000',
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[2],
            strokeWidth: 1,
            orientation: [
                'diagonalRightToLeft'
            ]
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("eI0U6")).default), {
            id: 'crosshair2',
            width: 10,
            height: 10,
            stroke: '#000000',
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[3],
            strokeWidth: 0.5,
            rotation: 45,
            gap: 7
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("1vFS2")).default), {
            id: "circles1",
            height: 8,
            width: 8,
            radius: 1,
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[4],
            stroke: '#000000',
            strokeWidth: 0.4,
            complement: true,
            fill: 'none'
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("fmpgQ")).default), {
            id: "waves1",
            height: 6,
            width: 6,
            stroke: '#000000',
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[5],
            strokeWidth: 0.5
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("at5Kr")).default), {
            id: "hexagons1",
            height: 3,
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[6],
            size: 3,
            gap: 2,
            strokeWidth: 0.5,
            stroke: "#000000"
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("tzkRL")).default), {
            id: "lines3",
            height: 6,
            width: 5,
            stroke: '#000000',
            strokeDasharray: 3,
            background: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb[7],
            orientation: [
                'horizontal'
            ]
        })
    ];
    const $c4fa96a3b63de071$export$7b0a836186aa9014 = (0, (0, parcelRequire("36FXm")).getPatternUrls)($c4fa96a3b63de071$export$3b4caf16b18628d7);
    const $c4fa96a3b63de071$export$c533e33795ec3ca2 = (_ref)=>{
        let { fillStyles: customFillStyles, enableDefaultPatterns: enableDefaultPatterns } = _ref;
        const fillStyles = enableDefaultPatterns ? $c4fa96a3b63de071$export$7b0a836186aa9014 : customFillStyles;
        if (!fillStyles) return {
            range: [],
            domain: []
        };
        if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
            domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
            range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
        };
        else return {
            range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
        };
    };
    const $c4fa96a3b63de071$export$14faa19a0f3bbeb2 = (0, (0, parcelRequire("1xLej")).element)((_ref2)=>{
        let { children: children } = _ref2;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    });
    const $c4fa96a3b63de071$export$569885e57444f84a = {
        accessibleCategorical: $c4fa96a3b63de071$export$f32b764d072ed1b7,
        categorical: $c4fa96a3b63de071$export$1a2fb10b6c1fe2eb,
        status: $c4fa96a3b63de071$export$5d11cb9bccf8f5db,
        categorical20: $c4fa96a3b63de071$export$f29a3c9071a2ca9,
        accessiblePatternDefs: $c4fa96a3b63de071$export$3b4caf16b18628d7
    };
});
parcelRegister("36FXm", function(module, exports) {
    $parcel$export(module.exports, "getPatternUrls", ()=>$24327a5561e77841$export$c66920886885446e);
    const $24327a5561e77841$export$c66920886885446e = (patterns)=>{
        if (!patterns) return [];
        return patterns.map((pattern)=>`url(#${pattern.props.id})`);
    };
});
parcelRegister("1vFS2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11992a54050b85ce$export$2e2bcd8739ae039);
    var $9NZZf;
    var $2OMIu = parcelRequire("2OMIu");
    function $11992a54050b85ce$export$2e2bcd8739ae039(_ref) {
        var _corners;
        let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
        let corners;
        if (complement) corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9NZZf")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                (0, $2OMIu.jsx)("circle", {
                    cx: width / 2,
                    cy: height / 2,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }),
                (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                    let [cornerX, cornerY] = _ref2;
                    return (0, $2OMIu.jsx)("circle", {
                        cx: cornerX,
                        cy: cornerY,
                        r: radius,
                        fill: fill,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    }, `${id}-complement-${cornerX}-${cornerY}`);
                })
            ]
        });
    }
});
parcelRegister("9NZZf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7238c5fbf3c5b07a$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    function $7238c5fbf3c5b07a$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, children: children } = _ref;
        return (0, $2OMIu.jsx)("defs", {
            children: (0, $2OMIu.jsx)("pattern", {
                id: id,
                width: width,
                height: height,
                patternUnits: "userSpaceOnUse",
                children: children
            })
        });
    }
});
parcelRegister("eI0U6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab55e03aef75907f$export$2e2bcd8739ae039);
    var $9NZZf;
    var $2OMIu = parcelRequire("2OMIu");
    function $ab55e03aef75907f$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, stroke: stroke = 'black', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, background: background, className: className, rotation: rotation = 0, gap: gap = 10 } = _ref;
        const halfGap = gap / 2;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9NZZf")).default), {
            id: id,
            width: gap,
            height: gap,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: gap,
                    height: gap,
                    fill: background
                }),
                (0, $2OMIu.jsxs)("g", {
                    transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
                    children: [
                        (0, $2OMIu.jsx)("line", {
                            x1: halfGap - width / 2,
                            y1: halfGap,
                            x2: halfGap + width / 2,
                            y2: halfGap,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            strokeDasharray: strokeDasharray
                        }),
                        (0, $2OMIu.jsx)("line", {
                            x1: halfGap,
                            y1: halfGap - height / 2,
                            x2: halfGap,
                            y2: halfGap + height / 2,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            strokeDasharray: strokeDasharray
                        })
                    ]
                })
            ]
        });
    }
});
parcelRegister("at5Kr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79f11247fb4541b1$export$2e2bcd8739ae039);
    var $edkbM;
    var $2OMIu = parcelRequire("2OMIu");
    function $79f11247fb4541b1$export$2e2bcd8739ae039(_ref) {
        let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, shapeRendering: shapeRendering, background: background, className: className, size: size = 3, gap: gap = 0 } = _ref;
        const hexWidth = size * Math.sqrt(3) + gap;
        const hexHeight = size * 2 + gap;
        const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("edkbM")).default), {
            path: path,
            id: id,
            width: hexWidth,
            height: hexHeight,
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            shapeRendering: shapeRendering,
            background: background
        });
    }
});
parcelRegister("edkbM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a591f0adba09b863$export$2e2bcd8739ae039);
    var $9NZZf;
    var $2OMIu = parcelRequire("2OMIu");
    function $a591f0adba09b863$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9NZZf")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                (0, $2OMIu.jsx)("path", {
                    d: path,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                })
            ]
        });
    }
});
parcelRegister("tzkRL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$058e1e73ded3a1ef$export$2e2bcd8739ae039);
    var $8Y6fp;
    var $9NZZf;
    var $2OMIu = parcelRequire("2OMIu");
    function $058e1e73ded3a1ef$export$777054cdc3eb6ab2(_ref) {
        let { height: height, orientation: orientation } = _ref;
        switch(orientation){
            case (0, (0, parcelRequire("8Y6fp")).PatternOrientation).horizontal:
                return `M 0,${height / 2} l ${height},0`;
            case (0, (0, parcelRequire("8Y6fp")).PatternOrientation).diagonal:
                return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
            case (0, (0, parcelRequire("8Y6fp")).PatternOrientation).diagonalRightToLeft:
                return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
            case (0, (0, parcelRequire("8Y6fp")).PatternOrientation).vertical:
            default:
                return `M ${height / 2}, 0 l 0, ${height}`;
        }
    }
    function $058e1e73ded3a1ef$export$2e2bcd8739ae039(_ref2) {
        let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
            'vertical'
        ], background: background, className: className } = _ref2;
        const orientations = Array.isArray(orientation) ? orientation : [
            orientation
        ];
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9NZZf")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                orientations.map((o, i)=>(0, $2OMIu.jsx)("path", {
                        d: $058e1e73ded3a1ef$export$777054cdc3eb6ab2({
                            orientation: o,
                            height: height
                        }),
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray,
                        strokeLinecap: strokeLinecap,
                        shapeRendering: shapeRendering
                    }, `visx-${id}-line-${o}-${i}`))
            ]
        });
    }
});
parcelRegister("8Y6fp", function(module, exports) {
    $parcel$export(module.exports, "PatternOrientation", ()=>$6878c5f4aa13ee1a$export$c37d4d4692ef0c91);
    const $6878c5f4aa13ee1a$export$c37d4d4692ef0c91 = {
        horizontal: 'horizontal',
        vertical: 'vertical',
        diagonal: 'diagonal',
        diagonalRightToLeft: 'diagonalRightToLeft'
    };
});
parcelRegister("fmpgQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2ec83536669626b$export$2e2bcd8739ae039);
    var $edkbM;
    var $2OMIu = parcelRequire("2OMIu");
    function $b2ec83536669626b$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("edkbM")).default), {
            path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
            id: id,
            width: width,
            height: height,
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            strokeLinecap: strokeLinecap,
            shapeRendering: shapeRendering,
            background: background
        });
    }
});
parcelRegister("2dgU7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19c9e87b14940b14$export$2e2bcd8739ae039);
    var $dCj52 = parcelRequire("dCj52");
    var $5uXOq = parcelRequire("5uXOq");
    var $ce7aF;
    var $2OMIu = parcelRequire("2OMIu");
    function $19c9e87b14940b14$export$2e2bcd8739ae039(_ref) {
        let { children: children } = _ref;
        const emitter = (0, $5uXOq.useMemo)(()=>(0, $dCj52.default)(), []);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("ce7aF")).default).Provider, {
            value: emitter,
            children: children
        });
    }
});
parcelRegister("dCj52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e9d9fee2f6620e9$export$2e2bcd8739ae039);
    function $9e9d9fee2f6620e9$export$2e2bcd8739ae039(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i ? i.push(e) : n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
            },
            emit: function(t, e) {
                var i = n.get(t);
                i && i.slice().map(function(n) {
                    n(e);
                }), (i = n.get("*")) && i.slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    }
});
parcelRegister("d9Y89", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994ac24effc0a743$export$2e2bcd8739ae039);
    var $2qM0c = parcelRequire("2qM0c");
    var $5uXOq = parcelRequire("5uXOq");
    var $kaPp4;
    var $dYSV3;
    var $2OMIu = parcelRequire("2OMIu");
    function $994ac24effc0a743$var$isValidNumber(_) {
        return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
    }
    function $994ac24effc0a743$export$2e2bcd8739ae039(_ref) {
        let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
        const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, (0, parcelRequire("kaPp4")).default)(undefined);
        const debouncedHideTooltip = (0, $5uXOq.useRef)(null);
        function cancelDeboundedHideTooltip() {
            if (debouncedHideTooltip.current) {
                debouncedHideTooltip.current.cancel();
                debouncedHideTooltip.current = null;
            }
        }
        (0, $5uXOq.useEffect)(()=>cancelDeboundedHideTooltip, []);
        const showTooltip = (0, $5uXOq.useRef)((_ref2)=>{
            let { svgPoint: svgPoint, index: index, datum: datum, distanceX: distanceX, distanceY: distanceY, nearestSeriesData: nearestSeriesData, event: event } = _ref2;
            cancelDeboundedHideTooltip();
            const cleanDistanceX = $994ac24effc0a743$var$isValidNumber(distanceX) ? distanceX : Infinity;
            const cleanDistanceY = $994ac24effc0a743$var$isValidNumber(distanceY) ? distanceY : Infinity;
            const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
            const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
            const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
            updateTooltip((_ref3)=>{
                let { tooltipData: tooltipData } = _ref3;
                return {
                    tooltipOpen: true,
                    tooltipLeft: tooltipLeft,
                    tooltipTop: tooltipTop,
                    tooltipData: {
                        nearestDatum: {
                            index: index,
                            datum: datum,
                            distance: distance
                        },
                        nearestSeriesData: nearestSeriesData
                    }
                };
            });
        });
        const hideTooltip = (0, $5uXOq.useCallback)(()=>{
            debouncedHideTooltip.current = (0, ($parcel$interopDefault($2qM0c)))(privateHideTooltip, hideTooltipDebounceMs);
            debouncedHideTooltip.current();
        }, [
            privateHideTooltip,
            hideTooltipDebounceMs
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                tooltipOpen: tooltipOpen,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: tooltipData,
                updateTooltip: updateTooltip,
                showTooltip: showTooltip.current,
                hideTooltip: hideTooltip
            }), [
            hideTooltip,
            tooltipData,
            tooltipLeft,
            tooltipOpen,
            tooltipTop,
            updateTooltip
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("dYSV3")).default).Provider, {
            value: value,
            children: children
        });
    }
});
parcelRegister("2qM0c", function(module, exports) {
    var $1c533eb56f421364$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $1c533eb56f421364$var$NAN = 0 / 0;
    var $1c533eb56f421364$var$symbolTag = '[object Symbol]';
    var $1c533eb56f421364$var$reTrim = /^\s+|\s+$/g;
    var $1c533eb56f421364$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var $1c533eb56f421364$var$reIsBinary = /^0b[01]+$/i;
    var $1c533eb56f421364$var$reIsOctal = /^0o[0-7]+$/i;
    var $1c533eb56f421364$var$freeParseInt = parseInt;
    var $1c533eb56f421364$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    var $1c533eb56f421364$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    var $1c533eb56f421364$var$root = $1c533eb56f421364$var$freeGlobal || $1c533eb56f421364$var$freeSelf || Function('return this')();
    var $1c533eb56f421364$var$objectProto = Object.prototype;
    var $1c533eb56f421364$var$objectToString = $1c533eb56f421364$var$objectProto.toString;
    var $1c533eb56f421364$var$nativeMax = Math.max, $1c533eb56f421364$var$nativeMin = Math.min;
    var $1c533eb56f421364$var$now = function() {
        return $1c533eb56f421364$var$root.Date.now();
    };
    function $1c533eb56f421364$var$debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError($1c533eb56f421364$var$FUNC_ERROR_TEXT);
        wait = $1c533eb56f421364$var$toNumber(wait) || 0;
        if ($1c533eb56f421364$var$isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? $1c533eb56f421364$var$nativeMax($1c533eb56f421364$var$toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout(timerExpired, wait);
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
            return maxing ? $1c533eb56f421364$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = $1c533eb56f421364$var$now();
            if (shouldInvoke(time)) return trailingEdge(time);
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge($1c533eb56f421364$var$now());
        }
        function debounced() {
            var time = $1c533eb56f421364$var$now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    function $1c533eb56f421364$var$isObject(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
    }
    function $1c533eb56f421364$var$isObjectLike(value) {
        return !!value && typeof value == 'object';
    }
    function $1c533eb56f421364$var$isSymbol(value) {
        return typeof value == 'symbol' || $1c533eb56f421364$var$isObjectLike(value) && $1c533eb56f421364$var$objectToString.call(value) == $1c533eb56f421364$var$symbolTag;
    }
    function $1c533eb56f421364$var$toNumber(value) {
        if (typeof value == 'number') return value;
        if ($1c533eb56f421364$var$isSymbol(value)) return $1c533eb56f421364$var$NAN;
        if ($1c533eb56f421364$var$isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = $1c533eb56f421364$var$isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = value.replace($1c533eb56f421364$var$reTrim, '');
        var isBinary = $1c533eb56f421364$var$reIsBinary.test(value);
        return isBinary || $1c533eb56f421364$var$reIsOctal.test(value) ? $1c533eb56f421364$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1c533eb56f421364$var$reIsBadHex.test(value) ? $1c533eb56f421364$var$NAN : +value;
    }
    module.exports = $1c533eb56f421364$var$debounce;
});
parcelRegister("kaPp4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eafc9d7ae9cf5da9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $eafc9d7ae9cf5da9$export$2e2bcd8739ae039(initialTooltipState) {
        const [tooltipState, setTooltipState] = (0, $5uXOq.useState)({
            tooltipOpen: false,
            ...initialTooltipState
        });
        const showTooltip = (0, $5uXOq.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
                let { tooltipOpen: tooltipOpen, ...show } = _ref;
                return {
                    ...showArgs(show),
                    tooltipOpen: true
                };
            } : {
                tooltipOpen: true,
                tooltipLeft: showArgs.tooltipLeft,
                tooltipTop: showArgs.tooltipTop,
                tooltipData: showArgs.tooltipData
            }), [
            setTooltipState
        ]);
        const hideTooltip = (0, $5uXOq.useCallback)(()=>setTooltipState({
                tooltipOpen: false,
                tooltipLeft: undefined,
                tooltipTop: undefined,
                tooltipData: undefined
            }), [
            setTooltipState
        ]);
        return {
            tooltipOpen: tooltipState.tooltipOpen,
            tooltipLeft: tooltipState.tooltipLeft,
            tooltipTop: tooltipState.tooltipTop,
            tooltipData: tooltipState.tooltipData,
            updateTooltip: setTooltipState,
            showTooltip: showTooltip,
            hideTooltip: hideTooltip
        };
    }
});
parcelRegister("dYSV3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2db7acbe58821cc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $a2db7acbe58821cc$var$TooltipContext = (0, $5uXOq.createContext)({});
    var $a2db7acbe58821cc$export$2e2bcd8739ae039 = $a2db7acbe58821cc$var$TooltipContext;
});
parcelRegister("8upbu", function(module, exports) {
    $parcel$export(module.exports, "SingleSeriesTooltip", ()=>$62e4a921b2a96d37$export$417a3bee9df17219);
    var $1xLej;
    var $7Mdb4;
    var $a6QE1;
    var $lCjFE;
    var $2OMIu = parcelRequire("2OMIu");
    function $62e4a921b2a96d37$var$SingleSeriesTooltip(_ref) {
        var _tooltipData$nearestD, _window, _window2;
        let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, (0, parcelRequire("lCjFE")).default).formatNumberAbbreviated } = _ref;
        const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
        const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
        const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
        const portalLeft = (tooltipLeft || 0) + scrollX;
        const portalTop = (tooltipTop || 0) + scrollY;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: datum && (0, $2OMIu.jsx)((0, (0, parcelRequire("a6QE1")).default), {
                left: portalLeft,
                top: portalTop,
                tooltipPortalElement: document.body,
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("7Mdb4")).TooltipRow), {
                    datum: datum,
                    color: colorScale(colorAccessor(datum)),
                    label: labelAccessor(datum),
                    value: String(valueFormatter(valueAccessor(datum)))
                }, String(labelAccessor(datum)))
            })
        });
    }
    const $62e4a921b2a96d37$export$417a3bee9df17219 = (0, (0, parcelRequire("1xLej")).element)($62e4a921b2a96d37$var$SingleSeriesTooltip);
});
parcelRegister("7Mdb4", function(module, exports) {
    $parcel$export(module.exports, "TooltipRow", ()=>$5a973cdf469c1297$export$4cf463b4a9fc631a);
    var $bwpsq;
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    const $5a973cdf469c1297$var$outerDivCss = null;
    const $5a973cdf469c1297$var$innerDivCss = null;
    const $5a973cdf469c1297$var$colorItemCss = null;
    const $5a973cdf469c1297$var$labelItemCss = null;
    const $5a973cdf469c1297$var$valueItemCss = null;
    function $5a973cdf469c1297$var$TooltipRow(_ref) {
        let { color: color, label: label, value: value, datum: datum } = _ref;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
            ]),
            children: (0, $2OMIu.jsxs)("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                ]),
                children: [
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                        ]),
                        children: (0, $2OMIu.jsx)("svg", {
                            style: {
                                width: 12,
                                height: 12,
                                borderRadius: 2
                            },
                            children: (0, $2OMIu.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                fill: color
                            })
                        })
                    }),
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"
                        ]),
                        children: label
                    }),
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"
                        ]),
                        children: value
                    })
                ]
            })
        });
    }
    const $5a973cdf469c1297$export$4cf463b4a9fc631a = (0, (0, parcelRequire("1xLej")).element)($5a973cdf469c1297$var$TooltipRow);
});
parcelRegister("a6QE1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75c34d03f8863ce8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gB7jb;
    var $2OMIu = parcelRequire("2OMIu");
    const $75c34d03f8863ce8$var$DEFAULT_TRANSLATE = 'translate(0%, -100%)';
    function $75c34d03f8863ce8$var$TooltipWithBounds(_ref) {
        let { children: children, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = -2, style: style = (0, (0, parcelRequire("gB7jb")).defaultStyles), top: initialTop = 0, unstyled: unstyled = false, ...otherProps } = _ref;
        const elementRef = (0, $5uXOq.useRef)(null);
        const [transformStyle, setTransformStyle] = (0, $5uXOq.useState)($75c34d03f8863ce8$var$DEFAULT_TRANSLATE);
        (0, $5uXOq.useEffect)(()=>{
            var _elementRef$current;
            const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
            if (rect) {
                const outOfViewTop = Math.min(0, initialTop - rect.height);
                const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
                const translateX = outOfViewRight > 0 ? -rect.width : 0;
                const translateY = outOfViewTop < 0 ? 0 : -rect.height;
                setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
            }
        }, [
            initialTop,
            initialLeft,
            elementRef
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("gB7jb")).default), {
            ref: elementRef,
            style: {
                top: initialTop + offsetTop,
                left: initialLeft + offsetLeft,
                transform: transformStyle,
                transition: 'transform 0.3s',
                ...!unstyled && style
            },
            ...otherProps,
            children: children
        });
    }
    var $75c34d03f8863ce8$export$2e2bcd8739ae039 = $75c34d03f8863ce8$var$TooltipWithBounds;
});
parcelRegister("gB7jb", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$c155c554b9b5d42f$export$214b055320e0bf32);
    $parcel$export(module.exports, "default", ()=>$c155c554b9b5d42f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $2OMIu = parcelRequire("2OMIu");
    const $c155c554b9b5d42f$export$214b055320e0bf32 = {
        position: 'absolute',
        backgroundColor: "var(--ds-surface-overlay, white)",
        padding: '.3rem .5rem',
        borderRadius: '3px',
        fontSize: '14px',
        boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
        lineHeight: '1em',
        pointerEvents: 'none',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        overflow: 'hidden',
        border: `1px ${"var(--ds-border, grey)"} solid`,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        zIndex: 999,
        display: 'flex'
    };
    const $c155c554b9b5d42f$var$Tooltip = (0, $5uXOq.forwardRef)((_ref, ref)=>{
        let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $c155c554b9b5d42f$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false } = _ref;
        const elem = (0, $2OMIu.jsx)("div", {
            ref: ref,
            className: className,
            style: {
                top: top == null || offsetTop == null ? top : top + offsetTop,
                left: left == null || offsetLeft == null ? left : left + offsetLeft,
                ...applyPositionStyle && {
                    position: 'absolute'
                },
                ...!unstyled && style
            },
            children: children
        });
        if (tooltipPortalElement) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $7nsd3.createPortal)(elem, tooltipPortalElement)
        });
        return elem;
    });
    $c155c554b9b5d42f$var$Tooltip.displayName = 'Tooltip';
    var $c155c554b9b5d42f$export$2e2bcd8739ae039 = $c155c554b9b5d42f$var$Tooltip;
});
parcelRegister("dcCcf", function(module, exports) {
    $parcel$export(module.exports, "DonutMetricValue", ()=>$99ca065e440c4016$export$a919e8af430790ff);
    $parcel$export(module.exports, "DonutMetricLabel", ()=>$99ca065e440c4016$export$1378bacd15e58eae);
    $parcel$export(module.exports, "DonutMetric", ()=>$99ca065e440c4016$export$263bc5dd8230a1d9);
    var $bwpsq;
    var $1xLej;
    var $9ZCPf;
    var $5rJQH;
    var $lCjFE;
    var $2OMIu = parcelRequire("2OMIu");
    const $99ca065e440c4016$export$9c69e622944f45dc = null;
    const $99ca065e440c4016$export$25396b46317eb664 = null;
    const $99ca065e440c4016$export$a919e8af430790ff = (0, (0, parcelRequire("1xLej")).element)((_ref)=>{
        let { totalValue: totalValue, width: width, formatter: formatter } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("5rJQH")).default), {
            width: width,
            truncate: true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lswu1fxt _1fjgnkob _ect41wi2 _1wyb1pa9"
            ]),
            children: formatter(totalValue)
        }, `donut-value-${totalValue}`);
    });
    const $99ca065e440c4016$export$1378bacd15e58eae = (0, (0, parcelRequire("1xLej")).element)((_ref2)=>{
        let { width: width, label: label, totalValue: totalValue } = _ref2;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("5rJQH")).default), {
            y: 24,
            width: width,
            truncate: true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lswu131l _1fjgnkob _ect41wi2 _1wyb7vkz"
            ]),
            children: label
        }, `donut-value-text-${label}`);
    });
    const $99ca065e440c4016$export$263bc5dd8230a1d9 = (0, (0, parcelRequire("1xLej")).element)(function DonutLabel(_ref3) {
        let { data: data, hide: hide, valueAccessor: valueAccessor, innerRadius: innerRadius } = _ref3;
        if (hide) return null;
        if (innerRadius < 30) return null;
        const centerTextValue = data.reduce((total, d)=>total + valueAccessor(d), 0);
        const width = innerRadius * Math.SQRT2;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9ZCPf")).default), {
            children: [
                (0, $2OMIu.jsx)($99ca065e440c4016$export$a919e8af430790ff, {
                    width: width,
                    totalValue: centerTextValue,
                    formatter: (0, (0, parcelRequire("lCjFE")).default).formatNumberAbbreviated
                }),
                (0, $2OMIu.jsx)($99ca065e440c4016$export$1378bacd15e58eae, {
                    width: width,
                    label: 'Total value',
                    totalValue: centerTextValue
                })
            ]
        });
    });
});
parcelRegister("9ZCPf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7467ed7d3ae0ffa3$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    function $7467ed7d3ae0ffa3$export$2e2bcd8739ae039(_ref) {
        let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
        return (0, $2OMIu.jsx)("g", {
            ref: innerRef,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            children: children
        });
    }
});
parcelRegister("5rJQH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f730a0b03a2463c$export$2e2bcd8739ae039);
    var $3bDjY;
    var $7V0T2;
    var $2OMIu = parcelRequire("2OMIu");
    const $3f730a0b03a2463c$var$SVG_STYLE = {
        overflow: 'visible'
    };
    function $3f730a0b03a2463c$export$2e2bcd8739ae039(props) {
        const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, alignmentBaseline: alignmentBaseline, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: scaleToFit = false, capHeight: capHeight, truncate: truncate, singleline: singleline, children: children, ...textProps } = props;
        const { x: x = 0, fontSize: fontSize } = textProps;
        const { wordsByLines: wordsByLines, startDy: startDy, transform: transform, truncated: truncated } = (0, (0, parcelRequire("7V0T2")).default)(props);
        const textComponent = (0, $2OMIu.jsx)("g", {
            ref: innerRef,
            fontSize: fontSize,
            style: {
                ...$3f730a0b03a2463c$var$SVG_STYLE,
                transform: `translate(calc(${dx}), calc(${dy}))`
            },
            children: wordsByLines.length > 0 ? (0, $2OMIu.jsx)("text", {
                ref: innerTextRef,
                transform: transform,
                ...textProps,
                textAnchor: textAnchor,
                children: wordsByLines.map((line, index)=>(0, $2OMIu.jsx)("tspan", {
                        alignmentBaseline: alignmentBaseline,
                        x: x,
                        dy: index === 0 ? startDy : lineHeight,
                        children: line.words.join(' ')
                    }, index))
            }) : null
        });
        if (truncated) {
            var _props$children;
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("3bDjY")).default), {
                tag: "g",
                content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
                position: "bottom",
                children: textComponent
            });
        }
        return textComponent;
    }
});
parcelRegister("7V0T2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c3e8b5dd84fb6ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6xQMF = parcelRequire("6xQMF");
    var $hRG4n;
    function $5c3e8b5dd84fb6ea$var$isNumber(val) {
        return typeof val === 'number';
    }
    function $5c3e8b5dd84fb6ea$var$isXOrYInValid(xOrY) {
        return (typeof xOrY === 'number' && Number.isFinite(xOrY) || typeof xOrY === 'string');
    }
    function $5c3e8b5dd84fb6ea$export$2e2bcd8739ae039(props) {
        const { verticalAnchor: verticalAnchor = 'start', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0em', children: children, truncate: truncate, style: style, singleline: singleline, ...textProps } = props;
        const { x: x = 0, y: y = 0 } = textProps;
        const isXOrYNotValid = !$5c3e8b5dd84fb6ea$var$isXOrYInValid(x) || !$5c3e8b5dd84fb6ea$var$isXOrYInValid(y);
        const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5uXOq.useMemo)(()=>{
            const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
            return {
                wordsWithWidth: words.map((word)=>({
                        word: word,
                        wordWidth: (0, (0, parcelRequire("hRG4n")).default)(word, style) || 0
                    })),
                spaceWidth: (0, (0, parcelRequire("hRG4n")).default)('\u00A0', style) || 0
            };
        }, [
            children,
            style
        ]);
        const { wordsByLines: wordsByLines, truncated: truncated } = (0, $5uXOq.useMemo)(()=>{
            let isTruncated = false;
            if (isXOrYNotValid) return {
                wordsByLines: [],
                truncated: isTruncated
            };
            if (width || scaleToFit) {
                const words = wordsWithWidth.reduce((result, _ref)=>{
                    let { word: word, wordWidth: wordWidth } = _ref;
                    const currentLine = result[result.length - 1];
                    if (currentLine && (width == null || scaleToFit || truncate || singleline || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                        currentLine.words.push(word);
                        currentLine.width = currentLine.width || 0;
                        currentLine.width += wordWidth + spaceWidth;
                    } else {
                        const newLine = {
                            words: [
                                word
                            ],
                            width: wordWidth
                        };
                        result.push(newLine);
                    }
                    return result;
                }, []);
                if (truncate && width) {
                    const ellipsesWidth = (0, (0, parcelRequire("hRG4n")).default)('...', style) || 0;
                    const joinedWords = words[0].words.join('\u00A0');
                    const joinedSubstring = joinedWords.substring(0, (width - ellipsesWidth) / (words[0].width || 0) * joinedWords.length);
                    if (joinedSubstring !== joinedWords) {
                        isTruncated = true;
                        words[0].words = [
                            joinedSubstring + '...'
                        ];
                    }
                }
                return {
                    wordsByLines: words,
                    truncated: isTruncated
                };
            }
            return {
                wordsByLines: [
                    {
                        words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
                    }
                ],
                truncated: isTruncated
            };
        }, [
            isXOrYNotValid,
            width,
            scaleToFit,
            children,
            wordsWithWidth,
            spaceWidth
        ]);
        const startDy = (0, $5uXOq.useMemo)(()=>{
            const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, ($parcel$interopDefault($6xQMF)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, ($parcel$interopDefault($6xQMF)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, ($parcel$interopDefault($6xQMF)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
            return startDyStr;
        }, [
            isXOrYNotValid,
            verticalAnchor,
            capHeight,
            wordsByLines.length,
            lineHeight
        ]);
        const transform = (0, $5uXOq.useMemo)(()=>{
            const transforms = [];
            if (isXOrYNotValid) return '';
            if ($5c3e8b5dd84fb6ea$var$isNumber(x) && $5c3e8b5dd84fb6ea$var$isNumber(y) && $5c3e8b5dd84fb6ea$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
                const lineWidth = wordsByLines[0].width || 1;
                const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
                const sy = sx;
                const originX = x - sx * x;
                const originY = y - sy * y;
                transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
            }
            if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
            return transforms.length > 0 ? transforms.join(' ') : '';
        }, [
            isXOrYNotValid,
            x,
            y,
            width,
            scaleToFit,
            wordsByLines,
            angle
        ]);
        return {
            wordsByLines: wordsByLines,
            startDy: startDy,
            transform: transform,
            truncated: truncated
        };
    }
});
parcelRegister("6xQMF", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $66zZI = parcelRequire("66zZI");
    var $4c3ec4f1f2153be8$var$_postcssValueParser2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($66zZI);
    var $dR6OW = parcelRequire("dR6OW");
    var $8nBRK = parcelRequire("8nBRK");
    var $4c3ec4f1f2153be8$var$_reducer2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($8nBRK);
    var $hYnJW = parcelRequire("hYnJW");
    var $4c3ec4f1f2153be8$var$_stringifier2 = $4c3ec4f1f2153be8$var$_interopRequireDefault($hYnJW);
    function $4c3ec4f1f2153be8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4c3ec4f1f2153be8$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
    module.exports.default = function(value) {
        var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
        return (0, $4c3ec4f1f2153be8$var$_postcssValueParser2.default)(value).walk(function(node) {
            if (node.type !== 'function' || !$4c3ec4f1f2153be8$var$MATCH_CALC.test(node.value)) return;
            var contents = $4c3ec4f1f2153be8$var$_postcssValueParser2.default.stringify(node.nodes);
            if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
            var ast = $dR6OW.parser.parse(contents);
            var reducedAst = (0, $4c3ec4f1f2153be8$var$_reducer2.default)(ast, precision);
            node.type = 'word';
            node.value = (0, $4c3ec4f1f2153be8$var$_stringifier2.default)(node.value, reducedAst, precision);
        }, true).toString();
    };
    module.exports = module.exports['default'];
});
parcelRegister("66zZI", function(module, exports) {
    var $c05wQ = parcelRequire("c05wQ");
    var $lLT70 = parcelRequire("lLT70");
    var $56MFS = parcelRequire("56MFS");
    function $471f39605d327d11$var$ValueParser(value) {
        if (this instanceof $471f39605d327d11$var$ValueParser) {
            this.nodes = $c05wQ(value);
            return this;
        }
        return new $471f39605d327d11$var$ValueParser(value);
    }
    $471f39605d327d11$var$ValueParser.prototype.toString = function() {
        return Array.isArray(this.nodes) ? $56MFS(this.nodes) : "";
    };
    $471f39605d327d11$var$ValueParser.prototype.walk = function(cb, bubble) {
        $lLT70(this.nodes, cb, bubble);
        return this;
    };
    $471f39605d327d11$var$ValueParser.unit = (parcelRequire("6U91R"));
    $471f39605d327d11$var$ValueParser.walk = $lLT70;
    $471f39605d327d11$var$ValueParser.stringify = $56MFS;
    module.exports = $471f39605d327d11$var$ValueParser;
});
parcelRegister("c05wQ", function(module, exports) {
    var $8bc9c60852c1cb63$var$openParentheses = "(".charCodeAt(0);
    var $8bc9c60852c1cb63$var$closeParentheses = ")".charCodeAt(0);
    var $8bc9c60852c1cb63$var$singleQuote = "'".charCodeAt(0);
    var $8bc9c60852c1cb63$var$doubleQuote = '"'.charCodeAt(0);
    var $8bc9c60852c1cb63$var$backslash = "\\".charCodeAt(0);
    var $8bc9c60852c1cb63$var$slash = "/".charCodeAt(0);
    var $8bc9c60852c1cb63$var$comma = ",".charCodeAt(0);
    var $8bc9c60852c1cb63$var$colon = ":".charCodeAt(0);
    var $8bc9c60852c1cb63$var$star = "*".charCodeAt(0);
    module.exports = function(input) {
        var tokens = [];
        var value = input;
        var next, quote, prev, token, escape, escapePos, whitespacePos;
        var pos = 0;
        var code = value.charCodeAt(pos);
        var max = value.length;
        var stack = [
            {
                nodes: tokens
            }
        ];
        var balanced = 0;
        var parent;
        var name = "";
        var before = "";
        var after = "";
        while(pos < max){
            if (code <= 32) {
                next = pos;
                do {
                    next += 1;
                    code = value.charCodeAt(next);
                }while (code <= 32)
                token = value.slice(pos, next);
                prev = tokens[tokens.length - 1];
                if (code === $8bc9c60852c1cb63$var$closeParentheses && balanced) after = token;
                else if (prev && prev.type === "div") prev.after = token;
                else if (code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon || code === $8bc9c60852c1cb63$var$slash && value.charCodeAt(next + 1) !== $8bc9c60852c1cb63$var$star) before = token;
                else tokens.push({
                    type: "space",
                    sourceIndex: pos,
                    value: token
                });
                pos = next;
            } else if (code === $8bc9c60852c1cb63$var$singleQuote || code === $8bc9c60852c1cb63$var$doubleQuote) {
                next = pos;
                quote = code === $8bc9c60852c1cb63$var$singleQuote ? "'" : '"';
                token = {
                    type: "string",
                    sourceIndex: pos,
                    quote: quote
                };
                do {
                    escape = false;
                    next = value.indexOf(quote, next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $8bc9c60852c1cb63$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += quote;
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape)
                token.value = value.slice(pos + 1, next);
                tokens.push(token);
                pos = next + 1;
                code = value.charCodeAt(pos);
            } else if (code === $8bc9c60852c1cb63$var$slash && value.charCodeAt(pos + 1) === $8bc9c60852c1cb63$var$star) {
                token = {
                    type: "comment",
                    sourceIndex: pos
                };
                next = value.indexOf("*/", pos);
                if (next === -1) {
                    token.unclosed = true;
                    next = value.length;
                }
                token.value = value.slice(pos + 2, next);
                tokens.push(token);
                pos = next + 2;
                code = value.charCodeAt(pos);
            } else if (code === $8bc9c60852c1cb63$var$slash || code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon) {
                token = value[pos];
                tokens.push({
                    type: "div",
                    sourceIndex: pos - before.length,
                    value: token,
                    before: before,
                    after: ""
                });
                before = "";
                pos += 1;
                code = value.charCodeAt(pos);
            } else if ($8bc9c60852c1cb63$var$openParentheses === code) {
                next = pos;
                do {
                    next += 1;
                    code = value.charCodeAt(next);
                }while (code <= 32)
                token = {
                    type: "function",
                    sourceIndex: pos - name.length,
                    value: name,
                    before: value.slice(pos + 1, next)
                };
                pos = next;
                if (name === "url" && code !== $8bc9c60852c1cb63$var$singleQuote && code !== $8bc9c60852c1cb63$var$doubleQuote) {
                    next -= 1;
                    do {
                        escape = false;
                        next = value.indexOf(")", next + 1);
                        if (~next) {
                            escapePos = next;
                            while(value.charCodeAt(escapePos - 1) === $8bc9c60852c1cb63$var$backslash){
                                escapePos -= 1;
                                escape = !escape;
                            }
                        } else {
                            value += ")";
                            next = value.length - 1;
                            token.unclosed = true;
                        }
                    }while (escape)
                    whitespacePos = next;
                    do {
                        whitespacePos -= 1;
                        code = value.charCodeAt(whitespacePos);
                    }while (code <= 32)
                    if (pos !== whitespacePos + 1) token.nodes = [
                        {
                            type: "word",
                            sourceIndex: pos,
                            value: value.slice(pos, whitespacePos + 1)
                        }
                    ];
                    else token.nodes = [];
                    if (token.unclosed && whitespacePos + 1 !== next) {
                        token.after = "";
                        token.nodes.push({
                            type: "space",
                            sourceIndex: whitespacePos + 1,
                            value: value.slice(whitespacePos + 1, next)
                        });
                    } else token.after = value.slice(whitespacePos + 1, next);
                    pos = next + 1;
                    code = value.charCodeAt(pos);
                    tokens.push(token);
                } else {
                    balanced += 1;
                    token.after = "";
                    tokens.push(token);
                    stack.push(token);
                    tokens = token.nodes = [];
                    parent = token;
                }
                name = "";
            } else if ($8bc9c60852c1cb63$var$closeParentheses === code && balanced) {
                pos += 1;
                code = value.charCodeAt(pos);
                parent.after = after;
                after = "";
                balanced -= 1;
                stack.pop();
                parent = stack[balanced];
                tokens = parent.nodes;
            } else {
                next = pos;
                do {
                    if (code === $8bc9c60852c1cb63$var$backslash) next += 1;
                    next += 1;
                    code = value.charCodeAt(next);
                }while (next < max && !(code <= 32 || code === $8bc9c60852c1cb63$var$singleQuote || code === $8bc9c60852c1cb63$var$doubleQuote || code === $8bc9c60852c1cb63$var$comma || code === $8bc9c60852c1cb63$var$colon || code === $8bc9c60852c1cb63$var$slash || code === $8bc9c60852c1cb63$var$openParentheses || code === $8bc9c60852c1cb63$var$closeParentheses && balanced))
                token = value.slice(pos, next);
                if ($8bc9c60852c1cb63$var$openParentheses === code) name = token;
                else tokens.push({
                    type: "word",
                    sourceIndex: pos,
                    value: token
                });
                pos = next;
            }
        }
        for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
        return stack[0].nodes;
    };
});
parcelRegister("lLT70", function(module, exports) {
    module.exports = function walk(nodes, cb, bubble) {
        var i, max, node, result;
        for(i = 0, max = nodes.length; i < max; i += 1){
            node = nodes[i];
            if (!bubble) result = cb(node, i, nodes);
            if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
            if (bubble) cb(node, i, nodes);
        }
    };
});
parcelRegister("56MFS", function(module, exports) {
    function $3b834504a4ab1d04$var$stringifyNode(node, custom) {
        var type = node.type;
        var value = node.value;
        var buf;
        var customResult;
        if (custom && (customResult = custom(node)) !== undefined) return customResult;
        else if (type === "word" || type === "space") return value;
        else if (type === "string") {
            buf = node.quote || "";
            return buf + value + (node.unclosed ? "" : buf);
        } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
        else if (type === "div") return (node.before || "") + value + (node.after || "");
        else if (Array.isArray(node.nodes)) {
            buf = $3b834504a4ab1d04$var$stringify(node.nodes);
            if (type !== "function") return buf;
            return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
        }
        return value;
    }
    function $3b834504a4ab1d04$var$stringify(nodes, custom) {
        var result, i;
        if (Array.isArray(nodes)) {
            result = "";
            for(i = nodes.length - 1; ~i; i -= 1)result = $3b834504a4ab1d04$var$stringifyNode(nodes[i], custom) + result;
            return result;
        }
        return $3b834504a4ab1d04$var$stringifyNode(nodes, custom);
    }
    module.exports = $3b834504a4ab1d04$var$stringify;
});
parcelRegister("6U91R", function(module, exports) {
    var $506ef9fdb9238895$var$minus = "-".charCodeAt(0);
    var $506ef9fdb9238895$var$plus = "+".charCodeAt(0);
    var $506ef9fdb9238895$var$dot = ".".charCodeAt(0);
    var $506ef9fdb9238895$var$exp = "e".charCodeAt(0);
    var $506ef9fdb9238895$var$EXP = "E".charCodeAt(0);
    module.exports = function(value) {
        var pos = 0;
        var length = value.length;
        var dotted = false;
        var sciPos = -1;
        var containsNumber = false;
        var code;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code >= 48 && code <= 57) containsNumber = true;
            else if (code === $506ef9fdb9238895$var$exp || code === $506ef9fdb9238895$var$EXP) {
                if (sciPos > -1) break;
                sciPos = pos;
            } else if (code === $506ef9fdb9238895$var$dot) {
                if (dotted) break;
                dotted = true;
            } else if (code === $506ef9fdb9238895$var$plus || code === $506ef9fdb9238895$var$minus) {
                if (pos !== 0) break;
            } else break;
            pos += 1;
        }
        if (sciPos + 1 === pos) pos--;
        return containsNumber ? {
            number: value.slice(0, pos),
            unit: value.slice(pos)
        } : false;
    };
});
parcelRegister("dR6OW", function(module, exports) {
    $parcel$export(module.exports, "parser", ()=>$a165840c76c6afe6$export$8f49e4af10703ce3, (v)=>$a165840c76c6afe6$export$8f49e4af10703ce3 = v);
    var $a165840c76c6afe6$export$8f49e4af10703ce3;
    var $a165840c76c6afe6$export$7acfa6ed01010e37;
    var $a165840c76c6afe6$export$98e6a39c04603d36;
    var $a165840c76c6afe6$var$parser = function() {
        function JisonParserError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonParserError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
        else JisonParserError.prototype = Object.create(Error.prototype);
        JisonParserError.prototype.constructor = JisonParserError;
        JisonParserError.prototype.name = 'JisonParserError';
        function bp(s) {
            var rv = [];
            var p = s.pop;
            var r = s.rule;
            for(var i = 0, l = p.length; i < l; i++)rv.push([
                p[i],
                r[i]
            ]);
            return rv;
        }
        function bda(s) {
            var rv = {};
            var d = s.idx;
            var g = s.goto;
            for(var i = 0, l = d.length; i < l; i++){
                var j = d[i];
                rv[j] = g[i];
            }
            return rv;
        }
        function bt(s) {
            var rv = [];
            var d = s.len;
            var y = s.symbol;
            var t = s.type;
            var a = s.state;
            var m = s.mode;
            var g = s.goto;
            for(var i = 0, l = d.length; i < l; i++){
                var n = d[i];
                var q = {};
                for(var j = 0; j < n; j++){
                    var z = y.shift();
                    switch(t.shift()){
                        case 2:
                            q[z] = [
                                m.shift(),
                                g.shift()
                            ];
                            break;
                        case 0:
                            q[z] = a.shift();
                            break;
                        default:
                            q[z] = [
                                3
                            ];
                    }
                }
                rv.push(q);
            }
            return rv;
        }
        function s(c, l, a) {
            a = a || 0;
            for(var i = 0; i < l; i++){
                this.push(c);
                c += a;
            }
        }
        function c(i, l) {
            i = this.length - i;
            for(l += i; i < l; i++)this.push(this[i]);
        }
        function u(a) {
            var rv = [];
            for(var i = 0, l = a.length; i < l; i++){
                var e = a[i];
                if (typeof e === 'function') {
                    i++;
                    e.apply(rv, a[i]);
                } else rv.push(e);
            }
            return rv;
        }
        var parser = {
            trace: function no_op_trace() {},
            JisonParserError: JisonParserError,
            yy: {},
            options: {
                type: "lalr",
                hasPartialLrUpgradeOnConflict: true,
                errorRecoveryTokenDiscardCount: 3
            },
            symbols_: {
                "$accept": 0,
                "$end": 1,
                "ADD": 3,
                "ANGLE": 16,
                "CHS": 22,
                "COMMA": 14,
                "CSS_CPROP": 13,
                "CSS_VAR": 12,
                "DIV": 6,
                "EMS": 20,
                "EOF": 1,
                "EXS": 21,
                "FREQ": 18,
                "LENGTH": 15,
                "LPAREN": 7,
                "MUL": 5,
                "NESTED_CALC": 9,
                "NUMBER": 11,
                "PERCENTAGE": 28,
                "PREFIX": 10,
                "REMS": 23,
                "RES": 19,
                "RPAREN": 8,
                "SUB": 4,
                "TIME": 17,
                "VHS": 24,
                "VMAXS": 27,
                "VMINS": 26,
                "VWS": 25,
                "css_value": 33,
                "css_variable": 32,
                "error": 2,
                "expression": 29,
                "math_expression": 30,
                "value": 31
            },
            terminals_: {
                1: "EOF",
                2: "error",
                3: "ADD",
                4: "SUB",
                5: "MUL",
                6: "DIV",
                7: "LPAREN",
                8: "RPAREN",
                9: "NESTED_CALC",
                10: "PREFIX",
                11: "NUMBER",
                12: "CSS_VAR",
                13: "CSS_CPROP",
                14: "COMMA",
                15: "LENGTH",
                16: "ANGLE",
                17: "TIME",
                18: "FREQ",
                19: "RES",
                20: "EMS",
                21: "EXS",
                22: "CHS",
                23: "REMS",
                24: "VHS",
                25: "VWS",
                26: "VMINS",
                27: "VMAXS",
                28: "PERCENTAGE"
            },
            TERROR: 2,
            EOF: 1,
            originalQuoteName: null,
            originalParseError: null,
            cleanupAfterParse: null,
            constructParseErrorInfo: null,
            yyMergeLocationInfo: null,
            __reentrant_call_depth: 0,
            __error_infos: [],
            __error_recovery_infos: [],
            quoteName: function parser_quoteName(id_str) {
                return '"' + id_str + '"';
            },
            getSymbolName: function parser_getSymbolName(symbol) {
                if (this.terminals_[symbol]) return this.terminals_[symbol];
                var s = this.symbols_;
                for(var key in s){
                    if (s[key] === symbol) return key;
                }
                return null;
            },
            describeSymbol: function parser_describeSymbol(symbol) {
                if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
                else if (symbol === this.EOF) return 'end of input';
                var id = this.getSymbolName(symbol);
                if (id) return this.quoteName(id);
                return null;
            },
            collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
                var TERROR = this.TERROR;
                var tokenset = [];
                var check = {};
                if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                    this.state_descriptions_[state]
                ];
                for(var p in this.table[state]){
                    p = +p;
                    if (p !== TERROR) {
                        var d = do_not_describe ? p : this.describeSymbol(p);
                        if (d && !check[d]) {
                            tokenset.push(d);
                            check[d] = true;
                        }
                    }
                }
                return tokenset;
            },
            productions_: bp({
                pop: u([
                    29,
                    s,
                    [
                        30,
                        10
                    ],
                    31,
                    31,
                    32,
                    32,
                    s,
                    [
                        33,
                        15
                    ]
                ]),
                rule: u([
                    2,
                    s,
                    [
                        3,
                        5
                    ],
                    4,
                    7,
                    s,
                    [
                        1,
                        4
                    ],
                    2,
                    4,
                    6,
                    s,
                    [
                        1,
                        14
                    ],
                    2
                ])
            }),
            performAction: function parser__PerformAction(yystate, yysp, yyvstack) {
                var yy = this.yy;
                var yyparser = yy.parser;
                var yylexer = yy.lexer;
                switch(yystate){
                    case 0:
                        this.$ = yyvstack[yysp - 1];
                        break;
                    case 1:
                        this.$ = yyvstack[yysp - 1];
                        return yyvstack[yysp - 1];
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        this.$ = {
                            type: 'MathExpression',
                            operator: yyvstack[yysp - 1],
                            left: yyvstack[yysp - 2],
                            right: yyvstack[yysp]
                        };
                        break;
                    case 6:
                        this.$ = yyvstack[yysp - 1];
                        break;
                    case 7:
                        this.$ = {
                            type: 'Calc',
                            value: yyvstack[yysp - 1]
                        };
                        break;
                    case 8:
                        this.$ = {
                            type: 'Calc',
                            value: yyvstack[yysp - 1],
                            prefix: yyvstack[yysp - 5]
                        };
                        break;
                    case 9:
                    case 10:
                    case 11:
                        this.$ = yyvstack[yysp];
                        break;
                    case 12:
                        this.$ = {
                            type: 'Value',
                            value: parseFloat(yyvstack[yysp])
                        };
                        break;
                    case 13:
                        this.$ = {
                            type: 'Value',
                            value: parseFloat(yyvstack[yysp]) * -1
                        };
                        break;
                    case 14:
                        this.$ = {
                            type: 'CssVariable',
                            value: yyvstack[yysp - 1]
                        };
                        break;
                    case 15:
                        this.$ = {
                            type: 'CssVariable',
                            value: yyvstack[yysp - 3],
                            fallback: yyvstack[yysp - 1]
                        };
                        break;
                    case 16:
                        this.$ = {
                            type: 'LengthValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                        };
                        break;
                    case 17:
                        this.$ = {
                            type: 'AngleValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                        };
                        break;
                    case 18:
                        this.$ = {
                            type: 'TimeValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                        };
                        break;
                    case 19:
                        this.$ = {
                            type: 'FrequencyValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                        };
                        break;
                    case 20:
                        this.$ = {
                            type: 'ResolutionValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                        };
                        break;
                    case 21:
                        this.$ = {
                            type: 'EmValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'em'
                        };
                        break;
                    case 22:
                        this.$ = {
                            type: 'ExValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'ex'
                        };
                        break;
                    case 23:
                        this.$ = {
                            type: 'ChValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'ch'
                        };
                        break;
                    case 24:
                        this.$ = {
                            type: 'RemValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'rem'
                        };
                        break;
                    case 25:
                        this.$ = {
                            type: 'VhValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'vh'
                        };
                        break;
                    case 26:
                        this.$ = {
                            type: 'VwValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'vw'
                        };
                        break;
                    case 27:
                        this.$ = {
                            type: 'VminValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'vmin'
                        };
                        break;
                    case 28:
                        this.$ = {
                            type: 'VmaxValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: 'vmax'
                        };
                        break;
                    case 29:
                        this.$ = {
                            type: 'PercentageValue',
                            value: parseFloat(yyvstack[yysp]),
                            unit: '%'
                        };
                        break;
                    case 30:
                        var prev = yyvstack[yysp];
                        prev.value *= -1;
                        this.$ = prev;
                        break;
                }
            },
            table: bt({
                len: u([
                    24,
                    1,
                    5,
                    23,
                    1,
                    18,
                    s,
                    [
                        0,
                        3
                    ],
                    1,
                    s,
                    [
                        0,
                        16
                    ],
                    s,
                    [
                        23,
                        4
                    ],
                    c,
                    [
                        28,
                        3
                    ],
                    0,
                    0,
                    16,
                    1,
                    6,
                    6,
                    s,
                    [
                        0,
                        3
                    ],
                    5,
                    1,
                    2,
                    c,
                    [
                        37,
                        3
                    ],
                    c,
                    [
                        20,
                        3
                    ],
                    5,
                    0,
                    0
                ]),
                symbol: u([
                    4,
                    7,
                    9,
                    11,
                    12,
                    s,
                    [
                        15,
                        19,
                        1
                    ],
                    1,
                    1,
                    s,
                    [
                        3,
                        4,
                        1
                    ],
                    c,
                    [
                        30,
                        19
                    ],
                    c,
                    [
                        29,
                        4
                    ],
                    7,
                    4,
                    10,
                    11,
                    c,
                    [
                        22,
                        14
                    ],
                    c,
                    [
                        19,
                        3
                    ],
                    c,
                    [
                        43,
                        22
                    ],
                    c,
                    [
                        23,
                        69
                    ],
                    c,
                    [
                        139,
                        4
                    ],
                    8,
                    c,
                    [
                        51,
                        24
                    ],
                    4,
                    c,
                    [
                        138,
                        15
                    ],
                    13,
                    c,
                    [
                        186,
                        5
                    ],
                    8,
                    c,
                    [
                        6,
                        6
                    ],
                    c,
                    [
                        5,
                        5
                    ],
                    9,
                    8,
                    14,
                    c,
                    [
                        159,
                        47
                    ],
                    c,
                    [
                        60,
                        10
                    ]
                ]),
                type: u([
                    s,
                    [
                        2,
                        19
                    ],
                    s,
                    [
                        0,
                        5
                    ],
                    1,
                    s,
                    [
                        2,
                        24
                    ],
                    s,
                    [
                        0,
                        4
                    ],
                    c,
                    [
                        22,
                        19
                    ],
                    c,
                    [
                        43,
                        42
                    ],
                    c,
                    [
                        23,
                        70
                    ],
                    c,
                    [
                        28,
                        25
                    ],
                    c,
                    [
                        45,
                        25
                    ],
                    c,
                    [
                        113,
                        54
                    ]
                ]),
                state: u([
                    1,
                    2,
                    8,
                    6,
                    7,
                    30,
                    c,
                    [
                        4,
                        3
                    ],
                    33,
                    37,
                    c,
                    [
                        5,
                        3
                    ],
                    38,
                    c,
                    [
                        4,
                        3
                    ],
                    39,
                    c,
                    [
                        4,
                        3
                    ],
                    40,
                    c,
                    [
                        4,
                        3
                    ],
                    42,
                    c,
                    [
                        21,
                        4
                    ],
                    50,
                    c,
                    [
                        5,
                        3
                    ],
                    51,
                    c,
                    [
                        4,
                        3
                    ]
                ]),
                mode: u([
                    s,
                    [
                        1,
                        179
                    ],
                    s,
                    [
                        2,
                        3
                    ],
                    c,
                    [
                        5,
                        5
                    ],
                    c,
                    [
                        6,
                        4
                    ],
                    s,
                    [
                        1,
                        57
                    ]
                ]),
                goto: u([
                    5,
                    3,
                    4,
                    24,
                    s,
                    [
                        9,
                        15,
                        1
                    ],
                    s,
                    [
                        25,
                        5,
                        1
                    ],
                    c,
                    [
                        24,
                        19
                    ],
                    31,
                    35,
                    32,
                    34,
                    c,
                    [
                        18,
                        14
                    ],
                    36,
                    c,
                    [
                        38,
                        19
                    ],
                    c,
                    [
                        19,
                        57
                    ],
                    c,
                    [
                        118,
                        4
                    ],
                    41,
                    c,
                    [
                        24,
                        19
                    ],
                    43,
                    35,
                    c,
                    [
                        16,
                        14
                    ],
                    44,
                    s,
                    [
                        2,
                        3
                    ],
                    28,
                    29,
                    2,
                    s,
                    [
                        3,
                        3
                    ],
                    28,
                    29,
                    3,
                    c,
                    [
                        53,
                        4
                    ],
                    s,
                    [
                        45,
                        5,
                        1
                    ],
                    c,
                    [
                        100,
                        42
                    ],
                    52,
                    c,
                    [
                        5,
                        4
                    ],
                    53
                ])
            }),
            defaultActions: bda({
                idx: u([
                    6,
                    7,
                    8,
                    s,
                    [
                        10,
                        16,
                        1
                    ],
                    33,
                    34,
                    39,
                    40,
                    41,
                    45,
                    47,
                    52,
                    53
                ]),
                goto: u([
                    9,
                    10,
                    11,
                    s,
                    [
                        16,
                        14,
                        1
                    ],
                    12,
                    1,
                    30,
                    13,
                    s,
                    [
                        4,
                        4,
                        1
                    ],
                    14,
                    15,
                    8
                ])
            }),
            parseError: function parseError(str, hash, ExceptionClass) {
                if (hash.recoverable) {
                    if (typeof this.trace === 'function') this.trace(str);
                    hash.destroy();
                } else {
                    if (typeof this.trace === 'function') this.trace(str);
                    if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                    throw new ExceptionClass(str, hash);
                }
            },
            parse: function parse(input) {
                var self = this;
                var stack = new Array(128);
                var sstack = new Array(128);
                var vstack = new Array(128);
                var table = this.table;
                var sp = 0;
                var symbol = 0;
                var TERROR = this.TERROR;
                var EOF = this.EOF;
                var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
                var NO_ACTION = [
                    0,
                    54
                ];
                var lexer;
                if (this.__lexer__) lexer = this.__lexer__;
                else lexer = this.__lexer__ = Object.create(this.lexer);
                var sharedState_yy = {
                    parseError: undefined,
                    quoteName: undefined,
                    lexer: undefined,
                    parser: undefined,
                    pre_parse: undefined,
                    post_parse: undefined,
                    pre_lex: undefined,
                    post_lex: undefined
                };
                var ASSERT;
                if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                    if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
                };
                else ASSERT = assert;
                this.yyGetSharedState = function yyGetSharedState() {
                    return sharedState_yy;
                };
                function shallow_copy_noclobber(dst, src) {
                    for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
                }
                shallow_copy_noclobber(sharedState_yy, this.yy);
                sharedState_yy.lexer = lexer;
                sharedState_yy.parser = this;
                if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                    if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                    return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
                };
                else this.parseError = this.originalParseError;
                if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                    return sharedState_yy.quoteName.call(this, id_str);
                };
                else this.quoteName = this.originalQuoteName;
                this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                    var rv;
                    if (invoke_post_methods) {
                        var hash;
                        if (sharedState_yy.post_parse || this.post_parse) hash = this.constructParseErrorInfo(null, null, null, false);
                        if (sharedState_yy.post_parse) {
                            rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                            if (typeof rv !== 'undefined') resultValue = rv;
                        }
                        if (this.post_parse) {
                            rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                            if (typeof rv !== 'undefined') resultValue = rv;
                        }
                        if (hash && hash.destroy) hash.destroy();
                    }
                    if (this.__reentrant_call_depth > 1) return resultValue;
                    if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                    if (sharedState_yy) {
                        sharedState_yy.lexer = undefined;
                        sharedState_yy.parser = undefined;
                        if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                    }
                    sharedState_yy = undefined;
                    this.parseError = this.originalParseError;
                    this.quoteName = this.originalQuoteName;
                    stack.length = 0;
                    sstack.length = 0;
                    vstack.length = 0;
                    sp = 0;
                    if (!do_not_nuke_errorinfos) {
                        for(var i = this.__error_infos.length - 1; i >= 0; i--){
                            var el = this.__error_infos[i];
                            if (el && typeof el.destroy === 'function') el.destroy();
                        }
                        this.__error_infos.length = 0;
                    }
                    return resultValue;
                };
                this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                    var pei = {
                        errStr: msg,
                        exception: ex,
                        text: lexer.match,
                        value: lexer.yytext,
                        token: this.describeSymbol(symbol) || symbol,
                        token_id: symbol,
                        line: lexer.yylineno,
                        expected: expected,
                        recoverable: recoverable,
                        state: state,
                        action: action,
                        new_state: newState,
                        symbol_stack: stack,
                        state_stack: sstack,
                        value_stack: vstack,
                        stack_pointer: sp,
                        yy: sharedState_yy,
                        lexer: lexer,
                        parser: this,
                        destroy: function destructParseErrorInfo() {
                            var rec = !!this.recoverable;
                            for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                            this.recoverable = rec;
                        }
                    };
                    this.__error_infos.push(pei);
                    return pei;
                };
                function getNonTerminalFromCode(symbol) {
                    var tokenName = self.getSymbolName(symbol);
                    if (!tokenName) tokenName = symbol;
                    return tokenName;
                }
                function stdLex() {
                    var token = lexer.lex();
                    if (typeof token !== 'number') token = self.symbols_[token] || token;
                    return token || EOF;
                }
                function fastLex() {
                    var token = lexer.fastLex();
                    if (typeof token !== 'number') token = self.symbols_[token] || token;
                    return token || EOF;
                }
                var lex = stdLex;
                var state, action, r, t;
                var yyval = {
                    $: true,
                    _$: undefined,
                    yy: sharedState_yy
                };
                var p;
                var yyrulelen;
                var this_production;
                var newState;
                var retval = false;
                try {
                    this.__reentrant_call_depth++;
                    lexer.setInput(input, sharedState_yy);
                    if (typeof lexer.canIUse === 'function') {
                        var lexerInfo = lexer.canIUse();
                        if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                    }
                    vstack[sp] = null;
                    sstack[sp] = 0;
                    stack[sp] = 0;
                    ++sp;
                    if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                    if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                    newState = sstack[sp - 1];
                    for(;;){
                        state = newState;
                        if (this.defaultActions[state]) {
                            action = 2;
                            newState = this.defaultActions[state];
                        } else {
                            if (!symbol) symbol = lex();
                            t = table[state] && table[state][symbol] || NO_ACTION;
                            newState = t[1];
                            action = t[0];
                            if (!action) {
                                var errStr;
                                var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                                var expected = this.collect_expected_token_set(state);
                                if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                                else errStr = 'Parse error: ';
                                if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                                if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                                else errStr += 'Unexpected ' + errSymbolDescr;
                                p = this.constructParseErrorInfo(errStr, null, expected, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                        }
                        switch(action){
                            default:
                                if (action instanceof Array) {
                                    p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                    r = this.parseError(p.errStr, p, this.JisonParserError);
                                    if (typeof r !== 'undefined') retval = r;
                                    break;
                                }
                                p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            case 1:
                                stack[sp] = symbol;
                                vstack[sp] = lexer.yytext;
                                sstack[sp] = newState;
                                ++sp;
                                symbol = 0;
                                continue;
                            case 2:
                                this_production = this.productions_[newState - 1];
                                yyrulelen = this_production[1];
                                r = this.performAction.call(yyval, newState, sp - 1, vstack);
                                if (typeof r !== 'undefined') {
                                    retval = r;
                                    break;
                                }
                                sp -= yyrulelen;
                                var ntsymbol = this_production[0];
                                stack[sp] = ntsymbol;
                                vstack[sp] = yyval.$;
                                newState = table[sstack[sp - 1]][ntsymbol];
                                sstack[sp] = newState;
                                ++sp;
                                continue;
                            case 3:
                                if (sp !== -2) {
                                    retval = true;
                                    sp--;
                                    if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                                }
                                break;
                        }
                        break;
                    }
                } catch (ex) {
                    if (ex instanceof this.JisonParserError) throw ex;
                    else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                    p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                    retval = false;
                    r = this.parseError(p.errStr, p, this.JisonParserError);
                    if (typeof r !== 'undefined') retval = r;
                } finally{
                    retval = this.cleanupAfterParse(retval, true, true);
                    this.__reentrant_call_depth--;
                }
                return retval;
            }
        };
        parser.originalParseError = parser.parseError;
        parser.originalQuoteName = parser.quoteName;
        var lexer = function() {
            function JisonLexerError(msg, hash) {
                Object.defineProperty(this, 'name', {
                    enumerable: false,
                    writable: false,
                    value: 'JisonLexerError'
                });
                if (msg == null) msg = '???';
                Object.defineProperty(this, 'message', {
                    enumerable: false,
                    writable: true,
                    value: msg
                });
                this.hash = hash;
                var stacktrace;
                if (hash && hash.exception instanceof Error) {
                    var ex2 = hash.exception;
                    this.message = ex2.message || msg;
                    stacktrace = ex2.stack;
                }
                if (!stacktrace) {
                    if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
                    else stacktrace = new Error(msg).stack;
                }
                if (stacktrace) Object.defineProperty(this, 'stack', {
                    enumerable: false,
                    writable: false,
                    value: stacktrace
                });
            }
            if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
            else JisonLexerError.prototype = Object.create(Error.prototype);
            JisonLexerError.prototype.constructor = JisonLexerError;
            JisonLexerError.prototype.name = 'JisonLexerError';
            var lexer = {
                EOF: 1,
                ERROR: 2,
                __currentRuleSet__: null,
                __error_infos: [],
                __decompressed: false,
                done: false,
                _backtrack: false,
                _input: '',
                _more: false,
                _signaled_error_token: false,
                conditionStack: [],
                match: '',
                matched: '',
                matches: false,
                yytext: '',
                offset: 0,
                yyleng: 0,
                yylineno: 0,
                yylloc: null,
                constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                    msg = '' + msg;
                    if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                    if (this.yylloc && show_input_position) {
                        if (typeof this.prettyPrintRange === 'function') {
                            var pretty_src = this.prettyPrintRange(this.yylloc);
                            if (!/\n\s*$/.test(msg)) msg += '\n';
                            msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                        } else if (typeof this.showPosition === 'function') {
                            var pos_str = this.showPosition();
                            if (pos_str) {
                                if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                                else msg += pos_str;
                            }
                        }
                    }
                    var pei = {
                        errStr: msg,
                        recoverable: !!recoverable,
                        text: this.match,
                        token: null,
                        line: this.yylineno,
                        loc: this.yylloc,
                        yy: this.yy,
                        lexer: this,
                        destroy: function destructLexErrorInfo() {
                            var rec = !!this.recoverable;
                            for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                            this.recoverable = rec;
                        }
                    };
                    this.__error_infos.push(pei);
                    return pei;
                },
                parseError: function lexer_parseError(str, hash, ExceptionClass) {
                    if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                    if (this.yy) {
                        if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                        else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    }
                    throw new ExceptionClass(str, hash);
                },
                yyerror: function yyError(str) {
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                    var args = Array.prototype.slice.call(arguments, 1);
                    if (args.length) p.extra_error_attributes = args;
                    return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                },
                cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                    this.setInput('', {});
                    if (!do_not_nuke_errorinfos) {
                        for(var i = this.__error_infos.length - 1; i >= 0; i--){
                            var el = this.__error_infos[i];
                            if (el && typeof el.destroy === 'function') el.destroy();
                        }
                        this.__error_infos.length = 0;
                    }
                    return this;
                },
                clear: function lexer_clear() {
                    this.yytext = '';
                    this.yyleng = 0;
                    this.match = '';
                    this.matches = false;
                    this._more = false;
                    this._backtrack = false;
                    var col = this.yylloc ? this.yylloc.last_column : 0;
                    this.yylloc = {
                        first_line: this.yylineno + 1,
                        first_column: col,
                        last_line: this.yylineno + 1,
                        last_column: col,
                        range: [
                            this.offset,
                            this.offset
                        ]
                    };
                },
                setInput: function lexer_setInput(input, yy) {
                    this.yy = yy || this.yy || {};
                    if (!this.__decompressed) {
                        var rules = this.rules;
                        for(var i = 0, len = rules.length; i < len; i++){
                            var rule_re = rules[i];
                            if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                        }
                        var conditions = this.conditions;
                        for(var k in conditions){
                            var spec = conditions[k];
                            var rule_ids = spec.rules;
                            var len = rule_ids.length;
                            var rule_regexes = new Array(len + 1);
                            var rule_new_ids = new Array(len + 1);
                            for(var i = 0; i < len; i++){
                                var idx = rule_ids[i];
                                var rule_re = rules[idx];
                                rule_regexes[i + 1] = rule_re;
                                rule_new_ids[i + 1] = idx;
                            }
                            spec.rules = rule_new_ids;
                            spec.__rule_regexes = rule_regexes;
                            spec.__rule_count = len;
                        }
                        this.__decompressed = true;
                    }
                    this._input = input || '';
                    this.clear();
                    this._signaled_error_token = false;
                    this.done = false;
                    this.yylineno = 0;
                    this.matched = '';
                    this.conditionStack = [
                        'INITIAL'
                    ];
                    this.__currentRuleSet__ = null;
                    this.yylloc = {
                        first_line: 1,
                        first_column: 0,
                        last_line: 1,
                        last_column: 0,
                        range: [
                            0,
                            0
                        ]
                    };
                    this.offset = 0;
                    return this;
                },
                editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                    var rv = callback.call(this, this._input, cpsArg);
                    if (typeof rv !== 'string') {
                        if (rv) this._input = '' + rv;
                    } else this._input = rv;
                    return this;
                },
                input: function lexer_input() {
                    if (!this._input) return null;
                    var ch = this._input[0];
                    this.yytext += ch;
                    this.yyleng++;
                    this.offset++;
                    this.match += ch;
                    this.matched += ch;
                    var slice_len = 1;
                    var lines = false;
                    if (ch === '\n') lines = true;
                    else if (ch === '\r') {
                        lines = true;
                        var ch2 = this._input[1];
                        if (ch2 === '\n') {
                            slice_len++;
                            ch += ch2;
                            this.yytext += ch2;
                            this.yyleng++;
                            this.offset++;
                            this.match += ch2;
                            this.matched += ch2;
                            this.yylloc.range[1]++;
                        }
                    }
                    if (lines) {
                        this.yylineno++;
                        this.yylloc.last_line++;
                        this.yylloc.last_column = 0;
                    } else this.yylloc.last_column++;
                    this.yylloc.range[1]++;
                    this._input = this._input.slice(slice_len);
                    return ch;
                },
                unput: function lexer_unput(ch) {
                    var len = ch.length;
                    var lines = ch.split(/(?:\r\n?|\n)/g);
                    this._input = ch + this._input;
                    this.yytext = this.yytext.substr(0, this.yytext.length - len);
                    this.yyleng = this.yytext.length;
                    this.offset -= len;
                    this.match = this.match.substr(0, this.match.length - len);
                    this.matched = this.matched.substr(0, this.matched.length - len);
                    if (lines.length > 1) {
                        this.yylineno -= lines.length - 1;
                        this.yylloc.last_line = this.yylineno + 1;
                        var pre = this.match;
                        var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                        if (pre_lines.length === 1) {
                            pre = this.matched;
                            pre_lines = pre.split(/(?:\r\n?|\n)/g);
                        }
                        this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                    } else this.yylloc.last_column -= len;
                    this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                    this.done = false;
                    return this;
                },
                more: function lexer_more() {
                    this._more = true;
                    return this;
                },
                reject: function lexer_reject() {
                    if (this.options.backtrack_lexer) this._backtrack = true;
                    else {
                        var lineno_msg = '';
                        if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                        this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                    return this;
                },
                less: function lexer_less(n) {
                    return this.unput(this.match.slice(n));
                },
                pastInput: function lexer_pastInput(maxSize, maxLines) {
                    var past = this.matched.substring(0, this.matched.length - this.match.length);
                    if (maxSize < 0) maxSize = past.length;
                    else if (!maxSize) maxSize = 20;
                    if (maxLines < 0) maxLines = past.length;
                    else if (!maxLines) maxLines = 1;
                    past = past.substr(-maxSize * 2 - 2);
                    var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                    a = a.slice(-maxLines);
                    past = a.join('\n');
                    if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                    return past;
                },
                upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                    var next = this.match;
                    if (maxSize < 0) maxSize = next.length + this._input.length;
                    else if (!maxSize) maxSize = 20;
                    if (maxLines < 0) maxLines = maxSize;
                    else if (!maxLines) maxLines = 1;
                    if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2);
                    var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                    a = a.slice(0, maxLines);
                    next = a.join('\n');
                    if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                    return next;
                },
                showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                    var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                    var c = new Array(pre.length + 1).join('-');
                    return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
                },
                deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                    var loc = {
                        first_line: 1,
                        first_column: 0,
                        last_line: 1,
                        last_column: 0,
                        range: [
                            0,
                            0
                        ]
                    };
                    if (actual) {
                        loc.first_line = actual.first_line | 0;
                        loc.last_line = actual.last_line | 0;
                        loc.first_column = actual.first_column | 0;
                        loc.last_column = actual.last_column | 0;
                        if (actual.range) {
                            loc.range[0] = actual.range[0] | 0;
                            loc.range[1] = actual.range[1] | 0;
                        }
                    }
                    if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                        if (loc.first_line <= 0 && preceding) {
                            loc.first_line = preceding.last_line | 0;
                            loc.first_column = preceding.last_column | 0;
                            if (preceding.range) loc.range[0] = actual.range[1] | 0;
                        }
                        if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                            loc.last_line = following.first_line | 0;
                            loc.last_column = following.first_column | 0;
                            if (following.range) loc.range[1] = actual.range[0] | 0;
                        }
                        if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                            loc.first_line = current.first_line | 0;
                            loc.first_column = current.first_column | 0;
                            if (current.range) loc.range[0] = current.range[0] | 0;
                        }
                        if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                            loc.last_line = current.last_line | 0;
                            loc.last_column = current.last_column | 0;
                            if (current.range) loc.range[1] = current.range[1] | 0;
                        }
                    }
                    if (loc.last_line <= 0) {
                        if (loc.first_line <= 0) {
                            loc.first_line = this.yylloc.first_line;
                            loc.last_line = this.yylloc.last_line;
                            loc.first_column = this.yylloc.first_column;
                            loc.last_column = this.yylloc.last_column;
                            loc.range[0] = this.yylloc.range[0];
                            loc.range[1] = this.yylloc.range[1];
                        } else {
                            loc.last_line = this.yylloc.last_line;
                            loc.last_column = this.yylloc.last_column;
                            loc.range[1] = this.yylloc.range[1];
                        }
                    }
                    if (loc.first_line <= 0) {
                        loc.first_line = loc.last_line;
                        loc.first_column = 0;
                        loc.range[1] = loc.range[0];
                    }
                    if (loc.first_column < 0) loc.first_column = 0;
                    if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                    return loc;
                },
                prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                    loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                    const CONTEXT = 3;
                    const CONTEXT_TAIL = 1;
                    const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                    var input = this.matched + this._input;
                    var lines = input.split('\n');
                    var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                    var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                    var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                    var ws_prefix = new Array(lineno_display_width).join(' ');
                    var nonempty_line_indexes = [];
                    var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                        var lno = index + l0;
                        var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                        var rv = lno_pfx + ': ' + line;
                        var errpfx = new Array(lineno_display_width + 1).join('^');
                        var offset = 3;
                        var len = 0;
                        if (lno === loc.first_line) {
                            offset += loc.first_column;
                            len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                        } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                        else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                        if (len) {
                            var lead = new Array(offset).join('.');
                            var mark = new Array(len).join('^');
                            rv += '\n' + errpfx + lead + mark;
                            if (line.trim().length > 0) nonempty_line_indexes.push(index);
                        }
                        rv = rv.replace(/\t/g, ' ');
                        return rv;
                    });
                    if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                        var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                        var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                        var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                        intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                        rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                    }
                    return rv.join('\n');
                },
                describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                    var l1 = yylloc.first_line;
                    var l2 = yylloc.last_line;
                    var c1 = yylloc.first_column;
                    var c2 = yylloc.last_column;
                    var dl = l2 - l1;
                    var dc = c2 - c1;
                    var rv;
                    if (dl === 0) {
                        rv = 'line ' + l1 + ', ';
                        if (dc <= 1) rv += 'column ' + c1;
                        else rv += 'columns ' + c1 + ' .. ' + c2;
                    } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                    if (yylloc.range && display_range_too) {
                        var r1 = yylloc.range[0];
                        var r2 = yylloc.range[1] - 1;
                        if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                        else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                    }
                    return rv;
                },
                test_match: function lexer_test_match(match, indexed_rule) {
                    var token, lines, backup, match_str, match_str_len;
                    if (this.options.backtrack_lexer) backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.yylloc.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column,
                            range: this.yylloc.range.slice(0)
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    match_str = match[0];
                    match_str_len = match_str.length;
                    lines = match_str.split(/(?:\r\n?|\n)/g);
                    if (lines.length > 1) {
                        this.yylineno += lines.length - 1;
                        this.yylloc.last_line = this.yylineno + 1;
                        this.yylloc.last_column = lines[lines.length - 1].length;
                    } else this.yylloc.last_column += match_str_len;
                    this.yytext += match_str;
                    this.match += match_str;
                    this.matched += match_str;
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    this.yylloc.range[1] += match_str_len;
                    this.offset += match_str_len;
                    this._more = false;
                    this._backtrack = false;
                    this._input = this._input.slice(match_str_len);
                    token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;
                    else if (this._backtrack) {
                        for(var k in backup)this[k] = backup[k];
                        this.__currentRuleSet__ = null;
                        return false;
                    } else if (this._signaled_error_token) {
                        token = this._signaled_error_token;
                        this._signaled_error_token = false;
                        return token;
                    }
                    return false;
                },
                next: function lexer_next() {
                    if (this.done) {
                        this.clear();
                        return this.EOF;
                    }
                    if (!this._input) this.done = true;
                    var token, match, tempMatch, index;
                    if (!this._more) this.clear();
                    var spec = this.__currentRuleSet__;
                    if (!spec) {
                        spec = this.__currentRuleSet__ = this._currentRules();
                        if (!spec || !spec.rules) {
                            var lineno_msg = '';
                            if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                            var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                            return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                        }
                    }
                    var rule_ids = spec.rules;
                    var regexes = spec.__rule_regexes;
                    var len = spec.__rule_count;
                    for(var i = 1; i <= len; i++){
                        tempMatch = this._input.match(regexes[i]);
                        if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                            match = tempMatch;
                            index = i;
                            if (this.options.backtrack_lexer) {
                                token = this.test_match(tempMatch, rule_ids[i]);
                                if (token !== false) return token;
                                else if (this._backtrack) {
                                    match = undefined;
                                    continue;
                                } else return false;
                            } else if (!this.options.flex) break;
                        }
                    }
                    if (match) {
                        token = this.test_match(match, rule_ids[index]);
                        if (token !== false) return token;
                        return false;
                    }
                    if (!this._input) {
                        this.done = true;
                        this.clear();
                        return this.EOF;
                    } else {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                        var pendingInput = this._input;
                        var activeCondition = this.topState();
                        var conditionStackDepth = this.conditionStack.length;
                        token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                        if (token === this.ERROR) {
                            if (!this.matches && pendingInput === this._input && activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                        }
                        return token;
                    }
                },
                lex: function lexer_lex() {
                    var r;
                    if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                    if (typeof this.options.pre_lex === 'function') r = this.options.pre_lex.call(this, r) || r;
                    if (this.yy && typeof this.yy.pre_lex === 'function') r = this.yy.pre_lex.call(this, r) || r;
                    while(!r)r = this.next();
                    if (this.yy && typeof this.yy.post_lex === 'function') r = this.yy.post_lex.call(this, r) || r;
                    if (typeof this.options.post_lex === 'function') r = this.options.post_lex.call(this, r) || r;
                    if (typeof this.post_lex === 'function') r = this.post_lex.call(this, r) || r;
                    return r;
                },
                fastLex: function lexer_fastLex() {
                    var r;
                    while(!r)r = this.next();
                    return r;
                },
                canIUse: function lexer_canIUse() {
                    var rv = {
                        fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                    };
                    return rv;
                },
                begin: function lexer_begin(condition) {
                    return this.pushState(condition);
                },
                pushState: function lexer_pushState(condition) {
                    this.conditionStack.push(condition);
                    this.__currentRuleSet__ = null;
                    return this;
                },
                popState: function lexer_popState() {
                    var n = this.conditionStack.length - 1;
                    if (n > 0) {
                        this.__currentRuleSet__ = null;
                        return this.conditionStack.pop();
                    } else return this.conditionStack[0];
                },
                topState: function lexer_topState(n) {
                    n = this.conditionStack.length - 1 - Math.abs(n || 0);
                    if (n >= 0) return this.conditionStack[n];
                    else return 'INITIAL';
                },
                _currentRules: function lexer__currentRules() {
                    if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                    else return this.conditions['INITIAL'];
                },
                stateStackSize: function lexer_stateStackSize() {
                    return this.conditionStack.length;
                },
                options: {
                    trackPosition: true
                },
                JisonLexerError: JisonLexerError,
                performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                    var yy_ = this;
                    var YYSTATE = YY_START;
                    switch(yyrulenumber){
                        case 1:
                            break;
                        default:
                            return this.simpleCaseActionClusters[yyrulenumber];
                    }
                },
                simpleCaseActionClusters: {
                    0: 13,
                    2: 5,
                    3: 6,
                    4: 3,
                    5: 4,
                    6: 15,
                    7: 15,
                    8: 15,
                    9: 15,
                    10: 15,
                    11: 15,
                    12: 16,
                    13: 16,
                    14: 16,
                    15: 16,
                    16: 17,
                    17: 17,
                    18: 18,
                    19: 18,
                    20: 19,
                    21: 19,
                    22: 19,
                    23: 20,
                    24: 21,
                    25: 22,
                    26: 23,
                    27: 25,
                    28: 24,
                    29: 26,
                    30: 27,
                    31: 28,
                    32: 11,
                    33: 9,
                    34: 12,
                    35: 10,
                    36: 7,
                    37: 8,
                    38: 14,
                    39: 1
                },
                rules: [
                    /^(?:(--[\d\-A-Za-z]*))/,
                    /^(?:\s+)/,
                    /^(?:\*)/,
                    /^(?:\/)/,
                    /^(?:\+)/,
                    /^(?:-)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                    /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                    /^(?:(calc))/,
                    /^(?:(var))/,
                    /^(?:([a-z]+))/,
                    /^(?:\()/,
                    /^(?:\))/,
                    /^(?:,)/,
                    /^(?:$)/
                ],
                conditions: {
                    'INITIAL': {
                        rules: [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            16,
                            17,
                            18,
                            19,
                            20,
                            21,
                            22,
                            23,
                            24,
                            25,
                            26,
                            27,
                            28,
                            29,
                            30,
                            31,
                            32,
                            33,
                            34,
                            35,
                            36,
                            37,
                            38,
                            39
                        ],
                        inclusive: true
                    }
                }
            };
            return lexer;
        }();
        parser.lexer = lexer;
        function Parser() {
            this.yy = {};
        }
        Parser.prototype = parser;
        parser.Parser = Parser;
        return new Parser();
    }();
    $a165840c76c6afe6$export$8f49e4af10703ce3 = $a165840c76c6afe6$var$parser;
    $a165840c76c6afe6$export$7acfa6ed01010e37 = $a165840c76c6afe6$var$parser.Parser;
    $a165840c76c6afe6$export$98e6a39c04603d36 = function() {
        return $a165840c76c6afe6$var$parser.parse.apply($a165840c76c6afe6$var$parser, arguments);
    };
});
parcelRegister("8nBRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.flip = $619dd81247578d79$var$flip;
    var $bJf2Y = parcelRequire("bJf2Y");
    var $619dd81247578d79$var$_convert2 = $619dd81247578d79$var$_interopRequireDefault($bJf2Y);
    function $619dd81247578d79$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $619dd81247578d79$var$reduce(node, precision) {
        if (node.type === "MathExpression") return $619dd81247578d79$var$reduceMathExpression(node, precision);
        if (node.type === "Calc") return $619dd81247578d79$var$reduce(node.value, precision);
        return node;
    }
    function $619dd81247578d79$var$isEqual(left, right) {
        return left.type === right.type && left.value === right.value;
    }
    function $619dd81247578d79$var$isValueType(type) {
        switch(type){
            case 'LengthValue':
            case 'AngleValue':
            case 'TimeValue':
            case 'FrequencyValue':
            case 'ResolutionValue':
            case 'EmValue':
            case 'ExValue':
            case 'ChValue':
            case 'RemValue':
            case 'VhValue':
            case 'VwValue':
            case 'VminValue':
            case 'VmaxValue':
            case 'PercentageValue':
            case 'Value':
                return true;
        }
        return false;
    }
    function $619dd81247578d79$var$convertMathExpression(node, precision) {
        var nodes = (0, $619dd81247578d79$var$_convert2.default)(node.left, node.right, precision);
        var left = $619dd81247578d79$var$reduce(nodes.left, precision);
        var right = $619dd81247578d79$var$reduce(nodes.right, precision);
        if (left.type === "MathExpression" && right.type === "MathExpression") {
            if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
                if ($619dd81247578d79$var$isEqual(left.right, right.right)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.left, precision);
                else if ($619dd81247578d79$var$isEqual(left.right, right.left)) nodes = (0, $619dd81247578d79$var$_convert2.default)(left.left, right.right, precision);
                left = $619dd81247578d79$var$reduce(nodes.left, precision);
                right = $619dd81247578d79$var$reduce(nodes.right, precision);
            }
        }
        node.left = left;
        node.right = right;
        return node;
    }
    function $619dd81247578d79$var$flip(operator) {
        return operator === '+' ? '-' : '+';
    }
    function $619dd81247578d79$var$flipValue(node) {
        if ($619dd81247578d79$var$isValueType(node.type)) node.value = -node.value;
        else if (node.type == 'MathExpression') {
            node.left = $619dd81247578d79$var$flipValue(node.left);
            node.right = $619dd81247578d79$var$flipValue(node.right);
        }
        return node;
    }
    function $619dd81247578d79$var$reduceAddSubExpression(node, precision) {
        var _node = node, left = _node.left, right = _node.right, op = _node.operator;
        if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
        if (right.value === 0) return left;
        if (left.value === 0 && op === "+") return right;
        if (left.value === 0 && op === "-") return $619dd81247578d79$var$flipValue(right);
        if (left.type === right.type && $619dd81247578d79$var$isValueType(left.type)) {
            node = Object.assign({}, left);
            if (op === "+") node.value = left.value + right.value;
            else node.value = left.value - right.value;
        }
        if ($619dd81247578d79$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
            if (left.type === right.left.type) {
                node = Object.assign({}, node);
                node.left = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op,
                    left: left,
                    right: right.left
                }, precision);
                node.right = right.right;
                node.operator = op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator;
                return $619dd81247578d79$var$reduce(node, precision);
            } else if (left.type === right.right.type) {
                node = Object.assign({}, node);
                node.left = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? $619dd81247578d79$var$flip(right.operator) : right.operator,
                    left: left,
                    right: right.right
                }, precision);
                node.right = right.left;
                return $619dd81247578d79$var$reduce(node, precision);
            }
        }
        if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $619dd81247578d79$var$isValueType(right.type)) {
            if (right.type === left.left.type) {
                node = Object.assign({}, left);
                node.left = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op,
                    left: left.left,
                    right: right
                }, precision);
                return $619dd81247578d79$var$reduce(node, precision);
            } else if (right.type === left.right.type) {
                node = Object.assign({}, left);
                if (left.operator === '-') {
                    node.right = $619dd81247578d79$var$reduce({
                        type: 'MathExpression',
                        operator: op === '-' ? '+' : '-',
                        left: right,
                        right: left.right
                    }, precision);
                    node.operator = op === '-' ? '-' : '+';
                } else node.right = $619dd81247578d79$var$reduce({
                    type: 'MathExpression',
                    operator: op,
                    left: left.right,
                    right: right
                }, precision);
                if (node.right.value < 0) {
                    node.right.value *= -1;
                    node.operator = node.operator === '-' ? '+' : '-';
                }
                return $619dd81247578d79$var$reduce(node, precision);
            }
        }
        return node;
    }
    function $619dd81247578d79$var$reduceDivisionExpression(node, precision) {
        if (!$619dd81247578d79$var$isValueType(node.right.type)) return node;
        if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
        if (node.right.value === 0) throw new Error('Cannot divide by zero');
        if (node.left.type === 'MathExpression') {
            if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
                node.left.left.value /= node.right.value;
                node.left.right.value /= node.right.value;
                return $619dd81247578d79$var$reduce(node.left, precision);
            }
            return node;
        } else if ($619dd81247578d79$var$isValueType(node.left.type)) {
            node.left.value /= node.right.value;
            return node.left;
        }
        return node;
    }
    function $619dd81247578d79$var$reduceMultiplicationExpression(node) {
        if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
            if ($619dd81247578d79$var$isValueType(node.left.left.type) && $619dd81247578d79$var$isValueType(node.left.right.type)) {
                node.left.left.value *= node.right.value;
                node.left.right.value *= node.right.value;
                return node.left;
            }
        } else if ($619dd81247578d79$var$isValueType(node.left.type) && node.right.type === 'Value') {
            node.left.value *= node.right.value;
            return node.left;
        } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
            if ($619dd81247578d79$var$isValueType(node.right.left.type) && $619dd81247578d79$var$isValueType(node.right.right.type)) {
                node.right.left.value *= node.left.value;
                node.right.right.value *= node.left.value;
                return node.right;
            }
        } else if (node.left.type === 'Value' && $619dd81247578d79$var$isValueType(node.right.type)) {
            node.right.value *= node.left.value;
            return node.right;
        }
        return node;
    }
    function $619dd81247578d79$var$reduceMathExpression(node, precision) {
        node = $619dd81247578d79$var$convertMathExpression(node, precision);
        switch(node.operator){
            case "+":
            case "-":
                return $619dd81247578d79$var$reduceAddSubExpression(node, precision);
            case "/":
                return $619dd81247578d79$var$reduceDivisionExpression(node, precision);
            case "*":
                return $619dd81247578d79$var$reduceMultiplicationExpression(node);
        }
        return node;
    }
    module.exports.default = $619dd81247578d79$var$reduce;
});
parcelRegister("bJf2Y", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $e3WAX = parcelRequire("e3WAX");
    var $889f91b7777ca440$var$_cssUnitConverter2 = $889f91b7777ca440$var$_interopRequireDefault($e3WAX);
    function $889f91b7777ca440$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $889f91b7777ca440$var$convertNodes(left, right, precision) {
        switch(left.type){
            case 'LengthValue':
            case 'AngleValue':
            case 'TimeValue':
            case 'FrequencyValue':
            case 'ResolutionValue':
                return $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision);
            default:
                return {
                    left: left,
                    right: right
                };
        }
    }
    function $889f91b7777ca440$var$convertAbsoluteLength(left, right, precision) {
        if (right.type === left.type) right = {
            type: left.type,
            value: (0, $889f91b7777ca440$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
            unit: left.unit
        };
        return {
            left: left,
            right: right
        };
    }
    module.exports.default = $889f91b7777ca440$var$convertNodes;
    module.exports = module.exports['default'];
});
parcelRegister("e3WAX", function(module, exports) {
    var $a3cecc42eafd4fde$var$conversions = {
        'px': {
            'px': 1,
            'cm': 96.0 / 2.54,
            'mm': 96.0 / 25.4,
            'in': 96,
            'pt': 96.0 / 72.0,
            'pc': 16
        },
        'cm': {
            'px': 2.54 / 96.0,
            'cm': 1,
            'mm': 0.1,
            'in': 2.54,
            'pt': 2.54 / 72.0,
            'pc': 2.54 / 6.0
        },
        'mm': {
            'px': 25.4 / 96.0,
            'cm': 10,
            'mm': 1,
            'in': 25.4,
            'pt': 25.4 / 72.0,
            'pc': 25.4 / 6.0
        },
        'in': {
            'px': 1.0 / 96.0,
            'cm': 1.0 / 2.54,
            'mm': 1.0 / 25.4,
            'in': 1,
            'pt': 1.0 / 72.0,
            'pc': 1.0 / 6.0
        },
        'pt': {
            'px': 0.75,
            'cm': 72.0 / 2.54,
            'mm': 72.0 / 25.4,
            'in': 72,
            'pt': 1,
            'pc': 12
        },
        'pc': {
            'px': 0.0625,
            'cm': 6.0 / 2.54,
            'mm': 6.0 / 25.4,
            'in': 6,
            'pt': 6.0 / 72.0,
            'pc': 1
        },
        'deg': {
            'deg': 1,
            'grad': 0.9,
            'rad': 180 / Math.PI,
            'turn': 360
        },
        'grad': {
            'deg': 400 / 360,
            'grad': 1,
            'rad': 200 / Math.PI,
            'turn': 400
        },
        'rad': {
            'deg': Math.PI / 180,
            'grad': Math.PI / 200,
            'rad': 1,
            'turn': Math.PI * 2
        },
        'turn': {
            'deg': 1 / 360,
            'grad': 1 / 400,
            'rad': 0.5 / Math.PI,
            'turn': 1
        },
        's': {
            's': 1,
            'ms': 0.001
        },
        'ms': {
            's': 1000,
            'ms': 1
        },
        'Hz': {
            'Hz': 1,
            'kHz': 1000
        },
        'kHz': {
            'Hz': 0.001,
            'kHz': 1
        },
        'dpi': {
            'dpi': 1,
            'dpcm': 1.0 / 2.54,
            'dppx': 1 / 96
        },
        'dpcm': {
            'dpi': 2.54,
            'dpcm': 1,
            'dppx': 2.54 / 96.0
        },
        'dppx': {
            'dpi': 96,
            'dpcm': 96.0 / 2.54,
            'dppx': 1
        }
    };
    module.exports = function(value, sourceUnit, targetUnit, precision) {
        if (!$a3cecc42eafd4fde$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
        if (!$a3cecc42eafd4fde$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round($a3cecc42eafd4fde$var$conversions[targetUnit][sourceUnit] * value * precision) / precision;
    };
});
parcelRegister("hYnJW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = function(calc, node, precision) {
        var str = $d15a748316f7199c$var$stringify(node, precision);
        if (node.type === "MathExpression") str = calc + "(" + str + ")";
        return str;
    };
    var $8nBRK = parcelRequire("8nBRK");
    var $d15a748316f7199c$var$order = {
        "*": 0,
        "/": 0,
        "+": 1,
        "-": 1
    };
    function $d15a748316f7199c$var$round(value, prec) {
        if (prec !== false) {
            var precision = Math.pow(10, prec);
            return Math.round(value * precision) / precision;
        }
        return value;
    }
    function $d15a748316f7199c$var$stringify(node, prec) {
        switch(node.type){
            case "MathExpression":
                var left = node.left, right = node.right, op = node.operator;
                var str = "";
                if (left.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[left.operator]) str += "(" + $d15a748316f7199c$var$stringify(left, prec) + ")";
                else str += $d15a748316f7199c$var$stringify(left, prec);
                str += " " + node.operator + " ";
                if (right.type === 'MathExpression' && $d15a748316f7199c$var$order[op] < $d15a748316f7199c$var$order[right.operator]) str += "(" + $d15a748316f7199c$var$stringify(right, prec) + ")";
                else if (right.type === 'MathExpression' && op === "-" && [
                    "+",
                    "-"
                ].includes(right.operator)) {
                    right.operator = (0, $8nBRK.flip)(right.operator);
                    str += $d15a748316f7199c$var$stringify(right, prec);
                } else str += $d15a748316f7199c$var$stringify(right, prec);
                return str;
            case "Value":
                return $d15a748316f7199c$var$round(node.value, prec);
            case 'CssVariable':
                if (node.fallback) return "var(" + node.value + ", " + $d15a748316f7199c$var$stringify(node.fallback, prec, true) + ")";
                return "var(" + node.value + ")";
            case 'Calc':
                if (node.prefix) return "-" + node.prefix + "-calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
                return "calc(" + $d15a748316f7199c$var$stringify(node.value, prec) + ")";
            default:
                return $d15a748316f7199c$var$round(node.value, prec) + node.unit;
        }
    }
    module.exports = module.exports["default"];
});
parcelRegister("hRG4n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d018050ac926ff2a$export$2e2bcd8739ae039);
    const $d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
    function $d018050ac926ff2a$export$2e2bcd8739ae039(str, style) {
        try {
            let textEl = document.getElementById($d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID);
            if (!textEl) {
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('aria-hidden', 'true');
                svg.style.width = '0';
                svg.style.height = '0';
                svg.style.position = 'absolute';
                svg.style.top = '-100%';
                svg.style.left = '-100%';
                textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                textEl.setAttribute('id', $d018050ac926ff2a$var$MEASUREMENT_ELEMENT_ID);
                svg.appendChild(textEl);
                document.body.appendChild(svg);
            }
            Object.assign(textEl.style, style);
            textEl.textContent = str;
            return textEl.getComputedTextLength();
        } catch (e) {
            return null;
        }
    }
});
parcelRegister("dFdp9", function(module, exports) {
    $parcel$export(module.exports, "DonutMarkLabels", ()=>$9f298093bfc25e3c$export$1d7ea9ddbe30b32);
    var $hjll3 = parcelRequire("hjll3");
    var $1xLej;
    var $k2cKq;
    var $2OMIu = parcelRequire("2OMIu");
    const $9f298093bfc25e3c$export$1d7ea9ddbe30b32 = (0, (0, parcelRequire("1xLej")).element)(function DonutMarkLabels(_ref) {
        let { arcs: arcs, hide: hide } = _ref;
        if (hide) return null;
        const arcPath = (0, $hjll3.arc)();
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: arcs.map((arc)=>{
                const arcCentroid = arcPath.centroid({
                    innerRadius: arc.innerRadius,
                    outerRadius: arc.outerRadius,
                    startAngle: arc.startAngle,
                    endAngle: arc.endAngle
                });
                return (0, $2OMIu.jsx)((0, (0, parcelRequire("k2cKq")).ValueLabel), {
                    x: arcCentroid[0],
                    y: arcCentroid[1],
                    color: arc.fill,
                    children: arc.value
                }, `stack-label-${arc.key}`);
            })
        });
    });
});
parcelRegister("k2cKq", function(module, exports) {
    $parcel$export(module.exports, "ValueLabel", ()=>$e95de202321265c6$export$d0e17caf98739ceb);
    var $bwpsq;
    var $1xLej;
    var $5rJQH;
    var $lCjFE;
    var $lASMz;
    var $2OMIu = parcelRequire("2OMIu");
    const $e95de202321265c6$var$labelTextStyles = null;
    function $e95de202321265c6$var$ValueLabel(_ref) {
        let { x: x, y: y, color: color, formatter: formatter = (0, (0, parcelRequire("lCjFE")).default).formatNumberAbbreviated, children: children } = _ref;
        if (!children) return null;
        if (typeof children === 'number' || typeof children === 'string') return (0, $2OMIu.jsx)((0, (0, parcelRequire("5rJQH")).default), {
            x: x,
            y: y,
            style: {
                fill: (0, (0, parcelRequire("lASMz")).getMaxContrast)(color)
            },
            verticalAnchor: "middle",
            alignmentBaseline: "central",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1fjgnkob _ect41wi2 _1wyb1crf"
            ]),
            children: formatter(children)
        });
        return children;
    }
    const $e95de202321265c6$export$d0e17caf98739ceb = (0, (0, parcelRequire("1xLej")).element)($e95de202321265c6$var$ValueLabel);
});
parcelRegister("lASMz", function(module, exports) {
    $parcel$export(module.exports, "getMaxContrast", ()=>$fb87746cb2f21746$export$499db937e3cd4eb2);
    var $kTHGn;
    var $7UL8A;
    function $fb87746cb2f21746$var$getLuminance(_ref) {
        let { r: r, g: g, b: b } = _ref;
        const a = [
            r,
            g,
            b
        ].map((v)=>{
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }
    function $fb87746cb2f21746$var$getContrast(color1, color2) {
        const lum1 = $fb87746cb2f21746$var$getLuminance(color1) + 0.05;
        const lum2 = $fb87746cb2f21746$var$getLuminance(color2) + 0.05;
        return Math.max(lum1, lum2) / Math.min(lum1, lum2);
    }
    function $fb87746cb2f21746$var$getTokenAndFallback(cssVar) {
        const numberMatch = cssVar.match(/\d+/);
        const number = numberMatch ? numberMatch[0] : '';
        const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
        const terms = termsMatch ? termsMatch[1].split('-') : [];
        const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
        const hexColor = hexColorMatch ? hexColorMatch[0] : '';
        const token = `color.${terms.join('.') + '.' + number}`;
        return {
            token: token,
            fallback: hexColor
        };
    }
    function $fb87746cb2f21746$export$499db937e3cd4eb2(arcColor) {
        const isPattern = arcColor.includes('url');
        const { token: token, fallback: fallback } = $fb87746cb2f21746$var$getTokenAndFallback(arcColor);
        const colorHex = (0, (0, parcelRequire("kTHGn")).default)(token, fallback);
        const color = (0, (0, parcelRequire("7UL8A")).rgb)(arcColor.startsWith('var(') ? colorHex : arcColor);
        if (isPattern) return 'black';
        if (!color) return '';
        const blackContrast = $fb87746cb2f21746$var$getContrast(color, (0, (0, parcelRequire("7UL8A")).rgb)('black'));
        const whiteContrast = $fb87746cb2f21746$var$getContrast(color, (0, (0, parcelRequire("7UL8A")).rgb)('white'));
        if (whiteContrast >= 4.5) return 'white';
        if (blackContrast >= 4.5) return 'black';
        return 'white';
    }
});
parcelRegister("7UL8A", function(module, exports) {
    $parcel$export(module.exports, "Color", ()=>Color);
    $parcel$export(module.exports, "darker", ()=>darker);
    $parcel$export(module.exports, "brighter", ()=>brighter);
    $parcel$export(module.exports, "default", ()=>color);
    $parcel$export(module.exports, "hslConvert", ()=>hslConvert);
    $parcel$export(module.exports, "Rgb", ()=>Rgb);
    $parcel$export(module.exports, "rgbConvert", ()=>rgbConvert);
    $parcel$export(module.exports, "rgb", ()=>rgb);
    $parcel$export(module.exports, "hsl", ()=>hsl);
    var $eeO9w;
    function Color() {}
    var darker = 0.7;
    var brighter = 1 / darker;
    var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
    var named = {
        aliceblue: 0xf0f8ff,
        antiquewhite: 0xfaebd7,
        aqua: 0x00ffff,
        aquamarine: 0x7fffd4,
        azure: 0xf0ffff,
        beige: 0xf5f5dc,
        bisque: 0xffe4c4,
        black: 0x000000,
        blanchedalmond: 0xffebcd,
        blue: 0x0000ff,
        blueviolet: 0x8a2be2,
        brown: 0xa52a2a,
        burlywood: 0xdeb887,
        cadetblue: 0x5f9ea0,
        chartreuse: 0x7fff00,
        chocolate: 0xd2691e,
        coral: 0xff7f50,
        cornflowerblue: 0x6495ed,
        cornsilk: 0xfff8dc,
        crimson: 0xdc143c,
        cyan: 0x00ffff,
        darkblue: 0x00008b,
        darkcyan: 0x008b8b,
        darkgoldenrod: 0xb8860b,
        darkgray: 0xa9a9a9,
        darkgreen: 0x006400,
        darkgrey: 0xa9a9a9,
        darkkhaki: 0xbdb76b,
        darkmagenta: 0x8b008b,
        darkolivegreen: 0x556b2f,
        darkorange: 0xff8c00,
        darkorchid: 0x9932cc,
        darkred: 0x8b0000,
        darksalmon: 0xe9967a,
        darkseagreen: 0x8fbc8f,
        darkslateblue: 0x483d8b,
        darkslategray: 0x2f4f4f,
        darkslategrey: 0x2f4f4f,
        darkturquoise: 0x00ced1,
        darkviolet: 0x9400d3,
        deeppink: 0xff1493,
        deepskyblue: 0x00bfff,
        dimgray: 0x696969,
        dimgrey: 0x696969,
        dodgerblue: 0x1e90ff,
        firebrick: 0xb22222,
        floralwhite: 0xfffaf0,
        forestgreen: 0x228b22,
        fuchsia: 0xff00ff,
        gainsboro: 0xdcdcdc,
        ghostwhite: 0xf8f8ff,
        gold: 0xffd700,
        goldenrod: 0xdaa520,
        gray: 0x808080,
        green: 0x008000,
        greenyellow: 0xadff2f,
        grey: 0x808080,
        honeydew: 0xf0fff0,
        hotpink: 0xff69b4,
        indianred: 0xcd5c5c,
        indigo: 0x4b0082,
        ivory: 0xfffff0,
        khaki: 0xf0e68c,
        lavender: 0xe6e6fa,
        lavenderblush: 0xfff0f5,
        lawngreen: 0x7cfc00,
        lemonchiffon: 0xfffacd,
        lightblue: 0xadd8e6,
        lightcoral: 0xf08080,
        lightcyan: 0xe0ffff,
        lightgoldenrodyellow: 0xfafad2,
        lightgray: 0xd3d3d3,
        lightgreen: 0x90ee90,
        lightgrey: 0xd3d3d3,
        lightpink: 0xffb6c1,
        lightsalmon: 0xffa07a,
        lightseagreen: 0x20b2aa,
        lightskyblue: 0x87cefa,
        lightslategray: 0x778899,
        lightslategrey: 0x778899,
        lightsteelblue: 0xb0c4de,
        lightyellow: 0xffffe0,
        lime: 0x00ff00,
        limegreen: 0x32cd32,
        linen: 0xfaf0e6,
        magenta: 0xff00ff,
        maroon: 0x800000,
        mediumaquamarine: 0x66cdaa,
        mediumblue: 0x0000cd,
        mediumorchid: 0xba55d3,
        mediumpurple: 0x9370db,
        mediumseagreen: 0x3cb371,
        mediumslateblue: 0x7b68ee,
        mediumspringgreen: 0x00fa9a,
        mediumturquoise: 0x48d1cc,
        mediumvioletred: 0xc71585,
        midnightblue: 0x191970,
        mintcream: 0xf5fffa,
        mistyrose: 0xffe4e1,
        moccasin: 0xffe4b5,
        navajowhite: 0xffdead,
        navy: 0x000080,
        oldlace: 0xfdf5e6,
        olive: 0x808000,
        olivedrab: 0x6b8e23,
        orange: 0xffa500,
        orangered: 0xff4500,
        orchid: 0xda70d6,
        palegoldenrod: 0xeee8aa,
        palegreen: 0x98fb98,
        paleturquoise: 0xafeeee,
        palevioletred: 0xdb7093,
        papayawhip: 0xffefd5,
        peachpuff: 0xffdab9,
        peru: 0xcd853f,
        pink: 0xffc0cb,
        plum: 0xdda0dd,
        powderblue: 0xb0e0e6,
        purple: 0x800080,
        rebeccapurple: 0x663399,
        red: 0xff0000,
        rosybrown: 0xbc8f8f,
        royalblue: 0x4169e1,
        saddlebrown: 0x8b4513,
        salmon: 0xfa8072,
        sandybrown: 0xf4a460,
        seagreen: 0x2e8b57,
        seashell: 0xfff5ee,
        sienna: 0xa0522d,
        silver: 0xc0c0c0,
        skyblue: 0x87ceeb,
        slateblue: 0x6a5acd,
        slategray: 0x708090,
        slategrey: 0x708090,
        snow: 0xfffafa,
        springgreen: 0x00ff7f,
        steelblue: 0x4682b4,
        tan: 0xd2b48c,
        teal: 0x008080,
        thistle: 0xd8bfd8,
        tomato: 0xff6347,
        turquoise: 0x40e0d0,
        violet: 0xee82ee,
        wheat: 0xf5deb3,
        white: 0xffffff,
        whitesmoke: 0xf5f5f5,
        yellow: 0xffff00,
        yellowgreen: 0x9acd32
    };
    (0, (0, parcelRequire("eeO9w")).default)(Color, color, {
        copy (channels) {
            return Object.assign(new this.constructor, this, channels);
        },
        displayable () {
            return this.rgb().displayable();
        },
        hex: color_formatHex,
        formatHex: color_formatHex,
        formatHex8: color_formatHex8,
        formatHsl: color_formatHsl,
        formatRgb: color_formatRgb,
        toString: color_formatRgb
    });
    function color_formatHex() {
        return this.rgb().formatHex();
    }
    function color_formatHex8() {
        return this.rgb().formatHex8();
    }
    function color_formatHsl() {
        return hslConvert(this).formatHsl();
    }
    function color_formatRgb() {
        return this.rgb().formatRgb();
    }
    function color(format) {
        var m, l;
        format = (format + "").trim().toLowerCase();
        return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) : null) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
    }
    function rgbn(n) {
        return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
    }
    function rgba(r, g, b, a) {
        if (a <= 0) r = g = b = NaN;
        return new Rgb(r, g, b, a);
    }
    function rgbConvert(o) {
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Rgb;
        o = o.rgb();
        return new Rgb(o.r, o.g, o.b, o.opacity);
    }
    function rgb(r, g, b, opacity) {
        return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
    }
    function Rgb(r, g, b, opacity) {
        this.r = +r;
        this.g = +g;
        this.b = +b;
        this.opacity = +opacity;
    }
    (0, (0, parcelRequire("eeO9w")).default)(Rgb, rgb, (0, (0, parcelRequire("eeO9w")).extend)(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        rgb () {
            return this;
        },
        clamp () {
            return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
        },
        displayable () {
            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
        },
        hex: rgb_formatHex,
        formatHex: rgb_formatHex,
        formatHex8: rgb_formatHex8,
        formatRgb: rgb_formatRgb,
        toString: rgb_formatRgb
    }));
    function rgb_formatHex() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
    }
    function rgb_formatHex8() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
    }
    function rgb_formatRgb() {
        const a = clampa(this.opacity);
        return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
    }
    function clampa(opacity) {
        return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
    }
    function clampi(value) {
        return Math.max(0, Math.min(255, Math.round(value) || 0));
    }
    function hex(value) {
        value = clampi(value);
        return (value < 16 ? "0" : "") + value.toString(16);
    }
    function hsla(h, s, l, a) {
        if (a <= 0) h = s = l = NaN;
        else if (l <= 0 || l >= 1) h = s = NaN;
        else if (s <= 0) h = NaN;
        return new Hsl(h, s, l, a);
    }
    function hslConvert(o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Hsl;
        if (o instanceof Hsl) return o;
        o = o.rgb();
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
        if (s) {
            if (r === max) h = (g - b) / s + (g < b) * 6;
            else if (g === max) h = (b - r) / s + 2;
            else h = (r - g) / s + 4;
            s /= l < 0.5 ? max + min : 2 - max - min;
            h *= 60;
        } else s = l > 0 && l < 1 ? 0 : h;
        return new Hsl(h, s, l, o.opacity);
    }
    function hsl(h, s, l, opacity) {
        return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
    }
    function Hsl(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    (0, (0, parcelRequire("eeO9w")).default)(Hsl, hsl, (0, (0, parcelRequire("eeO9w")).extend)(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
            return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
        },
        clamp () {
            return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
        },
        displayable () {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
        },
        formatHsl () {
            const a = clampa(this.opacity);
            return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
        }
    }));
    function clamph(value) {
        value = (value || 0) % 360;
        return value < 0 ? value + 360 : value;
    }
    function clampt(value) {
        return Math.max(0, Math.min(1, value || 0));
    }
    function hsl2rgb(h, m1, m2) {
        return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
    }
});
parcelRegister("eeO9w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5d946be86aedd6a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "extend", ()=>$a5d946be86aedd6a$export$8b58be045bf06082);
    function $a5d946be86aedd6a$export$2e2bcd8739ae039(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    }
    function $a5d946be86aedd6a$export$8b58be045bf06082(parent, definition) {
        var prototype = Object.create(parent.prototype);
        for(var key in definition)prototype[key] = definition[key];
        return prototype;
    }
});
parcelRegister("dwEoN", function(module, exports) {
    $parcel$export(module.exports, "DonutMarks", ()=>$9d8d99e31a956a19$export$a717cf1f0d95f89e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1xLej;
    var $dZ3lg;
    var $dYSV3;
    var $2OMIu = parcelRequire("2OMIu");
    const $9d8d99e31a956a19$export$a717cf1f0d95f89e = (0, (0, parcelRequire("1xLej")).element)(function DonutMarks(_ref) {
        let { arcs: arcs, labelAccessor: labelAccessor } = _ref;
        const { tooltipData: tooltipData } = (0, $5uXOq.useContext)((0, (0, parcelRequire("dYSV3")).default));
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: arcs.map((arc, i)=>{
                var _tooltipData$nearestD;
                return (0, $2OMIu.jsx)((0, (0, parcelRequire("dZ3lg")).Arc), {
                    ariaLabel: arc.ariaLabel,
                    datum: arc.data,
                    innerRadius: arc.innerRadius,
                    outerRadius: labelAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) === labelAccessor(arc.data) ? arc.outerRadius + arc.outerRadius * 0.05 : arc.outerRadius,
                    startAngle: arc.startAngle,
                    endAngle: arc.endAngle,
                    padAngle: arc.padAngle,
                    fill: arc.fill
                }, `Stack-${arc.key}-${i}`);
            })
        });
    });
});
parcelRegister("8Yq1M", function(module, exports) {
    $parcel$export(module.exports, "DonutScalesElement", ()=>$68881de45079d03f$export$2fe94717b0d39350);
    var $5uXOq = parcelRequire("5uXOq");
    var $gXw8D;
    var $1xLej;
    var $9ZuYc;
    var $juXo4;
    const $68881de45079d03f$export$2fe94717b0d39350 = (0, (0, parcelRequire("1xLej")).element)((_ref)=>{
        let { data: data, colorAccessor: colorAccessor, valueAccessor: valueAccessor, sort: sort = 'asc', children: children } = _ref;
        const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("gXw8D")).default).elements.Theme);
        const value = (0, $5uXOq.useMemo)(()=>{
            const sortedData = data.sort((a, b)=>{
                if (valueAccessor(a) > valueAccessor(b)) return sort === 'asc' ? 1 : -1;
                if (valueAccessor(a) < valueAccessor(b)) return sort === 'asc' ? -1 : 1;
                return 0;
            });
            const { domain: domain, range: range } = useThemeFillStyles({
                fillStyles: fillStyles,
                enableDefaultPatterns: enableDefaultPatterns
            });
            const colorScale = (0, (0, parcelRequire("juXo4")).default)({
                domain: domain ? domain : data.map(colorAccessor),
                range: range
            });
            return {
                colorScale: colorScale,
                data: sortedData
            };
        }, [
            data,
            colorAccessor,
            valueAccessor,
            fillStyles,
            enableDefaultPatterns
        ]);
        return children(value);
    });
});
parcelRegister("juXo4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31ee2bae0007f48$export$2e2bcd8739ae039);
    var $8idDz;
    var $caWsP;
    var $e31ee2bae0007f48$export$6c7fd0f60d1828d8 = (0, (0, parcelRequire("caWsP")).default)('domain', 'range', 'reverse', 'unknown');
    function $e31ee2bae0007f48$export$2e2bcd8739ae039(config) {
        return $e31ee2bae0007f48$export$6c7fd0f60d1828d8((0, (0, parcelRequire("8idDz")).default)(), config);
    }
});
parcelRegister("8idDz", function(module, exports) {
    $parcel$export(module.exports, "implicit", ()=>$609a953a3e88158e$export$e4f898ab14d9d460);
    $parcel$export(module.exports, "default", ()=>$609a953a3e88158e$export$2e2bcd8739ae039);
    var $ifNm6;
    var $l4Hc4;
    const $609a953a3e88158e$export$e4f898ab14d9d460 = Symbol("implicit");
    function $609a953a3e88158e$export$2e2bcd8739ae039() {
        var index = new (0, (0, parcelRequire("ifNm6")).InternMap)(), domain = [], range = [], unknown = $609a953a3e88158e$export$e4f898ab14d9d460;
        function scale(d) {
            let i = index.get(d);
            if (i === undefined) {
                if (unknown !== $609a953a3e88158e$export$e4f898ab14d9d460) return unknown;
                index.set(d, i = domain.push(d) - 1);
            }
            return range[i % range.length];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [], index = new (0, (0, parcelRequire("ifNm6")).InternMap)();
            for (const value of _){
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
            return scale;
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), scale) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return $609a953a3e88158e$export$2e2bcd8739ae039(domain, range).unknown(unknown);
        };
        (0, (0, parcelRequire("l4Hc4")).initRange).apply(scale, arguments);
        return scale;
    }
});
parcelRegister("ifNm6", function(module, exports) {
    $parcel$export(module.exports, "InternMap", ()=>$d49fe9b4e774f532$export$dcc6fb7d82b5bc7b);
    $parcel$export(module.exports, "InternSet", ()=>$d49fe9b4e774f532$export$55278c3294239828);
    class $d49fe9b4e774f532$export$dcc6fb7d82b5bc7b extends Map {
        constructor(entries, key = $d49fe9b4e774f532$var$keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (entries != null) for (const [key, value] of entries)this.set(key, value);
        }
        get(key) {
            return super.get($d49fe9b4e774f532$var$intern_get(this, key));
        }
        has(key) {
            return super.has($d49fe9b4e774f532$var$intern_get(this, key));
        }
        set(key, value) {
            return super.set($d49fe9b4e774f532$var$intern_set(this, key), value);
        }
        delete(key) {
            return super.delete($d49fe9b4e774f532$var$intern_delete(this, key));
        }
    }
    class $d49fe9b4e774f532$export$55278c3294239828 extends Set {
        constructor(values, key = $d49fe9b4e774f532$var$keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (values != null) for (const value of values)this.add(value);
        }
        has(value) {
            return super.has($d49fe9b4e774f532$var$intern_get(this, value));
        }
        add(value) {
            return super.add($d49fe9b4e774f532$var$intern_set(this, value));
        }
        delete(value) {
            return super.delete($d49fe9b4e774f532$var$intern_delete(this, value));
        }
    }
    function $d49fe9b4e774f532$var$intern_get({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        return _intern.has(key) ? _intern.get(key) : value;
    }
    function $d49fe9b4e774f532$var$intern_set({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) return _intern.get(key);
        _intern.set(key, value);
        return value;
    }
    function $d49fe9b4e774f532$var$intern_delete({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) {
            value = _intern.get(key);
            _intern.delete(key);
        }
        return value;
    }
    function $d49fe9b4e774f532$var$keyof(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
});
parcelRegister("l4Hc4", function(module, exports) {
    $parcel$export(module.exports, "initRange", ()=>$f57b7a0f29a58702$export$23c7bb9e6558da2a);
    $parcel$export(module.exports, "initInterpolator", ()=>$f57b7a0f29a58702$export$7d6b419e59e83f3d);
    function $f57b7a0f29a58702$export$23c7bb9e6558da2a(domain, range) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                this.range(domain);
                break;
            default:
                this.range(range).domain(domain);
                break;
        }
        return this;
    }
    function $f57b7a0f29a58702$export$7d6b419e59e83f3d(domain, interpolator) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                if (typeof domain === "function") this.interpolator(domain);
                else this.range(domain);
                break;
            default:
                this.domain(domain);
                if (typeof interpolator === "function") this.interpolator(interpolator);
                else this.range(interpolator);
                break;
        }
        return this;
    }
});
parcelRegister("caWsP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dd3c4ebebad7819$export$2e2bcd8739ae039);
    var $7NDDt;
    var $aag8f;
    var $8m6Xe;
    var $c8Zjd;
    var $1MYRX;
    var $adff9;
    var $1MyI8;
    var $ic1Fv;
    var $7goQn;
    var $c1r8l;
    var $dWXcN;
    var $4sSWK;
    var $iuIpV;
    var $jUCfg;
    var $8dd3c4ebebad7819$export$5f274da11658f617 = [
        'domain',
        'nice',
        'zero',
        'interpolate',
        'round',
        'range',
        'reverse',
        'align',
        'base',
        'clamp',
        'constant',
        'exponent',
        'padding',
        'unknown'
    ];
    var $8dd3c4ebebad7819$var$operators = {
        domain: (0, (0, parcelRequire("7NDDt")).default),
        nice: (0, (0, parcelRequire("7goQn")).default),
        zero: (0, (0, parcelRequire("jUCfg")).default),
        interpolate: (0, (0, parcelRequire("ic1Fv")).default),
        round: (0, (0, parcelRequire("4sSWK")).default),
        align: (0, (0, parcelRequire("8m6Xe")).default),
        base: (0, (0, parcelRequire("c8Zjd")).default),
        clamp: (0, (0, parcelRequire("1MYRX")).default),
        constant: (0, (0, parcelRequire("adff9")).default),
        exponent: (0, (0, parcelRequire("1MyI8")).default),
        padding: (0, (0, parcelRequire("c1r8l")).default),
        range: (0, (0, parcelRequire("aag8f")).default),
        reverse: (0, (0, parcelRequire("dWXcN")).default),
        unknown: (0, (0, parcelRequire("iuIpV")).default)
    };
    function $8dd3c4ebebad7819$export$2e2bcd8739ae039() {
        for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
        var selection = new Set(ops);
        var selectedOps = $8dd3c4ebebad7819$export$5f274da11658f617.filter(function(o) {
            return selection.has(o);
        });
        return function applyOperators(scale, config) {
            if (typeof config !== 'undefined') selectedOps.forEach(function(op) {
                $8dd3c4ebebad7819$var$operators[op](scale, config);
            });
            return scale;
        };
    }
});
parcelRegister("7NDDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5adbdad8d7dbd927$export$2e2bcd8739ae039);
    function $5adbdad8d7dbd927$export$2e2bcd8739ae039(scale, config) {
        if (config.domain) {
            if ('nice' in scale || 'quantiles' in scale) scale.domain(config.domain);
            else if ('padding' in scale) scale.domain(config.domain);
            else scale.domain(config.domain);
        }
    }
});
parcelRegister("aag8f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76675a108d27a9d2$export$2e2bcd8739ae039);
    function $76675a108d27a9d2$export$2e2bcd8739ae039(scale, config) {
        if (config.range) {
            if ('padding' in scale) scale.range(config.range);
            else scale.range(config.range);
        }
    }
});
parcelRegister("8m6Xe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6155c5c6f5439590$export$2e2bcd8739ae039);
    function $6155c5c6f5439590$export$2e2bcd8739ae039(scale, config) {
        if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
    }
});
parcelRegister("c8Zjd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d75ca1400c343c0$export$2e2bcd8739ae039);
    function $8d75ca1400c343c0$export$2e2bcd8739ae039(scale, config) {
        if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
    }
});
parcelRegister("1MYRX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14d97d80be7dc302$export$2e2bcd8739ae039);
    function $14d97d80be7dc302$export$2e2bcd8739ae039(scale, config) {
        if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
    }
});
parcelRegister("adff9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76f6f14eacc4e6ab$export$2e2bcd8739ae039);
    function $76f6f14eacc4e6ab$export$2e2bcd8739ae039(scale, config) {
        if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
    }
});
parcelRegister("1MyI8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14c532f8d5c42e52$export$2e2bcd8739ae039);
    function $14c532f8d5c42e52$export$2e2bcd8739ae039(scale, config) {
        if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
    }
});
parcelRegister("ic1Fv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3eaa44c0ab3088c$export$2e2bcd8739ae039);
    var $fVmmU;
    function $d3eaa44c0ab3088c$export$2e2bcd8739ae039(scale, config) {
        if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
            var interpolator = (0, (0, parcelRequire("fVmmU")).default)(config.interpolate);
            scale.interpolate(interpolator);
        }
    }
});
parcelRegister("fVmmU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b97d87c86200b9cc$export$2e2bcd8739ae039);
    var $bktzi;
    var $45TwU;
    var $9faDM;
    var $fBRs6;
    var $aG0QU;
    var $b97d87c86200b9cc$var$interpolatorMap = {
        lab: (0, (0, parcelRequire("fBRs6")).default),
        hcl: (0, (0, parcelRequire("45TwU")).default),
        'hcl-long': (0, (0, parcelRequire("45TwU")).hclLong),
        hsl: (0, (0, parcelRequire("9faDM")).default),
        'hsl-long': (0, (0, parcelRequire("9faDM")).hslLong),
        cubehelix: (0, (0, parcelRequire("bktzi")).default),
        'cubehelix-long': (0, (0, parcelRequire("bktzi")).cubehelixLong),
        rgb: (0, (0, parcelRequire("aG0QU")).default)
    };
    function $b97d87c86200b9cc$export$2e2bcd8739ae039(interpolate) {
        switch(interpolate){
            case 'lab':
            case 'hcl':
            case 'hcl-long':
            case 'hsl':
            case 'hsl-long':
            case 'cubehelix':
            case 'cubehelix-long':
            case 'rgb':
                return $b97d87c86200b9cc$var$interpolatorMap[interpolate];
            default:
        }
        var type = interpolate.type, gamma = interpolate.gamma;
        var interpolator = $b97d87c86200b9cc$var$interpolatorMap[type];
        return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
    }
});
parcelRegister("bktzi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83f87f9993df75d4$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "cubehelixLong", ()=>$83f87f9993df75d4$export$934fa09ad474a1b4);
    var $eKYlI;
    var $9fc6H;
    function $83f87f9993df75d4$var$cubehelix(hue) {
        return function cubehelixGamma(y) {
            y = +y;
            function cubehelix(start, end) {
                var h = hue((start = (0, (0, parcelRequire("eKYlI")).default)(start)).h, (end = (0, (0, parcelRequire("eKYlI")).default)(end)).h), s = (0, (0, parcelRequire("9fc6H")).default)(start.s, end.s), l = (0, (0, parcelRequire("9fc6H")).default)(start.l, end.l), opacity = (0, (0, parcelRequire("9fc6H")).default)(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.s = s(t);
                    start.l = l(Math.pow(t, y));
                    start.opacity = opacity(t);
                    return start + "";
                };
            }
            cubehelix.gamma = cubehelixGamma;
            return cubehelix;
        }(1);
    }
    var $83f87f9993df75d4$export$2e2bcd8739ae039 = $83f87f9993df75d4$var$cubehelix((0, (0, parcelRequire("9fc6H")).hue));
    var $83f87f9993df75d4$export$934fa09ad474a1b4 = $83f87f9993df75d4$var$cubehelix((0, (0, parcelRequire("9fc6H")).default));
});
parcelRegister("eKYlI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abe42cac81644644$export$2e2bcd8739ae039);
    var $eeO9w;
    var $7UL8A;
    var $fS7Ud;
    var $abe42cac81644644$var$A = -0.14861, $abe42cac81644644$var$B = 1.78277, $abe42cac81644644$var$C = -0.29227, $abe42cac81644644$var$D = -0.90649, $abe42cac81644644$var$E = 1.97294, $abe42cac81644644$var$ED = $abe42cac81644644$var$E * $abe42cac81644644$var$D, $abe42cac81644644$var$EB = $abe42cac81644644$var$E * $abe42cac81644644$var$B, $abe42cac81644644$var$BC_DA = $abe42cac81644644$var$B * $abe42cac81644644$var$C - $abe42cac81644644$var$D * $abe42cac81644644$var$A;
    function $abe42cac81644644$var$cubehelixConvert(o) {
        if (o instanceof $abe42cac81644644$export$57ed4bde61a1e2f2) return new $abe42cac81644644$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof (0, (0, parcelRequire("7UL8A")).Rgb))) o = (0, (0, parcelRequire("7UL8A")).rgbConvert)(o);
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($abe42cac81644644$var$BC_DA * b + $abe42cac81644644$var$ED * r - $abe42cac81644644$var$EB * g) / ($abe42cac81644644$var$BC_DA + $abe42cac81644644$var$ED - $abe42cac81644644$var$EB), bl = b - l, k = ($abe42cac81644644$var$E * (g - l) - $abe42cac81644644$var$C * bl) / $abe42cac81644644$var$D, s = Math.sqrt(k * k + bl * bl) / ($abe42cac81644644$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, (0, parcelRequire("fS7Ud")).degrees) - 120 : NaN;
        return new $abe42cac81644644$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
    }
    function $abe42cac81644644$export$2e2bcd8739ae039(h, s, l, opacity) {
        return arguments.length === 1 ? $abe42cac81644644$var$cubehelixConvert(h) : new $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
    }
    function $abe42cac81644644$export$57ed4bde61a1e2f2(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    (0, (0, parcelRequire("eeO9w")).default)($abe42cac81644644$export$57ed4bde61a1e2f2, $abe42cac81644644$export$2e2bcd8739ae039, (0, (0, parcelRequire("eeO9w")).extend)((0, (0, parcelRequire("7UL8A")).Color), {
        brighter (k) {
            k = k == null ? (0, (0, parcelRequire("7UL8A")).brighter) : Math.pow((0, (0, parcelRequire("7UL8A")).brighter), k);
            return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? (0, (0, parcelRequire("7UL8A")).darker) : Math.pow((0, (0, parcelRequire("7UL8A")).darker), k);
            return new $abe42cac81644644$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, (0, parcelRequire("fS7Ud")).radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
            return new (0, (0, parcelRequire("7UL8A")).Rgb)(255 * (l + a * ($abe42cac81644644$var$A * cosh + $abe42cac81644644$var$B * sinh)), 255 * (l + a * ($abe42cac81644644$var$C * cosh + $abe42cac81644644$var$D * sinh)), 255 * (l + a * ($abe42cac81644644$var$E * cosh)), this.opacity);
        }
    }));
});
parcelRegister("fS7Ud", function(module, exports) {
    $parcel$export(module.exports, "radians", ()=>$b8e20817cb73101d$export$8449e153fbd325fc);
    $parcel$export(module.exports, "degrees", ()=>$b8e20817cb73101d$export$41fc368e1a942b97);
    const $b8e20817cb73101d$export$8449e153fbd325fc = Math.PI / 180;
    const $b8e20817cb73101d$export$41fc368e1a942b97 = 180 / Math.PI;
});
parcelRegister("9fc6H", function(module, exports) {
    $parcel$export(module.exports, "hue", ()=>$6baee7f5715a9c6b$export$97d7b0c7ddb78dcf);
    $parcel$export(module.exports, "gamma", ()=>$6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37);
    $parcel$export(module.exports, "default", ()=>$6baee7f5715a9c6b$export$2e2bcd8739ae039);
    var $28ku5;
    function $6baee7f5715a9c6b$var$linear(a, d) {
        return function(t) {
            return a + t * d;
        };
    }
    function $6baee7f5715a9c6b$var$exponential(a, b, y) {
        return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
            return Math.pow(a + t * b, y);
        };
    }
    function $6baee7f5715a9c6b$export$97d7b0c7ddb78dcf(a, b) {
        var d = b - a;
        return d ? $6baee7f5715a9c6b$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, (0, parcelRequire("28ku5")).default)(isNaN(a) ? b : a);
    }
    function $6baee7f5715a9c6b$export$a7ebe8cc6aaf8d37(y) {
        return (y = +y) === 1 ? $6baee7f5715a9c6b$export$2e2bcd8739ae039 : function(a, b) {
            return b - a ? $6baee7f5715a9c6b$var$exponential(a, b, y) : (0, (0, parcelRequire("28ku5")).default)(isNaN(a) ? b : a);
        };
    }
    function $6baee7f5715a9c6b$export$2e2bcd8739ae039(a, b) {
        var d = b - a;
        return d ? $6baee7f5715a9c6b$var$linear(a, d) : (0, (0, parcelRequire("28ku5")).default)(isNaN(a) ? b : a);
    }
});
parcelRegister("28ku5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18dc37dae666c7d2$export$2e2bcd8739ae039);
    var $18dc37dae666c7d2$export$2e2bcd8739ae039 = (x)=>()=>x;
});
parcelRegister("45TwU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fb2b41fd8805549$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "hclLong", ()=>$2fb2b41fd8805549$export$5aaa50f7615f9b70);
    var $40oml;
    var $9fc6H;
    function $2fb2b41fd8805549$var$hcl(hue) {
        return function(start, end) {
            var h = hue((start = (0, (0, parcelRequire("40oml")).hcl)(start)).h, (end = (0, (0, parcelRequire("40oml")).hcl)(end)).h), c = (0, (0, parcelRequire("9fc6H")).default)(start.c, end.c), l = (0, (0, parcelRequire("9fc6H")).default)(start.l, end.l), opacity = (0, (0, parcelRequire("9fc6H")).default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.c = c(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var $2fb2b41fd8805549$export$2e2bcd8739ae039 = $2fb2b41fd8805549$var$hcl((0, (0, parcelRequire("9fc6H")).hue));
    var $2fb2b41fd8805549$export$5aaa50f7615f9b70 = $2fb2b41fd8805549$var$hcl((0, (0, parcelRequire("9fc6H")).default));
});
parcelRegister("40oml", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2eaa0ec960060b67$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "hcl", ()=>$2eaa0ec960060b67$export$d0e870ba50062ff1);
    var $eeO9w;
    var $7UL8A;
    var $fS7Ud;
    const $2eaa0ec960060b67$var$K = 18, $2eaa0ec960060b67$var$Xn = 0.96422, $2eaa0ec960060b67$var$Yn = 1, $2eaa0ec960060b67$var$Zn = 0.82521, $2eaa0ec960060b67$var$t0 = 4 / 29, $2eaa0ec960060b67$var$t1 = 6 / 29, $2eaa0ec960060b67$var$t2 = 3 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1, $2eaa0ec960060b67$var$t3 = $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1 * $2eaa0ec960060b67$var$t1;
    function $2eaa0ec960060b67$var$labConvert(o) {
        if (o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
        if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return $2eaa0ec960060b67$var$hcl2lab(o);
        if (!(o instanceof (0, (0, parcelRequire("7UL8A")).Rgb))) o = (0, (0, parcelRequire("7UL8A")).rgbConvert)(o);
        var r = $2eaa0ec960060b67$var$rgb2lrgb(o.r), g = $2eaa0ec960060b67$var$rgb2lrgb(o.g), b = $2eaa0ec960060b67$var$rgb2lrgb(o.b), y = $2eaa0ec960060b67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $2eaa0ec960060b67$var$Yn), x, z;
        if (r === g && g === b) x = z = y;
        else {
            x = $2eaa0ec960060b67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $2eaa0ec960060b67$var$Xn);
            z = $2eaa0ec960060b67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $2eaa0ec960060b67$var$Zn);
        }
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
    }
    function $2eaa0ec960060b67$export$3e2c219d3ab79d01(l, opacity) {
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
    }
    function $2eaa0ec960060b67$export$2e2bcd8739ae039(l, a, b, opacity) {
        return arguments.length === 1 ? $2eaa0ec960060b67$var$labConvert(l) : new $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
    }
    function $2eaa0ec960060b67$export$f2722c70a60257f7(l, a, b, opacity) {
        this.l = +l;
        this.a = +a;
        this.b = +b;
        this.opacity = +opacity;
    }
    (0, (0, parcelRequire("eeO9w")).default)($2eaa0ec960060b67$export$f2722c70a60257f7, $2eaa0ec960060b67$export$2e2bcd8739ae039, (0, (0, parcelRequire("eeO9w")).extend)((0, (0, parcelRequire("7UL8A")).Color), {
        brighter (k) {
            return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        darker (k) {
            return new $2eaa0ec960060b67$export$f2722c70a60257f7(this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        rgb () {
            var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
            x = $2eaa0ec960060b67$var$Xn * $2eaa0ec960060b67$var$lab2xyz(x);
            y = $2eaa0ec960060b67$var$Yn * $2eaa0ec960060b67$var$lab2xyz(y);
            z = $2eaa0ec960060b67$var$Zn * $2eaa0ec960060b67$var$lab2xyz(z);
            return new (0, (0, parcelRequire("7UL8A")).Rgb)($2eaa0ec960060b67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $2eaa0ec960060b67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $2eaa0ec960060b67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
        }
    }));
    function $2eaa0ec960060b67$var$xyz2lab(t) {
        return t > $2eaa0ec960060b67$var$t3 ? Math.pow(t, 1 / 3) : t / $2eaa0ec960060b67$var$t2 + $2eaa0ec960060b67$var$t0;
    }
    function $2eaa0ec960060b67$var$lab2xyz(t) {
        return t > $2eaa0ec960060b67$var$t1 ? t * t * t : $2eaa0ec960060b67$var$t2 * (t - $2eaa0ec960060b67$var$t0);
    }
    function $2eaa0ec960060b67$var$lrgb2rgb(x) {
        return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
    }
    function $2eaa0ec960060b67$var$rgb2lrgb(x) {
        return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    }
    function $2eaa0ec960060b67$var$hclConvert(o) {
        if (o instanceof $2eaa0ec960060b67$export$d9397e094a5fbb9a) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
        if (!(o instanceof $2eaa0ec960060b67$export$f2722c70a60257f7)) o = $2eaa0ec960060b67$var$labConvert(o);
        if (o.a === 0 && o.b === 0) return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
        var h = Math.atan2(o.b, o.a) * (0, (0, parcelRequire("fS7Ud")).degrees);
        return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
    }
    function $2eaa0ec960060b67$export$5a21418738164530(l, c, h, opacity) {
        return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(l) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
    }
    function $2eaa0ec960060b67$export$d0e870ba50062ff1(h, c, l, opacity) {
        return arguments.length === 1 ? $2eaa0ec960060b67$var$hclConvert(h) : new $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
    }
    function $2eaa0ec960060b67$export$d9397e094a5fbb9a(h, c, l, opacity) {
        this.h = +h;
        this.c = +c;
        this.l = +l;
        this.opacity = +opacity;
    }
    function $2eaa0ec960060b67$var$hcl2lab(o) {
        if (isNaN(o.h)) return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
        var h = o.h * (0, (0, parcelRequire("fS7Ud")).radians);
        return new $2eaa0ec960060b67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    (0, (0, parcelRequire("eeO9w")).default)($2eaa0ec960060b67$export$d9397e094a5fbb9a, $2eaa0ec960060b67$export$d0e870ba50062ff1, (0, (0, parcelRequire("eeO9w")).extend)((0, (0, parcelRequire("7UL8A")).Color), {
        brighter (k) {
            return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
        },
        darker (k) {
            return new $2eaa0ec960060b67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $2eaa0ec960060b67$var$K * (k == null ? 1 : k), this.opacity);
        },
        rgb () {
            return $2eaa0ec960060b67$var$hcl2lab(this).rgb();
        }
    }));
});
parcelRegister("9faDM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6badc4c070d16f58$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "hslLong", ()=>$6badc4c070d16f58$export$a2c535e270a59256);
    var $7UL8A;
    var $9fc6H;
    function $6badc4c070d16f58$var$hsl(hue) {
        return function(start, end) {
            var h = hue((start = (0, (0, parcelRequire("7UL8A")).hsl)(start)).h, (end = (0, (0, parcelRequire("7UL8A")).hsl)(end)).h), s = (0, (0, parcelRequire("9fc6H")).default)(start.s, end.s), l = (0, (0, parcelRequire("9fc6H")).default)(start.l, end.l), opacity = (0, (0, parcelRequire("9fc6H")).default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var $6badc4c070d16f58$export$2e2bcd8739ae039 = $6badc4c070d16f58$var$hsl((0, (0, parcelRequire("9fc6H")).hue));
    var $6badc4c070d16f58$export$a2c535e270a59256 = $6badc4c070d16f58$var$hsl((0, (0, parcelRequire("9fc6H")).default));
});
parcelRegister("fBRs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5d3c63d13f1ba54$export$2e2bcd8739ae039);
    var $40oml;
    var $9fc6H;
    function $b5d3c63d13f1ba54$export$2e2bcd8739ae039(start, end) {
        var l = (0, (0, parcelRequire("9fc6H")).default)((start = (0, (0, parcelRequire("40oml")).default)(start)).l, (end = (0, (0, parcelRequire("40oml")).default)(end)).l), a = (0, (0, parcelRequire("9fc6H")).default)(start.a, end.a), b = (0, (0, parcelRequire("9fc6H")).default)(start.b, end.b), opacity = (0, (0, parcelRequire("9fc6H")).default)(start.opacity, end.opacity);
        return function(t) {
            start.l = l(t);
            start.a = a(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
});
parcelRegister("aG0QU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c5e7ce60195f842$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "rgbBasis", ()=>$7c5e7ce60195f842$export$2c0e28f2e2852d3f);
    $parcel$export(module.exports, "rgbBasisClosed", ()=>$7c5e7ce60195f842$export$53d5214f625ccd4c);
    var $7UL8A;
    var $IzpFC;
    var $jde0I;
    var $9fc6H;
    var $7c5e7ce60195f842$export$2e2bcd8739ae039 = function rgbGamma(y) {
        var color = (0, (0, parcelRequire("9fc6H")).gamma)(y);
        function rgb(start, end) {
            var r = color((start = (0, (0, parcelRequire("7UL8A")).rgb)(start)).r, (end = (0, (0, parcelRequire("7UL8A")).rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, (0, parcelRequire("9fc6H")).default)(start.opacity, end.opacity);
            return function(t) {
                start.r = r(t);
                start.g = g(t);
                start.b = b(t);
                start.opacity = opacity(t);
                return start + "";
            };
        }
        rgb.gamma = rgbGamma;
        return rgb;
    }(1);
    function $7c5e7ce60195f842$var$rgbSpline(spline) {
        return function(colors) {
            var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
            for(i = 0; i < n; ++i){
                color = (0, (0, parcelRequire("7UL8A")).rgb)(colors[i]);
                r[i] = color.r || 0;
                g[i] = color.g || 0;
                b[i] = color.b || 0;
            }
            r = spline(r);
            g = spline(g);
            b = spline(b);
            color.opacity = 1;
            return function(t) {
                color.r = r(t);
                color.g = g(t);
                color.b = b(t);
                return color + "";
            };
        };
    }
    var $7c5e7ce60195f842$export$2c0e28f2e2852d3f = $7c5e7ce60195f842$var$rgbSpline((0, (0, parcelRequire("IzpFC")).default));
    var $7c5e7ce60195f842$export$53d5214f625ccd4c = $7c5e7ce60195f842$var$rgbSpline((0, (0, parcelRequire("jde0I")).default));
});
parcelRegister("IzpFC", function(module, exports) {
    $parcel$export(module.exports, "basis", ()=>$085f9477972cbd8b$export$4e41033bfeec1a4c);
    $parcel$export(module.exports, "default", ()=>$085f9477972cbd8b$export$2e2bcd8739ae039);
    function $085f9477972cbd8b$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
        var t2 = t1 * t1, t3 = t2 * t1;
        return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
    }
    function $085f9477972cbd8b$export$2e2bcd8739ae039(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return $085f9477972cbd8b$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
        };
    }
});
parcelRegister("jde0I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfca19696d8e5441$export$2e2bcd8739ae039);
    var $IzpFC;
    function $dfca19696d8e5441$export$2e2bcd8739ae039(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, (0, parcelRequire("IzpFC")).basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    }
});
parcelRegister("7goQn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$549d4c81fda79cdb$export$2e2bcd8739ae039);
    parcelRequire("dwFQU");
    var $cRW5v;
    var $kSdfl;
    var $7yDT1;
    var $2jkSd;
    var $dayZI;
    var $8vb39;
    var $idw3k;
    var $jjmqp;
    var $549d4c81fda79cdb$var$localTimeIntervals = {
        day: (0, (0, parcelRequire("cRW5v")).timeDay),
        hour: (0, (0, parcelRequire("kSdfl")).timeHour),
        minute: (0, (0, parcelRequire("7yDT1")).timeMinute),
        month: (0, (0, parcelRequire("2jkSd")).timeMonth),
        second: (0, (0, parcelRequire("dayZI")).second),
        week: (0, (0, parcelRequire("8vb39")).timeSunday),
        year: (0, (0, parcelRequire("idw3k")).timeYear)
    };
    var $549d4c81fda79cdb$var$utcIntervals = {
        day: (0, (0, parcelRequire("cRW5v")).utcDay),
        hour: (0, (0, parcelRequire("kSdfl")).utcHour),
        minute: (0, (0, parcelRequire("7yDT1")).utcMinute),
        month: (0, (0, parcelRequire("2jkSd")).utcMonth),
        second: (0, (0, parcelRequire("dayZI")).second),
        week: (0, (0, parcelRequire("8vb39")).utcSunday),
        year: (0, (0, parcelRequire("idw3k")).utcYear)
    };
    function $549d4c81fda79cdb$export$2e2bcd8739ae039(scale, config) {
        if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
            var nice = config.nice;
            if (typeof nice === 'boolean') {
                if (nice) scale.nice();
            } else if (typeof nice === 'number') scale.nice(nice);
            else {
                var timeScale = scale;
                var isUtc = (0, (0, parcelRequire("jjmqp")).default)(timeScale);
                if (typeof nice === 'string') timeScale.nice(isUtc ? $549d4c81fda79cdb$var$utcIntervals[nice] : $549d4c81fda79cdb$var$localTimeIntervals[nice]);
                else {
                    var interval = nice.interval, step = nice.step;
                    var parsedInterval = (isUtc ? $549d4c81fda79cdb$var$utcIntervals[interval] : $549d4c81fda79cdb$var$localTimeIntervals[interval]).every(step);
                    if (parsedInterval != null) timeScale.nice(parsedInterval);
                }
            }
        }
    }
});
parcelRegister("dwFQU", function(module, exports) {
    $parcel$export(module.exports, "timeDay", ()=>(parcelRequire("cRW5v")).timeDay);
    $parcel$export(module.exports, "timeHour", ()=>(parcelRequire("kSdfl")).timeHour);
    $parcel$export(module.exports, "timeMinute", ()=>(parcelRequire("7yDT1")).timeMinute);
    $parcel$export(module.exports, "timeMonth", ()=>(parcelRequire("2jkSd")).timeMonth);
    $parcel$export(module.exports, "timeSecond", ()=>(parcelRequire("dayZI")).second);
    $parcel$export(module.exports, "timeWeek", ()=>(parcelRequire("8vb39")).timeSunday);
    $parcel$export(module.exports, "timeYear", ()=>(parcelRequire("idw3k")).timeYear);
    $parcel$export(module.exports, "utcDay", ()=>(parcelRequire("cRW5v")).utcDay);
    $parcel$export(module.exports, "utcHour", ()=>(parcelRequire("kSdfl")).utcHour);
    $parcel$export(module.exports, "utcMinute", ()=>(parcelRequire("7yDT1")).utcMinute);
    $parcel$export(module.exports, "utcMonth", ()=>(parcelRequire("2jkSd")).utcMonth);
    $parcel$export(module.exports, "utcSecond", ()=>(parcelRequire("dayZI")).second);
    $parcel$export(module.exports, "utcWeek", ()=>(parcelRequire("8vb39")).utcSunday);
    $parcel$export(module.exports, "utcYear", ()=>(parcelRequire("idw3k")).utcYear);
    parcelRequire("gsGNk");
});
parcelRegister("gsGNk", function(module, exports) {
    $parcel$export(module.exports, "utcMillisecond", ()=>(parcelRequire("co6MX")).millisecond);
    $parcel$export(module.exports, "timeMillisecond", ()=>(parcelRequire("co6MX")).millisecond);
    $parcel$export(module.exports, "utcSecond", ()=>(parcelRequire("dayZI")).second);
    $parcel$export(module.exports, "timeSecond", ()=>(parcelRequire("dayZI")).second);
    $parcel$export(module.exports, "timeMinute", ()=>(parcelRequire("7yDT1")).timeMinute);
    $parcel$export(module.exports, "utcMinute", ()=>(parcelRequire("7yDT1")).utcMinute);
    $parcel$export(module.exports, "timeHour", ()=>(parcelRequire("kSdfl")).timeHour);
    $parcel$export(module.exports, "utcHour", ()=>(parcelRequire("kSdfl")).utcHour);
    $parcel$export(module.exports, "timeDay", ()=>(parcelRequire("cRW5v")).timeDay);
    $parcel$export(module.exports, "utcDay", ()=>(parcelRequire("cRW5v")).utcDay);
    $parcel$export(module.exports, "timeWeek", ()=>(parcelRequire("8vb39")).timeSunday);
    $parcel$export(module.exports, "utcWeek", ()=>(parcelRequire("8vb39")).utcSunday);
    $parcel$export(module.exports, "timeMonth", ()=>(parcelRequire("2jkSd")).timeMonth);
    $parcel$export(module.exports, "utcMonth", ()=>(parcelRequire("2jkSd")).utcMonth);
    $parcel$export(module.exports, "timeYear", ()=>(parcelRequire("idw3k")).timeYear);
    $parcel$export(module.exports, "utcYear", ()=>(parcelRequire("idw3k")).utcYear);
    var $co6MX;
    var $dayZI;
    var $7yDT1;
    var $kSdfl;
    var $cRW5v;
    var $8vb39;
    var $2jkSd;
    var $idw3k;
    var $dCu2z;
});
parcelRegister("co6MX", function(module, exports) {
    $parcel$export(module.exports, "millisecond", ()=>$904cfdfe660e697c$export$edc5e5cb87280477);
    var $ecWlt;
    const $904cfdfe660e697c$export$edc5e5cb87280477 = (0, (0, parcelRequire("ecWlt")).timeInterval)(()=>{}, (date, step)=>{
        date.setTime(+date + step);
    }, (start, end)=>{
        return end - start;
    });
    $904cfdfe660e697c$export$edc5e5cb87280477.every = (k)=>{
        k = Math.floor(k);
        if (!isFinite(k) || !(k > 0)) return null;
        if (!(k > 1)) return $904cfdfe660e697c$export$edc5e5cb87280477;
        return (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
            date.setTime(Math.floor(date / k) * k);
        }, (date, step)=>{
            date.setTime(+date + step * k);
        }, (start, end)=>{
            return (end - start) / k;
        });
    };
    const $904cfdfe660e697c$export$9a27fac83d67afd3 = $904cfdfe660e697c$export$edc5e5cb87280477.range;
});
parcelRegister("ecWlt", function(module, exports) {
    $parcel$export(module.exports, "timeInterval", ()=>$a57f71df9770069e$export$1a539c8b2950ab40);
    const $a57f71df9770069e$var$t0 = new Date, $a57f71df9770069e$var$t1 = new Date;
    function $a57f71df9770069e$export$1a539c8b2950ab40(floori, offseti, count, field) {
        function interval(date) {
            return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
        }
        interval.floor = (date)=>{
            return floori(date = new Date(+date)), date;
        };
        interval.ceil = (date)=>{
            return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
        };
        interval.round = (date)=>{
            const d0 = interval(date), d1 = interval.ceil(date);
            return date - d0 < d1 - date ? d0 : d1;
        };
        interval.offset = (date, step)=>{
            return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
        };
        interval.range = (start, stop, step)=>{
            const range = [];
            start = interval.ceil(start);
            step = step == null ? 1 : Math.floor(step);
            if (!(start < stop) || !(step > 0)) return range;
            let previous;
            do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
            while (previous < start && start < stop)
            return range;
        };
        interval.filter = (test)=>{
            return $a57f71df9770069e$export$1a539c8b2950ab40((date)=>{
                if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
            }, (date, step)=>{
                if (date >= date) {
                    if (step < 0) while(++step <= 0){
                        while(offseti(date, -1), !test(date));
                    }
                    else while(--step >= 0){
                        while(offseti(date, 1), !test(date));
                    }
                }
            });
        };
        if (count) {
            interval.count = (start, end)=>{
                $a57f71df9770069e$var$t0.setTime(+start), $a57f71df9770069e$var$t1.setTime(+end);
                floori($a57f71df9770069e$var$t0), floori($a57f71df9770069e$var$t1);
                return Math.floor(count($a57f71df9770069e$var$t0, $a57f71df9770069e$var$t1));
            };
            interval.every = (step)=>{
                step = Math.floor(step);
                return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
            };
        }
        return interval;
    }
});
parcelRegister("dayZI", function(module, exports) {
    $parcel$export(module.exports, "second", ()=>$99675ab62f0ed735$export$3d3c77ce7df7d30d);
    var $ecWlt;
    var $fUrRw;
    const $99675ab62f0ed735$export$3d3c77ce7df7d30d = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setTime(date - date.getMilliseconds());
    }, (date, step)=>{
        date.setTime(+date + step * (0, (0, parcelRequire("fUrRw")).durationSecond));
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationSecond);
    }, (date)=>{
        return date.getUTCSeconds();
    });
    const $99675ab62f0ed735$export$4792e48abc550fa1 = $99675ab62f0ed735$export$3d3c77ce7df7d30d.range;
});
parcelRegister("fUrRw", function(module, exports) {
    $parcel$export(module.exports, "durationSecond", ()=>$b951b2d60ecd41a7$export$79ef0e34099623dc);
    $parcel$export(module.exports, "durationMinute", ()=>$b951b2d60ecd41a7$export$683905d551c33fa9);
    $parcel$export(module.exports, "durationHour", ()=>$b951b2d60ecd41a7$export$4157bf0c8e241659);
    $parcel$export(module.exports, "durationDay", ()=>$b951b2d60ecd41a7$export$353686095f4fbf45);
    $parcel$export(module.exports, "durationWeek", ()=>$b951b2d60ecd41a7$export$c241eb88520d5016);
    $parcel$export(module.exports, "durationMonth", ()=>$b951b2d60ecd41a7$export$ab95684df7020b26);
    $parcel$export(module.exports, "durationYear", ()=>$b951b2d60ecd41a7$export$61f8ee2d834c6959);
    const $b951b2d60ecd41a7$export$79ef0e34099623dc = 1000;
    const $b951b2d60ecd41a7$export$683905d551c33fa9 = $b951b2d60ecd41a7$export$79ef0e34099623dc * 60;
    const $b951b2d60ecd41a7$export$4157bf0c8e241659 = $b951b2d60ecd41a7$export$683905d551c33fa9 * 60;
    const $b951b2d60ecd41a7$export$353686095f4fbf45 = $b951b2d60ecd41a7$export$4157bf0c8e241659 * 24;
    const $b951b2d60ecd41a7$export$c241eb88520d5016 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 7;
    const $b951b2d60ecd41a7$export$ab95684df7020b26 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 30;
    const $b951b2d60ecd41a7$export$61f8ee2d834c6959 = $b951b2d60ecd41a7$export$353686095f4fbf45 * 365;
});
parcelRegister("7yDT1", function(module, exports) {
    $parcel$export(module.exports, "timeMinute", ()=>$580aa6047b58c4b1$export$a7e4c34a52f0576);
    $parcel$export(module.exports, "utcMinute", ()=>$580aa6047b58c4b1$export$efe6712d6003761b);
    var $ecWlt;
    var $fUrRw;
    const $580aa6047b58c4b1$export$a7e4c34a52f0576 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, (0, parcelRequire("fUrRw")).durationSecond));
    }, (date, step)=>{
        date.setTime(+date + step * (0, (0, parcelRequire("fUrRw")).durationMinute));
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationMinute);
    }, (date)=>{
        return date.getMinutes();
    });
    const $580aa6047b58c4b1$export$186d65358374c0a2 = $580aa6047b58c4b1$export$a7e4c34a52f0576.range;
    const $580aa6047b58c4b1$export$efe6712d6003761b = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCSeconds(0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * (0, (0, parcelRequire("fUrRw")).durationMinute));
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationMinute);
    }, (date)=>{
        return date.getUTCMinutes();
    });
    const $580aa6047b58c4b1$export$cedd563624e8ee50 = $580aa6047b58c4b1$export$efe6712d6003761b.range;
});
parcelRegister("kSdfl", function(module, exports) {
    $parcel$export(module.exports, "timeHour", ()=>$f32320462d9111c0$export$46c68a5833bc315b);
    $parcel$export(module.exports, "utcHour", ()=>$f32320462d9111c0$export$31f6f2b3c63ac75e);
    var $ecWlt;
    var $fUrRw;
    const $f32320462d9111c0$export$46c68a5833bc315b = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, (0, parcelRequire("fUrRw")).durationSecond) - date.getMinutes() * (0, (0, parcelRequire("fUrRw")).durationMinute));
    }, (date, step)=>{
        date.setTime(+date + step * (0, (0, parcelRequire("fUrRw")).durationHour));
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationHour);
    }, (date)=>{
        return date.getHours();
    });
    const $f32320462d9111c0$export$fb843f9087cd5235 = $f32320462d9111c0$export$46c68a5833bc315b.range;
    const $f32320462d9111c0$export$31f6f2b3c63ac75e = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCMinutes(0, 0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * (0, (0, parcelRequire("fUrRw")).durationHour));
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationHour);
    }, (date)=>{
        return date.getUTCHours();
    });
    const $f32320462d9111c0$export$6e7a76cd5f50b719 = $f32320462d9111c0$export$31f6f2b3c63ac75e.range;
});
parcelRegister("cRW5v", function(module, exports) {
    $parcel$export(module.exports, "timeDay", ()=>$95e77e521447ed47$export$8888529b966033e5);
    $parcel$export(module.exports, "utcDay", ()=>$95e77e521447ed47$export$c8cbc42cefd47140);
    $parcel$export(module.exports, "unixDay", ()=>$95e77e521447ed47$export$fb065be2d7ea4a71);
    var $ecWlt;
    var $fUrRw;
    const $95e77e521447ed47$export$8888529b966033e5 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, (0, parcelRequire("fUrRw")).durationMinute)) / (0, (0, parcelRequire("fUrRw")).durationDay), (date)=>date.getDate() - 1);
    const $95e77e521447ed47$export$6657a54f3034cf45 = $95e77e521447ed47$export$8888529b966033e5.range;
    const $95e77e521447ed47$export$c8cbc42cefd47140 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationDay);
    }, (date)=>{
        return date.getUTCDate() - 1;
    });
    const $95e77e521447ed47$export$d277e198508549a1 = $95e77e521447ed47$export$c8cbc42cefd47140.range;
    const $95e77e521447ed47$export$fb065be2d7ea4a71 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / (0, (0, parcelRequire("fUrRw")).durationDay);
    }, (date)=>{
        return Math.floor(date / (0, (0, parcelRequire("fUrRw")).durationDay));
    });
    const $95e77e521447ed47$export$a491caaf5e9481aa = $95e77e521447ed47$export$fb065be2d7ea4a71.range;
});
parcelRegister("8vb39", function(module, exports) {
    $parcel$export(module.exports, "timeSunday", ()=>$6309ca3cb2286854$export$22ee6205b762968c);
    $parcel$export(module.exports, "timeMonday", ()=>$6309ca3cb2286854$export$e79bbe0177cf1b01);
    $parcel$export(module.exports, "timeThursday", ()=>$6309ca3cb2286854$export$608689422d5cf9f4);
    $parcel$export(module.exports, "utcSunday", ()=>$6309ca3cb2286854$export$4898b06303a92011);
    $parcel$export(module.exports, "utcMonday", ()=>$6309ca3cb2286854$export$9cfc53b9cfafd080);
    $parcel$export(module.exports, "utcThursday", ()=>$6309ca3cb2286854$export$1db08111baec2f53);
    var $ecWlt;
    var $fUrRw;
    function $6309ca3cb2286854$var$timeWeekday(i) {
        return (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
            date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setDate(date.getDate() + step * 7);
        }, (start, end)=>{
            return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, (0, parcelRequire("fUrRw")).durationMinute)) / (0, (0, parcelRequire("fUrRw")).durationWeek);
        });
    }
    const $6309ca3cb2286854$export$22ee6205b762968c = $6309ca3cb2286854$var$timeWeekday(0);
    const $6309ca3cb2286854$export$e79bbe0177cf1b01 = $6309ca3cb2286854$var$timeWeekday(1);
    const $6309ca3cb2286854$export$57c0658c29f77708 = $6309ca3cb2286854$var$timeWeekday(2);
    const $6309ca3cb2286854$export$3fbeef226c256e43 = $6309ca3cb2286854$var$timeWeekday(3);
    const $6309ca3cb2286854$export$608689422d5cf9f4 = $6309ca3cb2286854$var$timeWeekday(4);
    const $6309ca3cb2286854$export$548e5227aa183dca = $6309ca3cb2286854$var$timeWeekday(5);
    const $6309ca3cb2286854$export$c56a3ad248908e19 = $6309ca3cb2286854$var$timeWeekday(6);
    const $6309ca3cb2286854$export$eac514c8a8674eba = $6309ca3cb2286854$export$22ee6205b762968c.range;
    const $6309ca3cb2286854$export$f7219b1481948356 = $6309ca3cb2286854$export$e79bbe0177cf1b01.range;
    const $6309ca3cb2286854$export$77e22b12c5bed05b = $6309ca3cb2286854$export$57c0658c29f77708.range;
    const $6309ca3cb2286854$export$b85d407a471809e8 = $6309ca3cb2286854$export$3fbeef226c256e43.range;
    const $6309ca3cb2286854$export$c1bc1c49254c8855 = $6309ca3cb2286854$export$608689422d5cf9f4.range;
    const $6309ca3cb2286854$export$3691a1557fff46f1 = $6309ca3cb2286854$export$548e5227aa183dca.range;
    const $6309ca3cb2286854$export$b755452d02cba8d2 = $6309ca3cb2286854$export$c56a3ad248908e19.range;
    function $6309ca3cb2286854$var$utcWeekday(i) {
        return (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
            date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step * 7);
        }, (start, end)=>{
            return (end - start) / (0, (0, parcelRequire("fUrRw")).durationWeek);
        });
    }
    const $6309ca3cb2286854$export$4898b06303a92011 = $6309ca3cb2286854$var$utcWeekday(0);
    const $6309ca3cb2286854$export$9cfc53b9cfafd080 = $6309ca3cb2286854$var$utcWeekday(1);
    const $6309ca3cb2286854$export$2a6d545f77eceb15 = $6309ca3cb2286854$var$utcWeekday(2);
    const $6309ca3cb2286854$export$a5c25d8ed64433c4 = $6309ca3cb2286854$var$utcWeekday(3);
    const $6309ca3cb2286854$export$1db08111baec2f53 = $6309ca3cb2286854$var$utcWeekday(4);
    const $6309ca3cb2286854$export$29265e34dd5921f7 = $6309ca3cb2286854$var$utcWeekday(5);
    const $6309ca3cb2286854$export$85b74dad05049604 = $6309ca3cb2286854$var$utcWeekday(6);
    const $6309ca3cb2286854$export$6f3e1c2b0f7d7880 = $6309ca3cb2286854$export$4898b06303a92011.range;
    const $6309ca3cb2286854$export$1d2d8b858bb366f9 = $6309ca3cb2286854$export$9cfc53b9cfafd080.range;
    const $6309ca3cb2286854$export$1d5f6785fc7f30f8 = $6309ca3cb2286854$export$2a6d545f77eceb15.range;
    const $6309ca3cb2286854$export$7a75faf0e37ef4af = $6309ca3cb2286854$export$a5c25d8ed64433c4.range;
    const $6309ca3cb2286854$export$417eb959611b2f2f = $6309ca3cb2286854$export$1db08111baec2f53.range;
    const $6309ca3cb2286854$export$59d308db7af08c64 = $6309ca3cb2286854$export$29265e34dd5921f7.range;
    const $6309ca3cb2286854$export$a124108a0a7f34c8 = $6309ca3cb2286854$export$85b74dad05049604.range;
});
parcelRegister("2jkSd", function(module, exports) {
    $parcel$export(module.exports, "timeMonth", ()=>$1aed8c22031a7431$export$7e1084fb688591c1);
    $parcel$export(module.exports, "utcMonth", ()=>$1aed8c22031a7431$export$cd49b3d2bcfe50d5);
    var $ecWlt;
    const $1aed8c22031a7431$export$7e1084fb688591c1 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setMonth(date.getMonth() + step);
    }, (start, end)=>{
        return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
    }, (date)=>{
        return date.getMonth();
    });
    const $1aed8c22031a7431$export$3e24aa839cd0f1c4 = $1aed8c22031a7431$export$7e1084fb688591c1.range;
    const $1aed8c22031a7431$export$cd49b3d2bcfe50d5 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCDate(1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCMonth(date.getUTCMonth() + step);
    }, (start, end)=>{
        return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
    }, (date)=>{
        return date.getUTCMonth();
    });
    const $1aed8c22031a7431$export$49159f585997498 = $1aed8c22031a7431$export$cd49b3d2bcfe50d5.range;
});
parcelRegister("idw3k", function(module, exports) {
    $parcel$export(module.exports, "timeYear", ()=>$d4324de4c61acb39$export$cd17cfe45df0c046);
    $parcel$export(module.exports, "utcYear", ()=>$d4324de4c61acb39$export$d5c3802e389714c4);
    var $ecWlt;
    const $d4324de4c61acb39$export$cd17cfe45df0c046 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step);
    }, (start, end)=>{
        return end.getFullYear() - start.getFullYear();
    }, (date)=>{
        return date.getFullYear();
    });
    $d4324de4c61acb39$export$cd17cfe45df0c046.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
            date.setFullYear(Math.floor(date.getFullYear() / k) * k);
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setFullYear(date.getFullYear() + step * k);
        });
    };
    const $d4324de4c61acb39$export$69a4e90dd2cc3bd1 = $d4324de4c61acb39$export$cd17cfe45df0c046.range;
    const $d4324de4c61acb39$export$d5c3802e389714c4 = (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step);
    }, (start, end)=>{
        return end.getUTCFullYear() - start.getUTCFullYear();
    }, (date)=>{
        return date.getUTCFullYear();
    });
    $d4324de4c61acb39$export$d5c3802e389714c4.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, (0, parcelRequire("ecWlt")).timeInterval)((date)=>{
            date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCFullYear(date.getUTCFullYear() + step * k);
        });
    };
    const $d4324de4c61acb39$export$3e24d311e17f5802 = $d4324de4c61acb39$export$d5c3802e389714c4.range;
});
parcelRegister("dCu2z", function(module, exports) {
    $parcel$export(module.exports, "utcTicks", ()=>$9ea6205f05c3bf94$export$826ba5ae907e9767);
    $parcel$export(module.exports, "utcTickInterval", ()=>$9ea6205f05c3bf94$export$6262d8d056ea44c4);
    $parcel$export(module.exports, "timeTicks", ()=>$9ea6205f05c3bf94$export$60c76498552d28a6);
    $parcel$export(module.exports, "timeTickInterval", ()=>$9ea6205f05c3bf94$export$69511150134dd174);
    var $88EGG;
    var $80JJl;
    var $fUrRw;
    var $co6MX;
    var $dayZI;
    var $7yDT1;
    var $kSdfl;
    var $cRW5v;
    var $8vb39;
    var $2jkSd;
    var $idw3k;
    function $9ea6205f05c3bf94$var$ticker(year, month, week, day, hour, minute) {
        const tickIntervals = [
            [
                (0, (0, parcelRequire("dayZI")).second),
                1,
                (0, (0, parcelRequire("fUrRw")).durationSecond)
            ],
            [
                (0, (0, parcelRequire("dayZI")).second),
                5,
                5 * (0, (0, parcelRequire("fUrRw")).durationSecond)
            ],
            [
                (0, (0, parcelRequire("dayZI")).second),
                15,
                15 * (0, (0, parcelRequire("fUrRw")).durationSecond)
            ],
            [
                (0, (0, parcelRequire("dayZI")).second),
                30,
                30 * (0, (0, parcelRequire("fUrRw")).durationSecond)
            ],
            [
                minute,
                1,
                (0, (0, parcelRequire("fUrRw")).durationMinute)
            ],
            [
                minute,
                5,
                5 * (0, (0, parcelRequire("fUrRw")).durationMinute)
            ],
            [
                minute,
                15,
                15 * (0, (0, parcelRequire("fUrRw")).durationMinute)
            ],
            [
                minute,
                30,
                30 * (0, (0, parcelRequire("fUrRw")).durationMinute)
            ],
            [
                hour,
                1,
                (0, (0, parcelRequire("fUrRw")).durationHour)
            ],
            [
                hour,
                3,
                3 * (0, (0, parcelRequire("fUrRw")).durationHour)
            ],
            [
                hour,
                6,
                6 * (0, (0, parcelRequire("fUrRw")).durationHour)
            ],
            [
                hour,
                12,
                12 * (0, (0, parcelRequire("fUrRw")).durationHour)
            ],
            [
                day,
                1,
                (0, (0, parcelRequire("fUrRw")).durationDay)
            ],
            [
                day,
                2,
                2 * (0, (0, parcelRequire("fUrRw")).durationDay)
            ],
            [
                week,
                1,
                (0, (0, parcelRequire("fUrRw")).durationWeek)
            ],
            [
                month,
                1,
                (0, (0, parcelRequire("fUrRw")).durationMonth)
            ],
            [
                month,
                3,
                3 * (0, (0, parcelRequire("fUrRw")).durationMonth)
            ],
            [
                year,
                1,
                (0, (0, parcelRequire("fUrRw")).durationYear)
            ]
        ];
        function ticks(start, stop, count) {
            const reverse = stop < start;
            if (reverse) [start, stop] = [
                stop,
                start
            ];
            const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
            const ticks = interval ? interval.range(start, +stop + 1) : [];
            return reverse ? ticks.reverse() : ticks;
        }
        function tickInterval(start, stop, count) {
            const target = Math.abs(stop - start) / count;
            const i = (0, (0, parcelRequire("88EGG")).default)(([, , step])=>step).right(tickIntervals, target);
            if (i === tickIntervals.length) return year.every((0, (0, parcelRequire("80JJl")).tickStep)(start / (0, (0, parcelRequire("fUrRw")).durationYear), stop / (0, (0, parcelRequire("fUrRw")).durationYear), count));
            if (i === 0) return (0, (0, parcelRequire("co6MX")).millisecond).every(Math.max((0, (0, parcelRequire("80JJl")).tickStep)(start, stop, count), 1));
            const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
            return t.every(step);
        }
        return [
            ticks,
            tickInterval
        ];
    }
    const [$9ea6205f05c3bf94$export$826ba5ae907e9767, $9ea6205f05c3bf94$export$6262d8d056ea44c4] = $9ea6205f05c3bf94$var$ticker((0, (0, parcelRequire("idw3k")).utcYear), (0, (0, parcelRequire("2jkSd")).utcMonth), (0, (0, parcelRequire("8vb39")).utcSunday), (0, (0, parcelRequire("cRW5v")).unixDay), (0, (0, parcelRequire("kSdfl")).utcHour), (0, (0, parcelRequire("7yDT1")).utcMinute));
    const [$9ea6205f05c3bf94$export$60c76498552d28a6, $9ea6205f05c3bf94$export$69511150134dd174] = $9ea6205f05c3bf94$var$ticker((0, (0, parcelRequire("idw3k")).timeYear), (0, (0, parcelRequire("2jkSd")).timeMonth), (0, (0, parcelRequire("8vb39")).timeSunday), (0, (0, parcelRequire("cRW5v")).timeDay), (0, (0, parcelRequire("kSdfl")).timeHour), (0, (0, parcelRequire("7yDT1")).timeMinute));
});
parcelRegister("88EGG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ecea1c7e6e17c2e$export$2e2bcd8739ae039);
    var $9eRkP;
    var $jaL7t;
    function $5ecea1c7e6e17c2e$export$2e2bcd8739ae039(f) {
        let compare1, compare2, delta;
        if (f.length !== 2) {
            compare1 = (0, (0, parcelRequire("9eRkP")).default);
            compare2 = (d, x)=>(0, (0, parcelRequire("9eRkP")).default)(f(d), x);
            delta = (d, x)=>f(d) - x;
        } else {
            compare1 = f === (0, (0, parcelRequire("9eRkP")).default) || f === (0, (0, parcelRequire("jaL7t")).default) ? f : $5ecea1c7e6e17c2e$var$zero;
            compare2 = f;
            delta = f;
        }
        function left(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi)
            }
            return lo;
        }
        function right(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) <= 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi)
            }
            return lo;
        }
        function center(a, x, lo = 0, hi = a.length) {
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left: left,
            center: center,
            right: right
        };
    }
    function $5ecea1c7e6e17c2e$var$zero() {
        return 0;
    }
});
parcelRegister("9eRkP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b9ecb1327aa878a$export$2e2bcd8739ae039);
    function $6b9ecb1327aa878a$export$2e2bcd8739ae039(a, b) {
        return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
});
parcelRegister("jaL7t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df538075a00c34cb$export$2e2bcd8739ae039);
    function $df538075a00c34cb$export$2e2bcd8739ae039(a, b) {
        return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
});
parcelRegister("80JJl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d51cbe8842854f5$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "tickIncrement", ()=>$5d51cbe8842854f5$export$bc64d00cc98e7e95);
    $parcel$export(module.exports, "tickStep", ()=>$5d51cbe8842854f5$export$81087d9b915d4ede);
    const $5d51cbe8842854f5$var$e10 = Math.sqrt(50), $5d51cbe8842854f5$var$e5 = Math.sqrt(10), $5d51cbe8842854f5$var$e2 = Math.sqrt(2);
    function $5d51cbe8842854f5$var$tickSpec(start, stop, count) {
        const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $5d51cbe8842854f5$var$e10 ? 10 : error >= $5d51cbe8842854f5$var$e5 ? 5 : error >= $5d51cbe8842854f5$var$e2 ? 2 : 1;
        let i1, i2, inc;
        if (power < 0) {
            inc = Math.pow(10, -power) / factor;
            i1 = Math.round(start * inc);
            i2 = Math.round(stop * inc);
            if (i1 / inc < start) ++i1;
            if (i2 / inc > stop) --i2;
            inc = -inc;
        } else {
            inc = Math.pow(10, power) * factor;
            i1 = Math.round(start / inc);
            i2 = Math.round(stop / inc);
            if (i1 * inc < start) ++i1;
            if (i2 * inc > stop) --i2;
        }
        if (i2 < i1 && 0.5 <= count && count < 2) return $5d51cbe8842854f5$var$tickSpec(start, stop, count * 2);
        return [
            i1,
            i2,
            inc
        ];
    }
    function $5d51cbe8842854f5$export$2e2bcd8739ae039(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        if (!(count > 0)) return [];
        if (start === stop) return [
            start
        ];
        const reverse = stop < start, [i1, i2, inc] = reverse ? $5d51cbe8842854f5$var$tickSpec(stop, start, count) : $5d51cbe8842854f5$var$tickSpec(start, stop, count);
        if (!(i2 >= i1)) return [];
        const n = i2 - i1 + 1, ticks = new Array(n);
        if (reverse) {
            if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
            else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
        } else {
            if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
            else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
        }
        return ticks;
    }
    function $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        return $5d51cbe8842854f5$var$tickSpec(start, stop, count)[2];
    }
    function $5d51cbe8842854f5$export$81087d9b915d4ede(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        const reverse = stop < start, inc = reverse ? $5d51cbe8842854f5$export$bc64d00cc98e7e95(stop, start, count) : $5d51cbe8842854f5$export$bc64d00cc98e7e95(start, stop, count);
        return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
    }
});
parcelRegister("jjmqp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0f12fc7b7a74157$export$2e2bcd8739ae039);
    var $e0f12fc7b7a74157$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
    var $e0f12fc7b7a74157$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
    function $e0f12fc7b7a74157$export$2e2bcd8739ae039(scale) {
        var output = scale.tickFormat(1, $e0f12fc7b7a74157$var$TEST_FORMAT)($e0f12fc7b7a74157$var$TEST_TIME);
        return output === '2020-02-02 03:04';
    }
});
parcelRegister("c1r8l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c0aa03447ba5a2e$export$2e2bcd8739ae039);
    function $8c0aa03447ba5a2e$export$2e2bcd8739ae039(scale, config) {
        if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
        if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
        if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
    }
});
parcelRegister("dWXcN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a27e9e1fda753c21$export$2e2bcd8739ae039);
    function $a27e9e1fda753c21$export$2e2bcd8739ae039(scale, config) {
        if (config.reverse) {
            var reversedRange = scale.range().slice().reverse();
            if ('padding' in scale) scale.range(reversedRange);
            else scale.range(reversedRange);
        }
    }
});
parcelRegister("4sSWK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3404662c433becd8$export$2e2bcd8739ae039);
    var $8Masb;
    function $3404662c433becd8$export$2e2bcd8739ae039(scale, config) {
        if ('round' in config && typeof config.round !== 'undefined') {
            if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
            else if ('round' in scale) scale.round(config.round);
            else if ('interpolate' in scale && config.round) scale.interpolate((0, (0, parcelRequire("8Masb")).default));
        }
    }
});
parcelRegister("8Masb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$663aea45c6d13a8b$export$2e2bcd8739ae039);
    function $663aea45c6d13a8b$export$2e2bcd8739ae039(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    }
});
parcelRegister("iuIpV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d76d7ba35e78d530$export$2e2bcd8739ae039);
    function $d76d7ba35e78d530$export$2e2bcd8739ae039(scale, config) {
        if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
    }
});
parcelRegister("jUCfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f0ea00b7703963$export$2e2bcd8739ae039);
    function $e7f0ea00b7703963$export$2e2bcd8739ae039(scale, config) {
        if ('zero' in config && config.zero === true) {
            var domain = scale.domain();
            var a = domain[0], b = domain[1];
            var isDescending = b < a;
            var _ref = isDescending ? [
                b,
                a
            ] : [
                a,
                b
            ], min = _ref[0], max = _ref[1];
            var domainWithZero = [
                Math.min(0, min),
                Math.max(0, max)
            ];
            scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
        }
    }
});
parcelRegister("8aZwB", function(module, exports) {
    $parcel$export(module.exports, "DonutTooltipOverlay", ()=>$5f3efb7a4bd14f95$export$b33ac6556176a316);
    var $5uXOq = parcelRequire("5uXOq");
    var $1xLej;
    var $dZ3lg;
    var $dYSV3;
    var $lfbyn;
    var $3VFxT;
    var $2OMIu = parcelRequire("2OMIu");
    const $5f3efb7a4bd14f95$export$b33ac6556176a316 = (0, (0, parcelRequire("1xLej")).element)(function DonutTooltipOverlay(_ref) {
        let { arcs: arcs, onClick: onClick } = _ref;
        const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, (0, parcelRequire("dYSV3")).default));
        const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
            showTooltip({
                ...e,
                datum: e === null || e === void 0 ? void 0 : e.datum
            });
        }, []);
        const handleMouseOut = (0, $5uXOq.useCallback)(()=>{
            hideTooltip();
        }, []);
        (0, (0, parcelRequire("lfbyn")).default)('pointermove', handleMouseMove, [
            (0, $667d1afbf9cc771c$export$69b1818e3c4e83f9)
        ]);
        (0, (0, parcelRequire("lfbyn")).default)('pointerdown', onClick, [
            (0, $667d1afbf9cc771c$export$69b1818e3c4e83f9)
        ]);
        (0, (0, parcelRequire("lfbyn")).default)('pointerout', handleMouseOut, [
            (0, $667d1afbf9cc771c$export$69b1818e3c4e83f9)
        ]);
        const { onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerDown: onPointerDown } = (0, (0, parcelRequire("3VFxT")).default)({
            source: (0, $667d1afbf9cc771c$export$69b1818e3c4e83f9)
        });
        return (0, $2OMIu.jsx)("g", {
            style: {
                cursor: onClick ? 'pointer' : 'default'
            },
            children: arcs.map((arc)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("dZ3lg")).Arc), {
                    onPointerMove: (e)=>onPointerMove && onPointerMove(e, arc.data),
                    onPointerOut: onPointerOut,
                    onPointerDown: (e)=>onPointerDown && onPointerDown(e, arc.data),
                    ariaLabel: arc.ariaLabel,
                    outerRadius: arc.outerRadius,
                    innerRadius: arc.innerRadius,
                    startAngle: arc.startAngle,
                    endAngle: arc.endAngle,
                    padAngle: arc.padAngle,
                    fill: 'transparent'
                }, `DonutStack-${arc.key}`))
        });
    });
});
const $667d1afbf9cc771c$export$69b1818e3c4e83f9 = '__XY_EVENT_SOURCE__';
parcelRegister("3VFxT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dc6ec112ae0eb93$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfbyn;
    function $2dc6ec112ae0eb93$export$2e2bcd8739ae039(_ref) {
        let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
        const emit = (0, (0, parcelRequire("lfbyn")).default)();
        const emitPointerMove = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointermove', event, source, datum), [
            emit,
            source
        ]);
        const emitPointerOut = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerout', event, source), [
            emit,
            source
        ]);
        const emitPointerUp = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerup', event, source), [
            emit,
            source
        ]);
        const emitPointerDown = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointerdown', event, source, datum), [
            emit,
            source
        ]);
        const emitFocus = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('focus', event, source), [
            emit,
            source
        ]);
        const emitBlur = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('blur', event, source), [
            emit,
            source
        ]);
        return {
            onPointerMove: onPointerMove ? emitPointerMove : undefined,
            onFocus: onFocus ? emitFocus : undefined,
            onBlur: onBlur ? emitBlur : undefined,
            onPointerOut: onPointerOut ? emitPointerOut : undefined,
            onPointerUp: onPointerUp ? emitPointerUp : undefined,
            onPointerDown: onPointerDown ? emitPointerDown : undefined
        };
    }
});
parcelRegister("6MKTx", function(module, exports) {
    $parcel$export(module.exports, "PureDonutChart", ()=>$4f0b9a1741a5e453$export$d983777419d59151);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ZuYc;
    var $2OPEf;
    var $3fYJX;
    var $9ZCPf;
    var $fO4qI;
    var $lFJ6b;
    var $5LUa1;
    var $gT017;
    var $lbM48;
    var $c9FTW;
    var $kRW1r;
    var $19KuE;
    var $2OMIu = parcelRequire("2OMIu");
    function $4f0b9a1741a5e453$var$useAccessors(_ref) {
        let { valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor } = _ref;
        const [value, label, color] = (0, $5uXOq.useMemo)(()=>{
            const [v] = (0, (0, parcelRequire("fO4qI")).useSafeAccessors)(valueAccessor);
            const [l] = (0, (0, parcelRequire("fO4qI")).useSafeAccessors)(labelAccessor);
            const [c] = (0, (0, parcelRequire("fO4qI")).useSafeAccessors)(colorAccessor);
            return [
                v,
                l,
                c
            ];
        }, [
            valueAccessor,
            labelAccessor,
            colorAccessor
        ]);
        return {
            value: value,
            label: label,
            color: color
        };
    }
    function $4f0b9a1741a5e453$export$d983777419d59151(_ref2) {
        let { data: data, width: width, height: height, innerRadius: userInnerRadius, outerRadius: userOuterRadius, margin: margin = (0, (0, parcelRequire("lFJ6b")).DEFAULT_MARGIN), valueAccessor: valueAccessor, colorAccessor: colorAccessor, labelAccessor: labelAccessor, svgRef: svgRef } = _ref2;
        const layoutProps = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("2OPEf")).Layout));
        const { value: value, label: label, color: color } = $4f0b9a1741a5e453$var$useAccessors({
            valueAccessor: valueAccessor,
            labelAccessor: labelAccessor,
            colorAccessor: colorAccessor
        });
        const plotHeight = Math.max(0, height - (margin.top + margin.bottom));
        const plotWidth = Math.max(0, width - (margin.left + margin.right));
        const outerRadius = userOuterRadius || Math.min(plotHeight || 0, plotWidth || 0) / 2;
        const innerRadius = userInnerRadius !== undefined ? userInnerRadius : outerRadius / 1.3;
        const calculateHeight = layoutProps.height == null && layoutProps.width != null;
        const fixedHeight = calculateHeight ? `${plotWidth}px` : '100%';
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("19KuE")).DonutDataProvider), {
            data: data,
            width: plotWidth,
            height: plotHeight,
            valueAccessor: value,
            labelAccessor: label,
            colorAccessor: color,
            margin: margin,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("gT017")).DonutLegend), {}),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("3fYJX")).default), {
                    innerRef: svgRef,
                    height: fixedHeight,
                    children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("9ZCPf")).default), {
                        children: [
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("lbM48")).DonutPatterns), {}),
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("c9FTW")).DonutStackSlot), {})
                        ]
                    })
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("5LUa1")).DataTable), {}),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("kRW1r")).DonutTooltip), {})
            ]
        });
    }
});
parcelRegister("3fYJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25f1e3917ef986ed$export$2e2bcd8739ae039);
    var $bwpsq;
    var $1xLej;
    var $2OMIu = parcelRequire("2OMIu");
    var $25f1e3917ef986ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1xLej")).element)(function Plot(_ref) {
        let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $2OMIu.jsx)("svg", {
                ref: innerRef,
                width: width,
                height: height,
                transform: transform || `translate(${left}, ${top})`,
                ...restProps,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
                ]),
                children: children
            })
        });
    });
});
parcelRegister("fO4qI", function(module, exports) {
    $parcel$export(module.exports, "useSafeAccessors", ()=>$b81ef6354b1c1aaa$export$1ff31c13ab3c61e1);
    $parcel$export(module.exports, "getFirstItem", ()=>$b81ef6354b1c1aaa$export$fbdeaa6a76694f71);
    $parcel$export(module.exports, "getSecondItem", ()=>$b81ef6354b1c1aaa$export$18f9732b2021233c);
    function $b81ef6354b1c1aaa$export$227cf200245550ef(accessor) {
        if (typeof accessor === 'string') {
            function s(d) {
                try {
                    return d[accessor];
                } catch  {
                    return 0;
                }
            }
            return s;
        } else if (typeof accessor === 'number') {
            function s1(d) {
                try {
                    return d[accessor];
                } catch  {
                    return 0;
                }
            }
            return s1;
        }
        function s2(d) {
            try {
                return accessor instanceof Function ? accessor(d) : 0;
            } catch  {
                return 0;
            }
        }
        return s2;
    }
    function $b81ef6354b1c1aaa$export$1ff31c13ab3c61e1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.map((d)=>$b81ef6354b1c1aaa$export$227cf200245550ef(d));
    }
    function $b81ef6354b1c1aaa$export$3a667a3b7e4d6701(l) {
        return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
    }
    function $b81ef6354b1c1aaa$export$337238c011325465(l) {
        return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
    }
    function $b81ef6354b1c1aaa$export$dd2b6e807fb37ba3(l) {
        return l === null || l === void 0 ? void 0 : l.source;
    }
    function $b81ef6354b1c1aaa$export$c22522a4dfa48e9c(l) {
        return l === null || l === void 0 ? void 0 : l.target;
    }
    function $b81ef6354b1c1aaa$export$fbdeaa6a76694f71(d) {
        return d === null || d === void 0 ? void 0 : d[0];
    }
    function $b81ef6354b1c1aaa$export$18f9732b2021233c(d) {
        return d === null || d === void 0 ? void 0 : d[1];
    }
});
parcelRegister("lFJ6b", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_MARGIN", ()=>$fc7068f7f891b7c6$export$6475e56bfff61883);
    $parcel$export(module.exports, "STACK_GAP", ()=>$fc7068f7f891b7c6$export$56b61e27223adae9);
    $parcel$export(module.exports, "CORNER_RADIUS_VALUE", ()=>$fc7068f7f891b7c6$export$a15d94c34ecbca08);
    const $fc7068f7f891b7c6$export$6475e56bfff61883 = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    };
    const $fc7068f7f891b7c6$export$601d4a48e295711b = 150;
    const $fc7068f7f891b7c6$export$56b61e27223adae9 = 1;
    const $fc7068f7f891b7c6$export$4d00931646175b35 = 2;
    const $fc7068f7f891b7c6$export$a15d94c34ecbca08 = {
        SMALL: 2,
        MEDIUM: 4,
        LARGE: 8,
        NONE: 0
    };
});
parcelRegister("5LUa1", function(module, exports) {
    $parcel$export(module.exports, "DataTable", ()=>$433ce7e23219ab53$export$df30df7ec97b32b5);
    var $5uXOq = parcelRequire("5uXOq");
    var $dBbYh;
    var $19KuE;
    var $2OMIu = parcelRequire("2OMIu");
    const $433ce7e23219ab53$var$LazyDataTableModal = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("4Yvz8"))).then((module)=>({
                default: module.DataTableModal
            })));
    function $433ce7e23219ab53$export$df30df7ec97b32b5() {
        const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, (0, parcelRequire("dBbYh")).useMenuData)();
        const { data: data } = (0, (0, parcelRequire("19KuE")).useDonutData)();
        return showDataTable ? (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: (0, $2OMIu.jsx)("div", {
                style: {
                    visibility: 'hidden'
                }
            }),
            children: (0, $2OMIu.jsx)($433ce7e23219ab53$var$LazyDataTableModal, {
                data: data,
                closeModal: closeDataTable
            })
        }) : null;
    }
});
parcelRegister("19KuE", function(module, exports) {
    $parcel$export(module.exports, "DonutDataProvider", ()=>$0d7ab25958c047fa$export$201ee326cc161324);
    $parcel$export(module.exports, "useDonutData", ()=>$0d7ab25958c047fa$export$570f964a43ebb08);
    var $5uXOq = parcelRequire("5uXOq");
    var $dBbYh;
    var $gUvRg;
    var $8Yq1M;
    var $2OMIu = parcelRequire("2OMIu");
    const $0d7ab25958c047fa$var$DataContext = (0, $5uXOq.createContext)({});
    function $0d7ab25958c047fa$export$201ee326cc161324(_ref) {
        let { children: children, ...props } = _ref;
        const { showPatterns: showPatterns } = (0, (0, parcelRequire("dBbYh")).useMenuData)();
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("gUvRg")).Theme), {
            fillStyles: (0, (0, parcelRequire("gUvRg")).DEFAULT_ORDINAL_COLORS),
            enableDefaultPatterns: showPatterns,
            useThemeFillStyles: (0, (0, parcelRequire("gUvRg")).useThemeFillStyles),
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("8Yq1M")).DonutScalesElement), {
                ...props,
                children: (scales)=>(0, $2OMIu.jsx)($0d7ab25958c047fa$var$DataContext.Provider, {
                        value: {
                            ...props,
                            ...scales
                        },
                        children: children
                    })
            })
        });
    }
    function $0d7ab25958c047fa$export$570f964a43ebb08() {
        return (0, $5uXOq.useContext)($0d7ab25958c047fa$var$DataContext);
    }
});
parcelRegister("gT017", function(module, exports) {
    $parcel$export(module.exports, "DonutLegend", ()=>$c4b1cbcc910271de$export$bd81b761982512ab);
    var $jogiL;
    var $19KuE;
    var $2OMIu = parcelRequire("2OMIu");
    function $c4b1cbcc910271de$export$bd81b761982512ab() {
        const { data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, colorScale: colorScale } = (0, (0, parcelRequire("19KuE")).useDonutData)();
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("jogiL")).OrdinalLegend), {
            shape: "circle",
            data: data,
            colorScale: colorScale,
            colorAccessor: colorAccessor,
            labelAccessor: labelAccessor,
            justifyContent: 'center'
        });
    }
});
parcelRegister("lbM48", function(module, exports) {
    $parcel$export(module.exports, "DonutPatterns", ()=>$f6cfe8eb87dbbb52$export$bbefc336dd56edb0);
    var $gXw8D;
    var $9ZuYc;
    var $dBbYh;
    var $gUvRg;
    var $2OMIu = parcelRequire("2OMIu");
    const $f6cfe8eb87dbbb52$export$bbefc336dd56edb0 = ()=>{
        const { patternDefs: patternDefs } = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("gXw8D")).default).elements.Theme);
        const { showPatterns: showPatterns } = (0, (0, parcelRequire("dBbYh")).useMenuData)();
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: showPatterns ? (0, (0, parcelRequire("gUvRg")).DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
        });
    };
});
parcelRegister("c9FTW", function(module, exports) {
    $parcel$export(module.exports, "DonutStackSlot", ()=>$8d96d40a829d3e8b$export$24ce8a819edcba7b);
    var $1xLej;
    var $9ZuYc;
    var $2OPEf;
    var $9ZCPf;
    var $19KuE;
    var $dcCcf;
    var $dFdp9;
    var $dwEoN;
    var $8aZwB;
    var $iATZD;
    var $2OMIu = parcelRequire("2OMIu");
    const $8d96d40a829d3e8b$export$8874d6b2a9285ec0 = (0, (0, parcelRequire("1xLej")).element)(function DonutStack(_ref) {
        let { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, transform: transform } = _ref;
        const arcs = (0, (0, parcelRequire("iATZD")).default)(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("9ZCPf")).default), {
            transform: transform,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("dwEoN")).DonutMarks), {
                    arcs: arcs,
                    labelAccessor: labelAccessor
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("dFdp9")).DonutMarkLabels), {
                    arcs: arcs,
                    hide: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("dcCcf")).DonutMetric), {
                    data: data,
                    valueAccessor: valueAccessor,
                    innerRadius: innerRadius,
                    hide: false
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("8aZwB")).DonutTooltipOverlay), {
                    arcs: arcs
                })
            ]
        });
    });
    function $8d96d40a829d3e8b$export$24ce8a819edcba7b() {
        const { data: data, valueAccessor: valueAccessor, labelAccessor: labelAccessor, colorAccessor: colorAccessor, colorScale: colorScale, innerRadius: innerRadius, outerRadius: outerRadius, width: width, height: height } = (0, (0, parcelRequire("19KuE")).useDonutData)();
        const layoutProps = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("2OPEf")).Layout));
        const sideBySide = false;
        const transform = `translate(${sideBySide ? width - outerRadius : width / 2},${height / 2})`;
        return (0, $2OMIu.jsx)($8d96d40a829d3e8b$export$8874d6b2a9285ec0, {
            data: data,
            valueAccessor: valueAccessor,
            labelAccessor: labelAccessor,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            transform: transform
        });
    }
});
parcelRegister("iATZD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d89705dd8da899a1$export$2e2bcd8739ae039);
    var $hjll3 = parcelRequire("hjll3");
    function $d89705dd8da899a1$var$getStackArcs(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius) {
        const pie = (0, $hjll3.pie)().value(valueAccessor).sort(null);
        const arcs = pie(data);
        const stackArcs = arcs.map((arc)=>({
                key: labelAccessor(arc.data),
                ariaLabel: `${labelAccessor(arc.data)}, ${valueAccessor(arc.data)}`,
                innerRadius: innerRadius !== undefined && innerRadius < 1 ? 1 : innerRadius,
                outerRadius: outerRadius,
                startAngle: arc.startAngle,
                endAngle: arc.endAngle,
                padAngle: 0.01,
                fill: colorScale(colorAccessor(arc.data)),
                value: valueAccessor(arc.data),
                data: arc.data
            }));
        return stackArcs;
    }
    var $d89705dd8da899a1$export$2e2bcd8739ae039 = $d89705dd8da899a1$var$getStackArcs;
});
parcelRegister("kRW1r", function(module, exports) {
    $parcel$export(module.exports, "DonutTooltip", ()=>$f315c3ea6f65b130$export$9aab0b7a42ef8058);
    var $5uXOq = parcelRequire("5uXOq");
    var $dYSV3;
    var $8upbu;
    var $19KuE;
    var $2OMIu = parcelRequire("2OMIu");
    function $f315c3ea6f65b130$export$9aab0b7a42ef8058() {
        const { colorAccessor: colorAccessor, colorScale: colorScale, valueAccessor: valueAccessor, labelAccessor: labelAccessor } = (0, (0, parcelRequire("19KuE")).useDonutData)();
        const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, (0, parcelRequire("dYSV3")).default));
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("8upbu")).SingleSeriesTooltip), {
            tooltipData: tooltipData,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            valueAccessor: valueAccessor,
            labelAccessor: labelAccessor
        });
    }
});
parcelRegister("cJzGZ", function(module, exports) {
    $parcel$export(module.exports, "CustomLayout", ()=>$8694d14500f81c5e$export$38801bd36eb3c5d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gXw8D;
    var $1xLej;
    var $9ZuYc;
    const $8694d14500f81c5e$var$layoutStyles = null;
    const $8694d14500f81c5e$var$chartStyles = null;
    const $8694d14500f81c5e$export$38801bd36eb3c5d0 = (0, (0, parcelRequire("1xLej")).element)(()=>{
        const { children: children, width: width, height: height } = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("gXw8D")).default).elements.Layout);
        const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const ref = window.requestAnimationFrame(()=>{
                if (isMounted) setFadeInOpacity(1);
            });
            return ()=>{
                isMounted = false;
                window.cancelAnimationFrame(ref);
            };
        }, [
            setFadeInOpacity
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi _bfhkvuon"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-element": "chart",
            style: {
                opacity: fadeInOpacity
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1ul9idpf _1tkeidpf _16jlidpf _2lx21sxn _v56414fr _zulp1ejb"
            ])
        }, children)));
    }, {
        as: (0, (0, parcelRequire("gXw8D")).default).elements.Layout
    });
});
parcelRegister("8XQi0", function(module, exports) {
    $parcel$export(module.exports, "CustomLegend", ()=>$d28fdcdb2bc53ce9$export$502a55a813e9c262);
    var $5uXOq = parcelRequire("5uXOq");
    var $gXw8D;
    var $1xLej;
    var $9ZuYc;
    const $d28fdcdb2bc53ce9$export$502a55a813e9c262 = (0, (0, parcelRequire("1xLej")).element)(()=>{
        const { data: data } = (0, (0, parcelRequire("9ZuYc")).useElementProps)((0, (0, parcelRequire("gXw8D")).default).elements.Legend);
        data.sort((a, b)=>{
            if (a.label === 'Other') return 1;
            if (b.label === 'Other') return -1;
            return (a.value ?? 0) - (b.value ?? 0);
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXw8D")).default).elements.Legend, {
            data: data,
            maxRows: 10
        });
    }, {
        as: (0, (0, parcelRequire("gXw8D")).default).elements.Legend
    });
});
parcelRegister("7xWSv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04e59092817ccd1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $04e59092817ccd1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        centerTextLabel: {
            "id": "issue-field-statistics.single-select-chart-container.donut-chart.center-text-label",
            "defaultMessage": "Total"
        }
    });
});
parcelRegister("bI9TW", function(module, exports) {
    $parcel$export(module.exports, "HorizontalBarChart", ()=>$338813565f12cfb5$export$2d84115b1316e023);
    var $5uXOq = parcelRequire("5uXOq");
    var $181Rm;
    var $a3OZ0;
    var $c9rca;
    const $338813565f12cfb5$var$MAX_WIDTH = 600;
    const $338813565f12cfb5$export$2d84115b1316e023 = ({ data: data, width: initialWidth })=>{
        const width = Math.min(initialWidth, $338813565f12cfb5$var$MAX_WIDTH);
        data.sort((a, b)=>{
            if (a.label === 'Other') return -1;
            if (b.label === 'Other') return 1;
            return (a.value ?? 0) - (b.value ?? 0);
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("181Rm")).default), {
            data: data,
            width: width,
            yAccessor: (d)=>d.value,
            xAccessor: (d)=>d.label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9rca")).CustomLayout), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3OZ0")).CustomAxisLeftText), {
            sideBarWidth: width
        }));
    };
});
parcelRegister("181Rm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d27fb18a7b55403$export$2e2bcd8739ae039);
    var $epG85;
    var $hhESq;
    var $ft4EL;
    var $6nv1a;
    var $3KKAW;
    var $2OMIu = parcelRequire("2OMIu");
    function $0d27fb18a7b55403$export$2e2bcd8739ae039(_ref) {
        let { children: children, ...props } = _ref;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("epG85")).default), {
            ...props,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("hhESq")).BarGroupHorizontal), {}),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("3KKAW")).BarGroupHorizontalScalesElement), {}),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.TooltipOverlay, {
                    horizontal: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.TooltipEmitter, {
                    horizontal: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.Grid, {
                    rowLineStyle: "hidden",
                    columnLineStyle: "solid"
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.AxisLeftLine, {
                    hide: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.AxisLeftTick, {
                    hide: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.AxisBottomTick, {
                    hide: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("epG85")).default).elements.AxisBottomLine, {
                    hide: true
                }),
                children
            ]
        });
    }
    $0d27fb18a7b55403$export$2e2bcd8739ae039.elements = {
        ...(0, (0, parcelRequire("epG85")).default).elements,
        Scales: (0, (0, parcelRequire("3KKAW")).BarGroupHorizontalScalesElement),
        Marks: (0, (0, parcelRequire("6nv1a")).BarGroupHorizontalMarks).Component,
        MarkLabels: (0, (0, parcelRequire("ft4EL")).BarGroupHorizontalLabels).Component
    };
});
parcelRegister("epG85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7e4147ff34f7841$export$2e2bcd8739ae039);
    var $17PP9;
    var $lOXm0;
    var $hqZma;
    var $cXzUG;
    parcelRequire("lWVLr");
    var $7Nxvv;
    var $lWVLr;
    var $e2CtX;
    var $erST8;
    var $3B9ij;
    var $chU1I;
    var $PfPCm;
    var $iTGbP;
    var $cgmj2;
    var $doqD0;
    var $l6fAT;
    var $1Tf3y;
    var $lA40p;
    var $02ifK;
    var $e0UVN;
    var $2pOyr;
    var $arL7j;
    var $dwg9t;
    var $ggVTz;
    var $cKYPp;
    var $fAwZ6;
    var $2OMIu = parcelRequire("2OMIu");
    function $a7e4147ff34f7841$export$2e2bcd8739ae039(_ref) {
        let { width: width, height: height, data: data, children: children, ...restProps } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("17PP9")).ElementsProvider), {
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("e0UVN")).default), {
                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("PfPCm")).MenuProvider), {
                    children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("02ifK")).default), {
                        children: [
                            children,
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("lWVLr")).LayoutContainer), {
                                width: width,
                                height: height,
                                data: data,
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("e2CtX")).DimensionsWrapper), {
                                    children: (_ref2)=>{
                                        let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                        return (0, $2OMIu.jsx)((0, (0, parcelRequire("fAwZ6")).PureBarChart), {
                                            svgRef: plotSvgRef,
                                            height: plotHeight,
                                            width: plotWidth,
                                            margin: margin,
                                            data: data,
                                            ...restProps
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    $a7e4147ff34f7841$export$2e2bcd8739ae039.elements = {
        AxisLeft: (0, (0, parcelRequire("cXzUG")).AxisLeft).Component,
        AxisLeftText: (0, (0, parcelRequire("cXzUG")).AxisLeftText).Component,
        AxisLeftTick: (0, (0, parcelRequire("cXzUG")).AxisLeftTick).Component,
        AxisLeftLine: (0, (0, parcelRequire("cXzUG")).AxisLeftLine).Component,
        AxisBottom: (0, (0, parcelRequire("hqZma")).AxisBottom).Component,
        AxisBottomText: (0, (0, parcelRequire("hqZma")).AxisBottomText).Component,
        AxisBottomTick: (0, (0, parcelRequire("hqZma")).AxisBottomTick).Component,
        AxisBottomLine: (0, (0, parcelRequire("hqZma")).AxisBottomLine).Component,
        Grid: (0, (0, parcelRequire("erST8")).Grid).Component,
        Legend: (0, (0, parcelRequire("3B9ij")).OrdinalLegend).Component,
        Layout: (0, (0, parcelRequire("7Nxvv")).Layout).Component,
        Title: (0, (0, parcelRequire("l6fAT")).Title).Component,
        SubTitle: (0, (0, parcelRequire("doqD0")).Subtitle).Component,
        Marks: (0, (0, parcelRequire("dwg9t")).BarGroupMarks).Component,
        Mark: (0, (0, parcelRequire("iTGbP")).Bar).Component,
        MarkLabels: (0, (0, parcelRequire("arL7j")).BarGroupMarkLabels).Component,
        Scales: (0, (0, parcelRequire("ggVTz")).BarScalesElement).Component,
        Theme: (0, (0, parcelRequire("cgmj2")).Theme).Component,
        Tooltip: (0, (0, parcelRequire("2pOyr")).MultiSeriesTooltip).Component,
        TooltipHeader: (0, (0, parcelRequire("1Tf3y")).TooltipHeader).Component,
        TooltipRow: (0, (0, parcelRequire("lA40p")).TooltipRow).Component,
        TooltipOverlay: (0, (0, parcelRequire("cKYPp")).BarTooltipOverlayElement).Component,
        TooltipEmitter: (0, (0, parcelRequire("cKYPp")).BarTooltipOverlayEmitterElement).Component,
        Menu: (0, (0, parcelRequire("chU1I")).Menu).Component,
        DataTable: (0, (0, parcelRequire("lOXm0")).DataTable).Component
    };
});
parcelRegister("17PP9", function(module, exports) {
    $parcel$export(module.exports, "ElementsProvider", ()=>$0d1ea50b01d1ff20$export$71c0ba76abe92a7e);
    $parcel$export(module.exports, "useElements", ()=>$0d1ea50b01d1ff20$export$83d5c6859f2ae3df);
    $parcel$export(module.exports, "useElementProps", ()=>$0d1ea50b01d1ff20$export$8edbe6dd5606980);
    var $5uXOq = parcelRequire("5uXOq");
    var $2OMIu = parcelRequire("2OMIu");
    var $6cAn5 = parcelRequire("6cAn5");
    const $0d1ea50b01d1ff20$export$a92ee76f0b1f4e66 = (0, $5uXOq.createContext)(null);
    function $0d1ea50b01d1ff20$export$71c0ba76abe92a7e(_ref) {
        let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
        const ctx = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df();
        const value = (0, $5uXOq.useMemo)(()=>{
            const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
            const registeredOverrideComponents = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registeredOverrideComponents) || new Map();
            return {
                registry: registry,
                registeredOverrideComponents: registeredOverrideComponents,
                register: (kind, value)=>{
                    if (!registeredOverrideComponents.get(kind)) registeredOverrideComponents.set(kind, []);
                    const overrideComps = registeredOverrideComponents.get(kind) || [];
                    if (!overrideComps.includes(value.Component)) overrideComps.push(value.Component);
                    if (overrideComps[overrideComps.length - 1] === value.Component) registry.set(kind, value);
                },
                retrieve: (kind)=>registry.get(kind),
                isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
                getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
                getOuterProps: (k)=>{
                    var _registry$get;
                    return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
                }
            };
        }, [
            kind,
            defaultProps
        ]);
        return (0, $2OMIu.jsx)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66.Provider, {
            value: value,
            children: children
        });
    }
    const $0d1ea50b01d1ff20$export$83d5c6859f2ae3df = ()=>(0, $5uXOq.useContext)($0d1ea50b01d1ff20$export$a92ee76f0b1f4e66);
    function $0d1ea50b01d1ff20$export$8edbe6dd5606980(element, _temp) {
        var _process, _process$env, _useElements, _useElements2, _useElements3;
        let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
        if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
        if (((_process = $6cAn5) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
        return {
            ...(_useElements2 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
            ...(_useElements3 = $0d1ea50b01d1ff20$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
            ...mergeWith
        };
    }
});
parcelRegister("lOXm0", function(module, exports) {
    $parcel$export(module.exports, "DataTable", ()=>$fe2c4ef74d91a16f$export$df30df7ec97b32b5);
    $parcel$export(module.exports, "DataTableModal", ()=>$fe2c4ef74d91a16f$export$4717a7afeef78908);
    var $bwpsq;
    var $42CjB;
    var $k3qRI;
    var $lLLkM;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $bT1Sw;
    var $l6fAT;
    var $ltC0t;
    var $2OMIu = parcelRequire("2OMIu");
    const $fe2c4ef74d91a16f$var$gridStyles = null;
    const $fe2c4ef74d91a16f$export$a8a28302b48950e6 = null;
    function $fe2c4ef74d91a16f$var$getHeaders(headers) {
        const cellHeaders = headers.map((header)=>({
                key: header,
                content: (0, (0, parcelRequire("ltC0t")).toSentenceCase)(header),
                isSortable: true
            }));
        return {
            cells: cellHeaders
        };
    }
    function $fe2c4ef74d91a16f$var$getRows(data) {
        if (!data.length) {
            const keys = Object.keys(data);
            const rowData = keys.map((k)=>{
                var _data;
                const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
                return {
                    key: cellData,
                    content: cellData
                };
            });
            return [
                {
                    key: 'row-0',
                    cells: rowData
                }
            ];
        }
        const rows = data.map((d, i)=>{
            const keys = Object.keys(d);
            const rowData = keys.map((k)=>{
                var _d$k;
                const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
                return {
                    key: cellData,
                    content: cellData
                };
            });
            return {
                key: `row-${i}`,
                cells: rowData
            };
        });
        return rows;
    }
    function $fe2c4ef74d91a16f$export$84cbf2d941927b3b(_ref) {
        let { data: data, headers: userDefinedHeaders } = _ref;
        if (!data || Array.isArray(data) && data.length === 0) return null;
        const headers = userDefinedHeaders ? $fe2c4ef74d91a16f$var$getHeaders(userDefinedHeaders) : data && $fe2c4ef74d91a16f$var$getHeaders(Object.keys(data[0]));
        const rows = $fe2c4ef74d91a16f$var$getRows(data);
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih1gjq _1ouib76v _cnoh16g6 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"
            ]),
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("k3qRI")).default), {
                head: headers,
                rows: rows,
                rowsPerPage: 10,
                defaultPage: 1,
                loadingSpinnerSize: "large"
            })
        });
    }
    const $fe2c4ef74d91a16f$export$df30df7ec97b32b5 = (0, (0, parcelRequire("bT1Sw")).element)($fe2c4ef74d91a16f$export$84cbf2d941927b3b);
    function $fe2c4ef74d91a16f$export$4717a7afeef78908(_ref2) {
        let { data: data, closeModal: closeModal } = _ref2;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: closeModal,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("jgVsb")).default), {
                    children: (0, $2OMIu.jsxs)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"
                        ]),
                        children: [
                            (0, $2OMIu.jsx)("div", {
                                className: (0, (0, parcelRequire("bwpsq")).default)([
                                    "_1bahh9n0 _nd5l1bvj"
                                ]),
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("42CjB")).default), {
                                    appearance: "subtle",
                                    icon: (0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))),
                                    label: "Close Modal",
                                    onClick: closeModal
                                })
                            }),
                            (0, $2OMIu.jsx)("div", {
                                className: (0, (0, parcelRequire("bwpsq")).default)([
                                    "_1bahv2br _nd5l1cy2"
                                ]),
                                children: (0, $2OMIu.jsx)((0, (0, parcelRequire("l6fAT")).Title), {})
                            })
                        ]
                    })
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("7QSqG")).default), {
                    children: (0, $2OMIu.jsx)($fe2c4ef74d91a16f$export$df30df7ec97b32b5, {
                        data: data
                    })
                })
            ]
        });
    }
});
parcelRegister("bT1Sw", function(module, exports) {
    $parcel$export(module.exports, "element", ()=>$8a7649c186b65558$export$8454457683f90105);
    var $17PP9;
    var $2OMIu = parcelRequire("2OMIu");
    function $8a7649c186b65558$export$8454457683f90105(DefaultComponent, options) {
        var _options$as;
        if (options === void 0) options = {};
        const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
        const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
        if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
        const ElementComponent = (outerProps)=>{
            const ctx = (0, (0, parcelRequire("17PP9")).useElements)();
            if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
            if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return (0, $2OMIu.jsx)(DefaultComponent, {
                ...!options.as && ctx.getProps(kind),
                ...outerProps
            });
            else {
                ctx.register(kind, {
                    Component: DefaultComponent,
                    outerProps: outerProps
                });
                return null;
            }
        };
        ElementComponent.kind = kind;
        if (options.as) return ElementComponent;
        const ElementSlot = (defaultProps)=>{
            const ctx = (0, (0, parcelRequire("17PP9")).useElements)();
            const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
            const isSelf = Component === DefaultComponent;
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("17PP9")).ElementsProvider), {
                kind: kind,
                defaultProps: defaultProps,
                children: (0, $2OMIu.jsx)(Component, {
                    ...isSelf && defaultProps,
                    ...outerProps
                })
            });
        };
        ElementSlot.kind = kind;
        ElementSlot.Component = ElementComponent;
        ElementSlot.displayName = `element(${displayName})`;
        return ElementSlot;
    }
});
parcelRegister("l6fAT", function(module, exports) {
    $parcel$export(module.exports, "Title", ()=>$f5c641277358ed4b$export$f99233281efd08a0);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $f5c641277358ed4b$var$titleTextStyle = null;
    function $f5c641277358ed4b$var$Title(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("h2", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _k48pni7l _zg8l4jg8 _ect4e86e _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt461nu"
            ]),
            children: children
        });
    }
    const $f5c641277358ed4b$export$f99233281efd08a0 = (0, (0, parcelRequire("bT1Sw")).element)($f5c641277358ed4b$var$Title);
});
parcelRegister("ltC0t", function(module, exports) {
    $parcel$export(module.exports, "toSentenceCase", ()=>$fa29c9baa9a7a709$export$dcbb097fa84257c1);
    $parcel$export(module.exports, "default", ()=>$fa29c9baa9a7a709$export$2e2bcd8739ae039);
    var $hjll3 = parcelRequire("hjll3");
    const $fa29c9baa9a7a709$var$formatNumberAbbreviated = (value)=>{
        if (value === null) return 'null';
        let numberValue;
        if (typeof value === 'string') {
            const parsedValue = Number(value);
            if (isNaN(parsedValue)) return value;
            numberValue = parsedValue;
        } else numberValue = value;
        return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            compactDisplay: 'short'
        }).format(numberValue);
    };
    const $fa29c9baa9a7a709$var$percentChange = (currentValue, previousValue)=>{
        if (previousValue === 0) return (currentValue * 100).toFixed();
        return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
    };
    const $fa29c9baa9a7a709$var$formatMillisecond = (0, $hjll3.timeFormat)('.%L'), $fa29c9baa9a7a709$var$formatSecond = (0, $hjll3.timeFormat)(':%S'), $fa29c9baa9a7a709$var$formatMinute = (0, $hjll3.timeFormat)('%I:%M'), $fa29c9baa9a7a709$var$formatHour = (0, $hjll3.timeFormat)('%I %p'), $fa29c9baa9a7a709$var$formatDay = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatWeek = (0, $hjll3.timeFormat)('%b %d'), $fa29c9baa9a7a709$var$formatMonth = (0, $hjll3.timeFormat)('%b'), $fa29c9baa9a7a709$var$formatYear = (0, $hjll3.timeFormat)('%Y');
    function $fa29c9baa9a7a709$export$16cec29b78b14126(date) {
        return ((0, $hjll3.timeSecond)(date) < date ? $fa29c9baa9a7a709$var$formatMillisecond : (0, $hjll3.timeMinute)(date) < date ? $fa29c9baa9a7a709$var$formatSecond : (0, $hjll3.timeHour)(date) < date ? $fa29c9baa9a7a709$var$formatMinute : (0, $hjll3.timeDay)(date) < date ? $fa29c9baa9a7a709$var$formatHour : (0, $hjll3.timeMonth)(date) < date ? (0, $hjll3.timeWeek)(date) < date ? $fa29c9baa9a7a709$var$formatDay : $fa29c9baa9a7a709$var$formatWeek : (0, $hjll3.timeYear)(date) < date ? $fa29c9baa9a7a709$var$formatMonth : $fa29c9baa9a7a709$var$formatYear)(date);
    }
    function $fa29c9baa9a7a709$export$dcbb097fa84257c1(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    var $fa29c9baa9a7a709$export$2e2bcd8739ae039 = {
        formatNumberAbbreviated: $fa29c9baa9a7a709$var$formatNumberAbbreviated,
        percentChange: $fa29c9baa9a7a709$var$percentChange,
        multiTimeFormat: $fa29c9baa9a7a709$export$16cec29b78b14126,
        toSentenceCase: $fa29c9baa9a7a709$export$dcbb097fa84257c1
    };
});
parcelRegister("hqZma", function(module, exports) {
    $parcel$export(module.exports, "AxisBottomTick", ()=>$cb1475830d00691d$export$34bea378c04af713);
    $parcel$export(module.exports, "AxisBottomLine", ()=>$cb1475830d00691d$export$84b05a0ae8b61ab5);
    $parcel$export(module.exports, "AxisBottomText", ()=>$cb1475830d00691d$export$ebfad67a29d89d08);
    $parcel$export(module.exports, "AxisBottom", ()=>$cb1475830d00691d$export$deea0fad05dcb466);
    var $bwpsq;
    var $bT1Sw;
    var $eFK63;
    var $jxg43;
    var $42C9W;
    var $f8uii;
    var $da7Ww;
    var $l5ab7;
    var $2vbO1;
    var $kq3PX;
    var $2OMIu = parcelRequire("2OMIu");
    const $cb1475830d00691d$export$cd0785a309729df9 = {
        color: "var(--ds-text-subtlest, grey)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: 12,
        textAlign: 'center'
    };
    const $cb1475830d00691d$var$tickLength = 8;
    const $cb1475830d00691d$var$orientation = (0, (0, parcelRequire("jxg43")).default).bottom;
    const $cb1475830d00691d$export$34bea378c04af713 = (0, (0, parcelRequire("bT1Sw")).element)((0, (0, parcelRequire("l5ab7")).Tick));
    const $cb1475830d00691d$export$84b05a0ae8b61ab5 = (0, (0, parcelRequire("bT1Sw")).element)((_ref)=>{
        let { width: width, top: top, hide: hide } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("da7Ww")).AxisLine), {
            hide: hide,
            style: {
                borderBottom: `${(0, (0, parcelRequire("da7Ww")).axisLineStroke)} solid 2px`,
                width: `${width}px`,
                position: 'absolute',
                top: `${top}px`
            }
        });
    });
    const $cb1475830d00691d$export$ebfad67a29d89d08 = (0, (0, parcelRequire("bT1Sw")).element)((_ref2)=>{
        let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children, transform: transform } = _ref2;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("2vbO1")).TickText), {
            style: {
                width: width,
                transform: transform
            },
            formatter: formatter,
            truncate: truncate,
            singleline: singleline,
            children: children
        });
    });
    function $cb1475830d00691d$var$AxisBottom(_ref3) {
        let { scale: scale, numTicks: numTicks, tickValues: tickValues, top: top, left: left, rangePadding: rangePadding, hideZero: hideZero, label: label, hide: hide } = _ref3;
        if (hide) return null;
        const { ticks: ticks } = (0, (0, parcelRequire("kq3PX")).useAxisTicks)({
            scale: scale,
            numTicks: numTicks,
            tickValues: tickValues,
            orientation: $cb1475830d00691d$var$orientation,
            rangePadding: rangePadding,
            hideZero: hideZero,
            tickLength: $cb1475830d00691d$var$tickLength
        });
        const TickTextsComponent = ticks.map((_ref4)=>{
            let { value: value, index: index, from: from, to: to } = _ref4;
            const formatter = (0, (0, parcelRequire("f8uii")).default)(scale);
            return (0, $2OMIu.jsx)("div", {
                style: {
                    left: `${to.x}px`
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_yyhykb7n _1ii7kb7n _kqswh2mm _1bsbidpf _syaz13nv _ect41wi2 _1wyb1crf _y3gn1h6o"
                ]),
                children: (0, $2OMIu.jsx)($cb1475830d00691d$export$ebfad67a29d89d08, {
                    width: Number(scale.range()[1]) / ticks.length,
                    formatter: formatter,
                    truncate: (0, (0, parcelRequire("42C9W")).default)(scale) === 'string',
                    transform: "translateX(-50%)",
                    children: value
                })
            }, `axis-bottom-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
        });
        return (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                (0, $2OMIu.jsx)("div", {
                    style: {
                        gridArea: 'plot'
                    },
                    children: (0, $2OMIu.jsx)($cb1475830d00691d$export$84b05a0ae8b61ab5, {
                        width: left,
                        top: top
                    })
                }),
                (0, $2OMIu.jsxs)("div", {
                    style: {
                        gridArea: 'axis-bottom',
                        display: 'grid',
                        gridTemplateRows: 'auto min-content'
                    },
                    "data-axis-type": "axis-bottom",
                    children: [
                        (0, $2OMIu.jsx)("div", {
                            className: (0, (0, parcelRequire("bwpsq")).default)([
                                "_1e0c11p5 _yv0ehkll _2z05hkll _ca0q1crf _lcxvglyw"
                            ]),
                            children: TickTextsComponent
                        }),
                        label && (0, $2OMIu.jsx)("div", {
                            style: {
                                paddingTop: '8px',
                                width: '100%',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                ...(0, (0, parcelRequire("eFK63")).defaultTextHTMLProps)
                            },
                            children: label
                        })
                    ]
                })
            ]
        });
    }
    const $cb1475830d00691d$export$deea0fad05dcb466 = (0, (0, parcelRequire("bT1Sw")).element)($cb1475830d00691d$var$AxisBottom);
});
parcelRegister("eFK63", function(module, exports) {
    $parcel$export(module.exports, "defaultTextHTMLProps", ()=>$aae8a6d9dacb0080$export$51ee3858fd381684);
    const $aae8a6d9dacb0080$export$554ff5554bedd348 = {
        textAnchor: 'middle',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: 12,
        color: "var(--ds-text-subtlest, lightgrey)"
    };
    const $aae8a6d9dacb0080$export$51ee3858fd381684 = {
        textAlign: 'center',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: 12,
        color: "var(--ds-text-subtlest, lightgrey)"
    };
});
parcelRegister("jxg43", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e38d8f70dd0cbed6$export$2e2bcd8739ae039);
    const $e38d8f70dd0cbed6$var$Orientation = {
        top: 'top',
        left: 'left',
        right: 'right',
        bottom: 'bottom'
    };
    var $e38d8f70dd0cbed6$export$2e2bcd8739ae039 = $e38d8f70dd0cbed6$var$Orientation;
});
parcelRegister("42C9W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f14f2f7f7ffed93$export$2e2bcd8739ae039);
    function $2f14f2f7f7ffed93$export$2e2bcd8739ae039(scale) {
        const domainValues = scale.domain();
        if (domainValues.length === 0) return 'string';
        if (domainValues[0] instanceof Date || domainValues[domainValues.length - 1] instanceof Date) return 'time';
        else if (typeof domainValues[0] === 'number') return 'number';
        else return 'string';
    }
});
parcelRegister("f8uii", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b04f1a26b98e19d6$export$2e2bcd8739ae039);
    var $ltC0t;
    function $b04f1a26b98e19d6$export$2e2bcd8739ae039(scale) {
        const s = scale;
        if (scale.domain()[0] instanceof Date || scale.domain()[1] instanceof Date) return (0, (0, parcelRequire("ltC0t")).default).multiTimeFormat;
        else if ('tickFormat' in s) return (0, (0, parcelRequire("ltC0t")).default).formatNumberAbbreviated;
        return String;
    }
});
parcelRegister("da7Ww", function(module, exports) {
    $parcel$export(module.exports, "axisLineStroke", ()=>$99525ed62f9828e4$export$1b23eda9d50a8331);
    $parcel$export(module.exports, "AxisLine", ()=>$99525ed62f9828e4$export$6b38ce563ca3e26b);
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $99525ed62f9828e4$export$1b23eda9d50a8331 = "var(--ds-border-bold, lightgrey)";
    const $99525ed62f9828e4$export$6b38ce563ca3e26b = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        const { style: style, hide: hide } = props;
        if (hide) return null;
        return (0, $2OMIu.jsx)("div", {
            style: style
        });
    });
});
parcelRegister("l5ab7", function(module, exports) {
    $parcel$export(module.exports, "Tick", ()=>$f591f5cc8874127e$export$b1778e7c62739fdb);
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $f591f5cc8874127e$var$tickStroke = "var(--ds-border-bold, lightgrey)";
    const $f591f5cc8874127e$var$TICK_LENGTH = 8;
    const $f591f5cc8874127e$var$STROKE_WIDTH = 1;
    const $f591f5cc8874127e$export$b1778e7c62739fdb = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        const { from: from, to: to, hide: hide } = props;
        const isHorizontal = (from === null || from === void 0 ? void 0 : from.y) === (to === null || to === void 0 ? void 0 : to.y);
        if (hide) return null;
        const border = isHorizontal ? {
            borderBottom: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
        } : {
            borderLeft: `${$f591f5cc8874127e$var$STROKE_WIDTH}px solid ${$f591f5cc8874127e$var$tickStroke}`
        };
        return (0, $2OMIu.jsx)("div", {
            style: {
                ...border,
                width: isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
                height: !isHorizontal ? $f591f5cc8874127e$var$TICK_LENGTH : 0,
                position: 'absolute',
                top: `calc(${to === null || to === void 0 ? void 0 : to.y}px)`,
                left: `calc(${from === null || from === void 0 ? void 0 : from.x}px)`,
                transform: isHorizontal ? `translateX(-${$f591f5cc8874127e$var$TICK_LENGTH}px)` : ``
            }
        });
    });
});
parcelRegister("2vbO1", function(module, exports) {
    $parcel$export(module.exports, "TickText", ()=>$1d27a2655db0185a$export$d3f6b56e9fbffff3);
    var $3bDjY;
    var $hjll3 = parcelRequire("hjll3");
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $1d27a2655db0185a$var$TRUNCATE_STYLES = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
    const $1d27a2655db0185a$export$d3f6b56e9fbffff3 = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        const { formatter: formatter, style: style, truncate: truncate, singleline: singleline, children: children } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const truncateStyles = truncate ? $1d27a2655db0185a$var$TRUNCATE_STYLES : {};
        const tickContent = typeof formatter === 'function' ? formatter(children) : (0, $hjll3.timeFormat)(formatter)(children);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("3bDjY")).default), {
            tag: 'div',
            position: "bottom",
            content: tickContent,
            canAppear: ()=>{
                const element = ref.current;
                if (!element) return false;
                return element.offsetWidth < element.scrollWidth;
            },
            children: (0, $2OMIu.jsx)("div", {
                ref: ref,
                style: {
                    ...style,
                    ...truncateStyles,
                    pointerEvents: 'auto'
                },
                children: (0, $2OMIu.jsx)("span", {
                    children: tickContent
                })
            })
        });
    });
});
parcelRegister("kq3PX", function(module, exports) {
    $parcel$export(module.exports, "useAxisTicks", ()=>$edd9364b3322512a$export$b1d0fead756358a0);
    var $cMo1a;
    var $eOdM1;
    var $elPt5;
    var $2YVVm;
    var $jxg43;
    var $8LERT;
    var $4ZQLi;
    function $edd9364b3322512a$export$b1d0fead756358a0(_ref) {
        let { scale: scale, numTicks: numTicks, tickValues: tickValues, tickLength: tickLength, orientation: orientation, hideZero: hideZero = false } = _ref;
        const isLeft = orientation === (0, (0, parcelRequire("jxg43")).default).left;
        const isTop = orientation === (0, (0, parcelRequire("jxg43")).default).top;
        const horizontal = isTop || orientation === (0, (0, parcelRequire("jxg43")).default).bottom;
        const tickPosition = (0, (0, parcelRequire("4ZQLi")).default)(scale);
        const tickSign = isLeft || isTop ? -1 : 1;
        const range = scale.range();
        const scaleType = (0, (0, parcelRequire("elPt5")).default)(scale);
        const isNumeric = scaleType === 'linear' || scaleType === 'log';
        const tempCalcTicks = Math.round(Math.abs((range[1] || 1) - (range[0] || 0)) / (isLeft ? isNumeric ? (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41) : 18 : (0, $22cf0ae7e72c2bef$export$b3026b3c8d26dc41)));
        const calculatedNumTicks = numTicks !== undefined ? numTicks : tempCalcTicks < 2 ? 2 : tempCalcTicks;
        let calculatedScale = scale;
        if ('timeUnit' in scale && typeof scale.timeUnit === 'function' && scale.timeUnit()) {
            const domain = scale.domain();
            if (domain.length > 0) calculatedScale = (0, (0, parcelRequire("2YVVm")).default)({
                range: scale.range(),
                domain: [
                    scale.domain()[0],
                    scale.domain()[scale.domain().length - 1]
                ]
            });
        }
        const filteredTickValues = (tickValues !== null && tickValues !== void 0 ? tickValues : (0, (0, parcelRequire("eOdM1")).default)(calculatedScale, calculatedNumTicks)).filter((value)=>!hideZero || value !== 0 && value !== '0').map((value, index)=>({
                value: value,
                index: index
            }));
        const ticks = filteredTickValues.reduce((filtered, _ref2)=>{
            let { value: value, index: index } = _ref2;
            const scaledValue = (0, (0, parcelRequire("cMo1a")).default)(tickPosition(value));
            if (tickPosition(value) !== undefined) filtered.push({
                value: value,
                index: index,
                from: (0, (0, parcelRequire("8LERT")).default)({
                    x: scaledValue,
                    y: 0
                }, horizontal),
                to: (0, (0, parcelRequire("8LERT")).default)({
                    x: scaledValue,
                    y: tickLength * tickSign
                }, horizontal)
            });
            return filtered;
        }, []);
        return {
            ticks: ticks
        };
    }
});
parcelRegister("cMo1a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94dc992be9846d59$export$2e2bcd8739ae039);
    function $94dc992be9846d59$export$2e2bcd8739ae039(val) {
        if ((typeof val === 'function' || typeof val === 'object' && !!val) && 'valueOf' in val) {
            var num = val.valueOf();
            if (typeof num === 'number') return num;
        }
        return val;
    }
});
parcelRegister("eOdM1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac806b5b20fff3c3$export$2e2bcd8739ae039);
    function $ac806b5b20fff3c3$export$2e2bcd8739ae039(scale, numTicks) {
        var s = scale;
        if ('ticks' in s) return s.ticks(numTicks);
        return s.domain().filter(function(_, index, arr) {
            return numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0;
        });
    }
});
parcelRegister("elPt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a72af3598e52f8a9$export$2e2bcd8739ae039);
    var $jjmqp;
    function $a72af3598e52f8a9$export$2e2bcd8739ae039(scale) {
        if ('paddingInner' in scale) return 'band';
        if ('padding' in scale) return 'point';
        if ('quantiles' in scale) return 'quantile';
        if ('base' in scale) return 'log';
        if ('exponent' in scale) return scale.exponent() === 0.5 ? 'sqrt' : 'pow';
        if ('constant' in scale) return 'symlog';
        if ('clamp' in scale) {
            if (scale.ticks()[0] instanceof Date) return (0, (0, parcelRequire("jjmqp")).default)(scale) ? 'utc' : 'time';
            return 'linear';
        }
        if ('nice' in scale) return 'quantize';
        if ('invertExtent' in scale) return 'threshold';
        return 'ordinal';
    }
});
parcelRegister("2YVVm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22be1de14d945e20$export$2e2bcd8739ae039);
    var $hV9DI;
    var $caWsP;
    var $22be1de14d945e20$export$a5ffb43f629473d4 = (0, (0, parcelRequire("caWsP")).default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
    function $22be1de14d945e20$export$2e2bcd8739ae039(config) {
        return $22be1de14d945e20$export$a5ffb43f629473d4((0, (0, parcelRequire("hV9DI")).default)(), config);
    }
});
parcelRegister("hV9DI", function(module, exports) {
    $parcel$export(module.exports, "calendar", ()=>$d0bf3cbc94db3d51$export$56bbcdb8aca31149);
    $parcel$export(module.exports, "default", ()=>$d0bf3cbc94db3d51$export$2e2bcd8739ae039);
    var $cRW5v;
    var $kSdfl;
    var $7yDT1;
    var $2jkSd;
    var $dayZI;
    var $dCu2z;
    var $8vb39;
    var $idw3k;
    var $duk0X = parcelRequire("duk0X");
    var $jhkFB;
    var $l4Hc4;
    var $8h2kZ;
    function $d0bf3cbc94db3d51$var$date(t) {
        return new Date(t);
    }
    function $d0bf3cbc94db3d51$var$number(t) {
        return t instanceof Date ? +t : +new Date(+t);
    }
    function $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
        var scale = (0, (0, parcelRequire("jhkFB")).default)(), invert = scale.invert, domain = scale.domain;
        var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
        function tickFormat(date) {
            return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
        }
        scale.invert = function(y) {
            return new Date(invert(y));
        };
        scale.domain = function(_) {
            return arguments.length ? domain(Array.from(_, $d0bf3cbc94db3d51$var$number)) : domain().map($d0bf3cbc94db3d51$var$date);
        };
        scale.ticks = function(interval) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
        };
        scale.tickFormat = function(count, specifier) {
            return specifier == null ? tickFormat : format(specifier);
        };
        scale.nice = function(interval) {
            var d = domain();
            if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
            return interval ? domain((0, (0, parcelRequire("8h2kZ")).default)(d, interval)) : scale;
        };
        scale.copy = function() {
            return (0, (0, parcelRequire("jhkFB")).copy)(scale, $d0bf3cbc94db3d51$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
        };
        return scale;
    }
    function $d0bf3cbc94db3d51$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("l4Hc4")).initRange).apply($d0bf3cbc94db3d51$export$56bbcdb8aca31149((0, (0, parcelRequire("dCu2z")).timeTicks), (0, (0, parcelRequire("dCu2z")).timeTickInterval), (0, (0, parcelRequire("idw3k")).timeYear), (0, (0, parcelRequire("2jkSd")).timeMonth), (0, (0, parcelRequire("8vb39")).timeSunday), (0, (0, parcelRequire("cRW5v")).timeDay), (0, (0, parcelRequire("kSdfl")).timeHour), (0, (0, parcelRequire("7yDT1")).timeMinute), (0, (0, parcelRequire("dayZI")).second), (0, $duk0X.timeFormat)).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]), arguments);
    }
});
parcelRegister("duk0X", function(module, exports) {
    $parcel$export(module.exports, "timeFormat", ()=>$9d1d9a25801dc2bc$export$94f4d87fad5dcf9a);
    $parcel$export(module.exports, "timeParse", ()=>$9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2);
    $parcel$export(module.exports, "utcFormat", ()=>$9d1d9a25801dc2bc$export$1a08fe38f63ebbbb);
    $parcel$export(module.exports, "utcParse", ()=>$9d1d9a25801dc2bc$export$3edae9cf8e233729);
    var $7X48q;
    var $9d1d9a25801dc2bc$var$locale;
    var $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a;
    var $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2;
    var $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb;
    var $9d1d9a25801dc2bc$export$3edae9cf8e233729;
    $9d1d9a25801dc2bc$export$2e2bcd8739ae039({
        dateTime: "%x, %X",
        date: "%-m/%-d/%Y",
        time: "%-I:%M:%S %p",
        periods: [
            "AM",
            "PM"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    });
    function $9d1d9a25801dc2bc$export$2e2bcd8739ae039(definition) {
        $9d1d9a25801dc2bc$var$locale = (0, (0, parcelRequire("7X48q")).default)(definition);
        $9d1d9a25801dc2bc$export$94f4d87fad5dcf9a = $9d1d9a25801dc2bc$var$locale.format;
        $9d1d9a25801dc2bc$export$32b9cd16e1b8c8d2 = $9d1d9a25801dc2bc$var$locale.parse;
        $9d1d9a25801dc2bc$export$1a08fe38f63ebbbb = $9d1d9a25801dc2bc$var$locale.utcFormat;
        $9d1d9a25801dc2bc$export$3edae9cf8e233729 = $9d1d9a25801dc2bc$var$locale.utcParse;
        return $9d1d9a25801dc2bc$var$locale;
    }
});
parcelRegister("7X48q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ca140376c7a3a5b$export$2e2bcd8739ae039);
    var $cRW5v;
    var $8vb39;
    var $idw3k;
    function $5ca140376c7a3a5b$var$localDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
            date.setFullYear(d.y);
            return date;
        }
        return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
    }
    function $5ca140376c7a3a5b$var$utcDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
            date.setUTCFullYear(d.y);
            return date;
        }
        return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
    }
    function $5ca140376c7a3a5b$var$newDate(y, m, d) {
        return {
            y: y,
            m: m,
            d: d,
            H: 0,
            M: 0,
            S: 0,
            L: 0
        };
    }
    function $5ca140376c7a3a5b$export$2e2bcd8739ae039(locale) {
        var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
        var periodRe = $5ca140376c7a3a5b$var$formatRe(locale_periods), periodLookup = $5ca140376c7a3a5b$var$formatLookup(locale_periods), weekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_weekdays), weekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_weekdays), shortWeekdayRe = $5ca140376c7a3a5b$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortWeekdays), monthRe = $5ca140376c7a3a5b$var$formatRe(locale_months), monthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_months), shortMonthRe = $5ca140376c7a3a5b$var$formatRe(locale_shortMonths), shortMonthLookup = $5ca140376c7a3a5b$var$formatLookup(locale_shortMonths);
        var formats = {
            "a": formatShortWeekday,
            "A": formatWeekday,
            "b": formatShortMonth,
            "B": formatMonth,
            "c": null,
            "d": $5ca140376c7a3a5b$var$formatDayOfMonth,
            "e": $5ca140376c7a3a5b$var$formatDayOfMonth,
            "f": $5ca140376c7a3a5b$var$formatMicroseconds,
            "g": $5ca140376c7a3a5b$var$formatYearISO,
            "G": $5ca140376c7a3a5b$var$formatFullYearISO,
            "H": $5ca140376c7a3a5b$var$formatHour24,
            "I": $5ca140376c7a3a5b$var$formatHour12,
            "j": $5ca140376c7a3a5b$var$formatDayOfYear,
            "L": $5ca140376c7a3a5b$var$formatMilliseconds,
            "m": $5ca140376c7a3a5b$var$formatMonthNumber,
            "M": $5ca140376c7a3a5b$var$formatMinutes,
            "p": formatPeriod,
            "q": formatQuarter,
            "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
            "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
            "S": $5ca140376c7a3a5b$var$formatSeconds,
            "u": $5ca140376c7a3a5b$var$formatWeekdayNumberMonday,
            "U": $5ca140376c7a3a5b$var$formatWeekNumberSunday,
            "V": $5ca140376c7a3a5b$var$formatWeekNumberISO,
            "w": $5ca140376c7a3a5b$var$formatWeekdayNumberSunday,
            "W": $5ca140376c7a3a5b$var$formatWeekNumberMonday,
            "x": null,
            "X": null,
            "y": $5ca140376c7a3a5b$var$formatYear,
            "Y": $5ca140376c7a3a5b$var$formatFullYear,
            "Z": $5ca140376c7a3a5b$var$formatZone,
            "%": $5ca140376c7a3a5b$var$formatLiteralPercent
        };
        var utcFormats = {
            "a": formatUTCShortWeekday,
            "A": formatUTCWeekday,
            "b": formatUTCShortMonth,
            "B": formatUTCMonth,
            "c": null,
            "d": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
            "e": $5ca140376c7a3a5b$var$formatUTCDayOfMonth,
            "f": $5ca140376c7a3a5b$var$formatUTCMicroseconds,
            "g": $5ca140376c7a3a5b$var$formatUTCYearISO,
            "G": $5ca140376c7a3a5b$var$formatUTCFullYearISO,
            "H": $5ca140376c7a3a5b$var$formatUTCHour24,
            "I": $5ca140376c7a3a5b$var$formatUTCHour12,
            "j": $5ca140376c7a3a5b$var$formatUTCDayOfYear,
            "L": $5ca140376c7a3a5b$var$formatUTCMilliseconds,
            "m": $5ca140376c7a3a5b$var$formatUTCMonthNumber,
            "M": $5ca140376c7a3a5b$var$formatUTCMinutes,
            "p": formatUTCPeriod,
            "q": formatUTCQuarter,
            "Q": $5ca140376c7a3a5b$var$formatUnixTimestamp,
            "s": $5ca140376c7a3a5b$var$formatUnixTimestampSeconds,
            "S": $5ca140376c7a3a5b$var$formatUTCSeconds,
            "u": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday,
            "U": $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday,
            "V": $5ca140376c7a3a5b$var$formatUTCWeekNumberISO,
            "w": $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday,
            "W": $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday,
            "x": null,
            "X": null,
            "y": $5ca140376c7a3a5b$var$formatUTCYear,
            "Y": $5ca140376c7a3a5b$var$formatUTCFullYear,
            "Z": $5ca140376c7a3a5b$var$formatUTCZone,
            "%": $5ca140376c7a3a5b$var$formatLiteralPercent
        };
        var parses = {
            "a": parseShortWeekday,
            "A": parseWeekday,
            "b": parseShortMonth,
            "B": parseMonth,
            "c": parseLocaleDateTime,
            "d": $5ca140376c7a3a5b$var$parseDayOfMonth,
            "e": $5ca140376c7a3a5b$var$parseDayOfMonth,
            "f": $5ca140376c7a3a5b$var$parseMicroseconds,
            "g": $5ca140376c7a3a5b$var$parseYear,
            "G": $5ca140376c7a3a5b$var$parseFullYear,
            "H": $5ca140376c7a3a5b$var$parseHour24,
            "I": $5ca140376c7a3a5b$var$parseHour24,
            "j": $5ca140376c7a3a5b$var$parseDayOfYear,
            "L": $5ca140376c7a3a5b$var$parseMilliseconds,
            "m": $5ca140376c7a3a5b$var$parseMonthNumber,
            "M": $5ca140376c7a3a5b$var$parseMinutes,
            "p": parsePeriod,
            "q": $5ca140376c7a3a5b$var$parseQuarter,
            "Q": $5ca140376c7a3a5b$var$parseUnixTimestamp,
            "s": $5ca140376c7a3a5b$var$parseUnixTimestampSeconds,
            "S": $5ca140376c7a3a5b$var$parseSeconds,
            "u": $5ca140376c7a3a5b$var$parseWeekdayNumberMonday,
            "U": $5ca140376c7a3a5b$var$parseWeekNumberSunday,
            "V": $5ca140376c7a3a5b$var$parseWeekNumberISO,
            "w": $5ca140376c7a3a5b$var$parseWeekdayNumberSunday,
            "W": $5ca140376c7a3a5b$var$parseWeekNumberMonday,
            "x": parseLocaleDate,
            "X": parseLocaleTime,
            "y": $5ca140376c7a3a5b$var$parseYear,
            "Y": $5ca140376c7a3a5b$var$parseFullYear,
            "Z": $5ca140376c7a3a5b$var$parseZone,
            "%": $5ca140376c7a3a5b$var$parseLiteralPercent
        };
        formats.x = newFormat(locale_date, formats);
        formats.X = newFormat(locale_time, formats);
        formats.c = newFormat(locale_dateTime, formats);
        utcFormats.x = newFormat(locale_date, utcFormats);
        utcFormats.X = newFormat(locale_time, utcFormats);
        utcFormats.c = newFormat(locale_dateTime, utcFormats);
        function newFormat(specifier, formats) {
            return function(date) {
                var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
                if (!(date instanceof Date)) date = new Date(+date);
                while(++i < n)if (specifier.charCodeAt(i) === 37) {
                    string.push(specifier.slice(j, i));
                    if ((pad = $5ca140376c7a3a5b$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                    else pad = c === "e" ? " " : "0";
                    if (format = formats[c]) c = format(date, pad);
                    string.push(c);
                    j = i + 1;
                }
                string.push(specifier.slice(j, i));
                return string.join("");
            };
        }
        function newParse(specifier, Z) {
            return function(string) {
                var d = $5ca140376c7a3a5b$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
                if (i != string.length) return null;
                if ("Q" in d) return new Date(d.Q);
                if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
                if (Z && !("Z" in d)) d.Z = 0;
                if ("p" in d) d.H = d.H % 12 + d.p * 12;
                if (d.m === undefined) d.m = "q" in d ? d.q : 0;
                if ("V" in d) {
                    if (d.V < 1 || d.V > 53) return null;
                    if (!("w" in d)) d.w = 1;
                    if ("Z" in d) {
                        week = $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                        week = day > 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).utcMonday).ceil(week) : (0, (0, parcelRequire("8vb39")).utcMonday)(week);
                        week = (0, (0, parcelRequire("cRW5v")).utcDay).offset(week, (d.V - 1) * 7);
                        d.y = week.getUTCFullYear();
                        d.m = week.getUTCMonth();
                        d.d = week.getUTCDate() + (d.w + 6) % 7;
                    } else {
                        week = $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)), day = week.getDay();
                        week = day > 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).timeMonday).ceil(week) : (0, (0, parcelRequire("8vb39")).timeMonday)(week);
                        week = (0, (0, parcelRequire("cRW5v")).timeDay).offset(week, (d.V - 1) * 7);
                        d.y = week.getFullYear();
                        d.m = week.getMonth();
                        d.d = week.getDate() + (d.w + 6) % 7;
                    }
                } else if ("W" in d || "U" in d) {
                    if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                    day = "Z" in d ? $5ca140376c7a3a5b$var$utcDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getUTCDay() : $5ca140376c7a3a5b$var$localDate($5ca140376c7a3a5b$var$newDate(d.y, 0, 1)).getDay();
                    d.m = 0;
                    d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
                }
                if ("Z" in d) {
                    d.H += d.Z / 100 | 0;
                    d.M += d.Z % 100;
                    return $5ca140376c7a3a5b$var$utcDate(d);
                }
                return $5ca140376c7a3a5b$var$localDate(d);
            };
        }
        function parseSpecifier(d, specifier, string, j) {
            var i = 0, n = specifier.length, m = string.length, c, parse;
            while(i < n){
                if (j >= m) return -1;
                c = specifier.charCodeAt(i++);
                if (c === 37) {
                    c = specifier.charAt(i++);
                    parse = parses[c in $5ca140376c7a3a5b$var$pads ? specifier.charAt(i++) : c];
                    if (!parse || (j = parse(d, string, j)) < 0) return -1;
                } else if (c != string.charCodeAt(j++)) return -1;
            }
            return j;
        }
        function parsePeriod(d, string, i) {
            var n = periodRe.exec(string.slice(i));
            return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortWeekday(d, string, i) {
            var n = shortWeekdayRe.exec(string.slice(i));
            return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseWeekday(d, string, i) {
            var n = weekdayRe.exec(string.slice(i));
            return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortMonth(d, string, i) {
            var n = shortMonthRe.exec(string.slice(i));
            return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseMonth(d, string, i) {
            var n = monthRe.exec(string.slice(i));
            return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseLocaleDateTime(d, string, i) {
            return parseSpecifier(d, locale_dateTime, string, i);
        }
        function parseLocaleDate(d, string, i) {
            return parseSpecifier(d, locale_date, string, i);
        }
        function parseLocaleTime(d, string, i) {
            return parseSpecifier(d, locale_time, string, i);
        }
        function formatShortWeekday(d) {
            return locale_shortWeekdays[d.getDay()];
        }
        function formatWeekday(d) {
            return locale_weekdays[d.getDay()];
        }
        function formatShortMonth(d) {
            return locale_shortMonths[d.getMonth()];
        }
        function formatMonth(d) {
            return locale_months[d.getMonth()];
        }
        function formatPeriod(d) {
            return locale_periods[+(d.getHours() >= 12)];
        }
        function formatQuarter(d) {
            return 1 + ~~(d.getMonth() / 3);
        }
        function formatUTCShortWeekday(d) {
            return locale_shortWeekdays[d.getUTCDay()];
        }
        function formatUTCWeekday(d) {
            return locale_weekdays[d.getUTCDay()];
        }
        function formatUTCShortMonth(d) {
            return locale_shortMonths[d.getUTCMonth()];
        }
        function formatUTCMonth(d) {
            return locale_months[d.getUTCMonth()];
        }
        function formatUTCPeriod(d) {
            return locale_periods[+(d.getUTCHours() >= 12)];
        }
        function formatUTCQuarter(d) {
            return 1 + ~~(d.getUTCMonth() / 3);
        }
        return {
            format: function(specifier) {
                var f = newFormat(specifier += "", formats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            parse: function(specifier) {
                var p = newParse(specifier += "", false);
                p.toString = function() {
                    return specifier;
                };
                return p;
            },
            utcFormat: function(specifier) {
                var f = newFormat(specifier += "", utcFormats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            utcParse: function(specifier) {
                var p = newParse(specifier += "", true);
                p.toString = function() {
                    return specifier;
                };
                return p;
            }
        };
    }
    var $5ca140376c7a3a5b$var$pads = {
        "-": "",
        "_": " ",
        "0": "0"
    }, $5ca140376c7a3a5b$var$numberRe = /^\s*\d+/, $5ca140376c7a3a5b$var$percentRe = /^%/, $5ca140376c7a3a5b$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
    function $5ca140376c7a3a5b$var$pad(value, fill, width) {
        var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }
    function $5ca140376c7a3a5b$var$requote(s) {
        return s.replace($5ca140376c7a3a5b$var$requoteRe, "\\$&");
    }
    function $5ca140376c7a3a5b$var$formatRe(names) {
        return new RegExp("^(?:" + names.map($5ca140376c7a3a5b$var$requote).join("|") + ")", "i");
    }
    function $5ca140376c7a3a5b$var$formatLookup(names) {
        return new Map(names.map((name, i)=>[
                name.toLowerCase(),
                i
            ]));
    }
    function $5ca140376c7a3a5b$var$parseWeekdayNumberSunday(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
        return n ? (d.w = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseWeekdayNumberMonday(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
        return n ? (d.u = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseWeekNumberSunday(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.U = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseWeekNumberISO(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.V = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseWeekNumberMonday(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.W = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseFullYear(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 4));
        return n ? (d.y = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseYear(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseZone(d, string, i) {
        var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
        return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseQuarter(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 1));
        return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseMonthNumber(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseDayOfMonth(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.d = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseDayOfYear(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
        return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseHour24(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.H = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseMinutes(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.M = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseSeconds(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 2));
        return n ? (d.S = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseMilliseconds(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 3));
        return n ? (d.L = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseMicroseconds(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i, i + 6));
        return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseLiteralPercent(d, string, i) {
        var n = $5ca140376c7a3a5b$var$percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
    }
    function $5ca140376c7a3a5b$var$parseUnixTimestamp(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
        return n ? (d.Q = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$parseUnixTimestampSeconds(d, string, i) {
        var n = $5ca140376c7a3a5b$var$numberRe.exec(string.slice(i));
        return n ? (d.s = +n[0], i + n[0].length) : -1;
    }
    function $5ca140376c7a3a5b$var$formatDayOfMonth(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getDate(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatHour24(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getHours(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatHour12(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getHours() % 12 || 12, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatDayOfYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(1 + (0, (0, parcelRequire("cRW5v")).timeDay).count((0, (0, parcelRequire("idw3k")).timeYear)(d), d), p, 3);
    }
    function $5ca140376c7a3a5b$var$formatMilliseconds(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getMilliseconds(), p, 3);
    }
    function $5ca140376c7a3a5b$var$formatMicroseconds(d, p) {
        return $5ca140376c7a3a5b$var$formatMilliseconds(d, p) + "000";
    }
    function $5ca140376c7a3a5b$var$formatMonthNumber(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getMonth() + 1, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatMinutes(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getMinutes(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatSeconds(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getSeconds(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatWeekdayNumberMonday(d) {
        var day = d.getDay();
        return day === 0 ? 7 : day;
    }
    function $5ca140376c7a3a5b$var$formatWeekNumberSunday(d, p) {
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).timeSunday).count((0, (0, parcelRequire("idw3k")).timeYear)(d) - 1, d), p, 2);
    }
    function $5ca140376c7a3a5b$var$dISO(d) {
        var day = d.getDay();
        return day >= 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).timeThursday)(d) : (0, (0, parcelRequire("8vb39")).timeThursday).ceil(d);
    }
    function $5ca140376c7a3a5b$var$formatWeekNumberISO(d, p) {
        d = $5ca140376c7a3a5b$var$dISO(d);
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).timeThursday).count((0, (0, parcelRequire("idw3k")).timeYear)(d), d) + ((0, (0, parcelRequire("idw3k")).timeYear)(d).getDay() === 4), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatWeekdayNumberSunday(d) {
        return d.getDay();
    }
    function $5ca140376c7a3a5b$var$formatWeekNumberMonday(d, p) {
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).timeMonday).count((0, (0, parcelRequire("idw3k")).timeYear)(d) - 1, d), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatYearISO(d, p) {
        d = $5ca140376c7a3a5b$var$dISO(d);
        return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 100, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatFullYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
    }
    function $5ca140376c7a3a5b$var$formatFullYearISO(d, p) {
        var day = d.getDay();
        d = day >= 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).timeThursday)(d) : (0, (0, parcelRequire("8vb39")).timeThursday).ceil(d);
        return $5ca140376c7a3a5b$var$pad(d.getFullYear() % 10000, p, 4);
    }
    function $5ca140376c7a3a5b$var$formatZone(d) {
        var z = d.getTimezoneOffset();
        return (z > 0 ? "-" : (z *= -1, "+")) + $5ca140376c7a3a5b$var$pad(z / 60 | 0, "0", 2) + $5ca140376c7a3a5b$var$pad(z % 60, "0", 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCDayOfMonth(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCDate(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCHour24(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCHours(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCHour12(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCHours() % 12 || 12, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCDayOfYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(1 + (0, (0, parcelRequire("cRW5v")).utcDay).count((0, (0, parcelRequire("idw3k")).utcYear)(d), d), p, 3);
    }
    function $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCMilliseconds(), p, 3);
    }
    function $5ca140376c7a3a5b$var$formatUTCMicroseconds(d, p) {
        return $5ca140376c7a3a5b$var$formatUTCMilliseconds(d, p) + "000";
    }
    function $5ca140376c7a3a5b$var$formatUTCMonthNumber(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCMonth() + 1, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCMinutes(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCMinutes(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCSeconds(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCSeconds(), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberMonday(d) {
        var dow = d.getUTCDay();
        return dow === 0 ? 7 : dow;
    }
    function $5ca140376c7a3a5b$var$formatUTCWeekNumberSunday(d, p) {
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).utcSunday).count((0, (0, parcelRequire("idw3k")).utcYear)(d) - 1, d), p, 2);
    }
    function $5ca140376c7a3a5b$var$UTCdISO(d) {
        var day = d.getUTCDay();
        return day >= 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).utcThursday)(d) : (0, (0, parcelRequire("8vb39")).utcThursday).ceil(d);
    }
    function $5ca140376c7a3a5b$var$formatUTCWeekNumberISO(d, p) {
        d = $5ca140376c7a3a5b$var$UTCdISO(d);
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).utcThursday).count((0, (0, parcelRequire("idw3k")).utcYear)(d), d) + ((0, (0, parcelRequire("idw3k")).utcYear)(d).getUTCDay() === 4), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCWeekdayNumberSunday(d) {
        return d.getUTCDay();
    }
    function $5ca140376c7a3a5b$var$formatUTCWeekNumberMonday(d, p) {
        return $5ca140376c7a3a5b$var$pad((0, (0, parcelRequire("8vb39")).utcMonday).count((0, (0, parcelRequire("idw3k")).utcYear)(d) - 1, d), p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCYearISO(d, p) {
        d = $5ca140376c7a3a5b$var$UTCdISO(d);
        return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 100, p, 2);
    }
    function $5ca140376c7a3a5b$var$formatUTCFullYear(d, p) {
        return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function $5ca140376c7a3a5b$var$formatUTCFullYearISO(d, p) {
        var day = d.getUTCDay();
        d = day >= 4 || day === 0 ? (0, (0, parcelRequire("8vb39")).utcThursday)(d) : (0, (0, parcelRequire("8vb39")).utcThursday).ceil(d);
        return $5ca140376c7a3a5b$var$pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function $5ca140376c7a3a5b$var$formatUTCZone() {
        return "+0000";
    }
    function $5ca140376c7a3a5b$var$formatLiteralPercent() {
        return "%";
    }
    function $5ca140376c7a3a5b$var$formatUnixTimestamp(d) {
        return +d;
    }
    function $5ca140376c7a3a5b$var$formatUnixTimestampSeconds(d) {
        return Math.floor(+d / 1000);
    }
});
parcelRegister("jhkFB", function(module, exports) {
    $parcel$export(module.exports, "identity", ()=>$e08fa37ff0dcafa0$export$f0954fd7d5368655);
    $parcel$export(module.exports, "copy", ()=>$e08fa37ff0dcafa0$export$784d13d8ee351f07);
    $parcel$export(module.exports, "transformer", ()=>$e08fa37ff0dcafa0$export$6b468dcfb64c653c);
    $parcel$export(module.exports, "default", ()=>$e08fa37ff0dcafa0$export$2e2bcd8739ae039);
    var $babOZ;
    var $6RkHc;
    var $3Rh7t;
    var $8Masb;
    var $8CHve;
    var $bMlxp;
    var $e08fa37ff0dcafa0$var$unit = [
        0,
        1
    ];
    function $e08fa37ff0dcafa0$export$f0954fd7d5368655(x) {
        return x;
    }
    function $e08fa37ff0dcafa0$var$normalize(a, b) {
        return (b -= a = +a) ? function(x) {
            return (x - a) / b;
        } : (0, (0, parcelRequire("8CHve")).default)(isNaN(b) ? NaN : 0.5);
    }
    function $e08fa37ff0dcafa0$var$clamper(a, b) {
        var t;
        if (a > b) t = a, a = b, b = t;
        return function(x) {
            return Math.max(a, Math.min(b, x));
        };
    }
    function $e08fa37ff0dcafa0$var$bimap(domain, range, interpolate) {
        var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
        if (d1 < d0) d0 = $e08fa37ff0dcafa0$var$normalize(d1, d0), r0 = interpolate(r1, r0);
        else d0 = $e08fa37ff0dcafa0$var$normalize(d0, d1), r0 = interpolate(r0, r1);
        return function(x) {
            return r0(d0(x));
        };
    }
    function $e08fa37ff0dcafa0$var$polymap(domain, range, interpolate) {
        var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
        if (domain[j] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++i < j){
            d[i] = $e08fa37ff0dcafa0$var$normalize(domain[i], domain[i + 1]);
            r[i] = interpolate(range[i], range[i + 1]);
        }
        return function(x) {
            var i = (0, (0, parcelRequire("babOZ")).default)(domain, x, 1, j) - 1;
            return r[i](d[i](x));
        };
    }
    function $e08fa37ff0dcafa0$export$784d13d8ee351f07(source, target) {
        return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
    }
    function $e08fa37ff0dcafa0$export$6b468dcfb64c653c() {
        var domain = $e08fa37ff0dcafa0$var$unit, range = $e08fa37ff0dcafa0$var$unit, interpolate = (0, (0, parcelRequire("6RkHc")).default), transform, untransform, unknown, clamp = $e08fa37ff0dcafa0$export$f0954fd7d5368655, piecewise, output, input;
        function rescale() {
            var n = Math.min(domain.length, range.length);
            if (clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655) clamp = $e08fa37ff0dcafa0$var$clamper(domain[0], domain[n - 1]);
            piecewise = n > 2 ? $e08fa37ff0dcafa0$var$polymap : $e08fa37ff0dcafa0$var$bimap;
            output = input = null;
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
        }
        scale.invert = function(y) {
            return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, (0, parcelRequire("3Rh7t")).default))))(y)));
        };
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_, (0, (0, parcelRequire("bMlxp")).default)), rescale()) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.rangeRound = function(_) {
            return range = Array.from(_), interpolate = (0, (0, parcelRequire("8Masb")).default), rescale();
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = _ ? true : $e08fa37ff0dcafa0$export$f0954fd7d5368655, rescale()) : clamp !== $e08fa37ff0dcafa0$export$f0954fd7d5368655;
        };
        scale.interpolate = function(_) {
            return arguments.length ? (interpolate = _, rescale()) : interpolate;
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t, u) {
            transform = t, untransform = u;
            return rescale();
        };
    }
    function $e08fa37ff0dcafa0$export$2e2bcd8739ae039() {
        return $e08fa37ff0dcafa0$export$6b468dcfb64c653c()($e08fa37ff0dcafa0$export$f0954fd7d5368655, $e08fa37ff0dcafa0$export$f0954fd7d5368655);
    }
});
parcelRegister("babOZ", function(module, exports) {
    $parcel$export(module.exports, "bisectRight", ()=>$8209cc5de140cbf4$export$4d945ad3ad5751b0);
    $parcel$export(module.exports, "bisectLeft", ()=>$8209cc5de140cbf4$export$df7d25c84ebd12a5);
    $parcel$export(module.exports, "default", ()=>$8209cc5de140cbf4$export$2e2bcd8739ae039);
    var $9eRkP;
    var $88EGG;
    var $gcXrx;
    const $8209cc5de140cbf4$var$ascendingBisect = (0, (0, parcelRequire("88EGG")).default)((0, (0, parcelRequire("9eRkP")).default));
    const $8209cc5de140cbf4$export$4d945ad3ad5751b0 = $8209cc5de140cbf4$var$ascendingBisect.right;
    const $8209cc5de140cbf4$export$df7d25c84ebd12a5 = $8209cc5de140cbf4$var$ascendingBisect.left;
    const $8209cc5de140cbf4$export$c1cb828b1117c77b = (0, (0, parcelRequire("88EGG")).default)((0, (0, parcelRequire("gcXrx")).default)).center;
    var $8209cc5de140cbf4$export$2e2bcd8739ae039 = $8209cc5de140cbf4$export$4d945ad3ad5751b0;
});
parcelRegister("gcXrx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bccbe082a14f438f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "numbers", ()=>$bccbe082a14f438f$export$1f6c9cc012ebacae);
    function $bccbe082a14f438f$export$2e2bcd8739ae039(x) {
        return x === null ? NaN : +x;
    }
    function* $bccbe082a14f438f$export$1f6c9cc012ebacae(values, valueof) {
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) yield value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
        }
    }
});
parcelRegister("6RkHc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fe7bf159d941aaa$export$2e2bcd8739ae039);
    var $7UL8A;
    var $aG0QU;
    var $kTnyJ;
    var $MJl9N;
    var $3Rh7t;
    var $cNfx1;
    var $aAMMD;
    var $28ku5;
    var $fwtCP;
    function $4fe7bf159d941aaa$export$2e2bcd8739ae039(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, (0, parcelRequire("28ku5")).default)(b) : (t === "number" ? (0, (0, parcelRequire("3Rh7t")).default) : t === "string" ? (c = (0, (0, parcelRequire("7UL8A")).default)(b)) ? (b = c, (0, parcelRequire("aG0QU")).default) : (0, (0, parcelRequire("aAMMD")).default) : b instanceof (0, (0, parcelRequire("7UL8A")).default) ? (0, (0, parcelRequire("aG0QU")).default) : b instanceof Date ? (0, (0, parcelRequire("MJl9N")).default) : (0, (0, parcelRequire("fwtCP")).isNumberArray)(b) ? (0, (0, parcelRequire("fwtCP")).default) : Array.isArray(b) ? (0, (0, parcelRequire("kTnyJ")).genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, (0, parcelRequire("cNfx1")).default) : (0, (0, parcelRequire("3Rh7t")).default))(a, b);
    }
});
parcelRegister("kTnyJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f35b380b021f8b08$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "genericArray", ()=>$f35b380b021f8b08$export$15d09067c6a5ee49);
    var $6RkHc;
    var $fwtCP;
    function $f35b380b021f8b08$export$2e2bcd8739ae039(a, b) {
        return ((0, (0, parcelRequire("fwtCP")).isNumberArray)(b) ? (0, (0, parcelRequire("fwtCP")).default) : $f35b380b021f8b08$export$15d09067c6a5ee49)(a, b);
    }
    function $f35b380b021f8b08$export$15d09067c6a5ee49(a, b) {
        var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
        for(i = 0; i < na; ++i)x[i] = (0, (0, parcelRequire("6RkHc")).default)(a[i], b[i]);
        for(; i < nb; ++i)c[i] = b[i];
        return function(t) {
            for(i = 0; i < na; ++i)c[i] = x[i](t);
            return c;
        };
    }
});
parcelRegister("fwtCP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4d0d32910153fd7$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "isNumberArray", ()=>$b4d0d32910153fd7$export$5cd576d1827d40c8);
    function $b4d0d32910153fd7$export$2e2bcd8739ae039(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    }
    function $b4d0d32910153fd7$export$5cd576d1827d40c8(x) {
        return ArrayBuffer.isView(x) && !(x instanceof DataView);
    }
});
parcelRegister("MJl9N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0927a76fd784b52f$export$2e2bcd8739ae039);
    function $0927a76fd784b52f$export$2e2bcd8739ae039(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    }
});
parcelRegister("3Rh7t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cf399f0ec029057$export$2e2bcd8739ae039);
    function $2cf399f0ec029057$export$2e2bcd8739ae039(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    }
});
parcelRegister("cNfx1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95061be058f50ffd$export$2e2bcd8739ae039);
    var $6RkHc;
    function $95061be058f50ffd$export$2e2bcd8739ae039(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, (0, parcelRequire("6RkHc")).default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
});
parcelRegister("aAMMD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b631b92516e1d18$export$2e2bcd8739ae039);
    var $3Rh7t;
    var $7b631b92516e1d18$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7b631b92516e1d18$var$reB = new RegExp($7b631b92516e1d18$var$reA.source, "g");
    function $7b631b92516e1d18$var$zero(b) {
        return function() {
            return b;
        };
    }
    function $7b631b92516e1d18$var$one(b) {
        return function(t) {
            return b(t) + "";
        };
    }
    function $7b631b92516e1d18$export$2e2bcd8739ae039(a, b) {
        var bi = $7b631b92516e1d18$var$reA.lastIndex = $7b631b92516e1d18$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
        a = a + "", b = b + "";
        while((am = $7b631b92516e1d18$var$reA.exec(a)) && (bm = $7b631b92516e1d18$var$reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs;
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm;
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, (0, parcelRequire("3Rh7t")).default)(am, bm)
                });
            }
            bi = $7b631b92516e1d18$var$reB.lastIndex;
        }
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs;
            else s[++i] = bs;
        }
        return s.length < 2 ? q[0] ? $7b631b92516e1d18$var$one(q[0].x) : $7b631b92516e1d18$var$zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    }
});
parcelRegister("8CHve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64739e0ff1e8934d$export$2e2bcd8739ae039);
    function $64739e0ff1e8934d$export$2e2bcd8739ae039(x) {
        return function() {
            return x;
        };
    }
});
parcelRegister("bMlxp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8934e2622cfc7145$export$2e2bcd8739ae039);
    function $8934e2622cfc7145$export$2e2bcd8739ae039(x) {
        return +x;
    }
});
parcelRegister("8h2kZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6061b96d6d4d7b5e$export$2e2bcd8739ae039);
    function $6061b96d6d4d7b5e$export$2e2bcd8739ae039(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    }
});
const $22cf0ae7e72c2bef$export$b3026b3c8d26dc41 = 70;
parcelRegister("8LERT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66226a162ab0f42c$export$2e2bcd8739ae039);
    var $aDODq;
    function $66226a162ab0f42c$export$2e2bcd8739ae039(_ref, horizontal) {
        let { x: x, y: y } = _ref;
        return new (0, (0, parcelRequire("aDODq")).default)(horizontal ? {
            x: x,
            y: y
        } : {
            x: y,
            y: x
        });
    }
});
parcelRegister("aDODq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bf4d2f2ef1d9d73$export$2e2bcd8739ae039);
    class $7bf4d2f2ef1d9d73$export$2e2bcd8739ae039 {
        x = 0;
        y = 0;
        constructor(_ref){
            let { x: x = 0, y: y = 0 } = _ref;
            this.x = x;
            this.y = y;
        }
        value() {
            return {
                x: this.x,
                y: this.y
            };
        }
        toArray() {
            return [
                this.x,
                this.y
            ];
        }
    }
});
parcelRegister("4ZQLi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a35c94ede701419$export$2e2bcd8739ae039);
    function $3a35c94ede701419$export$2e2bcd8739ae039(scale, align) {
        if (align === void 0) align = 'center';
        const s = scale;
        if (align !== 'start' && 'bandwidth' in s) {
            let offset = s.bandwidth();
            if (align === 'center') offset /= 2;
            if (s.round()) offset = Math.round(offset);
            return (d)=>{
                const scaledValue = s(d);
                return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
            };
        }
        return scale;
    }
});
parcelRegister("cXzUG", function(module, exports) {
    $parcel$export(module.exports, "AxisLeftTick", ()=>$96f6da52418ad5a2$export$d9ad68803a03e71);
    $parcel$export(module.exports, "AxisLeftLine", ()=>$96f6da52418ad5a2$export$25abdf51e62eb76e);
    $parcel$export(module.exports, "AxisLeftText", ()=>$96f6da52418ad5a2$export$68f34be0235fe9c0);
    $parcel$export(module.exports, "AxisLeft", ()=>$96f6da52418ad5a2$export$4b76feaa547cd202);
    var $bwpsq;
    var $bT1Sw;
    var $eFK63;
    var $jxg43;
    var $42C9W;
    var $f8uii;
    var $da7Ww;
    var $l5ab7;
    var $2vbO1;
    var $kq3PX;
    var $2OMIu = parcelRequire("2OMIu");
    const $96f6da52418ad5a2$export$ec95513e2647ff3 = {
        color: "var(--ds-text-subtlest, grey)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: 12
    };
    const $96f6da52418ad5a2$var$tickLength = 8;
    const $96f6da52418ad5a2$var$orientation = (0, (0, parcelRequire("jxg43")).default).left;
    const $96f6da52418ad5a2$export$d9ad68803a03e71 = (0, (0, parcelRequire("bT1Sw")).element)((0, (0, parcelRequire("l5ab7")).Tick));
    const $96f6da52418ad5a2$export$25abdf51e62eb76e = (0, (0, parcelRequire("bT1Sw")).element)((_ref)=>{
        let { height: height, hide: hide } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("da7Ww")).AxisLine), {
            hide: hide,
            style: {
                borderLeft: `2px solid ${(0, (0, parcelRequire("da7Ww")).axisLineStroke)}`,
                height: `${height}px`,
                position: 'absolute',
                transform: 'translateX(-1px)'
            }
        });
    });
    const $96f6da52418ad5a2$export$68f34be0235fe9c0 = (0, (0, parcelRequire("bT1Sw")).element)((_ref2)=>{
        let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children } = _ref2;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("2vbO1")).TickText), {
            style: {
                maxWidth: width
            },
            formatter: formatter,
            truncate: truncate,
            singleline: singleline,
            children: children
        });
    });
    function $96f6da52418ad5a2$var$AxisLeft(_ref3) {
        let { scale: scale, numTicks: numTicks, tickValues: tickValues, rangePadding: rangePadding, hideZero: hideZero, label: label, hide: hide } = _ref3;
        if (hide) return null;
        const { ticks: ticks } = (0, (0, parcelRequire("kq3PX")).useAxisTicks)({
            scale: scale,
            numTicks: numTicks,
            tickValues: tickValues,
            orientation: $96f6da52418ad5a2$var$orientation,
            rangePadding: rangePadding,
            hideZero: hideZero,
            tickLength: $96f6da52418ad5a2$var$tickLength
        });
        const TicksTextsComponent = ticks.map((_ref4)=>{
            let { value: value, index: index, from: from, to: to } = _ref4;
            const formatter = (0, (0, parcelRequire("f8uii")).default)(scale);
            return (0, $2OMIu.jsx)("div", {
                style: {
                    top: `calc(${to.y}px - .6em)`,
                    minWidth: 0,
                    gridColumn: 1,
                    gridRow: 1,
                    position: 'relative',
                    textAlign: 'right',
                    ...$96f6da52418ad5a2$export$ec95513e2647ff3
                },
                children: (0, $2OMIu.jsx)($96f6da52418ad5a2$export$68f34be0235fe9c0, {
                    formatter: formatter,
                    width: 250,
                    truncate: (0, (0, parcelRequire("42C9W")).default)(scale) === 'string',
                    children: value
                })
            }, `axis-left-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
        });
        return (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                (0, $2OMIu.jsx)("div", {
                    style: {
                        gridArea: 'plot',
                        display: 'flex'
                    },
                    children: (0, $2OMIu.jsx)($96f6da52418ad5a2$export$25abdf51e62eb76e, {
                        height: scale.range()[0]
                    })
                }),
                (0, $2OMIu.jsxs)("div", {
                    "data-axis-type": "axis-left",
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_nd5l1jbf _1e0c11p5 _yv0elpux _1tke1osq"
                    ]),
                    children: [
                        label ? (0, $2OMIu.jsx)("div", {
                            style: {
                                overflow: 'hidden',
                                maxHeight: '100%',
                                width: 'max-content',
                                textOverflow: 'ellipsis',
                                alignSelf: 'center',
                                writingMode: 'vertical-rl',
                                transform: 'rotate(-180deg)',
                                paddingLeft: '8px',
                                whiteSpace: 'nowrap',
                                ...(0, (0, parcelRequire("eFK63")).defaultTextHTMLProps)
                            },
                            children: label
                        }) : (0, $2OMIu.jsx)("div", {}),
                        (0, $2OMIu.jsx)("div", {
                            className: (0, (0, parcelRequire("bwpsq")).default)([
                                "_1e0c11p5 _1bsb1ris _wij21bp4 _yv0ehkll _2z05hkll _u5f31crf _lcxvglyw"
                            ]),
                            children: TicksTextsComponent
                        })
                    ]
                })
            ]
        });
    }
    const $96f6da52418ad5a2$export$4b76feaa547cd202 = (0, (0, parcelRequire("bT1Sw")).element)($96f6da52418ad5a2$var$AxisLeft);
});
parcelRegister("lWVLr", function(module, exports) {
    $parcel$export(module.exports, "LayoutContainer", ()=>$ffabd285ad88bd55$export$faad8b178f68f912);
    $parcel$export(module.exports, "Layout", ()=>(parcelRequire("7Nxvv")).Layout);
    var $7Nxvv;
    var $2OMIu = parcelRequire("2OMIu");
    function $ffabd285ad88bd55$export$faad8b178f68f912(_ref) {
        let { height: height, width: width, children: children, ...props } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("7Nxvv")).Layout), {
            showBorder: true,
            width: width,
            height: height,
            hasSubtitle: true,
            gridTemplate: (0, (0, parcelRequire("7Nxvv")).defaultGrid),
            ...props,
            children: children
        });
    }
});
parcelRegister("7Nxvv", function(module, exports) {
    $parcel$export(module.exports, "defaultGrid", ()=>$5ad719d8f2270c77$export$aed5b7d86c3777ab);
    $parcel$export(module.exports, "Layout", ()=>$5ad719d8f2270c77$export$c84671f46d6a1ca);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $bSbfx;
    var $chU1I;
    var $doqD0;
    var $l6fAT;
    var $2OMIu = parcelRequire("2OMIu");
    const $5ad719d8f2270c77$export$aed5b7d86c3777ab = [
        'title',
        'subtitle',
        'legend',
        'plot'
    ];
    function $5ad719d8f2270c77$var$Layout(_ref) {
        var _ref2, _ordering$plot;
        let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, overflow: overflow = 'hidden', showBorder: showBorder = true } = _ref;
        const ordering = gridTemplate.reduce((acc, key, i)=>{
            acc[key] = i + 1;
            return acc;
        }, {});
        const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
        const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
        const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
        const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const ref = window.requestAnimationFrame(()=>{
                if (isMounted) setFadeInOpacity(1);
            });
            return ()=>{
                isMounted = false;
                window.cancelAnimationFrame(ref);
            };
        }, [
            setFadeInOpacity
        ]);
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $2OMIu.jsxs)("div", {
                "data-element": "layout",
                style: {
                    width: width,
                    height: height,
                    backgroundColor: "var(--ds-surface, white)",
                    border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                    padding: showBorder ? "var(--ds-space-200, 16px)" : 0,
                    overflow: overflow
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
                ]),
                children: [
                    (0, $2OMIu.jsxs)("div", {
                        style: {
                            order: ordering.title,
                            position: 'relative'
                        },
                        children: [
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("bSbfx")).Icon), {}),
                            (0, $2OMIu.jsx)((0, (0, parcelRequire("l6fAT")).Title), {})
                        ]
                    }),
                    (0, $2OMIu.jsx)("div", {
                        style: {
                            order: ordering.subtitle
                        },
                        children: hasSubtitle && (0, $2OMIu.jsx)((0, (0, parcelRequire("doqD0")).Subtitle), {})
                    }),
                    (0, $2OMIu.jsx)("div", {
                        "data-element": "chart",
                        style: {
                            opacity: fadeInOpacity,
                            transition: 'opacity .3s ease-in-out',
                            order: chartOrder,
                            flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                        },
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                        ]),
                        children: children
                    }),
                    (0, $2OMIu.jsx)((0, (0, parcelRequire("chU1I")).ChartMenu), {})
                ]
            })
        });
    }
    const $5ad719d8f2270c77$export$c84671f46d6a1ca = (0, (0, parcelRequire("bT1Sw")).element)($5ad719d8f2270c77$var$Layout);
});
parcelRegister("bSbfx", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$8a4d76c7fe38e6da$export$f04a61298a47a40f);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $8a4d76c7fe38e6da$var$iconStyle = null;
    function $8a4d76c7fe38e6da$var$Icon(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i1tcg _syaz1oju"
            ]),
            children: children
        });
    }
    const $8a4d76c7fe38e6da$export$f04a61298a47a40f = (0, (0, parcelRequire("bT1Sw")).element)($8a4d76c7fe38e6da$var$Icon);
});
parcelRegister("chU1I", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$8f22884b61eb2a4d$export$d9b273488cd8ce6f);
    $parcel$export(module.exports, "ChartMenu", ()=>$8f22884b61eb2a4d$export$597da2837c1a3c88);
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $bT1Sw;
    var $17PP9;
    parcelRequire("lWVLr");
    var $7Nxvv;
    var $3Anq0;
    var $PfPCm;
    var $2OMIu = parcelRequire("2OMIu");
    const $8f22884b61eb2a4d$export$d9b273488cd8ce6f = (0, (0, parcelRequire("bT1Sw")).element)((_ref)=>{
        let { children: children, hide: hide = false, toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns, disablePatternOption: disablePatternOption = false } = _ref;
        if (hide) return null;
        const { showBorder: showBorder } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("7Nxvv")).Layout));
        return (0, $2OMIu.jsx)("div", {
            style: {
                position: 'absolute',
                top: 0,
                right: 0,
                padding: showBorder ? "var(--ds-space-200, 16px)" : 0
            },
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("BLPHT")).default), {
                trigger: (_ref2)=>{
                    let { triggerRef: triggerRef, ...props } = _ref2;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("42CjB")).default), {
                        ...props,
                        appearance: "subtle",
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))),
                        label: "Chart Menu",
                        ref: triggerRef,
                        spacing: "compact"
                    });
                },
                label: "Chart Menu",
                shouldRenderToParent: true,
                placement: "top-end",
                spacing: "compact",
                children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("aRoVz")).default), {
                    children: [
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("6B7KL")).default), {
                            onClick: toggleDataTable,
                            testId: (0, (0, parcelRequire("3Anq0")).a11yStrings).showDataTable,
                            children: (0, (0, parcelRequire("3Anq0")).a11yStrings).showDataTable
                        }, (0, (0, parcelRequire("3Anq0")).a11yStrings).showDataTable),
                        !disablePatternOption ? (0, $2OMIu.jsx)((0, (0, parcelRequire("6B7KL")).default), {
                            onClick: toggleShowPatterns,
                            testId: (0, (0, parcelRequire("3Anq0")).a11yStrings).enablePatterns,
                            children: showPatterns ? (0, (0, parcelRequire("3Anq0")).a11yStrings).disablePatterns : (0, (0, parcelRequire("3Anq0")).a11yStrings).enablePatterns
                        }, (0, (0, parcelRequire("3Anq0")).a11yStrings).enablePatterns) : null,
                        children
                    ]
                })
            })
        });
    });
    function $8f22884b61eb2a4d$export$597da2837c1a3c88(props) {
        const { toggleDataTable: toggleDataTable, toggleShowPatterns: toggleShowPatterns, showPatterns: showPatterns } = (0, (0, parcelRequire("PfPCm")).useMenuData)();
        return (0, $2OMIu.jsx)($8f22884b61eb2a4d$export$d9b273488cd8ce6f, {
            ...props,
            toggleDataTable: toggleDataTable,
            toggleShowPatterns: toggleShowPatterns,
            showPatterns: showPatterns
        });
    }
});
parcelRegister("3Anq0", function(module, exports) {
    $parcel$export(module.exports, "a11yStrings", ()=>$29c6e64aba406dd9$export$1bab900455080d68);
    const $29c6e64aba406dd9$export$1bab900455080d68 = {
        enablePatterns: 'Enable Patterns',
        disablePatterns: 'Disable Patterns',
        showDataTable: 'Show Data Table'
    };
});
parcelRegister("PfPCm", function(module, exports) {
    $parcel$export(module.exports, "useMenuData", ()=>$09a10b5983af36a5$export$bf0039e2171862f5);
    $parcel$export(module.exports, "MenuProvider", ()=>$09a10b5983af36a5$export$62b22d151866115d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2OMIu = parcelRequire("2OMIu");
    function $09a10b5983af36a5$export$2ce5e940c4008526() {
        const [showDataTable, setShowDataTable] = (0, $5uXOq.useState)(false);
        const [showPatterns, setShowPatterns] = (0, $5uXOq.useState)(false);
        const toggleDataTable = (0, $5uXOq.useCallback)(()=>{
            setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
        }, [
            setShowDataTable
        ]);
        const closeDataTable = (0, $5uXOq.useCallback)(()=>{
            setShowDataTable(false);
        }, [
            setShowDataTable
        ]);
        const toggleShowPatterns = (0, $5uXOq.useCallback)(()=>{
            setShowPatterns((prevShowPatterns)=>!prevShowPatterns);
        }, [
            setShowPatterns
        ]);
        return {
            showDataTable: showDataTable,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable,
            showPatterns: showPatterns,
            toggleShowPatterns: toggleShowPatterns
        };
    }
    const $09a10b5983af36a5$export$c7e742effb1c51e2 = (0, $5uXOq.createContext)({});
    function $09a10b5983af36a5$export$bf0039e2171862f5() {
        return (0, $5uXOq.useContext)($09a10b5983af36a5$export$c7e742effb1c51e2);
    }
    const $09a10b5983af36a5$export$62b22d151866115d = (_ref)=>{
        let { children: children } = _ref;
        const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable, showPatterns: showPatterns, toggleShowPatterns: toggleShowPatterns } = $09a10b5983af36a5$export$2ce5e940c4008526();
        return (0, $2OMIu.jsx)($09a10b5983af36a5$export$c7e742effb1c51e2.Provider, {
            value: {
                showDataTable: showDataTable,
                showPatterns: showPatterns,
                closeDataTable: closeDataTable,
                toggleDataTable: toggleDataTable,
                toggleShowPatterns: toggleShowPatterns
            },
            children: children
        });
    };
});
parcelRegister("doqD0", function(module, exports) {
    $parcel$export(module.exports, "Subtitle", ()=>$9c022c0b2fd1f025$export$cf345ef34cd72655);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $9c022c0b2fd1f025$var$subTitleTextStyle = null;
    function $9c022c0b2fd1f025$var$Subtitle(_ref) {
        let { children: children } = _ref;
        if (!children) return null;
        return (0, $2OMIu.jsx)("h3", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _k48p1nn1 _ect41wi2 _1wyb1crf _zg8l4jg8 _vwz47vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"
            ]),
            children: children
        });
    }
    const $9c022c0b2fd1f025$export$cf345ef34cd72655 = (0, (0, parcelRequire("bT1Sw")).element)($9c022c0b2fd1f025$var$Subtitle);
});
parcelRegister("e2CtX", function(module, exports) {
    $parcel$export(module.exports, "DimensionsWrapper", ()=>$a38f1a5b7b4f9d3d$export$a263c0cd0abdd921);
    var $5uXOq = parcelRequire("5uXOq");
    const $a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS = {
        plotHeight: 100,
        plotWidth: 100,
        margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    };
    function $a38f1a5b7b4f9d3d$export$a263c0cd0abdd921(_ref) {
        let { children: children } = _ref;
        const [, forceUpdate] = (0, $5uXOq.useState)({});
        const dimensions = (0, $5uXOq.useRef)($a38f1a5b7b4f9d3d$var$INITIAL_DIMENSIONS);
        const plotSvgRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const resizeObserverSvg = new ResizeObserver((entries)=>{
                if (entries && entries[0]) {
                    const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                    const newMargin = Object.assign({}, dimensions.current.margin);
                    dimensions.current = {
                        margin: newMargin,
                        plotHeight: hs,
                        plotWidth: ws
                    };
                    forceUpdate({});
                }
            });
            if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
            return ()=>{
                resizeObserverSvg.disconnect();
            };
        }, []);
        return children({
            ...dimensions.current,
            plotSvgRef: plotSvgRef
        });
    }
});
parcelRegister("erST8", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$a84e29f28dbcd30d$export$ef2184bd89960b14);
    var $bT1Sw;
    var $jfNuF;
    var $f6BRA;
    var $2OMIu = parcelRequire("2OMIu");
    function $a84e29f28dbcd30d$var$Grid(_ref) {
        let { top: top, left: left, xScale: xScale, yScale: yScale, width: width, height: height, rowStrokeWidth: rowStrokeWidth, columnStrokeWidth: columnStrokeWidth, columnStroke: columnStroke, rowStroke: rowStroke, numTicksRows: numTicksRows, numTicksColumns: numTicksColumns, rowLineStyle: rowLineStyle, columnLineStyle: columnLineStyle, xOffset: xOffset, yOffset: yOffset, rowTickValues: rowTickValues, columnTickValues: columnTickValues, hide: hide = false } = _ref;
        if (hide) return null;
        return (0, $2OMIu.jsxs)("div", {
            style: {
                top: top,
                left: left,
                gridArea: 'plot'
            },
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("f6BRA")).GridRows), {
                    scale: yScale,
                    width: width,
                    stroke: rowStroke,
                    strokeWidth: rowStrokeWidth,
                    numTicks: numTicksRows,
                    lineStyle: rowLineStyle,
                    offset: yOffset,
                    tickValues: rowTickValues
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("jfNuF")).GridColumns), {
                    scale: xScale,
                    height: height,
                    stroke: columnStroke,
                    strokeWidth: columnStrokeWidth,
                    numTicks: numTicksColumns,
                    lineStyle: columnLineStyle,
                    offset: xOffset,
                    tickValues: columnTickValues
                })
            ]
        });
    }
    const $a84e29f28dbcd30d$export$ef2184bd89960b14 = (0, (0, parcelRequire("bT1Sw")).element)($a84e29f28dbcd30d$var$Grid);
});
parcelRegister("jfNuF", function(module, exports) {
    $parcel$export(module.exports, "GridColumns", ()=>$e045cf746f0b4756$export$22a67e3ff32a357a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $hqZma;
    var $kq3PX;
    var $jxg43;
    var $aDODq;
    var $cMo1a;
    var $8KrAm;
    var $2OMIu = parcelRequire("2OMIu");
    function $e045cf746f0b4756$var$GridColumns(_ref) {
        let { top: top = 0, left: left = 0, scale: scale, height: height, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
        if (hide) return null;
        const { ticks: ticks } = (0, (0, parcelRequire("kq3PX")).useAxisTicks)({
            scale: scale,
            numTicks: numTicks,
            tickValues: tickValues,
            tickLength: 8,
            orientation: (0, (0, parcelRequire("jxg43")).default).bottom,
            rangePadding: undefined
        });
        const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, (0, parcelRequire("8KrAm")).default)(scale) / 2;
        const tickLines = ticks.map((_ref2)=>{
            var _coerceNumber;
            let { value: value, index: index } = _ref2;
            const x = ((_coerceNumber = (0, (0, parcelRequire("cMo1a")).default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
            return {
                index: index,
                from: new (0, (0, parcelRequire("aDODq")).default)({
                    x: x,
                    y: 0
                }),
                to: new (0, (0, parcelRequire("aDODq")).default)({
                    x: x,
                    y: height
                })
            };
        });
        return (0, $2OMIu.jsx)("div", {
            style: {
                top: top,
                left: left,
                position: 'relative'
            },
            children: tickLines.map((_ref3)=>{
                let { from: from, to: to, index: index } = _ref3;
                return (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("hqZma")).AxisBottomTick), {
                            from: from,
                            to: to
                        }),
                        (0, $2OMIu.jsx)("div", {
                            style: {
                                borderLeft: `${stroke} ${lineStyle} ${strokeWidth}px`,
                                height: `${to.y}px`,
                                position: 'absolute',
                                left: to.x
                            }
                        })
                    ]
                }, `grid-columns-lines-${index}-${from.toArray()}-${to.toArray()}`);
            })
        });
    }
    const $e045cf746f0b4756$export$22a67e3ff32a357a = (0, (0, parcelRequire("bT1Sw")).element)($e045cf746f0b4756$var$GridColumns);
});
parcelRegister("8KrAm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65e80487c092a9cc$export$2e2bcd8739ae039);
    function $65e80487c092a9cc$export$2e2bcd8739ae039(scale) {
        return 'bandwidth' in scale ? scale.bandwidth() : 0;
    }
});
parcelRegister("f6BRA", function(module, exports) {
    $parcel$export(module.exports, "GridRows", ()=>$aff4c96cf8a8e597$export$f7ce055fe2ce64b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $cXzUG;
    var $kq3PX;
    var $jxg43;
    var $aDODq;
    var $cMo1a;
    var $8KrAm;
    var $2OMIu = parcelRequire("2OMIu");
    function $aff4c96cf8a8e597$var$GridRows(_ref) {
        let { top: top = 0, left: left = 0, scale: scale, width: width, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
        if (hide) return null;
        const { ticks: ticks } = (0, (0, parcelRequire("kq3PX")).useAxisTicks)({
            scale: scale,
            numTicks: numTicks,
            tickValues: tickValues,
            tickLength: 8,
            orientation: (0, (0, parcelRequire("jxg43")).default).left,
            rangePadding: undefined
        });
        const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, (0, parcelRequire("8KrAm")).default)(scale) / 2;
        const tickLines = ticks.map((_ref2)=>{
            var _coerceNumber;
            let { value: value, index: index } = _ref2;
            const y = ((_coerceNumber = (0, (0, parcelRequire("cMo1a")).default)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
            return {
                index: index,
                from: new (0, (0, parcelRequire("aDODq")).default)({
                    x: 0,
                    y: y
                }),
                to: new (0, (0, parcelRequire("aDODq")).default)({
                    x: width,
                    y: y
                })
            };
        });
        return (0, $2OMIu.jsx)("div", {
            style: {
                top: top,
                left: left,
                position: 'relative'
            },
            children: tickLines.map((_ref3)=>{
                let { from: from, to: to, index: index } = _ref3;
                return (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("cXzUG")).AxisLeftTick), {
                            from: from,
                            to: to
                        }),
                        (0, $2OMIu.jsx)("div", {
                            style: {
                                borderBottom: `${strokeWidth}px ${lineStyle} ${stroke}`,
                                width: `${to.x}px`,
                                position: 'absolute',
                                top: `calc(${to.y}px)`
                            }
                        })
                    ]
                }, `grid-rows-lines-${index}-${from.toArray()}-${to.toArray()}`);
            })
        });
    }
    const $aff4c96cf8a8e597$export$f7ce055fe2ce64b1 = (0, (0, parcelRequire("bT1Sw")).element)($aff4c96cf8a8e597$var$GridRows);
});
parcelRegister("3B9ij", function(module, exports) {
    $parcel$export(module.exports, "LegendLabel", ()=>$29ec097709f60bdd$export$f77025011665b85c);
    $parcel$export(module.exports, "OrdinalLegend", ()=>$29ec097709f60bdd$export$7f71253a43a34ee6);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZnN2;
    var $bT1Sw;
    var $17PP9;
    var $7Nxvv;
    var $gEnb9;
    var $2OMIu = parcelRequire("2OMIu");
    const $29ec097709f60bdd$export$83dfac8e05432e26 = {
        color: "var(--ds-text-subtlest, #626F86)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: '12px',
        margin: '8px 0px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
    const $29ec097709f60bdd$var$LegendSymbol = (_ref)=>{
        let { color: color, shape: shape } = _ref;
        let symbol;
        switch(shape){
            case 'square':
                symbol = (0, $2OMIu.jsx)("rect", {
                    fill: color,
                    width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                    height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                    rx: 1,
                    ry: 1
                });
                break;
            case 'line':
                symbol = (0, $2OMIu.jsx)("line", {
                    x1: 0,
                    y1: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                    x2: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                    y2: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                    stroke: color,
                    strokeWidth: 2
                });
                break;
            case 'circle':
            default:
                symbol = (0, $2OMIu.jsx)("rect", {
                    fill: color,
                    width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                    height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                    rx: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2,
                    ry: (0, $0bd291d77cbdd29d$export$1949567a35c96224) / 2
                });
        }
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o"
            ]),
            children: (0, $2OMIu.jsx)("svg", {
                width: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                height: (0, $0bd291d77cbdd29d$export$1949567a35c96224),
                children: symbol
            })
        });
    };
    const $29ec097709f60bdd$export$f77025011665b85c = (0, (0, parcelRequire("bT1Sw")).element)((_ref2)=>{
        let { labelAccessor: labelAccessor, datum: datum } = _ref2;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
            ]),
            children: labelAccessor(datum)
        });
    });
    const $29ec097709f60bdd$var$VerticalLegendMark = (_ref3)=>{
        let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref3;
        const label = labelAccessor(datum);
        const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, (0, parcelRequire("iZnN2")).default)();
        return (0, $2OMIu.jsxs)("div", {
            style: {
                opacity: opacity
            },
            onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
            onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"
            ]),
            children: [
                (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                    color: color,
                    shape: shape
                }),
                (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                    datum: datum,
                    labelAccessor: labelAccessor
                })
            ]
        });
    };
    const $29ec097709f60bdd$var$HorizontalLegendMark = (_ref4)=>{
        let { color: color, labelAccessor: labelAccessor, shape: shape, opacity: opacity, datum: datum } = _ref4;
        const label = labelAccessor(datum);
        const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, (0, parcelRequire("iZnN2")).default)();
        return (0, $2OMIu.jsxs)("div", {
            style: {
                opacity: opacity
            },
            onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
            onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"
            ]),
            children: [
                (0, $2OMIu.jsx)($29ec097709f60bdd$var$LegendSymbol, {
                    color: color,
                    shape: shape
                }),
                (0, $2OMIu.jsx)($29ec097709f60bdd$export$f77025011665b85c, {
                    labelAccessor: labelAccessor,
                    datum: datum
                })
            ]
        });
    };
    function $29ec097709f60bdd$var$VerticalLegend(_ref5) {
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref5;
        const legendRef = (0, $5uXOq.useRef)(null);
        const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
        const flatData = (0, (0, parcelRequire("gEnb9")).useFlatData)({
            labelAccessor: labelAccessor,
            data: data
        });
        (0, (0, parcelRequire("gEnb9")).useTruncationIndexObserver)({
            legendRefCurrent: legendRef.current,
            setTruncationIndex: setTruncationIndex
        });
        const itemsToTruncate = flatData.length - (truncationIndex || 0);
        return (0, $2OMIu.jsx)("div", {
            ref: legendRef,
            style: {
                maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
                justifyContent: justifyContent
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"
            ]),
            children: flatData.map((d, i)=>(0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsxs)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: [
                                (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                                    color: colorScale(colorAccessor(d)),
                                    labelAccessor: labelAccessor,
                                    shape: shape,
                                    opacity: 0,
                                    datum: d
                                }, labelAccessor(d)),
                                truncationIndex - 1 === i && (0, $2OMIu.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0
                                    },
                                    className: (0, (0, parcelRequire("bwpsq")).default)([
                                        "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                    ]),
                                    children: ` ... ${itemsToTruncate + 1} more`
                                })
                            ]
                        })
                    }) : (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegendMark, {
                        color: colorScale(colorAccessor(d)),
                        labelAccessor: labelAccessor,
                        shape: shape,
                        datum: d
                    }, labelAccessor(d))
                }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
        });
    }
    function $29ec097709f60bdd$var$HorizontalLegend(_ref6) {
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', flexDirection: flexDirection = 'row', maxRows: maxRows = 5 } = _ref6;
        const legendRef = (0, $5uXOq.useRef)(null);
        const [truncationIndex, setTruncationIndex] = (0, $5uXOq.useState)((0, $0bd291d77cbdd29d$export$7bf402e928540137));
        const flatData = (0, (0, parcelRequire("gEnb9")).useFlatData)({
            labelAccessor: labelAccessor,
            data: data
        });
        (0, (0, parcelRequire("gEnb9")).useTruncationIndexObserver)({
            legendRefCurrent: legendRef.current,
            setTruncationIndex: setTruncationIndex
        });
        const itemsToTruncate = flatData.length - (truncationIndex || 0);
        return (0, $2OMIu.jsx)("div", {
            ref: legendRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx21o5q _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"
            ]),
            style: {
                maxHeight: `${maxRows * (0, $0bd291d77cbdd29d$export$bc48d9a7fd313bb2) + 2}px`,
                justifyContent: justifyContent,
                "--_j9pi5t": (0, (0, parcelRequire("lD23V")).default)(flexDirection)
            },
            children: flatData.map((d, i)=>(0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: itemsToTruncate > 0 && truncationIndex - 1 === i ? (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsxs)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: [
                                (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                                    color: colorScale(colorAccessor(d)),
                                    labelAccessor: labelAccessor,
                                    shape: shape,
                                    opacity: 0,
                                    datum: d
                                }, labelAccessor(d)),
                                (0, $2OMIu.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0
                                    },
                                    className: (0, (0, parcelRequire("bwpsq")).default)([
                                        "_syaz131l _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                    ]),
                                    children: ` ... ${itemsToTruncate + 1} more`
                                })
                            ]
                        })
                    }) : (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegendMark, {
                        color: colorScale(colorAccessor(d)),
                        labelAccessor: labelAccessor,
                        shape: shape,
                        datum: d
                    }, labelAccessor(d))
                }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
        });
    }
    function $29ec097709f60bdd$export$734b3ee2d20431e7(_ref7) {
        var _layoutProps$gridTemp;
        let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, flexDirection: flexDirection = 'row', hide: hide = false } = _ref7;
        const layoutProps = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("7Nxvv")).Layout));
        const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
        if (hide) return null;
        if (sideBySide) return (0, $2OMIu.jsx)($29ec097709f60bdd$var$VerticalLegend, {
            data: data,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            labelAccessor: labelAccessor,
            shape: shape,
            maxRows: maxRows,
            justifyContent: justifyContent
        });
        return (0, $2OMIu.jsx)($29ec097709f60bdd$var$HorizontalLegend, {
            data: data,
            colorAccessor: colorAccessor,
            colorScale: colorScale,
            labelAccessor: labelAccessor,
            shape: shape,
            maxRows: maxRows,
            justifyContent: justifyContent,
            flexDirection: flexDirection
        });
    }
    const $29ec097709f60bdd$export$7f71253a43a34ee6 = (0, (0, parcelRequire("bT1Sw")).element)($29ec097709f60bdd$export$734b3ee2d20431e7);
});
parcelRegister("iZnN2", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$dd3060ab55d6e4ba$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "SERIES_SOURCE", ()=>$dd3060ab55d6e4ba$export$8312cda563b4f1d7);
    $parcel$export(module.exports, "default", ()=>$dd3060ab55d6e4ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lI55a;
    const $dd3060ab55d6e4ba$export$76a2e4c433c23bb9 = 'pointermove';
    const $dd3060ab55d6e4ba$export$8312cda563b4f1d7 = 'series-key-highlight';
    function $dd3060ab55d6e4ba$export$2e2bcd8739ae039(eventType) {
        if (eventType === void 0) eventType = $dd3060ab55d6e4ba$export$76a2e4c433c23bb9;
        const emit = (0, (0, parcelRequire("lI55a")).default)();
        const emitActiveSeriesKey = (0, $5uXOq.useCallback)((event, label)=>emit === null || emit === void 0 ? void 0 : emit(eventType, event, $dd3060ab55d6e4ba$export$8312cda563b4f1d7, label), [
            emit
        ]);
        return {
            emitActiveSeriesKey: emitActiveSeriesKey
        };
    }
});
parcelRegister("lI55a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fce1a64b58ee40be$export$2e2bcd8739ae039);
    var $eIrko;
    var $5uXOq = parcelRequire("5uXOq");
    var $fsVNF;
    function $fce1a64b58ee40be$export$2e2bcd8739ae039(eventType, handler, allowedSources) {
        const emitter = (0, $5uXOq.useContext)((0, (0, parcelRequire("fsVNF")).default));
        const allowedSourcesRef = (0, $5uXOq.useRef)();
        allowedSourcesRef.current = allowedSources;
        const emit = (0, $5uXOq.useCallback)((type, event, source, datum)=>{
            if (emitter) emitter.emit(type, {
                event: event,
                svgPoint: (0, (0, parcelRequire("eIrko")).default)(event),
                source: source,
                datum: datum
            });
        }, [
            emitter
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (emitter && eventType && handler) {
                const handlerWithSourceFilter = (params)=>{
                    var _allowedSourcesRef$cu;
                    if (!allowedSourcesRef.current || params !== null && params !== void 0 && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) !== null && _allowedSourcesRef$cu !== void 0 && _allowedSourcesRef$cu.includes(params.source)) handler(params);
                };
                emitter.on(eventType, handlerWithSourceFilter);
                return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
            }
            return undefined;
        }, [
            emitter,
            eventType,
            handler
        ]);
        return emitter ? emit : null;
    }
});
parcelRegister("fsVNF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4264e6f736a6013$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b4264e6f736a6013$var$EventEmitterContext = (0, $5uXOq.createContext)(null);
    var $b4264e6f736a6013$export$2e2bcd8739ae039 = $b4264e6f736a6013$var$EventEmitterContext;
});
const $0bd291d77cbdd29d$export$e64d201155cc8fe2 = 160;
const $0bd291d77cbdd29d$export$bc48d9a7fd313bb2 = 32;
const $0bd291d77cbdd29d$export$fece36e05d7a6c7b = 8;
const $0bd291d77cbdd29d$export$57cb39d4eda3140a = 16;
const $0bd291d77cbdd29d$export$1949567a35c96224 = 12;
const $0bd291d77cbdd29d$export$3a3ed70a2e553a67 = 2;
const $0bd291d77cbdd29d$export$7bf402e928540137 = 10000;
parcelRegister("gEnb9", function(module, exports) {
    $parcel$export(module.exports, "useTruncationIndexObserver", ()=>$c1f25c9c571436f1$export$ec599d67f76e7af7);
    $parcel$export(module.exports, "useFlatData", ()=>$c1f25c9c571436f1$export$f27cffe517b2d3a3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c1f25c9c571436f1$export$178827bcd84b6d71 = (data, labelAccessor)=>{
        return data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = d;
            return newFlatData;
        }, {});
    };
    const $c1f25c9c571436f1$export$5303528d1070ff6f = (value)=>{
        if (value === 'normal') return 8;
        else return parseFloat(value);
    };
    function $c1f25c9c571436f1$export$ec599d67f76e7af7(_ref) {
        let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
        (0, $5uXOq.useEffect)(()=>{
            const observer = new ResizeObserver((entries)=>{
                let fit = 0;
                const content = [
                    ...entries[0].target.children
                ];
                content.forEach((d)=>{
                    if (!$c1f25c9c571436f1$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
                });
                setTruncationIndex(fit);
            });
            if (legendRefCurrent) observer.observe(legendRefCurrent);
            return ()=>{
                if (legendRefCurrent) observer.unobserve(legendRefCurrent);
            };
        }, [
            legendRefCurrent,
            setTruncationIndex
        ]);
    }
    const $c1f25c9c571436f1$export$660f61eb7bd5242a = (parent, child)=>{
        const box1coords = parent.getBoundingClientRect();
        const box2coords = child.getBoundingClientRect();
        if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
        return false;
    };
    function $c1f25c9c571436f1$export$f27cffe517b2d3a3(_ref2) {
        let { labelAccessor: labelAccessor, data: data } = _ref2;
        return (0, $5uXOq.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
                const label = labelAccessor(d);
                if (flat[label]) return flat;
                const newFlatData = {
                    ...flat
                };
                newFlatData[label] = {
                    ...d
                };
                return newFlatData;
            }, {})), [
            labelAccessor,
            data
        ]);
    }
});
parcelRegister("iTGbP", function(module, exports) {
    $parcel$export(module.exports, "PrivateBar", ()=>$dc1e1713f476a0f6$export$79dfc6df660f8241);
    $parcel$export(module.exports, "Bar", ()=>$dc1e1713f476a0f6$export$bbc6c6369b38e3d1);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    function $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, radius) {
        if (radius === void 0) radius = {};
        const xEnd = x + width;
        const yEnd = y + height;
        const { topLeft: topLeft = 0, topRight: topRight = 0, bottomLeft: bottomLeft = 0, bottomRight: bottomRight = 0 } = radius;
        return `M${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    L${xEnd - (topRight !== null && topRight !== void 0 ? topRight : 0)} ${y}
    A${topRight !== null && topRight !== void 0 ? topRight : 0} ${topRight !== null && topRight !== void 0 ? topRight : 0} 0 0 1 ${xEnd} ${y + (topRight !== null && topRight !== void 0 ? topRight : 0)}
    L${xEnd} ${yEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)}
    A${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} ${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} 0 0 1 ${xEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)} ${yEnd}
    L${x + (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)} ${yEnd}
    A${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} ${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} 0 0 1 ${x} ${yEnd - (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)}
    L${x} ${y + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)}
    A${topLeft !== null && topLeft !== void 0 ? topLeft : 0} ${topLeft !== null && topLeft !== void 0 ? topLeft : 0} 0 0 1 ${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    Z`;
    }
    const $dc1e1713f476a0f6$var$barStyles = null;
    function $dc1e1713f476a0f6$export$79dfc6df660f8241(_ref) {
        let { datum: datum, innerRef: innerRef, ariaLabel: ariaLabel, x: x, y: y, width: width, height: height, cornerRadius: cornerRadius, fill: fill, opacity: opacity } = _ref;
        const d = $dc1e1713f476a0f6$var$createPathFromRoundedRect(x, y, width, height, cornerRadius);
        return (0, $2OMIu.jsx)("path", {
            fill: fill,
            opacity: opacity,
            role: "img",
            "aria-label": ariaLabel,
            ref: innerRef,
            d: d,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_v564g17y"
            ])
        });
    }
    const $dc1e1713f476a0f6$export$bbc6c6369b38e3d1 = (0, (0, parcelRequire("bT1Sw")).element)($dc1e1713f476a0f6$export$79dfc6df660f8241);
});
parcelRegister("cgmj2", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ORDINAL_COLORS", ()=>$8ed8482abbab76e7$export$1a2fb10b6c1fe2eb);
    $parcel$export(module.exports, "DEFAULT_ORDINAL_PATTERNS_DEFS", ()=>$8ed8482abbab76e7$export$3b4caf16b18628d7);
    $parcel$export(module.exports, "useThemeFillStyles", ()=>$8ed8482abbab76e7$export$c533e33795ec3ca2);
    $parcel$export(module.exports, "Theme", ()=>$8ed8482abbab76e7$export$14faa19a0f3bbeb2);
    var $bT1Sw;
    var $d9B5x;
    var $dTtIr;
    var $7jqLY;
    var $9VXb2;
    var $ekGvZ;
    var $e1sbT;
    var $2OMIu = parcelRequire("2OMIu");
    const $8ed8482abbab76e7$export$f32b764d072ed1b7 = [
        "var(--ds-chart-categorical-1, #2898BD)",
        "var(--ds-chart-categorical-2, #5E4DB2)",
        "var(--ds-chart-categorical-3, #E56910)",
        "var(--ds-chart-categorical-4, #943D73)",
        "var(--ds-chart-categorical-5, #09326C)",
        "var(--ds-chart-categorical-6, #8F7EE7)",
        "var(--ds-chart-categorical-7, #50253F)",
        "var(--ds-chart-categorical-8, #A54800)"
    ];
    const $8ed8482abbab76e7$export$5d11cb9bccf8f5db = [
        {
            key: 'danger',
            value: "var(--ds-chart-danger, #F15B50)"
        },
        {
            key: 'warning',
            value: "var(--ds-chart-warning, #B38600)"
        },
        {
            key: 'success',
            value: "var(--ds-chart-success, #22A06B)"
        },
        {
            key: 'discovery',
            value: "var(--ds-chart-discovery, #8F7EE7)"
        },
        {
            key: 'information',
            value: "var(--ds-chart-information, #388BFF)"
        },
        {
            key: 'neutral',
            value: "var(--ds-chart-neutral, #8590A2)"
        }
    ];
    const $8ed8482abbab76e7$export$f29a3c9071a2ca9 = [
        "var(--ds-chart-red-bold, #2898BD)",
        "var(--ds-chart-orange-bold, #943D73)",
        "var(--ds-chart-yellow-bold, #E56910)",
        "var(--ds-chart-lime-bold, #5E4DB2)",
        "var(--ds-chart-green-bold, #09326C)",
        "var(--ds-chart-teal-bold, #09326C)",
        "var(--ds-chart-blue-bold, #8F7EE7)",
        "var(--ds-chart-purple-bold, #50253F)",
        "var(--ds-chart-magenta-bold, #A54800)",
        "var(--ds-chart-gray-bold, #A54800)",
        "var(--ds-chart-red-boldest, #2898BD)",
        "var(--ds-chart-orange-boldest, #943D73)",
        "var(--ds-chart-yellow-boldest, #E56910)",
        "var(--ds-chart-lime-boldest, #5E4DB2)",
        "var(--ds-chart-green-boldest, #09326C)",
        "var(--ds-chart-teal-boldest, #09326C)",
        "var(--ds-chart-blue-boldest, #8F7EE7)",
        "var(--ds-chart-purple-boldest, #50253F)",
        "var(--ds-chart-magenta-boldest, #A54800)",
        "var(--ds-chart-gray-boldest, #A54800)"
    ];
    const $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb = [
        "var(--ds-chart-brand, #2898BD)",
        "var(--ds-chart-orange-bold, #943D73)",
        "var(--ds-chart-magenta-bold, #E56910)",
        "var(--ds-chart-lime-bold, #5E4DB2)",
        "var(--ds-chart-purple-bold, #09326C)",
        "var(--ds-chart-teal-bold, #8F7EE7)",
        "var(--ds-chart-green-bold, #50253F)",
        "var(--ds-chart-blue-boldest, #A54800)"
    ];
    const $8ed8482abbab76e7$export$3b4caf16b18628d7 = [
        (0, $2OMIu.jsx)((0, (0, parcelRequire("ekGvZ")).default), {
            id: 'lines1',
            height: 5,
            width: 5,
            stroke: '#000000',
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[0],
            strokeWidth: 1,
            orientation: [
                'diagonal'
            ]
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("7jqLY")).default), {
            id: 'crosshair1',
            width: 5,
            height: 5,
            stroke: '#000000',
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[1],
            strokeWidth: 0.7,
            rotation: 45,
            gap: 7
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("ekGvZ")).default), {
            id: 'lines2',
            height: 5,
            width: 5,
            stroke: '#000000',
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[2],
            strokeWidth: 1,
            orientation: [
                'diagonalRightToLeft'
            ]
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("7jqLY")).default), {
            id: 'crosshair2',
            width: 10,
            height: 10,
            stroke: '#000000',
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[3],
            strokeWidth: 0.5,
            rotation: 45,
            gap: 7
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("dTtIr")).default), {
            id: "circles1",
            height: 8,
            width: 8,
            radius: 1,
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[4],
            stroke: '#000000',
            strokeWidth: 0.4,
            complement: true,
            fill: 'none'
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("e1sbT")).default), {
            id: "waves1",
            height: 6,
            width: 6,
            stroke: '#000000',
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[5],
            strokeWidth: 0.5
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("9VXb2")).default), {
            id: "hexagons1",
            height: 3,
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[6],
            size: 3,
            gap: 2,
            strokeWidth: 0.5,
            stroke: "#000000"
        }),
        (0, $2OMIu.jsx)((0, (0, parcelRequire("ekGvZ")).default), {
            id: "lines3",
            height: 6,
            width: 5,
            stroke: '#000000',
            strokeDasharray: 3,
            background: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb[7],
            orientation: [
                'horizontal'
            ]
        })
    ];
    const $8ed8482abbab76e7$export$7b0a836186aa9014 = (0, (0, parcelRequire("d9B5x")).getPatternUrls)($8ed8482abbab76e7$export$3b4caf16b18628d7);
    const $8ed8482abbab76e7$export$c533e33795ec3ca2 = (_ref)=>{
        let { fillStyles: customFillStyles, enableDefaultPatterns: enableDefaultPatterns } = _ref;
        const fillStyles = enableDefaultPatterns ? $8ed8482abbab76e7$export$7b0a836186aa9014 : customFillStyles;
        if (!fillStyles) return {
            range: [],
            domain: []
        };
        if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
            domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
            range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
        };
        else return {
            range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
        };
    };
    const $8ed8482abbab76e7$export$14faa19a0f3bbeb2 = (0, (0, parcelRequire("bT1Sw")).element)((_ref2)=>{
        let { children: children } = _ref2;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children
        });
    });
    const $8ed8482abbab76e7$export$569885e57444f84a = {
        accessibleCategorical: $8ed8482abbab76e7$export$f32b764d072ed1b7,
        categorical: $8ed8482abbab76e7$export$1a2fb10b6c1fe2eb,
        status: $8ed8482abbab76e7$export$5d11cb9bccf8f5db,
        categorical20: $8ed8482abbab76e7$export$f29a3c9071a2ca9,
        accessiblePatternDefs: $8ed8482abbab76e7$export$3b4caf16b18628d7
    };
});
parcelRegister("d9B5x", function(module, exports) {
    $parcel$export(module.exports, "getPatternUrls", ()=>$9938e29a28d7097f$export$c66920886885446e);
    const $9938e29a28d7097f$export$c66920886885446e = (patterns)=>{
        if (!patterns) return [];
        return patterns.map((pattern)=>`url(#${pattern.props.id})`);
    };
});
parcelRegister("dTtIr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1d77660c0b91a6c$export$2e2bcd8739ae039);
    var $12tJU;
    var $2OMIu = parcelRequire("2OMIu");
    function $a1d77660c0b91a6c$export$2e2bcd8739ae039(_ref) {
        var _corners;
        let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
        let corners;
        if (complement) corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("12tJU")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                (0, $2OMIu.jsx)("circle", {
                    cx: width / 2,
                    cy: height / 2,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }),
                (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                    let [cornerX, cornerY] = _ref2;
                    return (0, $2OMIu.jsx)("circle", {
                        cx: cornerX,
                        cy: cornerY,
                        r: radius,
                        fill: fill,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray
                    }, `${id}-complement-${cornerX}-${cornerY}`);
                })
            ]
        });
    }
});
parcelRegister("12tJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    function $0c1d0bfb9e2e6ff6$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, children: children } = _ref;
        return (0, $2OMIu.jsx)("defs", {
            children: (0, $2OMIu.jsx)("pattern", {
                id: id,
                width: width,
                height: height,
                patternUnits: "userSpaceOnUse",
                children: children
            })
        });
    }
});
parcelRegister("7jqLY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$552f134aa047ca1f$export$2e2bcd8739ae039);
    var $12tJU;
    var $2OMIu = parcelRequire("2OMIu");
    function $552f134aa047ca1f$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, stroke: stroke = 'black', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, background: background, className: className, rotation: rotation = 0, gap: gap = 10 } = _ref;
        const halfGap = gap / 2;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("12tJU")).default), {
            id: id,
            width: gap,
            height: gap,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: gap,
                    height: gap,
                    fill: background
                }),
                (0, $2OMIu.jsxs)("g", {
                    transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
                    children: [
                        (0, $2OMIu.jsx)("line", {
                            x1: halfGap - width / 2,
                            y1: halfGap,
                            x2: halfGap + width / 2,
                            y2: halfGap,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            strokeDasharray: strokeDasharray
                        }),
                        (0, $2OMIu.jsx)("line", {
                            x1: halfGap,
                            y1: halfGap - height / 2,
                            x2: halfGap,
                            y2: halfGap + height / 2,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            strokeDasharray: strokeDasharray
                        })
                    ]
                })
            ]
        });
    }
});
parcelRegister("9VXb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73b7573cb69bdfa6$export$2e2bcd8739ae039);
    var $j92zy;
    var $2OMIu = parcelRequire("2OMIu");
    function $73b7573cb69bdfa6$export$2e2bcd8739ae039(_ref) {
        let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, shapeRendering: shapeRendering, background: background, className: className, size: size = 3, gap: gap = 0 } = _ref;
        const hexWidth = size * Math.sqrt(3) + gap;
        const hexHeight = size * 2 + gap;
        const path = `
        M ${size * Math.sqrt(3) / 2 + gap / 2},${gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size / 2 + gap / 2}
        L ${size * Math.sqrt(3) + gap / 2},${size * 1.5 + gap / 2}
        L ${size * Math.sqrt(3) / 2 + gap / 2},${size * 2 + gap / 2}
        L ${gap / 2},${size * 1.5 + gap / 2}
        L ${gap / 2},${size / 2 + gap / 2}
        Z
    `;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("j92zy")).default), {
            path: path,
            id: id,
            width: hexWidth,
            height: hexHeight,
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            shapeRendering: shapeRendering,
            background: background
        });
    }
});
parcelRegister("j92zy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df00da6821c1721f$export$2e2bcd8739ae039);
    var $12tJU;
    var $2OMIu = parcelRequire("2OMIu");
    function $df00da6821c1721f$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("12tJU")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                (0, $2OMIu.jsx)("path", {
                    d: path,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                })
            ]
        });
    }
});
parcelRegister("ekGvZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6f3e98601748030$export$2e2bcd8739ae039);
    var $1GwA3;
    var $12tJU;
    var $2OMIu = parcelRequire("2OMIu");
    function $a6f3e98601748030$export$777054cdc3eb6ab2(_ref) {
        let { height: height, orientation: orientation } = _ref;
        switch(orientation){
            case (0, (0, parcelRequire("1GwA3")).PatternOrientation).horizontal:
                return `M 0,${height / 2} l ${height},0`;
            case (0, (0, parcelRequire("1GwA3")).PatternOrientation).diagonal:
                return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
            case (0, (0, parcelRequire("1GwA3")).PatternOrientation).diagonalRightToLeft:
                return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
            case (0, (0, parcelRequire("1GwA3")).PatternOrientation).vertical:
            default:
                return `M ${height / 2}, 0 l 0, ${height}`;
        }
    }
    function $a6f3e98601748030$export$2e2bcd8739ae039(_ref2) {
        let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
            'vertical'
        ], background: background, className: className } = _ref2;
        const orientations = Array.isArray(orientation) ? orientation : [
            orientation
        ];
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("12tJU")).default), {
            id: id,
            width: width,
            height: height,
            children: [
                !!background && (0, $2OMIu.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: background
                }),
                orientations.map((o, i)=>(0, $2OMIu.jsx)("path", {
                        d: $a6f3e98601748030$export$777054cdc3eb6ab2({
                            orientation: o,
                            height: height
                        }),
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        strokeDasharray: strokeDasharray,
                        strokeLinecap: strokeLinecap,
                        shapeRendering: shapeRendering
                    }, `visx-${id}-line-${o}-${i}`))
            ]
        });
    }
});
parcelRegister("1GwA3", function(module, exports) {
    $parcel$export(module.exports, "PatternOrientation", ()=>$13a2fc7b62d049a2$export$c37d4d4692ef0c91);
    const $13a2fc7b62d049a2$export$c37d4d4692ef0c91 = {
        horizontal: 'horizontal',
        vertical: 'vertical',
        diagonal: 'diagonal',
        diagonalRightToLeft: 'diagonalRightToLeft'
    };
});
parcelRegister("e1sbT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a35706caca164049$export$2e2bcd8739ae039);
    var $j92zy;
    var $2OMIu = parcelRequire("2OMIu");
    function $a35706caca164049$export$2e2bcd8739ae039(_ref) {
        let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("j92zy")).default), {
            path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
            id: id,
            width: width,
            height: height,
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            strokeLinecap: strokeLinecap,
            shapeRendering: shapeRendering,
            background: background
        });
    }
});
parcelRegister("1Tf3y", function(module, exports) {
    $parcel$export(module.exports, "TooltipHeader", ()=>$16069b6018acac22$export$fd7ac08b5fcaeea);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $16069b6018acac22$var$headerCss = null;
    function $16069b6018acac22$var$TooltipHeader(_ref) {
        let { children: children, hide: hide, datum: datum } = _ref;
        if (hide) return null;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"
            ]),
            children: children
        });
    }
    const $16069b6018acac22$export$fd7ac08b5fcaeea = (0, (0, parcelRequire("bT1Sw")).element)($16069b6018acac22$var$TooltipHeader);
});
parcelRegister("lA40p", function(module, exports) {
    $parcel$export(module.exports, "TooltipRow", ()=>$fb601131272529e7$export$4cf463b4a9fc631a);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    const $fb601131272529e7$var$outerDivCss = null;
    const $fb601131272529e7$var$innerDivCss = null;
    const $fb601131272529e7$var$colorItemCss = null;
    const $fb601131272529e7$var$labelItemCss = null;
    const $fb601131272529e7$var$valueItemCss = null;
    function $fb601131272529e7$var$TooltipRow(_ref) {
        let { color: color, label: label, value: value, datum: datum } = _ref;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
            ]),
            children: (0, $2OMIu.jsxs)("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                ]),
                children: [
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                        ]),
                        children: (0, $2OMIu.jsx)("svg", {
                            style: {
                                width: 12,
                                height: 12,
                                borderRadius: 2
                            },
                            children: (0, $2OMIu.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                fill: color
                            })
                        })
                    }),
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"
                        ]),
                        children: label
                    }),
                    (0, $2OMIu.jsx)("div", {
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"
                        ]),
                        children: value
                    })
                ]
            })
        });
    }
    const $fb601131272529e7$export$4cf463b4a9fc631a = (0, (0, parcelRequire("bT1Sw")).element)($fb601131272529e7$var$TooltipRow);
});
parcelRegister("02ifK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$006e58b2f5bf66cd$export$2e2bcd8739ae039);
    var $gu0md = parcelRequire("gu0md");
    var $5uXOq = parcelRequire("5uXOq");
    var $fsVNF;
    var $2OMIu = parcelRequire("2OMIu");
    function $006e58b2f5bf66cd$export$2e2bcd8739ae039(_ref) {
        let { children: children } = _ref;
        const emitter = (0, $5uXOq.useMemo)(()=>(0, $gu0md.default)(), []);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("fsVNF")).default).Provider, {
            value: emitter,
            children: children
        });
    }
});
parcelRegister("gu0md", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfffb9a55931417f$export$2e2bcd8739ae039);
    function $bfffb9a55931417f$export$2e2bcd8739ae039(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i ? i.push(e) : n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
            },
            emit: function(t, e) {
                var i = n.get(t);
                i && i.slice().map(function(n) {
                    n(e);
                }), (i = n.get("*")) && i.slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    }
});
parcelRegister("e0UVN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a33d3a1e9d33e815$export$2e2bcd8739ae039);
    var $2qM0c = parcelRequire("2qM0c");
    var $5uXOq = parcelRequire("5uXOq");
    var $f76Li;
    var $lrseF;
    var $2OMIu = parcelRequire("2OMIu");
    function $a33d3a1e9d33e815$var$isValidNumber(_) {
        return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
    }
    function $a33d3a1e9d33e815$export$2e2bcd8739ae039(_ref) {
        let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
        const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, (0, parcelRequire("f76Li")).default)(undefined);
        const debouncedHideTooltip = (0, $5uXOq.useRef)(null);
        function cancelDeboundedHideTooltip() {
            if (debouncedHideTooltip.current) {
                debouncedHideTooltip.current.cancel();
                debouncedHideTooltip.current = null;
            }
        }
        (0, $5uXOq.useEffect)(()=>cancelDeboundedHideTooltip, []);
        const showTooltip = (0, $5uXOq.useRef)((_ref2)=>{
            let { svgPoint: svgPoint, index: index, datum: datum, distanceX: distanceX, distanceY: distanceY, nearestSeriesData: nearestSeriesData, event: event } = _ref2;
            cancelDeboundedHideTooltip();
            const cleanDistanceX = $a33d3a1e9d33e815$var$isValidNumber(distanceX) ? distanceX : Infinity;
            const cleanDistanceY = $a33d3a1e9d33e815$var$isValidNumber(distanceY) ? distanceY : Infinity;
            const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
            const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
            const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
            updateTooltip((_ref3)=>{
                let { tooltipData: tooltipData } = _ref3;
                return {
                    tooltipOpen: true,
                    tooltipLeft: tooltipLeft,
                    tooltipTop: tooltipTop,
                    tooltipData: {
                        nearestDatum: {
                            index: index,
                            datum: datum,
                            distance: distance
                        },
                        nearestSeriesData: nearestSeriesData
                    }
                };
            });
        });
        const hideTooltip = (0, $5uXOq.useCallback)(()=>{
            debouncedHideTooltip.current = (0, ($parcel$interopDefault($2qM0c)))(privateHideTooltip, hideTooltipDebounceMs);
            debouncedHideTooltip.current();
        }, [
            privateHideTooltip,
            hideTooltipDebounceMs
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                tooltipOpen: tooltipOpen,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: tooltipData,
                updateTooltip: updateTooltip,
                showTooltip: showTooltip.current,
                hideTooltip: hideTooltip
            }), [
            hideTooltip,
            tooltipData,
            tooltipLeft,
            tooltipOpen,
            tooltipTop,
            updateTooltip
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("lrseF")).default).Provider, {
            value: value,
            children: children
        });
    }
});
parcelRegister("f76Li", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b00cc13b202009ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b00cc13b202009ca$export$2e2bcd8739ae039(initialTooltipState) {
        const [tooltipState, setTooltipState] = (0, $5uXOq.useState)({
            tooltipOpen: false,
            ...initialTooltipState
        });
        const showTooltip = (0, $5uXOq.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
                let { tooltipOpen: tooltipOpen, ...show } = _ref;
                return {
                    ...showArgs(show),
                    tooltipOpen: true
                };
            } : {
                tooltipOpen: true,
                tooltipLeft: showArgs.tooltipLeft,
                tooltipTop: showArgs.tooltipTop,
                tooltipData: showArgs.tooltipData
            }), [
            setTooltipState
        ]);
        const hideTooltip = (0, $5uXOq.useCallback)(()=>setTooltipState({
                tooltipOpen: false,
                tooltipLeft: undefined,
                tooltipTop: undefined,
                tooltipData: undefined
            }), [
            setTooltipState
        ]);
        return {
            tooltipOpen: tooltipState.tooltipOpen,
            tooltipLeft: tooltipState.tooltipLeft,
            tooltipTop: tooltipState.tooltipTop,
            tooltipData: tooltipState.tooltipData,
            updateTooltip: setTooltipState,
            showTooltip: showTooltip,
            hideTooltip: hideTooltip
        };
    }
});
parcelRegister("lrseF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9c205926e36fc90$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $f9c205926e36fc90$var$TooltipContext = (0, $5uXOq.createContext)({});
    var $f9c205926e36fc90$export$2e2bcd8739ae039 = $f9c205926e36fc90$var$TooltipContext;
});
parcelRegister("2pOyr", function(module, exports) {
    $parcel$export(module.exports, "MultiSeriesTooltip", ()=>$1c2521aa24f64dee$export$a2bd9600d7197e69);
    var $bT1Sw;
    var $1Tf3y;
    var $lA40p;
    var $5RaE1;
    var $ltC0t;
    var $2OMIu = parcelRequire("2OMIu");
    function $1c2521aa24f64dee$var$MultiSeriesTooltip(_ref) {
        var _tooltipData$nearestD, _window, _window2, _tooltipData$nearestS;
        let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, (0, parcelRequire("ltC0t")).default).formatNumberAbbreviated } = _ref;
        const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
        const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
        const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
        const portalLeft = (tooltipLeft || 0) + scrollX;
        const portalTop = (tooltipTop || 0) + scrollY;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: datum && (0, $2OMIu.jsxs)((0, (0, parcelRequire("5RaE1")).default), {
                left: portalLeft,
                top: portalTop,
                tooltipPortalElement: document.body,
                children: [
                    (0, $2OMIu.jsx)((0, (0, parcelRequire("1Tf3y")).TooltipHeader), {
                        datum: datum,
                        children: xAccessor(datum) instanceof Date ? (0, (0, parcelRequire("ltC0t")).default).multiTimeFormat(xAccessor(datum)) : String(xAccessor(datum))
                    }),
                    tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestS = tooltipData.nearestSeriesData) === null || _tooltipData$nearestS === void 0 ? void 0 : _tooltipData$nearestS.map((d, i)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("lA40p")).TooltipRow), {
                            datum: d,
                            color: colorScale(colorAccessor(d)),
                            label: colorAccessor(d),
                            value: String(valueFormatter(yAccessor(d)))
                        }, String(xAccessor(d)) + i))
                ]
            })
        });
    }
    const $1c2521aa24f64dee$export$a2bd9600d7197e69 = (0, (0, parcelRequire("bT1Sw")).element)($1c2521aa24f64dee$var$MultiSeriesTooltip);
});
parcelRegister("5RaE1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$443a28c41fa47583$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $clgDn;
    var $2OMIu = parcelRequire("2OMIu");
    const $443a28c41fa47583$var$DEFAULT_TRANSLATE = 'translate(0%, -100%)';
    function $443a28c41fa47583$var$TooltipWithBounds(_ref) {
        let { children: children, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = -2, style: style = (0, (0, parcelRequire("clgDn")).defaultStyles), top: initialTop = 0, unstyled: unstyled = false, ...otherProps } = _ref;
        const elementRef = (0, $5uXOq.useRef)(null);
        const [transformStyle, setTransformStyle] = (0, $5uXOq.useState)($443a28c41fa47583$var$DEFAULT_TRANSLATE);
        (0, $5uXOq.useEffect)(()=>{
            var _elementRef$current;
            const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
            if (rect) {
                const outOfViewTop = Math.min(0, initialTop - rect.height);
                const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
                const translateX = outOfViewRight > 0 ? -rect.width : 0;
                const translateY = outOfViewTop < 0 ? 0 : -rect.height;
                setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
            }
        }, [
            initialTop,
            initialLeft,
            elementRef
        ]);
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("clgDn")).default), {
            ref: elementRef,
            style: {
                top: initialTop + offsetTop,
                left: initialLeft + offsetLeft,
                transform: transformStyle,
                transition: 'transform 0.3s',
                ...!unstyled && style
            },
            ...otherProps,
            children: children
        });
    }
    var $443a28c41fa47583$export$2e2bcd8739ae039 = $443a28c41fa47583$var$TooltipWithBounds;
});
parcelRegister("clgDn", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$8fc459612f6eae76$export$214b055320e0bf32);
    $parcel$export(module.exports, "default", ()=>$8fc459612f6eae76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $2OMIu = parcelRequire("2OMIu");
    const $8fc459612f6eae76$export$214b055320e0bf32 = {
        position: 'absolute',
        backgroundColor: "var(--ds-surface-overlay, white)",
        padding: '.3rem .5rem',
        borderRadius: '3px',
        fontSize: '14px',
        boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
        lineHeight: '1em',
        pointerEvents: 'none',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        overflow: 'hidden',
        border: `1px ${"var(--ds-border, grey)"} solid`,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        zIndex: 999,
        display: 'flex'
    };
    const $8fc459612f6eae76$var$Tooltip = (0, $5uXOq.forwardRef)((_ref, ref)=>{
        let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $8fc459612f6eae76$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false } = _ref;
        const elem = (0, $2OMIu.jsx)("div", {
            ref: ref,
            className: className,
            style: {
                top: top == null || offsetTop == null ? top : top + offsetTop,
                left: left == null || offsetLeft == null ? left : left + offsetLeft,
                ...applyPositionStyle && {
                    position: 'absolute'
                },
                ...!unstyled && style
            },
            children: children
        });
        if (tooltipPortalElement) return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $7nsd3.createPortal)(elem, tooltipPortalElement)
        });
        return elem;
    });
    $8fc459612f6eae76$var$Tooltip.displayName = 'Tooltip';
    var $8fc459612f6eae76$export$2e2bcd8739ae039 = $8fc459612f6eae76$var$Tooltip;
});
parcelRegister("arL7j", function(module, exports) {
    $parcel$export(module.exports, "BarGroupMarkLabels", ()=>$79b0f96bd5a8555c$export$d00262aaa41e206c);
    var $bT1Sw;
    var $8WT90;
    var $dnJJh;
    var $2OMIu = parcelRequire("2OMIu");
    const $79b0f96bd5a8555c$export$d00262aaa41e206c = (0, (0, parcelRequire("bT1Sw")).element)(function BarGroupMarkLabels(_ref) {
        let { barGroups: barGroups, hide: hide } = _ref;
        if (hide) return null;
        return barGroups.map((barGroup)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("dnJJh")).default), {
                left: barGroup.x0,
                children: barGroup.bars.map((bar)=>{
                    if (!bar.width || !bar.height) return null;
                    return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsx)((0, (0, parcelRequire("8WT90")).ValueLabel), {
                            x: bar.x + bar.width / 2,
                            y: bar.y + bar.height / 2,
                            color: bar.color,
                            children: bar.yValue.toString()
                        }, `bar-stack-label-${barGroup.index}-${bar.index}`)
                    });
                })
            }, `bar-group-labels-${barGroup.index}-${barGroup.x0}`));
    });
});
parcelRegister("8WT90", function(module, exports) {
    $parcel$export(module.exports, "ValueLabel", ()=>$683e8406f9035644$export$d0e17caf98739ceb);
    var $bwpsq;
    var $bT1Sw;
    var $cwHYm;
    var $ltC0t;
    var $jQ5Qu;
    var $2OMIu = parcelRequire("2OMIu");
    const $683e8406f9035644$var$labelTextStyles = null;
    function $683e8406f9035644$var$ValueLabel(_ref) {
        let { x: x, y: y, color: color, formatter: formatter = (0, (0, parcelRequire("ltC0t")).default).formatNumberAbbreviated, children: children } = _ref;
        if (!children) return null;
        if (typeof children === 'number' || typeof children === 'string') return (0, $2OMIu.jsx)((0, (0, parcelRequire("cwHYm")).default), {
            x: x,
            y: y,
            style: {
                fill: (0, (0, parcelRequire("jQ5Qu")).getMaxContrast)(color)
            },
            verticalAnchor: "middle",
            alignmentBaseline: "central",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1fjgnkob _ect41wi2 _1wyb1crf"
            ]),
            children: formatter(children)
        });
        return children;
    }
    const $683e8406f9035644$export$d0e17caf98739ceb = (0, (0, parcelRequire("bT1Sw")).element)($683e8406f9035644$var$ValueLabel);
});
parcelRegister("cwHYm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91ea953eed024a92$export$2e2bcd8739ae039);
    var $3bDjY;
    var $ikfTR;
    var $2OMIu = parcelRequire("2OMIu");
    const $91ea953eed024a92$var$SVG_STYLE = {
        overflow: 'visible'
    };
    function $91ea953eed024a92$export$2e2bcd8739ae039(props) {
        const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, alignmentBaseline: alignmentBaseline, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: scaleToFit = false, capHeight: capHeight, truncate: truncate, singleline: singleline, children: children, ...textProps } = props;
        const { x: x = 0, fontSize: fontSize } = textProps;
        const { wordsByLines: wordsByLines, startDy: startDy, transform: transform, truncated: truncated } = (0, (0, parcelRequire("ikfTR")).default)(props);
        const textComponent = (0, $2OMIu.jsx)("g", {
            ref: innerRef,
            fontSize: fontSize,
            style: {
                ...$91ea953eed024a92$var$SVG_STYLE,
                transform: `translate(calc(${dx}), calc(${dy}))`
            },
            children: wordsByLines.length > 0 ? (0, $2OMIu.jsx)("text", {
                ref: innerTextRef,
                transform: transform,
                ...textProps,
                textAnchor: textAnchor,
                children: wordsByLines.map((line, index)=>(0, $2OMIu.jsx)("tspan", {
                        alignmentBaseline: alignmentBaseline,
                        x: x,
                        dy: index === 0 ? startDy : lineHeight,
                        children: line.words.join(' ')
                    }, index))
            }) : null
        });
        if (truncated) {
            var _props$children;
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("3bDjY")).default), {
                tag: "g",
                content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
                position: "bottom",
                children: textComponent
            });
        }
        return textComponent;
    }
});
parcelRegister("ikfTR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5766daa0bc60be3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6xQMF = parcelRequire("6xQMF");
    var $lMXX0;
    function $d5766daa0bc60be3$var$isNumber(val) {
        return typeof val === 'number';
    }
    function $d5766daa0bc60be3$var$isXOrYInValid(xOrY) {
        return (typeof xOrY === 'number' && Number.isFinite(xOrY) || typeof xOrY === 'string');
    }
    function $d5766daa0bc60be3$export$2e2bcd8739ae039(props) {
        const { verticalAnchor: verticalAnchor = 'start', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0em', children: children, truncate: truncate, style: style, singleline: singleline, ...textProps } = props;
        const { x: x = 0, y: y = 0 } = textProps;
        const isXOrYNotValid = !$d5766daa0bc60be3$var$isXOrYInValid(x) || !$d5766daa0bc60be3$var$isXOrYInValid(y);
        const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5uXOq.useMemo)(()=>{
            const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
            return {
                wordsWithWidth: words.map((word)=>({
                        word: word,
                        wordWidth: (0, (0, parcelRequire("lMXX0")).default)(word, style) || 0
                    })),
                spaceWidth: (0, (0, parcelRequire("lMXX0")).default)('\u00A0', style) || 0
            };
        }, [
            children,
            style
        ]);
        const { wordsByLines: wordsByLines, truncated: truncated } = (0, $5uXOq.useMemo)(()=>{
            let isTruncated = false;
            if (isXOrYNotValid) return {
                wordsByLines: [],
                truncated: isTruncated
            };
            if (width || scaleToFit) {
                const words = wordsWithWidth.reduce((result, _ref)=>{
                    let { word: word, wordWidth: wordWidth } = _ref;
                    const currentLine = result[result.length - 1];
                    if (currentLine && (width == null || scaleToFit || truncate || singleline || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                        currentLine.words.push(word);
                        currentLine.width = currentLine.width || 0;
                        currentLine.width += wordWidth + spaceWidth;
                    } else {
                        const newLine = {
                            words: [
                                word
                            ],
                            width: wordWidth
                        };
                        result.push(newLine);
                    }
                    return result;
                }, []);
                if (truncate && width) {
                    const ellipsesWidth = (0, (0, parcelRequire("lMXX0")).default)('...', style) || 0;
                    const joinedWords = words[0].words.join('\u00A0');
                    const joinedSubstring = joinedWords.substring(0, (width - ellipsesWidth) / (words[0].width || 0) * joinedWords.length);
                    if (joinedSubstring !== joinedWords) {
                        isTruncated = true;
                        words[0].words = [
                            joinedSubstring + '...'
                        ];
                    }
                }
                return {
                    wordsByLines: words,
                    truncated: isTruncated
                };
            }
            return {
                wordsByLines: [
                    {
                        words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
                    }
                ],
                truncated: isTruncated
            };
        }, [
            isXOrYNotValid,
            width,
            scaleToFit,
            children,
            wordsWithWidth,
            spaceWidth
        ]);
        const startDy = (0, $5uXOq.useMemo)(()=>{
            const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, ($parcel$interopDefault($6xQMF)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, ($parcel$interopDefault($6xQMF)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, ($parcel$interopDefault($6xQMF)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
            return startDyStr;
        }, [
            isXOrYNotValid,
            verticalAnchor,
            capHeight,
            wordsByLines.length,
            lineHeight
        ]);
        const transform = (0, $5uXOq.useMemo)(()=>{
            const transforms = [];
            if (isXOrYNotValid) return '';
            if ($d5766daa0bc60be3$var$isNumber(x) && $d5766daa0bc60be3$var$isNumber(y) && $d5766daa0bc60be3$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
                const lineWidth = wordsByLines[0].width || 1;
                const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
                const sy = sx;
                const originX = x - sx * x;
                const originY = y - sy * y;
                transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
            }
            if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
            return transforms.length > 0 ? transforms.join(' ') : '';
        }, [
            isXOrYNotValid,
            x,
            y,
            width,
            scaleToFit,
            wordsByLines,
            angle
        ]);
        return {
            wordsByLines: wordsByLines,
            startDy: startDy,
            transform: transform,
            truncated: truncated
        };
    }
});
parcelRegister("lMXX0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fdcc959e1e17280b$export$2e2bcd8739ae039);
    const $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
    function $fdcc959e1e17280b$export$2e2bcd8739ae039(str, style) {
        try {
            let textEl = document.getElementById($fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
            if (!textEl) {
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('aria-hidden', 'true');
                svg.style.width = '0';
                svg.style.height = '0';
                svg.style.position = 'absolute';
                svg.style.top = '-100%';
                svg.style.left = '-100%';
                textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                textEl.setAttribute('id', $fdcc959e1e17280b$var$MEASUREMENT_ELEMENT_ID);
                svg.appendChild(textEl);
                document.body.appendChild(svg);
            }
            Object.assign(textEl.style, style);
            textEl.textContent = str;
            return textEl.getComputedTextLength();
        } catch (e) {
            return null;
        }
    }
});
parcelRegister("jQ5Qu", function(module, exports) {
    $parcel$export(module.exports, "getMaxContrast", ()=>$e7176877f098873f$export$499db937e3cd4eb2);
    var $kTHGn;
    var $7UL8A;
    function $e7176877f098873f$var$getLuminance(_ref) {
        let { r: r, g: g, b: b } = _ref;
        const a = [
            r,
            g,
            b
        ].map((v)=>{
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }
    function $e7176877f098873f$var$getContrast(color1, color2) {
        const lum1 = $e7176877f098873f$var$getLuminance(color1) + 0.05;
        const lum2 = $e7176877f098873f$var$getLuminance(color2) + 0.05;
        return Math.max(lum1, lum2) / Math.min(lum1, lum2);
    }
    function $e7176877f098873f$var$getTokenAndFallback(cssVar) {
        const numberMatch = cssVar.match(/\d+/);
        const number = numberMatch ? numberMatch[0] : '';
        const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
        const terms = termsMatch ? termsMatch[1].split('-') : [];
        const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
        const hexColor = hexColorMatch ? hexColorMatch[0] : '';
        const token = `color.${terms.join('.') + '.' + number}`;
        return {
            token: token,
            fallback: hexColor
        };
    }
    function $e7176877f098873f$export$499db937e3cd4eb2(arcColor) {
        const isPattern = arcColor.includes('url');
        const { token: token, fallback: fallback } = $e7176877f098873f$var$getTokenAndFallback(arcColor);
        const colorHex = (0, (0, parcelRequire("kTHGn")).default)(token, fallback);
        const color = (0, (0, parcelRequire("7UL8A")).rgb)(arcColor.startsWith('var(') ? colorHex : arcColor);
        if (isPattern) return 'black';
        if (!color) return '';
        const blackContrast = $e7176877f098873f$var$getContrast(color, (0, (0, parcelRequire("7UL8A")).rgb)('black'));
        const whiteContrast = $e7176877f098873f$var$getContrast(color, (0, (0, parcelRequire("7UL8A")).rgb)('white'));
        if (whiteContrast >= 4.5) return 'white';
        if (blackContrast >= 4.5) return 'black';
        return 'white';
    }
});
parcelRegister("dnJJh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9be0e5401983ef4c$export$2e2bcd8739ae039);
    var $2OMIu = parcelRequire("2OMIu");
    function $9be0e5401983ef4c$export$2e2bcd8739ae039(_ref) {
        let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
        return (0, $2OMIu.jsx)("g", {
            ref: innerRef,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            children: children
        });
    }
});
parcelRegister("dwg9t", function(module, exports) {
    $parcel$export(module.exports, "BarGroupMarks", ()=>$9d7acaf02478f739$export$fe396ea701d4567e);
    var $bT1Sw;
    var $iTGbP;
    var $dnJJh;
    var $dluWU;
    var $2OMIu = parcelRequire("2OMIu");
    const $9d7acaf02478f739$export$fe396ea701d4567e = (0, (0, parcelRequire("bT1Sw")).element)(function BarGroupMarks(_ref) {
        let { barGroups: barGroups, roundedCorners: roundedCorners = false } = _ref;
        return barGroups.map((barGroup)=>{
            return (0, $2OMIu.jsx)((0, (0, parcelRequire("dnJJh")).default), {
                left: barGroup.x0,
                children: barGroup.bars.map((bar)=>{
                    const cornerRadius = roundedCorners && bar.height > 2 * (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL ? (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL : (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).NONE;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("iTGbP")).Bar), {
                        ariaLabel: `${bar.label}, x: ${bar.xValue}, y: ${bar.yValue}`,
                        x: bar.x,
                        y: bar.y,
                        datum: bar.datum,
                        width: bar.width,
                        height: bar.height,
                        fill: bar.color,
                        cornerRadius: {
                            topLeft: cornerRadius,
                            topRight: cornerRadius
                        }
                    }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
                })
            }, `bar-group-marks-${barGroup.index}-${barGroup.x0}`);
        });
    });
});
parcelRegister("dluWU", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_MARGIN", ()=>$9b753e5f48cfde8e$export$6475e56bfff61883);
    $parcel$export(module.exports, "STACK_GAP", ()=>$9b753e5f48cfde8e$export$56b61e27223adae9);
    $parcel$export(module.exports, "CORNER_RADIUS_VALUE", ()=>$9b753e5f48cfde8e$export$a15d94c34ecbca08);
    const $9b753e5f48cfde8e$export$6475e56bfff61883 = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    };
    const $9b753e5f48cfde8e$export$601d4a48e295711b = 150;
    const $9b753e5f48cfde8e$export$56b61e27223adae9 = 1;
    const $9b753e5f48cfde8e$export$4d00931646175b35 = 2;
    const $9b753e5f48cfde8e$export$a15d94c34ecbca08 = {
        SMALL: 2,
        MEDIUM: 4,
        LARGE: 8,
        NONE: 0
    };
});
parcelRegister("ggVTz", function(module, exports) {
    $parcel$export(module.exports, "useMaximumYValue", ()=>$bd8b0cc46655e91a$export$b6f0cda1573da4a7);
    $parcel$export(module.exports, "calculateXScaleDomain", ()=>$bd8b0cc46655e91a$export$25d8e7ab8cac3e31);
    $parcel$export(module.exports, "calculateYDomain", ()=>$bd8b0cc46655e91a$export$d2ffead7cf0bfe5c);
    $parcel$export(module.exports, "BarScalesElement", ()=>$bd8b0cc46655e91a$export$399ec5971eff5385);
    var $hjll3 = parcelRequire("hjll3");
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $17PP9;
    parcelRequire("8WCE9");
    var $i3RkB;
    var $8WCE9;
    var $5pfgu;
    var $juXo4;
    var $6jSGb;
    var $cgmj2;
    function $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data, x, y, stacked) {
        const total = (0, $5uXOq.useMemo)(()=>{
            if (!stacked) return (0, $hjll3.max)(data, y) || 1;
            const grouped = (0, $hjll3.group)(data, x);
            const totals = [];
            grouped.forEach((colorGroup)=>{
                totals.push((0, $hjll3.sum)(colorGroup.map(y)));
            });
            return (0, $hjll3.max)(totals) || 1;
        }, [
            data,
            x,
            y,
            stacked
        ]);
        return total;
    }
    function $bd8b0cc46655e91a$export$25d8e7ab8cac3e31(_ref) {
        let { xData: xData, timeUnit: timeUnit, range: range, padding: padding } = _ref;
        if (timeUnit) {
            const timeExtent = (0, $hjll3.extent)(xData);
            let timeInterval = (0, $hjll3.timeYear);
            switch(timeUnit){
                case 'days':
                    timeInterval = (0, $hjll3.timeDay);
                    break;
                case 'months':
                    timeInterval = (0, $hjll3.timeMonth);
                    break;
                case 'weeks':
                    timeInterval = (0, $hjll3.timeWeek);
                    break;
                default:
                    break;
            }
            const timeDomain = timeInterval.range(timeExtent[0], timeInterval.offset(timeExtent[1], 1), 1);
            return (0, (0, parcelRequire("8WCE9")).scaleBandTime)({
                range: range,
                padding: padding,
                domain: timeDomain
            });
        } else return (0, (0, parcelRequire("i3RkB")).default)({
            domain: [
                ...new Set(xData)
            ],
            range: range,
            padding: padding
        });
    }
    function $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c(_ref2) {
        let { totalYValue: totalYValue, yDomain: yDomain, normalize: normalize } = _ref2;
        const domainOutput = normalize ? [
            0,
            1
        ] : [
            0,
            totalYValue
        ];
        if (yDomain && yDomain[0] != null) domainOutput[0] = yDomain[0];
        if (yDomain && yDomain[1] != null) domainOutput[1] = yDomain[1];
        return domainOutput;
    }
    const $bd8b0cc46655e91a$export$399ec5971eff5385 = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit } = props;
        const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("cgmj2")).Theme));
        const totalYValue = $bd8b0cc46655e91a$export$b6f0cda1573da4a7(data || [], x, y, false);
        const value = (0, $5uXOq.useMemo)(()=>{
            const xScaleRange = [
                0,
                width
            ];
            const xScalePadding = 0.25;
            const xScale = $bd8b0cc46655e91a$export$25d8e7ab8cac3e31({
                xData: data.map(x),
                timeUnit: timeUnit,
                range: xScaleRange,
                padding: xScalePadding
            });
            const groupScale = (0, (0, parcelRequire("i3RkB")).default)({
                domain: [
                    ...new Set(data.map(color))
                ],
                range: [
                    0,
                    (0, (0, parcelRequire("6jSGb")).default)(xScale)
                ],
                padding: 0.1
            });
            const yScale = (0, (0, parcelRequire("5pfgu")).default)({
                domain: $bd8b0cc46655e91a$export$d2ffead7cf0bfe5c({
                    totalYValue: totalYValue,
                    yDomain: yDomain
                }),
                range: [
                    height,
                    0
                ]
            });
            const { domain: domain, range: range } = useThemeFillStyles({
                fillStyles: fillStyles,
                enableDefaultPatterns: enableDefaultPatterns
            });
            const colorScale = (0, (0, parcelRequire("juXo4")).default)({
                domain: domain ? domain : data.map(color),
                range: range
            });
            const seriesData = (0, $hjll3.group)(data, x);
            return {
                xScale: xScale,
                yScale: yScale,
                colorScale: colorScale,
                groupScale: groupScale,
                seriesData: seriesData
            };
        }, [
            data,
            width,
            height,
            totalYValue,
            x,
            yDomain,
            timeUnit,
            fillStyles,
            enableDefaultPatterns
        ]);
        return props.children(value);
    });
});
parcelRegister("8WCE9", function(module, exports) {
    $parcel$export(module.exports, "scaleBandTime", ()=>$6831b7e75dd8af74$export$3664991d076c12bd);
    $parcel$export(module.exports, "scaleBand", ()=>(parcelRequire("i3RkB")).default);
    var $cMo1a;
    var $eOdM1;
    var $elPt5;
    var $i3RkB;
    var $5pfgu;
    var $juXo4;
    var $2YVVm;
    function $6831b7e75dd8af74$export$3664991d076c12bd(config) {
        const scale = (0, (0, parcelRequire("i3RkB")).default)(config);
        scale.timeUnit = function() {
            return config === null || config === void 0 ? void 0 : config.timeUnit;
        };
        return scale;
    }
});
parcelRegister("i3RkB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d261e04fb6b55f5b$export$2e2bcd8739ae039);
    var $gMRSL;
    var $caWsP;
    var $d261e04fb6b55f5b$export$933021962cd38dc1 = (0, (0, parcelRequire("caWsP")).default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
    function $d261e04fb6b55f5b$export$2e2bcd8739ae039(config) {
        return $d261e04fb6b55f5b$export$933021962cd38dc1((0, (0, parcelRequire("gMRSL")).default)(), config);
    }
});
parcelRegister("gMRSL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c38aecf3af0f59a7$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "point", ()=>$c38aecf3af0f59a7$export$105684a3041cb6f3);
    var $7urYO;
    var $l4Hc4;
    var $8idDz;
    function $c38aecf3af0f59a7$export$2e2bcd8739ae039() {
        var scale = (0, (0, parcelRequire("8idDz")).default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
        delete scale.unknown;
        function rescale() {
            var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
            step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
            if (round) step = Math.floor(step);
            start += (stop - start - step * (n - paddingInner)) * align;
            bandwidth = step * (1 - paddingInner);
            if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
            var values = (0, (0, parcelRequire("7urYO")).default)(n).map(function(i) {
                return start + step * i;
            });
            return ordinalRange(reverse ? values.reverse() : values);
        }
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.range = function(_) {
            return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
                r0,
                r1
            ];
        };
        scale.rangeRound = function(_) {
            return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
        };
        scale.bandwidth = function() {
            return bandwidth;
        };
        scale.step = function() {
            return step;
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, rescale()) : round;
        };
        scale.padding = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
        };
        scale.paddingInner = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
        };
        scale.paddingOuter = function(_) {
            return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
        };
        scale.align = function(_) {
            return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
        };
        scale.copy = function() {
            return $c38aecf3af0f59a7$export$2e2bcd8739ae039(domain(), [
                r0,
                r1
            ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
        };
        return (0, (0, parcelRequire("l4Hc4")).initRange).apply(rescale(), arguments);
    }
    function $c38aecf3af0f59a7$var$pointish(scale) {
        var copy = scale.copy;
        scale.padding = scale.paddingOuter;
        delete scale.paddingInner;
        delete scale.paddingOuter;
        scale.copy = function() {
            return $c38aecf3af0f59a7$var$pointish(copy());
        };
        return scale;
    }
    function $c38aecf3af0f59a7$export$105684a3041cb6f3() {
        return $c38aecf3af0f59a7$var$pointish($c38aecf3af0f59a7$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
    }
});
parcelRegister("7urYO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$574109f1d23a3200$export$2e2bcd8739ae039);
    function $574109f1d23a3200$export$2e2bcd8739ae039(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    }
});
parcelRegister("5pfgu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3efb20df079e2ed4$export$2e2bcd8739ae039);
    var $gcmOU;
    var $caWsP;
    var $3efb20df079e2ed4$export$7ce4d19a8c2ea22f = (0, (0, parcelRequire("caWsP")).default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
    function $3efb20df079e2ed4$export$2e2bcd8739ae039(config) {
        return $3efb20df079e2ed4$export$7ce4d19a8c2ea22f((0, (0, parcelRequire("gcmOU")).default)(), config);
    }
});
parcelRegister("gcmOU", function(module, exports) {
    $parcel$export(module.exports, "linearish", ()=>$bcaf77e9c6cf2e73$export$16a5d4b4a61a274d);
    $parcel$export(module.exports, "default", ()=>$bcaf77e9c6cf2e73$export$2e2bcd8739ae039);
    var $80JJl;
    var $jhkFB;
    var $l4Hc4;
    var $e86SE;
    function $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale) {
        var domain = scale.domain;
        scale.ticks = function(count) {
            var d = domain();
            return (0, (0, parcelRequire("80JJl")).default)(d[0], d[d.length - 1], count == null ? 10 : count);
        };
        scale.tickFormat = function(count, specifier) {
            var d = domain();
            return (0, (0, parcelRequire("e86SE")).default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
        };
        scale.nice = function(count) {
            if (count == null) count = 10;
            var d = domain();
            var i0 = 0;
            var i1 = d.length - 1;
            var start = d[i0];
            var stop = d[i1];
            var prestep;
            var step;
            var maxIter = 10;
            if (stop < start) {
                step = start, start = stop, stop = step;
                step = i0, i0 = i1, i1 = step;
            }
            while(maxIter-- > 0){
                step = (0, (0, parcelRequire("80JJl")).tickIncrement)(start, stop, count);
                if (step === prestep) {
                    d[i0] = start;
                    d[i1] = stop;
                    return domain(d);
                } else if (step > 0) {
                    start = Math.floor(start / step) * step;
                    stop = Math.ceil(stop / step) * step;
                } else if (step < 0) {
                    start = Math.ceil(start * step) / step;
                    stop = Math.floor(stop * step) / step;
                } else break;
                prestep = step;
            }
            return scale;
        };
        return scale;
    }
    function $bcaf77e9c6cf2e73$export$2e2bcd8739ae039() {
        var scale = (0, (0, parcelRequire("jhkFB")).default)();
        scale.copy = function() {
            return (0, (0, parcelRequire("jhkFB")).copy)(scale, $bcaf77e9c6cf2e73$export$2e2bcd8739ae039());
        };
        (0, (0, parcelRequire("l4Hc4")).initRange).apply(scale, arguments);
        return $bcaf77e9c6cf2e73$export$16a5d4b4a61a274d(scale);
    }
});
parcelRegister("e86SE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a497265f873a5cba$export$2e2bcd8739ae039);
    var $80JJl;
    var $lIJDz = parcelRequire("lIJDz");
    var $d52Pl;
    var $jGaQB;
    var $eP35l;
    var $3n7r8;
    function $a497265f873a5cba$export$2e2bcd8739ae039(start, stop, count, specifier) {
        var step = (0, (0, parcelRequire("80JJl")).tickStep)(start, stop, count), precision;
        specifier = (0, (0, parcelRequire("d52Pl")).default)(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = (0, (0, parcelRequire("eP35l")).default)(step, value))) specifier.precision = precision;
                return (0, $lIJDz.formatPrefix)(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = (0, (0, parcelRequire("3n7r8")).default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = (0, (0, parcelRequire("jGaQB")).default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return (0, $lIJDz.format)(specifier);
    }
});
parcelRegister("lIJDz", function(module, exports) {
    $parcel$export(module.exports, "format", ()=>$fd011b9e7fff9861$export$d9468344d3651243);
    $parcel$export(module.exports, "formatPrefix", ()=>$fd011b9e7fff9861$export$8d85692a469dde6f);
    var $9lU0X;
    var $fd011b9e7fff9861$var$locale;
    var $fd011b9e7fff9861$export$d9468344d3651243;
    var $fd011b9e7fff9861$export$8d85692a469dde6f;
    $fd011b9e7fff9861$export$2e2bcd8739ae039({
        thousands: ",",
        grouping: [
            3
        ],
        currency: [
            "$",
            ""
        ]
    });
    function $fd011b9e7fff9861$export$2e2bcd8739ae039(definition) {
        $fd011b9e7fff9861$var$locale = (0, (0, parcelRequire("9lU0X")).default)(definition);
        $fd011b9e7fff9861$export$d9468344d3651243 = $fd011b9e7fff9861$var$locale.format;
        $fd011b9e7fff9861$export$8d85692a469dde6f = $fd011b9e7fff9861$var$locale.formatPrefix;
        return $fd011b9e7fff9861$var$locale;
    }
});
parcelRegister("9lU0X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf18683e7066ef8$export$2e2bcd8739ae039);
    var $4PYTL;
    var $lumKq;
    var $69LQu;
    var $d52Pl;
    var $hFRdc;
    var $61KNZ;
    var $6be9G;
    var $koqnZ;
    var $6cf18683e7066ef8$var$map = Array.prototype.map, $6cf18683e7066ef8$var$prefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xb5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ];
    function $6cf18683e7066ef8$export$2e2bcd8739ae039(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, (0, parcelRequire("koqnZ")).default) : (0, (0, parcelRequire("lumKq")).default)($6cf18683e7066ef8$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, (0, parcelRequire("koqnZ")).default) : (0, (0, parcelRequire("69LQu")).default)($6cf18683e7066ef8$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, (0, parcelRequire("d52Pl")).default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            if (type === "n") comma = true, type = "g";
            else if (!(0, (0, parcelRequire("61KNZ")).default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            var formatType = (0, (0, parcelRequire("61KNZ")).default)[type], maybeSuffix = /[defgprs%]/.test(type);
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    var valueNegative = value < 0 || 1 / value < 0;
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    if (trim) value = (0, (0, parcelRequire("hFRdc")).default)(value);
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? $6cf18683e7066ef8$var$prefixes[8 + (0, (0, parcelRequire("6be9G")).prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                if (comma && !zero) value = group(value, Infinity);
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, (0, parcelRequire("d52Pl")).default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, (0, parcelRequire("4PYTL")).default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $6cf18683e7066ef8$var$prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    }
});
parcelRegister("4PYTL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$385b29fac2777bcf$export$2e2bcd8739ae039);
    var $dTsA8;
    function $385b29fac2777bcf$export$2e2bcd8739ae039(x) {
        return x = (0, (0, parcelRequire("dTsA8")).formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    }
});
parcelRegister("dTsA8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1d6952536ec19e2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "formatDecimalParts", ()=>$a1d6952536ec19e2$export$8f8e23dd27dc19f5);
    function $a1d6952536ec19e2$export$2e2bcd8739ae039(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    }
    function $a1d6952536ec19e2$export$8f8e23dd27dc19f5(x, p) {
        if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
        var i, coefficient = x.slice(0, i);
        return [
            coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
            +x.slice(i + 1)
        ];
    }
});
parcelRegister("lumKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa4e0b8ad8ee75a1$export$2e2bcd8739ae039);
    function $fa4e0b8ad8ee75a1$export$2e2bcd8739ae039(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    }
});
parcelRegister("69LQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47b8b274d7519d09$export$2e2bcd8739ae039);
    function $47b8b274d7519d09$export$2e2bcd8739ae039(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    }
});
parcelRegister("d52Pl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$985def61c5e3febe$export$2e2bcd8739ae039);
    var $985def61c5e3febe$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
    function $985def61c5e3febe$export$2e2bcd8739ae039(specifier) {
        if (!(match = $985def61c5e3febe$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
        var match;
        return new $985def61c5e3febe$export$963aac351db36ed4({
            fill: match[1],
            align: match[2],
            sign: match[3],
            symbol: match[4],
            zero: match[5],
            width: match[6],
            comma: match[7],
            precision: match[8] && match[8].slice(1),
            trim: match[9],
            type: match[10]
        });
    }
    $985def61c5e3febe$export$2e2bcd8739ae039.prototype = $985def61c5e3febe$export$963aac351db36ed4.prototype;
    function $985def61c5e3febe$export$963aac351db36ed4(specifier) {
        this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
        this.align = specifier.align === undefined ? ">" : specifier.align + "";
        this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
        this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
        this.zero = !!specifier.zero;
        this.width = specifier.width === undefined ? undefined : +specifier.width;
        this.comma = !!specifier.comma;
        this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
        this.trim = !!specifier.trim;
        this.type = specifier.type === undefined ? "" : specifier.type + "";
    }
    $985def61c5e3febe$export$963aac351db36ed4.prototype.toString = function() {
        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
    };
});
parcelRegister("hFRdc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cddf8aca24d838af$export$2e2bcd8739ae039);
    function $cddf8aca24d838af$export$2e2bcd8739ae039(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    }
});
parcelRegister("61KNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$463724a038112234$export$2e2bcd8739ae039);
    var $dTsA8;
    var $6be9G;
    var $91t1p;
    var $463724a038112234$export$2e2bcd8739ae039 = {
        "%": (x, p)=>(x * 100).toFixed(p),
        "b": (x)=>Math.round(x).toString(2),
        "c": (x)=>x + "",
        "d": (0, (0, parcelRequire("dTsA8")).default),
        "e": (x, p)=>x.toExponential(p),
        "f": (x, p)=>x.toFixed(p),
        "g": (x, p)=>x.toPrecision(p),
        "o": (x)=>Math.round(x).toString(8),
        "p": (x, p)=>(0, (0, parcelRequire("91t1p")).default)(x * 100, p),
        "r": (0, (0, parcelRequire("91t1p")).default),
        "s": (0, (0, parcelRequire("6be9G")).default),
        "X": (x)=>Math.round(x).toString(16).toUpperCase(),
        "x": (x)=>Math.round(x).toString(16)
    };
});
parcelRegister("6be9G", function(module, exports) {
    $parcel$export(module.exports, "prefixExponent", ()=>$47fec017c029c8e0$export$6863724d9a42263);
    $parcel$export(module.exports, "default", ()=>$47fec017c029c8e0$export$2e2bcd8739ae039);
    var $dTsA8;
    var $47fec017c029c8e0$export$6863724d9a42263;
    function $47fec017c029c8e0$export$2e2bcd8739ae039(x, p) {
        var d = (0, (0, parcelRequire("dTsA8")).formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - ($47fec017c029c8e0$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, (0, parcelRequire("dTsA8")).formatDecimalParts)(x, Math.max(0, p + i - 1))[0];
    }
});
parcelRegister("91t1p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$691ab825243f2afd$export$2e2bcd8739ae039);
    var $dTsA8;
    function $691ab825243f2afd$export$2e2bcd8739ae039(x, p) {
        var d = (0, (0, parcelRequire("dTsA8")).formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    }
});
parcelRegister("koqnZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed8a843c78cf60aa$export$2e2bcd8739ae039);
    function $ed8a843c78cf60aa$export$2e2bcd8739ae039(x) {
        return x;
    }
});
parcelRegister("jGaQB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e53a5aa57132374c$export$2e2bcd8739ae039);
    var $4PYTL;
    function $e53a5aa57132374c$export$2e2bcd8739ae039(step) {
        return Math.max(0, -(0, (0, parcelRequire("4PYTL")).default)(Math.abs(step)));
    }
});
parcelRegister("eP35l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aca838c0481a7c13$export$2e2bcd8739ae039);
    var $4PYTL;
    function $aca838c0481a7c13$export$2e2bcd8739ae039(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, (0, parcelRequire("4PYTL")).default)(value) / 3))) * 3 - (0, (0, parcelRequire("4PYTL")).default)(Math.abs(step)));
    }
});
parcelRegister("3n7r8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$274949d87d20acb5$export$2e2bcd8739ae039);
    var $4PYTL;
    function $274949d87d20acb5$export$2e2bcd8739ae039(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, (0, parcelRequire("4PYTL")).default)(max) - (0, (0, parcelRequire("4PYTL")).default)(step)) + 1;
    }
});
parcelRegister("6jSGb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$499eeea25e19f1a9$export$2e2bcd8739ae039);
    function $499eeea25e19f1a9$export$2e2bcd8739ae039(scale) {
        if ('bandwidth' in scale) return scale.bandwidth();
        const range = scale.range();
        const domain = scale.domain();
        return Math.abs(range[range.length - 1] - range[0]) / domain.length;
    }
});
parcelRegister("cKYPp", function(module, exports) {
    $parcel$export(module.exports, "BarTooltipOverlayElement", ()=>$9498f71ba797135a$export$5ba4961e00f9d36);
    $parcel$export(module.exports, "BarTooltipOverlayEmitterElement", ()=>$9498f71ba797135a$export$7224ce4821955367);
    $parcel$export(module.exports, "BarTooltipOverlayEmitter", ()=>$9498f71ba797135a$export$e3d7d80d1df1466);
    $parcel$export(module.exports, "BarTooltipOverlay", ()=>$9498f71ba797135a$export$a6d588001e949ed2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $iTGbP;
    var $6jSGb;
    var $lrseF;
    var $13b02;
    var $3xZ2d;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    const $9498f71ba797135a$export$5ba4961e00f9d36 = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        var _tooltipData$nearestD, _tooltipData$nearestD2, _tooltipData$nearestD3;
        const { tooltipOpen: tooltipOpen, tooltipData: tooltipData, showTooltip: showTooltip, hideTooltip: hideTooltip, width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, data: data, hide: hide } = props;
        if (hide) return null;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) && (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: !horizontal ? (0, $2OMIu.jsx)((0, (0, parcelRequire("iTGbP")).PrivateBar), {
                    x: (xScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD2 = tooltipData.nearestDatum) === null || _tooltipData$nearestD2 === void 0 ? void 0 : _tooltipData$nearestD2.datum)) || 0) - 5,
                    y: 0,
                    opacity: 0.5,
                    fill: "var(--ds-interaction-hovered, #00000029)",
                    width: (0, (0, parcelRequire("6jSGb")).default)(xScale) + 10,
                    height: height
                }) : (0, $2OMIu.jsx)((0, (0, parcelRequire("iTGbP")).PrivateBar), {
                    y: (yScale(xAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD3 = tooltipData.nearestDatum) === null || _tooltipData$nearestD3 === void 0 ? void 0 : _tooltipData$nearestD3.datum)) || 0) - 5,
                    x: 0,
                    opacity: 0.5,
                    fill: "var(--ds-interaction-hovered, #00000029)",
                    height: (0, (0, parcelRequire("6jSGb")).default)(yScale) + 10,
                    width: width
                })
            })
        });
    });
    const $9498f71ba797135a$export$7224ce4821955367 = (0, (0, parcelRequire("bT1Sw")).element)((props)=>{
        const { width: width, height: height, xScale: xScale, yScale: yScale, horizontal: horizontal, xAccessor: xAccessor, yAccessor: yAccessor, margin: margin, seriesData: seriesData, showTooltip: showTooltip, hideTooltip: hideTooltip, onClick: onClick, data: data, hide: hide } = props;
        if (hide) return null;
        const eventEmitters = (0, (0, parcelRequire("13b02")).default)({
            source: (0, $0277c50b98747247$export$69b1818e3c4e83f9)
        });
        (0, (0, parcelRequire("3xZ2d")).default)({
            dataKey: 'nearest',
            onPointerMove: (d)=>showTooltip(d),
            onPointerOut: ()=>hideTooltip(),
            onPointerDown: (d)=>onClick && onClick(d),
            allowedSources: [
                (0, $0277c50b98747247$export$69b1818e3c4e83f9)
            ],
            horizontal: horizontal,
            width: width,
            margin: margin,
            height: height,
            data: data,
            xScale: xScale,
            yScale: yScale,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            seriesData: seriesData
        });
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $2OMIu.jsx)("rect", {
                style: {
                    cursor: onClick ? 'pointer' : 'default'
                },
                width: width,
                height: height,
                fill: "transparent",
                ...eventEmitters
            })
        });
    });
    function $9498f71ba797135a$export$e3d7d80d1df1466() {
        const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lrseF")).default));
        return (0, $2OMIu.jsx)($9498f71ba797135a$export$7224ce4821955367, {
            showTooltip: showTooltip,
            hideTooltip: hideTooltip,
            width: width,
            height: height,
            xScale: xScale,
            yScale: yScale,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            data: data,
            seriesData: seriesData,
            margin: margin
        });
    }
    function $9498f71ba797135a$export$a6d588001e949ed2() {
        const { width: width, height: height, margin: margin, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, data: data } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        const { showTooltip: showTooltip, tooltipData: tooltipData, tooltipOpen: tooltipOpen, hideTooltip: hideTooltip } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lrseF")).default));
        return (0, $2OMIu.jsx)($9498f71ba797135a$export$5ba4961e00f9d36, {
            tooltipOpen: tooltipOpen,
            showTooltip: showTooltip,
            hideTooltip: hideTooltip,
            tooltipData: tooltipData,
            width: width,
            height: height,
            xScale: xScale,
            yScale: yScale,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            data: data,
            seriesData: seriesData,
            margin: margin
        });
    }
});
const $0277c50b98747247$export$69b1818e3c4e83f9 = '__XY_EVENT_SOURCE__';
parcelRegister("13b02", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c3e9a8e4cb9b40b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lI55a;
    function $0c3e9a8e4cb9b40b$export$2e2bcd8739ae039(_ref) {
        let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
        const emit = (0, (0, parcelRequire("lI55a")).default)();
        const emitPointerMove = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointermove', event, source, datum), [
            emit,
            source
        ]);
        const emitPointerOut = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerout', event, source), [
            emit,
            source
        ]);
        const emitPointerUp = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerup', event, source), [
            emit,
            source
        ]);
        const emitPointerDown = (0, $5uXOq.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointerdown', event, source, datum), [
            emit,
            source
        ]);
        const emitFocus = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('focus', event, source), [
            emit,
            source
        ]);
        const emitBlur = (0, $5uXOq.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('blur', event, source), [
            emit,
            source
        ]);
        return {
            onPointerMove: onPointerMove ? emitPointerMove : undefined,
            onFocus: onFocus ? emitFocus : undefined,
            onBlur: onBlur ? emitBlur : undefined,
            onPointerOut: onPointerOut ? emitPointerOut : undefined,
            onPointerUp: onPointerUp ? emitPointerUp : undefined,
            onPointerDown: onPointerDown ? emitPointerDown : undefined
        };
    }
});
parcelRegister("3xZ2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2953cc62a817af6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5yRts;
    var $4grX0;
    var $lI55a;
    const $2953cc62a817af6a$export$76917c244f8b44cb = '__POINTER_EVENTS_ALL';
    const $2953cc62a817af6a$export$ee16f91d64c2973e = '__POINTER_EVENTS_NEAREST';
    function $2953cc62a817af6a$export$1d0a87a519049f8c(event) {
        return !!event && ('clientX' in event || 'changedTouches' in event);
    }
    function $2953cc62a817af6a$export$9829d00ac5f2232d(event) {
        return !!event && !$2953cc62a817af6a$export$1d0a87a519049f8c(event);
    }
    function $2953cc62a817af6a$export$2e2bcd8739ae039(_ref) {
        let { findNearestDatum: findNearestDatumProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, allowedSources: allowedSources, width: width, height: height, margin: margin, data: data, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, horizontal: horizontal } = _ref;
        const getHandlerParams = (0, $5uXOq.useCallback)((params)=>{
            const { svgPoint: svgPoint, event: event } = params || {};
            if (params && event && svgPoint && width && height) {
                const findNearestFunction = !horizontal ? (0, (0, parcelRequire("5yRts")).default) : (0, (0, parcelRequire("4grX0")).default);
                const nearestDatum = findNearestFunction({
                    height: height,
                    data: data,
                    point: {
                        x: svgPoint.x - margin.left,
                        y: svgPoint.y - margin.top
                    },
                    width: width,
                    xAccessor: !horizontal ? xAccessor : yAccessor,
                    xScale: xScale,
                    yAccessor: !horizontal ? yAccessor : xAccessor,
                    yScale: yScale
                });
                if (nearestDatum) {
                    const access = xAccessor;
                    const pointerParams = [
                        {
                            svgPoint: svgPoint,
                            event: event,
                            ...nearestDatum,
                            nearestSeriesData: seriesData.get(access(nearestDatum === null || nearestDatum === void 0 ? void 0 : nearestDatum.datum))
                        }
                    ];
                    return pointerParams.filter((param)=>param);
                } else {
                    const pointerParams = [
                        {
                            svgPoint: svgPoint,
                            event: event,
                            datum: null
                        }
                    ];
                    return pointerParams.filter((param)=>param);
                }
            }
            return [];
        }, [
            data,
            xScale,
            yScale,
            width,
            height,
            (0, (0, parcelRequire("5yRts")).default)
        ]);
        const handlePointerMove = (0, $5uXOq.useCallback)((params)=>{
            if (onPointerMove) getHandlerParams(params).forEach((p)=>onPointerMove(p));
        }, [
            getHandlerParams,
            onPointerMove
        ]);
        const handlePointerUp = (0, $5uXOq.useCallback)((params)=>{
            if (onPointerUp) getHandlerParams(params).forEach((p)=>onPointerUp(p));
        }, [
            getHandlerParams,
            onPointerUp
        ]);
        const handlePointerDown = (0, $5uXOq.useCallback)((params)=>{
            if (onPointerDown) getHandlerParams(params).forEach((p)=>onPointerDown(p));
        }, [
            getHandlerParams,
            onPointerDown
        ]);
        const handleFocus = (0, $5uXOq.useCallback)((params)=>{
            if (onFocus) getHandlerParams(params).forEach((p)=>onFocus(p));
        }, [
            getHandlerParams,
            onFocus
        ]);
        const handlePointerOut = (0, $5uXOq.useCallback)((params)=>{
            const event = params === null || params === void 0 ? void 0 : params.event;
            if (event && $2953cc62a817af6a$export$1d0a87a519049f8c(event) && onPointerOut) onPointerOut(event);
        }, [
            onPointerOut
        ]);
        const handleBlur = (0, $5uXOq.useCallback)((params)=>{
            const event = params === null || params === void 0 ? void 0 : params.event;
            if (event && $2953cc62a817af6a$export$9829d00ac5f2232d(event) && onBlur) onBlur(event);
        }, [
            onBlur
        ]);
        (0, (0, parcelRequire("lI55a")).default)('pointermove', onPointerMove ? handlePointerMove : undefined, allowedSources);
        (0, (0, parcelRequire("lI55a")).default)('pointerout', onPointerOut ? handlePointerOut : undefined, allowedSources);
        (0, (0, parcelRequire("lI55a")).default)('pointerup', onPointerUp ? handlePointerUp : undefined, allowedSources);
        (0, (0, parcelRequire("lI55a")).default)('pointerdown', onPointerDown ? handlePointerDown : undefined, allowedSources);
        (0, (0, parcelRequire("lI55a")).default)('focus', onFocus ? handleFocus : undefined, allowedSources);
        (0, (0, parcelRequire("lI55a")).default)('blur', onBlur ? handleBlur : undefined, allowedSources);
    }
});
parcelRegister("5yRts", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40c99b8ee82fea7e$export$2e2bcd8739ae039);
    var $8EmVK;
    function $40c99b8ee82fea7e$export$2e2bcd8739ae039(_ref) {
        let { xScale: scale, xAccessor: accessor, yScale: yScale, yAccessor: yAccessor, point: point, data: data } = _ref;
        if (!point) return null;
        const nearestDatum = (0, (0, parcelRequire("8EmVK")).default)({
            scale: scale,
            accessor: accessor,
            scaledValue: point.x,
            data: data
        });
        return nearestDatum ? {
            datum: nearestDatum.datum,
            index: nearestDatum.index,
            distanceX: nearestDatum.distance,
            distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
        } : null;
    }
});
parcelRegister("8EmVK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64c3d8a41a163589$export$2e2bcd8739ae039);
    var $hjll3 = parcelRequire("hjll3");
    function $64c3d8a41a163589$export$2e2bcd8739ae039(_ref) {
        let { scale: scale, accessor: accessor, scaledValue: scaledValue, data: data } = _ref;
        const coercedScale = scale;
        let nearestDatum;
        let nearestDatumIndex;
        if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
            const bisect = (0, $hjll3.bisector)(accessor).left;
            const dataValue = Number(coercedScale.invert(scaledValue));
            const index = bisect(data, dataValue);
            const nearestDatum0 = data[index - 1];
            const nearestDatum1 = data[index];
            nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
            nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
        } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
            const domain = scale.domain();
            const range = scale.range().map(Number);
            const sortedRange = [
                ...range
            ].sort((a, b)=>a - b);
            const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
            let domainValue = 0;
            if ('paddingInner' in scale) {
                const paddingOuter = scale(sortedDomain[0]) || 0;
                const eachBand = coercedScale.step();
                const index = Math.floor((scaledValue - paddingOuter) / eachBand);
                domainValue = sortedDomain[Math.max(0, Math.min(index, sortedDomain.length - 1))];
            } else {
                const rangePoints = (0, $hjll3.range)(sortedRange[0] - coercedScale.step() * (0.5 - coercedScale.padding()), sortedRange[1] + coercedScale.step() * (0.5 - coercedScale.padding()), coercedScale.step());
                domainValue = sortedDomain[(0, $hjll3.bisectLeft)(rangePoints, scaledValue) - 1];
            }
            const index = data.findIndex((d)=>String(accessor(d)) === String(domainValue));
            nearestDatum = data[index];
            nearestDatumIndex = index;
        } else {
            console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
            return null;
        }
        if (nearestDatum == null || nearestDatumIndex == null) return null;
        const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
        return {
            datum: nearestDatum,
            index: nearestDatumIndex,
            distance: distance
        };
    }
});
parcelRegister("4grX0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31ae567ddf80c493$export$2e2bcd8739ae039);
    var $8EmVK;
    function $31ae567ddf80c493$export$2e2bcd8739ae039(_ref) {
        let { yScale: scale, yAccessor: accessor, xScale: xScale, xAccessor: xAccessor, point: point, data: data } = _ref;
        if (!point) return null;
        const nearestDatum = (0, (0, parcelRequire("8EmVK")).default)({
            scale: scale,
            accessor: accessor,
            scaledValue: point.y,
            data: data
        });
        return nearestDatum ? {
            datum: nearestDatum.datum,
            index: nearestDatum.index,
            distanceY: nearestDatum.distance,
            distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
        } : null;
    }
});
parcelRegister("aEZ4R", function(module, exports) {
    $parcel$export(module.exports, "BarDataProvider", ()=>$7c2d04805347e364$export$b2c9e5e1e06afcc9);
    $parcel$export(module.exports, "useBarData", ()=>$7c2d04805347e364$export$315829aab2a8c649);
    var $5uXOq = parcelRequire("5uXOq");
    var $PfPCm;
    var $cgmj2;
    var $ggVTz;
    var $2OMIu = parcelRequire("2OMIu");
    const $7c2d04805347e364$var$DataContext = (0, $5uXOq.createContext)({});
    function $7c2d04805347e364$export$b2c9e5e1e06afcc9(_ref) {
        let { children: children, ...props } = _ref;
        const { showPatterns: showPatterns } = (0, (0, parcelRequire("PfPCm")).useMenuData)();
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("cgmj2")).Theme), {
            fillStyles: (0, (0, parcelRequire("cgmj2")).DEFAULT_ORDINAL_COLORS),
            enableDefaultPatterns: showPatterns,
            useThemeFillStyles: (0, (0, parcelRequire("cgmj2")).useThemeFillStyles),
            children: (0, $2OMIu.jsx)((0, (0, parcelRequire("ggVTz")).BarScalesElement), {
                ...props,
                children: (scales)=>(0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $2OMIu.jsx)($7c2d04805347e364$var$DataContext.Provider, {
                            value: {
                                ...props,
                                ...scales
                            },
                            children: children
                        })
                    })
            })
        });
    }
    function $7c2d04805347e364$export$315829aab2a8c649() {
        return (0, $5uXOq.useContext)($7c2d04805347e364$var$DataContext);
    }
});
parcelRegister("fAwZ6", function(module, exports) {
    $parcel$export(module.exports, "PureBarChart", ()=>$b593cdda4009ff24$export$1870517ff3080193);
    var $5uXOq = parcelRequire("5uXOq");
    var $cMmlP;
    var $hi6Wp;
    var $dnJJh;
    var $8j5jo;
    var $dluWU;
    var $4zOFu;
    var $7RF0L;
    var $5jWQu;
    var $h3rAq;
    var $F3H4n;
    var $dcOT3;
    var $4HTJ0;
    var $cKYPp;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    function $b593cdda4009ff24$var$defaultColorAccessor() {
        return (_)=>'';
    }
    function $b593cdda4009ff24$var$useAccessors(_ref) {
        let { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor } = _ref;
        const [x, y, color] = (0, $5uXOq.useMemo)(()=>{
            const [x] = (0, (0, parcelRequire("8j5jo")).useSafeAccessors)(xAccessor);
            const [y] = (0, (0, parcelRequire("8j5jo")).useSafeAccessors)(yAccessor);
            const [color] = (0, (0, parcelRequire("8j5jo")).useSafeAccessors)(colorAccessor);
            return [
                x,
                y,
                color
            ];
        }, [
            xAccessor,
            yAccessor,
            colorAccessor
        ]);
        return {
            x: x,
            y: y,
            color: color
        };
    }
    function $b593cdda4009ff24$export$1870517ff3080193(_ref2) {
        let { data: data, width: width, height: height, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, margin: margin = (0, (0, parcelRequire("dluWU")).DEFAULT_MARGIN), svgRef: svgRef } = _ref2;
        const [plotHeight, plotWidth] = (0, $5uXOq.useMemo)(()=>[
                Math.max(0, height - margin.top - margin.bottom),
                Math.max(0, width - margin.left - margin.right)
            ], [
            height,
            margin,
            width
        ]);
        const { x: x, y: y, color: color } = $b593cdda4009ff24$var$useAccessors({
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            colorAccessor: colorAccessor || $b593cdda4009ff24$var$defaultColorAccessor()
        });
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("aEZ4R")).BarDataProvider), {
            data: data,
            width: plotWidth,
            height: plotHeight,
            x: x,
            y: y,
            xAccessor: x,
            yAccessor: y,
            color: color,
            colorAccessor: color,
            margin: margin,
            children: [
                colorAccessor && (0, $2OMIu.jsx)((0, (0, parcelRequire("F3H4n")).BarLegend), {}),
                (0, $2OMIu.jsxs)((0, (0, parcelRequire("cMmlP")).default), {
                    children: [
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("4zOFu")).BarAxes), {}),
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("h3rAq")).BarGrid), {}),
                        (0, $2OMIu.jsx)((0, (0, parcelRequire("hi6Wp")).default), {
                            innerRef: svgRef,
                            children: (0, $2OMIu.jsxs)((0, (0, parcelRequire("dnJJh")).default), {
                                top: margin.top,
                                left: margin.left,
                                children: [
                                    (0, $2OMIu.jsx)((0, (0, parcelRequire("dcOT3")).BarPatterns), {}),
                                    (0, $2OMIu.jsx)((0, (0, parcelRequire("7RF0L")).BarMarkSlot), {}),
                                    (0, $2OMIu.jsx)((0, (0, parcelRequire("cKYPp")).BarTooltipOverlay), {}),
                                    (0, $2OMIu.jsx)((0, (0, parcelRequire("cKYPp")).BarTooltipOverlayEmitter), {})
                                ]
                            })
                        })
                    ]
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("4HTJ0")).BarTooltip), {}),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("5jWQu")).DataTable), {})
            ]
        });
    }
});
parcelRegister("cMmlP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94db4e2c58c24248$export$2e2bcd8739ae039);
    var $bwpsq;
    var $2OMIu = parcelRequire("2OMIu");
    function $94db4e2c58c24248$export$2e2bcd8739ae039(_ref) {
        let { children: children } = _ref;
        return (0, $2OMIu.jsx)("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"
            ]),
            children: (0, $2OMIu.jsx)("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"
                ]),
                children: children
            })
        });
    }
});
parcelRegister("hi6Wp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c96980735a92a865$export$2e2bcd8739ae039);
    var $bwpsq;
    var $bT1Sw;
    var $2OMIu = parcelRequire("2OMIu");
    var $c96980735a92a865$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bT1Sw")).element)(function Plot(_ref) {
        let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: (0, $2OMIu.jsx)("svg", {
                ref: innerRef,
                width: width,
                height: height,
                transform: transform || `translate(${left}, ${top})`,
                ...restProps,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
                ]),
                children: children
            })
        });
    });
});
parcelRegister("8j5jo", function(module, exports) {
    $parcel$export(module.exports, "useSafeAccessors", ()=>$60c437dea181ada7$export$1ff31c13ab3c61e1);
    $parcel$export(module.exports, "getFirstItem", ()=>$60c437dea181ada7$export$fbdeaa6a76694f71);
    $parcel$export(module.exports, "getSecondItem", ()=>$60c437dea181ada7$export$18f9732b2021233c);
    function $60c437dea181ada7$export$227cf200245550ef(accessor) {
        if (typeof accessor === 'string') {
            function s(d) {
                try {
                    return d[accessor];
                } catch  {
                    return 0;
                }
            }
            return s;
        } else if (typeof accessor === 'number') {
            function s1(d) {
                try {
                    return d[accessor];
                } catch  {
                    return 0;
                }
            }
            return s1;
        }
        function s2(d) {
            try {
                return accessor instanceof Function ? accessor(d) : 0;
            } catch  {
                return 0;
            }
        }
        return s2;
    }
    function $60c437dea181ada7$export$1ff31c13ab3c61e1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.map((d)=>$60c437dea181ada7$export$227cf200245550ef(d));
    }
    function $60c437dea181ada7$export$3a667a3b7e4d6701(l) {
        return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
    }
    function $60c437dea181ada7$export$337238c011325465(l) {
        return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
    }
    function $60c437dea181ada7$export$dd2b6e807fb37ba3(l) {
        return l === null || l === void 0 ? void 0 : l.source;
    }
    function $60c437dea181ada7$export$c22522a4dfa48e9c(l) {
        return l === null || l === void 0 ? void 0 : l.target;
    }
    function $60c437dea181ada7$export$fbdeaa6a76694f71(d) {
        return d === null || d === void 0 ? void 0 : d[0];
    }
    function $60c437dea181ada7$export$18f9732b2021233c(d) {
        return d === null || d === void 0 ? void 0 : d[1];
    }
});
parcelRegister("4zOFu", function(module, exports) {
    $parcel$export(module.exports, "BarAxes", ()=>$3551bbeee5340be1$export$2212d638e9c7f00f);
    var $hqZma;
    var $cXzUG;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    function $3551bbeee5340be1$export$2212d638e9c7f00f() {
        const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        return (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("hqZma")).AxisBottom), {
                    scale: xScale,
                    top: height,
                    left: width
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("cXzUG")).AxisLeft), {
                    scale: yScale
                })
            ]
        });
    }
});
parcelRegister("7RF0L", function(module, exports) {
    $parcel$export(module.exports, "BarGroup", ()=>$5b9d4ba7b0c88f2a$export$54ef77743fe39325);
    $parcel$export(module.exports, "BarMarkSlot", ()=>$5b9d4ba7b0c88f2a$export$a8a51762e68574d8);
    var $bT1Sw;
    var $dnJJh;
    var $aEZ4R;
    var $arL7j;
    var $dwg9t;
    var $cp7lx;
    var $2OMIu = parcelRequire("2OMIu");
    const $5b9d4ba7b0c88f2a$export$54ef77743fe39325 = (0, (0, parcelRequire("bT1Sw")).element)(function BarGroup(_ref) {
        let { data: data, top: top, left: left, xScale: xScale, yScale: yScale, colorScale: colorScale, groupScale: groupScale, colorAccessor: colorAccessor, groupAccessor: groupAccessor, valueAccessor: valueAccessor, xAccessor: xAccessor } = _ref;
        const barGroups = (0, (0, parcelRequire("cp7lx")).getBarGroups)(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("dnJJh")).default), {
            top: top,
            left: left,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("dwg9t")).BarGroupMarks), {
                    barGroups: barGroups,
                    roundedCorners: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("arL7j")).BarGroupMarkLabels), {
                    barGroups: barGroups,
                    hide: true
                })
            ]
        });
    });
    function $5b9d4ba7b0c88f2a$export$a8a51762e68574d8() {
        const { data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, groupScale: groupScale, xScale: xScale, yScale: yScale } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        return (0, $2OMIu.jsx)($5b9d4ba7b0c88f2a$export$54ef77743fe39325, {
            data: data,
            groupScale: groupScale,
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            xAccessor: xAccessor,
            valueAccessor: yAccessor,
            colorAccessor: colorAccessor,
            groupAccessor: colorAccessor
        });
    }
});
parcelRegister("cp7lx", function(module, exports) {
    $parcel$export(module.exports, "getBarGroups", ()=>$907d84b07dc8893a$export$b0379c1526b79abe);
    var $hjll3 = parcelRequire("hjll3");
    function $907d84b07dc8893a$var$getScaleBandwidth(scale) {
        return 'bandwidth' in scale ? scale.bandwidth() : 0;
    }
    function $907d84b07dc8893a$export$b0379c1526b79abe(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
        const barWidth = $907d84b07dc8893a$var$getScaleBandwidth(groupScale);
        const groups = (0, $hjll3.group)(data, groupAccessor);
        const barGroups = Array.from(groups).map((_ref, i)=>{
            let [key, entries] = _ref;
            return {
                index: i,
                x0: groupScale(key),
                bars: entries.map((d, j)=>{
                    var _yScale;
                    return {
                        index: j,
                        key: key,
                        datum: d,
                        width: barWidth,
                        xValue: xAccessor(d) || 0,
                        yValue: valueAccessor(d) || 0,
                        x: xScale(xAccessor(d)) || 0,
                        y: yScale(valueAccessor(d)) || 0,
                        label: colorAccessor(d) || '',
                        color: colorScale(colorAccessor(d)),
                        height: yScale.range()[0] - ((_yScale = yScale(valueAccessor(d))) !== null && _yScale !== void 0 ? _yScale : yScale.range()[0])
                    };
                })
            };
        });
        return barGroups;
    }
});
parcelRegister("5jWQu", function(module, exports) {
    $parcel$export(module.exports, "DataTable", ()=>$3dfc5f9b9010c7cb$export$df30df7ec97b32b5);
    var $5uXOq = parcelRequire("5uXOq");
    var $PfPCm;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    const $3dfc5f9b9010c7cb$var$LazyDataTableModal = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lOXm0"))).then((module)=>({
                default: module.DataTableModal
            })));
    function $3dfc5f9b9010c7cb$export$df30df7ec97b32b5() {
        const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, (0, parcelRequire("PfPCm")).useMenuData)();
        const { data: data } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        return showDataTable ? (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: (0, $2OMIu.jsx)("div", {
                style: {
                    visibility: 'hidden'
                }
            }),
            children: (0, $2OMIu.jsx)($3dfc5f9b9010c7cb$var$LazyDataTableModal, {
                data: data,
                closeModal: closeDataTable
            })
        }) : null;
    }
});
parcelRegister("h3rAq", function(module, exports) {
    $parcel$export(module.exports, "BarGrid", ()=>$c6a81d93c24dd46f$export$fb11aa615404ad71);
    var $erST8;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    function $c6a81d93c24dd46f$export$fb11aa615404ad71() {
        const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("erST8")).Grid), {
            rowLineStyle: "solid",
            columnLineStyle: "hidden",
            xScale: xScale,
            yScale: yScale,
            width: width,
            height: height
        });
    }
});
parcelRegister("F3H4n", function(module, exports) {
    $parcel$export(module.exports, "BarLegend", ()=>$07b6b1efa859beb0$export$9a281618489c171);
    var $3B9ij;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    function $07b6b1efa859beb0$export$9a281618489c171() {
        const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("3B9ij")).OrdinalLegend), {
            shape: "square",
            data: data,
            colorScale: colorScale,
            colorAccessor: colorAccessor,
            labelAccessor: colorAccessor
        });
    }
});
parcelRegister("dcOT3", function(module, exports) {
    $parcel$export(module.exports, "BarPatterns", ()=>$99d3de702876114d$export$73f9b7830d32a61e);
    var $epG85;
    var $17PP9;
    var $PfPCm;
    var $cgmj2;
    var $2OMIu = parcelRequire("2OMIu");
    const $99d3de702876114d$export$73f9b7830d32a61e = ()=>{
        const { patternDefs: patternDefs } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("epG85")).default).elements.Theme);
        const { showPatterns: showPatterns } = (0, (0, parcelRequire("PfPCm")).useMenuData)();
        return (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: showPatterns ? (0, (0, parcelRequire("cgmj2")).DEFAULT_ORDINAL_PATTERNS_DEFS) : patternDefs
        });
    };
});
parcelRegister("4HTJ0", function(module, exports) {
    $parcel$export(module.exports, "BarTooltip", ()=>$36d66762af5c6a24$export$f509e97905f1d31f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lrseF;
    var $2pOyr;
    var $aEZ4R;
    var $2OMIu = parcelRequire("2OMIu");
    function $36d66762af5c6a24$export$f509e97905f1d31f() {
        const { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale } = (0, (0, parcelRequire("aEZ4R")).useBarData)();
        const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lrseF")).default));
        return (0, $2OMIu.jsx)((0, (0, parcelRequire("2pOyr")).MultiSeriesTooltip), {
            tooltipData: tooltipData,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            colorAccessor: colorAccessor,
            colorScale: colorScale
        });
    }
});
parcelRegister("hhESq", function(module, exports) {
    $parcel$export(module.exports, "BarGroupHorizontal", ()=>$c953bb7e79beb6df$export$ca0ea6f4f6e77023);
    var $bT1Sw;
    var $17PP9;
    var $dnJJh;
    var $7RF0L;
    var $ft4EL;
    var $6nv1a;
    var $IqHcb;
    var $2OMIu = parcelRequire("2OMIu");
    function $c953bb7e79beb6df$var$BarGroupHorizontal(props) {
        const { data: data, top: top, left: left, xScale: xScale, yScale: yScale, colorScale: colorScale, groupScale: groupScale, colorAccessor: colorAccessor, groupAccessor: groupAccessor, valueAccessor: valueAccessor, xAccessor: xAccessor } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("7RF0L")).BarGroup), {
            mergeWith: props
        });
        const barGroups = (0, (0, parcelRequire("IqHcb")).getHorizontalBarGroups)(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
        return (0, $2OMIu.jsxs)((0, (0, parcelRequire("dnJJh")).default), {
            top: top,
            left: left,
            children: [
                (0, $2OMIu.jsx)((0, (0, parcelRequire("6nv1a")).BarGroupHorizontalMarks), {
                    barGroups: barGroups,
                    roundedCorners: true
                }),
                (0, $2OMIu.jsx)((0, (0, parcelRequire("ft4EL")).BarGroupHorizontalLabels), {
                    barGroups: barGroups,
                    hide: true
                })
            ]
        });
    }
    const $c953bb7e79beb6df$export$ca0ea6f4f6e77023 = (0, (0, parcelRequire("bT1Sw")).element)($c953bb7e79beb6df$var$BarGroupHorizontal, {
        as: (0, (0, parcelRequire("7RF0L")).BarGroup)
    });
});
parcelRegister("ft4EL", function(module, exports) {
    $parcel$export(module.exports, "BarGroupHorizontalLabels", ()=>$b42d2d20ec6e978b$export$c934468eb2e0ea9c);
    var $bT1Sw;
    var $8WT90;
    var $dnJJh;
    var $2OMIu = parcelRequire("2OMIu");
    const $b42d2d20ec6e978b$export$c934468eb2e0ea9c = (0, (0, parcelRequire("bT1Sw")).element)(function BarGroupHorizontalMarks(_ref) {
        let { barGroups: barGroups, hide: hide } = _ref;
        if (hide) return null;
        return barGroups.map((barGroup)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("dnJJh")).default), {
                top: barGroup.x0,
                children: barGroup.bars.map((bar)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("8WT90")).ValueLabel), {
                        x: bar.x + bar.width,
                        y: bar.y + bar.height / 2,
                        color: bar.color,
                        children: bar.yValue.toString()
                    }, `bar-group-label-${barGroup.index}-${bar.index}`))
            }, `bar-group-${barGroup.index}-${barGroup.x0}`));
    });
});
parcelRegister("6nv1a", function(module, exports) {
    $parcel$export(module.exports, "BarGroupHorizontalMarks", ()=>$4a4cf388352f75af$export$a1a3a490a3ff3095);
    var $bT1Sw;
    var $iTGbP;
    var $dnJJh;
    var $dluWU;
    var $2OMIu = parcelRequire("2OMIu");
    const $4a4cf388352f75af$export$a1a3a490a3ff3095 = (0, (0, parcelRequire("bT1Sw")).element)(function BarGroupHorizontalMarks(_ref) {
        let { barGroups: barGroups, roundedCorners: roundedCorners = true, baseRoundedCorners: baseRoundedCorners = false } = _ref;
        return barGroups.map((barGroup)=>(0, $2OMIu.jsx)((0, (0, parcelRequire("dnJJh")).default), {
                top: barGroup.x0,
                children: barGroup.bars.map((bar)=>{
                    const cornerRadius = bar.height > 2 * (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL && bar.width > 2 * (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL ? (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).SMALL : (0, (0, parcelRequire("dluWU")).CORNER_RADIUS_VALUE).NONE;
                    return (0, $2OMIu.jsx)((0, (0, parcelRequire("iTGbP")).Bar), {
                        ariaLabel: `${bar.label}, x: ${bar.yValue}, y: ${bar.xValue}`,
                        x: bar.x,
                        y: bar.y,
                        width: bar.width,
                        datum: bar.datum,
                        height: bar.height,
                        fill: bar.color,
                        cornerRadius: {
                            ...roundedCorners ? {
                                topRight: cornerRadius,
                                bottomRight: cornerRadius
                            } : {},
                            ...baseRoundedCorners ? {
                                topLeft: cornerRadius,
                                bottomLeft: cornerRadius
                            } : {}
                        }
                    }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.xValue}-${bar.key}`);
                })
            }, `bar-group-${barGroup.index}-${barGroup.x0}`));
    });
});
parcelRegister("IqHcb", function(module, exports) {
    $parcel$export(module.exports, "getHorizontalBarGroups", ()=>$0858d162a90bae8d$export$bf66c194b5d480d3);
    var $hjll3 = parcelRequire("hjll3");
    var $6jSGb;
    function $0858d162a90bae8d$export$bf66c194b5d480d3(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
        const barWidth = (0, (0, parcelRequire("6jSGb")).default)(groupScale);
        const groups = (0, $hjll3.group)(data, groupAccessor);
        const barGroups = Array.from(groups).map((_ref, i)=>{
            let [key, entries] = _ref;
            return {
                index: i,
                x0: groupScale(key),
                bars: entries.map((d, j)=>{
                    return {
                        index: j,
                        key: key,
                        datum: d,
                        height: barWidth,
                        xValue: xAccessor(d) || 0,
                        yValue: valueAccessor(d) || 0,
                        label: colorAccessor(d) || '',
                        y: yScale(xAccessor(d)) || 0,
                        x: 0,
                        color: colorScale(colorAccessor(d)),
                        width: xScale(valueAccessor(d)) || 0
                    };
                })
            };
        });
        return barGroups;
    }
});
parcelRegister("3KKAW", function(module, exports) {
    $parcel$export(module.exports, "BarGroupHorizontalScalesElement", ()=>$2bb9cfbca25ab016$export$e839b74fab6169e4);
    var $hjll3 = parcelRequire("hjll3");
    var $5uXOq = parcelRequire("5uXOq");
    var $bT1Sw;
    var $17PP9;
    parcelRequire("8WCE9");
    var $i3RkB;
    var $5pfgu;
    var $juXo4;
    var $6jSGb;
    var $cgmj2;
    var $ggVTz;
    function $2bb9cfbca25ab016$var$BarGroupHorizontalScalesElement(props) {
        const { data: data, x: x, y: y, color: color, width: width, height: height, yDomain: yDomain, timeUnit: timeUnit, children: children } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("ggVTz")).BarScalesElement), {
            mergeWith: props
        });
        const { fillStyles: fillStyles, enableDefaultPatterns: enableDefaultPatterns, useThemeFillStyles: useThemeFillStyles } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("cgmj2")).Theme));
        const totalYValue = (0, (0, parcelRequire("ggVTz")).useMaximumYValue)(data || [], x, y, false);
        const value = (0, $5uXOq.useMemo)(()=>{
            const xScaleRange = [
                height,
                0
            ];
            const xScalePadding = 0.25;
            const xScale = (0, (0, parcelRequire("ggVTz")).calculateXScaleDomain)({
                xData: data.map(x),
                timeUnit: timeUnit,
                range: xScaleRange,
                padding: xScalePadding
            });
            const groupScale = (0, (0, parcelRequire("i3RkB")).default)({
                domain: [
                    ...new Set(data.map(color))
                ],
                range: [
                    0,
                    (0, (0, parcelRequire("6jSGb")).default)(xScale)
                ],
                padding: 0.1
            });
            const yScale = (0, (0, parcelRequire("5pfgu")).default)({
                domain: (0, (0, parcelRequire("ggVTz")).calculateYDomain)({
                    totalYValue: totalYValue,
                    yDomain: yDomain
                }),
                range: [
                    0,
                    width
                ]
            });
            const { domain: domain, range: range } = useThemeFillStyles({
                fillStyles: fillStyles,
                enableDefaultPatterns: enableDefaultPatterns
            });
            const colorScale = (0, (0, parcelRequire("juXo4")).default)({
                domain: domain ? domain : data.map(color),
                range: range
            });
            const seriesData = (0, $hjll3.group)(data, x);
            return {
                xScale: yScale,
                yScale: xScale,
                colorScale: colorScale,
                groupScale: groupScale,
                seriesData: seriesData
            };
        }, [
            data,
            width,
            height,
            totalYValue,
            x,
            yDomain,
            timeUnit,
            fillStyles,
            enableDefaultPatterns
        ]);
        return children(value);
    }
    const $2bb9cfbca25ab016$export$e839b74fab6169e4 = (0, (0, parcelRequire("bT1Sw")).element)($2bb9cfbca25ab016$var$BarGroupHorizontalScalesElement, {
        as: (0, (0, parcelRequire("ggVTz")).BarScalesElement).Component
    });
});
parcelRegister("a3OZ0", function(module, exports) {
    $parcel$export(module.exports, "CustomAxisLeftText", ()=>$5a8d1fe115bd4783$export$82b464522a99ba59);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $181Rm;
    var $bT1Sw;
    var $17PP9;
    const $5a8d1fe115bd4783$export$82b464522a99ba59 = (0, (0, parcelRequire("bT1Sw")).element)(({ sideBarWidth: sideBarWidth })=>{
        const { children: children } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("181Rm")).default).elements.AxisLeftText);
        return $5uXOq.createElement("div", {
            style: {
                maxWidth: `calc(${sideBarWidth / 3}px)`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c"
            ])
        }, $5uXOq.createElement("span", null, children?.toString()));
    }, {
        as: (0, (0, parcelRequire("181Rm")).default).elements.AxisLeftText
    });
    const $5a8d1fe115bd4783$var$axisStyles = null;
});
parcelRegister("c9rca", function(module, exports) {
    $parcel$export(module.exports, "CustomLayout", ()=>$9352f45c6e65c7f2$export$38801bd36eb3c5d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $181Rm;
    var $bT1Sw;
    var $17PP9;
    const $9352f45c6e65c7f2$var$chartStyles = null;
    const $9352f45c6e65c7f2$export$38801bd36eb3c5d0 = (0, (0, parcelRequire("bT1Sw")).element)(()=>{
        const { children: children, width: width, height: height } = (0, (0, parcelRequire("17PP9")).useElementProps)((0, (0, parcelRequire("181Rm")).default).elements.Layout);
        const [fadeInOpacity, setFadeInOpacity] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const ref = window.requestAnimationFrame(()=>{
                if (isMounted) setFadeInOpacity(1);
            });
            return ()=>{
                isMounted = false;
                window.cancelAnimationFrame(ref);
            };
        }, [
            setFadeInOpacity
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-element": "chart",
            style: {
                opacity: fadeInOpacity
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1ul9idpf _1tkeidpf _v56414fr _1h1t1smo"
            ])
        }, children)));
    }, {
        as: (0, (0, parcelRequire("181Rm")).default).elements.Layout
    });
});
parcelRegister("dUJCJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00347ab46067e4f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00347ab46067e4f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTypeErrorNonFinal: {
            "id": "issue-field-statistics.single-select-chart-container.chart-type-error-non-final",
            "defaultMessage": " Invalid chart type. Please select a valid chart type from the options below."
        },
        chartTypeSelectLabel: {
            "id": "issue-field-statistics.single-select-chart-container.chart-type-select-label",
            "defaultMessage": "Chart type"
        }
    });
});
const $03857339d4f662fa$export$eb686c593382b322 = 40;
const $03857339d4f662fa$export$6b0a922783b1a3e9 = 24;
parcelRegister("1ovIw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3af034c7ae137843$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3af034c7ae137843$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noFieldSelectedError: {
            "id": "business-issue-field-statistics.statistics-sidebar.no-field-selected-error",
            "defaultMessage": "We can't show this chart because it uses one of your hidden fields. Select a different field from the dropdown."
        }
    });
});
parcelRegister("5ea6B", function(module, exports) {
    $parcel$export(module.exports, "filterStatisticFields", ()=>$721e5fcee88f3f56$export$297d943b5bad2c36);
    const $721e5fcee88f3f56$var$SUPPORTED_STATISTIC_FIELD_TYPES = [
        'com.atlassian.jira.plugin.system.customfieldtypes:select',
        'com.atlassian.jira.plugin.system.customfieldtypes:float',
        'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        'com.pyxis.greenhopper.jira:jsw-story-points',
        'assignee',
        'reporter',
        'status',
        'priority',
        'issuetype'
    ];
    const $721e5fcee88f3f56$export$297d943b5bad2c36 = (fields)=>{
        return fields.filter((field)=>field.__typename === 'JiraNumberField' || field.type && $721e5fcee88f3f56$var$SUPPORTED_STATISTIC_FIELD_TYPES.includes(field.type));
    };
});
parcelRegister("i0CN8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0a0f82215b28cfe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b0a0f82215b28cfe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTitle: {
            "id": "business-list.list-view.header-actions.share-title",
            "defaultMessage": "List"
        },
        simpleSearch: {
            "id": "business-list.list-view.header-actions.simple-search",
            "defaultMessage": "Search list"
        },
        searchLabel: {
            "id": "business-list.list-view.header-actions.search-label",
            "defaultMessage": "Typing letters in the search input applies filters"
        },
        format: {
            "id": "business-list.list-view.header-actions.conditional-formatting",
            "defaultMessage": "Format"
        }
    });
});
parcelRegister("h4BPz", function(module, exports) {
    $parcel$export(module.exports, "useFilterProps", ()=>$882feec1572e145b$export$5e00405c50f0041a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $hE5wF;
    var $5fc53;
    var $4nnGr;
    var $8TUlY;
    const $882feec1572e145b$var$createStringSet = (0, (0, parcelRequire("8QpSo")).default)((...args)=>new Set([
            ...args
        ]));
    const $882feec1572e145b$export$5e00405c50f0041a = ()=>{
        const { getAvailableFields: getAvailableFields } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const availableFields = (0, $5uXOq.useMemo)(()=>getAvailableFields(), [
            getAvailableFields
        ]);
        const hiddenQuickFilters = (0, $5uXOq.useMemo)(()=>{
            if (!isSoftwareFieldsEnabled) return [
                'ACTIVE_SPRINTS'
            ];
            const sprintField = availableFields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE));
            if (sprintField == null) return [
                'ACTIVE_SPRINTS'
            ];
            return [];
        }, [
            availableFields,
            isSoftwareFieldsEnabled
        ]);
        const allowedAliasFieldId = (0, $5uXOq.useMemo)(()=>{
            if (!isSoftwareFieldsEnabled) return;
            const fieldsAliases = availableFields.filter((field)=>field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID) || field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)).map((field)=>field.aliasFieldId);
            if (fieldsAliases.length === 0) return;
            return $882feec1572e145b$var$createStringSet(...fieldsAliases);
        }, [
            availableFields,
            isSoftwareFieldsEnabled
        ]);
        return {
            allowedAliasFieldId: allowedAliasFieldId,
            hiddenQuickFilters: hiddenQuickFilters
        };
    };
});
parcelRegister("aQK8w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$440547739bd87478$export$2e2bcd8739ae039);
    var $7VHMR;
    var $440547739bd87478$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        listHeading: {
            "id": "business-list.list-view.list-heading",
            "defaultMessage": "List"
        },
        unassignedOption: {
            "id": "business-list.list-view.unassigned-option",
            "defaultMessage": "Unassigned"
        },
        assignToMe: {
            "id": "business-list.list-view.assign-to-me",
            "defaultMessage": "Assign to me"
        },
        loadingMoreItems: {
            "id": "business-list.list-view.loading-more-items",
            "defaultMessage": "Loading more items..."
        }
    });
});
parcelRegister("dfOFF", function(module, exports) {
    $parcel$export(module.exports, "InteractionMetrics", ()=>$7ab82445f13b3e8b$export$341b330828bd3906);
    var $dJ1ye;
    const $7ab82445f13b3e8b$export$341b330828bd3906 = ()=>{
        const interactionMetrics = (0, (0, parcelRequire("dJ1ye")).useInteractionMetrics)();
        if (interactionMetrics[0, (0, parcelRequire("dJ1ye")).COLUMN_RESIZED].state === 'started') interactionMetrics[0, (0, parcelRequire("dJ1ye")).COLUMN_RESIZED].stop({
            stopTime: Math.floor(performance.now())
        });
        if (interactionMetrics[0, (0, parcelRequire("dJ1ye")).COLUMN_VISIBILITY_CHANGED].state === 'started') interactionMetrics[0, (0, parcelRequire("dJ1ye")).COLUMN_VISIBILITY_CHANGED].stop({
            stopTime: Math.floor(performance.now())
        });
        if (interactionMetrics[0, (0, parcelRequire("dJ1ye")).DND_ROW_DROPPED].state === 'started') interactionMetrics[0, (0, parcelRequire("dJ1ye")).DND_ROW_DROPPED].stop({
            stopTime: Math.floor(performance.now())
        });
        return null;
    };
});
parcelRegister("8nhP8", function(module, exports) {
    $parcel$export(module.exports, "AsyncReparentModal", ()=>$90b147095b0262a8$export$2afac3ca0625436);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $7lNbC;
    var $emGcb;
    const $90b147095b0262a8$var$runtimeProps = {};
    const $90b147095b0262a8$var$entryPointParams = {};
    const $90b147095b0262a8$export$2afac3ca0625436 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7lNbC")).reparentModalEntryPoint), $90b147095b0262a8$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jwm.list.reparent-modal",
            packageName: (0, (0, parcelRequire("emGcb")).PACKAGE_NAME),
            teamName: "keystone",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $90b147095b0262a8$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
parcelRegister("7lNbC", function(module, exports) {
    $parcel$export(module.exports, "reparentModalEntryPoint", ()=>$bdf94962c4e0afae$export$e5e5cbbac06953a1);
    var $eufEc;
    var $fEDBv;
    const $bdf94962c4e0afae$export$e5e5cbbac06953a1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("i4M4p")), {
            moduleId: "aa8d69b8"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("i4M4p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d9OVr")
    ]).then(()=>parcelRequire('5yG4z'));
});
parcelRegister("emGcb", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$1b79c8e8f28b4c9b$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", ()=>$1b79c8e8f28b4c9b$export$5b388ccfa29be01);
    const $1b79c8e8f28b4c9b$export$b8b9d90f9e5bd72b = 'jiraBusinessList';
    const $1b79c8e8f28b4c9b$export$5b388ccfa29be01 = -1;
});
parcelRegister("35R0r", function(module, exports) {
    $parcel$export(module.exports, "useGetColumns", ()=>$8c034c8d39e84861$export$5cedf9467e164d21);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $hE5wF;
    var $daQYX;
    var $35OFV;
    var $iILDa;
    var $ijSZT;
    var $57lFd;
    var $939cg;
    var $gULOk;
    var $4R6GH;
    var $5fc53;
    var $g5X3G;
    var $eTDjN;
    var $cjOYL;
    var $3fT9O;
    var $3rO9r;
    var $4HIDQ;
    var $lt1LT;
    var $8TUlY;
    var $9u99d;
    var $gEb1A;
    var $3O2kS;
    var $koElh;
    var $99NMg;
    var $3yRl2;
    var $i29pf;
    var $kX1vD;
    var $al7Aq;
    var $3jNxz;
    var $bFmRi;
    var $3rwUA;
    var $3Vqf5;
    var $iQ6fh;
    var $0CGYD;
    var $e7PC0;
    var $aQK8w;
    var $aYkrQ;
    var $1vBWF;
    var $hTzzn;
    var $eRBDs;
    var $1HY3B;
    var $f9qBd;
    var $7xYOf;
    var $bRFLq;
    var $c9UvN;
    var $lup7l;
    var $9gyyM;
    var $iydSP;
    var $eTHix;
    var $7NVIZ;
    var $3T0IO;
    const $8c034c8d39e84861$var$dateFieldWidth = 120;
    const $8c034c8d39e84861$var$getAlwaysVisibleFieldsMemoized = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("lt1LT")).getAlwaysVisibleFields));
    const $8c034c8d39e84861$export$23779177436374fa = ()=>({
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: 110,
            key: 120,
            [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: 400,
            [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: 120,
            [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: 180,
            [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: 180,
            [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: 180,
            [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $8c034c8d39e84861$var$dateFieldWidth,
            [(0, (0, parcelRequire("5fc53")).CREATED)]: $8c034c8d39e84861$var$dateFieldWidth,
            [(0, (0, parcelRequire("5fc53")).UPDATED)]: $8c034c8d39e84861$var$dateFieldWidth,
            [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: 120,
            [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: 170,
            [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: 120,
            [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: 170,
            [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: 180,
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: 200,
            moreFields: 50,
            [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: 200,
            [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: 170,
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: 170,
            [(0, (0, parcelRequire("5fc53")).COMMENT_TYPE)]: 145,
            [(0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE)]: 145,
            [(0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)]: 200,
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: 145,
            ...(0, (0, parcelRequire("35OFV")).getColumnWidths)()
        });
    const $8c034c8d39e84861$export$f2dfe9615519b1 = ()=>({
            [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: false,
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: false,
            [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: false,
            [(0, (0, parcelRequire("5fc53")).COMMENT_TYPE)]: false,
            [(0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE)]: false,
            [(0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)]: false,
            ...(0, (0, parcelRequire("ijSZT")).getSortingDisabledFields)()
        });
    const $8c034c8d39e84861$var$COMMON_COLUMN_ATTRIBUTES = {
        frozen: false,
        maxWidth: 640,
        minWidth: 120,
        resizable: true
    };
    const $8c034c8d39e84861$var$COLUMN_ATTRIBUTE_OVERRIDES = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: {
            minWidth: 52
        },
        [(0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)]: {
            minWidth: 200
        },
        key: {
            minWidth: 72
        }
    };
    const $8c034c8d39e84861$var$selectRowColumn = (showBulkEditOnboarding)=>({
            key: (0, (0, parcelRequire("3rO9r")).SELECT_ROW_COLUMN_ID),
            dataKey: (0, (0, parcelRequire("3rO9r")).SELECT_ROW_COLUMN_ID),
            width: (0, (0, parcelRequire("eTDjN")).SELECT_ROW_COLUMN_WIDTH),
            headerRenderer: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7xYOf")).SelectAllColumnCheckbox), {
                showBulkEditOnboarding: showBulkEditOnboarding
            }),
            cellRenderer: (props)=>{
                if ((0, (0, parcelRequire("3fT9O")).isItemSkeleton)(props.rowData.issueId)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    style: (0, (0, parcelRequire("cjOYL")).loadingCellStyles)
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yRl2")).CellNavigation), {
                    columnIndex: 0,
                    rowIndex: props.rowIndex || 0
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7xYOf")).SelectRowCheckbox), props));
            }
        });
    const $8c034c8d39e84861$var$iconSize = 'medium';
    const $8c034c8d39e84861$var$EMPTY_ARRAY = [];
    const $8c034c8d39e84861$var$EMPTY_PAGES_ARRAY = [];
    const $8c034c8d39e84861$var$isTimeTrackingConfigNeeded = (field)=>field.type === (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE);
    const $8c034c8d39e84861$export$5cedf9467e164d21 = ({ columnWidths: columnWidths, rowHeight: rowHeight, openIssueModal: openIssueModal, highlightRow: highlightRow, loading: pageLoading, projectId: projectId, onIssueUpdated: onIssueUpdated, showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getVisibleFields: getVisibleFields, loading: loading, isVisibleFieldsCached: isVisibleFieldsCached } = (0, (0, parcelRequire("8TUlY")).useIssueFields)();
        const visibleFields = getVisibleFields();
        const iconMap = (0, (0, parcelRequire("iILDa")).getFieldIcons)($8c034c8d39e84861$var$iconSize);
        const { data: projectData, getProjectData: getProjectData, loading: projectDataLoading } = (0, (0, parcelRequire("koElh")).useJiraSettings)();
        const [, { getParentIssueKeysByChildId: getParentIssueKeysByChildId }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { globalSystemFields: globalSystemFields } = (0, (0, parcelRequire("3O2kS")).useSystemFields)();
        const { onOpenCommentsSidebar: onOpenCommentsSidebar, selectedIssueKey: selectedIssueKey } = (0, (0, parcelRequire("4HIDQ")).useCommentsSidebar)({
            CommentsSidebar: (0, parcelRequire("bFmRi")).CommentsSidebar
        });
        const isIssueViewVisible = (0, (0, parcelRequire("939cg")).useIssueViewIsVisible)();
        const [{ createFields: createFields }] = (0, (0, parcelRequire("gEb1A")).useInlineFieldCreateControls)();
        const [hierarchyStore] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const currentFirstRowKey = (0, $5uXOq.useRef)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const defaultColumnWidths = (0, $5uXOq.useMemo)(()=>$8c034c8d39e84861$export$23779177436374fa(), []);
        const sortingActions = (0, $5uXOq.useMemo)(()=>$8c034c8d39e84861$export$f2dfe9615519b1(), []);
        const columnFields = (0, $5uXOq.useMemo)(()=>{
            const _columnFields = [
                ...visibleFields
            ];
            if (createFields.length > 0) createFields.forEach(({ fieldId: fieldId, name: name, type: type, createIndex: createIndex })=>{
                const placeholderField = {
                    id: `${(0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN)}-${fieldId}`,
                    name: name,
                    type: type
                };
                if (createIndex != null) _columnFields.splice(createIndex, 0, placeholderField);
                else _columnFields.push(placeholderField);
            });
            return _columnFields;
        }, [
            visibleFields,
            createFields
        ]);
        const getFirstGroupChildRowKey = (0, $5uXOq.useCallback)(()=>{
            const groups = hierarchyStore.hierarchyData.data;
            const firstGroupChild = groups[0]?.children;
            if (!Array.isArray(groups) || !firstGroupChild) return null;
            const firstGroupRow = firstGroupChild.length > 0 && firstGroupChild[0].key.startsWith((0, (0, parcelRequire("3fT9O")).INLINE_CREATE_ITEM_PREFIX)) ? firstGroupChild[1] : firstGroupChild[0];
            const firstGroupChildRowKey = firstGroupRow?.key ?? null;
            return firstGroupChildRowKey;
        }, [
            hierarchyStore.hierarchyData.data
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const firstGroupChildRowKey = getFirstGroupChildRowKey();
            currentFirstRowKey.current = firstGroupChildRowKey;
        }, [
            getFirstGroupChildRowKey
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!projectData && visibleFields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)) && !projectDataLoading && pageLoading === false) getProjectData();
        }, [
            projectData,
            pageLoading,
            getProjectData,
            visibleFields,
            projectDataLoading
        ]);
        const hierarchyLevelsByName = (0, $5uXOq.useMemo)(()=>Object.fromEntries(hierarchyLevelsWithCache.map((hierarchyLevel)=>[
                    hierarchyLevel.name,
                    hierarchyLevel.level,
                    hierarchyLevel.id
                ])), [
            hierarchyLevelsWithCache
        ]);
        const cellRenderers = (0, $5uXOq.useMemo)(()=>{
            const toReturn = {};
            columnFields.map((field)=>{
                switch(field.type){
                    case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData = {}, rowData: rowData })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eTHix")).TypeCell), {
                                    id: rowData.issueId,
                                    iconUrl: cellData.iconUrl,
                                    name: cellData.name,
                                    avatarId: field.fieldConfig?.avatarId,
                                    onChildCreateButtonClicked: rowData.onChildCreateButtonClicked,
                                    hierarchyLevel: hierarchyLevelsByName[rowData.issuetype.name ?? ''],
                                    rankIndex: rowData.rankIndex
                                })
                        };
                    case 'key':
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData })=>{
                                const parentIssues = getParentIssueKeysByChildId(rowData.issueId);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0CGYD")).KeyCell), {
                                    issueId: rowData.id,
                                    issueKey: cellData,
                                    parentIssues: parentIssues,
                                    onOpenIssueModal: openIssueModal
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData, rowIndex: rowIndex })=>{
                                const isNudgeCell = rowIndex === 0 || rowData?.key === currentFirstRowKey.current;
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iydSP")).TextCell), {
                                    isNudgeCell: (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? !isIssueViewVisible && isNudgeCell : isNudgeCell,
                                    issueId: rowData.issueId,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldType: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                                    fieldValue: cellData,
                                    fieldKey: field.id,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    testId: "business-list.ui.list-view.summary-cell"
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).URL_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const url = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'url', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NVIZ")).UrlCell), {
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldType: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                                    fieldValue: url,
                                    fieldKey: field.id,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const wiki = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'wiki', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iydSP")).TextCell), {
                                    issueId: rowData.issueId,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldType: (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
                                    fieldValue: wiki,
                                    fieldKey: field.id,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id,
                                    testId: "business-list.ui.list-view.text-cf-cell"
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const adf = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'adf', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gyyM")).TextAreaCell), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    onClick: openIssueModal(rowData),
                                    fieldValue: adf
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lup7l")).default), {
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    width: column.width,
                                    height: rowHeight,
                                    rowData: rowData,
                                    onHighlightRow: highlightRow,
                                    ...cellData
                                })
                        };
                    case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const userField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'userValue', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3T0IO")).default), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    initialValue: userField,
                                    width: column.width,
                                    emptyUserNameText: (0, (0, parcelRequire("aQK8w")).default).unassignedOption,
                                    loggedInUserActionNameText: (0, (0, parcelRequire("aQK8w")).default).assignToMe,
                                    testId: "business-list.ui.list-view.assignee-cell",
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).COMMENT_TYPE:
                    case 0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const totalCount = rowData?.commentSummary?.totalCount;
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3jNxz")).CommentsCell), {
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    isSelected: selectedIssueKey === rowData.key,
                                    onClick: onOpenCommentsSidebar,
                                    totalCount: totalCount
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const userField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'userValue', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3T0IO")).default), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    initialValue: userField,
                                    width: column.width,
                                    emptyUserNameText: (0, (0, parcelRequire("aQK8w")).default).unassignedOption,
                                    loggedInUserActionNameText: (0, (0, parcelRequire("aQK8w")).default).assignToMe,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const userField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'selectedUser', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3T0IO")).default), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    initialValue: userField,
                                    width: column.width,
                                    emptyUserNameText: (0, (0, parcelRequire("aQK8w")).default).unassignedOption,
                                    loggedInUserActionNameText: (0, (0, parcelRequire("aQK8w")).default).assignToMe,
                                    isEditable: userField?.isEditable,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const labels = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'labels', []);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e7PC0")).default), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    issueLabels: labels,
                                    width: column.width,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e7PC0")).default), {
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    issueLabels: cellData,
                                    width: column.width,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                })
                        };
                    case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>{
                                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
                                    const priorityValue = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'priority', {});
                                    const { name: name, id: id } = rowData.issuetype;
                                    if (typeof name !== 'string' || typeof id !== 'string') return;
                                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1HY3B")).default), {
                                        ...priorityValue,
                                        fieldType: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                                        issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                        width: column.width,
                                        height: rowHeight,
                                        fieldName: field.name,
                                        issueType: name,
                                        issueTypeId: id,
                                        testId: "business-list.ui.list-view.priority-cell",
                                        isEditable: field.fieldConfig?.isEditable ?? false,
                                        selectOptions: field.fieldConfig?.options ?? []
                                    });
                                }
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1HY3B")).default), {
                                    ...cellData,
                                    fieldType: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    width: column.width,
                                    height: rowHeight,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id,
                                    testId: "business-list.ui.list-view.priority-cell",
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    selectOptions: field.fieldConfig?.options ?? []
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Vqf5")).default), {
                                    issueId: rowData.issueId,
                                    fieldKey: field.id,
                                    dateOnly: cellData,
                                    fieldType: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    isDue: String(rowData.status?.categoryId) !== String((0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)((0, (0, parcelRequire("gULOk")).DONE))),
                                    testId: "business-list.ui.list-view.date-cell",
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                })
                        };
                    case 0, (0, parcelRequire("5fc53")).CREATED:
                    case 0, (0, parcelRequire("5fc53")).UPDATED:
                        return {
                            [field.id]: ({ cellData: cellData, rowData: rowData })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Vqf5")).default), {
                                    issueId: rowData.issueId,
                                    fieldKey: field.id,
                                    readOnly: true,
                                    dateOnly: cellData,
                                    onOpenIssueModal: openIssueModal,
                                    rowData: rowData,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                })
                        };
                    case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const selectedValue = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'selectedValue', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRFLq")).default), {
                                    fieldType: (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
                                    fieldName: field.name,
                                    width: column.width,
                                    fieldKey: field.id,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    fieldValue: selectedValue,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const selectedValues = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'selectedValues', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYkrQ")).default), {
                                    fieldType: (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
                                    fieldName: field.name,
                                    selectOptions: field.fieldConfig?.selectOptions,
                                    width: column.width,
                                    fieldKey: field.id,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    fieldValue: selectedValues,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const getFieldValue = ()=>(0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'value', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99NMg")).default), {
                                    issueId: rowData.issueId,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    width: column.width,
                                    fieldKey: field.id,
                                    fieldType: (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
                                    issueTypeId: rowData.issuetype.id != null ? Number.parseInt(rowData.issuetype.id, 10) : -1,
                                    isEditable: true,
                                    fieldValue: getFieldValue(),
                                    fieldName: field.name,
                                    issueType: rowData.issuetype?.name
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const originalEstimate = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'originalEstimate', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eRBDs")).default), {
                                    config: projectData?.jiraSettings?.timeTracking ?? undefined,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldId: field.id,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    fieldValue: originalEstimate
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const stringValue = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'stringValue', null);
                                return rowData && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Vqf5")).default), {
                                    issueId: rowData.issueId,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    readOnly: !field.fieldConfig?.isEditable,
                                    fieldType: (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
                                    fieldValue: stringValue,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                    case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                    case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>{
                                const numberField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'floatValue', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTzzn")).default), {
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    fieldType: field.type,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldValue: numberField,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const dateTimeField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'dateTimeValue', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iQ6fh")).default), {
                                    height: rowHeight,
                                    width: column.width,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldValue: dateTimeField,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE:
                    case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const multiUserField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, field.type === (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE) ? 'selectedUsers' : 'users', undefined);
                                const fieldType = field.type;
                                if (fieldType == null) return null;
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1vBWF")).default), {
                                    height: rowHeight,
                                    fieldKey: field.id,
                                    fieldType: fieldType,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    initialValue: multiUserField,
                                    width: column.width,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    fieldName: field.name,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const componentsField = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'componentValues', undefined);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rwUA")).default), {
                                    width: column.width,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    fieldValue: componentsField,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    issueId: rowData.issueId
                                });
                            }
                        };
                    case 0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9qBd")).default), {
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    issueId: rowData.issueId,
                                    pages: rowData.confluenceLinks?.linkedConfluencePages?.pages || $8c034c8d39e84861$var$EMPTY_PAGES_ARRAY,
                                    pageCount: rowData.confluenceLinks?.linkedConfluencePages?.pageCount || 0
                                })
                        };
                    case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const selectedValues = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'selectedValues', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kX1vD")).default), {
                                    width: column.width,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    fieldName: field.name,
                                    fieldValue: selectedValues,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    issueId: rowData.issueId,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id
                                });
                            }
                        };
                    case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                        return {
                            [field.id]: ({ rowData: rowData, column: column })=>{
                                const selectedValues = (0, (0, parcelRequire("57lFd")).safeGetTransformedFieldValue)(rowData.fields, field.id, 'sprint', null);
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9UvN")).default), {
                                    width: column.width,
                                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(rowData.key),
                                    fieldKey: field.id,
                                    fieldName: field.name,
                                    fieldValue: selectedValues,
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    issueId: rowData.issueId,
                                    issueType: rowData.issuetype.name,
                                    issueTypeId: rowData.issuetype.id,
                                    issueTypeLevel: rowData.issuetype.level
                                });
                            }
                        };
                    default:
                        return {
                            [field.id]: undefined
                        };
                }
            }).forEach((fieldEntry)=>fieldEntry && Object.keys(fieldEntry).forEach((fieldKey)=>{
                    toReturn[fieldKey] = fieldEntry[fieldKey];
                }));
            return toReturn;
        }, [
            columnFields,
            hierarchyLevelsByName,
            getParentIssueKeysByChildId,
            openIssueModal,
            isIssueViewVisible,
            rowHeight,
            highlightRow,
            selectedIssueKey,
            onOpenCommentsSidebar,
            projectData?.jiraSettings?.timeTracking
        ]);
        const iconMapWithCategoriesEnabled = (0, $5uXOq.useCallback)((field)=>{
            if (field.type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) return null;
            if (field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) return field.type != null && iconMap[field.type];
            return iconMap[field.id] ?? (field.type !== undefined && iconMap[field.type]);
        }, [
            iconMap
        ]);
        const canEditField = project.isSimplified && project.permissions?.administerProject;
        return (0, $5uXOq.useMemo)(()=>loading && !isVisibleFieldsCached ? $8c034c8d39e84861$var$EMPTY_ARRAY : [
                $8c034c8d39e84861$var$selectRowColumn(showBulkEditOnboarding),
                ...columnFields.map((field, index)=>{
                    const width = columnWidths[field.id] ?? (field.type !== undefined && defaultColumnWidths[field.type]) ?? 120;
                    return {
                        key: field.id,
                        dataKey: field.id,
                        width: width,
                        timeTrackingConfig: $8c034c8d39e84861$var$isTimeTrackingConfigNeeded(field) ? projectData?.jiraSettings?.timeTracking : undefined,
                        headerRenderer: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("al7Aq")).ColumnHeader), {
                            icon: iconMapWithCategoriesEnabled(field),
                            label: field.name,
                            fieldId: field.id,
                            fieldType: field.type,
                            canSortField: field.type !== undefined && (sortingActions[field.type] ?? true) && !field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN)),
                            canHideField: !$8c034c8d39e84861$var$getAlwaysVisibleFieldsMemoized().includes(field.id) && !field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN)),
                            canEditField: !!(canEditField && globalSystemFields.length && !globalSystemFields.includes(field.id) && !field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN))),
                            disableDrag: (0, (0, parcelRequire("3rO9r")).COLUMNS_WITH_DISABLED_REORDERING).includes(field.id) || field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN)),
                            index: index
                        }),
                        cellRenderer: (params)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i29pf")).CellWithHorizontalVirtualization), {
                                ...params,
                                cellRenderers: cellRenderers,
                                field: field,
                                key: params.column.key,
                                onIssueUpdated: onIssueUpdated,
                                projectId: projectId,
                                width: width
                            }),
                        ...$8c034c8d39e84861$var$COMMON_COLUMN_ATTRIBUTES,
                        ...$8c034c8d39e84861$var$COLUMN_ATTRIBUTE_OVERRIDES[field.id]
                    };
                })
            ], [
            loading,
            isVisibleFieldsCached,
            showBulkEditOnboarding,
            columnFields,
            columnWidths,
            defaultColumnWidths,
            projectData?.jiraSettings?.timeTracking,
            iconMapWithCategoriesEnabled,
            sortingActions,
            canEditField,
            globalSystemFields,
            cellRenderers,
            onIssueUpdated,
            projectId
        ]);
    };
});
parcelRegister("35OFV", function(module, exports) {
    $parcel$export(module.exports, "getColumnWidths", ()=>$82c6a3ce6b6561ce$export$e54c9225ca52acc);
    var $8QpSo;
    var $29sHF;
    var $45bkV;
    var $3kayq;
    var $ja4AN;
    var $2hdRM;
    var $jAVAE;
    var $1B2ke;
    var $UXtnp;
    const $82c6a3ce6b6561ce$export$e54c9225ca52acc = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("UXtnp")).versionColumnWidth),
            ...(0, (0, parcelRequire("29sHF")).devSummaryColumnWidth),
            ...(0, (0, parcelRequire("1B2ke")).teamColumnWidth),
            ...(0, (0, parcelRequire("45bkV")).goalsColumnWidth),
            ...(0, (0, parcelRequire("jAVAE")).resolutionColumnWidth),
            ...(0, (0, parcelRequire("3kayq")).groupColumnWidth),
            ...(0, (0, parcelRequire("2hdRM")).radioSelectColumnWidth),
            ...(0, (0, parcelRequire("ja4AN")).projectColumnWidth)
        }));
});
parcelRegister("29sHF", function(module, exports) {
    $parcel$export(module.exports, "devSummaryColumnWidth", ()=>$2b3505fa8b29c774$export$358a1d02595241e8);
    var $5fc53;
    const $2b3505fa8b29c774$export$358a1d02595241e8 = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: 160
    };
});
parcelRegister("45bkV", function(module, exports) {
    $parcel$export(module.exports, "goalsColumnWidth", ()=>$43e3d5588f0a98c3$export$775dc358f0002ea0);
    var $5fc53;
    const $43e3d5588f0a98c3$export$775dc358f0002ea0 = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: 160
    };
});
parcelRegister("3kayq", function(module, exports) {
    $parcel$export(module.exports, "groupColumnWidth", ()=>$ac63a7647149f192$export$67a3cc86fcd4231);
    var $5fc53;
    const $ac63a7647149f192$export$67a3cc86fcd4231 = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: 160,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: 160
    };
});
parcelRegister("ja4AN", function(module, exports) {
    $parcel$export(module.exports, "projectColumnWidth", ()=>$f742573b639cf5c7$export$8f9363e2d2217d2a);
    var $5fc53;
    const $f742573b639cf5c7$export$8f9363e2d2217d2a = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: 160
    };
});
parcelRegister("2hdRM", function(module, exports) {
    $parcel$export(module.exports, "radioSelectColumnWidth", ()=>$97ec0edab3d93beb$export$c34ad8e09b312cd3);
    var $5fc53;
    const $97ec0edab3d93beb$export$c34ad8e09b312cd3 = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: 160
    };
});
parcelRegister("jAVAE", function(module, exports) {
    $parcel$export(module.exports, "resolutionColumnWidth", ()=>$14dc170c77505262$export$a759c5e7f31f10ca);
    var $5fc53;
    const $14dc170c77505262$export$a759c5e7f31f10ca = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: 160
    };
});
parcelRegister("1B2ke", function(module, exports) {
    $parcel$export(module.exports, "teamColumnWidth", ()=>$c7cd699e434b0d38$export$1f7dab61cbeaeb04);
    var $5fc53;
    const $c7cd699e434b0d38$export$1f7dab61cbeaeb04 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: 160
    };
});
parcelRegister("UXtnp", function(module, exports) {
    $parcel$export(module.exports, "versionColumnWidth", ()=>$b29d1cd1f93af855$export$99cf8efcc69bcfe1);
    var $5fc53;
    const $b29d1cd1f93af855$export$99cf8efcc69bcfe1 = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: 160,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: 160,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: 160,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: 160
    };
});
parcelRegister("iILDa", function(module, exports) {
    $parcel$export(module.exports, "getFieldIcons", ()=>$7baed92d0530c851$export$df250ca2240f6516);
    var $gJBT6 = parcelRequire("gJBT6");
    var $4R6GH;
    var $dCm1o;
    var $e9eMH;
    var $bViCV;
    var $662ks;
    var $3TWSN;
    var $bgVbd;
    var $ct5ko;
    var $iAedE;
    var $jlels;
    var $39zTs;
    var $a3Xnj;
    var $6WNmP;
    var $6TIYL;
    const $7baed92d0530c851$export$df250ca2240f6516 = (0, ($parcel$interopDefault($gJBT6)))((size)=>{
        const spacing = size === 'medium' && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'spacious' : 'none';
        const legacyFieldIcons = (0, (0, parcelRequire("6TIYL")).getLegacyFieldIcons)({
            size: size,
            spacing: spacing
        });
        return {
            ...legacyFieldIcons,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                ...(0, (0, parcelRequire("6WNmP")).getVersionIcons)(size, spacing),
                ...(0, (0, parcelRequire("bgVbd")).getParentIcon)(size, spacing),
                ...(0, (0, parcelRequire("bViCV")).getDevSummaryIcons)(size, spacing),
                ...(0, (0, parcelRequire("a3Xnj")).getTeamIcons)(size, spacing),
                ...(0, (0, parcelRequire("662ks")).getGoalsIcons)(size, spacing)
            } : {},
            ...(0, (0, parcelRequire("jlels")).getResolutionIcons)(size, spacing),
            ...(0, (0, parcelRequire("3TWSN")).getGroupIcons)(size, spacing),
            ...(0, (0, parcelRequire("39zTs")).getStatusCategoryIcons)(size, spacing),
            ...(0, (0, parcelRequire("iAedE")).getRadioSelectIcon)(size, spacing),
            ...(0, (0, parcelRequire("ct5ko")).getProjectIcons)(size, spacing),
            ...(0, (0, parcelRequire("e9eMH")).getCascadingSelectIcons)(size, spacing)
        };
    });
});
parcelRegister("e9eMH", function(module, exports) {
    $parcel$export(module.exports, "getCascadingSelectIcons", ()=>$cab199932002825c$export$a1c73b689cfdba0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $726zd;
    var $lxS2w;
    var $5fc53;
    const $cab199932002825c$export$a1c73b689cfdba0d = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("726zd"))))), {
                label: "",
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("lxS2w")))))
            })
        });
});
parcelRegister("726zd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $51edd060d29365e3$var$_react = $51edd060d29365e3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $51edd060d29365e3$var$_UNSAFE_baseNew = $51edd060d29365e3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $51edd060d29365e3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $51edd060d29365e3$var$BulletedListIcon = (props)=>$51edd060d29365e3$var$_react.default.createElement($51edd060d29365e3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
        }, props));
    $51edd060d29365e3$var$BulletedListIcon.displayName = 'BulletedListIcon';
    var $51edd060d29365e3$var$_default = module.exports.default = $51edd060d29365e3$var$BulletedListIcon;
});
parcelRegister("lxS2w", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $faf6993318468f57$var$_react = $faf6993318468f57$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $faf6993318468f57$var$_listBulleted = $faf6993318468f57$var$_interopRequireDefault((parcelRequire("bEjt9")));
    function $faf6993318468f57$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $faf6993318468f57$var$EditorBulletListIcon = (props)=>$faf6993318468f57$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
        }, props, {
            newIcon: $faf6993318468f57$var$_listBulleted.default
        }));
    $faf6993318468f57$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
    var $faf6993318468f57$var$_default = module.exports.default = $faf6993318468f57$var$EditorBulletListIcon;
});
parcelRegister("bEjt9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87b28849bcb64a34$var$_UNSAFE_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87b28849bcb64a34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>$87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
        }, props));
    $87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
    var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;
});
parcelRegister("bViCV", function(module, exports) {
    $parcel$export(module.exports, "getDevSummaryIcons", ()=>$5eb2ab3f85f5e801$export$af7756d867a4596f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4iPF3;
    var $9XvX5;
    var $5fc53;
    const $5eb2ab3f85f5e801$export$af7756d867a4596f = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4iPF3"))))), {
                label: "",
                color: "currentColor",
                spacing: spacing,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("9XvX5"))))),
                LEGACY_size: size
            })
        });
});
parcelRegister("4iPF3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3220eab15e59539d$var$_UNSAFE_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3220eab15e59539d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3220eab15e59539d$var$BranchIcon = (props)=>$3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
        }, props));
    $3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
    var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;
});
parcelRegister("9XvX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
    function $740268c474e86b43$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>$740268c474e86b43$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
        }, props, {
            newIcon: $740268c474e86b43$var$_branch.default
        }));
    $740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
    var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;
});
parcelRegister("662ks", function(module, exports) {
    $parcel$export(module.exports, "getGoalsIcons", ()=>$2abb01abbbef961f$export$191c71adb6287036);
    var $5uXOq = parcelRequire("5uXOq");
    var $4iV1e;
    var $4R6GH;
    var $5fc53;
    var $dCm1o;
    const $2abb01abbbef961f$export$191c71adb6287036 = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4iV1e"))))), {
                label: "",
                spacing: spacing,
                LEGACY_size: size,
                color: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'currentColor' : "var(--ds-icon, #44546F)"
            })
        });
});
parcelRegister("3TWSN", function(module, exports) {
    $parcel$export(module.exports, "getGroupIcons", ()=>$22c451d7b18611a5$export$4b39ade85c5051f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $fptva;
    var $kFO36;
    var $5fc53;
    const $22c451d7b18611a5$export$4b39ade85c5051f7 = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fptva"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("kFO36")))))
            }),
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fptva"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("kFO36")))))
            })
        });
});
parcelRegister("bgVbd", function(module, exports) {
    $parcel$export(module.exports, "getParentIcon", ()=>$ed8bbd7a9b338871$export$744c82990563f55a);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $8PbqG;
    const $ed8bbd7a9b338871$export$744c82990563f55a = ()=>({
            [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8PbqG")).HierarchyIcon), null)
        });
});
parcelRegister("8PbqG", function(module, exports) {
    $parcel$export(module.exports, "HierarchyIcon", ()=>$40fd4b04549e2998$export$8c3a8f220bd0db42);
    var $5uXOq = parcelRequire("5uXOq");
    const $40fd4b04549e2998$export$8c3a8f220bd0db42 = ({ size: size = 24 })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "4.33333",
            cy: "4.66732",
            r: "1.33333",
            stroke: "#9FADBC",
            "stroke-width": "1.33333"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "10.9998",
            cy: "11.3333",
            r: "1.33333",
            stroke: "#9FADBC",
            "stroke-width": "1.33333"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
            stroke: "#9FADBC",
            "stroke-width": "1.33333"
        }));
});
parcelRegister("ct5ko", function(module, exports) {
    $parcel$export(module.exports, "getProjectIcons", ()=>$9104da68dce3f532$export$6db5abb9a6c7aec2);
    var $5uXOq = parcelRequire("5uXOq");
    var $9xuGL;
    var $bP37O;
    var $5fc53;
    const $9104da68dce3f532$export$6db5abb9a6c7aec2 = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9xuGL"))))), {
                color: "currentColor",
                label: "",
                spacing: spacing,
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("bP37O")))))
            })
        });
});
parcelRegister("iAedE", function(module, exports) {
    $parcel$export(module.exports, "getRadioSelectIcon", ()=>$c74528cd7e4bc25a$export$c36fadaa74abd39e);
    var $5uXOq = parcelRequire("5uXOq");
    var $kqGQn;
    var $iQHJo;
    var $5fc53;
    const $c74528cd7e4bc25a$export$c36fadaa74abd39e = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kqGQn"))))), {
                color: "currentColor",
                label: "",
                spacing: spacing,
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("iQHJo")))))
            })
        });
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("jlels", function(module, exports) {
    $parcel$export(module.exports, "getResolutionIcons", ()=>$7c2789aa231c9f2d$export$e9550187a88e57a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjo8S;
    var $4DXCl;
    var $5fc53;
    const $7c2789aa231c9f2d$export$e9550187a88e57a5 = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bjo8S"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("4DXCl"))))),
                label: ""
            })
        });
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("39zTs", function(module, exports) {
    $parcel$export(module.exports, "getStatusCategoryIcons", ()=>$d864fb264f22652f$export$f263f5d2ca3dcccb);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgRoK;
    var $1pwdH;
    var $5fc53;
    const $d864fb264f22652f$export$f263f5d2ca3dcccb = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cgRoK"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("1pwdH")))))
            })
        });
});
parcelRegister("cgRoK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8ef0666e0cb275e1$var$_react = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8ef0666e0cb275e1$var$_UNSAFE_baseNew = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8ef0666e0cb275e1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8ef0666e0cb275e1$var$LozengeIcon = (props)=>$8ef0666e0cb275e1$var$_react.default.createElement($8ef0666e0cb275e1$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M2 11.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H2C1.31 4.75.75 5.31.75 6v4c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $8ef0666e0cb275e1$var$LozengeIcon.displayName = 'LozengeIcon';
    var $8ef0666e0cb275e1$var$_default = module.exports.default = $8ef0666e0cb275e1$var$LozengeIcon;
});
parcelRegister("1pwdH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $10711e7344caba74$var$_react = $10711e7344caba74$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $10711e7344caba74$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $10711e7344caba74$var$StatusIcon = (props)=>$10711e7344caba74$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
        }, props));
    $10711e7344caba74$var$StatusIcon.displayName = 'StatusIcon';
    var $10711e7344caba74$var$_default = module.exports.default = $10711e7344caba74$var$StatusIcon;
});
parcelRegister("a3Xnj", function(module, exports) {
    $parcel$export(module.exports, "getTeamIcons", ()=>$a56e7484244cb118$export$b7d8ffd86073bea);
    var $5uXOq = parcelRequire("5uXOq");
    var $c781K;
    var $8E9tB;
    var $5fc53;
    const $a56e7484244cb118$export$b7d8ffd86073bea = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c781K"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("8E9tB")))))
            })
        });
});
parcelRegister("8E9tB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64b968f6017085d1$var$_react = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $64b968f6017085d1$var$_teams = $64b968f6017085d1$var$_interopRequireDefault((parcelRequire("c781K")));
    function $64b968f6017085d1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64b968f6017085d1$var$TeamsIcon = (props)=>$64b968f6017085d1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
        }, props, {
            newIcon: $64b968f6017085d1$var$_teams.default
        }));
    $64b968f6017085d1$var$TeamsIcon.displayName = 'TeamsIcon';
    var $64b968f6017085d1$var$_default = module.exports.default = $64b968f6017085d1$var$TeamsIcon;
});
parcelRegister("6WNmP", function(module, exports) {
    $parcel$export(module.exports, "getVersionIcons", ()=>$f62a45208355ca06$export$5c5f41529027464e);
    var $5uXOq = parcelRequire("5uXOq");
    var $2Ljwn;
    var $jUUuf;
    var $5fc53;
    const $f62a45208355ca06$export$5c5f41529027464e = (size, spacing)=>({
            [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("jUUuf")))))
            }),
            [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("jUUuf")))))
            }),
            [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("jUUuf")))))
            }),
            [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_size: size,
                label: "",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("jUUuf")))))
            })
        });
});
parcelRegister("6TIYL", function(module, exports) {
    $parcel$export(module.exports, "getLegacyFieldIcons", ()=>$c2272700869b41b5$export$eddca397cc46c15);
    var $5uXOq = parcelRequire("5uXOq");
    var $i6luQ;
    var $3fesp;
    var $aoKYM;
    var $hyKRO;
    var $bFmnZ;
    var $ehis8;
    var $fhbwe;
    var $gmyWi;
    var $1f9bV;
    var $izMdR;
    var $fYy29;
    var $kdfZa;
    var $fptva;
    var $1bKdn;
    var $8mG85;
    var $iRvAI;
    var $eKl4L;
    var $kauzw;
    var $cTemL;
    var $6aY6N;
    var $asS9k;
    var $DBbS0;
    var $7dTJQ;
    var $a76wv;
    var $7WxSP;
    var $3kXe9;
    var $6uqJA;
    var $lRPYt;
    var $8sgpE;
    var $cL0IW;
    var $8FAWm;
    var $aLbwz;
    var $eWXbg;
    var $h8cgU;
    var $j85Tc;
    var $5IlYG;
    var $iyo13;
    var $gKopa;
    var $hORKG;
    var $dC5iT;
    var $8CUq3;
    var $hE5wF;
    var $5fc53;
    var $dCm1o;
    const $c2272700869b41b5$var$PriorityIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            focusable: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
            fill: "currentColor"
        }));
    const $c2272700869b41b5$var$StatusIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            focusable: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
            fill: "currentColor"
        }));
    const $c2272700869b41b5$var$NumberGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
            fill: "currentColor",
            fillRule: "evenodd"
        }));
    const $c2272700869b41b5$var$TypeIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
            fill: "currentColor"
        }));
    const $c2272700869b41b5$var$KeyIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
            fill: "currentColor"
        }));
    const $c2272700869b41b5$var$EpicIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
            fill: "currentColor"
        }));
    const $c2272700869b41b5$var$renderChevronDownIcon = ({ size: size })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c2272700869b41b5$var$iconSpacing
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
            LEGACY_size: size,
            color: "currentColor",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("asS9k"))))),
            label: ""
        });
    const $c2272700869b41b5$export$eddca397cc46c15 = ({ size: size, spacing: spacing })=>({
            key: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$KeyIcon, null),
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$TypeIcon, null),
            [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i6luQ"))))), {
                color: "currentColor",
                spacing: spacing,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("a76wv"))))),
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$StatusIcon, null),
            [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("izMdR"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("3kXe9"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eKl4L"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cL0IW"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fesp"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).CREATED)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fesp"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).UPDATED)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fesp"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_DATE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fesp"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$PriorityIcon, null),
            [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("izMdR"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("3kXe9"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kauzw"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("lRPYt"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1f9bV"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("j85Tc"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i6luQ"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("a76wv"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $c2272700869b41b5$var$renderChevronDownIcon({
                size: size
            }),
            [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $c2272700869b41b5$var$renderChevronDownIcon({
                size: size
            }),
            [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fesp"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
            [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyKRO"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6uqJA"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fptva"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyKRO"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("5IlYG"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ehis8"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("7dTJQ"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
            [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$NumberGlyph, null),
            [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eKl4L"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("cL0IW"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fptva"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).SUBTASKS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iRvAI"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("gKopa"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fYy29"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("aLbwz"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).EPIC_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement($c2272700869b41b5$var$EpicIcon, null),
            [(0, (0, parcelRequire("5fc53")).COMMENT_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("DBbS0"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("DBbS0"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aoKYM"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8mG85"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("iyo13"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kdfZa"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("eWXbg"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gmyWi"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            }),
            [(0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE)]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fhbwe"))))), {
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("8FAWm"))))),
                spacing: spacing,
                LEGACY_size: size,
                label: ""
            })
        });
    const $c2272700869b41b5$var$iconSpacing = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.075',
        marginTop: 'space.050'
    });
});
parcelRegister("i6luQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d2d976446b240c09$var$_react = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d2d976446b240c09$var$_UNSAFE_baseNew = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d2d976446b240c09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d2d976446b240c09$var$AlignLeftIcon = (props)=>$d2d976446b240c09$var$_react.default.createElement($d2d976446b240c09$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
        }, props));
    $d2d976446b240c09$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
    var $d2d976446b240c09$var$_default = module.exports.default = $d2d976446b240c09$var$AlignLeftIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("bFmnZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e4e36d6c115ce9$var$_UNSAFE_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e4e36d6c115ce9$var$CommentIcon = (props)=>$87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
        }, props));
    $87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
    var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;
});
parcelRegister("ehis8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a650f78d49c8cbb1$var$_UNSAFE_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>$a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.25H2c-.69 0-1.25.56-1.25 1.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.5c0-.69-.56-1.25-1.25-1.25h-.75m-10.5 0v-2.5h3.5v2.5m-3.5 0h3.5m0 0h3.5m0 0v-2.5h3.5v2.5m-3.5 0h3.5"/>`
        }, props));
    $a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
    var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;
});
parcelRegister("fhbwe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b1f160f6235a0c00$var$_react = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b1f160f6235a0c00$var$_UNSAFE_baseNew = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b1f160f6235a0c00$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b1f160f6235a0c00$var$ImageIcon = (props)=>$b1f160f6235a0c00$var$_react.default.createElement($b1f160f6235a0c00$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
        }, props));
    $b1f160f6235a0c00$var$ImageIcon.displayName = 'ImageIcon';
    var $b1f160f6235a0c00$var$_default = module.exports.default = $b1f160f6235a0c00$var$ImageIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("izMdR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d860e6e53b6f4f6d$var$_react = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d860e6e53b6f4f6d$var$_UNSAFE_baseNew = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d860e6e53b6f4f6d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d860e6e53b6f4f6d$var$MentionIcon = (props)=>$d860e6e53b6f4f6d$var$_react.default.createElement($d860e6e53b6f4f6d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linecap="square" stroke-width="1.5" d="M11.625 14.28A7.25 7.25 0 1 1 15.25 8c0 1.381-.932 3.107-2.59 3.107-1.656 0-1.782-1.976-1.782-3.357l.005-.125m0 0c.022-1.019-.42-1.956-1.258-2.44-1.315-.759-3.11-.114-4.007 1.44s-.558 3.43.757 4.19c1.315.759 3.11.115 4.007-1.44a3.7 3.7 0 0 0 .5-1.75Z"/>`
        }, props));
    $d860e6e53b6f4f6d$var$MentionIcon.displayName = 'MentionIcon';
    var $d860e6e53b6f4f6d$var$_default = module.exports.default = $d860e6e53b6f4f6d$var$MentionIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("8mG85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $61710ed7f2aa84a3$var$_UNSAFE_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61710ed7f2aa84a3$var$SprintIcon = (props)=>$61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
    var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;
});
parcelRegister("iRvAI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $dbb5ae8ec700c853$var$_UNSAFE_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>$dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3 8h10c.69 0 1.25.56 1.25 1.25V13c0 .69-.56 1.25-1.25 1.25H9.25C8.56 14.25 8 13.69 8 13V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v3.75C1.75 7.44 2.31 8 3 8Z"/>`
        }, props));
    $dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
    var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;
});
parcelRegister("eKl4L", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $abc5b5ca44dcd9b7$var$_react = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $abc5b5ca44dcd9b7$var$_UNSAFE_baseNew = $abc5b5ca44dcd9b7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $abc5b5ca44dcd9b7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $abc5b5ca44dcd9b7$var$TagIcon = (props)=>$abc5b5ca44dcd9b7$var$_react.default.createElement($abc5b5ca44dcd9b7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
        }, props));
    $abc5b5ca44dcd9b7$var$TagIcon.displayName = 'TagIcon';
    var $abc5b5ca44dcd9b7$var$_default = module.exports.default = $abc5b5ca44dcd9b7$var$TagIcon;
});
parcelRegister("kauzw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eaec74c566e8a5e8$var$_UNSAFE_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>$eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
        }, props));
    $eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
    var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("asS9k", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79e685e2724d7fad$var$_react = $79e685e2724d7fad$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $79e685e2724d7fad$var$_chevronDown = $79e685e2724d7fad$var$_interopRequireDefault((parcelRequire("hORKG")));
    function $79e685e2724d7fad$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79e685e2724d7fad$var$ChevronDownCircleIcon = (props)=>$79e685e2724d7fad$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
        }, props, {
            newIcon: $79e685e2724d7fad$var$_chevronDown.default,
            iconType: "utility"
        }));
    $79e685e2724d7fad$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
    var $79e685e2724d7fad$var$_default = module.exports.default = $79e685e2724d7fad$var$ChevronDownCircleIcon;
});
parcelRegister("DBbS0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07707de1f3ce8a8c$var$_react = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $07707de1f3ce8a8c$var$_comment = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("bFmnZ")));
    function $07707de1f3ce8a8c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07707de1f3ce8a8c$var$CommentIcon = (props)=>$07707de1f3ce8a8c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
        }, props, {
            newIcon: $07707de1f3ce8a8c$var$_comment.default
        }));
    $07707de1f3ce8a8c$var$CommentIcon.displayName = 'CommentIcon';
    var $07707de1f3ce8a8c$var$_default = module.exports.default = $07707de1f3ce8a8c$var$CommentIcon;
});
parcelRegister("7dTJQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5424fbcfeb6a920c$var$_react = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5424fbcfeb6a920c$var$_component = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("ehis8")));
    function $5424fbcfeb6a920c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5424fbcfeb6a920c$var$ComponentIcon = (props)=>$5424fbcfeb6a920c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
        }, props, {
            newIcon: $5424fbcfeb6a920c$var$_component.default
        }));
    $5424fbcfeb6a920c$var$ComponentIcon.displayName = 'ComponentIcon';
    var $5424fbcfeb6a920c$var$_default = module.exports.default = $5424fbcfeb6a920c$var$ComponentIcon;
});
parcelRegister("a76wv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $75cf9e3d9f96735a$var$_react = $75cf9e3d9f96735a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $75cf9e3d9f96735a$var$_alignLeft = $75cf9e3d9f96735a$var$_interopRequireDefault((parcelRequire("i6luQ")));
    function $75cf9e3d9f96735a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $75cf9e3d9f96735a$var$EditorAlignLeftIcon = (props)=>$75cf9e3d9f96735a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
        }, props, {
            newIcon: $75cf9e3d9f96735a$var$_alignLeft.default
        }));
    $75cf9e3d9f96735a$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
    var $75cf9e3d9f96735a$var$_default = module.exports.default = $75cf9e3d9f96735a$var$EditorAlignLeftIcon;
});
parcelRegister("7WxSP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>$5c883bb6fff27f31$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
        }, props, {
            newIcon: $5c883bb6fff27f31$var$_link.default
        }));
    $5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
    var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;
});
parcelRegister("3kXe9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $26e12eaafd006aef$var$_react = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $26e12eaafd006aef$var$_mention = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("izMdR")));
    function $26e12eaafd006aef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $26e12eaafd006aef$var$EditorMentionIcon = (props)=>$26e12eaafd006aef$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
        }, props, {
            newIcon: $26e12eaafd006aef$var$_mention.default
        }));
    $26e12eaafd006aef$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
    var $26e12eaafd006aef$var$_default = module.exports.default = $26e12eaafd006aef$var$EditorMentionIcon;
});
parcelRegister("6uqJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $4b9a484973717fe2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>$4b9a484973717fe2$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
        }, props, {
            newIcon: $4b9a484973717fe2$var$_clock.default
        }));
    $4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
    var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;
});
parcelRegister("lRPYt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $feb6dd38b103e72a$var$_react = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $feb6dd38b103e72a$var$_textStyle = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("kauzw")));
    function $feb6dd38b103e72a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $feb6dd38b103e72a$var$EmojiKeyboardIcon = (props)=>$feb6dd38b103e72a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
        }, props, {
            newIcon: $feb6dd38b103e72a$var$_textStyle.default
        }));
    $feb6dd38b103e72a$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
    var $feb6dd38b103e72a$var$_default = module.exports.default = $feb6dd38b103e72a$var$EmojiKeyboardIcon;
});
parcelRegister("cL0IW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $949a6f91366cfd9f$var$_react = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $949a6f91366cfd9f$var$_tag = $949a6f91366cfd9f$var$_interopRequireDefault((parcelRequire("eKl4L")));
    function $949a6f91366cfd9f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $949a6f91366cfd9f$var$LabelIcon = (props)=>$949a6f91366cfd9f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
        }, props, {
            newIcon: $949a6f91366cfd9f$var$_tag.default
        }));
    $949a6f91366cfd9f$var$LabelIcon.displayName = 'LabelIcon';
    var $949a6f91366cfd9f$var$_default = module.exports.default = $949a6f91366cfd9f$var$LabelIcon;
});
parcelRegister("8FAWm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64fecea1e5bea51d$var$_react = $64fecea1e5bea51d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $64fecea1e5bea51d$var$_image = $64fecea1e5bea51d$var$_interopRequireDefault((parcelRequire("fhbwe")));
    function $64fecea1e5bea51d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64fecea1e5bea51d$var$MediaServicesScaleLargeIcon = (props)=>$64fecea1e5bea51d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007m-2 0A3.006 3.006 0 0 1 6.007 3h11.986A3.006 3.006 0 0 1 21 6.007v11.986A3.006 3.006 0 0 1 17.993 21H6.007A3.006 3.006 0 0 1 3 17.993z"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.73.73 0 0 0-.167-.44L14.5 11.85a.24.24 0 0 0-.344-.006L11 15l-.821-.821a.25.25 0 0 0-.358 0l-2.465 2.465c-.195.195-.136.356.135.356z"/><circle cx="9" cy="9" r="2"/></g></svg>`
        }, props, {
            newIcon: $64fecea1e5bea51d$var$_image.default
        }));
    $64fecea1e5bea51d$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
    var $64fecea1e5bea51d$var$_default = module.exports.default = $64fecea1e5bea51d$var$MediaServicesScaleLargeIcon;
});
parcelRegister("eWXbg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
    function $ae246388ea520792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ae246388ea520792$var$PageIcon = (props)=>$ae246388ea520792$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
        }, props, {
            newIcon: $ae246388ea520792$var$_page.default
        }));
    $ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
    var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;
});
parcelRegister("h8cgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
    function $c78cb3eb85357720$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c78cb3eb85357720$var$PeopleIcon = (props)=>$c78cb3eb85357720$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $c78cb3eb85357720$var$_peopleGroup.default
        }));
    $c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
    var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;
});
parcelRegister("iyo13", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
    function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d81e080f0024ae1d$var$SprintIcon = (props)=>$d81e080f0024ae1d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
        }, props, {
            newIcon: $d81e080f0024ae1d$var$_sprint.default
        }));
    $d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
    var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;
});
parcelRegister("gKopa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c313df89ecedecba$var$_react = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c313df89ecedecba$var$_subtasks = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("iRvAI")));
    function $c313df89ecedecba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c313df89ecedecba$var$SubtaskIcon = (props)=>$c313df89ecedecba$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
        }, props, {
            newIcon: $c313df89ecedecba$var$_subtasks.default
        }));
    $c313df89ecedecba$var$SubtaskIcon.displayName = 'SubtaskIcon';
    var $c313df89ecedecba$var$_default = module.exports.default = $c313df89ecedecba$var$SubtaskIcon;
});
parcelRegister("939cg", function(module, exports) {
    $parcel$export(module.exports, "useIssueViewIsVisible", ()=>$34fa9fb07bb53175$export$433ecf2b8511729e);
    var $hE5wF;
    var $ieDtd;
    const $34fa9fb07bb53175$export$433ecf2b8511729e = ()=>{
        const [selectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        return selectedIssueKey != null;
    };
});
parcelRegister("cjOYL", function(module, exports) {
    $parcel$export(module.exports, "loadingCellStyles", ()=>$8fe3565086e02d38$export$81b1b3cccf003fa1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $8fe3565086e02d38$export$81b1b3cccf003fa1 = {
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N20})`,
        paddingleft: '1px',
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`,
        width: `calc(100% - ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px)`,
        height: `calc(100% - ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px)`,
        marginLeft: "var(--ds-space-100, 8px)"
    };
    const $8fe3565086e02d38$export$5191481abee8295e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_9povrw": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width - (0, (0, parcelRequire("gwIPs")).gridSize) * 2, "px"),
                "--_1z066df": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height - (0, (0, parcelRequire("gwIPs")).gridSize) * 2, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1aqf _14eot94y _2rko1l7b _1bsb5cnj _4t3i5cnj _18u0u2gc",
                __cmplp.width ? "_1bsb1fse" : "_1bsb5cnj",
                __cmplp.height ? "_4t3i14kp" : "_4t3i5cnj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4HIDQ", function(module, exports) {
    $parcel$export(module.exports, "useCommentsSidebar", ()=>$13a0c7c1170b3aa4$export$aec60bac36c8115);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $hE5wF;
    var $8zOmE;
    var $2NMNM;
    var $ieDtd;
    const $13a0c7c1170b3aa4$export$aec60bac36c8115 = ({ CommentsSidebar: CommentsSidebar })=>{
        const [selectedIssueKey, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM));
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onOpen = (0, $5uXOq.useCallback)((issueKey)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar opened');
            setSelectedIssueKey(issueKey);
        }, [
            createAnalyticsEvent,
            setSelectedIssueKey
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar closed');
            setSelectedIssueKey(undefined);
            setSidebarContent(null);
        }, [
            createAnalyticsEvent,
            setSelectedIssueKey,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (selectedIssueKey) {
                const newContent = (0, ($parcel$interopDefault($5uXOq))).createElement(CommentsSidebar, {
                    issueKey: selectedIssueKey,
                    onClose: onClose
                });
                setSidebarContent(newContent);
            }
        }, [
            CommentsSidebar,
            onClose,
            selectedIssueKey,
            setSidebarContent
        ]);
        return {
            selectedIssueKey: selectedIssueKey,
            onOpenCommentsSidebar: onOpen,
            onCloseCommentsSidebar: onClose
        };
    };
});
parcelRegister("3O2kS", function(module, exports) {
    $parcel$export(module.exports, "useSystemFields", ()=>$a34a71fc4c701024$export$91f469581f79f11f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $1T2vX;
    const $a34a71fc4c701024$export$91f469581f79f11f = ()=>{
        const { data: data } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const globalSystemFields = (0, $5uXOq.useMemo)(()=>{
            if (!data || !data.fields || !data.fields.length) return [];
            const issueTypesAndFieldsData = data.fields;
            return issueTypesAndFieldsData.filter((field)=>!field.id.startsWith('customfield')).map((field)=>field.id).concat('key', (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE), (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE));
        }, [
            data
        ]);
        return {
            globalSystemFields: globalSystemFields
        };
    };
});
parcelRegister("koElh", function(module, exports) {
    $parcel$export(module.exports, "useJiraSettings", ()=>$8d4b4af78901e39c$export$5de424af876772e4);
    var $5tTFS;
    var $jcw0u;
    var $4R6GH;
    var $4NLOw;
    var $fJJRm;
    const $8d4b4af78901e39c$export$5de424af876772e4 = ()=>{
        const [getProjectData, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("fJJRm")).JIRA_SETTINGS_QUERY), {
            onError: (apolloError)=>{
                if (!(0, (0, parcelRequire("4NLOw")).shouldHandleTheError)(apolloError) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_-_support_partial_failures_services')) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jiraSettingsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch jira settings in list view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        return {
            error: error,
            loading: loading,
            data: data,
            getProjectData: getProjectData
        };
    };
});
parcelRegister("fJJRm", function(module, exports) {
    $parcel$export(module.exports, "JIRA_SETTINGS_QUERY", ()=>$4f83e50084561132$export$652ac25405e90703);
    var $5cllN;
    const $4f83e50084561132$export$652ac25405e90703 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessSettings {
    jiraSettings {
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
        format
      }
    }
  }
`;
});
parcelRegister("99NMg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcf1c729996b187a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $i5fxJ;
    const $dcf1c729996b187a$var$LazyCategoryCell = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("i5fxJ"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/category-cell/main.tsx"
    });
    const $dcf1c729996b187a$var$AsyncCategoryCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "category-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dcf1c729996b187a$var$LazyCategoryCell, props));
    var $dcf1c729996b187a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("i5fxJ")).default), $dcf1c729996b187a$var$AsyncCategoryCell);
});
parcelRegister("i5fxJ", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$3e8153a5e26c0c65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kgoHi;
    var $8CUq3;
    var $64gJA;
    var $daQYX;
    var $b5lmY;
    var $e0a4D;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $lI995;
    var $dSjBh;
    var $3aLMK;
    var $gvQOt;
    var $cPZte;
    const $3e8153a5e26c0c65$var$CategoryCell = ({ isEditable: isEditable, fieldKey: fieldKey, fieldValue: fieldValue, issueKey: issueKey, width: width, fieldType: fieldType, issueTypeId: issueTypeId, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName, editMode: editMode = false, setEditMode: setEditMode = (0, ($parcel$interopDefault($8Rkzz))), cellRef: cellRef, issueType: issueType = '', inputValue: inputValue, onInputChange: onInputChange })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [categoryCellState, setCategoryCellState] = (0, $5uXOq.useState)({
            status: 'read-mode'
        });
        const [categoryToDeleteInModal, setCategoryToDeleteInModal] = (0, $5uXOq.useState)(null);
        const { editFieldError: editFieldError, categoryState: categoryState, createAndAssignNewCategory: createAndAssignNewCategory, updateCategory: updateCategory, deleteAndUnassignCategory: deleteAndUnassignCategory, categoryOptions: categoryOptions, assignCategoryToCell: assignCategoryToCell } = (0, (0, parcelRequire("64gJA")).useCategoryCellStateController)({
            fieldValue: fieldValue,
            fieldType: fieldType,
            issueKey: issueKey,
            fieldKey: fieldKey,
            issueTypeId: issueTypeId,
            createExperience: (0, (0, parcelRequire("eTDjN")).CREATE_CATEGORY_EXPERIENCE),
            updateExperience: (0, (0, parcelRequire("eTDjN")).UPDATE_CATEGORY_EXPERIENCE),
            deleteExperience: (0, (0, parcelRequire("eTDjN")).DELETE_CATEGORY_EXPERIENCE)
        });
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setEditMode(false);
            else setCategoryCellState({
                status: 'read-mode'
            });
        }, [
            setEditMode
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && categoryCellState.status === 'read-mode') setCategoryCellState({
                status: 'edit-mode'
            });
        }, [
            categoryCellState.status,
            isEditable
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (categoryState?.value) event.clipboardData.setData('text/plain', categoryState?.value);
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'category');
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'category');
                assignCategoryToCell(null);
            }
        }, [
            categoryState?.value,
            createAnalyticsEvent,
            assignCategoryToCell
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            const clipText = event.clipboardData.getData('text/plain');
            const foundCategory = categoryOptions.find((option)=>option.label === clipText);
            if (foundCategory) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'category', {
                valid: true
            });
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'category', {
                valid: false,
                error: 'Not a valid category'
            });
        }, [
            createAnalyticsEvent,
            categoryOptions
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const onDeleteCompleted = (0, $5uXOq.useCallback)(()=>{
            setCategoryToDeleteInModal(null);
        }, [
            setCategoryToDeleteInModal
        ]);
        const onEscapeKeyPress = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setCategoryCellState({
                status: 'read-mode'
            });
            wrapperRef?.current?.focus();
        }, [
            wrapperRef
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') onEscapeKeyPress(e);
            else categoryCellState.status === 'read-mode' && onKeyDown?.(e);
        }, [
            categoryCellState.status,
            onEscapeKeyPress,
            onKeyDown
        ]);
        const sortedCategories = (0, $5uXOq.useMemo)(()=>{
            if (categoryState == null) return categoryOptions;
            const selectedCategoryIndex = categoryOptions.findIndex((option)=>option.value === categoryState?.optionId);
            if (selectedCategoryIndex === -1) return categoryOptions;
            const sortedCategoryOptions = [
                ...categoryOptions
            ];
            const selectedCategoryOption = sortedCategoryOptions[selectedCategoryIndex];
            sortedCategoryOptions.splice(selectedCategoryIndex, 1);
            sortedCategoryOptions.unshift(selectedCategoryOption);
            return sortedCategoryOptions;
        }, [
            categoryOptions,
            categoryState
        ]);
        const triggerContent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSjBh")).CategoryCellContent), {
                isEditable: isEditable,
                categoryState: categoryState
            }), [
            isEditable,
            categoryState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected === false && categoryCellState.status === 'edit-mode' && !categoryToDeleteInModal && !(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setCategoryCellState({
                status: 'read-mode'
            });
        }, [
            isSelected,
            categoryToDeleteInModal,
            categoryCellState.status
        ]);
        const tmpError = project.isSimplified && editFieldError;
        const staticContent = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? triggerContent : (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, triggerContent);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (editMode || categoryToDeleteInModal) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') || categoryCellState.status === 'edit-mode' && !(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gvQOt")).EditCategoryCell), {
            width: width,
            issueTypeId: issueTypeId,
            categoryOptions: sortedCategories,
            triggerContent: triggerContent,
            onClose: onClose,
            wrapperRef: wrapperRef,
            setCategoryToDeleteInModal: setCategoryToDeleteInModal,
            categoryState: categoryState,
            onCategoryCreate: createAndAssignNewCategory,
            onCategoryCellValueChange: assignCategoryToCell,
            onCategoryUpdate: updateCategory,
            cellRef: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? cellRef : undefined,
            inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
            onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : undefined
        }) : staticContent, categoryToDeleteInModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3aLMK")).default), {
            categoryToDelete: categoryToDeleteInModal,
            onDeleteCompleted: onDeleteCompleted,
            onCategoryDelete: deleteAndUnassignCategory
        }), tmpError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: editFieldError,
            title: (0, (0, parcelRequire("cPZte")).default).errorTitle,
            description: (0, (0, parcelRequire("cPZte")).default).errorMessage,
            issueType: issueType,
            issueTypeId: String(issueTypeId),
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            hasPadding: false,
            testId: "business-list.ui.list-view.category-cell.cell-container",
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $3e8153a5e26c0c65$var$cellContentStyles
        }, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            onClick: handleClick,
            isFocused: isSelected && categoryCellState.status === 'read-mode',
            onBlur: (event)=>{
                if (categoryCellState.status === 'read-mode') onBlur?.(event);
            },
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            "data-testid": "business-list.ui.list-view.category-cell.cell-container"
        }, cellContent);
    };
    var $3e8153a5e26c0c65$export$2e2bcd8739ae039 = $3e8153a5e26c0c65$var$CategoryCell;
    const $3e8153a5e26c0c65$var$cellContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
});
parcelRegister("64gJA", function(module, exports) {
    $parcel$export(module.exports, "useCategoryCellStateController", ()=>$e8c2b17de9ebf948$export$6b6a02976fa812c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $daQYX;
    var $jcw0u;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $lQE94;
    var $itmJb;
    var $lVJAU;
    var $kWfaA;
    var $aNJFF;
    var $4czz5;
    var $a3IM2;
    var $bPi86;
    var $lnCtA;
    var $hqdlT;
    var $kzvKj;
    const $e8c2b17de9ebf948$export$614564ba26164c27 = 'OPTIMISTIC_UPDATE_OPTION_ID';
    const $e8c2b17de9ebf948$export$575776c1bc65689e = 'OPTIMISTIC_CREATE_OPTION_ID';
    const $e8c2b17de9ebf948$export$6b6a02976fa812c3 = ({ fieldValue: fieldValue, fieldType: fieldType, issueKey: issueKey, fieldKey: fieldKey, issueTypeId: issueTypeId, createExperience: createExperience, updateExperience: updateExperience, deleteExperience: deleteExperience })=>{
        const prevFieldValueRef = (0, $5uXOq.useRef)(fieldValue);
        const { categoryOptions: categoryOptions } = (0, (0, parcelRequire("kWfaA")).useCategoryOptionsService)();
        const [categoryState, setCategoryState] = (0, $5uXOq.useState)(fieldValue);
        const categoryStateRef = (0, $5uXOq.useRef)(categoryState);
        categoryStateRef.current = categoryState;
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const isProjectAdmin = project.permissions.administerProject;
        const isProjectSimplified = project.isSimplified;
        const projectKey = project.key;
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ value: value, error: editFieldError }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: fieldValue ? {
                id: fieldValue?.optionId,
                value: fieldValue?.value,
                color: fieldValue?.color
            } : null
        });
        const setCategoryStateAndSave = (0, $5uXOq.useCallback)(async (newCategoryState)=>{
            setCategoryState(newCategoryState);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
                const previousCategoryState = categoryStateRef.current;
                try {
                    await saveValue(newCategoryState ? {
                        ...getOptionIdToSave(newCategoryState?.optionId),
                        value: newCategoryState?.value ?? null,
                        color: newCategoryState?.color ?? null
                    } : null, null, createAnalyticsEvent({}));
                } catch (error) {
                    setCategoryState(previousCategoryState);
                }
            }
        }, [
            createAnalyticsEvent,
            saveValue
        ]);
        const setCategory = (0, (0, parcelRequire("4R6GH")).fg)('hot-113252_category_reset_to_previous_value') ? setCategoryState : setCategoryStateAndSave;
        const { createCategory: createCategory } = (0, (0, parcelRequire("4czz5")).useCreateCategory)({
            experience: createExperience
        });
        const { updateCategory: updateCategoryService, error: updateCategoryError } = (0, (0, parcelRequire("bPi86")).useUpdateCategory)({
            experience: updateExperience
        });
        const { deleteCategory: deleteCategory, error: deleteError } = (0, (0, parcelRequire("a3IM2")).useDeleteCategory)({
            experience: deleteExperience
        });
        const { addCategory: addCategoryToCache, updateCategory: updateCategoryInCache, removeCategory: removeCategoryInCache } = (0, (0, parcelRequire("kWfaA")).useCategoryOptionsCache)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        (0, $5uXOq.useEffect)(()=>{
            const fieldValueHasChanged = prevFieldValueRef.current?.optionId !== fieldValue?.optionId || prevFieldValueRef.current?.value !== fieldValue?.value || prevFieldValueRef.current?.color !== fieldValue?.color;
            if (fieldValueHasChanged) {
                prevFieldValueRef.current = fieldValue;
                setCategory(fieldValue);
            }
        }, [
            categoryOptions,
            fieldValue,
            setCategory
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const valueHasChanged = categoryState?.optionId !== value?.id || categoryState?.value !== value?.value || categoryState?.color !== value?.color;
            if (valueHasChanged && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
                const newValue = value ? {
                    optionId: value.id,
                    value: value.value,
                    color: value.color
                } : null;
                setCategoryState(newValue);
            }
        }, [
            categoryState,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const currentCategoryState = categoryStateRef.current;
            if (!currentCategoryState) return;
            if (currentCategoryState.optionId === $e8c2b17de9ebf948$export$575776c1bc65689e) return;
            const categoryOption = categoryOptions.find((o)=>o.value === currentCategoryState.optionId);
            if (!categoryOption) return;
            if (currentCategoryState.value !== categoryOption?.label || currentCategoryState.color !== categoryOption?.color) setCategory({
                ...currentCategoryState,
                value: categoryOption?.label,
                color: categoryOption?.color
            });
        }, [
            categoryOptions,
            setCategory
        ]);
        const categoryOptionsRef = (0, $5uXOq.useRef)(categoryOptions);
        categoryOptionsRef.current = categoryOptions;
        const getCategoryOptionFromName = (0, $5uXOq.useCallback)((categoryName)=>categoryOptionsRef.current.find((co)=>co.label.toLocaleLowerCase() === categoryName.toLocaleLowerCase()), []);
        const getOptionIdToSave = (optionId)=>({
                id: optionId
            });
        const handleSaveValueError = (0, $5uXOq.useCallback)((e, id)=>{
            if (!isProjectSimplified) {
                const errorFlag = (0, (0, parcelRequire("kzvKj")).getSaveValueErrorFlag)(e, isAdmin || isProjectAdmin, ()=>{
                    if (isProjectSimplified) push(`/jira/core/projects/${projectKey}/settings/issuetypes`);
                    else push(`/plugins/servlet/project-config/${projectKey}/fields`);
                });
                showFlag(errorFlag);
            }
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: id,
                    packageName: 'jiraBusinessCategories',
                    teamName: 'jira-warepil'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            isAdmin,
            isProjectAdmin,
            isProjectSimplified,
            projectKey,
            push,
            showFlag
        ]);
        const createAndAssignNewCategory = (0, $5uXOq.useCallback)(async (categoryName, color)=>{
            if (!isProjectAdmin) return;
            const trimmedCategoryName = categoryName.trim();
            if (trimmedCategoryName === '') {
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("hqdlT")).default).createdCategoryNameCantBeEmpty)
                });
                return;
            }
            if (getCategoryOptionFromName(trimmedCategoryName)) {
                showFlag((0, (0, parcelRequire("lnCtA")).CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG));
                return;
            }
            const previousCategoryState = categoryStateRef.current;
            setCategoryState({
                optionId: $e8c2b17de9ebf948$export$575776c1bc65689e,
                value: trimmedCategoryName,
                color: color
            });
            let categoryMutationResult;
            try {
                categoryMutationResult = await createCategory({
                    issueTypeId: issueTypeId,
                    value: trimmedCategoryName,
                    color: color
                });
                if (categoryMutationResult) addCategoryToCache({
                    id: categoryMutationResult.id,
                    color: categoryMutationResult.color,
                    option: {
                        optionId: categoryMutationResult.option?.optionId,
                        value: categoryMutationResult.option?.value,
                        id: categoryMutationResult.option?.id,
                        isDisabled: categoryMutationResult.option?.isDisabled
                    }
                });
            } catch (e) {
                const isCategoryNameAlreadyExistsError = e.message === (0, (0, parcelRequire("lnCtA")).CATEGORY_NAME_ALREADY_EXISTS_ERROR_MESSAGE);
                const errorFlag = isCategoryNameAlreadyExistsError ? (0, (0, parcelRequire("lnCtA")).CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG) : (0, (0, parcelRequire("aNJFF")).CREATE_FAILED_FLAG);
                showFlag(errorFlag);
                if (!isCategoryNameAlreadyExistsError) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCreateCategory',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
                setCategoryState(previousCategoryState);
                return;
            }
            if (!categoryMutationResult) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCreateCategoryEmpty',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: new Error('categoryMutationResult is empty'),
                    sendToPrivacyUnsafeSplunk: true
                });
                setCategoryState(previousCategoryState);
                return;
            }
            try {
                await saveValue({
                    ...getOptionIdToSave(categoryMutationResult.option.optionId),
                    value: categoryMutationResult.option.value ?? null,
                    color: categoryMutationResult.color ?? null
                }, null, createAnalyticsEvent({}));
                setCategoryState({
                    optionId: categoryMutationResult.option.optionId,
                    value: categoryMutationResult.option.value,
                    color: categoryMutationResult.color
                });
            } catch (e) {
                handleSaveValueError(e, 'jwmCreateCategoryThenAssign');
                setCategoryState(previousCategoryState);
            }
        }, [
            isProjectAdmin,
            getCategoryOptionFromName,
            showFlag,
            formatMessage,
            createCategory,
            issueTypeId,
            addCategoryToCache,
            saveValue,
            createAnalyticsEvent,
            handleSaveValueError
        ]);
        const updateCategory = (0, $5uXOq.useCallback)(async ({ optionId: optionId, newCategoryName: newCategoryName, newCategoryColor: newCategoryColor })=>{
            if (!isProjectAdmin) return;
            const oldCategoryOption = categoryOptionsRef.current.find((co)=>co.value === optionId);
            const trimmedNewCategoryName = newCategoryName.trim();
            if (trimmedNewCategoryName === oldCategoryOption?.label.trim() && newCategoryColor === oldCategoryOption?.color) return;
            if (trimmedNewCategoryName === '') {
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("hqdlT")).default).renamedCategoryCantBeEmpty)
                });
                return;
            }
            const categoryOptionWithSameName = getCategoryOptionFromName(trimmedNewCategoryName);
            if (categoryOptionWithSameName && categoryOptionWithSameName.value !== optionId) {
                showFlag((0, (0, parcelRequire("lnCtA")).CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG));
                return;
            }
            updateCategoryInCache({
                option: {
                    optionId: optionId,
                    value: trimmedNewCategoryName
                },
                color: newCategoryColor
            });
            const isCurrentCategoryRenamed = categoryStateRef.current && optionId === categoryStateRef.current.optionId;
            if (isCurrentCategoryRenamed) setCategory({
                optionId: optionId,
                value: trimmedNewCategoryName,
                color: newCategoryColor
            });
            let updateResponse = null;
            try {
                updateResponse = await updateCategoryService({
                    optionId: Number.parseInt(optionId, 10),
                    issueTypeId: issueTypeId,
                    value: trimmedNewCategoryName,
                    color: newCategoryColor
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCategoryUpdateCategory',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                if (updateCategoryError || !updateResponse) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jwmCategoryUpdateCategoryError',
                            packageName: 'jiraBusinessCategories',
                            teamName: 'jira-warepil'
                        },
                        error: updateCategoryError ? new Error(updateCategoryError?.message ?? 'updateCategory mutation error') : new Error('updateCategoryMutationResult is empty'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    updateCategoryInCache({
                        option: {
                            optionId: optionId,
                            value: oldCategoryOption?.label ?? ''
                        },
                        color: oldCategoryOption?.color ?? null
                    });
                    if (isCurrentCategoryRenamed) setCategoryState({
                        optionId: optionId,
                        value: oldCategoryOption?.label ?? '',
                        color: oldCategoryOption?.color ?? null
                    });
                }
            }
        }, [
            isProjectAdmin,
            getCategoryOptionFromName,
            updateCategoryInCache,
            showFlag,
            formatMessage,
            setCategory,
            updateCategoryService,
            issueTypeId,
            updateCategoryError
        ]);
        const deleteAndUnassignCategory = (0, $5uXOq.useCallback)(async (optionIdToDelete)=>{
            if (!isProjectAdmin) return;
            const categoryOptionToDelete = categoryOptionsRef.current.find((co)=>co.value === optionIdToDelete);
            if (!categoryOptionToDelete) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCategoryDeleteCategoryNotFound',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: new Error('Cannot find categoryOption to delete'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                const deleteSuccess = await deleteCategory({
                    issueTypeId: issueTypeId,
                    optionId: Number.parseInt(optionIdToDelete, 10)
                });
                if (!deleteSuccess) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jwmCategoryDeleteCategorySuccessFalse',
                            packageName: 'jiraBusinessCategories',
                            teamName: 'jira-warepil'
                        },
                        error: new Error(deleteError?.message ?? 'Category delete mutation result.success is false'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return;
                }
                removeCategoryInCache(optionIdToDelete);
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCategoryDeleteCategoryError',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            deleteCategory,
            deleteError?.message,
            isProjectAdmin,
            issueTypeId,
            removeCategoryInCache
        ]);
        const assignCategoryToCell = (0, $5uXOq.useCallback)(async (categoryToAssign)=>{
            if (categoryState?.optionId === categoryToAssign?.optionId) return;
            const previousCategoryState = categoryStateRef.current;
            setCategoryState(categoryToAssign);
            try {
                await saveValue(categoryToAssign ? {
                    ...getOptionIdToSave(categoryToAssign?.optionId),
                    value: categoryToAssign?.value ?? null,
                    color: categoryToAssign?.color ?? null
                } : null, null, createAnalyticsEvent({}));
            } catch (e) {
                handleSaveValueError(e, 'jwmCategoryAssign');
                setCategoryState(previousCategoryState);
            }
        }, [
            categoryState?.optionId,
            saveValue,
            createAnalyticsEvent,
            handleSaveValueError
        ]);
        return {
            editFieldError: editFieldError,
            categoryState: categoryState,
            categoryOptions: categoryOptions,
            createAndAssignNewCategory: createAndAssignNewCategory,
            updateCategory: updateCategory,
            deleteAndUnassignCategory: deleteAndUnassignCategory,
            assignCategoryToCell: assignCategoryToCell
        };
    };
});
parcelRegister("lQE94", function(module, exports) {
    $parcel$export(module.exports, "useEditField", ()=>$c31e2d123e024ddc$export$343e962d356c0af1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3BIWb;
    var $3BIWb;
    var $dJl1T;
    var $co1wz;
    var $4R6GH;
    var $jJZqs;
    var $fZneA;
    var $ctrpc;
    var $2gCtH;
    var $6Ou5i;
    var $afs7f;
    var $15WDX;
    var $biQrn;
    var $8zOmE;
    var $3fAi8;
    var $99cgx;
    const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
        if (!response) return null;
        if (response.fields) {
            if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
            return null;
        }
        return response;
    };
    const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
        if (!response) return false;
        if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
        return true;
    };
    const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
        const baseUrl = '';
        const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, (0, parcelRequire("99cgx")).defaultSaveField), saveFieldById: saveFieldById = (0, (0, parcelRequire("99cgx")).defaultSaveFieldById), addValuesToField: addValuesToField = (0, (0, parcelRequire("99cgx")).defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, (0, parcelRequire("99cgx")).defaultRemoveValuesFromField), onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))) } = fieldOptions;
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const resetError = (0, $5uXOq.useCallback)(()=>{
            if (isMounted.current) setError(null);
        }, [
            setError,
            isMounted
        ]);
        const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
            isOptimistic: true
        })=>{
            let result;
            const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
            const analyticsData = {
                editOperationType: editOperationType,
                issueId: issueId,
                fieldKey: analyticsFieldKeyAlias ?? fieldKey,
                fieldType: actualFieldType
            };
            if (isMounted.current) {
                setLoading(true);
                setError(null);
            }
            try {
                onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
                if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
                result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
                const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
                $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
                onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                    analytics: analyticsEvent,
                    attributes: {
                        fieldType: actualFieldType
                    }
                });
            } catch (ex) {
                result = Promise.reject(ex);
                onFailure(ex, valuesForOperation);
                setFieldValue(issueKey, fieldKey, fieldValue);
                if (isMounted.current) setError(ex);
                const isValidationError = ex instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
                if (!isValidationError) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
                if (fieldKey === 'timetracking' && (0, (0, parcelRequire("co1wz")).ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s')) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'timetracking updateFailed', {
                    fieldKey: fieldKey,
                    fieldType: fieldType,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex),
                    exceptionName: ex.name,
                    exceptionMessage: ex.message,
                    exceptionStack: ex.stack
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    fieldKey: fieldKey,
                    fieldType: analyticsFieldTypeAlias ?? fieldType,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex)
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
            }
            if (isMounted.current) setLoading(false);
            return result;
        }, [
            issueId,
            analyticsFieldKeyAlias,
            fieldKey,
            analyticsFieldTypeAlias,
            fieldType,
            isMounted,
            onSubmit,
            fieldValue,
            setFieldValue,
            issueKey,
            onSuccess,
            onFailure,
            mapNonOptimisticResponse
        ]);
        const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
            editFieldValue,
            saveField
        ]);
        const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
                isOptimistic: false
            }), [
            editFieldValue,
            saveFieldById
        ]);
        const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
            editFieldValue,
            addValuesToField
        ]);
        const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
            editFieldValue,
            removeValuesFromField
        ]);
        return [
            {
                value: fieldValue,
                loading: loading,
                error: error
            },
            {
                saveById: saveById,
                saveValue: saveValue,
                addValues: addValues,
                removeValues: removeValues,
                resetError: resetError
            }
        ];
    };
    const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
        const contextualIssueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        const contextualIssueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return contextualIssueKey === issueKey ? contextualIssueId : null;
    };
    const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
        if (!meta || typeof meta === 'object') return {
            ...meta ?? {},
            isEditFromIssueView: isEditFromIssueView
        };
        return meta;
    };
    const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
        const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
        const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, (0, parcelRequire("15WDX")).useIssueViewFieldUpdateEvents)();
        const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
        const issueId = issueIdFromFieldOptions ?? contextualIssueId;
        const isEditFromIssueView = (0, (0, parcelRequire("6Ou5i")).useIsEditFromIssueView);
        const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
            onSubmit(oldValue, newValue, meta, event);
            issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
        }, [
            fieldChangeRequested,
            fieldKey,
            issueId,
            onSubmit
        ]);
        const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
            onSuccess(fieldValue);
            issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, isEditFromIssueView(event)) : meta);
            if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
                const reason = (0, (0, parcelRequire("afs7f")).Reason).SoftRefresh;
                (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, (0, parcelRequire("3BIWb")).default).refreshIssuePageThrowable(issueKey, reason) : await (0, (0, parcelRequire("3BIWb")).default).refreshIssuePageThrowable(issueKey, reason);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
            }
        }, [
            fieldChanged,
            fieldKey,
            shouldPreventIssueViewSoftRefresh,
            isEditFromIssueView,
            issueId,
            issueKey,
            onSuccess
        ]);
        const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
            onFailure(error, failedValue);
            issueId && fieldChangeFailed(issueId, fieldKey);
        }, [
            fieldChangeFailed,
            fieldKey,
            issueId,
            onFailure
        ]);
        return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
            ...fieldOptions,
            onSubmit: onSubmitFn,
            onSuccess: onSuccessFn,
            onFailure: onFailureFn
        });
    };
});
parcelRegister("3BIWb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65e83eb4ced9ce9$export$2e2bcd8739ae039);
    var $afs7f;
    const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
    const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
    const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
        document.addEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
        document.removeEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = (0, (0, parcelRequire("afs7f")).Reason).OnDemand)=>{
        try {
            document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
                detail: [
                    issueKey,
                    {
                        mergeIntoCurrent: false,
                        reason: reason
                    }
                ]
            }));
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
    const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>$b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
    var $b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
        addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
        removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
        addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
        removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
        refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
        refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
    };
});
parcelRegister("afs7f", function(module, exports) {
    $parcel$export(module.exports, "Reason", ()=>$90b3aba4b3cc23bb$export$fe867595c4640fb1);
    const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
        OnDemand: 'ON_DEMAND',
        SoftRefresh: 'SOFT_REFRESH',
        Realtime: 'REALTIME'
    };
});
parcelRegister("ctrpc", function(module, exports) {
    $parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", ()=>$a32e213c0a4381f7$export$f3b2b77402b2631f);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $dJl1T;
    var $4R6GH;
    var $8zOmE;
    var $8ikZj;
    var $bximr;
    class $a32e213c0a4381f7$var$EventFlowManager {
        reset() {
            this.ids.clear();
            this.extraAttributes.clear();
        }
        push(key) {
            const id = (0, ($parcel$interopDefault($7Jxgt))).v4();
            this.ids.set(key, id);
            return id;
        }
        pull(key, shouldDelete = true) {
            const value = this.ids.get(key);
            if (shouldDelete) this.ids.delete(key);
            return value;
        }
        constructor(){
            this.ids = new Map();
            this.extraAttributes = new Map();
        }
    }
    const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
    const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
        let fieldTypeValue = attributes.fieldType;
        const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
        const FIELD_TYPE_MAP = (0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg') ? (0, (0, parcelRequire("8ikZj")).FIELD_TYPE_MAP) : (0, (0, parcelRequire("8ikZj")).FIELD_TYPE_MAP_OLD);
        const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
        return {
            updateSessionId: updateSessionId,
            ...(0, (0, parcelRequire("8ikZj")).DEFAULT_ATTRIBUTES),
            ...attributes,
            ...extraAttributes,
            fieldKey: fieldKey,
            fieldType: fieldType
        };
    };
    const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
    const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
        fireAnalyticsStart (fieldKey, params) {
            try {
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                    fieldType: params.attributes.fieldType
                });
                const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
                const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(params.analytics, `${(0, (0, parcelRequire("8ikZj")).START_ACTION_SUBJECT)} ${(0, (0, parcelRequire("8ikZj")).START_ACTION)}`, (0, (0, parcelRequire("8ikZj")).START_ACTION_SUBJECT_ID), attributes);
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
            }
        },
        fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
            try {
                const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
                const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
                if (isEndOfSession) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(params.analytics, `${(0, (0, parcelRequire("8ikZj")).END_ACTION_SUBJECT)} ${(0, (0, parcelRequire("8ikZj")).END_ACTION)}`, (0, (0, parcelRequire("8ikZj")).END_ACTION_SUBJECT_ID), attributes);
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
            }
        },
        setAttributes (fieldKey, attributes) {
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
        },
        setActionTakenAttributes (fieldKey, oldValId, newValId) {
            if (oldValId !== newValId) this.setAttributes(fieldKey, {
                oldValId: oldValId,
                newValId: newValId,
                actionTaken: (0, (0, parcelRequire("bximr")).getActionTaken)(oldValId, newValId)
            });
        },
        endSession (fieldKey) {
            $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
        },
        reset () {
            $a32e213c0a4381f7$export$87846400a9b428fc.reset();
        }
    };
    const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;
});
parcelRegister("8ikZj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ATTRIBUTES", ()=>$ba1d12fd09beb370$export$69665899d8392309);
    $parcel$export(module.exports, "START_ACTION", ()=>$ba1d12fd09beb370$export$c0a4673e0c78e972);
    $parcel$export(module.exports, "START_ACTION_SUBJECT", ()=>$ba1d12fd09beb370$export$34a5ae354a38cc7e);
    $parcel$export(module.exports, "START_ACTION_SUBJECT_ID", ()=>$ba1d12fd09beb370$export$bc373f59492dc6e2);
    $parcel$export(module.exports, "END_ACTION", ()=>$ba1d12fd09beb370$export$b19686c1fe99f85a);
    $parcel$export(module.exports, "END_ACTION_SUBJECT", ()=>$ba1d12fd09beb370$export$4ce67e80878d47ed);
    $parcel$export(module.exports, "END_ACTION_SUBJECT_ID", ()=>$ba1d12fd09beb370$export$e3d957ccc2d46469);
    $parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", ()=>$ba1d12fd09beb370$export$403ea87111529de);
    $parcel$export(module.exports, "FIELD_TYPE_MAP", ()=>$ba1d12fd09beb370$export$d8ccf495ccc97a69);
    $parcel$export(module.exports, "ENTITY_FIELD_KEYS", ()=>$ba1d12fd09beb370$export$7d9dd31e187cb2db);
    var $5fc53;
    const $ba1d12fd09beb370$export$69665899d8392309 = {
        isInlineEditing: false,
        isCommandPaletteEditing: false,
        isDragEditing: false
    };
    const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
    const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
    const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
    const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
    const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
    const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
    const $ba1d12fd09beb370$export$403ea87111529de = {
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: 'singleUserPicker',
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: 'versions',
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: 'versions',
        [(0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)]: 'organizations',
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: 'link',
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: 'multiVersion',
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: 'singleSelect',
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: 'multiSelect',
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: 'singleUser',
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: 'radio',
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: 'url',
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: 'singleGroup',
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: 'multiGroup'
    };
    const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: 'singleUserPicker',
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: 'attachment',
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: 'components',
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: 'date',
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: 'dateTime',
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: 'fixVersions',
        [(0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE)]: 'flag',
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: 'goals',
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: 'singleGroup',
        [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: 'issuetype',
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: 'labels',
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: 'multiGroup',
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: 'multiSelect',
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: 'multiVersion',
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: 'float',
        [(0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)]: 'organizations',
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: 'parent',
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: 'priority',
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: 'project',
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: 'radio',
        [(0, (0, parcelRequire("5fc53")).RANK_CF_TYPE)]: 'status',
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: 'singleSelect',
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: 'sprint',
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: 'status',
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)]: 'timeTracking',
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: 'url',
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: 'singleUser',
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: 'version',
        [(0, (0, parcelRequire("5fc53")).VOTES_TYPE)]: 'votes',
        [(0, (0, parcelRequire("5fc53")).WATCHES_TYPE)]: 'watchers',
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: 'storyPointEstimate'
    };
    const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
        WEB_LINK: 'weblink',
        ATTACHMENT: 'attachment',
        ISSUE_LINKS: 'link'
    };
});
parcelRegister("bximr", function(module, exports) {
    $parcel$export(module.exports, "getActionTaken", ()=>$440267fcdb63291a$export$9d814e3464362b48);
    const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
        if (oldValId !== newValId) {
            if (newValId === null) return 'remove';
            if (oldValId === null || oldValId === undefined) return 'add';
        }
        return undefined;
    };
});
parcelRegister("6Ou5i", function(module, exports) {
    $parcel$export(module.exports, "useIsEditFromIssueView", ()=>$b57bb78db332aa99$export$870b996a6c1c7896);
    var $hBuqR;
    var $lhVtI;
    const $b57bb78db332aa99$export$870b996a6c1c7896 = (event)=>{
        const ISSUE_VIEW_SOURCES = [
            'fullIssueScreen',
            'boardIssueViewScreen',
            'agility-backlogScreen',
            'issueNavigatorEmbeddedIssueViewScreen',
            'globalIssueNavigatorIssueScreen',
            'mobileIssueScreen',
            'classicRoadmapScreen',
            'roadmapScreen',
            'versionDetailsIssueScreen',
            'bitbucketIssueScreen',
            'jsmQueueAgentViewSidebarScreen',
            'viewQueueIssueScreen',
            'jswModalIssueAppScreen',
            'jwmModalIssueAppScreen',
            'jswSidebarIssueAppScreen',
            'jwmSidebarIssueAppScreen'
        ];
        const { payload: { source: source } } = (0, (0, parcelRequire("lhVtI")).getEvent)(event);
        if (!source) return false;
        if (ISSUE_VIEW_SOURCES.includes(source)) return true;
        if (source.startsWith((0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3))) return true;
        return false;
    };
});
parcelRegister("15WDX", function(module, exports) {
    $parcel$export(module.exports, "useIssueViewFieldUpdateEvents", ()=>$947bdf396d8056bc$export$444af741f6d8f512);
    $parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", ()=>$947bdf396d8056bc$export$f9eb49cc2f0e28ce);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $5YMLs;
    var $3z81P;
    const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
            if (typeof eventHandler !== 'function') return ()=>{};
            const { eventHandlers: eventHandlers } = getState();
            const typeEventHandlers = eventHandlers[type];
            setState({
                eventHandlers: {
                    ...eventHandlers,
                    [type]: typeEventHandlers.concat([
                        eventHandler
                    ])
                }
            });
            return ()=>{
                const { eventHandlers: eventHandlersForUnregister } = getState();
                const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
                const newTypeEventHandlers = typeEventHandlersForUnregister.filter((handler)=>handler !== eventHandler);
                setState({
                    eventHandlers: {
                        ...eventHandlersForUnregister,
                        [type]: newTypeEventHandlers
                    }
                });
            };
        };
    const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    fieldId: fieldId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_FAILED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_REQUESTED
                });
            });
        };
    const $947bdf396d8056bc$var$actions = {
        fieldChanged: $947bdf396d8056bc$var$fieldChanged,
        fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
        fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
        registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
    };
    const $947bdf396d8056bc$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-view-field-update-events',
        initialState: {
            eventHandlers: {
                onChange: []
            }
        },
        actions: $947bdf396d8056bc$var$actions
    });
    const $947bdf396d8056bc$export$444af741f6d8f512 = (0, (0, parcelRequire("3sQ5x")).createHook)($947bdf396d8056bc$var$store, {
        selector: null
    });
    const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, (0, parcelRequire("gg7kZ")).createContainer)($947bdf396d8056bc$var$store);
});
parcelRegister("5YMLs", function(module, exports) {
    $parcel$export(module.exports, "transformAggToLegacy", ()=>$1da8cbd2b672325c$export$d951e3c38e10736d);
    var $bMD69;
    var $5fc53;
    var $1pF6B;
    var $lTnWS;
    const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
        if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
        switch(aggFieldChangeProps.__typename){
            case 0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).URL_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type
                })?.value;
            case 0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD:
                return (0, (0, parcelRequire("lTnWS")).transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
            case 0, (0, parcelRequire("5fc53")).PARENT_GQL_FIELD:
                return (0, (0, parcelRequire("1pF6B")).transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
            case 0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    ...fieldValue
                })?.value;
            case 0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    originalEstimate: fieldValue.originalEstimate,
                    remainingEstimate: fieldValue.remainingEstimate,
                    timeSpent: fieldValue.timeSpent
                })?.value;
            case 0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    selectedOptions: fieldValue.selectedOptions,
                    checkboxesFieldOptions: fieldValue.fieldOptions
                })?.value;
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    components: fieldValue.components,
                    selectedComponentsConnection: fieldValue.selectedComponentsConnection
                })?.value;
            default:
                throw new Error('__typename not implemented');
        }
    };
    const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
        const VALUE_KEYS = {
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: 'text',
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: 'number',
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: 'priority',
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: 'user',
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: 'date',
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: 'project',
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: 'dateTime',
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: 'uri',
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: 'securityLevel',
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: 'watch',
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: 'vote',
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: 'color',
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: 'issueType',
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: 'resolution',
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: 'status',
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: 'selectedOption',
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: 'richText'
        };
        const value = VALUE_KEYS[__typename];
        if (value) return value;
        throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
    };
});
parcelRegister("bMD69", function(module, exports) {
    $parcel$export(module.exports, "transformAggFieldToLegacyField", ()=>$af5e8bab0defb9c8$export$586ba15cbf3d3031);
    $parcel$export(module.exports, "transformAggFieldsToLegacyFields", ()=>$af5e8bab0defb9c8$export$ba106ff8c087e6b1);
    var $8QpSo;
    var $5fc53;
    var $9bgym;
    var $6iJEF;
    var $9UrtF;
    var $hsEaK;
    var $2qu1N;
    var $16Zia;
    var $iv8Rf;
    var $hDlc2;
    var $c3LW9;
    var $h92P3;
    var $aeO9V;
    var $6Tnq8;
    var $6mbsj;
    var $d3nG3;
    var $1xW6n;
    var $fW9XR;
    var $bKMMB;
    var $7JL37;
    var $dulCG;
    var $6vno6;
    var $as0vY;
    var $6dPLd;
    var $gKccZ;
    var $jnUrZ;
    var $iJtmd;
    var $iPyq0;
    var $384lj;
    var $axTS6;
    var $lfJ6H;
    var $9UXU7;
    var $b6BoU;
    var $gak3n;
    var $i47fO;
    var $gvljZ;
    var $6XFn2;
    var $6e1Ya;
    var $hBEiJ;
    var $1XNj2;
    var $f6zXW;
    var $fB4wX;
    var $cXBkk;
    var $iDKu3;
    var $aGv90;
    var $19DRh;
    var $lkW3a;
    var $lQAwK;
    var $8qOI6;
    var $cbd7V;
    var $6hj44;
    var $4nh4C;
    var $hA3EZ;
    var $2z4xE;
    var $cO2KQ;
    var $5sETx;
    var $f454b;
    var $aafIf;
    var $2yWre;
    var $lUeQj;
    var $6SWOK;
    var $cMc7B;
    var $38GNL;
    var $avV20;
    var $cbXvu;
    var $aSXJi;
    var $8uxcU;
    var $arKlm;
    var $hCKV6;
    var $d8wC0;
    const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
            [(0, (0, parcelRequire("5fc53")).AFFECTED_SERVICES_GQL_FIELD)]: (0, (0, parcelRequire("9bgym")).transformAggAffectedServicesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).BOOLEAN_GQL_FIELD)]: (0, (0, parcelRequire("9UrtF")).transformAggBooleanToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("hsEaK")).transformAggCascadingSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD)]: (0, (0, parcelRequire("2qu1N")).transformAggCheckboxToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CMDB_GQL_FIELD)]: (0, (0, parcelRequire("16Zia")).transformAggCMDBToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("19DRh")).transformAggMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD)]: (0, (0, parcelRequire("hDlc2")).transformAggComponentsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("c3LW9")).transformAggConnectDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("h92P3")).transformAggConnectMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("aeO9V")).transformAggConnectNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("6Tnq8")).transformAggConnectRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("6mbsj")).transformAggConnectSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("d3nG3")).transformAggConnectTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: (0, (0, parcelRequire("iv8Rf")).transformAggColorToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("fW9XR")).transformAggDatePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("bKMMB")).transformAggDateTimePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).EPIC_LINK_GQL_FIELD)]: (0, (0, parcelRequire("7JL37")).transformAggEpicLinkToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FLAG_GQL_FIELD)]: (0, (0, parcelRequire("dulCG")).transformAggFlagToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATETIME_GQL_FIELD)]: (0, (0, parcelRequire("as0vY")).transformAggForgeDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATE_GQL_FIELD)]: (0, (0, parcelRequire("6vno6")).transformAggForgeDateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUP_GQL_FIELD)]: (0, (0, parcelRequire("6dPLd")).transformAggForgeGroupToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUPS_GQL_FIELD)]: (0, (0, parcelRequire("gKccZ")).transformAggForgeGroupsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("jnUrZ")).transformAggForgeNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_OBJECT_GQL_FIELD)]: (0, (0, parcelRequire("iJtmd")).transformAggForgeObjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRING_GQL_FIELD)]: (0, (0, parcelRequire("iPyq0")).transformAggForgeStringToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRINGS_GQL_FIELD)]: (0, (0, parcelRequire("384lj")).transformAggForgeStringsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USER_GQL_FIELD)]: (0, (0, parcelRequire("axTS6")).transformAggForgeUserToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USERS_GQL_FIELD)]: (0, (0, parcelRequire("lfJ6H")).transformAggForgeUsersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_GQL_FIELD)]: (0, (0, parcelRequire("b6BoU")).transformAggIssueRestrictionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("gak3n")).transformAggIssueTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_APPROVAL_GQL_FIELD)]: (0, (0, parcelRequire("i47fO")).transformAggJSMApprovalsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ASSETS_GQL_FIELD)]: (0, (0, parcelRequire("6iJEF")).transformAggAssetToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_MAJOR_INCIDENT_FIELD)]: (0, (0, parcelRequire("6XFn2")).transformAggJSMMajorIncidentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ORGANIZATION_GQL_FIELD)]: (0, (0, parcelRequire("6e1Ya")).transformAggJSMOrganizationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ENTITLEMENTS_GQL_FIELD)]: (0, (0, parcelRequire("gvljZ")).transformAggJSMEntitlementsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_SENTIMENT_GQL_FIELD)]: (0, (0, parcelRequire("cXBkk")).transformAggJSMSentimentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, (0, parcelRequire("hBEiJ")).transformAggJSMRequestFeedbackToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, (0, parcelRequire("1XNj2")).transformAggJSMRequestLanguageToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("f6zXW")).transformAggJSMRequestTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_RESPONDERS_GQL_FIELD)]: (0, (0, parcelRequire("fB4wX")).transformAggJSMRespondersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).LABEL_GQL_FIELD)]: (0, (0, parcelRequire("iDKu3")).transformAggLabelsNodeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: (0, (0, parcelRequire("6hj44")).transformAggPriorityToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aGv90")).transformAggMultiGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("8qOI6")).transformAggNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, (0, parcelRequire("cbd7V")).transformAggOriginalEstimateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROFORMA_FORMS_GQL_FIELD)]: (0, (0, parcelRequire("4nh4C")).transformAggProformaFormsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: (0, (0, parcelRequire("hA3EZ")).transformAggProjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_GQL_FIELD)]: (0, (0, parcelRequire("lQAwK")).transformAggMultipleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: (0, (0, parcelRequire("2z4xE")).transformAggRadioSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("5sETx")).transformAggRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: (0, (0, parcelRequire("cO2KQ")).transformAggResolutionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: (0, (0, parcelRequire("f454b")).transformAggSecurityLevelToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD)]: (0, (0, parcelRequire("38GNL")).transformAggSprintToLegacyField),
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: (0, (0, parcelRequire("avV20")).transformAggStatusToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aafIf")).transformAggSingleGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("lUeQj")).transformAggSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_GQL_FIELD)]: (0, (0, parcelRequire("cbXvu")).transformAggTeamToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: (0, (0, parcelRequire("aSXJi")).transformAggTeamViewToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: (0, (0, parcelRequire("2yWre")).transformAggSingleLineTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD)]: (0, (0, parcelRequire("8uxcU")).transformAggTimeTrackingToLegacyField),
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("6SWOK")).transformAggSingleSelectUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: (0, (0, parcelRequire("arKlm")).transformAggUrlToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VERSION_GQL_FIELD)]: (0, (0, parcelRequire("cMc7B")).transformAggSingleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: (0, (0, parcelRequire("hCKV6")).transformAggVotesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: (0, (0, parcelRequire("d8wC0")).transformAggWatchesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_FIELD)]: (0, (0, parcelRequire("1xW6n")).transformAggDataClassificationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).GOALS_GQL_FIELD)]: (0, (0, parcelRequire("9UXU7")).transformAggGoalsToLegacyField)
        });
    const $af5e8bab0defb9c8$var$getTransformers = (0, (0, parcelRequire("8QpSo")).default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
    const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, context)=>{
        const typename = node.__typename;
        const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
        return transformer ? transformer(node, context) : undefined;
    };
    const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields)=>{
        if (fields == null) return {};
        return fields.reduce((fieldsState, fieldEdge)=>{
            if (fieldEdge?.node != null) {
                const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, fields);
                if (transformedField != null) {
                    const fieldData = 'key' in transformedField ? {
                        [transformedField.key]: transformedField
                    } : transformedField;
                    Object.assign(fieldsState, fieldData);
                }
            }
            return fieldsState;
        }, {});
    };
});
parcelRegister("9bgym", function(module, exports) {
    $parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", ()=>$0bce5d1c363f27e8$export$231e0419515441d4);
    var $5fc53;
    var $o7K5u;
    const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
            id: serviceId,
            name: name ?? undefined
        });
    const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)) return undefined;
        const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
                items: 'service-entity-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';
parcelRegister("o7K5u", function(module, exports) {
    $parcel$export(module.exports, "transformAggNodeToLegacyField", ()=>$cfa10031dfb7ad46$export$e7ea61856a169c36);
    $parcel$export(module.exports, "transformAggConnection", ()=>$cfa10031dfb7ad46$export$daf92cda81d86cdc);
    $parcel$export(module.exports, "toLegacyConnectOption", ()=>$cfa10031dfb7ad46$export$b5de5f3d2de73afc);
    const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
            ari: 'id' in node ? node.id : undefined,
            key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
            title: 'name' in node ? node.name : '',
            editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
            required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
            autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
            allowedValues: [],
            value: null,
            schema: {
                type: 'type' in node ? node.type : '',
                custom: null,
                system: null
            },
            description: 'description' in node && node.description ? node.description : undefined
        });
    const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
        const edges = connection?.edges ?? [];
        if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
        return edges.map((edge)=>edge?.node).filter(Boolean);
    };
    const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
        if (!node) return null;
        return {
            value: node.value ?? null,
            id: parseInt(node.optionId, 10)
        };
    };
});
parcelRegister("6iJEF", function(module, exports) {
    $parcel$export(module.exports, "transformAggAssetToLegacyField", ()=>$b9f6b8590a60f3b3$export$2136dcd78a2ef18f);
    var $5fc53;
    var $o7K5u;
    const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE:
                {
                    const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                    const assetValue = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                            appKey: appKey,
                            originId: originId,
                            serializedOrigin: serializedOrigin,
                            value: value
                        })) : null;
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        autoCompleteUrl: node.searchUrl,
                        value: assetValue,
                        schema: {
                            custom: node.type,
                            system: null,
                            items: 'sd-asset',
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("9UrtF", function(module, exports) {
    $parcel$export(module.exports, "transformAggBooleanToLegacyField", ()=>$474331244347ccdb$export$4bd89b95f0d10de9);
    var $5fc53;
    var $o7K5u;
    const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: {
                        alertLinking: {
                            enabled: node.value
                        }
                    },
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: null,
                        custom: null,
                        system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hsEaK", function(module, exports) {
    $parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", ()=>$afb6a8576bf8d731$export$a8778af5ceb1017c);
    var $o7K5u;
    const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
        let value = null;
        if (node.cascadingOption) {
            const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
            const child = childOptionValue ? {
                child: {
                    id: childOptionValue.optionId,
                    value: childOptionValue.value
                }
            } : {};
            value = {
                id: parentOptionValue?.optionId,
                value: parentOptionValue?.value,
                ...child
            };
        }
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: [],
            schema: {
                type: 'option-with-child',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2qu1N", function(module, exports) {
    $parcel$export(module.exports, "transformAggCheckboxToLegacyField", ()=>$3efe07b8b545ea99$export$baa5afdbd8fd12d3);
    var $5fc53;
    var $o7K5u;
    const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: allowedValues,
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("16Zia", function(module, exports) {
    $parcel$export(module.exports, "transformAggCMDBToLegacyField", ()=>$4d2c21f2e394ef74$export$93506453d9bb56ae);
    var $5fc53;
    var $o7K5u;
    const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
            workspaceId: workspaceId,
            id: `${workspaceId}:${attribute.objectTypeId}`,
            name: attribute.name,
            objectSchemaId: attribute.objectSchemaId,
            objectTypeId: attribute.objectTypeId,
            icon: {
                id: attribute.icon.id,
                name: attribute.icon.name,
                url16: attribute.icon.url16,
                url48: attribute.icon.url48
            }
        });
    const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
        if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
            isInsightAvailable: node.isInsightAvailable
        } : {};
        return {
            cmdbFieldConfig: {
                multiple: node.cmdbFieldConfig.multiple,
                objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
                attributesDisplayedOnIssue: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
                attributesIncludedInAutoCompleteSearch: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
            },
            isInsightAvailable: node.isInsightAvailable,
            wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
        };
    };
    const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
        switch(type){
            case 'REFERENCED_OBJECT':
                return 1;
            case 'USER':
                return 2;
            case 'GROUP':
                return 4;
            case 'PROJECT':
                return 6;
            case 'STATUS':
                return 7;
            case 'BITBUCKET_REPO':
                return 8;
            case 'OPSGENIE_TEAM':
                return 9;
            case 'DEFAULT':
                return 0;
            default:
                console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
                return -1;
        }
    };
    const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
            id: node.objectGlobalId,
            workspaceId: node.workspaceId,
            objectKey: node.objectKey,
            label: node.label,
            avatar: node.avatar,
            objectId: node.objectId
        });
    const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
            avatarUrl: node.picture,
            displayName: node.name,
            name: node.name,
            key: node.accountId
        });
    const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
            avatarUrl: node.avatar?.large,
            id: Number(node.id),
            key: node.key,
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
            uuid: node.uuid,
            name: node.name,
            url: node.url,
            avatarUrl: node.avatarUrl
        });
    const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
            id: node.id,
            name: node.name,
            url: node.url
        });
    const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
            id: node.id,
            name: node.name,
            category: node.category
        });
    const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
        if (!node) return null;
        const defaultObjectValue = {
            displayValue: node.displayValue,
            searchValue: node.searchValue,
            ...node.value != null ? {
                value: node.value
            } : {}
        };
        if (node.referencedObject) return {
            ...defaultObjectValue,
            referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
        };
        if (node.user) return {
            ...defaultObjectValue,
            user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
        };
        if (node.group) return {
            ...defaultObjectValue,
            group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
        };
        if (node.project) return {
            ...defaultObjectValue,
            project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
        };
        if (node.bitbucketRepo) return {
            ...defaultObjectValue,
            bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
        };
        if (node.opsgenieTeam) return {
            ...defaultObjectValue,
            opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
        };
        if (node.status) return {
            ...defaultObjectValue,
            status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
        };
        return defaultObjectValue;
    };
    const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
        if (!node) return null;
        const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
        return {
            objectTypeAttributeId: objectTypeAttributeId,
            workspaceId: workspaceId,
            objectAttributeValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
            objectTypeAttribute: {
                id: objectTypeAttributeId,
                label: objectTypeAttribute.label,
                name: objectTypeAttribute.name,
                workspaceId: workspaceId,
                type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
                ...objectTypeAttribute.defaultType ? {
                    defaultType: {
                        id: objectTypeAttribute.defaultType.id,
                        name: objectTypeAttribute.defaultType.name
                    }
                } : {}
            }
        };
    };
    const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
        if (!node) return null;
        const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
        return {
            attributes: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
            avatar: avatar,
            label: label,
            id: objectGlobalId,
            objectId: objectId,
            objectKey: objectKey,
            workspaceId: workspaceId,
            links: {
                self: webUrl
            },
            objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
        };
    };
    const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
            configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE),
                items: 'cmdb-object-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iv8Rf", function(module, exports) {
    $parcel$export(module.exports, "transformAggColorToLegacyField", ()=>$b83a62ddd17b4586$export$587c178f1b45e5e9);
    var $5fc53;
    var $o7K5u;
    const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
        const value = node.color?.colorKey ?? null;
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE:
            case 0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: value,
                    schema: {
                        configuration: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hDlc2", function(module, exports) {
    $parcel$export(module.exports, "transformAggComponentsToLegacyField", ()=>$315456e18e2330f5$export$97a9275777684b77);
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
        if (component == null) return null;
        return {
            id: component.componentId,
            name: component.name,
            ...(0, (0, parcelRequire("co1wz")).ff)('compass-components-in-jira-components_xw42u', false) ? {
                ari: component.ari,
                metadata: component.metadata
            } : {}
        };
    };
    const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: 'component',
                renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)
            }
        };
    };
});
parcelRegister("c3LW9", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", ()=>$e80217ec1ee321d5$export$e6d015aa746cbdaf);
    var $5fc53;
    var $o7K5u;
    const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        });
});
parcelRegister("h92P3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", ()=>$1bb7cdf99e93ff64$export$edf5c98d20696686);
    var $5fc53;
    var $o7K5u;
    const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectMultiSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length ? value : null,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
                configuration: null
            }
        };
    };
});
parcelRegister("aeO9V", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectNumberToLegacyField", ()=>$b8a5823753f7873f$export$4638a5dd3285d8f2);
    var $5fc53;
    var $o7K5u;
    const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        });
});
parcelRegister("6Tnq8", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", ()=>$f9558299012f1c2e$export$11063e1f9210f191);
    var $kz2lw;
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f9558299012f1c2e$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText.plainText == null) return '';
        return node.richText.plainText;
    };
    const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        const values = isPlainTextRenderer ? {
            value: $f9558299012f1c2e$var$getPlainTextValue(node)
        } : {
            adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            ...values,
            schema: {
                custom: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                renderer: renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            }
        };
    };
});
parcelRegister("kz2lw", function(module, exports) {
    $parcel$export(module.exports, "getEmptyADF", ()=>$06167b6274ea84aa$export$d109ab46c9575565);
    var $ebjue;
    const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
            type: 'doc',
            version: 1,
            content: []
        });
});
parcelRegister("ebjue", function(module, exports) {
    $parcel$export(module.exports, "isEmpty", ()=>$9e55b7d6fded4629$export$dd1bc94b04021eeb);
    const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
});
parcelRegister("dMYPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4fed9edf4c76e19$export$2e2bcd8739ae039);
    var $dJl1T;
    const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
    const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
        try {
            if (!('renderer' in field)) return false;
            if (field?.renderer) return false;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
            return true;
        } catch  {
            return false;
        }
    };
    var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;
});
parcelRegister("6mbsj", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", ()=>$ceb0872dd5eafe49$export$e44db7cf61369a28);
    var $5fc53;
    var $o7K5u;
    const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
        let value = null;
        if (node.fieldOption != null) value = {
            id: parseInt(node.fieldOption?.optionId, 10),
            value: node.fieldOption?.value
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectSingleSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption)),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("d3nG3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectTextToLegacyField", ()=>$145b645a3d2e801e$export$dd05277f5aa90657);
    var $5fc53;
    var $o7K5u;
    const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("1xW6n", function(module, exports) {
    $parcel$export(module.exports, "transformAggDataClassificationToLegacyField", ()=>$1a8d4561538d1d2b$export$b5edfdc89a7a2932);
    var $5fc53;
    var $o7K5u;
    const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE),
            value: node,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                custom: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE)
            }
        });
});
parcelRegister("fW9XR", function(module, exports) {
    $parcel$export(module.exports, "transformAggDatePickerToLegacyField", ()=>$c44a652aaa9bff90$export$3d6e51d37c0454a9);
    var $5fc53;
    var $o7K5u;
    const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        configuration: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        custom: node.type,
                        configuration: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("bKMMB", function(module, exports) {
    $parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", ()=>$fb29b1af2f1467e0$export$3de22f1277f0c239);
    var $5fc53;
    var $o7K5u;
    const $fb29b1af2f1467e0$var$defaultSchema = {
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE),
        custom: null,
        system: null,
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime || '',
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_DATE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIRST_RESPONSE_DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_DATE_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        custom: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("7JL37", function(module, exports) {
    $parcel$export(module.exports, "transformAggEpicLinkToLegacyField", ()=>$3279d658ea1a4982$export$1311f30c94840aa2);
    var $kFsv3;
    var $5fc53;
    var $o7K5u;
    const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
        if (epic == null) return null;
        return {
            id: Number(epic.issueId),
            key: epic.key || '',
            done: !!epic.done,
            name: epic.name || '',
            summary: epic.summary || '',
            color: {
                key: epic.color ?? (0, (0, parcelRequire("kFsv3")).AgileColors).AGILE_COLOR_1
            },
            fromCache: false
        };
    };
    const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).EPIC_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl,
            value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
            schema: {
                configuration: null,
                items: null,
                renderer: 'jira-text-renderer',
                type: 'any',
                custom: (0, (0, parcelRequire("5fc53")).EPIC_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("dulCG", function(module, exports) {
    $parcel$export(module.exports, "transformAggFlagToLegacyField", ()=>$f31e97d89b497c1c$export$31555b6ea19f4c2);
    var $5fc53;
    var $o7K5u;
    const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
        if (flag == null || flag.isFlagged == null) return null;
        return [
            {
                value: flag.isFlagged
            }
        ];
    };
    const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE),
                items: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6vno6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateToLegacyField", ()=>$f5e60b2709763004$export$30fccfce22948120);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.date,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE)
            }
        };
    };
});
parcelRegister("as0vY", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", ()=>$3520698819975afe$export$61b1f0cbd04c7b9c);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        };
    };
});
parcelRegister("6dPLd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupToLegacyField", ()=>$ce6b58a5b1f45912$export$60b03d63015cbb9f);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedGroup ? {
                name: node.selectedGroup.name
            } : null,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
            }
        };
    };
});
parcelRegister("gKccZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", ()=>$256d8054300c3cdf$export$2dfa4944fba5d1f5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedGroupsConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
                name: name
            })) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("jnUrZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeNumberToLegacyField", ()=>$c68528ed0dfd109c$export$5dab8986dc45db07);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iJtmd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeObjectToLegacyField", ()=>$c814454c00552e79$export$fbdabdbae2a203b9);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = (()=>{
            if (node.object == null) return null;
            try {
                return JSON.parse(node.object);
            } catch (e) {
                throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
            }
        })();
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_OBJECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("iPyq0", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringToLegacyField", ()=>$29f719811f573640$export$3a581fb4b3e578bd);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("384lj", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringsToLegacyField", ()=>$0d30cb879c19e1ba$export$418a06cb5dc6aba5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("axTS6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUserToLegacyField", ()=>$0669940239efeaff$export$bc73c7a747f907e5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iob0v", function(module, exports) {
    $parcel$export(module.exports, "transformJiraUserToLegacyServerUser", ()=>$42550039db1edc00$export$d7b231260a016eaf);
    const $42550039db1edc00$var$getAccountType = (objectType)=>{
        switch(objectType){
            case 'AtlassianAccountUser':
                return 0, $145004f7a92e2423$export$981400c14dd99bc0;
            case 'CustomerUser':
                return 0, $145004f7a92e2423$export$2823897fb92cd040;
            case 'AppUser':
                return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
            default:
                return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
        }
    };
    const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
            '16x16': url,
            '24x24': url,
            '32x32': url,
            '48x48': url
        });
    const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
        if (!user) return null;
        const userOptionalKeysMap = {
            emailAddress: 'email',
            locale: 'locale',
            timeZone: 'zoneinfo'
        };
        const optionalValues = {};
        Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
            const aggValue = user[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        const avatars = user.picture != null ? {
            avatarUrl: user.picture,
            avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
        } : {};
        return {
            ...avatars,
            ...optionalValues,
            accountId: user.accountId,
            accountType: $42550039db1edc00$var$getAccountType(user.__typename),
            active: user.accountStatus === 'active',
            displayName: user.name
        };
    };
});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';
parcelRegister("lfJ6H", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUsersToLegacyField", ()=>$eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedUsersConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("9UXU7", function(module, exports) {
    $parcel$export(module.exports, "transformAggGoalsToLegacyField", ()=>$a8d444f432651533$export$158301a02ae4cbe7);
    var $5fc53;
    var $o7K5u;
    const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) return undefined;
        const value = node.selectedGoals ? {
            goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                    id: edge?.node?.id || '',
                    name: edge?.node?.name || '',
                    status: edge?.node?.status || null
                })) || [],
            totalCount: node.selectedGoals?.totalCount || 0
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
                items: null,
                renderer: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)
            }
        };
    };
});
parcelRegister("b6BoU", function(module, exports) {
    $parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", ()=>$d0a0e03637cc83cd$export$62db794d5816e28e);
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
        if (role == null) return null;
        return {
            restrictionValue: role.roleId
        };
    };
    const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, context)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE)) return undefined;
        const roles = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
        const restrictions = roles.length > 0 ? {
            projectrole: roles
        } : {};
        const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                shouldDisplay: project.canSetIssueRestriction === true,
                issuerestrictions: restrictions
            },
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE),
                custom: null,
                system: node.type
            }
        };
    };
});
parcelRegister("hA3EZ", function(module, exports) {
    $parcel$export(module.exports, "getProjectType", ()=>$e3d5807b112803bd$export$3dd0da95519c1a33);
    $parcel$export(module.exports, "getSystemAggJiraProject", ()=>$e3d5807b112803bd$export$d100105d56da4a0a);
    $parcel$export(module.exports, "isAggJiraProjectClassic", ()=>$e3d5807b112803bd$export$3502ed01c034e451);
    $parcel$export(module.exports, "transformAggProjectToProjectContext", ()=>$e3d5807b112803bd$export$275f121d4e6f5165);
    $parcel$export(module.exports, "transformAggProjectToLegacyField", ()=>$e3d5807b112803bd$export$30c14b802399f417);
    var $2vSU6;
    var $5fc53;
    var $g5X3G;
    var $k5x3N;
    var $o7K5u;
    const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
        switch(status){
            case 'ACTIVE':
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
            case 'ARCHIVED':
                return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
            case 'DELETED':
                return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
            default:
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
        }
    };
    const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
        switch(projectType){
            case 'SERVICE_DESK':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'BUSINESS':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'SOFTWARE':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'PRODUCT_DISCOVERY':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
        const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, (0, parcelRequire("5fc53")).PROJECT_TYPE))?.node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        return projectField.project;
    };
    const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
    const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
    const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
        if (project == null) return null;
        const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
        return {
            name: name,
            id: projectId ?? undefined,
            key: (0, (0, parcelRequire("g5X3G")).toProjectKey)(key),
            avatarUrls: {
                '48x48': avatar.large
            }
        };
    };
    const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
        const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
        const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
        return {
            projectId: projectId,
            projectType: projectType,
            projectName: name,
            projectKey: key,
            projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
            avatarUrl: avatar.medium,
            isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
            boardId: navigationMetadata?.boardId
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
                system: null
            }
        });
    const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
        if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            title: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            value: node.project?.similarIssues?.featureEnabled === true,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE)
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
        if (node?.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, (0, parcelRequire("5fc53")).PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
        const projectField = node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        const project = projectField.project;
        const { projectType: type } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                projectType: projectType
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
        return undefined;
    };
    const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
        if ((0, (0, parcelRequire("k5x3N")).isJPDDeliveryLinkTypeFilteringEnabled)()) switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
            default:
                return undefined;
        }
        else switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
            default:
                return undefined;
        }
    };
});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';
parcelRegister("k5x3N", function(module, exports) {
    $parcel$export(module.exports, "isJPDDeliveryLinkTypeFilteringEnabled", ()=>$9be9ea07d5dfc538$export$8fac1563227555f2);
    var $co1wz;
    const $9be9ea07d5dfc538$export$8fac1563227555f2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);
});
parcelRegister("gak3n", function(module, exports) {
    $parcel$export(module.exports, "getSystemAggJiraIssueType", ()=>$4f9b530de681b60e$export$b4644a0cc2f2935e);
    $parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", ()=>$4f9b530de681b60e$export$2356062173546155);
    $parcel$export(module.exports, "transformAggIssueTypeToLegacyField", ()=>$4f9b530de681b60e$export$de2eb3b47c7c887b);
    var $imYFg;
    var $5fc53;
    var $o7K5u;
    const $4f9b530de681b60e$export$d95e76b2d065f98d = {
        avatarId: 0,
        self: ''
    };
    const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
        const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE))?.node;
        if (issueTypeField == null || issueTypeField.__typename !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
        return issueTypeField.issueType;
    };
    const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
            ...$4f9b530de681b60e$export$d95e76b2d065f98d,
            id: issueType.issueTypeId,
            iconUrl: issueType.avatar?.medium ?? '',
            name: issueType.name,
            description: 'description' in issueType && issueType.description != null ? issueType.description : '',
            hierarchyLevel: issueType.hierarchy.level,
            subtask: issueType.hierarchy.level === (0, (0, parcelRequire("imYFg")).ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
        });
    const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
            }
        };
    };
});
parcelRegister("imYFg", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", ()=>$ccb1a8095461a82a$export$2fe6880f0073407c);
    var $g4tDr;
    const $ccb1a8095461a82a$export$2fe6880f0073407c = {
        SUBTASK_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK),
        BASE_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE),
        LEVEL_ONE: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
        LEVEL_TWO: 2
    };
});
parcelRegister("i47fO", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", ()=>$448e6754d8bf50d1$export$b14d30f2a9e4c343);
    var $9ar3z;
    var $5fc53;
    var $g5X3G;
    var $o7K5u;
    var $iob0v;
    const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
        if (!approverPrincipal) return undefined;
        switch(approverPrincipal.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("g5X3G")).toAccountId)(approverPrincipal.user.accountId),
                    name: approverPrincipal.user.name,
                    meta: {
                        jiraRest: approverPrincipal.jiraRest
                    },
                    type: 'user',
                    avatarUrl: approverPrincipal.user.picture
                };
            case 0, (0, parcelRequire("5fc53")).JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("9ar3z")).toGroupId)(approverPrincipal.groupId),
                    meta: {
                        memberCount: approverPrincipal.memberCount,
                        approvedCount: approverPrincipal.approvedCount
                    },
                    name: approverPrincipal.name,
                    type: 'group'
                };
            default:
                return undefined;
        }
    };
    const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
        switch(decision){
            case 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING:
            default:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING;
        }
    };
    const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
        if (!approvalNode) return undefined;
        const approver = (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(approvalNode.approver);
        if (!approver) return undefined;
        return {
            approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
            approver: approver
        };
    };
    const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
        const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
        const approverConfiguration = approversConfigurations[0];
        return {
            approvers: {
                type: approverConfiguration?.type ?? '',
                customFieldName: approverConfiguration?.fieldName ?? '',
                customFieldId: approverConfiguration?.fieldId ?? ''
            },
            condition: {
                type: condition?.type ?? '',
                value: condition?.value ?? ''
            }
        };
    };
    const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
            epochMillis: new Date(date).valueOf()
        });
    const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
            name: status.name || '',
            category: Number(status.categoryId)
        });
    const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
        const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
        return {
            id: id,
            approvalState: approvalState,
            approvedStatus: approvedStatus,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            name: name,
            pendingApprovalCount: pendingApprovalCount,
            canAnswerApproval: canAnswerApproval,
            approverPrincipals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
            configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            decisions: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
            excludedApprovers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.excludedApprovers, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
        };
    };
    const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
        if (!completedApproval) return undefined;
        const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
        return {
            id: id,
            name: name,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
        };
    };
    const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)) return undefined;
        const activeApproval = node.activeApproval ? {
            activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
        } : {};
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...activeApproval,
                completedApprovals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE),
                type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)
            }
        };
    };
});
parcelRegister("9ar3z", function(module, exports) {
    $parcel$export(module.exports, "toGroupId", ()=>$4a7fc5eda3865b0e$export$779c261480444a4d);
    $parcel$export(module.exports, "APPROVER_PENDING", ()=>$4a7fc5eda3865b0e$export$3b59c4db06f5829b);
    $parcel$export(module.exports, "APPROVER_APPROVED", ()=>$4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
    $parcel$export(module.exports, "APPROVER_DECLINED", ()=>$4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
    $parcel$export(module.exports, "APPROVAL_OK", ()=>$4a7fc5eda3865b0e$export$2e6187b6a4348938);
    const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
    const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
    const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
    const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
    const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
    const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';
});
parcelRegister("gvljZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", ()=>$b281bef34e07e20f$export$850fadda8a5e6f27);
    var $5fc53;
    var $o7K5u;
    const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedEntitlement,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6XFn2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", ()=>$926c732f6621d9fd$export$d4e0b2288fb31144);
    var $5fc53;
    var $o7K5u;
    const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.majorIncident,
            renderedValue: null,
            configuration: {},
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("6e1Ya", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", ()=>$0e4eebb31cef7087$export$7bd14951253a7c5f);
    var $5fc53;
    var $o7K5u;
    const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                    id: selectedNode.organizationId,
                    name: selectedNode.organizationName
                })),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE),
                items: 'sd-customerorganization',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("hBEiJ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", ()=>$841fa8e5b9308ced$export$c52c6988b335096);
    var $5fc53;
    var $o7K5u;
    const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.feedback,
            schema: {
                type: 'sd-feedback',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("1XNj2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", ()=>$1edf1c9b37cdb462$export$6a53240e225f742);
    var $5fc53;
    var $o7K5u;
    const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.language,
            allowedValues: [
                ...node.languages ?? []
            ],
            schema: {
                type: 'sd-request-lang',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("f6zXW", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", ()=>$8030de3237296d5c$export$5ffaab1383177efa);
    var $5fc53;
    var $o7K5u;
    const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
        if (!requestType) return null;
        return {
            requestType: {
                id: parseInt(requestType.requestTypeId, 10),
                issueTypeId: requestType.issueType?.issueTypeId || '',
                name: requestType.name || '',
                icon: {
                    _links: {
                        iconUrls: {
                            '48x48': requestType.avatar?.large || ''
                        }
                    }
                }
            }
        };
    };
    const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'sd-customerrequesttype'
            }
        };
    };
});
parcelRegister("fB4wX", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", ()=>$0ea07ade045943f7$export$5171c4d1ae5bcde5);
    var $5fc53;
    var $o7K5u;
    const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
        if (responder == null) return undefined;
        switch(responder.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_RESPONDER_GQL_FIELD:
                if (responder.user === null) return undefined;
                return {
                    ari: responder.user.canonicalAccountId,
                    avatarUrl: responder.user.picture,
                    name: responder.user.name,
                    type: 'user'
                };
            case 0, (0, parcelRequire("5fc53")).JSM_TEAM_RESPONDER_FIELD:
                return {
                    ari: responder.teamId,
                    name: responder.teamName,
                    type: 'team'
                };
            default:
                return undefined;
        }
    };
    const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("cXBkk", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", ()=>$5dcf9f49c6a1536d$export$702d3754a4c7d90a);
    var $5fc53;
    var $o7K5u;
    const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.sentiment,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iDKu3", function(module, exports) {
    $parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", ()=>$5345161012c71e28$export$98e4f56e2e6c44fe);
    var $5fc53;
    var $o7K5u;
    const $5345161012c71e28$var$defaultSchema = {
        configuration: null,
        items: 'string',
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
        const selectedLabels = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels.length === 0 ? null : selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: node.type,
                        system: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("aGv90", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", ()=>$ee565846dd4aef42$export$f968da580693597d);
    var $o7K5u;
    const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
                groupId: groupNode.groupId,
                name: groupNode.name
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                type: 'array',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: 'group',
                configuration: null
            }
        };
    };
});
parcelRegister("19DRh", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", ()=>$d83d25c034b1d99f$export$869fb8fbcb97e0ee);
    var $5fc53;
    var $o7K5u;
    const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: [],
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lkW3a", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", ()=>$9b1f1d40e628c968$export$cdd9991119eb040e);
    var $2vSU6;
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    var $iob0v;
    const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, context)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser));
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                configuration: null,
                custom: node.type,
                items: 'user',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE:
                {
                    if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm') && node.__typename === (0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)) return {
                        ...legacyFieldValues,
                        value: value
                    };
                    const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
                    if ((0, (0, parcelRequire("hA3EZ")).getProjectType)(project.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
                    return {
                        ...legacyFieldValues,
                        value: value
                    };
                }
            case 0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE:
                return legacyFieldValues;
            case 0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                {
                    const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                        {
                            key: 'isMulti',
                            value: String(node.isMulti)
                        }
                    ] : null;
                    return {
                        ...legacyFieldValues,
                        autoCompleteUrl: node.searchUrl,
                        schema: {
                            ...legacyFieldValues.schema,
                            configuration: schemaConfig
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lQAwK", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", ()=>$dc0acfee4cadcdcd$export$6207ea60703068d8);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $dc0acfee4cadcdcd$var$defaultSchema = {
        configuration: null,
        custom: null,
        items: 'version',
        renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
        system: null,
        type: 'array'
    };
    const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)) return undefined;
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedVersionsConnection, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion))
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE:
                return {
                    ...legacyFieldValues,
                    value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        custom: (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
                return {
                    ...legacyFieldValues,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        system: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("149sa", function(module, exports) {
    $parcel$export(module.exports, "transformAggVersionToLegacyVersion", ()=>$4617842fe98d5759$export$becef8d087e8b62b);
    var $jPhQo;
    const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
            id: version.versionId ?? '',
            name: version.name ?? '',
            description: version.description ?? '',
            archived: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).ARCHIVED,
            released: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).RELEASED,
            ari: version.id
        });
});
parcelRegister("jPhQo", function(module, exports) {
    $parcel$export(module.exports, "VersionStatus", ()=>$b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
    var $imYFg;
    const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
        ARCHIVED: 'ARCHIVED',
        RELEASED: 'RELEASED',
        UNRELEASED: 'UNRELEASED'
    };
});
parcelRegister("8qOI6", function(module, exports) {
    $parcel$export(module.exports, "transformAggNumberToLegacyField", ()=>$b542e2b397d83c88$export$d754a24ed0096d2f);
    var $5fc53;
    var $o7K5u;
    const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
        const fieldType = node.isStoryPointField === true ? (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE) : node.type;
        switch(fieldType){
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.number ?? null,
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: fieldType,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cbd7V", function(module, exports) {
    $parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", ()=>$47597066e94f8347$export$f08d02fdc74f920e);
    var $5fc53;
    var $o7K5u;
    const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.originalEstimate?.timeInSeconds ?? null,
            schema: {
                configuration: null,
                custom: null,
                system: node.type,
                items: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE),
                renderer: null
            }
        };
    };
});
parcelRegister("6hj44", function(module, exports) {
    $parcel$export(module.exports, "transformAggPriorityToLegacyField", ()=>$47c25f6616be0140$export$9e966ce605f800d2);
    var $5fc53;
    var $o7K5u;
    const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
        if (priority == null) return null;
        return {
            id: priority.priorityId,
            iconUrl: String(priority.iconUrl || ''),
            name: priority.name || '',
            sequence: priority.sequence || undefined
        };
    };
    const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
            schema: {
                type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
            }
        };
    };
});
parcelRegister("4nh4C", function(module, exports) {
    $parcel$export(module.exports, "transformAggProformaFormsToLegacyField", ()=>$27d464e5749e1114$export$fdcdbf17b0d4e36f);
    var $5fc53;
    var $o7K5u;
    const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.proformaForms,
            schema: {
                configuration: null,
                items: null,
                system: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS),
                custom: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)
            }
        };
    };
});
parcelRegister("2z4xE", function(module, exports) {
    $parcel$export(module.exports, "transformAggRadioSelectToLegacyField", ()=>$b545e68fef1c7c25$export$f147f1eb3a15ccfc);
    var $5fc53;
    var $o7K5u;
    const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)) return undefined;
        const value = node.selectedOption ? {
            id: node.selectedOption?.optionId,
            value: node.selectedOption?.value,
            isDisabled: node.selectedOption?.isDisabled
        } : null;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
                id: option.optionId,
                value: option.value ?? null,
                ari: option.id
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("cO2KQ", function(module, exports) {
    $parcel$export(module.exports, "transformAggResolutionToLegacyField", ()=>$b13d1a2c3ca9d3cb$export$179f600c7e1d0230);
    var $5fc53;
    var $o7K5u;
    const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
        if (resolution == null) return null;
        return {
            id: resolution.resolutionId,
            name: resolution.name || ''
        };
    };
    const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)) return undefined;
        const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("5sETx", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextToLegacyField", ()=>$181b5722dae42ee4$export$e65ff2ce94be106e);
    var $kz2lw;
    var $5fc53;
    var $fCo6Y;
    var $o7K5u;
    var $dMYPq;
    const $181b5722dae42ee4$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
        switch(aggType){
            case 0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE:
                return {
                    custom: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    system: null,
                    configuration: null,
                    items: null
                };
            case 0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE:
            case 0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE:
            default:
                return {
                    system: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    configuration: null,
                    items: null
                };
        }
    };
    const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText?.plainText == null) return '';
        return node.richText?.plainText;
    };
    const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = node.type !== (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        if (isPlainTextRenderer) return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $181b5722dae42ee4$var$getPlainTextValue(node),
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
        const adfValueJson = node.richText?.adfValue?.json ?? null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            adfValue: adfValueJson ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
            value: null,
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
    };
});
parcelRegister("fCo6Y", function(module, exports) {
    $parcel$export(module.exports, "emptyAdfObject", ()=>$79bd166f69131b05$export$202742e99f678c60);
    $parcel$export(module.exports, "removeCollectionFromAdf", ()=>$79bd166f69131b05$export$9e9311e676291037);
    $parcel$export(module.exports, "convertAdfStringToObject", ()=>$79bd166f69131b05$export$ee70d4eb14697455);
    $parcel$export(module.exports, "isOnlyWhitespaceAdf", ()=>$79bd166f69131b05$export$cf4bde415465976c);
    $parcel$export(module.exports, "removeNewLineCharactersFromAdf", ()=>$79bd166f69131b05$export$d6ce0667c33b94ff);
    $parcel$export(module.exports, "removeTrailingNewLineCharacters", ()=>$79bd166f69131b05$export$3688e35a300432d6);
    $parcel$export(module.exports, "simplifyAdf", ()=>$79bd166f69131b05$export$def86d25f0c7f0bc);
    $parcel$export(module.exports, "hasMediaFileNodes", ()=>$79bd166f69131b05$export$9a632b58fb9b287c);
    $parcel$export(module.exports, "hasMediaFileNodesUpdated", ()=>$79bd166f69131b05$export$80a6e90c7b29d88c);
    var $lmhF9;
    var $l1C1k;
    var $dJl1T;
    const $79bd166f69131b05$export$202742e99f678c60 = {
        type: 'doc',
        version: 1,
        content: []
    };
    const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
        if (adf === null || adf === undefined) return null;
        if (adf.type === 'media' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.type === 'mediaInline' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.content) return {
            ...adf,
            content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
        };
        return adf;
    };
    const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
        if (typeof adf === 'string') try {
            return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
            return null;
        }
        return $79bd166f69131b05$export$9e9311e676291037(adf);
    };
    const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
            if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
            return false;
        }) : false;
    const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
        if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
        let len;
        for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
            if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
        }
        return {
            ...adf,
            content: adf.content.slice(0, len + 1)
        };
    };
    const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
    const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
    const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
        const mediaNodes = new Map();
        (0, (0, parcelRequire("l1C1k")).traverse)(doc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    };
    const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, (0, parcelRequire("l1C1k")).traverse)(newDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, (0, parcelRequire("l1C1k")).traverse)(currentDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    };
    const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
        if (doc === null || doc === undefined) return false;
        const nonSimpleTextNodes = (0, (0, parcelRequire("lmhF9")).filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
        return nonSimpleTextNodes.length === 0;
    };
    const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
        const { defaultSchema: defaultSchema } = await (parcelRequire("j87Vo"));
        const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("h2XnI"));
        const { JSONTransformer: JSONTransformer } = await (parcelRequire("hgt9V"));
        const jsonTransformer = new JSONTransformer();
        const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
        if (node === null || node === undefined) return '';
        const pmNode = jsonTransformer.parse(node);
        return wikiMarkupTransformer.encode(pmNode);
    };
});
parcelRegister("lmhF9", function(module, exports) {
    $parcel$export(module.exports, "filter", ()=>$cb7d90be6f5f5975$export$3dea766d36a8935f);
    var $l1C1k;
    function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
        const result = [];
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                if (callback(node)) result.push(node);
            }
        });
        return result;
    }
});
parcelRegister("l1C1k", function(module, exports) {
    $parcel$export(module.exports, "traverse", ()=>$b903aab814d8ed47$export$df3f009e3d155b20);
    function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
        return true;
    }
    function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
        if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
        return $b903aab814d8ed47$var$traverseNode(adf, {
            node: undefined
        }, visitors, 0, 0);
    }
    function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
        const visitor = visitors[adfNode.type] || visitors['any'];
        let newNode = {
            ...adfNode
        };
        if (visitor) {
            const processedNode = visitor({
                ...newNode
            }, parent, index, depth);
            if (processedNode === false) return false;
            newNode = processedNode || adfNode;
        }
        if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
            if (!node) return acc;
            const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
                node: newNode,
                parent: parent
            }, visitors, idx, depth + 1);
            if (processedNode !== false) acc.push(processedNode);
            return acc;
        }, []);
        return newNode;
    }
});
parcelRegister("j87Vo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Q4nN").then(()=>parcelRequire('kOFhM'));
});
parcelRegister("h2XnI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikOjy").then(()=>parcelRequire('dN5CS'));
});
parcelRegister("hgt9V", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("akgCU").then(()=>parcelRequire('hYNZx'));
});
parcelRegister("f454b", function(module, exports) {
    $parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", ()=>$811c3c0495fb451c$export$45e25e2a6750ea5a);
    var $5fc53;
    var $o7K5u;
    const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
        if (securityLevel == null) return null;
        return {
            id: securityLevel.securityId,
            description: securityLevel.description || '',
            name: securityLevel.name || ''
        };
    };
    const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
            schema: {
                configuration: null,
                type: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE_OVERRIDE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE),
                items: null
            }
        });
});
parcelRegister("aafIf", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", ()=>$950a9b8297396bb3$export$e6697ec5bdac9ec0);
    var $o7K5u;
    const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
        const value = node.selectedGroup != null ? {
            groupId: node.selectedGroup.groupId,
            name: node.selectedGroup.name
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'group',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2yWre", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", ()=>$f5309f9bc8791ddf$export$31f32b3fd9e5ab6);
    var $5fc53;
    var $o7K5u;
    const $f5309f9bc8791ddf$var$defaultSchema = {
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
        const defaultTransformedField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_PROPERTY_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RANK_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE:
                return node.text != null ? {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: [
                        node.text
                    ],
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        renderer: null,
                        custom: null,
                        system: node.type,
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE)
                    }
                } : undefined;
            default:
                return undefined;
        }
    };
});
parcelRegister("lUeQj", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectToLegacyField", ()=>$9513f3f43c691d67$export$4e113f935e09d226);
    var $5fc53;
    var $o7K5u;
    const $9513f3f43c691d67$var$getField = (node, customType)=>{
        const value = node.fieldOption != null ? {
            ari: node.fieldOption.id,
            id: node.fieldOption.optionId,
            value: node.fieldOption.value
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: customType || node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
    const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                return $9513f3f43c691d67$var$getField(node);
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return $9513f3f43c691d67$var$getField(node, (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE));
            default:
                return undefined;
        }
    };
});
parcelRegister("6SWOK", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", ()=>$7348765074cf60a5$export$7bf73fc06c6d71be);
    var $5fc53;
    var $o7K5u;
    var $iob0v;
    const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
        const legacyField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).LAST_UPDATER_OR_COMMENTER_CF_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: node.type,
                        system: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cMc7B", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", ()=>$1c34fc6a70d0e0b4$export$d03f622577260442);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.singlePickerVersions, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion));
        const value = node.version ? (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion)(node.version) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_VERSION_CF_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("38GNL", function(module, exports) {
    $parcel$export(module.exports, "transformAggSprintToLegacyField", ()=>$05e0b9d6b707c3a6$export$9b5bb05d50970021);
    var $5fc53;
    var $o7K5u;
    const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
        goal: 'goal',
        completeDate: 'completionDate',
        startDate: 'startDate',
        endDate: 'endDate'
    };
    const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
        const optionalValues = {};
        Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
            const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
            const aggValue = sprint[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        return {
            id: Number(sprint.sprintId),
            name: sprint.name,
            state: sprint.state?.toLowerCase(),
            boardId: Number(sprint.boardName) || 0,
            ...optionalValues
        };
    };
    const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) return undefined;
        const sprints = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: sprints,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
                items: 'json',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("avV20", function(module, exports) {
    $parcel$export(module.exports, "getStatusesDeprecatedValue", ()=>$e8b60f3bf3251c5a$export$b80ec59d806c2f94);
    $parcel$export(module.exports, "transformAggStatusToLegacyField", ()=>$e8b60f3bf3251c5a$export$c80e5acb1c882c48);
    var $gULOk;
    var $5fc53;
    var $o7K5u;
    const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
        const { status: status } = fields;
        if (!status || status.value == null) return {};
        const { value: value } = status;
        return {
            [value.id]: {
                id: value.id,
                name: value.name,
                statusCategory: (0, (0, parcelRequire("gULOk")).statusCategoryForId)(value.statusCategory?.id)
            }
        };
    };
    const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
        if (status == null) return null;
        const { statusCategory: statusCategory } = status;
        return {
            id: status.statusId,
            name: status.name || '',
            statusCategory: {
                id: Number(statusCategory.statusCategoryId)
            }
        };
    };
    const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).STATUS_TYPE)
            }
        };
    };
});
parcelRegister("cbXvu", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamToLegacyField", ()=>$2c8c4053c45e92fb$export$fb1b80497e96456f);
    var $5fc53;
    var $o7K5u;
    const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)) return undefined;
        const value = node.selectedTeam ? {
            id: node.selectedTeam.teamId,
            title: node.selectedTeam.name,
            isShared: node.selectedTeam.isShared,
            avatarUrl: node.selectedTeam.avatar?.medium
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
            }
        };
    };
});
parcelRegister("aSXJi", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamViewToLegacyField", ()=>$b1861ddba2f2c1e6$export$6f6aaafb49bd4769);
    var $5fc53;
    var $o7K5u;
    const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
        if (team == null) return null;
        return {
            id: team.jiraSuppliedTeamId,
            name: team.jiraSuppliedName || '',
            isVisible: team.jiraSuppliedVisibility || false,
            avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
        };
    };
    const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'team'
            }
        };
    };
});
parcelRegister("8uxcU", function(module, exports) {
    $parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", ()=>$63b0d60fa2cc1a3e$export$874d9bd14269ec6f);
    var $5fc53;
    var $o7K5u;
    const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
        if (estimate) return {
            [key]: estimate.timeInSeconds || 0
        };
        return {};
    };
    const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)) return undefined;
        const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
        const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
        const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...originalEstimate,
                ...remainingEstimate,
                ...timeSpent
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE),
                type: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)
            }
        };
    };
});
parcelRegister("arKlm", function(module, exports) {
    $parcel$export(module.exports, "transformAggUrlToLegacyField", ()=>$86ba2c1106803d01$export$6e950e0ec9801f6c);
    var $5fc53;
    var $o7K5u;
    const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).URL_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.uri ?? null,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("hCKV6", function(module, exports) {
    $parcel$export(module.exports, "transformAggVotesToLegacyField", ()=>$78b4a5963398330d$export$8966614b8594736);
    var $5fc53;
    var $o7K5u;
    const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
            votes: vote.count != null ? Number(vote.count) : 0,
            hasVoted: vote.hasVoted ?? false
        });
    const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VOTES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).VOTES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).VOTES_TYPE)
            }
        };
    };
});
parcelRegister("d8wC0", function(module, exports) {
    $parcel$export(module.exports, "transformAggWatchesToLegacyField", ()=>$a83bab4858993b2f$export$6730cb17d10d6156);
    var $5fc53;
    var $o7K5u;
    const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
            watchCount: watch.count != null ? Number(watch.count) : 0,
            isWatching: watch.isWatching ?? false
        });
    const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)
            }
        };
    };
});
parcelRegister("1pF6B", function(module, exports) {
    $parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", ()=>$f8196a61a82995ed$export$d8a5feb2bb0425b4);
    const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
        if (!parentIssue) return null;
        return {
            id: parentIssue.issueId,
            ari: parentIssue.id,
            key: parentIssue.key,
            self: parentIssue.webUrl,
            color: parentIssue.issueColorField?.color?.colorKey,
            fields: {
                summary: parentIssue.summaryField?.text,
                issuetype: {
                    name: parentIssue.issueTypeField?.issueType?.name,
                    iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                    id: '',
                    self: '',
                    description: '',
                    subtask: false,
                    avatarId: 0,
                    hierarchyLevel: 0
                }
            }
        };
    };
});
parcelRegister("lTnWS", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", ()=>$51ceecc021979aad$export$b3a2c3992977726e);
    var $kz2lw;
    var $fCo6Y;
    const $51ceecc021979aad$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
        if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
        if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
            if (richText.plainText !== undefined) return richText.plainText;
            return richText?.adfValue?.convertedPlainText?.plainText;
        }
        return richText?.adfValue?.json ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
    };
});
parcelRegister("3z81P", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$c6ffe75554a4bac3$export$8db21fc94823e1cc);
    const $c6ffe75554a4bac3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
    const $c6ffe75554a4bac3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
    const $c6ffe75554a4bac3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
    const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
        [$c6ffe75554a4bac3$export$8b9b8ed7fbac313c]: $c6ffe75554a4bac3$export$8b9b8ed7fbac313c,
        [$c6ffe75554a4bac3$export$7c15aaba9a26f469]: $c6ffe75554a4bac3$export$7c15aaba9a26f469,
        [$c6ffe75554a4bac3$export$f567ac9d3526e5ce]: $c6ffe75554a4bac3$export$f567ac9d3526e5ce
    };
});
parcelRegister("biQrn", function(module, exports) {
    $parcel$export(module.exports, "useIsMounted", ()=>$c6adaed2787020bf$export$80c2a3957bcb42ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, [
            isMounted
        ]);
        return isMounted;
    };
});
parcelRegister("kWfaA", function(module, exports) {
    $parcel$export(module.exports, "useCategoryOptionsService", ()=>$a97cefcd4418779b$export$343b4a5d0ceb0f64);
    $parcel$export(module.exports, "useCategoryOptionsCache", ()=>$a97cefcd4418779b$export$c28db2c8cc3e5deb);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $12jwF;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $gEn6y;
    var $jEgAa;
    const $a97cefcd4418779b$export$343b4a5d0ceb0f64 = ()=>{
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("5tTFS")).useQuery)((0, (0, parcelRequire("gEn6y")).CATEGORY_OPTIONS), {
            variables: {
                projectId: entityAri,
                first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
            },
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCategoryOptions',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    attributes: {
                        message: 'Failed to fetch category options with color'
                    },
                    error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const options = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jEgAa")).transformCategoryOptionsData)(data), [
            data
        ]);
        return {
            categoryOptions: options,
            loading: loading,
            error: error
        };
    };
    const $a97cefcd4418779b$export$c28db2c8cc3e5deb = ()=>{
        const analyticsTaskName = 'useCategoryOptionsCacheApolloCacheActions';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const getNewTotalCount = (0, $5uXOq.useCallback)((currentCount, action)=>{
            if (currentCount && action === 'ADD') return currentCount + 1;
            if (currentCount && action === 'REMOVE') return currentCount - 1;
            return currentCount;
        }, []);
        const categoryOptionsCache = (0, $5uXOq.useCallback)((category, action)=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: (0, (0, parcelRequire("gEn6y")).CATEGORY_OPTIONS),
                        variables: {
                            projectId: entityAri,
                            first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                        }
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'categoryOptionsCache',
                            packageName: 'jiraBusinessCategories',
                            teamName: 'jira-warepil'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify((0, (0, parcelRequire("gEn6y")).CATEGORY_OPTIONS)),
                            variables: {
                                projectId: entityAri,
                                first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                            },
                            error: JSON.stringify(e),
                            eventName: 'apolloCacheRead taskFail'
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            if (data == null || data.jira?.jwmCategoryOptions?.__typename === 'QueryError') return;
            const edges = data.jira?.jwmCategoryOptions?.edges;
            if (edges == null) return;
            const newEdges = [
                ...edges
            ];
            const index = newEdges.findIndex((edge)=>edge && edge.node?.option?.optionId === category.option.optionId);
            switch(action){
                case 'ADD':
                    newEdges.push({
                        __typename: 'JiraWorkManagementCategoryOptionEdge',
                        node: {
                            __typename: 'JiraWorkManagementCategoryOption',
                            id: category.id || '',
                            color: category.color || null,
                            option: {
                                id: category.option.id || '',
                                optionId: category.option.optionId,
                                value: category.option.value || '',
                                isDisabled: false,
                                __typename: 'JiraOption'
                            }
                        }
                    });
                    break;
                case 'REMOVE':
                    if (index !== -1) newEdges.splice(index, 1);
                    break;
                case 'UPDATE':
                    if (index !== -1) {
                        const edgeToUpdate = newEdges[index];
                        if (edgeToUpdate) {
                            const edgeUpdated = {
                                ...edgeToUpdate,
                                node: edgeToUpdate?.node && {
                                    ...edgeToUpdate.node,
                                    option: edgeToUpdate.node.option && {
                                        ...edgeToUpdate?.node?.option,
                                        value: category.option.value || ''
                                    },
                                    color: category.color || null
                                }
                            };
                            newEdges.splice(index, 1, edgeUpdated);
                        }
                    }
                    break;
                default:
                    return;
            }
            const totalCount = data.jira?.jwmCategoryOptions?.totalCount || null;
            const newTotalCount = getNewTotalCount(totalCount, action);
            const newData = {
                ...data,
                jira: data.jira && {
                    ...data.jira,
                    jwmCategoryOptions: data?.jira?.jwmCategoryOptions?.__typename === 'JiraWorkManagementCategoryOptionConnection' ? {
                        ...data.jira.jwmCategoryOptions,
                        edges: newEdges,
                        totalCount: newTotalCount
                    } : null
                }
            };
            try {
                client.writeQuery({
                    query: (0, (0, parcelRequire("gEn6y")).CATEGORY_OPTIONS),
                    variables: {
                        projectId: entityAri,
                        first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                    },
                    data: newData
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'categoryOptionsCache',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify((0, (0, parcelRequire("gEn6y")).CATEGORY_OPTIONS)),
                        variables: {
                            projectId: entityAri,
                            first: (0, $a50aeb58786ea834$export$ec93a669a20aa982)
                        },
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            entityAri,
            getNewTotalCount
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                addCategory (category) {
                    categoryOptionsCache(category, 'ADD');
                },
                removeCategory (optionId) {
                    categoryOptionsCache({
                        option: {
                            optionId: optionId
                        },
                        color: null
                    }, 'REMOVE');
                },
                updateCategory (category) {
                    categoryOptionsCache(category, 'UPDATE');
                }
            }), [
            categoryOptionsCache
        ]);
    };
});
const $a50aeb58786ea834$export$a93d8cd30a94ee3a = 'jwmCategoryOptions';
const $a50aeb58786ea834$export$ec93a669a20aa982 = 200;
parcelRegister("gEn6y", function(module, exports) {
    $parcel$export(module.exports, "CATEGORY_OPTIONS", ()=>$4a56a0feb05d0795$export$ce79ac9d0544a95e);
    var $5cllN;
    var $cNu0r;
    const $4a56a0feb05d0795$export$ce79ac9d0544a95e = (0, (0, parcelRequire("5cllN")).default)`
  query JwmCategoryOptions($projectId: ID!, $first: Int) {
    jira {
        jwmCategoryOptions(projectId: $projectId, first: $first) {
            ... on JiraWorkManagementCategoryOptionConnection {
                edges {
                    node {
                        ...JwmCategoryOptionsFragment
                    }
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                }
                totalCount
            }
            ... on QueryError {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
  }
  ${(0, (0, parcelRequire("cNu0r")).JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
});
parcelRegister("jEgAa", function(module, exports) {
    $parcel$export(module.exports, "transformCategoryOptionsData", ()=>$2411a5cf60539afa$export$e25f9b0517b88333);
    const $2411a5cf60539afa$export$e25f9b0517b88333 = (data)=>{
        if (data?.jira?.jwmCategoryOptions && 'edges' in data?.jira?.jwmCategoryOptions && Array.isArray(data?.jira?.jwmCategoryOptions.edges)) {
            const items = [];
            data.jira.jwmCategoryOptions.edges.forEach((edge)=>{
                if (edge && edge.node && edge.node.option) items.push({
                    label: edge.node.option.value ?? '',
                    value: String(edge.node.option.optionId),
                    color: edge.node.color
                });
            });
            return items;
        }
        return [];
    };
});
parcelRegister("aNJFF", function(module, exports) {
    $parcel$export(module.exports, "CREATE_FAILED_FLAG", ()=>$bf14fe7c647de186$export$a94c54b030e108e);
    $parcel$export(module.exports, "QUERY_NAME", ()=>$bf14fe7c647de186$export$a93d8cd30a94ee3a);
    var $kdKGv;
    const $bf14fe7c647de186$export$7ec1427613e4cea = 'jira-business.categories.src.services.create-category';
    const $bf14fe7c647de186$export$a94c54b030e108e = {
        type: 'error',
        title: (0, (0, parcelRequire("kdKGv")).default).createErrorTitle,
        description: (0, (0, parcelRequire("kdKGv")).default).createErrorMessage,
        messageType: 'transactional'
    };
    const $bf14fe7c647de186$export$a93d8cd30a94ee3a = 'jwmCreateCategory';
});
parcelRegister("kdKGv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dedaab0aa0d8004$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2dedaab0aa0d8004$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createErrorTitle: {
            "id": "business-categories.services.create-category.create-error-title",
            "defaultMessage": "We couldn't create the category"
        },
        createErrorMessage: {
            "id": "business-categories.services.create-category.create-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("4czz5", function(module, exports) {
    $parcel$export(module.exports, "useCreateCategory", ()=>$7821cae2a3a7cc15$export$4225ec1f1086359b);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $cm8b5;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $aNJFF;
    var $ezZV6;
    const $7821cae2a3a7cc15$export$4225ec1f1086359b = ({ experience: experience, onCompleted: onCompleted })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experience);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experience);
        const projectId = String(project.id);
        const [createCategory, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("ezZV6")).CREATE_CATEGORY), {
            onError: (apolloError)=>{
                markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
                showFlag((0, (0, parcelRequire("aNJFF")).CREATE_FAILED_FLAG));
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmCreateCategory',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    attributes: {
                        message: 'Failed to create category'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (onCompletedData)=>{
                if (onCompletedData?.createJwmCategory?.errors) return;
                markExperienceSuccess();
                if (onCompleted) onCompleted(onCompletedData);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("aNJFF")).QUERY_NAME)} succeeded`);
            }
        });
        const create = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, value: value, color: color })=>{
            startExperience();
            const response = await createCategory({
                variables: {
                    input: {
                        projectId: projectId,
                        issueTypeId: issueTypeId,
                        value: value,
                        color: color
                    }
                }
            });
            const result = response?.data?.createJwmCategory;
            if (result?.success) {
                if (result.category?.option?.optionId) return {
                    id: result.category.id,
                    color: result.category.color,
                    option: {
                        optionId: result.category.option.optionId,
                        value: result.category.option.value,
                        id: result.category.option.id,
                        isDisabled: result.category.option.isDisabled
                    }
                };
                return null;
            }
            const createError = result?.errors?.find((e)=>e.message);
            if (createError) throw new Error(createError.message || '');
            return null;
        }, [
            createCategory,
            projectId,
            startExperience
        ]);
        const mutationBadRequestError = data?.createJwmCategory?.errors?.find((e)=>e.message);
        return {
            error: error || mutationBadRequestError,
            data: data,
            loading: loading,
            createCategory: create
        };
    };
});
parcelRegister("ezZV6", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CATEGORY", ()=>$28fbafb28db5b55c$export$b88942163ad28b3e);
    var $5cllN;
    var $cNu0r;
    const $28fbafb28db5b55c$export$b88942163ad28b3e = (0, (0, parcelRequire("5cllN")).default)`
  mutation JwmCreateCategory($input: JWMCreateCategoryInput!) {
    createJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
      category {
        ...JwmCategoryOptionsFragment
      }
    }
  }
  ${(0, (0, parcelRequire("cNu0r")).JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
});
parcelRegister("a3IM2", function(module, exports) {
    $parcel$export(module.exports, "useDeleteCategory", ()=>$937fc5423e55917e$export$daf5e0a4ffd89067);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $cm8b5;
    var $dJl1T;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $iyUAx;
    var $77qU8;
    const $937fc5423e55917e$export$daf5e0a4ffd89067 = ({ experience: experience, onCompleted: onCompleted })=>{
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experience);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experience);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectId = String(project.id);
        const [deleteJwmCategory, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("77qU8")).DELETE_JIRA_BUSINESS_CATEGORY), {
            onError: (apolloError)=>{
                markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
                showFlag((0, (0, parcelRequire("iyUAx")).DELETE_FAILED_FLAG));
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, (0, parcelRequire("iyUAx")).PACKAGE_LOCATION), 'ApolloError: Failed to delete category');
            },
            onCompleted: (onCompletedData)=>{
                markExperienceSuccess();
                if (onCompleted) onCompleted(onCompletedData);
                if (onCompletedData?.deleteJwmCategory?.errors) {
                    showFlag((0, (0, parcelRequire("iyUAx")).DELETE_FAILED_FLAG));
                    return;
                }
                showFlag((0, (0, parcelRequire("iyUAx")).DELETE_SUCCESS_FLAG));
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("iyUAx")).QUERY_NAME)} succeeded`);
            }
        });
        const deleteCategory = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, optionId: optionId })=>{
            startExperience();
            const response = await deleteJwmCategory({
                variables: {
                    input: {
                        projectId: projectId,
                        issueTypeId: issueTypeId,
                        optionId: optionId
                    }
                }
            });
            const result = response?.data?.deleteJwmCategory;
            if (result?.success) return true;
            return false;
        }, [
            deleteJwmCategory,
            projectId,
            startExperience
        ]);
        const mutationBadRequestError = (0, $5uXOq.useMemo)(()=>data?.deleteJwmCategory?.errors?.find((e)=>e.message), [
            data
        ]);
        return {
            error: error || mutationBadRequestError,
            data: data,
            loading: loading,
            deleteCategory: deleteCategory
        };
    };
});
parcelRegister("iyUAx", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_LOCATION", ()=>$58fe877000abe9fc$export$7ec1427613e4cea);
    $parcel$export(module.exports, "DELETE_FAILED_FLAG", ()=>$58fe877000abe9fc$export$73026709962f2ff);
    $parcel$export(module.exports, "DELETE_SUCCESS_FLAG", ()=>$58fe877000abe9fc$export$b4ec21d91832b908);
    $parcel$export(module.exports, "QUERY_NAME", ()=>$58fe877000abe9fc$export$a93d8cd30a94ee3a);
    var $gzbtb;
    const $58fe877000abe9fc$export$7ec1427613e4cea = 'jira-business.categories.src.services.delete-category';
    const $58fe877000abe9fc$export$73026709962f2ff = {
        type: 'error',
        title: (0, (0, parcelRequire("gzbtb")).default).deleteErrorTitle,
        description: (0, (0, parcelRequire("gzbtb")).default).deleteErrorMessage,
        messageType: 'transactional'
    };
    const $58fe877000abe9fc$export$b4ec21d91832b908 = {
        type: 'success',
        title: (0, (0, parcelRequire("gzbtb")).default).deleteSuccessTitle,
        description: (0, (0, parcelRequire("gzbtb")).default).deleteSuccessMessage,
        messageType: 'transactional'
    };
    const $58fe877000abe9fc$export$a93d8cd30a94ee3a = 'deleteJwmCategory';
});
parcelRegister("gzbtb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ffa0dde618c2f18$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1ffa0dde618c2f18$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteErrorTitle: {
            "id": "business-categories.services.delete-category.delete-error-title",
            "defaultMessage": "We couldn't delete the category"
        },
        deleteErrorMessage: {
            "id": "business-categories.services.delete-category.delete-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        deleteSuccessTitle: {
            "id": "business-categories.services.delete-category.delete-success-title",
            "defaultMessage": "Category deleted"
        },
        deleteSuccessMessage: {
            "id": "business-categories.services.delete-category.delete-success-message",
            "defaultMessage": "Category has been deleted from your business project."
        }
    });
});
parcelRegister("77qU8", function(module, exports) {
    $parcel$export(module.exports, "DELETE_JIRA_BUSINESS_CATEGORY", ()=>$ed174276a5198c68$export$1117beef9815e76c);
    var $5cllN;
    const $ed174276a5198c68$export$1117beef9815e76c = (0, (0, parcelRequire("5cllN")).default)`
  mutation DeleteJwmCategory($input: JWMDeleteCategoryInput!) {
    deleteJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
    }
  }
`;
});
parcelRegister("bPi86", function(module, exports) {
    $parcel$export(module.exports, "useUpdateCategory", ()=>$8abe70ef9e503944$export$89393e180ebe9dba);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $cm8b5;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $bLYBp;
    var $imjuR;
    const $8abe70ef9e503944$export$89393e180ebe9dba = ({ experience: experience, onCompleted: onCompleted })=>{
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experience);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experience);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectId = String(project.id);
        const [updateCategory, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("imjuR")).UPDATE_CATEGORY), {
            onError: (apolloError)=>{
                markExperienceFailed(`${experience.experience} category service error handling`, apolloError);
                showFlag((0, (0, parcelRequire("bLYBp")).UPDATE_FAILED_FLAG));
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmUpdateCategory',
                        packageName: 'jiraBusinessCategories',
                        teamName: 'jira-warepil'
                    },
                    attributes: {
                        message: 'Failed to update category'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (onCompletedData)=>{
                if (onCompletedData?.updateJwmCategory?.errors) {
                    showFlag((0, (0, parcelRequire("bLYBp")).UPDATE_FAILED_FLAG));
                    return;
                }
                markExperienceSuccess();
                showFlag((0, (0, parcelRequire("bLYBp")).UPDATE_SUCCESS_FLAG));
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("bLYBp")).QUERY_NAME)} succeeded`);
                if (onCompleted) onCompleted(onCompletedData);
            }
        });
        const update = (0, $5uXOq.useCallback)(async ({ issueTypeId: issueTypeId, optionId: optionId, value: value, color: color })=>{
            startExperience();
            const response = await updateCategory({
                variables: {
                    input: {
                        projectId: projectId,
                        issueTypeId: issueTypeId,
                        optionId: optionId,
                        value: value,
                        color: color
                    }
                }
            });
            const result = response?.data?.updateJwmCategory;
            if (result?.success) {
                if (result.category) return result.category;
            }
            return null;
        }, [
            startExperience,
            updateCategory,
            projectId
        ]);
        const mutationBadRequestError = (0, $5uXOq.useMemo)(()=>data?.updateJwmCategory?.errors?.find((e)=>e.message), [
            data
        ]);
        return {
            error: error || mutationBadRequestError,
            data: data,
            loading: loading,
            updateCategory: update
        };
    };
});
parcelRegister("bLYBp", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_FAILED_FLAG", ()=>$a7944c290a9fef53$export$ce554ac3b5c50c57);
    $parcel$export(module.exports, "UPDATE_SUCCESS_FLAG", ()=>$a7944c290a9fef53$export$4780917480343dea);
    $parcel$export(module.exports, "QUERY_NAME", ()=>$a7944c290a9fef53$export$a93d8cd30a94ee3a);
    var $gbPvu;
    const $a7944c290a9fef53$export$7ec1427613e4cea = 'jira-business.categories.src.services.update-category';
    const $a7944c290a9fef53$export$ce554ac3b5c50c57 = {
        type: 'error',
        title: (0, (0, parcelRequire("gbPvu")).default).updateErrorTitle,
        description: (0, (0, parcelRequire("gbPvu")).default).updateErrorMessage,
        messageType: 'transactional'
    };
    const $a7944c290a9fef53$export$4780917480343dea = {
        type: 'success',
        title: (0, (0, parcelRequire("gbPvu")).default).updateSuccessTitle,
        description: (0, (0, parcelRequire("gbPvu")).default).updateSuccessMessage,
        messageType: 'transactional'
    };
    const $a7944c290a9fef53$export$a93d8cd30a94ee3a = 'jwmUpdateCategory';
});
parcelRegister("gbPvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfc86e442988f8be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bfc86e442988f8be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateErrorTitle: {
            "id": "business-categories.services.update-category.update-error-title",
            "defaultMessage": "We couldn't update the category"
        },
        updateErrorMessage: {
            "id": "business-categories.services.update-category.update-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        updateSuccessTitle: {
            "id": "business-categories.services.update-category.update-success-title",
            "defaultMessage": "Category updated"
        },
        updateSuccessMessage: {
            "id": "business-categories.services.update-category.update-success-message",
            "defaultMessage": "Category has been updated successfully."
        }
    });
});
parcelRegister("imjuR", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORY", ()=>$7d152b99758b43ea$export$95f0050ef87b4d2c);
    var $5cllN;
    var $cNu0r;
    const $7d152b99758b43ea$export$95f0050ef87b4d2c = (0, (0, parcelRequire("5cllN")).default)`
  mutation JwmUpdateCategory($input: JWMUpdateCategoryInput!) {
    updateJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
      category {
        ...JwmCategoryOptionsFragment
      }
    }
  }
  ${(0, (0, parcelRequire("cNu0r")).JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
});
parcelRegister("lnCtA", function(module, exports) {
    $parcel$export(module.exports, "KNOWN_ERROR_MESSAGE", ()=>$93467720d58c9bc8$export$b1ecc86f640c9cfe);
    $parcel$export(module.exports, "CATEGORY_NAME_ALREADY_EXISTS_ERROR_MESSAGE", ()=>$93467720d58c9bc8$export$4d51e3539367ec13);
    $parcel$export(module.exports, "CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG", ()=>$93467720d58c9bc8$export$e4ea5893185263d8);
    var $hqdlT;
    const $93467720d58c9bc8$export$b1ecc86f640c9cfe = 'It is not on the appropriate screen, or unknown.';
    const $93467720d58c9bc8$export$4d51e3539367ec13 = 'Category with the same name exists';
    const $93467720d58c9bc8$export$e4ea5893185263d8 = {
        type: 'error',
        title: (0, (0, parcelRequire("hqdlT")).default).categoryNameAlreadyExists,
        messageType: 'transactional'
    };
});
parcelRegister("hqdlT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd0893495adf500d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd0893495adf500d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        knownErrorNonAdminTitle: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-title",
            "defaultMessage": "Error editing this field"
        },
        knownErrorNonAdminDescription: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-description",
            "defaultMessage": "You\u2019ll either need edit permissions, or the project admin will need to add the category field to this issue type. To learn more, speak to your project admin."
        },
        knownErrorAdminTitle: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-title",
            "defaultMessage": "To edit this field you\u2019ll need to go to project settings and add the category field to this issue type."
        },
        knownErrorAdminCta: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-cta",
            "defaultMessage": "Go to project settings"
        },
        networkErrorTitle: {
            "id": "business-categories.controllers.category-cell-state-controller.network-error-title",
            "defaultMessage": "An unexpected error occurred. Check your network connection, then refresh your page to try again."
        },
        genericErrorTitle: {
            "id": "business-categories.controllers.category-cell-state-controller.generic-error-title",
            "defaultMessage": "An unexpected error occurred. Wait a few moments, then refresh your page to try again."
        },
        createdCategoryNameCantBeEmpty: {
            "id": "business-categories.controllers.category-cell-state-controller.created-category-name-cant-be-empty",
            "defaultMessage": "Categories can\u2019t be left blank. To create a category, give it a name."
        },
        renamedCategoryCantBeEmpty: {
            "id": "business-categories.controllers.category-cell-state-controller.renamed-category-cant-be-empty",
            "defaultMessage": "Categories can\u2019t be left blank. To rename a category, give it a name."
        },
        categoryNameAlreadyExists: {
            "id": "business-categories.controllers.category-cell-state-controller.category-name-already-exists",
            "defaultMessage": "The name you\u2019ve selected for this category already exists. Try a new name."
        },
        knownErrorNonAdminDescriptionIssueTermRefresh: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-non-admin-description-issue-term-refresh",
            "defaultMessage": "You\u2019ll either need edit permissions, or the project admin will need to add the category field to this work type. To learn more, speak to your project admin."
        },
        knownErrorAdminTitleIssueTermRefresh: {
            "id": "business-categories.controllers.category-cell-state-controller.known-error-admin-title-issue-term-refresh",
            "defaultMessage": "To edit this field you\u2019ll need to go to project settings and add the category field to this work type."
        }
    });
});
parcelRegister("kzvKj", function(module, exports) {
    $parcel$export(module.exports, "getSaveValueErrorFlag", ()=>$c765599d0c6c0ffc$export$e5c7668e936e16e1);
    var $6s1PB;
    var $lnCtA;
    var $hqdlT;
    const $c765599d0c6c0ffc$export$e5c7668e936e16e1 = (error, isAdminOrProjectAdmin, onOpenSettings)=>{
        const errorMessage = error.errors?.find((e)=>e.error)?.error;
        const isKnownErrorMessage = errorMessage && errorMessage.includes((0, (0, parcelRequire("lnCtA")).KNOWN_ERROR_MESSAGE));
        const FLAG = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $c765599d0c6c0ffc$export$a6efb19cdceab88f : $c765599d0c6c0ffc$export$674d6632095d387f;
        if (error.statusCode === 400 && isKnownErrorMessage) return isAdminOrProjectAdmin ? $c765599d0c6c0ffc$export$3510136e72b8218b({
            onOpenSettings: onOpenSettings
        }) : FLAG;
        if (error.statusCode) return $c765599d0c6c0ffc$export$a077289c8607d69d;
        return $c765599d0c6c0ffc$export$bbdfcd88a11759b1;
    };
    const $c765599d0c6c0ffc$export$674d6632095d387f = {
        type: 'error',
        title: (0, (0, parcelRequire("hqdlT")).default).knownErrorNonAdminTitle,
        description: (0, (0, parcelRequire("hqdlT")).default).knownErrorNonAdminDescription,
        messageType: 'transactional'
    };
    const $c765599d0c6c0ffc$export$a6efb19cdceab88f = {
        type: 'error',
        title: (0, (0, parcelRequire("hqdlT")).default).knownErrorNonAdminTitle,
        description: (0, (0, parcelRequire("hqdlT")).default).knownErrorNonAdminDescriptionIssueTermRefresh,
        messageType: 'transactional'
    };
    const $c765599d0c6c0ffc$export$3510136e72b8218b = ({ onOpenSettings: onOpenSettings })=>({
            type: 'error',
            title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("hqdlT")).default).knownErrorAdminTitleIssueTermRefresh : (0, (0, parcelRequire("hqdlT")).default).knownErrorAdminTitle,
            actions: [
                {
                    content: (0, (0, parcelRequire("hqdlT")).default).knownErrorAdminCta,
                    onClick: onOpenSettings
                }
            ],
            messageType: 'transactional'
        });
    const $c765599d0c6c0ffc$export$a077289c8607d69d = {
        type: 'error',
        title: (0, (0, parcelRequire("hqdlT")).default).genericErrorTitle,
        messageType: 'transactional'
    };
    const $c765599d0c6c0ffc$export$bbdfcd88a11759b1 = {
        type: 'error',
        title: (0, (0, parcelRequire("hqdlT")).default).networkErrorTitle,
        messageType: 'transactional'
    };
});
parcelRegister("b5lmY", function(module, exports) {
    $parcel$export(module.exports, "WrapperCommon", ()=>$f10e7d989c7a367e$export$2cd335d97b9054d6);
    $parcel$export(module.exports, "CellWrapper", ()=>$f10e7d989c7a367e$export$4812fadef83edffe);
    $parcel$export(module.exports, "TextCellWrapper", ()=>$f10e7d989c7a367e$export$aea2b0ba32a5c9ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $f10e7d989c7a367e$export$2cd335d97b9054d6 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f10e7d989c7a367e$var$wrapperCommonStyles
        }, props.children);
    const $f10e7d989c7a367e$export$4812fadef83edffe = ({ isEditable: isEditable, testId: testId, children: children, hasPadding: hasPadding = true, ariaLabel: ariaLabel, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $f10e7d989c7a367e$var$wrapperCommonStyles,
                $f10e7d989c7a367e$var$cellWrapperStyles,
                isEditable && $f10e7d989c7a367e$var$editableCellWrapperStyles,
                hasPadding && $f10e7d989c7a367e$var$cellWrapperPaddingStyles
            ],
            testId: testId,
            "aria-label": ariaLabel,
            onCut: onCut,
            onCopy: onCopy,
            onPaste: onPaste
        }, children);
    const $f10e7d989c7a367e$export$aea2b0ba32a5c9ab = ({ isEditable: isEditable, testId: testId, ariaLabel: ariaLabel, children: children, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $f10e7d989c7a367e$var$textCellWrapperStyles,
                isEditable && $f10e7d989c7a367e$var$editableTextCellWrapperStyles
            ],
            testId: testId,
            "aria-label": ariaLabel,
            onCut: onCut,
            onCopy: onCopy,
            onPaste: onPaste
        }, children);
    const $f10e7d989c7a367e$var$wrapperCommonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        outline: 'none'
    });
    const $f10e7d989c7a367e$var$cellWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'border-box',
        borderRadius: 'border.radius'
    });
    const $f10e7d989c7a367e$var$cellWrapperPaddingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.100'
    });
    const $f10e7d989c7a367e$var$editableCellWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'pointer'
    });
    const $f10e7d989c7a367e$var$textCellWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        outline: 'none',
        paddingTop: 'space.0',
        paddingBottom: 'space.0',
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        form: {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            '[data-ds--text-field--input]': {
                height: '100%',
                outline: 'none'
            },
            '[data-ds--text-field--container], [data-ds--text-field--container]:focus-within': {
                outline: 'none',
                boxShadow: 'none',
                border: 'none'
            }
        },
        span: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    });
    const $f10e7d989c7a367e$var$editableTextCellWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'text'
    });
});
parcelRegister("e0a4D", function(module, exports) {
    $parcel$export(module.exports, "FixItErrorFlag", ()=>$ebb64575ccac1f6b$export$68221e9bb70731fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $daQYX;
    var $2AOGO;
    var $6s1PB;
    var $jJZqs;
    var $LJaTB;
    var $pa9q9;
    var $koVbs;
    var $8tf7c;
    var $8zOmE;
    var $2NMNM;
    var $fvbnb;
    const $ebb64575ccac1f6b$export$68221e9bb70731fc = ({ error: error, title: title, description: description, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName })=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        if (project.isSimplified) {
            const ASSOCIATION_OR_PERMISSION_ERROR = `Field '${fieldId}' cannot be set. It is not on the appropriate screen, or unknown.`;
            const errorMessage = error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) ? error.errors && error.errors[0] && error.errors[0].error || error.message : String(error);
            const isFixitError = errorMessage?.includes(ASSOCIATION_OR_PERMISSION_ERROR);
            const isEditPermissionError = isFixitError && !project.permissions.editIssues;
            if (isEditPermissionError) return (0, ($parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$EditPermissionErrorFlag, null);
            if (isFixitError) return (0, ($parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$FieldAssociationErrorFlag, {
                issueType: issueType,
                fieldName: fieldName,
                fieldId: fieldId,
                projectId: project.id,
                issueTypeId: issueTypeId,
                isAdmin: project.permissions.administerProject
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8tf7c")).ErrorFlag), {
            error: error,
            title: title,
            description: description
        });
    };
    const $ebb64575ccac1f6b$var$EditPermissionErrorFlag = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'editPermissionErrorFlag');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
            flag: {
                type: 'warning',
                title: formatMessage((0, (0, parcelRequire("fvbnb")).default).editPermissionErrorTitle),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("fvbnb")).default).editPermissionErrorAction),
                        href: '/secure/ContactAdministrators!default.jspa',
                        target: '_blank',
                        onClick: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromEditPermissionFlag');
                        }
                    }
                ]
            }
        });
    };
    const $ebb64575ccac1f6b$var$FieldAssociationErrorFlag = ({ fieldId: fieldId, fieldName: fieldName, issueType: issueType, projectId: projectId, issueTypeId: issueTypeId, isAdmin: isAdmin })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { associate: associate } = (0, (0, parcelRequire("2AOGO")).useAssociateField)();
        const { dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [shouldAssociate, setShouldAssociate] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const dismissPreviousFlags = (0, $5uXOq.useRef)(true);
        const FIXIT_ERROR_FLAG_ID = `FIXIT_ERROR_FLAG_FOR_${issueTypeId}_${fieldId}`;
        (0, $5uXOq.useEffect)(()=>{
            if (shouldAssociate) {
                setShouldAssociate(false);
                associate({
                    input: {
                        projectId: String(projectId),
                        fieldId: fieldId,
                        issueTypeIds: [
                            Number(issueTypeId)
                        ]
                    },
                    fieldName: fieldName,
                    issueType: issueType,
                    showSuccess: true,
                    analyticsAttributes: {
                        source: 'business-fields.common.ui.fixit-error-flag'
                    }
                }).catch(()=>{});
            }
        }, [
            associate,
            fieldId,
            fieldName,
            issueType,
            issueTypeId,
            projectId,
            shouldAssociate
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'fixItErrorFlag');
        }, [
            createAnalyticsEvent
        ]);
        const actions = isAdmin ? [
            {
                content: formatMessage((0, (0, parcelRequire("fvbnb")).default).updateFieldAssociationAction),
                onClick: async ()=>{
                    if (projectId) {
                        dismissFlag(FIXIT_ERROR_FLAG_ID);
                        setShouldAssociate(true);
                    }
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'associateFieldFromFixItFlag');
                }
            }
        ] : [
            {
                content: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fvbnb")).default).editIssueTypesPermissionErrorActionIssueTermRefresh : (0, (0, parcelRequire("fvbnb")).default).editIssueTypesPermissionErrorAction),
                href: '/secure/ContactAdministrators!default.jspa',
                target: '_blank',
                onClick: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromFixitFlag');
                }
            }
        ];
        if (dismissPreviousFlags.current) {
            dismissFlag(FIXIT_ERROR_FLAG_ID);
            dismissPreviousFlags.current = false;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
            flag: {
                id: FIXIT_ERROR_FLAG_ID,
                type: 'warning',
                title: [
                    (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fvbnb")).default).editAssociationErrorTitleIssueTermRefresh : (0, (0, parcelRequire("fvbnb")).default).editAssociationErrorTitle,
                    {
                        fieldName: fieldName,
                        issueType: issueType,
                        normal: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ebb64575ccac1f6b$var$FlagMessageWrapper, null, chunks),
                        strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                                as: "strong"
                            }, chunks)
                    }
                ],
                actions: actions
            }
        });
    };
    const $ebb64575ccac1f6b$var$FlagMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1nn1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2AOGO", function(module, exports) {
    $parcel$export(module.exports, "useAssociateField", ()=>$bda9e90d453c18dd$export$b4b274ed0d9c5388);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $388MD;
    var $jFfcO;
    var $6s1PB;
    var $7HGHK;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $ceIBL;
    var $6N6hk;
    var $d44vd;
    const $bda9e90d453c18dd$export$c18a1e642576984f = (0, (0, parcelRequire("7HGHK")).toFlagId)('associate-field-error-flag');
    const $bda9e90d453c18dd$export$5122d1806ca6643c = (0, (0, parcelRequire("7HGHK")).toFlagId)('associate-field-success-flag');
    const $bda9e90d453c18dd$export$a2a68c9b88c306f0 = (0, (0, parcelRequire("7HGHK")).toFlagId)('refetch-fields-error-flag');
    const $bda9e90d453c18dd$export$b4b274ed0d9c5388 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { associate: associate, loading: loading, error: error } = (0, (0, parcelRequire("ceIBL")).useAssociateField)();
        const { refetchFields: refetchFields } = (0, (0, parcelRequire("388MD")).useRefetchFields)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ associateQueue: associateQueue }, { setAssociateQueue: setAssociateQueue, associate: associateStore, addToAssociateQueue: addToAssociateQueue }] = (0, (0, parcelRequire("6N6hk")).useAssociateFieldStore)();
        const associateField = (0, $5uXOq.useCallback)(({ input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess = false, analyticsAttributes: analyticsAttributes })=>new Promise((resolve, reject)=>{
                addToAssociateQueue({
                    resolve: resolve,
                    reject: reject,
                    fieldProps: {
                        input: input,
                        fieldName: fieldName,
                        issueType: issueType,
                        showSuccess: showSuccess,
                        analyticsAttributes: analyticsAttributes
                    }
                });
            }), [
            addToAssociateQueue
        ]);
        const associateNextInQueue = (0, $5uXOq.useCallback)(async ()=>{
            if (associateQueue.length === 0) return;
            const [{ resolve: resolve, reject: reject, fieldProps: { input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess, analyticsAttributes: analyticsAttributes = {} } }] = associateQueue;
            setAssociateQueue(associateQueue.splice(1));
            dismissFlag(`${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}`);
            dismissFlag(`${$bda9e90d453c18dd$export$a2a68c9b88c306f0}-${input.fieldId}`);
            const result = await associate({
                input: input
            });
            if (!result?.data?.jira?.jwmAssociateField?.success) {
                showFlag({
                    id: `${$bda9e90d453c18dd$export$c18a1e642576984f}-${input.fieldId}`,
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("d44vd")).default).associateFieldErrorTitleV2IssueTermRefresh : (0, (0, parcelRequire("d44vd")).default).associateFieldErrorTitleV2, {
                        fieldName: fieldName
                    }),
                    description: (0, (0, parcelRequire("d44vd")).default).associateFieldErrorMessageV2,
                    actions: [
                        {
                            content: (0, (0, parcelRequire("d44vd")).default).associateFieldTryAgainAction,
                            onClick: ()=>{
                                associateField({
                                    input: input,
                                    fieldName: fieldName,
                                    issueType: issueType,
                                    showSuccess: showSuccess,
                                    analyticsAttributes: analyticsAttributes
                                });
                            }
                        }
                    ]
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'associate failed', analyticsAttributes);
                reject(new Error('Associate field mutation did not succeed'));
                return;
            }
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', analyticsAttributes);
            if (showSuccess) showFlag({
                id: $bda9e90d453c18dd$export$5122d1806ca6643c,
                type: 'success',
                title: (0, (0, parcelRequire("d44vd")).default).successTitle,
                description: [
                    (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("d44vd")).default).successDescriptionIssueTermRefresh : (0, (0, parcelRequire("d44vd")).default).successDescription,
                    {
                        fieldName: fieldName,
                        issueType: issueType,
                        strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                                as: "strong"
                            }, chunks)
                    }
                ]
            });
            try {
                await refetchFields({
                    shouldRetry: ([response])=>!(0, (0, parcelRequire("jFfcO")).isFieldInResponse)({
                            response: response,
                            fieldId: input.fieldId
                        })
                });
            } catch (e) {
                showFlag({
                    id: `${$bda9e90d453c18dd$export$a2a68c9b88c306f0}-${input.fieldId}`,
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("d44vd")).default).refetchFieldsErrorTitleIssueTermRefresh : (0, (0, parcelRequire("d44vd")).default).refetchFieldsErrorTitle, {
                        fieldName: fieldName
                    }),
                    description: (0, (0, parcelRequire("d44vd")).default).refetchFieldsErrorMessage
                });
                reject(e);
                return;
            }
            resolve(result);
        }, [
            associateQueue,
            setAssociateQueue,
            dismissFlag,
            associate,
            createAnalyticsEvent,
            showFlag,
            formatMessage,
            associateField,
            refetchFields
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (associateQueue.length > 0) associateStore(associateNextInQueue);
        }, [
            associateQueue,
            associateNextInQueue,
            associateStore
        ]);
        return {
            associate: associateField,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jFfcO", function(module, exports) {
    $parcel$export(module.exports, "isFieldInResponse", ()=>$d5c202bb1245d36b$export$c323cb8dc752a295);
    const $d5c202bb1245d36b$export$c323cb8dc752a295 = ({ fieldId: fieldId, response: response })=>{
        const field = (response.data.jiraBusinessAvailableFields?.edges ?? []).find((issueTypeEdge)=>issueTypeEdge?.node?.fields?.edges?.find((fieldEdge)=>fieldEdge?.node?.fieldId === fieldId));
        return !!field;
    };
});
parcelRegister("ceIBL", function(module, exports) {
    $parcel$export(module.exports, "useAssociateField", ()=>$e51943b33e758b1d$export$b4b274ed0d9c5388);
    var $5tTFS;
    var $cm8b5;
    var $jcw0u;
    var $eCBf9;
    var $8empw;
    var $ki8aF;
    var $l0lZL;
    const $e51943b33e758b1d$export$a93d8cd30a94ee3a = 'associateJwmFieldMutation';
    const $e51943b33e758b1d$var$findMutationBadRequestError = (data)=>data?.jira?.jwmAssociateField?.errors?.find((e)=>e.message);
    const $e51943b33e758b1d$export$b4b274ed0d9c5388 = ()=>{
        const onExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("ki8aF")).ASSOCIATE_FIELD_EXPERIENCE));
        const onExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("ki8aF")).ASSOCIATE_FIELD_EXPERIENCE));
        const onExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("ki8aF")).ASSOCIATE_FIELD_EXPERIENCE));
        const [associateField, { loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("l0lZL")).QUERY), {
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $e51943b33e758b1d$export$a93d8cd30a94ee3a,
                        packageName: 'jiraBusinessInlineFieldConfigSidebar',
                        teamName: 'deliveroo'
                    },
                    error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                    attributes: {
                        message: 'Failed to associate the field with issue types'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                onExperienceFail('Failed to associate the field with issue types', apolloError);
            },
            onCompleted: (apolloData)=>{
                const mutationBadRequestError = $e51943b33e758b1d$var$findMutationBadRequestError(apolloData);
                if (mutationBadRequestError) {
                    const isClientError = (0, (0, parcelRequire("8empw")).isClientErrorResponse)(mutationBadRequestError.extensions?.statusCode);
                    isClientError ? onExperienceSuccess() : onExperienceFail('Failed to associate the field with issue types', new (0, (0, parcelRequire("eCBf9")).MutationError)(mutationBadRequestError));
                } else onExperienceSuccess();
            }
        });
        const associate = ({ input: input })=>{
            onExperienceStart();
            return associateField({
                variables: {
                    input: input
                }
            });
        };
        return {
            associate: associate,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("8empw", function(module, exports) {
    $parcel$export(module.exports, "isClientErrorResponse", ()=>$356c6d91a785011f$export$fa1f4b2a472e138c);
    const $356c6d91a785011f$export$fa1f4b2a472e138c = (statusCode)=>statusCode && statusCode >= 400 && statusCode < 500 || false;
});
parcelRegister("ki8aF", function(module, exports) {
    $parcel$export(module.exports, "availableFieldTypes", ()=>$f17544388eb6b17d$export$93dbaa9aec3844f0);
    $parcel$export(module.exports, "CREATE_FIELD_EXPERIENCE", ()=>$f17544388eb6b17d$export$9eae0a16f5941351);
    $parcel$export(module.exports, "ASSOCIATE_FIELD_EXPERIENCE", ()=>$f17544388eb6b17d$export$335bd3f229a4665a);
    $parcel$export(module.exports, "DELETE_FIELD_EXPERIENCE", ()=>$f17544388eb6b17d$export$d7cc90452cff4bb3);
    $parcel$export(module.exports, "UPDATE_FIELD_EXPERIENCE", ()=>$f17544388eb6b17d$export$64421f268399035e);
    $parcel$export(module.exports, "GET_FIELDS_CONFIGURATION_EXPERIENCE", ()=>$f17544388eb6b17d$export$88bd6cc0b5f8c349);
    $parcel$export(module.exports, "GET_FIELD_DETAILS_EXPERIENCE", ()=>$f17544388eb6b17d$export$e6582dde0a4e6af7);
    var $5fc53;
    const $f17544388eb6b17d$var$defaultFieldOperations = {
        editable: true,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: true
    };
    const $f17544388eb6b17d$var$operations = {
        ...$f17544388eb6b17d$var$defaultFieldOperations,
        canModifyDefaultValue: false
    };
    const $f17544388eb6b17d$export$93dbaa9aec3844f0 = [
        {
            key: (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
            name: 'Short text',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
            name: 'Paragraph',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
            name: 'Timestamp',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
            name: 'Dropdown',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
            name: 'Date',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
            name: 'Number',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
            name: 'Labels',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
            name: 'Checkbox',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
            name: 'People',
            operations: $f17544388eb6b17d$var$operations
        },
        {
            key: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
            name: 'Url',
            operations: $f17544388eb6b17d$var$operations
        }
    ];
    const $f17544388eb6b17d$export$b8b9d90f9e5bd72b = 'jiraBusinessInlineFieldConfigSidebar';
    const $f17544388eb6b17d$export$9eae0a16f5941351 = {
        experience: 'createField',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
    const $f17544388eb6b17d$export$335bd3f229a4665a = {
        experience: 'associateField',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
    const $f17544388eb6b17d$export$d7cc90452cff4bb3 = {
        experience: 'deleteField',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
    const $f17544388eb6b17d$export$64421f268399035e = {
        experience: 'updateField',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
    const $f17544388eb6b17d$export$88bd6cc0b5f8c349 = {
        experience: 'getFieldsConfiguration',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
    const $f17544388eb6b17d$export$e6582dde0a4e6af7 = {
        experience: 'getFieldDetails',
        packageName: $f17544388eb6b17d$export$b8b9d90f9e5bd72b,
        teamName: 'deliveroo'
    };
});
parcelRegister("l0lZL", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$e534c5bba2da4535$export$2b91517d6d5b4365);
    var $5cllN;
    const $e534c5bba2da4535$export$2b91517d6d5b4365 = (0, (0, parcelRequire("5cllN")).default)`
mutation JwmAssociateField ($input: JiraWorkManagementAssociateFieldInput!) {
  jira {
    jwmAssociateField (input: $input) {
      success
      errors {
        extensions {
          errorType
          statusCode
        }
        message
      }
      associatedIssueTypeIds
    }
  }
}
`;
});
parcelRegister("6N6hk", function(module, exports) {
    $parcel$export(module.exports, "useAssociateFieldStore", ()=>$aface8d3c0a62f76$export$877fa8e9cadf66c8);
    var $3sQ5x;
    var $iXqE5;
    const $aface8d3c0a62f76$var$actions = {
        addAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
                setState({
                    associatingFields: [
                        ...getState().associatingFields,
                        fieldId
                    ]
                });
            },
        removeAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
                setState({
                    associatingFields: getState().associatingFields.filter((assocFieldId)=>fieldId !== assocFieldId)
                });
            },
        setAssociateQueue: (associateQueue)=>({ setState: setState })=>{
                setState({
                    associateQueue: associateQueue
                });
            },
        addToAssociateQueue: (itemToAssociate)=>({ setState: setState, getState: getState })=>{
                setState({
                    associateQueue: [
                        ...getState().associateQueue,
                        itemToAssociate
                    ]
                });
            },
        setIsAssociating: (isAssociating)=>({ setState: setState })=>{
                setState({
                    isAssociating: isAssociating
                });
            },
        associate: (associateFunction)=>async ({ setState: setState, getState: getState })=>{
                if (!getState().isAssociating) {
                    setState({
                        isAssociating: true
                    });
                    try {
                        await associateFunction();
                    } finally{
                        setState({
                            isAssociating: false
                        });
                    }
                }
            }
    };
    const $aface8d3c0a62f76$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            associatingFields: [],
            associateQueue: [],
            isAssociating: false
        },
        actions: $aface8d3c0a62f76$var$actions,
        name: 'JwmFieldConfigAssociatingFields'
    });
    const $aface8d3c0a62f76$export$877fa8e9cadf66c8 = (0, (0, parcelRequire("3sQ5x")).createHook)($aface8d3c0a62f76$var$Store);
});
parcelRegister("d44vd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adc3ae8cb1b6f08f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $adc3ae8cb1b6f08f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        associateFieldErrorTitleV2: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2",
            "defaultMessage": "Unable to connect {fieldName} to issue types in this project"
        },
        associateFieldErrorMessageV2: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-message-v-2",
            "defaultMessage": "Check your connection, then try again."
        },
        associateFieldTryAgainAction: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-try-again-action",
            "defaultMessage": "Try again"
        },
        refetchFieldsErrorTitle: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title",
            "defaultMessage": "{fieldName} has been associated to issue types in the list view"
        },
        refetchFieldsErrorMessage: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-message",
            "defaultMessage": "Wait a few moments and try refreshing your page to see the change."
        },
        successTitle: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.success-title",
            "defaultMessage": "Field association updated!"
        },
        successDescription: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description",
            "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for your <strong>{issueType}</strong> issue type"
        },
        associateFieldErrorTitleV2IssueTermRefresh: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2-issue-term-refresh",
            "defaultMessage": "Unable to connect {fieldName} to work types in this project"
        },
        refetchFieldsErrorTitleIssueTermRefresh: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title-issue-term-refresh",
            "defaultMessage": "{fieldName} has been associated to work types in the list view"
        },
        successDescriptionIssueTermRefresh: {
            "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description-issue-term-refresh",
            "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for a <strong>{issueType}</strong>"
        }
    });
});
parcelRegister("fvbnb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ca24c5034e4757b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0ca24c5034e4757b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editAssociationErrorTitle: {
            "id": "business-fields.common.fixit-error-flag.edit-association-error-title",
            "defaultMessage": "<normal><strong>{fieldName}</strong> is not associated to the <strong>{issueType}</strong> issue type</normal>"
        },
        updateFieldAssociationAction: {
            "id": "business-fields.common.fixit-error-flag.update-field-association-action",
            "defaultMessage": "Update field association"
        },
        editPermissionErrorTitle: {
            "id": "business-fields.common.fixit-error-flag.edit-permission-error-title",
            "defaultMessage": "You do not have permission to edit in this project"
        },
        editPermissionErrorAction: {
            "id": "business-fields.common.fixit-error-flag.edit-permission-error-action",
            "defaultMessage": "Contact your project admin"
        },
        editIssueTypesPermissionErrorAction: {
            "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action",
            "defaultMessage": "Contact your project admin to edit issue types"
        },
        editAssociationErrorTitleIssueTermRefresh: {
            "id": "business-fields.common.fixit-error-flag.edit-association-error-title-issue-term-refresh",
            "defaultMessage": "<normal><strong>{fieldName}</strong> isn't associated with a <strong>{issueType}</strong>.</normal>"
        },
        editIssueTypesPermissionErrorActionIssueTermRefresh: {
            "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action-issue-term-refresh",
            "defaultMessage": "Contact your project admin to edit work types"
        }
    });
});
parcelRegister("dSjBh", function(module, exports) {
    $parcel$export(module.exports, "CategoryCellContent", ()=>$56d35fac8f7fcd7a$export$acfc5fe93bbbc6de);
    var $5uXOq = parcelRequire("5uXOq");
    var $DhnKp;
    var $k2xO1;
    const $56d35fac8f7fcd7a$export$acfc5fe93bbbc6de = ({ categoryState: categoryState, isEditable: isEditable, onClick: onClick })=>{
        if (!categoryState) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
            onClick: onClick,
            isEditable: isEditable,
            "data-testid": "business-list.ui.list-view.category-cell.category-cell-content.no-category-wrapper"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
            onClick: onClick,
            isEditable: isEditable,
            "data-testid": "business-list.ui.list-view.category-cell.category-cell-content.category-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("DhnKp")).default), {
            categoryColor: categoryState.color?.toString() ?? null,
            categoryName: categoryState.value ?? ''
        }));
    };
});
parcelRegister("k2xO1", function(module, exports) {
    $parcel$export(module.exports, "TagListWrapper", ()=>$34393a02d8ac31b7$export$e4f5eab7c40840c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $4R6GH;
    var $9Llqt;
    const $34393a02d8ac31b7$var$conditionalStyle = (styleAttr)=>{
        return (0, (0, parcelRequire("4R6GH")).fg)('jira_list_checkbox_convert_to_pressable') ? styleAttr : 'unset';
    };
    const $34393a02d8ac31b7$var$conditionalStyleWidth = ()=>{
        return (0, (0, parcelRequire("4R6GH")).fg)('single_select_popup_width_adjustment') ? '100%' : '100%,';
    };
    const $34393a02d8ac31b7$export$e4f5eab7c40840c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFocused: isFocused, isEditable: isEditable, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16fvj7w": (0, (0, parcelRequire("lD23V")).default)($34393a02d8ac31b7$var$conditionalStyleWidth()),
                "--_1uzc8vy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("9Llqt")).SELECTED_CELL_BOX_SHADOW)),
                "--_1d9o9fi": (0, (0, parcelRequire("lD23V")).default)($34393a02d8ac31b7$var$conditionalStyle('1.5')),
                "--_7knbem": (0, (0, parcelRequire("lD23V")).default)($34393a02d8ac31b7$var$conditionalStyle("var(--ds-font-body, 14px)"))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11vw1qnq _1e0c1txw _4cvr1h6o _1bsb9td3 _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _1n261q9c _1reo15vq _18m915vq _1yt41cy0 _o5721q9c _11c814nh _vwz410kt _hc7q15vq _njtz15vq _p7r1116y",
                __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
                __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
                __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9Llqt", function(module, exports) {
    $parcel$export(module.exports, "SELECTED_CELL_BOX_SHADOW", ()=>$ddd90f161976f576$export$e643c5fb607dbcc5);
    $parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", ()=>$ddd90f161976f576$export$258441c8a79bb589);
    const $ddd90f161976f576$export$95bfdfec8f6b837d = 2;
    const $ddd90f161976f576$export$e643c5fb607dbcc5 = `0 0 0 ${$ddd90f161976f576$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`} inset`;
    const $ddd90f161976f576$export$258441c8a79bb589 = 40;
    const $ddd90f161976f576$export$3e36baaa5cb0cfb5 = [
        0,
        -$ddd90f161976f576$export$258441c8a79bb589
    ];
});
parcelRegister("3aLMK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efa1d55d3f04cd7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $efa1d55d3f04cd7e$var$LazyDeleteCategoryModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4reir")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/category-cell/delete-category-modal/main.tsx"
    });
    var $efa1d55d3f04cd7e$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "delete-category-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($efa1d55d3f04cd7e$var$LazyDeleteCategoryModal, props));
});
parcelRegister("4reir", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ei1uC")
    ]).then(()=>parcelRequire('dyQ1C'));
});
parcelRegister("gvQOt", function(module, exports) {
    $parcel$export(module.exports, "EditCategoryCell", ()=>$9ae93109dcf682a6$export$a89ef86139e07798);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $1I7E8;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $dKy4F;
    var $2uW5h;
    var $daQYX;
    var $jRzRt;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $5fc53;
    var $eTDjN;
    var $6du7W;
    var $lI995;
    var $1pa56;
    var $bqVq1;
    var $jGpUV;
    const $9ae93109dcf682a6$export$494249755a84b147 = (field)=>field != null && field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE);
    const $9ae93109dcf682a6$var$isReadOnlyArray = (param)=>Array.isArray(param);
    const $9ae93109dcf682a6$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $9ae93109dcf682a6$var$POPUP_OFFSET = (0, (0, parcelRequire("eTDjN")).LIST_FIELD_POPUP_OFFSET);
    const $9ae93109dcf682a6$var$POPUP_OFFSET_NEW = [
        0,
        -(0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $9ae93109dcf682a6$export$a89ef86139e07798 = ({ width: width, issueTypeId: issueTypeId, categoryState: categoryState, categoryOptions: categoryOptions, triggerContent: triggerContent, setCategoryToDeleteInModal: setCategoryToDeleteInModal, onCategoryCellValueChange: onCategoryCellValueChange, onCategoryUpdate: onCategoryUpdate, onCategoryCreate: onCategoryCreate, onClose: onClose, wrapperRef: wrapperRef, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
        const [defaultCategoryOptions, setDefaultCategoryOptions] = (0, $5uXOq.useState)(categoryOptions);
        const [editCategoryCellState, setEditCategoryCellState] = (0, $5uXOq.useState)({
            status: 'idle'
        });
        const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const hasAdminPermission = project.permissions.administerProject;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isCreateOptionFocused = (0, $5uXOq.useRef)(false);
        const onPopupClose = (0, $5uXOq.useCallback)((event)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') || !event || !(event.target instanceof HTMLElement && triggerRef && event.target.contains(triggerRef))) {
                onClose();
                setEditCategoryCellState({
                    status: 'idle'
                });
                wrapperRef && setTimeout(()=>{
                    wrapperRef?.current?.focus();
                }, 0);
            }
        }, [
            onClose,
            wrapperRef,
            triggerRef
        ]);
        const searchCategories = (0, $5uXOq.useCallback)((query = '')=>{
            const filteredCategories = categoryOptions.filter((categoryOption)=>categoryOption?.label.toLowerCase().startsWith(query.toLowerCase()));
            return Promise.resolve(filteredCategories);
        }, [
            categoryOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setDefaultCategoryOptions(categoryOptions);
        }, [
            categoryOptions
        ]);
        const loadOptionsDebounced = (0, $5uXOq.useCallback)((...args)=>{
            const debounced = (0, ($parcel$interopDefault($lFKmC)))(searchCategories, $9ae93109dcf682a6$var$LOAD_OPTIONS_DEBOUNCE_TIMER, {
                leading: true
            });
            return debounced(...args);
        }, [
            searchCategories
        ]);
        const showErrorFlag = (0, $5uXOq.useCallback)(()=>{
            showFlag({
                id: (0, (0, parcelRequire("1pa56")).CREATE_CATEGORY_ERROR_FLAG_ID),
                render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1pa56")).default), null)
            });
        }, [
            showFlag
        ]);
        const handleChange = (0, $5uXOq.useCallback)((newOption)=>{
            if ($9ae93109dcf682a6$var$isReadOnlyArray(newOption)) return;
            const isValueEqual = newOption?.value === categoryState?.optionId;
            if (isValueEqual || editCategoryCellState.status !== 'idle') return;
            onCategoryCellValueChange(newOption ? {
                optionId: newOption.value,
                value: newOption.label,
                color: newOption.color
            } : null);
            onPopupClose();
        }, [
            categoryState?.optionId,
            editCategoryCellState.status,
            onCategoryCellValueChange,
            onPopupClose
        ]);
        const updateEditingCategory = (0, $5uXOq.useCallback)((categoryLabel, categoryValue, categoryColor)=>{
            setEditCategoryCellState({
                status: 'updating-category',
                categoryName: categoryLabel ?? '',
                categoryOptionId: categoryValue ?? '',
                categoryColor: categoryColor ?? null
            });
        }, []);
        const handleCreate = (0, $5uXOq.useCallback)((categoryName)=>{
            if (!hasAdminPermission) {
                showErrorFlag();
                return;
            }
            setEditCategoryCellState({
                status: 'creating-category',
                categoryToBeCreated: categoryName
            });
        }, [
            hasAdminPermission,
            showErrorFlag
        ]);
        const onNewCategoryFormSubmit = (0, $5uXOq.useCallback)((newCategory)=>{
            onCategoryCreate(newCategory.categoryName, newCategory.categoryColor);
            onPopupClose();
            setEditCategoryCellState({
                status: 'idle'
            });
        }, [
            onCategoryCreate,
            onPopupClose
        ]);
        const onEditCategoryFormSubmit = (0, $5uXOq.useCallback)((updatedCategory)=>{
            if (editCategoryCellState.status === 'updating-category') {
                onCategoryUpdate({
                    optionId: editCategoryCellState.categoryOptionId,
                    newCategoryName: updatedCategory.categoryName,
                    newCategoryColor: updatedCategory.categoryColor
                });
                onPopupClose();
                setEditCategoryCellState({
                    status: 'idle'
                });
            }
        }, [
            onCategoryUpdate,
            onPopupClose,
            editCategoryCellState
        ]);
        const getCreateCategoryLabel = (0, $5uXOq.useCallback)((categoryInputValue)=>`${categoryInputValue} (${formatMessage((0, (0, parcelRequire("jGpUV")).default).createNewCategory)})`, [
            formatMessage
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>{
            const ref = (node)=>{
                setTriggerRef(node);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(node);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: $9ae93109dcf682a6$var$popupTriggerStyles,
                ref: ref
            }, triggerContent);
        }, [
            triggerContent
        ]);
        const getCustomComponents = (0, $5uXOq.useCallback)((onContentUpdate)=>({
                Option: (optionProps)=>{
                    const { label: label, value: value, data: optionPropsData, isFocused: isFocused } = optionProps;
                    const { __isNew__: isCreateOption } = optionPropsData;
                    isCreateOptionFocused.current = isCreateOption && isFocused;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, optionProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bqVq1")).default), {
                        label: label,
                        value: value,
                        color: optionPropsData?.color,
                        isFocused: isFocused,
                        isCreateOption: isCreateOption,
                        issueTypeId: issueTypeId,
                        onCategoryIsEditing: (categoryLabel, categoryValue, categoryColor)=>{
                            updateEditingCategory(categoryLabel, categoryValue, categoryColor);
                            onContentUpdate();
                        },
                        onCategoryUpdate: onCategoryUpdate,
                        categoryBeenEdited: editCategoryCellState.status === 'updating-category' ? editCategoryCellState.categoryName : null,
                        wrapperRef: wrapperRef,
                        selectedOption: categoryState?.value ?? '',
                        setCategoryToDeleteInModal: setCategoryToDeleteInModal
                    }));
                }
            }), [
            issueTypeId,
            updateEditingCategory,
            onCategoryUpdate,
            editCategoryCellState,
            wrapperRef,
            categoryState?.value,
            setCategoryToDeleteInModal
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>({
                dropdownIndicator: (base)=>({
                        ...base,
                        display: 'none'
                    }),
                option: (base)=>({
                        ...base,
                        padding: '0px',
                        ':active': {
                            backgroundColor: 'none'
                        },
                        ...editCategoryCellState.status === 'updating-category' && {
                            boxShadow: 'none',
                            background: 'none'
                        }
                    }),
                container: (base)=>({
                        ...base,
                        cursor: `${editCategoryCellState.status === 'updating-category' ? 'default' : 'pointer'}`,
                        background: "var(--ds-surface, transparent)"
                    })
            }), [
            editCategoryCellState.status
        ]);
        const noOptionMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, (0, parcelRequire("jGpUV")).default).noMatches), [
            formatMessage
        ]);
        const PopupComponentBasedOnOptionsHeight = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: defaultCategoryOptions.length,
                hasFooter: true
            }), [
            defaultCategoryOptions
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (editCategoryCellState.status !== 'idle') return;
            if (e.key === 'Escape') wrapperRef?.current?.focus();
        }, [
            editCategoryCellState.status,
            wrapperRef
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editCategoryCellState.status !== 'idle') return true;
            if (event.code === 'Tab') return true;
            if (event.code === 'Enter' && isCreateOptionFocused.current) return true;
            return false;
        }, [
            editCategoryCellState.status
        ]);
        const handleBlur = (0, $5uXOq.useCallback)(()=>true, []);
        (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
                onKeyDown: handleKeyDownNew,
                onBlur: handleBlur
            }), [
            handleKeyDownNew,
            handleBlur
        ]);
        const categoryEditData = (0, $5uXOq.useMemo)(()=>editCategoryCellState.status === 'updating-category' ? {
                categoryName: editCategoryCellState.categoryName,
                categoryColor: editCategoryCellState.categoryColor
            } : {
                categoryName: '',
                categoryColor: null
            }, [
            editCategoryCellState
        ]);
        const popupContent = (0, $5uXOq.useCallback)(({ update: onContentUpdate })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
                preferredWidth: editCategoryCellState.status === 'idle' ? width - 1 : (0, $c8d9a5c50f0c3337$export$5aa64aeadd515250) - 1,
                "data-testid": "business-list.ui.list-view.category-cell.edit-category-cell.category-wrapper",
                onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? undefined : handleKeyDown
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6du7W")).default), {
                autoFocus: true,
                value: (0, (0, parcelRequire("dKy4F")).toCategorySelectOption)(categoryState),
                label: editCategoryCellState.status === 'creating-category' ? editCategoryCellState.categoryToBeCreated : formatMessage((0, (0, parcelRequire("jGpUV")).default).placeholder),
                placeholder: editCategoryCellState.status === 'creating-category' ? editCategoryCellState.categoryToBeCreated : formatMessage((0, (0, parcelRequire("jGpUV")).default).placeholder),
                onChange: handleChange,
                isClearable: true,
                isMulti: false,
                isDisabled: editCategoryCellState.status !== 'idle',
                noOptionsMessage: noOptionMessage,
                menuIsOpen: editCategoryCellState.status === 'idle',
                onCreateOption: (categoryName)=>{
                    handleCreate(categoryName);
                    onContentUpdate();
                },
                formatCreateLabel: getCreateCategoryLabel,
                defaultOptions: defaultCategoryOptions,
                loadOptions: loadOptionsDebounced,
                components: getCustomComponents(onContentUpdate),
                styles: styles,
                inputValue: inputValue,
                onInputChange: onInputChange
            })), editCategoryCellState.status !== 'idle' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2uW5h")).default), {
                initialData: editCategoryCellState.status === 'creating-category' ? {
                    categoryName: editCategoryCellState.categoryToBeCreated,
                    categoryColor: null
                } : categoryEditData,
                type: editCategoryCellState.status === 'creating-category' ? 'create' : 'edit',
                onCancel: ()=>{
                    setEditCategoryCellState({
                        status: 'idle'
                    });
                    onContentUpdate();
                },
                onSubmit: editCategoryCellState.status === 'creating-category' ? onNewCategoryFormSubmit : onEditCategoryFormSubmit
            })), [
            inputValue,
            onInputChange,
            editCategoryCellState,
            width,
            handleKeyDown,
            categoryState,
            formatMessage,
            handleChange,
            noOptionMessage,
            handleCreate,
            getCreateCategoryLabel,
            defaultCategoryOptions,
            loadOptionsDebounced,
            getCustomComponents,
            styles,
            categoryEditData,
            onNewCategoryFormSubmit,
            onEditCategoryFormSubmit
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            testId: "business-list.ui.list-view.category-cell.edit-category-cell.popup",
            isOpen: true,
            placement: "bottom-start",
            autoFocus: false,
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $9ae93109dcf682a6$var$POPUP_OFFSET_NEW : $9ae93109dcf682a6$var$POPUP_OFFSET,
            onClose: onPopupClose,
            popupComponent: editCategoryCellState.status === 'idle' ? PopupComponentBasedOnOptionsHeight : (0, (0, parcelRequire("jRzRt")).PopupComponent),
            trigger: trigger,
            content: popupContent
        });
    };
    const $9ae93109dcf682a6$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    });
});
parcelRegister("dKy4F", function(module, exports) {
    $parcel$export(module.exports, "toCategorySelectOption", ()=>$458e9e69d75d72fc$export$2187805b683a1b65);
    const $458e9e69d75d72fc$export$2187805b683a1b65 = (jiraOption)=>{
        if (jiraOption == null) return null;
        return {
            value: String(jiraOption.optionId),
            label: jiraOption.value || '',
            color: jiraOption.color
        };
    };
});
const $c8d9a5c50f0c3337$export$5aa64aeadd515250 = 370;
parcelRegister("2uW5h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f318f1743b0e0ca7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $iKhOS = parcelRequire("iKhOS");
    var $fVnbM;
    var $2rqOp;
    var $efXp3;
    var $qfj8c;
    var $7O4UO;
    var $l1N8i;
    var $ebd3R;
    var $3dGN0;
    var $dC5iT;
    var $kgoHi;
    var $f5TWP;
    var $8CUq3;
    var $kY99m;
    var $7XYc4;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $gSwFG;
    var $kTBFu;
    var $DhnKp;
    var $jordx;
    const $f318f1743b0e0ca7$var$CategoryForm = ({ onCancel: onCancel, onSubmit: onSubmit, initialData: initialData, type: type })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { categoryColor: categoryColor, categoryName: categoryName } = initialData;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [currentColor, setCurrentColor] = (0, $5uXOq.useState)(categoryColor === null ? (0, (0, parcelRequire("gSwFG")).getRandomColor)() : categoryColor);
        const [currentName, setCurrentName] = (0, $5uXOq.useState)(categoryName);
        const inputElement = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'CategoryForm viewed', {
                purpose: type
            });
        }, [
            createAnalyticsEvent,
            type
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (inputElement.current) (0, ($parcel$interopDefault($iKhOS)))(()=>inputElement?.current?.focus());
        }, []);
        const isValidCategoryName = (0, $5uXOq.useCallback)((value)=>{
            if (!value || value.trim() === '') return formatMessage((0, (0, parcelRequire("jordx")).default).errorMessageBlankCategoryName);
            return undefined;
        }, [
            formatMessage
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)((formData)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', type === 'edit' ? 'categoryFormSave' : 'categoryFormAdd');
            onSubmit && onSubmit(formData);
        }, [
            createAnalyticsEvent,
            onSubmit,
            type
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f318f1743b0e0ca7$var$formStyles,
            backgroundColor: "elevation.surface.overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $f318f1743b0e0ca7$var$previewStyles,
            testId: "business-categories.ui.category-form.preview"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "h4",
            size: "small"
        }, type === 'edit' ? formatMessage((0, (0, parcelRequire("jordx")).default).editCategoryTitle) : formatMessage((0, (0, parcelRequire("jordx")).default).newCategoryTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
            label: "",
            color: "var(--ds-icon-subtle, #626F86)",
            spacing: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'spacious' : 'none',
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("ebd3R")))))
        }), currentName !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$TagContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("DhnKp")).default), {
            categoryName: currentName,
            categoryColor: currentColor
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: handleSubmit
        }, ({ formProps: formProps, submitting: submitting })=>(0, ($parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$StyledForm, {
                ...formProps,
                autoComplete: "off",
                "data-testid": "business-categories.ui.category-form.form"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$FieldsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "categoryName",
                defaultValue: initialData.categoryName,
                testId: "business-categories.ui.category-form.category-name",
                validate: isValidCategoryName
            }, ({ fieldProps: fieldProps, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                    ...fieldProps,
                    "aria-label": formatMessage((0, (0, parcelRequire("jordx")).default).categoryNameLabel),
                    autoComplete: "off",
                    autoFocus: true,
                    ref: inputElement,
                    placeholder: formatMessage((0, (0, parcelRequire("jordx")).default).categoryNamePlaceholder),
                    onChange: (e)=>{
                        setCurrentName(e.currentTarget.value);
                        fieldProps.onChange(e);
                    }
                }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, error)))), (0, ($parcel$interopDefault($5uXOq))).createElement($f318f1743b0e0ca7$var$FieldsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "categoryColor",
                defaultValue: currentColor
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTBFu")).CategoryColorPicker), {
                    ...fieldProps,
                    onChangeColor: (newColor)=>{
                        setCurrentColor(newColor);
                        fieldProps.onChange(newColor);
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'color clicked', 'categoryFormColorPicker', {
                            color: newColor
                        });
                    },
                    color: currentColor
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                gap: "space.100",
                justifyContent: "end"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle",
                testId: "business-categories.ui.category-form.cancel-button",
                onClick: ()=>{
                    onCancel();
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'categoryFormCancel');
                }
            }, formatMessage((0, (0, parcelRequire("jordx")).default).cancelButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
                appearance: "primary",
                type: "submit",
                isLoading: submitting,
                testId: "business-categories.ui.category-form.submit-button"
            }, type === 'edit' ? formatMessage((0, (0, parcelRequire("jordx")).default).saveButton) : formatMessage((0, (0, parcelRequire("jordx")).default).addButton))))));
    };
    var $f318f1743b0e0ca7$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f318f1743b0e0ca7$var$CategoryForm);
    const $f318f1743b0e0ca7$var$formStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.100',
        borderRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        display: 'block',
        padding: 'space.200',
        width: 'fit-content'
    });
    const $f318f1743b0e0ca7$var$previewStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        maxWidth: '360px'
    });
    const $f318f1743b0e0ca7$var$tagContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'grid',
        paddingTop: 'space.025'
    });
    const $f318f1743b0e0ca7$var$TagContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f318f1743b0e0ca7$var$tagContainerStyles
        }, children), (0, $5uXOq.Fragment));
    const $f318f1743b0e0ca7$var$StyledForm = (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f318f1743b0e0ca7$var$FieldsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iKhOS", function(module, exports) {
    var $1gef8 = parcelRequire("1gef8");
    var $g7i7g = parcelRequire("g7i7g");
    var $da5a5877d5d6860c$var$defer = $g7i7g(function(func, args) {
        return $1gef8(func, 1, args);
    });
    module.exports = $da5a5877d5d6860c$var$defer;
});
parcelRegister("1gef8", function(module, exports) {
    var $0eb25573bf32f124$var$FUNC_ERROR_TEXT = 'Expected a function';
    function $0eb25573bf32f124$var$baseDelay(func, wait, args) {
        if (typeof func != 'function') throw new TypeError($0eb25573bf32f124$var$FUNC_ERROR_TEXT);
        return setTimeout(function() {
            func.apply(undefined, args);
        }, wait);
    }
    module.exports = $0eb25573bf32f124$var$baseDelay;
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("kTBFu", function(module, exports) {
    $parcel$export(module.exports, "CategoryColorPicker", ()=>$8a8f7ec2b7d5afbc$export$cb1530364589b080);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("3zNHM");
    var $lGTQx = parcelRequire("lGTQx");
    var $3zNHM = parcelRequire("3zNHM");
    var $koVbs;
    var $gSwFG;
    var $3m7Ch;
    const $8a8f7ec2b7d5afbc$export$cb1530364589b080 = ({ color: color, onChangeColor: onChangeColor })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const colorPalette = (0, (0, parcelRequire("3m7Ch")).CATEGORY_THEMES).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
                label: formatMessage(messageLabel),
                value: backgroundColor
            }));
        const handleChangeColor = (0, $5uXOq.useCallback)((_, newColor)=>{
            onChangeColor((0, (0, parcelRequire("gSwFG")).getColorNameFromValue)(newColor));
        }, [
            onChangeColor
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lGTQx.default), {
            cols: colorPalette.length / 5,
            palette: colorPalette,
            selectedColor: (0, (0, parcelRequire("gSwFG")).getValueFromColorName)(color),
            onChange: handleChangeColor,
            mode: (0, $3zNHM.Compact),
            checkMarkColor: color.includes('LIGHT') ? (0, (0, parcelRequire("3m7Ch")).CHECK_MARK_COLOR_LIGHT) : (0, (0, parcelRequire("3m7Ch")).CHECK_MARK_COLOR_DARK),
            autoFocus: false,
            isFocusLockEnabled: false,
            isInsideMenu: false
        });
    };
});
parcelRegister("3zNHM", function(module, exports) {
    $parcel$export(module.exports, "Compact", ()=>$06f62cb25bd09d8d$export$6479582a9c9e50ce);
    $parcel$export(module.exports, "default", ()=>$06f62cb25bd09d8d$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ColorPaletteMenu", ()=>(parcelRequire("lGTQx")).default);
    var $3PpqK = parcelRequire("3PpqK");
    var $kD00A = parcelRequire("kD00A");
    var $lGTQx = parcelRequire("lGTQx");
    const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
    var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);
});
parcelRegister("3PpqK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f994db29f75e4622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9dFI;
    var $1ErJq = parcelRequire("1ErJq");
    var $jKrb6 = parcelRequire("jKrb6");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $8RXs9;
    var $VSDnB;
    var $7oXeG = parcelRequire("7oXeG");
    function $f994db29f75e4622$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f994db29f75e4622$var$defaultPopperProps = {
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            }
        ],
        placement: 'bottom-start'
    };
    const $f994db29f75e4622$var$packageName = "platform-pkg";
    const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
    class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
            const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
            const fullLabel = this.getFullLabel(intl, value, label);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b9dFI")).default), {
                target: ({ ref: ref, isOpen: isOpen })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                        css: $f994db29f75e4622$var$colorCardWrapperStyles,
                        ref: ref
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId
                    })),
                popperProps: popperProps,
                maxMenuWidth: "auto",
                minMenuWidth: "auto",
                options: options,
                "aria-label": fullLabel,
                value: value,
                components: $jKrb6,
                onChange: this.onChangeSelect,
                searchThreshold: Number.MAX_VALUE,
                cols: cols,
                checkMarkColor: checkMarkColor,
                onKeyDown: this.onKeyDown,
                isTabbing: this.state.isTabbing,
                onOptionKeyDown: this.onOptionKeyDown,
                ...(0, (0, parcelRequire("VSDnB")).fg)('one_event_rules_them_all_fg') && {
                    onMenuOpen: this.props.onMenuOpen
                }
            });
        }
        constructor(...args){
            super(...args), this.createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit'), this.state = {
                isTabbing: false
            }, this.changeAnalyticsCaller = ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                    action: 'clicked',
                    actionSubject: 'color-picker',
                    attributes: {
                        componentName: 'color-picker',
                        packageName: $f994db29f75e4622$var$packageName,
                        packageVersion: $f994db29f75e4622$var$packageVersion
                    }
                })(createAnalyticsEvent);
                return undefined;
            }, this.onChangeSelect = (option)=>{
                this.props.onChange(option.value, this.changeAnalyticsCaller());
            }, this.onOptionKeyDown = (value)=>{
                this.props.onChange(value, this.changeAnalyticsCaller());
            }, this.onKeyDown = (e)=>{
                const key = e.key;
                if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                    isTabbing: true
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                    isTabbing: false
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
            }, this.getFullLabel = (intl, value, label)=>{
                if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                    color: value.label,
                    message: label
                });
                else return label;
            };
        }
    }
    const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, (0, parcelRequire("8RXs9")).default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
    var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: $f994db29f75e4622$var$packageName,
        packageVersion: $f994db29f75e4622$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
    const $f994db29f75e4622$var$colorCardWrapperStyles = {
        name: "1r5gb7q",
        styles: "display:inline-block"
    };
});
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            }), this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            }, this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            }, this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            }, this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            }, this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            }, this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            }, this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            }, this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            }, this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }, this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            }, this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            }, this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            }, this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer)));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("1ErJq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$609735830782207d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $VSDnB;
    var $f8Sb3;
    function $609735830782207d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id })=>{
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            event.currentTarget.focus();
            if (onClick) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: [
                $609735830782207d$var$sharedColorContainerStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorContainerSize : $609735830782207d$var$defaultColorContainerSize,
                $609735830782207d$var$colorCardButtonStyles,
                expanded && !(0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-dsp-20821-color-pickr-focus') && $609735830782207d$var$colorCardButtonFocusedStyles
            ],
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $609735830782207d$var$colorCardWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $609735830782207d$var$colorCardContentStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorCardContentSize : $609735830782207d$var$defaultColorCardContentSize
            ],
            style: {
                background: value || 'transparent'
            }
        }))));
    };
    var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
    const $609735830782207d$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: '6px',
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $609735830782207d$var$smallColorContainerSize = {
        name: "1435ao5",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
    };
    const $609735830782207d$var$defaultColorContainerSize = {
        name: "1uafl10",
        styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
    };
    const $609735830782207d$var$colorCardButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover': {
            borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        },
        ':not(:focus):hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            outline: 'none'
        }
    });
    const $609735830782207d$var$colorCardButtonFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        outline: 'none'
    });
    const $609735830782207d$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $609735830782207d$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
    const $609735830782207d$var$smallColorCardContentSize = {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    };
    const $609735830782207d$var$defaultColorCardContentSize = {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    };
});
parcelRegister("jKrb6", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$b794a85d007e2dce$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "Option", ()=>$b794a85d007e2dce$export$36d18380658d5d20);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$b794a85d007e2dce$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "Placeholder", ()=>$b794a85d007e2dce$export$84712d0562a614b8);
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $koVbs;
    var $7oXeG = parcelRequire("7oXeG");
    function $b794a85d007e2dce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
        const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorPaletteContainerStyles,
            role: "group",
            "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
            style: {
                maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
            },
            ref: innerRef
        }, children);
    };
    const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
        const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorCardWrapperStyles,
            ...innerProps,
            role: "radio",
            "aria-checked": isSelected,
            "aria-selected": undefined,
            "aria-label": label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing
        }));
    };
    const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
    const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
    const $b794a85d007e2dce$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $b794a85d007e2dce$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
});
parcelRegister("l0sd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d681a23420d49946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eJbwP;
    var $3bDjY;
    var $f8Sb3;
    var $bWn3s;
    function $d681a23420d49946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d681a23420d49946$var$ColorCard = (0, $5uXOq.forwardRef)((props, componentRef)=>{
        const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const isInitialFocus = (0, $5uXOq.useRef)(true);
        const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                onClick(event, value);
            }
        }, [
            onClick,
            value
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
                event.preventDefault();
                if (isTabbing) event.stopPropagation();
                onClick(event, value);
            }
            if (isColorPaletteMenu) onKeyDown?.(event);
            else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, [
            isColorPaletteMenu,
            isTabbing,
            value,
            onClick,
            onKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
                focus: ()=>{
                    if (isColorPaletteMenu) {
                        if (isInitialFocus.current) {
                            autoFocus && !initialFocusRef && ref.current?.focus();
                            isInitialFocus.current = false;
                        } else ref.current?.focus();
                    }
                }
            }), [
            autoFocus,
            isColorPaletteMenu,
            initialFocusRef
        ]);
        const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
        const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
        const ariaChecked = isColorPaletteMenu ? selected : undefined;
        const ariaLabel = isColorPaletteMenu ? label : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                css: [
                    $d681a23420d49946$var$sharedColorContainerStyles,
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && $d681a23420d49946$var$colorCardOptionTabbingStyles,
                    focused && (isColorPaletteMenu || !isTabbing) && $d681a23420d49946$var$colorCardOptionFocusedStyles
                ],
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardContentStyles,
                style: {
                    background: value || 'transparent'
                }
            }, selected && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJbwP"))))), {
                color: checkMarkColor,
                label: "",
                spacing: "spacious",
                LEGACY_margin: "1px"
            }))));
        });
    });
    var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
    const $d681a23420d49946$var$colorCardOptionTabbingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
        }
    });
    const $d681a23420d49946$var$colorCardOptionFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
    });
    const $d681a23420d49946$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-border-radius-200, 6px)",
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $d681a23420d49946$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $d681a23420d49946$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
});
parcelRegister("eJbwP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));
    var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>$ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
        }, props));
    $ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;
});
const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("5dAp2", function(module, exports) {
    $parcel$export(module.exports, "getWidth", ()=>$38874a93fb14a10d$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getOptions", ()=>$38874a93fb14a10d$export$d2312e68e1f5ad00);
    var $k5uoT;
    var $8QpSo;
    var $kD00A = parcelRequire("kD00A");
    const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
        const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, (0, parcelRequire("k5uoT")).gridSize)() / 2);
        return mode === (0, $kD00A.Mode).Standard ? width + (0, (0, parcelRequire("k5uoT")).gridSize)() : width;
    };
    const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((palette, selectedColor, showDefaultSwatchColor)=>{
        let focusedItemIndex = 0;
        let defaultSelectedColor = palette[0];
        if (!showDefaultSwatchColor) defaultSelectedColor = {
            label: '',
            value: ''
        };
        const value = palette.find((color, index)=>{
            if (color.value === selectedColor) {
                focusedItemIndex = index;
                return true;
            }
            return false;
        }) || defaultSelectedColor;
        return {
            options: palette,
            value: value,
            focusedItemIndex: focusedItemIndex
        };
    });
});
parcelRegister("kD00A", function(module, exports) {
    $parcel$export(module.exports, "Mode", ()=>$e25de60b37efd75a$export$9484bbecc3c49a2e);
    var $e25de60b37efd75a$export$9484bbecc3c49a2e;
    (function(Mode) {
        Mode[Mode["Compact"] = 0] = "Compact";
        Mode[Mode["Standard"] = 1] = "Standard";
    })($e25de60b37efd75a$export$9484bbecc3c49a2e || ($e25de60b37efd75a$export$9484bbecc3c49a2e = {}));
});
parcelRegister("7oXeG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d42a6da5a6d06680$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorPickerAriaLabel: {
            id: 'jira.color-picker.src.color-picker-aria-label',
            defaultMessage: '{color} selected, {message}',
            description: 'This text is used as aria-label text in color picker component'
        },
        menuListAriaLabel: {
            id: 'jira.color-picker.src.menu-list-aria-label',
            defaultMessage: 'Color picker list',
            description: 'This text is used as aria-label text for the listbox element in color picker component'
        }
    });
});
parcelRegister("lGTQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5e30770a4da4328$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kD00A = parcelRequire("kD00A");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    function $c5e30770a4da4328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef })=>{
        const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
        const fullLabel = `${label}, ${selectedValue.label} selected`;
        const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
        const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
        const createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
        const changeAnalyticsCaller = ()=>{
            if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-palette-menu',
                attributes: {
                    componentName: 'color-picker',
                    packageName: "platform-pkg",
                    packageVersion: "0.0.0-use.local"
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
        const handleChange = (event, value)=>{
            onChange(event, value, changeAnalyticsCaller());
        };
        (0, $5uXOq.useEffect)(()=>{
            colorCardRefs[focusedIndex]?.focus();
        }, [
            focusedIndex,
            colorCardRefs
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const numItems = options.length;
            switch(event.key){
                case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
                case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                    setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
                case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                    setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                    if (isFocusLockEnabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        setFocusedIndex(selectedColorIndex);
                    }
                    break;
                default:
                    break;
            }
        }, [
            isFocusLockEnabled,
            selectedColorIndex,
            setFocusedIndex,
            options
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-label": fullLabel,
            role: isInsideMenu ? 'menu' : 'radiogroup',
            css: [
                $c5e30770a4da4328$var$colorPaletteMenuStyles,
                mode === (0, $kD00A.Mode).Standard && $c5e30770a4da4328$var$colorPaletteMenuStandardStyles
            ],
            style: {
                width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $c5e30770a4da4328$var$colorPaletteContainerStyles,
                mode === (0, $kD00A.Mode).Compact && $c5e30770a4da4328$var$colorPaletteContainerCompactStyles
            ]
        }, options.map(({ label: label, value: value }, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $c5e30770a4da4328$var$colorCardWrapperStyles,
                key: value
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
                type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                label: label,
                value: value,
                checkMarkColor: checkMarkColor,
                isOption: true,
                selected: value === selectedValue.value,
                onClick: handleChange,
                ref: (ref)=>{
                    colorCardRefs[index] = ref;
                },
                autoFocus: autoFocus,
                initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                isInsideMenu: isInsideMenu,
                onKeyDown: handleKeyDown
            })))));
    };
    var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    })((0, (0, parcelRequire("cb25w")).default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
    const $c5e30770a4da4328$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = {
        name: "h6te2n",
        styles: "padding:var(--ds-space-0, 0)"
    };
    const $c5e30770a4da4328$var$colorPaletteMenuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        margin: "var(--ds-space-0, 0)",
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}, 0 0 8px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}`})`
    });
});
parcelRegister("jordx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c37a3fe09f6772c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0c37a3fe09f6772c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        categoryNameLabel: {
            "id": "business-categories.category-form.category-name-label",
            "defaultMessage": "Category name"
        },
        categoryNamePlaceholder: {
            "id": "business-categories.category-form.category-name-placeholder",
            "defaultMessage": "New category"
        },
        cancelButton: {
            "id": "business-categories.category-form.cancel-button",
            "defaultMessage": "Cancel"
        },
        saveButton: {
            "id": "business-categories.category-form.save-button",
            "defaultMessage": "Save"
        },
        addButton: {
            "id": "business-categories.category-form.add-button",
            "defaultMessage": "Add"
        },
        errorMessageBlankCategoryName: {
            "id": "business-categories.category-form.error-message-blank-category-name",
            "defaultMessage": "Category name cannot be blank"
        },
        editCategoryTitle: {
            "id": "business-categories.category-form.edit-category-title",
            "defaultMessage": "Edit category"
        },
        newCategoryTitle: {
            "id": "business-categories.category-form.new-category-title",
            "defaultMessage": "New category"
        }
    });
});
parcelRegister("jRzRt", function(module, exports) {
    $parcel$export(module.exports, "PopupComponent", ()=>$75cd825029e592f3$export$9fac2d040f3ed438);
    $parcel$export(module.exports, "getPopupComponentWithHeight", ()=>$75cd825029e592f3$export$21bfee93f8bea1c4);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    const $75cd825029e592f3$var$OPTION_COMPACT_HEIGHT = 28;
    const $75cd825029e592f3$var$OPTION_DEFAULT_HEIGHT = 40;
    const $75cd825029e592f3$var$INPUT_HEIGHT = 48;
    const $75cd825029e592f3$var$FOOTER_HEIGHT = 46;
    const $75cd825029e592f3$var$MENU_LIST_HEIGHT = 300;
    const $75cd825029e592f3$export$9fac2d040f3ed438 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($75cd825029e592f3$var$PopupComponentContainer, {
            ...props,
            ref: ref
        }));
    const $75cd825029e592f3$export$21bfee93f8bea1c4 = ({ numOptions: numOptions, hasInput: hasInput = true, hasFooter: hasFooter = false, spacing: spacing = 'compact' })=>{
        const menuHeight = numOptions * (spacing === 'compact' ? $75cd825029e592f3$var$OPTION_COMPACT_HEIGHT : $75cd825029e592f3$var$OPTION_DEFAULT_HEIGHT);
        const menuAdjustedHeight = Math.min(menuHeight, $75cd825029e592f3$var$MENU_LIST_HEIGHT);
        const height = menuAdjustedHeight + (hasInput ? $75cd825029e592f3$var$INPUT_HEIGHT : 0) + (hasFooter ? $75cd825029e592f3$var$FOOTER_HEIGHT : 0);
        return (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($75cd825029e592f3$var$PopupComponentContainer, {
                ...props,
                ref: ref,
                height: height
            }));
    };
    const $75cd825029e592f3$var$shadowSize = 2;
    const $75cd825029e592f3$var$boxShadow = `0 0 0 ${$75cd825029e592f3$var$shadowSize}px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`} inset`;
    const $75cd825029e592f3$var$transition = 'box-shadow 0.1s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
    const $75cd825029e592f3$var$PopupComponentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10ib6lf": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height, "px"),
                "--_kgvpqr": (0, (0, parcelRequire("lD23V")).default)($75cd825029e592f3$var$boxShadow)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk18uv _v5641ni2 _nt751r31 _49pcglyw _1hvw1o36 _7ehi6a9y",
                __cmplp.height != null ? "_4t3it1jn" : "_4t3i1kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6du7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01e27ef03a76e529$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $01e27ef03a76e529$var$CreatableSelect = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("i6LrV")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/common/ui/lazy-creatable-select/main.tsx"
    });
    var $01e27ef03a76e529$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "creatable-select",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($01e27ef03a76e529$var$CreatableSelect, props));
});
parcelRegister("i6LrV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h4zYz").then(()=>parcelRequire('cTNS8'));
});
parcelRegister("1pa56", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CATEGORY_ERROR_FLAG_ID", ()=>$10d2ca19e2b09d36$export$2938ca3596e53b03);
    $parcel$export(module.exports, "default", ()=>$10d2ca19e2b09d36$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $7HGHK;
    var $d4xRU;
    var $pa9q9;
    var $7HGHK;
    var $8Q4sF;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $391Aj;
    const $10d2ca19e2b09d36$export$2938ca3596e53b03 = (0, (0, parcelRequire("7HGHK")).toFlagId)('create-category-error-flag');
    var $10d2ca19e2b09d36$export$2e2bcd8739ae039 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const onDismissed = (0, $5uXOq.useCallback)(()=>{
            dismissFlag({
                command: (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND),
                id: $10d2ca19e2b09d36$export$2938ca3596e53b03
            });
        }, [
            dismissFlag
        ]);
        const handleContactAdminClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministrator');
        }, [
            createAnalyticsEvent
        ]);
        return (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                id: (0, (0, parcelRequire("7HGHK")).fromFlagId)($10d2ca19e2b09d36$export$2938ca3596e53b03),
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                    label: "error",
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                }),
                title: formatMessage((0, (0, parcelRequire("391Aj")).default).noPermissionToCreateCategoryTitle),
                description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
                    message: formatMessage((0, (0, parcelRequire("391Aj")).default).createCategoryNoPermissions, {
                        linkStart: '{linkStart}',
                        linkEnd: '{linkEnd}'
                    }),
                    componentsMapping: {
                        link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                                href: "/secure/ContactAdministrators!default.jspa",
                                target: "_blank",
                                onClick: handleContactAdminClick
                            }, children)
                    }
                }),
                onDismissed: onDismissed
            }), [
            formatMessage,
            onDismissed,
            handleContactAdminClick
        ]);
    };
});
parcelRegister("8Q4sF", function(module, exports) {
    $parcel$export(module.exports, "FormattedI18nMessage", ()=>$7c8c20575fbc9bfc$export$200d7bd7633253ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHDlh;
    var $9Byym;
    const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
        const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
        const messageParts = (0, $5uXOq.useMemo)(()=>{
            const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, (0, parcelRequire("9Byym")).getTags)(componentsMapping);
            try {
                const parts = [];
                let token = '';
                let TagComponent;
                let closeTagLookup;
                for(let i = 0; i < message.length; i += 1){
                    const letter = message[i];
                    token += letter;
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter)) {
                        const firstTagFound = (0, (0, parcelRequire("9Byym")).findTag)(token, {
                            tags: openTags
                        });
                        if (firstTagFound !== null && firstTagFound !== undefined) {
                            if (TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                            const text = token.replace(firstTagFound, '');
                            parts.push(text);
                            const tagInfo = tags[firstTagFound];
                            TagComponent = tagInfo.component;
                            closeTagLookup = tagInfo.close;
                            token = '';
                        }
                    }
                    if (closeTagLookup !== null && closeTagLookup !== undefined && (0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: [
                            closeTagLookup
                        ]
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                        const text = token.replace(closeTagLookup, '');
                        parts.push((0, ($parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                        TagComponent = undefined;
                        token = '';
                        closeTagLookup = undefined;
                    }
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: closeTags
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                    }
                }
                if (TagComponent || closeTagLookup) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                if (token.length > 0) parts.push(token);
                return parts;
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("gHDlh")).MalformedMessageError)) {
                    (0, (0, parcelRequire("gHDlh")).logMalformedMessageError)({
                        message: message,
                        packageName: packageName
                    });
                    return [
                        (0, (0, parcelRequire("gHDlh")).getMalformedMessage)({
                            message: message,
                            closeTags: closeTags,
                            openTags: openTags
                        })
                    ];
                }
                throw e;
            }
        }, [
            message,
            packageName,
            componentsMapping
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: index
            }, item)));
    };
});
parcelRegister("gHDlh", function(module, exports) {
    $parcel$export(module.exports, "getMalformedMessage", ()=>$ecff24857c176a60$export$f085cf20ec1f69ab);
    $parcel$export(module.exports, "logMalformedMessageError", ()=>$ecff24857c176a60$export$954c3e6aad1c9429);
    $parcel$export(module.exports, "MalformedMessageError", ()=>$ecff24857c176a60$export$40d900e818b9630e);
    var $dJl1T;
    var $jcw0u;
    const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
            ...openTags,
            ...closeTags
        ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
    const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
        if (packageName !== null && packageName !== undefined) {
            const errorMessage = `Malformed message: ${message}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: packageName,
                    id: (0, $5514815b06163219$export$f3390a0e172fee41)
                },
                attributes: {
                    message: errorMessage
                }
            });
            const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, errorMessage);
        }
    };
    class $ecff24857c176a60$export$40d900e818b9630e extends Error {
        constructor(){
            super('Malformed i18n message');
        }
    }
});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';
parcelRegister("9Byym", function(module, exports) {
    $parcel$export(module.exports, "getTags", ()=>$84498158f946a67b$export$af63d7414243dad3);
    $parcel$export(module.exports, "isAnyTag", ()=>$84498158f946a67b$export$38ffa64fc639355f);
    $parcel$export(module.exports, "findTag", ()=>$84498158f946a67b$export$dfca0f74034f8657);
    $parcel$export(module.exports, "isCloseTagDelimiter", ()=>$84498158f946a67b$export$d5170904651e91b1);
    const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce((acc, [key, value])=>{
            const open = `{${key}Start}`;
            const close = `{${key}End}`;
            acc.tags[open] = {
                close: close,
                component: value
            };
            acc.openTags.push(open);
            acc.closeTags.push(close);
            return acc;
        }, {
            tags: {},
            openTags: [],
            closeTags: []
        });
    const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
    const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
    const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);
});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';
parcelRegister("391Aj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78189dae7fad13c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $78189dae7fad13c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPermissionToCreateCategoryTitle: {
            "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category-title",
            "defaultMessage": "Unable to add category"
        },
        noPermissionToCreateCategory: {
            "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.no-permission-to-create-category",
            "defaultMessage": "To add a category, you'll need to {contactAdmin}"
        },
        createCategoryNoPermissions: {
            "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.create-category-no-permissions",
            "defaultMessage": "To add a category, you'll need to {linkStart}contact your admin{linkEnd}"
        },
        contactAdmin: {
            "id": "business-list.list-view.category-cell.edit-category-cell.create-error-flag.contact-admin",
            "defaultMessage": "contact your admin"
        }
    });
});
parcelRegister("bqVq1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$781f3b0d516b33ef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $42CjB;
    var $4IrpZ;
    var $5nRKm;
    var $gsEeL;
    var $3fOYK;
    var $dC5iT;
    var $8CUq3;
    var $DhnKp;
    var $daQYX;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $fLR9b;
    var $4VVfj;
    const $781f3b0d516b33ef$var$CustomSelectOption = (optionProps)=>{
        const { onCategoryIsEditing: onCategoryIsEditing, categoryBeenEdited: categoryBeenEdited, label: label, value: optionId, color: color, isCreateOption: isCreateOption = false, isFocused: isFocused, selectedOption: selectedOption, setCategoryToDeleteInModal: setCategoryToDeleteInModal } = optionProps;
        const isOptionBeingEdited = categoryBeenEdited === label;
        const isEditing = categoryBeenEdited != null;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const hasAdminPermission = project.permissions.administerProject;
        const handleEditClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmListViewCategoryOptionButtonEdit');
            onCategoryIsEditing(label, optionId, color);
        }, [
            createAnalyticsEvent,
            onCategoryIsEditing,
            label,
            optionId,
            color
        ]);
        const handleDeleteClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmListViewCategoryOptionButtonDelete');
            setCategoryToDeleteInModal({
                label: label,
                value: optionId,
                color: color
            });
        }, [
            color,
            createAnalyticsEvent,
            label,
            optionId,
            setCategoryToDeleteInModal
        ]);
        const handleEditKeyDownOld = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                handleEditClick(e);
            }
        }, [
            handleEditClick
        ]);
        const handleEditKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                handleEditClick(e);
            }
        }, [
            handleEditClick
        ]);
        const handleDeleteKeyDownOld = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                handleDeleteClick(e);
            }
        }, [
            handleDeleteClick
        ]);
        const handleDeleteKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                handleDeleteClick(e);
            }
        }, [
            handleDeleteClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4VVfj")).OptionWrapper), {
            isOptionBeingEdited: isOptionBeingEdited,
            isEditing: isEditing,
            testId: `business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option-${label}`
        }, (!isEditing || !isOptionBeingEdited) && (0, ($parcel$interopDefault($5uXOq))).createElement($781f3b0d516b33ef$var$CategoryWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("DhnKp")).default), {
            categoryColor: color,
            categoryName: label
        })), hasAdminPermission && !isCreateOption && !isEditing && isFocused && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $781f3b0d516b33ef$var$optionIconsWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("5nRKm"))))),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, (0, parcelRequire("fLR9b")).default).rename),
            onKeyDown: handleEditKeyDown,
            onClick: handleEditClick,
            testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.edit-button"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("4IrpZ"))))),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, (0, parcelRequire("fLR9b")).default).delete),
            onKeyDown: handleDeleteKeyDown,
            onClick: handleDeleteClick,
            testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.delete-button"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($781f3b0d516b33ef$var$OptionIconsWrapper, {
            isHoveringOption: selectedOption === label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": formatMessage((0, (0, parcelRequire("fLR9b")).default).rename),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gsEeL"))))), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("fLR9b")).default).rename)
            }),
            onKeyDown: handleEditKeyDownOld,
            onClick: handleEditClick,
            testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.edit-button"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": formatMessage((0, (0, parcelRequire("fLR9b")).default).delete),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fOYK"))))), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("fLR9b")).default).delete)
            }),
            onKeyDown: handleDeleteKeyDownOld,
            onClick: handleDeleteClick,
            testId: "business-list.ui.list-view.category-cell.edit-category-cell.custom-select-option.delete-button"
        }))));
    };
    const $781f3b0d516b33ef$var$optionIconsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        right: "var(--ds-space-0, 0px)",
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    });
    var $781f3b0d516b33ef$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($781f3b0d516b33ef$var$CustomSelectOption);
    const $781f3b0d516b33ef$var$CategoryWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1dza",
                __cmplp.className
            ])
        });
    });
    const $781f3b0d516b33ef$var$OptionIconsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1xi2ze3t _1yt41cy0 _4t3i1osq _1e0c1txw _4cvr1h6o _7dir18uv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_UNSAFE_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("5nRKm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3eb8cab3ab465b93$var$_UNSAFE_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb8cab3ab465b93$var$EditIcon = (props)=>$3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
    var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;
});
parcelRegister("gsEeL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
    function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfbe7921991bc4cb$var$EditIcon = (props)=>$bfbe7921991bc4cb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $bfbe7921991bc4cb$var$_edit.default
        }));
    $bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
    var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;
});
parcelRegister("3fOYK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25ea512a3c153cf8$var$_react = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25ea512a3c153cf8$var$_delete = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    function $25ea512a3c153cf8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25ea512a3c153cf8$var$TrashIcon = (props)=>$25ea512a3c153cf8$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
        }, props, {
            newIcon: $25ea512a3c153cf8$var$_delete.default
        }));
    $25ea512a3c153cf8$var$TrashIcon.displayName = 'TrashIcon';
    var $25ea512a3c153cf8$var$_default = module.exports.default = $25ea512a3c153cf8$var$TrashIcon;
});
parcelRegister("fLR9b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee59b30e5221a127$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ee59b30e5221a127$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rename: {
            "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.rename",
            "defaultMessage": "Rename"
        },
        delete: {
            "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.delete",
            "defaultMessage": "Delete"
        },
        confirm: {
            "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.confirm",
            "defaultMessage": "Confirm"
        },
        cancel: {
            "id": "business-list.list-view.category-cell.edit-category-cell.custom-select-option.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("4VVfj", function(module, exports) {
    $parcel$export(module.exports, "OptionWrapper", ()=>$9de8c43051ae513c$export$d6f6a072cce04542);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    const $9de8c43051ae513c$var$optionWrapperBaseStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minHeight: '25px',
        position: 'relative',
        paddingBlock: 'space.075',
        paddingInline: 'space.150',
        cursor: 'pointer'
    });
    const $9de8c43051ae513c$var$isOptionBeingEditedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0'
    });
    const $9de8c43051ae513c$var$isEditingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'inherit'
    });
    const $9de8c43051ae513c$export$d6f6a072cce04542 = ({ isOptionBeingEdited: isOptionBeingEdited, isEditing: isEditing, testId: testId, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            justifyContent: "space-between",
            xcss: [
                $9de8c43051ae513c$var$optionWrapperBaseStyles,
                isOptionBeingEdited && $9de8c43051ae513c$var$isOptionBeingEditedStyles,
                isEditing && $9de8c43051ae513c$var$isEditingStyles
            ],
            testId: testId
        }, children);
    const $9de8c43051ae513c$export$7a73e3f07eb82217 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1dza",
                __cmplp.className
            ])
        });
    });
    const $9de8c43051ae513c$export$8220e436750973f7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1xi2ze3t _1yt41cy0 _4t3i1osq _1e0c1txw _4cvr1h6o _7dir18uv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jGpUV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f500da77f7450823$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f500da77f7450823$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "business-list.list-view.category-cell.edit-category-cell.placeholder",
            "defaultMessage": "Add category"
        },
        createNewCategory: {
            "id": "business-list.list-view.category-cell.edit-category-cell.create-new-category",
            "defaultMessage": "New category"
        },
        noMatches: {
            "id": "business-list.list-view.category-cell.edit-category-cell.no-matches",
            "defaultMessage": "No matches found"
        }
    });
});
parcelRegister("cPZte", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0eaa0ae61f6f7add$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0eaa0ae61f6f7add$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.category-cell.error-title",
            "defaultMessage": "We couldn't save the new value"
        },
        errorMessage: {
            "id": "business-list.list-view.category-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("3yRl2", function(module, exports) {
    $parcel$export(module.exports, "CellNavigation", ()=>$82fabdbd20c0ce7c$export$8511762758d83099);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $af2fN;
    var $icf02;
    var $9fuVs;
    var $6s1PB;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $lI995;
    var $3xYte;
    var $2gmNO;
    var $2LpEi;
    var $d3rVJ;
    const $82fabdbd20c0ce7c$var$isNonCharacterKey = (event)=>event.key.length > 1 || event.ctrlKey || event.metaKey;
    const $82fabdbd20c0ce7c$var$copiedFromStyles = null;
    const $82fabdbd20c0ce7c$export$8511762758d83099 = (0, $5uXOq.memo)(({ children: children, columnIndex: columnIndex, rowIndex: rowIndex, field: field, onSendNodeSelected: onSendNodeSelected, onSendClearNodeSelection: onSendClearNodeSelection, issue: issue, fieldId: fieldId })=>{
        const [{ isSelected: isSelected = false, isCopiedFrom: isCopiedFrom = false }, { setSelectedCell: setSelectedCell, clearSelectedCell: clearSelectedCell, clearCopiedFromCell: clearCopiedFromCell }] = (0, (0, parcelRequire("3xYte")).useCellSelected)({
            column: columnIndex,
            row: rowIndex,
            issueId: issue?.issueId,
            fieldId: field?.id
        });
        const isSelectedRef = (0, $5uXOq.useRef)(isSelected);
        const prevIsSelected = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(isSelected);
        const horizontalNavigationRef = (0, $5uXOq.useRef)(false);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const cellRef = (0, $5uXOq.useRef)(null);
        const { navigate: navigate } = (0, (0, parcelRequire("3xYte")).useCellActions)();
        const [{ tableRef: tableRef }] = (0, (0, parcelRequire("2LpEi")).useTableRefStore)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [editMode, setEditModeFn] = (0, $5uXOq.useState)(false);
        const [inputValue, setInputValue] = (0, $5uXOq.useState)();
        const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
        const isCellActiveRef = (0, $5uXOq.useRef)(false);
        const editModeRef = (0, $5uXOq.useRef)(editMode);
        editModeRef.current = editMode;
        let formatRuleBackgroundColor = null;
        if ((0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) {
            const issueFields = issue?.fields;
            formatRuleBackgroundColor = (0, (0, parcelRequire("af2fN")).useGetColorFormatRule)({
                formattingArea: 'CELL',
                fieldId: fieldId,
                issueId: String(issue?.issueId),
                issueFields: issueFields
            });
        }
        const isEditable = field?.fieldConfig?.isEditable ?? true;
        const isNewKeyboardNavField = field?.type && (0, (0, parcelRequire("d3rVJ")).getNewNavSupportedFieldTypes)().has(field.type) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav');
        const setEditMode = (0, $5uXOq.useCallback)((nextEditMode)=>{
            if (nextEditMode === editMode) return;
            if (!isNewKeyboardNavField || isEditable) setEditModeFn(nextEditMode);
        }, [
            editMode,
            isEditable,
            isNewKeyboardNavField
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected === true && prevIsSelected === false) {
                onSendNodeSelected && onSendNodeSelected();
                horizontalNavigationRef.current = false;
            }
            if (isSelected === false && prevIsSelected === true) onSendClearNodeSelection && onSendClearNodeSelection();
        }, [
            isSelected,
            onSendClearNodeSelection,
            onSendNodeSelected,
            prevIsSelected
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isSelectedRef.current = isSelected;
            if (isSelected && wrapperRef.current) wrapperRef.current.focus();
        }, [
            isSelected
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (isSelectedRef.current) clearSelectedCell();
            }, [
            clearSelectedCell
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNewKeyboardNavField) {
                if (isSelected === false && editMode) setEditMode(false);
            }
        }, [
            editMode,
            isSelected,
            isNewKeyboardNavField,
            setEditMode
        ]);
        const handleFocus = (0, $5uXOq.useCallback)(()=>{
            setSelectedCell(columnIndex, rowIndex);
        }, [
            columnIndex,
            rowIndex,
            setSelectedCell
        ]);
        const handleBlur = (0, $5uXOq.useCallback)((event)=>{
            if ((!isNewKeyboardNavField || event.relatedTarget) && !event.currentTarget?.contains(event.relatedTarget)) {
                isCellActiveRef.current = false;
                const stop = cellRef.current?.onBlur?.(event);
                if (stop) return;
                clearSelectedCell();
            }
        }, [
            clearSelectedCell,
            isNewKeyboardNavField
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (isNewKeyboardNavField) {
                const stop = cellRef.current?.onKeyDown?.(event);
                if (stop) return;
            }
            const horizontalNavKeyPressed = (0, (0, parcelRequire("d3rVJ")).VALID_HORIZONTAL_NAV_KEYS).has(event.key);
            const isTabPressed = event.key === (0, (0, parcelRequire("d3rVJ")).KEY_TAB);
            const isValidKey = (0, (0, parcelRequire("d3rVJ")).VALID_NAVIGATION_KEYS).has(event.key);
            if (event.shiftKey && !isTabPressed) return;
            if (!isValidKey) {
                if (isNewKeyboardNavField && !editMode && !$82fabdbd20c0ce7c$var$isNonCharacterKey(event)) {
                    setEditMode(true);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'typeToEdit',
                        actionSubject: 'listNavigated'
                    }), {
                        fieldType: field.type
                    });
                    setTimeout(()=>{
                        setInputValue(event.key);
                    });
                }
                return;
            }
            const isScrolling = !!tableRef?.current?.table?.bodyRef?.state?.isScrolling;
            const navigationInProgress = isSelected && horizontalNavigationRef.current && horizontalNavKeyPressed;
            if (navigationInProgress || isScrolling) return;
            const fireNavigationAnalytics = ()=>{
                const EVENT_KEY = event.key === (0, (0, parcelRequire("d3rVJ")).KEY_SPACE) ? 'Space' : event.key;
                const attributes = isNewKeyboardNavField && [
                    'Enter',
                    'Tab',
                    'Escape',
                    'Space'
                ].includes(EVENT_KEY) ? {
                    isEditMode: editMode,
                    fieldType: field.type
                } : {};
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: EVENT_KEY,
                    actionSubject: 'listNavigated'
                }), attributes);
            };
            const handleNavigationEvent = (overrideDirection)=>{
                const direction = overrideDirection ?? (0, (0, parcelRequire("d3rVJ")).NAV_KEYS_TO_DIRECTION)[event.key];
                if (horizontalNavKeyPressed) horizontalNavigationRef.current = true;
                navigate(direction, tableRef);
            };
            if (isNewKeyboardNavField && editMode) switch(event.key){
                case 0, (0, parcelRequire("d3rVJ")).KEY_ENTER:
                    setTimeout(()=>{
                        setEditMode(false);
                        wrapperRef?.current?.focus();
                        handleNavigationEvent((0, (0, parcelRequire("eTDjN")).DOWN));
                        fireNavigationAnalytics();
                    }, 1);
                    return;
                case 0, (0, parcelRequire("d3rVJ")).KEY_ESCAPE:
                    setTimeout(()=>{
                        setEditMode(false);
                        setInputValue(undefined);
                        wrapperRef?.current?.focus();
                    });
                    return;
                case 0, (0, parcelRequire("d3rVJ")).KEY_TAB:
                    setTimeout(()=>{
                        setEditMode(false);
                        wrapperRef?.current?.focus();
                        handleNavigationEvent(event.shiftKey ? (0, (0, parcelRequire("eTDjN")).LEFT) : (0, (0, parcelRequire("eTDjN")).RIGHT));
                        fireNavigationAnalytics();
                    }, 1);
                    return;
                case 0, (0, parcelRequire("d3rVJ")).KEY_SPACE:
                    setTimeout(()=>{
                        if (!editModeRef.current) {
                            wrapperRef?.current?.focus();
                            handleNavigationEvent((0, (0, parcelRequire("eTDjN")).DOWN));
                            fireNavigationAnalytics();
                        }
                    }, 1);
                    return;
                case 0, (0, parcelRequire("d3rVJ")).KEY_UP:
                case 0, (0, parcelRequire("d3rVJ")).KEY_DOWN:
                case 0, (0, parcelRequire("d3rVJ")).KEY_LEFT:
                case 0, (0, parcelRequire("d3rVJ")).KEY_RIGHT:
                    return;
                default:
            }
            const tableDataLength = tableRef?.current?.table?.props?.data?.length || 0;
            const totalColumns = tableRef?.current?.table?.props?.columns?.length || 0;
            const isFirstTableItem = columnIndex === 0 && rowIndex === 0;
            const isLastTableItem = columnIndex === totalColumns - 1 && rowIndex === tableDataLength - 1;
            const isDirectionLeft = event.key === (0, (0, parcelRequire("d3rVJ")).KEY_LEFT) || isTabPressed && event.shiftKey;
            const isDirectionRight = event.key === (0, (0, parcelRequire("d3rVJ")).KEY_RIGHT) || isTabPressed && !event.shiftKey;
            if (isFirstTableItem && isDirectionLeft || isLastTableItem && isDirectionRight) return;
            event.preventDefault();
            fireNavigationAnalytics();
            switch(event.key){
                case 0, (0, parcelRequire("d3rVJ")).KEY_UP:
                case 0, (0, parcelRequire("d3rVJ")).KEY_DOWN:
                    handleNavigationEvent();
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_LEFT:
                    if (columnIndex > 0) handleNavigationEvent();
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_RIGHT:
                    if (columnIndex < totalColumns - 1) handleNavigationEvent();
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_TAB:
                    handleNavigationEvent(event.shiftKey ? (0, (0, parcelRequire("eTDjN")).LEFT) : (0, (0, parcelRequire("eTDjN")).RIGHT));
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_ENTER:
                    if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_SPACE:
                    if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                    break;
                case 0, (0, parcelRequire("d3rVJ")).KEY_ESCAPE:
                    if (!isNewKeyboardNavField || !editMode) {
                        clearSelectedCell();
                        clearCopiedFromCell();
                        wrapperRef?.current?.blur();
                    }
                    break;
                default:
                    break;
            }
        }, [
            isNewKeyboardNavField,
            tableRef,
            isSelected,
            editMode,
            columnIndex,
            rowIndex,
            setEditMode,
            createAnalyticsEvent,
            field?.type,
            navigate,
            clearSelectedCell,
            clearCopiedFromCell
        ]);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (isNewKeyboardNavField) {
                const stop = cellRef.current?.onClick?.(event);
                if (stop) return;
            }
            setEditMode(true);
        }, [
            isNewKeyboardNavField,
            setEditMode
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value)=>setInputValue(value), []);
        const getClone = ()=>{
            if ((0, $5uXOq.isValidElement)(children)) {
                if (isNewKeyboardNavField) return (0, $5uXOq.cloneElement)(children, {
                    isSelected: isSelected,
                    wrapperRef: wrapperRef,
                    cellRef: cellRef,
                    editMode: editMode,
                    setEditMode: setEditMode,
                    isHovering: isHovering,
                    inputValue: inputValue,
                    onInputChange: onInputChange
                });
                return (0, $5uXOq.cloneElement)(children, {
                    isSelected: isSelected,
                    wrapperRef: wrapperRef,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    onKeyDown: handleKeyDown
                });
            }
            return children;
        };
        if (isNewKeyboardNavField) {
            const getCellContainer = (props = {})=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
                    ref: wrapperRef,
                    isFocused: isSelected,
                    tabIndex: 0,
                    "data-testid": (0, (0, parcelRequire("icf02")).CELL_WRAPPER_TEST_ID),
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave,
                    onBlur: handleBlur,
                    onFocus: handleFocus,
                    onClick: handleClick,
                    formatRuleBackgroundColor: formatRuleBackgroundColor,
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        isCopiedFrom && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') && "_kqswh2mm _cfu11ule _1cs8stnw _1kt9b3bt _1mp4mslj _kfgtmslj _rfx3glpi _3l88yh40 _kzdagq9o _15m6194a _1rus18uv _dsq4glyw _1g0vidpf"
                    ])
                }, getClone()), isSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null));
            if (issue && field && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2gmNO")).ClipboardController), {
                issue: issue,
                field: field,
                fieldId: fieldId,
                isSelected: isSelected,
                isEditMode: editMode,
                onKeyDown: handleKeyDown
            }, getCellContainer());
            return getCellContainer({
                onKeyDown: handleKeyDown
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, getClone());
    });
});
parcelRegister("af2fN", function(module, exports) {
    $parcel$export(module.exports, "useGetColorFormatRule", ()=>$0759c2c8622ae825$export$7162d2241c1da066);
    var $5uXOq = parcelRequire("5uXOq");
    var $hug5L;
    var $6yL7o;
    const $0759c2c8622ae825$export$7162d2241c1da066 = ({ formattingArea: formattingArea, fieldId: fieldId, issueId: issueId, issueFields: issueFields })=>{
        const [{ rowRules: rowRules, cellRulesByFieldId: cellRulesByFieldId, issueIdRowRuleMatched: issueIdRowRuleMatched }, { setMatchedRowRule: setMatchedRowRule }] = (0, (0, parcelRequire("hug5L")).useFormatRulesStore)();
        const isCellArea = formattingArea === 'CELL';
        const formatRule = (0, $5uXOq.useMemo)(()=>{
            if (!issueFields || !issueId) return null;
            const rules = isCellArea && fieldId ? cellRulesByFieldId[fieldId] : rowRules;
            if (!rules?.length) return null;
            const rule = (0, (0, parcelRequire("6yL7o")).getColorFormatRules)({
                rules: rules,
                issueFields: issueFields
            });
            if (!rule) return null;
            if (isCellArea) {
                const rowRule = issueIdRowRuleMatched[issueId];
                if (rowRule?.index != null && rowRule.index < rule.index) return null;
            }
            return rule;
        }, [
            cellRulesByFieldId,
            fieldId,
            isCellArea,
            issueFields,
            issueId,
            issueIdRowRuleMatched,
            rowRules
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isCellArea && formatRule && issueId) setMatchedRowRule({
                rule: formatRule,
                issueId: issueId
            });
        }, [
            formatRule,
            isCellArea,
            issueId,
            setMatchedRowRule
        ]);
        return formatRule?.color || null;
    };
    const $0759c2c8622ae825$export$8027caa9547dee98 = ({ formattingArea: formattingArea, fieldId: fieldId, issueId: issueId, issueFields: issueFields })=>{
        const [{ rowRules: rowRules, cellRulesByFieldId: cellRulesByFieldId, issueIdRowRuleMatched: issueIdRowRuleMatched }, { setMatchedRowRule: setMatchedRowRule }] = (0, (0, parcelRequire("hug5L")).useFormatRulesStore)();
        const isCellArea = formattingArea === 'CELL';
        const formatRule = (0, $5uXOq.useMemo)(()=>{
            if (!issueFields || !issueId) return null;
            const rules = isCellArea && fieldId ? cellRulesByFieldId[fieldId] : rowRules;
            if (!rules?.length) return null;
            const rule = (0, (0, parcelRequire("6yL7o")).getColorFormatRules)({
                rules: rules,
                issueFields: issueFields
            });
            if (!rule) return null;
            if (isCellArea) {
                const rowRule = issueIdRowRuleMatched[issueId];
                if (rowRule?.index != null && rowRule.index < rule.index) return null;
            }
            return rule;
        }, [
            cellRulesByFieldId,
            fieldId,
            isCellArea,
            issueFields,
            issueId,
            issueIdRowRuleMatched,
            rowRules
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isCellArea && formatRule && issueId) setMatchedRowRule({
                rule: formatRule,
                issueId: issueId
            });
        }, [
            formatRule,
            isCellArea,
            issueId,
            setMatchedRowRule
        ]);
        return {
            backgroundColor: formatRule?.color || null,
            hoverColor: formatRule?.hoverColor || null
        };
    };
});
parcelRegister("6yL7o", function(module, exports) {
    $parcel$export(module.exports, "getColorFormatRules", ()=>$00e9da19cc1fb303$export$251900d893745a4b);
    var $gJBT6 = parcelRequire("gJBT6");
    var $ey4Q6;
    const $00e9da19cc1fb303$export$251900d893745a4b = (0, ($parcel$interopDefault($gJBT6)))(({ rules: rules, issueFields: issueFields })=>{
        if (!issueFields || !rules) return null;
        const issueFieldsById = {};
        issueFields.forEach((field)=>{
            issueFieldsById[field.fieldId] = field;
        });
        for (const rule of rules){
            const { operator: operator, value: value, fieldId: fieldId } = rule;
            if (operator && fieldId) {
                const ruleField = issueFieldsById[fieldId];
                if ((0, (0, parcelRequire("ey4Q6")).isFormatRuleEvaluationSupported)(ruleField?.type)) {
                    const ruleResult = (0, (0, parcelRequire("ey4Q6")).evaluateFormatRule)(ruleField?.type, {
                        field: ruleField,
                        operator: operator,
                        value: value
                    });
                    if (ruleResult) return rule;
                }
            }
        }
        return null;
    }, (args)=>JSON.stringify(args));
});
parcelRegister("ey4Q6", function(module, exports) {
    $parcel$export(module.exports, "evaluateFormatRule", ()=>$565f99cf872d9328$export$311cdf99cceaadec);
    $parcel$export(module.exports, "isFormatRuleEvaluationSupported", ()=>$565f99cf872d9328$export$e5e9880b1a0ddbe4);
    var $8QpSo;
    var $dth51;
    var $gWw5G;
    var $ikY6i;
    var $gdYT7;
    var $4RRRc;
    var $a6LRq;
    var $kEdiA;
    var $5tKyS;
    var $6r8Er;
    var $1HNg6;
    var $EAgoA;
    var $jFqRZ;
    var $gydIO;
    var $2ut8I;
    var $8DFJJ;
    const $565f99cf872d9328$export$1179b9c33b3930fd = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("jFqRZ")).textEvaluateFormatRule),
            ...(0, (0, parcelRequire("ikY6i")).labelsEvaluateFormatRule),
            ...(0, (0, parcelRequire("2ut8I")).userEvaluateFormatRule),
            ...(0, (0, parcelRequire("gWw5G")).dateEvaluateFormatRule),
            ...(0, (0, parcelRequire("4RRRc")).numberEvaluateFormatRule),
            ...(0, (0, parcelRequire("a6LRq")).priorityEvaluateFormatRule),
            ...(0, (0, parcelRequire("kEdiA")).projectEvaluateFormatRule),
            ...(0, (0, parcelRequire("1HNg6")).sprintEvaluateFormatRule),
            ...(0, (0, parcelRequire("8DFJJ")).versionEvaluateFormatRule),
            ...(0, (0, parcelRequire("gydIO")).typeEvaluateFormatRule),
            ...(0, (0, parcelRequire("EAgoA")).statusEvaluateFormatRule),
            ...(0, (0, parcelRequire("6r8Er")).singleSelectEvaluateFormatRule),
            ...(0, (0, parcelRequire("gdYT7")).multiSelectEvaluateFormatRule),
            ...(0, (0, parcelRequire("5tKyS")).radioEvaluateFormatRule),
            ...(0, (0, parcelRequire("dth51")).componentsEvaluateFormatRule)
        }));
    const $565f99cf872d9328$export$311cdf99cceaadec = (fieldType, ...args)=>{
        const handlers = $565f99cf872d9328$export$1179b9c33b3930fd();
        if (handlers[fieldType] == null) return;
        return handlers[fieldType]?.(...args);
    };
    const $565f99cf872d9328$export$e5e9880b1a0ddbe4 = (fieldType)=>{
        if (!fieldType) return false;
        const handlers = $565f99cf872d9328$export$1179b9c33b3930fd();
        return handlers[fieldType] != null;
    };
});
parcelRegister("dth51", function(module, exports) {
    $parcel$export(module.exports, "componentsEvaluateFormatRule", ()=>$8a98ab87f413ef83$export$e0e459c1e8cd74a0);
    var $5fc53;
    const $8a98ab87f413ef83$var$evaluateHandler = {
        CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length === value?.length),
        HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.name))),
        DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.name)).length !== value?.length),
        IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
        IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
    };
    const $8a98ab87f413ef83$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $8a98ab87f413ef83$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $8a98ab87f413ef83$export$e0e459c1e8cd74a0 = {
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: $8a98ab87f413ef83$var$evaluateFormatRule
    };
});
parcelRegister("gWw5G", function(module, exports) {
    $parcel$export(module.exports, "dateEvaluateFormatRule", ()=>$cf5a4f98ddbaf658$export$289deaf929c3babd);
    var $72LGt;
    var $dnQN3;
    var $9mNfg;
    var $79nXx;
    var $kUxFz;
    var $f1uil;
    var $ki4Ey;
    var $9JptI;
    var $iTBZZ;
    var $jovBr;
    var $iMVUf;
    var $htiPW;
    var $6HFRN;
    var $eBfUM;
    var $5fc53;
    var $42ioY;
    const $cf5a4f98ddbaf658$var$evaluateHandler = {
        IS: (field, value)=>{
            if (field.value && typeof value === 'string') switch(value){
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TODAY:
                    return (0, (0, parcelRequire("9JptI")).default)(new Date(field.value));
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, (0, parcelRequire("iTBZZ")).default)(new Date(field.value));
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, (0, parcelRequire("iMVUf")).default)(new Date(field.value));
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, (0, parcelRequire("ki4Ey")).default)(new Date(field.value));
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) === -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) === 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) === 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) === -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) === 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) === 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) === -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) === 1;
                default:
                    {
                        const dateValue = new Date(value);
                        if ((0, (0, parcelRequire("jovBr")).default)(dateValue)) return (0, (0, parcelRequire("f1uil")).default)(dateValue, new Date(field.value));
                        return false;
                    }
            }
            return false;
        },
        IS_AFTER: (field, value)=>{
            if (field.value && typeof value === 'string') switch(value){
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TODAY:
                    return (0, (0, parcelRequire("79nXx")).default)(new Date(field.value), (0, (0, parcelRequire("htiPW")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, (0, parcelRequire("79nXx")).default)(new Date(field.value), (0, (0, parcelRequire("6HFRN")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, (0, parcelRequire("79nXx")).default)(new Date(field.value), (0, (0, parcelRequire("eBfUM")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) > 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) >= 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) > 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) > 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) >= 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) > 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) > 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) >= 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) > 1;
                default:
                    {
                        const dateValue = new Date(value);
                        if ((0, (0, parcelRequire("jovBr")).default)(dateValue)) return (0, (0, parcelRequire("79nXx")).default)(new Date(field.value), dateValue);
                        return false;
                    }
            }
            return false;
        },
        IS_BEFORE: (field, value)=>{
            if (field.value && typeof value === 'string') switch(value){
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TODAY:
                    return (0, (0, parcelRequire("kUxFz")).default)(new Date(field.value), (0, (0, parcelRequire("htiPW")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).TOMORROW:
                    return (0, (0, parcelRequire("kUxFz")).default)(new Date(field.value), (0, (0, parcelRequire("6HFRN")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).YESTERDAY:
                    return (0, (0, parcelRequire("kUxFz")).default)(new Date(field.value), (0, (0, parcelRequire("eBfUM")).default)());
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) < 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) < -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_WEEK:
                    return (0, (0, parcelRequire("dnQN3")).default)(new Date(field.value), new Date()) < 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) < 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) < -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_QUARTER:
                    return (0, (0, parcelRequire("72LGt")).default)(new Date(field.value), new Date()) < 1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).THIS_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) < 0;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).LAST_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) < -1;
                case (0, (0, parcelRequire("42ioY")).DATE_VALUE_OPERATORS).NEXT_YEAR:
                    return (0, (0, parcelRequire("9mNfg")).default)(new Date(field.value), new Date()) < 1;
                default:
                    {
                        const dateValue = new Date(value);
                        if ((0, (0, parcelRequire("jovBr")).default)(dateValue)) return (0, (0, parcelRequire("kUxFz")).default)(new Date(field.value), dateValue);
                        return false;
                    }
            }
            return false;
        },
        IS_NOT: (field, value)=>!$cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value),
        IS_ON_OR_AFTER: (field, value)=>Boolean($cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value) || $cf5a4f98ddbaf658$var$evaluateHandler.IS_AFTER?.(field, value)),
        IS_ON_OR_BEFORE: (field, value)=>Boolean($cf5a4f98ddbaf658$var$evaluateHandler.IS?.(field, value) || $cf5a4f98ddbaf658$var$evaluateHandler.IS_BEFORE?.(field, value)),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $cf5a4f98ddbaf658$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $cf5a4f98ddbaf658$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $cf5a4f98ddbaf658$export$289deaf929c3babd = {
        [(0, (0, parcelRequire("5fc53")).START_DATE_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).UPDATED)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).CREATED)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $cf5a4f98ddbaf658$var$evaluateFormatRule
    };
});
parcelRegister("ikY6i", function(module, exports) {
    $parcel$export(module.exports, "labelsEvaluateFormatRule", ()=>$71e37884e7a6cf86$export$44959830567aabae);
    var $5fc53;
    const $71e37884e7a6cf86$var$evaluateHandler = {
        CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length === value?.length),
        HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue))),
        DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue)).length !== value?.length),
        IS_EMPTY: (field)=>field.value?.length === 0,
        IS_NOT_EMPTY: (field)=>field.value?.length > 0
    };
    const $71e37884e7a6cf86$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $71e37884e7a6cf86$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $71e37884e7a6cf86$export$44959830567aabae = {
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $71e37884e7a6cf86$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $71e37884e7a6cf86$var$evaluateFormatRule
    };
});
parcelRegister("gdYT7", function(module, exports) {
    $parcel$export(module.exports, "multiSelectEvaluateFormatRule", ()=>$8e3351380c39cef1$export$52c36143869699f1);
    var $5fc53;
    const $8e3351380c39cef1$var$evaluateHandler = {
        CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length === value?.length),
        HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(field.value?.some((fieldValue)=>fieldValue && value?.includes(fieldValue.value))),
        DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>fieldValue && value?.includes(fieldValue.value)).length !== value?.length),
        IS_EMPTY: (field)=>!field.value || field.value?.length === 0,
        IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value.length > 0)
    };
    const $8e3351380c39cef1$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $8e3351380c39cef1$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $8e3351380c39cef1$export$52c36143869699f1 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $8e3351380c39cef1$var$evaluateFormatRule
    };
});
parcelRegister("4RRRc", function(module, exports) {
    $parcel$export(module.exports, "numberEvaluateFormatRule", ()=>$3189a44e1211082b$export$8b123092055dd2da);
    var $5fc53;
    const $3189a44e1211082b$var$evaluateHandler = {
        EQUALS: (field, value)=>Boolean(field.value && field.value === Number(value)),
        DOES_NOT_EQUAL: (field, value)=>Boolean(field.value && field.value !== Number(value)),
        GREATER_THAN: (field, value)=>Boolean(field.value && field.value > Number(value)),
        GREATER_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value >= Number(value)),
        LESS_THAN: (field, value)=>Boolean(field.value && field.value < Number(value)),
        LESS_THAN_OR_EQUALS: (field, value)=>Boolean(field.value && field.value <= Number(value)),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $3189a44e1211082b$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $3189a44e1211082b$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $3189a44e1211082b$export$8b123092055dd2da = {
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: $3189a44e1211082b$var$evaluateFormatRule
    };
});
parcelRegister("a6LRq", function(module, exports) {
    $parcel$export(module.exports, "priorityEvaluateFormatRule", ()=>$8254740ac77e923c$export$8d97b18a0e2778ac);
    var $5fc53;
    const $8254740ac77e923c$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value?.priorityId === value),
        IS_NOT: (field, value)=>Boolean(field.value?.priorityId !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $8254740ac77e923c$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $8254740ac77e923c$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $8254740ac77e923c$export$8d97b18a0e2778ac = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $8254740ac77e923c$var$evaluateFormatRule
    };
});
parcelRegister("kEdiA", function(module, exports) {
    $parcel$export(module.exports, "projectEvaluateFormatRule", ()=>$b24eab0f30116df2$export$abda41e836fbe53a);
    var $5fc53;
    const $b24eab0f30116df2$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value?.projectId === value),
        IS_NOT: (field, value)=>Boolean(field.value?.projectId !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $b24eab0f30116df2$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $b24eab0f30116df2$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $b24eab0f30116df2$export$abda41e836fbe53a = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $b24eab0f30116df2$var$evaluateFormatRule
    };
});
parcelRegister("5tKyS", function(module, exports) {
    $parcel$export(module.exports, "radioEvaluateFormatRule", ()=>$f4b1ee03a5b932e8$export$4f805002362dd334);
    var $5fc53;
    const $f4b1ee03a5b932e8$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value?.id === value),
        IS_NOT: (field, value)=>Boolean(field.value?.id !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $f4b1ee03a5b932e8$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $f4b1ee03a5b932e8$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $f4b1ee03a5b932e8$export$4f805002362dd334 = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $f4b1ee03a5b932e8$var$evaluateFormatRule
    };
});
parcelRegister("6r8Er", function(module, exports) {
    $parcel$export(module.exports, "singleSelectEvaluateFormatRule", ()=>$199d65a5d5fffc5d$export$466ec2bab0b5512f);
    var $5fc53;
    const $199d65a5d5fffc5d$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value?.value === value),
        IS_NOT: (field, value)=>Boolean(field.value?.value !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $199d65a5d5fffc5d$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $199d65a5d5fffc5d$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $199d65a5d5fffc5d$export$466ec2bab0b5512f = {
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $199d65a5d5fffc5d$var$evaluateFormatRule
    };
});
parcelRegister("1HNg6", function(module, exports) {
    $parcel$export(module.exports, "sprintEvaluateFormatRule", ()=>$9b0e26a2a4ad2db8$export$4a797e9c240634e1);
    var $5fc53;
    const $9b0e26a2a4ad2db8$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId === value),
        IS_NOT: (field, value)=>Boolean(field.value.length && field.value[0]?.sprintId !== value),
        IS_EMPTY: (field)=>!field.value || !field.value.length,
        IS_NOT_EMPTY: (field)=>Boolean(field.value.length)
    };
    const $9b0e26a2a4ad2db8$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $9b0e26a2a4ad2db8$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $9b0e26a2a4ad2db8$export$4a797e9c240634e1 = {
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: $9b0e26a2a4ad2db8$var$evaluateFormatRule
    };
});
parcelRegister("EAgoA", function(module, exports) {
    $parcel$export(module.exports, "statusEvaluateFormatRule", ()=>$bf093575e5ef4233$export$e03c41425f1d323d);
    var $5fc53;
    const $bf093575e5ef4233$var$evaluateHandler = {
        IS: (field, value)=>field.statusId === value,
        IS_NOT: (field, value)=>field.statusId !== value,
        HAS_ANY_OF: (field, value)=>Array.isArray(value) && Boolean(value?.includes(field.statusId))
    };
    const $bf093575e5ef4233$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $bf093575e5ef4233$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $bf093575e5ef4233$export$e03c41425f1d323d = {
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: $bf093575e5ef4233$var$evaluateFormatRule
    };
});
parcelRegister("jFqRZ", function(module, exports) {
    $parcel$export(module.exports, "textEvaluateFormatRule", ()=>$6e9dda04111fc2ba$export$c4da0f7dd3518065);
    var $5fc53;
    const $6e9dda04111fc2ba$var$evaluateHandler = {
        IS_EMPTY: (field)=>Boolean(!field.value),
        IS_NOT_EMPTY: (field)=>Boolean(field.value),
        CONTAINS: (field, value)=>Boolean(typeof value === 'string' && field.value?.includes(value)),
        DOES_NOT_CONTAIN: (field, value)=>Boolean(typeof value === 'string' && !field.value?.includes(value))
    };
    const $6e9dda04111fc2ba$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $6e9dda04111fc2ba$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $6e9dda04111fc2ba$export$c4da0f7dd3518065 = {
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $6e9dda04111fc2ba$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $6e9dda04111fc2ba$var$evaluateFormatRule
    };
});
parcelRegister("gydIO", function(module, exports) {
    $parcel$export(module.exports, "typeEvaluateFormatRule", ()=>$3585a67825579232$export$8b8aad40b9f7a09b);
    var $5fc53;
    const $3585a67825579232$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.issueTypeId === value),
        IS_NOT: (field, value)=>Boolean(field.issueTypeId !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $3585a67825579232$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $3585a67825579232$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $3585a67825579232$export$8b8aad40b9f7a09b = {
        [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: $3585a67825579232$var$evaluateFormatRule
    };
});
parcelRegister("2ut8I", function(module, exports) {
    $parcel$export(module.exports, "userEvaluateFormatRule", ()=>$dd6beeb81d7c9301$export$27e95a93355e9d3c);
    var $5fc53;
    var $lJP8I;
    const $dd6beeb81d7c9301$var$evaluateHandler = {
        IS: (field, value)=>{
            if (value === (0, (0, parcelRequire("lJP8I")).USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, (0, parcelRequire("lJP8I")).USER_EMPTY_OPERATORS).EMPTY) return Boolean(!field.value?.accountId);
            return Boolean(field.value?.accountId === value);
        },
        IS_NOT: (field, value)=>{
            if (value === (0, (0, parcelRequire("lJP8I")).USER_EMPTY_OPERATORS).UNASSIGNED || value === (0, (0, parcelRequire("lJP8I")).USER_EMPTY_OPERATORS).EMPTY) return Boolean(field.value?.accountId);
            return Boolean(field.value?.accountId !== value);
        }
    };
    const $dd6beeb81d7c9301$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $dd6beeb81d7c9301$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $dd6beeb81d7c9301$var$evaluateMultiUserHandler = {
        CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.accountId)).length === value.length),
        HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.accountId))),
        DOES_NOT_CONTAIN: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>!value?.includes(fieldValue.accountId))),
        IS_EMPTY: (field)=>field.value?.length === 0,
        IS_NOT_EMPTY: (field)=>field.value?.length > 0
    };
    const $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $dd6beeb81d7c9301$var$evaluateMultiUserHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $dd6beeb81d7c9301$export$27e95a93355e9d3c = {
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $dd6beeb81d7c9301$var$evaluateFormatRulesForMultiUser
    };
});
parcelRegister("lJP8I", function(module, exports) {
    $parcel$export(module.exports, "USER_EMPTY_OPERATORS", ()=>$b34ee070465ec63a$export$d6d1c00539a63d49);
    const $b34ee070465ec63a$export$d6d1c00539a63d49 = {
        UNASSIGNED: 'UNASSIGNED',
        EMPTY: 'EMPTY'
    };
});
parcelRegister("8DFJJ", function(module, exports) {
    $parcel$export(module.exports, "versionEvaluateFormatRule", ()=>$66c00a81039c929b$export$da4c4fbd4009c683);
    var $5fc53;
    const $66c00a81039c929b$var$evaluateHandler = {
        IS: (field, value)=>Boolean(field.value?.name === value),
        IS_NOT: (field, value)=>Boolean(field.value?.name !== value),
        IS_EMPTY: (field)=>!field.value,
        IS_NOT_EMPTY: (field)=>Boolean(field.value)
    };
    const $66c00a81039c929b$var$evaluateFormatRule = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $66c00a81039c929b$var$evaluateHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $66c00a81039c929b$var$evaluateMultiVersionHandler = {
        CONTAINS: (field, value)=>Boolean(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
        HAS_ANY_OF: (field, value)=>Boolean(Array.isArray(value) && field.value?.some((fieldValue)=>value?.includes(fieldValue.name))),
        DOES_NOT_CONTAIN: (field, value)=>!(Array.isArray(value) && field.value?.filter((fieldValue)=>value?.includes(fieldValue.name)).length === value.length),
        IS_EMPTY: (field)=>field.value?.length === 0,
        IS_NOT_EMPTY: (field)=>Boolean(field.value && field.value?.length > 0)
    };
    const $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion = ({ field: field, operator: operator, value: value })=>{
        const evaluateHandlerFn = $66c00a81039c929b$var$evaluateMultiVersionHandler[operator];
        if (!evaluateHandlerFn) return false;
        return evaluateHandlerFn(field, value);
    };
    const $66c00a81039c929b$export$da4c4fbd4009c683 = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $66c00a81039c929b$var$evaluateFormatRule,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $66c00a81039c929b$var$evaluateFormatRulesForMultiVersion
    };
});
parcelRegister("icf02", function(module, exports) {
    $parcel$export(module.exports, "CELL_WRAPPER_TEST_ID", ()=>$4ffb91ba355bde2b$export$dec9ff238ffa9d69);
    $parcel$export(module.exports, "useMultiSelectKeyDown", ()=>$4ffb91ba355bde2b$export$704331f55cc6e6a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    const $4ffb91ba355bde2b$export$dec9ff238ffa9d69 = 'business-list.ui.list-view.cell-navigation.cell-container';
    const $4ffb91ba355bde2b$export$c4f223e53a47f1c6 = (element)=>element?.getAttribute('data-testid') === $4ffb91ba355bde2b$export$dec9ff238ffa9d69;
    const $4ffb91ba355bde2b$export$704331f55cc6e6a4 = ({ editMode: editMode = true, wasEditMode: wasEditMode = false, menuIsOpen: menuIsOpen, setMenuIsOpen: setMenuIsOpen, saveAndClose: saveAndClose, onEscapeKeyPress: onEscapeKeyPress })=>{
        const shouldCloseWithoutSaving = (0, $5uXOq.useRef)(false);
        const saveAndCloseRef = (0, $5uXOq.useRef)(saveAndClose);
        saveAndCloseRef.current = saveAndClose;
        (0, $5uXOq.useEffect)(()=>{
            shouldCloseWithoutSaving.current = false;
        }, [
            editMode
        ]);
        const saveOnBlur = (0, $5uXOq.useCallback)(()=>{
            if (wasEditMode && !editMode && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) {
                if (!shouldCloseWithoutSaving.current) {
                    saveAndClose();
                    shouldCloseWithoutSaving.current = true;
                } else shouldCloseWithoutSaving.current = false;
            }
        }, [
            editMode,
            saveAndClose,
            wasEditMode
        ]);
        const saveOnUnmount = (0, $5uXOq.useCallback)(()=>{
            if (!shouldCloseWithoutSaving.current && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) saveAndCloseRef.current();
            else shouldCloseWithoutSaving.current = false;
        }, []);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (editMode) {
                if (menuIsOpen && [
                    'Enter',
                    'Tab',
                    'Space'
                ].includes(event.code)) {
                    setMenuIsOpen(false);
                    return true;
                }
                if (!menuIsOpen && [
                    'Enter',
                    'Tab'
                ].includes(event.code)) {
                    saveAndClose();
                    shouldCloseWithoutSaving.current = true;
                    return false;
                }
                if (!menuIsOpen && (event.code === 'ArrowDown' || event.code.startsWith('Key') && !event.metaKey && !event.ctrlKey)) {
                    setMenuIsOpen(true);
                    return true;
                }
                if (event.code === 'Escape') {
                    shouldCloseWithoutSaving.current = true;
                    onEscapeKeyPress && onEscapeKeyPress();
                }
            }
            return false;
        }, [
            editMode,
            menuIsOpen,
            onEscapeKeyPress,
            saveAndClose,
            setMenuIsOpen
        ]);
        return {
            onKeyDown: onKeyDown,
            saveOnBlur: saveOnBlur,
            saveOnUnmount: saveOnUnmount
        };
    };
});
parcelRegister("3xYte", function(module, exports) {
    $parcel$export(module.exports, "useCellSelected", ()=>$e7c44969594389ca$export$82315ac370e9a611);
    $parcel$export(module.exports, "useHasCellSelection", ()=>$e7c44969594389ca$export$a808344e7adc2015);
    $parcel$export(module.exports, "useCellActions", ()=>$e7c44969594389ca$export$98b52eeb50fa4d73);
    var $jDUax;
    var $3sQ5x;
    var $iXqE5;
    var $eTDjN;
    var $2CfGf;
    var $guydz;
    const $e7c44969594389ca$var$actions = {
        clearSelectedCell: ()=>({ setState: setState })=>{
                setState({
                    selectedCell: undefined
                });
            },
        clearCopiedFromCell: ()=>({ setState: setState })=>{
                setState({
                    copiedFromCell: null
                });
            },
        setSelectedCell: (columnIndex, rowIndex)=>({ setState: setState, getState: getState })=>{
                const { selectedCell: selectedCell } = getState();
                if ((0, (0, parcelRequire("guydz")).checkIsCellSelected)(selectedCell, columnIndex, rowIndex)) return;
                setState({
                    selectedCell: {
                        column: columnIndex,
                        row: rowIndex
                    }
                });
            },
        setCopiedFromCell: (fieldId, issueId)=>({ setState: setState, getState: getState })=>{
                if (!fieldId || !issueId) return;
                const { copiedFromCell: copiedFromCell } = getState();
                if ((0, (0, parcelRequire("guydz")).checkIsCellCopiedFrom)(copiedFromCell, fieldId, issueId)) return;
                setState({
                    copiedFromCell: {
                        fieldId: fieldId,
                        issueId: issueId
                    }
                });
            },
        navigate: (direction, tableRef, dragAndDropButtonRow)=>({ setState: setState, getState: getState })=>{
                const { selectedCell: selectedCell } = getState();
                const tableRefProps = tableRef?.current?.table?.props;
                const tableData = tableRefProps?.data;
                const tableWidth = tableRefProps?.width || 0;
                const scrollLeft = tableRef?.current?.table?.bodyRef?.state?.scrollLeft || 0;
                const tableColumns = tableRefProps?.columns || [];
                const { visibleColumns: visibleColumns } = (0, (0, parcelRequire("2CfGf")).getColumnVisibilityIndexes)(scrollLeft, tableWidth, tableColumns);
                if (dragAndDropButtonRow && tableData) {
                    if ((0, (0, parcelRequire("jDUax")).isGroupItem)(tableData?.[dragAndDropButtonRow - 1]?.issueId?.toString() || null)) return;
                    (0, (0, parcelRequire("guydz")).scrollCellIntoView)(tableRef, visibleColumns, direction, {
                        column: 0,
                        row: dragAndDropButtonRow
                    }, {
                        column: tableColumns.length - 1,
                        row: dragAndDropButtonRow - 1
                    });
                    setTimeout(()=>{
                        setState({
                            selectedCell: {
                                column: tableColumns.length - 1,
                                row: dragAndDropButtonRow - 1
                            }
                        });
                    }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
                    return;
                }
                if (!selectedCell || !tableData) return;
                const { newColumnIndex: newColumnIndex, newRowIndex: newRowIndex } = (0, (0, parcelRequire("guydz")).getUpdatedNavigationIndexes)(selectedCell, direction, tableColumns, tableData);
                if (tableData && (0, (0, parcelRequire("jDUax")).isGroupItem)(tableData?.[newRowIndex]?.issueId?.toString() || null)) return;
                (0, (0, parcelRequire("guydz")).scrollCellIntoView)(tableRef, visibleColumns, direction, selectedCell, {
                    column: newColumnIndex,
                    row: newRowIndex
                });
                const prevCellColumn = selectedCell.column;
                const shouldFocusOnDragAndDropButton = prevCellColumn === tableColumns.length - 1 && newColumnIndex === 0 && newRowIndex < tableData.length;
                if (shouldFocusOnDragAndDropButton) {
                    const { issueId: issueId } = tableData[newRowIndex];
                    setTimeout(()=>{
                        if (typeof document !== 'undefined') document.dispatchEvent(new CustomEvent(`${(0, (0, parcelRequire("eTDjN")).DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                            detail: {
                                issueId: issueId
                            }
                        }));
                    }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
                } else setTimeout(()=>{
                    setState({
                        selectedCell: {
                            column: newColumnIndex,
                            row: newRowIndex
                        }
                    });
                }, (0, $8ae9e10bb829c07c$export$c10811fdbc59f0be));
            }
    };
    const $e7c44969594389ca$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            selectedCell: undefined,
            copiedFromCell: null,
            prevScrolledColumnIndex: undefined
        },
        actions: $e7c44969594389ca$var$actions,
        name: 'JwmCellNavigation'
    });
    const $e7c44969594389ca$export$82315ac370e9a611 = (0, (0, parcelRequire("3sQ5x")).createHook)($e7c44969594389ca$export$390f32400eaf98c9, {
        selector: (0, (0, parcelRequire("guydz")).getCellSelectedSelector)
    });
    const $e7c44969594389ca$export$a808344e7adc2015 = (0, (0, parcelRequire("3sQ5x")).createHook)($e7c44969594389ca$export$390f32400eaf98c9, {
        selector: (0, (0, parcelRequire("guydz")).getHasSelectionSelector)
    });
    const $e7c44969594389ca$export$98b52eeb50fa4d73 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($e7c44969594389ca$export$390f32400eaf98c9);
});
const $8ae9e10bb829c07c$export$c10811fdbc59f0be = 50;
parcelRegister("guydz", function(module, exports) {
    $parcel$export(module.exports, "checkIsCellSelected", ()=>$de36b09dafacedf7$export$137ef1ae0e2f1e4f);
    $parcel$export(module.exports, "checkIsCellCopiedFrom", ()=>$de36b09dafacedf7$export$10a6e994f306d4c1);
    $parcel$export(module.exports, "getCellSelectedSelector", ()=>$de36b09dafacedf7$export$8faeda346ea872cf);
    $parcel$export(module.exports, "getHasSelectionSelector", ()=>$de36b09dafacedf7$export$f296623a5c5deab7);
    $parcel$export(module.exports, "getUpdatedNavigationIndexes", ()=>$de36b09dafacedf7$export$e86d0c724f5bd464);
    $parcel$export(module.exports, "scrollCellIntoView", ()=>$de36b09dafacedf7$export$5d689075caa24122);
    var $2HfxU = parcelRequire("2HfxU");
    var $hYfgW = parcelRequire("hYfgW");
    var $jDUax;
    var $6dDSs;
    var $eTDjN;
    const $de36b09dafacedf7$export$137ef1ae0e2f1e4f = (selectedCell, columnIndex, rowIndex)=>selectedCell ? selectedCell.column === columnIndex && selectedCell.row === rowIndex : false;
    const $de36b09dafacedf7$export$10a6e994f306d4c1 = (copiedCell, fieldId, issueId)=>{
        if (!copiedCell || !fieldId || !issueId) return false;
        return copiedCell.fieldId === fieldId && copiedCell.issueId === issueId;
    };
    const $de36b09dafacedf7$export$8faeda346ea872cf = (0, (0, parcelRequire("6dDSs")).createSelector)((state, coordinate)=>({
            isCellSelected: $de36b09dafacedf7$export$137ef1ae0e2f1e4f(state.selectedCell, coordinate.column, coordinate.row),
            isCellCopiedFrom: $de36b09dafacedf7$export$10a6e994f306d4c1(state.copiedFromCell, coordinate.fieldId, coordinate.issueId)
        }), ({ isCellSelected: isCellSelected, isCellCopiedFrom: isCellCopiedFrom })=>({
            isSelected: isCellSelected,
            isCopiedFrom: isCellCopiedFrom ?? false
        }));
    const $de36b09dafacedf7$export$f296623a5c5deab7 = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>({
            hasSelection: !!state.selectedCell
        }), ({ hasSelection: hasSelection })=>({
            hasSelection: hasSelection
        }));
    const $de36b09dafacedf7$var$getNewColumnIndex = (initialCell, direction, totalColumns, totalRows)=>{
        const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
        const lastColumnIndex = totalColumns - 1;
        const lastRowIndex = totalRows - 1;
        const isFirstTableItem = initialColumnIndex === 0 && initialRowIndex === 0;
        const isLastTableItem = initialColumnIndex === lastColumnIndex && initialRowIndex === lastRowIndex;
        if (direction === (0, (0, parcelRequire("eTDjN")).LEFT) && !isFirstTableItem) return (initialColumnIndex || totalColumns) - 1;
        if (direction === (0, (0, parcelRequire("eTDjN")).RIGHT) && !isLastTableItem) return (initialColumnIndex + 1) % totalColumns;
        return initialColumnIndex;
    };
    const $de36b09dafacedf7$var$getNewRowIndex = (initialCell, direction, tableData)=>{
        const { row: initialRowIndex } = initialCell;
        if (direction === (0, (0, parcelRequire("eTDjN")).UP)) {
            let newRowIndex = initialRowIndex - 1;
            while(newRowIndex > 0 && (0, (0, parcelRequire("jDUax")).isGroupItem)(tableData[newRowIndex]?.issueId?.toString() || null))newRowIndex--;
            return Math.max(0, newRowIndex);
        }
        if (direction === (0, (0, parcelRequire("eTDjN")).DOWN)) {
            let nextRowIndex = initialRowIndex + 1;
            while(nextRowIndex < tableData.length && (0, (0, parcelRequire("jDUax")).isGroupItem)(tableData[nextRowIndex]?.issueId?.toString() || null))nextRowIndex++;
            return Math.min(tableData.length - 1, nextRowIndex);
        }
        return initialRowIndex;
    };
    const $de36b09dafacedf7$export$e86d0c724f5bd464 = (initialCell, direction, tableColumn, tableData)=>{
        const totalColumns = tableColumn.length;
        const totalRows = tableData.length;
        const newColumnIndex = $de36b09dafacedf7$var$getNewColumnIndex(initialCell, direction, totalColumns, totalRows);
        if (direction === (0, (0, parcelRequire("eTDjN")).UP) || direction === (0, (0, parcelRequire("eTDjN")).DOWN)) {
            const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, direction, tableData);
            return {
                newColumnIndex: newColumnIndex,
                newRowIndex: newRowIndex
            };
        }
        if (direction === (0, (0, parcelRequire("eTDjN")).RIGHT) && newColumnIndex === 0) {
            const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, (0, (0, parcelRequire("eTDjN")).DOWN), tableData);
            return {
                newColumnIndex: newColumnIndex,
                newRowIndex: newRowIndex
            };
        }
        if (direction === (0, (0, parcelRequire("eTDjN")).LEFT) && newColumnIndex === totalColumns - 1) {
            const newRowIndex = $de36b09dafacedf7$var$getNewRowIndex(initialCell, (0, (0, parcelRequire("eTDjN")).UP), tableData);
            return {
                newColumnIndex: newColumnIndex,
                newRowIndex: newRowIndex
            };
        }
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: initialCell.row
        };
    };
    const $de36b09dafacedf7$export$5d689075caa24122 = (tableRef, visibleColumns, direction, initialCell, newCell)=>{
        const tableWidth = tableRef.current?.table?.props?.width || 0;
        const tableColumns = tableRef.current?.table?.props?.columns || [];
        const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
        const { column: newColumnIndex, row: newRowIndex } = newCell;
        if (initialRowIndex !== newRowIndex) setTimeout(()=>tableRef.current?.scrollToRow(newRowIndex, 'auto'));
        if (direction === (0, (0, parcelRequire("eTDjN")).LEFT)) {
            const firstVisibleColumn = (0, ($parcel$interopDefault($2HfxU)))(visibleColumns);
            const shouldScrollColumnIntoView = firstVisibleColumn === initialColumnIndex || firstVisibleColumn === newColumnIndex || newColumnIndex > initialColumnIndex;
            if (shouldScrollColumnIntoView) {
                const scrollAmount = tableColumns.slice(0, newColumnIndex).reduce((acc, column)=>acc + column.width, 0);
                setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
            }
        }
        if (direction === (0, (0, parcelRequire("eTDjN")).RIGHT)) {
            const lastVisibleColumn = (0, ($parcel$interopDefault($hYfgW)))(visibleColumns);
            const shouldScrollColumnIntoView = lastVisibleColumn === initialColumnIndex || lastVisibleColumn === newColumnIndex || newColumnIndex < initialColumnIndex;
            if (shouldScrollColumnIntoView) {
                const totalWidthUntilNextCell = tableColumns.slice(0, newColumnIndex + 1).reduce((acc, column)=>acc + column.width, 0);
                const scrollAmount = Math.max(0, totalWidthUntilNextCell - tableWidth);
                setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
            }
        }
    };
});
parcelRegister("2HfxU", function(module, exports) {
    module.exports = (parcelRequire("bH3EF"));
});
parcelRegister("bH3EF", function(module, exports) {
    function $88368ba58341d518$var$head(array) {
        return array && array.length ? array[0] : undefined;
    }
    module.exports = $88368ba58341d518$var$head;
});
parcelRegister("2gmNO", function(module, exports) {
    $parcel$export(module.exports, "ClipboardController", ()=>$0be66f78721f7623$export$16d13693519be2ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $daTLS;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $3xYte;
    var $g65iA;
    const $0be66f78721f7623$export$16d13693519be2ee = ({ children: children, issue: issue, field: field, fieldId: fieldId, isSelected: isSelected, isEditMode: isEditMode, onKeyDown: onKeyDown })=>{
        const transformedField = (0, $5uXOq.useMemo)(()=>issue.fields?.find((f)=>{
                const fieldId_ = field.id === 'key' ? 'issuekey' : field.id;
                return f.fieldId === fieldId_;
            }), [
            field.id,
            issue.fields
        ]);
        const isFieldAssociated = field.issueTypes?.includes(issue.issuetype.id ?? '');
        const transformedMissingField = isFieldAssociated ? {
            type: field.type,
            fieldId: field.id,
            value: null
        } : null;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [clipboard, setClipboard] = (0, $5uXOq.useState)(null);
        const [isCutting, setIsCutting] = (0, $5uXOq.useState)(false);
        const [contentToCopy, setContentToCopy] = (0, $5uXOq.useState)(null);
        const { setCopiedFromCell: setCopiedFromCell, clearCopiedFromCell: clearCopiedFromCell } = (0, (0, parcelRequire("3xYte")).useCellActions)();
        const isEditable = field.fieldConfig?.isEditable ?? true;
        const canBeUnset = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("g65iA")).canBeReset)(field), [
            field
        ]);
        const issueForCopyAndPaste = (0, $5uXOq.useMemo)(()=>({
                key: issue.key,
                issueId: issue.issueId,
                issueType: issue.issuetype
            }), [
            issue.issueId,
            issue.issuetype,
            issue.key
        ]);
        const { renderPrepareToCopyComponent: renderPrepareToCopyComponent, renderPasteHandlerComponent: renderPasteHandlerComponent, renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent } = (0, (0, parcelRequire("daTLS")).useClipboard)(issueForCopyAndPaste, transformedField ?? transformedMissingField, fieldId);
        const { reportError: reportError, dismissFlag: dismissFlag } = (0, (0, parcelRequire("g65iA")).useClipboardErrorReporting)(field);
        const onPaste = (0, $5uXOq.useCallback)((success, error)=>{
            dismissFlag();
            setClipboard(null);
            if (success) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'cell pasted', {
                fieldType: field.type
            });
            else reportError({
                action: 'paste',
                error: error
            });
            if (isFieldAssociated && !transformedField) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraClipboardController',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: `A field of type ${field.type} is missing in BE response`,
                    fieldType: field.type
                },
                error: new Error('jiraClipboardControllerMissingFieldError')
            });
        }, [
            createAnalyticsEvent,
            dismissFlag,
            field.type,
            isFieldAssociated,
            reportError,
            transformedField
        ]);
        const onCut = (0, $5uXOq.useCallback)((success, error)=>{
            dismissFlag();
            setIsCutting(false);
            if (!success) reportError({
                action: 'cut',
                error: error
            });
        }, [
            dismissFlag,
            reportError
        ]);
        const paste = (0, $5uXOq.useCallback)((event)=>{
            if (isEditMode || !isEditable) return;
            const data = event.clipboardData;
            setClipboard({
                plainText: data?.getData('text/plain'),
                html: data?.getData('text/html')
            });
        }, [
            setClipboard,
            isEditMode,
            isEditable
        ]);
        const copyEventListener = (0, $5uXOq.useCallback)((e)=>{
            if (!isSelected || isEditMode) return;
            dismissFlag();
            try {
                (0, (0, parcelRequire("g65iA")).setDataToClipboard)(e, contentToCopy);
            } catch (error) {
                reportError({
                    action: 'copy',
                    error: error
                });
                return;
            }
            e.preventDefault();
            setCopiedFromCell(field.id, issue?.issueId);
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'cell copied', {
                fieldType: field.type,
                hasCopied: true
            });
        }, [
            isSelected,
            isEditMode,
            contentToCopy,
            dismissFlag,
            setCopiedFromCell,
            field.id,
            field.type,
            issue?.issueId,
            createAnalyticsEvent,
            reportError
        ]);
        const cutEventListener = (0, $5uXOq.useCallback)((e)=>{
            if (!isSelected || isEditMode) return;
            try {
                (0, (0, parcelRequire("g65iA")).setDataToClipboard)(e, contentToCopy);
            } catch (error) {
                reportError({
                    action: 'cut',
                    error: error
                });
                return;
            }
            e.preventDefault();
            dismissFlag();
            setCopiedFromCell(field.id, issue?.issueId);
            setIsCutting(true);
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'cell cut', {
                fieldType: field.type,
                canBeReset: canBeUnset,
                hasCopied: true
            });
        }, [
            isSelected,
            isEditMode,
            dismissFlag,
            setCopiedFromCell,
            field.id,
            field.type,
            issue?.issueId,
            createAnalyticsEvent,
            canBeUnset,
            contentToCopy,
            reportError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected) {
                document.addEventListener('paste', paste, true);
                document.addEventListener('copy', copyEventListener);
                document.addEventListener('cut', cutEventListener);
            } else {
                document.removeEventListener('paste', paste, true);
                document.removeEventListener('copy', copyEventListener);
                document.removeEventListener('cut', cutEventListener);
            }
            return ()=>{
                document.removeEventListener('paste', paste, true);
                document.removeEventListener('copy', copyEventListener);
                document.removeEventListener('cut', cutEventListener);
            };
        }, [
            copyEventListener,
            cutEventListener,
            isSelected,
            paste
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, $5uXOq.cloneElement)(children, {
            onKeyDown: onKeyDown
        }), clipboard && renderPasteHandlerComponent({
            clipboard: clipboard,
            onPaste: onPaste,
            isEditable: isEditable,
            onBeforePaste: clearCopiedFromCell
        }), isCutting && renderCutOnlyHandlerComponent({
            onCut: onCut,
            isEditable: canBeUnset
        }), isSelected && renderPrepareToCopyComponent({
            onContentReady: setContentToCopy
        }));
    };
});
parcelRegister("daTLS", function(module, exports) {
    $parcel$export(module.exports, "useClipboard", ()=>$31ec25dabeedbefa$export$2314ca2a3e892862);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bj6Oi;
    var $bxNFR;
    var $4R6GH;
    var $koVbs;
    var $1xoxe;
    var $7CjVW;
    var $3O2T0;
    var $9de3P;
    const $31ec25dabeedbefa$var$PrepareToCopyComponent = ({ issue: issue, field: field, onMissingClipboardHandler: onMissingClipboardHandler, onContentReady: onContentReady })=>{
        const Component = (0, (0, parcelRequire("7CjVW")).getClipboardHandlerComponent)(field?.type);
        (0, $5uXOq.useEffect)(()=>{
            if (!Component) try {
                const result = onMissingClipboardHandler();
                onContentReady(result);
            } catch (error) {
                onContentReady(null);
            }
        }, [
            Component,
            onContentReady,
            onMissingClipboardHandler
        ]);
        if (!Component) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            issue: issue,
            field: field,
            action: "prepare-to-copy",
            onComplete: (0, ($parcel$interopDefault($8Rkzz))),
            onContentReady: onContentReady,
            metadata: null
        });
    };
    const $31ec25dabeedbefa$var$CutOnlyHandlerComponent = ({ issue: issue, field: field, onCut: onCut, isEditable: isEditable })=>{
        const Component = (0, (0, parcelRequire("7CjVW")).getClipboardHandlerComponent)(field.type);
        const checkIsEditable = (0, $5uXOq.useCallback)(()=>{
            if (!isEditable) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_EDITABLE);
        }, [
            isEditable
        ]);
        if (!isEditable) {
            onCut(false, new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_EDITABLE));
            return null;
        }
        if (!Component) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            issue: issue,
            field: field,
            action: "cut-only",
            onComplete: onCut,
            metadata: {
                fieldId: field.fieldId,
                fieldType: field.type,
                fieldValue: null
            },
            onBeforeAction: checkIsEditable
        });
    };
    const $31ec25dabeedbefa$export$2314ca2a3e892862 = (issue, field, fieldId)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getCellValueFallback = (0, $5uXOq.useCallback)(()=>{
            if (!field) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).MISSING_FIELD);
            return (0, (0, parcelRequire("3O2T0")).getCellValue)(field, issue, formatMessage);
        }, [
            field,
            formatMessage,
            issue
        ]);
        const renderPrepareToCopyComponent = ({ onContentReady: onContentReady })=>{
            if (!field || !issue?.key || !issue?.issueId) return;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($31ec25dabeedbefa$var$PrepareToCopyComponent, {
                issue: issue,
                field: field,
                onMissingClipboardHandler: getCellValueFallback,
                onContentReady: onContentReady
            });
        };
        const renderPasteHandlerComponent = ({ clipboard: clipboard, onPaste: onPaste, isEditable: isEditable, onBeforePaste: onBeforePaste })=>{
            if (!issue?.key || !issue?.issueId) return onPaste(false, new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).MISSING_ISSUE));
            const isTopLevelField = fieldId && (0, (0, parcelRequire("1xoxe")).SUPPORTED_TOP_LEVEL_FIELD_TYPES).includes(fieldId);
            const fieldType = isTopLevelField ? fieldId : field?.type;
            if (!fieldType) return onPaste(false, new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).MISSING_FIELD));
            const PasteHandlerComponent = field && (0, (0, parcelRequire("7CjVW")).getClipboardHandlerComponent)(field?.type);
            if (!PasteHandlerComponent || !isEditable) return onPaste(false, new (0, (0, parcelRequire("bxNFR")).UnsupportedOperationError)(`Pasting on field type ${fieldType} is not supported`));
            if (!clipboard?.plainText) return onPaste(false, new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD));
            const metadata = (0, (0, parcelRequire("9de3P")).getFieldMetadataFromClipboard)(clipboard);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(PasteHandlerComponent, {
                issue: issue,
                field: field,
                action: "paste",
                clipboardItem: clipboard,
                onBeforeAction: onBeforePaste,
                onComplete: onPaste,
                metadata: metadata
            });
        };
        const renderCutOnlyHandlerComponent = ({ onCut: onCut, isEditable: isEditable })=>{
            if (!field || !issue?.key || !issue?.issueId) return onCut(false, new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).MISSING_FIELD));
            return (0, ($parcel$interopDefault($5uXOq))).createElement($31ec25dabeedbefa$var$CutOnlyHandlerComponent, {
                issue: issue,
                field: field,
                onCut: onCut,
                isEditable: isEditable
            });
        };
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return {
            renderPasteHandlerComponent: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            renderPrepareToCopyComponent: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            renderCutOnlyHandlerComponent: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        };
        return {
            renderPasteHandlerComponent: renderPasteHandlerComponent,
            renderPrepareToCopyComponent: renderPrepareToCopyComponent,
            renderCutOnlyHandlerComponent: renderCutOnlyHandlerComponent
        };
    };
});
parcelRegister("bj6Oi", function(module, exports) {
    $parcel$export(module.exports, "ClientSideValidationError", ()=>$fdb996f0512636de$export$5ba9b77898e6c81d);
    $parcel$export(module.exports, "isClientSideValidationError", ()=>$fdb996f0512636de$export$ea2382f3076b0d69);
    class $fdb996f0512636de$export$5ba9b77898e6c81d extends Error {
        constructor(message){
            super(message);
            this.name = 'ClientSideValidationError';
            this.skipSentry = true;
        }
    }
    const $fdb996f0512636de$export$ea2382f3076b0d69 = (error)=>error instanceof $fdb996f0512636de$export$5ba9b77898e6c81d;
});
parcelRegister("bxNFR", function(module, exports) {
    $parcel$export(module.exports, "UnsupportedOperationError", ()=>$a9534f2b2fe2c376$export$ab59e00737fb22e6);
    $parcel$export(module.exports, "isUnsupportedOperationError", ()=>$a9534f2b2fe2c376$export$cdab81fcd467111);
    class $a9534f2b2fe2c376$export$ab59e00737fb22e6 extends Error {
        constructor(message){
            super(message);
            this.name = 'UnsupportedOperationError';
            this.skipSentry = true;
        }
    }
    const $a9534f2b2fe2c376$export$cdab81fcd467111 = (error)=>error instanceof $a9534f2b2fe2c376$export$ab59e00737fb22e6;
});
parcelRegister("1xoxe", function(module, exports) {
    $parcel$export(module.exports, "VALIDATION_ERROR_CODES", ()=>$5f608d3cb06b552d$export$6d25692f75bd9b88);
    $parcel$export(module.exports, "SUPPORTED_TOP_LEVEL_FIELD_TYPES", ()=>$5f608d3cb06b552d$export$71645e77fbde68a0);
    var $hE5wF;
    var $5fc53;
    const $5f608d3cb06b552d$export$6d25692f75bd9b88 = {
        NULL_GETTER: 'NULL_GETTER',
        MISSING_FIELD: 'MISSING_FIELD',
        MISSING_ISSUE: 'MISSING_ISSUE',
        NON_COMPATIBLE_FIELD_TYPE: 'NON_COMPATIBLE_FIELD_TYPE',
        EMPTY_CLIPBOARD: 'EMPTY_CLIPBOARD',
        NON_EDITABLE: 'NON_EDITABLE'
    };
    const $5f608d3cb06b552d$export$71645e77fbde68a0 = [
        (0, (0, parcelRequire("5fc53")).COMMENT_TYPE),
        (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE),
        (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE)
    ];
});
parcelRegister("7CjVW", function(module, exports) {
    $parcel$export(module.exports, "getClipboardHandlerComponent", ()=>$42bcc5428b94d826$export$547cefce1a43344e);
    var $8QpSo;
    var $5PsOy;
    var $jhaRN;
    var $auKIK;
    var $ayltP;
    var $8WsUD;
    var $inOlw;
    var $bZjVN;
    var $7Y57h;
    var $1ZojP;
    var $233vh;
    var $62Lxt;
    var $eOY1D;
    var $g8t8K;
    var $8swam;
    var $lhJy9;
    var $jtn4P;
    var $1O7xL;
    var $dCJsI;
    var $57YE2;
    var $iAC09;
    var $eowGc;
    var $4dpsE;
    var $9UQ66;
    const $42bcc5428b94d826$var$createClipboardHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("jhaRN")).categoryClipboardHandler),
            ...(0, (0, parcelRequire("auKIK")).checkboxClipboardHandler),
            ...(0, (0, parcelRequire("ayltP")).componentsClipboardHandler),
            ...(0, (0, parcelRequire("9UQ66")).versionClipboardHandler),
            ...(0, (0, parcelRequire("7Y57h")).labelsClipboardHandler),
            ...(0, (0, parcelRequire("233vh")).numberClipboardHandler),
            ...(0, (0, parcelRequire("4dpsE")).userClipboardHandler),
            ...(0, (0, parcelRequire("4dpsE")).multiUserClipboardHandler),
            ...(0, (0, parcelRequire("1ZojP")).multiSelectClipboardHandler),
            ...(0, (0, parcelRequire("8WsUD")).dateClipboardHandler),
            ...(0, (0, parcelRequire("inOlw")).dateTimeClipboardHandler),
            ...(0, (0, parcelRequire("57YE2")).textClipboardHandler),
            ...(0, (0, parcelRequire("lhJy9")).richTextClipboardHandler),
            ...(0, (0, parcelRequire("eOY1D")).priorityClipboardHandler),
            ...(0, (0, parcelRequire("jtn4P")).singleSelectClipboardHandler),
            ...(0, (0, parcelRequire("1O7xL")).sprintClipboardHandler),
            ...(0, (0, parcelRequire("iAC09")).timeTrackingClipboardHandler),
            ...(0, (0, parcelRequire("eowGc")).urlClipboardHandler),
            ...(0, (0, parcelRequire("dCJsI")).teamClipboardHandler),
            ...(0, (0, parcelRequire("62Lxt")).parentClipboardHandler),
            ...(0, (0, parcelRequire("bZjVN")).groupClipboardHandler),
            ...(0, (0, parcelRequire("g8t8K")).projectClipboardHandler),
            ...(0, (0, parcelRequire("5PsOy")).cascadingSelectClipboardHandler),
            ...(0, (0, parcelRequire("8swam")).radioSelectClipboardHandler)
        }));
    const $42bcc5428b94d826$export$547cefce1a43344e = (fieldType)=>{
        const handlers = $42bcc5428b94d826$var$createClipboardHandlers();
        if (!fieldType || handlers[fieldType] == null) return;
        return handlers[fieldType];
    };
});
parcelRegister("5PsOy", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectClipboardHandler", ()=>$029a3ce5110ccb9a$export$9fd387ed8e8432cb);
    var $5fc53;
    var $dZxXA;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $029a3ce5110ccb9a$var$isCascadingSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'parentOptionValue' in fieldValue;
    const $029a3ce5110ccb9a$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, [
            (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)
        ])) return null;
        if (!$029a3ce5110ccb9a$var$isCascadingSelectOption(metadata.fieldValue)) return null;
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = metadata.fieldValue;
        return {
            parentOptionValue: parentOptionValue,
            childOptionValue: childOptionValue
        };
    };
    const $029a3ce5110ccb9a$export$5da374e426806c6a = (fieldValue)=>{
        if (fieldValue && fieldValue.parentOptionValue) {
            if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
            return `${fieldValue.parentOptionValue.value}`;
        }
        return '';
    };
    function $029a3ce5110ccb9a$var$assertCascadingSelectField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $029a3ce5110ccb9a$var$useCascadingSelectClipboardHandler = (issue, field)=>{
        $029a3ce5110ccb9a$var$assertCascadingSelectField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("dZxXA")).useCascadingSelectField)({
            fieldAriId: field.id,
            issueKey: issue.key,
            fieldKey: field.fieldId,
            initialValue: $029a3ce5110ccb9a$var$isCascadingSelectOption(field.value) ? field.value : null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: $029a3ce5110ccb9a$export$5da374e426806c6a(value),
            currentValue: value,
            getPastedValue: $029a3ce5110ccb9a$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $029a3ce5110ccb9a$var$CascadingSelectClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($029a3ce5110ccb9a$var$useCascadingSelectClipboardHandler);
    const $029a3ce5110ccb9a$export$9fd387ed8e8432cb = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $029a3ce5110ccb9a$var$CascadingSelectClipboardHelper
    };
});
parcelRegister("dZxXA", function(module, exports) {
    $parcel$export(module.exports, "useCascadingSelectField", ()=>$d1627e1289106486$export$f7e91b2d1b79d323);
    var $k6djR;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lQE94;
    var $5fc53;
    const $d1627e1289106486$export$f7e91b2d1b79d323 = ({ fieldAriId: fieldAriId, issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onFailure: onFailure })=>{
        const [editValue, setEditValue] = (0, $5uXOq.useState)(initialValue);
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("k6djR")).default));
        const saveField = (0, $5uXOq.useCallback)((_iKey, _fKey, valuesForOperation)=>{
            if (!valuesForOperation) return Promise.resolve(undefined);
            const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = valuesForOperation;
            commit({
                variables: {
                    input: {
                        id: fieldAriId,
                        operation: {
                            operation: 'SET',
                            parentOption: parentOptionValue?.id,
                            childOption: childOptionValue?.id
                        }
                    }
                },
                onError: onFailure,
                optimisticResponse: {
                    jira: {
                        updateCascadingSelectField: {
                            success: true,
                            errors: null
                        }
                    }
                }
            });
            return Promise.resolve(undefined);
        }, [
            commit,
            fieldAriId,
            onFailure
        ]);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldType: (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE),
            issueId: fieldAriId,
            issueKey: issueKey,
            initialValue: initialValue,
            fieldKey: fieldKey,
            saveField: saveField
        });
        return [
            {
                value: value,
                editValue: editValue,
                setEditValue: setEditValue
            },
            {
                saveValue: saveValue
            }
        ];
    };
});
parcelRegister("k6djR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f35d4af38035f678$export$2e2bcd8739ae039);
    const $f35d4af38035f678$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraCascadingSelectFieldPayload",
                        "kind": "LinkedField",
                        "name": "updateCascadingSelectField",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "MutationError",
                                "kind": "LinkedField",
                                "name": "errors",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "message"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "cascadingSelectField_Mutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "cascadingSelectField_Mutation",
                "selections": v1
            },
            "params": {
                "id": "12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f",
                "metadata": {},
                "name": "cascadingSelectField_Mutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $f35d4af38035f678$var$node.hash = "30c90a51c8447b75fc86baef709bc308";
    var $f35d4af38035f678$export$2e2bcd8739ae039 = $f35d4af38035f678$var$node;
});
parcelRegister("4UjyI", function(module, exports) {
    $parcel$export(module.exports, "createClipboardHelperComponent", ()=>$8ccc65698593f46d$export$6ac5565d32c446cd);
    var $5uXOq = parcelRequire("5uXOq");
    const $8ccc65698593f46d$export$6ac5565d32c446cd = (useFieldPasteHandler)=>({ issue: issue, field: field, clipboardItem: clipboardItem, metadata: metadata, action: action, onBeforeAction: onBeforeAction, onComplete: onComplete, onContentReady: onContentReady })=>{
            const [hasBeenCalled, setHasBeenCalled] = (0, $5uXOq.useState)(false);
            const { contentToCopy: contentToCopy, copyHandler: copyHandler, pasteHandler: pasteHandler, cutHandler: cutHandler } = useFieldPasteHandler(issue, field);
            (0, $5uXOq.useEffect)(()=>{
                async function handlePrepareToCopy() {
                    if (!contentToCopy || !onContentReady) return;
                    try {
                        onContentReady(contentToCopy);
                        onComplete(true);
                    } catch (error) {
                        onComplete(false, error);
                    }
                }
                if (action === 'prepare-to-copy') handlePrepareToCopy();
            }, [
                onComplete,
                hasBeenCalled,
                action,
                copyHandler,
                contentToCopy,
                onContentReady
            ]);
            (0, $5uXOq.useEffect)(()=>{
                async function handlePaste() {
                    if (!clipboardItem || hasBeenCalled) return;
                    setHasBeenCalled(true);
                    onBeforeAction?.();
                    try {
                        await pasteHandler(clipboardItem, metadata);
                        onComplete(true);
                    } catch (error) {
                        onComplete(false, error);
                    }
                }
                if (action === 'paste') handlePaste();
            }, [
                clipboardItem,
                onComplete,
                pasteHandler,
                metadata,
                hasBeenCalled,
                action,
                onBeforeAction
            ]);
            (0, $5uXOq.useEffect)(()=>{
                async function handleCutOnly() {
                    if (hasBeenCalled) return;
                    setHasBeenCalled(true);
                    try {
                        await cutHandler();
                        onComplete(true);
                    } catch (error) {
                        onComplete(false, error);
                    }
                }
                if (action === 'cut-only') handleCutOnly();
            }, [
                clipboardItem,
                onComplete,
                cutHandler,
                metadata,
                hasBeenCalled,
                action,
                onBeforeAction,
                copyHandler
            ]);
            return null;
        };
});
parcelRegister("ks0ly", function(module, exports) {
    $parcel$export(module.exports, "useClipboardHandler", ()=>$2321e17aa8b25bd2$export$bc92cd7bfdca2774);
    var $5uXOq = parcelRequire("5uXOq");
    var $bj6Oi;
    var $2NMNM;
    var $1xoxe;
    var $3O2T0;
    function $2321e17aa8b25bd2$export$bc92cd7bfdca2774({ issue: issue, field: field, currentStringValue: currentStringValue, currentValue: currentValue, getPastedValue: getPastedValue, saveValue: saveValue, emptyValue: emptyValue }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const getContentToCopy = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("3O2T0")).getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue), [
            currentStringValue,
            currentValue,
            field,
            issue
        ]);
        const [contentToCopy, setContentToCopy] = (0, $5uXOq.useState)(getContentToCopy);
        (0, $5uXOq.useEffect)(()=>{
            if (contentToCopy?.html !== getContentToCopy()?.html) setContentToCopy(getContentToCopy());
        }, [
            getContentToCopy,
            contentToCopy
        ]);
        const copyHandler = (0, $5uXOq.useCallback)(async ()=>{
            const { html: html, plainText: plainText } = (0, (0, parcelRequire("3O2T0")).getFieldValueAsClipboardItem)(field, issue, currentStringValue, currentValue);
            if (!plainText || !html) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NULL_GETTER);
            await (0, (0, parcelRequire("3O2T0")).addToClipboard)(plainText, html);
        }, [
            currentStringValue,
            currentValue,
            field,
            issue
        ]);
        const pasteHandler = (0, $5uXOq.useCallback)(async (clipboardItem, metadata)=>{
            const value = getPastedValue(clipboardItem, metadata);
            if (!value || Array.isArray(value) && !value.length) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
            await saveValue(value, null, createAnalyticsEvent({}));
        }, [
            getPastedValue,
            saveValue,
            createAnalyticsEvent
        ]);
        const cutHandler = (0, $5uXOq.useCallback)(async ()=>{
            await saveValue(emptyValue ?? null, null, createAnalyticsEvent({}));
        }, [
            saveValue,
            emptyValue,
            createAnalyticsEvent
        ]);
        return {
            contentToCopy: contentToCopy,
            copyHandler: copyHandler,
            pasteHandler: pasteHandler,
            cutHandler: cutHandler
        };
    }
});
parcelRegister("3O2T0", function(module, exports) {
    $parcel$export(module.exports, "assertClipboardHasPlainTextFormat", ()=>$c7bbbd6441a8af75$export$4f1e704a7a6a6107);
    $parcel$export(module.exports, "assertClipboardHasRichFormat", ()=>$c7bbbd6441a8af75$export$acf1aef2ce2e9ad4);
    $parcel$export(module.exports, "assertClipboardDataIsCompatible", ()=>$c7bbbd6441a8af75$export$4957d49d1a7a1b9e);
    $parcel$export(module.exports, "getFieldValueAsClipboardItem", ()=>$c7bbbd6441a8af75$export$7afe662a0eda30a6);
    $parcel$export(module.exports, "addToClipboard", ()=>$c7bbbd6441a8af75$export$89af511f3acca517);
    $parcel$export(module.exports, "getCellValue", ()=>$c7bbbd6441a8af75$export$b1f6fa0c5f374def);
    var $bj6Oi;
    var $4R6GH;
    var $9mWE9;
    var $1xoxe;
    function $c7bbbd6441a8af75$export$4f1e704a7a6a6107(clipboardItem) {
        if (!clipboardItem?.plainText) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD);
        return true;
    }
    function $c7bbbd6441a8af75$export$acf1aef2ce2e9ad4(clipboardItem) {
        $c7bbbd6441a8af75$export$4f1e704a7a6a6107(clipboardItem);
        if (!clipboardItem?.html) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
        return true;
    }
    function $c7bbbd6441a8af75$export$4957d49d1a7a1b9e(metadata, compatibleTypes) {
        if (!metadata?.fieldType || !compatibleTypes.includes(metadata?.fieldType)) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
        return true;
    }
    function $c7bbbd6441a8af75$var$getStringifiedRichFieldValue(richValue) {
        if (!richValue) return null;
        if (typeof richValue === 'string') return {
            value: richValue
        };
        return richValue;
    }
    const $c7bbbd6441a8af75$var$safelyAddRichValueToHtml = (html, richValue)=>{
        try {
            const DOM = new DOMParser().parseFromString(html, 'text/html');
            DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(richValue));
            return DOM.body?.innerHTML || '';
        } catch (e) {
            return html;
        }
    };
    function $c7bbbd6441a8af75$export$7afe662a0eda30a6(field, issue, textValue, value) {
        const richValue = $c7bbbd6441a8af75$var$getStringifiedRichFieldValue(value);
        if (!textValue) return {};
        const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
        return {
            html: richValue ? $c7bbbd6441a8af75$var$safelyAddRichValueToHtml(html, richValue) : html,
            plainText: textValue
        };
    }
    const $c7bbbd6441a8af75$export$89af511f3acca517 = (plainText, html)=>{
        const blobPlain = new window.Blob([
            plainText
        ], {
            type: 'text/plain'
        });
        const blobHTML = new window.Blob([
            html
        ], {
            type: 'text/html'
        });
        const clipboardItem = new window.ClipboardItem({
            'text/html': blobHTML,
            'text/plain': blobPlain
        });
        return (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard.write([
            clipboardItem
        ]) : navigator.clipboard.write([
            clipboardItem
        ]);
    };
    const $c7bbbd6441a8af75$export$b1f6fa0c5f374def = (field, issue, formatMessage)=>{
        const textValue = (0, (0, parcelRequire("9mWE9")).getStringValue)(field.type, field, formatMessage);
        const richValue = $c7bbbd6441a8af75$var$getStringifiedRichFieldValue((0, (0, parcelRequire("9mWE9")).getRichOrStringValue)(field.type, field));
        if (!textValue) return {};
        const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
        return {
            html: richValue ? $c7bbbd6441a8af75$var$safelyAddRichValueToHtml(html, richValue) : html,
            plainText: textValue
        };
    };
});
parcelRegister("9mWE9", function(module, exports) {
    $parcel$export(module.exports, "getStringValue", ()=>$6e5ff40d78ee90c0$export$5da374e426806c6a);
    $parcel$export(module.exports, "isStringValueSupported", ()=>$6e5ff40d78ee90c0$export$c7e2e8fb7867bf39);
    $parcel$export(module.exports, "getRichOrStringValue", ()=>$6e5ff40d78ee90c0$export$efe475f7dd73bf7c);
    var $8QpSo;
    var $jKNTt;
    var $hnYsi;
    var $bkhZT;
    var $4ckl0;
    var $9FPlx;
    var $j0kCu;
    var $4436V;
    var $4r55J;
    var $1q6eD;
    var $k0gwt;
    var $8oWyK;
    var $3ebyg;
    var $lDYU1;
    var $iPTHj;
    var $a7Aen;
    var $6IPMF;
    var $cNLaA;
    var $ha4No;
    var $7T77A;
    var $kIloX;
    var $6sBiS;
    var $bv3n4;
    var $eVlry;
    var $fD5gp;
    var $gaDgh;
    var $6NkwW;
    var $ayYAS;
    var $4q3hR;
    var $4OYfI;
    var $55rRx;
    const $6e5ff40d78ee90c0$var$createStringValueHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("hnYsi")).categoryStringValueHandler),
            ...(0, (0, parcelRequire("bkhZT")).checkboxStringValueHandler),
            ...(0, (0, parcelRequire("4ckl0")).componentsStringValueHandler),
            ...(0, (0, parcelRequire("55rRx")).versionStringValueHandler),
            ...(0, (0, parcelRequire("iPTHj")).parentStringValueHandler),
            ...(0, (0, parcelRequire("4436V")).devSummaryStringValueHandler),
            ...(0, (0, parcelRequire("8oWyK")).labelsStringValueHandler),
            ...(0, (0, parcelRequire("lDYU1")).numberStringValueHandler),
            ...(0, (0, parcelRequire("k0gwt")).keyStringValueHandler),
            ...(0, (0, parcelRequire("ayYAS")).typeStringValueHandler),
            ...(0, (0, parcelRequire("4OYfI")).userStringValueHandler),
            ...(0, (0, parcelRequire("fD5gp")).teamStringValueHandler),
            ...(0, (0, parcelRequire("1q6eD")).groupStringValueHandler),
            ...(0, (0, parcelRequire("ha4No")).resolutionStringValueHandler),
            ...(0, (0, parcelRequire("j0kCu")).dateTimeStringValueHandler),
            ...(0, (0, parcelRequire("9FPlx")).dateStringValueHandler),
            ...(0, (0, parcelRequire("4r55J")).goalStringValueHandler),
            ...(0, (0, parcelRequire("gaDgh")).textStringValueHandler),
            ...(0, (0, parcelRequire("a7Aen")).priorityStringValueHandler),
            ...(0, (0, parcelRequire("cNLaA")).radioSelectStringValueHandler),
            ...(0, (0, parcelRequire("4q3hR")).urlStringValueHandler),
            ...(0, (0, parcelRequire("3ebyg")).multiSelectStringValueHandler),
            ...(0, (0, parcelRequire("eVlry")).statusStringValueHandler),
            ...(0, (0, parcelRequire("bv3n4")).statusCategoryStringValueHandler),
            ...(0, (0, parcelRequire("6NkwW")).timeTrackingStringValueHandler),
            ...(0, (0, parcelRequire("kIloX")).singleSelectStringValueHandler),
            ...(0, (0, parcelRequire("6sBiS")).sprintStringValueHandler),
            ...(0, (0, parcelRequire("7T77A")).richTextStringValueHandler),
            ...(0, (0, parcelRequire("6IPMF")).projectStringValueHandler),
            ...(0, (0, parcelRequire("jKNTt")).cascadingSelectStringValueHandler)
        }));
    const $6e5ff40d78ee90c0$export$5da374e426806c6a = (fieldType, ...args)=>{
        const handlers = $6e5ff40d78ee90c0$var$createStringValueHandlers();
        if (handlers[fieldType] == null) return;
        return handlers[fieldType]?.(...args);
    };
    const $6e5ff40d78ee90c0$export$c7e2e8fb7867bf39 = (fieldType)=>{
        const handlers = $6e5ff40d78ee90c0$var$createStringValueHandlers();
        return handlers[fieldType] != null;
    };
    const $6e5ff40d78ee90c0$var$createRichValueHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("hnYsi")).categoryRichValueHandler),
            ...(0, (0, parcelRequire("bkhZT")).checkboxRichValueHandler),
            ...(0, (0, parcelRequire("4ckl0")).componentsRichValueHandler),
            ...(0, (0, parcelRequire("4OYfI")).userRichValueHandler),
            ...(0, (0, parcelRequire("55rRx")).versionRichValueHandler),
            ...(0, (0, parcelRequire("a7Aen")).priorityRichValueHandler),
            ...(0, (0, parcelRequire("3ebyg")).multiSelectRichValueHandler),
            ...(0, (0, parcelRequire("kIloX")).singleSelectRichValueHandler),
            ...(0, (0, parcelRequire("6sBiS")).sprintRichValueHandler),
            ...(0, (0, parcelRequire("iPTHj")).parentRichValueHandler),
            ...(0, (0, parcelRequire("fD5gp")).teamRichValueHandler),
            ...(0, (0, parcelRequire("6IPMF")).projectRichValueHandler),
            ...(0, (0, parcelRequire("1q6eD")).groupRichValueHandler),
            ...(0, (0, parcelRequire("jKNTt")).cascadingSelectRichValueHandler),
            ...(0, (0, parcelRequire("cNLaA")).radioSelectRichValueHandler)
        }));
    const $6e5ff40d78ee90c0$export$3c808f0df8be4abb = (fieldType)=>{
        const handlers = $6e5ff40d78ee90c0$var$createRichValueHandlers();
        if (fieldType in handlers) return true;
        return false;
    };
    const $6e5ff40d78ee90c0$export$efe475f7dd73bf7c = (fieldType, ...args)=>{
        const handlers = $6e5ff40d78ee90c0$var$createRichValueHandlers();
        if ($6e5ff40d78ee90c0$export$3c808f0df8be4abb(fieldType)) return (handlers[fieldType]?.(...args));
        return $6e5ff40d78ee90c0$export$5da374e426806c6a(fieldType, ...args);
    };
});
parcelRegister("hnYsi", function(module, exports) {
    $parcel$export(module.exports, "categoryStringValueHandler", ()=>$1b891cb4842f6194$export$648bd4153bebf5ec);
    $parcel$export(module.exports, "categoryRichValueHandler", ()=>$1b891cb4842f6194$export$c7c1e80cbae33846);
    var $5fc53;
    const $1b891cb4842f6194$var$getCategoryStringValue = (field)=>String(field.value?.value ?? '');
    const $1b891cb4842f6194$export$648bd4153bebf5ec = {
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: $1b891cb4842f6194$var$getCategoryStringValue
    };
    const $1b891cb4842f6194$var$getCategoryRichValue = (field)=>field.value ?? null;
    const $1b891cb4842f6194$export$c7c1e80cbae33846 = {
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: $1b891cb4842f6194$var$getCategoryRichValue
    };
});
parcelRegister("bkhZT", function(module, exports) {
    $parcel$export(module.exports, "checkboxStringValueHandler", ()=>$46beb28657e205e5$export$e8595eb8b08dfff6);
    $parcel$export(module.exports, "checkboxRichValueHandler", ()=>$46beb28657e205e5$export$8c6878c535c99dc0);
    var $5fc53;
    const $46beb28657e205e5$var$getCheckboxValue = (field)=>String(field.value?.map((option)=>option?.value || '').join(', ') || '');
    const $46beb28657e205e5$export$e8595eb8b08dfff6 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $46beb28657e205e5$var$getCheckboxValue
    };
    const $46beb28657e205e5$var$getCheckboxRichValue = (field)=>field.value ?? [];
    const $46beb28657e205e5$export$8c6878c535c99dc0 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $46beb28657e205e5$var$getCheckboxRichValue
    };
});
parcelRegister("4ckl0", function(module, exports) {
    $parcel$export(module.exports, "componentsStringValueHandler", ()=>$cea76a4879655623$export$8c05fcecf4920250);
    $parcel$export(module.exports, "componentsRichValueHandler", ()=>$cea76a4879655623$export$22a98ba00b45930);
    var $5fc53;
    const $cea76a4879655623$var$getComponentsStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
    const $cea76a4879655623$export$8c05fcecf4920250 = {
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: $cea76a4879655623$var$getComponentsStringValue
    };
    const $cea76a4879655623$var$getComponentsRichValue = (field)=>field.value ?? [];
    const $cea76a4879655623$export$22a98ba00b45930 = {
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: $cea76a4879655623$var$getComponentsRichValue
    };
});
parcelRegister("9FPlx", function(module, exports) {
    $parcel$export(module.exports, "dateStringValueHandler", ()=>$4da089b6762dd39d$export$e35cf2b38b82bde);
    var $k7m40;
    var $4R6GH;
    var $5fc53;
    const $4da089b6762dd39d$var$getDateValue = (field)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_view_bulk_copy_date_fix')) {
            if (field.value && (field.type === (0, (0, parcelRequire("5fc53")).CREATED) || field.type === (0, (0, parcelRequire("5fc53")).UPDATED))) return (0, (0, parcelRequire("k7m40")).default)(new Date(field.value), 'yyyy-MM-dd');
            return field.value || '';
        }
        return field.value && (0, (0, parcelRequire("4R6GH")).fg)('list_view_small_bulk_copy_fixes') ? (0, (0, parcelRequire("k7m40")).default)(new Date(field.value), 'yyyy-MM-dd') : field.value || '';
    };
    const $4da089b6762dd39d$export$e35cf2b38b82bde = {
        [(0, (0, parcelRequire("5fc53")).START_DATE_TYPE)]: $4da089b6762dd39d$var$getDateValue,
        [(0, (0, parcelRequire("5fc53")).UPDATED)]: $4da089b6762dd39d$var$getDateValue,
        [(0, (0, parcelRequire("5fc53")).CREATED)]: $4da089b6762dd39d$var$getDateValue,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $4da089b6762dd39d$var$getDateValue,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $4da089b6762dd39d$var$getDateValue
    };
});
parcelRegister("j0kCu", function(module, exports) {
    $parcel$export(module.exports, "dateTimeStringValueHandler", ()=>$9ef6e18d548be661$export$3364b5b1994fef68);
    var $5fc53;
    const $9ef6e18d548be661$var$getDateTimeValue = (field)=>field.value || '';
    const $9ef6e18d548be661$export$3364b5b1994fef68 = {
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $9ef6e18d548be661$var$getDateTimeValue
    };
});
parcelRegister("4436V", function(module, exports) {
    $parcel$export(module.exports, "devSummaryStringValueHandler", ()=>$b2aa768b91edea85$export$92f03a013990abef);
    var $5fc53;
    var $jTRqe;
    const $b2aa768b91edea85$var$getDevSummaryValue = (field, formatMessage)=>{
        if (formatMessage && field) {
            if (field.isMerged) return formatMessage((0, (0, parcelRequire("jTRqe")).default).merged);
            if (field.isUnderReview) return formatMessage((0, (0, parcelRequire("jTRqe")).default).underReview);
            if (field.commitCount) return formatMessage((0, (0, parcelRequire("jTRqe")).default).commit, {
                count: field.commitCount
            });
        }
        return '';
    };
    const $b2aa768b91edea85$export$92f03a013990abef = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: $b2aa768b91edea85$var$getDevSummaryValue
    };
});
parcelRegister("jTRqe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d9a7893539a3bb7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9d9a7893539a3bb7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        underReview: {
            "id": "business-fields.common.field-types.dev-summary.value.under-review",
            "defaultMessage": "Under review"
        },
        merged: {
            "id": "business-fields.common.field-types.dev-summary.value.merged",
            "defaultMessage": "Merged"
        },
        commit: {
            "id": "business-fields.common.field-types.dev-summary.value.commit",
            "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
        }
    });
});
parcelRegister("4r55J", function(module, exports) {
    $parcel$export(module.exports, "goalStringValueHandler", ()=>$435d98029b25b04d$export$fc09a341d50e572e);
    var $5fc53;
    const $435d98029b25b04d$export$75c4ea7a4006e4cc = (fieldValue)=>{
        const goalsStringValue = fieldValue.goals.map((goal)=>goal.name).join(', ');
        const remainingCount = fieldValue.totalCount - fieldValue.goals.length;
        if (remainingCount > 0) return `${goalsStringValue} +${remainingCount}`;
        return goalsStringValue;
    };
    const $435d98029b25b04d$var$getGoalsSelectValue = (field)=>$435d98029b25b04d$export$75c4ea7a4006e4cc(field.value);
    const $435d98029b25b04d$export$fc09a341d50e572e = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: $435d98029b25b04d$var$getGoalsSelectValue
    };
});
parcelRegister("1q6eD", function(module, exports) {
    $parcel$export(module.exports, "groupStringValueHandler", ()=>$3a1a62e1b381c27a$export$520e19bcc394328a);
    $parcel$export(module.exports, "groupRichValueHandler", ()=>$3a1a62e1b381c27a$export$2df4c615ae11e379);
    var $5fc53;
    const $3a1a62e1b381c27a$var$getSingleGroupValue = (field)=>field.value?.name ?? '';
    const $3a1a62e1b381c27a$var$getMultipleGroupValue = (field)=>field.value == null ? '' : field.value.map((v)=>v?.name).join(',');
    const $3a1a62e1b381c27a$var$getSingleGroupRichValue = (field)=>field.value ?? null;
    const $3a1a62e1b381c27a$var$getMultipleGroupRichValue = (field)=>field.value ?? [];
    const $3a1a62e1b381c27a$export$520e19bcc394328a = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getSingleGroupValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getMultipleGroupValue
    };
    const $3a1a62e1b381c27a$export$2df4c615ae11e379 = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getSingleGroupRichValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $3a1a62e1b381c27a$var$getMultipleGroupRichValue
    };
});
parcelRegister("k0gwt", function(module, exports) {
    $parcel$export(module.exports, "keyStringValueHandler", ()=>$4ab5244b7319c856$export$6a82d6d16aaf1aae);
    const $4ab5244b7319c856$var$getKeyValue = (field)=>String(field.value || '');
    const $4ab5244b7319c856$export$6a82d6d16aaf1aae = {
        key: $4ab5244b7319c856$var$getKeyValue
    };
});
parcelRegister("8oWyK", function(module, exports) {
    $parcel$export(module.exports, "labelsStringValueHandler", ()=>$444aac30a5c82b3f$export$614150a18e87c3e9);
    var $5fc53;
    const $444aac30a5c82b3f$var$getLabelsValue = (field)=>String(field.value.join(', ') || '');
    const $444aac30a5c82b3f$export$614150a18e87c3e9 = {
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $444aac30a5c82b3f$var$getLabelsValue,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $444aac30a5c82b3f$var$getLabelsValue
    };
});
parcelRegister("3ebyg", function(module, exports) {
    $parcel$export(module.exports, "multiSelectStringValueHandler", ()=>$f30130b65ee57709$export$a8b18450ad254ab4);
    $parcel$export(module.exports, "multiSelectRichValueHandler", ()=>$f30130b65ee57709$export$5b873e39c38cc9ad);
    var $5fc53;
    const $f30130b65ee57709$var$getMultiSelectStringValue = (field)=>String(field.value?.map((option)=>option?.value ?? '').join(', ') ?? '');
    const $f30130b65ee57709$export$a8b18450ad254ab4 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $f30130b65ee57709$var$getMultiSelectStringValue
    };
    const $f30130b65ee57709$var$getMultiSelectRichValue = (field)=>field.value ?? [];
    const $f30130b65ee57709$export$5b873e39c38cc9ad = {
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $f30130b65ee57709$var$getMultiSelectRichValue
    };
});
parcelRegister("lDYU1", function(module, exports) {
    $parcel$export(module.exports, "numberStringValueHandler", ()=>$c17bd39a28c9b001$export$e0e13344aaa5277f);
    var $5fc53;
    const $c17bd39a28c9b001$var$getNumberValue = (field)=>String(field.value || '');
    const $c17bd39a28c9b001$export$e0e13344aaa5277f = {
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $c17bd39a28c9b001$var$getNumberValue,
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: $c17bd39a28c9b001$var$getNumberValue,
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: $c17bd39a28c9b001$var$getNumberValue
    };
});
parcelRegister("iPTHj", function(module, exports) {
    $parcel$export(module.exports, "parentStringValueHandler", ()=>$c4c1a0f4617bd749$export$c53efd3fefacccdb);
    $parcel$export(module.exports, "parentRichValueHandler", ()=>$c4c1a0f4617bd749$export$bd920f00473058fd);
    var $5fc53;
    const $c4c1a0f4617bd749$var$getParentValue = (field)=>field.value ? field.value.issueKey : '';
    const $c4c1a0f4617bd749$export$c53efd3fefacccdb = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $c4c1a0f4617bd749$var$getParentValue
    };
    const $c4c1a0f4617bd749$var$getParentRichValue = (field)=>field.value ?? null;
    const $c4c1a0f4617bd749$export$bd920f00473058fd = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $c4c1a0f4617bd749$var$getParentRichValue
    };
});
parcelRegister("a7Aen", function(module, exports) {
    $parcel$export(module.exports, "priorityStringValueHandler", ()=>$3673cf72ee9bcf66$export$2fcd34cd217ed0e0);
    $parcel$export(module.exports, "priorityRichValueHandler", ()=>$3673cf72ee9bcf66$export$74a600c7fe980807);
    var $4R6GH;
    var $5fc53;
    const $3673cf72ee9bcf66$var$isNewTransformedPriorityField = (field)=>typeof field.value === 'object' && 'name' in (field.value || {});
    const $3673cf72ee9bcf66$var$isOldTransformedPriorityField = (field)=>typeof field.value === 'string';
    const $3673cf72ee9bcf66$var$getPriorityValueOld = (field)=>field.value?.name || '';
    const $3673cf72ee9bcf66$var$getPriorityValue = (field)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_view_small_bulk_copy_fixes')) {
            if ($3673cf72ee9bcf66$var$isNewTransformedPriorityField(field)) return field.value?.name || '';
            if ($3673cf72ee9bcf66$var$isOldTransformedPriorityField(field)) return field.value;
            return '';
        }
        return $3673cf72ee9bcf66$var$getPriorityValueOld(field);
    };
    const $3673cf72ee9bcf66$export$2fcd34cd217ed0e0 = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $3673cf72ee9bcf66$var$getPriorityValue
    };
    const $3673cf72ee9bcf66$var$getPriorityRichValue = (field)=>field.value || null;
    const $3673cf72ee9bcf66$export$74a600c7fe980807 = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $3673cf72ee9bcf66$var$getPriorityRichValue
    };
});
parcelRegister("6IPMF", function(module, exports) {
    $parcel$export(module.exports, "projectStringValueHandler", ()=>$542d9437b6783744$export$ac54e893c65fec32);
    $parcel$export(module.exports, "projectRichValueHandler", ()=>$542d9437b6783744$export$24de57791a81b4b0);
    var $5fc53;
    const $542d9437b6783744$var$getProjectValue = (field)=>field.value?.name ?? '';
    const $542d9437b6783744$export$ac54e893c65fec32 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $542d9437b6783744$var$getProjectValue
    };
    const $542d9437b6783744$var$getProjectRichValue = (field)=>field.value ?? null;
    const $542d9437b6783744$export$24de57791a81b4b0 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $542d9437b6783744$var$getProjectRichValue
    };
});
parcelRegister("cNLaA", function(module, exports) {
    $parcel$export(module.exports, "radioSelectStringValueHandler", ()=>$43d3560737b9942f$export$5716e87f97e42f22);
    $parcel$export(module.exports, "radioSelectRichValueHandler", ()=>$43d3560737b9942f$export$c28597602359ee5);
    var $5fc53;
    const $43d3560737b9942f$var$getRadioSelectValue = (field)=>field.value?.value ?? '';
    const $43d3560737b9942f$export$5716e87f97e42f22 = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $43d3560737b9942f$var$getRadioSelectValue
    };
    const $43d3560737b9942f$var$getRadioSelectRichValue = (field)=>field.value ?? null;
    const $43d3560737b9942f$export$c28597602359ee5 = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $43d3560737b9942f$var$getRadioSelectRichValue
    };
});
parcelRegister("ha4No", function(module, exports) {
    $parcel$export(module.exports, "resolutionStringValueHandler", ()=>$5582bb0e1df9d6cf$export$ce4b64838599caf9);
    var $5fc53;
    var $k8BN5;
    const $5582bb0e1df9d6cf$var$getResolutionValue = (field, formatMessage)=>{
        if (field.value?.name) return field.value?.name;
        return formatMessage ? formatMessage((0, (0, parcelRequire("k8BN5")).default).unresolvedResolution) : '';
    };
    const $5582bb0e1df9d6cf$export$ce4b64838599caf9 = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: $5582bb0e1df9d6cf$var$getResolutionValue
    };
});
parcelRegister("k8BN5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3602b5c2c6ac20d9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3602b5c2c6ac20d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unresolvedResolution: {
            "id": "business-fields.common.field-types.resolution.value.unresolved-resolution",
            "defaultMessage": "Unresolved"
        }
    });
});
parcelRegister("7T77A", function(module, exports) {
    $parcel$export(module.exports, "richTextStringValueHandler", ()=>$f6dcab5e3bea46a6$export$b6df34212c07f1f3);
    var $5fc53;
    const $f6dcab5e3bea46a6$var$getStringValue = (field)=>String(field.value || '');
    const $f6dcab5e3bea46a6$export$b6df34212c07f1f3 = {
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: $f6dcab5e3bea46a6$var$getStringValue
    };
});
parcelRegister("kIloX", function(module, exports) {
    $parcel$export(module.exports, "singleSelectStringValueHandler", ()=>$579e3ef3b403676c$export$6477cb7a98167465);
    $parcel$export(module.exports, "singleSelectRichValueHandler", ()=>$579e3ef3b403676c$export$8f1681f1304731e9);
    var $5fc53;
    const $579e3ef3b403676c$var$getSingleSelectValue = (field)=>String(field.value?.value || '');
    const $579e3ef3b403676c$export$6477cb7a98167465 = {
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $579e3ef3b403676c$var$getSingleSelectValue
    };
    const $579e3ef3b403676c$var$getSingleSelectRichValue = (field)=>field.value || null;
    const $579e3ef3b403676c$export$8f1681f1304731e9 = {
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $579e3ef3b403676c$var$getSingleSelectRichValue
    };
});
parcelRegister("6sBiS", function(module, exports) {
    $parcel$export(module.exports, "sprintStringValueHandler", ()=>$9a4dceb1207c7cf8$export$c934a6ef333435f4);
    $parcel$export(module.exports, "sprintRichValueHandler", ()=>$9a4dceb1207c7cf8$export$363144cf26cab14d);
    var $5fc53;
    const $9a4dceb1207c7cf8$var$getSprintStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
    const $9a4dceb1207c7cf8$export$c934a6ef333435f4 = {
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: $9a4dceb1207c7cf8$var$getSprintStringValue
    };
    const $9a4dceb1207c7cf8$var$getSprintRichValue = (field)=>field.value ?? [];
    const $9a4dceb1207c7cf8$export$363144cf26cab14d = {
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: $9a4dceb1207c7cf8$var$getSprintRichValue
    };
});
parcelRegister("bv3n4", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryStringValueHandler", ()=>$41eba0e4a35a010c$export$fbf872252a7f1d2d);
    var $5fc53;
    const $41eba0e4a35a010c$var$getStatusCategoryValue = (field)=>field.value?.name ?? '';
    const $41eba0e4a35a010c$export$fbf872252a7f1d2d = {
        [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: $41eba0e4a35a010c$var$getStatusCategoryValue
    };
});
parcelRegister("eVlry", function(module, exports) {
    $parcel$export(module.exports, "statusStringValueHandler", ()=>$9a139c828513cd4a$export$237f3a01398656da);
    var $5fc53;
    const $9a139c828513cd4a$var$getStatusValue = (field)=>String(field.name || '');
    const $9a139c828513cd4a$export$237f3a01398656da = {
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: $9a139c828513cd4a$var$getStatusValue
    };
});
parcelRegister("fD5gp", function(module, exports) {
    $parcel$export(module.exports, "teamStringValueHandler", ()=>$d10084d34c71b8cd$export$b5a765abdc307683);
    $parcel$export(module.exports, "teamRichValueHandler", ()=>$d10084d34c71b8cd$export$c73de7087af53cf7);
    var $5fc53;
    const $d10084d34c71b8cd$var$getTeamValue = (field)=>field.value?.name ?? '';
    const $d10084d34c71b8cd$export$b5a765abdc307683 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: $d10084d34c71b8cd$var$getTeamValue
    };
    const $d10084d34c71b8cd$var$getTeamRichValue = (field)=>field.value ?? null;
    const $d10084d34c71b8cd$export$c73de7087af53cf7 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: $d10084d34c71b8cd$var$getTeamRichValue
    };
});
parcelRegister("gaDgh", function(module, exports) {
    $parcel$export(module.exports, "textStringValueHandler", ()=>$78fd0eaf044fb7cb$export$ec13eae086c24fc4);
    var $5fc53;
    const $78fd0eaf044fb7cb$var$getTextValue = (field)=>String(field.value || '');
    const $78fd0eaf044fb7cb$export$ec13eae086c24fc4 = {
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $78fd0eaf044fb7cb$var$getTextValue,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $78fd0eaf044fb7cb$var$getTextValue
    };
});
parcelRegister("6NkwW", function(module, exports) {
    $parcel$export(module.exports, "timeTrackingStringValueHandler", ()=>$820aa870fe03580c$export$d2867bf3f48fbaac);
    var $4R6GH;
    var $5fc53;
    const $820aa870fe03580c$var$getStringValue = (field)=>(0, (0, parcelRequire("4R6GH")).fg)('list_view_small_bulk_copy_fixes') ? field.value?.timeAsString || '' : String(field.value?.timeInSeconds || '');
    const $820aa870fe03580c$export$d2867bf3f48fbaac = {
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: $820aa870fe03580c$var$getStringValue
    };
});
parcelRegister("ayYAS", function(module, exports) {
    $parcel$export(module.exports, "typeStringValueHandler", ()=>$4822c57804ac4083$export$8a5121728c374439);
    var $5fc53;
    const $4822c57804ac4083$var$getTypeValue = (field)=>String(field.value || '');
    const $4822c57804ac4083$export$8a5121728c374439 = {
        [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: $4822c57804ac4083$var$getTypeValue
    };
});
parcelRegister("4q3hR", function(module, exports) {
    $parcel$export(module.exports, "urlStringValueHandler", ()=>$cef1dc7a90fd274d$export$7f5de2e826ef2c21);
    var $5fc53;
    const $cef1dc7a90fd274d$var$getUrlValue = (field)=>String(field.value || '');
    const $cef1dc7a90fd274d$export$7f5de2e826ef2c21 = {
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: $cef1dc7a90fd274d$var$getUrlValue
    };
});
parcelRegister("4OYfI", function(module, exports) {
    $parcel$export(module.exports, "userStringValueHandler", ()=>$26297ec6841ed337$export$160c08a2783fe34b);
    $parcel$export(module.exports, "userRichValueHandler", ()=>$26297ec6841ed337$export$5fad1a6b4b204395);
    var $5fc53;
    const $26297ec6841ed337$var$getUserStringValue = (field)=>String(field.value?.name || '');
    const $26297ec6841ed337$var$getUsersStringValue = (field)=>String(field.value.map((user)=>user?.name).join(', ') || '');
    const $26297ec6841ed337$export$160c08a2783fe34b = {
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $26297ec6841ed337$var$getUserStringValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: $26297ec6841ed337$var$getUsersStringValue,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $26297ec6841ed337$var$getUsersStringValue
    };
    const $26297ec6841ed337$var$getUserRichValue = (field)=>field.value || null;
    const $26297ec6841ed337$var$getUserListRichValue = (field)=>field.value || [];
    const $26297ec6841ed337$export$5fad1a6b4b204395 = {
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $26297ec6841ed337$var$getUserRichValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: $26297ec6841ed337$var$getUserListRichValue,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $26297ec6841ed337$var$getUserListRichValue
    };
});
parcelRegister("55rRx", function(module, exports) {
    $parcel$export(module.exports, "versionStringValueHandler", ()=>$5fc1c692afc7905d$export$608329dccbc25996);
    $parcel$export(module.exports, "versionRichValueHandler", ()=>$5fc1c692afc7905d$export$534995286ab15bde);
    var $5fc53;
    const $5fc1c692afc7905d$var$getSingleVersionValue = (field)=>field.value?.name ?? '';
    const $5fc1c692afc7905d$var$getMultipleVersionValue = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $5fc1c692afc7905d$var$getSingleVersionRichValue = (field)=>field.value ?? null;
    const $5fc1c692afc7905d$var$getMultipleVersionRichValue = (field)=>field.value ?? [];
    const $5fc1c692afc7905d$export$608329dccbc25996 = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getSingleVersionValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionValue
    };
    const $5fc1c692afc7905d$export$534995286ab15bde = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getSingleVersionRichValue,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $5fc1c692afc7905d$var$getMultipleVersionRichValue
    };
});
parcelRegister("jhaRN", function(module, exports) {
    $parcel$export(module.exports, "categoryClipboardHandler", ()=>$7aabea9eb9c86fb2$export$b2a7ae1b92d8afd3);
    var $lQE94;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $9aWWe;
    const $7aabea9eb9c86fb2$var$isCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
    const $7aabea9eb9c86fb2$var$isTransformedCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
    const $7aabea9eb9c86fb2$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("9aWWe")).categorySupportedTypes))) return null;
        if (!$7aabea9eb9c86fb2$var$isCategory(metadata.fieldValue)) return null;
        return metadata.fieldValue;
    };
    const $7aabea9eb9c86fb2$var$useCategoryClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            fieldType: (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
            initialValue: field.value && $7aabea9eb9c86fb2$var$isTransformedCategory(field.value) ? {
                id: field.value.optionId,
                value: field.value.value,
                color: field.value?.color
            } : null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.value || '',
            currentValue: value,
            getPastedValue: $7aabea9eb9c86fb2$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $7aabea9eb9c86fb2$var$CategoryClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($7aabea9eb9c86fb2$var$useCategoryClipboardHandler);
    const $7aabea9eb9c86fb2$export$b2a7ae1b92d8afd3 = {
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: $7aabea9eb9c86fb2$var$CategoryClipboardHelper
    };
});
parcelRegister("9aWWe", function(module, exports) {
    $parcel$export(module.exports, "categorySupportedTypes", ()=>$2f068fc1b946612b$export$7a3abb279a994c7d);
    var $5fc53;
    const $2f068fc1b946612b$export$7a3abb279a994c7d = [
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)
    ];
});
parcelRegister("auKIK", function(module, exports) {
    $parcel$export(module.exports, "checkboxClipboardHandler", ()=>$2abffd1afef5cafd$export$a637ce753d346a9a);
    var $7Y3nn;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $8jn7A;
    const $2abffd1afef5cafd$var$isTransformedCheckboxOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
    const $2abffd1afef5cafd$var$isTransformedCheckbox = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($2abffd1afef5cafd$var$isTransformedCheckboxOption);
    const $2abffd1afef5cafd$var$isCheckboxValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
    const $2abffd1afef5cafd$var$emptyValue = [];
    const $2abffd1afef5cafd$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("8jn7A")).checkboxSupportedTypes))) return [];
        if (!$2abffd1afef5cafd$var$isCheckboxValue(metadata?.fieldValue)) return [];
        return metadata?.fieldValue ?? [];
    };
    function $2abffd1afef5cafd$var$assertCheckboxField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $2abffd1afef5cafd$var$useCheckboxClipboardHandler = (issue, field)=>{
        $2abffd1afef5cafd$var$assertCheckboxField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("7Y3nn")).useCheckboxSelectField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            initialValue: $2abffd1afef5cafd$var$isTransformedCheckbox(field.value) ? field.value.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? ''
                })) : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map((option)=>option?.value || '').join(', ') || '',
            currentValue: value,
            getPastedValue: $2abffd1afef5cafd$var$getPastedValue,
            saveValue: saveValue,
            emptyValue: $2abffd1afef5cafd$var$emptyValue
        });
    };
    const $2abffd1afef5cafd$var$CheckboxClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($2abffd1afef5cafd$var$useCheckboxClipboardHandler);
    const $2abffd1afef5cafd$export$a637ce753d346a9a = {
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $2abffd1afef5cafd$var$CheckboxClipboardHelper
    };
});
parcelRegister("7Y3nn", function(module, exports) {
    $parcel$export(module.exports, "useCheckboxSelectField", ()=>$d31cc439efc1ff22$export$64fe88e084e8ce22);
    var $lQE94;
    var $54wEF;
    var $69oHP;
    const $d31cc439efc1ff22$export$64fe88e084e8ce22 = ({ issueKey: issueKey, initialValue: initialValue = null, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, (0, parcelRequire("69oHP")).getFieldType)(fieldConfig.value) || 'array';
        const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                loading: loading,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                saveById: saveById,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("54wEF", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfig", ()=>$a5085d8f4019d625$export$5406c21e0d275680);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$217a0e2f2962f4ae);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", ()=>$a5085d8f4019d625$export$5f641a998c6dfa06);
    $parcel$export(module.exports, "useFieldConfig", ()=>$a5085d8f4019d625$export$70da50df1be2dbe1);
    $parcel$export(module.exports, "useFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$1eed575f8f3334eb);
    $parcel$export(module.exports, "useFieldConfigActions", ()=>$a5085d8f4019d625$export$28a22fd0dedf31b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $e5wyW;
    var $4R6GH;
    var $jJZqs;
    var $eusud;
    var $iZIvy;
    var $eDXka;
    var $gXz4p;
    var $biQrn;
    var $2N3tQ;
    const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
    const $a5085d8f4019d625$var$fetchDataOld = async (issueKey)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce((result, field)=>({
                ...result,
                [field.key]: {
                    autoCompleteUrl: field.autoCompleteUrl,
                    allowedValues: field.allowedValues,
                    isEditable: field.editable,
                    isRequired: field.required,
                    schema: field.schema,
                    title: field.title,
                    ...field.description ? {
                        description: field.description
                    } : {}
                }
            }), {});
        return null;
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION,
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: 'Issue View Field Configuration Query',
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error?.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {}
        }));
    };
    const $a5085d8f4019d625$var$fetchDataWithExperienceTracking = async (issueKey)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
                body: JSON.stringify({
                    query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                    variables: {
                        issueKey: issueKey
                    }
                })
            });
            if (response?.data?.issue?.fields) {
                const fieldConfigData = response.data.issue.fields.reduce((result, field)=>({
                        ...result,
                        [field.key]: {
                            autoCompleteUrl: field.autoCompleteUrl,
                            allowedValues: field.allowedValues,
                            isEditable: field.editable,
                            isRequired: field.required,
                            schema: field.schema,
                            title: field.title,
                            ...field.description ? {
                                description: field.description
                            } : {}
                        }
                    }), {});
                $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                    wasExperienceSuccessful: true
                });
                return fieldConfigData;
            }
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: new Error('Unexpected field configuration response')
            });
            return null;
        } catch (error) {
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            return null;
        }
    };
    const $a5085d8f4019d625$var$fetchData = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-18890-field-configuration-query-exp-tracking'), $a5085d8f4019d625$var$fetchDataWithExperienceTracking, $a5085d8f4019d625$var$fetchDataOld);
    const $a5085d8f4019d625$var$requestSet = new Set();
    const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
        skipRefresh: false
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [, { setIssueConfig: setIssueConfig }] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
        const getData = (0, $5uXOq.useCallback)(async ()=>{
            setLoading(true);
            $a5085d8f4019d625$var$requestSet.add(issueKey);
            const result = await $a5085d8f4019d625$var$fetchData(issueKey);
            setIssueConfig(issueKey, result);
            $a5085d8f4019d625$var$requestSet.delete(issueKey);
            if (isMounted.current) setLoading(false);
        }, [
            isMounted,
            issueKey,
            setIssueConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const shouldGetData = (0, (0, parcelRequire("4R6GH")).fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
            if (shouldGetData) getData();
        }, [
            issueKey,
            value,
            getData,
            skipRefresh
        ]);
        return [
            {
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useIssueOverridesStore)({
            issueKey: issueKey
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) {
                const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                    acc[fieldKey] = {
                        ...fieldValues,
                        ...overrides[fieldKey]
                    };
                    return acc;
                }, {});
                return [
                    issueWithOverrides
                ];
            }
            return [
                value
            ];
        }, [
            value,
            overrides
        ]);
    };
    const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useFieldOverridesStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) return [
            {
                ...value,
                ...overrides
            }
        ];
        return [
            value
        ];
    };
    const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
        const [, setIssueConfigActions] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>{
            const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
            const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
            const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
            const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
            const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
            return {
                setIssueConfig: setIssueConfig,
                setIssuesConfig: setIssuesConfig,
                mergeIssueConfig: mergeIssueConfig,
                mergeIssuesConfig: mergeIssuesConfig,
                setFieldConfigValue: setFieldConfigValue
            };
        }, [
            setIssueConfigActions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("iZIvy", function(module, exports) {
    $parcel$export(module.exports, "getGraphQlUrl", ()=>$ef2130f553e5234b$export$5647e6bbf2b3526f);
    $parcel$export(module.exports, "getFieldDataOptions", ()=>$ef2130f553e5234b$export$f2fec0cacdfabaaf);
    var $96nmc;
    var $chLKn;
    const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
            method: 'POST',
            body: JSON.stringify({
                query: (0, (0, parcelRequire("chLKn")).default)(issueKey, projectKey)
            })
        });
});
parcelRegister("chLKn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
    const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
    const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
    const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
    const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
    const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
    const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
    var $2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;
});
parcelRegister("eDXka", function(module, exports) {
    $parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", ()=>$9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
    $parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", ()=>$9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
    $parcel$export(module.exports, "IssueViewFetchOperations", ()=>$9f0f96bc04f1e77a$export$b38f30d67f730bc4);
    const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
    const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
    const $9f0f96bc04f1e77a$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
    const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
        EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
        INITIAL_GRAPHQL: 'issueDataQuery',
        EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
        INITIAL_GIRA: 'issueViewInteractiveQuery',
        EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
        INITIAL_AGG: 'mainIssueAggQuery',
        EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
        NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
        VIEW_SCREEN_ID: 'viewScreenIdQuery',
        FIELD_CONFIGURATION: 'fieldConfigurationQuery',
        FIELD_DESCRIPTION: 'fieldDescriptionQuery',
        ATTACHMENT: 'attachmentsQuery'
    };
});
parcelRegister("2N3tQ", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfigStore", ()=>$0471f3f4df57179c$export$52f51db4e2b3da57);
    $parcel$export(module.exports, "useFieldConfigStore", ()=>$0471f3f4df57179c$export$f9beb98c7488fd61);
    $parcel$export(module.exports, "useFieldConfigStoreActions", ()=>$0471f3f4df57179c$export$314199caf05d245);
    $parcel$export(module.exports, "useIssueOverridesStore", ()=>$0471f3f4df57179c$export$ff357cf5a96ec0c6);
    $parcel$export(module.exports, "useFieldOverridesStore", ()=>$0471f3f4df57179c$export$6e41e9c34587d557);
    $parcel$export(module.exports, "useFieldOverridesStoreWithLabel", ()=>$0471f3f4df57179c$export$e704d739927bd1d6);
    $parcel$export(module.exports, "useOverridesStoreActions", ()=>$0471f3f4df57179c$export$d94ae842140da412);
    $parcel$export(module.exports, "useFieldOptionsOverrides", ()=>$0471f3f4df57179c$export$bfea9bb9bad7bc8f);
    $parcel$export(module.exports, "useIsFieldBusy", ()=>$0471f3f4df57179c$export$982ff1008c2e2780);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
            setState({
                [issueKey]: issueConfiguration
            });
        };
    const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
            });
        };
    const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
            const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                    ...acc,
                    ...issue
                }), {});
            setState(newIssues);
        };
    const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
            if (issuesWithConfigurations.length === 0) return;
            const newIssues = {};
            issuesWithConfigurations.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfiguration = getState()[issueKey];
            if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: {
                        ...getState()[issueKey][fieldKey],
                        ...fieldConfiguration
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$actions = {
        setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
        setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
        mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
        mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
        setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
    };
    const $0471f3f4df57179c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-config',
        initialState: {},
        actions: $0471f3f4df57179c$var$actions
    });
    const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
    const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey] : null;
    });
    const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
        if (fieldConfig?.title === undefined) return fieldConfig;
        return {
            ...fieldConfig,
            label: fieldConfig.title
        };
    });
    const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
    });
    const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$314199caf05d245 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: null
    });
    const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
            setState({
                [issueKey]: {
                    ...issueKeyFieldConfigurationWithOverrides,
                    [fieldKey]: {
                        ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                        ...fieldConfigOverrides
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
            setState({
                [issueKey]: undefined
            });
        };
    const $0471f3f4df57179c$var$overridesActions = {
        setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
        resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
    };
    const $0471f3f4df57179c$var$overridesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-overrides',
        initialState: {},
        actions: $0471f3f4df57179c$var$overridesActions
    });
    const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
    });
    const $0471f3f4df57179c$export$d94ae842140da412 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0471f3f4df57179c$var$overridesStore);
    const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
    });
    const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
        const { fieldId: fieldId, issueKey: issueKey } = args;
        return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
    };
    const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIsFieldBusySelector
    });
});
parcelRegister("69oHP", function(module, exports) {
    $parcel$export(module.exports, "getFieldType", ()=>$53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
    $parcel$export(module.exports, "isRichTextSupported", ()=>$53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);
    var $fOGZN;
    var $5fc53;
    const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
        const customSystemFields = (0, (0, parcelRequire("fOGZN")).specialFields)();
        return [
            ...(0, (0, parcelRequire("fOGZN")).customFieldsToDisplay)().filter((cf)=>!(0, (0, parcelRequire("fOGZN")).ecosystemCustomFields).includes(cf)),
            ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
            (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE)
        ];
    };
    const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
    const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
        const fieldSchema = field ? field.schema : undefined;
        return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
    };
    const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
        const fieldSchema = field ? field.schema : undefined;
        return fieldSchema ? fieldSchema.type === (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE) : false;
    };
});
parcelRegister("fOGZN", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$1df76d38eb6e3f90$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_SUMMARY", ()=>$1df76d38eb6e3f90$export$a464614f8f5fe986);
    $parcel$export(module.exports, "SUBTASK_PARENT", ()=>$1df76d38eb6e3f90$export$a311a3c9b207604e);
    $parcel$export(module.exports, "WATCHES", ()=>$1df76d38eb6e3f90$export$289917d9a7031e1d);
    $parcel$export(module.exports, "VOTES", ()=>$1df76d38eb6e3f90$export$81614f6dc3be5b00);
    $parcel$export(module.exports, "SECURITY", ()=>$1df76d38eb6e3f90$export$72a5630aa398d6b4);
    $parcel$export(module.exports, "ISSUE_RESTRICTION", ()=>$1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
    $parcel$export(module.exports, "ASSIGNEE", ()=>$1df76d38eb6e3f90$export$f8f7545d2bb78afb);
    $parcel$export(module.exports, "REPORTER", ()=>$1df76d38eb6e3f90$export$6d7021166edc895c);
    $parcel$export(module.exports, "DUE_DATE", ()=>$1df76d38eb6e3f90$export$cf7e173386d30cdd);
    $parcel$export(module.exports, "PRIORITY", ()=>$1df76d38eb6e3f90$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "LABELS", ()=>$1df76d38eb6e3f90$export$79b91d4669dcadcb);
    $parcel$export(module.exports, "EPIC", ()=>$1df76d38eb6e3f90$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "FIX_VERSIONS", ()=>$1df76d38eb6e3f90$export$d7e18f5730074533);
    $parcel$export(module.exports, "AFFECTS_VERSIONS", ()=>$1df76d38eb6e3f90$export$c435f0000304e508);
    $parcel$export(module.exports, "TIME_TRACKING", ()=>$1df76d38eb6e3f90$export$ee99ef6ee562a446);
    $parcel$export(module.exports, "TIME_ESTIMATE", ()=>$1df76d38eb6e3f90$export$a6a74b4bc927d39f);
    $parcel$export(module.exports, "STATUS", ()=>$1df76d38eb6e3f90$export$e50006273435e7d4);
    $parcel$export(module.exports, "CREATED", ()=>$1df76d38eb6e3f90$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "SUMMARY", ()=>$1df76d38eb6e3f90$export$913055729e1380b2);
    $parcel$export(module.exports, "DESCRIPTION", ()=>$1df76d38eb6e3f90$export$d44826c816b5619b);
    $parcel$export(module.exports, "COMMENT", ()=>$1df76d38eb6e3f90$export$a29989082612d0d9);
    $parcel$export(module.exports, "EPIC_ISSUES", ()=>$1df76d38eb6e3f90$export$8fe3d5be8cb17459);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$1df76d38eb6e3f90$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "ENVIRONMENT", ()=>$1df76d38eb6e3f90$export$be46596bc6608f3b);
    $parcel$export(module.exports, "SUBTASKS", ()=>$1df76d38eb6e3f90$export$f528fadbfdb3c25e);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$1df76d38eb6e3f90$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "PARENT", ()=>$1df76d38eb6e3f90$export$e0dfb65d1047c53c);
    $parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", ()=>$1df76d38eb6e3f90$export$aba22e09a66f6826);
    $parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", ()=>$1df76d38eb6e3f90$export$826d657005bbe54c);
    $parcel$export(module.exports, "FLAG_ACTIONS", ()=>$1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
    $parcel$export(module.exports, "CARD_COVER_ACTIONS", ()=>$1df76d38eb6e3f90$export$c161a774ec2e7e56);
    $parcel$export(module.exports, "specialFields", ()=>$1df76d38eb6e3f90$export$89e5c40c0f5c7561);
    $parcel$export(module.exports, "ecosystemCustomFields", ()=>$1df76d38eb6e3f90$export$87934b3672715c91);
    $parcel$export(module.exports, "customFieldsToDisplay", ()=>$1df76d38eb6e3f90$export$efd443bccc4c01ed);
    $parcel$export(module.exports, "itemDocumentationUrls", ()=>$1df76d38eb6e3f90$export$a18b3a656ee9c709);
    $parcel$export(module.exports, "emptyConfiguration", ()=>$1df76d38eb6e3f90$export$a52507e68e7aeeb);
    $parcel$export(module.exports, "softwareConfiguration", ()=>$1df76d38eb6e3f90$export$27e0678365e5dcff);
    $parcel$export(module.exports, "simpleSoftwareBoardConfiguration", ()=>$1df76d38eb6e3f90$export$aebf676dfa727a1c);
    $parcel$export(module.exports, "standardRoadmapConfiguration", ()=>$1df76d38eb6e3f90$export$1afca4d3eb6b218b);
    $parcel$export(module.exports, "bitbucketConfiguration", ()=>$1df76d38eb6e3f90$export$8a060ed6f66c43b0);
    $parcel$export(module.exports, "mobileConfiguration", ()=>$1df76d38eb6e3f90$export$78a2cb921e46f5eb);
    $parcel$export(module.exports, "serviceDeskConfiguration", ()=>$1df76d38eb6e3f90$export$db1115186532f6d5);
    $parcel$export(module.exports, "connectConfiguration", ()=>$1df76d38eb6e3f90$export$557d5094ec5cf234);
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$1df76d38eb6e3f90$export$902f6c5cc939598a);
    var $65mz3;
    var $2vSU6;
    var $5fc53;
    const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
    const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
    const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
    const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
    const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent';
    const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
    const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
    const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
    const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
    const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
    const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
    const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
    const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
    const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
    const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
    const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
    const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
    const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
    const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
    const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
    const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
    const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
    const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
    const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
    const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
    const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
    const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
    const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
    const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
    const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
    const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
    const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
    const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
    const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
    const $1df76d38eb6e3f90$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
    const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
    const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
    const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
    const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
    const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
    const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
    const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues';
    const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
    const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
    const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
    const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
    const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE);
    const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE);
    const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
    const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
        const fields = {
            [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
            [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
            [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
            [(0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).PARENT_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE)]: (0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE),
            [(0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE)]: (0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE),
            [(0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)]: (0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)
        };
        return fields;
    };
    const $1df76d38eb6e3f90$export$87934b3672715c91 = [
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
    ];
    const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
        (0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).APPROVALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).ORGANIZATION_CF_TYPE)
    ];
    const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
            (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE),
            (0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE),
            (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
            (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
            ...$1df76d38eb6e3f90$export$87934b3672715c91,
            ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
        ];
    const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
    };
    const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SOFTWARE_ISSUE,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
                $1df76d38eb6e3f90$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).MOBILE_ISSUE,
            issueActions: []
        });
    const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
            applicationKey: (0, (0, parcelRequire("65mz3")).default).CONNECT_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
                return $1df76d38eb6e3f90$export$27e0678365e5dcff();
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return $1df76d38eb6e3f90$export$381ce08838c53afa();
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return $1df76d38eb6e3f90$export$db1115186532f6d5();
            default:
                return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        }
        return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    };
});
parcelRegister("8jn7A", function(module, exports) {
    $parcel$export(module.exports, "checkboxSupportedTypes", ()=>$c89b01151f17f142$export$432ca25b66c37cc2);
    var $5fc53;
    const $c89b01151f17f142$export$432ca25b66c37cc2 = [
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)
    ];
});
parcelRegister("ayltP", function(module, exports) {
    $parcel$export(module.exports, "componentsClipboardHandler", ()=>$3e4fdb5e75808293$export$4edb8679282799b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1ODRz;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $edOg5;
    const $3e4fdb5e75808293$var$isTransformedComponentsOption = (option)=>!!option && typeof option === 'object' && 'componentId' in option && 'name' in option;
    const $3e4fdb5e75808293$var$isTransformedComponents = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($3e4fdb5e75808293$var$isTransformedComponentsOption);
    const $3e4fdb5e75808293$var$isValidComponentsValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option);
    const $3e4fdb5e75808293$var$emptyValue = [];
    const $3e4fdb5e75808293$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("edOg5")).componentsSupportedTypes))) return [];
        if (!$3e4fdb5e75808293$var$isValidComponentsValue(metadata?.fieldValue)) return [];
        return metadata?.fieldValue;
    };
    function $3e4fdb5e75808293$var$assertComponentsField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) throw new Error('Field type is not supported');
    }
    const $3e4fdb5e75808293$var$useComponentsClipboardHandler = (issue, field)=>{
        $3e4fdb5e75808293$var$assertComponentsField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("1ODRz")).useComponentsField)({
            issueKey: issue.key,
            initialValue: $3e4fdb5e75808293$var$isTransformedComponents(field?.value) ? field.value.map((component)=>({
                    id: component.componentId,
                    name: component.name
                })) : $3e4fdb5e75808293$var$emptyValue
        });
        const saveValueFn = (0, $5uXOq.useCallback)((valueToSave, meta, analyticsEvent)=>saveValue(valueToSave ?? [], meta, analyticsEvent), [
            saveValue
        ]);
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map(({ name: name })=>name).join(', ') || '',
            currentValue: value,
            getPastedValue: $3e4fdb5e75808293$var$getPastedValue,
            saveValue: saveValueFn
        });
    };
    const $3e4fdb5e75808293$var$ComponentsClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($3e4fdb5e75808293$var$useComponentsClipboardHandler);
    const $3e4fdb5e75808293$export$4edb8679282799b3 = {
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: $3e4fdb5e75808293$var$ComponentsClipboardHelper
    };
});
parcelRegister("1ODRz", function(module, exports) {
    $parcel$export(module.exports, "useComponentsField", ()=>$ee14033da18c8c3a$export$adf68b6acc459cc4);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    const $ee14033da18c8c3a$export$adf68b6acc459cc4 = ({ issueKey: issueKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, $e9be48d6d2c01760$export$98a935eb30de54ab));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
        const [{ loading: loading, value: value, error: error }, { saveById: saveById, saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, $e9be48d6d2c01760$export$98a935eb30de54ab),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                loading: loading,
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                saveById: saveById,
                resetError: resetError
            }
        ];
    };
});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$498b2652a6d7832d = 'flag';
parcelRegister("edOg5", function(module, exports) {
    $parcel$export(module.exports, "componentsSupportedTypes", ()=>$518b8de6724142ac$export$99fbea5790ee13d2);
    var $5fc53;
    const $518b8de6724142ac$export$99fbea5790ee13d2 = [
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)
    ];
});
parcelRegister("8WsUD", function(module, exports) {
    $parcel$export(module.exports, "dateClipboardHandler", ()=>$0e296f48531c340f$export$e718187ed2d7ce50);
    var $a3qR8;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $dllQ7;
    const $0e296f48531c340f$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("dllQ7")).dateSupportedTypes))) return null;
        return clipboardItem.plainText;
    };
    function $0e296f48531c340f$var$assertDateField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).START_DATE_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).UPDATED) && field.type !== (0, (0, parcelRequire("5fc53")).CREATED) && field.type !== (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $0e296f48531c340f$var$useDateClipboardHandler = (issue, field)=>{
        $0e296f48531c340f$var$assertDateField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("a3qR8")).useDateField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: field?.value
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value,
            currentValue: value,
            getPastedValue: $0e296f48531c340f$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $0e296f48531c340f$var$DateClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($0e296f48531c340f$var$useDateClipboardHandler);
    const $0e296f48531c340f$export$e718187ed2d7ce50 = {
        [(0, (0, parcelRequire("5fc53")).START_DATE_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).UPDATED)]: $0e296f48531c340f$var$DateClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).CREATED)]: $0e296f48531c340f$var$DateClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $0e296f48531c340f$var$DateClipboardHelper
    };
});
parcelRegister("a3qR8", function(module, exports) {
    $parcel$export(module.exports, "useDateField", ()=>$b32b8f04096d0815$export$5591b0b878c1a989);
    var $lQE94;
    var $54wEF;
    const $b32b8f04096d0815$export$5591b0b878c1a989 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = fieldConfig?.schema.type ?? 'date';
        const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSuccess: onSuccess
        });
        return [
            {
                loading: loading,
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("dllQ7", function(module, exports) {
    $parcel$export(module.exports, "dateSupportedTypes", ()=>$ce6c091136a1238e$export$c1d8f1bf05dab6ae);
    var $5fc53;
    const $ce6c091136a1238e$export$c1d8f1bf05dab6ae = [
        (0, (0, parcelRequire("5fc53")).START_DATE_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).CREATED),
        (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ];
});
parcelRegister("inOlw", function(module, exports) {
    $parcel$export(module.exports, "dateTimeClipboardHandler", ()=>$8eed2e51af79adf5$export$6fbf80b68eb3090c);
    var $3c83i;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $9zEWU;
    const $8eed2e51af79adf5$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("9zEWU")).dateTimeSupportedTypes))) return null;
        return clipboardItem.plainText;
    };
    function $8eed2e51af79adf5$var$assertDateTimeField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $8eed2e51af79adf5$var$useDateTimeClipboardHandler = (issue, field)=>{
        $8eed2e51af79adf5$var$assertDateTimeField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("3c83i")).useDateTimeField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: field?.value || null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value,
            currentValue: value,
            getPastedValue: $8eed2e51af79adf5$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $8eed2e51af79adf5$var$DateTimeClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($8eed2e51af79adf5$var$useDateTimeClipboardHandler);
    const $8eed2e51af79adf5$export$6fbf80b68eb3090c = {
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $8eed2e51af79adf5$var$DateTimeClipboardHelper
    };
});
parcelRegister("3c83i", function(module, exports) {
    $parcel$export(module.exports, "useDateTimeField", ()=>$7f247d23c9fd3e62$export$2c2e7f1ceedfa8fa);
    var $lQE94;
    var $54wEF;
    const $7f247d23c9fd3e62$export$2c2e7f1ceedfa8fa = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = fieldConfig?.schema.type ?? 'datetime';
        const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                loading: loading,
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("9zEWU", function(module, exports) {
    $parcel$export(module.exports, "dateTimeSupportedTypes", ()=>$dd83f9f28fcc0252$export$80f63aa16e4e1227);
    var $5fc53;
    const $dd83f9f28fcc0252$export$80f63aa16e4e1227 = [
        (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)
    ];
});
parcelRegister("bZjVN", function(module, exports) {
    $parcel$export(module.exports, "groupClipboardHandler", ()=>$a4549a8af071c112$export$ae43e91e8e2e40e7);
    var $lQE94;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $ekKiJ;
    const $a4549a8af071c112$var$isTransformedSingleGroup = (option)=>!!option && typeof option === 'object' && 'groupId' in option && 'name' in option;
    const $a4549a8af071c112$var$isTransformedMultipleGroups = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($a4549a8af071c112$var$isTransformedSingleGroup);
    const $a4549a8af071c112$var$emptyValue = [];
    const $a4549a8af071c112$var$getPastedSingleGroupValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("ekKiJ")).groupSupportedTypes))) return null;
        if (!$a4549a8af071c112$var$isTransformedSingleGroup(metadata.fieldValue)) return null;
        return metadata?.fieldValue;
    };
    const $a4549a8af071c112$var$getPastedMultipleGroupsValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("ekKiJ")).groupSupportedTypes))) return null;
        if (!$a4549a8af071c112$var$isTransformedMultipleGroups(metadata.fieldValue)) return null;
        return metadata?.fieldValue;
    };
    const $a4549a8af071c112$var$useSingleGroupClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            fieldType: field.type,
            initialValue: $a4549a8af071c112$var$isTransformedSingleGroup(field.value) ? field.value : null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.name || null,
            currentValue: value,
            getPastedValue: $a4549a8af071c112$var$getPastedSingleGroupValue,
            saveValue: saveValue
        });
    };
    const $a4549a8af071c112$var$useMultipleGroupsClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            fieldType: field.type,
            initialValue: $a4549a8af071c112$var$isTransformedMultipleGroups(field.value) ? field.value : $a4549a8af071c112$var$emptyValue
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map((group)=>group.name).join(', ') || null,
            currentValue: value,
            getPastedValue: $a4549a8af071c112$var$getPastedMultipleGroupsValue,
            saveValue: saveValue
        });
    };
    const $a4549a8af071c112$var$SingleGroupClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($a4549a8af071c112$var$useSingleGroupClipboardHandler);
    const $a4549a8af071c112$var$MultipleGroupsClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($a4549a8af071c112$var$useMultipleGroupsClipboardHandler);
    const $a4549a8af071c112$export$ae43e91e8e2e40e7 = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $a4549a8af071c112$var$SingleGroupClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $a4549a8af071c112$var$MultipleGroupsClipboardHelper
    };
});
parcelRegister("7Y57h", function(module, exports) {
    $parcel$export(module.exports, "labelsClipboardHandler", ()=>$0aba695b13ee6ae7$export$b0d4c8fecec395de);
    var $iY5Zn;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $0aba695b13ee6ae7$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, [
            (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)
        ])) return null;
        return clipboardItem.plainText.split(',').map((label)=>label.trim());
    };
    function $0aba695b13ee6ae7$var$assertLabelsField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).LABELS_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)) throw new Error('Field type is not supported');
    }
    function $0aba695b13ee6ae7$var$isNotNull(value) {
        return value !== null;
    }
    const $0aba695b13ee6ae7$var$useLabelsClipboardHandler = (issue, field)=>{
        $0aba695b13ee6ae7$var$assertLabelsField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("iY5Zn")).useLabelsField)({
            issueKey: issue.key,
            issueId: issue.issueId,
            fieldKey: field?.fieldId,
            initialValue: Array.isArray(field?.value) ? field.value.filter($0aba695b13ee6ae7$var$isNotNull) : []
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.join(', ') || '',
            currentValue: value,
            getPastedValue: $0aba695b13ee6ae7$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $0aba695b13ee6ae7$var$LabelsClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($0aba695b13ee6ae7$var$useLabelsClipboardHandler);
    const $0aba695b13ee6ae7$export$b0d4c8fecec395de = {
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $0aba695b13ee6ae7$var$LabelsClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $0aba695b13ee6ae7$var$LabelsClipboardHelper
    };
});
parcelRegister("iY5Zn", function(module, exports) {
    $parcel$export(module.exports, "useLabelsField", ()=>$bfbd97057d68d7c4$export$64894e54f74d7bc5);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $9sTOh;
    const $bfbd97057d68d7c4$export$64894e54f74d7bc5 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, fieldType: fieldType, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
        const saveLabelsFieldField = (0, (0, parcelRequire("9sTOh")).useSaveLabelsField)(issueId);
        const saveField = saveLabelsFieldField;
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const labelsFieldType = fieldType || (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
        const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldType: labelsFieldType,
            issueId: issueId,
            issueKey: issueKey,
            onSuccess: onSuccess,
            onFailure: onFailure,
            initialValue: initialValue || null,
            fieldKey: fieldKey || (0, $e9be48d6d2c01760$export$93605f2a09aa8d26),
            saveField: saveField
        });
        return [
            {
                error: error,
                value: value,
                fieldConfig: fieldConfig
            },
            {
                resetError: resetError,
                saveValue: saveValue
            }
        ];
    };
});
parcelRegister("9sTOh", function(module, exports) {
    $parcel$export(module.exports, "useSaveLabelsField", ()=>$bfea513db97883c2$export$212ad40ad2c2a1db);
    var $l32RZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jJZqs;
    var $koeKL;
    const $bfea513db97883c2$var$buildId = (cloudId, issueId, fieldKey)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldKey}`;
    const $bfea513db97883c2$export$212ad40ad2c2a1db = (issueId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("l32RZ")).default));
        return (0, $5uXOq.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: $bfea513db97883c2$var$buildId(cloudId, issueId, fieldKey),
                            operations: [
                                {
                                    operation: 'SET',
                                    labels: value || []
                                }
                            ]
                        }
                    },
                    onCompleted (mutationData) {
                        if (mutationData.jira?.updateLabelsField) {
                            const { success: success, errors: responseErrors } = mutationData.jira?.updateLabelsField;
                            if (success) {
                                resolve();
                                return;
                            }
                            if (responseErrors?.length) reject(responseErrors[0].message ? new (0, (0, parcelRequire("jJZqs")).ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating labels'));
                        } else reject(new Error('Unknown error when mutating labels'));
                    },
                    onError (error) {
                        reject(error);
                    }
                });
            }), [
            cloudId,
            commit,
            issueId
        ]);
    };
});
parcelRegister("l32RZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b06b0a9852b299ba$export$2e2bcd8739ae039);
    const $b06b0a9852b299ba$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSaveLabelsField_LabelsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraLabelsFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateLabelsField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraLabelsField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSaveLabelsField_LabelsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraLabelsFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateLabelsField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraLabelsField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "first",
                                                        "value": 1000
                                                    }
                                                ],
                                                "concreteType": "JiraLabelConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedLabelsConnection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "totalCount"
                                                    },
                                                    {
                                                        "concreteType": "JiraLabelEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraLabel",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v4
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            v4,
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "concreteType": "JiraFieldConfig",
                                                "kind": "LinkedField",
                                                "name": "fieldConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d9561e4e88b317e2954d5ed9798719aaa143c5c332b9bc9b9f0da41947c9216b",
                "metadata": {},
                "name": "useSaveLabelsField_LabelsMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $b06b0a9852b299ba$var$node.hash = "8ad20115daf17ea5e9001db36624cdd7";
    var $b06b0a9852b299ba$export$2e2bcd8739ae039 = $b06b0a9852b299ba$var$node;
});
parcelRegister("1ZojP", function(module, exports) {
    $parcel$export(module.exports, "multiSelectClipboardHandler", ()=>$8ccd5b5ee2d1f5bd$export$4181cf95bcdec65a);
    var $hWkQo;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $Hn0D6;
    const $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelectOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
    const $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelect = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($8ccd5b5ee2d1f5bd$var$isTransformedMultiSelectOption);
    const $8ccd5b5ee2d1f5bd$var$isMultiSelectValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>!!option && typeof option === 'object' && 'id' in option && 'value' in option);
    const $8ccd5b5ee2d1f5bd$var$emptyValue = [];
    function $8ccd5b5ee2d1f5bd$var$isNotNull(value) {
        return value !== null;
    }
    const $8ccd5b5ee2d1f5bd$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("Hn0D6")).multiSelectSupportedTypes))) return null;
        if (!$8ccd5b5ee2d1f5bd$var$isMultiSelectValue(metadata.fieldValue)) return null;
        return metadata.fieldValue?.filter($8ccd5b5ee2d1f5bd$var$isNotNull) ?? null;
    };
    function $8ccd5b5ee2d1f5bd$var$assertMultiSelectField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $8ccd5b5ee2d1f5bd$var$useMultiSelectClipboardHandler = (issue, field)=>{
        $8ccd5b5ee2d1f5bd$var$assertMultiSelectField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("hWkQo")).useMultiSelectField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            fieldType: (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
            initialValue: $8ccd5b5ee2d1f5bd$var$isTransformedMultiSelect(field.value) ? field.value.map((option)=>({
                    id: option.optionId,
                    value: option.value
                })) : $8ccd5b5ee2d1f5bd$var$emptyValue
        });
        const saveFn = (valueToSave, meta, analyticsEvent)=>saveValue(valueToSave ?? $8ccd5b5ee2d1f5bd$var$emptyValue, meta, analyticsEvent);
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map((option)=>option.value).join(', ') || '',
            currentValue: value,
            getPastedValue: $8ccd5b5ee2d1f5bd$var$getPastedValue,
            saveValue: saveFn
        });
    };
    const $8ccd5b5ee2d1f5bd$var$MultiSelectClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($8ccd5b5ee2d1f5bd$var$useMultiSelectClipboardHandler);
    const $8ccd5b5ee2d1f5bd$export$4181cf95bcdec65a = {
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: $8ccd5b5ee2d1f5bd$var$MultiSelectClipboardHelper
    };
});
parcelRegister("hWkQo", function(module, exports) {
    $parcel$export(module.exports, "useSingleSelectField", ()=>$960925b05bbc934f$export$de455e978fcfd3cf);
    $parcel$export(module.exports, "useMultiSelectField", ()=>$960925b05bbc934f$export$a996b308983609cf);
    var $lQE94;
    var $54wEF;
    var $69oHP;
    var $aorE7;
    const $960925b05bbc934f$var$useSelectField = ({ issueKey: issueKey, fieldKey: fieldKey, fieldDefaultSchemaType: fieldDefaultSchemaType, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField, fieldType: fieldType, initialValue: initialValue })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const resolvedFieldType = fieldType || (0, (0, parcelRequire("69oHP")).getFieldType)(fieldConfig.value) || fieldDefaultSchemaType;
        const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: resolvedFieldType,
            initialValue: initialValue,
            onSuccess: onSuccess,
            onFailure: onFailure,
            saveField: saveField
        });
        return [
            {
                value: value,
                loading: loading,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                saveById: saveById,
                resetError: resetError
            }
        ];
    };
    const $960925b05bbc934f$export$de455e978fcfd3cf = (props)=>{
        const saveSingleSelectField = (0, (0, parcelRequire("aorE7")).useSingleSelectMutation)();
        return $960925b05bbc934f$var$useSelectField({
            ...props,
            saveField: saveSingleSelectField,
            fieldDefaultSchemaType: 'option'
        });
    };
    const $960925b05bbc934f$export$a996b308983609cf = (props)=>$960925b05bbc934f$var$useSelectField({
            ...props,
            fieldDefaultSchemaType: 'array'
        });
});
parcelRegister("aorE7", function(module, exports) {
    $parcel$export(module.exports, "useSingleSelectMutation", ()=>$e4e6c684acb49b66$export$e568023bd1bde626);
    var $cRpav;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jJZqs;
    var $2gCtH;
    var $koeKL;
    var $kSlPt;
    function $e4e6c684acb49b66$export$e568023bd1bde626() {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueContextIssueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("cRpav")).default));
        return (0, $5uXOq.useCallback)(async (issueKey, fieldId, option)=>{
            const { issueId: issueId, fieldOptionAri: fieldOptionAri } = await (0, (0, parcelRequire("kSlPt")).fetchMissingIssueAndFieldOptionData)(issueContextIssueId, option, environment, {
                cloudId: cloudId,
                issueKey: issueKey,
                fieldId: fieldId
            });
            return new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: `ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldId}`,
                            operation: {
                                operation: 'SET',
                                id: fieldOptionAri
                            }
                        }
                    },
                    onCompleted (data) {
                        if (!data.jira?.updateSingleSelectField) {
                            reject(new Error('unknown error occurred'));
                            return;
                        }
                        const { success: success, errors: errors, field: field } = data.jira.updateSingleSelectField;
                        if (!success || errors?.length) {
                            reject(errors?.[0].message ? new (0, (0, parcelRequire("jJZqs")).ValidationError)(errors[0].message) : new Error('unknown error occurred'));
                            return;
                        }
                        resolve(field?.fieldOption ? {
                            ari: field.fieldOption.id,
                            value: field.fieldOption.value,
                            id: field.fieldOption.optionId
                        } : null);
                    },
                    onError: reject
                });
            });
        }, [
            cloudId,
            commit,
            environment,
            issueContextIssueId
        ]);
    }
});
parcelRegister("cRpav", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$443ef4dbea26c47c$export$2e2bcd8739ae039);
    const $443ef4dbea26c47c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "fieldOption",
            "plural": false,
            "selections": [
                v4,
                {
                    "kind": "ScalarField",
                    "name": "optionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSingleSelectMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleSelectFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleSelectField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleSelectField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSingleSelectMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleSelectFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleSelectField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleSelectField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v5,
                                            v4
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61",
                "metadata": {},
                "name": "useSingleSelectMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $443ef4dbea26c47c$var$node.hash = "b8d6036932768e6445d7615f80fc6acb";
    var $443ef4dbea26c47c$export$2e2bcd8739ae039 = $443ef4dbea26c47c$var$node;
});
parcelRegister("kSlPt", function(module, exports) {
    $parcel$export(module.exports, "fetchMissingIssueAndFieldOptionData", ()=>$04141e8649a14bd2$export$def6f7858b27fc01);
    var $8KOXt;
    var $8Uumt = parcelRequire("8Uumt");
    async function $04141e8649a14bd2$export$def6f7858b27fc01(issueId, option, environment, vars) {
        const skipFieldOptionAri = option === null || Boolean(option.ari);
        if (issueId && skipFieldOptionAri) return {
            issueId: issueId,
            fieldOptionAri: option?.ari ?? null
        };
        const result = await (0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("8KOXt")).default), {
            ...vars,
            searchBy: option?.value,
            skipFieldOptionAri: skipFieldOptionAri
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const jiraIssue = result?.jira?.issueByKey;
        if (!jiraIssue?.issueId) throw new Error('failed fetch issue id');
        let ari = option != null ? option?.ari : null;
        if (!skipFieldOptionAri) ari = option ? jiraIssue?.fieldsById?.edges?.[0]?.node?.fieldOptions?.edges?.find((opt)=>opt?.node?.optionId === option.id)?.node?.id : null;
        if (ari === undefined) throw new Error('failed to fetch field option ari');
        return {
            issueId: jiraIssue.issueId,
            fieldOptionAri: ari
        };
    }
});
parcelRegister("8KOXt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16036a00db06e9b2$export$2e2bcd8739ae039);
    const $16036a00db06e9b2$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchBy"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipFieldOptionAri"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "issueKey"
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v7 = [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "ids.0",
                        "variableName": "fieldId"
                    }
                ],
                "kind": "ListValue",
                "name": "ids"
            }
        ], v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "searchBy",
                            "variableName": "searchBy"
                        }
                    ],
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraOptionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8,
                                        {
                                            "kind": "ScalarField",
                                            "name": "optionId"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSingleSelectField"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v6,
                                    {
                                        "condition": "skipFieldOptionAri",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v7,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v6,
                                    {
                                        "condition": "skipFieldOptionAri",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": v7,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    },
                                                                    v9,
                                                                    v8
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58",
                "metadata": {},
                "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $16036a00db06e9b2$var$node.hash = "9fecb581bfb367efbee5768f0f78cc7a";
    var $16036a00db06e9b2$export$2e2bcd8739ae039 = $16036a00db06e9b2$var$node;
});
parcelRegister("Hn0D6", function(module, exports) {
    $parcel$export(module.exports, "multiSelectSupportedTypes", ()=>$3c0f93086e9e92c6$export$9cb7f11173b6b689);
    var $5fc53;
    const $3c0f93086e9e92c6$export$9cb7f11173b6b689 = [
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)
    ];
});
parcelRegister("233vh", function(module, exports) {
    $parcel$export(module.exports, "numberClipboardHandler", ()=>$f90ed9f2a3070025$export$801c183086232047);
    var $bj6Oi;
    var $3wves;
    var $5fc53;
    var $1xoxe;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $f90ed9f2a3070025$var$getPastedValue = (clipboardItem)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
        if (Number.isNaN(Number(clipboardItem.plainText))) throw new (0, (0, parcelRequire("bj6Oi")).ClientSideValidationError)((0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE);
        return Number(clipboardItem.plainText);
    };
    const $f90ed9f2a3070025$var$useNumberClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("3wves")).useNumberField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: typeof field?.value === 'number' ? field?.value : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: typeof value === 'number' ? String(value) : null,
            currentValue: value,
            getPastedValue: $f90ed9f2a3070025$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $f90ed9f2a3070025$var$NumberClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($f90ed9f2a3070025$var$useNumberClipboardHandler);
    const $f90ed9f2a3070025$export$801c183086232047 = {
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: $f90ed9f2a3070025$var$NumberClipboardHelper
    };
});
parcelRegister("3wves", function(module, exports) {
    $parcel$export(module.exports, "useNumberField", ()=>$b5136d35d41d8f83$export$23f548e970bdf099);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    const $b5136d35d41d8f83$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            saveField: saveField
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("62Lxt", function(module, exports) {
    $parcel$export(module.exports, "parentClipboardHandler", ()=>$1d8be24e4a514978$export$a8a030d8148a051e);
    var $5uXOq = parcelRequire("5uXOq");
    var $4FipU;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $1d8be24e4a514978$var$isTransformedParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'issueKey' in fieldValue && 'summary' in fieldValue && 'issueType' in fieldValue && 'issueId' in fieldValue;
    const $1d8be24e4a514978$var$isParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'label' in fieldValue && 'key' in fieldValue && 'fields' in fieldValue;
    const $1d8be24e4a514978$var$getPastedValue = (clipboardItem, metadata, issue)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, [
            (0, (0, parcelRequire("5fc53")).PARENT_TYPE)
        ])) return null;
        if (String(issue?.issueType?.level) !== metadata.sourceIssueTypeLevel) return null;
        if (!$1d8be24e4a514978$var$isParentOption(metadata.fieldValue)) return null;
        return metadata.fieldValue;
    };
    const $1d8be24e4a514978$var$toParentFieldOption = (value)=>{
        const { issueKey: issueKey, issueId: issueId, summary: summary, issueType: issueType } = value;
        if (summary == null || issueType == null) return null;
        return {
            value: issueId,
            label: summary,
            key: issueKey,
            fields: {
                summary: summary,
                issuetype: issueType
            }
        };
    };
    const $1d8be24e4a514978$var$useParentClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("4FipU")).useParentField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            issueId: issue.issueId,
            initialValue: $1d8be24e4a514978$var$isTransformedParentOption(field.value) ? $1d8be24e4a514978$var$toParentFieldOption(field.value) : null
        });
        const createPastedValueWithIssue = (0, $5uXOq.useMemo)(()=>(clipboardItem, metadata)=>$1d8be24e4a514978$var$getPastedValue(clipboardItem, metadata, issue), [
            issue
        ]);
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.key ?? '',
            currentValue: value,
            getPastedValue: createPastedValueWithIssue,
            saveValue: saveValue
        });
    };
    const $1d8be24e4a514978$var$ParentClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($1d8be24e4a514978$var$useParentClipboardHandler);
    const $1d8be24e4a514978$export$a8a030d8148a051e = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $1d8be24e4a514978$var$ParentClipboardHelper
    };
});
parcelRegister("4FipU", function(module, exports) {
    $parcel$export(module.exports, "useParentField", ()=>$9abd8b32d92effd3$export$23f8a245702eecc6);
    var $eusud;
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $9abd8b32d92effd3$export$984ebf992eeb92e6 = async (issueKey, fieldKey, newValue)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify({
                fields: {
                    [fieldKey]: newValue && newValue.value ? {
                        id: newValue.value
                    } : null
                }
            })
        });
    const $9abd8b32d92effd3$export$aee311d2cd3543e6 = (response)=>{
        if (!response?.fields) return null;
        return response.fields.parent;
    };
    const $9abd8b32d92effd3$export$23f8a245702eecc6 = (props)=>{
        const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null } = props;
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = fieldConfig?.schema.custom ?? (0, (0, parcelRequire("5fc53")).PARENT_TYPE);
        const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue, saveById: saveById }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            fieldType: fieldType,
            issueId: issueId,
            issueKey: issueKey,
            onSuccess: onSuccess,
            onFailure: onFailure,
            initialValue: initialValue,
            saveField: $9abd8b32d92effd3$export$984ebf992eeb92e6,
            mapNonOptimisticResponse: $9abd8b32d92effd3$export$aee311d2cd3543e6
        });
        const valueOption = value || null;
        return [
            {
                value: valueOption,
                fieldConfig: fieldConfig,
                error: error
            },
            {
                saveValue: saveValue,
                saveById: saveById,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("eOY1D", function(module, exports) {
    $parcel$export(module.exports, "priorityClipboardHandler", ()=>$50c5f5d2210d721b$export$b89004aa95786c81);
    var $lQE94;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $wQk2k;
    const $50c5f5d2210d721b$var$isTransformedPriority = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'priorityId' in fieldValue && 'iconUrl' in fieldValue;
    const $50c5f5d2210d721b$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("wQk2k")).prioritySupportedTypes))) return null;
        if (!$50c5f5d2210d721b$var$isTransformedPriority(metadata.fieldValue)) return null;
        const { name: name, iconUrl: iconUrl, priorityId: priorityId } = metadata.fieldValue;
        return {
            name: name,
            iconUrl: iconUrl,
            priorityId: priorityId
        };
    };
    const $50c5f5d2210d721b$var$usePriorityClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            issueKey: issue.key,
            fieldType: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            initialValue: $50c5f5d2210d721b$var$isTransformedPriority(field.value) ? field.value : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.name || null,
            currentValue: value,
            getPastedValue: $50c5f5d2210d721b$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $50c5f5d2210d721b$var$PriorityClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($50c5f5d2210d721b$var$usePriorityClipboardHandler);
    const $50c5f5d2210d721b$export$b89004aa95786c81 = {
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $50c5f5d2210d721b$var$PriorityClipboardHelper
    };
});
parcelRegister("wQk2k", function(module, exports) {
    $parcel$export(module.exports, "prioritySupportedTypes", ()=>$4c97812eae062814$export$870d540e29b75531);
    var $5fc53;
    const $4c97812eae062814$export$870d540e29b75531 = [
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)
    ];
});
parcelRegister("g8t8K", function(module, exports) {
    $parcel$export(module.exports, "projectClipboardHandler", ()=>$adecb6b7202ff60d$export$54ffe1b6751ffaa1);
    var $crLaw;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $adecb6b7202ff60d$var$isProjectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'avatarUrls' in fieldValue && 'key' in fieldValue;
    const $adecb6b7202ff60d$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, [
            (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)
        ])) return null;
        if (!$adecb6b7202ff60d$var$isProjectOption(metadata.fieldValue)) return null;
        const { avatarUrls: avatarUrls, key: key, name: name } = metadata.fieldValue;
        return {
            avatarUrls: avatarUrls,
            key: key,
            name: name
        };
    };
    function $adecb6b7202ff60d$var$assertProjectField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $adecb6b7202ff60d$var$useProjectClipboardHandler = (issue, field)=>{
        $adecb6b7202ff60d$var$assertProjectField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("crLaw")).useProjectField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: field?.value ?? null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.name ?? '',
            currentValue: value,
            getPastedValue: $adecb6b7202ff60d$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $adecb6b7202ff60d$var$ProjectClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($adecb6b7202ff60d$var$useProjectClipboardHandler);
    const $adecb6b7202ff60d$export$54ffe1b6751ffaa1 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $adecb6b7202ff60d$var$ProjectClipboardHelper
    };
});
parcelRegister("crLaw", function(module, exports) {
    $parcel$export(module.exports, "useProjectField", ()=>$c53050cb92cb8ee9$export$85a22e7dcab3be80);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $c53050cb92cb8ee9$export$85a22e7dcab3be80 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE));
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("8swam", function(module, exports) {
    $parcel$export(module.exports, "radioSelectClipboardHandler", ()=>$631e8a3a716c702e$export$29dacd6ff7afb87c);
    var $9sUAX;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $cyODY;
    const $631e8a3a716c702e$var$isRadioSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'value' in fieldValue;
    const $631e8a3a716c702e$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("cyODY")).radioSelectSupportedTypes))) return null;
        if (!$631e8a3a716c702e$var$isRadioSelectOption(metadata.fieldValue)) return null;
        return {
            id: metadata.fieldValue.id,
            value: metadata.fieldValue.value
        };
    };
    const $631e8a3a716c702e$var$useRadioSelectClipboardHandler = (issue, field)=>{
        $631e8a3a716c702e$var$assertRadioSelectField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("9sUAX")).useRadioSelectCustomField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: field?.value ? field?.value : null
        });
        const { value: valueAsString = null } = value ?? {};
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: valueAsString,
            currentValue: value,
            getPastedValue: $631e8a3a716c702e$var$getPastedValue,
            saveValue: saveValue
        });
    };
    function $631e8a3a716c702e$var$assertRadioSelectField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $631e8a3a716c702e$var$RadioSelectClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($631e8a3a716c702e$var$useRadioSelectClipboardHandler);
    const $631e8a3a716c702e$export$29dacd6ff7afb87c = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $631e8a3a716c702e$var$RadioSelectClipboardHelper
    };
});
parcelRegister("9sUAX", function(module, exports) {
    $parcel$export(module.exports, "useRadioSelectCustomField", ()=>$a90ed6d8b34d430d$export$ef02e43cfb758362);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    const $a90ed6d8b34d430d$export$ef02e43cfb758362 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue = null, onFailure: onFailure, onSuccess: onSuccess })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'option');
        const options = fieldConfig.value?.allowedValues ?? [];
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError, saveById: saveById }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig,
                options: options
            },
            {
                saveValue: saveValue,
                resetError: resetError,
                saveById: saveById
            }
        ];
    };
});
parcelRegister("lhJy9", function(module, exports) {
    $parcel$export(module.exports, "richTextClipboardHandler", ()=>$c5aa69c4a9e562f8$export$f1f0130932e64bf7);
    var $lQE94;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $5zOc3;
    const $c5aa69c4a9e562f8$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("5zOc3")).richTextSupportedTypes))) return null;
        return JSON.parse(clipboardItem.plainText);
    };
    function $c5aa69c4a9e562f8$var$assertRichTextField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $c5aa69c4a9e562f8$var$useRichTextClipboardHandler = (issue, field)=>{
        $c5aa69c4a9e562f8$var$assertRichTextField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            issueKey: issue.key,
            fieldKey: field.fieldId,
            fieldType: field.type,
            initialValue: field.value ?? null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: typeof value !== 'string' ? JSON.stringify(value) : '',
            currentValue: value,
            getPastedValue: $c5aa69c4a9e562f8$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $c5aa69c4a9e562f8$var$RichTextClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($c5aa69c4a9e562f8$var$useRichTextClipboardHandler);
    const $c5aa69c4a9e562f8$export$f1f0130932e64bf7 = {
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: $c5aa69c4a9e562f8$var$RichTextClipboardHelper
    };
});
parcelRegister("5zOc3", function(module, exports) {
    $parcel$export(module.exports, "richTextSupportedTypes", ()=>$5eaf4c5a462accac$export$8eb80ed0ab47e2a5);
    var $5fc53;
    const $5eaf4c5a462accac$export$8eb80ed0ab47e2a5 = [
        (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)
    ];
});
parcelRegister("jtn4P", function(module, exports) {
    $parcel$export(module.exports, "singleSelectClipboardHandler", ()=>$7e8851a662dc3d52$export$40b3cfc25c74248b);
    var $hWkQo;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $15cxS;
    const $7e8851a662dc3d52$var$isSingleSelectValue = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'id' in fieldValue;
    const $7e8851a662dc3d52$var$isTransformedSingleSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
    const $7e8851a662dc3d52$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("15cxS")).singleSelectSupportedTypes))) return null;
        if (!$7e8851a662dc3d52$var$isSingleSelectValue(metadata.fieldValue)) return null;
        return metadata.fieldValue;
    };
    const $7e8851a662dc3d52$var$useSingleSelectClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("hWkQo")).useSingleSelectField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            initialValue: $7e8851a662dc3d52$var$isTransformedSingleSelectOption(field.value) ? {
                id: field.value.optionId,
                value: field.value.value
            } : null
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.value || '',
            currentValue: value,
            getPastedValue: $7e8851a662dc3d52$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $7e8851a662dc3d52$var$SingleSelectClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($7e8851a662dc3d52$var$useSingleSelectClipboardHandler);
    const $7e8851a662dc3d52$export$40b3cfc25c74248b = {
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $7e8851a662dc3d52$var$SingleSelectClipboardHelper
    };
});
parcelRegister("15cxS", function(module, exports) {
    $parcel$export(module.exports, "singleSelectSupportedTypes", ()=>$ebca28208c1fe29b$export$2bbc728e21b0f517);
    var $5fc53;
    const $ebca28208c1fe29b$export$2bbc728e21b0f517 = [
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)
    ];
});
parcelRegister("1O7xL", function(module, exports) {
    $parcel$export(module.exports, "sprintClipboardHandler", ()=>$3cacae2083c5de9b$export$43b74ee26a0ff997);
    var $5uXOq = parcelRequire("5uXOq");
    var $dMnMc;
    var $a29sl;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $hIYZb;
    const $3cacae2083c5de9b$var$isTransformedSprintOption = (option)=>option != null && typeof option === 'object' && 'sprintId' in option && 'name' in option && 'state' in option;
    const $3cacae2083c5de9b$var$isTransformedSprint = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($3cacae2083c5de9b$var$isTransformedSprintOption);
    const $3cacae2083c5de9b$var$isSprintValue = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every((option)=>option != null && typeof option === 'object' && 'id' in option && 'name' in option && 'state' in option && 'boardId' in option);
    const $3cacae2083c5de9b$var$emptyValue = [];
    const $3cacae2083c5de9b$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("hIYZb")).sprintSupportedTypes))) return [];
        if (!$3cacae2083c5de9b$var$isSprintValue(metadata?.fieldValue)) return [];
        return metadata?.fieldValue ?? [];
    };
    const $3cacae2083c5de9b$var$toSprintValue = (sprint)=>({
            id: Number(sprint.sprintId),
            name: String(sprint.name),
            state: String(sprint.state),
            boardId: Number((0, (0, parcelRequire("dMnMc")).getBoardId)(window.location.href))
        });
    const $3cacae2083c5de9b$var$useSprintClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("a29sl")).useSprintField)({
            issueKey: issue.key,
            fieldKey: field.fieldId,
            initialValue: $3cacae2083c5de9b$var$isTransformedSprint(field.value) ? field.value.map($3cacae2083c5de9b$var$toSprintValue) : $3cacae2083c5de9b$var$emptyValue
        });
        const saveValueFn = (0, $5uXOq.useCallback)((valueToSave, meta, analyticsEvent)=>saveValue(valueToSave ?? [], meta, analyticsEvent), [
            saveValue
        ]);
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map((sprint)=>sprint.name).join(', ') || '',
            currentValue: value,
            getPastedValue: $3cacae2083c5de9b$var$getPastedValue,
            saveValue: saveValueFn,
            emptyValue: $3cacae2083c5de9b$var$emptyValue
        });
    };
    const $3cacae2083c5de9b$var$SprintClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($3cacae2083c5de9b$var$useSprintClipboardHandler);
    const $3cacae2083c5de9b$export$43b74ee26a0ff997 = {
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: $3cacae2083c5de9b$var$SprintClipboardHelper
    };
});
parcelRegister("a29sl", function(module, exports) {
    $parcel$export(module.exports, "useSprintField", ()=>$2fd006a23bf8311f$export$414b643c95e23ae5);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $lQE94;
    var $54wEF;
    var $5fc53;
    var $jOtoq;
    const $2fd006a23bf8311f$export$218ac2eb848871c9 = async (issueKey, fieldKey, newValue)=>{
        const value = (0, (0, parcelRequire("jOtoq")).getActiveOrFutureSprint)(newValue);
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify({
                fields: {
                    [fieldKey]: value ? value.id : null
                }
            })
        });
    };
    const $2fd006a23bf8311f$export$414b643c95e23ae5 = (props)=>{
        const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = [] } = props;
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = fieldConfig?.schema.custom ?? (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
        const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            fieldType: fieldType,
            issueId: issueId,
            issueKey: issueKey,
            onSuccess: onSuccess,
            onFailure: onFailure,
            initialValue: initialValue,
            saveField: $2fd006a23bf8311f$export$218ac2eb848871c9
        });
        const currentSprint = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jOtoq")).getActiveOrFutureSprint)(value), [
            value
        ]);
        const closedSprints = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jOtoq")).getClosedSprints)(value), [
            value
        ]);
        return [
            {
                currentSprint: currentSprint,
                closedSprints: closedSprints,
                error: error,
                value: value,
                fieldConfig: fieldConfig
            },
            {
                resetError: resetError,
                saveValue: saveValue
            }
        ];
    };
});
parcelRegister("jOtoq", function(module, exports) {
    $parcel$export(module.exports, "getActiveOrFutureSprint", ()=>$baca344a1a8bf89a$export$976090522bae1157);
    $parcel$export(module.exports, "getClosedSprints", ()=>$baca344a1a8bf89a$export$d643f70a4819e76d);
    var $3spCR;
    var $249dD;
    const $baca344a1a8bf89a$export$976090522bae1157 = (value)=>{
        const activeSprint = (0, (0, parcelRequire("249dD")).findSprintWithState)(value, (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE));
        if (activeSprint) return activeSprint;
        const futureSprint = (0, (0, parcelRequire("249dD")).findSprintWithState)(value, (0, (0, parcelRequire("3spCR")).FUTURE_SPRINT_STATE));
        if (futureSprint) return futureSprint;
        return null;
    };
    const $baca344a1a8bf89a$export$d643f70a4819e76d = (value)=>{
        if (!value) return [];
        return value.filter((0, (0, parcelRequire("249dD")).hasState)((0, (0, parcelRequire("3spCR")).CLOSED_SPRINT_STATE)));
    };
});
parcelRegister("3spCR", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$3ebc9911a79d714f);
    $parcel$export(module.exports, "FUTURE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$863e42082c6bde5);
    $parcel$export(module.exports, "CLOSED_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$86cdef09a89e8c4b);
    $parcel$export(module.exports, "SPRINT_STATES", ()=>$113c1ed08a0bda4f$export$73a0206a4dc59760);
    const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
    const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
    const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
    const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
        ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
        CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
        FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
    };
});
parcelRegister("249dD", function(module, exports) {
    $parcel$export(module.exports, "hasState", ()=>$cfadc135289d0d3a$export$d2fec4e2fc5f065a);
    $parcel$export(module.exports, "findSprintWithState", ()=>$cfadc135289d0d3a$export$fb6b70a9c996212b);
    $parcel$export(module.exports, "mapSprintOptionToData", ()=>$cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
    $parcel$export(module.exports, "transformSuggestions", ()=>$cfadc135289d0d3a$export$1d0ee4320c26fb60);
    var $3spCR;
    var $e7pk8;
    const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
    const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
    const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
        if (!sprints) return undefined;
        return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
    };
    const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
        if (state !== undefined) {
            const stateKey = state.toUpperCase();
            return (0, (0, parcelRequire("3spCR")).SPRINT_STATES)[stateKey];
        }
        return undefined;
    };
    const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
    const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
            id: Number(option.value),
            name: String(option.label),
            state: option.state,
            boardId: Number(option.data?.boardId) || 0
        });
    const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
    const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
            id: Number(option.value),
            boardName: option.description,
            name: String(option.label),
            stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
            date: String(option.data?.date)
        });
    const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
    const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
            id: sprint.id,
            description: sprint.boardName,
            label: sprint.name,
            state: sprint.stateKey,
            value: sprint.id,
            data: {
                date: sprint.date,
                fromCache: sprint.fromCache
            }
        });
    const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
            id: sprint.id,
            name: sprint.name,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            endDate: sprint.endDate || ''
        });
    const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
            label: sprint.name,
            value: sprint.id,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
            data: {
                boardId: sprint.boardId,
                date: sprint.startDate
            }
        });
    const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
    const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
        const serverSuggestions = suggestionsFromServer.suggestions || [];
        const allMatches = suggestionsFromServer.allMatches || [];
        const allItems = serverSuggestions.concat(allMatches);
        const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const sprints = [
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).activeSprints),
                options: activeItems
            },
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).futureSprints),
                options: futureItems
            }
        ];
        return sprints;
    };
});
parcelRegister("e7pk8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f3d56beb10e0cde$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activeSprints: {
            "id": "issue-field-sprint.common.active-sprints",
            "defaultMessage": "Active"
        },
        futureSprints: {
            "id": "issue-field-sprint.common.future-sprints",
            "defaultMessage": "Future"
        },
        recentSprints: {
            "id": "issue-field-sprint.common.recent-sprints",
            "defaultMessage": "Recent sprints"
        }
    });
});
parcelRegister("hIYZb", function(module, exports) {
    $parcel$export(module.exports, "sprintSupportedTypes", ()=>$48d47f85fb1aba83$export$e25836d1d6e63e05);
    var $5fc53;
    const $48d47f85fb1aba83$export$e25836d1d6e63e05 = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)
    ];
});
parcelRegister("dCJsI", function(module, exports) {
    $parcel$export(module.exports, "teamClipboardHandler", ()=>$ce6b26da99d59604$export$c625d5eb0e1357b2);
    var $4tlhS;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $ce6b26da99d59604$var$isTransformedTeamOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'name' in fieldValue;
    function $ce6b26da99d59604$var$assertTeamField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $ce6b26da99d59604$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, [
            (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)
        ])) return null;
        if (!$ce6b26da99d59604$var$isTransformedTeamOption(metadata.fieldValue)) return null;
        const { id: id, name: name } = metadata.fieldValue;
        return {
            id: id,
            name: name
        };
    };
    const $ce6b26da99d59604$var$useTeamClipboardHandler = (issue, field)=>{
        $ce6b26da99d59604$var$assertTeamField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("4tlhS")).useTeamField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: $ce6b26da99d59604$var$isTransformedTeamOption(field.value) ? field.value : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: field.value?.name ?? '',
            currentValue: value,
            getPastedValue: $ce6b26da99d59604$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $ce6b26da99d59604$var$TeamClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($ce6b26da99d59604$var$useTeamClipboardHandler);
    const $ce6b26da99d59604$export$c625d5eb0e1357b2 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: $ce6b26da99d59604$var$TeamClipboardHelper
    };
});
parcelRegister("4tlhS", function(module, exports) {
    $parcel$export(module.exports, "useTeamField", ()=>$27aed0aa4f300f8f$export$183b0f27978cd3a6);
    $parcel$export(module.exports, "useTeamFieldRelay", ()=>$27aed0aa4f300f8f$export$9cb6c5f2b8075e40);
    var $21z07;
    var $fYWdS;
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $jJZqs;
    var $fZneA;
    var $lQE94;
    var $99cgx;
    var $54wEF;
    var $15WDX;
    var $8zOmE;
    const $27aed0aa4f300f8f$var$saveField = async (issueKey, fieldKey, newValue, baseUrl)=>{
        const newId = newValue?.id ?? null;
        return (0, (0, parcelRequire("99cgx")).defaultSaveField)(issueKey, fieldKey, newId, baseUrl);
    };
    const $27aed0aa4f300f8f$export$183b0f27978cd3a6 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'array');
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? initialValue || null : null,
            onSuccess: onSuccess,
            saveField: $27aed0aa4f300f8f$var$saveField,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
    const $27aed0aa4f300f8f$var$transformComponentValueToAggValue = (value)=>{
        if (!value) return null;
        return {
            jiraSuppliedId: value?.teamId ?? '',
            jiraSuppliedName: value?.name ?? '',
            jiraSuppliedVisibility: true,
            jiraSuppliedTeamId: value?.id ?? '',
            jiraIncludesYou: !!value?.includesYou,
            jiraMemberCount: value?.memberCount ?? 0
        };
    };
    const $27aed0aa4f300f8f$export$a3e1bed60407fb27 = (fieldData)=>{
        if (!fieldData) return null;
        return {
            id: fieldData.jiraSuppliedTeamId,
            name: fieldData.jiraSuppliedName ?? '',
            isVisible: !!fieldData.jiraSuppliedVisibility,
            teamId: fieldData.jiraSuppliedId,
            memberCount: fieldData.jiraMemberCount ?? 0,
            includesYou: !!fieldData?.jiraIncludesYou
        };
    };
    const $27aed0aa4f300f8f$export$9cb6c5f2b8075e40 = ({ fragmentKey: fragmentKey, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, (0, parcelRequire("15WDX")).useIssueViewFieldUpdateEvents)();
        const [error, setError] = (0, $5uXOq.useState)(null);
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("fYWdS")).default), fragmentKey);
        const issueId = data?.issue?.id;
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("21z07")).default));
        async function saveValue(value, meta, analyticsEvent) {
            const newAggValue = $27aed0aa4f300f8f$var$transformComponentValueToAggValue(value);
            const analyticsData = {
                editOperationType: 'set',
                issueId: issueId,
                fieldKey: data.fieldId,
                fieldType: data.type
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            issueId && fieldChangeRequested(issueId, data.fieldId, newAggValue, undefined, {
                type: data.type,
                __typename: data.__typename
            });
            commit({
                variables: {
                    input: {
                        id: data.id,
                        operation: {
                            operation: 'SET',
                            id: newAggValue?.jiraSuppliedId ?? null
                        }
                    }
                },
                onCompleted: (mutationData)=>{
                    if (mutationData.jira?.updateTeamField?.success) {
                        issueId && fieldChanged(issueId, data.fieldId, newAggValue, {
                            type: data.type,
                            __typename: data.__typename
                        });
                        onSuccess && onSuccess(value);
                    } else issueId && fieldChangeFailed(issueId, data.fieldId);
                },
                onError (ex) {
                    issueId && fieldChangeFailed(issueId, data.fieldId);
                    onFailure && onFailure(ex, value);
                    const isValidationError = ex instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                        fieldKey: data.fieldId,
                        fieldType: data.type,
                        isValidationError: isValidationError,
                        isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex)
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateTeamField: {
                            success: true,
                            errors: [],
                            field: {
                                id: data.id,
                                issue: {
                                    id: issueId ?? '',
                                    key: data.issue?.key ?? ''
                                },
                                selectedTeam: {
                                    jiraSuppliedId: newAggValue?.jiraSuppliedId ?? '',
                                    jiraSuppliedName: newAggValue?.jiraSuppliedName,
                                    jiraSuppliedVisibility: newAggValue?.jiraSuppliedVisibility,
                                    jiraSuppliedTeamId: newAggValue?.jiraSuppliedTeamId ?? ''
                                }
                            }
                        }
                    }
                }
            });
        }
        function resetError() {
            setError(null);
        }
        return [
            {
                value: $27aed0aa4f300f8f$export$a3e1bed60407fb27(data.selectedTeam),
                error: error,
                fieldConfig: {
                    isEditable: !!data.fieldConfig?.isEditable,
                    allowedValues: [],
                    isRequired: !!data.fieldConfig?.isRequired,
                    schema: {
                        custom: null,
                        system: null,
                        type: ''
                    },
                    title: ''
                }
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("21z07", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b8acf545d58806c$export$2e2bcd8739ae039);
    const $2b8acf545d58806c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "key"
        }, v6 = {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedVisibility"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedTeamId"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraTeamFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateTeamField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraTeamViewField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            },
                                            v6
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraTeamFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateTeamField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraTeamViewField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                    v5,
                                                    v4
                                                ]
                                            },
                                            v6
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0bb03bd20026a47750a48b235c2f8d1e8eeecb4df2e71cebbc4da18dd6fdd31d",
                "metadata": {},
                "name": "services_issueViewLayoutTeamField_IssueViewTeamField_Mutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $2b8acf545d58806c$var$node.hash = "8f2e3b069da3abd11887dcb1c1108e5b";
    var $2b8acf545d58806c$export$2e2bcd8739ae039 = $2b8acf545d58806c$var$node;
});
parcelRegister("fYWdS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1a725b9b2a8270c$export$2e2bcd8739ae039);
    const $c1a725b9b2a8270c$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "services_issueViewLayoutTeamField_IssueViewTeamField",
            "selections": [
                v0,
                {
                    "kind": "ScalarField",
                    "name": "fieldId"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRequired"
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v0,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                },
                {
                    "concreteType": "JiraTeamView",
                    "kind": "LinkedField",
                    "name": "selectedTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedVisibility"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedTeamId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jiraIncludesYou"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jiraMemberCount"
                        }
                    ]
                }
            ],
            "type": "JiraTeamViewField"
        };
    }();
    $c1a725b9b2a8270c$var$node.hash = "8713158512b148e6e9909aead2a53a99";
    var $c1a725b9b2a8270c$export$2e2bcd8739ae039 = $c1a725b9b2a8270c$var$node;
});
parcelRegister("57YE2", function(module, exports) {
    $parcel$export(module.exports, "textClipboardHandler", ()=>$a446163e363c852b$export$c09434927c21c56);
    var $3p8iD;
    var $80wkc;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $a446163e363c852b$var$getPastedValue = (clipboardItem)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
        return clipboardItem.plainText;
    };
    function $a446163e363c852b$var$assertTextField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)) throw new Error('Field type is not supported');
    }
    const $a446163e363c852b$var$useSummaryClipboardHandler = (issue, field)=>{
        $a446163e363c852b$var$assertTextField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("80wkc")).useSummaryField)({
            issueId: issue.issueId.toString(),
            issueKey: issue.key,
            initialValue: field.value
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value,
            currentValue: value,
            getPastedValue: $a446163e363c852b$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $a446163e363c852b$var$useTextClipboardHandler = (issue, field)=>{
        $a446163e363c852b$var$assertTextField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("3p8iD")).useTextCustomField)({
            issueKey: issue.key,
            fieldKey: field.fieldId,
            initialValue: field.value
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value,
            currentValue: value,
            getPastedValue: $a446163e363c852b$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $a446163e363c852b$var$SummaryClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($a446163e363c852b$var$useSummaryClipboardHandler);
    const $a446163e363c852b$var$TextClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($a446163e363c852b$var$useTextClipboardHandler);
    const $a446163e363c852b$export$c09434927c21c56 = {
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $a446163e363c852b$var$SummaryClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $a446163e363c852b$var$TextClipboardHelper
    };
});
parcelRegister("3p8iD", function(module, exports) {
    $parcel$export(module.exports, "useTextCustomField", ()=>$08dedeee1aa4605e$export$1e71b41e5a5c15c3);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    const $08dedeee1aa4605e$export$1e71b41e5a5c15c3 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("80wkc", function(module, exports) {
    $parcel$export(module.exports, "useSummaryField", ()=>$3937341f26b89a45$export$a01f0885983ceff0);
    var $9XE6b = parcelRequire("9XE6b");
    var $co1wz;
    var $lQE94;
    var $54wEF;
    var $5fc53;
    var $lcPD8;
    const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
        const saveField = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') ? (0, (0, parcelRequire("lcPD8")).useSaveSummaryField)(issueId) : undefined;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            ...(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') && {
                saveField: saveField
            },
            ...onSaveField && {
                saveField: onSaveField
            }
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("lcPD8", function(module, exports) {
    $parcel$export(module.exports, "useSaveSummaryField", ()=>$296ba0222c720503$export$2429979662d1fc23);
    var $883fO;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lBwHJ;
    var $jJZqs;
    var $koeKL;
    const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("883fO")).default));
        return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: (0, (0, parcelRequire("lBwHJ")).JiraIssuefieldvalueAri).create({
                                siteId: cloudId,
                                issueId: issueId || '',
                                fieldId: fieldId
                            }).toString(),
                            operation: {
                                operation: 'SET',
                                text: newValue
                            }
                        }
                    },
                    onCompleted (response) {
                        if (response.jira?.updateSingleLineTextField) {
                            const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                            if (success) {
                                resolve();
                                return;
                            }
                            if (responseErrors?.length) reject(responseErrors[0].message ? new (0, (0, parcelRequire("jJZqs")).ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                        } else reject(new Error('Unknown error when mutating summary'));
                    },
                    onError (error) {
                        reject(error);
                    }
                });
            }), [
            cloudId,
            commit,
            issueId
        ]);
    };
});
parcelRegister("883fO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80cb93aeec4c927$export$2e2bcd8739ae039);
    const $d80cb93aeec4c927$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "text"
                                            },
                                            {
                                                "concreteType": "JiraFieldConfig",
                                                "kind": "LinkedField",
                                                "name": "fieldConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isRequired"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8b02759e10438a127aac20f64c8486592f4fd2cd831c3688a79bab526279fedf",
                "metadata": {},
                "name": "useSaveSummaryFieldMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
    var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;
});
parcelRegister("lBwHJ", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAri", ()=>$fba66c0f0a21639a$export$828c4931ae562af7);
    var $gB07r;
    var $9KGzW;
    var $1C2Ux;
    var $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceType),
        resourceIdSlug: "{issueId}/{fieldId}",
        resourceIdSegmentFormats: {
            issueId: /[0-9]+/,
            fieldId: /[a-zA-Z0-9_\-]+/
        }
    };
    var $fba66c0f0a21639a$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
        }
        get siteId() {
            return this._siteId;
        }
        get issueId() {
            return this._issueId;
        }
        get fieldId() {
            return this._fieldId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
                platformQualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
                resourceType: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
                resourceId: `${opts.issueId}/${opts.fieldId}`,
                resourceIdSegmentValues: {
                    issueId: opts.issueId,
                    fieldId: opts.fieldId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                issueId: this.issueId,
                fieldId: this.fieldId
            };
        }
    };
});
parcelRegister("gB07r", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", ()=>$c15031ac9edfd973$export$39e9358142fbbc64);
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", ()=>$c15031ac9edfd973$export$f9e57427271adc95);
    var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";
});
parcelRegister("iAC09", function(module, exports) {
    $parcel$export(module.exports, "timeTrackingClipboardHandler", ()=>$1b0eb1d2d59158fe$export$a6166b81649f40c4);
    var $8Zm3O;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $g92DA;
    const $1b0eb1d2d59158fe$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("g92DA")).timeTrackingSupportedTypes))) return null;
        const time = Number(clipboardItem.plainText);
        if (Number.isNaN(time)) return null;
        return time;
    };
    function $1b0eb1d2d59158fe$var$assertTimeTrackingField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)) throw new Error('Field type is not supported');
    }
    const $1b0eb1d2d59158fe$var$useTimeTrackingClipboardHandler = (issue, field)=>{
        $1b0eb1d2d59158fe$var$assertTimeTrackingField(field);
        const fieldValue = field.value;
        const hookInitialValue = fieldValue?.timeAsString && fieldValue?.timeInSeconds && {
            originalEstimate: fieldValue.timeAsString,
            originalEstimateSeconds: fieldValue.timeInSeconds
        } || {};
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("8Zm3O")).useOriginalEstimateField)({
            issueKey: issue.key,
            issueId: issue.issueId,
            fieldId: field.fieldId,
            timeTrackingValue: hookInitialValue
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: typeof value === 'number' ? String(value) : null,
            currentValue: value,
            getPastedValue: $1b0eb1d2d59158fe$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $1b0eb1d2d59158fe$var$TimeTrackingClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($1b0eb1d2d59158fe$var$useTimeTrackingClipboardHandler);
    const $1b0eb1d2d59158fe$export$a6166b81649f40c4 = {
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: $1b0eb1d2d59158fe$var$TimeTrackingClipboardHelper
    };
});
parcelRegister("8Zm3O", function(module, exports) {
    $parcel$export(module.exports, "saveField", ()=>$dbb581df97946a35$export$72a8b15fb4557735);
    $parcel$export(module.exports, "useOriginalEstimateField", ()=>$dbb581df97946a35$export$ce089f5e05395af0);
    $parcel$export(module.exports, "useOriginalEstimateFieldWithTimeTracking", ()=>$dbb581df97946a35$export$a79ecf7a6123f80e);
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    var $lQE94;
    var $54wEF;
    var $akMx1;
    var $9odSb;
    var $5fc53;
    var $4tcSU;
    var $gEYwC;
    const $dbb581df97946a35$export$347b6dd45094a5fd = (timeTrackingValue)=>{
        const hasTimeLogged = timeTrackingValue?.timeSpentSeconds != null;
        const hasTimeRemainUpdated = timeTrackingValue?.remainingEstimateSeconds != null && timeTrackingValue?.remainingEstimateSeconds !== timeTrackingValue?.originalEstimateSeconds;
        return hasTimeLogged || hasTimeRemainUpdated;
    };
    const $dbb581df97946a35$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, timeTrackingValue: timeTrackingValue })=>{
        const hasTimeRemainingEstimate = $dbb581df97946a35$export$347b6dd45094a5fd(timeTrackingValue);
        const value = newValue !== null ? (0, (0, parcelRequire("akMx1")).secondsToWholeMinuteTimeString)(newValue) : null;
        return (0, (0, parcelRequire("eusud")).performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: (0, $ebyGx.stringify)({
                issueId: issueId,
                timetracking_originalestimate: value,
                timetracking_targetsubfield: hasTimeRemainingEstimate ? 'timetracking_originalestimate' : undefined,
                ...(0, (0, parcelRequire("gEYwC")).originalEstimateBodyParams),
                singleFieldEdit: true,
                skipScreenCheck: true,
                atl_token: (0, (0, parcelRequire("4tcSU")).default)()
            })
        });
    };
    const $dbb581df97946a35$export$ce089f5e05395af0 = ({ issueKey: issueKey, issueId: issueId, fieldId: fieldId, timeTrackingValue: timeTrackingValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldId);
        const fieldType = fieldConfig?.schema.system || '';
        const saveClassicField = (_, __, newValue)=>$dbb581df97946a35$export$72a8b15fb4557735({
                issueId: issueId,
                newValue: newValue,
                timeTrackingValue: timeTrackingValue
            });
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldId,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: null,
            saveField: saveClassicField,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onSubmit: onSubmit
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
    const $dbb581df97946a35$export$a79ecf7a6123f80e = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const timeTrack = (0, (0, parcelRequire("9odSb")).useTimeTrackingField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE),
            issueId: issueId,
            issueKey: issueKey
        });
        let timeTrackingValue = {};
        if (timeTrack) {
            const trackData = timeTrack[0].value;
            timeTrackingValue = {
                originalEstimateSeconds: trackData.originalEstimateSeconds,
                timeSpentSeconds: trackData.timeSpentSeconds,
                remainingEstimateSeconds: trackData.remainingEstimateSeconds
            };
        }
        const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = $dbb581df97946a35$export$ce089f5e05395af0({
            fieldId: fieldKey,
            issueKey: issueKey,
            issueId: issueId,
            timeTrackingValue: timeTrackingValue,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onSubmit: onSubmit
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("akMx1", function(module, exports) {
    $parcel$export(module.exports, "secondsToWholeMinuteTimeString", ()=>$ebeaf61d195e1652$export$e090c313e2cb7081);
    const $ebeaf61d195e1652$var$SECONDS_PER_MINUTE = 60;
    const $ebeaf61d195e1652$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $ebeaf61d195e1652$var$SECONDS_PER_MINUTE)}m`;
    var $ebeaf61d195e1652$export$2e2bcd8739ae039 = $ebeaf61d195e1652$export$e090c313e2cb7081;
});
parcelRegister("9odSb", function(module, exports) {
    $parcel$export(module.exports, "useTimeTrackingField", ()=>$eb158ccbc60bd81b$export$eda25773281b1630);
    var $lQE94;
    var $54wEF;
    const $eb158ccbc60bd81b$export$eda25773281b1630 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = fieldConfig?.schema.system || '';
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: {
                originalEstimateSeconds: 0,
                timeSpentSeconds: 0,
                remainingEstimateSeconds: 0
            },
            onSuccess: onSuccess,
            onFailure: onFailure,
            onSubmit: onSubmit
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("gEYwC", function(module, exports) {
    $parcel$export(module.exports, "originalEstimateBodyParams", ()=>$0f3bfc7baad799e0$export$25ca12ed4532196);
    $parcel$export(module.exports, "originalEstimateEditTestId", ()=>$0f3bfc7baad799e0$export$85273aacc194bf89);
    $parcel$export(module.exports, "originalEstimateViewTestId", ()=>$0f3bfc7baad799e0$export$97847a81d7704a9e);
    $parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR_NAME", ()=>$0f3bfc7baad799e0$export$916dec1cd99a42a1);
    $parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR", ()=>$0f3bfc7baad799e0$export$5c18970ef161f5b6);
    $parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR_NAME", ()=>$0f3bfc7baad799e0$export$c43a88184f234cd2);
    $parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR", ()=>$0f3bfc7baad799e0$export$366394ad8172710b);
    const $0f3bfc7baad799e0$export$25ca12ed4532196 = {
        fieldsToForcePresent: 'timetracking'
    };
    const $0f3bfc7baad799e0$export$85273aacc194bf89 = 'issue-field-original-estimate-editview-full.ui.original-estimate.edit';
    const $0f3bfc7baad799e0$export$97847a81d7704a9e = 'issue-field-original-estimate.ui.view';
    const $0f3bfc7baad799e0$export$916dec1cd99a42a1 = 'jira-issue-field-inline-edit-read-view-container';
    const $0f3bfc7baad799e0$export$5c18970ef161f5b6 = `[data-component-selector="${$0f3bfc7baad799e0$export$916dec1cd99a42a1}"]`;
    const $0f3bfc7baad799e0$export$c43a88184f234cd2 = 'jira-issue-field-original-estimate-hover-container';
    const $0f3bfc7baad799e0$export$366394ad8172710b = `[data-component-selector="${$0f3bfc7baad799e0$export$c43a88184f234cd2}"]`;
});
parcelRegister("g92DA", function(module, exports) {
    $parcel$export(module.exports, "timeTrackingSupportedTypes", ()=>$7cfa5cc7eb8e971f$export$de876e84f23a34b2);
    var $5fc53;
    const $7cfa5cc7eb8e971f$export$de876e84f23a34b2 = [
        (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)
    ];
});
parcelRegister("eowGc", function(module, exports) {
    $parcel$export(module.exports, "urlClipboardHandler", ()=>$6d04cb075a7ac863$export$6e2f5cd13985078c);
    var $hJx2A;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    const $6d04cb075a7ac863$var$getPastedValue = (clipboardItem)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem)) return null;
        return clipboardItem.plainText;
    };
    function $6d04cb075a7ac863$var$assertUrlField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).URL_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $6d04cb075a7ac863$var$useUrlClipboardHandler = (issue, field)=>{
        $6d04cb075a7ac863$var$assertUrlField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("hJx2A")).useUrlCustomField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId,
            initialValue: field.value
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value ?? '',
            currentValue: value,
            getPastedValue: $6d04cb075a7ac863$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $6d04cb075a7ac863$var$UrlClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($6d04cb075a7ac863$var$useUrlClipboardHandler);
    const $6d04cb075a7ac863$export$6e2f5cd13985078c = {
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: $6d04cb075a7ac863$var$UrlClipboardHelper
    };
});
parcelRegister("hJx2A", function(module, exports) {
    $parcel$export(module.exports, "useUrlCustomField", ()=>$5c820c84e8064736$export$8745adc9879e9e03);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    const $5c820c84e8064736$export$8745adc9879e9e03 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("4dpsE", function(module, exports) {
    $parcel$export(module.exports, "userClipboardHandler", ()=>$d5837a14d54538d4$export$5fdc9960135beb70);
    $parcel$export(module.exports, "multiUserClipboardHandler", ()=>$d5837a14d54538d4$export$6c011954430f0654);
    var $9pwsK;
    var $lKk7c;
    var $5FzCC;
    var $jXbbD;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $jO40L;
    const $d5837a14d54538d4$var$isTransformedUser = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'name' in fieldValue && 'picture' in fieldValue;
    const $d5837a14d54538d4$var$isTransformedUserList = (fieldValue)=>fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($d5837a14d54538d4$var$isTransformedUser);
    function $d5837a14d54538d4$var$isUserValue(fieldValue) {
        return fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'displayName' in fieldValue && 'avatarUrls' in fieldValue;
    }
    function $d5837a14d54538d4$var$isUserValueList(fieldValue) {
        return fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue.every($d5837a14d54538d4$var$isUserValue);
    }
    function $d5837a14d54538d4$var$transformToUserValue(fieldValue) {
        const { accountId: accountId, name: name, picture: picture } = fieldValue;
        return {
            accountId: accountId,
            displayName: name,
            avatarUrl: picture,
            avatarUrls: {
                '48x48': picture
            }
        };
    }
    function $d5837a14d54538d4$var$getPastedValue(clipboardItem, metadata) {
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("jO40L")).userSupportedTypes))) return null;
        if (!$d5837a14d54538d4$var$isUserValue(metadata.fieldValue)) return null;
        return metadata.fieldValue;
    }
    function $d5837a14d54538d4$var$getPastedValuePlural(clipboardItem, metadata) {
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasRichFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("jO40L")).multiUserSupportedTypes))) return null;
        if (!$d5837a14d54538d4$var$isUserValueList(metadata.fieldValue)) return null;
        return metadata.fieldValue;
    }
    const $d5837a14d54538d4$var$useAssigneeClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("9pwsK")).default)({
            issueKey: issue.key,
            initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.displayName || null,
            currentValue: value,
            getPastedValue: $d5837a14d54538d4$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $d5837a14d54538d4$var$useReporterClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("jXbbD")).useReporterField)({
            issueKey: issue.key,
            initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.displayName || null,
            currentValue: value,
            getPastedValue: $d5837a14d54538d4$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $d5837a14d54538d4$var$useSingleUserClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lKk7c")).useUserCustomField)({
            issueKey: issue.key,
            fieldKey: field.fieldId,
            initialValue: $d5837a14d54538d4$var$isTransformedUser(field.value) ? $d5837a14d54538d4$var$transformToUserValue(field.value) : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.displayName || null,
            currentValue: value,
            getPastedValue: $d5837a14d54538d4$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $d5837a14d54538d4$var$useMultiUserClipboardHandler = (issue, field)=>{
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("5FzCC")).useMultiUserCustomField)({
            issueKey: issue.key,
            fieldKey: field.fieldId,
            initialValue: $d5837a14d54538d4$var$isTransformedUserList(field.value) ? field.value.map($d5837a14d54538d4$var$transformToUserValue) : undefined
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: value?.map((user)=>user.displayName).join(', ') || null,
            currentValue: value,
            getPastedValue: $d5837a14d54538d4$var$getPastedValuePlural,
            saveValue: saveValue
        });
    };
    const $d5837a14d54538d4$var$UserClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($d5837a14d54538d4$var$useSingleUserClipboardHandler);
    const $d5837a14d54538d4$var$MultiUserClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($d5837a14d54538d4$var$useMultiUserClipboardHandler);
    const $d5837a14d54538d4$var$AssigneeClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($d5837a14d54538d4$var$useAssigneeClipboardHandler);
    const $d5837a14d54538d4$var$ReporterClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($d5837a14d54538d4$var$useReporterClipboardHandler);
    const $d5837a14d54538d4$export$5fdc9960135beb70 = {
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: $d5837a14d54538d4$var$UserClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $d5837a14d54538d4$var$ReporterClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $d5837a14d54538d4$var$AssigneeClipboardHelper
    };
    const $d5837a14d54538d4$export$6c011954430f0654 = {
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: $d5837a14d54538d4$var$MultiUserClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $d5837a14d54538d4$var$MultiUserClipboardHelper
    };
});
parcelRegister("9pwsK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$698ad2ce222cbf0d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $gHS8W;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $lQE94;
    var $54wEF;
    var $3fAi8;
    var $1kqLh;
    const $698ad2ce222cbf0d$var$getCurrentAssigneeUrl = (_baseUrl, issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
    const $698ad2ce222cbf0d$var$getCurrentAssignee = async (baseUrl, issueKey)=>{
        const response = await (0, (0, parcelRequire("eusud")).performGetRequest)($698ad2ce222cbf0d$var$getCurrentAssigneeUrl(baseUrl, issueKey), {
            ...(0, (0, parcelRequire("gHS8W")).default)
        });
        const { assignee: assignee } = response.fields;
        return assignee;
    };
    const $698ad2ce222cbf0d$export$e3a8121b536e7353 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
        const fieldKey = (0, $e9be48d6d2c01760$export$e18419056f3d184a);
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'user');
        const [, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
        });
        const baseUrl = '';
        const onSaveSuccess = (0, $5uXOq.useCallback)((currentAssignee)=>{
            if (currentAssignee && currentAssignee.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) $698ad2ce222cbf0d$var$getCurrentAssignee(baseUrl, issueKey).then((assignee)=>{
                setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$e18419056f3d184a), assignee);
                onSuccess?.(assignee);
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'currentAssigneeFetch',
                        packageName: 'jiraIssueFieldAssignee'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                onSuccess?.(currentAssignee);
            });
            else onSuccess?.(currentAssignee);
        }, [
            baseUrl,
            issueKey,
            onSuccess,
            setFieldValue
        ]);
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSaveSuccess,
            onFailure: onFailure,
            saveField: (0, (0, parcelRequire("4R6GH")).fg)('issue_cards_in_program_board') ? onSaveField || (0, (0, parcelRequire("1kqLh")).saveAssigneeField) : (0, (0, parcelRequire("1kqLh")).saveAssigneeField)
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
    var $698ad2ce222cbf0d$export$2e2bcd8739ae039 = $698ad2ce222cbf0d$export$e3a8121b536e7353;
});
const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';
parcelRegister("1kqLh", function(module, exports) {
    $parcel$export(module.exports, "saveAssigneeField", ()=>$181ec719237f646a$export$4966afe29c596da8);
    var $eusud;
    const $181ec719237f646a$export$4966afe29c596da8 = async (issueKey, fieldKey, newValue, _baseUrl)=>{
        const userValue = newValue;
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/assignee`, {
            body: JSON.stringify({
                accountId: userValue?.accountId || null
            })
        });
    };
});
parcelRegister("lKk7c", function(module, exports) {
    $parcel$export(module.exports, "useUserCustomField", ()=>$915ad675f09dae67$export$44f19b35a6cf5de7);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $915ad675f09dae67$export$44f19b35a6cf5de7 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).USER_CF_TYPE));
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("5FzCC", function(module, exports) {
    $parcel$export(module.exports, "useMultiUserCustomField", ()=>$aa0502e28ab7d5f7$export$80bbf5398d3851fe);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $aa0502e28ab7d5f7$export$80bbf5398d3851fe = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE));
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("jXbbD", function(module, exports) {
    $parcel$export(module.exports, "useReporterField", ()=>$26ce637363a1a7cc$export$62a1425ef3dadde5);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $26ce637363a1a7cc$export$62a1425ef3dadde5 = ({ issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
        const fieldKey = (0, $e9be48d6d2c01760$export$45cafdfd629c3ca1);
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, fieldKey);
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).REPORTER_TYPE));
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("jO40L", function(module, exports) {
    $parcel$export(module.exports, "userSupportedTypes", ()=>$9ab5e35e7add97a9$export$ef7e74d56a5479e);
    $parcel$export(module.exports, "multiUserSupportedTypes", ()=>$9ab5e35e7add97a9$export$60f19a2c9595ba14);
    var $5fc53;
    const $9ab5e35e7add97a9$export$ef7e74d56a5479e = [
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)
    ];
    const $9ab5e35e7add97a9$export$60f19a2c9595ba14 = [
        (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)
    ];
});
parcelRegister("9UQ66", function(module, exports) {
    $parcel$export(module.exports, "versionClipboardHandler", ()=>$9e30f249684de572$export$ac26006c0d5889ca);
    var $lQE94;
    var $5fc53;
    var $4UjyI;
    var $ks0ly;
    var $3O2T0;
    var $8g1d0;
    const $9e30f249684de572$var$isTransformedSingleVersion = (option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option;
    const $9e30f249684de572$var$isTransformedMultipleVersions = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($9e30f249684de572$var$isTransformedSingleVersion);
    const $9e30f249684de572$var$emptyValue = [];
    function $9e30f249684de572$var$assertVersionField(field) {
        if (!field) throw new Error('Field is required');
        if (field.type !== (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && field.type !== (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)) throw new Error('Field type is not supported');
    }
    const $9e30f249684de572$var$getPastedValue = (clipboardItem, metadata)=>{
        if (!(0, (0, parcelRequire("3O2T0")).assertClipboardHasPlainTextFormat)(clipboardItem) || !(0, (0, parcelRequire("3O2T0")).assertClipboardDataIsCompatible)(metadata, (0, (0, parcelRequire("8g1d0")).versionSupportedTypes))) return null;
        if (!$9e30f249684de572$var$isTransformedMultipleVersions(metadata?.fieldValue) && !$9e30f249684de572$var$isTransformedSingleVersion(metadata?.fieldValue)) return null;
        if (!(0, (0, parcelRequire("8g1d0")).versionSupportedTypes).includes(metadata.fieldType)) return null;
        return metadata?.fieldValue;
    };
    const $9e30f249684de572$var$getInitialValue = (field)=>{
        if (field.type === (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)) return field.value ?? null;
        return $9e30f249684de572$var$isTransformedMultipleVersions(field.value) ? field.value : $9e30f249684de572$var$emptyValue;
    };
    const $9e30f249684de572$var$useVersionClipboardHandler = (issue, field)=>{
        $9e30f249684de572$var$assertVersionField(field);
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: field.fieldId,
            issueKey: issue.key,
            fieldType: field.type,
            initialValue: $9e30f249684de572$var$getInitialValue(field)
        });
        return (0, (0, parcelRequire("ks0ly")).useClipboardHandler)({
            issue: issue,
            field: field,
            currentStringValue: $9e30f249684de572$var$isTransformedSingleVersion(field.value) ? field.value?.name ?? null : field.value?.map((v)=>v.name).join(',') ?? null,
            currentValue: value,
            getPastedValue: $9e30f249684de572$var$getPastedValue,
            saveValue: saveValue
        });
    };
    const $9e30f249684de572$var$VersionClipboardHelper = (0, (0, parcelRequire("4UjyI")).createClipboardHelperComponent)($9e30f249684de572$var$useVersionClipboardHandler);
    const $9e30f249684de572$export$ac26006c0d5889ca = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $9e30f249684de572$var$VersionClipboardHelper
    };
});
parcelRegister("9de3P", function(module, exports) {
    $parcel$export(module.exports, "getFieldMetadataFromClipboard", ()=>$8710af0b45a9f4dc$export$6de7bf511f204c08);
    const $8710af0b45a9f4dc$export$6de7bf511f204c08 = (clipboard)=>{
        if (!clipboard?.html) return null;
        try {
            const clipboardDocument = new DOMParser().parseFromString(clipboard.html, 'text/html');
            const data = clipboardDocument.body?.querySelector('div')?.dataset;
            if (!data || !data.fieldType || !data.fieldId) return null;
            return {
                fieldType: data.fieldType,
                fieldId: data.fieldId,
                fieldValue: data.fieldValue ? JSON.parse(data.fieldValue) : null,
                sourceIssueTypeLevel: data.issueTypeLevel
            };
        } catch (e) {
            return null;
        }
    };
    const $8710af0b45a9f4dc$export$94a5f06e658f87e2 = ()=>Promise.resolve(false);
});
parcelRegister("g65iA", function(module, exports) {
    $parcel$export(module.exports, "canBeReset", ()=>$4a9a7d152ef300aa$export$7f0aa0ea8c7401f3);
    $parcel$export(module.exports, "useClipboardErrorReporting", ()=>$4a9a7d152ef300aa$export$a3594035e6545378);
    $parcel$export(module.exports, "setDataToClipboard", ()=>$4a9a7d152ef300aa$export$8b3dcc1c5e2cc52e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bj6Oi;
    var $bxNFR;
    var $1xoxe;
    var $jcw0u;
    var $6s1PB;
    var $7HGHK;
    var $pa9q9;
    var $koVbs;
    var $bGSLr;
    const $4a9a7d152ef300aa$var$UNSETTABLE_FIELD_TYPES = {
        issuekey: true,
        issuetype: true,
        priority: true,
        status: true,
        parent: true
    };
    const $4a9a7d152ef300aa$export$7f0aa0ea8c7401f3 = (field)=>{
        const isEditable = field.fieldConfig?.isEditable ?? false;
        const isRequired = field.fieldConfig?.isRequired ?? false;
        if (field.type != null && field.type in $4a9a7d152ef300aa$var$UNSETTABLE_FIELD_TYPES) return false;
        return isEditable && !isRequired;
    };
    const $4a9a7d152ef300aa$var$getPasteMessage = (error, wrappedFormatMessage)=>{
        if ((0, (0, parcelRequire("bj6Oi")).isClientSideValidationError)(error)) {
            if (error.message === (0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).EMPTY_CLIPBOARD) return {
                title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).emptyClipboardTitle),
                description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteEmptyClipboardError)
            };
            if (error.message === (0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).MISSING_FIELD) return {
                title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteErrorTitle),
                description: wrappedFormatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("bGSLr")).default).missingFieldAssociationErrorIssueTermRefresh : (0, (0, parcelRequire("bGSLr")).default).missingFieldAssociationError)
            };
            if (error.message === (0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_COMPATIBLE_FIELD_TYPE) return {
                title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteErrorTitle),
                description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteUnsupportedError)
            };
        }
        if ((0, (0, parcelRequire("bxNFR")).isUnsupportedOperationError)(error)) return {
            title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteErrorTitle),
            description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteUnsupportedError)
        };
        return {
            title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).pasteErrorTitle),
            description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).genericServerError)
        };
    };
    const $4a9a7d152ef300aa$var$getCutMessage = (error, wrappedFormatMessage)=>{
        if ((0, (0, parcelRequire("bj6Oi")).isClientSideValidationError)(error) && error.message === (0, (0, parcelRequire("1xoxe")).VALIDATION_ERROR_CODES).NON_EDITABLE) return {
            title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).cutErrorTitle),
            description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).cutNonEditableError)
        };
        return {
            title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).cutErrorTitle),
            description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).genericServerError)
        };
    };
    const $4a9a7d152ef300aa$var$getCopyMessage = (error, wrappedFormatMessage)=>({
            title: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).copyErrorTitle),
            description: wrappedFormatMessage((0, (0, parcelRequire("bGSLr")).default).copyValidationError)
        });
    const $4a9a7d152ef300aa$var$getErrorMessage = (action, error, wrappedFormatMessage)=>{
        if (action === 'paste') return $4a9a7d152ef300aa$var$getPasteMessage(error, wrappedFormatMessage);
        if (action === 'cut') return $4a9a7d152ef300aa$var$getCutMessage(error, wrappedFormatMessage);
        if (action === 'copy') return $4a9a7d152ef300aa$var$getCopyMessage(error, wrappedFormatMessage);
    };
    const $4a9a7d152ef300aa$var$uniqueFlagId = (0, (0, parcelRequire("7HGHK")).toFlagId)('LIST_COPY_PASTE_FLAG');
    const $4a9a7d152ef300aa$export$a3594035e6545378 = (field)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const reportError = (0, $5uXOq.useCallback)(({ action: action, error: error })=>{
            if (!error) return;
            const ugcSafeMessage = `Failed to ${action} a field of type ${field.type}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraClipboardController',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: field.type,
                    operation: action
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            const wrappedFormatMessage = (message)=>formatMessage(message, {
                    name: field.name
                });
            const errorMessage = $4a9a7d152ef300aa$var$getErrorMessage(action, error, wrappedFormatMessage);
            if (!errorMessage) return;
            showFlag({
                id: $4a9a7d152ef300aa$var$uniqueFlagId,
                type: (0, (0, parcelRequire("bj6Oi")).isClientSideValidationError)(error) ? 'warning' : 'error',
                title: errorMessage.title,
                description: errorMessage.description
            });
        }, [
            showFlag,
            field.type,
            field.name,
            formatMessage
        ]);
        return {
            reportError: reportError,
            dismissFlag: ()=>dismissFlag($4a9a7d152ef300aa$var$uniqueFlagId)
        };
    };
    const $4a9a7d152ef300aa$export$8b3dcc1c5e2cc52e = (e, clipboardItem)=>{
        if (!e.clipboardData || !clipboardItem || !clipboardItem.plainText || !clipboardItem.html) throw new Error('Clipboard item is not provided');
        e.clipboardData.setData('text/plain', clipboardItem.plainText);
        e.clipboardData.setData('text/html', clipboardItem.html);
    };
});
parcelRegister("bGSLr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ab19ff3c4a36483$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3ab19ff3c4a36483$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pasteErrorTitle: {
            "id": "business-list.controllers.clipboard.paste-error-title",
            "defaultMessage": "Unable to paste"
        },
        cutErrorTitle: {
            "id": "business-list.controllers.clipboard.cut-error-title",
            "defaultMessage": "We couldn't cut this field"
        },
        copyErrorTitle: {
            "id": "business-list.controllers.clipboard.copy-error-title",
            "defaultMessage": "Unable to copy"
        },
        emptyClipboardTitle: {
            "id": "business-list.controllers.clipboard.empty-clipboard-title",
            "defaultMessage": "Your clipboard is empty"
        },
        genericServerError: {
            "id": "business-list.controllers.clipboard.generic-server-error",
            "defaultMessage": "Your changes couldn't be saved."
        },
        pasteUnsupportedError: {
            "id": "business-list.controllers.clipboard.paste-unsupported-error",
            "defaultMessage": "This can't be pasted on {name}."
        },
        missingFieldAssociationError: {
            "id": "business-list.controllers.clipboard.missing-field-association-error",
            "defaultMessage": "Can't paste on {name}, looks like the field is not associated to this issue type."
        },
        cutNonEditableError: {
            "id": "business-list.controllers.clipboard.cut-non-editable-error",
            "defaultMessage": "{name} is copied to your clipboard instead."
        },
        copyValidationError: {
            "id": "business-list.controllers.clipboard.copy-validation-error",
            "defaultMessage": "{name} can't be copied."
        },
        pasteEmptyClipboardError: {
            "id": "business-list.controllers.clipboard.paste-empty-clipboard-error",
            "defaultMessage": "Cut or copy your data, then try again."
        },
        missingFieldAssociationErrorIssueTermRefresh: {
            "id": "business-list.controllers.clipboard.missing-field-association-error-issue-term-refresh",
            "defaultMessage": "Can't paste on {name}, looks like the field is not associated to this work type."
        }
    });
});
parcelRegister("d3rVJ", function(module, exports) {
    $parcel$export(module.exports, "KEY_LEFT", ()=>$dea06fb03addf101$export$fc4577f2a2af0ae3);
    $parcel$export(module.exports, "KEY_RIGHT", ()=>$dea06fb03addf101$export$c40f9845adc73fb5);
    $parcel$export(module.exports, "KEY_UP", ()=>$dea06fb03addf101$export$390330c10ff2b9a1);
    $parcel$export(module.exports, "KEY_DOWN", ()=>$dea06fb03addf101$export$a80636c6f41931fe);
    $parcel$export(module.exports, "KEY_SPACE", ()=>$dea06fb03addf101$export$e51a3576c045c8d5);
    $parcel$export(module.exports, "KEY_ENTER", ()=>$dea06fb03addf101$export$8152f929a25a0ff4);
    $parcel$export(module.exports, "KEY_ESCAPE", ()=>$dea06fb03addf101$export$929c2026f4dd54a2);
    $parcel$export(module.exports, "KEY_TAB", ()=>$dea06fb03addf101$export$10f6869ed0a7d75b);
    $parcel$export(module.exports, "VALID_HORIZONTAL_NAV_KEYS", ()=>$dea06fb03addf101$export$4db3e0c7105aa3de);
    $parcel$export(module.exports, "VALID_NAVIGATION_KEYS", ()=>$dea06fb03addf101$export$dbef91493a5ef2ef);
    $parcel$export(module.exports, "NAV_KEYS_TO_DIRECTION", ()=>$dea06fb03addf101$export$678e8f968de3f1e5);
    $parcel$export(module.exports, "getNewNavSupportedFieldTypes", ()=>$dea06fb03addf101$export$a421a6d0cf26d9e);
    var $8QpSo;
    var $hE5wF;
    var $7q7Al;
    var $5fc53;
    var $eTDjN;
    const $dea06fb03addf101$export$fc4577f2a2af0ae3 = 'ArrowLeft';
    const $dea06fb03addf101$export$c40f9845adc73fb5 = 'ArrowRight';
    const $dea06fb03addf101$export$390330c10ff2b9a1 = 'ArrowUp';
    const $dea06fb03addf101$export$a80636c6f41931fe = 'ArrowDown';
    const $dea06fb03addf101$export$e51a3576c045c8d5 = ' ';
    const $dea06fb03addf101$export$8152f929a25a0ff4 = 'Enter';
    const $dea06fb03addf101$export$929c2026f4dd54a2 = 'Escape';
    const $dea06fb03addf101$export$10f6869ed0a7d75b = 'Tab';
    const $dea06fb03addf101$export$4db3e0c7105aa3de = new Set([
        $dea06fb03addf101$export$fc4577f2a2af0ae3,
        $dea06fb03addf101$export$c40f9845adc73fb5,
        $dea06fb03addf101$export$10f6869ed0a7d75b
    ]);
    const $dea06fb03addf101$export$dbef91493a5ef2ef = new Set([
        ...$dea06fb03addf101$export$4db3e0c7105aa3de,
        $dea06fb03addf101$export$390330c10ff2b9a1,
        $dea06fb03addf101$export$a80636c6f41931fe,
        $dea06fb03addf101$export$e51a3576c045c8d5,
        $dea06fb03addf101$export$8152f929a25a0ff4,
        $dea06fb03addf101$export$929c2026f4dd54a2
    ]);
    const $dea06fb03addf101$export$678e8f968de3f1e5 = {
        [$dea06fb03addf101$export$fc4577f2a2af0ae3]: (0, (0, parcelRequire("eTDjN")).LEFT),
        [$dea06fb03addf101$export$c40f9845adc73fb5]: (0, (0, parcelRequire("eTDjN")).RIGHT),
        [$dea06fb03addf101$export$390330c10ff2b9a1]: (0, (0, parcelRequire("eTDjN")).UP),
        [$dea06fb03addf101$export$a80636c6f41931fe]: (0, (0, parcelRequire("eTDjN")).DOWN)
    };
    const $dea06fb03addf101$var$NEW_NAV_SUPPORTED_FIELD_TYPES = new Set([
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).COMMENT_TYPE),
        (0, (0, parcelRequire("hE5wF")).COMMENT_SUMMARY_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE),
        (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        'key'
    ]);
    const $dea06fb03addf101$export$a421a6d0cf26d9e = (0, (0, parcelRequire("8QpSo")).default)(()=>new Set([
            ...$dea06fb03addf101$var$NEW_NAV_SUPPORTED_FIELD_TYPES,
            ...(0, (0, parcelRequire("7q7Al")).getSupportedFieldTypes)(true)
        ]));
});
parcelRegister("i29pf", function(module, exports) {
    $parcel$export(module.exports, "CellWithHorizontalVirtualization", ()=>$1ecf207fc704f608$export$9f868e7b7b690ae0);
    var $5uXOq = parcelRequire("5uXOq");
    var $7q7Al;
    var $7xKtR;
    var $cjOYL;
    var $3fT9O;
    var $3rO9r;
    var $cYskc;
    var $jUhIo;
    const $1ecf207fc704f608$export$195172c54e8df31 = ({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width })=>(0, (0, parcelRequire("7xKtR")).isFieldCellTypes)(field.type) && (0, (0, parcelRequire("7xKtR")).isFieldCellSupported)(field.type) ? (params)=>{
            const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
            if ((0, (0, parcelRequire("3fT9O")).isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN))) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testId": "business-list.ui.list-view.loading-cell",
                style: (0, (0, parcelRequire("cjOYL")).loadingCellStyles)
            });
            let cellData;
            if ((0, (0, parcelRequire("7q7Al")).isTopLevelField)(field.type)) {
                const key = (0, (0, parcelRequire("7q7Al")).getTopLevelFieldKey)(field.type);
                if (key) cellData = rowData[key];
            } else cellData = rowData.fields?.find((f)=>f.fieldId === field.id);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUhIo")).WithCellSelection), {
                depth: rowData.depth,
                width: width,
                fieldId: field.id,
                projectId: projectId,
                issueId: rowData.issueId,
                position: rowIndex === 0 ? (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) : (0, $44496cc0f0c1ce14$export$a3a66eb204e551b3),
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                field: field,
                issue: rowData
            }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7xKtR")).FieldCell), {
                    fieldType: field.type ?? '',
                    ...params,
                    cellData: cellData,
                    onIssueUpdated: onIssueUpdated,
                    fieldId: field.id,
                    fieldName: field.name
                }));
        } : (params)=>{
            const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
            if ((0, (0, parcelRequire("3fT9O")).isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, (0, parcelRequire("3rO9r")).PLACEHOLDER_COLUMN))) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testId": "business-list.ui.list-view.loading-cell",
                style: (0, (0, parcelRequire("cjOYL")).loadingCellStyles)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jUhIo")).WithCellSelection), {
                depth: rowData.depth,
                width: width,
                fieldId: field.id,
                projectId: projectId,
                issueId: rowData.issueId,
                position: rowIndex === 0 ? (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) : (0, $44496cc0f0c1ce14$export$a3a66eb204e551b3),
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                field: field,
                issue: rowData
            }, ()=>cellRenderers[field.id](params));
        };
    const $1ecf207fc704f608$export$f6f0c3fe4ec306ea = (0, $5uXOq.memo)(({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, $1ecf207fc704f608$export$195172c54e8df31({
            cellRenderers: cellRenderers,
            field: field,
            onIssueUpdated: onIssueUpdated,
            projectId: projectId,
            width: width
        })({
            ...rest,
            onIssueUpdated: onIssueUpdated
        })));
    $1ecf207fc704f608$export$f6f0c3fe4ec306ea.displayName = 'Cell';
    const $1ecf207fc704f608$export$9f868e7b7b690ae0 = (props)=>{
        const isColumnVisible = (0, (0, parcelRequire("cYskc")).useIsColumnVisible)(props.column);
        return isColumnVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement($1ecf207fc704f608$export$f6f0c3fe4ec306ea, props) : null;
    };
});
const $44496cc0f0c1ce14$export$86bcdda8e7a22b9d = 'inner';
const $44496cc0f0c1ce14$export$a3a66eb204e551b3 = 'outer';
parcelRegister("7xKtR", function(module, exports) {
    $parcel$export(module.exports, "isFieldCellSupported", ()=>$50b53fd6303170ad$export$33fa2ddeaefadb7f);
    $parcel$export(module.exports, "isFieldCellTypes", ()=>$50b53fd6303170ad$export$6a0360e2da5b783e);
    $parcel$export(module.exports, "FieldCell", ()=>$50b53fd6303170ad$export$8ae908fe84f8a33b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $4R6GH;
    var $9hMF9;
    var $3RxLo;
    var $7Qe9Z;
    var $lna2D;
    var $kpNUY;
    var $8egWI;
    var $c2t1Z;
    var $kpiLK;
    var $1RGG5;
    var $cphvi;
    var $jRQOz;
    const $50b53fd6303170ad$var$createFieldCellComponents = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("jRQOz")).versionCellHandler),
            ...(0, (0, parcelRequire("kpNUY")).parentCellHandler),
            ...(0, (0, parcelRequire("3RxLo")).devSummaryCellHandler),
            ...(0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? (0, (0, parcelRequire("7Qe9Z")).goalsCellHandler) : {},
            ...(0, (0, parcelRequire("cphvi")).teamCellHandler),
            ...(0, (0, parcelRequire("kpiLK")).resolutionCellHandler),
            ...(0, (0, parcelRequire("lna2D")).groupCellHandler),
            ...(0, (0, parcelRequire("1RGG5")).statusCategoryCellHandler),
            ...(0, (0, parcelRequire("c2t1Z")).radioSelectCellHandler),
            ...(0, (0, parcelRequire("8egWI")).projectCellHandler),
            ...(0, (0, parcelRequire("9hMF9")).cascadingSelectCellHandler)
        }));
    const $50b53fd6303170ad$export$33fa2ddeaefadb7f = (fieldType)=>{
        const Components = $50b53fd6303170ad$var$createFieldCellComponents();
        return Components[fieldType] != null;
    };
    const $50b53fd6303170ad$export$6a0360e2da5b783e = (_)=>true;
    const $50b53fd6303170ad$export$8ae908fe84f8a33b = ({ fieldType: fieldType, ...cellProps })=>{
        const Components = $50b53fd6303170ad$var$createFieldCellComponents();
        if (!$50b53fd6303170ad$export$6a0360e2da5b783e(fieldType)) return null;
        const Component = Components[fieldType];
        if (Component == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, cellProps);
    };
});
parcelRegister("9hMF9", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectCellHandler", ()=>$43d2cd2de4baae92$export$27b118c54b403d55);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $5fc53;
    var $dZxXA;
    var $b5lmY;
    var $dNtZc;
    var $iCm5X;
    const $43d2cd2de4baae92$export$4f505fdc26f544f5 = ({ rowData: issue, cellData: field, setEditMode: setEditMode, editMode: editMode, column: { width: preferredWidth }, cellRef: cellRef })=>{
        const [cascadingSelectValue, setCascadingSelectValue] = (0, $5uXOq.useState)(field?.value ?? null);
        (0, $5uXOq.useEffect)(()=>{
            setCascadingSelectValue(field?.value ?? null);
        }, [
            field?.value
        ]);
        const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
            issue.fieldConfig?.isEditable
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
            const [{ value: value }] = (0, (0, parcelRequire("dZxXA")).useCascadingSelectField)({
                fieldAriId: field?.id ?? '',
                issueKey: issue.key,
                fieldKey: field?.fieldId ?? '',
                initialValue: field?.value ?? null
            });
            if (value !== cascadingSelectValue) setCascadingSelectValue(value);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-fields.ui.cascading-select.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dNtZc")).CascadingSelectEdit), {
            cellRef: cellRef,
            setEditMode: setEditMode,
            fieldAriId: field?.id ?? '',
            onChange: setCascadingSelectValue,
            preferredWidth: preferredWidth,
            readContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCm5X")).CascadingSelectRead), {
                value: cascadingSelectValue
            }),
            currentValue: cascadingSelectValue,
            issueKey: issue.key,
            fieldKey: field?.fieldId || ''
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCm5X")).CascadingSelectRead), {
            value: cascadingSelectValue
        }));
    };
    const $43d2cd2de4baae92$export$27b118c54b403d55 = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $43d2cd2de4baae92$export$4f505fdc26f544f5
    };
});
parcelRegister("dNtZc", function(module, exports) {
    $parcel$export(module.exports, "CascadingSelectEdit", ()=>$d278b52f9752e6e0$export$e624ed4af58fd142);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $jOJ3A;
    const $d278b52f9752e6e0$export$e624ed4af58fd142 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("jOJ3A")).CascadingSelectEditEntryPoint), {});
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.cascadingSelect.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("jOJ3A", function(module, exports) {
    $parcel$export(module.exports, "CascadingSelectEditEntryPoint", ()=>$5d4b7f45d5089d76$export$93e961c95d3c1b6a);
    var $eufEc;
    var $fEDBv;
    const $5d4b7f45d5089d76$export$93e961c95d3c1b6a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("h8LhJ")), {
            moduleId: "2a2020e5"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("h8LhJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("80wEF").then(()=>parcelRequire('lylJ2'));
});
parcelRegister("iCm5X", function(module, exports) {
    $parcel$export(module.exports, "CascadingSelectRead", ()=>$bbdaaf7db4173b66$export$1e55dc71aaaa2cc4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $jKNTt;
    const $bbdaaf7db4173b66$export$1e55dc71aaaa2cc4 = ({ value: value })=>{
        if (value == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $bbdaaf7db4173b66$var$containerStyles
        }, (0, (0, parcelRequire("jKNTt")).getCascadingSelectStringValue)(value));
    };
    const $bbdaaf7db4173b66$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        display: 'block'
    });
});
parcelRegister("3RxLo", function(module, exports) {
    $parcel$export(module.exports, "devSummaryCellHandler", ()=>$59f75287926d77d9$export$31d4252fa9154106);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $b5lmY;
    var $bThTZ;
    const $59f75287926d77d9$export$e04e820b15fa1f63 = ({ rowData: rowData, cellData: cellData, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: false
        }, cellData && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bThTZ")).DevSummaryRead), {
            ...cellData,
            isHovering: false,
            issueId: rowData.issueId,
            editMode: editMode,
            setEditMode: setEditMode,
            cellRef: cellRef
        }));
    const $59f75287926d77d9$export$31d4252fa9154106 = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: $59f75287926d77d9$export$e04e820b15fa1f63
    };
});
parcelRegister("bThTZ", function(module, exports) {
    $parcel$export(module.exports, "DevSummaryRead", ()=>$31f6a400bfa036d1$export$9147ca8c33d1d192);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $8YTUU;
    var $lxrPB;
    var $kcaDR;
    var $7XluA;
    var $4mO32;
    var $kaHBi;
    var $3bQtK;
    var $a3HWu;
    var $9OXo1;
    var $lfl7G;
    var $5ryCV;
    const $31f6a400bfa036d1$var$popupOffset = [
        -8,
        0
    ];
    const $31f6a400bfa036d1$var$scopeId = 'software-list.list';
    const $31f6a400bfa036d1$export$9147ca8c33d1d192 = ({ issueId: issueId, isMerged: isMerged, isUnderReview: isUnderReview, commitCount: commitCount, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, ...props })=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const issueAri = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("kcaDR")).createIssueAri)(cloudId, issueId.toString()), [
            cloudId,
            issueId
        ]);
        const devInfoType = isMerged || isUnderReview ? (0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST : (0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT;
        const { id: experienceId, name: experienceName } = (0, (0, parcelRequire("lfl7G")).experienceDetails)[devInfoType];
        const onExperienceSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experienceName
        });
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                issueId: issueAri
            }), [
            issueAri
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("lfl7G")).popupEntryPoints)[devInfoType], entryPointParams, (0, (0, parcelRequire("lfl7G")).metricsDev)[devInfoType]);
        const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("lfl7G")).packageDetails)[devInfoType],
                errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lxrPB")).default), {
                        devInfoType: devInfoType,
                        issueAri: issueAri,
                        scopeId: $31f6a400bfa036d1$var$scopeId
                    })
            }), [
            devInfoType,
            issueAri
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                issueAri: issueAri,
                devInfoType: devInfoType,
                onReady: ()=>{
                    stopMetric();
                    onExperienceSuccess();
                },
                scopeId: $31f6a400bfa036d1$var$scopeId
            }), [
            issueAri,
            devInfoType,
            stopMetric,
            onExperienceSuccess
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (editMode) entryPointActions.load();
        }, [
            editMode,
            entryPointActions
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
            if (!editMode) entryPointActions.preload();
        }, [
            entryPointActions,
            editMode
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
            entryPointActions.cancelPreload();
        }, [
            entryPointActions
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ref: ref,
                role: "button",
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHaspopup,
                "aria-controls": ariaControls,
                xcss: $31f6a400bfa036d1$var$triggerContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ryCV")).DevSummaryLozenge), {
                isMerged: isMerged,
                isUnderReview: isUnderReview,
                commitCount: commitCount,
                ...props
            })), [
            commitCount,
            isMerged,
            isUnderReview,
            props
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.code === 'Tab') return true;
            return false;
        }, []);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDown
            }), [
            handleKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        if (!isMerged && !isUnderReview && commitCount === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($31f6a400bfa036d1$var$Container, {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            "data-testId": "business-fields.ui.dev-summary.cell.read.container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "bottom-start",
            autoFocus: false,
            shouldUseCaptureOnOutsideClick: true,
            testId: "business-fields.ui.dev-summary.cell.read.popup",
            trigger: popupTrigger,
            isOpen: editMode,
            offset: $31f6a400bfa036d1$var$popupOffset,
            onClose: ()=>setEditMode(false),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
                    analyticsSource: experienceName,
                    experience: experienceName,
                    experienceId: experienceId
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    ...entryPointErrorBoundaryProps,
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3HWu")).DevInfoDetailsPopupSkeleton), {
                        devinfoType: devInfoType
                    }),
                    runtimeProps: runtimeProps
                }))
        }));
    };
    const $31f6a400bfa036d1$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $31f6a400bfa036d1$var$triggerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        boxSizing: 'border-box',
        alignItems: 'center'
    });
});
parcelRegister("8YTUU", function(module, exports) {
    $parcel$export(module.exports, "DevInfoTypes", ()=>$ba5542dc32884ee4$export$a100703e17b2650a);
    $parcel$export(module.exports, "DevInfoTypeMap", ()=>$ba5542dc32884ee4$export$39c00ace65e13f2d);
    $parcel$export(module.exports, "ButtonStatus", ()=>$ba5542dc32884ee4$export$477d4d2d93581a40);
    const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
        BRANCH: 'branch',
        COMMIT: 'commit',
        PULLREQUEST: 'pullrequest',
        DECLINED: 'declined',
        MERGED: 'merged',
        DEPLOYMENT: 'deployment',
        DESIGN: 'design'
    });
    const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
        [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
        [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
        [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
    };
    const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
        ACTIVE: 'active',
        HOVER: 'hover',
        DEFAULT: 'default'
    });
});
parcelRegister("lxrPB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfd87e1125ba31c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $7nnPp;
    var $koVbs;
    var $ifS9h;
    var $8YTUU;
    var $dt6Va;
    var $el2W3;
    const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, (0, parcelRequire("dt6Va")).useShowDevDetailDialogForPopup)(scopeId);
        const handleLinkClick = ()=>{
            showDevDetailDialogForPopup(devInfoType, issueAri);
        };
        const devInfoTypeName = (0, (0, parcelRequire("8YTUU")).DevInfoTypeMap)[devInfoType];
        const errorMessage = devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN ? formatMessage((0, (0, parcelRequire("el2W3")).default).designErrorDescription, {
            devInfoType: devInfoTypeName
        }) : formatMessage((0, (0, parcelRequire("el2W3")).default).errorDescription, {
            devInfoType: devInfoTypeName
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupTitle), null, formatMessage((0, (0, parcelRequire("el2W3")).default).errorPopupTitle, {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypeMap)[devInfoType]
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, (0, parcelRequire("el2W3")).default).errorTitle)))), (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN && (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
            appearance: "link",
            onClick: handleLinkClick
        }, formatMessage((0, (0, parcelRequire("el2W3")).default).developmentErrorDescriptionCta))));
    };
    var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
    const $cfd87e1125ba31c4$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$Header = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ifS9h", function(module, exports) {
    $parcel$export(module.exports, "PopupContainer", ()=>$88fc3594fd7e78a2$export$cca08eed9de89ba9);
    $parcel$export(module.exports, "LinkContainer", ()=>$88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
    $parcel$export(module.exports, "PopupHeader", ()=>$88fc3594fd7e78a2$export$b11ea9d6e8111404);
    $parcel$export(module.exports, "StyledDate", ()=>$88fc3594fd7e78a2$export$30301703d55848e7);
    $parcel$export(module.exports, "RepositoryInfo", ()=>$88fc3594fd7e78a2$export$fde5e3d077213a6f);
    $parcel$export(module.exports, "PopupTitle", ()=>$88fc3594fd7e78a2$export$b834616c6081368f);
    $parcel$export(module.exports, "StyledLink", ()=>$88fc3594fd7e78a2$export$9048d548939551ee);
    $parcel$export(module.exports, "PopupOverflowSection", ()=>$88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
    $parcel$export(module.exports, "PopupKeyline", ()=>$88fc3594fd7e78a2$export$a0765d4427758c62);
    $parcel$export(module.exports, "PopupOverflowButton", ()=>$88fc3594fd7e78a2$export$aeb11758c9d29e5c);
    $parcel$export(module.exports, "TimeDisplay", ()=>$88fc3594fd7e78a2$export$9b3df3d60caed5f9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $41j30;
    const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$30301703d55848e7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$fde5e3d077213a6f = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$80b51772092eddc0 = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _1p1dangw _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xxsmall",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
    const $88fc3594fd7e78a2$export$9048d548939551ee = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("41j30")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81doa _k48p1igg _syaz1y58 _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$a0765d4427758c62 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3it94y _bfhk1wws _otyrutpp",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _80omtlke",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("dt6Va", function(module, exports) {
    $parcel$export(module.exports, "useShowDevDetailDialogForPopup", ()=>$71478bde10e2ba46$export$cdc75a6c65207319);
    var $4HJKb;
    var $dXq4S;
    var $8YTUU;
    const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, (0, parcelRequire("dXq4S")).parseAri)(issueAri)?.resourceId;
    const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
        if (devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
        if (devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
        return devInfoType;
    };
    function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
        const { showDevDetailDialog: showDevDetailDialog } = (0, (0, parcelRequire("4HJKb")).useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
        const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
            const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
            const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
            showDevDetailDialog(type, undefined, '', issueId);
        };
        return {
            showDevDetailDialogForPopup: showDevDetailDialogForPopup
        };
    }
});
parcelRegister("4HJKb", function(module, exports) {
    $parcel$export(module.exports, "loadDialogBridge", ()=>$ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
    $parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", ()=>$ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
    $parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", ()=>$ccf4b85a4aaf3a68$export$693f51ab225dff94);
    $parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", ()=>$ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
    var $6BZYo;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $bKpgX;
    var $62M1I;
    const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>(0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: (0, (0, parcelRequire("62M1I")).DEV_DETAILS_WRM_RESOURCE),
            wrmKeys: [
                'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
                'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
            ]
        });
    const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
        resetState: (stateOverrides)=>({ setState: setState })=>{
                setState({
                    ...(0, (0, parcelRequire("62M1I")).INITIAL_STATE),
                    ...stateOverrides
                });
            },
        updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    ...stateUpdates
                });
            },
        showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
                if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) setState({
                    ...getState(),
                    legacyDevPanelDetailsDialogShownCounter: getState().legacyDevPanelDetailsDialogShownCounter + 1,
                    isDevPanelDetailsDialogShown: false,
                    dataTypeSelected: itemType,
                    legacyData: legacyData,
                    issueKey: targetIssueKey,
                    issueId: targetIssueId
                });
                else setState({
                    ...getState(),
                    isDevPanelDetailsDialogShown: true,
                    dataTypeSelected: itemType,
                    issueKey: targetIssueKey,
                    issueId: targetIssueId
                });
            },
        closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    ...getState(),
                    dataTypeSelected: '',
                    isDevPanelDetailsDialogShown: false,
                    issueKey: undefined,
                    issueId: undefined
                });
            }
    };
    const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'DetailsDialogLoaderRemoteState',
        initialState: (0, (0, parcelRequire("62M1I")).INITIAL_STATE),
        actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
    });
    const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, (0, parcelRequire("gg7kZ")).createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, (0, parcelRequire("51nlc")).createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, (0, parcelRequire("3sQ5x")).createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
        return (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
    }
});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';
const $61a2cd6236d50c20$export$74189cec821240a6 = 'development.details.remote-links';
parcelRegister("62M1I", function(module, exports) {
    $parcel$export(module.exports, "INITIAL_STATE", ()=>$bf37254db56efc10$export$36d128238e6b60f5);
    $parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", ()=>$bf37254db56efc10$export$43a8ab4f373ff0ee);
    const $bf37254db56efc10$export$36d128238e6b60f5 = {
        issueId: '',
        issueKey: undefined,
        locale: 'en_US',
        dataTypeSelected: '',
        legacyData: undefined,
        isDevPanelDetailsDialogShown: false,
        legacyDevPanelDetailsDialogShownCounter: 0
    };
    const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
    const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
    const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';
});
parcelRegister("el2W3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06bd70345536382a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $06bd70345536382a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorPopupTitle: {
            "id": "development-board-common.error-fallback.error-popup-title",
            "defaultMessage": "{devInfoType}"
        },
        errorTitle: {
            "id": "development-board-common.error-fallback.error-title",
            "defaultMessage": "Something went wrong"
        },
        errorDescription: {
            "id": "development-board-common.error-fallback.error-description",
            "defaultMessage": "For some reason we couldn't load this {devInfoType}."
        },
        developmentErrorDescriptionCta: {
            "id": "development-board-common.error-fallback.development-error-description-cta",
            "defaultMessage": "View all development information."
        },
        designErrorDescription: {
            "id": "development-board-common.error-fallback.design-error-description",
            "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
        }
    });
});
parcelRegister("kcaDR", function(module, exports) {
    $parcel$export(module.exports, "createIssueAri", ()=>$f1bea1631292edff$export$6b0ec881a3540845);
    var $dXq4S;
    const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        });
});
parcelRegister("a3HWu", function(module, exports) {
    $parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", ()=>$93f34a824a74f869$export$9044eba4855892a5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $kfBZt = parcelRequire("kfBZt");
    var $if4PE = parcelRequire("if4PE");
    var $gVTPk = parcelRequire("gVTPk");
    var $i2tpm = parcelRequire("i2tpm");
    var $5swzJ = parcelRequire("5swzJ");
    const $93f34a824a74f869$var$customCssStyles = null;
    const $93f34a824a74f869$var$skeletonStyles = null;
    const $93f34a824a74f869$export$ae7439e01588d047 = {
        BRANCH: 'branch',
        COMMIT: 'commit',
        PULLREQUEST: 'pullrequest',
        DEPLOYMENT: 'deployment',
        DESIGN: 'design'
    };
    const $93f34a824a74f869$var$skeletonAsset = {
        [$93f34a824a74f869$export$ae7439e01588d047.BRANCH]: (0, ($parcel$interopDefault($kfBZt))),
        [$93f34a824a74f869$export$ae7439e01588d047.COMMIT]: (0, ($parcel$interopDefault($if4PE))),
        [$93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST]: (0, ($parcel$interopDefault($5swzJ))),
        [$93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT]: (0, ($parcel$interopDefault($gVTPk))),
        [$93f34a824a74f869$export$ae7439e01588d047.DESIGN]: (0, ($parcel$interopDefault($i2tpm)))
    };
    const $93f34a824a74f869$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: $93f34a824a74f869$var$skeletonAsset[devinfoType],
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw _rcujmgjw"
            ])
        }));
});
parcelRegister("kfBZt", function(module, exports) {
    module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();
});
parcelRegister("if4PE", function(module, exports) {
    module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();
});
parcelRegister("gVTPk", function(module, exports) {
    module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();
});
parcelRegister("i2tpm", function(module, exports) {
    module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();
});
parcelRegister("5swzJ", function(module, exports) {
    module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();
});
parcelRegister("lfl7G", function(module, exports) {
    $parcel$export(module.exports, "metricsDev", ()=>$b87793044194a9b0$export$9d08247a1076ddb0);
    $parcel$export(module.exports, "experienceDetails", ()=>$b87793044194a9b0$export$ba2604b0fdde2542);
    $parcel$export(module.exports, "packageDetails", ()=>$b87793044194a9b0$export$48b44d9f3c6e15de);
    $parcel$export(module.exports, "popupEntryPoints", ()=>$b87793044194a9b0$export$1452632269dce6);
    var $dGrdR;
    var $6KTxo;
    var $8YTUU;
    var $890PS;
    const $b87793044194a9b0$var$commitDetailsPopupLoad = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'list.commit-details-popup-load'
    });
    const $b87793044194a9b0$var$prDetailsPopupLoad = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'list.pr-details-popup-load'
    });
    const $b87793044194a9b0$export$9d08247a1076ddb0 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: $b87793044194a9b0$var$commitDetailsPopupLoad,
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: $b87793044194a9b0$var$prDetailsPopupLoad
    };
    const $b87793044194a9b0$export$ba2604b0fdde2542 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: {
            id: 'commitDetailsPopup',
            name: 'jiraSoftwareListCommitDetailsPopup'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: {
            id: 'prDetailsPopup',
            name: 'jiraSoftwareListPrDetailsPopup'
        }
    };
    const $b87793044194a9b0$export$48b44d9f3c6e15de = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: {
            id: 'renderCommitDetailsPopup',
            packageName: 'jiraDevelopmentListCommitDetailsPopup',
            teamName: 'fusion-isotopes'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: {
            id: 'renderPRDetailsPopup',
            packageName: 'jiraDevelopmentListPrDetailsPopup',
            teamName: 'fusion-isotopes'
        }
    };
    const $b87793044194a9b0$export$1452632269dce6 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: (0, (0, parcelRequire("6KTxo")).commitDetailsEntryPoint),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: (0, (0, parcelRequire("890PS")).pullRequestDetailsEntryPoint)
    };
});
parcelRegister("6KTxo", function(module, exports) {
    $parcel$export(module.exports, "commitDetailsEntryPoint", ()=>$9842290edc643ca7$export$543707906869c79b);
    var $kmK4e;
    var $eufEc;
    var $fEDBv;
    const $9842290edc643ca7$export$543707906869c79b = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bppAv")), {
            moduleId: "c43c4a0f"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    commitDetailsForIssue: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("kmK4e")).default,
                        variables: {
                            issueId: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("kmK4e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1a92de7c94d3b0d$export$2e2bcd8739ae039);
    const $e1a92de7c94d3b0d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
            "metadata": {},
            "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;
});
parcelRegister("bppAv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fxdbP").then(()=>parcelRequire('1ml2E'));
});
parcelRegister("890PS", function(module, exports) {
    $parcel$export(module.exports, "pullRequestDetailsEntryPoint", ()=>$0896cca9b8d893af$export$37ab544e7066c095);
    var $5E8Mw;
    var $eufEc;
    var $fEDBv;
    const $0896cca9b8d893af$export$37ab544e7066c095 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fRRC0")), {
            moduleId: "1b74db53"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    pullRequestDetailsForIssue: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("5E8Mw")).default,
                        variables: {
                            issueId: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("5E8Mw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a4d40ac042e33e2$export$2e2bcd8739ae039);
    const $6a4d40ac042e33e2$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
            "metadata": {},
            "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;
});
parcelRegister("fRRC0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("98n7j")
    ]).then(()=>parcelRequire('cnLAn'));
});
parcelRegister("5ryCV", function(module, exports) {
    $parcel$export(module.exports, "DevSummaryLozenge", ()=>$2b9afaa1c90ae7b8$export$3bb699b6db60f511);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $koVbs;
    var $k2xO1;
    var $fRYcY;
    const $2b9afaa1c90ae7b8$export$3bb699b6db60f511 = ({ isUnderReview: isUnderReview, isMerged: isMerged, commitCount: commitCount, pullRequestsCount: pullRequestsCount })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isMerged || isUnderReview) {
            const tooltipText = formatMessage((0, (0, parcelRequire("fRYcY")).default).pullRequest, {
                count: pullRequestsCount
            });
            const lozengeText = isMerged ? formatMessage((0, (0, parcelRequire("fRYcY")).default).merged) : formatMessage((0, (0, parcelRequire("fRYcY")).default).underReview);
            const lozengeAppearance = isMerged ? 'success' : 'default';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltipText,
                position: "top"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                appearance: lozengeAppearance
            }, lozengeText)));
        }
        if (commitCount > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2b9afaa1c90ae7b8$var$linkStyles
        }, formatMessage((0, (0, parcelRequire("fRYcY")).default).commit, {
            count: commitCount
        }));
    };
    const $2b9afaa1c90ae7b8$var$linkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.blue',
        paddingLeft: 'space.075'
    });
});
parcelRegister("fRYcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4429f82c000b7221$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4429f82c000b7221$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        underReview: {
            "id": "business-fields.dev-summary.cell.read.lozenge.under-review",
            "defaultMessage": "Under review"
        },
        merged: {
            "id": "business-fields.dev-summary.cell.read.lozenge.merged",
            "defaultMessage": "Merged"
        },
        commit: {
            "id": "business-fields.dev-summary.cell.read.lozenge.commit",
            "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
        },
        pullRequest: {
            "id": "business-fields.dev-summary.cell.read.lozenge.pull-request",
            "defaultMessage": "{count, plural, one {# pull request} other {# pull requests}}"
        }
    });
});
parcelRegister("7Qe9Z", function(module, exports) {
    $parcel$export(module.exports, "goalsCellHandler", ()=>$91d6f645e6d5af35$export$524e25319ef30df1);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hv5Vo;
    var $l213r;
    var $5fc53;
    var $2NMNM;
    var $b5lmY;
    var $cZbJv;
    var $jno68;
    const $91d6f645e6d5af35$var$defaultValue = {
        goals: [],
        totalCount: 0
    };
    const $91d6f645e6d5af35$export$aea87ff07be8100d = ({ rowData: issue, cellData: field, editMode: editMode, setEditMode: setEditMode, fieldId: fieldId, fieldName: fieldName, cellRef: cellRef })=>{
        const [goalsValue, setGoalsValue] = (0, $5uXOq.useState)(field?.value ?? $91d6f645e6d5af35$var$defaultValue);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isEditable = field?.isEditable ?? true;
        const isFieldAssociated = (0, (0, parcelRequire("jno68")).useIsFieldAssociatedWithIssueType)({
            fieldId: fieldId,
            issueTypeId: issue.issuetype?.id
        });
        const [{ value: value }, { saveValue: saveValue }] = (0, (0, parcelRequire("l213r")).useGoalsField)({
            issueId: issue.issueId,
            issueKey: issue.key,
            fieldKey: fieldId,
            initialValue: field?.value ?? $91d6f645e6d5af35$var$defaultValue
        });
        (0, $5uXOq.useEffect)(()=>{
            setGoalsValue(field?.value ?? $91d6f645e6d5af35$var$defaultValue);
        }, [
            field?.value
        ]);
        if (!(0, ($parcel$interopDefault($ajpes)))(value, goalsValue)) setGoalsValue(value);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
        }, [
            setEditMode
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.code === 'Tab') return true;
            return false;
        }, []);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDown
            }), [
            handleKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const onGoalPicked = (0, $5uXOq.useCallback)((goal)=>{
            const newValue = {
                goals: [
                    ...goalsValue.goals,
                    goal
                ],
                totalCount: goalsValue.totalCount + 1
            };
            setGoalsValue(newValue);
            saveValue(newValue, null, createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            goalsValue.goals,
            goalsValue.totalCount,
            saveValue
        ]);
        const onGoalUnlinked = (0, $5uXOq.useCallback)((_, remainingGoals)=>{
            const newValue = {
                goals: remainingGoals,
                totalCount: goalsValue.totalCount > 0 ? goalsValue.totalCount - 1 : 0
            };
            setGoalsValue(newValue);
            saveValue(newValue, null, createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            goalsValue.totalCount,
            saveValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable
        }, isFieldAssociated && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hv5Vo")).default), {
            issueAri: issue.id,
            editMode: editMode,
            goals: goalsValue.goals,
            goalCount: goalsValue.totalCount,
            onClose: onClose,
            isEditable: isEditable,
            onGoalPicked: onGoalPicked,
            onGoalUnlinked: onGoalUnlinked
        }), !isFieldAssociated && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZbJv")).AssociateFieldPopup), {
            isOpen: editMode,
            issueType: issue.issuetype?.name,
            issueTypeId: issue.issuetype?.id,
            fieldId: fieldId,
            fieldName: fieldName,
            onClose: onClose
        }));
    };
    const $91d6f645e6d5af35$export$524e25319ef30df1 = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: $91d6f645e6d5af35$export$aea87ff07be8100d
    };
});
parcelRegister("hv5Vo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d219a9dbdcde069$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $kMSay;
    var $cm8b5;
    var $47gW9;
    var $7XluA;
    var $4mO32;
    var $pa9q9;
    var $ctrpc;
    var $5fc53;
    var $2NMNM;
    var $koeKL;
    var $e9BT8;
    var $hvXUb;
    var $g75FT;
    var $gZCQJ;
    var $c0Z9B;
    var $1JUx3;
    const $4d219a9dbdcde069$var$POPUP_OFFSET = [
        -8,
        8
    ];
    const $4d219a9dbdcde069$var$GoalsPicker = ({ issueAri: issueAri, goals: goals, goalCount: goalCount, isEditable: isEditable, editMode: editMode, onClose: onClose, onGoalPicked: onGoalPicked, onGoalUnlinked: onGoalUnlinked, shouldRenderToParent: shouldRenderToParent = false, showPlaceholder: showPlaceholder })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const pressTracing = (0, (0, parcelRequire("kMSay")).default)('platform-goal-picker');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const ariaLabel = (0, (0, parcelRequire("gZCQJ")).useGoalsCellAriaLabel)({
            goalCount: goalCount,
            showPlaceholder: showPlaceholder
        });
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("e9BT8")).VIEW_GOAL_PICKER_EXPERIENCE));
        const { showFlag: showFlag, hasFlag: hasFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("c0Z9B")).goalPickerPopoverEntryPoint), {
            cloudId: cloudId,
            issueAri: issueAri
        });
        const buttonTrigger = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        (0, $5uXOq.useEffect)(()=>{
            if (editMode) entryPointActions.load();
        }, [
            editMode,
            entryPointActions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (editMode) {
                startExperience();
                pressTracing();
                (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE), {
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        fieldType: 'goals'
                    }
                });
            }
        }, [
            editMode,
            startExperience,
            pressTracing,
            createAnalyticsEvent
        ]);
        const handleGoalPicked = (0, $5uXOq.useCallback)((goal)=>{
            (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: 'goals',
                    goalId: goal.id,
                    action: 'goal linked',
                    numLinkedGoals: goalCount + 1
                }
            });
            onGoalPicked(goal);
        }, [
            createAnalyticsEvent,
            goalCount,
            onGoalPicked
        ]);
        const handleGoalUnlinked = (0, $5uXOq.useCallback)((goalUnlinkedId, remainingGoals)=>{
            (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: 'goals',
                    goalId: goalUnlinkedId,
                    action: 'goal unlinked',
                    numLinkedGoals: remainingGoals.length
                }
            });
            onGoalUnlinked(goalUnlinkedId, remainingGoals);
        }, [
            createAnalyticsEvent,
            onGoalUnlinked
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                role: "button",
                "aria-label": ariaLabel,
                xcss: $4d219a9dbdcde069$var$triggerStyles,
                ...triggerProps,
                ref: (element)=>{
                    buttonTrigger(element);
                    triggerProps.ref(element);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g75FT")).GoalsCellContent), {
                showPlaceholder: showPlaceholder,
                goals: goals,
                goalCount: goalCount,
                isEditable: isEditable
            })), [
            ariaLabel,
            buttonTrigger,
            goalCount,
            goals,
            isEditable,
            showPlaceholder
        ]);
        const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
            if (!hasFlag?.((0, (0, parcelRequire("1JUx3")).ERROR_FLAG_ID))) showFlag((0, (0, parcelRequire("1JUx3")).POPUP_ENTRYPOINT_ERROR_FLAG));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
                experience: (0, (0, parcelRequire("e9BT8")).VIEW_GOAL_PICKER_EXPERIENCE),
                error: error
            });
        }, [
            hasFlag,
            showFlag
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                issueAri: issueAri,
                goalCount: goalCount,
                onGoalPicked: handleGoalPicked,
                onGoalUnlinked: handleGoalUnlinked,
                onClose: onClose
            }), [
            goalCount,
            handleGoalPicked,
            handleGoalUnlinked,
            issueAri,
            onClose
        ]);
        const content = (0, $5uXOq.useCallback)(({ update: update })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "jwm.goals.picker.edit.popup",
                packageName: "jiraBusinessGoalPicker",
                teamName: "jira-yurree",
                runtimeProps: {
                    ...runtimeProps,
                    onContentsResized: update
                },
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hvXUb")).LoadingContent), null),
                errorFallback: errorFallback
            }), [
            entryPointReferenceSubject,
            errorFallback,
            runtimeProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $4d219a9dbdcde069$var$goalPickerStyles,
            alignItems: "center",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            autoFocus: false,
            isOpen: editMode,
            content: content,
            trigger: popupTrigger,
            offset: $4d219a9dbdcde069$var$POPUP_OFFSET,
            placement: "bottom-start",
            shouldRenderToParent: shouldRenderToParent,
            onClose: onClose,
            shouldUseCaptureOnOutsideClick: true
        }));
    };
    var $4d219a9dbdcde069$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($4d219a9dbdcde069$var$GoalsPicker);
    const $4d219a9dbdcde069$var$triggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        width: '100%',
        flexGrow: 1,
        flexDirection: 'column',
        alignItems: 'center'
    });
    const $4d219a9dbdcde069$var$goalPickerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minHeight: '100%',
        width: '100%'
    });
});
parcelRegister("e9BT8", function(module, exports) {
    $parcel$export(module.exports, "VIEW_GOAL_PICKER_EXPERIENCE", ()=>$7ba6d9612cf1f5cf$export$e665d677258d0141);
    const $7ba6d9612cf1f5cf$export$e665d677258d0141 = {
        experience: 'viewGoalPicker',
        packageName: 'jiraBusinessGoalPicker',
        teamName: 'jira-yurree'
    };
});
parcelRegister("hvXUb", function(module, exports) {
    $parcel$export(module.exports, "LoadingContent", ()=>$46b92da982e69756$export$4ab3512e4872e6ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $kgoHi;
    var $8CUq3;
    var $eZJjh;
    const $46b92da982e69756$export$4ab3512e4872e6ff = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "center",
            alignItems: "center",
            xcss: $46b92da982e69756$var$loadingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        }));
    const $46b92da982e69756$var$loadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        width: '342px',
        padding: 'space.500'
    });
});
parcelRegister("g75FT", function(module, exports) {
    $parcel$export(module.exports, "GoalsCellContent", ()=>$e1e87c226c626164$export$72e457a3c2c5d2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4iV1e;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $en3kR;
    var $koVbs;
    var $jjqnH;
    var $9ChYQ;
    var $6nBz0;
    const $e1e87c226c626164$export$72e457a3c2c5d2a = ({ goals: goals, goalCount: goalCount, isEditable: isEditable, showPlaceholder: showPlaceholder = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (goalCount > 0 && goals !== null && goals.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($e1e87c226c626164$var$Wrapper, {
            "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $e1e87c226c626164$var$iconStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("en3kR")).GoalIcon), {
            size: "16",
            appearance: (0, (0, parcelRequire("en3kR")).normalizeGoalAppearance)(goals[0].status || 'PENDING')
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjqnH")).GoalName), {
            name: goals[0].name
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ChYQ")).GoalsCount), {
            goalCount: goalCount
        }));
        let noGoalsContent;
        if (showPlaceholder) noGoalsContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e1e87c226c626164$var$noGoalsStyles
        }, formatMessage((0, (0, parcelRequire("6nBz0")).default).noGoals));
        else if (isEditable) noGoalsContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e1e87c226c626164$var$addGoalStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4iV1e"))))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }), formatMessage((0, (0, parcelRequire("6nBz0")).default).addGoal));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e1e87c226c626164$var$Wrapper, {
            "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
        }, noGoalsContent);
    };
    const $e1e87c226c626164$var$GOAL_PICKER_ADD_GOAL_DISPLAY = '--jira-goal-picker-cell-add-goal-display';
    const $e1e87c226c626164$var$addGoalStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: `var(${$e1e87c226c626164$var$GOAL_PICKER_ADD_GOAL_DISPLAY}, none)`,
        gap: 'space.100',
        alignItems: 'center',
        color: 'color.text.subtlest'
    });
    const $e1e87c226c626164$var$noGoalsStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        gap: 'space.100',
        alignItems: 'center',
        color: 'color.text.subtlest'
    });
    const $e1e87c226c626164$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _80omtlke _1bsb1osq _4t3i1osq _u5f3u2gc _vchhusvi _16jlkb7n _4cvr1h6o _zulpu2gc _tj4x1txw _2ooc1txw",
                __cmplp.className
            ])
        });
    });
    const $e1e87c226c626164$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: 'space.200'
    });
});
parcelRegister("en3kR", function(module, exports) {
    $parcel$export(module.exports, "GoalIcon", ()=>$a6db28d963218554$export$134cbcd70c6693b8);
    $parcel$export(module.exports, "normalizeGoalAppearance", ()=>$a6db28d963218554$export$f1b3ca93191ce5cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cwmS5;
    var $4iV1e;
    var $4DRId;
    var $3pgsH;
    var $h7ddS;
    var $dOSG9;
    const $a6db28d963218554$var$appearanceToColorMap = {
        default: 'gray',
        menu: 'gray',
        off_track: 'red',
        at_risk: 'yellow',
        on_track: 'green'
    };
    const $a6db28d963218554$var$appearanceToNewColorMap = {
        menu: "var(--ds-icon, #44546F)",
        default: "var(--ds-icon-accent-gray, #758195)",
        off_track: "var(--ds-icon-danger, #C9372C)",
        at_risk: "var(--ds-icon-warning, #E56910)",
        on_track: "var(--ds-icon-success, #22A06B)"
    };
    const $a6db28d963218554$var$keyToIconMap = {
        GOAL: (0, ($parcel$interopDefault((0, parcelRequire("4iV1e"))))),
        OBJECTIVE: (0, ($parcel$interopDefault((0, parcelRequire("3pgsH"))))),
        KEY_RESULT: (0, ($parcel$interopDefault((0, parcelRequire("4DRId")))))
    };
    const $a6db28d963218554$var$getLabel = (intl, label, localizedLabel)=>{
        if (label) return label;
        if (localizedLabel && (0, (0, parcelRequire("dOSG9")).isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, (0, parcelRequire("dOSG9")).messages)[localizedLabel.messageId]);
        return '';
    };
    const $a6db28d963218554$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const iconLabel = $a6db28d963218554$var$getLabel(intl, label, localizedLabel);
        const Icon = $a6db28d963218554$var$keyToIconMap[goalIconKey];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isVisualRefresh ? (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: $a6db28d963218554$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            size: size,
            icon: Icon,
            label: iconLabel,
            appearance: $a6db28d963218554$var$appearanceToColorMap[appearance]
        }));
    };
    const $a6db28d963218554$export$f1b3ca93191ce5cc = (statusValue)=>{
        const appearanceLowercase = statusValue.toLocaleLowerCase();
        return (0, (0, parcelRequire("h7ddS")).isGoalAppearance)(appearanceLowercase) ? appearanceLowercase : 'default';
    };
});
parcelRegister("cwmS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a921419639fe8f6f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a921419639fe8f6f$var$sizeMap = {
        '16': {
            name: "157xhr7",
            styles: "width:16px;height:16px"
        },
        '24': {
            name: "rrel8y",
            styles: "width:24px;height:24px"
        },
        '32': {
            name: "68x97p",
            styles: "width:32px;height:32px"
        },
        '40': {
            name: "1mfsro6",
            styles: "width:40px;height:40px"
        },
        '48': {
            name: "18jhpep",
            styles: "width:48px;height:48px"
        }
    };
    const $a921419639fe8f6f$var$appearanceMap = {
        grayBold: {
            name: "algye9",
            styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        limeBold: {
            name: "a86nvv",
            styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        greenBold: {
            name: "13e2qqr",
            styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        blueBold: {
            name: "jpsdma",
            styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        redBold: {
            name: "1bg8y7a",
            styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        purpleBold: {
            name: "19bo3lb",
            styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        magentaBold: {
            name: "1l16rgo",
            styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        tealBold: {
            name: "7kw5zl",
            styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        orangeBold: {
            name: "h77eay",
            styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        yellowBold: {
            name: "sbe4w3",
            styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        gray: {
            name: "yxgei8",
            styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
        },
        lime: {
            name: "o9c6oh",
            styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
        },
        orange: {
            name: "szqzk5",
            styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
        },
        magenta: {
            name: "o6ptuw",
            styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
        },
        green: {
            name: "157dg7e",
            styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
        },
        blue: {
            name: "x3nujl",
            styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
        },
        red: {
            name: "zqoyws",
            styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
        },
        purple: {
            name: "fitjkd",
            styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
        },
        teal: {
            name: "b3m1ww",
            styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
        },
        yellow: {
            name: "1j18jub",
            styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
        }
    };
    const $a921419639fe8f6f$var$shapeMap = {
        square: {
            name: "vwdoqr",
            styles: "border-radius:var(--ds-border-radius-100, 4px)"
        },
        circle: {
            name: "i2ucdk",
            styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
        }
    };
    const $a921419639fe8f6f$var$iconTileStyles = {
        name: "ykimcl",
        styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
    };
    function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
        const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
        const ExpandedIcon = Icon;
        if (LEGACY_fallbackComponent && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $a921419639fe8f6f$var$iconTileStyles,
                $a921419639fe8f6f$var$appearanceMap[appearance],
                $a921419639fe8f6f$var$sizeMap[size],
                $a921419639fe8f6f$var$shapeMap[shape]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        }));
    }
});
parcelRegister("4DRId", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3614780827b64603$var$_react = $3614780827b64603$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3614780827b64603$var$_UNSAFE_baseNew = $3614780827b64603$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3614780827b64603$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3614780827b64603$var$KeyResultIcon = (props)=>$3614780827b64603$var$_react.default.createElement($3614780827b64603$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.5 3.5 9.477.75A10.96 10.96 0 0 0 6.75 8c0 2.777 1.052 5.314 2.75 7.25l3-2.75m-8.875-7L.75 8l2.875 2.5M11 8l1.5-1.5h2.75L14.5 8l.75 1.5H12.5zm0 0H1.25"/>`
        }, props));
    $3614780827b64603$var$KeyResultIcon.displayName = 'KeyResultIcon';
    var $3614780827b64603$var$_default = module.exports.default = $3614780827b64603$var$KeyResultIcon;
});
parcelRegister("3pgsH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $27b079e3ef5ffb2f$var$_react = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $27b079e3ef5ffb2f$var$_UNSAFE_baseNew = $27b079e3ef5ffb2f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $27b079e3ef5ffb2f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $27b079e3ef5ffb2f$var$ObjectiveIcon = (props)=>$27b079e3ef5ffb2f$var$_react.default.createElement($27b079e3ef5ffb2f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 1 1 8 .75M7.5 8.5l3.75-3.75m0 0v-2l2-2 .5 1.5 1.5.5-2 2zm.5 3.25A3.75 3.75 0 1 1 8 4.25"/>`
        }, props));
    $27b079e3ef5ffb2f$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
    var $27b079e3ef5ffb2f$var$_default = module.exports.default = $27b079e3ef5ffb2f$var$ObjectiveIcon;
});
parcelRegister("h7ddS", function(module, exports) {
    $parcel$export(module.exports, "isGoalAppearance", ()=>$926e58146ec2300b$export$86d2476abee3806b);
    const $926e58146ec2300b$export$d6870ac5e959c0f5 = [
        'default',
        'on_track',
        'at_risk',
        'off_track',
        'menu'
    ];
    const $926e58146ec2300b$export$86d2476abee3806b = (value)=>$926e58146ec2300b$export$d6870ac5e959c0f5.includes(value);
    const $926e58146ec2300b$export$d7b4c6a971e28318 = [
        'ON_TRACK',
        'AT_RISK',
        'OFF_TRACK',
        'PENDING',
        'DONE',
        'CANCELLED',
        'PAUSED',
        'ARCHIVED'
    ];
    const $926e58146ec2300b$export$4111757052fdbdc2 = [
        'GOAL',
        'OBJECTIVE',
        'KEY_RESULT'
    ];
});
parcelRegister("dOSG9", function(module, exports) {
    $parcel$export(module.exports, "isMessageId", ()=>$a371d973bdb7f9d5$export$d28699f9b486207b);
    $parcel$export(module.exports, "messages", ()=>$a371d973bdb7f9d5$export$defe85febe8b728c);
    var $7VHMR;
    const $a371d973bdb7f9d5$var$MESSAGE_IDS = [
        'townsquare.api.goal-state.on-track',
        'townsquare.api.goal-state.off-track',
        'townsquare.api.goal-state.at-risk',
        'townsquare.api.goal-state.pending',
        'townsquare.api.goal-state.completed',
        'townsquare.api.goal-state.cancelled',
        'townsquare.api.goal-state.paused'
    ];
    const $a371d973bdb7f9d5$export$d28699f9b486207b = (value)=>$a371d973bdb7f9d5$var$MESSAGE_IDS.includes(value);
    const $a371d973bdb7f9d5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        'townsquare.api.goal-state.on-track': {
            id: 'Goals.icon.label.on-track',
            defaultMessage: 'On track',
            description: 'The label for the "on track" goal status'
        },
        'townsquare.api.goal-state.off-track': {
            id: 'Goals.icon.label.off-track',
            defaultMessage: 'Off track',
            description: 'The label for the "off track" goal status'
        },
        'townsquare.api.goal-state.at-risk': {
            id: 'Goals.icon.label.at-risk',
            defaultMessage: 'At risk',
            description: 'The label for the "at risk" goal status'
        },
        'townsquare.api.goal-state.pending': {
            id: 'Goals.icon.label.pending',
            defaultMessage: 'Pending',
            description: 'The label for the "pending" goal status'
        },
        'townsquare.api.goal-state.completed': {
            id: 'Goals.icon.label.completed',
            defaultMessage: 'Completed',
            description: 'The label for the "completed" goal status'
        },
        'townsquare.api.goal-state.cancelled': {
            id: 'Goals.icon.label.cancelled',
            defaultMessage: 'Cancelled',
            description: 'The label for the "cancelled" goal status'
        },
        'townsquare.api.goal-state.paused': {
            id: 'Goals.icon.label.paused',
            defaultMessage: 'Paused',
            description: 'The label for the "paused" goal status'
        }
    });
});
parcelRegister("jjqnH", function(module, exports) {
    $parcel$export(module.exports, "GoalName", ()=>$ea6d388f7d79d28d$export$4427fb3cde8dd0cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $ea6d388f7d79d28d$export$4427fb3cde8dd0cf = ({ name: name })=>name && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ea6d388f7d79d28d$var$goalTextStyles,
            as: "span"
        }, name);
    const $ea6d388f7d79d28d$var$goalTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
});
parcelRegister("9ChYQ", function(module, exports) {
    $parcel$export(module.exports, "GoalsCount", ()=>$01e107082108f486$export$cb088e21a8acb84d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $01e107082108f486$export$cb088e21a8acb84d = ({ goalCount: goalCount })=>{
        const numberOfGoals = (0, $5uXOq.useMemo)(()=>goalCount > 1 ? `+${goalCount - 1}` : '', [
            goalCount
        ]);
        return numberOfGoals && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $01e107082108f486$var$countStyles
        }, numberOfGoals);
    };
    const $01e107082108f486$var$countStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.disabled',
        fontWeight: 400,
        borderRadius: 'border.radius',
        lineHeight: 0.8632,
        padding: 'space.050',
        pointerEvents: 'none'
    });
});
parcelRegister("6nBz0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa925733c785654d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aa925733c785654d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addGoal: {
            "id": "business-goal-picker.goals-cell-content.add-goal",
            "defaultMessage": "Add goal"
        },
        noGoals: {
            "id": "business-goal-picker.goals-cell-content.no-goals",
            "defaultMessage": "None"
        },
        linkGoals: {
            "id": "business-goal-picker.goals-cell-content.link-goals",
            "defaultMessage": "Link Goals"
        }
    });
});
parcelRegister("gZCQJ", function(module, exports) {
    $parcel$export(module.exports, "useGoalsCellAriaLabel", ()=>$bc223400301b4fa1$export$65ef52b68009f944);
    var $koVbs;
    var $6nBz0;
    const $bc223400301b4fa1$export$65ef52b68009f944 = ({ goalCount: goalCount, showPlaceholder: showPlaceholder })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (showPlaceholder) return undefined;
        if (goalCount === 0) return formatMessage((0, (0, parcelRequire("6nBz0")).default).addGoal);
        return formatMessage((0, (0, parcelRequire("6nBz0")).default).linkGoals);
    };
});
parcelRegister("c0Z9B", function(module, exports) {
    $parcel$export(module.exports, "goalPickerPopoverEntryPoint", ()=>$90eb827e4736f9e8$export$2917eb3a6c81ef7c);
    var $jcI49;
    var $eufEc;
    var $fEDBv;
    const $90eb827e4736f9e8$export$2917eb3a6c81ef7c = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fGyVH")), {
            moduleId: "97c2ac23"
        }),
        getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
                queries: {
                    mainGoalsPopupContentQuery: {
                        parameters: (0, (0, parcelRequire("jcI49")).default),
                        variables: {
                            cloudId: cloudId,
                            issueAri: issueAri
                        },
                        options: {
                            fetchPolicy: 'store-or-network'
                        }
                    }
                }
            })
    });
});
parcelRegister("jcI49", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56a552aaf657035b$export$2e2bcd8739ae039);
    const $56a552aaf657035b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "issueAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "cloudId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        }, v4 = {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }, v5 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            v4
        ], v6 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = [
            v7
        ], v9 = {
            "kind": "InlineFragment",
            "selections": v8,
            "type": "Node",
            "abstractKey": "__isNode"
        }, v10 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v11 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v12 = [
            "id"
        ], v13 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            },
            v4
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainGoalsPopupContentQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueGoals_AtlassianGoalPicker"
                    },
                    {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "TownsquareWorkspaceConnection",
                                "kind": "LinkedField",
                                "name": "allWorkspacesForOrg",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareWorkspaceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareWorkspace",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    v3
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainGoalsPopupContentQuery",
                "selections": [
                    {
                        "concreteType": "GraphStore",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                                "kind": "LinkedField",
                                "name": "jiraEpicContributesToAtlasGoal",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v7,
                                                            v3,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "url"
                                                            },
                                                            {
                                                                "concreteType": "TownsquareStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    },
                                                                    {
                                                                        "concreteType": "TownsquareLocalizationField",
                                                                        "kind": "LinkedField",
                                                                        "name": "localizedLabel",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "messageId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "TownsquareGoal"
                                                    },
                                                    v9
                                                ]
                                            },
                                            v10,
                                            v7
                                        ]
                                    },
                                    v11
                                ]
                            },
                            {
                                "args": v5,
                                "filters": v12,
                                "handle": "connection",
                                "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                                "kind": "LinkedHandle",
                                "name": "jiraEpicContributesToAtlasGoal"
                            },
                            {
                                "alias": "issueGoalPicker",
                                "args": v13,
                                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                                "kind": "LinkedField",
                                "name": "jiraEpicContributesToAtlasGoal",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v8,
                                                        "type": "TownsquareGoal"
                                                    },
                                                    v9
                                                ]
                                            },
                                            v10,
                                            v7
                                        ]
                                    },
                                    v11
                                ]
                            },
                            {
                                "alias": "issueGoalPicker",
                                "args": v13,
                                "filters": v12,
                                "handle": "connection",
                                "key": "Goals_issueGoalPicker",
                                "kind": "LinkedHandle",
                                "name": "jiraEpicContributesToAtlasGoal"
                            }
                        ]
                    },
                    {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "TownsquareWorkspaceConnection",
                                "kind": "LinkedField",
                                "name": "allWorkspacesForOrg",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareWorkspaceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareWorkspace",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    v3,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "e291987f4b2f3c06a39fa1847bccf79e6c0a181764a535dbcd391aa5e7f53c2b",
                "metadata": {},
                "name": "mainGoalsPopupContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $56a552aaf657035b$var$node.hash = "465827f41dc8a072858c56967c88337f";
    var $56a552aaf657035b$export$2e2bcd8739ae039 = $56a552aaf657035b$var$node;
});
parcelRegister("fGyVH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8yffO")
    ]).then(()=>parcelRequire('hrswT'));
});
parcelRegister("1JUx3", function(module, exports) {
    $parcel$export(module.exports, "ERROR_FLAG_ID", ()=>$bf42591600af2e30$export$f5e4c120ac01b615);
    $parcel$export(module.exports, "POPUP_ENTRYPOINT_ERROR_FLAG", ()=>$bf42591600af2e30$export$bb0d35c1fc48487f);
    var $hadBz;
    const $bf42591600af2e30$export$f5e4c120ac01b615 = 'OPEN_GOAL_PICKER_ERROR_FLAG';
    const $bf42591600af2e30$export$bb0d35c1fc48487f = {
        id: $bf42591600af2e30$export$f5e4c120ac01b615,
        type: 'error',
        title: (0, (0, parcelRequire("hadBz")).default).errorFlagTitle,
        description: (0, (0, parcelRequire("hadBz")).default).errorFlagDescription,
        isAutoDismiss: true
    };
});
parcelRegister("hadBz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29eed584a2262e67$export$2e2bcd8739ae039);
    var $7VHMR;
    var $29eed584a2262e67$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "business-goal-picker.error-flag-title",
            "defaultMessage": "Something's gone wrong"
        },
        errorFlagDescription: {
            "id": "business-goal-picker.error-flag-description",
            "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
        }
    });
});
parcelRegister("l213r", function(module, exports) {
    $parcel$export(module.exports, "useGoalsField", ()=>$fa1aa5746e3ca5cc$export$c45dcf2640399301);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $lBwHJ;
    var $lQE94;
    var $5fc53;
    var $koeKL;
    var $iJZ8l;
    const $fa1aa5746e3ca5cc$export$c45dcf2640399301 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const getDataId = (0, $5uXOq.useCallback)((typeName, issue)=>(0, (0, parcelRequire("iJZ8l")).default)({
                id: (0, (0, parcelRequire("lBwHJ")).JiraIssuefieldvalueAri).create({
                    siteId: cloudId,
                    issueId: issue.toString(),
                    fieldId: fieldKey
                }).toString()
            }, typeName), [
            cloudId,
            fieldKey
        ]);
        const saveField = (0, $5uXOq.useCallback)((_iKey, _fKey, valuesForOperation)=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                if (!issueId) return;
                const dataID = getDataId('JiraGoalsField', issueId);
                if (!dataID) return;
                const goalsField = store.get(dataID);
                if (!goalsField) return;
                const connection = (0, $eiowN.ConnectionHandler).getConnection(goalsField, 'issue_view_goals_field_selectedGoals');
                if (connection == null) return;
                let edges = connection.getLinkedRecords('edges');
                if (!edges || edges.length === 0) {
                    const newGoalDataId = getDataId('JiraGoalsField:selectedGoals(first:1):edges:0', issueId);
                    if (!newGoalDataId) return;
                    const newEdge = (0, $eiowN.ConnectionHandler).createEdge(store, connection, store.create(newGoalDataId, 'JiraGoal'), 'JiraGoalEdge');
                    (0, $eiowN.ConnectionHandler).insertEdgeBefore(connection, newEdge);
                    edges = connection.getLinkedRecords('edges');
                }
                if (!edges) return;
                const node = edges[0].getLinkedRecord('node');
                if (valuesForOperation.totalCount === 0) {
                    const nodeId = node?.getDataID();
                    const edgeId = edges[0].getDataID();
                    if (!nodeId || !edgeId) return;
                    store.delete(nodeId);
                    store.delete(edgeId);
                    connection.setLinkedRecords([], 'edges');
                } else {
                    node?.setValue(valuesForOperation.goals[0].id, 'id');
                    node?.setValue(valuesForOperation.goals[0].name, 'name');
                    node?.setValue(valuesForOperation.goals[0].status, 'status');
                }
                connection?.setValue(valuesForOperation.totalCount, 'totalCount');
            });
            return Promise.resolve(undefined);
        }, [
            environment,
            getDataId,
            issueId
        ]);
        const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldType: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
            issueId: issueId,
            issueKey: issueKey,
            onSuccess: onSuccess,
            onFailure: onFailure,
            initialValue: initialValue,
            fieldKey: fieldKey,
            saveField: saveField,
            shouldPreventIssueViewSoftRefresh: true
        });
        return [
            {
                error: error,
                value: value
            },
            {
                resetError: resetError,
                saveValue: saveValue
            }
        ];
    };
});
parcelRegister("cZbJv", function(module, exports) {
    $parcel$export(module.exports, "AssociateFieldPopup", ()=>$7f730dd37615959a$export$bd4255b1f989bfbd);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1I7E8;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $daQYX;
    var $2AOGO;
    var $6s1PB;
    var $koVbs;
    var $1FGgx;
    const $7f730dd37615959a$var$POPUP_OFFSET = [
        -8,
        8
    ];
    const $7f730dd37615959a$export$bd4255b1f989bfbd = ({ isOpen: isOpen, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName, onClose: onClose })=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { associate: associate } = (0, (0, parcelRequire("2AOGO")).useAssociateField)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const canAssociateField = project.permissions.administerProject && project.isSimplified && issueType !== undefined && issueTypeId !== undefined;
        const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ref: ref,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHaspopup,
                "aria-controls": ariaControls,
                xcss: $7f730dd37615959a$var$triggerStyles,
                role: "button",
                "aria-label": formatMessage((0, (0, parcelRequire("1FGgx")).default).linkGoals)
            }), [
            formatMessage
        ]);
        const onAssociateField = (0, $5uXOq.useCallback)(()=>{
            associate({
                input: {
                    projectId: String(project.id),
                    fieldId: fieldId,
                    issueTypeIds: [
                        Number(issueTypeId)
                    ]
                },
                fieldName: fieldName,
                issueType: issueType,
                showSuccess: true,
                analyticsAttributes: {
                    source: 'business-list.shared.fields.goals-cell'
                }
            });
            onClose();
        }, [
            associate,
            fieldId,
            fieldName,
            issueType,
            issueTypeId,
            onClose,
            project.id
        ]);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.100",
                xcss: $7f730dd37615959a$var$popupStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1FGgx")).default).associateGoalsFieldBodyIssueTermRefresh : (0, (0, parcelRequire("1FGgx")).default).associateGoalsFieldBody, {
                issueType: issueType,
                fieldName: fieldName,
                bold: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunk)
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, canAssociateField ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                onClick: onAssociateField,
                appearance: "link",
                spacing: "none"
            }, formatMessage((0, (0, parcelRequire("1FGgx")).default).updateFieldAssociationAction)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                href: "/secure/ContactAdministrators!default.jspa",
                target: "_blank",
                onClick: onClose,
                appearance: "link",
                spacing: "none"
            }, formatMessage((0, (0, parcelRequire("1FGgx")).default).contactAdmin))))), [
            canAssociateField,
            fieldName,
            formatMessage,
            issueType,
            onAssociateField,
            onClose
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            content: content,
            trigger: popupTrigger,
            offset: $7f730dd37615959a$var$POPUP_OFFSET,
            placement: "bottom-start",
            onClose: onClose
        });
    };
    const $7f730dd37615959a$var$popupStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '300px',
        paddingTop: 'space.200',
        paddingBottom: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300'
    });
    const $7f730dd37615959a$var$triggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        width: '100%'
    });
});
parcelRegister("1FGgx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50db2cf807dc99d2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50db2cf807dc99d2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        associateGoalsFieldBody: {
            "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body",
            "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the <bold>{issueType}</bold> issue type."
        },
        contactAdmin: {
            "id": "business-fields.goals.cell.associate-field-popup.contact-admin",
            "defaultMessage": "Contact Admin"
        },
        updateFieldAssociationAction: {
            "id": "business-fields.goals.cell.associate-field-popup.update-field-association-action",
            "defaultMessage": "Update field association"
        },
        linkGoals: {
            "id": "business-fields.goals.cell.associate-field-popup.link-goals",
            "defaultMessage": "Link Goals"
        },
        associateGoalsFieldBodyIssueTermRefresh: {
            "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body-issue-term-refresh",
            "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the work type."
        }
    });
});
parcelRegister("jno68", function(module, exports) {
    $parcel$export(module.exports, "useIsFieldAssociatedWithIssueType", ()=>$30156937743291f0$export$cb0b144001cec81a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    const $30156937743291f0$export$cb0b144001cec81a = ({ fieldId: fieldId, issueTypeId: issueTypeId })=>{
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const isFieldAssociated = (0, $5uXOq.useMemo)(()=>{
            if (issueTypeId === undefined) return false;
            const issueTypeFields = typesWithFields.find((type)=>type.issueType.id === issueTypeId)?.fields;
            return issueTypeFields?.some((issueTypeField)=>issueTypeField.id === fieldId) ?? false;
        }, [
            fieldId,
            issueTypeId,
            typesWithFields
        ]);
        return isFieldAssociated;
    };
});
parcelRegister("lna2D", function(module, exports) {
    $parcel$export(module.exports, "groupCellHandler", ()=>$178b2eb52257e100$export$b2844c90dc2ccc0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $lQE94;
    var $5fc53;
    var $b5lmY;
    var $2etjA;
    var $3J9ez;
    const $178b2eb52257e100$export$2f128d21295c820 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
        const [selectedGroups, setSelectedGroups] = (0, $5uXOq.useState)(field?.value ?? null);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
            const [{ value: fieldValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
                fieldKey: field?.fieldId ?? '',
                issueKey: issue.key,
                fieldType: field?.type ?? '',
                initialValue: field?.value ?? null
            });
            if (!editMode && fieldValue !== selectedGroups) setSelectedGroups(fieldValue);
        }
        (0, $5uXOq.useEffect)(()=>{
            setSelectedGroups(field?.value ?? null);
        }, [
            field?.value
        ]);
        const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
            issue.fieldConfig?.isEditable
        ]);
        const isMulti = (0, $5uXOq.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker', [
            field?.type
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-fields.ui.group.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2etjA")).GroupEdit), {
            cellRef: cellRef,
            setEditMode: setEditMode,
            inputValue: inputValue,
            onInputChange: onInputChange,
            isMulti: isMulti,
            fieldName: field?.name || '',
            onChange: setSelectedGroups,
            preferredWidth: preferredWidth,
            selectedGroups: selectedGroups,
            fieldKey: field?.fieldId || '',
            issueKey: issue.key,
            fieldType: field?.type || '',
            initialValue: field?.value ?? null,
            readContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3J9ez")).GroupRead), {
                isEditable: isEditable,
                selectedGroups: selectedGroups
            })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3J9ez")).GroupRead), {
            isEditable: isEditable,
            selectedGroups: selectedGroups
        }));
    };
    const $178b2eb52257e100$export$b2844c90dc2ccc0f = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $178b2eb52257e100$export$2f128d21295c820,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $178b2eb52257e100$export$2f128d21295c820
    };
});
parcelRegister("2etjA", function(module, exports) {
    $parcel$export(module.exports, "GroupEdit", ()=>$d65840a6527f96eb$export$9036da6562372d3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $cObeo;
    const $d65840a6527f96eb$var$entryPointParams = {};
    const $d65840a6527f96eb$export$9036da6562372d3b = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("cObeo")).groupEditEntryPoint), $d65840a6527f96eb$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.group.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("cObeo", function(module, exports) {
    $parcel$export(module.exports, "groupEditEntryPoint", ()=>$262750810fef9327$export$20cce7641ad91969);
    var $eufEc;
    var $fEDBv;
    const $262750810fef9327$export$20cce7641ad91969 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("gcbfo")), {
            moduleId: "fc335c35"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("gcbfo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7wTbt").then(()=>parcelRequire('c4MTA'));
});
parcelRegister("3J9ez", function(module, exports) {
    $parcel$export(module.exports, "GroupRead", ()=>$fc80ff35ded673cb$export$d8ab1fa8206677db);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9xxV;
    var $b5lmY;
    var $k2xO1;
    const $fc80ff35ded673cb$export$d8ab1fa8206677db = ({ selectedGroups: selectedGroups, isEditable: isEditable })=>{
        const group = (0, $5uXOq.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups[0]?.name : selectedGroups?.name, [
            selectedGroups
        ]);
        const count = (0, $5uXOq.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups.length - 1 : 0, [
            selectedGroups
        ]);
        if (group == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).WrapperCommon), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
            isEditable: isEditable
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            text: group
        }), count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            text: `+${count}`
        })));
    };
});
parcelRegister("kpNUY", function(module, exports) {
    $parcel$export(module.exports, "parentCellHandler", ()=>$bcdec2aa400fb11e$export$342c67b3a001949f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $4FipU;
    var $5fc53;
    var $g5X3G;
    var $b5lmY;
    var $5SDWV;
    var $cVGH1;
    const $bcdec2aa400fb11e$var$transformFieldToParent = (field)=>{
        if (field?.value?.summary == null || field?.value?.issueType == null || field?.value?.issueId == null || field?.value?.issueKey == null) return null;
        return {
            key: field?.value.issueKey,
            value: field?.value?.issueId,
            label: field?.value?.summary,
            fields: {
                summary: field?.value?.summary,
                issuetype: field?.value?.issueType
            },
            color: field?.value?.color
        };
    };
    const $bcdec2aa400fb11e$export$d5a4cc78f8c5a2cd = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, onIssueUpdated: onIssueUpdated, cellRef: cellRef })=>{
        const [parent, setParent] = (0, $5uXOq.useState)($bcdec2aa400fb11e$var$transformFieldToParent(field));
        const [{ value: value }] = (0, (0, parcelRequire("4FipU")).useParentField)({
            issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issue.key),
            fieldKey: field?.fieldId ?? '',
            issueId: issue.issueId
        });
        if (value && value !== parent && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) setParent(value);
        (0, $5uXOq.useEffect)(()=>{
            setParent($bcdec2aa400fb11e$var$transformFieldToParent(field));
        }, [
            field
        ]);
        const handleChange = (0, $5uXOq.useCallback)((newParent)=>{
            setParent((oldParent)=>{
                if (field != null) onIssueUpdated({
                    fieldId: field.fieldId,
                    fieldType: field.type,
                    issueId: issue.issueId,
                    newValue: newParent,
                    oldValue: oldParent,
                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issue.key)
                });
                return newParent;
            });
            setEditMode(false);
        }, [
            field,
            issue.issueId,
            issue.key,
            onIssueUpdated,
            setEditMode
        ]);
        const handleFailure = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
        }, [
            setEditMode
        ]);
        if (field == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: true
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SDWV")).ParentEdit), {
            parent: parent,
            cellRef: cellRef,
            fieldId: field.fieldId,
            issueKey: issue.key,
            issueId: issue.issueId,
            preferredWidth: preferredWidth,
            onChange: handleChange,
            onFailure: handleFailure,
            readContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cVGH1")).ParentRead), {
                parent: parent
            })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cVGH1")).ParentRead), {
            parent: parent
        }));
    };
    const $bcdec2aa400fb11e$export$342c67b3a001949f = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $bcdec2aa400fb11e$export$d5a4cc78f8c5a2cd
    };
});
parcelRegister("5SDWV", function(module, exports) {
    $parcel$export(module.exports, "ParentEdit", ()=>$dd8c5fbe0789c866$export$c7e5e7ddde2d8f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $lqdAB;
    const $dd8c5fbe0789c866$var$entryPointParams = {};
    const $dd8c5fbe0789c866$export$c7e5e7ddde2d8f0 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("lqdAB")).parentEditEntryPoint), $dd8c5fbe0789c866$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.parent.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("lqdAB", function(module, exports) {
    $parcel$export(module.exports, "parentEditEntryPoint", ()=>$340f6220f071f296$export$1d2363001ed1e75d);
    var $eufEc;
    var $fEDBv;
    const $340f6220f071f296$export$1d2363001ed1e75d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("38hlT")), {
            moduleId: "9c7e10fe"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("38hlT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ZxeqL").then(()=>parcelRequire('1jioY'));
});
parcelRegister("cVGH1", function(module, exports) {
    $parcel$export(module.exports, "ParentRead", ()=>$652a909455a2ba76$export$500e192e2d559470);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $ltZxv;
    var $76pK6;
    const $652a909455a2ba76$export$500e192e2d559470 = ({ parent: parent })=>{
        const { createOpenIssueModalHandler: createOpenIssueModalHandler } = (0, (0, parcelRequire("ltZxv")).useIssueModalActions)();
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            if (parent == null || parent.key == null) return;
            return createOpenIssueModalHandler({
                key: parent.key
            })(e);
        }, [
            createOpenIssueModalHandler,
            parent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $652a909455a2ba76$var$parentCellStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("76pK6")).ParentViewField), {
            value: parent,
            noValueText: "",
            isMobile: false,
            onClick: handleClick
        }));
    };
    const $652a909455a2ba76$var$parentCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '100%'
    });
});
parcelRegister("76pK6", function(module, exports) {
    $parcel$export(module.exports, "ParentViewField", ()=>$6009579b1db350c9$export$51036c707862fc9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $koVbs;
    var $hDzhb;
    var $iVcsU;
    var $8KNKh;
    const $6009579b1db350c9$var$Summary = ({ isMobile: isMobile, onClick: onClick, label: label, lozengeTheme: lozengeTheme, issueKey: issueKey })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isMobile) return (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$WrapperNoClick, {
            style: lozengeTheme
        }, label);
        if (onClick != null) return (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$ButtonText, {
            onClick: onClick,
            style: lozengeTheme
        }, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$LinkText, {
            "data-testid": "issue-field-parent.ui.view-link",
            href: `/browse/${issueKey}`,
            "aria-label": formatMessage((0, (0, parcelRequire("8KNKh")).default).parentTitle, {
                label: label
            }),
            style: lozengeTheme
        }, label);
    };
    const $6009579b1db350c9$export$51036c707862fc9f = (props)=>{
        const { value: value, noValueText: noValueText, isMobile: isMobile, onClick: onClick } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (value) {
            const { key: key, fields: fields } = value;
            const label = `${key} ${fields.summary}`;
            const style = value.color ? (0, (0, parcelRequire("iVcsU")).getLozengeThemeByColor)(value.color) : undefined;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: label,
                position: "bottom"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Container, {
                "data-testid": "issue-field-parent.ui.container"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Icon, {
                src: fields.issuetype.iconUrl,
                alt: formatMessage((0, (0, parcelRequire("8KNKh")).default).icon, {
                    issueType: fields?.issuetype.name || ''
                })
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$Summary, {
                isMobile: isMobile,
                label: label,
                lozengeTheme: style,
                onClick: onClick,
                issueKey: key
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6009579b1db350c9$var$EmptyValue, {
            "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
        }, noValueText);
    };
    const $6009579b1db350c9$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $6009579b1db350c9$var$LinkText = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _80omtlke _p12f1osq _2rko1sit _1yt4otz2 _11c81oud _2hwxu2gc _9oik18uv _1bnx8stv _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
    const $6009579b1db350c9$var$ButtonText = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _o5721q9c _80omtlke _4t3igktf _p12f1osq _2rko1sit _1yt4u49m _11c81oud _2hwxu2gc _19itglyw _11q7glyw _syaz1kw7 _12ji1r31 _1qu21kw7 _12y31o36 _vwz44jg8 _1bto1l2s _1e0c1ule _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
    const $6009579b1db350c9$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx12x7 _p12f7vkz",
                __cmplp.className
            ])
        });
    });
    const $6009579b1db350c9$var$WrapperNoClick = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1e0c1ule _4t3i7vkz _2rko1sit _1yt4u49m _11c81oud _p12f1osq _2hwxu2gc _vwz44jg8",
                __cmplp.className
            ])
        });
    });
    const $6009579b1db350c9$var$EmptyValue = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iVcsU", function(module, exports) {
    $parcel$export(module.exports, "getOptionColorElem", ()=>$608100d8bb869e55$export$b00899e73680c477);
    $parcel$export(module.exports, "mapDataToOptions", ()=>$608100d8bb869e55$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$608100d8bb869e55$export$fc800909123977f3);
    $parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", ()=>$608100d8bb869e55$export$feb08457bf70a411);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$608100d8bb869e55$export$949dc67535a8ff2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $heWHN;
    var $iHPnC;
    const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color];
    const $608100d8bb869e55$export$b00899e73680c477 = (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
            color: color,
            "data-testid": `issue-field-parent.common.color-patch-${color}`
        });
    const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
        return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
                id: id,
                key: key,
                fields: {
                    issuetype: issueType,
                    summary: summary
                },
                color: color,
                value: id,
                label: `${key} ${summary}`,
                isDone: isDone
            }));
    };
    const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
            id: option.value
        });
    const $608100d8bb869e55$export$9b822862d986dfdf = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
        if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
    };
    const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
    const $608100d8bb869e55$var$ColorPatch = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1nzbko4": (0, (0, parcelRequire("lD23V")).default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
            text: "var(--ds-text-accent-purple, #803FA5)",
            textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
            text: "var(--ds-text-accent-blue, #1558BC)",
            textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
            text: "var(--ds-text-accent-green, #216E4E)",
            textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
            text: "var(--ds-text-accent-teal, #206A83)",
            textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
            text: "var(--ds-text-accent-yellow, #7F5F01)",
            textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
            text: "var(--ds-text-accent-red, #AE2E24)",
            textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            text: "var(--ds-text-accent-gray, #505258)",
            textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
            border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
            border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
            border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
parcelRegister("8KNKh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63688812b02739a0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $63688812b02739a0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        parentTitle: {
            "id": "issue-field-parent.parent-title",
            "defaultMessage": "Click to visit {label}"
        },
        icon: {
            "id": "issue-field-parent.icon",
            "defaultMessage": "{issueType} icon"
        }
    });
});
parcelRegister("8egWI", function(module, exports) {
    $parcel$export(module.exports, "projectCellHandler", ()=>$45583a47da1accfa$export$ae050ab68eec4031);
    var $5uXOq = parcelRequire("5uXOq");
    var $crLaw;
    var $5fc53;
    var $b5lmY;
    var $7ry80;
    var $2I8hn;
    const $45583a47da1accfa$export$a0acc7707bde1d3 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
        const [project, setProject] = (0, $5uXOq.useState)(field?.value);
        const [{ value: value }] = (0, (0, parcelRequire("crLaw")).useProjectField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId || '',
            initialValue: field?.value
        });
        if (value !== project) setProject(value);
        if (field == null) return null;
        const readContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2I8hn")).ProjectRead), {
            project: project
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: true,
            hasPadding: false,
            testId: "business-fields.ui.project.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ry80")).ProjectEdit), {
            issueKey: issue.key,
            fieldKey: field.fieldId,
            option: project,
            onChange: setProject,
            setEditMode: setEditMode,
            readContent: readContent,
            preferredWidth: preferredWidth,
            cellRef: cellRef
        }) : readContent);
    };
    const $45583a47da1accfa$export$ae050ab68eec4031 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $45583a47da1accfa$export$a0acc7707bde1d3
    };
});
parcelRegister("7ry80", function(module, exports) {
    $parcel$export(module.exports, "ProjectEdit", ()=>$7975949636177568$export$847a1c7fcc9fac3d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $8dqjY;
    const $7975949636177568$export$847a1c7fcc9fac3d = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("8dqjY")).projectEditEntryPoint), {});
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.project.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("8dqjY", function(module, exports) {
    $parcel$export(module.exports, "projectEditEntryPoint", ()=>$635f5330de127ee9$export$a995c657f37f351f);
    var $eufEc;
    var $fEDBv;
    const $635f5330de127ee9$export$a995c657f37f351f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("EZeDY")), {
            moduleId: "934d87d1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("EZeDY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6Sa8R").then(()=>parcelRequire('l7zSa'));
});
parcelRegister("2I8hn", function(module, exports) {
    $parcel$export(module.exports, "ProjectRead", ()=>$d78a6889e5251e69$export$c2b863d8638c3f33);
    var $5uXOq = parcelRequire("5uXOq");
    var $20ivj;
    const $d78a6889e5251e69$export$c2b863d8638c3f33 = ({ project: project })=>project ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("20ivj")).ProjectReadView), {
            value: project
        }) : null;
});
parcelRegister("20ivj", function(module, exports) {
    $parcel$export(module.exports, "ProjectReadView", ()=>$8724762dba6fa853$export$5c3359f22f4596bc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $jhmo0;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $hDzhb;
    const $8724762dba6fa853$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true })=>{
        const onClickLink = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            onClick && onClick(e);
        }, [
            onClick
        ]);
        if (value === undefined || value === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8724762dba6fa853$var$emptyValueContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$EmptyValue, {
            "data-testid": "issue-field-project.ui.view-read-view-empty-value"
        }, noValueText || ''));
        const stopPropagation = (e)=>{
            e.stopPropagation();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$ReadViewContainer, {
            "data-component-selector": "project-read-view-container"
        }, Boolean(value.avatarUrls['48x48']) && (0, ($parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$AvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            size: "xsmall",
            src: value.avatarUrls['48x48'],
            borderColor: "transparent",
            testId: "issue-field-project.ui.project-avatar"
        })), (0, (0, parcelRequire("4R6GH")).fg)('endeavour_add_density_full_to_issue_fields') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8724762dba6fa853$var$labelContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            testId: "issue-field-project.ui.view-label-link",
            onClick: onClickLink,
            onKeyUp: stopPropagation,
            onKeyDown: stopPropagation,
            href: `/projects/${value.key}`,
            xcss: [
                $8724762dba6fa853$var$labelLinkStylesBase,
                isTruncated ? $8724762dba6fa853$var$labelLinkStylesTruncated : $8724762dba6fa853$var$labelLinkStylesNonTruncated
            ]
        }, value.name)) : (0, ($parcel$interopDefault($5uXOq))).createElement($8724762dba6fa853$var$Label, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            "data-testid": "issue-field-project.ui.view-label-link",
            onClick: onClickLink,
            onKeyPress: stopPropagation,
            href: `/projects/${value.key}`
        }, value.name)));
    };
    const $8724762dba6fa853$var$EmptyValue = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz",
                __cmplp.className
            ])
        });
    });
    const $8724762dba6fa853$var$ReadViewContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _1yt41b66",
                __cmplp.className
            ])
        });
    });
    const $8724762dba6fa853$var$emptyValueContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075'
    });
    const $8724762dba6fa853$var$AvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $8724762dba6fa853$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1ul9idpf _2hwxu2gc _1x211q9c _1rg815vq _1yoo15vq _1p6l1l2s _h5vp1o8l _i78x1osq",
                __cmplp.className
            ])
        });
    });
    const $8724762dba6fa853$var$labelContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        minWidth: '0',
        marginRight: 'space.100'
    });
    const $8724762dba6fa853$var$labelLinkStylesBase = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        maxWidth: '100%',
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline'
        }
    });
    const $8724762dba6fa853$var$labelLinkStylesTruncated = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
    const $8724762dba6fa853$var$labelLinkStylesNonTruncated = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowWrap: 'anywhere'
    });
});
parcelRegister("c2t1Z", function(module, exports) {
    $parcel$export(module.exports, "radioSelectCellHandler", ()=>$eff2712f4a54ccf5$export$cf09278854214c31);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9sUAX;
    var $aSk8p;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $b5lmY;
    var $btDbz;
    var $2VWmE;
    var $4cSsp;
    const $eff2712f4a54ccf5$var$transformToOption = (option)=>{
        if (!option) return null;
        const { id: id, value: value } = option;
        return {
            value: id,
            label: value
        };
    };
    const $eff2712f4a54ccf5$export$b6b4cb8dcfd6af64 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleFailure = (0, $5uXOq.useCallback)((err)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'field updateFailed', 'radioSelectIssueField', {
                error: err
            });
        }, [
            createAnalyticsEvent
        ]);
        const [{ value: customFieldValue, options: radioOptions }, { saveValue: saveValue }] = (0, (0, parcelRequire("9sUAX")).useRadioSelectCustomField)({
            issueKey: issue.key,
            fieldKey: field?.fieldId || '',
            initialValue: field?.value ?? null,
            onFailure: handleFailure
        });
        const option = $eff2712f4a54ccf5$var$transformToOption(customFieldValue);
        const emptyOption = (0, $5uXOq.useMemo)(()=>({
                label: formatMessage((0, (0, parcelRequire("2VWmE")).default).noValue),
                value: ''
            }), [
            formatMessage
        ]);
        const options = (0, $5uXOq.useMemo)(()=>{
            const result = (0, (0, parcelRequire("aSk8p")).mapDataToOptions)(radioOptions);
            if (option) result.unshift(emptyOption);
            return result;
        }, [
            option,
            emptyOption,
            radioOptions
        ]);
        const handleChange = (0, $5uXOq.useCallback)((newValue)=>{
            const newOption = newValue?.value ? newValue : null;
            const transformForSave = (0, (0, parcelRequire("aSk8p")).mapOptionToData)({
                value: newOption?.value ?? '',
                label: newOption?.label ?? ''
            });
            saveValue(transformForSave, null, createAnalyticsEvent({}));
            setEditMode(false);
        }, [
            saveValue,
            createAnalyticsEvent,
            setEditMode
        ]);
        const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
            issue.fieldConfig?.isEditable
        ]);
        if (field == null) return null;
        const placeholder = formatMessage((0, (0, parcelRequire("2VWmE")).default).placeholder, {
            fieldName: field.name
        });
        const label = formatMessage((0, (0, parcelRequire("2VWmE")).default).label, {
            fieldName: field.name
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            hasPadding: false,
            testId: "business-fields.ui.radio-select.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("btDbz")).RadioSelectEdit), {
            label: label,
            placeholder: placeholder,
            option: option,
            options: options,
            readContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cSsp")).RadioSelectRead), null, option?.label ?? ''),
            preferredWidth: preferredWidth,
            onChange: handleChange
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cSsp")).RadioSelectRead), null, option?.label ?? ''));
    };
    const $eff2712f4a54ccf5$export$cf09278854214c31 = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $eff2712f4a54ccf5$export$b6b4cb8dcfd6af64
    };
});
parcelRegister("aSk8p", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$08634f5a5ba1d218$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$08634f5a5ba1d218$export$fc800909123977f3);
    const $08634f5a5ba1d218$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
                label: value,
                value: id
            }));
    const $08634f5a5ba1d218$export$fc800909123977f3 = ({ label: label, value: value })=>({
            id: value,
            value: label
        });
});
parcelRegister("btDbz", function(module, exports) {
    $parcel$export(module.exports, "RadioSelectEdit", ()=>$a8701065c7d51775$export$7f25860f9e4ad119);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $9ibIo;
    const $a8701065c7d51775$var$entryPointParams = {};
    const $a8701065c7d51775$export$7f25860f9e4ad119 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("9ibIo")).radioSelectEntryPoint), $a8701065c7d51775$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.radio-select.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("9ibIo", function(module, exports) {
    $parcel$export(module.exports, "radioSelectEntryPoint", ()=>$40269a041ca57c58$export$ec67c8b087cb34f);
    var $eufEc;
    var $fEDBv;
    const $40269a041ca57c58$export$ec67c8b087cb34f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("65PO4")), {
            moduleId: "ff25c236"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("65PO4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7ZBMt").then(()=>parcelRequire('jGw9Z'));
});
parcelRegister("2VWmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e41ec29dcf651d45$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e41ec29dcf651d45$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noValue: {
            "id": "business-fields.radio-select.cell.no-value",
            "defaultMessage": "None"
        },
        placeholder: {
            "id": "business-fields.radio-select.cell.placeholder",
            "defaultMessage": "Select { fieldName }"
        },
        label: {
            "id": "business-fields.radio-select.cell.label",
            "defaultMessage": "{ fieldName }"
        }
    });
});
parcelRegister("4cSsp", function(module, exports) {
    $parcel$export(module.exports, "RadioSelectRead", ()=>$c70baf2fa049d53c$export$51198f70a0069b1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $b5lmY;
    const $c70baf2fa049d53c$export$51198f70a0069b1e = ({ children: children })=>{
        if (!children) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).WrapperCommon), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c70baf2fa049d53c$var$optionWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c70baf2fa049d53c$var$optionTextStyles
        }, children)));
    };
    const $c70baf2fa049d53c$var$optionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        padding: 'space.075'
    });
    const $c70baf2fa049d53c$var$optionTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("kpiLK", function(module, exports) {
    $parcel$export(module.exports, "resolutionCellHandler", ()=>$9795b82c42e160a8$export$9762e1de55e8d420);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $b5lmY;
    var $1l3QS;
    const $9795b82c42e160a8$export$8b67413bfec99fe = ({ cellData: field })=>{
        const [resolution, setResolution] = (0, $5uXOq.useState)(field?.value || null);
        (0, $5uXOq.useEffect)(()=>{
            setResolution(field?.value || null);
        }, [
            field?.value
        ]);
        if (field == null) return null;
        const readContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1l3QS")).ResolutionRead), {
            resolution: resolution
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: false,
            hasPadding: true
        }, readContent);
    };
    const $9795b82c42e160a8$export$9762e1de55e8d420 = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: $9795b82c42e160a8$export$8b67413bfec99fe
    };
});
parcelRegister("1l3QS", function(module, exports) {
    $parcel$export(module.exports, "ResolutionRead", ()=>$5014dda692555891$export$8741d57e18b24f9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $03RlV;
    const $5014dda692555891$export$8741d57e18b24f9f = ({ resolution: resolution })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("03RlV")).ResolutionReadView), {
            value: resolution,
            isLabelClickEnabled: true,
            hideIcon: true
        });
});
parcelRegister("03RlV", function(module, exports) {
    $parcel$export(module.exports, "ResolutionReadView", ()=>$4770b901e9bb750b$export$dfd4dfe034c38e3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $kbxJz;
    var $3bDjY;
    var $gwIPs;
    var $4R6GH;
    var $koVbs;
    var $4oAv9;
    const $4770b901e9bb750b$export$dfd4dfe034c38e3f = ({ value: value, isLabelClickEnabled: isLabelClickEnabled, hideIcon: hideIcon = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasResolution = value;
        const resolutionName = value?.name || formatMessage((0, (0, parcelRequire("4oAv9")).default).unresolvedResolution);
        const icon = hasResolution && !hideIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kbxJz"))))), {
            size: "medium",
            label: (0, (0, parcelRequire("4R6GH")).fg)('deployment_issue_sideview_icon_a11y') ? '' : resolutionName,
            testId: "issue-field-resolution.ui.read.check-icon",
            primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`,
            "aria-hidden": !!(0, (0, parcelRequire("4R6GH")).fg)('deployment_issue_sideview_icon_a11y')
        }) : null;
        const renderResolutionLabel = (labelName)=>{
            const resolutionStatusLabel = (0, ($parcel$interopDefault($5uXOq))).createElement($4770b901e9bb750b$var$ResolutionStatusLabel, {
                "data-testid": "issue-field-resolution.ui.read.resolution-status-label",
                isDisabled: !isLabelClickEnabled,
                isDarkText: isLabelClickEnabled || !!hasResolution
            }, labelName);
            return !isLabelClickEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("4oAv9")).default).readViewMessage),
                position: "top"
            }, resolutionStatusLabel) : resolutionStatusLabel;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4770b901e9bb750b$var$Container, {
            addPadding: !isLabelClickEnabled,
            "data-testid": "issue-field-resolution.ui.read.label"
        }, icon, renderResolutionLabel(resolutionName));
    };
    const $4770b901e9bb750b$var$Container = (0, $47bDC.default).div.withConfig({
        componentId: "sc-6kdpa7-0"
    })(({ addPadding: addPadding })=>({
            padding: addPadding ? `0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px 0 12px` : 0,
            display: 'flex',
            alignItems: 'center',
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 4}px`
        }));
    const $4770b901e9bb750b$var$itemTruncateWidth = (0, (0, parcelRequire("gwIPs")).gridSize) * 25;
    const $4770b901e9bb750b$var$ResolutionStatusLabel = (0, $47bDC.default).span.withConfig({
        componentId: "sc-6kdpa7-1"
    })((props)=>({
            color: props.isDarkText ? `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`,
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: `${$4770b901e9bb750b$var$itemTruncateWidth}px`
        }), (props)=>props.isDisabled ? ':hover { cursor: not-allowed; }' : '');
});
parcelRegister("kbxJz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb1f0098e5a023eb$var$CheckIcon = (props)=>$eb1f0098e5a023eb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
        }, props, {
            newIcon: $eb1f0098e5a023eb$var$_checkMark.default
        }));
    $eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
    var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;
});
parcelRegister("4oAv9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e635713c840273f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3e635713c840273f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        readViewMessage: {
            "id": "issue-field-resolution.read.read-view-message",
            "defaultMessage": "You cannot edit the resolution field"
        },
        unresolvedResolution: {
            "id": "issue-field-resolution.read.unresolved-resolution",
            "defaultMessage": "Unresolved"
        }
    });
});
parcelRegister("1RGG5", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryCellHandler", ()=>$f94184594f4cccc9$export$1c03cc5b920eec85);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $b5lmY;
    var $8phy8;
    const $f94184594f4cccc9$export$8b895f86148e277 = ({ cellData: field })=>{
        const [statusCategory, setStatusCategory] = (0, $5uXOq.useState)(field?.value || null);
        (0, $5uXOq.useEffect)(()=>{
            setStatusCategory(field?.value || null);
        }, [
            field?.value
        ]);
        if (field == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: false
        }, statusCategory && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8phy8")).StatusCategoryRead), statusCategory));
    };
    const $f94184594f4cccc9$export$1c03cc5b920eec85 = {
        [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: $f94184594f4cccc9$export$8b895f86148e277
    };
});
parcelRegister("8phy8", function(module, exports) {
    $parcel$export(module.exports, "StatusCategoryRead", ()=>$9ef1191a4c6818d2$export$3d1939a7f374f0ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $gULOk;
    var $4R6GH;
    var $dCm1o;
    const $9ef1191a4c6818d2$var$appearanceMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 'default',
        [(0, (0, parcelRequire("gULOk")).TODO)]: 'default',
        [(0, (0, parcelRequire("gULOk")).DONE)]: 'success',
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 'inprogress'
    };
    const $9ef1191a4c6818d2$export$3d1939a7f374f0ac = ({ statusCategoryId: statusCategoryId, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "business-fields.ui.status-category.cell.read.lozenge",
            appearance: $9ef1191a4c6818d2$var$appearanceMap[(0, (0, parcelRequire("gULOk")).statusCategoryForId)(statusCategoryId)],
            isBold: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1')
        }, name);
});
parcelRegister("cphvi", function(module, exports) {
    $parcel$export(module.exports, "teamCellHandler", ()=>$f5afb002faf95f63$export$c23dfb5658df72ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $4tlhS;
    var $5fc53;
    var $g5X3G;
    var $b5lmY;
    var $cnBEF;
    var $iM6lG;
    const $f5afb002faf95f63$export$2ea8e60ef5e5f6ad = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
        const [team, setTeam] = (0, $5uXOq.useState)(field?.value);
        const [{ value: value }] = (0, (0, parcelRequire("4tlhS")).useTeamField)({
            issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issue.key),
            fieldKey: field?.fieldId ?? '',
            initialValue: team
        });
        if (value !== team && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) setTeam(value);
        (0, $5uXOq.useEffect)(()=>{
            setTeam(field?.value);
        }, [
            field?.value
        ]);
        if (field == null) return null;
        const readContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iM6lG")).TeamRead), {
            team: team
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: true,
            hasPadding: false,
            testId: "business-fields.ui.team.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cnBEF")).TeamEdit), {
            issueKey: issue.key,
            fieldKey: field.fieldId,
            team: team,
            onChange: setTeam,
            setEditMode: setEditMode,
            readContent: readContent,
            preferredWidth: preferredWidth,
            cellRef: cellRef
        }) : readContent);
    };
    const $f5afb002faf95f63$export$c23dfb5658df72ac = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: $f5afb002faf95f63$export$2ea8e60ef5e5f6ad
    };
});
parcelRegister("cnBEF", function(module, exports) {
    $parcel$export(module.exports, "TeamEdit", ()=>$40d4e5a5df33f9ab$export$88197130b31e38af);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $ioccx;
    const $40d4e5a5df33f9ab$export$88197130b31e38af = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("ioccx")).teamEditEntryPoint), {});
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.team.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("ioccx", function(module, exports) {
    $parcel$export(module.exports, "teamEditEntryPoint", ()=>$3ce79e2e803c0940$export$9bcf1ad2d1e96b95);
    var $eufEc;
    var $fEDBv;
    const $3ce79e2e803c0940$export$9bcf1ad2d1e96b95 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iWtzK")), {
            moduleId: "e322dd82"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("iWtzK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iDrM4")
    ]).then(()=>parcelRequire('c9AOc'));
});
parcelRegister("iM6lG", function(module, exports) {
    $parcel$export(module.exports, "TeamRead", ()=>$14befa705267cf1b$export$5f2e28c402b347f);
    var $5uXOq = parcelRequire("5uXOq");
    var $cUfIr;
    const $14befa705267cf1b$export$5f2e28c402b347f = ({ team: team })=>team ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cUfIr")).TeamPickerView), {
            defaultValue: team,
            placeholder: "",
            isEditable: false
        }) : null;
});
parcelRegister("cUfIr", function(module, exports) {
    $parcel$export(module.exports, "TeamPickerView", ()=>$4276e1b7b30e55b4$export$d284ae84f659e68c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hGgHi = parcelRequire("hGgHi");
    var $jhVLw;
    var $cgL5K;
    var $3bDjY;
    var $koVbs;
    var $1dNQ0;
    var $4vyX4;
    const $4276e1b7b30e55b4$var$ErrorView = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("4vyX4")).default).teamErrorViewTooltip)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Text_, {
            isDisabled: true,
            "data-testid": "issue-field-team.ui.view-error-value-text"
        }, formatMessage((0, (0, parcelRequire("4vyX4")).default).teamErrorViewText))));
    };
    const $4276e1b7b30e55b4$export$d284ae84f659e68c = (props)=>{
        const { defaultValue: defaultValue, isEditable: isEditable, placeholder: placeholder, noPaddingLeft: noPaddingLeft } = props;
        if ((0, ($parcel$interopDefault($hGgHi)))(defaultValue)) return (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$ReadViewContainerEmpty, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: "issue-field-team.ui.view-empty-value-text",
            color: "color.text.subtlest"
        }, placeholder));
        if (defaultValue.isVisible === false) return (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$ErrorView, null);
        const team = defaultValue;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Wrapper, {
            isEditable: isEditable,
            noPaddingLeft: noPaddingLeft
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dNQ0")).default), {
            teamId: team.id,
            trigger: "hover-click",
            position: "left-start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4276e1b7b30e55b4$var$Text_, {
            "data-testid": "issue-field-team.ui.view-team-name"
        }, team.name))));
    };
    var $4276e1b7b30e55b4$export$2e2bcd8739ae039 = $4276e1b7b30e55b4$export$d284ae84f659e68c;
    const $4276e1b7b30e55b4$var$ReadViewContainerEmpty = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _11c81oud _p12f1osq _1yt412x7 _1tke7vkz _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $4276e1b7b30e55b4$var$Text_ = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_bz06rf": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz48sxn _y3gn1e5h _syaz85nu _4cvr1h6o _1e0c1txw _1yt4x7n9",
                __cmplp.className
            ])
        });
    });
    const $4276e1b7b30e55b4$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isEditable: isEditable, noPaddingLeft: noPaddingLeft, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_167ft80": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isEditable ? 'pointer' : 'default'),
                "--_1qzp7z5": (0, (0, parcelRequire("lD23V")).default)(__cmplp.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_80omm20a _19bv11d4 _1bsb1osq _1e0c1txw _4cvr1h6o _nbr41txw _dskl1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1dNQ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95b4cdaa4ace2b66$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $95b4cdaa4ace2b66$var$AsyncTeamProfileCardNext = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aVUrq")), {
        ssr: false,
        moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard/main.tsx"
    });
    var $95b4cdaa4ace2b66$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.profilecard-next.team-profilecard",
            packageName: "async.profilecard-next.team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-team-profilecard-next",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($95b4cdaa4ace2b66$var$AsyncTeamProfileCardNext, props)));
});
parcelRegister("aVUrq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2MFVe")
    ]).then(()=>parcelRequire('3FCPe'));
});
parcelRegister("4vyX4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8457da62d9869465$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8457da62d9869465$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "issue-field-team.error-title",
            "defaultMessage": "We couldn't set the team value"
        },
        errorMessage: {
            "id": "issue-field-team.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        teamErrorViewTooltip: {
            "id": "issue-field-team.team-error-view-tooltip",
            "defaultMessage": "This team may have been deleted, or you do not have access"
        },
        teamErrorViewText: {
            "id": "issue-field-team.team-error-view-text",
            "defaultMessage": "Not available"
        },
        placeholderTeamEditSelector: {
            "id": "issue-field-team.placeholder-team-edit-selector",
            "defaultMessage": "Choose a team"
        },
        defaultNoValueText: {
            "id": "issue-field-team.default-no-value-text",
            "defaultMessage": "None"
        },
        createTeamButtonText: {
            "id": "issue-field-team.create-team-button-text",
            "defaultMessage": "Create a team"
        },
        emptyStateDescription: {
            "id": "issue-field-team.empty-state-description",
            "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
        },
        noOptionsMessage: {
            "id": "issue-field-team.no-options-message",
            "defaultMessage": "No options"
        }
    });
});
parcelRegister("jRQOz", function(module, exports) {
    $parcel$export(module.exports, "versionCellHandler", ()=>$3c8fb7bb3047c601$export$fc6264270343b1df);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $lQE94;
    var $5fc53;
    var $b5lmY;
    var $6q9eL;
    var $kg162;
    const $3c8fb7bb3047c601$export$710c4688cbbfc14a = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
        const [selectedVersions, setSelectedVersions] = (0, $5uXOq.useState)(field?.value ?? null);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
            const [{ value: fieldValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
                fieldKey: field?.fieldId ?? '',
                issueKey: issue.key,
                fieldType: field?.type ?? '',
                initialValue: field?.value ?? null
            });
            if (!editMode && fieldValue !== selectedVersions) setSelectedVersions(fieldValue);
        }
        (0, $5uXOq.useEffect)(()=>{
            setSelectedVersions(field?.value ?? null);
        }, [
            field?.value
        ]);
        const isEditable = (0, $5uXOq.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
            issue.fieldConfig?.isEditable
        ]);
        const isMulti = (0, $5uXOq.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:version', [
            field?.type
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-fields.ui.version.cell.cell-wrapper"
        }, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6q9eL")).VersionEdit), {
            cellRef: cellRef,
            setEditMode: setEditMode,
            inputValue: inputValue,
            onInputChange: onInputChange,
            isMulti: isMulti,
            fieldName: field?.name || '',
            onChange: setSelectedVersions,
            preferredWidth: preferredWidth,
            selectedVersions: selectedVersions,
            fieldKey: field?.fieldId || '',
            issueKey: issue.key,
            fieldType: field?.type || '',
            initialValue: field?.value ?? null,
            readContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kg162")).VersionRead), {
                isEditable: isEditable,
                selectedVersions: selectedVersions
            })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kg162")).VersionRead), {
            isEditable: isEditable,
            selectedVersions: selectedVersions
        }));
    };
    const $3c8fb7bb3047c601$export$fc6264270343b1df = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $3c8fb7bb3047c601$export$710c4688cbbfc14a
    };
});
parcelRegister("6q9eL", function(module, exports) {
    $parcel$export(module.exports, "VersionEdit", ()=>$d29ec3c07469f399$export$3c0e57d9b0204cdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $kRxRA;
    const $d29ec3c07469f399$var$entryPointParams = {};
    const $d29ec3c07469f399$export$3c0e57d9b0204cdc = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kRxRA")).versionEditEntryPoint), $d29ec3c07469f399$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.business.fields.version.edit",
            packageName: "jiraBusinessFields",
            runtimeProps: props,
            fallback: props.readContent
        });
    };
});
parcelRegister("kRxRA", function(module, exports) {
    $parcel$export(module.exports, "versionEditEntryPoint", ()=>$02328e8a90a0c71c$export$e4a061611063756b);
    var $eufEc;
    var $fEDBv;
    const $02328e8a90a0c71c$export$e4a061611063756b = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8wour")), {
            moduleId: "d7202e48"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("8wour", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fcEiB").then(()=>parcelRequire('azBtZ'));
});
parcelRegister("kg162", function(module, exports) {
    $parcel$export(module.exports, "VersionRead", ()=>$b5ef598bab0a2320$export$6cc418351c9e7765);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9xxV;
    var $b5lmY;
    var $k2xO1;
    const $b5ef598bab0a2320$export$6cc418351c9e7765 = ({ selectedVersions: selectedVersions, isEditable: isEditable })=>{
        const [version, count] = (0, $5uXOq.useMemo)(()=>{
            if (Array.isArray(selectedVersions)) {
                const [firstVersion, ...others] = selectedVersions ?? [];
                return [
                    firstVersion?.name,
                    others.length
                ];
            }
            if (selectedVersions != null) return [
                selectedVersions.name,
                0
            ];
            return [
                undefined,
                0
            ];
        }, [
            selectedVersions
        ]);
        if (version == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).WrapperCommon), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
            isEditable: isEditable
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            text: version
        }), count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
            text: `+${count}`
        })));
    };
});
parcelRegister("cYskc", function(module, exports) {
    $parcel$export(module.exports, "ColumnVisibilityProvider", ()=>$0a181db91170dacc$export$a60887dfea90a0d9);
    $parcel$export(module.exports, "useColumnVisibilityUpdater", ()=>$0a181db91170dacc$export$ef90c8750ba3bb5);
    $parcel$export(module.exports, "useIsColumnVisible", ()=>$0a181db91170dacc$export$3dbd1ecf42329eea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Qi2I;
    const $0a181db91170dacc$var$VISIBILITY_OFFSET = 120;
    const $0a181db91170dacc$var$getVisibleColumns = (scrollLeft, tableWidth, columns)=>{
        const windowLeft = scrollLeft - $0a181db91170dacc$var$VISIBILITY_OFFSET;
        const windowRight = scrollLeft + tableWidth + $0a181db91170dacc$var$VISIBILITY_OFFSET;
        const result = new Map();
        let currentOffset = 0;
        for (const column of columns){
            const columnLeft = currentOffset;
            const columnRight = columnLeft + column.width;
            const isVisible = columnRight >= windowLeft && columnLeft <= windowRight;
            result.set(column.key, isVisible);
            currentOffset = columnRight;
        }
        return result;
    };
    const $0a181db91170dacc$var$ColumnVisibilityUpdaterContext = (0, $5uXOq.createContext)(null);
    const $0a181db91170dacc$var$ColumnVisibilityAccessorContext = (0, $5uXOq.createContext)(null);
    const $0a181db91170dacc$export$a60887dfea90a0d9 = ({ children: children, columns: columns, width: width })=>{
        const [scrollPosition, setScrollPosition] = (0, $5uXOq.useState)({
            scrollLeft: 0
        });
        const visibleColumns = (0, $5uXOq.useMemo)(()=>$0a181db91170dacc$var$getVisibleColumns(scrollPosition.scrollLeft, width, columns), [
            columns,
            scrollPosition.scrollLeft,
            width
        ]);
        const memoizedVisibileColumns = (0, (0, parcelRequire("8Qi2I")).useDeepMemo)(()=>visibleColumns, [
            visibleColumns
        ]);
        const getIsColumnVisible = (0, $5uXOq.useCallback)(({ key: key })=>memoizedVisibileColumns.get(key) ?? true, [
            memoizedVisibileColumns
        ]);
        const columnVisibilityAccessor = (0, $5uXOq.useMemo)(()=>({
                getIsColumnVisible: getIsColumnVisible
            }), [
            getIsColumnVisible
        ]);
        const columnVisibilityUpdater = (0, $5uXOq.useMemo)(()=>({
                handleScroll: ({ scrollLeft: scrollLeft })=>setScrollPosition((prev)=>scrollLeft !== prev.scrollLeft ? {
                            scrollLeft: scrollLeft
                        } : prev)
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0a181db91170dacc$var$ColumnVisibilityUpdaterContext.Provider, {
            value: columnVisibilityUpdater
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0a181db91170dacc$var$ColumnVisibilityAccessorContext.Provider, {
            value: columnVisibilityAccessor
        }, children));
    };
    const $0a181db91170dacc$export$ef90c8750ba3bb5 = ()=>{
        const context = (0, $5uXOq.useContext)($0a181db91170dacc$var$ColumnVisibilityUpdaterContext);
        if (!context) throw new Error("'useColumnVisibilityUpdater' must be used inside a 'ColumnVisibilityProvider'");
        return context;
    };
    const $0a181db91170dacc$export$3dbd1ecf42329eea = (column)=>{
        const context = (0, $5uXOq.useContext)($0a181db91170dacc$var$ColumnVisibilityAccessorContext);
        if (!context) throw new Error("'useIsColumnVisible' must be used inside a 'ColumnVisibilityProvider'");
        return context.getIsColumnVisible(column);
    };
});
parcelRegister("jUhIo", function(module, exports) {
    $parcel$export(module.exports, "WithCellSelection", ()=>$b18a2b2a33e74111$export$3f3bc47e8aed32cb);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $6l4ko;
    var $b9ZBg;
    var $bDD22;
    var $koVbs;
    var $5fc53;
    var $eTDjN;
    var $3yRl2;
    var $d93RL;
    const $b18a2b2a33e74111$export$3f3bc47e8aed32cb = (0, $5uXOq.memo)(({ projectId: projectId, fieldId: fieldId, issueId: issueId, position: position, children: children, rowIndex: rowIndex, columnIndex: columnIndex, width: width, field: field, issue: issue, depth: depth = 0 })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ nodeSelection: nodeSelection }, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, (0, parcelRequire("6l4ko")).useCollabStore)();
        const nodeId = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("bDD22")).getPresenceNodeId)({
                projectId: projectId,
                viewId: 'list',
                nodeId: `${fieldId}-${issueId}`
            }), [
            projectId,
            issueId,
            fieldId
        ]);
        const selections = nodeSelection[nodeId];
        const selection = selections && selections[0];
        const isIssueType = fieldId === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE);
        const onSendNodeSelected = (0, $5uXOq.useCallback)(()=>sendNodeSelected({
                nodeId: nodeId
            }), [
            sendNodeSelected,
            nodeId
        ]);
        const onSendClearNodeSelection = (0, $5uXOq.useCallback)(()=>sendClearNodeSelection({
                nodeId: nodeId
            }), [
            sendClearNodeSelection,
            nodeId
        ]);
        const renderedChildren = (0, $5uXOq.useMemo)(()=>children && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yRl2")).CellNavigation), {
                columnIndex: columnIndex,
                rowIndex: rowIndex,
                field: field,
                issue: issue,
                fieldId: fieldId,
                onSendNodeSelected: onSendNodeSelected,
                onSendClearNodeSelection: onSendClearNodeSelection
            }, children()), [
            children,
            columnIndex,
            fieldId,
            onSendClearNodeSelection,
            onSendNodeSelected,
            rowIndex,
            field,
            issue
        ]);
        if (selection) {
            const hasMoreSelections = selections && selections.length > 1;
            const tooltipContent = hasMoreSelections ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: user.name
                }, user.name))) : null;
            const otherSelectionsContent = hasMoreSelections ? formatMessage((0, (0, parcelRequire("d93RL")).default).moreSelections, {
                count: selections.length - 1
            }) : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b18a2b2a33e74111$var$NodeWrapper, {
                isIssueType: isIssueType,
                width: width,
                depth: depth
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9ZBg")).NodeSelectionWrapper), {
                color: selection.color
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltipContent,
                position: "top"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9ZBg")).ParticipantBadge), {
                color: selection.color,
                position: position
            }, selection.user.name, otherSelectionsContent)), renderedChildren));
        }
        return renderedChildren;
    });
    const $b18a2b2a33e74111$var$nodeWrapperBaseStyles = null;
    const $b18a2b2a33e74111$var$NodeWrapper = ({ isIssueType: isIssueType, width: width, depth: depth, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                ...isIssueType && {
                    paddingLeft: `${depth > 0 ? (0, (0, parcelRequire("eTDjN")).EXPAND_ICON_INDENT_WIDTH) * depth + 4 : 0}px`,
                    boxSizing: 'border-box',
                    width: `${width - (0, (0, parcelRequire("eTDjN")).LIST_PADDING_LEFT)}px`
                }
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsb1kw7 _4t3i1ylp"
            ])
        }, children);
});
parcelRegister("6l4ko", function(module, exports) {
    $parcel$export(module.exports, "useCollabStore", ()=>$b8a7111dc9f99b0c$export$4159ae80cfa2156);
    var $3JOCw = parcelRequire("3JOCw");
    var $3sQ5x;
    var $iXqE5;
    var $lVnZu;
    const $b8a7111dc9f99b0c$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            setState({
                ...state,
                participants: state.participants.map((participant)=>{
                    if (participant.clientId === user.userId) return {
                        ...participant,
                        avatar: user.avatar,
                        name: user.name,
                        email: user.email
                    };
                    return participant;
                })
            });
        };
    const $b8a7111dc9f99b0c$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
            const uniqueJoined = (0, ($parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
            const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
            const state = getState();
            const { provider: provider } = state;
            const newParticipants = [
                ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
                ...uniqueJoined
            ];
            if (newParticipants.length >= (0, $8c1bce549db6af3b$export$3debf01bbfa135e5) && provider) {
                const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
                const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
                const lastActiveUser = sortedUsers[sortedUsers.length - 1];
                setState({
                    ...state,
                    participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
                });
                if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
                return;
            }
            setState({
                ...state,
                participants: newParticipants
            });
        };
    const $b8a7111dc9f99b0c$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
            const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
            const state = getState();
            const newSelection = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                const selections = state.nodeSelection[nodeIdKey];
                if (selections.length > 0) {
                    const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                    if (filteredSelections.length === 0) return;
                    newSelection[nodeIdKey] = filteredSelections;
                }
            });
            setState({
                ...state,
                participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
                nodeSelection: newSelection
            });
        };
    const $b8a7111dc9f99b0c$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
                ...getState(),
                provider: provider
            });
    const $b8a7111dc9f99b0c$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
            if (nodeId == null) return;
            const { provider: provider, participants: participants } = getState();
            if (participants.length <= 1) return;
            if (provider) provider.sendMessage({
                type: 'telepointer',
                sessionId: provider.sessionId,
                selection: {
                    type: 'nodeSelection',
                    anchor: JSON.stringify({
                        nodeId: nodeId
                    })
                }
            });
        };
    const $b8a7111dc9f99b0c$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
            if (nodeId == null) return;
            const { provider: provider, participants: participants } = getState();
            if (participants.length <= 1) return;
            if (provider) provider.sendMessage({
                type: 'telepointer',
                sessionId: provider.sessionId,
                selection: {
                    type: 'nodeSelection',
                    head: JSON.stringify({
                        nodeId: nodeId,
                        dropParams: dropParams
                    })
                }
            });
        };
    const $b8a7111dc9f99b0c$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
            const { color: color } = (0, (0, parcelRequire("lVnZu")).getColorFromString)(sessionId);
            const newSelection = {
                nodeId: nodeId,
                user: user,
                color: color,
                sessionId: sessionId
            };
            const state = getState();
            const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
            const nodeSelection = dedupCurrentSelection ? [
                ...dedupCurrentSelection,
                newSelection
            ] : [
                newSelection
            ];
            const dedupOtherSelections = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                const selections = state.nodeSelection[nodeIdKey];
                if (selections.length > 0) {
                    const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                    if (filteredSelections.length === 0) return;
                    dedupOtherSelections[nodeIdKey] = filteredSelections;
                }
            });
            setState({
                ...state,
                nodeSelection: {
                    ...dedupOtherSelections,
                    [nodeId]: nodeSelection
                }
            });
        };
    const $b8a7111dc9f99b0c$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newNodeSelection = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
            });
            setState({
                ...state,
                nodeSelection: newNodeSelection,
                dragAnimation: dropParams && userId != null ? [
                    ...state.dragAnimation,
                    {
                        ...dropParams,
                        userId: userId
                    }
                ] : state.dragAnimation
            });
        };
    const $b8a7111dc9f99b0c$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
            });
        };
    const $b8a7111dc9f99b0c$var$actions = {
        setProvider: $b8a7111dc9f99b0c$var$setProvider,
        participantsLeft: $b8a7111dc9f99b0c$var$participantsLeft,
        participantsJoined: $b8a7111dc9f99b0c$var$participantsJoined,
        updateUserInParticipants: $b8a7111dc9f99b0c$var$updateUserInParticipants,
        sendNodeSelected: $b8a7111dc9f99b0c$var$sendNodeSelected,
        sendClearNodeSelection: $b8a7111dc9f99b0c$var$sendClearNodeSelection,
        setNodeSelection: $b8a7111dc9f99b0c$var$setNodeSelection,
        clearNodeSelection: $b8a7111dc9f99b0c$var$clearNodeSelection,
        stopDragAnimation: $b8a7111dc9f99b0c$var$stopDragAnimation
    };
    const $b8a7111dc9f99b0c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            provider: null,
            participants: [],
            nodeSelection: {},
            dragAnimation: []
        },
        actions: $b8a7111dc9f99b0c$var$actions,
        name: 'JWMCollabStore'
    });
    const $b8a7111dc9f99b0c$export$4159ae80cfa2156 = (0, (0, parcelRequire("3sQ5x")).createHook)($b8a7111dc9f99b0c$var$Store);
});
parcelRegister("lVnZu", function(module, exports) {
    $parcel$export(module.exports, "getColorFromString", ()=>$cb176b2a2314f98e$export$137ec5185b12f5a2);
    const $cb176b2a2314f98e$var$colors = [
        (0, $829f609a65d26a98$exports).R300,
        (0, $829f609a65d26a98$exports).R400,
        (0, $829f609a65d26a98$exports).R500,
        (0, $829f609a65d26a98$exports).Y300,
        (0, $829f609a65d26a98$exports).Y400,
        (0, $829f609a65d26a98$exports).Y500,
        (0, $829f609a65d26a98$exports).G300,
        (0, $829f609a65d26a98$exports).G400,
        (0, $829f609a65d26a98$exports).G500,
        (0, $829f609a65d26a98$exports).T300,
        (0, $829f609a65d26a98$exports).T400,
        (0, $829f609a65d26a98$exports).T500,
        (0, $829f609a65d26a98$exports).P300,
        (0, $829f609a65d26a98$exports).P400,
        (0, $829f609a65d26a98$exports).P500,
        (0, $829f609a65d26a98$exports).N200,
        (0, $829f609a65d26a98$exports).N500,
        (0, $829f609a65d26a98$exports).N800
    ];
    const $cb176b2a2314f98e$export$137ec5185b12f5a2 = (str)=>{
        let hash = 0;
        for(let i = 0; i < str.length; i += 1){
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash &= hash;
        }
        const index = Math.abs(hash) % $cb176b2a2314f98e$var$colors.length;
        const hexColor = $cb176b2a2314f98e$var$colors[index];
        return {
            index: index,
            color: hexColor
        };
    };
});
const $8c1bce549db6af3b$export$3debf01bbfa135e5 = 80;
parcelRegister("b9ZBg", function(module, exports) {
    $parcel$export(module.exports, "NodeSelectionWrapper", ()=>$245afad9428c4f83$export$f758a58bee5c7927);
    $parcel$export(module.exports, "ParticipantBadge", ()=>$245afad9428c4f83$export$91bc13dfc76fa8fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $245afad9428c4f83$var$BADGE_SIZE = 16;
    const $245afad9428c4f83$var$BADGE_TEXT_COLOR = 'white';
    const $245afad9428c4f83$export$f758a58bee5c7927 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_oor3vt": (0, (0, parcelRequire("lD23V")).default)(`0 0 0 2px ${__cmplp.color} inset`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _16qs1zte _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $245afad9428c4f83$export$91bc13dfc76fa8fa = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { position: position, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _1yt4otz2 _11q71cj8 _vchhusvi _11c8qk37 _syazu67f",
                __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
                __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bDD22", function(module, exports) {
    $parcel$export(module.exports, "getPresenceNodeId", ()=>$a5ff4c6838514ad6$export$b31325f2ad6cf0b5);
    const $a5ff4c6838514ad6$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;
});
parcelRegister("d93RL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62998662af00620d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $62998662af00620d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreSelections: {
            "id": "business-list.list-view.cell.with-cell-selection.more-selections",
            "defaultMessage": " + {count, plural, one {# other} other {# others}}"
        }
    });
});
parcelRegister("kX1vD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0140b4c5d32ff7f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $0140b4c5d32ff7f1$var$CheckboxCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("khpy0")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/checkbox-cell/main.tsx"
    });
    const $0140b4c5d32ff7f1$var$AsyncCheckboxCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "checkbox-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0140b4c5d32ff7f1$var$CheckboxCell, props));
    var $0140b4c5d32ff7f1$export$2e2bcd8739ae039 = $0140b4c5d32ff7f1$var$AsyncCheckboxCell;
});
parcelRegister("khpy0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3zgcF").then(()=>parcelRequire('bzcYv'));
});
parcelRegister("al7Aq", function(module, exports) {
    $parcel$export(module.exports, "ColumnHeader", ()=>$37ba110525867ccd$export$5667c09b71ee0f05);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $34ck9 = parcelRequire("34ck9");
    var $kgoHi;
    var $8CUq3;
    var $daQYX;
    var $eq0nK;
    var $koVbs;
    var $dCm1o;
    var $8VBZp;
    var $82a7H;
    var $fXEYJ;
    var $gEb1A;
    var $5ipyI;
    var $5XBz0;
    var $lLkXN;
    const $37ba110525867ccd$var$BOUNDARY = 70;
    const $37ba110525867ccd$var$MOUSE_MOVE_THROTTLE = 16;
    const $37ba110525867ccd$export$cdd17a489f5a2a5c = 'business-list.ui.list-view.column-header.column-header-container';
    const $37ba110525867ccd$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID = 'business-list.ui.list-view.column-header.column-header-container.drag-handle';
    const $37ba110525867ccd$var$VisualRefreshIconWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "center",
            alignItems: "center",
            xcss: $37ba110525867ccd$var$iconWrapperStyle
        }, children);
    const $37ba110525867ccd$export$5667c09b71ee0f05 = ({ icon: icon, label: label, canSortField: canSortField = true, canHideField: canHideField = false, canEditField: canEditField = false, fieldId: fieldId, fieldType: fieldType = '', disableDrag: isDragDisabled, index: index })=>{
        const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectId = String(project.id);
        const ref = (0, $5uXOq.useRef)(null);
        const { status: dragStatus } = (0, (0, parcelRequire("82a7H")).useReorderColumns)({
            ref: ref,
            id: fieldId,
            index: index,
            isDragDisabled: isDragDisabled
        });
        const { dropTargetJSX: dropTargetJSX } = (0, (0, parcelRequire("8VBZp")).useFullHeightColumnDropTarget)({
            id: fieldId,
            index: index
        });
        const [{ isSelected: isSelected }] = (0, (0, parcelRequire("gEb1A")).useInlineFieldCreateControls)();
        const { clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex } = (0, (0, parcelRequire("fXEYJ")).useInlineCreateActions)();
        const { getFieldDetails: getFieldDetails, fieldDetails: fieldDetails, called: called } = (0, (0, parcelRequire("eq0nK")).useFieldDetails)(projectId, false);
        (0, $5uXOq.useEffect)(()=>{
            if (canEditField && isHovering && !fieldDetails && !called) getFieldDetails(fieldId);
        }, [
            called,
            canEditField,
            fieldDetails,
            fieldId,
            getFieldDetails,
            isHovering
        ]);
        const customLabel = (0, (0, parcelRequire("lLkXN")).default)[fieldId] ? formatMessage((0, (0, parcelRequire("lLkXN")).default)[fieldId]) : label;
        const showActions = canSortField || canHideField || canEditField;
        const editActionIsVisible = canEditField && !!fieldDetails?.operations.editable;
        const columnActions = showActions ? (0, ($parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ActionsWrapper, {
            "data-testid": "business-list.ui.list-view.column-header.actions-wrapper"
        }, canSortField && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5XBz0")).default), {
            columnName: fieldId,
            isVisible: isHovering,
            fieldType: fieldType
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ipyI")).default), {
            fieldId: fieldId,
            isVisible: isHovering,
            fieldType: fieldType,
            visibleActions: {
                sort: canSortField,
                hide: canHideField,
                edit: editActionIsVisible
            }
        })) : null;
        const calculateColumnIndex = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((event)=>{
            if (!event.currentTarget) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const width = rect.right - rect.left;
            if (x < width / 2 && x <= $37ba110525867ccd$var$BOUNDARY) setIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74), index - 1);
            else if (x >= width / 2 && x >= width - $37ba110525867ccd$var$BOUNDARY) setIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74), index);
            else clearIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74));
        }, $37ba110525867ccd$var$MOUSE_MOVE_THROTTLE), [
            index,
            setIndex,
            clearIndex
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovering(false);
            !isSelected && clearIndexAfterDelay((0, $42342df24820ed74$export$d6f887e0c1be1b74));
        }, [
            clearIndexAfterDelay,
            isSelected
        ]);
        const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.persist();
            if (ref.current?.contains(event.target)) calculateColumnIndex(event);
            else clearIndex((0, $42342df24820ed74$export$d6f887e0c1be1b74));
        }, [
            calculateColumnIndex,
            clearIndex
        ]);
        const IconWrapperComponent = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $37ba110525867ccd$var$VisualRefreshIconWrapper : $37ba110525867ccd$var$IconWrapper;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ColumnHeaderContainer, {
            "data-testid": $37ba110525867ccd$export$cdd17a489f5a2a5c,
            ref: ref,
            dragStatus: dragStatus,
            isDragDisabled: isDragDisabled,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onMouseMove: handleMouseMove
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$Title, null, isHovering && isDragDisabled !== true ? (0, ($parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$ColumnDragHandle, {
            "data-testid": $37ba110525867ccd$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID
        }) : icon != null && (0, ($parcel$interopDefault($5uXOq))).createElement(IconWrapperComponent, null, icon), (0, ($parcel$interopDefault($5uXOq))).createElement($37ba110525867ccd$var$TextWrapper, null, customLabel)), dragStatus === 'idle' ? columnActions : null, isDragDisabled !== true ? dropTargetJSX : null);
    };
    const $37ba110525867ccd$var$ColumnDragHandle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1kt9mrja _is061n3s _1mp41tcg _cfu11txw _24gj1h6o _18oh15vq _eid31b66 _fntn1b66 _sxliewfl _bc1wewfl",
                __cmplp.className
            ])
        });
    });
    const $37ba110525867ccd$var$iconWrapperStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'size.200',
        width: 'size.200',
        marginRight: 'space.050',
        marginLeft: 'space.050'
    });
    const $37ba110525867ccd$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _16jlkb7n _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1yb4 _18s8otz2 _x7odidpf",
                __cmplp.className
            ])
        });
    });
    const $37ba110525867ccd$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _4t3i1tcg _2hwx1b66 _18u01b66",
                __cmplp.className
            ])
        });
    });
    const $37ba110525867ccd$var$TextWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _o5721q9c _1bto1l2s _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $37ba110525867ccd$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _16jlidpf _1reo15vq _18m915vq _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $37ba110525867ccd$var$ColumnHeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDragDisabled: isDragDisabled, dragStatus: dragStatus, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _kqswh2mm",
                __cmplp.isDragDisabled === false && "_80om1qgj",
                __cmplp.dragStatus === 'dragging' && "_11q71caa _syaz9jg2 _80om5szm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eq0nK", function(module, exports) {
    $parcel$export(module.exports, "useFieldDetails", ()=>$91a98daf25b371ef$export$ad7ee326a4c8ec42);
    var $5uXOq = parcelRequire("5uXOq");
    var $j5YhT;
    var $3Mzpf;
    var $4R6GH;
    var $7HGHK;
    var $pa9q9;
    var $dXq4S;
    var $9OXo1;
    var $kpbr3;
    var $bBm7i;
    var $baVaq;
    const $91a98daf25b371ef$export$3fa4bbd5b4cf486d = (0, (0, parcelRequire("7HGHK")).toFlagId)('field-details-error-flag');
    const $91a98daf25b371ef$export$ad7ee326a4c8ec42 = (projectId, showErrorFlag = true)=>{
        const { getFieldDetails: getFieldDetailsService, fieldDetails: fieldDetails, loading: loading, error: error, called: called } = (0, (0, parcelRequire("kpbr3")).useFieldDetails)();
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const projectAri = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4R6GH")).fg)('migrate-deliveroo-ari-package') ? (0, (0, parcelRequire("j5YhT")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString() : (0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }), [
            projectId,
            cloudId
        ]);
        const cloudAri = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4R6GH")).fg)('migrate-deliveroo-ari-package') ? (0, (0, parcelRequire("3Mzpf")).JiraSiteAri).create({
                siteId: cloudId
            }).toString() : (0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: cloudId
            }), [
            cloudId
        ]);
        const getFieldDetails = (0, $5uXOq.useCallback)((fieldId)=>{
            getFieldDetailsService({
                fieldId: fieldId,
                cloudId: cloudAri,
                projectId: projectAri
            });
        }, [
            getFieldDetailsService,
            cloudAri,
            projectAri
        ]);
        const associatedFieldDetails = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("bBm7i")).toAssociatedField)(fieldDetails), [
            fieldDetails
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!showErrorFlag) return;
            if (error) showFlag({
                id: $91a98daf25b371ef$export$3fa4bbd5b4cf486d,
                type: 'error',
                title: (0, (0, parcelRequire("baVaq")).default).errorTitle,
                description: (0, (0, parcelRequire("baVaq")).default).errorMessage
            });
            else dismissFlag($91a98daf25b371ef$export$3fa4bbd5b4cf486d);
        }, [
            error,
            showFlag,
            dismissFlag,
            showErrorFlag
        ]);
        return {
            getFieldDetails: getFieldDetails,
            fieldDetails: associatedFieldDetails,
            loading: loading,
            error: error,
            called: called
        };
    };
});
parcelRegister("kpbr3", function(module, exports) {
    $parcel$export(module.exports, "useFieldDetails", ()=>$658da91d25e18b7a$export$ad7ee326a4c8ec42);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $cm8b5;
    var $jcw0u;
    var $ki8aF;
    var $erWQJ;
    const $658da91d25e18b7a$export$ad7ee326a4c8ec42 = ()=>{
        const onExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("ki8aF")).GET_FIELD_DETAILS_EXPERIENCE));
        const onExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("ki8aF")).GET_FIELD_DETAILS_EXPERIENCE));
        const onExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("ki8aF")).GET_FIELD_DETAILS_EXPERIENCE));
        const [getFieldDetailsQuery, { data: data, loading: loading, error: error, called: called }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("erWQJ")).QUERY), {
            onCompleted: ()=>{
                onExperienceSuccess();
            },
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'JwmCustomFieldDetails',
                        packageName: 'jiraBusinessInlineFieldConfigSidebar',
                        teamName: 'deliveroo'
                    },
                    error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                    attributes: {
                        message: 'Failed to retrieve field details'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                onExperienceFail('Failed to retrieve field details', apolloError);
            },
            fetchPolicy: 'no-cache'
        });
        const getFieldDetails = (0, $5uXOq.useCallback)((variables)=>{
            onExperienceStart();
            getFieldDetailsQuery({
                variables: variables
            });
        }, [
            onExperienceStart,
            getFieldDetailsQuery
        ]);
        return {
            getFieldDetails: getFieldDetails,
            fieldDetails: data,
            error: error,
            loading: loading,
            called: called
        };
    };
});
parcelRegister("erWQJ", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$6511b5c120994298$export$2b91517d6d5b4365);
    var $5cllN;
    const $6511b5c120994298$export$2b91517d6d5b4365 = (0, (0, parcelRequire("5cllN")).default)`
query JWMFieldDetails($cloudId: ID!, $projectId: ID!, $fieldId: String!) {
  jira {
    jwmCustomFieldDetails(cloudId: $cloudId, projectId: $projectId, fieldId: $fieldId) {
      fieldId
      name
      type
      description
      options(first: 100) {
        edges {
          node {
            optionId
            value
            isDisabled
            color {
              id
              colorKey
            }
          }
        }
      }
      configuration
      operations {
        editable
        removable
        deletable
        categoriesWhitelist
        canModifyRequired
        canModifyOptions
        canModifyDefaultValue
        canModifyPropertyConfiguration
        canAssociateInSettings
      }
    }
  }
}`;
});
parcelRegister("bBm7i", function(module, exports) {
    $parcel$export(module.exports, "toAssociatedField", ()=>$0db552f318bae4ea$export$b14a602973946199);
    const $0db552f318bae4ea$export$b14a602973946199 = (data)=>{
        const fieldDetails = data?.jira?.jwmCustomFieldDetails;
        if (!fieldDetails) return;
        return {
            name: fieldDetails.name ?? '',
            key: fieldDetails.fieldId ?? '',
            externalUuid: fieldDetails.fieldId ?? '',
            type: fieldDetails.type ?? '',
            custom: true,
            global: false,
            description: fieldDetails.description ?? '',
            category: '',
            required: false,
            options: fieldDetails.options?.edges ? fieldDetails.options.edges.map((edge)=>({
                    id: +String(edge?.node?.optionId),
                    optimisticId: String(edge?.node?.optionId),
                    value: String(edge?.node?.value),
                    externalUuid: String(edge?.node?.optionId)
                })) : undefined,
            configuration: fieldDetails.configuration,
            operations: {
                editable: fieldDetails.operations?.editable ?? false,
                deletable: fieldDetails.operations?.deletable ?? false,
                removable: fieldDetails.operations?.removable ?? false,
                categoriesWhitelist: fieldDetails.operations?.categoriesWhitelist ?? [],
                canAssociateInSettings: fieldDetails.operations?.canAssociateInSettings ?? false,
                canModifyOptions: fieldDetails.operations?.canModifyOptions ?? false,
                canModifyDefaultValue: false,
                canModifyPropertyConfiguration: fieldDetails.operations?.canModifyPropertyConfiguration ?? false,
                canModifyRequired: fieldDetails.operations?.canModifyRequired ?? false
            },
            availability: null
        };
    };
});
parcelRegister("baVaq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a5a6b3aa3631c1c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5a5a6b3aa3631c1c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-inline-field-config-sidebar.controllers.field-details.error-title",
            "defaultMessage": "We couldn't load the field details"
        },
        errorMessage: {
            "id": "business-inline-field-config-sidebar.controllers.field-details.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("8VBZp", function(module, exports) {
    $parcel$export(module.exports, "useFullHeightColumnDropTarget", ()=>$fe00cb5b0c4fbecc$export$2d25a320c0ca42d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $i9j7E;
    var $5bBwj;
    const $fe00cb5b0c4fbecc$export$79660a248b11010 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _1bsb1lxk _4t3iz7a8 _1e0cglyw",
                __cmplp.className
            ])
        });
    });
    function $fe00cb5b0c4fbecc$export$2d25a320c0ca42d3({ id: id, index: index }) {
        const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
        const [isDraggingAnyColumn, setIsDraggingAnyColumn] = (0, $5uXOq.useState)(false);
        const { monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements, attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge } = (0, (0, parcelRequire("5bBwj")).useDragAndDropAsyncModules)();
        const dropTargetRef = (0, $5uXOq.useRef)(null);
        const dropTargetJSX = (0, ($parcel$interopDefault($5uXOq))).createElement($fe00cb5b0c4fbecc$export$79660a248b11010, {
            ref: dropTargetRef,
            "data-testid": "business-list.controllers.drag-and-drop.use-full-height-column-drop-target.drop-target"
        }, closestEdge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9j7E")).DropIndicator), {
            edge: closestEdge
        }));
        (0, $5uXOq.useEffect)(()=>monitorForElements({
                canMonitor ({ source: source }) {
                    return source.data.type === 'table-header';
                },
                onGenerateDragPreview () {
                    if (dropTargetRef.current) dropTargetRef.current.style.display = 'block';
                },
                onDragStart () {
                    setIsDraggingAnyColumn(true);
                },
                onDrop () {
                    setIsDraggingAnyColumn(false);
                    if (dropTargetRef.current) dropTargetRef.current.style.display = 'none';
                }
            }), [
            monitorForElements,
            setIsDraggingAnyColumn
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const dropTarget = dropTargetRef.current;
            if (!isDraggingAnyColumn || !dropTarget) return ()=>{};
            return dropTargetForElements({
                element: dropTarget,
                getIsSticky () {
                    return true;
                },
                getData ({ input: input, element: element }) {
                    const data = {
                        id: id,
                        index: index
                    };
                    return attachClosestEdge(data, {
                        input: input,
                        element: element,
                        allowedEdges: [
                            'left',
                            'right'
                        ]
                    });
                },
                canDrop ({ source: source }) {
                    return source.data.type === 'table-header';
                },
                onDrag ({ source: source, self: self }) {
                    if (source.data.id !== id) setClosestEdge(extractClosestEdge(self.data));
                },
                onDragLeave () {
                    setClosestEdge(null);
                },
                onDrop () {
                    setClosestEdge(null);
                }
            });
        }, [
            attachClosestEdge,
            dropTargetForElements,
            extractClosestEdge,
            id,
            index,
            isDraggingAnyColumn
        ]);
        return {
            dropTargetJSX: dropTargetJSX
        };
    }
});
parcelRegister("i9j7E", function(module, exports) {
    $parcel$export(module.exports, "DropIndicator", ()=>$e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6);
    $parcel$export(module.exports, "default", ()=>$e2ea2483ebbe0d5a$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5rg5B;
    const $e2ea2483ebbe0d5a$var$lineStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        position: 'absolute',
        zIndex: 1,
        background: (0, (0, parcelRequire("5rg5B")).line).backgroundColor,
        content: '""',
        pointerEvents: 'none'
    });
    const $e2ea2483ebbe0d5a$var$edgeStyles = {
        top: (0, (0, parcelRequire("f8Sb3")).css)({
            height: (0, (0, parcelRequire("5rg5B")).line).thickness,
            top: 'var(--local-line-offset)',
            right: 0,
            left: 0
        }),
        right: (0, (0, parcelRequire("f8Sb3")).css)({
            width: (0, (0, parcelRequire("5rg5B")).line).thickness,
            top: 0,
            right: 'var(--local-line-offset)',
            bottom: 0
        }),
        bottom: (0, (0, parcelRequire("f8Sb3")).css)({
            height: (0, (0, parcelRequire("5rg5B")).line).thickness,
            right: 0,
            bottom: 'var(--local-line-offset)',
            left: 0
        }),
        left: (0, (0, parcelRequire("f8Sb3")).css)({
            width: (0, (0, parcelRequire("5rg5B")).line).thickness,
            top: 0,
            bottom: 0,
            left: 'var(--local-line-offset)'
        })
    };
    function $e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
        const lineOffset = `calc(-0.5 * (${gap} + ${(0, (0, parcelRequire("5rg5B")).line).thickness}px))`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $e2ea2483ebbe0d5a$var$lineStyles,
                edge && $e2ea2483ebbe0d5a$var$edgeStyles[edge]
            ],
            style: {
                '--local-line-offset': lineOffset
            }
        });
    }
    var $e2ea2483ebbe0d5a$export$2e2bcd8739ae039 = $e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6;
});
parcelRegister("5rg5B", function(module, exports) {
    $parcel$export(module.exports, "line", ()=>$5fa9eeeb39a80f61$export$53f1d5ea8de3d7c);
    const $5fa9eeeb39a80f61$export$53f1d5ea8de3d7c = {
        borderRadius: 0,
        thickness: 2,
        backgroundColor: "var(--ds-border-selected, #0C66E4)"
    };
});
parcelRegister("5bBwj", function(module, exports) {
    $parcel$export(module.exports, "useDragAndDropAsyncModules", ()=>$10de5cf2cc5a4997$export$c56d63ea801ce3a6);
    var $5uXOq = parcelRequire("5uXOq");
    var $e39Vk;
    var $gXGDg;
    var $3sQ5x;
    var $iXqE5;
    const $10de5cf2cc5a4997$export$d146a9e5d792fbb2 = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>Promise.resolve((parcelRequire("7gWdR"))), {
            moduleId: "a81eb583"
        });
    const $10de5cf2cc5a4997$export$7c4ce555ad7d3850 = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>(parcelRequire("a2HnD")), {
            moduleId: "63a9d67a"
        });
    const $10de5cf2cc5a4997$export$435d59857451154b = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>(parcelRequire("7okL3")), {
            moduleId: "5ef6ba42"
        });
    const $10de5cf2cc5a4997$export$361499d975b59f21 = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>(parcelRequire("4wqlR")), {
            moduleId: "fbbc3330"
        });
    const $10de5cf2cc5a4997$export$5e8458edfac77ad = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>Promise.resolve((parcelRequire("4hDdm"))), {
            moduleId: "8a3e47ea"
        });
    const $10de5cf2cc5a4997$export$d75430c29c69863c = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>(parcelRequire("cdhKx")), {
            moduleId: "b863ce2b"
        });
    const $10de5cf2cc5a4997$export$86880b4b2e1a2384 = 'column.widths';
    const $10de5cf2cc5a4997$var$actions = {
        loadModules: ()=>({ setState: setState })=>{
                (0, (0, parcelRequire("gXGDg")).waitForAllResources)([
                    $10de5cf2cc5a4997$export$d146a9e5d792fbb2(),
                    $10de5cf2cc5a4997$export$7c4ce555ad7d3850(),
                    $10de5cf2cc5a4997$export$435d59857451154b(),
                    $10de5cf2cc5a4997$export$361499d975b59f21(),
                    $10de5cf2cc5a4997$export$5e8458edfac77ad(),
                    $10de5cf2cc5a4997$export$d75430c29c69863c()
                ]).onComplete(([{ draggable: draggable, monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements }, { autoScroller: autoScroller }, { attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge }, { getReorderDestinationIndex: getReorderDestinationIndex }, { combine: combine }, { attachInstruction: attachInstruction, extractInstruction: extractInstruction }])=>{
                    setState({
                        draggable: draggable,
                        monitorForElements: monitorForElements,
                        dropTargetForElements: dropTargetForElements,
                        autoScroller: autoScroller,
                        attachClosestEdge: attachClosestEdge,
                        extractClosestEdge: extractClosestEdge,
                        getReorderDestinationIndex: getReorderDestinationIndex,
                        combine: combine,
                        attachInstruction: attachInstruction,
                        extractInstruction: extractInstruction
                    });
                });
            }
    };
    const $10de5cf2cc5a4997$var$noop = ()=>()=>{};
    const $10de5cf2cc5a4997$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            draggable: $10de5cf2cc5a4997$var$noop,
            monitorForElements: $10de5cf2cc5a4997$var$noop,
            dropTargetForElements: $10de5cf2cc5a4997$var$noop,
            autoScroller: {
                start: $10de5cf2cc5a4997$var$noop,
                stop: $10de5cf2cc5a4997$var$noop,
                updateInput: $10de5cf2cc5a4997$var$noop
            },
            attachClosestEdge: $10de5cf2cc5a4997$var$noop,
            extractClosestEdge: $10de5cf2cc5a4997$var$noop,
            getReorderDestinationIndex: $10de5cf2cc5a4997$var$noop,
            combine: $10de5cf2cc5a4997$var$noop,
            attachInstruction: $10de5cf2cc5a4997$var$noop,
            extractInstruction: $10de5cf2cc5a4997$var$noop
        },
        actions: $10de5cf2cc5a4997$var$actions,
        name: 'JWMDragAndDropAsyncModulesStore'
    });
    const $10de5cf2cc5a4997$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($10de5cf2cc5a4997$var$Store);
    const $10de5cf2cc5a4997$export$c56d63ea801ce3a6 = ()=>{
        const [asyncModules, { loadModules: loadModules }] = $10de5cf2cc5a4997$var$useHook();
        (0, $5uXOq.useEffect)(()=>{
            loadModules();
        }, [
            loadModules
        ]);
        return asyncModules;
    };
});
parcelRegister("e39Vk", function(module, exports) {
    $parcel$export(module.exports, "importForInteraction", ()=>$1224ecfa51385ab0$export$5b50cea0b44df65b);
    var $eIMrK;
    var $eYVtd;
    var $iyWSs;
    const $1224ecfa51385ab0$var$cache = (0, (0, parcelRequire("eIMrK")).createCache)(new Map());
    function $1224ecfa51385ab0$export$5b50cea0b44df65b(loader, opts) {
        const resource = $1224ecfa51385ab0$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("eYVtd")).JSResource)(()=>(0, (0, parcelRequire("iyWSs")).postTask)(loader, {
                    priority: 'user-visible'
                }), opts));
        resource.load().catch(()=>{});
        return resource;
    }
});
parcelRegister("gXGDg", function(module, exports) {
    $parcel$export(module.exports, "waitForAllResources", ()=>$29bb74f10fe3539e$export$c33694368275e0ee);
    function $29bb74f10fe3539e$export$c33694368275e0ee(resources) {
        return {
            onComplete (onLoad, onError) {
                const cleanups = [];
                const values = new Array(resources.length);
                let completed = false;
                const dispose = ()=>{
                    cleanups.forEach((cleanup)=>cleanup());
                    cleanups.length = 0;
                };
                const done = ()=>{
                    dispose();
                    completed = true;
                };
                let loadedResources = 0;
                for(let i = 0; i < resources.length && !completed; i++){
                    const completable = resources[i];
                    cleanups.push(completable.onComplete((value)=>{
                        values[i] = value;
                        loadedResources++;
                        if (loadedResources === resources.length) {
                            onLoad(values);
                            done();
                        }
                    }, (error)=>{
                        onError?.(error);
                        done();
                    }));
                }
                return dispose;
            }
        };
    }
});
parcelRegister("a2HnD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5A1SC").then(()=>parcelRequire('41Tr4'));
});
parcelRegister("7okL3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g8Wf8").then(()=>parcelRequire('biEfA'));
});
parcelRegister("4wqlR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eUpxV").then(()=>parcelRequire('9EGGH'));
});
parcelRegister("cdhKx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fmiDU").then(()=>parcelRequire('f3lfW'));
});
parcelRegister("82a7H", function(module, exports) {
    $parcel$export(module.exports, "useReorderColumns", ()=>$a66eb853dd98550b$export$b250c61f32d9da58);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bBwj;
    var $1msUu;
    var $c9pDL;
    const $a66eb853dd98550b$var$noop = ()=>{};
    const $a66eb853dd98550b$export$b250c61f32d9da58 = ({ id: id, index: index, isDragDisabled: isDragDisabled, ref: ref })=>{
        const [status, setStatus] = (0, $5uXOq.useState)('idle');
        const { combine: combine, draggable: draggable } = (0, (0, parcelRequire("5bBwj")).useDragAndDropAsyncModules)();
        (0, $5uXOq.useEffect)(()=>{
            const el = ref.current;
            if (isDragDisabled || !el) return ()=>{};
            let nextSiblingCleanupFn = $a66eb853dd98550b$var$noop;
            let tableBodyCleanupFn = $a66eb853dd98550b$var$noop;
            return combine(draggable({
                element: el,
                getInitialData () {
                    return {
                        type: 'table-header',
                        id: id,
                        index: index
                    };
                },
                onGenerateDragPreview () {
                    setStatus('preview');
                    const tableBody = el.closest(`.${(0, (0, parcelRequire("1msUu")).cl).BASE_TABLE}`)?.querySelector(`.${(0, (0, parcelRequire("1msUu")).cl).BASE_TABLE_BODY}`);
                    if (tableBody) tableBodyCleanupFn = (0, (0, parcelRequire("c9pDL")).setStyle)(tableBody, {
                        overflow: 'hidden'
                    });
                    const nextSibling = el?.nextSibling;
                    if (nextSibling) nextSiblingCleanupFn = (0, (0, parcelRequire("c9pDL")).setStyle)(nextSibling, {
                        visibility: 'hidden'
                    });
                },
                onDragStart () {
                    setStatus('dragging');
                    tableBodyCleanupFn();
                },
                onDrop () {
                    setStatus('idle');
                    nextSiblingCleanupFn();
                }
            }));
        }, [
            isDragDisabled,
            id,
            index,
            ref,
            draggable,
            combine
        ]);
        return {
            status: status
        };
    };
});
parcelRegister("1msUu", function(module, exports) {
    $parcel$export(module.exports, "cssVarTableHeight", ()=>$64e1e978e44c4adf$export$4c4d2d5ba926bbe5);
    $parcel$export(module.exports, "cl", ()=>$64e1e978e44c4adf$export$b975d55abac2bbe3);
    $parcel$export(module.exports, "INDENT_PER_LEVEL", ()=>$64e1e978e44c4adf$export$130b26c73bb9d040);
    $parcel$export(module.exports, "EXPAND_DELAY_MS", ()=>$64e1e978e44c4adf$export$e5daf2bc041d74b0);
    $parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", ()=>$64e1e978e44c4adf$export$5b388ccfa29be01);
    const $64e1e978e44c4adf$export$4c4d2d5ba926bbe5 = '--jwm-list-height';
    const $64e1e978e44c4adf$export$b975d55abac2bbe3 = {
        BASE_TABLE: 'BaseTable',
        BASE_TABLE_BODY: 'BaseTable__body',
        BASE_TABLE_TABLE: 'BaseTable__table',
        MULTIDRAG_COUNTER: 'jwm-multidrag-counter'
    };
    const $64e1e978e44c4adf$export$130b26c73bb9d040 = 25;
    const $64e1e978e44c4adf$export$e5daf2bc041d74b0 = 500;
    const $64e1e978e44c4adf$export$5b388ccfa29be01 = -1;
});
parcelRegister("c9pDL", function(module, exports) {
    $parcel$export(module.exports, "setStyle", ()=>$50cb8c6939a4f8ce$export$37a5fde709c1db82);
    function $50cb8c6939a4f8ce$export$37a5fde709c1db82(el, css) {
        const originalCss = {};
        Object.keys(css).forEach((property)=>{
            originalCss[property] = el.style[property];
            el.style[property] = css[property];
        });
        return ()=>{
            Object.keys(originalCss).forEach((property)=>{
                el.style[property] = originalCss[property];
            });
        };
    }
});
parcelRegister("fXEYJ", function(module, exports) {
    $parcel$export(module.exports, "InlineCreateContainer", ()=>$cddeccc1bbf0ec5a$export$c61fba5cf4e215ae);
    $parcel$export(module.exports, "useInlineCreateActions", ()=>$cddeccc1bbf0ec5a$export$5d97dcebeb3ebb31);
    $parcel$export(module.exports, "useInlineIssueCreateContext", ()=>$cddeccc1bbf0ec5a$export$81dc4a9ada8e5cf3);
    $parcel$export(module.exports, "useInlineFieldCreateContext", ()=>$cddeccc1bbf0ec5a$export$3b94b6fe5fe8d50d);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $cddeccc1bbf0ec5a$var$CLEAR_DELAY = 300;
    const $cddeccc1bbf0ec5a$var$initialState = {
        issue: {
            index: undefined,
            isIndexLocked: false,
            timeoutId: undefined
        },
        field: {
            index: undefined,
            isIndexLocked: false,
            timeoutId: undefined
        }
    };
    const $cddeccc1bbf0ec5a$var$actions = {
        setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                setState({
                    [key]: {
                        ...getState()[key],
                        index: index
                    }
                });
                dispatch($cddeccc1bbf0ec5a$var$actions.lockIndex(key));
            },
        clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                setState({
                    [key]: {
                        ...getState()[key],
                        index: undefined
                    }
                });
                dispatch($cddeccc1bbf0ec5a$var$actions.unlockIndex(key));
            },
        clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const timeoutId = setTimeout(()=>{
                    if (!getState()[key].isIndexLocked) {
                        dispatch($cddeccc1bbf0ec5a$var$actions.clearIndex(key));
                        setState({
                            [key]: {
                                ...getState()[key],
                                timeoutId: undefined
                            }
                        });
                    }
                }, $cddeccc1bbf0ec5a$var$CLEAR_DELAY);
                setState({
                    [key]: {
                        ...getState()[key],
                        isIndexLocked: false,
                        timeoutId: timeoutId
                    }
                });
            },
        lockIndex: (key)=>({ setState: setState, getState: getState })=>{
                const { timeoutId: timeoutId } = getState()[key];
                if (timeoutId) clearTimeout(timeoutId);
                setState({
                    [key]: {
                        ...getState()[key],
                        isIndexLocked: true,
                        timeoutId: undefined
                    }
                });
            },
        unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
                setState({
                    [key]: {
                        ...getState()[key],
                        isIndexLocked: false
                    }
                });
            }
    };
    const $cddeccc1bbf0ec5a$export$c61fba5cf4e215ae = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $cddeccc1bbf0ec5a$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cddeccc1bbf0ec5a$var$initialState,
        actions: $cddeccc1bbf0ec5a$var$actions,
        name: 'JwmListInlineCreate',
        containedBy: $cddeccc1bbf0ec5a$export$c61fba5cf4e215ae
    });
    const $cddeccc1bbf0ec5a$export$1baf430619906b52 = (0, (0, parcelRequire("3sQ5x")).createHook)($cddeccc1bbf0ec5a$var$Store);
    const $cddeccc1bbf0ec5a$export$5d97dcebeb3ebb31 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($cddeccc1bbf0ec5a$var$Store);
    const $cddeccc1bbf0ec5a$var$getInlineIssueCreate = (state)=>state.issue;
    const $cddeccc1bbf0ec5a$var$getInlineFieldCreate = (state)=>state.field;
    const $cddeccc1bbf0ec5a$export$81dc4a9ada8e5cf3 = (0, (0, parcelRequire("3sQ5x")).createHook)($cddeccc1bbf0ec5a$var$Store, {
        selector: $cddeccc1bbf0ec5a$var$getInlineIssueCreate
    });
    const $cddeccc1bbf0ec5a$export$3b94b6fe5fe8d50d = (0, (0, parcelRequire("3sQ5x")).createHook)($cddeccc1bbf0ec5a$var$Store, {
        selector: $cddeccc1bbf0ec5a$var$getInlineFieldCreate
    });
});
const $42342df24820ed74$export$76a449e52fa0e1e8 = 'issue';
const $42342df24820ed74$export$d6f887e0c1be1b74 = 'field';
parcelRegister("5ipyI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f222cc05ded03b86$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $drTrn;
    const $f222cc05ded03b86$var$ActionsDropdownMenu = ({ isVisible: isVisible, ...rest })=>{
        const [isMenuOpen, setMenuOpen] = (0, $5uXOq.useState)(false);
        return isMenuOpen || isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drTrn")).default), {
            ...rest,
            setMenuOpen: setMenuOpen
        }) : null;
    };
    var $f222cc05ded03b86$export$2e2bcd8739ae039 = $f222cc05ded03b86$var$ActionsDropdownMenu;
});
parcelRegister("drTrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1db2672fdce0ae7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $1db2672fdce0ae7e$var$ActionsDropdownMenu = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("j1vyp")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/actions-dropdown-menu/main.tsx"
    });
    var $1db2672fdce0ae7e$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-common-actions-dropdown-menu",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1db2672fdce0ae7e$var$ActionsDropdownMenu, props));
});
parcelRegister("j1vyp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6j6JE").then(()=>parcelRequire('a06mX'));
});
parcelRegister("5XBz0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed25a2e670ce827d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2UUq6;
    var $lfTZh;
    var $kxZPA;
    const $ed25a2e670ce827d$export$9951126d1499b75c = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("98wdn")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/sorting-indicator/main.tsx"
    });
    var $ed25a2e670ce827d$export$2e2bcd8739ae039 = (props)=>{
        const [sorting] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "sorting-indicator",
            fallback: null
        }, (props.columnName === sorting.sortBy || props.isVisible) && (0, ($parcel$interopDefault($5uXOq))).createElement($ed25a2e670ce827d$export$9951126d1499b75c, props));
    };
});
parcelRegister("98wdn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lg1v5").then(()=>parcelRequire('9aBEu'));
});
parcelRegister("lLkXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93fe1610c739516b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93fe1610c739516b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuetype: {
            "id": "business-list.list-view.column-header.issuetype",
            "defaultMessage": "Type"
        },
        issuekey: {
            "id": "business-list.list-view.column-header.issuekey",
            "defaultMessage": "Key"
        },
        summary: {
            "id": "business-list.list-view.column-header.summary",
            "defaultMessage": "Summary"
        },
        status: {
            "id": "business-list.list-view.column-header.status",
            "defaultMessage": "Status"
        },
        assignee: {
            "id": "business-list.list-view.column-header.assignee",
            "defaultMessage": "Assignee"
        },
        labels: {
            "id": "business-list.list-view.column-header.labels",
            "defaultMessage": "Labels"
        },
        duedate: {
            "id": "business-list.list-view.column-header.duedate",
            "defaultMessage": "Due date"
        },
        priority: {
            "id": "business-list.list-view.column-header.priority",
            "defaultMessage": "Priority"
        },
        created: {
            "id": "business-list.list-view.column-header.created",
            "defaultMessage": "Created"
        },
        updated: {
            "id": "business-list.list-view.column-header.updated",
            "defaultMessage": "Updated"
        }
    });
});
parcelRegister("3jNxz", function(module, exports) {
    $parcel$export(module.exports, "CommentsCell", ()=>$28e29ee490039ab9$export$11f3e85eadff465c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bFmnZ;
    var $DBbS0;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $koVbs;
    var $lI995;
    var $kzK6P;
    const $28e29ee490039ab9$export$11f3e85eadff465c = ({ issueKey: issueKey, isSelected: isSelected = false, onClick: onClick, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, totalCount: totalCount, cellRef: cellRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            onClick(issueKey);
        }, [
            onClick,
            issueKey
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                handleClick();
                return;
            }
            onKeyDown?.(e);
        }, [
            onKeyDown,
            handleClick
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (event.code === 'Enter') {
                onClick(issueKey);
                return true;
            }
            return false;
        }, [
            issueKey,
            onClick
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDownNew,
                onClick: ()=>true
            }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const renderedCommentCount = (0, $5uXOq.useMemo)(()=>{
            if (totalCount == null) return null;
            if (totalCount === 0) return formatMessage((0, (0, parcelRequire("kzK6P")).default).addComment);
            if (totalCount < 100) return formatMessage((0, (0, parcelRequire("kzK6P")).default).commentsCount, {
                commentCount: totalCount
            });
            return formatMessage((0, (0, parcelRequire("kzK6P")).default).moreComments);
        }, [
            formatMessage,
            totalCount
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($28e29ee490039ab9$export$6ce170286acaa8d3, {
            noComments: totalCount === 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))), {
            color: "currentColor",
            label: formatMessage((0, (0, parcelRequire("kzK6P")).default).comments),
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("DBbS0")))))
        }), renderedCommentCount));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $28e29ee490039ab9$var$wrapperStyles,
            onClick: handleClick
        }, cellContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellWrapper), {
            isFocused: isSelected,
            isEditable: true,
            onClick: handleClick,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef
        }, cellContent);
    };
    const $28e29ee490039ab9$export$6ce170286acaa8d3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { noComments: noComments, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1osq _7yhb1b66",
                __cmplp.noComments ? "_syazobra" : "_syaz1x9z",
                __cmplp.className
            ])
        });
    });
    const $28e29ee490039ab9$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        paddingLeft: 'space.100'
    });
});
parcelRegister("kzK6P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7bb374695f8a620$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a7bb374695f8a620$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        comments: {
            "id": "business-list.list-view.comments-cell.comments",
            "defaultMessage": "Comments"
        },
        commentsCount: {
            "id": "business-list.list-view.comments-cell.comments-count",
            "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
        },
        moreComments: {
            "id": "business-list.list-view.comments-cell.more-comments",
            "defaultMessage": "99+ comments"
        },
        addComment: {
            "id": "business-list.list-view.comments-cell.add-comment",
            "defaultMessage": "Add comment"
        }
    });
});
parcelRegister("bFmRi", function(module, exports) {
    $parcel$export(module.exports, "CommentsSidebar", ()=>$e49b3d0a939d5434$export$46e144cce632afca);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7eqRV;
    var $lfTZh;
    var $iXVV6;
    var $c65JB;
    var $kxZPA;
    var $5JdtV;
    const $e49b3d0a939d5434$var$PACKAGE_NAME = 'jwmCommentsSidebarIssueApp';
    const $e49b3d0a939d5434$export$35dd9ab573b87c3f = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jO7eF")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $e49b3d0a939d5434$export$46e144cce632afca = (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose })=>{
        (0, (0, parcelRequire("5JdtV")).useScrollToComments)({
            issueKey: issueKey
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessCommentsSidebarInListView"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7eqRV")).IssueBoundary), {
            packageName: $e49b3d0a939d5434$var$PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e49b3d0a939d5434$var$CSSAntiCorruptionLayer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-app",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e49b3d0a939d5434$export$35dd9ab573b87c3f, {
            analyticsSource: (0, $fcf97b7a09088940$export$7ca28938a07e0c33),
            issueKey: issueKey,
            onClose: onClose,
            shouldSetInitialFocus: true,
            shouldShowCloseButton: true,
            shouldShowRootProjectsBreadcrumb: true,
            isSpaEnabled: false,
            isLoadedWithPage: false,
            viewModeOptions: {
                viewMode: 'SIDEBAR'
            }
        })))));
    });
    const $e49b3d0a939d5434$var$CSSAntiCorruptionLayer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5JdtV", function(module, exports) {
    $parcel$export(module.exports, "useScrollToComments", ()=>$33ba799027cb914b$export$5baf464300edba1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $k9tnV;
    var $92wsG;
    const $33ba799027cb914b$var$INTERVAL = 100;
    const $33ba799027cb914b$var$TIMEOUT = 10000;
    const $33ba799027cb914b$var$SCROLL_PADDING = 34;
    const $33ba799027cb914b$export$f0c653cfd7dea798 = ()=>{
        const nodes = Array.from(document.querySelectorAll(`#${(0, (0, parcelRequire("92wsG")).ELID_ISSUE_HEADER)} + div h2`));
        return nodes.length ? nodes[nodes.length - 1] : null;
    };
    const $33ba799027cb914b$export$5baf464300edba1e = ({ issueKey: issueKey })=>{
        const intervalId = (0, $5uXOq.useRef)();
        const timeoutId = (0, $5uXOq.useRef)();
        const isTimeout = (0, $5uXOq.useRef)(false);
        const waitForElement = (0, $5uXOq.useCallback)(()=>{
            if (isTimeout.current) return;
            const ref = $33ba799027cb914b$export$f0c653cfd7dea798();
            if (ref) setTimeout(()=>{
                ref && (0, (0, parcelRequire("k9tnV")).default)(ref, {
                    scrollMode: 'always',
                    block: 'start',
                    inline: 'nearest',
                    behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                            el.scrollTop = top - $33ba799027cb914b$var$SCROLL_PADDING;
                        })
                });
            }, 300);
            else intervalId.current = setTimeout(waitForElement, $33ba799027cb914b$var$INTERVAL);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
            isTimeout.current = false;
            timeoutId.current = setTimeout(()=>{
                isTimeout.current = true;
            }, $33ba799027cb914b$var$TIMEOUT);
            intervalId.current = setTimeout(waitForElement, $33ba799027cb914b$var$INTERVAL);
            return ()=>{
                clearTimeout(intervalId.current);
                clearTimeout(timeoutId.current);
            };
        }, [
            waitForElement,
            issueKey
        ]);
    };
});
parcelRegister("92wsG", function(module, exports) {
    $parcel$export(module.exports, "issueAppModalWrapperClassName", ()=>$fcc2b749aa610036$export$6bf7918be801e6c5);
    $parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", ()=>$fcc2b749aa610036$export$bab98b619b4558be);
    $parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", ()=>$fcc2b749aa610036$export$2ec9dc4e52ec0b5d);
    $parcel$export(module.exports, "EDITOR_END_CLASS_NAME", ()=>$fcc2b749aa610036$export$18cffbebfac64f6d);
    $parcel$export(module.exports, "EDITOR_START_CLASS_NAME", ()=>$fcc2b749aa610036$export$ebb284f63692b8b2);
    $parcel$export(module.exports, "ISSUE_DESCRIPTION_EDITOR_ID", ()=>$fcc2b749aa610036$export$b8a46c806f8a6ef3);
    $parcel$export(module.exports, "ELID_ISSUE_HEADER", ()=>$fcc2b749aa610036$export$4ca9dd62cc85a6c6);
    $parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", ()=>$fcc2b749aa610036$export$23d48b936935fa57);
    $parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", ()=>$fcc2b749aa610036$export$66553a9be1be2f7e);
    var $fmm8O;
    const $fcc2b749aa610036$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
    const $fcc2b749aa610036$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
    const $fcc2b749aa610036$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
    const $fcc2b749aa610036$export$18cffbebfac64f6d = 'issue-editor-end';
    const $fcc2b749aa610036$export$ebb284f63692b8b2 = 'issue-editor-start';
    const $fcc2b749aa610036$export$b8a46c806f8a6ef3 = 'issue-description-editor';
    const $fcc2b749aa610036$export$3ef7e400a3598524 = 'issue.error';
    const $fcc2b749aa610036$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
    const $fcc2b749aa610036$export$23d48b936935fa57 = 'jira-issue-header-actions';
    const $fcc2b749aa610036$export$66553a9be1be2f7e = 'issue.error.agg';
});
parcelRegister("fmm8O", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", ()=>$99d43d51c2dfe210$export$ec8031e221d27341);
    $parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", ()=>$99d43d51c2dfe210$export$78f84210a13989cb);
    $parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", ()=>$99d43d51c2dfe210$export$10b0b01977598ffc);
    $parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", ()=>$99d43d51c2dfe210$export$9b38ca770beaf3d0);
    $parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", ()=>$99d43d51c2dfe210$export$eef81693e817e3a6);
    $parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", ()=>$99d43d51c2dfe210$export$a0d4d86bde270ad6);
    $parcel$export(module.exports, "COMMENT_DELETE_ERROR", ()=>$99d43d51c2dfe210$export$6b6cd1b99772a4a1);
    $parcel$export(module.exports, "EDITOR_ERROR", ()=>$99d43d51c2dfe210$export$2e48be8618f1b4f8);
    $parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", ()=>$99d43d51c2dfe210$export$c060b7873ebc2eb3);
    $parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", ()=>$99d43d51c2dfe210$export$1f8e6f6f8d64a715);
    $parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", ()=>$99d43d51c2dfe210$export$1f92a25b34c4df93);
    $parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", ()=>$99d43d51c2dfe210$export$d8750340852b965e);
    $parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", ()=>$99d43d51c2dfe210$export$f0962d071c2a358a);
    $parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", ()=>$99d43d51c2dfe210$export$ef7767ceecf9097c);
    $parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", ()=>$99d43d51c2dfe210$export$516af79f4e3b8794);
    $parcel$export(module.exports, "FETCH_WATCHERS_ERROR", ()=>$99d43d51c2dfe210$export$cde4105f7711a10a);
    $parcel$export(module.exports, "STOP_WATCHING_SUCCESS", ()=>$99d43d51c2dfe210$export$f674d1f44f57f99d);
    $parcel$export(module.exports, "START_WATCHING_SUCCESS", ()=>$99d43d51c2dfe210$export$bff6b5ab70bcec53);
    $parcel$export(module.exports, "REMOVE_WATCHER_ERROR", ()=>$99d43d51c2dfe210$export$37934e343a22c4e6);
    $parcel$export(module.exports, "ADD_WATCHER_ERROR", ()=>$99d43d51c2dfe210$export$6a1827094c1ef6d8);
    $parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", ()=>$99d43d51c2dfe210$export$bb96d519395e5dcc);
    $parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", ()=>$99d43d51c2dfe210$export$18bd55ba676f8b6d);
    $parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", ()=>$99d43d51c2dfe210$export$1249a100986a9489);
    $parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", ()=>$99d43d51c2dfe210$export$6b737093486e5a4e);
    $parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", ()=>$99d43d51c2dfe210$export$a2723f15441225d0);
    $parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", ()=>$99d43d51c2dfe210$export$569f7258d337be55);
    $parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", ()=>$99d43d51c2dfe210$export$f92af4e9761d23b9);
    $parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", ()=>$99d43d51c2dfe210$export$16dc9ff6a8822a90);
    $parcel$export(module.exports, "DELETE_ISSUE_ERROR", ()=>$99d43d51c2dfe210$export$d4030883b7b7a04);
    $parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", ()=>$99d43d51c2dfe210$export$2519b72aefd62ee3);
    $parcel$export(module.exports, "ADD_WORKLOG_FAILURE", ()=>$99d43d51c2dfe210$export$190e4e4a6ee2a0a2);
    $parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$f1709ebef49207cc);
    $parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", ()=>$99d43d51c2dfe210$export$bde55584c7518e8d);
    $parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", ()=>$99d43d51c2dfe210$export$cf8d549e537c67d3);
    $parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", ()=>$99d43d51c2dfe210$export$2d33e591258e36a8);
    $parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", ()=>$99d43d51c2dfe210$export$b595535e9bb1a2a2);
    $parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", ()=>$99d43d51c2dfe210$export$c3739a68f63b7e09);
    $parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", ()=>$99d43d51c2dfe210$export$6ba6cb22d5a3c521);
    $parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", ()=>$99d43d51c2dfe210$export$b1a41c9183097dc);
    $parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", ()=>$99d43d51c2dfe210$export$67544887e2b37fbc);
    $parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", ()=>$99d43d51c2dfe210$export$67566c205c72838a);
    $parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", ()=>$99d43d51c2dfe210$export$733fe45ab8c75209);
    $parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", ()=>$99d43d51c2dfe210$export$9d1386a2d0651ca9);
    $parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", ()=>$99d43d51c2dfe210$export$56094d7f6af14eac);
    $parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", ()=>$99d43d51c2dfe210$export$92d58445895900f9);
    $parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", ()=>$99d43d51c2dfe210$export$75d850be4d27b98e);
    $parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$9030bf81702823b8);
    $parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$a2a71fb6b193e549);
    $parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$8c5e4d3dfe9a1c32);
    $parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$49d11338d75de478);
    $parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", ()=>$99d43d51c2dfe210$export$3573d8ff428b4c8f);
    $parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", ()=>$99d43d51c2dfe210$export$c0657c5ed1bbfed4);
    const $99d43d51c2dfe210$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
    const $99d43d51c2dfe210$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
    const $99d43d51c2dfe210$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
    const $99d43d51c2dfe210$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
    const $99d43d51c2dfe210$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
    const $99d43d51c2dfe210$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
    const $99d43d51c2dfe210$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
    const $99d43d51c2dfe210$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
    const $99d43d51c2dfe210$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
    const $99d43d51c2dfe210$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
    const $99d43d51c2dfe210$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
    const $99d43d51c2dfe210$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
    const $99d43d51c2dfe210$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
    const $99d43d51c2dfe210$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
    const $99d43d51c2dfe210$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
    const $99d43d51c2dfe210$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
    const $99d43d51c2dfe210$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
    const $99d43d51c2dfe210$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
    const $99d43d51c2dfe210$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
    const $99d43d51c2dfe210$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
    const $99d43d51c2dfe210$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
    const $99d43d51c2dfe210$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
    const $99d43d51c2dfe210$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
    const $99d43d51c2dfe210$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
    const $99d43d51c2dfe210$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
    const $99d43d51c2dfe210$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
    const $99d43d51c2dfe210$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
    const $99d43d51c2dfe210$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
    const $99d43d51c2dfe210$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
    const $99d43d51c2dfe210$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
    const $99d43d51c2dfe210$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
    const $99d43d51c2dfe210$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
    const $99d43d51c2dfe210$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
    const $99d43d51c2dfe210$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
    const $99d43d51c2dfe210$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
    const $99d43d51c2dfe210$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
    const $99d43d51c2dfe210$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
    const $99d43d51c2dfe210$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
    const $99d43d51c2dfe210$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
    const $99d43d51c2dfe210$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
    const $99d43d51c2dfe210$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
    const $99d43d51c2dfe210$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
    const $99d43d51c2dfe210$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
    const $99d43d51c2dfe210$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
    const $99d43d51c2dfe210$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
    const $99d43d51c2dfe210$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
    const $99d43d51c2dfe210$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
    const $99d43d51c2dfe210$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
    const $99d43d51c2dfe210$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
    const $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
    const $99d43d51c2dfe210$export$c0657c5ed1bbfed4 = [
        $99d43d51c2dfe210$export$a2a71fb6b193e549,
        $99d43d51c2dfe210$export$3573d8ff428b4c8f
    ];
});
const $7e58198413094512$export$bd6f44214f84c29a = 4102;
const $7e58198413094512$export$aa53f670803b96e = 3165;
parcelRegister("3rwUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c54c7ad473af2c3d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $c54c7ad473af2c3d$var$ComponentsCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lRI10")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/components-cell/main.tsx"
    });
    const $c54c7ad473af2c3d$var$AsyncComponentsCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "components-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c54c7ad473af2c3d$var$ComponentsCell, props));
    var $c54c7ad473af2c3d$export$2e2bcd8739ae039 = $c54c7ad473af2c3d$var$AsyncComponentsCell;
});
parcelRegister("lRI10", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2G8m9").then(()=>parcelRequire('lzZqM'));
});
parcelRegister("3Vqf5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5964753ef696e100$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $1BQWb;
    const $5964753ef696e100$var$LazyDateCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("1BQWb"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/date-cell/main.tsx"
    });
    const $5964753ef696e100$var$AsyncDateCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "date-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5964753ef696e100$var$LazyDateCell, props));
    var $5964753ef696e100$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("1BQWb")).default), $5964753ef696e100$var$AsyncDateCell);
});
parcelRegister("1BQWb", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$4a863ca1a041cc1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cTemL;
    var $7qZ1x;
    var $1I7E8;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $kY99m;
    var $e0a4D;
    var $gwIPs;
    var $4R6GH;
    var $koVbs;
    var $lQE94;
    var $6yeNV;
    var $1p96B;
    var $4kK95;
    var $8zOmE;
    var $2NMNM;
    var $DVljb;
    var $dCm1o;
    var $eTDjN;
    var $lI995;
    var $luwkS;
    var $7pQZt;
    const $4a863ca1a041cc1d$var$DATE_FORMAT_OPTIONS = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    const $4a863ca1a041cc1d$var$ALL_NUMERIC_DATE_FORMAT_OPTIONS = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        format: 'dd/mm/yyyy'
    };
    const $4a863ca1a041cc1d$var$NUMERIC_DATE_FORMAT_REGEX = /^[0-9]{1,2}[-/][0-9]{1,2}[-/][0-9]{4}$/;
    const $4a863ca1a041cc1d$var$INVALID_DATE = 'Invalid Date';
    const $4a863ca1a041cc1d$var$EMPTY_ARR = [];
    const $4a863ca1a041cc1d$var$TEST_ID_PREFIX = 'business-list.ui.list-view.date-cell.date-cell';
    const $4a863ca1a041cc1d$var$CALENDAR_PROPS = {
        style: {
            display: 'inline-block',
            boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px 1px ${(0, $829f609a65d26a98$exports).N40A}`})`
        }
    };
    const $4a863ca1a041cc1d$var$dateLozengeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        paddingLeft: 'space.075'
    });
    const $4a863ca1a041cc1d$var$POPUP_OFFSET = [
        0,
        2 * (0, (0, parcelRequire("gwIPs")).gridSize)
    ];
    const $4a863ca1a041cc1d$var$DateCell = (0, $5uXOq.memo)(({ dateOnly: dateOnly, readOnly: readOnly = false, issueKey: issueKey = '', isDue: isDue = false, onOpenIssueModal: onOpenIssueModal, rowData: rowData, fieldKey: fieldKey, fieldValue: fieldValue = null, fieldType: fieldType = '', isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, testId: testId, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const weekStartDay = (0, (0, parcelRequire("1p96B")).getLocale)(locale)?.options?.weekStartsOn;
        const standardizedLocale = (0, (0, parcelRequire("6yeNV")).standardizeLocale)(locale);
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatDate: formatDateIntl, formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formatDate = (0, $5uXOq.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $4a863ca1a041cc1d$var$DATE_FORMAT_OPTIONS) : '', [
            formatDateIntl
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && isSelected === false && editMode) setEditMode(false);
        }, [
            editMode,
            isSelected,
            setEditMode
        ]);
        const [localizationProvider] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(standardizedLocale));
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [{ value: ISOStringValue_, error: error }, { saveValue: saveISOStringValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: dateOnly?.toISOString() || fieldValue
        });
        const ISOStringValue = (0, $5uXOq.useMemo)(()=>{
            if (ISOStringValue_ && !(0, (0, parcelRequire("4kK95")).DateOnly).isISODateString(ISOStringValue_) && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) return (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date(ISOStringValue_)).toISOString();
            return ISOStringValue_;
        }, [
            ISOStringValue_
        ]);
        const currentValue = (0, $5uXOq.useMemo)(()=>formatDate(ISOStringValue !== null ? (0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(ISOStringValue) : null), [
            ISOStringValue,
            formatDate
        ]);
        const [textInputValueOld, setTextInputValueOld] = (0, $5uXOq.useState)(currentValue);
        const [textInputValue, setTextInputValue] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            inputValue ?? currentValue,
            onInputChange
        ] : [
            textInputValueOld,
            setTextInputValueOld
        ];
        const formatDateString = (0, $5uXOq.useCallback)((dateString)=>dateString === null || dateString === '' ? '' : formatDate((0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(dateString)), [
            formatDate
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            if (textInputValue === formatDateString(ISOStringValue)) return;
            const formattedInputValue = formatDateIntl(new Date(String(textInputValue)), $4a863ca1a041cc1d$var$ALL_NUMERIC_DATE_FORMAT_OPTIONS);
            const isFormattedInputValid = formattedInputValue !== $4a863ca1a041cc1d$var$INVALID_DATE && $4a863ca1a041cc1d$var$NUMERIC_DATE_FORMAT_REGEX.test(formattedInputValue);
            const parsedDate = localizationProvider.parseDate(isFormattedInputValid ? formattedInputValue : String(textInputValue));
            const isEmptyValue = textInputValue === '';
            const isNewDateInputValid = !Number.isNaN(Number(parsedDate)) || isEmptyValue;
            if (isNewDateInputValid) saveISOStringValue(isEmptyValue ? null : (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date(parsedDate)).toISOString(), null, createAnalyticsEvent({}));
            else setTextInputValue(formatDateString(ISOStringValue));
        }, [
            setEditMode,
            textInputValue,
            formatDateString,
            ISOStringValue,
            formatDateIntl,
            localizationProvider,
            saveISOStringValue,
            createAnalyticsEvent,
            setTextInputValue
        ]);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (!readOnly && !editMode) setEditMode(true);
            onOpenIssueModal && rowData && onOpenIssueModal({
                id: rowData.id,
                key: rowData.key
            })(event);
            return true;
        }, [
            readOnly,
            editMode,
            onOpenIssueModal,
            rowData,
            setEditMode
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleDateSelect = (0, $5uXOq.useCallback)(({ iso: iso })=>{
            setTextInputValue(formatDate((0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(iso)));
            saveISOStringValue(iso, null, createAnalyticsEvent({}));
            setEditMode(false);
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            setTextInputValue,
            formatDate,
            saveISOStringValue,
            createAnalyticsEvent,
            setEditMode,
            wrapperRef
        ]);
        const handleChange = (0, $5uXOq.useCallback)((e)=>{
            resetError();
            setTextInputValue(e.target.value);
        }, [
            resetError,
            setTextInputValue
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && e.key === 'Escape') {
                e.preventDefault();
                setTextInputValue(formatDateString(ISOStringValue));
            }
        }, [
            setTextInputValue,
            formatDateString,
            ISOStringValue
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((e)=>{
            if (readOnly && ![
                'Tab',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight'
            ].includes(e.code)) {
                setEditMode(false);
                return true;
            }
            if (editMode) {
                if (!(e.target instanceof HTMLElement)) return;
                if ([
                    'Tab',
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ].includes(e.code)) return true;
                if ([
                    'Enter',
                    'Space'
                ].includes(e.code) && [
                    `${$4a863ca1a041cc1d$var$TEST_ID_PREFIX}--previous-month`,
                    `${$4a863ca1a041cc1d$var$TEST_ID_PREFIX}--next-month`
                ].includes(e.target.getAttribute('data-testid') ?? '')) return true;
                if (e.key === 'Enter' && e.target.nodeName === 'INPUT') {
                    saveAndClose();
                    return false;
                }
            }
        }, [
            editMode,
            readOnly,
            saveAndClose,
            setEditMode
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (ISOStringValue) event.clipboardData.setData('text/plain', ISOStringValue);
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'date');
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'date');
                setTextInputValue('');
                saveISOStringValue(null, null, createAnalyticsEvent({}));
            }
        }, [
            ISOStringValue,
            createAnalyticsEvent,
            setTextInputValue,
            saveISOStringValue
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            const clipText = event.clipboardData.getData('text/plain');
            try {
                const formattedClipText = formatDateIntl(new Date(clipText), $4a863ca1a041cc1d$var$ALL_NUMERIC_DATE_FORMAT_OPTIONS);
                const parsedDate = localizationProvider.parseDate(formattedClipText);
                const ISODate = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date(parsedDate)).toISOString();
                setTextInputValue(formatDateString(ISODate));
                saveISOStringValue(ISODate, null, createAnalyticsEvent({}));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'date', {
                    valid: true
                });
            } catch (e) {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'date', {
                    valid: false,
                    error: e.message
                });
            }
        }, [
            formatDateIntl,
            localizationProvider,
            setTextInputValue,
            formatDateString,
            saveISOStringValue,
            createAnalyticsEvent
        ]);
        const defaultDate = ISOStringValue === null || ISOStringValue === '' ? (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date()).toISOString() : ISOStringValue;
        const defaultDateOnly = (0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(defaultDate);
        const dateOnlyToday = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date());
        const dateOnlyFromISOString = ISOStringValue !== null ? (0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(ISOStringValue) : null;
        const pastDue = Boolean(isDue && dateOnlyFromISOString && (0, (0, parcelRequire("4kK95")).DateOnly).compare(dateOnlyFromISOString, dateOnlyToday) < 0);
        const staticContent = (0, $5uXOq.useMemo)(()=>{
            return ISOStringValue !== null && ISOStringValue !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                xcss: $4a863ca1a041cc1d$var$dateLozengeStyles,
                justifyContent: "start",
                alignItems: "center"
            }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                xcss: [
                    $4a863ca1a041cc1d$var$dateTagStyles,
                    pastDue ? $4a863ca1a041cc1d$var$overdueStyles : $4a863ca1a041cc1d$var$normalDateStyles
                ]
            }, formatDate(dateOnlyFromISOString)) : (0, ($parcel$interopDefault($5uXOq))).createElement($4a863ca1a041cc1d$var$DateLozenge, {
                id: !pastDue ? (0, (0, parcelRequire("eTDjN")).DATE_LOZENGE_ID) : '',
                pastDue: pastDue
            }, formatDate(dateOnlyFromISOString)));
        }, [
            ISOStringValue,
            formatDate,
            dateOnlyFromISOString,
            pastDue
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4a863ca1a041cc1d$var$DropdownWrapper, {
                onKeyDown: handleKeyDown
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luwkS")).default), {
                defaultSelected: [
                    defaultDate
                ],
                defaultDay: defaultDateOnly.getDay(),
                defaultMonth: defaultDateOnly.getMonth(),
                defaultYear: defaultDateOnly.getYear(),
                defaultPreviouslySelected: $4a863ca1a041cc1d$var$EMPTY_ARR,
                defaultDisabled: $4a863ca1a041cc1d$var$EMPTY_ARR,
                innerProps: $4a863ca1a041cc1d$var$CALENDAR_PROPS,
                onSelect: handleDateSelect,
                locale: standardizedLocale,
                testId: $4a863ca1a041cc1d$var$TEST_ID_PREFIX,
                weekStartDay: weekStartDay
            })), [
            handleKeyDown,
            defaultDate,
            defaultDateOnly,
            handleDateSelect,
            standardizedLocale,
            weekStartDay
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
            saveAndClose();
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            saveAndClose,
            wrapperRef
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement($4a863ca1a041cc1d$var$DateForm, {
                onSubmit: handleSubmit,
                "data-testid": "business-list.ui.list-view.date-cell.form"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                appearance: "none",
                value: textInputValue,
                autoFocus: true,
                onChange: handleChange,
                placeholder: localizationProvider.formatDate(new Date(new Date().getTime())),
                onKeyDown: handleKeyDown
            })) : staticContent, (ISOStringValue === null || ISOStringValue === '') && !editMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).EmptyCellContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))), {
                label: formatMessage((0, (0, parcelRequire("7pQZt")).default).emptyDate)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("7pQZt")).default).emptyDate)))), [
            editMode,
            handleSubmit,
            textInputValue,
            handleChange,
            localizationProvider,
            handleKeyDown,
            staticContent,
            ISOStringValue,
            formatMessage
        ]);
        const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: editMode,
                placement: "bottom-start",
                offset: $4a863ca1a041cc1d$var$POPUP_OFFSET,
                autoFocus: false,
                onClose: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : saveAndClose,
                content: popupContent,
                trigger: popupTrigger
            }) : staticContent, [
            staticContent,
            editMode,
            isHovering,
            saveAndClose,
            popupContent,
            popupTrigger
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const onEscapeKeyPress = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setEditMode(false);
            wrapperRef?.current?.focus();
        }, [
            wrapperRef,
            setEditMode
        ]);
        const handleKeyPress = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') onEscapeKeyPress(e);
            else !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onEscapeKeyPress,
            onKeyDown
        ]);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                    onClick: handleClick,
                    onKeyDown: handleKeyDownNew
                }), [
            handleClick,
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const dateCell = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, content, error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("7pQZt")).default).errorTitle,
            description: (0, (0, parcelRequire("7pQZt")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement($4a863ca1a041cc1d$var$DateContainerNew, {
            "data-testid": testId,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {
                tabIndex: 0
            }
        }, dateCell);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4a863ca1a041cc1d$var$DateContainer, {
            isFocused: isSelected,
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyPress,
            ref: onWrapperRef,
            "data-testid": testId
        }, dateCell);
    });
    var $4a863ca1a041cc1d$export$2e2bcd8739ae039 = $4a863ca1a041cc1d$var$DateCell;
    const $4a863ca1a041cc1d$var$DateLozenge = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { pastDue: pastDue, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rkoglpi _1yt4u49m _lcxvglyw",
                __cmplp.pastDue ? "_11q7taeo" : "_11q71s4m",
                __cmplp.pastDue ? "_syaz1gtz" : "_syazjjyb",
                __cmplp.className
            ])
        });
    });
    const $4a863ca1a041cc1d$var$dateTagStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderStyle: 'solid',
        borderRadius: 'border.radius',
        borderWidth: 'border.width',
        paddingLeft: 'space.075',
        paddingRight: 'space.075'
    });
    const $4a863ca1a041cc1d$var$overdueStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    });
    const $4a863ca1a041cc1d$var$normalDateStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    });
    const $4a863ca1a041cc1d$var$DateForm = (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8v77o",
                __cmplp.className
            ])
        });
    });
    const $4a863ca1a041cc1d$var$DropdownWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1mjv _1ul9nklw",
                __cmplp.className
            ])
        });
    });
    const $4a863ca1a041cc1d$var$DateContainer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lI995")).CellContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _2rko1sit _xmji1r31 _gxxuglyw _34ir1o36 _k2u01osq _8jdu1osq _h61aze3t _1pchze3t _1bayze3t _lmlqu2gc _p7r11txw _k8em1osq _bhl91osq _dzc21h6o",
                __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
                __cmplp.isFocused ? "_16qsw95a" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $4a863ca1a041cc1d$var$DateContainerNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsbmslj _4t3i1osq _xmji1r31 _gxxuglyw _34ir1o36 _k2u01osq _8jdu1osq _h61aze3t _1pchze3t _1bayze3t _lmlqu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("6yeNV", function(module, exports) {
    $parcel$export(module.exports, "standardizeLocale", ()=>$e3b19be89da6c3f8$export$ca06804549ae25fb);
    $parcel$export(module.exports, "verifyTimeZone", ()=>$e3b19be89da6c3f8$export$93ff13646da25bd);
    var $lzeFL;
    var $dJl1T;
    const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
    const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
        if (typeof jiraLocale !== 'string') {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
            return $e3b19be89da6c3f8$export$95b7602913551865;
        }
        const standardizedLocale = jiraLocale.replace('_', '-');
        switch(standardizedLocale){
            case 'en':
                return 'en-US';
            case 'en-UK':
                return 'en-GB';
            default:
                if (!(0, (0, parcelRequire("lzeFL")).default).includes(jiraLocale)) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
                return standardizedLocale;
        }
    };
    const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
        try {
            Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
                timeZone: timeZone
            });
            return timeZone;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
            return undefined;
        }
    };
});
parcelRegister("luwkS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37f02f7dd24a69d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $e37f02f7dd24a69d$var$Calendar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9EAG1")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/date-cell/async-calendar/main.tsx"
    });
    var $e37f02f7dd24a69d$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "calendar",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e37f02f7dd24a69d$var$Calendar, props));
});
parcelRegister("9EAG1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eSScX").then(()=>parcelRequire('jaONu'));
});
parcelRegister("7pQZt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf5372cb47c43ab2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cf5372cb47c43ab2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyDate: {
            "id": "business-list.list-view.date-cell.empty-date",
            "defaultMessage": "None"
        },
        errorTitle: {
            "id": "business-list.list-view.date-cell.error-title",
            "defaultMessage": "We couldn't save the date value."
        },
        errorMessage: {
            "id": "business-list.list-view.date-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("iQ6fh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b9bcd5d05e0ecfc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $bvcjY;
    const $9b9bcd5d05e0ecfc$var$LazyDateTimeCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("bvcjY"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/date-time-cell/main.tsx"
    });
    const $9b9bcd5d05e0ecfc$var$AsyncDateTimeCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "date-time-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9b9bcd5d05e0ecfc$var$LazyDateTimeCell, props));
    var $9b9bcd5d05e0ecfc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("bvcjY")).default), $9b9bcd5d05e0ecfc$var$AsyncDateTimeCell);
});
parcelRegister("bvcjY", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$47839763f0b470b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $5IlYG;
    var $1I7E8;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $e0a4D;
    var $jRzRt;
    var $4R6GH;
    var $koVbs;
    var $lQE94;
    var $8tRRd;
    var $eTDjN;
    var $lI995;
    var $fDcD3;
    var $fdumZ;
    var $fBU5v;
    const $47839763f0b470b9$var$POPUP_OFFSET = (0, (0, parcelRequire("eTDjN")).LIST_FIELD_POPUP_OFFSET);
    const $47839763f0b470b9$var$POPUP_OFFSET_NEW = [
        0,
        -(0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT) - 1
    ];
    const $47839763f0b470b9$var$DateTimeCell = (0, $5uXOq.memo)(({ isEditable: isEditable = false, issueKey: issueKey = '', fieldKey: fieldKey, fieldValue: fieldValue = null, width: width, height: height, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [textInputValueOld, setTextInputValueOld] = (0, $5uXOq.useState)(fieldValue);
        const textInputValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (inputValue ?? fieldValue) || '' : textInputValueOld;
        const setTextInputValueNew = (0, $5uXOq.useCallback)((value)=>onInputChange(value === null ? '' : value), [
            onInputChange
        ]);
        const setTextInputValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? setTextInputValueNew : setTextInputValueOld;
        const { formatDateTime: formatDateTime } = (0, (0, parcelRequire("8tRRd")).useDateTimeFormatter)(null);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: 'datetime',
            initialValue: fieldValue
        });
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setTextInputValue(value);
        }, [
            setTextInputValue,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && !isSelected && editMode) setEditMode(false);
        }, [
            editMode,
            isSelected,
            setEditMode
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) setEditMode(true);
        }, [
            editMode,
            isEditable,
            setEditMode
        ]);
        const handleChange = (0, $5uXOq.useCallback)((newValue)=>{
            resetError();
            if (newValue === value) return;
            saveValue(newValue, null, createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            resetError,
            saveValue,
            value
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            if (textInputValue === value) return;
            saveValue(textInputValue, null, createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            saveValue,
            textInputValue,
            value,
            setEditMode
        ]);
        const staticContent = textInputValue !== null && textInputValue !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fBU5v")).CellContent), null, formatDateTime(textInputValue)));
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const onEscapeKeyPress = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setEditMode(false);
            wrapperRef?.current?.focus();
        }, [
            wrapperRef,
            setEditMode
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Escape') onEscapeKeyPress(event);
            else !editMode && onKeyDown?.(event);
        }, [
            editMode,
            onEscapeKeyPress,
            onKeyDown
        ]);
        const handleContentKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                wrapperRef?.current?.focus();
            }
        }, [
            wrapperRef
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editMode && [
                'Enter',
                'Tab'
            ].includes(event.code)) return true;
            return false;
        }, [
            editMode
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fDcD3")).default), {
                width: width,
                height: height,
                value: textInputValue,
                onChange: handleChange,
                onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleContentKeyDown
            }), [
            handleChange,
            handleContentKeyDown,
            height,
            textInputValue,
            width
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).Container), null, textInputValue !== null && textInputValue !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fBU5v")).CellContent), null, formatDateTime(textInputValue)), (textInputValue === null || textInputValue === '') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).EmptyCellContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5IlYG"))))), {
                label: formatMessage((0, (0, parcelRequire("fdumZ")).default).emptyDate)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("fdumZ")).default).emptyDate))))), [
            formatDateTime,
            formatMessage,
            textInputValue
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
                onKeyDown: handleKeyDownNew
            }), [
            handleKeyDownNew
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            autoFocus: false,
            isOpen: editMode,
            placement: "bottom-start",
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $47839763f0b470b9$var$POPUP_OFFSET_NEW : $47839763f0b470b9$var$POPUP_OFFSET,
            popupComponent: (0, (0, parcelRequire("jRzRt")).PopupComponent),
            onClose: saveAndClose,
            content: popupContent,
            trigger: popupTrigger
        }) : staticContent, error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("fdumZ")).default).errorTitle,
            description: (0, (0, parcelRequire("fdumZ")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $47839763f0b470b9$var$wrapperStyles
            ],
            testId: "business-list.ui.list-view.date-time-cell.cell-container"
        }, cellContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onClick: handleClick,
            isFocused: isSelected,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            "data-testid": "business-list.ui.list-view.date-time-cell.cell-container",
            ref: onWrapperRef
        }, cellContent);
    });
    var $47839763f0b470b9$export$2e2bcd8739ae039 = $47839763f0b470b9$var$DateTimeCell;
    const $47839763f0b470b9$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
});
parcelRegister("8tRRd", function(module, exports) {
    $parcel$export(module.exports, "useDateTimeFormatter", ()=>$e6616d5994c4d841$export$163f492669f74d5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $cYlk7;
    var $DVljb;
    var $1YbNB;
    var $6yeNV;
    const $e6616d5994c4d841$export$163f492669f74d5b = (overrideTimeZone)=>{
        (0, (0, parcelRequire("gKZoD")).di)(Intl);
        const { data: { user: { timeZone: timeZonePreference } } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const timeZone = overrideTimeZone ?? timeZonePreference;
        const jiraLocal = (0, (0, parcelRequire("DVljb")).useLocale)();
        const standardizedLocale = (0, (0, parcelRequire("6yeNV")).standardizeLocale)(jiraLocal);
        const verifiedTimeZone = (0, (0, parcelRequire("6yeNV")).verifyTimeZone)(timeZone);
        const dateTimeFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
                ...(0, (0, parcelRequire("1YbNB")).longDateTimeFormat),
                timeZone: verifiedTimeZone
            }), [
            standardizedLocale,
            verifiedTimeZone
        ]);
        const dateOnlyFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
                ...(0, (0, parcelRequire("1YbNB")).longDateOnlyFormat),
                timeZone: 'UTC'
            }), [
            standardizedLocale
        ]);
        const formatDateTime = (0, $5uXOq.useCallback)((date)=>{
            const rawValue = typeof date === 'string' ? new Date(date) : date;
            return dateTimeFormatter.format(rawValue);
        }, [
            dateTimeFormatter
        ]);
        const formatDateOnly = (0, $5uXOq.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
            dateOnlyFormatter
        ]);
        return {
            formatDateTime: formatDateTime,
            formatDateOnly: formatDateOnly
        };
    };
});
parcelRegister("1YbNB", function(module, exports) {
    $parcel$export(module.exports, "longDateTimeFormat", ()=>$71114821d9cd9835$export$f2f390060309965);
    $parcel$export(module.exports, "longDateOnlyFormat", ()=>$71114821d9cd9835$export$51f819d50bcd4ae1);
    const $71114821d9cd9835$export$f2f390060309965 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    };
    const $71114821d9cd9835$export$51f819d50bcd4ae1 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
});
parcelRegister("fDcD3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bae380e69b076bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8bae380e69b076bf$var$DateTimeFieldEditView = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("345JW")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/date-time-cell/async-date-time-picker/main.tsx"
    });
    var $8bae380e69b076bf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "date-time-field-edit-view",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8bae380e69b076bf$var$DateTimeFieldEditView, props));
});
parcelRegister("345JW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b245r").then(()=>parcelRequire('9xCka'));
});
parcelRegister("fdumZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0efcea67dc18ed61$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0efcea67dc18ed61$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyDate: {
            "id": "business-list.list-view.date-time-cell.empty-date",
            "defaultMessage": "None"
        },
        errorTitle: {
            "id": "business-list.list-view.date-time-cell.error-title",
            "defaultMessage": "We couldn't save the date time value."
        },
        errorMessage: {
            "id": "business-list.list-view.date-time-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("fBU5v", function(module, exports) {
    $parcel$export(module.exports, "CellContent", ()=>$003a848b9a178764$export$3b628a2b5574282f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $003a848b9a178764$export$3b628a2b5574282f = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("0CGYD", function(module, exports) {
    $parcel$export(module.exports, "KeyCell", ()=>$0ff0bb70369876ca$export$4d17c2f4d9bbf823);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $b0JGA;
    var $btivG;
    var $458iJ;
    var $dC5iT;
    var $8CUq3;
    var $bG3pQ;
    var $hE5wF;
    var $1JH9w;
    var $b6nbP;
    var $7XYc4;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $hDzhb;
    var $aPg5m;
    var $lI995;
    var $3xYte;
    var $4nnGr;
    var $mH57d;
    var $92kct;
    const $0ff0bb70369876ca$export$4d17c2f4d9bbf823 = (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, parentIssues: parentIssues, onOpenIssueModal: onOpenIssueModal, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, isHovering: isHoveringNew = false, cellRef: cellRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { issueViewInteraction: issueViewInteraction } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const { showFlatList: showFlatList } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { prefetchIssue: prefetchIssue } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewDataActions)();
        const [{ hasSelection: hasSelection }] = (0, (0, parcelRequire("3xYte")).useHasCellSelection)();
        const handleIssueKeyMouseEnter = (0, $5uXOq.useCallback)(()=>{
            prefetchIssue(issueKey);
        }, [
            issueKey,
            prefetchIssue
        ]);
        const { clearSelectedCell: clearSelectedCell } = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? (0, (0, parcelRequire("3xYte")).useCellActions)() : {
            clearSelectedCell: (0, ($parcel$interopDefault($8Rkzz)))
        };
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleCopyClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell copyIssueLink', {});
        }, [
            createAnalyticsEvent
        ]);
        const handleCopyReset = (0, $5uXOq.useCallback)(()=>setIsCopied(false), [
            setIsCopied
        ]);
        const handleClickChange = (0, $5uXOq.useCallback)((status)=>setIsCopied(status), []);
        const onEmbedIssueClick = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) clearSelectedCell();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'listEmbedIssue');
            (0, (0, parcelRequire("bG3pQ")).openViewFromEmbed)({
                key: (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
                value: issueKey
            });
            event.preventDefault();
            event.stopPropagation();
        }, [
            clearSelectedCell,
            createAnalyticsEvent,
            issueKey
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') return;
            onKeyDown?.(e);
        }, [
            onKeyDown
        ]);
        const onIssueKeyClick = (0, $5uXOq.useCallback)(({ id: id, key: key })=>(event)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) {
                    event.stopPropagation();
                    clearSelectedCell();
                }
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell linkClicked');
                onOpenIssueModal({
                    id: id,
                    key: key
                })(event);
            }, [
            clearSelectedCell,
            createAnalyticsEvent,
            onOpenIssueModal
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') issueViewInteraction === 'openNewTab' ? onEmbedIssueClick(e) : onIssueKeyClick({
                id: issueId,
                key: issueKey
            })(e);
            return false;
        }, [
            issueId,
            issueKey,
            issueViewInteraction,
            onEmbedIssueClick,
            onIssueKeyClick
        ]);
        const handleCopyIconFocus = (0, $5uXOq.useCallback)((e)=>{
            (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') && e.stopPropagation();
        }, []);
        (0, $5uXOq.useImperativeHandle)(cellRef, ()=>({
                onClick: ()=>true,
                onKeyDown: handleKeyDownNew
            }), [
            handleKeyDownNew
        ]);
        let keyContent = (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKey, {
            href: `/browse/${issueKey}`,
            onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                id: issueId,
                key: issueKey
            }),
            onMouseEnter: handleIssueKeyMouseEnter,
            "data-testid": "business-list.ui.list-view.key-cell.issue-key"
        }, issueKey);
        if (showFlatList && parentIssues != null) keyContent = (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKeyContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$ParentIssueKeysWrapper, null, parentIssues.map(({ id: id, key: key }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, index > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$ParentIssueKeysDivider, null, "/"), (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKey, {
                href: `/browse/${key}`,
                onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                    id: id,
                    key: key
                }),
                "data-testid": "business-list.ui.list-view.key-cell.parent-issue-key"
            }, key)))), (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKeyHierarchyWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPg5m")).default), {
            label: "",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKey, {
            href: `/browse/${issueKey}`,
            onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                id: issueId,
                key: issueKey
            }),
            "data-testid": "business-list.ui.list-view.key-cell.issue-key"
        }, issueKey)));
        const shouldShowCopyIcon = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? !hasSelection && isHovering || isCopied : isHovering;
        const keyCellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, keyContent, shouldShowCopyIcon && (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$CopyIconWrapper, {
            onFocus: handleCopyIconFocus
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6nbP")).default), {
            id: `copy-${issueKey}`,
            label: formatMessage((0, (0, parcelRequire("92kct")).default).copy),
            tooltipDelay: 0,
            tooltipLabel: formatMessage((0, (0, parcelRequire("92kct")).default).copy),
            tooltipLabelPosition: "top",
            shouldFitContainer: true,
            value: typeof window !== 'undefined' ? `${window.location.origin}/browse/${issueKey}` : '',
            hideFieldText: true,
            remountOnChange: true,
            onCopyClick: handleCopyClick,
            onClickChange: handleClickChange,
            onCopyReset: handleCopyReset
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            iconBefore: isCopied ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("b0JGA"))))), {
                label: formatMessage((0, (0, parcelRequire("92kct")).default).copied),
                color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G500})`,
                LEGACY_primaryColor: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G500})`,
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("btivG"))))),
                LEGACY_size: "small"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("458iJ"))))), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("92kct")).default).copy)
            }),
            spacing: "none"
        }))));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0ff0bb70369876ca$var$issueKeyCellStyles
        }, keyCellContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0ff0bb70369876ca$var$IssueKeyCell, {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            isFocused: isSelected
        }, keyCellContent);
    });
    const $0ff0bb70369876ca$var$CopyIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_tzy41r8u _t9ec12hf _u5f31b66 _4t3ipxbi _v5641hdd _kqswstnw _1xi2idpf",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$IssueKeyCell = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lI995")).WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19bvu2gc _u5f3u2gc _k48pbfng _syazagj8 _80omtlke _kqswh2mm _2rkoglpi _vchhusvi _sqoridpf _xm5vfdjv _1nw4t94y _qnlu1xty",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$issueKeyCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        outline: 'none',
        paddingLeft: 'space.100',
        paddingRight: 'space.100',
        fontWeight: 500,
        cursor: 'pointer',
        color: 'color.text',
        position: 'relative',
        '--copy-icon-opacity': 0,
        '--copy-icon-transform': `translate(${"var(--ds-space-negative-100, -8px)"}, 0)`,
        ':hover': {
            '--copy-icon-opacity': 1,
            '--copy-icon-transform': 'translate(0, 0)'
        }
    });
    const $0ff0bb70369876ca$var$IssueKeyOld = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazagj8 _1reo15vq _18m915vq _1bto1l2s _u5f3u2gc _30l3agj8",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$IssueKeyOldFont = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _1reo15vq _18m915vq _1bto1l2s _u5f3u2gc _30l31gjq",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$IssueKeyNewFont = (0, $5uXOq.forwardRef)(({ as: C = $0ff0bb70369876ca$var$IssueKeyOldFont, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48pi7a9 _u5f3utpp",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$IssueKeyNew = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $0ff0bb70369876ca$var$IssueKeyNewFont, $0ff0bb70369876ca$var$IssueKeyOldFont);
    const $0ff0bb70369876ca$var$IssueKey = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $0ff0bb70369876ca$var$IssueKeyNew, $0ff0bb70369876ca$var$IssueKeyOld);
    const $0ff0bb70369876ca$var$IssueKeyContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$IssueKeyHierarchyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$ParentIssueKeysWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _11c81vlj",
                __cmplp.className
            ])
        });
    });
    const $0ff0bb70369876ca$var$ParentIssueKeysDivider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41nxw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("bG3pQ", function(module, exports) {
    $parcel$export(module.exports, "openViewFromEmbed", ()=>$b6fc163d26910ed9$export$a29603f2eb9b6da6);
    const $b6fc163d26910ed9$export$a29603f2eb9b6da6 = (param)=>{
        const cleanUrl = window.location.href.replace('/embed', '');
        const currentUrl = new URL(cleanUrl);
        if (param != null) currentUrl.searchParams.append(param.key, param.value);
        window.open(currentUrl.href, '_blank');
    };
});
parcelRegister("b6nbP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f75a19e3ebf5c6c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7EEmi;
    class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                className: undefined,
                shouldFitContainer: false,
                hideFieldText: false,
                onCopyClick: undefined,
                onCopyReset: undefined,
                tooltipDelay: undefined,
                remountOnChange: false,
                tooltipDisabled: false
            };
        }
        componentWillUnmount() {
            clearTimeout(this.timeoutId);
        }
        render() {
            const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
            const fieldValue = hideFieldText ? '' : value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7EEmi")).default), {
                id: id,
                label: label,
                tooltipLabel: tooltipLabel,
                tooltipLabelPosition: tooltipLabelPosition,
                tooltipDelay: tooltipDelay,
                remountOnChange: remountOnChange,
                fieldKey: value,
                value: fieldValue,
                className: className,
                shouldFitContainer: shouldFitContainer,
                hideFieldText: hideFieldText,
                ...this.state,
                onCopyClick: this.onCopyClick,
                innerInputRef: this.onRef,
                tooltipDisabled: tooltipDisabled
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                copied: false,
                copyFailed: false
            }, this.onCopyClick = (event, analyticsEvent)=>{
                if (!this.inputTextRef || !this.inputTextRef.current) return;
                this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
                if (this.props.hideFieldText) this.inputTextRef.current.value = this.props.value;
                this.inputTextRef.current.select();
                let success = false;
                try {
                    success = document.execCommand('copy');
                    this.setState({
                        copied: true
                    });
                    this.props.onClickChange && this.props.onClickChange(true);
                } catch (e) {
                    success = false;
                }
                if (!success) this.setState({
                    copyFailed: true
                });
                this.timeoutId = setTimeout(()=>{
                    this.setState({
                        copied: false,
                        copyFailed: false
                    });
                    this.props.onCopyReset && this.props.onCopyReset();
                }, 3000);
                if (this.props.onCopyFinish) this.props.onCopyFinish();
            }, this.onRef = (ref)=>{
                this.inputTextRef = ref;
            };
        }
    }
});
parcelRegister("7EEmi", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$4e1842edd397110a$export$2d5d2ba3c7c8c40b);
    $parcel$export(module.exports, "default", ()=>$4e1842edd397110a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3Fq5M;
    var $5ILhZ;
    var $8CUq3;
    var $kY99m;
    var $3bDjY;
    var $fVAPR;
    var $az4zD;
    var $gT8ZY;
    var $9iXoh;
    class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                className: undefined,
                copyFailed: false,
                shouldFitContainer: false,
                hideFieldText: false,
                tooltipDelay: 100,
                remountOnChange: false
            };
        }
        constructor(props){
            super(props);
            this.textInput = (0, $5uXOq.createRef)();
            this.props.innerInputRef(this.textInput);
        }
        renderDefaultButton() {
            const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
                onClick: onCopyClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                color: "currentColor",
                label: tooltipLabel
            }));
        }
        render() {
            const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
            let actualTooltipLabel = tooltipLabel;
            if (copied) actualTooltipLabel = intl.formatMessage((0, (0, parcelRequire("gT8ZY")).default).copied);
            else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, (0, parcelRequire("gT8ZY")).default).copyFailed);
            const copyButton = !this.props.children ? null : (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
                onClick: onCopyClick
            });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9iXoh")).Root), props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9iXoh")).FieldContainer), {
                shouldFitContainer: shouldFitContainer,
                hideFieldText: hideFieldText
            }, label && !hideFieldText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVAPR")).FieldLabel), {
                htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                label: label
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                "aria-hidden": hideFieldText ? 'true' : undefined,
                key: fieldKey,
                id: id,
                name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                label: label,
                value: value,
                isReadOnly: true,
                ref: this.textInput,
                tabIndex: hideFieldText ? -1 : undefined
            })), tooltipDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                tag: "span",
                key: remountOnChange ? actualTooltipLabel : undefined,
                delay: tooltipDelay,
                position: tooltipLabelPosition,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "aria-live": "assertive"
                }, actualTooltipLabel)
            }, copyButton || this.renderDefaultButton())));
        }
    }
    var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
    const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...props,
            xcss: $4e1842edd397110a$var$pressableStyles
        });
    $4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton';
    const $4e1842edd397110a$var$FlexGrow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $4e1842edd397110a$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '40px',
        width: '40px',
        borderRadius: "var(--ds-border-radius, 3px)",
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        ':active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    });
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("fVAPR", function(module, exports) {
    $parcel$export(module.exports, "FieldLabel", ()=>$97462970d1593b07$export$1acdcf5a973a8414);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $gwIPs;
    const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
            htmlFor: htmlFor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
            role: "presentation"
        }, "*") : null));
    const $97462970d1593b07$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
    const $97462970d1593b07$var$LabelText = (0, $47bDC.default).div.withConfig({
        componentId: "sc-9kgl5s-0"
    })`${(0, (0, parcelRequire("3RZIb")).h200)()} display:block;font-family:${(0, (0, parcelRequire("gwIPs")).fontFamily)};margin:0;${(0, $47bDC.css)({
        padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
    })}`;
    const $97462970d1593b07$var$RequiredIndicator = (0, $47bDC.default).span.withConfig({
        componentId: "sc-9kgl5s-1"
    })({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R400})`,
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        paddingLeft: "var(--ds-space-025, 2px)"
    });
    $97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';
});
const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';
parcelRegister("gT8ZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb069c8c90804ba8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copied: {
            "id": "common.field-copy-text.copied",
            "defaultMessage": "Copied!"
        },
        copyFailed: {
            "id": "common.field-copy-text.copy-failed",
            "defaultMessage": "Couldn't copy to clipboard"
        }
    });
});
parcelRegister("9iXoh", function(module, exports) {
    $parcel$export(module.exports, "Root", ()=>$d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
    $parcel$export(module.exports, "FieldContainer", ()=>$d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
    var $47bDC = parcelRequire("47bDC");
    const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g0si8d-0"
    })({
        display: 'flex',
        alignItems: 'flex-end'
    }, (props)=>props.hideFieldText === true ? (0, $47bDC.css)({
            userSelect: 'none'
        }) : '');
    const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g0si8d-1"
    })({
        marginRight: "var(--ds-space-100, 8px)"
    }, (props)=>props.shouldFitContainer ? (0, $47bDC.css)({
            flexGrow: 1
        }) : '', (props)=>props.hideFieldText === true ? (0, $47bDC.css)({
            position: 'absolute',
            left: '-9999px',
            height: 0,
            opacity: 0,
            pointerEvents: 'none',
            userSelect: 'none'
        }) : '');
});
parcelRegister("aPg5m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bdcab90fa945ecc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $6bdcab90fa945ecc$var$defaultStrokeColor = "var(--ds-text-accent-blue-bolder, #42526E)";
    const $6bdcab90fa945ecc$var$HierarchyIconSVG = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "5.33333",
            cy: "5.33333",
            r: "1.33333",
            stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
            strokeWidth: "1.33333",
            fill: "none"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "10.6667",
            cy: "10.6666",
            r: "1.33333",
            stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
            strokeWidth: "1.33333",
            fill: "none"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M5.33337 6.66669V9.33335C5.33337 10.0697 5.93033 10.6667 6.66671 10.6667H9.33337",
            stroke: props.stroke || $6bdcab90fa945ecc$var$defaultStrokeColor,
            strokeWidth: "1.33333",
            fill: "none"
        }));
    const $6bdcab90fa945ecc$var$HierarchyIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: (customGlyphProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($6bdcab90fa945ecc$var$HierarchyIconSVG, {
                    ...customGlyphProps,
                    stroke: props.stroke
                }),
            size: props.size,
            label: props.label
        });
    var $6bdcab90fa945ecc$export$2e2bcd8739ae039 = $6bdcab90fa945ecc$var$HierarchyIcon;
});
parcelRegister("92kct", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5144cc01f8a4b829$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5144cc01f8a4b829$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copy: {
            "id": "business-list.list-view.key-cell.copy",
            "defaultMessage": "Copy link"
        },
        copied: {
            "id": "business-list.list-view.key-cell.copied",
            "defaultMessage": "Copied"
        }
    });
});
parcelRegister("e7PC0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b41839aa9a40ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $cafgS;
    const $c4b41839aa9a40ba$var$LazyLabelsCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("cafgS"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/labels-cell/main.tsx"
    });
    const $c4b41839aa9a40ba$var$AsyncLabelsCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "labels-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c4b41839aa9a40ba$var$LazyLabelsCell, props));
    var $c4b41839aa9a40ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("cafgS")).default), $c4b41839aa9a40ba$var$AsyncLabelsCell);
});
parcelRegister("cafgS", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$e1dc99ba033469ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2x3Cb;
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $d9xxV;
    var $3bDjY;
    var $jldZL;
    var $b5lmY;
    var $icf02;
    var $e0a4D;
    var $jRzRt;
    var $k2xO1;
    var $4R6GH;
    var $koVbs;
    var $iY5Zn;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $eTDjN;
    var $6du7W;
    var $lI995;
    var $1h5yY;
    var $l6CFv;
    const $e1dc99ba033469ed$var$defaultIssueLabels = [];
    const $e1dc99ba033469ed$var$wordRegex = /(\S+)/gm;
    const $e1dc99ba033469ed$var$POPUP_OFFSET = [
        0,
        1 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $e1dc99ba033469ed$var$POPUP_OFFSET_NEW = [
        0,
        -(0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $e1dc99ba033469ed$var$LabelsCell = (0, $5uXOq.memo)(({ issueKey: issueKey, issueId: issueId, issueLabels: issueLabels = $e1dc99ba033469ed$var$defaultIssueLabels, width: width, fieldType: fieldType, fieldKey: fieldKey, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, isEditable: isEditable, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
        const inputRef = (0, $5uXOq.useRef)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ error: error, value: value }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("iY5Zn")).useLabelsField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: issueLabels,
            issueId: issueId,
            onFailure: ()=>setLabels(issueLabels)
        });
        const { defaultSuggestions: defaultSuggestions, addDefaultSuggestion: addDefaultSuggestion, getSuggestions: getSuggestions } = (0, (0, parcelRequire("1h5yY")).useLabels)(issueId, fieldKey);
        const updatedLabels = (0, $5uXOq.useMemo)(()=>value || $e1dc99ba033469ed$var$defaultIssueLabels, [
            value
        ]);
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(editMode);
        const wasEditMode = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(editMode);
        (0, $5uXOq.useEffect)(()=>{
            setMenuIsOpen(editMode);
        }, [
            editMode
        ]);
        const [labels, setLabels] = (0, $5uXOq.useState)(()=>updatedLabels);
        if (!editMode && !(0, ($parcel$interopDefault($ajpes)))(labels, updatedLabels) && (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') || !wasEditMode)) setLabels(updatedLabels);
        const [isCreating, setIsCreating] = (0, $5uXOq.useState)(false);
        const [shouldFocusInput, setShouldFocusInput] = (0, $5uXOq.useState)(false);
        const [shouldSave, setShouldSave] = (0, $5uXOq.useState)(false);
        const saveAndClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setShouldSave(false);
            if (!(0, ($parcel$interopDefault($ajpes)))(labels.slice().sort(), updatedLabels.slice().sort())) saveValue(labels, null, createAnalyticsEvent({})).then(()=>{
                labels.filter((label)=>issueLabels.indexOf(label) === -1).forEach((suggestion)=>{
                    addDefaultSuggestion(suggestion);
                });
            }).catch(()=>{});
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) wrapperRef?.current?.focus();
        }, [
            setEditMode,
            labels,
            updatedLabels,
            wrapperRef,
            saveValue,
            createAnalyticsEvent,
            issueLabels,
            addDefaultSuggestion
        ]);
        const onEscapeKeyPress = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            setLabels(issueLabels);
        }, [
            issueLabels,
            setEditMode
        ]);
        const { onKeyDown: onMultiSelectKeyDown, saveOnBlur: saveOnBlur } = (0, (0, parcelRequire("icf02")).useMultiSelectKeyDown)({
            editMode: editMode,
            wasEditMode: wasEditMode,
            menuIsOpen: menuIsOpen,
            setMenuIsOpen: setMenuIsOpen,
            saveAndClose: saveAndClose,
            onEscapeKeyPress: onEscapeKeyPress
        });
        (0, $5uXOq.useEffect)(saveOnBlur, [
            saveOnBlur
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: onMultiSelectKeyDown
            }), [
            onMultiSelectKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (editMode === true) setShouldSave(true);
            else setEditMode(true);
        }, [
            editMode,
            setEditMode
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onKeyDown
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleLabelsChange = (0, $5uXOq.useCallback)((newValue)=>{
            resetError();
            if (newValue) setLabels(Array.isArray(newValue) ? newValue.map((option)=>String(option.label)).sort() : [
                newValue.label
            ]);
            else setLabels([]);
        }, [
            resetError
        ]);
        const handleBlur = (0, $5uXOq.useCallback)((event)=>{
            if (!isCreating) onBlur?.(event);
            else {
                setIsCreating(false);
                setShouldFocusInput(true);
            }
        }, [
            onBlur,
            isCreating
        ]);
        const handleLabelsClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
        }, []);
        const handleCreateOption = (0, $5uXOq.useCallback)((label)=>{
            setLabels([
                ...labels,
                label
            ].sort());
            setIsCreating(true);
        }, [
            labels
        ]);
        const handleMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (!isCreating) setShouldSave(true);
        }, [
            isCreating
        ]);
        const handleInputRef = (0, $5uXOq.useCallback)((ref)=>{
            if (inputRef) inputRef.current = ref;
        }, [
            inputRef
        ]);
        const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setShouldSave(true);
        }, []);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (Array.isArray(labels)) event.clipboardData.setData('text/plain', labels.join(' '));
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'labels');
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'labels');
                setLabels([]);
                saveValue([], null, createAnalyticsEvent({})).catch();
            }
        }, [
            labels,
            saveValue,
            createAnalyticsEvent
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            const clipText = event.clipboardData.getData('text/plain');
            const words = clipText.match($e1dc99ba033469ed$var$wordRegex);
            if (Array.isArray(words) && words.length > 0) {
                const newLabels = Array.from(new Set([
                    ...labels,
                    ...words
                ]));
                setLabels(newLabels);
                saveValue(newLabels, null, createAnalyticsEvent({})).catch();
                if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setMenuIsOpen(false);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'labels', {
                    valid: true
                });
            } else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'labels', {
                valid: false,
                error: 'Paste content contains no words'
            });
        }, [
            labels,
            saveValue,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (editMode && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) inputRef?.current?.focus();
        }, [
            editMode,
            issueLabels
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && isSelected === false && editMode) setShouldSave(true);
        }, [
            isSelected,
            editMode,
            saveAndClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && shouldFocusInput) {
                inputRef?.current?.focus();
                setShouldFocusInput(false);
            }
        }, [
            shouldFocusInput
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && shouldSave) saveAndClose();
        }, [
            shouldSave,
            saveAndClose
        ]);
        const staticContent = (0, $5uXOq.useMemo)(()=>labels.map((label)=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span",
                    xcss: $e1dc99ba033469ed$var$tagContainerStyles,
                    key: label
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                    text: label
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                    key: label,
                    text: label
                })), [
            labels
        ]);
        const defaultOptions = (0, $5uXOq.useMemo)(()=>defaultSuggestions.filter((suggestion)=>labels.indexOf(suggestion.label) === -1).map((suggestion)=>({
                    label: suggestion.label,
                    value: suggestion.label
                })), [
            defaultSuggestions,
            labels
        ]);
        const formatCreateLabel = (0, $5uXOq.useCallback)((inputValue_)=>`${inputValue_} (${formatMessage((0, (0, parcelRequire("l6CFv")).default).createNewItem)})`, [
            formatMessage
        ]);
        const noOptionsMessage = (0, $5uXOq.useCallback)((args)=>labels.find((label)=>label === args.inputValue) ? formatMessage((0, (0, parcelRequire("l6CFv")).default).duplicate) : formatMessage((0, (0, parcelRequire("l6CFv")).default).noResults), [
            formatMessage,
            labels
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                isEditable: isEditable,
                "data-testid": "business-list.ui.list-view.labels-cell.tag-list-wrapper"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: labels.join(', '),
                position: "top"
            }, staticContent))), [
            labels,
            isEditable,
            staticContent
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
                preferredWidth: width - 1,
                onClick: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleLabelsClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
                htmlFor: "business-list.ui.list-view.labels-cell.popup-content-lazy-creatable-select"
            }, formatMessage((0, (0, parcelRequire("l6CFv")).default).labelMultipleOptionsLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6du7W")).default), {
                isMulti: true,
                isClearable: true,
                autoFocus: true,
                menuIsOpen: menuIsOpen,
                placeholder: formatMessage((0, (0, parcelRequire("l6CFv")).default).placeholder),
                value: labels.map((label)=>({
                        value: label,
                        label: label
                    })),
                onChange: handleLabelsChange,
                loadOptions: getSuggestions,
                defaultOptions: defaultOptions,
                onCreateOption: handleCreateOption,
                formatCreateLabel: formatCreateLabel,
                noOptionsMessage: noOptionsMessage,
                onMenuClose: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleMenuClose,
                closeMenuOnSelect: false,
                onInputRef: handleInputRef,
                inputId: "business-list.ui.list-view.labels-cell.popup-content-lazy-creatable-select",
                label: formatMessage((0, (0, parcelRequire("l6CFv")).default).selectBoxLabel),
                tabSelectsValue: !!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav'),
                inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
                onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : undefined
            })), [
            width,
            handleLabelsClick,
            formatMessage,
            menuIsOpen,
            labels,
            handleLabelsChange,
            getSuggestions,
            defaultOptions,
            handleCreateOption,
            formatCreateLabel,
            noOptionsMessage,
            handleMenuClose,
            handleInputRef,
            inputValue,
            onInputChange
        ]);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: Math.min(8, defaultSuggestions.length),
                hasFooter: true
            }), [
            defaultSuggestions
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: editMode,
            placement: "bottom-start",
            autoFocus: false,
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $e1dc99ba033469ed$var$POPUP_OFFSET_NEW : $e1dc99ba033469ed$var$POPUP_OFFSET,
            onClose: handlePopupClose,
            popupComponent: popupComponent,
            content: popupContent,
            trigger: popupTrigger,
            testId: "business-list.ui.list-view.labels-cell.labels-menu"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), null, staticContent), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("l6CFv")).default).errorTitle,
            description: (0, (0, parcelRequire("l6CFv")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.labels-cell.cell-container",
            hasPadding: false,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e1dc99ba033469ed$var$ContentWrapper, null, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            onBlur: handleBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            onClick: handleClick,
            isFocused: isSelected && !editMode,
            "data-testid": "business-list.ui.list-view.labels-cell.cell-container"
        }, cellContent);
    });
    var $e1dc99ba033469ed$export$2e2bcd8739ae039 = $e1dc99ba033469ed$var$LabelsCell;
    const $e1dc99ba033469ed$var$ContentWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $e1dc99ba033469ed$var$wrapperStyles
            ]
        }, children);
    const $e1dc99ba033469ed$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
    const $e1dc99ba033469ed$var$tagContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        minWidth: '45px'
    });
});
parcelRegister("1h5yY", function(module, exports) {
    $parcel$export(module.exports, "useLabels", ()=>$700f5c352b9b5a67$export$d6875122194c7b44);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $FtZX9;
    var $1iIjC;
    const $700f5c352b9b5a67$var$LABEL_SUGGESTIONS_DEBOUNCE_MS = 500;
    const $700f5c352b9b5a67$export$d6875122194c7b44 = (issueId, fieldKey)=>{
        const [{ defaultSuggestions: defaultSuggestions, defaultSuggestionsIssueId: defaultSuggestionsIssueId }, { setDefaultSuggestions: setDefaultSuggestions, addDefaultSuggestion: addDefaultSuggestion, setDefaultSuggestionsIssueId: setDefaultSuggestionsIssueId }] = (0, (0, parcelRequire("1iIjC")).useLabelsStore)(issueId);
        if (!defaultSuggestionsIssueId) setDefaultSuggestionsIssueId(issueId);
        const autoCompleteUrl = (0, $5uXOq.useMemo)(()=>{
            let url = `/rest/api/1.0/labels/${issueId}/suggest?`;
            if (fieldKey !== 'labels') url += `customFieldId=${fieldKey.split('_').reverse()[0]}&`;
            url += 'query=';
            return url;
        }, [
            fieldKey,
            issueId
        ]);
        const loadSuggestions = (0, $5uXOq.useCallback)((query)=>{
            const url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
            return (0, (0, parcelRequire("eusud")).performGetRequest)(url).then((response)=>response.suggestions);
        }, [
            autoCompleteUrl
        ]);
        const getSuggestions = (0, $5uXOq.useCallback)((query)=>{
            if (!query && defaultSuggestions) return Promise.resolve(defaultSuggestions);
            return loadSuggestions(query);
        }, [
            defaultSuggestions,
            loadSuggestions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultSuggestionsIssueId === issueId && !defaultSuggestions) loadSuggestions('').then((suggestions)=>{
                setDefaultSuggestions(suggestions);
            });
        }, [
            defaultSuggestionsIssueId,
            defaultSuggestions,
            issueId,
            loadSuggestions,
            setDefaultSuggestions
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                defaultSuggestions: defaultSuggestions ?? [],
                getSuggestions: (0, (0, parcelRequire("FtZX9")).default)(getSuggestions, $700f5c352b9b5a67$var$LABEL_SUGGESTIONS_DEBOUNCE_MS),
                addDefaultSuggestion: addDefaultSuggestion
            }), [
            defaultSuggestions,
            getSuggestions,
            addDefaultSuggestion
        ]);
    };
});
parcelRegister("FtZX9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebb46637e8f856b8$export$2e2bcd8739ae039);
    const $ebb46637e8f856b8$var$defer = ()=>{
        const deferred = {};
        deferred.promise = new Promise((resolve, reject)=>{
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    };
    function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
        let deferred;
        let timer;
        let lastArgs;
        function flush() {
            const thisDeferred = deferred;
            clearTimeout(timer);
            if (thisDeferred) Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
            lastArgs = [];
            deferred = null;
        }
        return function debounced(...args) {
            if (deferred) clearTimeout(timer);
            else deferred = $ebb46637e8f856b8$var$defer();
            lastArgs = args;
            timer = setTimeout(flush.bind(this), wait);
            return deferred.promise;
        };
    }
    var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;
});
parcelRegister("1iIjC", function(module, exports) {
    $parcel$export(module.exports, "useLabelsStore", ()=>$37d133c6b4ba9e4c$export$760f05b2dd641a7b);
    var $3sQ5x;
    var $iXqE5;
    const $37d133c6b4ba9e4c$var$actions = {
        setDefaultSuggestions: (defaultSuggestions)=>({ setState: setState })=>{
                setState({
                    defaultSuggestions: defaultSuggestions
                });
            },
        addDefaultSuggestion: (label)=>({ setState: setState, getState: getState })=>{
                const defaultSuggestions = getState().defaultSuggestions ? [
                    ...getState().defaultSuggestions
                ] : [];
                const idx = defaultSuggestions.findIndex((suggestion)=>suggestion.label === label);
                if (idx >= 0) defaultSuggestions.splice(idx, 1);
                setState({
                    defaultSuggestions: [
                        {
                            label: label,
                            value: label
                        },
                        ...defaultSuggestions
                    ].slice(0, 20)
                });
            },
        setDefaultSuggestionsIssueId: (issueId)=>({ setState: setState, getState: getState })=>{
                if (!getState().defaultSuggestionsIssueId) setState({
                    defaultSuggestionsIssueId: issueId
                });
            }
    };
    const $37d133c6b4ba9e4c$var$LabelsStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            defaultSuggestions: null,
            defaultSuggestionsIssueId: null
        },
        actions: $37d133c6b4ba9e4c$var$actions,
        name: 'JWMLabels'
    });
    const $37d133c6b4ba9e4c$export$57a5095d1d6807d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($37d133c6b4ba9e4c$var$LabelsStore);
    const $37d133c6b4ba9e4c$export$760f05b2dd641a7b = (issueId)=>{
        const labelsStore = $37d133c6b4ba9e4c$export$57a5095d1d6807d3();
        const [, { setDefaultSuggestionsIssueId: setDefaultSuggestionsIssueId }] = labelsStore;
        setDefaultSuggestionsIssueId(issueId);
        return labelsStore;
    };
});
parcelRegister("l6CFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$745d1bccd087eebb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $745d1bccd087eebb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.labels-cell.error-title",
            "defaultMessage": "We couldn't set the labels value"
        },
        errorMessage: {
            "id": "business-list.list-view.labels-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        placeholder: {
            "id": "business-list.list-view.labels-cell.placeholder",
            "defaultMessage": "Select label"
        },
        createNewItem: {
            "id": "business-list.list-view.labels-cell.create-new-item",
            "defaultMessage": "New label"
        },
        noResults: {
            "id": "business-list.list-view.labels-cell.no-results",
            "defaultMessage": "No matches found"
        },
        duplicate: {
            "id": "business-list.list-view.labels-cell.duplicate",
            "defaultMessage": "Label already added"
        },
        labelMultipleOptionsLabel: {
            "id": "business-list.list-view.labels-cell.label-multiple-options-label",
            "defaultMessage": "Multiple labels can be selected"
        },
        selectBoxLabel: {
            "id": "business-list.list-view.labels-cell.select-box-label",
            "defaultMessage": "Label"
        }
    });
});
parcelRegister("aYkrQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e634a5fcd705fbcc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $e634a5fcd705fbcc$var$MultiSelectCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("bJ7zw")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/multi-select-cell/main.tsx"
    });
    const $e634a5fcd705fbcc$var$AsyncMultiSelectCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "multi-select-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e634a5fcd705fbcc$var$MultiSelectCell, props));
    var $e634a5fcd705fbcc$export$2e2bcd8739ae039 = $e634a5fcd705fbcc$var$AsyncMultiSelectCell;
});
parcelRegister("bJ7zw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Wlli").then(()=>parcelRequire('7mtWh'));
});
parcelRegister("1vBWF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b785165cee754a9c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $cBLvr;
    const $b785165cee754a9c$var$LazyMultiUserCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("cBLvr"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/multi-user-cell/main.tsx"
    });
    const $b785165cee754a9c$var$AsyncMultiUserCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "multi-user-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b785165cee754a9c$var$LazyMultiUserCell, props));
    var $b785165cee754a9c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("cBLvr")).default), $b785165cee754a9c$var$AsyncMultiUserCell);
});
parcelRegister("cBLvr", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "MultiUserReadView", ()=>$5eb636095bdc41bd$export$f4784aff017e1cd6);
    $parcel$export(module.exports, "default", ()=>$5eb636095bdc41bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ujWmd;
    var $jnhNB;
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $5ILhZ;
    var $8CUq3;
    var $b5lmY;
    var $e0a4D;
    var $jRzRt;
    var $4R6GH;
    var $koVbs;
    var $lQE94;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $lI995;
    var $j6Uv1;
    var $f2d3w;
    var $l4l7M;
    const $5eb636095bdc41bd$var$MENU_MIN_WIDTH = 260;
    const $5eb636095bdc41bd$var$MAX_AVATAR = 5;
    const $5eb636095bdc41bd$var$POPUP_OFFSET = [
        0,
        1 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $5eb636095bdc41bd$var$POPUP_OFFSET_NEW = [
        0,
        6 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $5eb636095bdc41bd$export$f4784aff017e1cd6 = (0, $5uXOq.memo)(({ isEditable: isEditable, userOptions: userOptions })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, userOptions && userOptions.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: userOptions.map((user)=>({
                    name: user.name,
                    src: user.avatarUrl ?? ''
                })),
            maxCount: $5eb636095bdc41bd$var$MAX_AVATAR,
            size: "small"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).AvatarItem), {
            isUnassigned: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            src: "",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).DisplayName), null, formatMessage((0, (0, parcelRequire("f2d3w")).default).emptyMultiUser))));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$var$AvatarGroupContainer, {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.multi-user-cell.avatar-group-container"
        }, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$var$AvatarGroupContainerOld, {
            isEditable: isEditable,
            "data-testid": "business-list.ui.list-view.multi-user-cell.avatar-group-container"
        }, content);
    });
    const $5eb636095bdc41bd$var$MultiUserCell = (0, $5uXOq.memo)(({ initialValue: _initialValue, fieldKey: fieldKey, fieldType: fieldType, issueKey: issueKey, isEditable: isEditable, width: width, height: height, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, cellRef: cellRef })=>{
        const initialValue = (0, $5uXOq.useMemo)(()=>_initialValue?.map((0, (0, parcelRequire("l4l7M")).transformToUserOption)).filter(Boolean) ?? null, [
            _initialValue
        ]);
        const userPickerWidth = width > $5eb636095bdc41bd$var$MENU_MIN_WIDTH ? width : $5eb636095bdc41bd$var$MENU_MIN_WIDTH;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ value: savedValue, error: error }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue,
            onFailure: ()=>{
                setUserOptions(savedValue ?? null);
            }
        });
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [userOptions, setUserOptions] = (0, $5uXOq.useState)(savedValue);
        const wasEditMode = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(editMode);
        const hasValueUpdated = (0, $5uXOq.useRef)(false);
        if (!editMode && !(0, (0, parcelRequire("l4l7M")).isUserOptionsEqual)(savedValue, userOptions) && (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') || !wasEditMode)) setUserOptions(savedValue);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleChange = (0, $5uXOq.useCallback)((userPickerValue)=>{
            let newValue = null;
            if (userPickerValue) newValue = Array.isArray(userPickerValue) ? userPickerValue : null;
            setUserOptions(newValue);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) {
                hasValueUpdated.current = true;
                setTimeout(()=>{
                    hasValueUpdated.current = false;
                });
            }
        }, []);
        const handleCellClick = (0, $5uXOq.useCallback)(()=>{
            if (!editMode && isEditable) setEditMode(true);
        }, [
            editMode,
            isEditable,
            setEditMode
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            if ((0, (0, parcelRequire("l4l7M")).isUserOptionsEqual)(savedValue, userOptions)) return;
            saveValue(userOptions, null, createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            saveValue,
            savedValue,
            setEditMode,
            userOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && isSelected === false && editMode) saveAndClose();
        }, [
            isSelected,
            editMode,
            saveAndClose
        ]);
        const handleContentKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') {
                e.preventDefault();
                saveAndClose();
                wrapperRef?.current?.focus();
            }
        }, [
            saveAndClose,
            wrapperRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (wasEditMode && !editMode && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) saveAndClose();
        }, [
            editMode,
            saveAndClose,
            wasEditMode
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editMode && event.code === 'Enter') {
                if (!hasValueUpdated.current) {
                    setEditMode(false);
                    return false;
                }
                return true;
            }
            return false;
        }, [
            editMode,
            setEditMode
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDownNew
            }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onKeyDown
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (userOptions && userOptions.length > 0) {
                event.clipboardData.setData('text/plain', userOptions.map((user)=>user.name).join(', '));
                event.clipboardData.setData('text/html', userOptions.map((user)=>`<span account-id="${user.id}" avatar-url="${user.avatarUrl}">${user.name}</span>`).join(''));
                if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'multi-user');
                else if (event.type === 'cut') {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'multi-user');
                    setUserOptions([]);
                    saveValue([], null, createAnalyticsEvent({}));
                }
            }
        }, [
            userOptions,
            createAnalyticsEvent,
            saveValue
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            const clipHtml = event.clipboardData.getData('text/html');
            const clipText = event.clipboardData.getData('text/plain');
            if (clipHtml) {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(clipHtml, 'text/html');
                const pastedUserOptions = Array.from(htmlDoc.querySelectorAll('span')).map((span)=>{
                    const id = span.getAttribute('account-id');
                    const avatarUrl = span.getAttribute('avatar-url') ?? undefined;
                    const name = span.textContent;
                    if (id && name) return {
                        id: id,
                        name: name,
                        avatarUrl: avatarUrl
                    };
                    return undefined;
                }).filter((value)=>!!value);
                if (pastedUserOptions.length > 0) {
                    event.preventDefault();
                    setUserOptions(pastedUserOptions);
                    saveValue(pastedUserOptions, null, createAnalyticsEvent({}));
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'multi-user', {
                        format: 'html'
                    });
                    return;
                }
            }
            if (clipText) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'multi-user', {
                format: 'text'
            });
        }, [
            saveValue,
            createAnalyticsEvent
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("4R6GH")).fg)('jira_list_checkbox_convert_to_pressable') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: $5eb636095bdc41bd$var$popupTriggerStyles,
                testId: "business-list.ui.list-view.multi-user-cell.popup-trigger"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$export$f4784aff017e1cd6, {
                isEditable: isEditable,
                userOptions: userOptions
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ...triggerProps,
                "data-testid": "business-list.ui.list-view.multi-user-cell.popup-trigger"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$export$f4784aff017e1cd6, {
                isEditable: isEditable,
                userOptions: userOptions
            })), [
            isEditable,
            userOptions
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6Uv1")).default), {
                width: width,
                height: height,
                userPickerWidth: userPickerWidth,
                menuMinWidth: $5eb636095bdc41bd$var$MENU_MIN_WIDTH,
                placeholder: formatMessage((0, (0, parcelRequire("f2d3w")).default).placeholder),
                fieldId: fieldType,
                value: userOptions,
                onChange: handleChange,
                onKeyDown: handleContentKeyDown,
                autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
                    context: 'CustomMultiUserField',
                    ...issueKey && {
                        issueKey: issueKey
                    },
                    query: ''
                })}`
            }), [
            issueKey,
            fieldType,
            formatMessage,
            handleChange,
            handleContentKeyDown,
            height,
            userOptions,
            userPickerWidth,
            width
        ]);
        const content = isHovering || editMode || isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $5eb636095bdc41bd$var$POPUP_OFFSET_NEW : $5eb636095bdc41bd$var$POPUP_OFFSET,
            placement: "bottom-start",
            isOpen: editMode,
            onClose: saveAndClose,
            popupComponent: (0, (0, parcelRequire("jRzRt")).PopupComponent),
            autoFocus: false,
            trigger: popupTrigger,
            content: popupContent
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$export$f4784aff017e1cd6, {
            isEditable: isEditable,
            userOptions: userOptions
        });
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isEditable ? content : (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$export$f4784aff017e1cd6, {
            isEditable: isEditable,
            userOptions: userOptions
        }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("f2d3w")).default).errorTitle,
            description: (0, (0, parcelRequire("f2d3w")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.multi-user-cell.cell-container",
            hasPadding: false,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5eb636095bdc41bd$var$ContentWrapper, null, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onClick: handleCellClick,
            isFocused: isSelected && !editMode,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            "data-testid": "business-list.ui.list-view.multi-user-cell.cell-container"
        }, cellContent);
    });
    var $5eb636095bdc41bd$export$2e2bcd8739ae039 = $5eb636095bdc41bd$var$MultiUserCell;
    const $5eb636095bdc41bd$var$ContentWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5eb636095bdc41bd$var$wrapperStyles
            ]
        }, children);
    const $5eb636095bdc41bd$var$AvatarGroupContainer = ({ children: children, isEditable: isEditable, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: testId,
            alignItems: "center",
            xcss: [
                $5eb636095bdc41bd$var$avatarGroupContainerStyles,
                isEditable ? $5eb636095bdc41bd$var$avatarGroupContainerPointerStyles : $5eb636095bdc41bd$var$avatarGroupContainerDefaultStyles
            ]
        }, children);
    const $5eb636095bdc41bd$var$avatarGroupContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.100',
        width: '100%'
    });
    const $5eb636095bdc41bd$var$avatarGroupContainerDefaultStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'default'
    });
    const $5eb636095bdc41bd$var$avatarGroupContainerPointerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'pointer'
    });
    const $5eb636095bdc41bd$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $5eb636095bdc41bd$var$AvatarGroupContainerOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isEditable: isEditable, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19bvu2gc _1bsb1osq",
                __cmplp.isEditable ? "_80omtlke" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $5eb636095bdc41bd$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    });
});
parcelRegister("j6Uv1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d85d6e6b7e2c69b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $2d85d6e6b7e2c69b$var$UserPicker = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9xw5T")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/ui/list-view/multi-user-cell/async-user-picker/main.tsx"
    });
    var $2d85d6e6b7e2c69b$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "user-picker",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2d85d6e6b7e2c69b$var$UserPicker, props));
});
parcelRegister("9xw5T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cZS31").then(()=>parcelRequire('1mKwT'));
});
parcelRegister("f2d3w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d48a4df130d53300$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d48a4df130d53300$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyMultiUser: {
            "id": "business-list.list-view.multi-user-cell.empty-multi-user",
            "defaultMessage": "None"
        },
        placeholder: {
            "id": "business-list.list-view.multi-user-cell.placeholder",
            "defaultMessage": "Select User"
        },
        errorTitle: {
            "id": "business-list.list-view.multi-user-cell.error-title",
            "defaultMessage": "We couldn't save the user value."
        },
        errorMessage: {
            "id": "business-list.list-view.multi-user-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("l4l7M", function(module, exports) {
    $parcel$export(module.exports, "isUserOptionsEqual", ()=>$d63c6d7fdbb78e58$export$28c83218de06edb7);
    $parcel$export(module.exports, "transformToUserOption", ()=>$d63c6d7fdbb78e58$export$5924759166d7a225);
    var $ajpes = parcelRequire("ajpes");
    var $7qDUb = parcelRequire("7qDUb");
    const $d63c6d7fdbb78e58$var$sortUserOptions = (options)=>(0, ($parcel$interopDefault($7qDUb)))(options, [
            'id'
        ]);
    const $d63c6d7fdbb78e58$export$28c83218de06edb7 = (a, b)=>(0, ($parcel$interopDefault($ajpes)))(a, b) || (0, ($parcel$interopDefault($ajpes)))(a && $d63c6d7fdbb78e58$var$sortUserOptions(a), b && $d63c6d7fdbb78e58$var$sortUserOptions(b));
    const $d63c6d7fdbb78e58$export$5924759166d7a225 = (userData)=>{
        if (!userData) return null;
        return {
            avatarUrl: 'picture' in userData ? userData.picture : userData.avatarUrl,
            id: userData.accountId,
            name: userData.name ?? ''
        };
    };
});
parcelRegister("hTzzn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39a390424aeb4478$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $cg7wp;
    const $39a390424aeb4478$var$LazyNumberCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("cg7wp"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/number-cell/main.tsx"
    });
    const $39a390424aeb4478$var$AsyncNumberCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "number-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($39a390424aeb4478$var$LazyNumberCell, props));
    var $39a390424aeb4478$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("cg7wp")).default), $39a390424aeb4478$var$AsyncNumberCell);
});
parcelRegister("cg7wp", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$fc2bea2a18f2294b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $kY99m;
    var $b5lmY;
    var $e0a4D;
    var $4R6GH;
    var $lQE94;
    var $lI995;
    var $9Ludo;
    const $fc2bea2a18f2294b$var$getInputValue = ({ inputValue: inputValue, fieldValue: fieldValue })=>{
        if (typeof inputValue === 'undefined') return fieldValue;
        return typeof inputValue === 'string' && inputValue ? Number(inputValue) : null;
    };
    const $fc2bea2a18f2294b$var$NumberCell = (0, $5uXOq.memo)(({ issueKey: issueKey, fieldKey: fieldKey, fieldType: fieldType = '', isEditable: isEditable, fieldValue: fieldValue = null, fieldName: fieldName, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const [numValueOld, setNumValueOld] = (0, $5uXOq.useState)(fieldValue);
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const numValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $fc2bea2a18f2294b$var$getInputValue({
            inputValue: inputValue,
            fieldValue: fieldValue
        }) : numValueOld;
        const setNumValueNew = (value)=>onInputChange(value !== null ? String(value) : '');
        const setNumValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? setNumValueNew : setNumValueOld;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: fieldValue
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) {
                setEditMode(true);
                setNumValue(value);
            }
        }, [
            isEditable,
            editMode,
            setEditMode,
            setNumValue,
            value
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)((event)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) event.preventDefault();
            if (editMode) {
                setEditMode(false);
                numValue !== value && saveValue(numValue, null, createAnalyticsEvent({}));
            }
        }, [
            createAnalyticsEvent,
            editMode,
            numValue,
            saveValue,
            value,
            setEditMode
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)((event)=>{
            saveAndClose(event);
            wrapperRef?.current?.focus();
        }, [
            saveAndClose,
            wrapperRef
        ]);
        const handleChange = (0, $5uXOq.useCallback)((event)=>{
            resetError();
            const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
            setNumValue(typedValue);
        }, [
            resetError,
            setNumValue
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onKeyDown
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const onTextFieldKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') {
                e.preventDefault();
                setNumValue(value);
                wrapperRef?.current?.focus();
            }
        }, [
            setNumValue,
            value,
            wrapperRef
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editMode && event.code === 'Escape') setNumValue(value || null);
            return false;
        }, [
            editMode,
            setNumValue,
            value
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDownNew
            }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const numberCell = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? saveAndClose : handleSubmit
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fc2bea2a18f2294b$var$Textfield, {
            autoFocus: true,
            type: "number",
            onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : onTextFieldKeyDown,
            onBlur: saveAndClose,
            value: numValue === null ? '' : numValue,
            onChange: handleChange,
            step: "any"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($fc2bea2a18f2294b$var$NumberLabel, null, value), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("9Ludo")).default).errorTitle,
            description: (0, (0, parcelRequire("9Ludo")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).TextCellWrapper), {
            testId: "business-list.ui.list-view.number-cell.text-field-wrapper",
            isEditable: isEditable,
            ariaLabel: fieldName
        }, numberCell);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).TextFieldWrapper), {
            isSelected: isSelected,
            onClick: handleClick,
            isEditable: isEditable,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            "data-testid": "business-list.ui.list-view.number-cell.text-field-wrapper",
            "aria-label": fieldName
        }, numberCell);
    });
    var $fc2bea2a18f2294b$export$2e2bcd8739ae039 = $fc2bea2a18f2294b$var$NumberCell;
    const $fc2bea2a18f2294b$var$NumberLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gnusic _u5f3u2gc _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $fc2bea2a18f2294b$var$Textfield = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("kY99m")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19bvusic _n3elu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9Ludo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0448640e1edfd035$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0448640e1edfd035$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.number-cell.error-title",
            "defaultMessage": "We couldn't save the number value."
        },
        errorMessage: {
            "id": "business-list.list-view.number-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("eRBDs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acb1c4daaf17e66b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $acb1c4daaf17e66b$var$OriginalEstimateCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3gcAb")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/original-estimate-cell/main.tsx"
    });
    const $acb1c4daaf17e66b$var$AsyncOriginalEstimateCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "original-estimate-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($acb1c4daaf17e66b$var$OriginalEstimateCell, props));
    var $acb1c4daaf17e66b$export$2e2bcd8739ae039 = $acb1c4daaf17e66b$var$AsyncOriginalEstimateCell;
});
parcelRegister("3gcAb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("11uYS").then(()=>parcelRequire('23FiY'));
});
parcelRegister("1HY3B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae1740356bb7001c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $7JBoP;
    const $ae1740356bb7001c$var$LazyPriorityCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("7JBoP"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/priority-cell/main.tsx"
    });
    const $ae1740356bb7001c$var$AsyncPriorityCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "priority-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ae1740356bb7001c$var$LazyPriorityCell, props));
    var $ae1740356bb7001c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("7JBoP")).default), $ae1740356bb7001c$var$AsyncPriorityCell);
});
parcelRegister("7JBoP", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$9fc628cef9db7bc0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1I7E8;
    var $5ILhZ;
    var $8CUq3;
    var $3bDjY;
    var $b5lmY;
    var $e0a4D;
    var $8ad1n;
    var $jRzRt;
    var $gwIPs;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $lQE94;
    var $20vaL;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $lI995;
    var $3tdNZ;
    var $ATTEL;
    const $9fc628cef9db7bc0$var$POPUP_OFFSET = [
        -(0, (0, parcelRequire("gwIPs")).gridSize),
        2 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $9fc628cef9db7bc0$var$PriorityCellView = (0, $5uXOq.memo)(({ name: name, iconUrl: iconUrl, onClick: onClick, width: width, height: height, isHovering: isHovering })=>{
        if (name === null || name === undefined || iconUrl == null) return null;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("20vaL")).CardPriority), {
            uri: iconUrl,
            name: name
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentContainer), {
            onClick: onClick,
            width: width,
            height: height,
            "data-testid": "business-list.ui.list-view.priority-cell.priority-cell-view"
        }, isHovering ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$InnerContainer, null, content)) : content);
    });
    $9fc628cef9db7bc0$var$PriorityCellView.displayName = 'PriorityCellView';
    const $9fc628cef9db7bc0$var$PriorityCell = (0, $5uXOq.memo)(({ name: name, iconUrl: iconUrl, issueKey: issueKey, issueType: issueType, width: width, height: height, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, isEditable: isEditable, selectOptions: selectOptions, issueTypeId: issueTypeId, fieldName: fieldName, testId: testId, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, inputValue: inputValue, onInputChange: onInputChange })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [{ value: value, error: error }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: {
                name: name,
                iconUrl: iconUrl
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && isSelected === false && editMode) setEditMode(false);
        }, [
            editMode,
            isSelected,
            setEditMode
        ]);
        const cellViewProps = (0, $5uXOq.useMemo)(()=>({
                name: value && value.name,
                iconUrl: value && value.iconUrl,
                width: width,
                height: height
            }), [
            value,
            width,
            height
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (!editMode && isEditable) setEditMode(true);
        }, [
            editMode,
            isEditable,
            setEditMode
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleChange = (0, $5uXOq.useCallback)((option)=>{
            setEditMode(false);
            const selectedOption = selectOptions.find((fieldoption)=>fieldoption.name === option?.value);
            selectedOption && saveValue(selectedOption, null, createAnalyticsEvent({}));
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            setEditMode,
            selectOptions,
            saveValue,
            createAnalyticsEvent,
            wrapperRef
        ]);
        const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
        }, [
            setEditMode
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (value?.name) event.clipboardData.setData('text/plain', value.name);
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'priority');
            else if (event.type === 'cut') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'priority');
        }, [
            value,
            createAnalyticsEvent
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            const clipText = event.clipboardData.getData('text/plain');
            event.preventDefault();
            const option = selectOptions.find((fieldConfigOption)=>fieldConfigOption.name === clipText);
            if (option) {
                saveValue(option, null, createAnalyticsEvent({}));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'priority', {
                    valid: true
                });
            } else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'priority', {
                valid: false,
                error: 'Priority not found'
            });
        }, [
            selectOptions,
            saveValue,
            createAnalyticsEvent
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: $9fc628cef9db7bc0$var$popupTriggerStyles,
                testId: "business-list.ui.list-view.priority-cell.trigger"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$PriorityCellView, {
                ...cellViewProps,
                isHovering: isHovering
            })), [
            isHovering,
            cellViewProps
        ]);
        const prioritySelectOptions = (0, $5uXOq.useMemo)(()=>{
            let selectedPriorityOption = null;
            const priorityOptions = [];
            (selectOptions || []).forEach((option)=>{
                if (option.name == null) return;
                const priorityOption = {
                    label: option.name,
                    value: option.name
                };
                if (option.name === value?.name) selectedPriorityOption = priorityOption;
                else priorityOptions.push(priorityOption);
            });
            if (selectedPriorityOption != null) priorityOptions.unshift(selectedPriorityOption);
            return priorityOptions;
        }, [
            selectOptions,
            value?.name
        ]);
        const getFormatOptionLabel = (0, $5uXOq.useCallback)((option)=>{
            const selectedOption = selectOptions.find((fieldoption)=>fieldoption.name === option?.value);
            if (selectedOption?.iconUrl === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, option.label || '');
            return (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$OptionWrapper, {
                "data-testid": "business-list.ui.list-view.priority-cell.priority-option"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$ImgSpan, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$StyledImage, {
                src: selectedOption.iconUrl,
                alt: option.label,
                role: "none"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$FlexSpan, null, option.label));
        }, [
            selectOptions
        ]);
        const handleContentKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && e.key === 'Escape') {
                e.preventDefault();
                setEditMode(false);
                wrapperRef?.current?.focus();
            }
        }, [
            setEditMode,
            wrapperRef
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
                preferredWidth: width - 1,
                onKeyDown: handleContentKeyDown,
                "data-testid": "business-list.ui.list-view.priority-cell.popup-content"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ad1n")).default), {
                autoFocus: true,
                menuIsOpen: true,
                placeholder: formatMessage((0, (0, parcelRequire("3tdNZ")).default).placeholder),
                options: prioritySelectOptions,
                onChange: handleChange,
                value: (0, (0, parcelRequire("ATTEL")).transformValue)(value),
                formatOptionLabel: getFormatOptionLabel,
                isMulti: false,
                isInvalid: false,
                isClearable: false,
                tabSelectsValue: !!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav'),
                inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
                onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : undefined
            })), [
            formatMessage,
            getFormatOptionLabel,
            handleChange,
            handleContentKeyDown,
            inputValue,
            onInputChange,
            prioritySelectOptions,
            value,
            width
        ]);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: selectOptions.length ?? 0
            }), [
            selectOptions.length
        ]);
        const popup = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: editMode,
                placement: "bottom-start",
                onClose: handlePopupClose,
                trigger: popupTrigger,
                offset: $9fc628cef9db7bc0$var$POPUP_OFFSET,
                popupComponent: popupComponent,
                content: popupContent,
                autoFocus: false
            }), [
            editMode,
            handlePopupClose,
            popupTrigger,
            popupContent,
            popupComponent
        ]);
        const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode || isSelected ? popup : (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$PriorityCellView, {
                ...cellViewProps,
                isHovering: isHovering
            }), [
            isHovering,
            editMode,
            isSelected,
            popup,
            cellViewProps
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            if (!isEditable && e.key === 'Enter') e.preventDefault();
            !editMode && onKeyDown?.(e);
        }, [
            isEditable,
            editMode,
            onKeyDown
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement($9fc628cef9db7bc0$var$PriorityCellView, {
            ...cellViewProps,
            isHovering: isHovering
        }) : content, error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3tdNZ")).default).errorTitleIssueTermRefresh : (0, (0, parcelRequire("3tdNZ")).default).errorTitle,
            description: (0, (0, parcelRequire("3tdNZ")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: testId,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, cellContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellWrapper), {
            isFocused: editMode || isSelected,
            onClick: handleClick,
            isEditable: isEditable,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            tabIndex: 0,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            "data-testId": testId,
            ref: onWrapperRef
        }, cellContent);
    });
    var $9fc628cef9db7bc0$export$2e2bcd8739ae039 = $9fc628cef9db7bc0$var$PriorityCell;
    const $9fc628cef9db7bc0$var$InnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i1osq _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9fc628cef9db7bc0$var$FlexSpan = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $9fc628cef9db7bc0$var$ImgSpan = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _u5f3u2gc",
                __cmplp.className
            ])
        });
    });
    const $9fc628cef9db7bc0$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1l7b",
                __cmplp.className
            ])
        });
    });
    const $9fc628cef9db7bc0$var$StyledImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
    const $9fc628cef9db7bc0$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    });
});
parcelRegister("8ad1n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c414531c2730e4db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $c414531c2730e4db$var$Select = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fYjMK")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/fields/src/common/ui/lazy-select/main.tsx"
    });
    const $c414531c2730e4db$var$SelectComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "select",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c414531c2730e4db$var$Select, props));
    var $c414531c2730e4db$export$2e2bcd8739ae039 = $c414531c2730e4db$var$SelectComponent;
});
parcelRegister("fYjMK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("14Q1l").then(()=>parcelRequire('46JGW'));
});
parcelRegister("20vaL", function(module, exports) {
    $parcel$export(module.exports, "CardPriority", ()=>$cc5d64f9a1c4db88$export$92d93d4ee23c212c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $gwIPs;
    var $koVbs;
    var $jsE5o;
    const $cc5d64f9a1c4db88$export$92d93d4ee23c212c = (props)=>{
        const { name: name, uri: uri } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const priorityLevel = formatMessage((0, (0, parcelRequire("jsE5o")).default).priorityTooltip, {
            priorityLevel: name
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$var$Icon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: priorityLevel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$export$3e431a229df88919, {
            alt: priorityLevel,
            src: uri
        })));
    };
    var $cc5d64f9a1c4db88$export$2e2bcd8739ae039 = $cc5d64f9a1c4db88$export$92d93d4ee23c212c;
    const $cc5d64f9a1c4db88$var$iconSize = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $cc5d64f9a1c4db88$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $cc5d64f9a1c4db88$export$3e431a229df88919 = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz _s7n41ndm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jsE5o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd4384d9d4bf039b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd4384d9d4bf039b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        priorityTooltip: {
            "id": "platform-ui-card.common.priority.priority-tooltip",
            "defaultMessage": "{priorityLevel} priority"
        }
    });
});
parcelRegister("3tdNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d9c47e3a393eda9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8d9c47e3a393eda9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.priority-cell.error-title",
            "defaultMessage": "We couldn't save the issue priority."
        },
        errorMessage: {
            "id": "business-list.list-view.priority-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        placeholder: {
            "id": "business-list.list-view.priority-cell.placeholder",
            "defaultMessage": "Select Priority"
        },
        priorityLabel: {
            "id": "business-list.list-view.priority-cell.priority-label",
            "defaultMessage": "{priority} priority"
        },
        errorTitleIssueTermRefresh: {
            "id": "business-list.list-view.priority-cell.error-title-issue-term-refresh",
            "defaultMessage": "We couldn't save the work item priority "
        }
    });
});
parcelRegister("ATTEL", function(module, exports) {
    $parcel$export(module.exports, "transformValue", ()=>$f053920f1d5fc034$export$98c150630afe5417);
    const $f053920f1d5fc034$export$98c150630afe5417 = (value)=>{
        if (!value) return [];
        const valuesArray = Array.isArray(value) ? value : [
            value
        ];
        return valuesArray.map(({ name: name })=>({
                value: name,
                label: name
            }));
    };
});
parcelRegister("f9qBd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97d6faa0e27a5cf5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $97d6faa0e27a5cf5$var$RemoteIssueLinksCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jEJNt")), {
        moduleId: "./src/packages/business/list/src/ui/list-view/remote-issue-links-cell/main.tsx"
    });
    const $97d6faa0e27a5cf5$var$AsyncRemoteIssueLinksCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "remote-issue-links-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97d6faa0e27a5cf5$var$RemoteIssueLinksCell, props));
    var $97d6faa0e27a5cf5$export$2e2bcd8739ae039 = $97d6faa0e27a5cf5$var$AsyncRemoteIssueLinksCell;
});
parcelRegister("jEJNt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gTNzB")
    ]).then(()=>parcelRequire('dkDSI'));
});
parcelRegister("7xYOf", function(module, exports) {
    $parcel$export(module.exports, "SelectRowCheckbox", ()=>$93c39f1bb8ec9d60$export$ee74d161095f15ae);
    $parcel$export(module.exports, "SelectAllColumnCheckbox", ()=>$93c39f1bb8ec9d60$export$7ea5ed11456af816);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $iAbh9;
    var $deqCE;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $eTDjN;
    var $2GQqf;
    var $mk7k0;
    var $cNbiI;
    var $bW4OH;
    var $fC925;
    var $d61RR;
    const $93c39f1bb8ec9d60$export$ee74d161095f15ae = (0, $5uXOq.memo)(({ rowData: rowData, rowIndex: rowIndex, onKeyDown: onKeyDown, ...props })=>{
        const { issueId: rowIssueId, id: id } = rowData;
        const issueId = String(rowIssueId);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { selectIssues: selectIssues, unselectIssues: unselectIssues }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const [isRowSelected] = (0, (0, parcelRequire("mk7k0")).useIsIssueSelected)({
            issueId: issueId,
            parentIssueId: rowData.parentIssueId
        });
        const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, (0, parcelRequire("bW4OH")).useShiftKeySelection)();
        const bulkOpsFlow = (0, (0, parcelRequire("iAbh9")).useBulkOpsSessionContext)();
        const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
            const bulkOpsSessionID = bulkOpsFlow?.getFlowAttributes()?.bulkOpsSessionID ?? '';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectIssue', {
                isChecked: isChecked,
                rowIndex: rowIndex,
                shiftKeyPressed: shiftKeyPressed,
                bulkOpsSessionID: bulkOpsSessionID
            });
            if (isChecked) selectIssues({
                issues: [
                    issueId
                ],
                rowIndex: rowIndex
            });
            else unselectIssues({
                issues: [
                    issueId
                ],
                rowIndex: rowIndex
            });
            if (shiftKeyPressed) onShiftKeyBulkSelection({
                isChecked: isChecked,
                rowIndex: rowIndex
            });
        }, [
            createAnalyticsEvent,
            issueId,
            onShiftKeyBulkSelection,
            rowIndex,
            selectIssues,
            unselectIssues,
            bulkOpsFlow
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') {
                onClickCheckbox({
                    isChecked: !isRowSelected,
                    shiftKeyPressed: e.shiftKey
                });
                return;
            }
            if (e.shiftKey && e.key === 'Tab' || e.key === 'ArrowLeft' && typeof document !== 'undefined') {
                e.preventDefault();
                document.dispatchEvent(new CustomEvent(`${(0, (0, parcelRequire("eTDjN")).DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                    detail: {
                        issueId: issueId
                    }
                }));
                return;
            }
            onKeyDown?.(e);
        }, [
            isRowSelected,
            onClickCheckbox,
            onKeyDown,
            issueId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const focusOnCheckbox = (e)=>{
                if (String(e.detail.issueId) !== issueId) return;
                if (typeof document !== 'undefined') {
                    const checkbox = document.getElementById(`${(0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID)}-${issueId}`);
                    checkbox?.focus();
                }
            };
            typeof document !== 'undefined' && document.addEventListener(`${(0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener(`${(0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
            };
        }, [
            issueId
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_view_a11y_aria-required-children_table')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fC925")).DragHandle), {
            issueId: issueId,
            parentIssueId: rowData.parentIssueId,
            hierarchyLevel: rowData.issuetype?.level
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GQqf")).BulkSelectCheckbox), {
            id: `${(0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID)}-${issueId}`,
            onClick: onClickCheckbox,
            isChecked: isRowSelected,
            onKeyDown: handleKeyDown,
            isDisabled: id.startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)),
            label: formatMessage((0, (0, parcelRequire("d61RR")).default).selectIssue, {
                issueKey: rowData.key
            }),
            ...props
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($93c39f1bb8ec9d60$var$SingleSelectChecboxContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GQqf")).BulkSelectCheckbox), {
            id: `${(0, (0, parcelRequire("eTDjN")).BULK_SELECT_CHECKBOX_ID)}-${issueId}`,
            onClick: onClickCheckbox,
            isChecked: isRowSelected,
            onKeyDown: handleKeyDown,
            isDisabled: id.startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)),
            label: formatMessage((0, (0, parcelRequire("d61RR")).default).selectIssue, {
                issueKey: rowData.key
            }),
            ...props
        }));
    });
    const $93c39f1bb8ec9d60$export$7ea5ed11456af816 = (0, $5uXOq.memo)(({ showBulkEditOnboarding: showBulkEditOnboarding = false })=>{
        const { isIndeterminate: isIndeterminate, onClickCheckbox: onClickCheckbox, isChecked: isChecked } = (0, (0, parcelRequire("cNbiI")).useSelectAllCheckbox)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isPulseActive, setIsPulseActive] = (0, $5uXOq.useState)(!isChecked);
        const onClickSelectAllCheckbox = (0, $5uXOq.useCallback)((e)=>{
            onClickCheckbox(e);
            setIsPulseActive(false);
        }, [
            onClickCheckbox
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GQqf")).BulkSelectCheckbox), {
            onClick: onClickSelectAllCheckbox,
            isChecked: isChecked || isIndeterminate,
            isIndeterminate: isIndeterminate,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("d61RR")).default).selectAllIssueTermRefresh : (0, (0, parcelRequire("d61RR")).default).selectAll),
            hasPulse: showBulkEditOnboarding && isPulseActive && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_view_bulk_edit_changeboarding')
        });
    });
    const $93c39f1bb8ec9d60$var$SingleSelectChecboxContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u08jkm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cNbiI", function(module, exports) {
    $parcel$export(module.exports, "useSelectAllCheckbox", ()=>$90aa8202aedd922f$export$1f1cc91657e74385);
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $8e3Yw;
    var $9u99d;
    var $mk7k0;
    var $79pxk;
    var $4DEgE;
    const $90aa8202aedd922f$export$1f1cc91657e74385 = ()=>{
        const [{ hierarchyData: { data: data, isLoadingNextPage: isLoadingNextPage }, childrenItems: childrenItems }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectAllIssues: selectAllIssues, selectAll: selectAll, clearSelection: clearSelection, unselectAll: unselectAll }] = (0, (0, parcelRequire("mk7k0")).useBulkSelectionStore)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, (0, parcelRequire("79pxk")).useSelectCollapsedGroups)();
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const prevGroupByFieldId = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(groupByFieldId);
        const isGrouping = groupByFieldId != null;
        (0, $5uXOq.useEffect)(()=>{
            if (prevGroupByFieldId !== groupByFieldId) clearSelection();
        }, [
            clearSelection,
            groupByFieldId,
            prevGroupByFieldId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLoadingNextPage && areAllIssuesSelected) unselectAll();
        }, [
            areAllIssuesSelected,
            isLoadingNextPage,
            unselectAll
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (areAllIssuesSelected) {
                if (!isGrouping) unselectAll();
                else if (isGrouping && !fetchingGroups) unselectAll();
            }
        }, [
            JSON.stringify(childrenItems),
            data.length
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!areAllIssuesSelected && selectedIssues.size) {
                if (!isGrouping && selectedIssues.size >= data.length) {
                    const allIssues = (0, (0, parcelRequire("4DEgE")).getAllIssuesIds)({
                        data: data,
                        childrenItems: childrenItems
                    });
                    if (allIssues.length === selectedIssues.size) selectAll();
                } else if (isGrouping) {
                    for(let i = 0; i < data.length; i += 1){
                        const group = data[i];
                        const hasChildren = group.childSummary?.hasChildren;
                        if (hasChildren && childrenItems[group.issueId] === undefined) return;
                    }
                    const allIssues = (0, (0, parcelRequire("4DEgE")).getAllIssuesIds)({
                        data: data,
                        childrenItems: childrenItems
                    });
                    if (allIssues.length === selectedIssues.size) selectAll();
                }
            }
        }, [
            selectedIssues
        ]);
        const onClickCheckbox = (0, $5uXOq.useCallback)(({ isChecked: isChecked })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectAll', {
                isChecked: isChecked
            });
            if (isChecked) {
                const allIssues = (0, (0, parcelRequire("4DEgE")).getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (!allIssues.length && !isGrouping) return;
                selectAllIssues({
                    issues: allIssues
                });
                if (isGrouping) selectCollapsedGroups(data);
            } else clearSelection();
        }, [
            childrenItems,
            clearSelection,
            createAnalyticsEvent,
            data,
            isGrouping,
            selectAllIssues,
            selectCollapsedGroups
        ]);
        return {
            isChecked: areAllIssuesSelected,
            isIndeterminate: !areAllIssuesSelected && selectedIssues.size > 0,
            onClickCheckbox: onClickCheckbox
        };
    };
});
parcelRegister("fC925", function(module, exports) {
    $parcel$export(module.exports, "DragHandle", ()=>$1fb0b7c4540da9f7$export$a0c24614540b0efb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $fSR12;
    var $3bDjY;
    var $kRkJF;
    var $cLGgz;
    var $koVbs;
    var $7mPT9;
    var $8zOmE;
    var $2NMNM;
    var $aHcof;
    var $8e3Yw;
    var $9u99d;
    var $hb2SN;
    var $dkRGQ;
    var $5SOge;
    var $tx8ST;
    var $1hMwG;
    const $1fb0b7c4540da9f7$export$6857f01327f0ba6b = 'business-list.ui.list-view.select-row-cell.drag-handle.handle';
    const $1fb0b7c4540da9f7$export$d14865b4344e4f2d = 'business-list.ui.list-view.select-row-cell.drag-handle.drag-handle-container';
    function $1fb0b7c4540da9f7$export$a0c24614540b0efb({ issueId: issueId, parentIssueId: parentIssueId, hierarchyLevel: issueHierarchyLevel }) {
        const { disallowDragWithMessage: disallowDragWithMessage, isDragHandleHidden: isDragHandleHidden, dragHandleRef: dragHandleRef, onDrag: handleDrag, onDragTargetKeyDown: handleDragTargetKeyDown, onContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("aHcof")).useDraggableRow)();
        const [{ issuesMap: issuesMap, hierarchyData: hierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const currentIssues = parentIssueId ? issuesMap.get(parentIssueId)?.children : hierarchyData.data;
        const currentIssueIndex = currentIssues?.findIndex((issue)=>issue.issueId === Number(issueId));
        const { loading: loading } = (0, (0, parcelRequire("5SOge")).useRankIssue)();
        const { rankFirst: rankFirst, rankLast: rankLast, rankBefore: rankBefore, rankAfter: rankAfter } = (0, (0, parcelRequire("dkRGQ")).useRankIssueActions)(issueId, parentIssueId);
        const isOptimisticItem = (0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(issueId));
        const [groupByFieldId] = (0, (0, parcelRequire("8e3Yw")).useGroupBy)();
        const isGrouping = groupByFieldId != null;
        const { isFiltering: isFiltering } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'list'
        });
        const [{ hierarchyLevel: hierarchyLevel }] = (0, (0, parcelRequire("tx8ST")).useHierarchyLevel)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { openReparentModal: openReparentModal }] = (0, (0, parcelRequire("hb2SN")).useReparentModalStore)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleOpenReparentModal = (0, $5uXOq.useCallback)(()=>{
            openReparentModal(String(issueId));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'reparent clicked', 'dragHandleDropdown');
        }, [
            createAnalyticsEvent,
            issueId,
            openReparentModal
        ]);
        if (disallowDragWithMessage != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: disallowDragWithMessage
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$DragHandleContainer, {
            onKeyDown: handleContainerKeyDown,
            "data-testid": $1fb0b7c4540da9f7$export$d14865b4344e4f2d
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fSR12")).DragHandleButtonSmall), {
            ref: dragHandleRef,
            "data-drag-handle": true,
            label: formatMessage((0, (0, parcelRequire("1hMwG")).default).reorder),
            "aria-disabled": "true",
            onKeyDown: handleDragTargetKeyDown,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_80om13gf _1e0c1xpt"
            ]),
            style: {
                "--_9h4ns6": (0, (0, parcelRequire("lD23V")).default)(isDragHandleHidden ? 'none' : 'flex')
            }
        })));
        if (isOptimisticItem) return (0, ($parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$Handle, {
            disallowDrag: true,
            "data-drag-handle": true,
            "data-testid": $1fb0b7c4540da9f7$export$6857f01327f0ba6b
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1fb0b7c4540da9f7$var$DragHandleContainer, {
            onKeyDown: handleContainerKeyDown
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fSR12")).DragHandleButtonSmall), {
                    ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(dragHandleRef, triggerRef),
                    "data-drag-handle": true,
                    label: formatMessage((0, (0, parcelRequire("1hMwG")).default).reorder),
                    ...triggerProps,
                    onDrag: handleDrag,
                    onKeyDown: handleDragTargetKeyDown,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_1e0c1xpt"
                    ]),
                    style: {
                        "--_9h4ns6": (0, (0, parcelRequire("lD23V")).default)(isDragHandleHidden ? 'none' : 'flex')
                    }
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, !loading && currentIssueIndex != null && currentIssueIndex > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: rankFirst
        }, formatMessage((0, (0, parcelRequire("1hMwG")).default).movetoTop)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: rankBefore
        }, formatMessage((0, (0, parcelRequire("1hMwG")).default).moveUp))), !loading && currentIssues && currentIssueIndex !== currentIssues.length - 1 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: rankAfter
        }, formatMessage((0, (0, parcelRequire("1hMwG")).default).moveDown)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: rankLast
        }, formatMessage((0, (0, parcelRequire("1hMwG")).default).moveToBottom))), !loading && !isFiltering && !isGrouping && issueHierarchyLevel !== hierarchyLevel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: handleOpenReparentModal
        }, parentIssueId != null ? formatMessage((0, (0, parcelRequire("1hMwG")).default).changeParent) : formatMessage((0, (0, parcelRequire("1hMwG")).default).addParent)))));
    }
    const $1fb0b7c4540da9f7$var$DragHandleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _19bvv77o _1ltvu2gc _154ize3t _94n5ze3t _1e0c1txw _4cvr1h6o _is061rc1 _1mp4gktf _cfu11txw _24gj1h6o",
                __cmplp.className
            ])
        });
    });
    const $1fb0b7c4540da9f7$var$Handle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { disallowDrag: disallowDrag, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw _kqswstnw _1ltvv77o _154ize3t _94n5ze3t _1kt9mrja _is061rc1 _1mp4gktf _cfu11txw _24gj1h6o _kfgt1osq _19o61h6o",
                __cmplp.disallowDrag ? "_wxb013gf" : "_wxb01qgj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fSR12", function(module, exports) {
    $parcel$export(module.exports, "DragHandleButtonSmall", ()=>$9e0d22c00c6251eb$export$81bd0a2e6f324029);
    var $5uXOq = parcelRequire("5uXOq");
    var $dQO6P;
    var $9YxlF;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $1R0ak;
    const $9e0d22c00c6251eb$var$iconSmallStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginInline: 'space.negative.050'
    });
    const $9e0d22c00c6251eb$var$iconSmallStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex'
    });
    const $9e0d22c00c6251eb$export$81bd0a2e6f324029 = (0, $5uXOq.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R0ak")).DragHandleButtonBase), {
            ref: ref,
            ...buttonProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') || (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? $9e0d22c00c6251eb$var$iconSmallStylesNew : $9e0d22c00c6251eb$var$iconSmallStyles
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dQO6P"))))), {
            color: "currentColor",
            label: label
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9YxlF"))))), {
            color: "currentColor",
            label: label,
            LEGACY_size: "small"
        })));
    });
});
parcelRegister("dQO6P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a157005563d95297$var$_react = $a157005563d95297$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a157005563d95297$var$_UNSAFE_baseNew = $a157005563d95297$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a157005563d95297$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a157005563d95297$var$DragHandleIcon = (props)=>$a157005563d95297$var$_react.default.createElement($a157005563d95297$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M5 2.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5 6a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 5 6m4.5 0A1.25 1.25 0 1 1 7 6a1.25 1.25 0 0 1 2.5 0M5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"/>`,
            type: 'utility'
        }, props));
    $a157005563d95297$var$DragHandleIcon.displayName = 'DragHandleIcon';
    var $a157005563d95297$var$_default = module.exports.default = $a157005563d95297$var$DragHandleIcon;
});
parcelRegister("9YxlF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $743395f900b621b5$var$_react = $743395f900b621b5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $743395f900b621b5$var$_dragHandle = $743395f900b621b5$var$_interopRequireDefault((parcelRequire("dQO6P")));
    var $743395f900b621b5$var$_dragHandler = $743395f900b621b5$var$_interopRequireDefault((parcelRequire("78tet")));
    function $743395f900b621b5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $743395f900b621b5$var$DragHandleIcon = (props)=>$743395f900b621b5$var$_react.default.createElement($743395f900b621b5$var$_dragHandle.default, Object.assign({
            LEGACY_fallbackIcon: $743395f900b621b5$var$_dragHandler.default
        }, props));
    $743395f900b621b5$var$DragHandleIcon.Name = 'DragHandleIconMigration';
    var $743395f900b621b5$var$_default = module.exports.default = $743395f900b621b5$var$DragHandleIcon;
});
parcelRegister("78tet", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $531ff4bbcd008815$var$_dragHandle = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("idRxN")));
    function $531ff4bbcd008815$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>$531ff4bbcd008815$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
        }, props, {
            newIcon: $531ff4bbcd008815$var$_dragHandle.default
        }));
    $531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
    var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;
});
parcelRegister("idRxN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d442f9a78d3217d7$var$_react = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d442f9a78d3217d7$var$_UNSAFE_baseNew = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d442f9a78d3217d7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d442f9a78d3217d7$var$DragHandleIcon = (props)=>$d442f9a78d3217d7$var$_react.default.createElement($d442f9a78d3217d7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
        }, props));
    $d442f9a78d3217d7$var$DragHandleIcon.displayName = 'DragHandleIcon';
    var $d442f9a78d3217d7$var$_default = module.exports.default = $d442f9a78d3217d7$var$DragHandleIcon;
});
parcelRegister("1R0ak", function(module, exports) {
    $parcel$export(module.exports, "DragHandleButtonBase", ()=>$34ba86d040d49b37$export$c099c65cfbd84d0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    function $34ba86d040d49b37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $34ba86d040d49b37$var$buttonStyles = {
        name: "1waumgt",
        styles: "color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius-100, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
    };
    const $34ba86d040d49b37$var$buttonAppearanceStyles = {
        default: {
            name: "1dab6g1",
            styles: "background-color:var(--ds-background-neutral, #091E420F);&:hover{background-color:var(--ds-background-neutral-hovered, #091E4224);}&:active{background-color:var(--ds-background-neutral-pressed, #091E424F);}"
        },
        subtle: {
            name: "1hy78sx",
            styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
        },
        selected: {
            name: "1pi0h5q",
            styles: "background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4)"
        }
    };
    const $34ba86d040d49b37$export$c099c65cfbd84d0a = (0, $5uXOq.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: type = 'button', ...buttonProps }, ref) {
        const appearance = isSelected ? 'selected' : appearanceProp;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ref: ref,
            css: [
                $34ba86d040d49b37$var$buttonStyles,
                $34ba86d040d49b37$var$buttonAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            type: type,
            ...buttonProps
        }, children));
    });
});
parcelRegister("aHcof", function(module, exports) {
    $parcel$export(module.exports, "DraggableRowContext", ()=>$8686e476f30c2781$export$58601e96edd1b5b4);
    $parcel$export(module.exports, "useDraggableRow", ()=>$8686e476f30c2781$export$a878804271d34ba8);
    var $5uXOq = parcelRequire("5uXOq");
    const $8686e476f30c2781$export$58601e96edd1b5b4 = (0, $5uXOq.createContext)(null);
    function $8686e476f30c2781$export$a878804271d34ba8() {
        const context = (0, $5uXOq.useContext)($8686e476f30c2781$export$58601e96edd1b5b4);
        if (context == null) throw new Error('Unable to retrieve DraggableRow context');
        return context;
    }
});
parcelRegister("dkRGQ", function(module, exports) {
    $parcel$export(module.exports, "useRankIssueActions", ()=>$9ee421b5cac4ecb7$export$87538f9c3aec3a67);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $jDUax;
    var $koeKL;
    var $9u99d;
    var $eg2To;
    var $5SOge;
    function $9ee421b5cac4ecb7$export$87538f9c3aec3a67(issueId, parentIssueId) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const input = (0, (0, parcelRequire("eg2To")).useIssuesInput)({
            groupIssueId: (0, (0, parcelRequire("jDUax")).isGroupItem)(parentIssueId) ? parentIssueId : undefined,
            parentIssueId: !(0, (0, parcelRequire("jDUax")).isGroupItem)(parentIssueId) ? parentIssueId : undefined
        });
        const variables = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("egmQO")).getVariables)(input),
                cloudId: cloudId
            }), [
            cloudId,
            input
        ]);
        const [{ issuesMap: issuesMap, hierarchyData: hierarchyData }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const { rankIssue: rankIssue } = (0, (0, parcelRequire("5SOge")).useRankIssue)();
        const currentIssues = parentIssueId ? issuesMap.get(parentIssueId)?.children : hierarchyData.data;
        const currentIssueIndex = currentIssues?.findIndex((issue)=>issue.issueId === Number(issueId));
        const rankItem = (0, $5uXOq.useCallback)(({ oldIndex: oldIndex, newIndex: newIndex })=>{
            if (oldIndex == null || newIndex == null) return;
            if (currentIssues == null || currentIssueIndex == null || currentIssueIndex === -1) return;
            rankIssue({
                newIndex: newIndex,
                oldIndex: oldIndex,
                issues: currentIssues,
                variables: variables
            });
        }, [
            currentIssueIndex,
            currentIssues,
            rankIssue,
            variables
        ]);
        const rankAfter = (0, $5uXOq.useCallback)(()=>{
            rankItem({
                oldIndex: currentIssueIndex,
                ...currentIssueIndex != null ? {
                    newIndex: currentIssueIndex + 1
                } : {}
            });
        }, [
            rankItem,
            currentIssueIndex
        ]);
        const rankBefore = (0, $5uXOq.useCallback)(()=>{
            rankItem({
                oldIndex: currentIssueIndex,
                ...currentIssueIndex != null ? {
                    newIndex: currentIssueIndex - 1
                } : {}
            });
        }, [
            rankItem,
            currentIssueIndex
        ]);
        const rankFirst = (0, $5uXOq.useCallback)(()=>{
            rankItem({
                oldIndex: currentIssueIndex,
                newIndex: 0
            });
        }, [
            rankItem,
            currentIssueIndex
        ]);
        const rankLast = (0, $5uXOq.useCallback)(()=>{
            rankItem({
                oldIndex: currentIssueIndex,
                ...currentIssues != null ? {
                    newIndex: currentIssues?.length - 1
                } : {}
            });
        }, [
            rankItem,
            currentIssueIndex,
            currentIssues
        ]);
        return {
            rankFirst: rankFirst,
            rankLast: rankLast,
            rankBefore: rankBefore,
            rankAfter: rankAfter
        };
    }
});
parcelRegister("5SOge", function(module, exports) {
    $parcel$export(module.exports, "useRankIssue", ()=>$77a89c01dc5b1159$export$dbe3d15eebe7e64c);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $cm8b5;
    var $2UUq6;
    var $jDUax;
    var $krCqe;
    var $jcw0u;
    var $6s1PB;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $61h55;
    var $aQbWi;
    var $eg2To;
    var $1vW2U;
    const $77a89c01dc5b1159$export$2d7a379894b4651b = ()=>(error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'rankIssuelistViewRestQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to rank issue in list view via Rest'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
    const $77a89c01dc5b1159$export$dbe3d15eebe7e64c = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const [{ sortBy: sortBy }] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const isBlockedBySorting = sortBy !== undefined && sortBy !== null;
        const [{ rankParentIssueId: rankParentIssueId }] = (0, (0, parcelRequire("aQbWi")).useRankParent)();
        const input = (0, (0, parcelRequire("eg2To")).useIssuesInput)({
            groupIssueId: (0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
            parentIssueId: !(0, (0, parcelRequire("jDUax")).isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("1vW2U")).RANK_ISSUE_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("1vW2U")).RANK_ISSUE_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("1vW2U")).RANK_ISSUE_EXPERIENCE));
        const onError = (0, $5uXOq.useMemo)(()=>$77a89c01dc5b1159$export$2d7a379894b4651b(), []);
        const { loading: loading, rankListViewIssue: rankListViewIssue } = (0, (0, parcelRequire("krCqe")).useRankIssue)({
            query: (0, (0, parcelRequire("61h55")).LIST_VIEW_QUERY),
            variables: {
                ...(0, (0, parcelRequire("egmQO")).getVariables)(input),
                cloudId: cloudId
            },
            onError: (error)=>{
                onError(error);
                if (error.statusCode === 403) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1vW2U")).RANK_ITEM_FAIL_403_FLAG_NEW) : (0, (0, parcelRequire("1vW2U")).RANK_ITEM_FAIL_403_FLAG));
                else if (error.statusCode === 404) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1vW2U")).RANK_ITEM_FAIL_404_FLAG_NEW) : (0, (0, parcelRequire("1vW2U")).RANK_ITEM_FAIL_404_FLAG));
                else {
                    showFlag((0, (0, parcelRequire("1vW2U")).RANK_ITEM_FAIL_GENERIC_FLAG));
                    if (error.statusCode >= 500) {
                        markExperienceFailed('list issue rank failed', error);
                        return;
                    }
                }
                markExperienceSuccess();
            },
            onSuccess: ()=>{
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issue update', {
                    fieldKey: 'rank'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'listRankIssue success');
            },
            onStart: ()=>{
                startExperience();
            }
        });
        const rankIssue = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: issueToRank, variables: variables, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
            const params = {
                oldIndex: oldIndex,
                newIndex: newIndex,
                issues: issues,
                issueToRank: issueToRank,
                variables: variables,
                skipUpdateCache: skipUpdateCache,
                instruction: instruction,
                relativeIssueOverride: relativeIssueOverride
            };
            rankListViewIssue(params);
        };
        return {
            rankIssue: rankIssue,
            isBlockedBySorting: isBlockedBySorting,
            loading: loading
        };
    };
});
parcelRegister("krCqe", function(module, exports) {
    $parcel$export(module.exports, "useRankIssue", ()=>$25d51d58b2db8192$export$dbe3d15eebe7e64c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dqDis;
    var $eusud;
    var $8zOmE;
    var $2NMNM;
    var $hlKA4;
    var $eVIe2;
    const $25d51d58b2db8192$var$performRestCall = (performRequest, url, issueId, relativeIssueId, setLoading, onError, onSuccess)=>{
        performRequest(url, {
            body: JSON.stringify({
                issueId: Number(issueId),
                relativeIssueId: Number(relativeIssueId)
            })
        }).then(()=>{
            setLoading(false);
            onSuccess && onSuccess();
        }).catch((error)=>{
            setLoading(false);
            onError && onError(error);
        });
    };
    const $25d51d58b2db8192$export$dbe3d15eebe7e64c = ({ query: query, variables: variables, onError: onError, onSuccess: onSuccess, onStart: onStart })=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const { getCachedIssueById: getCachedIssueById, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const queryRef = (0, $5uXOq.useRef)(query);
        queryRef.current = query;
        const variablesRef = (0, $5uXOq.useRef)(variables);
        variablesRef.current = variables;
        const rank = (0, $5uXOq.useCallback)(({ issueId: issueId, relativeIssue: relativeIssue, rankCall: rankCall, skipUpdateCache: skipUpdateCache, variablesInput: variablesInput })=>{
            setLoading(true);
            onStart && onStart();
            const cacheVariables = variablesInput ?? variablesRef.current;
            const issueToRank = getCachedIssueById({
                issueId: issueId,
                query: queryRef.current,
                variables: cacheVariables
            });
            const relativeIssueRank = relativeIssue.rank;
            if (issueToRank && relativeIssueRank) {
                const optimisticRank = rankCall === 'rankBefore' ? (0, (0, parcelRequire("dqDis")).getPreviousRank)(relativeIssueRank) : (0, (0, parcelRequire("dqDis")).getNextRank)(relativeIssueRank);
                if (!skipUpdateCache) updateItemsInCache({
                    query: queryRef.current,
                    variables: cacheVariables,
                    issueIds: [
                        issueToRank?.issueId
                    ],
                    updateItem: ()=>(0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(issueToRank, optimisticRank)
                });
                $25d51d58b2db8192$var$performRestCall((0, (0, parcelRequire("eusud")).performPutRequest), `/rest/board-api/1/rank/${rankCall}`, Number(issueToRank.issueId), Number(relativeIssue.issueId), setLoading, (error)=>{
                    onError(error);
                    updateItemsInCache({
                        query: query,
                        variables: cacheVariables,
                        issueIds: [
                            issueToRank?.issueId
                        ],
                        updateItem: (existingIssue)=>({
                                ...existingIssue,
                                fields: existingIssue.fields?.filter((field)=>field?.aliasFieldId !== 'rank').concat(issueToRank.fields?.find((field)=>field?.aliasFieldId === 'rank'))
                            })
                    });
                }, ()=>{
                    onSuccess && onSuccess();
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRank succeeded');
                });
            } else setLoading(false);
        }, [
            createAnalyticsEvent,
            getCachedIssueById,
            onError,
            onStart,
            onSuccess,
            query,
            updateItemsInCache
        ]);
        const rankListViewIssue = (0, $5uXOq.useCallback)(({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: prevIssueToRank, variables: variablesInput, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
            const rankingIssue = prevIssueToRank ?? issues[oldIndex];
            const { rankCall: rankCall, relativeIssue: relativeIssue } = (0, (0, parcelRequire("eVIe2")).getListViewRelativeIssueInfo)({
                newIndex: newIndex,
                oldIndex: oldIndex,
                issues: issues,
                instruction: instruction,
                relativeIssueOverride: relativeIssueOverride
            });
            if (relativeIssue) rank({
                relativeIssue: relativeIssue,
                issueId: rankingIssue.issueId,
                rankCall: rankCall,
                variablesInput: variablesInput,
                skipUpdateCache: skipUpdateCache
            });
        }, [
            rank
        ]);
        return {
            loading: loading,
            rank: rank,
            rankListViewIssue: rankListViewIssue
        };
    };
});
parcelRegister("1vW2U", function(module, exports) {
    $parcel$export(module.exports, "RANK_ISSUE_EXPERIENCE", ()=>$3cf701d1c6798b87$export$1cc6cf3582688fdd);
    $parcel$export(module.exports, "RANK_ITEM_FAIL_GENERIC_FLAG", ()=>$3cf701d1c6798b87$export$8d4e704b1891708c);
    $parcel$export(module.exports, "RANK_ITEM_FAIL_404_FLAG", ()=>$3cf701d1c6798b87$export$3d4660e65f55cbb9);
    $parcel$export(module.exports, "RANK_ITEM_FAIL_404_FLAG_NEW", ()=>$3cf701d1c6798b87$export$c1cc3a4bbf199816);
    $parcel$export(module.exports, "RANK_ITEM_FAIL_403_FLAG", ()=>$3cf701d1c6798b87$export$8e1bffd4c5401c9e);
    $parcel$export(module.exports, "RANK_ITEM_FAIL_403_FLAG_NEW", ()=>$3cf701d1c6798b87$export$abad146ab2dd0701);
    var $6s1PB;
    var $e5wyW;
    var $79389;
    const $3cf701d1c6798b87$var$PACKAGE_NAME = 'jiraBusinessList';
    const $3cf701d1c6798b87$var$descriptionSelector = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>(0, (0, parcelRequire("79389")).default).rankItem404ErrorDescriptionIssueTermRefresh, ()=>(0, (0, parcelRequire("79389")).default).rankItem404ErrorDescription);
    const $3cf701d1c6798b87$export$1cc6cf3582688fdd = {
        experience: 'rankIssue',
        packageName: $3cf701d1c6798b87$var$PACKAGE_NAME,
        teamName: 'keystone'
    };
    const $3cf701d1c6798b87$export$8d4e704b1891708c = {
        type: 'error',
        title: (0, (0, parcelRequire("79389")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("79389")).default).rankItemErrorDescription
    };
    const $3cf701d1c6798b87$export$3d4660e65f55cbb9 = {
        type: 'error',
        title: (0, (0, parcelRequire("79389")).default).rankItemErrorTitle,
        description: $3cf701d1c6798b87$var$descriptionSelector()
    };
    const $3cf701d1c6798b87$export$c1cc3a4bbf199816 = {
        type: 'error',
        title: (0, (0, parcelRequire("79389")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("79389")).default).rankItem404ErrorDescriptionIssueTermRefresh
    };
    const $3cf701d1c6798b87$export$8e1bffd4c5401c9e = {
        type: 'error',
        title: (0, (0, parcelRequire("79389")).default).rankItemErrorTitle,
        description: $3cf701d1c6798b87$var$descriptionSelector()
    };
    const $3cf701d1c6798b87$export$abad146ab2dd0701 = {
        type: 'error',
        title: (0, (0, parcelRequire("79389")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("79389")).default).rankItem403ErrorDescriptionIssueTermRefresh
    };
});
parcelRegister("79389", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98ca5710e85e7360$export$2e2bcd8739ae039);
    var $7VHMR;
    var $98ca5710e85e7360$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rankItemErrorTitle: {
            "id": "business-list.controllers.use-rank-issue.rank-item-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        rankItemErrorDescription: {
            "id": "business-list.controllers.use-rank-issue.rank-item-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        rankItem403ErrorDescription: {
            "id": "business-list.controllers.use-rank-issue.rank-item-403-error-description",
            "defaultMessage": "You don\u2019t have permission to move this issue. Contact a project admin."
        },
        rankItem404ErrorDescription: {
            "id": "business-list.controllers.use-rank-issue.rank-item-404-error-description",
            "defaultMessage": "We\u2019re having trouble moving this issue. To continue, refresh the page."
        },
        rankItem403ErrorDescriptionIssueTermRefresh: {
            "id": "business-list.controllers.use-rank-issue.rank-item-403-error-description-issue-term-refresh",
            "defaultMessage": "You don\u2019t have permission to move this work item. Contact your admin."
        },
        rankItem404ErrorDescriptionIssueTermRefresh: {
            "id": "business-list.controllers.use-rank-issue.rank-item-404-error-description-issue-term-refresh",
            "defaultMessage": "We\u2019re having trouble moving this work item. To continue, refresh the page."
        }
    });
});
parcelRegister("1hMwG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a7c463c0e640081$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8a7c463c0e640081$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moveUp: {
            "id": "business-list.list-view.select-row-cell.drag-handle.move-up",
            "defaultMessage": "Move issue up"
        },
        movetoTop: {
            "id": "business-list.list-view.select-row-cell.drag-handle.moveto-top",
            "defaultMessage": "Move issue to the top"
        },
        moveDown: {
            "id": "business-list.list-view.select-row-cell.drag-handle.move-down",
            "defaultMessage": "Move issue down"
        },
        moveToBottom: {
            "id": "business-list.list-view.select-row-cell.drag-handle.move-to-bottom",
            "defaultMessage": "Move issue to the bottom"
        },
        addParent: {
            "id": "business-list.list-view.select-row-cell.drag-handle.add-parent",
            "defaultMessage": "Add parent"
        },
        changeParent: {
            "id": "business-list.list-view.select-row-cell.drag-handle.change-parent",
            "defaultMessage": "Change parent"
        },
        reorder: {
            "id": "business-list.list-view.select-row-cell.drag-handle.reorder",
            "defaultMessage": "Reorder"
        }
    });
});
parcelRegister("d61RR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3adb82dd2da115ea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3adb82dd2da115ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectAll: {
            "id": "business-list.list-view.select-row-cell.select-all",
            "defaultMessage": "Select all issues"
        },
        selectIssue: {
            "id": "business-list.list-view.select-row-cell.select-issue",
            "defaultMessage": "Select {issueKey}"
        },
        selectAllIssueTermRefresh: {
            "id": "business-list.list-view.select-row-cell.select-all-issue-term-refresh",
            "defaultMessage": "Select all work items"
        }
    });
});
parcelRegister("bRFLq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8cccca969844fc83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $isAZv;
    const $8cccca969844fc83$var$LazySingleSelectCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("isAZv"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/single-select-cell/main.tsx"
    });
    const $8cccca969844fc83$var$AsyncSingleSelectCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "single-select-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8cccca969844fc83$var$LazySingleSelectCell, props));
    var $8cccca969844fc83$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("isAZv")).default), $8cccca969844fc83$var$AsyncSingleSelectCell);
});
parcelRegister("isAZv", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$cce8f13d0c36da0f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $5ILhZ;
    var $8CUq3;
    var $d9xxV;
    var $3bDjY;
    var $b5lmY;
    var $e0a4D;
    var $8ad1n;
    var $jRzRt;
    var $k2xO1;
    var $4R6GH;
    var $koVbs;
    var $lQE94;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $eTDjN;
    var $lI995;
    var $92WqQ;
    var $3KPLw;
    const $cce8f13d0c36da0f$var$transformValueWithOptionId = (values)=>{
        if (!values) return [];
        const valuesArray = Array.isArray(values) ? values : [
            values
        ];
        return valuesArray.map(({ optionId: optionId, value: value })=>({
                value: value,
                label: value,
                optionId: optionId
            }));
    };
    const $cce8f13d0c36da0f$var$getValue = (values)=>{
        if (Array.isArray(values)) return values[0]?.value ?? '';
        return values?.value ?? '';
    };
    const $cce8f13d0c36da0f$var$transformLabels = (values)=>values.map(({ value: value })=>value).join(', ');
    const $cce8f13d0c36da0f$var$POPUP_OFFSET = (0, (0, parcelRequire("eTDjN")).LIST_FIELD_POPUP_OFFSET);
    const $cce8f13d0c36da0f$var$POPUP_OFFSET_NEW = [
        0,
        -(0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT) - 1
    ];
    const $cce8f13d0c36da0f$var$SingleSelectCell = (0, $5uXOq.memo)(({ issueKey: issueKey, fieldValue: fieldValue = null, width: width, fieldKey: fieldKey, fieldName: fieldName, isEditable: isEditable, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, inputValue: inputValue, onInputChange: onInputChange, cellRef: cellRef })=>{
        const { latestFieldOptions: latestFieldOptions, getLatestFieldValue: getLatestFieldValue } = (0, (0, parcelRequire("92WqQ")).useCellOptions)({
            fieldId: fieldKey
        });
        const latestFieldValue = getLatestFieldValue(fieldValue);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [selectValue, setSelectValue] = (0, $5uXOq.useState)($cce8f13d0c36da0f$var$transformValueWithOptionId(latestFieldValue));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [prevFieldValue, setPrevFieldValue] = (0, $5uXOq.useState)(fieldValue);
        const clearOnBlur = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(fieldValue, prevFieldValue)) {
                setSelectValue($cce8f13d0c36da0f$var$transformValueWithOptionId(latestFieldValue));
                setPrevFieldValue(fieldValue);
            }
        }, [
            fieldValue,
            latestFieldValue,
            prevFieldValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const latestSelectValue = $cce8f13d0c36da0f$var$transformValueWithOptionId(getLatestFieldValue(selectValue));
            if (!(0, ($parcel$interopDefault($ajpes)))(selectValue, latestSelectValue)) setSelectValue(latestSelectValue);
        }, [
            getLatestFieldValue,
            selectValue
        ]);
        const [{ value: editValue, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: $cce8f13d0c36da0f$var$transformValueWithOptionId(fieldValue),
            onSuccess: (v)=>setSelectValue($cce8f13d0c36da0f$var$transformValueWithOptionId(v)),
            onFailure: ()=>setSelectValue($cce8f13d0c36da0f$var$transformValueWithOptionId(editValue))
        });
        (0, $5uXOq.useEffect)(()=>{
            if ($cce8f13d0c36da0f$var$getValue(selectValue) !== $cce8f13d0c36da0f$var$getValue(editValue) && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) setSelectValue($cce8f13d0c36da0f$var$transformValueWithOptionId(editValue));
        }, [
            editValue,
            selectValue
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) saveValue(selectValue[0] ?? null, null, createAnalyticsEvent({}));
        }, [
            setEditMode,
            saveValue,
            selectValue,
            createAnalyticsEvent
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) setEditMode(true);
        }, [
            editMode,
            isEditable,
            setEditMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && isSelected === false && editMode) saveAndClose();
        }, [
            editMode,
            isSelected,
            saveAndClose
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                wrapperRef?.current?.focus();
            } else if (!editMode) setEditMode(true);
        }, [
            editMode,
            setEditMode,
            wrapperRef
        ]);
        const handleSelectChange = (0, $5uXOq.useCallback)((newValue)=>{
            resetError();
            const selection = Array.isArray(newValue) ? newValue[0] : newValue;
            setSelectValue(selection ? [
                selection
            ] : []);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) {
                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) saveValue(selection, null, createAnalyticsEvent({}));
                if (newValue != null) {
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) saveValue(selection, null, createAnalyticsEvent({}));
                    setEditMode(false);
                    wrapperRef && setTimeout(()=>{
                        wrapperRef?.current?.focus();
                    });
                    clearOnBlur.current = false;
                } else clearOnBlur.current = true;
                return;
            }
            saveValue(selection, null, createAnalyticsEvent({}));
            setEditMode(false);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) wrapperRef && setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            createAnalyticsEvent,
            resetError,
            saveValue,
            setEditMode,
            wrapperRef
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), [
            setIsHovering
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), [
            setIsHovering
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (selectValue) event.clipboardData.setData('text/plain', $cce8f13d0c36da0f$var$transformLabels(selectValue));
            const actionSubjectId = 'single-select';
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', actionSubjectId);
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', actionSubjectId);
                setSelectValue([]);
                saveValue(null, null, createAnalyticsEvent({}));
            }
        }, [
            selectValue,
            saveValue,
            createAnalyticsEvent
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            const clipText = event.clipboardData.getData('text/plain');
            const actionSubjectId = 'single-select';
            const labels = clipText.split(',');
            const options = latestFieldOptions.filter((option)=>labels.find((label)=>label.trim() === option.label));
            if (options.length > 0) {
                setSelectValue(options);
                saveValue(options[0], null, createAnalyticsEvent({}));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', actionSubjectId, {
                    valid: true
                });
            } else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', actionSubjectId, {
                valid: false,
                error: 'Not a valid option'
            });
        }, [
            latestFieldOptions,
            saveValue,
            createAnalyticsEvent
        ]);
        const staticContent = (0, $5uXOq.useMemo)(()=>selectValue.map(({ value: value })=>(0, (0, parcelRequire("4R6GH")).fg)('jwm-list-view-responsive-select-field') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span",
                    key: value,
                    xcss: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $cce8f13d0c36da0f$var$selectFieldStyles : $cce8f13d0c36da0f$var$selectFieldStylesOld
                }, value) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                    key: value,
                    text: value
                })), [
            selectValue
        ]);
        const sortedSelectOptions = (0, $5uXOq.useMemo)(()=>{
            if (!selectValue.length) return latestFieldOptions;
            const selectedOptionIndex = latestFieldOptions.findIndex((option)=>option.value === selectValue[0].value);
            const sortedOptions = [
                ...latestFieldOptions
            ];
            if (selectedOptionIndex > -1) sortedOptions.splice(selectedOptionIndex, 1);
            sortedOptions.unshift(selectValue[0]);
            return sortedOptions;
        }, [
            latestFieldOptions,
            selectValue
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
                preferredWidth: width - 1,
                onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleKeyDown,
                "data-testid": "business-list.ui.list-view.single-select-cell.cell-content-wrapper"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ad1n")).default), {
                autoFocus: true,
                menuIsOpen: editMode,
                placeholder: formatMessage((0, (0, parcelRequire("3KPLw")).default).placeholder, {
                    fieldName: fieldName
                }),
                isClearable: true,
                options: sortedSelectOptions,
                isMulti: false,
                onChange: handleSelectChange,
                value: selectValue,
                isInvalid: !!error,
                tabSelectsValue: !!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav'),
                inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
                onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : undefined
            })), [
            width,
            handleKeyDown,
            editMode,
            formatMessage,
            fieldName,
            sortedSelectOptions,
            handleSelectChange,
            selectValue,
            error,
            inputValue,
            onInputChange
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("4R6GH")).fg)('jira_list_checkbox_convert_to_pressable') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: [
                    $cce8f13d0c36da0f$var$popupTriggerStyles,
                    (0, (0, parcelRequire("4R6GH")).fg)('single_select_popup_width_adjustment') && $cce8f13d0c36da0f$var$popupTriggerContainerStylesXCSS
                ]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                isEditable: isEditable
            }, selectValue.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: $cce8f13d0c36da0f$var$transformLabels(selectValue),
                position: "top"
            }, staticContent))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ...triggerProps,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    (0, (0, parcelRequire("4R6GH")).fg)('single_select_popup_width_adjustment') && "_1bsb1osq"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                isEditable: isEditable
            }, selectValue.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: $cce8f13d0c36da0f$var$transformLabels(selectValue),
                position: "top"
            }, staticContent))), [
            isEditable,
            selectValue,
            staticContent
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const onEscapeKeyPress = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setEditMode(false);
            wrapperRef?.current?.focus();
        }, [
            setEditMode,
            wrapperRef
        ]);
        const handleKeyPress = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') onEscapeKeyPress(e);
            else !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onEscapeKeyPress,
            onKeyDown
        ]);
        const handleKeydownNew = (0, $5uXOq.useCallback)((e)=>{
            if (editMode) {
                if (selectValue[0] == null) {
                    if (e.key === 'Escape') clearOnBlur.current = false;
                    setSelectValue($cce8f13d0c36da0f$var$transformValueWithOptionId(prevFieldValue));
                } else if (e.key === 'Delete') {
                    saveValue(null, null, createAnalyticsEvent({}));
                    setEditMode(false);
                    setTimeout(()=>{
                        wrapperRef?.current?.focus();
                    });
                    clearOnBlur.current = false;
                }
            }
            return false;
        }, [
            createAnalyticsEvent,
            editMode,
            prevFieldValue,
            saveValue,
            selectValue,
            setEditMode,
            wrapperRef
        ]);
        const handleBlur = (0, $5uXOq.useCallback)(()=>{
            if (clearOnBlur.current) {
                saveValue(null, null, createAnalyticsEvent({}));
                clearOnBlur.current = false;
            }
            return false;
        }, [
            createAnalyticsEvent,
            saveValue
        ]);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? {
                    onKeyDown: handleKeydownNew,
                    onBlur: handleBlur
                } : {}, [
            handleKeydownNew,
            handleBlur
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: latestFieldOptions.length
            }), [
            latestFieldOptions
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isHovering || editMode || isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: editMode,
            placement: "bottom-start",
            autoFocus: false,
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $cce8f13d0c36da0f$var$POPUP_OFFSET_NEW : $cce8f13d0c36da0f$var$POPUP_OFFSET,
            onClose: saveAndClose,
            popupComponent: popupComponent,
            content: popupContent,
            trigger: popupTrigger
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), null, staticContent), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("3KPLw")).default).errorTitle,
            description: (0, (0, parcelRequire("3KPLw")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.single-select-cell.cell-container",
            hasPadding: false,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cce8f13d0c36da0f$var$ContentWrapper, null, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: handleKeyPress,
            ref: onWrapperRef,
            isFocused: isSelected,
            onClick: handleClick,
            tabIndex: 0,
            "data-testid": "business-list.ui.list-view.single-select-cell.cell-container"
        }, cellContent);
    });
    var $cce8f13d0c36da0f$export$2e2bcd8739ae039 = $cce8f13d0c36da0f$var$SingleSelectCell;
    const $cce8f13d0c36da0f$var$ContentWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $cce8f13d0c36da0f$var$wrapperStyles
            ]
        }, children);
    const $cce8f13d0c36da0f$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
    const $cce8f13d0c36da0f$var$selectFieldStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        borderRadius: 'border.radius',
        margin: 'space.050',
        paddingLeft: 'space.050',
        paddingRight: 'space.050',
        backgroundColor: 'color.background.neutral',
        color: 'color.text'
    });
    const $cce8f13d0c36da0f$var$selectFieldStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: 'color.text',
        margin: 'space.050',
        paddingLeft: 'space.050',
        paddingRight: 'space.050',
        backgroundColor: 'color.background.neutral.subtle',
        boxSizing: 'border-box',
        borderRadius: 'border.radius',
        border: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border'
    });
    const $cce8f13d0c36da0f$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0',
        width: '100%'
    });
    const $cce8f13d0c36da0f$var$popupTriggerContainerStylesXCSS = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $cce8f13d0c36da0f$var$popupTriggerContainerStyles = null;
});
parcelRegister("92WqQ", function(module, exports) {
    $parcel$export(module.exports, "useCellOptions", ()=>$19f8277dc3393798$export$60a5a2d5b09fbd7b);
    var $1T2vX;
    const $19f8277dc3393798$export$60a5a2d5b09fbd7b = ({ fieldId: fieldId })=>{
        const { data: { fields: fields } } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const fieldConfigOptions = fields.filter((f)=>f.id === fieldId)?.[0]?.fieldConfig?.selectOptions ?? [];
        const getLatestFieldValue = (fieldValue)=>{
            const optionMap = {};
            fieldConfigOptions?.forEach((field)=>{
                const { value: value, optionId: optionId } = field;
                optionMap[String(optionId)] = value;
            });
            let updated = false;
            const updatedFieldValue = [];
            const fieldValueArray = Array.isArray(fieldValue) ? fieldValue : [
                fieldValue
            ];
            fieldValueArray?.forEach((field)=>{
                if (field) {
                    const { optionId: optionId, value: value } = field;
                    const strOptionId = String(optionId);
                    if (value !== optionMap[strOptionId]) updated = true;
                    updatedFieldValue.push({
                        optionId: optionId,
                        value: optionMap[strOptionId] ?? value,
                        label: optionMap[strOptionId] ?? value
                    });
                }
            });
            if (!Array.isArray(fieldValue)) return updated ? updatedFieldValue[0] : fieldValue;
            return updated ? updatedFieldValue : fieldValue;
        };
        return {
            latestFieldOptions: fieldConfigOptions || [],
            getLatestFieldValue: getLatestFieldValue
        };
    };
});
parcelRegister("3KPLw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8f2cb9ffc307ad9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f8f2cb9ffc307ad9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.single-select-cell.error-title",
            "defaultMessage": "We couldn't set the select value"
        },
        errorMessage: {
            "id": "business-list.list-view.single-select-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        placeholder: {
            "id": "business-list.list-view.single-select-cell.placeholder",
            "defaultMessage": "Select {fieldName}"
        }
    });
});
parcelRegister("c9UvN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc464360d7e190ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $dG20o;
    const $fc464360d7e190ae$var$LazySprintCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("dG20o"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/sprint-cell/main.tsx"
    });
    const $fc464360d7e190ae$var$AsyncSprintCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "sprint-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fc464360d7e190ae$var$LazySprintCell, props));
    var $fc464360d7e190ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("dG20o")).default), $fc464360d7e190ae$var$AsyncSprintCell);
});
parcelRegister("dG20o", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$d3b4bcf20cd00404$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $183uB = parcelRequire("183uB");
    var $6tSZM;
    var $1I7E8;
    var $dC5iT;
    var $kgoHi;
    var $5ILhZ;
    var $8CUq3;
    var $d9xxV;
    var $3bDjY;
    var $b5lmY;
    var $e0a4D;
    var $jRzRt;
    var $k2xO1;
    var $gULOk;
    var $dMnMc;
    var $4R6GH;
    var $koVbs;
    var $a29sl;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $eTDjN;
    var $lI995;
    var $9u99d;
    var $3dLJg;
    var $lWtBl;
    var $kBrmp;
    const $d3b4bcf20cd00404$var$POPUP_OFFSET = [
        0,
        1 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $d3b4bcf20cd00404$var$POPUP_OFFSET_NEW = [
        0,
        -(0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT) - 1
    ];
    const $d3b4bcf20cd00404$var$noop = ()=>{};
    const $d3b4bcf20cd00404$var$SprintCell = (0, $5uXOq.memo)(({ fieldKey: fieldKey, issueKey: issueKey, issueId: issueId, isEditable: isEditable, fieldValue: fieldValue, width: width, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', issueTypeLevel: issueTypeLevel, editMode: editModeNew = false, setEditMode: setEditModeNew = $d3b4bcf20cd00404$var$noop, inputValue: inputValue, onInputChange: onInputChange, cellRef: cellRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const boardId = (0, (0, parcelRequire("dMnMc")).getBoardId)(typeof window !== 'undefined' ? window.location.href : '');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [options, setOptions] = (0, $5uXOq.useState)([]);
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("9u99d")).useHierarchyStore)();
        const initialValue = (0, $5uXOq.useMemo)(()=>{
            if (fieldValue && Array.isArray(fieldValue) && fieldValue.length) {
                const initialSprintValue = fieldValue[0];
                if (initialSprintValue) return [
                    {
                        id: Number(initialSprintValue.sprintId),
                        name: String(initialSprintValue.name),
                        state: String(initialSprintValue.state),
                        boardId: Number(boardId)
                    }
                ];
            }
            return undefined;
        }, [
            boardId,
            fieldValue
        ]);
        const [{ value: sprintValue, error: error }, { saveValue: saveValue }] = (0, (0, parcelRequire("a29sl")).useSprintField)({
            fieldKey: fieldKey,
            initialValue: initialValue,
            onSuccess: $d3b4bcf20cd00404$var$noop,
            onFailure: $d3b4bcf20cd00404$var$noop,
            issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey),
            issueId: issueId
        });
        const currentValue = sprintValue.length ? sprintValue[0] : undefined;
        const [selectValue, setSelectValue] = (0, $5uXOq.useState)(currentValue);
        const clearOnBlur = (0, $5uXOq.useRef)(false);
        if (currentValue?.id !== selectValue?.id && !editMode && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) setSelectValue(currentValue);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) setEditMode(true);
        }, [
            isEditable,
            editMode,
            setEditMode
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (!isEditable && e.key === 'Enter') e.preventDefault();
            !editMode && onKeyDown?.(e);
        }, [
            isEditable,
            editMode,
            onKeyDown
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (currentValue) event.clipboardData.setData('text/plain', currentValue.name);
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'sprint');
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'sprint');
                saveValue([], null, createAnalyticsEvent({})).catch();
            }
        }, [
            createAnalyticsEvent,
            currentValue,
            saveValue
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            const sprintName = event.clipboardData.getData('text/plain');
            const allOptions = (0, ($parcel$interopDefault($183uB)))(options.map((group)=>group.options));
            const validOption = allOptions.find((op)=>op.label === sprintName);
            if (validOption) {
                saveValue([
                    (0, (0, parcelRequire("kBrmp")).mapOptionToSprint)(validOption, boardId)
                ], null, createAnalyticsEvent({}));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'sprint', {
                    valid: true
                });
            } else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'sprint', {
                valid: false,
                error: 'Paste content invalid option'
            });
        }, [
            options,
            saveValue,
            boardId,
            createAnalyticsEvent
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: 0,
                hasFooter: false
            }), []);
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
        }, [
            setEditMode
        ]);
        const saveValueNew = (0, $5uXOq.useCallback)(async (value, meta, analyticsEvent)=>{
            setSelectValue(value[0]);
            if (value[0] != null) {
                saveValue(value, meta, analyticsEvent);
                clearOnBlur.current = false;
            } else clearOnBlur.current = true;
        }, [
            saveValue
        ]);
        const handleKeydown = (0, $5uXOq.useCallback)((e)=>{
            if (editMode) {
                if (selectValue == null) {
                    if (e.key === 'Escape') clearOnBlur.current = false;
                    setSelectValue(currentValue);
                } else if (e.key === 'Delete') {
                    saveValue([], null, createAnalyticsEvent({}));
                    setEditMode(false);
                    setTimeout(()=>{
                        wrapperRef?.current?.focus();
                    });
                    clearOnBlur.current = false;
                }
            }
            return false;
        }, [
            createAnalyticsEvent,
            currentValue,
            editMode,
            saveValue,
            selectValue,
            setEditMode,
            wrapperRef
        ]);
        const handleBlur = (0, $5uXOq.useCallback)(()=>{
            if (clearOnBlur.current) {
                saveValue([], null, createAnalyticsEvent({}));
                clearOnBlur.current = false;
            }
            return false;
        }, [
            createAnalyticsEvent,
            saveValue
        ]);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                    onKeyDown: handleKeydown,
                    onBlur: handleBlur
                }), [
            handleKeydown,
            handleBlur
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lWtBl")).SprintPopupContent), {
                wrapperRef: wrapperRef,
                width: width,
                currentSprint: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? selectValue : currentValue,
                onCloseMenu: handleClose,
                saveValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? saveValueNew : saveValue,
                setSprintOptions: setOptions,
                issueTypeLevel: issueTypeLevel,
                inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
                onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : undefined
            }), [
            wrapperRef,
            width,
            selectValue,
            currentValue,
            handleClose,
            saveValueNew,
            saveValue,
            issueTypeLevel,
            inputValue,
            onInputChange
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
            const sprintName = currentValue?.name;
            if (currentValue?.state === 'CLOSED' && sprintName) {
                const issue = issuesMap.get(issueId.toString());
                if (issue && issue.status?.categoryId !== (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE].toString()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                    ...triggerProps,
                    xcss: $d3b4bcf20cd00404$var$popupTriggerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                    isEditable: isEditable
                }));
                const tooltipText = formatMessage((0, (0, parcelRequire("3dLJg")).default).completedSprintTooltip, {
                    sprintName: sprintName
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                    ...triggerProps,
                    xcss: $d3b4bcf20cd00404$var$popupTriggerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                    isEditable: isEditable
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: tooltipText,
                    position: "top"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                    text: sprintName,
                    color: "greenLight",
                    elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $d3b4bcf20cd00404$var$iconWrapperStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6tSZM"))))), {
                        size: "small",
                        label: tooltipText
                    }))
                }))));
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: $d3b4bcf20cd00404$var$popupTriggerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2xO1")).TagListWrapper), {
                isEditable: isEditable
            }, currentValue && sprintName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                text: sprintName
            })));
        }, [
            currentValue,
            formatMessage,
            isEditable,
            issueId,
            issuesMap
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: editMode,
            placement: "bottom-start",
            autoFocus: false,
            offset: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $d3b4bcf20cd00404$var$POPUP_OFFSET_NEW : $d3b4bcf20cd00404$var$POPUP_OFFSET,
            onClose: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? $d3b4bcf20cd00404$var$noop : handleClose,
            popupComponent: popupComponent,
            content: popupContent,
            trigger: popupTrigger
        }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("3dLJg")).default).errorTitle,
            description: (0, (0, parcelRequire("3dLJg")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            hasPadding: false,
            testId: "business-list.ui.list-view.sprint-cell.cell-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d3b4bcf20cd00404$var$ContentWrapper, null, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContainer), {
            onClick: handleClick,
            isFocused: isSelected,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            "data-testid": "business-list.ui.list-view.sprint-cell.cell-container"
        }, cellContent);
    });
    var $d3b4bcf20cd00404$export$2e2bcd8739ae039 = $d3b4bcf20cd00404$var$SprintCell;
    const $d3b4bcf20cd00404$var$ContentWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $d3b4bcf20cd00404$var$wrapperStyles
            ]
        }, children);
    const $d3b4bcf20cd00404$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.025',
        marginLeft: 'space.025'
    });
    const $d3b4bcf20cd00404$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
    const $d3b4bcf20cd00404$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    });
});
parcelRegister("6tSZM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b801c7587081e8b$var$_react = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4b801c7587081e8b$var$_checkCircle = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("34OIV")));
    function $4b801c7587081e8b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b801c7587081e8b$var$CheckCircleOutlineIcon = (props)=>$4b801c7587081e8b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $4b801c7587081e8b$var$_checkCircle.default
        }));
    $4b801c7587081e8b$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
    var $4b801c7587081e8b$var$_default = module.exports.default = $4b801c7587081e8b$var$CheckCircleOutlineIcon;
});
parcelRegister("34OIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>$23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;
});
parcelRegister("3dLJg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$890b85c3e24c0170$export$2e2bcd8739ae039);
    var $7VHMR;
    var $890b85c3e24c0170$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.sprint-cell.error-title",
            "defaultMessage": "We couldn't set the sprint value"
        },
        errorMessage: {
            "id": "business-list.list-view.sprint-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        placeholder: {
            "id": "business-list.list-view.sprint-cell.placeholder",
            "defaultMessage": "Select sprint"
        },
        completedSprintTooltip: {
            "id": "business-list.list-view.sprint-cell.completed-sprint-tooltip",
            "defaultMessage": "{sprintName} is complete"
        }
    });
});
parcelRegister("lWtBl", function(module, exports) {
    $parcel$export(module.exports, "SprintPopupContent", ()=>$dda5a4bc5db7630b$export$48152b89ed0e4e13);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $8ad1n;
    var $dMnMc;
    var $jcw0u;
    var $4R6GH;
    var $koVbs;
    var $249dD;
    var $bW9R0;
    var $2NMNM;
    var $8q5UJ;
    var $lI995;
    var $9hpga;
    var $cYmr7;
    var $kBrmp;
    const $dda5a4bc5db7630b$var$AUTO_COMPLETE_URL = '/rest/greenhopper/1.0/sprint/picker?query=';
    const $dda5a4bc5db7630b$var$SPRINT_HELP_ARTICLE = {
        href: 'https://support.atlassian.com/jira-software-cloud/docs/sprints-in-next-gen-projects/',
        helpArticleId: '4czk5C61YP1n5wpBCfITEN'
    };
    const $dda5a4bc5db7630b$export$48152b89ed0e4e13 = (0, $5uXOq.memo)(({ wrapperRef: wrapperRef, width: width, onCloseMenu: onCloseMenu, currentSprint: currentSprint, saveValue: saveValue, setSprintOptions: setSprintOptions, issueTypeLevel: issueTypeLevel, inputValue: inputValue, onInputChange: onInputChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const boardId = (0, (0, parcelRequire("dMnMc")).getBoardId)(typeof window !== 'undefined' ? window.location.href : '');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [options, setOptions] = (0, $5uXOq.useState)([]);
        const [fetchError, setFetchError] = (0, $5uXOq.useState)();
        const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, (0, parcelRequire("bW9R0")).useSprintSuggestions)({
            getSuggestions: (0, (0, parcelRequire("kBrmp")).getSprintSuggestions)
        });
        const fetchSuggestions = (0, $5uXOq.useCallback)(()=>{
            setIsLoadingSuggestions(true);
            getSprintSuggestions($dda5a4bc5db7630b$var$AUTO_COMPLETE_URL, '', projectKey).then((suggestionsFromServer)=>{
                setIsLoadingSuggestions(false);
                const sprintOptions = (0, (0, parcelRequire("249dD")).transformSuggestions)({
                    ...suggestionsFromServer,
                    suggestions: suggestionsFromServer?.suggestions?.filter((option)=>option?.id !== Number(currentSprint?.id)),
                    allMatches: suggestionsFromServer?.allMatches?.filter((option)=>option?.id !== Number(currentSprint?.id))
                }, formatMessage);
                setOptions(sprintOptions);
                setSprintOptions(sprintOptions);
            }).catch((error)=>{
                setIsLoadingSuggestions(false);
                setFetchError(error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchSprintSuggestions',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to fetch sprint suggestions'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            currentSprint?.id,
            formatMessage,
            getSprintSuggestions,
            projectKey,
            setIsLoadingSuggestions,
            setSprintOptions
        ]);
        const isSubTask = issueTypeLevel === -1;
        (0, $5uXOq.useEffect)(()=>{
            if (!isSubTask) fetchSuggestions();
        }, [
            fetchSuggestions,
            isSubTask
        ]);
        const handleContentKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && event.key === 'Escape') {
                event.preventDefault();
                wrapperRef?.current?.focus();
            }
        }, [
            wrapperRef
        ]);
        const handleChange = (0, $5uXOq.useCallback)((option)=>{
            saveValue(option != null ? [
                (0, (0, parcelRequire("kBrmp")).mapOptionToSprint)(option, boardId)
            ] : [], null, createAnalyticsEvent({}));
            if (option != null) {
                onCloseMenu();
                setTimeout(()=>{
                    wrapperRef?.current?.focus();
                });
            }
        }, [
            boardId,
            createAnalyticsEvent,
            onCloseMenu,
            saveValue,
            wrapperRef
        ]);
        const selectComponents = (0, $5uXOq.useMemo)(()=>{
            if (isSubTask) return {
                NoOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9hpga")).default), {
                        message: formatMessage((0, (0, parcelRequire("cYmr7")).default).cannotEditSubtasks),
                        analyticsCellName: "sprint",
                        helpArticle: $dda5a4bc5db7630b$var$SPRINT_HELP_ARTICLE,
                        onHandleLearnMore: onCloseMenu
                    })
            };
            if (fetchError) return {
                NoOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8q5UJ")).default), {
                        onTryAgain: fetchSuggestions,
                        message: formatMessage((0, (0, parcelRequire("cYmr7")).default).cannotLoadSprintSuggestions),
                        analyticsCellName: "sprint"
                    })
            };
            return {};
        }, [
            fetchError,
            fetchSuggestions,
            formatMessage,
            isSubTask,
            onCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
            "data-testid": "business-list.ui.list-view.sprint-cell.popup-content.cell-content-wrapper",
            preferredWidth: width,
            onKeyDown: handleContentKeyDown
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ad1n")).default), {
            autoFocus: true,
            menuIsOpen: true,
            isClearable: true,
            placeholder: formatMessage((0, (0, parcelRequire("cYmr7")).default).placeholder),
            options: options,
            onChange: handleChange,
            isInvalid: false,
            value: currentSprint ? [
                {
                    label: currentSprint.name,
                    value: currentSprint.id.toString()
                }
            ] : [],
            isLoading: isLoadingSuggestions,
            isMulti: false,
            components: selectComponents,
            tabSelectsValue: !!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav'),
            inputValue: inputValue,
            onInputChange: onInputChange
        }));
    });
});
parcelRegister("bW9R0", function(module, exports) {
    $parcel$export(module.exports, "useSprintSuggestions", ()=>$76a69867a9473261$export$16d0ab78a0b529dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
        maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
        maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
    });
    const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
        let queryString;
        if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
        else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(queryString);
    };
    const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
        const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
        const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
        const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
            try {
                const response = await getSuggestions(autoCompleteUrl, query, projectKey);
                setIsLoadingSuggestions(false);
                return response;
            } catch (error) {
                setIsLoadingSuggestions(false);
                throw error;
            }
        }, [
            getSuggestions,
            setIsLoadingSuggestions
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>({
                getSprintSuggestions: getSprintSuggestions,
                setIsLoadingSuggestions: setIsLoadingSuggestions
            }), [
            getSprintSuggestions,
            setIsLoadingSuggestions
        ]);
        return [
            {
                isLoadingSuggestions: isLoadingSuggestions
            },
            actions
        ];
    };
});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;
parcelRegister("8q5UJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9920cddfd7fbcb2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $g67r8;
    const $c9920cddfd7fbcb2$var$LazySelectFetchError = ({ onTryAgain: onTryAgain, message: message, analyticsCellName: analyticsCellName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnTryAgain = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'tryAgain', {
                cell: analyticsCellName
            });
            onTryAgain && onTryAgain();
        }, [
            analyticsCellName,
            createAnalyticsEvent,
            onTryAgain
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $c9920cddfd7fbcb2$var$wrapperStyles,
            alignItems: "center",
            justifyContent: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c9920cddfd7fbcb2$var$errorMessageWrapperStyles
        }, message), onTryAgain && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "link",
            spacing: "none",
            onClick: (event)=>{
                event.stopPropagation();
                handleOnTryAgain();
            },
            theme: (currentTheme, theme)=>{
                const buttonTheme = currentTheme(theme);
                return {
                    ...buttonTheme,
                    buttonStyles: {
                        ...buttonTheme.buttonStyles,
                        alignItems: 'center'
                    }
                };
            }
        }, formatMessage((0, (0, parcelRequire("g67r8")).default).tryAgain))));
    };
    var $c9920cddfd7fbcb2$export$2e2bcd8739ae039 = $c9920cddfd7fbcb2$var$LazySelectFetchError;
    const $c9920cddfd7fbcb2$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: "var(--ds-space-600, 48px)",
        paddingLeft: 'space.150',
        paddingRight: 'space.150'
    });
    const $c9920cddfd7fbcb2$var$errorMessageWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
});
parcelRegister("g67r8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$133d7df961eec9be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $133d7df961eec9be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tryAgain: {
            "id": "business-list.common.lazy-select-fetch-error.try-again",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("9hpga", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c77fd297c3e380f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $5Zxxp;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $hDzhb;
    var $9x7UV;
    const $c77fd297c3e380f1$var$SelectEditError = ({ helpArticle: helpArticle, message: message, analyticsCellName: analyticsCellName, onHandleLearnMore: onHandleLearnMore })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleLearnMore = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'learnMore', {
                cell: analyticsCellName
            });
            onHandleLearnMore && onHandleLearnMore();
        }, [
            analyticsCellName,
            createAnalyticsEvent,
            onHandleLearnMore
        ]);
        const { href: href, helpArticleId: helpArticleId } = helpArticle;
        const fallbackAnchor = (0, $5uXOq.useMemo)(()=>href !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                href: href,
                onClick: handleLearnMore
            }, formatMessage((0, (0, parcelRequire("9x7UV")).default).learnMore)), [
            formatMessage,
            handleLearnMore,
            href
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c77fd297c3e380f1$var$wrapperStyles
        }, message, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $c77fd297c3e380f1$var$helpLinkStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
            articleId: helpArticleId,
            type: "HELP_ARTICLE",
            appearance: "link",
            spacing: "none",
            onClick: handleLearnMore,
            fallbackComponent: fallbackAnchor
        }, formatMessage((0, (0, parcelRequire("9x7UV")).default).learnMore))));
    };
    var $c77fd297c3e380f1$export$2e2bcd8739ae039 = $c77fd297c3e380f1$var$SelectEditError;
    const $c77fd297c3e380f1$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: "var(--ds-space-600, 48px)",
        paddingLeft: 'space.150',
        paddingRight: 'space.150'
    });
    const $c77fd297c3e380f1$var$helpLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return handleOnClick;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("9x7UV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b783b04dfd5628dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b783b04dfd5628dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        learnMore: {
            "id": "business-list.common.select-edit-error.learn-more",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("cYmr7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0eb2a6421c0780c2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0eb2a6421c0780c2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "business-list.list-view.sprint-cell.popup-content.placeholder",
            "defaultMessage": "Select sprint"
        },
        cannotLoadSprintSuggestions: {
            "id": "business-list.list-view.sprint-cell.popup-content.cannot-load-sprint-suggestions",
            "defaultMessage": "Couldn't load the sprints."
        },
        cannotEditSubtasks: {
            "id": "business-list.list-view.sprint-cell.popup-content.cannot-edit-subtasks",
            "defaultMessage": "Subtasks remain in the same sprint as their parent task."
        }
    });
});
parcelRegister("kBrmp", function(module, exports) {
    $parcel$export(module.exports, "getSprintSuggestions", ()=>$992e6f25010ccbd7$export$a5ccca5b51d5d670);
    $parcel$export(module.exports, "mapOptionToSprint", ()=>$992e6f25010ccbd7$export$dc6ac67640c50628);
    var $eusud;
    const $992e6f25010ccbd7$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
        const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
        return queryString;
    };
    const $992e6f25010ccbd7$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, (0, parcelRequire("eusud")).performGetRequest)($992e6f25010ccbd7$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));
    const $992e6f25010ccbd7$export$dc6ac67640c50628 = (option, boardId)=>({
            name: option.label,
            id: Number(option.value),
            boardId: Number(boardId),
            state: option.state
        });
});
parcelRegister("lup7l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$045d9dc4d0939a23$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $a25Xj;
    const $045d9dc4d0939a23$var$LazyStatusCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("a25Xj"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/status-cell/main.tsx"
    });
    const $045d9dc4d0939a23$var$AsyncStatusCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "status-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($045d9dc4d0939a23$var$LazyStatusCell, props));
    var $045d9dc4d0939a23$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("a25Xj")).default), $045d9dc4d0939a23$var$AsyncStatusCell);
});
parcelRegister("a25Xj", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "FormattedStatusOptionLabel", ()=>$7ee05b09f15b753f$export$60035e0a086aefd4);
    $parcel$export(module.exports, "default", ()=>$7ee05b09f15b753f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8RBk4;
    var $lj8SI;
    var $1I7E8;
    var $5ILhZ;
    var $8CUq3;
    var $b5lmY;
    var $8ad1n;
    var $jRzRt;
    var $gULOk;
    var $gwIPs;
    var $6s1PB;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $9RrVQ;
    var $bUXoM;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $dCm1o;
    var $eTDjN;
    var $8q5UJ;
    var $lI995;
    var $mk7k0;
    var $3AZQW;
    var $5uSmq;
    const $7ee05b09f15b753f$var$serviceProjectType = 'business';
    const $7ee05b09f15b753f$export$60035e0a086aefd4 = (0, $5uXOq.memo)(({ option: option, hasDuplicateStatusesInTargets: hasDuplicateStatusesInTargets })=>{
        if (option.transition == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$OptionWrapper, null, hasDuplicateStatusesInTargets ? (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$TransitionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$TransitionLabel, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$TransitionName, null, option.transition?.name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            size: "small",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$StatusName, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            isBold: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)(),
            appearance: (0, (0, parcelRequire("5uSmq")).toAppearance)(option.transition.to)
        }, option.transition.to.name)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            isBold: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)(),
            appearance: (0, (0, parcelRequire("5uSmq")).toAppearance)(option.transition.to)
        }, option.transition.to.name)));
    });
    const $7ee05b09f15b753f$var$ServiceWrapper = (0, $5uXOq.memo)(({ id: id, name: name, categoryId: categoryId, issueKey: issueKey, children: children, onStatusChange: onStatusChange = (0, ($parcel$interopDefault($8Rkzz))), issueId: issueId })=>{
        const { baseUrl: baseUrl } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const initialValue = {
            id: id,
            name: name,
            statusCategory: {
                id: categoryId
            }
        };
        const statusServiceChildren = (0, $5uXOq.useCallback)(({ value: statusFromService, loading: saving, transitionStatus: transitionStatus })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bUXoM")).TransitionsQuery), {
                issueKey: issueKey,
                baseUrl: baseUrl,
                status: statusFromService,
                isSaving: saving,
                projectType: $7ee05b09f15b753f$var$serviceProjectType
            }, ({ data: transitions, loading: loading, fetch: fetchTransitions })=>children({
                    transitions: transitions,
                    statusFromService: statusFromService,
                    transitionStatus: transitionStatus,
                    serviceBusy: saving || loading,
                    fetchTransitions: fetchTransitions
                })), [
            issueKey,
            baseUrl,
            children
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RrVQ")).StatusService), {
            appearance: "lozenge",
            projectType: $7ee05b09f15b753f$var$serviceProjectType,
            initialValue: initialValue,
            issueKey: issueKey,
            issueId: issueId,
            baseUrl: baseUrl,
            onSubmit: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: onStatusChange,
            onFailure: (0, ($parcel$interopDefault($8Rkzz))),
            onEditStart: (0, ($parcel$interopDefault($8Rkzz))),
            onEditCancel: (0, ($parcel$interopDefault($8Rkzz)))
        }, statusServiceChildren);
    });
    $7ee05b09f15b753f$var$ServiceWrapper.displayName = 'ServiceWrapper';
    const $7ee05b09f15b753f$var$POPUP_OFFSET = [
        -(0, (0, parcelRequire("gwIPs")).gridSize),
        2 - (0, (0, parcelRequire("eTDjN")).DEFAULT_ROW_HEIGHT)
    ];
    const $7ee05b09f15b753f$var$Transitions = (0, $5uXOq.memo)(({ transitions: transitions, statusFromService: statusFromService, transitionStatus: transitionStatus, fetchTransitions: fetchTransitions, serviceBusy: serviceBusy, isMenuOpen: isMenuOpen, isSelected: isSelected, isHovering: isHovering, isLozengeBold: isLozengeBold, width: width, height: height, wrapperRef: wrapperRef, inputRef: inputRef, onMenuOpen: onMenuOpen, onPopupClose: onPopupClose, inputValue: inputValueNew, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [availableTransitions, setAvailableTransitions] = (0, $5uXOq.useState)(transitions);
        const [transitionsReady, setTransitionsReady] = (0, $5uXOq.useState)(false);
        const [inputValueOld, setInputValueOld] = (0, $5uXOq.useState)('');
        const inputValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValueNew : inputValueOld;
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(transitions, availableTransitions)) {
                setAvailableTransitions(transitions);
                setTimeout(()=>{
                    setTransitionsReady(true);
                }, 100);
            }
        }, [
            transitions,
            availableTransitions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (serviceBusy === false && inputRef?.current) setTimeout(()=>{
                inputRef.current?.focus();
            }, 1);
        }, [
            serviceBusy,
            inputRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isMenuOpen && (!transitions || !transitions.length) && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) fetchTransitions(createAnalyticsEvent({}));
        }, [
            createAnalyticsEvent,
            fetchTransitions,
            isMenuOpen,
            transitions
        ]);
        const handleMenuOpenChange = (0, $5uXOq.useCallback)(()=>{
            fetchTransitions(createAnalyticsEvent({}));
        }, [
            fetchTransitions,
            createAnalyticsEvent
        ]);
        const handleContentKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && e.key === 'Escape') {
                e.stopPropagation();
                e.preventDefault();
                onMenuOpen(false);
                wrapperRef?.current?.focus();
            }
        }, [
            wrapperRef,
            onMenuOpen
        ]);
        const handleTransitionChange = (0, $5uXOq.useCallback)((transitionOption)=>{
            if (transitionOption?.transition) transitionStatus(transitionOption?.transition, createAnalyticsEvent({}));
            onMenuOpen(false);
            wrapperRef?.current && setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            createAnalyticsEvent,
            onMenuOpen,
            wrapperRef,
            transitionStatus
        ]);
        const handleInputChange = (0, $5uXOq.useCallback)((value)=>{
            setInputValueOld(value);
        }, [
            setInputValueOld
        ]);
        const handleInputChangeNew = (0, $5uXOq.useCallback)((value)=>{
            if (transitionsReady) onInputChange(value);
        }, [
            onInputChange,
            transitionsReady
        ]);
        const selectValue = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5uSmq")).transformValue)(statusFromService), [
            statusFromService
        ]);
        const selectOptions = (0, $5uXOq.useMemo)(()=>{
            let selectedStatusOption = null;
            const statusOptions = [];
            (availableTransitions || []).forEach((transitionOption)=>{
                if (transitionOption.name == null) return;
                const statusOption = {
                    label: transitionOption.to.name,
                    value: transitionOption.to.name,
                    transition: transitionOption
                };
                if (transitionOption.to.name === statusFromService?.name) selectedStatusOption = statusOption;
                else statusOptions.push(statusOption);
            });
            if (selectedStatusOption != null) statusOptions.unshift(selectedStatusOption);
            return statusOptions;
        }, [
            availableTransitions,
            statusFromService
        ]);
        const hasDuplicateStatusesInTargets = (0, $5uXOq.useMemo)(()=>{
            const targetStatusNames = availableTransitions ? availableTransitions.map((transition)=>transition.to.name) : [];
            return targetStatusNames.some((statusName, index)=>targetStatusNames.indexOf(statusName) !== index);
        }, [
            availableTransitions
        ]);
        const selectComponents = (0, $5uXOq.useMemo)(()=>({
                NoOptionsMessage: ()=>inputValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8q5UJ")).default), {
                        message: formatMessage((0, (0, parcelRequire("3AZQW")).default).noSearchResults)
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8q5UJ")).default), {
                        onTryAgain: handleMenuOpenChange,
                        message: formatMessage((0, (0, parcelRequire("3AZQW")).default).cannotLoadTransitions),
                        analyticsCellName: "status"
                    })
            }), [
            handleMenuOpenChange,
            inputValue,
            formatMessage
        ]);
        const getFormatOptionLabel = (0, $5uXOq.useCallback)((option)=>{
            if (option.transition == null) return option.label || '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$export$60035e0a086aefd4, {
                option: option,
                hasDuplicateStatusesInTargets: hasDuplicateStatusesInTargets
            });
        }, [
            hasDuplicateStatusesInTargets
        ]);
        const handleInputRef = (0, $5uXOq.useCallback)((ref)=>{
            if (inputRef) inputRef.current = ref;
        }, [
            inputRef
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentWrapper), {
                preferredWidth: width - 1,
                onKeyDown: handleContentKeyDown
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ad1n")).default), {
                autoFocus: true,
                menuIsOpen: true,
                placeholder: formatMessage((0, (0, parcelRequire("3AZQW")).default).placeholder),
                options: selectOptions,
                onChange: handleTransitionChange,
                value: selectValue,
                formatOptionLabel: getFormatOptionLabel,
                isMulti: false,
                isInvalid: false,
                isClearable: false,
                isLoading: serviceBusy,
                components: selectComponents,
                onInputRef: handleInputRef,
                tabSelectsValue: !!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav'),
                inputValue: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : undefined,
                onInputChange: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? handleInputChangeNew : handleInputChange
            })), [
            width,
            handleContentKeyDown,
            formatMessage,
            selectOptions,
            handleTransitionChange,
            selectValue,
            getFormatOptionLabel,
            serviceBusy,
            selectComponents,
            handleInputRef,
            inputValue,
            handleInputChangeNew,
            handleInputChange
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("4R6GH")).fg)('jira_list_checkbox_convert_to_pressable') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...triggerProps,
                xcss: $7ee05b09f15b753f$var$popupTriggerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentContainer), {
                onClick: handleMenuOpenChange,
                width: width,
                height: height
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                isBold: isLozengeBold,
                appearance: (0, (0, parcelRequire("5uSmq")).toAppearance)(statusFromService)
            }, statusFromService.name))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellContentContainer), {
                onClick: handleMenuOpenChange,
                width: width,
                height: height,
                ...triggerProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                isBold: isLozengeBold,
                appearance: (0, (0, parcelRequire("5uSmq")).toAppearance)(statusFromService)
            }, statusFromService.name))), [
            handleMenuOpenChange,
            width,
            height,
            isLozengeBold,
            statusFromService
        ]);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: selectOptions.length
            }), [
            selectOptions
        ]);
        const statusMenu = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isMenuOpen,
                placement: "bottom-start",
                autoFocus: false,
                offset: $7ee05b09f15b753f$var$POPUP_OFFSET,
                popupComponent: popupComponent,
                content: popupContent,
                trigger: popupTrigger,
                onClose: onPopupClose,
                testId: "business-list.ui.list-view.status-cell.status-menu"
            }), [
            isMenuOpen,
            onPopupClose,
            popupContent,
            popupTrigger,
            popupComponent
        ]);
        return isHovering || isMenuOpen || isSelected ? statusMenu : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            isBold: isLozengeBold,
            appearance: (0, (0, parcelRequire("5uSmq")).toAppearance)(statusFromService)
        }, statusFromService.name);
    });
    const $7ee05b09f15b753f$var$StatusCell = (0, $5uXOq.memo)(({ id: id, name: name, categoryId: categoryId, issueKey: issueKey, width: width, height: height, onHighlightRow: onHighlightRow, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, rowData: rowData, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, inputValue: inputValue, onInputChange: onInputChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const containerRef = (0, $5uXOq.useRef)(null);
        const inputRef = (0, $5uXOq.useRef)(null);
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [statusValue, setStatusValue] = (0, $5uXOq.useState)({
            id: id,
            name: name,
            statusCategory: {
                id: categoryId
            }
        });
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const [isRowSelected] = (0, (0, parcelRequire("mk7k0")).useIsIssueSelected)({
            issueId: String(rowData.issueId)
        });
        const isLozengeBold = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() || isRowSelected && categoryId === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).INDETERMINATE];
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') && !isSelected && editMode) setEditMode(false);
        }, [
            editMode,
            isSelected,
            setEditMode
        ]);
        const onCompleted = (0, $5uXOq.useCallback)(()=>onHighlightRow && onHighlightRow(issueKey), [
            issueKey,
            onHighlightRow
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            if ((e.key === 'Enter' || e.key === ' ') && containerRef.current && e.currentTarget === e.target) containerRef.current.click();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            containerRef,
            onKeyDown
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleWrapperClick = (0, $5uXOq.useCallback)(()=>{
            setEditMode(!editMode);
        }, [
            editMode,
            setEditMode
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
            setIsHovering(true);
        }, []);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovering(false);
        }, []);
        const handleBlur = (0, $5uXOq.useCallback)((event)=>{
            if (!editMode) onBlur?.(event);
        }, [
            onBlur,
            editMode
        ]);
        const onPopupClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
        }, [
            setEditMode
        ]);
        const handleStatusChange = (0, $5uXOq.useCallback)((value)=>{
            setStatusValue(value);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
            if (value.statusCategory.id === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE] && !(0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag')) {
                showFlag({
                    id: 'marked-as-done-flag',
                    isAutoDismiss: true,
                    type: 'success',
                    title: `\u{1F389} ${formatMessage((0, (0, parcelRequire("3AZQW")).default).markedAsDoneFlagTitle)}`,
                    description: [
                        (0, (0, parcelRequire("3AZQW")).default).markedAsDone,
                        {
                            issue: `${issueKey}`,
                            statusName: value.name
                        }
                    ],
                    actions: [
                        {
                            content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3AZQW")).default).viewIssueIssueTermRefresh : (0, (0, parcelRequire("3AZQW")).default).viewIssue,
                            href: `/browse/${issueKey}`,
                            target: '_blank'
                        }
                    ]
                });
                onCompleted();
            }
        }, [
            formatMessage,
            issueKey,
            onCompleted,
            showFlag,
            wrapperRef
        ]);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (statusValue) event.clipboardData.setData('text/plain', statusValue.name);
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'status');
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'status');
        }, [
            statusValue,
            createAnalyticsEvent
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            const clipText = event.clipboardData.getData('text/plain');
            if (clipText) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'status');
        }, [
            createAnalyticsEvent
        ]);
        const transitionsChildren = (0, $5uXOq.useCallback)(({ transitions: transitions, statusFromService: statusFromService, transitionStatus: transitionStatus, fetchTransitions: fetchTransitions, serviceBusy: serviceBusy })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$Transitions, {
                transitions: transitions,
                statusFromService: statusFromService,
                transitionStatus: transitionStatus,
                fetchTransitions: fetchTransitions,
                serviceBusy: serviceBusy,
                isSelected: isSelected,
                isHovering: isHovering,
                isMenuOpen: editMode,
                isLozengeBold: isLozengeBold,
                width: width,
                height: height,
                wrapperRef: wrapperRef,
                containerRef: containerRef,
                inputRef: inputRef,
                onPopupClose: onPopupClose,
                onMenuOpen: setEditMode,
                inputValue: inputValue,
                onInputChange: onInputChange
            }), [
            isSelected,
            isHovering,
            editMode,
            isLozengeBold,
            width,
            height,
            wrapperRef,
            onPopupClose,
            setEditMode,
            inputValue,
            onInputChange
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement($7ee05b09f15b753f$var$ServiceWrapper, {
            id: id,
            issueId: String(rowData.issueId),
            name: name,
            categoryId: categoryId,
            issueKey: issueKey,
            onStatusChange: handleStatusChange
        }, transitionsChildren);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: true,
            testId: "business-list.ui.list-view.status-cell.cell-container",
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, cellContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellWrapper), {
            isFocused: editMode || isSelected,
            isEditable: true,
            onClick: handleWrapperClick,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            tabIndex: 0,
            onFocus: onFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            "data-testid": "business-list.ui.list-view.status-cell.cell-container"
        }, cellContent);
    });
    var $7ee05b09f15b753f$export$2e2bcd8739ae039 = $7ee05b09f15b753f$var$StatusCell;
    const $7ee05b09f15b753f$var$TransitionLabel = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1t211l2s",
                __cmplp.className
            ])
        });
    });
    const $7ee05b09f15b753f$var$TransitionName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jl11wp _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $7ee05b09f15b753f$var$StatusName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gnusic",
                __cmplp.className
            ])
        });
    });
    const $7ee05b09f15b753f$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $7ee05b09f15b753f$var$TransitionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _2lx21bp4 _1bsb1osq _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $7ee05b09f15b753f$var$popupTriggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    });
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("9RrVQ", function(module, exports) {
    $parcel$export(module.exports, "StatusService", ()=>$9d12d6dcae452c2c$export$3e14b51c9a9c5a1a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    var $f9Owr;
    var $cSD7y;
    var $4R6GH;
    var $jJZqs;
    var $fZneA;
    var $eusud;
    var $34Vv8;
    var $ctrpc;
    var $3fAi8;
    var $6Ou5i;
    var $jpZIw;
    var $dTUtq;
    var $gXz4p;
    var $k0ahW;
    var $aubl2;
    var $dXq4S;
    var $5fc53;
    var $8zOmE;
    var $koeKL;
    var $cQp7J;
    var $270P6;
    var $d7lJH;
    var $55hg5;
    const $9d12d6dcae452c2c$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
    const $9d12d6dcae452c2c$export$582c70653d60fda9 = (selector, event, handler)=>{
        const el = document.querySelector(selector);
        if (el) el.removeEventListener(event, handler);
    };
    const $9d12d6dcae452c2c$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
        $9d12d6dcae452c2c$export$582c70653d60fda9(selector, event, handler);
        const el = document.querySelector(selector);
        if (el) el.addEventListener(event, handler);
    };
    class $9d12d6dcae452c2c$export$be60a1d722248cfa extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onSubmit: (0, ($parcel$interopDefault($8Rkzz))),
                onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
                onFailure: (0, ($parcel$interopDefault($8Rkzz))),
                onEditStart: (0, ($parcel$interopDefault($8Rkzz))),
                onEditCancel: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        static getDerivedStateFromProps(props, state) {
            if (state.loading || !props.value) return null;
            return {
                value: props.value
            };
        }
        constructor(props){
            super(props), this.componentDidUpdate = (prevProps)=>{
                if (this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id) this.setState({
                    loading: false,
                    value: this.props.initialValue
                });
            }, this.isDialogOpened = false, this.isDialogConfirmPressed = false, this.onDialogContentReady = ()=>{
                setTimeout(()=>{
                    this.bindDialogFormHandlers();
                    this.isDialogOpened = true;
                    this.isDialogConfirmPressed = false;
                });
            }, this.bindDialogFormHandlers = ()=>{
                $9d12d6dcae452c2c$export$8e05e1932c4b20b0($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
            }, this.unbindDialogFormHandlers = ()=>{
                $9d12d6dcae452c2c$export$582c70653d60fda9($9d12d6dcae452c2c$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
            }, this.handleBeforeDialogHide = ()=>{
                this.unbindDialogFormHandlers();
                this.isDialogOpened = false;
                this.isDialogConfirmPressed = false;
            }, this.onClickDialogConfirm = ()=>{
                this.isDialogConfirmPressed = true;
            }, this.resetError = ()=>this.setState({
                    error: null
                }), this.submit = (transition, event)=>{
                const oldValue = this.state.value;
                const newValue = transition.to;
                const isEditFromIssueView = !(0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg') || (0, (0, parcelRequire("6Ou5i")).useIsEditFromIssueView)(event);
                if (!isEditFromIssueView && (0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, (0, parcelRequire("5fc53")).STATUS_TYPE), {
                    analytics: event,
                    attributes: {
                        fieldType: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                        oldValId: oldValue.id,
                        newValId: newValue.id,
                        oldStatusCategoryId: oldValue.statusCategory.id,
                        newStatusCategoryId: newValue.statusCategory.id,
                        isInlineEditing: true
                    }
                });
                this.setState({
                    loading: true,
                    value: newValue
                });
                this.props.onSubmit(oldValue, newValue, {
                    transition: transition
                }, event);
            }, this.success = ({ status: status, event: event, viaDialog: viaDialog = false })=>{
                this.setState({
                    loading: false,
                    lastSavedValue: status
                });
                this.props.fieldValueActions.setFieldValue(this.props.issueKey, (0, (0, parcelRequire("5fc53")).STATUS_TYPE), status);
                this.props.onSuccess(status, viaDialog, event);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
                (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)((0, (0, parcelRequire("270P6")).transitionIssueExperienceDescription)(true, 'POST', 'Issue View Status Service', this.props.projectType));
            }, this.failure = (error, event)=>{
                this.setState({
                    error: error,
                    loading: false,
                    value: this.state.lastSavedValue || this.props.value || this.props.initialValue
                });
                this.props.onFailure(error);
                const isValidationError = error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
                if (isValidationError) this.props.flagService.showFlag((0, (0, parcelRequire("55hg5")).default)(error.message));
                else this.props.flagService.showFlag((0, (0, parcelRequire("d7lJH")).default)());
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
                    validationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)
                });
                if ((0, (0, parcelRequire("k0ahW")).default)(error)) (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)((0, (0, parcelRequire("270P6")).transitionIssueExperienceDescription)(false, 'POST', 'Issue View Status Service', this.props.projectType, error.message, error.traceId, (0, (0, parcelRequire("4R6GH")).fg)('thor_populate_missing_attributes_across_issue_view') ? error.statusCode : undefined));
                else (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)((0, (0, parcelRequire("270P6")).transitionIssueExperienceDescription)(true, 'POST', 'Issue View Status Service', this.props.projectType));
            }, this.cancel = ()=>{
                this.setState({
                    loading: false,
                    value: this.props.value || this.props.initialValue
                });
                this.props.onEditCancel();
                this.props.workflowTransitionsActions.setTransitionInProgress(false);
            }, this.transitionStatus = async (transition, event)=>{
                const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal, renderIssueTransitionSuccessFlag: renderIssueTransitionSuccessFlag } = this.props;
                const newStatus = transition.to;
                this.submit(transition, event);
                try {
                    if (transition.hasScreen) {
                        const handleDialogSuccess = ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'issueTransition success', {
                                triggerPointKey: (0, (0, parcelRequire("cQp7J")).ISSUE_TRANSITION_STATUS_FIELD),
                                isModalOpen: true
                            });
                            (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                            return this.success({
                                status: newStatus,
                                event: event,
                                viaDialog: true
                            });
                        };
                        const handleDialogCancel = ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'issueTransition cancel', {
                                triggerPointKey: (0, (0, parcelRequire("cQp7J")).ISSUE_TRANSITION_STATUS_FIELD),
                                isModalOpen: true
                            });
                            return this.cancel();
                        };
                        const handleDialogError = ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'issueTransition failed', {
                                triggerPointKey: (0, (0, parcelRequire("cQp7J")).ISSUE_TRANSITION_STATUS_FIELD),
                                isModalOpen: true
                            });
                        };
                        if (renderIssueTransitionModal) {
                            const { issueId: issueId } = this.props;
                            renderIssueTransitionModal({
                                payload: {
                                    issueId: issueId,
                                    issueKey: issueKey,
                                    transitionId: transition.id
                                },
                                triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                                onDialogSuccess: handleDialogSuccess,
                                onDialogCancel: handleDialogCancel,
                                onDialogError: handleDialogError,
                                analyticsEvent: event
                            });
                        }
                    } else {
                        if ((0, (0, parcelRequire("f9Owr")).ff)('relay-migration-issue-fields-status_qg82c') && this.props.onUpdateStatusMutation) await this.props.onUpdateStatusMutation?.({
                            transitionId: transition.id,
                            newStatus: newStatus
                        });
                        else await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                            body: JSON.stringify({
                                transition: transition
                            })
                        });
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'issueTransition success', {
                            triggerPointKey: (0, (0, parcelRequire("cQp7J")).ISSUE_TRANSITION_STATUS_FIELD),
                            isModalOpen: false
                        });
                        (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                        this.success({
                            status: newStatus,
                            event: event
                        });
                    }
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$25529a3376b831fd), error);
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'issueTransition failed', {
                        triggerPointKey: (0, (0, parcelRequire("cQp7J")).ISSUE_TRANSITION_STATUS_FIELD),
                        isModalOpen: false
                    });
                    this.failure(error, event);
                }
            }, this.api = {
                transitionStatus: this.transitionStatus,
                resetError: this.resetError
            };
            const value = props.value || props.initialValue;
            if (value == null) throw new Error('Either value or initialValue prop is required.');
            this.state = {
                value: value,
                lastSavedValue: value,
                loading: false,
                error: null
            };
        }
        componentDidMount() {
            document.addEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
            document.addEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
        }
        componentWillUnmount() {
            document.removeEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
            document.removeEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
            this.unbindDialogFormHandlers();
            this.isDialogOpened = false;
        }
        render() {
            return this.props.children({
                ...this.state,
                ...this.api
            });
        }
    }
    const $9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabled = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$var$StatusServiceWithoutAriId, props);
    const $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdOld = (props)=>{
        const { issueId: issueId } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ariIssueId = issueId ? (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        }) : undefined;
        const renderIssueTransitionModal = (0, (0, parcelRequire("jpZIw")).useOpenIssueTransitionModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$export$be60a1d722248cfa, {
            ...props,
            renderIssueTransitionModal: renderIssueTransitionModal,
            issueId: ariIssueId
        });
    };
    const $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdNew = (props)=>{
        const { issueId: issueId } = props;
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ariIssueId = issueId ? (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        }) : undefined;
        const renderIssueTransitionModal = (0, (0, parcelRequire("jpZIw")).useOpenIssueTransitionModal)();
        const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, (0, parcelRequire("dTUtq")).useShowFlag)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$export$be60a1d722248cfa, {
            ...props,
            renderIssueTransitionModal: renderIssueTransitionModal,
            renderIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
            issueId: ariIssueId
        });
    };
    const $9d12d6dcae452c2c$var$StatusServiceWithoutAriId = (0, (0, parcelRequire("cSD7y")).componentWithFG)('show-modernised-issue-transition-success-flag', $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdNew, $9d12d6dcae452c2c$var$StatusServiceWithoutAriIdOld);
    const $9d12d6dcae452c2c$var$StatusWithValueService = (props)=>{
        const [, workflowTransitionsActions] = (0, (0, parcelRequire("aubl2")).useWorkflowTransitionsActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3fAi8")).FieldValueSubscriber), {
            issueKey: props.issueKey,
            fieldKey: (0, (0, parcelRequire("5fc53")).STATUS_TYPE)
        }, (value, fieldValueActions)=>{
            const statusServiceProps = {
                value: value,
                ...props,
                fieldValueActions: fieldValueActions,
                workflowTransitionsActions: workflowTransitionsActions
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement($9d12d6dcae452c2c$var$StatusServiceForMigrateIssueTransitionEnabled, statusServiceProps);
        });
    };
    const $9d12d6dcae452c2c$export$3e14b51c9a9c5a1a = (0, (0, parcelRequire("34Vv8")).default)($9d12d6dcae452c2c$var$StatusWithValueService);
});
parcelRegister("jpZIw", function(module, exports) {
    $parcel$export(module.exports, "useOpenIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$736bd10472c63b49);
    $parcel$export(module.exports, "useCloseIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$4629f18d511ad32e);
    $parcel$export(module.exports, "useTriggerIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$95a1e9702d78f223);
    $parcel$export(module.exports, "default", ()=>$f41d32ebe3d90af0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $6ikhl;
    var $2gCtH;
    var $ct2PA;
    var $3NlyR;
    var $8zOmE;
    var $2NMNM;
    var $9MiT2;
    var $fNOVA;
    var $1btwe;
    var $gjoNn;
    var $ipUU1;
    const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
        const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, (0, parcelRequire("fNOVA")).useIssueTransitionLabsOptIn)();
        const publish = (0, (0, parcelRequire("1btwe")).usePublishOpenIssueTransitionModalPubSub)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const { fireUIEvent: fireUIEvent } = (0, (0, parcelRequire("3NlyR")).useIssueTransitionUIAnalyticsEvent)();
        const { stateGet: { state: state } } = (0, (0, parcelRequire("9MiT2")).useIssueTransitionChangeboardingPreferences)();
        const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, (0, parcelRequire("ct2PA")).useIssueTransitionsOperationalAnalyticsEvent)();
        const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
        const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
        return (0, $5uXOq.useCallback)((nextState)=>{
            try {
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    fireOperationalAnalyticsTransitionScreenOpened({
                        actionSubject: 'issueTransition triggered',
                        isBenefitsModalFGEneabled: (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal'),
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                    });
                    openIssueTransitionModalNew({
                        nextState: nextState,
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        publishTriggerToOpenTransitions: publish,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                        fireUIEvent: fireUIEvent
                    });
                    return;
                }
                if (source === 'connect-issue') {
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        transitionModalVersion: 'NEW'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, [
            fireOperationalAnalyticsTransitionScreenOpened,
            isEnabled,
            source,
            isDisabled,
            nextDateToShowBenefitsModal,
            openIssueTransitionModalNew,
            publish,
            fireUIEvent,
            openIssueTransitionModalAction
        ]);
    };
    const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
        const [, { resetState: resetState }] = (0, (0, parcelRequire("6ikhl")).useInlineFieldsActions)();
        const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
            closeIssueTransitionModalAction();
            (0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf-transition-view-forge-rendering') && resetState();
            if (shouldOpenLegacyModal) {
                const onOpenDialog = ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
                };
                (0, (0, parcelRequire("ipUU1")).openLegacyIssueTransitionModal)({
                    issueKey: issueKey,
                    isReopenScenario: true,
                    transitionId: transitionId,
                    onDialogCancel: onDialogCancel,
                    onDialogError: onDialogError,
                    onDialogSuccess: onDialogSuccess,
                    onOpenDialog: onOpenDialog
                });
            }
        }, [
            closeIssueTransitionModalAction,
            createAnalyticsEvent,
            issueKey,
            onDialogCancel,
            onDialogError,
            onDialogSuccess,
            transitionId,
            resetState
        ]);
    };
    const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
        const state = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const actions = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
        const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
        return [
            state,
            {
                ...restActions,
                openIssueTransitionModal: openIssueTransitionModal
            }
        ];
    };
    var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;
});
parcelRegister("6ikhl", function(module, exports) {
    $parcel$export(module.exports, "useInlineFields", ()=>$d56dd4f138add558$export$71d5b5acb7d7f5ce);
    $parcel$export(module.exports, "useInlineField", ()=>$d56dd4f138add558$export$14c9655e9d9e873c);
    $parcel$export(module.exports, "useInlineFieldsActions", ()=>$d56dd4f138add558$export$cdb4b503c6154b35);
    var $3sQ5x;
    var $iXqE5;
    var $5rCpD;
    const $d56dd4f138add558$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'forge.inline-fields-state',
        initialState: {},
        actions: (0, parcelRequire("5rCpD")).default
    });
    const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store);
    const $d56dd4f138add558$export$14c9655e9d9e873c = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: (state, fieldId)=>state[fieldId]
    });
    const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: null
    });
});
parcelRegister("5rCpD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02373df28193ad93$export$2e2bcd8739ae039);
    var $hPhpd;
    const $02373df28193ad93$var$actions = {
        setFieldState: (0, parcelRequire("hPhpd")).setFieldState,
        resetState: (0, parcelRequire("hPhpd")).resetState,
        dispatchRetryFunction: (0, parcelRequire("hPhpd")).dispatchRetryFunction,
        dispatchFormSubmits: (0, parcelRequire("hPhpd")).dispatchFormSubmits
    };
    var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;
});
parcelRegister("hPhpd", function(module, exports) {
    $parcel$export(module.exports, "setFieldState", ()=>$9eca433be421af07$export$80fd62d9217dd703);
    $parcel$export(module.exports, "resetState", ()=>$9eca433be421af07$export$8e84bad0b35de9e8);
    $parcel$export(module.exports, "dispatchRetryFunction", ()=>$9eca433be421af07$export$27c59f06a7c1fe26);
    $parcel$export(module.exports, "dispatchFormSubmits", ()=>$9eca433be421af07$export$42fd5e650971333b);
    var $9J85a;
    const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const stateObject = {
                status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
                formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
                retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
            };
            setState({
                ...getState(),
                [data.fieldId]: stateObject
            });
        };
    const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
            const stateToOverride = {};
            Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
                stateToOverride[fieldId] = {
                    status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
                };
            });
            setState(stateToOverride);
        };
    const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
            const currentState = getState();
            const fieldData = currentState[fieldId];
            const retryFunction = fieldData?.retryFunction;
            retryFunction && retryFunction();
        };
    const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
            const currentState = getState();
            Object.keys(currentState).forEach((fieldId)=>{
                if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, (0, parcelRequire("9J85a")).dispatchFormSubmitAndBlurElements)(formRef);
                }
            });
        };
});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';
parcelRegister("9J85a", function(module, exports) {
    $parcel$export(module.exports, "submitForgeFormField", ()=>$b1c36799aab2b39a$export$7e50fee868362aa2);
    $parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", ()=>$b1c36799aab2b39a$export$4d639a8e0790daf2);
    $parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", ()=>$b1c36799aab2b39a$export$ee23412a8bea9333);
    const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
        formRef?.current?.requestSubmit();
    };
    const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
        $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
        if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
            if ('blur' in element && typeof element.blur === 'function') element?.blur();
        });
    };
    const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);
});
parcelRegister("ct2PA", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", ()=>$539a3126b0b48d6d$export$4d10663856b750d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                fieldCount: fieldCount
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
                preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
                issueViewAnalyticsSource: issueViewAnalyticsSource,
                isBenefitsModalDisabled: isBenefitsModalDisabled,
                dateToShowBenefitsModal: dateToShowBenefitsModal
            });
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
            fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
            fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
        };
    };
});
parcelRegister("3NlyR", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", ()=>$5656c248adec15f1$export$d0823e3d2e087672);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
            if (analyticsEvent !== undefined) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
            else {
                const createdAnalyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
            }
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireUIEvent: fireUIEvent
        };
    };
});
parcelRegister("1btwe", function(module, exports) {
    $parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", ()=>$9796b79be99bbec0$export$76b6328962c9935f);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXy8e;
    const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
            (0, (0, parcelRequire("iXy8e")).ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
                payload: payload,
                isEnabled: isEnabled
            });
        }, []);
});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';
parcelRegister("iXy8e", function(module, exports) {
    $parcel$export(module.exports, "ITSPubSub", ()=>$c6c4e897a3edd1a2$export$a3877931259d622e);
    var $da7iT;
    const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, (0, parcelRequire("da7iT")).PubSubHub)();
    const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
            ...$c6c4e897a3edd1a2$export$a3877931259d622e
        });
});
parcelRegister("da7iT", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$4d1dbccbbe967a62$export$e3607828f8f2c01e);
    class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("gjoNn", function(module, exports) {
    $parcel$export(module.exports, "TriggerIssueTransitionModalContainer", ()=>$18f6c8628e84d111$export$8ad65e459a406a8a);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalActions", ()=>$18f6c8628e84d111$export$68de001c738e4145);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalState", ()=>$18f6c8628e84d111$export$d3aceeec551eaab5);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $QnL9H;
    var $bpOxh;
    const $18f6c8628e84d111$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
        initialState: (0, parcelRequire("QnL9H")).initialState,
        actions: (0, parcelRequire("bpOxh"))
    });
    const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, (0, parcelRequire("gg7kZ")).createContainer)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$68de001c738e4145 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($18f6c8628e84d111$var$store);
});
parcelRegister("QnL9H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$b1651ed43432db50$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$7320afd6d2c7276d);
    $parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$8ed7400ca8e89de2);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
        inProgressTransitionID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
        isModalOpen: false,
        isBenefitsModalOpen: false,
        isSubsequentLoad: false,
        payload: {
            issueId: '',
            issueKey: '',
            transitionId: ''
        },
        id: 'issue-transition-dialog',
        title: null,
        fetchedIssueId: '',
        triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
        openLegacyTransitionsDialog: null,
        onDialogSuccess: null,
        onDialogCancel: null,
        onDialogError: null
    };
    const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
    const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';
});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';
parcelRegister("bpOxh", function(module, exports) {
    $parcel$export(module.exports, "closeIssueTransitionModal", ()=>(parcelRequire("3KYVT")).default);
    $parcel$export(module.exports, "openIssueTransitionModal", ()=>(parcelRequire("3cIaS")).default);
    $parcel$export(module.exports, "restoreState", ()=>(parcelRequire("keQtD")).default);
    $parcel$export(module.exports, "setFetchedIssueId", ()=>(parcelRequire("fb5Xn")).default);
    $parcel$export(module.exports, "hideBenefitsModal", ()=>(parcelRequire("bemkp")).default);
    $parcel$export(module.exports, "openIssueTransitionModalNew", ()=>(parcelRequire("bnv5t")).default);
    var $3KYVT;
    var $3cIaS;
    var $keQtD;
    var $fb5Xn;
    var $bemkp;
    var $bnv5t;
});
parcelRegister("3KYVT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09ddf425c332ed49$export$2e2bcd8739ae039);
    var $QnL9H;
    const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
            setState({
                ...(0, (0, parcelRequire("QnL9H")).initialState),
                isModalOpen: false,
                isSubsequentLoad: true
            });
        };
    var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;
});
parcelRegister("3cIaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc7e957c004b1c31$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $jtjyW;
    var $jHYHS;
    const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;
});
parcelRegister("eVcDT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25bfe0b90f22578e$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6BZYo;
    var $4tcSU;
    var $emTT1;
    class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
        constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
            this.onDialogSuccessCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogErrorCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogCancelCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.issueId = issueId;
            this.transitionId = transitionId;
            this.issueKey = issueKey;
            this.issueKeys = issueKeys;
        }
        static{
            this.onDialogContentReady = ()=>{
                setTimeout(()=>{
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).stop();
                });
            };
        }
        onDialogSuccess(onDialogSuccessCallback) {
            this.onDialogSuccessCallback = onDialogSuccessCallback;
            return this;
        }
        onDialogError(onDialogErrorCallback) {
            this.onDialogErrorCallback = onDialogErrorCallback;
            return this;
        }
        onDialogCancel(onDialogCancelCallback) {
            this.onDialogCancelCallback = onDialogCancelCallback;
            return this;
        }
        getIssueParam() {
            if (this.issueId != null) return `id=${this.issueId}`;
            if (this.issueKey != null) return `key=${this.issueKey}`;
            return '';
        }
        getUrl() {
            const { issueKeys: issueKeys } = this;
            if (issueKeys != null) return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
            return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&returnUrl=`;
        }
        async show() {
            document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            const FormDialog = await (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: 'wrc!jira.webresources:dialogs'
            });
            const dialog = new FormDialog({
                id: 'edit-issue-dialog',
                ajaxOptions: {
                    url: this.getUrl(),
                    dataType: 'json'
                },
                autoClose: true,
                widthClass: 'large',
                onDialogFinished: this.onDialogSuccessCallback,
                onUnSuccessfulSubmit: this.onDialogErrorCallback,
                shouldLoadHeritageFormDialogContext: true
            });
            const cancelNativeHandler = (event)=>{
                if (!(event instanceof CustomEvent)) return;
                const dialogElement = event.detail.popup;
                const { reason: reason } = event.detail;
                if (dialogElement.is(dialog.get$popup())) {
                    if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                    document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                    document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
                }
            };
            document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
            dialog.show();
        }
    }
});
parcelRegister("emTT1", function(module, exports) {
    $parcel$export(module.exports, "timeToRenderTransitionModal", ()=>$4a78c80c71ff3414$export$9d20a86383e90d09);
    var $dGrdR;
    const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue.time-to.render-issue-transition-screen',
        histogram: {
            result: '500_1000_2500_4000_7000_10000'
        }
    });
});
parcelRegister("jtjyW", function(module, exports) {
    $parcel$export(module.exports, "startIssueTransitionMetrics", ()=>$1832266ecf87e128$export$3fc439100e136a52);
    var $eTXmK;
    var $4R6GH;
    var $lL2Jl;
    var $lP1Jn;
    var $fc6nm;
    const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionLoadUFOExperience).start();
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionUFOExperience).start();
        const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("lP1Jn")).issueTransittionModalLoadSubsequent) : (0, (0, parcelRequire("lP1Jn")).issueTransitionModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal');
        issueTransitionModalLoadMetric.start();
        if ((0, (0, parcelRequire("4R6GH")).fg)('ui-modifications-on-issue-transition-view_7z1g0')) (0, (0, parcelRequire("fc6nm")).startUimTTI)();
    };
});
parcelRegister("lL2Jl", function(module, exports) {
    $parcel$export(module.exports, "IssueTransitionLoadUFOExperience", ()=>$f07939f1a4892f29$export$8fb308d8abecd81a);
    $parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", ()=>$f07939f1a4892f29$export$bd3bf8b90a131c50);
    $parcel$export(module.exports, "IssueTransitionUFOExperience", ()=>$f07939f1a4892f29$export$2f3b26e8acf79182);
    var $atdLB;
    var $duUGa;
    const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-load'
    });
    const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-sumbit'
    });
    const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-issue'
    });
});
parcelRegister("lP1Jn", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionModalLoad", ()=>$e48205cb6c384272$export$772fb4a8bd181fd6);
    $parcel$export(module.exports, "issueTransittionModalLoadSubsequent", ()=>$e48205cb6c384272$export$afa89f024c56a00a);
    var $dGrdR;
    const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal'
    });
    const $e48205cb6c384272$export$afa89f024c56a00a = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal-subsequent'
    });
});
parcelRegister("fc6nm", function(module, exports) {
    $parcel$export(module.exports, "startUimTTI", ()=>$50f6a9f98192a4eb$export$ae34c17d9cd2c876);
    $parcel$export(module.exports, "markIssueTransitionLoaded", ()=>$50f6a9f98192a4eb$export$7cc1bb35860c7c25);
    $parcel$export(module.exports, "stopTTI", ()=>$50f6a9f98192a4eb$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$50f6a9f98192a4eb$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$50f6a9f98192a4eb$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$50f6a9f98192a4eb$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$50f6a9f98192a4eb$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'ui-modifications-in-issue-transition',
        timings: [
            {
                key: 'issue-transition-tti-delta',
                startMark: 'issue-transition-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
    };
    const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
    const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
            customData: customData
        });
    };
    const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
    };
    const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
    };
    const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
    };
    const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
    };
});
parcelRegister("jHYHS", function(module, exports) {
    $parcel$export(module.exports, "isNewTransitionScreenEnabled", ()=>$5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    const $5f3a7dc1f1182e00$export$3e9c47f2b27760a = (triggerPointKey)=>{
        const triggerPointsFlags = {
            'issue-transition-issue-view': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view'),
            'issue-transition-issue-view-shortcut-dialog': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view-shortcut'),
            'issue-transition-board-card-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-board-card-transition'),
            'issue-transition-advanced-roadmaps-jira-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-advanced-roadmaps-jira-transition'),
            'issue-transition-command-palette-status-field-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-command-palette-status'),
            'issue-transition-issue-results-shortcut-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-results-shortcut-transition'),
            'issue-transition-backlog-inline-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-backlog-inline-transition'),
            'issue-transition-status-field-trigger': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-status-field-trigger'),
            'trigger-point-key-not-defined': (0, (0, parcelRequire("4R6GH")).fg)('trigger-point-key-not-defined')
        };
        return triggerPointsFlags[triggerPointKey];
    };
    const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return true;
        if ((0, (0, parcelRequire("4R6GH")).fg)('modern_its_render_flag_migration') ? !(0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') : !(0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z')) return false;
        if (!triggerPointKey || !$5f3a7dc1f1182e00$export$3e9c47f2b27760a(triggerPointKey)) return false;
        return preferNewIssueTransitionScreen || (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb');
    };
});
parcelRegister("keQtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9984214aecd9b0cd$export$2e2bcd8739ae039);
    const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
            setState(stateToRestore);
        };
    var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;
});
parcelRegister("fb5Xn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58f04f71b4951234$export$2e2bcd8739ae039);
    const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { fetchedIssueId: fetchedIssueId } = currentState;
            if (issueId !== fetchedIssueId) setState({
                ...currentState,
                fetchedIssueId: issueId
            });
        };
    var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;
});
parcelRegister("bemkp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66c42f9cd1814e06$export$2e2bcd8739ae039);
    var $QnL9H;
    var $jtjyW;
    const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_MODERN_TRANSITION_MODAL)) {
                (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: true
                });
            } else if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_LEGACY_TRANSITION_MODAL)) {
                const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: false
                });
                openLegacyTransitionsDialog?.();
            }
        };
    var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;
});
parcelRegister("bnv5t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0522276a96c69778$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $jtjyW;
    var $jHYHS;
    const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    if (issueViewAnalyticsSource === 'connect-issue') {
                        publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                        fireUIEvent?.({
                            actionSubject: 'issueTransition',
                            actionSubjectId: 'connectIssue',
                            action: 'opened'
                        });
                        return;
                    }
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                    return;
                }
                const currentDate = new Date();
                const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
                const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
                if (((0, (0, parcelRequire("4R6GH")).fg)('modern_its_render_flag_migration') ? (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') : (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z')) && !isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate) {
                    transitionModalVersion = 'NEW';
                    const callback = ()=>{
                        (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                        new (0, (0, parcelRequire("eVcDT")).default)({
                            issueKey: issueKey,
                            transitionId: transitionId
                        }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                    };
                    setState({
                        ...currentState,
                        isBenefitsModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState,
                        openLegacyTransitionsDialog: callback
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;
});
parcelRegister("ipUU1", function(module, exports) {
    $parcel$export(module.exports, "openLegacyIssueTransitionModal", ()=>$f258fa9a0604f29b$export$6bfef2005bd55204);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
        try {
            (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
            new (0, (0, parcelRequire("eVcDT")).default)({
                issueKey: issueKey,
                transitionId: transitionId
            }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
            onOpenDialog?.();
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: 'OLD',
                    isReopenScenario: isReopenScenario
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("dTUtq", function(module, exports) {
    $parcel$export(module.exports, "useShowFlag", ()=>$4e3d7d0cd8105532$export$46b5557ad4264ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $6OtcO;
    const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
            try {
                showFlag((0, (0, parcelRequire("6OtcO")).getTransitionSuccessFlag)(issueKey, status, formatMessage));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'showSuccessFlag',
                        packageName: 'jiraIssueTransitionUseShowFlag',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            formatMessage,
            showFlag
        ]);
        const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey)=>showFlag((0, (0, parcelRequire("6OtcO")).getTransitionFailureFlag)(issueKey, formatMessage)), [
            formatMessage,
            showFlag
        ]);
        return {
            showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
            showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
        };
    };
});
parcelRegister("6OtcO", function(module, exports) {
    $parcel$export(module.exports, "getTransitionSuccessFlag", ()=>$12ec3642dfb43880$export$8cfa71b43d733669);
    $parcel$export(module.exports, "getTransitionFailureFlag", ()=>$12ec3642dfb43880$export$d9438db72c9548f1);
    var $6s1PB;
    var $7HGHK;
    var $4O0IR;
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
    const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
        const showLinkToIssue = Boolean(issueKey && status);
        if (showLinkToIssue) return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
                issueKey: issueKey,
                status: status
            }),
            description: (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulFlagDescription
        };
        return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessful)
        };
    };
    const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage)=>({
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
            type: 'error',
            title: issueKey ? formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureWithKey, {
                issueKey: issueKey
            }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailure)
        });
});
parcelRegister("4O0IR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d201576bd998790a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d201576bd998790a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTransitionSuccessful: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
            "defaultMessage": "Issue has been updated."
        },
        issueTransitionSuccessfulWithIssueKeyAndStatus: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
            "defaultMessage": "{issueKey} moved to {status}."
        },
        issueTransitionSuccessfulFlagDescription: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
            "defaultMessage": "Kudos for keeping things up-to-date!"
        },
        issueTransitionFailure: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
            "defaultMessage": "Issue could not be updated."
        },
        issueTransitionFailureWithKey: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
            "defaultMessage": "We couldn't update {issueKey}."
        },
        viewIssue: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
            "defaultMessage": "View issue"
        },
        issueTransitionSuccessfulIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
            "defaultMessage": "Work item has been updated."
        },
        issueTransitionFailureIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
            "defaultMessage": "Work item could not be updated."
        },
        viewIssueIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
parcelRegister("k0ahW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$022f11dfbb4aab97$export$2e2bcd8739ae039);
    var $jJZqs;
    const $022f11dfbb4aab97$var$errorCases4xx = [
        (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f),
        (0, $3cd8a0ece36fbae5$export$5244030134e99)
    ];
    const $022f11dfbb4aab97$var$statusCodeIs4xx = (statusCode)=>$022f11dfbb4aab97$var$errorCases4xx.some((status)=>status === statusCode);
    var $022f11dfbb4aab97$export$2e2bcd8739ae039 = (error)=>{
        const isValidationError = error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
        if (isValidationError) return false;
        const isFetchError = error instanceof (0, (0, parcelRequire("jJZqs")).default);
        if (isFetchError && !!error.statusCode && $022f11dfbb4aab97$var$statusCodeIs4xx(error.statusCode)) return false;
        if (error.name === (0, (0, parcelRequire("jJZqs")).TYPE_ERROR_NAME) || error.name === (0, (0, parcelRequire("jJZqs")).ABORT_ERROR_NAME)) return false;
        return true;
    };
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("aubl2", function(module, exports) {
    $parcel$export(module.exports, "useWorkflowTransitionsValue", ()=>$8cffab54c7064731$export$435cba24c8d1ddf6);
    $parcel$export(module.exports, "useWorkflowTransitionsTransitionInProgress", ()=>$8cffab54c7064731$export$9b35656991b0ecda);
    $parcel$export(module.exports, "useWorkflowTransitionsActions", ()=>$8cffab54c7064731$export$d5245ade1619037b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4PVOa;
    const $8cffab54c7064731$export$435cba24c8d1ddf6 = ()=>{
        const [value, { setState: setState }] = (0, (0, parcelRequire("4PVOa")).useWorkflowTransitionsStoreValue)();
        return [
            value,
            setState
        ];
    };
    const $8cffab54c7064731$export$9b35656991b0ecda = ()=>{
        const [value] = (0, (0, parcelRequire("4PVOa")).useWorkflowTransitionsStoreTransitionInProgress)();
        return value;
    };
    const $8cffab54c7064731$export$d5245ade1619037b = ()=>{
        const [, actions] = (0, (0, parcelRequire("4PVOa")).useWorkflowTransitionsStoreActions)();
        const workflowActions = (0, $5uXOq.useMemo)(()=>{
            const setState = (partialState)=>{
                actions.setState(partialState);
            };
            const setTransitionInProgress = (isLoading)=>{
                actions.setTransitionInProgress(isLoading);
            };
            return {
                setState: setState,
                setTransitionInProgress: setTransitionInProgress
            };
        }, [
            actions
        ]);
        return [
            null,
            workflowActions
        ];
    };
});
parcelRegister("4PVOa", function(module, exports) {
    $parcel$export(module.exports, "useWorkflowTransitionsStoreValue", ()=>$e5b56d683dce601e$export$435e780321f76edc);
    $parcel$export(module.exports, "useWorkflowTransitionsStoreTransitionInProgress", ()=>$e5b56d683dce601e$export$35c153667c57d035);
    $parcel$export(module.exports, "useWorkflowTransitionsStoreActions", ()=>$e5b56d683dce601e$export$370707f36c1f66df);
    $parcel$export(module.exports, "WorkflowTransitionsStoreContainer", ()=>$e5b56d683dce601e$export$1e23e2bdfc599859);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $7maqj;
    const $e5b56d683dce601e$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'workflow-transitions',
        initialState: {
            data: null,
            loading: false,
            error: null,
            ui: {
                transitionInProgress: false
            }
        },
        actions: (0, parcelRequire("7maqj")).actions
    });
    const $e5b56d683dce601e$export$435e780321f76edc = (0, (0, parcelRequire("3sQ5x")).createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
        selector: (state)=>state
    });
    const $e5b56d683dce601e$export$35c153667c57d035 = (0, (0, parcelRequire("3sQ5x")).createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
        selector: (state)=>state.ui.transitionInProgress
    });
    const $e5b56d683dce601e$export$370707f36c1f66df = (0, (0, parcelRequire("3sQ5x")).createHook)($e5b56d683dce601e$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $e5b56d683dce601e$export$1e23e2bdfc599859 = (0, (0, parcelRequire("gg7kZ")).createContainer)($e5b56d683dce601e$export$6f57813fe9f31bf9);
});
parcelRegister("7maqj", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$d085cbf81f7ccf7c$export$e324594224ef24da);
    const $d085cbf81f7ccf7c$var$setState = (state = {})=>({ setState: setSweetState, getState: getState })=>{
            const newState = {
                ...getState(),
                ...state
            };
            setSweetState(newState);
        };
    const $d085cbf81f7ccf7c$export$c4d3076bd1999d92 = (transitionInProgress)=>({ setState: setSweetState, getState: getState })=>{
            setSweetState({
                ui: {
                    ...getState().ui,
                    transitionInProgress: transitionInProgress
                }
            });
        };
    const $d085cbf81f7ccf7c$export$e324594224ef24da = {
        setState: $d085cbf81f7ccf7c$var$setState,
        setTransitionInProgress: $d085cbf81f7ccf7c$export$c4d3076bd1999d92
    };
});
const $878fbedb9c4ca329$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $878fbedb9c4ca329$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $878fbedb9c4ca329$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $878fbedb9c4ca329$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $878fbedb9c4ca329$export$624e7abc8d9cada5 = 'ADMINISTER';
parcelRegister("cQp7J", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TRANSITION_STATUS_FIELD", ()=>$5101b286174175c1$export$a6eb4c39beb71474);
    const $5101b286174175c1$export$f048d91ccaf92408 = {
        TIME_TO_RENDER_OPTIONS: 'jira.fe.issue.fields.status.time-to.render-options',
        TIME_TO_APPLY_SELECTED_OPTION: 'jira.fe.issue.fields.status.time-to.reflect-selected',
        TIME_TO_CANCEL_DROPDOWN: 'jira.fe.issue.fields.status.time-to.cancel-dropdown',
        TIME_TO_OPEN_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.open-transition-screen',
        TIME_TO_CONFIRM_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.confirm-transition-screen',
        TIME_TO_CANCEL_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.cancel-transition-screen',
        TIME_TO_ERROR_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.error-transition-screen'
    };
    const $5101b286174175c1$export$a6eb4c39beb71474 = 'issue-transition-status-field';
});
parcelRegister("270P6", function(module, exports) {
    $parcel$export(module.exports, "transitionIssueExperienceDescription", ()=>$435fd9ced643a015$export$1afc7ca514c2b5b9);
    var $4Pf62;
    var $4R6GH;
    var $efvDm;
    var $ldyPw;
    const $435fd9ced643a015$export$1afc7ca514c2b5b9 = (wasSuccessful, method, analyticsSource, projectType, errorMessage, traceId, statusCode)=>{
        let application = null;
        let edition = null;
        if (projectType !== null) try {
            const { appEditions: appEditions } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
            application = (0, (0, parcelRequire("efvDm")).getApplicationForProject)(projectType);
            edition = (0, (0, parcelRequire("ldyPw")).getEdition)(application, appEditions);
        } catch (e) {}
        const additionalAttributes = {};
        if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
        if (traceId != null) additionalAttributes.traceId = traceId;
        if (statusCode && (0, (0, parcelRequire("4R6GH")).fg)('thor_populate_missing_attributes_across_issue_view')) additionalAttributes.statusCode = statusCode;
        return {
            experience: 'transitionIssue',
            wasExperienceSuccesful: wasSuccessful,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: {
                ...additionalAttributes,
                method: method
            }
        };
    };
});
parcelRegister("d7lJH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf133abbd76f3557$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bf133abbd76f3557$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-field-status.services.flags.transition-failed-error.main.title",
            "defaultMessage": "We couldn't update the status"
        },
        description: {
            "id": "issue-field-status.services.flags.transition-failed-error.main.description",
            "defaultMessage": "Check your network connection, then try reloading the issue."
        }
    });
    const $bf133abbd76f3557$var$statusTransitionErrorFlag = ()=>({
            type: 'error',
            title: $bf133abbd76f3557$var$messages.title,
            description: $bf133abbd76f3557$var$messages.description,
            isAutoDismiss: true
        });
    var $bf133abbd76f3557$export$2e2bcd8739ae039 = $bf133abbd76f3557$var$statusTransitionErrorFlag;
});
parcelRegister("55hg5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d918a4398288451$export$2e2bcd8739ae039);
    var $7VHMR;
    const $7d918a4398288451$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-field-status.services.flags.validation-error.main.title",
            "defaultMessage": "Transition failed"
        }
    });
    const $7d918a4398288451$var$statusTransitionValidationErrorFlag = (description)=>({
            type: 'warning',
            title: $7d918a4398288451$var$messages.title,
            description: {
                id: 'issue-field.status.services.flags.validation-error.main.description',
                defaultMessage: description
            },
            isAutoDismiss: true
        });
    var $7d918a4398288451$export$2e2bcd8739ae039 = $7d918a4398288451$var$statusTransitionValidationErrorFlag;
});
parcelRegister("bUXoM", function(module, exports) {
    $parcel$export(module.exports, "TransitionsQuery", ()=>$16e688304a9816fa$export$e166c7039d71);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $7iJwP;
    var $crJh3;
    const $16e688304a9816fa$export$e166c7039d71 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue.fields.status.transitions-query"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "fields.status.transitions-query",
            packageName: "jiraIssueFieldStatus",
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("crJh3")).TransitionsQuery), props)));
});
parcelRegister("crJh3", function(module, exports) {
    $parcel$export(module.exports, "getStatusTransitionsUrl", ()=>$d2bb6497d10e73da$export$661439a50b90a96f);
    $parcel$export(module.exports, "TransitionsQuery", ()=>$d2bb6497d10e73da$export$e166c7039d71);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $co1wz;
    var $4R6GH;
    var $7f4tk;
    var $jJZqs;
    var $3fAi8;
    var $gXz4p;
    var $6r7fT;
    var $k0ahW;
    var $4PVOa;
    var $aubl2;
    var $8zOmE;
    var $270P6;
    var $399w3;
    var $iLLko;
    const $d2bb6497d10e73da$export$661439a50b90a96f = (_baseUrl, issueKey)=>`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`;
    const $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics = (successful, projectType, errorMessage, traceId, statusCode)=>{
        const description = typeof errorMessage === 'string' ? (0, (0, parcelRequire("270P6")).transitionIssueExperienceDescription)(successful, 'GET', 'Issue View BaseTransitionsQuery', projectType || null, errorMessage, traceId, (0, (0, parcelRequire("4R6GH")).fg)('thor_populate_missing_attributes_across_issue_view') ? statusCode : undefined) : (0, (0, parcelRequire("270P6")).transitionIssueExperienceDescription)(successful, 'GET', 'Issue View BaseTransitionsQuery', projectType || null);
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)(description);
    };
    const $d2bb6497d10e73da$export$4f5a845fd57540e7 = (props)=>{
        const { status: status, issueKey: issueKey, baseUrl: baseUrl, projectType: projectType, preFetch: preFetch, createAnalyticsEvent: createAnalyticsEvent, isSaving: isSaving } = props;
        const [transitionsState, setTransitionsState] = (0, (0, parcelRequire("aubl2")).useWorkflowTransitionsValue)();
        const isSingletonRequestRef = (0, $5uXOq.useRef)(false);
        const [fieldValues] = (0, (0, parcelRequire("3fAi8")).useFieldsValues)(issueKey);
        const { fetchTransitions: fetchTransitions } = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c') ? (0, (0, parcelRequire("399w3")).useFetchTransitionsForStatusField)({
            issueKey: issueKey
        }) : {
            fetchTransitions: ()=>[]
        };
        const fetch = (0, $5uXOq.useCallback)(async (event)=>{
            if (transitionsState.loading) return;
            if (isSingletonRequestRef.current) return;
            isSingletonRequestRef.current = true;
            setTransitionsState({
                loading: true,
                error: null
            });
            try {
                let transitions;
                if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c')) transitions = await fetchTransitions();
                else {
                    const result = await (0, (0, parcelRequire("7f4tk")).default)($d2bb6497d10e73da$export$661439a50b90a96f(baseUrl, issueKey));
                    transitions = (0, (0, parcelRequire("iLLko")).filterTransitionsWithDestinationAndCategory)(result.transitions).map((0, (0, parcelRequire("iLLko")).transformTransitionToStore));
                }
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(event, 'statusField transitionsFetched', 'statusField', {
                    count: transitions.length
                });
                $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(true, projectType);
                setTransitionsState({
                    data: transitions,
                    loading: false,
                    error: null
                });
            } catch (e) {
                (0, (0, parcelRequire("6r7fT")).trackOrLogClientError)((0, $878fbedb9c4ca329$export$71a8e2ae8cfade56), e.toString(), e);
                if ((0, (0, parcelRequire("k0ahW")).default)(e)) {
                    const shouldSendStatusCode = (0, (0, parcelRequire("4R6GH")).fg)('thor_populate_missing_attributes_across_issue_view') && e instanceof (0, (0, parcelRequire("jJZqs")).default);
                    $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(false, projectType, `${e.name || ''} ${e.message}`.trim(), e.traceId, shouldSendStatusCode ? e.statusCode : undefined);
                } else $d2bb6497d10e73da$var$enhancedSendExperienceAnalytics(true, projectType);
                setTransitionsState({
                    data: null,
                    loading: false,
                    error: e
                });
            }
            isSingletonRequestRef.current = false;
        }, [
            baseUrl,
            issueKey,
            projectType,
            setTransitionsState,
            fieldValues
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
        }, [
            issueKey,
            preFetch,
            createAnalyticsEvent,
            setTransitionsState,
            fetch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSaving) setTransitionsState({
                data: null
            });
            else if (!isSaving && preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
        }, [
            isSaving,
            status,
            preFetch,
            createAnalyticsEvent,
            setTransitionsState,
            fetch
        ]);
        return props.children({
            ...transitionsState,
            data: transitionsState.data ? transitionsState.data.map((0, (0, parcelRequire("iLLko")).transformTransitionFromStore)) : null,
            fetch: fetch
        });
    };
    const $d2bb6497d10e73da$export$833bdce708ba82a6 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4PVOa")).WorkflowTransitionsStoreContainer), {
            scope: props.issueKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d2bb6497d10e73da$export$4f5a845fd57540e7, props));
    const $d2bb6497d10e73da$export$e166c7039d71 = (0, (0, parcelRequire("cb25w")).default)()($d2bb6497d10e73da$export$833bdce708ba82a6);
});
parcelRegister("6r7fT", function(module, exports) {
    $parcel$export(module.exports, "trackOrLogClientError", ()=>$cdae82c8a9c247d5$export$2fc29872103bf255);
    var $dJl1T;
    var $jcw0u;
    var $fZneA;
    const $cdae82c8a9c247d5$export$c392d6295c0a29c7 = (location, message, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            attributes: {
                message: message
            },
            meta: {
                id: location,
                packageName: 'jiraIssueViewCommonUtils'
            }
        });
    };
    const $cdae82c8a9c247d5$export$2fc29872103bf255 = (location, message, error)=>{
        if (error instanceof TypeError && (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) $cdae82c8a9c247d5$export$c392d6295c0a29c7(location, message, error);
        else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message, error);
    };
});
parcelRegister("399w3", function(module, exports) {
    $parcel$export(module.exports, "useFetchTransitionsForStatusField", ()=>$bac4918992388b6b$export$bff299af05778444);
    var $cO6TL;
    var $5uXOq = parcelRequire("5uXOq");
    var $eiowN = parcelRequire("eiowN");
    var $5yJb9;
    var $koeKL;
    const $bac4918992388b6b$export$bff299af05778444 = ({ issueKey: issueKey })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const fetchTransitions = (0, $5uXOq.useCallback)(async ()=>{
            const data = await (0, $eiowN.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("cO6TL")).default), {
                issueKey: issueKey,
                cloudId: cloudId
            }).toPromise();
            return data?.jira?.issueByKey?.statusField?.transitions?.edges?.map((edge)=>({
                    id: edge?.node?.transitionId ?? 0,
                    name: edge?.node?.name ?? '',
                    hasScreen: edge?.node?.hasScreen ?? false,
                    isGlobal: edge?.node?.isGlobal ?? false,
                    isInitial: edge?.node?.isInitial ?? false,
                    isConditional: edge?.node?.hasPreConditions ?? false,
                    isLooped: edge?.node?.isLooped ?? false,
                    to: {
                        id: parseInt(edge?.node?.to?.statusId ?? '', 10),
                        name: edge?.node?.to?.name ?? '',
                        description: '',
                        statusCategory: {
                            id: parseInt(edge?.node?.to?.statusCategory?.statusCategoryId ?? '', 10)
                        }
                    },
                    from: null
                })) ?? [];
        }, [
            cloudId,
            issueKey
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                fetchTransitions: fetchTransitions
            }), [
            fetchTransitions
        ]);
    };
});
parcelRegister("cO6TL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51bba1402798face$export$2e2bcd8739ae039);
    const $51bba1402798face$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "issueKey"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "issueKey"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "transitionId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        }, v4 = {
            "kind": "ScalarField",
            "name": "hasScreen"
        }, v5 = {
            "kind": "ScalarField",
            "name": "isGlobal"
        }, v6 = {
            "kind": "ScalarField",
            "name": "isInitial"
        }, v7 = {
            "kind": "ScalarField",
            "name": "isLooped"
        }, v8 = {
            "kind": "ScalarField",
            "name": "hasPreConditions"
        }, v9 = {
            "kind": "ScalarField",
            "name": "statusId"
        }, v10 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v11 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "transitionsRelayQueryForStatusFieldQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusField",
                                        "kind": "LinkedField",
                                        "name": "statusField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraTransitionConnection",
                                                "kind": "LinkedField",
                                                "name": "transitions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraTransitionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraTransition",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v2,
                                                                    v3,
                                                                    v4,
                                                                    v5,
                                                                    v6,
                                                                    v7,
                                                                    v8,
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v9,
                                                                            v3,
                                                                            {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v10
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "transitionsRelayQueryForStatusFieldQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraStatusField",
                                        "kind": "LinkedField",
                                        "name": "statusField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraTransitionConnection",
                                                "kind": "LinkedField",
                                                "name": "transitions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraTransitionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraTransition",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v2,
                                                                    v3,
                                                                    v4,
                                                                    v5,
                                                                    v6,
                                                                    v7,
                                                                    v8,
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v9,
                                                                            v3,
                                                                            {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v10,
                                                                                    v11
                                                                                ]
                                                                            },
                                                                            v11
                                                                        ]
                                                                    },
                                                                    v11
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v11
                                        ]
                                    },
                                    v11
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "28659a6750bb8a6cc2a4f5ae9f3557603b7b1ef5dd0d1fb5065f9082560406d7",
                "metadata": {},
                "name": "transitionsRelayQueryForStatusFieldQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $51bba1402798face$var$node.hash = "149d6549724f4aab7d08100ce8f1bebb";
    var $51bba1402798face$export$2e2bcd8739ae039 = $51bba1402798face$var$node;
});
parcelRegister("iLLko", function(module, exports) {
    $parcel$export(module.exports, "filterTransitionsWithDestinationAndCategory", ()=>$ad6093c5a367a301$export$f27913d8073a7e1);
    $parcel$export(module.exports, "transformTransitionToStore", ()=>$ad6093c5a367a301$export$3482bcbbb2a2b63a);
    $parcel$export(module.exports, "transformTransitionFromStore", ()=>$ad6093c5a367a301$export$1eab4bccf39ab44d);
    const $ad6093c5a367a301$export$f27913d8073a7e1 = (transitions = [])=>transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory);
    const $ad6093c5a367a301$export$3482bcbbb2a2b63a = (transition)=>({
            id: parseInt(transition.id, 10),
            name: transition.name,
            hasScreen: transition.hasScreen,
            isGlobal: transition.isGlobal,
            isInitial: transition.isInitial,
            isConditional: transition.isConditional,
            ...typeof transition.isLooped === 'boolean' && {
                isLooped: transition.isLooped
            },
            to: {
                id: parseInt(transition.to.id, 10),
                name: transition.to.name,
                description: '',
                statusCategory: {
                    id: transition.to.statusCategory.id
                }
            },
            from: null
        });
    const $ad6093c5a367a301$export$1eab4bccf39ab44d = (transition)=>({
            id: String(transition.id),
            name: transition.name,
            hasScreen: transition.hasScreen,
            isGlobal: transition.isGlobal,
            isInitial: transition.isInitial,
            isConditional: transition.isConditional,
            ...typeof transition.isLooped === 'boolean' && {
                isLooped: transition.isLooped
            },
            to: {
                id: String(transition.to.id),
                name: transition.to.name,
                statusCategory: {
                    id: transition.to.statusCategory.id
                }
            }
        });
});
parcelRegister("3AZQW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7233d047052dbe1d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7233d047052dbe1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        markedAsDoneFlagTitle: {
            "id": "business-list.list-view.status-cell.marked-as-done-flag-title",
            "defaultMessage": "Nice one!"
        },
        markedAsDone: {
            "id": "business-list.list-view.status-cell.marked-as-done",
            "defaultMessage": "Marked \"{issue}\" as {statusName}"
        },
        viewIssue: {
            "id": "business-list.list-view.status-cell.view-issue",
            "defaultMessage": "View issue"
        },
        markedAsDoneOld: {
            "id": "business-list.list-view.status-cell.marked-as-done-old",
            "defaultMessage": "Marked {link} as {statusName}"
        },
        placeholder: {
            "id": "business-list.list-view.status-cell.placeholder",
            "defaultMessage": "Select Status"
        },
        cannotLoadTransitions: {
            "id": "business-list.list-view.status-cell.cannot-load-transitions",
            "defaultMessage": "Couldn't load the statuses."
        },
        noSearchResults: {
            "id": "business-list.list-view.status-cell.no-search-results",
            "defaultMessage": "It looks like we can't find any statuses that match."
        },
        viewIssueIssueTermRefresh: {
            "id": "business-list.list-view.status-cell.view-issue-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
parcelRegister("5uSmq", function(module, exports) {
    $parcel$export(module.exports, "transformValue", ()=>$e92a4dbef880f9fe$export$98c150630afe5417);
    $parcel$export(module.exports, "toAppearance", ()=>$e92a4dbef880f9fe$export$cbc76b787f60c037);
    var $gULOk;
    const $e92a4dbef880f9fe$var$appearanceMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 'default',
        [(0, (0, parcelRequire("gULOk")).TODO)]: 'default',
        [(0, (0, parcelRequire("gULOk")).DONE)]: 'success',
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 'inprogress'
    };
    const $e92a4dbef880f9fe$export$98c150630afe5417 = (value)=>{
        if (!value) return [];
        const valuesArray = Array.isArray(value) ? value : [
            value
        ];
        return valuesArray.map(({ name: name })=>({
                value: name,
                label: name
            }));
    };
    const $e92a4dbef880f9fe$export$cbc76b787f60c037 = (statusValue)=>statusValue.statusCategory.id ? $e92a4dbef880f9fe$var$appearanceMap[(0, (0, parcelRequire("gULOk")).statusCategoryForId)(statusValue.statusCategory.id)] : $e92a4dbef880f9fe$var$appearanceMap[0, (0, parcelRequire("gULOk")).UNDEFINED];
});
parcelRegister("9gyyM", function(module, exports) {
    $parcel$export(module.exports, "TextAreaCell", ()=>$309d1fc5b0994c7c$export$1e25c2913c11e42f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $bG3pQ;
    var $hE5wF;
    var $4R6GH;
    var $lQE94;
    var $8zOmE;
    var $2NMNM;
    var $fCo6Y;
    var $lI995;
    var $fkAB3;
    var $4nnGr;
    const $309d1fc5b0994c7c$export$1e25c2913c11e42f = (0, $5uXOq.memo)(({ fieldKey: fieldKey, fieldType: fieldType, fieldValue: fieldValue, onClick: onClick, issueKey: issueKey, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { issueViewInteraction: issueViewInteraction } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const [textValue, setTextValue] = (0, $5uXOq.useState)('');
        const onEmbedClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'textAreaCell clicked', 'listEmbedIssue');
            (0, (0, parcelRequire("bG3pQ")).openViewFromEmbed)({
                key: (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
                value: issueKey
            });
        }, [
            createAnalyticsEvent,
            issueKey
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const [{ value: extractedFieldValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: fieldValue
        });
        const cellValue = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? extractedFieldValue : fieldValue;
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("fkAB3")).getADFMarkup)((0, (0, parcelRequire("fCo6Y")).convertAdfStringToObject)(cellValue)).then((value)=>setTextValue(value));
        }, [
            cellValue
        ]);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            issueViewInteraction === 'openNewTab' ? onEmbedClick() : onClick(event);
        }, [
            issueViewInteraction,
            onClick,
            onEmbedClick
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.code === 'Enter') {
                handleClick(event);
                return true;
            }
            return false;
        }, [
            handleClick
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onClick: ()=>true,
                onKeyDown: handleKeyDown
            }), [
            handleKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $309d1fc5b0994c7c$var$wrapperStyles,
            onClick: handleClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $309d1fc5b0994c7c$var$textStyles,
            as: "span"
        }, textValue));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($309d1fc5b0994c7c$export$e6dfd72ab29f8598, {
            isFocused: isSelected,
            onClick: handleClick,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            ref: onWrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, textValue));
    });
    const $309d1fc5b0994c7c$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lI995")).WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_80omtlke _9n9ou2gc _17kn15vq _1hrp15vq _x3fa1l2s",
                __cmplp.className
            ])
        });
    });
    $309d1fc5b0994c7c$export$e6dfd72ab29f8598.displayName = 'Wrapper';
    const $309d1fc5b0994c7c$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        cursor: 'pointer'
    });
    const $309d1fc5b0994c7c$var$textStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
});
parcelRegister("fkAB3", function(module, exports) {
    $parcel$export(module.exports, "getADFMarkup", ()=>$d25444d60d26b6d9$export$3d7eec7fcefdad14);
    const $d25444d60d26b6d9$export$3d7eec7fcefdad14 = async (node)=>{
        if (node === null || node === undefined || typeof node === 'string') return '';
        const schemaPromise = (parcelRequire("j87Vo"));
        const wikiPromise = (parcelRequire("h2XnI"));
        const jsonPromise = (parcelRequire("hgt9V"));
        const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
            schemaPromise,
            wikiPromise,
            jsonPromise
        ]);
        const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
        const adfTransformer = new JSONTransformer();
        const pmNode = adfTransformer.parse(node);
        return wikiTransformer.encode(pmNode);
    };
});
parcelRegister("iydSP", function(module, exports) {
    $parcel$export(module.exports, "TextCell", ()=>$310165238372edbd$export$765aced31cc89655);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iZOJ9;
    var $2NMNM;
    var $kY99m;
    var $6ByXP;
    var $b5lmY;
    var $e0a4D;
    var $1T1ir;
    var $6s1PB;
    var $4R6GH;
    var $lQE94;
    var $1RMb0;
    var $k2wwp;
    var $4DpHn;
    var $iXGUb;
    var $lI995;
    var $5YWZW;
    var $64Oxj;
    const $310165238372edbd$export$fc152bafe73dcaee = (props)=>{
        const { editMode: editMode, highlight: highlight, fieldName: fieldName, onSubmit: onSubmit, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, value: value, testId: testId } = props;
        if (editMode) return (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: onSubmit ?? (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            testId: testId ? `${testId}-field` : undefined,
            autoFocus: true,
            onBlur: onBlur,
            value: value,
            onChange: onChange,
            onKeyDown: onKeyDown,
            "aria-label": fieldName
        }));
        if (value && typeof value === 'string' && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(value) && (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1RMb0")).LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: value,
            fieldType: "text"
        });
        if (highlight && highlight.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2wwp")).default), {
            highlight: highlight,
            text: value
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": testId
        }, value);
    };
    const $310165238372edbd$export$765aced31cc89655 = ({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, testId: testId, isNudgeCell: isNudgeCell = false, isSelected: isSelected, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, issueId: issueId, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', fieldName: fieldName = '', inputValue: inputValue, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const searchHighlight = (0, (0, parcelRequire("1T1ir")).useSimpleSearchHighlight)();
        const [textValueOld, setTextValueOld] = (0, $5uXOq.useState)(fieldValue || '');
        const textValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (inputValue ?? fieldValue) || '' : textValueOld;
        const setTextValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueId: issueId,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: fieldValue,
            onFailure: ()=>{
                setTextValue(value || '');
            }
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { ref: inlineEditNudgeRef } = (0, (0, parcelRequire("4DpHn")).useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$a1398a6ef9526001), isNudgeCell);
        (0, $5uXOq.useEffect)(()=>{
            if (wrapperRef?.current && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) inlineEditNudgeRef.current = wrapperRef.current;
        }, [
            inlineEditNudgeRef,
            wrapperRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (fieldValue) setTextValue(fieldValue);
        }, [
            fieldValue,
            setTextValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (value !== textValue && (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) setTextValue(value || '');
        }, [
            setTextValue,
            value
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) {
                setEditMode(true);
                setTextValue(value || '');
            }
        }, [
            editMode,
            isEditable,
            setTextValue,
            value,
            setEditMode
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            if (event.key === 'Escape') {
                setTextValue(value || '');
                wrapperRef?.current?.focus();
            }
        }, [
            setTextValue,
            value,
            wrapperRef
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editMode && event.code === 'Escape') setTextValue(value || '');
            return false;
        }, [
            editMode,
            setTextValue,
            value
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)((event)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) event.preventDefault();
            if (editMode) {
                setEditMode(false);
                if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
            }
        }, [
            editMode,
            textValue,
            value,
            saveValue,
            createAnalyticsEvent,
            setEditMode
        ]);
        const handleBlur = (0, $5uXOq.useCallback)((event)=>{
            saveAndClose(event);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) onBlur && onBlur(event);
        }, [
            onBlur,
            saveAndClose
        ]);
        const handleChange = (0, $5uXOq.useCallback)((event)=>{
            setTextValue(event.target.value);
            resetError();
        }, [
            resetError,
            setTextValue
        ]);
        const renderNudgeWrapper = (children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXGUb")).InlineEditListNudgeAsync), null, children);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
            inlineEditNudgeRef.current = ref;
        }, [
            inlineEditNudgeRef,
            wrapperRef
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)((e)=>{
            saveAndClose(e);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) wrapperRef?.current?.focus();
        }, [
            saveAndClose,
            wrapperRef
        ]);
        const cellOverrides = (0, $5uXOq.useCallback)(()=>({
                onKeyDown: handleKeyDownNew
            }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const handleSpotlightClose = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            setEditMode(false);
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            }, 0);
        }, [
            setEditMode,
            wrapperRef
        ]);
        const textCell = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($310165238372edbd$export$fc152bafe73dcaee, {
            editMode: editMode,
            onBlur: handleBlur,
            onSubmit: handleSubmit,
            onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleKeyDown,
            onChange: handleChange,
            value: textValue,
            highlight: searchHighlight,
            testId: testId,
            fieldName: fieldName
        }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("64Oxj")).default).errorTitle,
            description: (0, (0, parcelRequire("64Oxj")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        const textCellWrapper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ByXP")).ConditionalWrapper), {
            condition: isNudgeCell,
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).TextCellWrapper), {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.text-cell.text-cell-wrapper"
        }, textCell));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YWZW")).ClickToEditOnboardingTour), {
            isNudgeCell: isNudgeCell,
            wrapperRef: wrapperRef,
            onClose: handleSpotlightClose
        }, textCellWrapper);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, textCellWrapper);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ByXP")).ConditionalWrapper), {
            condition: isNudgeCell,
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).TextFieldWrapper), {
            onClick: handleClick,
            isEditable: isEditable,
            onFocus: onFocus,
            onBlur: onBlur,
            isSelected: isSelected,
            tabIndex: 0,
            onKeyDown: onKeyDown,
            ref: onWrapperRef
        }, textCell));
    };
});
parcelRegister("iZOJ9", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$dd4545da25e52dce$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "linkify", ()=>$dd4545da25e52dce$export$8ccbde94d5c7f8e7);
    $parcel$export(module.exports, "linkifyMatch", ()=>$dd4545da25e52dce$export$6f7d7761b97f967);
    $parcel$export(module.exports, "getLinkMatch", ()=>$dd4545da25e52dce$export$ce9ae45aed3e4ec);
    $parcel$export(module.exports, "normalizeUrl", ()=>$dd4545da25e52dce$export$6535eb414fa2c8b6);
    $parcel$export(module.exports, "isRootRelative", ()=>$dd4545da25e52dce$export$23579274a7a24f7b);
    var $i6xkD = parcelRequire("i6xkD");
    const $dd4545da25e52dce$var$whitelistedURLPatterns = [
        /^https?:\/\//im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\//im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:/im,
        /^facetime:/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^sourcetree:\/\//im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^#/im
    ];
    const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        if (urlTrimmed.length === 0) return true;
        return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, ($parcel$interopDefault($i6xkD)))();
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
    const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
        validate: /[^\s]+/
    };
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
    const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
    const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
        if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
        const matches = [];
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
        if (!str) return null;
        let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
        if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
        return match && match[0];
    }
    function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
        const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
        return match && match.url || '';
    }
    function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
        return url.startsWith('/') || url === '#top' || url === '#';
    }
});
parcelRegister("i6xkD", function(module, exports) {
    'use strict';
    function $d2e2a485107d561a$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $d2e2a485107d561a$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $d2e2a485107d561a$var$isString(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object String]';
    }
    function $d2e2a485107d561a$var$isObject(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
    }
    function $d2e2a485107d561a$var$isRegExp(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
    }
    function $d2e2a485107d561a$var$isFunction(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
    }
    function $d2e2a485107d561a$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $d2e2a485107d561a$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $d2e2a485107d561a$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $d2e2a485107d561a$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $d2e2a485107d561a$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $d2e2a485107d561a$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $d2e2a485107d561a$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $d2e2a485107d561a$var$compile(self) {
        var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($d2e2a485107d561a$var$isObject(val)) {
                if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
                else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($d2e2a485107d561a$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $d2e2a485107d561a$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($d2e2a485107d561a$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
        $d2e2a485107d561a$var$resetScanCache(self);
    }
    function $d2e2a485107d561a$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $d2e2a485107d561a$var$createMatch(self, shift) {
        var match = new $d2e2a485107d561a$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $d2e2a485107d561a$var$compile(this);
    }
    $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $d2e2a485107d561a$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $d2e2a485107d561a$var$LinkifyIt;
});
parcelRegister("9mKTr", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,3}[a-zA-Z0-9%/]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("b9ep3", function(module, exports) {
    module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
});
parcelRegister("23ErL", function(module, exports) {
    module.exports = /[\0-\x1F\x7F-\x9F]/;
});
parcelRegister("oRY4m", function(module, exports) {
    module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
});
parcelRegister("9bBmm", function(module, exports) {
    module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
});
parcelRegister("6ByXP", function(module, exports) {
    $parcel$export(module.exports, "ConditionalWrapper", ()=>$29a10aa5daca2294$export$39aecc95f0365819);
    var $5uXOq = parcelRequire("5uXOq");
    const $29a10aa5daca2294$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
});
parcelRegister("1RMb0", function(module, exports) {
    $parcel$export(module.exports, "LazySingleLineSmartLink", ()=>$1520f3a29774e13a$export$80092fcb07ccc4b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $7c22Q;
    const $1520f3a29774e13a$var$entryPointParams = {};
    const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7c22Q")).SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira.issue-field.single-line-smart-link",
            packageName: "issue-field-smart-link",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props
        });
    };
});
parcelRegister("7c22Q", function(module, exports) {
    $parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", ()=>$5f4ae65db2a1976a$export$e236c9b35543c8d);
    var $eufEc;
    var $fEDBv;
    const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bVBtc")).then((module)=>module.SingleLineSmartLink), {
            moduleId: "97818dc4"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("bVBtc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jo8eM")
    ]).then(()=>parcelRequire('k2J4N'));
});
parcelRegister("k2wwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e37bd657627b5db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1H6kL;
    var $cM7El;
    const $5e37bd657627b5db$var$HighlightTextWithParser = (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
        const parts = (0, (0, parcelRequire("1H6kL")).getParts)(highlight, text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cM7El")).default), {
            parts: parts
        });
    });
    var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;
});
parcelRegister("1H6kL", function(module, exports) {
    $parcel$export(module.exports, "removeAccents", ()=>$0b92ef830f5aa8e4$export$f3f2882e8b11d731);
    $parcel$export(module.exports, "getParts", ()=>$0b92ef830f5aa8e4$export$a3aee8a24a54661f);
    var $8QDwl = parcelRequire("8QDwl");
    var $ajpes = parcelRequire("ajpes");
    var $3JOCw = parcelRequire("3JOCw");
    var $8QpSo;
    const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, (0, parcelRequire("8QpSo")).default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, (0, parcelRequire("8QpSo")).default)((highlight)=>{
        const escapedFilter = highlight.map((phrase)=>(0, ($parcel$interopDefault($8QDwl)))(phrase)).join('|');
        return new RegExp(escapedFilter, 'gmi');
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
    const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
            type: 'text',
            content: content
        });
    const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
            type: 'highlight',
            content: content
        });
    const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
        const ms = [];
        let m = regExp.exec(str);
        while(m){
            ms.push(m);
            m = regExp.exec(str);
        }
        return ms;
    };
    const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
        if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
            $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
        ];
        const parts = [];
        const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
        const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
        const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
        const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
        const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
        const highlightMatches = (0, ($parcel$interopDefault($3JOCw)))([
            ...textWithoutAccentsMatches,
            ...textMatches
        ], 'index');
        let currentPosition = 0;
        highlightMatches.forEach((match)=>{
            const matchText = text.slice(match.index, match.index + match[0].length);
            const leading = text.slice(currentPosition, match.index);
            if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
            parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
            currentPosition = match.index + matchText.length;
        });
        const trailing = text.slice(currentPosition);
        if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
        return parts;
    };
});
parcelRegister("cM7El", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328475be93221885$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $328475be93221885$var$Mark = (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkwtfv _syaz1fxt",
                __cmplp.className
            ])
        });
    });
    const $328475be93221885$var$HighlightText = ({ parts: parts })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
            if (part.type === 'text') return part.content;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
                key: i
            }, part.content);
        }));
    var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;
});
parcelRegister("iXGUb", function(module, exports) {
    $parcel$export(module.exports, "InlineEditListNudgeAsync", ()=>$ecb11ac319bfddf4$export$ae0c23fe550deebc);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $avYCR;
    const $ecb11ac319bfddf4$var$runtimeProps = {};
    const $ecb11ac319bfddf4$var$entryPointParams = {};
    const $ecb11ac319bfddf4$export$ae0c23fe550deebc = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("avYCR")).inlineEditNudgeEntrypoint), $ecb11ac319bfddf4$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: (0, $dbbf68c32d8c4308$export$501e36925fa10eef),
            packageName: "jiraListOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            runtimeProps: $ecb11ac319bfddf4$var$runtimeProps
        }));
    };
});
parcelRegister("avYCR", function(module, exports) {
    $parcel$export(module.exports, "inlineEditNudgeEntrypoint", ()=>$e132edaa0d1fa946$export$8073de424af508bc);
    var $eufEc;
    var $fEDBv;
    const $e132edaa0d1fa946$export$8073de424af508bc = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("7RwQH")), {
            moduleId: "1e3103f7"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("7RwQH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("96rib").then(()=>parcelRequire('kbd1h'));
});
parcelRegister("5YWZW", function(module, exports) {
    $parcel$export(module.exports, "ClickToEditOnboardingTour", ()=>$2582cb405acaae8c$export$7b4b56fb1204d901);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6ByXP;
    var $ousew;
    var $koVbs;
    var $cRuls;
    var $kmVCz;
    const $2582cb405acaae8c$var$isMacOS = ()=>/Mac/i.test(typeof window !== 'undefined' ? window?.navigator?.platform : '');
    function $2582cb405acaae8c$export$7b4b56fb1204d901(props) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const steps = {
            'copy-paste': {
                heading: formatMessage((0, (0, parcelRequire("kmVCz")).default).clickToEditCopyPasteHeading),
                body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    values: {
                        code: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                    },
                    ...$2582cb405acaae8c$var$isMacOS() ? (0, (0, parcelRequire("kmVCz")).default).clickToEditCopyPasteBodyMac : (0, (0, parcelRequire("kmVCz")).default).clickToEditCopyPasteBodyWindows
                })
            },
            navigation: {
                heading: formatMessage((0, (0, parcelRequire("kmVCz")).default).clickToEditNavigationHeading),
                body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    values: {
                        code: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                    },
                    ...$2582cb405acaae8c$var$isMacOS() ? (0, (0, parcelRequire("kmVCz")).default).clickToEditNavigationBodyMac : (0, (0, parcelRequire("kmVCz")).default).clickToEditNavigationBodyWindows
                })
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$CopyPasteOnboardingTour, {
            ...props,
            cohort: "control",
            steps: steps
        });
    }
    function $2582cb405acaae8c$export$c6deaa5246c3126(props) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const steps = {
            'copy-paste': {
                heading: formatMessage((0, (0, parcelRequire("kmVCz")).default).clickToSelectCopyPasteHeading),
                body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    values: {
                        code: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                    },
                    ...$2582cb405acaae8c$var$isMacOS() ? (0, (0, parcelRequire("kmVCz")).default).clickToSelectCopyPasteBodyMac : (0, (0, parcelRequire("kmVCz")).default).clickToSelectCopyPasteBodyWindows
                })
            },
            navigation: {
                heading: formatMessage((0, (0, parcelRequire("kmVCz")).default).clickToSelectNavigationHeading),
                body: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    values: {
                        code: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$Code, null, chunks)
                    },
                    ...$2582cb405acaae8c$var$isMacOS() ? (0, (0, parcelRequire("kmVCz")).default).clickToSelectNavigationBodyMac : (0, (0, parcelRequire("kmVCz")).default).clickToSelectNavigationBodyWindows
                })
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2582cb405acaae8c$var$CopyPasteOnboardingTour, {
            ...props,
            cohort: "variation",
            steps: steps
        });
    }
    function $2582cb405acaae8c$var$CopyPasteOnboardingTour({ children: children, isNudgeCell: isNudgeCell, wrapperRef: wrapperRef, steps: steps, cohort: cohort, onClose: onClose }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ByXP")).ConditionalWrapper), {
            condition: isNudgeCell,
            renderWrapper: (wrappedChildren)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cRuls")).CopyPasteTourAsync), {
                    wrapperRef: wrapperRef,
                    cohort: cohort,
                    steps: steps,
                    onClose: onClose
                }, wrappedChildren)
        }, children);
    }
    function $2582cb405acaae8c$var$Code({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81u0j _bfhkm7j4 _syaz15cr _2rkoglpi _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _1yt41d1z _16d9qvcn _1i4q1hna _o5721jtm"
            ])
        }, children);
    }
    const $2582cb405acaae8c$var$codeStyles = null;
});
parcelRegister("cRuls", function(module, exports) {
    $parcel$export(module.exports, "CopyPasteTourAsync", ()=>$6b8ba61cbc1ed3f7$export$cc0fbe7c384bfe4a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $6b8ba61cbc1ed3f7$var$LazyCopyPasteTour = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("1wM1g")), {
        ssr: false,
        moduleId: "./src/packages/business/list/src/common/ui/lazy-copy-paste-tour/main.tsx"
    });
    function $6b8ba61cbc1ed3f7$export$cc0fbe7c384bfe4a(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "copy-paste-onboarding-tour",
            fallback: props.children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6b8ba61cbc1ed3f7$var$LazyCopyPasteTour, props));
    }
});
parcelRegister("1wM1g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2fvnY").then(()=>parcelRequire('dytsQ'));
});
parcelRegister("kmVCz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$393dcda9650aa91a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $393dcda9650aa91a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clickToEditCopyPasteHeading: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading",
            "defaultMessage": "Edit issues inline, or copy and paste"
        },
        clickToEditCopyPasteBodyMac: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-mac",
            "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>command</code> + <code>C</code> / <code>V</code>."
        },
        clickToEditCopyPasteBodyWindows: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-windows",
            "defaultMessage": "Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>ctrl</code> + <code>C</code> / <code>V</code>."
        },
        clickToEditNavigationHeading: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-heading",
            "defaultMessage": "Navigate with your keyboard"
        },
        clickToEditNavigationBodyMac: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-mac",
            "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
        },
        clickToEditNavigationBodyWindows: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-windows",
            "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
        },
        clickToSelectCopyPasteHeading: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-heading",
            "defaultMessage": "Copy and paste details, just like a spreadsheet"
        },
        clickToSelectCopyPasteBodyMac: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac",
            "defaultMessage": "To copy and paste issue details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
        },
        clickToSelectCopyPasteBodyWindows: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows",
            "defaultMessage": "To copy and paste issue details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit."
        },
        clickToSelectNavigationHeading: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-heading",
            "defaultMessage": "Navigate with your keyboard"
        },
        clickToSelectNavigationBodyMac: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-mac",
            "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode."
        },
        clickToSelectNavigationBodyWindows: {
            "id": "business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-windows",
            "defaultMessage": "Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode."
        }
    });
});
parcelRegister("64Oxj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0089743c0f9c5c88$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0089743c0f9c5c88$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.text-cell.error-title",
            "defaultMessage": "We couldn't save the text value."
        },
        errorMessage: {
            "id": "business-list.list-view.text-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("eTHix", function(module, exports) {
    $parcel$export(module.exports, "TypeCell", ()=>$d801f8d5b8ae88a1$export$1034b01824b6a80);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $6ByXP;
    var $1T2vX;
    var $cLGgz;
    var $jjlQu;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $560mU;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $1CXMr;
    var $lI995;
    var $lDRI0;
    var $4nnGr;
    var $mH57d;
    var $88kyp;
    const $d801f8d5b8ae88a1$var$empty = ()=>null;
    const $d801f8d5b8ae88a1$export$1034b01824b6a80 = (0, $5uXOq.memo)(({ id: id, iconUrl: iconUrl, name: name, avatarId: avatarId = '', onChildCreateButtonClicked: onChildCreateButtonClicked, hierarchyLevel: hierarchyLevel = 0, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef, rankIndex: rankIndex })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlatList: showFlatList } = (0, (0, parcelRequire("mH57d")).useHierarchyConfig)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            onChildCreateButtonClicked && setTimeout(()=>{
                onChildCreateButtonClicked();
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'childCreateButton');
        }, [
            createAnalyticsEvent,
            onChildCreateButtonClicked
        ]);
        const { hasCreateSubtask: hasCreateSubtask } = (0, (0, parcelRequire("4nnGr")).useJWMListFeatures)();
        const { data: { issueTypes: issueTypes } } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        const canCreateChildIssue = hierarchyLevel > 0 ? issueTypes.some((issueType)=>issueType.hierarchyLevel === hierarchyLevel - 1) : hasCreateSubtask && issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
        const canCreateChild = !(0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(id)) && !showFlatList && typeof onChildCreateButtonClicked === 'function' && canCreateChildIssue;
        const childCreateContent = canCreateChild && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ByXP")).ConditionalWrapper), {
            condition: rankIndex === 0 && (0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate'),
            renderWrapper: ()=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDRI0")).OnboardingSpotlightWrapper), {
                    spotlightId: (0, (0, parcelRequire("560mU")).CREATE_CHILD_SPOTLIGHT_ID),
                    renderTrigger: (isSpotlightVisible)=>{
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CXMr")).default), {
                            tooltip: formatMessage((0, (0, parcelRequire("88kyp")).default).createChildItem),
                            label: formatMessage((0, (0, parcelRequire("88kyp")).default).createChildItem),
                            onClick: handleClick,
                            shouldDisplayBtn: isSpotlightVisible || isSelected
                        });
                    }
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CXMr")).default), {
            tooltip: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("88kyp")).default).createChildItemIssueTermRefresh : (0, (0, parcelRequire("88kyp")).default).createChildItem),
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("88kyp")).default).createChildItemIssueTermRefresh : (0, (0, parcelRequire("88kyp")).default).createChildItem),
            onClick: handleClick,
            shouldDisplayBtn: isSelected
        }));
        const iconContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
            url: iconUrl,
            alt: name,
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
                    url: `/secure/viewavatar?size=medium&avatarId=${avatarId}&avatarType=issuetype`,
                    alt: name,
                    fallback: $d801f8d5b8ae88a1$var$empty
                })
        });
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Enter') return;
            onKeyDown?.(e);
        }, [
            onKeyDown
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (event.code === 'Enter') return true;
            return false;
        }, []);
        const handleClickNew = (0, $5uXOq.useCallback)(()=>true, []);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                    onClick: handleClickNew,
                    onKeyDown: handleKeyDownNew
                }), [
            handleClickNew,
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement($d801f8d5b8ae88a1$var$TypeWrapper, {
            "data-testid": "business-list.ui.list-view.type-cell.type-wrapper",
            canCreateChild: canCreateChild,
            tabIndex: 0,
            isVisualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: name
        }, iconContent), childCreateContent);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d801f8d5b8ae88a1$var$TypeWrapperOld, {
            canCreateChild: canCreateChild,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            isFocused: isSelected,
            "data-testid": "business-list.ui.list-view.type-cell.type-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: name
        }, iconContent), childCreateContent);
    });
    const $d801f8d5b8ae88a1$var$TypeWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lI995")).WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rkoglpi _19bvldb6 _k8empxbi",
                __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
                __cmplp.className
            ])
        });
    });
    const $d801f8d5b8ae88a1$var$TypeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _19bvldb6",
                __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
                __cmplp.isVisualRefresh ? "_p7r11txw _tij01h6o" : "_k8empxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jjlQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f7206d8a029d15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4R6GH;
    const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                url: undefined,
                title: undefined,
                alt: undefined,
                width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                fallback: undefined
            };
        }
        render() {
            const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
            const width = this.convertSize(this.props.width);
            const height = this.convertSize(this.props.height);
            if (this.state.isBroken && fallback) return fallback();
            if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
                src: url,
                width: width,
                height: height,
                title: title ?? undefined,
                alt: alt ?? '',
                onError: this.onError,
                draggable: false
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('jfp-1020-use-compiled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $e7f7206d8a029d15$var$placeholderStyles,
                style: {
                    height: height,
                    width: width
                },
                backgroundColor: "color.background.input.hovered",
                testId: "common-components-async-icon.placeholder"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
                width: width,
                height: height,
                "data-testid": "common-components-async-icon.placeholder"
            });
        }
        constructor(...args){
            super(...args), this.state = {
                isBroken: false
            }, this.onError = ()=>{
                this.setState({
                    isBroken: true
                });
            }, this.convertSize = (size)=>size ? `${size}px` : '0';
        }
    }
    const $e7f7206d8a029d15$var$ImagePlaceholder = (0, $47bDC.default).span.withConfig({
        componentId: "owe24v-0"
    })((props)=>({
            height: props.height,
            width: props.width,
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            borderRadius: '3px',
            display: 'flex',
            flex: 'none'
        }));
    const $e7f7206d8a029d15$var$placeholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    });
    const $e7f7206d8a029d15$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lDRI0", function(module, exports) {
    $parcel$export(module.exports, "OnboardingSpotlightWrapper", ()=>$6b34fa4a91432925$export$e77e3591fa77f5ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $1QiBP;
    var $hxoiH;
    var $daQYX;
    var $jlRCt = parcelRequire("jlRCt");
    var $3mbNA = parcelRequire("3mbNA");
    var $kNcLf = parcelRequire("kNcLf");
    var $5q9gS = parcelRequire("5q9gS");
    var $koVbs;
    var $560mU;
    var $8zOmE;
    var $2NMNM;
    var $ehdJY;
    var $aum1T;
    const $6b34fa4a91432925$var$spotlightMessages = {
        [(0, (0, parcelRequire("560mU")).CREATE_CHILD_SPOTLIGHT_ID)]: {
            heading: (0, (0, parcelRequire("aum1T")).messages).createChildHeading,
            body: (0, (0, parcelRequire("aum1T")).messages).createChildBody,
            dismiss: (0, (0, parcelRequire("aum1T")).messages).dismiss
        },
        [(0, (0, parcelRequire("560mU")).CREATE_FIELD_SPOTLIGHT_ID)]: {
            heading: (0, (0, parcelRequire("aum1T")).messages).createFieldHeading,
            body: (0, (0, parcelRequire("aum1T")).messages).createFieldBody,
            dismiss: (0, (0, parcelRequire("aum1T")).messages).dismiss
        }
    };
    const $6b34fa4a91432925$var$spotlightImageUrls = {
        [(0, (0, parcelRequire("560mU")).CREATE_CHILD_SPOTLIGHT_ID)]: {
            light: (0, ($parcel$interopDefault($5q9gS))),
            dark: (0, ($parcel$interopDefault($kNcLf)))
        },
        [(0, (0, parcelRequire("560mU")).CREATE_FIELD_SPOTLIGHT_ID)]: {
            light: (0, ($parcel$interopDefault($3mbNA))),
            dark: (0, ($parcel$interopDefault($jlRCt)))
        }
    };
    const $6b34fa4a91432925$export$e77e3591fa77f5ec = ({ renderTrigger: renderTrigger, spotlightId: spotlightId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const [isSpotlightVisible, actions] = (0, (0, parcelRequire("560mU")).useListViewOnboarding)({
            projectId: String(projectData.id),
            id: spotlightId
        });
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (isSpotlightVisible) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'spotlight'
            }), spotlightId);
        }, [
            createAnalyticsEvent,
            isSpotlightVisible,
            spotlightId
        ]);
        const onClick = (_, analyticsEvent)=>{
            actions.dismissSpotlight(spotlightId);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, `${spotlightId}Dismiss`);
        };
        const { heading: heading, body: body, dismiss: dismiss } = $6b34fa4a91432925$var$spotlightMessages[spotlightId];
        const { dark: dark, light: light } = $6b34fa4a91432925$var$spotlightImageUrls[spotlightId];
        const imageUrl = colorMode === 'dark' ? dark : light;
        if (isSpotlightVisible) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: spotlightId
        }, renderTrigger(isSpotlightVisible)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            image: imageUrl,
            actions: [
                {
                    onClick: onClick,
                    text: formatMessage(dismiss)
                }
            ],
            heading: formatMessage(heading),
            target: spotlightId,
            key: spotlightId,
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            messageId: spotlightId,
            messageType: "engagement",
            dialogWidth: 275
        }, formatMessage(body))));
        return renderTrigger(isSpotlightVisible);
    };
});
parcelRegister("jlRCt", function(module, exports) {
    module.exports = new URL("edit-ticket-with-background-dark.9447b0b7.svg", import.meta.url).toString();
});
parcelRegister("3mbNA", function(module, exports) {
    module.exports = new URL("edit-ticket-with-background-light.78ada054.svg", import.meta.url).toString();
});
parcelRegister("kNcLf", function(module, exports) {
    module.exports = new URL("hierarchy-tasks-with-background-dark.54880609.svg", import.meta.url).toString();
});
parcelRegister("5q9gS", function(module, exports) {
    module.exports = new URL("hierarchy-tasks-with-background-light.7076b893.svg", import.meta.url).toString();
});
parcelRegister("aum1T", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$805758291b6be1d3$export$defe85febe8b728c);
    var $7VHMR;
    const $805758291b6be1d3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createChildHeading: {
            "id": "business-list.common.onboarding-spotlight-wrapper.create-child-heading",
            "defaultMessage": "Now break it down"
        },
        createChildBody: {
            "id": "business-list.common.onboarding-spotlight-wrapper.create-child-body",
            "defaultMessage": "Splitting the work into smaller tasks makes it easier to prioritize each one."
        },
        createFieldHeading: {
            "id": "business-list.common.onboarding-spotlight-wrapper.create-field-heading",
            "defaultMessage": "Add a new field"
        },
        createFieldBody: {
            "id": "business-list.common.onboarding-spotlight-wrapper.create-field-body",
            "defaultMessage": "Add as many fields as you require in order to capture the right information for each piece of work."
        },
        dismiss: {
            "id": "business-list.common.spotlight-wrapper.dismiss-non-final",
            "defaultMessage": "OK"
        }
    });
});
parcelRegister("88kyp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c549057f047aa0e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c549057f047aa0e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addChildItem: {
            "id": "business-list.list-view.type-cell.add-child-item",
            "defaultMessage": "Add child item"
        },
        createSubtask: {
            "id": "business-list.list-view.type-cell.create-subtask",
            "defaultMessage": "Create subtask"
        },
        createTask: {
            "id": "business-list.list-view.type-cell.create-task",
            "defaultMessage": "Create"
        },
        createChildItem: {
            "id": "business-list.list-view.type-cell.create-child-item",
            "defaultMessage": "Create child issue"
        },
        createChildItemIssueTermRefresh: {
            "id": "business-list.list-view.type-cell.create-child-item-issue-term-refresh",
            "defaultMessage": "Create child work item"
        }
    });
});
parcelRegister("7NVIZ", function(module, exports) {
    $parcel$export(module.exports, "UrlCell", ()=>$38f12ffb698c385f$export$110272e30ac53e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $kY99m;
    var $b5lmY;
    var $e0a4D;
    var $6s1PB;
    var $7XYc4;
    var $4R6GH;
    var $lQE94;
    var $lI995;
    var $cdzQd;
    var $inpY4;
    const $38f12ffb698c385f$export$110272e30ac53e5 = (0, $5uXOq.memo)(({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), cellRef: cellRef, inputValue: inputValue = fieldValue ?? '', onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const [textValueOld, setTextValueOld] = (0, $5uXOq.useState)(fieldValue || '');
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const textValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue : textValueOld;
        const setTextValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: fieldValue
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (error && value !== textValue) setTextValue(value ?? '');
        }, [
            error,
            setTextValue,
            textValue,
            value
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if (isEditable && !editMode) {
                setEditMode(true);
                setTextValue(value || '');
            }
        }, [
            editMode,
            isEditable,
            setEditMode,
            setTextValue,
            value
        ]);
        const saveAndClose = (0, $5uXOq.useCallback)((event)=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) event.preventDefault();
            if (editMode) {
                setEditMode(false);
                if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
            }
        }, [
            createAnalyticsEvent,
            editMode,
            saveValue,
            setEditMode,
            textValue,
            value
        ]);
        const handleChange = (0, $5uXOq.useCallback)((event)=>{
            setTextValue(event.target.value);
            resetError();
        }, [
            resetError,
            setTextValue
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onKeyDown
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((event)=>{
            if (editMode && event.code === 'Escape') setTextValue(value ?? '');
            return false;
        }, [
            editMode,
            setTextValue,
            value
        ]);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                    onKeyDown: handleKeyDownNew
                }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleTextFieldKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') {
                e.preventDefault();
                setTextValue(value || '');
                setTimeout(()=>{
                    wrapperRef?.current?.focus();
                });
            }
        }, [
            setTextValue,
            value,
            wrapperRef
        ]);
        const handleSubmit = (0, $5uXOq.useCallback)((event)=>{
            saveAndClose(event);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }, [
            saveAndClose,
            wrapperRef
        ]);
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: handleSubmit
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            autoFocus: true,
            onBlur: saveAndClose,
            value: textValue,
            onChange: handleChange,
            onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? (0, ($parcel$interopDefault($8Rkzz))) : handleTextFieldKeyDown
        })) : value != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cdzQd")).SmartLink), {
            value: value
        }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: error,
            title: (0, (0, parcelRequire("inpY4")).default).errorTitle,
            description: (0, (0, parcelRequire("inpY4")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: "business-list.ui.list-view.url-cell.url-cell-wrapper",
            hasPadding: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($38f12ffb698c385f$var$Wrapper, null, cellContent));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($38f12ffb698c385f$var$WrapperOld, {
            isFocused: editMode || isSelected,
            onClick: handleClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            tabIndex: 0,
            "data-testid": "business-list.ui.list-view.url-cell.url-cell-wrapper"
        }, cellContent);
    });
    const $38f12ffb698c385f$var$WrapperOld = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lI995")).WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw _1tuuidpf _1lxnidpf _2vryidpf _1umfidpf",
                __cmplp.className
            ])
        });
    });
    $38f12ffb698c385f$var$WrapperOld.displayName = 'Wrapper';
    const $38f12ffb698c385f$var$NonSmartLinkWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw _1tuuidpf _1lxnidpf _2vryidpf _1umfidpf",
                __cmplp.className
            ])
        });
    });
    const $38f12ffb698c385f$var$SmartLinkWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _h5vp1txw _16gx1y6m _1qxz1h6o _i78x1osq _mdbou2gc _i9kvh2mm _18vc1txw _18z6idpf _svocidpf _r8aoidpf _1kmuidpf",
                __cmplp.className
            ])
        });
    });
    const $38f12ffb698c385f$var$Wrapper = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true), $38f12ffb698c385f$var$SmartLinkWrapper, $38f12ffb698c385f$var$NonSmartLinkWrapper);
});
parcelRegister("cdzQd", function(module, exports) {
    $parcel$export(module.exports, "SmartLink", ()=>$66799bc77fd126d1$export$8416d4d37a0abf2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1FouZ;
    var $dC5iT;
    var $8CUq3;
    var $6s1PB;
    var $1RMb0;
    const $66799bc77fd126d1$export$8416d4d37a0abf2d = ({ value: value })=>{
        const DefaultLink = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: value,
                target: "_blank"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($66799bc77fd126d1$var$LinkText, null, value), (0, ($parcel$interopDefault($5uXOq))).createElement($66799bc77fd126d1$var$LinkFollower, {
                "data-component-selector": "business-list.ui.list-view.url-cell.link-follower"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1FouZ"))))), {
                label: value
            }))), [
            value
        ]);
        if (value && (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_perf_format-links-in-custom-fields', 'list-view', true)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $66799bc77fd126d1$var$smartLinkWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1RMb0")).LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: value,
            fieldType: "url"
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DefaultLink, null);
    };
    const $66799bc77fd126d1$var$smartLinkWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100',
        marginRight: 'space.100'
    });
    const $66799bc77fd126d1$var$LinkFollower = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ejb _11q7txrc _1e0cglyw _4cvr1h6o _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $66799bc77fd126d1$var$LinkText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _p12f1osq _1bto1l2s _1reo15vq _18m915vq _1o9zkb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("inpY4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6208e8c575652861$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6208e8c575652861$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.url-cell.error-title",
            "defaultMessage": "We couldn't save the text value."
        },
        errorMessage: {
            "id": "business-list.list-view.url-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("3T0IO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b41ddb03500305ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e1OxR;
    var $cSD7y;
    var $lfTZh;
    var $kxZPA;
    var $1KleD;
    const $b41ddb03500305ca$var$LazyUserCell = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>Promise.resolve((parcelRequire("1KleD"))), {
        moduleId: "./src/packages/business/list/src/ui/list-view/user-cell/main.tsx"
    });
    const $b41ddb03500305ca$var$AsyncUserCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "user-cell",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1OxR")).default), {
            shouldUseInvitePeopleModal: true,
            source: "listViewAssignee"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b41ddb03500305ca$var$LazyUserCell, props)));
    var $b41ddb03500305ca$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('list_view_sync_cells', (0, (0, parcelRequire("1KleD")).default), $b41ddb03500305ca$var$AsyncUserCell);
});
parcelRegister("1KleD", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$86e94321800af0e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $laWvb;
    var $bXrHm = parcelRequire("bXrHm");
    var $ujWmd;
    var $7ymNM;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $kY99m;
    var $3bDjY;
    var $bmZvc;
    var $hE5wF;
    var $b5lmY;
    var $e0a4D;
    var $jRzRt;
    var $7wK4b;
    var $gwIPs;
    var $4R6GH;
    var $eusud;
    var $koVbs;
    var $7lGt2;
    var $1kqLh;
    var $kt8K4;
    var $lQE94;
    var $5fc53;
    var $cYlk7;
    var $8zOmE;
    var $2NMNM;
    var $90yGq;
    var $lI995;
    var $epX45;
    var $khm7P;
    const $86e94321800af0e7$var$SEARCH_DEBOUNCE_TIMEOUT = 300;
    const $86e94321800af0e7$var$EMPTY_USER_ID = '__EMPTY_USER_ID__';
    const $86e94321800af0e7$var$INVITE_PEOPLE_ID = '__INVITE_PEOPLE_ID__';
    const $86e94321800af0e7$var$MAX_NUMBER_OF_OPTIONS = 7;
    const $86e94321800af0e7$var$LISTBOX_OPTION_PREFIX = `user-option-${(0, ($parcel$interopDefault($bXrHm)))()}`;
    const $86e94321800af0e7$var$LISTBOX_LIST_ID = `user-listbox-${(0, ($parcel$interopDefault($bXrHm)))()}`;
    const $86e94321800af0e7$var$getOptionId = (index)=>`${$86e94321800af0e7$var$LISTBOX_OPTION_PREFIX}-${index}`;
    const $86e94321800af0e7$var$createTestId = (testId, suffix = '')=>testId != null ? `${testId}${suffix}` : undefined;
    const $86e94321800af0e7$var$getAvatarUrl = (user)=>user.avatarUrls && user.avatarUrls[0, (0, parcelRequire("hE5wF")).DEFAULT_AVATAR_RES] ? user.avatarUrls[0, (0, parcelRequire("hE5wF")).DEFAULT_AVATAR_RES] : '';
    const $86e94321800af0e7$var$UserCell = (0, $5uXOq.memo)(({ initialValue: initialValue, fieldKey: fieldKey, fieldType: fieldType, issueKey: issueKey, isEditable: isEditable = true, width: width, emptyUserNameText: emptyUserNameText, loggedInUserActionNameText: loggedInUserActionNameText, testId: testId, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, ($parcel$interopDefault($8Rkzz))), isHovering: isHoveringNew = false, cellRef: cellRef, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', inputValue: inputValue, onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { openAddPeopleModal: openAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const userQuery = (0, $5uXOq.useRef)({
            previousQuery: undefined
        }).current;
        const [{ data: users, loading: loadingUsers, error: error }, fetchUsers] = (0, (0, parcelRequire("kt8K4")).default)(`/rest/api/3/user/assignable/search?issueKey=${issueKey}&maxResults=${$86e94321800af0e7$var$MAX_NUMBER_OF_OPTIONS}&query=`);
        const emptyUserName = formatMessage(emptyUserNameText);
        const listboxLabel = formatMessage((0, (0, parcelRequire("khm7P")).default).assigneeList);
        const emptyUser = (0, $5uXOq.useMemo)(()=>({
                accountId: $86e94321800af0e7$var$EMPTY_USER_ID,
                displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).unassignedOption),
                avatarUrls: {}
            }), [
            formatMessage
        ]);
        const invitePeople = (0, $5uXOq.useMemo)(()=>({
                accountId: $86e94321800af0e7$var$INVITE_PEOPLE_ID,
                displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).invitePeopleOptionAdmin),
                avatarUrls: {}
            }), [
            formatMessage
        ]);
        const initialValueUser = (0, $5uXOq.useMemo)(()=>{
            if (initialValue) return {
                accountId: initialValue.accountId,
                displayName: initialValue?.name || initialValue.displayName,
                avatarUrls: {
                    [(0, (0, parcelRequire("hE5wF")).DEFAULT_AVATAR_RES)]: initialValue?.picture
                }
            };
            return null;
        }, [
            initialValue
        ]);
        const [{ value: assigneeValue, error: updateError }, { saveValue: saveValue }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: fieldKey,
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValueUser,
            ...fieldKey === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE) ? {
                saveField: (0, (0, parcelRequire("1kqLh")).saveAssigneeField)
            } : {}
        });
        const value = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? assigneeValue : assigneeValue ?? initialValueUser;
        const [editMode, setEditMode] = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? [
            editModeNew,
            setEditModeNew
        ] : (0, $5uXOq.useState)(false);
        const [highlightedUserIndex, setHighlightedUserIndex] = (0, $5uXOq.useState)(0);
        const [activeDescendentId, setActiveDescendentId] = (0, $5uXOq.useState)('');
        const currentUserAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [isHoveringOld, setIsHovering] = (0, $5uXOq.useState)(false);
        const isHovering = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
        const [isStartSearching, setIsStartSearching] = (0, $5uXOq.useState)(false);
        const [userValue, setUserValue] = (0, $5uXOq.useState)(null);
        const currentUser = (0, $5uXOq.useRef)((0, (0, parcelRequire("cYlk7")).useCurrentUser)().data.user);
        const [userDisplayName, setUserDisplayName] = (0, $5uXOq.useState)(userValue?.displayName ?? emptyUserName);
        const [textValueOld, setTextValueOld] = (0, $5uXOq.useState)(userDisplayName);
        const textValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? inputValue ?? userDisplayName : textValueOld;
        const setTextValue = (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
        const [usersList, setUsersList] = (0, $5uXOq.useState)([]);
        const [fetchedUsers, setFetchedUsers] = (0, $5uXOq.useState)(false);
        const isUnassigned = !userValue?.accountId;
        const selectedAvatarUrl = userValue?.displayName === textValue ? $86e94321800af0e7$var$getAvatarUrl(userValue) : '';
        const userOptions = (0, $5uXOq.useMemo)(()=>{
            const isAssigneeFieldType = fieldKey === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE) && isStartSearching;
            if (isAssigneeFieldType) {
                const invitePeopleOption = usersList.length <= 2 ? [
                    invitePeople
                ] : [];
                const emptyOption = textValue === '' ? [
                    emptyUser
                ] : [];
                return [
                    ...emptyOption,
                    ...usersList.slice(0, Math.min($86e94321800af0e7$var$MAX_NUMBER_OF_OPTIONS, usersList.length + 1)),
                    ...invitePeopleOption
                ];
            }
            if (usersList.length === 0) return [
                emptyUser
            ];
            return [
                ...isUnassigned || value?.accountId !== currentUserAccountId ? [
                    currentUser.current
                ] : [],
                ...isUnassigned ? [] : [
                    emptyUser
                ],
                ...usersList.filter((u)=>u.accountId !== currentUser.current.accountId).slice(0, Math.min($86e94321800af0e7$var$MAX_NUMBER_OF_OPTIONS, usersList.length + 1))
            ];
        }, [
            fieldKey,
            isStartSearching,
            usersList,
            textValue,
            invitePeople,
            emptyUser,
            currentUserAccountId,
            isUnassigned,
            value?.accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setTextValue(userDisplayName);
        }, [
            setTextValue,
            userDisplayName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setUserValue(value);
            setUserDisplayName(value?.displayName ?? emptyUserName);
        }, [
            value,
            emptyUserName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setUsersList(users);
        }, [
            users
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (editMode && isEditable && !fetchedUsers && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) {
                setFetchedUsers(true);
                fetchUsers();
            }
        }, [
            usersList,
            editMode,
            isEditable,
            fetchUsers,
            fetchedUsers
        ]);
        const handleUserOptionClick = (0, $5uXOq.useCallback)((user)=>(event)=>{
                event.stopPropagation();
                setEditMode(false);
                setIsStartSearching(false);
                const isInvitePeopleID = user.accountId === $86e94321800af0e7$var$INVITE_PEOPLE_ID;
                if (isInvitePeopleID) openAddPeopleModal(undefined, 'listInviteFromAssigneeBtn');
                setUserDisplayName(isInvitePeopleID ? '' : user.displayName);
                setTextValue(isInvitePeopleID ? '' : user.displayName);
                saveValue(user.accountId === $86e94321800af0e7$var$EMPTY_USER_ID || isInvitePeopleID ? null : user, null, createAnalyticsEvent({}));
                setTimeout(()=>{
                    wrapperRef?.current?.focus();
                });
            }, [
            setEditMode,
            setTextValue,
            saveValue,
            createAnalyticsEvent,
            openAddPeopleModal,
            wrapperRef
        ]);
        const [handleSearch] = (0, (0, parcelRequire("laWvb")).default)((query)=>{
            query !== userQuery.previousQuery && fetchUsers(query);
            userQuery.previousQuery = query;
            setHighlightedUserIndex(0);
        }, $86e94321800af0e7$var$SEARCH_DEBOUNCE_TIMEOUT);
        const handleTextChange = (0, $5uXOq.useCallback)((event)=>{
            const newValue = event.target.value;
            setTextValue(newValue);
            setIsStartSearching(true);
            handleSearch(newValue);
        }, [
            handleSearch,
            setTextValue
        ]);
        const handleCellClick = (0, $5uXOq.useCallback)(()=>{
            if (!editMode && isEditable) {
                setEditMode(true);
                (!usersList || !usersList.length) && fetchUsers();
            }
        }, [
            editMode,
            isEditable,
            usersList,
            fetchUsers,
            setEditMode
        ]);
        const handleKeyPressOnSearchField = (0, $5uXOq.useCallback)((e)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
            switch(e.key){
                case 'Escape':
                    e.preventDefault();
                    setEditMode(false);
                    if (value) setTextValue(value.displayName);
                    wrapperRef?.current?.focus();
                    break;
                case 'ArrowUp':
                    {
                        e.preventDefault();
                        const activeIndex = highlightedUserIndex === 0 ? userOptions.length - 1 : highlightedUserIndex - 1;
                        setHighlightedUserIndex(activeIndex);
                        break;
                    }
                case 'ArrowDown':
                    {
                        e.preventDefault();
                        const activeIndex = highlightedUserIndex === userOptions.length - 1 ? 0 : highlightedUserIndex + 1;
                        setHighlightedUserIndex(activeIndex);
                        break;
                    }
                case 'Enter':
                    e.preventDefault();
                    userOptions[highlightedUserIndex] && handleUserOptionClick(userOptions[highlightedUserIndex])(e);
                    break;
                default:
                    break;
            }
        }, [
            setEditMode,
            value,
            wrapperRef,
            setTextValue,
            highlightedUserIndex,
            userOptions,
            handleUserOptionClick
        ]);
        const onWrapperRef = (0, $5uXOq.useCallback)((ref)=>{
            if (wrapperRef) wrapperRef.current = ref;
        }, [
            wrapperRef
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovering(false);
        }, []);
        const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
            setIsHovering(true);
        }, []);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            !editMode && onKeyDown?.(e);
        }, [
            editMode,
            onKeyDown
        ]);
        const handleKeyDownNew = (0, $5uXOq.useCallback)((e)=>{
            if (!(e.target instanceof HTMLElement) || e.target.nodeName !== 'INPUT') return;
            switch(e.code){
                case 'ArrowUp':
                    {
                        const activeIndex = highlightedUserIndex === 0 ? userOptions.length - 1 : highlightedUserIndex - 1;
                        setHighlightedUserIndex(activeIndex);
                        return true;
                    }
                case 'ArrowDown':
                    {
                        const activeIndex = highlightedUserIndex === userOptions.length - 1 ? 0 : highlightedUserIndex + 1;
                        setHighlightedUserIndex(activeIndex);
                        return true;
                    }
                case 'Enter':
                    userOptions[highlightedUserIndex] && handleUserOptionClick(userOptions[highlightedUserIndex])(e);
                    return false;
                default:
                    return false;
            }
        }, [
            userOptions,
            handleUserOptionClick,
            highlightedUserIndex
        ]);
        const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
            setEditMode(false);
            setIsStartSearching(false);
            setTextValue(userDisplayName);
            setHighlightedUserIndex(0);
        }, [
            setEditMode,
            setTextValue,
            userDisplayName
        ]);
        const handleTextRef = (0, $5uXOq.useCallback)((textFieldRef)=>{
            textFieldRef?.click();
            textFieldRef?.focus();
        }, []);
        const handleCutCopy = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (value) {
                event.clipboardData.setData('text/plain', value.displayName);
                event.clipboardData.setData('text/html', `<span account-id="${value.accountId}">${value.displayName}</span>`);
            }
            if (event.type === 'copy') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell copied', 'user');
            else if (event.type === 'cut') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell cut', 'user');
                setTextValue('');
                saveValue(null, null, createAnalyticsEvent({}));
            }
        }, [
            value,
            createAnalyticsEvent,
            setTextValue,
            saveValue
        ]);
        const handlePaste = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            const clipHtml = event.clipboardData.getData('text/html');
            const clipText = event.clipboardData.getData('text/plain');
            if (clipHtml) {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(clipHtml, 'text/html');
                const accountId = htmlDoc.querySelector('span')?.getAttribute('account-id');
                const displayName = htmlDoc.querySelector('span')?.textContent;
                if (displayName) setTextValue(displayName);
                if (accountId) {
                    (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/2/user/assignable/search?issueKey=${issueKey}&accountId=${accountId}`).then((response)=>{
                        if (Array.isArray(response) && response.length > 0) {
                            setUsersList(response);
                            setHighlightedUserIndex(1);
                        }
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'user', {
                        format: 'html'
                    });
                }
            } else if (clipText) {
                setTextValue(clipText);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'cell pasted', 'user', {
                    format: 'text'
                });
            }
        }, [
            setTextValue,
            issueKey,
            createAnalyticsEvent
        ]);
        const staticContent = (0, $5uXOq.useMemo)(()=>isUnassigned ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bmZvc")).AvatarLite), {
                avatarUrl: selectedAvatarUrl,
                testId: $86e94321800af0e7$var$createTestId(testId, '--avatar')
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).DisplayName), {
                "data-testid": $86e94321800af0e7$var$createTestId(testId, '--name')
            }, userDisplayName)), [
            isUnassigned,
            selectedAvatarUrl,
            testId,
            userDisplayName
        ]);
        const userDisplayLabel = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: userDisplayName
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).DisplayName), {
                "data-testid": $86e94321800af0e7$var$createTestId(testId, '--name')
            }, userDisplayName)), [
            testId,
            userDisplayName
        ]);
        const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).AvatarItem), {
                isUnassigned: isUnassigned && !editMode,
                ref: ref,
                ...triggerProps,
                "data-testid": "business-list.ui.list-view.user-cell.popup-avatar-item"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                appearance: "circle",
                src: selectedAvatarUrl,
                size: "small"
            }), editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $86e94321800af0e7$var$userSearchWrapperStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                appearance: "none",
                value: textValue === emptyUserName ? '' : textValue,
                onChange: handleTextChange,
                placeholder: emptyUserName,
                ref: handleTextRef,
                onKeyDown: handleKeyPressOnSearchField,
                role: "combobox",
                "aria-expanded": true,
                "aria-autocomplete": "list",
                "aria-controls": $86e94321800af0e7$var$LISTBOX_LIST_ID,
                "aria-activedescendant": activeDescendentId,
                "data-testid": $86e94321800af0e7$var$createTestId(testId, '--user-search-input')
            })) : userDisplayLabel()), [
            isUnassigned,
            editMode,
            selectedAvatarUrl,
            textValue,
            emptyUserName,
            handleTextChange,
            handleTextRef,
            handleKeyPressOnSearchField,
            activeDescendentId,
            testId,
            userDisplayLabel
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($86e94321800af0e7$var$UsersContainer, {
                width: width,
                role: "listbox",
                id: $86e94321800af0e7$var$LISTBOX_LIST_ID,
                "aria-label": listboxLabel
            }, userOptions.map((user, index)=>{
                const id = $86e94321800af0e7$var$getOptionId(index);
                const isInvitePeople = user.accountId === $86e94321800af0e7$var$INVITE_PEOPLE_ID;
                const shouldHighlight = index === highlightedUserIndex;
                if (shouldHighlight && activeDescendentId !== id) setActiveDescendentId(id);
                return (0, ($parcel$interopDefault($5uXOq))).createElement($86e94321800af0e7$var$UserOptionWrapper, {
                    id: id,
                    key: user.accountId,
                    onClick: handleUserOptionClick(user),
                    highlighted: shouldHighlight,
                    "data-testid": $86e94321800af0e7$var$createTestId(testId, `--option-${index}`),
                    role: "option",
                    "aria-selected": shouldHighlight
                }, isInvitePeople ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $86e94321800af0e7$var$iconWrapperStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                    label: "Add",
                    size: "medium"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    appearance: "circle",
                    src: $86e94321800af0e7$var$getAvatarUrl(user),
                    size: "small"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).DisplayName), null, user.displayName ?? emptyUserName, user.accountId === currentUserAccountId && (0, ($parcel$interopDefault($5uXOq))).createElement($86e94321800af0e7$var$AdditionalInfo, null, ' ', "(", formatMessage(loggedInUserActionNameText), ")")));
            }), loadingUsers && (0, ($parcel$interopDefault($5uXOq))).createElement($86e94321800af0e7$var$SpinnerWrapper, {
                "data-testid": "business-list.ui.list-view.user-cell.spinner-wrapper"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("epX45")).default), {
                onFetchUsers: fetchUsers
            })), [
            activeDescendentId,
            currentUserAccountId,
            emptyUserName,
            error,
            fetchUsers,
            formatMessage,
            handleUserOptionClick,
            highlightedUserIndex,
            listboxLabel,
            loadingUsers,
            loggedInUserActionNameText,
            testId,
            userOptions,
            width
        ]);
        const popupOffset = (0, $5uXOq.useMemo)(()=>[
                -(0, (0, parcelRequire("gwIPs")).gridSize),
                (0, (0, parcelRequire("gwIPs")).gridSize)
            ], []);
        const popupComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jRzRt")).getPopupComponentWithHeight)({
                numOptions: Math.min(userOptions.length, $86e94321800af0e7$var$MAX_NUMBER_OF_OPTIONS),
                spacing: 'default',
                hasInput: false
            }), [
            userOptions
        ]);
        const content = (0, $5uXOq.useMemo)(()=>isHovering || editMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: editMode,
                placement: "bottom-start",
                onClose: handlePopupClose,
                autoFocus: false,
                trigger: popupTrigger,
                content: popupContent,
                offset: popupOffset,
                popupComponent: popupComponent
            }) : staticContent, [
            handlePopupClose,
            isHovering,
            editMode,
            staticContent,
            popupTrigger,
            popupContent,
            popupOffset,
            popupComponent
        ]);
        const cellOverrides = (0, $5uXOq.useMemo)(()=>()=>({
                    onKeyDown: handleKeyDownNew
                }), [
            handleKeyDownNew
        ]);
        (0, $5uXOq.useImperativeHandle)(cellRef, cellOverrides, [
            cellOverrides
        ]);
        if (!isEditable && value?.accountId == null) return null;
        const userCell = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isEditable ? content : staticContent, updateError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0a4D")).FixItErrorFlag), {
            error: updateError,
            title: (0, (0, parcelRequire("khm7P")).default).errorTitle,
            description: (0, (0, parcelRequire("khm7P")).default).errorMessage,
            issueType: issueType,
            issueTypeId: issueTypeId,
            fieldId: fieldKey,
            fieldName: fieldName
        }));
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b5lmY")).CellWrapper), {
            isEditable: isEditable,
            testId: $86e94321800af0e7$var$createTestId(testId, '--cell-wrapper'),
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? {
                onCopy: handleCutCopy,
                onCut: handleCutCopy,
                onPaste: handlePaste
            } : {}
        }, userCell);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lI995")).CellWrapper), {
            isFocused: editMode || isSelected,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onClick: handleCellClick,
            isEditable: isEditable,
            onBlur: onBlur,
            tabIndex: 0,
            onFocus: onFocus,
            onKeyDown: handleKeyDown,
            ref: onWrapperRef,
            onCopy: handleCutCopy,
            onCut: handleCutCopy,
            onPaste: handlePaste,
            "data-testid": $86e94321800af0e7$var$createTestId(testId, '--cell-wrapper')
        }, userCell);
    });
    var $86e94321800af0e7$export$2e2bcd8739ae039 = $86e94321800af0e7$var$UserCell;
    const $86e94321800af0e7$var$AdditionalInfo = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz17iv",
                __cmplp.className
            ])
        });
    });
    const $86e94321800af0e7$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.025'
    });
    const $86e94321800af0e7$var$userSearchWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.negative.025'
    });
    const $86e94321800af0e7$var$UsersContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul9p3fh _1bsb1rkg _bfhkvuon _1reo15vq _18m915vq _16qs1os1",
                __cmplp.className
            ])
        });
    });
    const $86e94321800af0e7$var$UserOptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { highlighted: highlighted, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1e0c1txw _1yt4h8dc _4cvr1h6o _80omtlke _ce7e1b66",
                __cmplp.highlighted ? "_bfhkm96g" : "_bfhk1kw7",
                __cmplp.highlighted ? "_irr3xh9w" : "_irr3v8hk",
                __cmplp.className
            ])
        });
    });
    const $86e94321800af0e7$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7lGt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2aaed3328149e1d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassignedOption: {
            "id": "issue-field-assignee.unassigned-option",
            "defaultMessage": "Unassigned"
        },
        automaticOption: {
            "id": "issue-field-assignee.automatic-option",
            "defaultMessage": "Automatic"
        },
        assignToMe: {
            "id": "issue-field-assignee.assign-to-me",
            "defaultMessage": "Assign to me"
        },
        searchForAssignee: {
            "id": "issue-field-assignee.search-for-assignee",
            "defaultMessage": "Search for assignee"
        },
        invitePeopleOption: {
            "id": "issue-field-assignee.invite-people-option",
            "defaultMessage": "Add teammate to Jira"
        },
        invitePeopleOptionAdmin: {
            "id": "issue-field-assignee.invite-people-option-admin",
            "defaultMessage": "Invite teammate to Jira"
        }
    });
});
parcelRegister("kt8K4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$564a5b059c2a0fff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $7f4tk;
    const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl)=>{
        const [users, setUsers] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const currentQuery = (0, $5uXOq.useRef)('');
        const fetchUsers = (0, $5uXOq.useCallback)((query = '')=>{
            if ([
                '',
                null,
                undefined
            ].includes(autoCompleteUrl)) return Promise.resolve([]);
            const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
            setLoading(true);
            currentQuery.current = query;
            if (error) setError(undefined);
            return (0, (0, parcelRequire("7f4tk")).default)(usersFetchUrl).then((response)=>{
                if (query === currentQuery.current) setUsers(response);
            }).catch((err)=>{
                if (query === currentQuery.current) setError(err);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
            }).finally(()=>setLoading(false));
        }, [
            autoCompleteUrl,
            error
        ]);
        return [
            {
                data: users,
                error: error,
                loading: loading
            },
            fetchUsers
        ];
    };
    var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;
});
parcelRegister("epX45", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f033b6ab4405a7b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9yOBd;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $1pQYV;
    const $f033b6ab4405a7b1$var$ErrorUser = ({ onFetchUsers: onFetchUsers })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f033b6ab4405a7b1$var$Wrapper, {
            role: "alert"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f033b6ab4405a7b1$var$errorMessageWrapperStyles
        }, formatMessage((0, (0, parcelRequire("1pQYV")).default).cannotLoadUsers)), (0, ($parcel$interopDefault($5uXOq))).createElement($f033b6ab4405a7b1$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "link",
            spacing: "none",
            onClick: (event)=>{
                event.stopPropagation();
                onFetchUsers();
            },
            theme: (currentTheme, theme)=>{
                const buttonTheme = currentTheme(theme);
                return {
                    ...buttonTheme,
                    buttonStyles: {
                        ...buttonTheme.buttonStyles,
                        alignItems: 'center'
                    }
                };
            }
        }, formatMessage((0, (0, parcelRequire("1pQYV")).default).tryAgain))));
    };
    var $f033b6ab4405a7b1$export$2e2bcd8739ae039 = $f033b6ab4405a7b1$var$ErrorUser;
    const $f033b6ab4405a7b1$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1e0c1txw _4cvr1h6o _1yt4s8vo _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $f033b6ab4405a7b1$var$ButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $f033b6ab4405a7b1$var$errorMessageWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
});
parcelRegister("1pQYV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4daaf0cbf201f34b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4daaf0cbf201f34b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cannotLoadUsers: {
            "id": "business-list.list-view.user-cell.error-user.cannot-load-users",
            "defaultMessage": "Couldn\u2019t find users."
        },
        tryAgain: {
            "id": "business-list.list-view.user-cell.error-user.try-again",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("khm7P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42b1bed06f795cb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $42b1bed06f795cb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-list.list-view.user-cell.error-title",
            "defaultMessage": "We couldn't save the user value."
        },
        errorMessage: {
            "id": "business-list.list-view.user-cell.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        assigneeList: {
            "id": "business-list.list-view.user-cell.assignee-list",
            "defaultMessage": "Users"
        }
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';
const $c5ab1cac32219280$export$87b07f66f76af007 = 1000;
const $c5ab1cac32219280$export$7cf28317477c9e48 = 'w';
const $13918fc81534c491$export$cb17e3c17bc50301 = 'Epic';
const $13918fc81534c491$export$d29cf9c8492f955d = 'Base';
const $13918fc81534c491$export$7fbc739f2667a35e = 'Subtask';
const $05ea8866f66e1e3c$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $05ea8866f66e1e3c$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $05ea8866f66e1e3c$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $05ea8866f66e1e3c$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
